(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 41750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Breakpoints = exports.BreakpointConstraint = void 0;

var _Utils = __webpack_require__(4607);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function breakpointKey(breakpoint) {
  return Array.isArray(breakpoint) ? breakpoint.join("-") : breakpoint;
}

var BreakpointConstraint;
/**
 * Encapsulates all breakpoint data needed by the Media component. The data is
 * generated on initialization so no further runtime work is necessary.
 */

exports.BreakpointConstraint = BreakpointConstraint;

(function (BreakpointConstraint) {
  BreakpointConstraint["at"] = "at";
  BreakpointConstraint["lessThan"] = "lessThan";
  BreakpointConstraint["greaterThan"] = "greaterThan";
  BreakpointConstraint["greaterThanOrEqual"] = "greaterThanOrEqual";
  BreakpointConstraint["between"] = "between";
})(BreakpointConstraint || (exports.BreakpointConstraint = BreakpointConstraint = {}));

var Breakpoints = /*#__PURE__*/function () {
  _createClass(Breakpoints, null, [{
    key: "validKeys",
    value: function validKeys() {
      return [BreakpointConstraint.at, BreakpointConstraint.lessThan, BreakpointConstraint.greaterThan, BreakpointConstraint.greaterThanOrEqual, BreakpointConstraint.between];
    }
  }]);

  function Breakpoints(_breakpoints) {
    var _this = this,
        _this$_mediaQueries;

    _classCallCheck(this, Breakpoints);

    _defineProperty(this, "_sortedBreakpoints", void 0);

    _defineProperty(this, "_breakpoints", void 0);

    _defineProperty(this, "_mediaQueries", void 0);

    _defineProperty(this, "findBreakpointsForWidths", function (fromWidth, throughWidth) {
      var fromBreakpoint = _this.findBreakpointAtWidth(fromWidth);

      if (!fromBreakpoint) {
        return undefined;
      }

      var throughBreakpoint = _this.findBreakpointAtWidth(throughWidth);

      if (!throughBreakpoint || fromBreakpoint === throughBreakpoint) {
        return [fromBreakpoint];
      } else {
        return _this._sortedBreakpoints.slice(_this._sortedBreakpoints.indexOf(fromBreakpoint), _this._sortedBreakpoints.indexOf(throughBreakpoint) + 1);
      }
    });

    _defineProperty(this, "findBreakpointAtWidth", function (width) {
      return _this._sortedBreakpoints.find(function (breakpoint, i) {
        var nextBreakpoint = _this._sortedBreakpoints[i + 1];

        if (nextBreakpoint) {
          return width >= _this._breakpoints[breakpoint] && width < _this._breakpoints[nextBreakpoint];
        } else {
          return width >= _this._breakpoints[breakpoint];
        }
      });
    });

    _defineProperty(this, "valuesWithBreakpointProps", function (values) {
      var max = values.length;
      var valueBreakpoints = [];
      var lastTuple;

      _this._sortedBreakpoints.forEach(function (breakpoint, i) {
        var value = values[i];

        if (i < max && (!lastTuple || lastTuple[0] !== value)) {
          lastTuple = [value, [breakpoint]];
          valueBreakpoints.push(lastTuple);
        } else {
          lastTuple[1].push(breakpoint);
        }
      });

      return valueBreakpoints.map(function (_ref, i) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[0],
            breakpoints = _ref2[1];

        var props = {};

        if (i === valueBreakpoints.length - 1) {
          props.greaterThanOrEqual = breakpoints[0];
        } else if (breakpoints.length === 1) {
          props.at = breakpoints[0];
        } else {
          // TODO: This is less than ideal, would be good to have a `through`
          //       prop, which unlike `between` is inclusive.
          props.between = [breakpoints[0], valueBreakpoints[i + 1][1][0]];
        }

        return [value, props];
      });
    });

    this._breakpoints = _breakpoints;
    this._sortedBreakpoints = Object.keys(_breakpoints).map(function (breakpoint) {
      return [breakpoint, _breakpoints[breakpoint]];
    }).sort(function (a, b) {
      return a[1] < b[1] ? -1 : 1;
    }).map(function (breakpointAndValue) {
      return breakpointAndValue[0];
    }); // List of all possible and valid `between` combinations

    var betweenCombinations = this._sortedBreakpoints.slice(0, -1).reduce(function (acc, b1, i) {
      return _toConsumableArray(acc).concat(_toConsumableArray(_this._sortedBreakpoints.slice(i + 1).map(function (b2) {
        return [b1, b2];
      })));
    }, []);

    this._mediaQueries = (_this$_mediaQueries = {}, _defineProperty(_this$_mediaQueries, BreakpointConstraint.at, this._createBreakpointQueries(BreakpointConstraint.at, this._sortedBreakpoints)), _defineProperty(_this$_mediaQueries, BreakpointConstraint.lessThan, this._createBreakpointQueries(BreakpointConstraint.lessThan, this._sortedBreakpoints.slice(1))), _defineProperty(_this$_mediaQueries, BreakpointConstraint.greaterThan, this._createBreakpointQueries(BreakpointConstraint.greaterThan, this._sortedBreakpoints.slice(0, -1))), _defineProperty(_this$_mediaQueries, BreakpointConstraint.greaterThanOrEqual, this._createBreakpointQueries(BreakpointConstraint.greaterThanOrEqual, this._sortedBreakpoints)), _defineProperty(_this$_mediaQueries, BreakpointConstraint.between, this._createBreakpointQueries(BreakpointConstraint.between, betweenCombinations)), _this$_mediaQueries);
  }

  _createClass(Breakpoints, [{
    key: "toVisibleAtBreakpointSet",
    value: function toVisibleAtBreakpointSet(breakpointProps) {
      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var breakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.lessThan;
        });
        return this.sortedBreakpoints.slice(0, breakpointIndex);
      } else if (breakpointProps.greaterThan) {
        var _breakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.greaterThan;
        });

        return this.sortedBreakpoints.slice(_breakpointIndex + 1);
      } else if (breakpointProps.greaterThanOrEqual) {
        var _breakpointIndex2 = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.greaterThanOrEqual;
        });

        return this.sortedBreakpoints.slice(_breakpointIndex2);
      } else if (breakpointProps.between) {
        var between = breakpointProps.between;
        var fromBreakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === between[0];
        });
        var toBreakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === between[1];
        });
        return this.sortedBreakpoints.slice(fromBreakpointIndex, toBreakpointIndex);
      }

      return [];
    }
  }, {
    key: "toRuleSets",
    value: function toRuleSets() {
      var _this2 = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Breakpoints.validKeys();
      var selectedMediaQueries = keys.reduce(function (mediaQueries, query) {
        mediaQueries[query] = _this2._mediaQueries[query];
        return mediaQueries;
      }, {});
      return Object.entries(selectedMediaQueries).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            type = _ref4[0],
            queries = _ref4[1];

        queries.forEach(function (query, breakpoint) {
          // We need to invert the query, such that it matches when we want the
          // element to be hidden.
          acc.push((0, _Utils.createRuleSet)((0, _Utils.createClassName)(type, breakpoint), "not all and ".concat(query)));
        });
        return acc;
      }, []);
    }
  }, {
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(breakpointProps, onlyRenderAt) {
      var _this3 = this;

      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var width = this._breakpoints[breakpointProps.lessThan];
        var lowestAllowedWidth = Math.min.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));
        return lowestAllowedWidth < width;
      } else if (breakpointProps.greaterThan) {
        var _width = this._breakpoints[this._findNextBreakpoint(breakpointProps.greaterThan)];

        var highestAllowedWidth = Math.max.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));
        return highestAllowedWidth >= _width;
      } else if (breakpointProps.greaterThanOrEqual) {
        var _width2 = this._breakpoints[breakpointProps.greaterThanOrEqual];

        var _highestAllowedWidth = Math.max.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));

        return _highestAllowedWidth >= _width2;
      } else if (breakpointProps.between) {
        // TODO: This is the only useful breakpoint to negate, but we’ll
        //       we’ll see when/if we need it. We could then also decide
        //       to add `oustide`.
        var fromWidth = this._breakpoints[breakpointProps.between[0]];
        var toWidth = this._breakpoints[breakpointProps.between[1]];
        var allowedWidths = onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        });
        return !(Math.max.apply(Math, _toConsumableArray(allowedWidths)) < fromWidth || Math.min.apply(Math, _toConsumableArray(allowedWidths)) >= toWidth);
      }

      return false;
    }
  }, {
    key: "_normalizeProps",
    value: function _normalizeProps(breakpointProps) {
      if (breakpointProps.at) {
        var fromIndex = this._sortedBreakpoints.indexOf(breakpointProps.at);

        var to = this._sortedBreakpoints[fromIndex + 1];
        return to ? {
          between: [breakpointProps.at, to]
        } : {
          greaterThanOrEqual: breakpointProps.at
        };
      }

      return breakpointProps;
    }
  }, {
    key: "_createBreakpointQuery",
    value: function _createBreakpointQuery(breakpointProps) {
      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var width = this._breakpoints[breakpointProps.lessThan];
        return "(max-width:".concat(width - 0.02, "px)");
      } else if (breakpointProps.greaterThan) {
        var _width3 = this._breakpoints[this._findNextBreakpoint(breakpointProps.greaterThan)];

        return "(min-width:".concat(_width3, "px)");
      } else if (breakpointProps.greaterThanOrEqual) {
        var _width4 = this._breakpoints[breakpointProps.greaterThanOrEqual];
        return "(min-width:".concat(_width4, "px)");
      } else if (breakpointProps.between) {
        // TODO: This is the only useful breakpoint to negate, but we’ll
        //       we’ll see when/if we need it. We could then also decide
        //       to add `outside`.
        var fromWidth = this._breakpoints[breakpointProps.between[0]];
        var toWidth = this._breakpoints[breakpointProps.between[1]];
        return "(min-width:".concat(fromWidth, "px) and (max-width:").concat(toWidth - 0.02, "px)");
      }

      throw new Error("Unexpected breakpoint props: ".concat(JSON.stringify(breakpointProps)));
    }
  }, {
    key: "_createBreakpointQueries",
    value: function _createBreakpointQueries(key, forBreakpoints) {
      var _this4 = this;

      return forBreakpoints.reduce(function (map, breakpoint) {
        map.set(breakpointKey(breakpoint), _this4._createBreakpointQuery(_defineProperty({}, key, breakpoint)));
        return map;
      }, new Map());
    }
  }, {
    key: "_findNextBreakpoint",
    value: function _findNextBreakpoint(breakpoint) {
      var nextBreakpoint = this._sortedBreakpoints[this._sortedBreakpoints.indexOf(breakpoint) + 1];

      if (!nextBreakpoint) {
        throw new Error("There is no breakpoint larger than ".concat(breakpoint));
      }

      return nextBreakpoint;
    }
  }, {
    key: "sortedBreakpoints",
    get: function get() {
      return this._sortedBreakpoints;
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return Array.from(this._mediaQueries[BreakpointConstraint.at].entries()).reduce(function (acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            k = _ref6[0],
            v = _ref6[1];

        return _objectSpread({}, acc, _defineProperty({}, k, v));
      }, {});
    }
  }, {
    key: "largestBreakpoint",
    get: function get() {
      return this._sortedBreakpoints[this._sortedBreakpoints.length - 1];
    }
  }]);

  return Breakpoints;
}();

exports.Breakpoints = Breakpoints;
//# sourceMappingURL=Breakpoints.js.map

/***/ }),

/***/ 11882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createResponsiveComponents = createResponsiveComponents;

var _react = _interopRequireDefault(__webpack_require__(2784));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var shallowEqual = function shallowEqual(a, b) {
  for (var _key in a) {
    if (a[_key] !== b[_key]) return false;
  }

  return true;
};
/** TODO */


function createResponsiveComponents() {
  var ResponsiveContext = _react.default.createContext({});

  ResponsiveContext.displayName = "Media.DynamicContext";
  var ResponsiveConsumer = ResponsiveContext.Consumer;
  return {
    Consumer: ResponsiveConsumer,
    Provider: /*#__PURE__*/function (_React$Component) {
      _inherits(ResponsiveProvider, _React$Component);

      function ResponsiveProvider(props) {
        var _this;

        _classCallCheck(this, ResponsiveProvider);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveProvider).call(this, props));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isSupportedEnvironment", function () {
          return typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setupMatchers", function (mediaQueries) {
          return Object.keys(mediaQueries).reduce(function (matchers, key) {
            return _objectSpread({}, matchers, _defineProperty({}, key, window.matchMedia(mediaQueries[key])));
          }, {});
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkMatchers", function (mediaQueryMatchers) {
          return Object.keys(mediaQueryMatchers).reduce(function (matches, key) {
            return _objectSpread({}, matches, _defineProperty({}, key, mediaQueryMatchers[key].matches));
          }, {});
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mediaQueryStatusChangedCallback", function () {
          var mediaQueryMatches = _this.checkMatchers(_this.state.mediaQueryMatchers);

          _this.setState({
            mediaQueryMatches: mediaQueryMatches
          });
        });

        var _mediaQueryMatchers = undefined;

        var _mediaQueryMatches;

        if (_this.isSupportedEnvironment()) {
          _mediaQueryMatchers = _this.setupMatchers(props.mediaQueries);
          _mediaQueryMatches = _this.checkMatchers(_mediaQueryMatchers);
        } else {
          _mediaQueryMatches = Object.keys(props.mediaQueries).reduce(function (matches, key) {
            return _objectSpread({}, matches, _defineProperty({}, key, !!props.initialMatchingMediaQueries && props.initialMatchingMediaQueries.includes(key)));
          }, {});
        }

        _this.state = {
          mediaQueryMatchers: _mediaQueryMatchers,
          mediaQueryMatches: _mediaQueryMatches
        };
        return _this;
      }

      _createClass(ResponsiveProvider, [{
        key: "componentDidMount",
        // Lifecycle methods
        value: function componentDidMount() {
          if (this.state.mediaQueryMatchers) {
            var mediaQueryStatusChangedCallback = this.mediaQueryStatusChangedCallback;
            Object.values(this.state.mediaQueryMatchers).forEach(function (matcher) {
              matcher.addListener(mediaQueryStatusChangedCallback);
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.mediaQueryMatchers) {
            var mediaQueryStatusChangedCallback = this.mediaQueryStatusChangedCallback;
            Object.values(this.state.mediaQueryMatchers).forEach(function (matcher) {
              return matcher.removeListener(mediaQueryStatusChangedCallback);
            });
          }
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          if (!this.state.mediaQueryMatchers) return false;
          if (nextProps.children !== this.props.children) return true;

          if (shallowEqual(this.state.mediaQueryMatches, nextState.mediaQueryMatches)) {
            return false;
          }

          return true;
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(ResponsiveContext.Provider, {
            value: this.state.mediaQueryMatches
          }, this.props.children);
        }
      }]);

      return ResponsiveProvider;
    }(_react.default.Component)
  };
}
//# sourceMappingURL=DynamicResponsive.js.map

/***/ }),

/***/ 58310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Interactions = exports.InteractionKey = void 0;

var _Utils = __webpack_require__(4607);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InteractionKey;
/**
 * Encapsulates all interaction data needed by the Media component. The data is
 * generated on initialization so no further runtime work is necessary.
 */

exports.InteractionKey = InteractionKey;

(function (InteractionKey) {
  InteractionKey["interaction"] = "interaction";
})(InteractionKey || (exports.InteractionKey = InteractionKey = {}));

var Interactions = /*#__PURE__*/function () {
  _createClass(Interactions, null, [{
    key: "validKeys",
    value: function validKeys() {
      return [InteractionKey.interaction];
    }
  }]);

  function Interactions(interactions) {
    _classCallCheck(this, Interactions);

    _defineProperty(this, "_interactions", void 0);

    this._interactions = interactions;
  }

  _createClass(Interactions, [{
    key: "toRuleSets",
    value: function toRuleSets() {
      return Object.entries(this._interactions).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            query = _ref2[1];

        return _toConsumableArray(acc).concat([(0, _Utils.createRuleSet)((0, _Utils.createClassName)(InteractionKey.interaction, name), query)]);
      }, []);
    }
  }, {
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(interaction, onlyMatch) {
      return !!(onlyMatch && onlyMatch.includes(interaction));
    }
  }, {
    key: "interactions",
    get: function get() {
      return Object.keys(this._interactions);
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return Object.entries(this._interactions).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            query = _ref4[1];

        return _objectSpread({}, acc, _defineProperty({}, name, query));
      }, {});
    }
  }]);

  return Interactions;
}();

exports.Interactions = Interactions;
//# sourceMappingURL=Interactions.js.map

/***/ }),

/***/ 82428:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createMedia = createMedia;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _DynamicResponsive = __webpack_require__(11882);

var _MediaQueries = __webpack_require__(95261);

var _Utils = __webpack_require__(4607);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This is used to generate a Media component, its context provider, and CSS
 * rules based on your application’s breakpoints and interactions.
 *
 * Note that the interaction queries are entirely up to you to define and they
 * should be written in such a way that they match when you want the element to
 * be hidden.
 *
 * @example
 *
   ```tsx
   const MyAppMedia = createMedia({
     breakpoints: {
       xs: 0,
       sm: 768,
       md: 900
       lg: 1024,
       xl: 1192,
     },
     interactions: {
       hover: `not all and (hover:hover)`
     },
   })

   export const Media = MyAppMedia.Media
   export const MediaContextProvider = MyAppMedia.MediaContextProvider
   export const createMediaStyle = MyAppMedia.createMediaStyle
   ```
 *
 */
function createMedia(config) {
  var _class, _temp;

  var breakpoints = (0, _Utils.castBreakpointsToIntegers)(config.breakpoints);
  var mediaQueries = new _MediaQueries.MediaQueries(breakpoints, config.interactions || {});
  var DynamicResponsive = (0, _DynamicResponsive.createResponsiveComponents)();

  var MediaContext = _react.default.createContext({});

  MediaContext.displayName = "Media.Context";

  var MediaParentContext = _react.default.createContext({
    hasParentMedia: false,
    breakpointProps: {}
  });

  MediaContext.displayName = "MediaParent.Context";
  var getMediaContextValue = (0, _Utils.memoize)(function (onlyMatch) {
    return {
      onlyMatch: onlyMatch
    };
  });

  var MediaContextProvider = function MediaContextProvider(_ref) {
    var disableDynamicMediaQueries = _ref.disableDynamicMediaQueries,
        onlyMatch = _ref.onlyMatch,
        children = _ref.children;

    if (disableDynamicMediaQueries) {
      var MediaContextValue = getMediaContextValue(onlyMatch);
      return _react.default.createElement(MediaContext.Provider, {
        value: MediaContextValue
      }, children);
    } else {
      return _react.default.createElement(DynamicResponsive.Provider, {
        mediaQueries: mediaQueries.dynamicResponsiveMediaQueries,
        initialMatchingMediaQueries: (0, _Utils.intersection)(mediaQueries.mediaQueryTypes, onlyMatch)
      }, _react.default.createElement(DynamicResponsive.Consumer, null, function (matches) {
        var matchingMediaQueries = Object.keys(matches).filter(function (key) {
          return matches[key];
        });
        var MediaContextValue = getMediaContextValue((0, _Utils.intersection)(matchingMediaQueries, onlyMatch));
        return _react.default.createElement(MediaContext.Provider, {
          value: MediaContextValue
        }, children);
      }));
    }
  };

  var Media = (_temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(Media, _React$Component);

    function Media(props) {
      var _this;

      _classCallCheck(this, Media);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Media).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMediaParentContextValue", (0, _Utils.memoize)(function (breakpointProps) {
        return {
          hasParentMedia: true,
          breakpointProps: breakpointProps
        };
      }));

      validateProps(props);
      return _this;
    }

    _createClass(Media, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = this.props;

        var children = props.children,
            passedClassName = props.className,
            style = props.style,
            interaction = props.interaction,
            breakpointProps = _objectWithoutProperties(props, ["children", "className", "style", "interaction"]);

        var mediaParentContextValue = this.getMediaParentContextValue(breakpointProps);
        return _react.default.createElement(MediaParentContext.Consumer, null, function (mediaParentContext) {
          return _react.default.createElement(MediaParentContext.Provider, {
            value: mediaParentContextValue
          }, _react.default.createElement(MediaContext.Consumer, null, function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                onlyMatch = _ref2.onlyMatch;

            var className;

            if (props.interaction) {
              className = (0, _Utils.createClassName)("interaction", props.interaction);
            } else {
              if (props.at) {
                var largestBreakpoint = mediaQueries.breakpoints.largestBreakpoint;

                if (props.at === largestBreakpoint) {
                  // TODO: We should look into making React’s __DEV__ available
                  //       and have webpack completely compile these away.
                  var ownerName = null;

                  try {
                    var owner = _this2._reactInternalFiber._debugOwner.type;
                    ownerName = owner.displayName || owner.name;
                  } catch (err) {// no-op
                  }

                  console.warn("[@artsy/fresnel] " + "`at` is being used with the largest breakpoint. " + "Consider using `<Media greaterThanOrEqual=" + "\"".concat(largestBreakpoint, "\">` to account for future ") + "breakpoint definitions outside of this range.".concat(ownerName ? " It is being used in the ".concat(ownerName, " component.") : ""));
                }
              }

              var type = (0, _Utils.propKey)(breakpointProps);
              var breakpoint = breakpointProps[type];
              className = (0, _Utils.createClassName)(type, breakpoint);
            }

            var doesMatchParent = !mediaParentContext.hasParentMedia || (0, _Utils.intersection)(mediaQueries.breakpoints.toVisibleAtBreakpointSet(mediaParentContext.breakpointProps), mediaQueries.breakpoints.toVisibleAtBreakpointSet(breakpointProps)).length > 0;
            var renderChildren = doesMatchParent && (onlyMatch === undefined || mediaQueries.shouldRenderMediaQuery(_objectSpread({}, breakpointProps, {
              interaction: interaction
            }), onlyMatch));

            if (props.children instanceof Function) {
              return props.children(className, renderChildren);
            } else {
              return _react.default.createElement("div", {
                className: "fresnel-container ".concat(className, " ").concat(passedClassName),
                style: style,
                suppressHydrationWarning: !renderChildren
              }, renderChildren ? props.children : null);
            }
          }));
        });
      }
    }]);

    return Media;
  }(_react.default.Component), _defineProperty(_class, "defaultProps", {
    className: "",
    style: {}
  }), _defineProperty(_class, "contextType", MediaParentContext), _temp);
  return {
    Media: Media,
    MediaContextProvider: MediaContextProvider,
    createMediaStyle: mediaQueries.toStyle,
    SortedBreakpoints: _toConsumableArray(mediaQueries.breakpoints.sortedBreakpoints),
    findBreakpointAtWidth: mediaQueries.breakpoints.findBreakpointAtWidth,
    findBreakpointsForWidths: mediaQueries.breakpoints.findBreakpointsForWidths,
    valuesWithBreakpointProps: mediaQueries.breakpoints.valuesWithBreakpointProps
  };
}

var MutuallyExclusiveProps = _MediaQueries.MediaQueries.validKeys();

function validateProps(props) {
  var selectedProps = Object.keys(props).filter(function (prop) {
    return MutuallyExclusiveProps.includes(prop);
  });

  if (selectedProps.length < 1) {
    throw new Error("1 of ".concat(MutuallyExclusiveProps.join(", "), " is required."));
  } else if (selectedProps.length > 1) {
    throw new Error("Only 1 of ".concat(selectedProps.join(", "), " is allowed at a time."));
  }
}
//# sourceMappingURL=Media.js.map

/***/ }),

/***/ 95261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MediaQueries = void 0;

var _Breakpoints = __webpack_require__(41750);

var _Interactions = __webpack_require__(58310);

var _Utils = __webpack_require__(4607);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Encapsulates all interaction data (and breakpoint data in the superclass)
 * needed by the Media component. The data is generated on initialization so no
 * further runtime work is necessary.
 */
var MediaQueries = /*#__PURE__*/function () {
  _createClass(MediaQueries, null, [{
    key: "validKeys",
    value: function validKeys() {
      return _toConsumableArray(_Breakpoints.Breakpoints.validKeys()).concat(_toConsumableArray(_Interactions.Interactions.validKeys()));
    }
  }]);

  function MediaQueries(breakpoints, interactions) {
    var _this = this;

    _classCallCheck(this, MediaQueries);

    _defineProperty(this, "_breakpoints", void 0);

    _defineProperty(this, "_interactions", void 0);

    _defineProperty(this, "toStyle", function (breakpointKeys) {
      return [// Don’t add any size to the layout
      ".fresnel-container{margin:0;padding:0;}"].concat(_toConsumableArray(_this._breakpoints.toRuleSets(breakpointKeys)), _toConsumableArray(_this._interactions.toRuleSets())).join("\n");
    });

    this._breakpoints = new _Breakpoints.Breakpoints(breakpoints);
    this._interactions = new _Interactions.Interactions(interactions || {});
  }

  _createClass(MediaQueries, [{
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(mediaQueryProps, onlyMatch) {
      var interaction = mediaQueryProps.interaction,
          breakpointProps = _objectWithoutProperties(mediaQueryProps, ["interaction"]);

      if (interaction) {
        return this._interactions.shouldRenderMediaQuery(interaction, onlyMatch);
      } // Remove any interaction possibilities from the list.


      var onlyMatchBreakpoints = (0, _Utils.intersection)(onlyMatch, this._breakpoints.sortedBreakpoints);
      return this._breakpoints.shouldRenderMediaQuery(breakpointProps, onlyMatchBreakpoints);
    }
  }, {
    key: "breakpoints",
    get: function get() {
      return this._breakpoints;
    }
  }, {
    key: "mediaQueryTypes",
    get: function get() {
      return _toConsumableArray(this._breakpoints.sortedBreakpoints).concat(_toConsumableArray(this._interactions.interactions));
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return _objectSpread({}, this._breakpoints.dynamicResponsiveMediaQueries, this._interactions.dynamicResponsiveMediaQueries);
    }
  }]);

  return MediaQueries;
}();

exports.MediaQueries = MediaQueries;
//# sourceMappingURL=MediaQueries.js.map

/***/ }),

/***/ 4607:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.propKey = propKey;
exports.intersection = intersection;
exports.createRuleSet = createRuleSet;
exports.createClassName = createClassName;
exports.castBreakpointsToIntegers = castBreakpointsToIntegers;
exports.memoize = memoize;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Extracts the single breakpoint prop from the props object.
 */
function propKey(breakpointProps) {
  return Object.keys(breakpointProps)[0];
}
/**
 * Returns the intersection of two arrays.
 */


function intersection(a1, a2) {
  return a2 ? a1.filter(function (element) {
    return a2.indexOf(element) >= 0;
  }) : _toConsumableArray(a1);
}
/**
 * Generate a style rule for a given class name that will hide the element
 * when the given query matches.
 */


function createRuleSet(className, query) {
  return "@media ".concat(query, "{.").concat(className, "{display:none!important;}}");
}
/**
 * Given a list of strings, or string tuples, generates a class name.
 */


function createClassName() {
  for (var _len = arguments.length, components = new Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return ["fresnel"].concat(_toConsumableArray(components.reduce(function (acc, breakpoint) {
    return Array.isArray(breakpoint) ? _toConsumableArray(acc).concat(_toConsumableArray(breakpoint)) : _toConsumableArray(acc).concat([breakpoint]);
  }, []))).join("-");
}
/**
 * Returns an object with every values casted to integers.
 */


function castBreakpointsToIntegers(breakpoints) {
  var keys = Object.keys(breakpoints);
  return keys.reduce(function (previous, current, currentIndex) {
    return _objectSpread({}, previous, _defineProperty({}, keys[currentIndex], Math.round(Number(breakpoints[current]))));
  }, {});
}
/**
 * Use this function to memoize any function
 */


function memoize(func) {
  var results = {};
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var argsKey = JSON.stringify(args);

    if (!results[argsKey]) {
      results[argsKey] = func.apply(void 0, args);
    }

    return results[argsKey];
  };
}
//# sourceMappingURL=Utils.js.map

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "createMedia", ({
  enumerable: true,
  get: function get() {
    return _Media.createMedia;
  }
}));
Object.defineProperty(exports, "BreakpointKey", ({
  enumerable: true,
  get: function get() {
    return _Breakpoints.BreakpointConstraint;
  }
}));

var _Media = __webpack_require__(82428);

var _Breakpoints = __webpack_require__(41750);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 79138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 15472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ resize; }
});

// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
var resolve_elements_es = __webpack_require__(71010);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/resize/handle-element.es.js


const resizeHandlers = new WeakMap();
let observer;
function getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize, blockSize } = borderBoxSize[0];
        return { width: inlineSize, height: blockSize };
    }
    else if (target instanceof SVGElement && "getBBox" in target) {
        return target.getBBox();
    }
    else {
        return {
            width: target.offsetWidth,
            height: target.offsetHeight,
        };
    }
}
function notifyTarget({ target, contentRect, borderBoxSize, }) {
    var _a;
    (_a = resizeHandlers.get(target)) === null || _a === void 0 ? void 0 : _a.forEach((handler) => {
        handler({
            target,
            contentSize: contentRect,
            get size() {
                return getElementSize(target, borderBoxSize);
            },
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined")
        return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer)
        createResizeObserver();
    const elements = (0,resolve_elements_es/* resolveElements */.I)(target);
    elements.forEach((element) => {
        let elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer === null || observer === void 0 ? void 0 : observer.observe(element);
    });
    return () => {
        elements.forEach((element) => {
            const elementHandlers = resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(element);
            }
        });
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/resize/handle-window.es.js
const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = () => {
        const size = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        const info = {
            target: window,
            size,
            contentSize: size,
        };
        windowCallbacks.forEach((callback) => callback(info));
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler)
        createWindowResizeHandler();
    return () => {
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && windowResizeHandler) {
            windowResizeHandler = undefined;
        }
    };
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-function.es.js
var is_function_es = __webpack_require__(26766);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/resize/index.es.js




function resize(a, b) {
    return (0,is_function_es/* isFunction */.m)(a) ? resizeWindow(a) : resizeElement(a, b);
}




/***/ }),

/***/ 15734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ index_es_scroll; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/resize/index.es.js + 2 modules
var index_es = __webpack_require__(15472);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/progress.es.js
var progress_es = __webpack_require__(39496);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/velocity.es.js
var velocity_es = __webpack_require__(89831);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/info.es.js


/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */
const maxElapsed = 50;
const createAxisInfo = () => ({
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0,
});
const createScrollInfo = () => ({
    time: 0,
    x: createAxisInfo(),
    y: createAxisInfo(),
});
const keys = {
    x: {
        length: "Width",
        position: "Left",
    },
    y: {
        length: "Height",
        position: "Top",
    },
};
function updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length, position } = keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element["scroll" + position];
    axis.scrollLength = element["scroll" + length] - element["client" + length];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0,progress_es/* progress */.Y)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity =
        elapsed > maxElapsed ? 0 : (0,velocity_es/* velocityPerSecond */.R)(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
    updateAxisInfo(element, "x", info, time);
    updateAxisInfo(element, "y", info, time);
    info.time = time;
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-function.es.js
var is_function_es = __webpack_require__(26766);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/noop.es.js
var noop_es = __webpack_require__(82278);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/interpolate.es.js
var interpolate_es = __webpack_require__(16395);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/offset.es.js
var offset_es = __webpack_require__(26560);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/inset.es.js
function calcInset(element, container) {
    let inset = { x: 0, y: 0 };
    let current = element;
    while (current && current !== container) {
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        }
        else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top, left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */
            while (current && current.tagName !== "svg") {
                current = current.parentNode;
            }
        }
    }
    return inset;
}



// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/presets.es.js
var presets_es = __webpack_require__(41333);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-number.es.js
var is_number_es = __webpack_require__(68213);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-string.es.js
var is_string_es = __webpack_require__(90003);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/edge.es.js


const namedEdges = {
    start: 0,
    center: 0.5,
    end: 1,
};
function resolveEdge(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */
    if (namedEdges[edge] !== undefined) {
        edge = namedEdges[edge];
    }
    /**
     * Handle unit values
     */
    if ((0,is_string_es/* isString */.H)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) {
            delta = asNumber;
        }
        else if (edge.endsWith("%")) {
            edge = asNumber / 100;
        }
        else if (edge.endsWith("vw")) {
            delta = (asNumber / 100) * document.documentElement.clientWidth;
        }
        else if (edge.endsWith("vh")) {
            delta = (asNumber / 100) * document.documentElement.clientHeight;
        }
        else {
            edge = asNumber;
        }
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */
    if ((0,is_number_es/* isNumber */.h)(edge)) {
        delta = length * edge;
    }
    return inset + delta;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/offset.es.js



const defaultOffset = [0, 0];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0,is_number_es/* isNumber */.h)(offset)) {
        /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */
        offsetDefinition = [offset, offset];
    }
    else if ((0,is_string_es/* isString */.H)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) {
            offsetDefinition = offset.split(" ");
        }
        else {
            /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */
            offsetDefinition = [offset, namedEdges[offset] ? offset : `0`];
        }
    }
    targetPoint = resolveEdge(offsetDefinition[0], targetLength, targetInset);
    containerPoint = resolveEdge(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/index.es.js





const point = { x: 0, y: 0 };
function resolveOffsets(container, info, options) {
    let { offset: offsetDefinition = presets_es/* ScrollOffset.All */._.All } = options;
    const { target = container, axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? calcInset(target, container) : point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */
    const targetSize = target === container
        ? { width: container.scrollWidth, height: container.scrollHeight }
        : { width: target.clientWidth, height: target.clientHeight };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight,
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */
    info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */
    let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for (let i = 0; i < numOffsets; i++) {
        const offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
            hasChanged = true;
        }
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */
    if (hasChanged) {
        info[axis].interpolate = (0,interpolate_es/* interpolate */.s)((0,offset_es/* defaultOffset */.Y)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [...info[axis].offset];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/on-scroll-handler.es.js




function measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */
    info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while (node && node != container) {
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength =
        target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength =
        target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: () => measure(element, options.target, info),
        update: (time) => {
            updateScrollInfo(element, info, time);
            if (options.offset || options.target) {
                resolveOffsets(element, info, options);
            }
        },
        notify: (0,is_function_es/* isFunction */.m)(onScroll)
            ? () => onScroll(info)
            : scrubAnimation(onScroll, info[axis]),
    };
}
function scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing }) => {
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing)
                animation.easing = noop_es/* noopReturn */.V;
            animation.updateDuration(1);
        }
        else {
            const timingOptions = { duration: 1000 };
            if (!easing)
                timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 ? void 0 : _b.call(_a, timingOptions);
        }
    });
    return () => {
        controls.currentTime = axisInfo.progress;
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/index.es.js





const scrollListeners = new WeakMap();
const resizeListeners = new WeakMap();
const onScrollHandlers = new WeakMap();
const getEventTarget = (element) => element === document.documentElement ? window : element;
function index_es_scroll(onScroll, _a = {}) {
    var { container = document.documentElement } = _a, options = (0,tslib_es6.__rest)(_a, ["container"]);
    let containerHandlers = onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */
    if (!containerHandlers) {
        containerHandlers = new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */
    const info = createScrollInfo();
    const containerHandler = createOnScrollHandler(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */
    if (!scrollListeners.has(container)) {
        const listener = () => {
            const time = performance.now();
            for (const handler of containerHandlers)
                handler.measure();
            for (const handler of containerHandlers)
                handler.update(time);
            for (const handler of containerHandlers)
                handler.notify();
        };
        scrollListeners.set(container, listener);
        const target = getEventTarget(container);
        window.addEventListener("resize", listener, { passive: true });
        if (container !== document.documentElement) {
            resizeListeners.set(container, (0,index_es/* resize */.S)(container, listener));
        }
        target.addEventListener("scroll", listener, { passive: true });
    }
    const listener = scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return () => {
        var _a;
        if (typeof onScroll !== "function")
            onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */
        const containerHandlers = onScrollHandlers.get(container);
        if (!containerHandlers)
            return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size)
            return;
        /**
         * If no more handlers, remove the scroll listener too.
         */
        const listener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (listener) {
            getEventTarget(container).removeEventListener("scroll", listener);
            (_a = resizeListeners.get(container)) === null || _a === void 0 ? void 0 : _a();
            window.removeEventListener("resize", listener);
        }
    };
}




/***/ }),

/***/ 41333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ScrollOffset; }
/* harmony export */ });
const ScrollOffset = {
    Enter: [
        [0, 1],
        [1, 1],
    ],
    Exit: [
        [0, 0],
        [1, 0],
    ],
    Any: [
        [1, 0],
        [0, 1],
    ],
    All: [
        [0, 0],
        [1, 1],
    ],
};




/***/ }),

/***/ 14343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ScrollOffset": function() { return /* reexport */ presets_es/* ScrollOffset */._; },
  "animate": function() { return /* reexport */ animate; },
  "animateStyle": function() { return /* reexport */ animateStyle; },
  "createAnimate": function() { return /* reexport */ createAnimate; },
  "createMotionState": function() { return /* reexport */ createMotionState; },
  "createStyleString": function() { return /* reexport */ createStyleString; },
  "createStyles": function() { return /* reexport */ createStyles; },
  "getAnimationData": function() { return /* reexport */ getAnimationData; },
  "getStyleName": function() { return /* reexport */ getStyleName; },
  "glide": function() { return /* reexport */ index_es_glide; },
  "inView": function() { return /* reexport */ inView; },
  "mountedStates": function() { return /* reexport */ mountedStates; },
  "resize": function() { return /* reexport */ index_es/* resize */.S; },
  "scroll": function() { return /* reexport */ scroll_index_es/* scroll */.A; },
  "spring": function() { return /* reexport */ index_es_spring; },
  "stagger": function() { return /* reexport */ stagger; },
  "style": function() { return /* reexport */ style; },
  "timeline": function() { return /* reexport */ timeline; },
  "withControls": function() { return /* reexport */ withControls; }
});

;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/defaults.es.js
const defaults = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease",
};



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/noop.es.js
var noop_es = __webpack_require__(82278);
;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/is-easing-generator.es.js
const isEasingGenerator = (easing) => typeof easing === "object" &&
    Boolean(easing.createAnimation);



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-easing-list.es.js
var is_easing_list_es = __webpack_require__(24702);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/interpolate.es.js
var interpolate_es = __webpack_require__(16395);
;// CONCATENATED MODULE: ../../node_modules/@motionone/easing/dist/cubic-bezier.es.js


/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop_es/* noopReturn */.V;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/clamp.es.js
var clamp_es = __webpack_require__(62105);
;// CONCATENATED MODULE: ../../node_modules/@motionone/easing/dist/steps.es.js


const steps = (steps, direction = "end") => (progress) => {
    progress =
        direction === "end"
            ? Math.min(progress, 0.999)
            : Math.max(progress, 0.001);
    const expanded = progress * steps;
    const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
    return (0,clamp_es/* clamp */.u)(0, 1, rounded / steps);
};



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-function.es.js
var is_function_es = __webpack_require__(26766);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-number.es.js
var is_number_es = __webpack_require__(68213);
;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/is-cubic-bezier.es.js


const isCubicBezier = (easing) => Array.isArray(easing) && (0,is_number_es/* isNumber */.h)(easing[0]);



;// CONCATENATED MODULE: ../../node_modules/@motionone/animation/dist/utils/easing.es.js



const namedEasings = {
    ease: cubicBezier(0.25, 0.1, 0.25, 1.0),
    "ease-in": cubicBezier(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": cubicBezier(0.42, 0.0, 0.58, 1.0),
    "ease-out": cubicBezier(0.0, 0.0, 0.58, 1.0),
};
const functionArgsRegex = /\((.*?)\)/;
function getEasingFunction(definition) {
    // If already an easing function, return
    if ((0,is_function_es/* isFunction */.m)(definition))
        return definition;
    // If an easing curve definition, return bezier function
    if (isCubicBezier(definition))
        return cubicBezier(...definition);
    // If we have a predefined easing function, return
    if (namedEasings[definition])
        return namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return steps(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return noop_es/* noopReturn */.V;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/animation/dist/Animation.es.js



class Animation {
    constructor(output, keyframes = [0, 1], { easing, duration: initialDuration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, offset, direction = "normal", autoplay = true, } = {}) {
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = noop_es/* noopReturn */.V;
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || defaults.easing;
        if (isEasingGenerator(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0,is_easing_list_es/* isEasingList */.K)(easing) ? noop_es/* noopReturn */.V : getEasingFunction(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0,interpolate_es/* interpolate */.s)(keyframes, offset, (0,is_easing_list_es/* isEasingList */.K)(easing) ? easing.map(getEasingFunction) : noop_es/* noopReturn */.V);
        this.tick = (timestamp) => {
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay = delay;
            let t = 0;
            if (this.pauseTime !== undefined) {
                t = this.pauseTime;
            }
            else {
                t = (timestamp - this.startTime) * this.rate;
            }
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */
            if (this.playState === "finished" && this.pauseTime === undefined) {
                t = this.totalDuration;
            }
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */
            const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */
            let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */
            let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) {
                iterationProgress = 1;
            }
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */
            iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */
            const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" ||
                (direction === "alternate" && iterationIsOdd) ||
                (direction === "alternate-reverse" && !iterationIsOdd)) {
                iterationProgress = 1 - iterationProgress;
            }
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined &&
                (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, latest);
            }
            else if (this.playState !== "idle") {
                this.frameRequestId = requestAnimationFrame(this.tick);
            }
        };
        if (autoplay)
            this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) {
            this.startTime = now - this.pauseTime;
        }
        else if (!this.startTime) {
            this.startTime = now;
        }
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) {
            cancelAnimationFrame(this.frameRequestId);
        }
        (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() { }
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) {
            this.pauseTime = t;
        }
        else {
            this.startTime = performance.now() - t / this.rate;
        }
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}



// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
;// CONCATENATED MODULE: ../../node_modules/@motionone/types/dist/MotionValue.es.js
/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */
class MotionValue {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 ? void 0 : animation.finished.then(() => this.clearAnimation()).catch(() => { });
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/data.es.js


const data = new WeakMap();
function getAnimationData(element) {
    if (!data.has(element)) {
        data.set(element, {
            transforms: [],
            values: new Map(),
        });
    }
    return data.get(element);
}
function getMotionValue(motionValues, name) {
    if (!motionValues.has(name)) {
        motionValues.set(name, new MotionValue());
    }
    return motionValues.get(name);
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/array.es.js
function addUniqueItem(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/transforms.es.js



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
const axes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
const order = ["translate", "scale", "rotate", "skew"];
const transformAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
};
const rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v) => v + "deg",
};
const baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v) => v + "px",
    },
    rotate: rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: noop_es/* noopReturn */.V,
    },
    skew: rotation,
};
const transformDefinitions = new Map();
const asTransformCssVar = (name) => `--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */
const transforms = ["x", "y", "z"];
order.forEach((name) => {
    axes.forEach((axis) => {
        transforms.push(name + axis);
        transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
const compareTransformOrder = (a, b) => transforms.indexOf(a) - transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */
const transformLookup = new Set(transforms);
const isTransform = (name) => transformLookup.has(name);
const addTransformToElement = (element, name) => {
    // Map x to translateX etc
    if (transformAlias[name])
        name = transformAlias[name];
    const { transforms } = getAnimationData(element);
    addUniqueItem(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */
    element.style.transform = buildTransformTemplate(transforms);
};
const buildTransformTemplate = (transforms) => transforms
    .sort(compareTransformOrder)
    .reduce(transformListToString, "")
    .trim();
const transformListToString = (template, name) => `${template} ${name}(var(${asTransformCssVar(name)}))`;



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/css-var.es.js


const isCssVar = (name) => name.startsWith("--");
const registeredProperties = new Set();
function registerCssVariable(name) {
    if (registeredProperties.has(name))
        return;
    registeredProperties.add(name);
    try {
        const { syntax, initialValue } = transformDefinitions.has(name)
            ? transformDefinitions.get(name)
            : {};
        CSS.registerProperty({
            name,
            inherits: false,
            syntax,
            initialValue,
        });
    }
    catch (e) { }
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/time.es.js
const time = {
    ms: (seconds) => seconds * 1000,
    s: (milliseconds) => milliseconds / 1000,
};



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/progress.es.js
var progress_es = __webpack_require__(39496);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/feature-detection.es.js
const testAnimation = (keyframes, options) => document.createElement("div").animate(keyframes, options);
const featureTests = {
    cssRegisterProperty: () => typeof CSS !== "undefined" &&
        Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: () => {
        try {
            testAnimation({ opacity: [1] });
        }
        catch (e) {
            return false;
        }
        return true;
    },
    finished: () => Boolean(testAnimation({ opacity: [0, 1] }, { duration: 0.001 }).finished),
    linearEasing: () => {
        try {
            testAnimation({ opacity: 0 }, { easing: "linear(0, 1)" });
        }
        catch (e) {
            return false;
        }
        return true;
    },
};
const results = {};
const supports = {};
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/easing.es.js



// Create a linear easing point for every x second
const resolution = 0.015;
const generateLinearEasingPoints = (easing, duration) => {
    let points = "";
    const numPoints = Math.round(duration / resolution);
    for (let i = 0; i < numPoints; i++) {
        points += easing((0,progress_es/* progress */.Y)(0, numPoints - 1, i)) + ", ";
    }
    return points.substring(0, points.length - 2);
};
const convertEasing = (easing, duration) => {
    if ((0,is_function_es/* isFunction */.m)(easing)) {
        return supports.linearEasing()
            ? `linear(${generateLinearEasingPoints(easing, duration)})`
            : defaults.easing;
    }
    else {
        return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
    }
};
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/keyframes.es.js
function hydrateKeyframes(keyframes, readInitialValue) {
    for (let i = 0; i < keyframes.length; i++) {
        if (keyframes[i] === null) {
            keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
        }
    }
    return keyframes;
}
const keyframesList = (keyframes) => Array.isArray(keyframes) ? keyframes : [keyframes];



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/get-style-name.es.js


function getStyleName(key) {
    if (transformAlias[key])
        key = transformAlias[key];
    return isTransform(key) ? asTransformCssVar(key) : key;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/style.es.js




const style = {
    get: (element, name) => {
        name = getStyleName(name);
        let value = isCssVar(name)
            ? element.style.getPropertyValue(name)
            : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = transformDefinitions.get(name);
            if (definition)
                value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value) => {
        name = getStyleName(name);
        if (isCssVar(name)) {
            element.style.setProperty(name, value);
        }
        else {
            element.style[name] = value;
        }
    },
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/stop-animation.es.js
function stopAnimation(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished")
        return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) {
            animation.stop();
        }
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    }
    catch (e) { }
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-string.es.js
var is_string_es = __webpack_require__(90003);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/get-unit.es.js


function getUnitConverter(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noop_es/* noopReturn */.V;
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0,is_string_es/* isString */.H)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit)
            toUnit = (value) => value + unit;
    }
    return toUnit;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/animate-style.es.js












function getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, easing = defaults.easing, persist = false, direction, offset, allowWebkitAcceleration = false, autoplay = true, } = options;
    const data = getAnimationData(element);
    const valueIsTransform = isTransform(key);
    let canAnimateNatively = supports.waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */
    valueIsTransform && addTransformToElement(element, key);
    const name = getStyleName(key);
    const motionValue = getMotionValue(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */
    const definition = transformDefinitions.get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */
    stopAnimation(motionValue.animation, !(isEasingGenerator(easing) && motionValue.generator) &&
        options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */
    return () => {
        const readInitialValue = () => { var _a, _b; return (_b = (_a = style.get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0; };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */
        let keyframes = hydrateKeyframes(keyframesList(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */
        const toUnit = getUnitConverter(keyframes, definition);
        if (isEasingGenerator(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */
        if (isCssVar(name)) {
            if (supports.cssRegisterProperty()) {
                registerCssVariable(name);
            }
            else {
                canAnimateNatively = false;
            }
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */
        if (valueIsTransform &&
            !supports.linearEasing() &&
            ((0,is_function_es/* isFunction */.m)(easing) || ((0,is_easing_list_es/* isEasingList */.K)(easing) && easing.some(is_function_es/* isFunction */.m)))) {
            canAnimateNatively = false;
        }
        /**
         * If we can animate this value with WAAPI, do so.
         */
        if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */
            if (definition) {
                keyframes = keyframes.map((value) => (0,is_number_es/* isNumber */.h)(value) ? definition.toDefaultUnit(value) : value);
            }
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */
            if (keyframes.length === 1 &&
                (!supports.partialKeyframes() || isRecording)) {
                keyframes.unshift(readInitialValue());
            }
            const animationOptions = {
                delay: time.ms(delay),
                duration: time.ms(duration),
                endDelay: time.ms(endDelay),
                easing: !(0,is_easing_list_es/* isEasingList */.K)(easing)
                    ? convertEasing(easing, duration)
                    : undefined,
                direction,
                iterations: repeat + 1,
                fill: "both",
            };
            animation = element.animate({
                [name]: keyframes,
                offset,
                easing: (0,is_easing_list_es/* isEasingList */.K)(easing)
                    ? easing.map((thisEasing) => convertEasing(thisEasing, duration))
                    : undefined,
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */
            if (!animation.finished) {
                animation.finished = new Promise((resolve, reject) => {
                    animation.onfinish = resolve;
                    animation.oncancel = reject;
                });
            }
            const target = keyframes[keyframes.length - 1];
            animation.finished
                .then(() => {
                if (persist)
                    return;
                // Apply styles to target
                style.set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            })
                .catch(noop_es/* noop */.Z);
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */
            if (!allowWebkitAcceleration)
                animation.playbackRate = 1.000001;
            /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */
        }
        else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */
            keyframes = keyframes.map((value) => typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */
            if (keyframes.length === 1) {
                keyframes.unshift(parseFloat(readInitialValue()));
            }
            animation = new AnimationPolyfill((latest) => {
                style.set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), { duration,
                easing }));
        }
        else {
            const target = keyframes[keyframes.length - 1];
            style.set(element, name, definition && (0,is_number_es/* isNumber */.h)(target)
                ? definition.toDefaultUnit(target)
                : target);
        }
        if (isRecording) {
            record(element, key, keyframes, {
                duration,
                delay: delay,
                easing,
                repeat,
                offset,
            }, "motion-one");
        }
        motionValue.setAnimation(animation);
        if (animation && !autoplay)
            animation.pause();
        return animation;
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/options.es.js
const getOptions = (options, key) => 
/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */
options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);



// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
var resolve_elements_es = __webpack_require__(71010);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/controls.es.js



const createAnimation = (factory) => factory();
const withControls = (animationFactory, options, duration = defaults.duration) => {
    return new Proxy({
        animations: animationFactory.map(createAnimation).filter(Boolean),
        duration,
        options,
    }, controls);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */
const getActiveAnimation = (state) => state.animations[0];
const controls = {
    get: (target, key) => {
        const activeAnimation = getActiveAnimation(target);
        switch (key) {
            case "duration":
                return target.duration;
            case "currentTime":
                return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) {
                    target.finished = Promise.all(target.animations.map(selectFinished)).catch(noop_es/* noop */.Z);
                }
                return target.finished;
            case "stop":
                return () => {
                    target.animations.forEach((animation) => stopAnimation(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */
                return (callback) => {
                    target.animations.forEach((animation) => callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined"
                    ? undefined
                    : () => target.animations.forEach((animation) => animation[key]());
        }
    },
    set: (target, key, value) => {
        switch (key) {
            case "currentTime":
                value = time.ms(value);
            // Fall-through
            case "playbackRate":
                for (let i = 0; i < target.animations.length; i++) {
                    target.animations[i][key] = value;
                }
                return true;
        }
        return false;
    },
};
const selectFinished = (animation) => animation.finished;



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/utils/stagger.es.js



function stagger(duration = 0.1, { start = 0, from = 0, easing } = {}) {
    return (i, total) => {
        const fromIndex = (0,is_number_es/* isNumber */.h)(from) ? from : getFromIndex(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = getEasingFunction(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function getFromIndex(from, total) {
    if (from === "first") {
        return 0;
    }
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function resolveOption(option, i, total) {
    return (0,is_function_es/* isFunction */.m)(option) ? option(i, total) : option;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/create-animate.es.js







function createAnimate(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0,resolve_elements_es/* resolveElements */.I)(elements);
        const numElements = elements.length;
        (0,hey_listen_es.invariant)(Boolean(numElements), "No valid element provided.");
        (0,hey_listen_es.invariant)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */
        const animationFactories = [];
        for (let i = 0; i < numElements; i++) {
            const element = elements[i];
            for (const key in keyframes) {
                const valueOptions = getOptions(options, key);
                valueOptions.delay = resolveOption(valueOptions.delay, i, numElements);
                const animation = animateStyle(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return withControls(animationFactories, options, 
        /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */
        options.duration);
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/index.es.js



const animate = createAnimate(Animation);



// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/offset.es.js
var offset_es = __webpack_require__(26560);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/timeline/utils/calc-time.es.js


function calcNextTime(current, next, prev, labels) {
    var _a;
    if ((0,is_number_es/* isNumber */.h)(next)) {
        return next;
    }
    else if (next.startsWith("-") || next.startsWith("+")) {
        return Math.max(0, current + parseFloat(next));
    }
    else if (next === "<") {
        return prev;
    }
    else {
        return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
    }
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/mix.es.js
var mix_es = __webpack_require__(33877);
// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/easing.es.js + 1 modules
var easing_es = __webpack_require__(93193);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/timeline/utils/edit.es.js


function eraseKeyframes(sequence, startTime, endTime) {
    for (let i = 0; i < sequence.length; i++) {
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            removeItem(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */
    eraseKeyframes(sequence, startTime, endTime);
    for (let i = 0; i < keyframes.length; i++) {
        sequence.push({
            value: keyframes[i],
            at: (0,mix_es/* mix */.C)(startTime, endTime, offset[i]),
            easing: (0,easing_es/* getEasingForSegment */.I)(easing, i),
        });
    }
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/timeline/utils/sort.es.js
function compareByTime(a, b) {
    if (a.at === b.at) {
        return a.value === null ? 1 : -1;
    }
    else {
        return a.at - b.at;
    }
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/timeline/index.es.js














function timeline(definition, options = {}) {
    var _a;
    const animationDefinitions = createAnimationsFromTimeline(definition, options);
    /**
     * Create and start animations
     */
    const animationFactories = animationDefinitions
        .map((definition) => animateStyle(...definition, Animation))
        .filter(Boolean);
    return withControls(animationFactories, options, 
    // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration);
}
function createAnimationsFromTimeline(definition, _a = {}) {
    var { defaultOptions = {} } = _a, timelineOptions = (0,tslib_es6.__rest)(_a, ["defaultOptions"]);
    const animationDefinitions = [];
    const elementSequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the definition array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */
    for (let i = 0; i < definition.length; i++) {
        const segment = definition[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */
        if ((0,is_string_es/* isString */.H)(segment)) {
            timeLabels.set(segment, currentTime);
            continue;
        }
        else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        const [elementDefinition, keyframes, options = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */
        if (options.at !== undefined) {
            currentTime = calcNextTime(currentTime, options.at, prevTime, timeLabels);
        }
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */
        let maxDuration = 0;
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */
        const elements = (0,resolve_elements_es/* resolveElements */.I)(elementDefinition, elementCache);
        const numElements = elements.length;
        for (let elementIndex = 0; elementIndex < numElements; elementIndex++) {
            const element = elements[elementIndex];
            const elementSequence = getElementSequence(element, elementSequences);
            for (const key in keyframes) {
                const valueSequence = getValueSequence(key, elementSequence);
                let valueKeyframes = keyframesList(keyframes[key]);
                const valueOptions = getOptions(options, key);
                let { duration = defaultOptions.duration || defaults.duration, easing = defaultOptions.easing || defaults.easing, } = valueOptions;
                if (isEasingGenerator(easing)) {
                    (0,hey_listen_es.invariant)(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
                    const custom = easing.createAnimation(valueKeyframes, key !== "opacity", () => 0, key);
                    easing = custom.easing;
                    valueKeyframes = custom.keyframes || valueKeyframes;
                    duration = custom.duration || duration;
                }
                const delay = resolveOption(options.delay, elementIndex, numElements) || 0;
                const startTime = currentTime + delay;
                const targetTime = startTime + duration;
                /**
                 *
                 */
                let { offset = (0,offset_es/* defaultOffset */.Y)(valueKeyframes.length) } = valueOptions;
                /**
                 * If there's only one offset of 0, fill in a second with length 1
                 *
                 * TODO: Ensure there's a test that covers this removal
                 */
                if (offset.length === 1 && offset[0] === 0) {
                    offset[1] = 1;
                }
                /**
                 * Fill out if offset if fewer offsets than keyframes
                 */
                const remainder = offset.length - valueKeyframes.length;
                remainder > 0 && (0,offset_es/* fillOffset */.c)(offset, remainder);
                /**
                 * If only one value has been set, ie [1], push a null to the start of
                 * the keyframe array. This will let us mark a keyframe at this point
                 * that will later be hydrated with the previous value.
                 */
                valueKeyframes.length === 1 && valueKeyframes.unshift(null);
                /**
                 * Add keyframes, mapping offsets to absolute time.
                 */
                addKeyframes(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
                maxDuration = Math.max(delay + duration, maxDuration);
                totalDuration = Math.max(targetTime, totalDuration);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */
    elementSequences.forEach((valueSequences, element) => {
        for (const key in valueSequences) {
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */
            valueSequence.sort(compareByTime);
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */
            for (let i = 0; i < valueSequence.length; i++) {
                const { at, value, easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0,progress_es/* progress */.Y)(0, totalDuration, at));
                valueEasing.push(easing || defaults.easing);
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */
            if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift("linear");
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */
            if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            animationDefinitions.push([
                element,
                key,
                keyframes,
                Object.assign(Object.assign(Object.assign({}, defaultOptions), { duration: totalDuration, easing: valueEasing, offset: valueOffset }), timelineOptions),
            ]);
        }
    });
    return animationDefinitions;
}
function getElementSequence(element, sequences) {
    !sequences.has(element) && sequences.set(element, {});
    return sequences.get(element);
}
function getValueSequence(name, sequences) {
    if (!sequences[name])
        sequences[name] = [];
    return sequences[name];
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/spring/defaults.es.js
const defaults_es_defaults = {
    stiffness: 100.0,
    damping: 10.0,
    mass: 1.0,
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/spring/utils.es.js


const calcDampingRatio = (stiffness = defaults_es_defaults.stiffness, damping = defaults_es_defaults.damping, mass = defaults_es_defaults.mass) => damping / (2 * Math.sqrt(stiffness * mass));



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/utils/has-reached-target.es.js
function hasReachedTarget(origin, target, current) {
    return ((origin < target && current >= target) ||
        (origin > target && current <= target));
}



// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/velocity.es.js
var velocity_es = __webpack_require__(89831);
;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/utils/velocity.es.js


const sampleT = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - sampleT, 0);
    return (0,velocity_es/* velocityPerSecond */.R)(current - resolveValue(prevT), t - prevT);
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/spring/index.es.js






const spring = ({ stiffness = defaults_es_defaults.stiffness, damping = defaults_es_defaults.damping, mass = defaults_es_defaults.mass, from = 0, to = 1, velocity = 0.0, restSpeed, restDistance, } = {}) => {
    velocity = velocity ? time.s(velocity) : 0.0;
    const state = {
        done: false,
        hasReachedTarget: false,
        current: from,
        target: to,
    };
    const initialDelta = to - from;
    const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
    const dampingRatio = calcDampingRatio(stiffness, damping, mass);
    const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDistance || (restDistance = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = undampedAngularFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
        // Underdamped spring (bouncy)
        resolveSpring = (t) => to -
            Math.exp(-dampingRatio * undampedAngularFreq * t) *
                (((-velocity + dampingRatio * undampedAngularFreq * initialDelta) /
                    angularFreq) *
                    Math.sin(angularFreq * t) +
                    initialDelta * Math.cos(angularFreq * t));
    }
    else {
        // Critically damped spring
        resolveSpring = (t) => {
            return (to -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta + (-velocity + undampedAngularFreq * initialDelta) * t));
        };
    }
    return (t) => {
        state.current = resolveSpring(t);
        const currentVelocity = t === 0
            ? velocity
            : calcGeneratorVelocity(resolveSpring, t, state.current);
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(to - state.current) <= restDistance;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
        state.hasReachedTarget = hasReachedTarget(from, to, state.current);
        return state;
    };
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/utils/pregenerate-keyframes.es.js


const timeStep = 10;
const maxDuration = 10000;
function pregenerateKeyframes(generator, toUnit = noop_es/* noopReturn */.V) {
    let overshootDuration = undefined;
    let timestamp = timeStep;
    let state = generator(0);
    const keyframes = [toUnit(state.current)];
    while (!state.done && timestamp < maxDuration) {
        state = generator(timestamp);
        keyframes.push(toUnit(state.done ? state.target : state.current));
        if (overshootDuration === undefined && state.hasReachedTarget) {
            overshootDuration = timestamp;
        }
        timestamp += timeStep;
    }
    const duration = timestamp - timeStep;
    /**
     * If generating an animation that didn't actually move,
     * generate a second keyframe so we have an origin and target.
     */
    if (keyframes.length === 1)
        keyframes.push(state.current);
    return {
        keyframes,
        duration: duration / 1000,
        overshootDuration: (overshootDuration !== null && overshootDuration !== void 0 ? overshootDuration : duration) / 1000,
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/easing/create-generator-easing.es.js






function canGenerate(value) {
    return (0,is_number_es/* isNumber */.h)(value) && !isNaN(value);
}
function getAsNumber(value) {
    return (0,is_string_es/* isString */.H)(value) ? parseFloat(value) : value;
}
function createGeneratorEasing(createGenerator) {
    const keyframesCache = new WeakMap();
    return (options = {}) => {
        const generatorCache = new Map();
        const getGenerator = (from = 0, to = 100, velocity = 0, isScale = false) => {
            const key = `${from}-${to}-${velocity}-${isScale}`;
            if (!generatorCache.has(key)) {
                generatorCache.set(key, createGenerator(Object.assign({ from,
                    to,
                    velocity }, options)));
            }
            return generatorCache.get(key);
        };
        const getKeyframes = (generator, toUnit) => {
            if (!keyframesCache.has(generator)) {
                keyframesCache.set(generator, pregenerateKeyframes(generator, toUnit));
            }
            return keyframesCache.get(generator);
        };
        return {
            createAnimation: (keyframes, shouldGenerate = true, getOrigin, name, motionValue) => {
                let settings;
                let origin;
                let target;
                let velocity = 0;
                let toUnit = noop_es/* noopReturn */.V;
                const numKeyframes = keyframes.length;
                /**
                 * If we should generate an animation for this value, run some preperation
                 * like resolving target/origin, finding a unit (if any) and determine if
                 * it is actually possible to generate.
                 */
                if (shouldGenerate) {
                    toUnit = getUnitConverter(keyframes, name ? transformDefinitions.get(getStyleName(name)) : undefined);
                    const targetDefinition = keyframes[numKeyframes - 1];
                    target = getAsNumber(targetDefinition);
                    if (numKeyframes > 1 && keyframes[0] !== null) {
                        /**
                         * If we have multiple keyframes, take the initial keyframe as the origin.
                         */
                        origin = getAsNumber(keyframes[0]);
                    }
                    else {
                        const prevGenerator = motionValue === null || motionValue === void 0 ? void 0 : motionValue.generator;
                        /**
                         * If we have an existing generator for this value we can use it to resolve
                         * the animation's current value and velocity.
                         */
                        if (prevGenerator) {
                            /**
                             * If we have a generator for this value we can use it to resolve
                             * the animations's current value and velocity.
                             */
                            const { animation, generatorStartTime } = motionValue;
                            const startTime = (animation === null || animation === void 0 ? void 0 : animation.startTime) || generatorStartTime || 0;
                            const currentTime = (animation === null || animation === void 0 ? void 0 : animation.currentTime) || performance.now() - startTime;
                            const prevGeneratorCurrent = prevGenerator(currentTime).current;
                            origin = prevGeneratorCurrent;
                            velocity = calcGeneratorVelocity((t) => prevGenerator(t).current, currentTime, prevGeneratorCurrent);
                        }
                        else if (getOrigin) {
                            /**
                             * As a last resort, read the origin from the DOM.
                             */
                            origin = getAsNumber(getOrigin());
                        }
                    }
                }
                /**
                 * If we've determined it is possible to generate an animation, do so.
                 */
                if (canGenerate(origin) && canGenerate(target)) {
                    const generator = getGenerator(origin, target, velocity, name === null || name === void 0 ? void 0 : name.includes("scale"));
                    settings = Object.assign(Object.assign({}, getKeyframes(generator, toUnit)), { easing: "linear" });
                    // TODO Add test for this
                    if (motionValue) {
                        motionValue.generator = generator;
                        motionValue.generatorStartTime = performance.now();
                    }
                }
                /**
                 * If by now we haven't generated a set of keyframes, create a generic generator
                 * based on the provided props that animates from 0-100 to fetch a rough
                 * "overshootDuration" - the moment when the generator first hits the animation target.
                 * Then return animation settings that will run a normal animation for that duration.
                 */
                if (!settings) {
                    const keyframesMetadata = getKeyframes(getGenerator(0, 100));
                    settings = {
                        easing: "ease",
                        duration: keyframesMetadata.overshootDuration,
                    };
                }
                return settings;
            },
        };
    };
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/easing/spring/index.es.js



const index_es_spring = createGeneratorEasing(spring);



;// CONCATENATED MODULE: ../../node_modules/@motionone/generators/dist/glide/index.es.js




const glide = ({ from = 0, velocity = 0.0, power = 0.8, decay = 0.325, bounceDamping, bounceStiffness, changeTarget, min, max, restDistance = 0.5, restSpeed, }) => {
    decay = time.ms(decay);
    const state = {
        hasReachedTarget: false,
        done: false,
        current: from,
        target: from,
    };
    const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
    const nearestBoundary = (v) => {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = changeTarget === undefined ? ideal : changeTarget(ideal);
    state.target = target;
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - from;
    const calcDelta = (t) => -amplitude * Math.exp(-t / decay);
    const calcLatest = (t) => target + calcDelta(t);
    const applyFriction = (t) => {
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDistance;
        state.current = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */
    let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t) => {
        if (!isOutOfBounds(state.current))
            return;
        timeReachedBoundary = t;
        spring$1 = spring({
            from: state.current,
            to: nearestBoundary(state.current),
            velocity: calcGeneratorVelocity(calcLatest, t, state.current),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDistance,
            restSpeed,
        });
    };
    checkCatchBoundary(0);
    return (t) => {
        /**
         * We need to resolve the friction to figure out if we need a
         * spring but we don't want to do this twice per frame. So here
         * we flag if we updated for this frame and later if we did
         * we can skip doing it again.
         */
        let hasUpdatedFrame = false;
        if (!spring$1 && timeReachedBoundary === undefined) {
            hasUpdatedFrame = true;
            applyFriction(t);
            checkCatchBoundary(t);
        }
        /**
         * If we have a spring and the provided t is beyond the moment the friction
         * animation crossed the min/max boundary, use the spring.
         */
        if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
            state.hasReachedTarget = true;
            return spring$1(t - timeReachedBoundary);
        }
        else {
            state.hasReachedTarget = false;
            !hasUpdatedFrame && applyFriction(t);
            return state;
        }
    };
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/easing/glide/index.es.js



const index_es_glide = createGeneratorEasing(glide);



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = (0,resolve_elements_es/* resolveElements */.I)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0,is_function_es/* isFunction */.m)(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/resize/index.es.js + 2 modules
var index_es = __webpack_require__(15472);
// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/index.es.js + 6 modules
var scroll_index_es = __webpack_require__(15734);
// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/offsets/presets.es.js
var presets_es = __webpack_require__(41333);
;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/utils/has-changed.es.js
function hasChanged(a, b) {
    if (typeof a !== typeof b)
        return true;
    if (Array.isArray(a) && Array.isArray(b))
        return !shallowCompare(a, b);
    return a !== b;
}
function shallowCompare(next, prev) {
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/utils/is-variant.es.js
function isVariant(definition) {
    return typeof definition === "object";
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/utils/resolve-variant.es.js


function resolveVariant(definition, variants) {
    if (isVariant(definition)) {
        return definition;
    }
    else if (definition && variants) {
        return variants[definition];
    }
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/utils/schedule.es.js


let scheduled = undefined;
function processScheduledAnimations() {
    if (!scheduled)
        return;
    const generators = scheduled.sort(compareByDepth).map(fireAnimateUpdates);
    generators.forEach(fireNext);
    generators.forEach(fireNext);
    scheduled = undefined;
}
function scheduleAnimation(state) {
    if (!scheduled) {
        scheduled = [state];
        requestAnimationFrame(processScheduledAnimations);
    }
    else {
        addUniqueItem(scheduled, state);
    }
}
function unscheduleAnimation(state) {
    scheduled && removeItem(scheduled, state);
}
const compareByDepth = (a, b) => a.getDepth() - b.getDepth();
const fireAnimateUpdates = (state) => state.animateUpdates();
const fireNext = (iterator) => iterator.next();



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/utils/events.es.js
const motionEvent = (name, target) => new CustomEvent(name, { detail: { target } });
function dispatchPointerEvent(element, name, event) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEvent: event } }));
}
function dispatchViewEvent(element, name, entry) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEntry: entry } }));
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/gestures/in-view.es.js




const in_view_es_inView = {
    isActive: (options) => Boolean(options.inView),
    subscribe: (element, { enable, disable }, { inViewOptions = {} }) => {
        const { once } = inViewOptions, viewOptions = (0,tslib_es6.__rest)(inViewOptions, ["once"]);
        return inView(element, (enterEntry) => {
            enable();
            dispatchViewEvent(element, "viewenter", enterEntry);
            if (!once) {
                return (leaveEntry) => {
                    disable();
                    dispatchViewEvent(element, "viewleave", leaveEntry);
                };
            }
        }, viewOptions);
    },
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/gestures/hover.es.js


const mouseEvent = (element, name, action) => (event) => {
    if (event.pointerType && event.pointerType !== "mouse")
        return;
    action();
    dispatchPointerEvent(element, name, event);
};
const hover = {
    isActive: (options) => Boolean(options.hover),
    subscribe: (element, { enable, disable }) => {
        const onEnter = mouseEvent(element, "hoverstart", enable);
        const onLeave = mouseEvent(element, "hoverend", disable);
        element.addEventListener("pointerenter", onEnter);
        element.addEventListener("pointerleave", onLeave);
        return () => {
            element.removeEventListener("pointerenter", onEnter);
            element.removeEventListener("pointerleave", onLeave);
        };
    },
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/gestures/press.es.js


const press = {
    isActive: (options) => Boolean(options.press),
    subscribe: (element, { enable, disable }) => {
        const onPointerUp = (event) => {
            disable();
            dispatchPointerEvent(element, "pressend", event);
            window.removeEventListener("pointerup", onPointerUp);
        };
        const onPointerDown = (event) => {
            enable();
            dispatchPointerEvent(element, "pressstart", event);
            window.addEventListener("pointerup", onPointerUp);
        };
        element.addEventListener("pointerdown", onPointerDown);
        return () => {
            element.removeEventListener("pointerdown", onPointerDown);
            window.removeEventListener("pointerup", onPointerUp);
        };
    },
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/state/index.es.js















const gestures = { inView: in_view_es_inView, hover: hover, press: press };
/**
 * A list of state types, in priority order. If a value is defined in
 * a righter-most type, it will override any definition in a lefter-most.
 */
const stateTypes = ["initial", "animate", ...Object.keys(gestures), "exit"];
/**
 * A global store of all generated motion states. This can be used to lookup
 * a motion state for a given Element.
 */
const mountedStates = new WeakMap();
function createMotionState(options = {}, parent) {
    /**
     * The element represented by the motion state. This is an empty reference
     * when we create the state to support SSR and allow for later mounting
     * in view libraries.
     *
     * @ts-ignore
     */
    let element;
    /**
     * Calculate a depth that we can use to order motion states by tree depth.
     */
    let depth = parent ? parent.getDepth() + 1 : 0;
    /**
     * Track which states are currently active.
     */
    const activeStates = { initial: true, animate: true };
    /**
     * A map of functions that, when called, will remove event listeners for
     * a given gesture.
     */
    const gestureSubscriptions = {};
    /**
     * Initialise a context to share through motion states. This
     * will be populated by variant names (if any).
     */
    const context = {};
    for (const name of stateTypes) {
        context[name] =
            typeof options[name] === "string"
                ? options[name]
                : parent === null || parent === void 0 ? void 0 : parent.getContext()[name];
    }
    /**
     * If initial is set to false we use the animate prop as the initial
     * animation state.
     */
    const initialVariantSource = options.initial === false ? "animate" : "initial";
    /**
     * Destructure an initial target out from the resolved initial variant.
     */
    let _a = resolveVariant(options[initialVariantSource] || context[initialVariantSource], options.variants) || {}, target = (0,tslib_es6.__rest)(_a, ["transition"]);
    /**
     * The base target is a cached map of values that we'll use to animate
     * back to if a value is removed from all active state types. This
     * is usually the initial value as read from the DOM, for instance if
     * it hasn't been defined in initial.
     */
    const baseTarget = Object.assign({}, target);
    /**
     * A generator that will be processed by the global animation scheduler.
     * This yields when it switches from reading the DOM to writing to it
     * to prevent layout thrashing.
     */
    function* animateUpdates() {
        var _a, _b;
        const prevTarget = target;
        target = {};
        const animationOptions = {};
        for (const name of stateTypes) {
            if (!activeStates[name])
                continue;
            const variant = resolveVariant(options[name]);
            if (!variant)
                continue;
            for (const key in variant) {
                if (key === "transition")
                    continue;
                target[key] = variant[key];
                animationOptions[key] = getOptions((_b = (_a = variant.transition) !== null && _a !== void 0 ? _a : options.transition) !== null && _b !== void 0 ? _b : {}, key);
            }
        }
        const allTargetKeys = new Set([
            ...Object.keys(target),
            ...Object.keys(prevTarget),
        ]);
        const animationFactories = [];
        allTargetKeys.forEach((key) => {
            var _a;
            if (target[key] === undefined) {
                target[key] = baseTarget[key];
            }
            if (hasChanged(prevTarget[key], target[key])) {
                (_a = baseTarget[key]) !== null && _a !== void 0 ? _a : (baseTarget[key] = style.get(element, key));
                animationFactories.push(animateStyle(element, key, target[key], animationOptions[key], Animation));
            }
        });
        // Wait for all animation states to read from the DOM
        yield;
        const animations = animationFactories
            .map((factory) => factory())
            .filter(Boolean);
        if (!animations.length)
            return;
        const animationTarget = target;
        element.dispatchEvent(motionEvent("motionstart", animationTarget));
        Promise.all(animations.map((animation) => animation.finished))
            .then(() => {
            element.dispatchEvent(motionEvent("motioncomplete", animationTarget));
        })
            .catch(noop_es/* noop */.Z);
    }
    const setGesture = (name, isActive) => () => {
        activeStates[name] = isActive;
        scheduleAnimation(state);
    };
    const updateGestureSubscriptions = () => {
        for (const name in gestures) {
            const isGestureActive = gestures[name].isActive(options);
            const remove = gestureSubscriptions[name];
            if (isGestureActive && !remove) {
                gestureSubscriptions[name] = gestures[name].subscribe(element, {
                    enable: setGesture(name, true),
                    disable: setGesture(name, false),
                }, options);
            }
            else if (!isGestureActive && remove) {
                remove();
                delete gestureSubscriptions[name];
            }
        }
    };
    const state = {
        update: (newOptions) => {
            if (!element)
                return;
            options = newOptions;
            updateGestureSubscriptions();
            scheduleAnimation(state);
        },
        setActive: (name, isActive) => {
            if (!element)
                return;
            activeStates[name] = isActive;
            scheduleAnimation(state);
        },
        animateUpdates,
        getDepth: () => depth,
        getTarget: () => target,
        getOptions: () => options,
        getContext: () => context,
        mount: (newElement) => {
            (0,hey_listen_es.invariant)(Boolean(newElement), "Animation state must be mounted with valid Element");
            element = newElement;
            mountedStates.set(element, state);
            updateGestureSubscriptions();
            return () => {
                mountedStates.delete(element);
                unscheduleAnimation(state);
                for (const key in gestureSubscriptions) {
                    gestureSubscriptions[key]();
                }
            };
        },
        isMounted: () => Boolean(element),
    };
    return state;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/style-object.es.js



function createStyles(keyframes) {
    const initialKeyframes = {};
    const transformKeys = [];
    for (let key in keyframes) {
        const value = keyframes[key];
        if (isTransform(key)) {
            if (transformAlias[key])
                key = transformAlias[key];
            transformKeys.push(key);
            key = asTransformCssVar(key);
        }
        let initialKeyframe = Array.isArray(value) ? value[0] : value;
        /**
         * If this is a number and we have a default value type, convert the number
         * to this type.
         */
        const definition = transformDefinitions.get(key);
        if (definition) {
            initialKeyframe = (0,is_number_es/* isNumber */.h)(value)
                ? definition.toDefaultUnit(value)
                : value;
        }
        initialKeyframes[key] = initialKeyframe;
    }
    if (transformKeys.length) {
        initialKeyframes.transform = buildTransformTemplate(transformKeys);
    }
    return initialKeyframes;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/animate/utils/style-string.es.js


const camelLetterToPipeLetter = (letter) => `-${letter.toLowerCase()}`;
const camelToPipeCase = (str) => str.replace(/[A-Z]/g, camelLetterToPipeLetter);
function createStyleString(target = {}) {
    const styles = createStyles(target);
    let style = "";
    for (const key in styles) {
        style += key.startsWith("--") ? key : camelToPipeCase(key);
        style += `: ${styles[key]}; `;
    }
    return style;
}



;// CONCATENATED MODULE: ../../node_modules/@motionone/dom/dist/index.es.js




















/***/ }),

/***/ 71010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ resolveElements; }
/* harmony export */ });
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}




/***/ }),

/***/ 62105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
const clamp = (min, max, v) => Math.min(Math.max(v, min), max);




/***/ }),

/***/ 93193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ getEasingForSegment; }
});

// EXTERNAL MODULE: ../../node_modules/@motionone/utils/dist/is-easing-list.es.js
var is_easing_list_es = __webpack_require__(24702);
;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/wrap.es.js
const wrap = (min, max, v) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};



;// CONCATENATED MODULE: ../../node_modules/@motionone/utils/dist/easing.es.js



function getEasingForSegment(easing, i) {
    return (0,is_easing_list_es/* isEasingList */.K)(easing)
        ? easing[wrap(0, easing.length, i)]
        : easing;
}




/***/ }),

/***/ 16395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ interpolate; }
/* harmony export */ });
/* harmony import */ var _mix_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33877);
/* harmony import */ var _noop_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82278);
/* harmony import */ var _offset_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26560);
/* harmony import */ var _progress_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39496);
/* harmony import */ var _easing_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93193);
/* harmony import */ var _clamp_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62105);







function interpolate(output, input = (0,_offset_es_js__WEBPACK_IMPORTED_MODULE_0__/* .defaultOffset */ .Y)(output.length), easing = _noop_es_js__WEBPACK_IMPORTED_MODULE_1__/* .noopReturn */ .V) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */
    const remainder = length - input.length;
    remainder > 0 && (0,_offset_es_js__WEBPACK_IMPORTED_MODULE_0__/* .fillOffset */ .c)(input, remainder);
    return (t) => {
        let i = 0;
        for (; i < length - 2; i++) {
            if (t < input[i + 1])
                break;
        }
        let progressInRange = (0,_clamp_es_js__WEBPACK_IMPORTED_MODULE_2__/* .clamp */ .u)(0, 1, (0,_progress_es_js__WEBPACK_IMPORTED_MODULE_3__/* .progress */ .Y)(input[i], input[i + 1], t));
        const segmentEasing = (0,_easing_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getEasingForSegment */ .I)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0,_mix_es_js__WEBPACK_IMPORTED_MODULE_5__/* .mix */ .C)(output[i], output[i + 1], progressInRange);
    };
}




/***/ }),

/***/ 24702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ isEasingList; }
/* harmony export */ });
/* harmony import */ var _is_number_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68213);


const isEasingList = (easing) => Array.isArray(easing) && !(0,_is_number_es_js__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .h)(easing[0]);




/***/ }),

/***/ 26766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ isFunction; }
/* harmony export */ });
const isFunction = (value) => typeof value === "function";




/***/ }),

/***/ 68213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ isNumber; }
/* harmony export */ });
const isNumber = (value) => typeof value === "number";




/***/ }),

/***/ 90003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ isString; }
/* harmony export */ });
const isString = (value) => typeof value === "string";




/***/ }),

/***/ 33877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ mix; }
/* harmony export */ });
const mix = (min, max, progress) => -progress * min + progress * max + min;




/***/ }),

/***/ 82278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ noopReturn; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
const noop = () => { };
const noopReturn = (v) => v;




/***/ }),

/***/ 26560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ defaultOffset; },
/* harmony export */   "c": function() { return /* binding */ fillOffset; }
/* harmony export */ });
/* harmony import */ var _mix_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33877);
/* harmony import */ var _progress_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39496);



function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = (0,_progress_es_js__WEBPACK_IMPORTED_MODULE_0__/* .progress */ .Y)(0, remaining, i);
        offset.push((0,_mix_es_js__WEBPACK_IMPORTED_MODULE_1__/* .mix */ .C)(min, 1, offsetProgress));
    }
}
function defaultOffset(length) {
    const offset = [0];
    fillOffset(offset, length - 1);
    return offset;
}




/***/ }),

/***/ 39496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ progress; }
/* harmony export */ });
const progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);




/***/ }),

/***/ 89831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ velocityPerSecond; }
/* harmony export */ });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 13421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 50381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(91706);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 39714:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 62584:
/***/ (function(module) {

/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */

( function( global, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

function EvEmitter() {}

let proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) return this;

  // set events hash
  let events = this._events = this._events || {};
  // set listeners array
  let listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( !listeners.includes( listener ) ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) return this;

  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  let onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  let onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  let listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) return this;

  let index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  let listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) return this;

  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice( 0 );
  args = args || [];
  // once stuff
  let onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( let listener of listeners ) {
    let isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
  return this;
};

return EvEmitter;

} ) );


/***/ }),

/***/ 44082:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 34235:
/***/ (function(__unused_webpack_module, exports) {

var keyList = Object.keys;

exports.D = function equal (a, b) {
  if (a === b) return true;
  if (!(a instanceof Object) || !(b instanceof Object)) return false;

  var keys = keyList(a);
  var length = keys.length;

  for (var i = 0; i < length; i++)
    if (!(keys[i] in b)) return false;

  for (var i = 0; i < length; i++)
    if (a[keys[i]] !== b[keys[i]]) return false;

  return length === keyList(b).length;
};


/***/ }),

/***/ 63966:
/***/ (function(module) {

/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */

( function( global, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( global );
  } else {
    // browser global
    global.fizzyUIUtils = factory( global );
  }

}( this, function factory( global ) {

let utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  return Object.assign( a, b );
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  // use object if already an array
  if ( Array.isArray( obj ) ) return obj;

  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) return [];

  let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  // convert nodeList to array
  if ( isArrayLike ) return [ ...obj ];

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  let index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( elem.matches( selector ) ) return elem;
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  let method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );

  return elems
    // check that elem is an actual element
    .filter( ( elem ) => elem instanceof HTMLElement )
    .reduce( ( ffElems, elem ) => {
      // add elem if no selector
      if ( !selector ) {
        ffElems.push( elem );
        return ffElems;
      }
      // filter & find items if we have a selector
      // filter
      if ( elem.matches( selector ) ) {
        ffElems.push( elem );
      }
      // find children
      let childElems = elem.querySelectorAll( selector );
      // concat childElems to filterFound array
      ffElems = ffElems.concat( ...childElems );
      return ffElems;
    }, [] );
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  let method = _class.prototype[ methodName ];
  let timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    clearTimeout( this[ timeoutName ] );

    let args = arguments;
    this[ timeoutName ] = setTimeout( () => {
      method.apply( this, args );
      delete this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( onDocReady ) {
  let readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( onDocReady );
  } else {
    document.addEventListener( 'DOMContentLoaded', onDocReady );
  }
};

// ----- htmlInit ----- //

// http://bit.ly/3oYLusc
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  } ).toLowerCase();
};

let console = global.console;

// allow user to initialize classes via [data-namespace] or .js-namespace class
// htmlInit( Widget, 'widgetName' )
// options are parsed from data-namespace-options
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    let dashedNamespace = utils.toDashed( namespace );
    let dataAttr = 'data-' + dashedNamespace;
    let dataAttrElems = document.querySelectorAll( `[${dataAttr}]` );
    let jQuery = global.jQuery;

    [ ...dataAttrElems ].forEach( ( elem ) => {
      let attr = elem.getAttribute( dataAttr );
      let options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( `Error parsing ${dataAttr} on ${elem.className}: ${error}` );
        }
        return;
      }
      // initialize
      let instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    } );

  } );
};

// -----  ----- //

return utils;

} ) );


/***/ }),

/***/ 72076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// add, remove cell
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        __webpack_require__(28071),
        __webpack_require__(63966),
    );
  } else {
    // browser global
    factory(
        window.Flickity,
        window.fizzyUIUtils,
    );
  }

}( typeof window != 'undefined' ? window : this, function factory( Flickity, utils ) {

// append cells to a document fragment
function getCellsFragment( cells ) {
  let fragment = document.createDocumentFragment();
  cells.forEach( ( cell ) => fragment.appendChild( cell.element ) );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

let proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  let cells = this._makeCells( elems );
  if ( !cells || !cells.length ) return;

  let len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  let fragment = getCellsFragment( cells );
  // append to slider
  let isAppend = index === len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    let insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    let endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index );
  this.positionSliderAtSelected();
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  let cells = this.getCells( elems );
  if ( !cells || !cells.length ) return;

  let minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( ( cell ) => {
    cell.remove();
    let index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  } );

  this.cellChange( minCellIndex );
  this.positionSliderAtSelected();
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  let cell = this.getCell( elem );
  if ( !cell ) return;

  cell.getSize();

  let index = this.cells.indexOf( cell );
  this.cellChange( index );
  // do not position slider after lazy load
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */
proto.cellChange = function( changedCellIndex ) {
  let prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._updateWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex, try to maintain position & select previous selected element
  let cell = this.getCell( prevSelectedElem );
  if ( cell ) this.selectedIndex = this.getCellSlideIndex( cell );
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
};

// -----  ----- //

return Flickity;

} ) );


/***/ }),

/***/ 76268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// animate
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( __webpack_require__(63966) );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory( window.fizzyUIUtils );
  }

}( typeof window != 'undefined' ? window : this, function factory( utils ) {

// -------------------------- animate -------------------------- //

let proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) return;

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  let previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) requestAnimationFrame( () => this.animate() );
};

proto.positionSlider = function() {
  let x = this.x;
  // wrap position around
  if ( this.isWrapping ) {
    x = utils.modulo( x, this.slideableWidth ) - this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  if ( this.options.rightToLeft ) x = -x;
  let translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
};

proto.dispatchScrollEvent = function() {
  let firstSlide = this.slides[0];
  if ( !firstSlide ) return;

  let positionX = -this.x - firstSlide.target;
  let progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) return;

  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  let isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) === Math.round( previousX * 100 );
  if ( isResting ) this.restingFrames++;
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  let beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  let afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  cells.forEach( ( cell ) => {
    let cellShift = gap > 0 ? shift : 0;
    this._wrapShiftCell( cell, cellShift );
    gap -= cell.size.outerWidth;
  } );
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) return;

  cells.forEach( ( cell ) => this._wrapShiftCell( cell, 0 ) );
};

// @param {Integer} shift - 0, 1, or -1
proto._wrapShiftCell = function( cell, shift ) {
  this._renderCellPosition( cell, cell.x + this.slideableWidth * shift );
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) return;

  // change the position to drag position by applying force
  let dragVelocity = this.dragX - this.x;
  let dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  let dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) return;

  let distance = this.selectedSlide.target * -1 - this.x;
  let force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );


/***/ }),

/***/ 90378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( __webpack_require__(40172) );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory( window.getSize );
  }

}( typeof window != 'undefined' ? window : this, function factory( getSize ) {

const cellClassName = 'flickity-cell';

function Cell( elem ) {
  this.element = elem;
  this.element.classList.add( cellClassName );

  this.x = 0;
  this.unselect();
}

let proto = Cell.prototype;

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.classList.remove( cellClassName );
  this.element.style.transform = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

proto.remove = function() {
  this.element.remove();
};

return Cell;

} ) );


/***/ }),

/***/ 28071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        __webpack_require__(62584),
        __webpack_require__(40172),
        __webpack_require__(63966),
        __webpack_require__(90378),
        __webpack_require__(53303),
        __webpack_require__(76268),
    );
  } else {
    // browser global
    let _Flickity = window.Flickity;

    window.Flickity = factory(
        window,
        window.EvEmitter,
        window.getSize,
        window.fizzyUIUtils,
        _Flickity.Cell,
        _Flickity.Slide,
        _Flickity.animatePrototype,
    );
  }

}( typeof window != 'undefined' ? window : this,
    function factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
/* eslint-enable max-params */

// vars
const { getComputedStyle, console } = window;
let { jQuery } = window;

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
let GUID = 0;
// internal store of all Flickity intances
let instances = {};

function Flickity( element, options ) {
  let queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) console.error(`Bad element for Flickity: ${queryElement || element}`);
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    let instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = { ...this.constructor.defaults };
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.create = {};

let proto = Flickity.prototype;
// inherit EventEmitter
Object.assign( proto, EvEmitter.prototype );

proto._create = function() {
  let { resize, watchCSS, rightToLeft } = this.options;
  // add id for Flickity.data
  let id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
  this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();
  // used for keyboard navigation
  this.focusableElems = [ this.element ];

  if ( resize || watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( let eventName in this.options.on ) {
    let listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  for ( let method in Flickity.create ) {
    Flickity.create[ method ].call( this );
  }

  if ( watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }
};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  Object.assign( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) return;

  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  let cellElems = this._filterFindCellElements( this.element.children );
  this.slider.append( ...cellElems );
  this.viewport.append( this.slider );
  this.element.append( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  let slider = document.createElement('div');
  slider.className = 'flickity-slider';
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._updateWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  let cellElems = this._filterFindCellElements( elems );

  // create new Cells for collection
  return cellElems.map( ( cellElem ) => new Cell( cellElem ) );
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  let cellX = 0;
  // get cellX
  if ( index > 0 ) {
    let startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }

  this.cells.slice( index ).forEach( ( cell ) => {
    cell.x = cellX;
    this._renderCellPosition( cell, cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  } );
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = this.cells.length ?
    this.getLastSlide().target - this.slides[0].target : 0;
};

proto._renderCellPosition = function( cell, x ) {
  // render position of cell with in slider
  let sideOffset = this.options.rightToLeft ? -1 : 1;
  let renderX = x * sideOffset;
  if ( this.options.percentPosition ) renderX *= this.size.innerWidth / cell.size.width;
  let positionValue = this.getPositionValue( renderX );
  cell.element.style.transform = `translateX( ${positionValue} )`;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( ( cell ) => cell.getSize() );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) return;

  let { beginMargin, endMargin } = this;
  let slide = new Slide( beginMargin, endMargin, this.cellAlign );
  this.slides.push( slide );

  let canCellFit = this._getCanCellFit();

  this.cells.forEach( ( cell, i ) => {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    let slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ endMargin ] );

    if ( canCellFit( i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( beginMargin, endMargin, this.cellAlign );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  } );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  let { groupCells } = this.options;
  if ( !groupCells ) return () => false;

  if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    let number = parseInt( groupCells, 10 );
    return ( i ) => ( i % number ) !== 0;
  }
  // default, group by width of slide
  let percent = 1;
  // parse '75%
  let percentMatch = typeof groupCells == 'string' && groupCells.match( /^(\d+)%$/ );
  if ( percentMatch ) percent = parseInt( percentMatch[1], 10 ) / 100;
  let groupWidth = ( this.size.innerWidth + 1 ) * percent;
  return ( i, slideWidth ) => slideWidth <= groupWidth;
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

let cellAlignShorthands = {
  left: 0,
  center: 0.5,
  right: 1,
};

proto.setCellAlign = function() {
  let { cellAlign, rightToLeft } = this.options;
  let shorthand = cellAlignShorthands[ cellAlign ];
  this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
  if ( rightToLeft ) this.cellAlign = 1 - this.cellAlign;
};

proto.setGallerySize = function() {
  if ( !this.options.setGallerySize ) return;

  let height = this.options.adaptiveHeight && this.selectedSlide ?
    this.selectedSlide.height : this.maxCellHeight;
  this.viewport.style.height = `${height}px`;
};

proto._updateWrapShiftCells = function() {
  // update isWrapping
  this.isWrapping = this.getIsWrapping();
  // only for wrap-around
  if ( !this.isWrapping ) return;

  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  let beforeGapX = this.cursorPosition;
  let lastIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( beforeGapX, lastIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  let afterGapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( afterGapX, 0, 1 );
};

proto.getIsWrapping = function() {
  let { wrapAround } = this.options;
  if ( !wrapAround || this.slides.length < 2 ) return false;

  if ( wrapAround !== 'fill' ) return true;
  // check that slides can fit

  let gapWidth = this.slideableWidth - this.size.innerWidth;
  if ( gapWidth > this.size.innerWidth ) return true; // gap * 2x big, all good
  // check that content width - shifting cell is bigger than viewport width
  for ( let cell of this.cells ) {
    if ( cell.size.outerWidth > gapWidth ) return false;
  }
  return true;
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  let cells = [];
  while ( gapX > 0 ) {
    let cell = this.cells[ cellIndex ];
    if ( !cell ) break;

    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain & wrap ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  let isContaining = this.options.contain && !this.isWrapping &&
      this.cells.length;
  if ( !isContaining ) return;

  let contentWidth = this.slideableWidth - this.getLastCell().size[ this.endMargin ];
  // content is less than gallery size
  let isContentSmaller = contentWidth < this.size.innerWidth;
  if ( isContentSmaller ) {
    // all cells fit inside gallery
    this.slides.forEach( ( slide ) => {
      slide.target = contentWidth * this.cellAlign;
    } );
  } else {
    // contain to bounds
    let beginBound = this.cursorPosition + this.cells[0].size[ this.beginMargin ];
    let endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
    this.slides.forEach( ( slide ) => {
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    } );
  }
};

// ----- events ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  let emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    let $event = type;
    if ( event ) {
      // create jQuery event
      let jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

const unidraggerEvents = [
  'dragStart',
  'dragMove',
  'dragEnd',
  'pointerDown',
  'pointerMove',
  'pointerEnd',
  'staticClick',
];

let _emitEvent = proto.emitEvent;
proto.emitEvent = function( eventName, args ) {
  if ( eventName === 'staticClick' ) {
    // add cellElem and cellIndex args to staticClick
    let clickedCell = this.getParentCell( args[0].target );
    let cellElem = clickedCell && clickedCell.element;
    let cellIndex = clickedCell && this.cells.indexOf( clickedCell );
    args = args.concat( cellElem, cellIndex );
  }
  // do regular thing
  _emitEvent.call( this, eventName, args );
  // duck-punch in jQuery events for Unidragger events
  let isUnidraggerEvent = unidraggerEvents.includes( eventName );
  if ( !isUnidraggerEvent || !jQuery || !this.$element ) return;

  eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
  let event = args.shift( 0 );
  let jQEvent = new jQuery.Event( event );
  jQEvent.type = eventName;
  this.$element.trigger( jQEvent, args );
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) return;

  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.isWrapping || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) return;

  let prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index !== prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  if ( !this.isWrapping ) return;

  const { selectedIndex, slideableWidth, slides: { length } } = this;
  // shift index for wrap, do not wrap dragSelect
  if ( !this.isDragSelect ) {
    let wrapIndex = utils.modulo( index, length );
    // go to shortest
    let delta = Math.abs( wrapIndex - selectedIndex );
    let backWrapDelta = Math.abs( ( wrapIndex + length ) - selectedIndex );
    let forewardWrapDelta = Math.abs( ( wrapIndex - length ) - selectedIndex );
    if ( backWrapDelta < delta ) {
      index += length;
    } else if ( forewardWrapDelta < delta ) {
      index -= length;
    }
  }

  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= slideableWidth;
  } else if ( index >= length ) {
    this.x += slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  let slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) return;

  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) this.selectedSlide.unselect();
};

proto.selectInitialIndex = function() {
  let initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    let cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  let index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  let cell = this.queryCell( value );
  if ( !cell ) return;

  let index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slide that has cell
  let cellSlide = this.slides.find( ( slide ) => slide.cells.includes( cell ) );
  return this.slides.indexOf( cellSlide );
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( let cell of this.cells ) {
    if ( cell.element === elem ) return cell;
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  return elems.map( ( elem ) => this.getCell( elem ) ).filter( Boolean );
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( ( cell ) => cell.element );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  let cell = this.getCell( elem );
  if ( cell ) return cell;

  // try to get parent cell elem
  let closest = elem.closest('.flickity-slider > *');
  return this.getCell( closest );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) return this.selectedSlide.getCellElements();

  index = index === undefined ? this.selectedIndex : index;

  let len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements(); // get all
  }

  let cellElems = [];
  for ( let i = index - adjCount; i <= index + adjCount; i++ ) {
    let slideIndex = this.isWrapping ? utils.modulo( i, len ) : i;
    let slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  // do not select invalid selectors from hash: #123, #/. #791
  let isSelectorString = typeof selector == 'string' && !selector.match( /^[#.]?[\d/]/ );
  if ( isSelectorString ) {
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  // #1177 disable resize behavior when animating or dragging for iOS 15
  if ( !this.isActive || this.isAnimating || this.isDragging ) return;
  this.getSize();
  // wrap values
  if ( this.isWrapping ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._updateWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  let selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  if ( !this.options.watchCSS ) return;

  let afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.includes('flickity') ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  let { activeElement } = document;
  let handler = Flickity.keyboardHandlers[ event.key ];
  // only work if element is in focus
  if ( !this.options.accessibility || !activeElement || !handler ) return;

  let isFocused = this.focusableElems.some( ( elem ) => activeElement === elem );
  if ( isFocused ) handler.call( this );
};

Flickity.keyboardHandlers = {
  ArrowLeft: function() {
    this.uiChange();
    let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this[ leftMethod ]();
  },
  ArrowRight: function() {
    this.uiChange();
    let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  this.element.focus({ preventScroll: true });
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) return;

  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( ( cell ) => cell.destroy() );
  this.viewport.remove();
  // move child elements back into element
  this.element.append( ...this.slider.children );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

Object.assign( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  if ( elem ) return instances[ elem.flickityGUID ];
};

utils.htmlInit( Flickity, 'flickity' );

let { jQueryBridget } = window;
if ( jQuery && jQueryBridget ) {
  jQueryBridget( 'flickity', Flickity, jQuery );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );


/***/ }),

/***/ 56207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// drag
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        __webpack_require__(28071),
        __webpack_require__(17083),
        __webpack_require__(63966),
    );
  } else {
    // browser global
    window.Flickity = factory(
        window,
        window.Flickity,
        window.Unidragger,
        window.fizzyUIUtils,
    );
  }

}( typeof window != 'undefined' ? window : this,
    function factory( window, Flickity, Unidragger, utils ) {

// ----- defaults ----- //

Object.assign( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// -------------------------- drag prototype -------------------------- //

let proto = Flickity.prototype;
Object.assign( proto, Unidragger.prototype ); // inherit Unidragger
proto.touchActionValue = '';

// --------------------------  -------------------------- //

Flickity.create.drag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  this.on( 'pointerDown', this.handlePointerDown );
  this.on( 'pointerUp', this.handlePointerUp );
  this.on( 'pointerDown', this.handlePointerDone );
  this.on( 'dragStart', this.handleDragStart );
  this.on( 'dragMove', this.handleDragMove );
  this.on( 'dragEnd', this.handleDragEnd );
  this.on( 'staticClick', this.handleStaticClick );
  // TODO updateDraggable on resize? if groupCells & slides change
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable === '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  this.element.classList.toggle( 'is-draggable', this.isDraggable );
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.handlePointerDown = function( event ) {
  if ( !this.isDraggable ) {
    // proceed for staticClick
    this.bindActivePointerEvents( event );
    return;
  }

  let isTouchStart = event.type === 'touchstart';
  let isTouchPointer = event.pointerType === 'touch';
  let isFocusNode = event.target.matches('input, textarea, select');
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) event.preventDefault();
  if ( !isFocusNode ) this.focus();
  // blur
  if ( document.activeElement !== this.element ) document.activeElement.blur();
  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );
  this.bindActivePointerEvents( event );
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.handlePointerUp = function() {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
};

proto.handlePointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.handleDragStart = function() {
  if ( !this.isDraggable ) return;

  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
};

proto.handleDragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) return;

  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  let direction = this.options.rightToLeft ? -1 : 1;
  // wrap around move. #589
  if ( this.isWrapping ) moveVector.x %= this.slideableWidth;
  let dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.isWrapping ) {
    // slow drag
    let originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    let endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;
  this.dragMoveTime = new Date();
};

proto.handleDragEnd = function() {
  if ( !this.isDraggable ) return;

  let { freeScroll } = this.options;
  if ( freeScroll ) this.isFreeScrolling = true;
  // set selectedIndex based on where flick will end up
  let index = this.dragEndRestingSelect();

  if ( freeScroll && !this.isWrapping ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    let restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !freeScroll && index === this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.isWrapping;
  this.select( index );
  delete this.isDragSelect;
};

proto.dragEndRestingSelect = function() {
  let restingX = this.getRestingPosition();
  // how far away from selected slide
  let distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  let positiveResting = this._getClosestResting( restingX, distance, 1 );
  let negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  return positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  let index = this.selectedIndex;
  let minDistance = Infinity;
  let condition = this.options.contain && !this.isWrapping ?
    // if containing, keep going if distance is equal to minDistance
    ( dist, minDist ) => dist <= minDist :
    ( dist, minDist ) => dist < minDist;

  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) break;

    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  let len = this.slides.length;
  // wrap around if at least 2 slides
  let isWrapAround = this.options.wrapAround && len > 1;
  let slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  let slide = this.slides[ slideIndex ];
  if ( !slide ) return null;

  // add distance for wrap-around slides
  let wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  let distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  let delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- scroll ----- //

proto.onscroll = function() {
  let scroll = getScrollPosition();
  let scrollMoveX = this.pointerDownScroll.x - scroll.x;
  let scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this.pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );


/***/ }),

/***/ 61982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// imagesloaded
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        __webpack_require__(28071),
        __webpack_require__(25669),
    );
  } else {
    // browser global
    factory(
        window.Flickity,
        window.imagesLoaded,
    );
  }

}( typeof window != 'undefined' ? window : this,
    function factory( Flickity, imagesLoaded ) {

Flickity.create.imagesLoaded = function() {
  this.on( 'activate', this.imagesLoaded );
};

Flickity.prototype.imagesLoaded = function() {
  if ( !this.options.imagesLoaded ) return;

  let onImagesLoadedProgress = ( instance, image ) => {
    let cell = this.getParentCell( image.img );
    this.cellSizeChange( cell && cell.element );
    if ( !this.options.freeScroll ) this.positionSliderAtSelected();
  };
  imagesLoaded( this.slider ).on( 'progress', onImagesLoadedProgress );
};

return Flickity;

} ) );


/***/ }),

/***/ 89735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */

if (  true && module.exports ) {
  const Flickity = __webpack_require__(28071);
  __webpack_require__(56207);
  __webpack_require__(28066);
  __webpack_require__(91114);
  __webpack_require__(58476);
  __webpack_require__(72076);
  __webpack_require__(8107);
  __webpack_require__(61982);

  module.exports = Flickity;
}


/***/ }),

/***/ 8107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// lazyload
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        __webpack_require__(28071),
        __webpack_require__(63966),
    );
  } else {
    // browser global
    factory(
        window.Flickity,
        window.fizzyUIUtils,
    );
  }

}( typeof window != 'undefined' ? window : this, function factory( Flickity, utils ) {

const lazyAttr = 'data-flickity-lazyload';
const lazySrcAttr = `${lazyAttr}-src`;
const lazySrcsetAttr = `${lazyAttr}-srcset`;
const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` +
  `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;

Flickity.create.lazyLoad = function() {
  this.on( 'select', this.lazyLoad );

  this.handleLazyLoadComplete = this.onLazyLoadComplete.bind( this );
};

let proto = Flickity.prototype;

proto.lazyLoad = function() {
  let { lazyLoad } = this.options;
  if ( !lazyLoad ) return;

  // get adjacent cells, use lazyLoad option for adjacent count
  let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  // lazy load images
  this.getAdjacentCellElements( adjCount )
    .map( getCellLazyImages )
    .flat()
    .forEach( ( img ) => new LazyLoader( img, this.handleLazyLoadComplete ) );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.matches('img') ) {
    let cellAttr = cellElem.getAttribute( lazyAttr );
    let cellSrcAttr = cellElem.getAttribute( lazySrcAttr );
    let cellSrcsetAttr = cellElem.getAttribute( lazySrcsetAttr );
    if ( cellAttr || cellSrcAttr || cellSrcsetAttr ) {
      return cellElem;
    }
  }
  // select lazy images in cell
  return [ ...cellElem.querySelectorAll( imgSelector ) ];
}

proto.onLazyLoadComplete = function( img, event ) {
  let cell = this.getParentCell( img );
  let cellElem = cell && cell.element;
  this.cellSizeChange( cellElem );

  this.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */
function LazyLoader( img, onComplete ) {
  this.img = img;
  this.onComplete = onComplete;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  let src = this.img.getAttribute( lazyAttr ) ||
    this.img.getAttribute( lazySrcAttr );
  let srcset = this.img.getAttribute( lazySrcsetAttr );
  // set src & serset
  this.img.src = src;
  if ( srcset ) this.img.setAttribute( 'srcset', srcset );
  // remove attr
  this.img.removeAttribute( lazyAttr );
  this.img.removeAttribute( lazySrcAttr );
  this.img.removeAttribute( lazySrcsetAttr );
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
  let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
  mediaElem.classList.add( className );

  this.onComplete( this.img, event );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );


/***/ }),

/***/ 91114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// page dots
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        __webpack_require__(28071),
        __webpack_require__(63966),
    );
  } else {
    // browser global
    factory(
        window.Flickity,
        window.fizzyUIUtils,
    );
  }

}( typeof window != 'undefined' ? window : this, function factory( Flickity, utils ) {

// -------------------------- PageDots -------------------------- //

function PageDots() {
  // create holder element
  this.holder = document.createElement('div');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
}

PageDots.prototype.setDots = function( slidesLength ) {
  // get difference between number of slides and number of dots
  let delta = slidesLength - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  let newDots = new Array( count ).fill()
    .map( ( item, i ) => {
      let dot = document.createElement('button');
      dot.setAttribute( 'type', 'button' );
      let num = i + 1 + this.dots.length;
      dot.className = 'flickity-page-dot';
      dot.textContent = `View slide ${num}`;
      return dot;
    } );

  this.holder.append( ...newDots );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  let removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( ( dot ) => dot.remove() );
};

PageDots.prototype.updateSelected = function( index ) {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.classList.remove('is-selected');
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) return;

  this.selectedDot = this.dots[ index ];
  this.selectedDot.classList.add('is-selected');
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

Object.assign( Flickity.defaults, {
  pageDots: true,
} );

Flickity.create.pageDots = function() {
  if ( !this.options.pageDots ) return;

  this.pageDots = new PageDots();
  this.handlePageDotsClick = this.onPageDotsClick.bind( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

let proto = Flickity.prototype;

proto.activatePageDots = function() {
  this.pageDots.setDots( this.slides.length );
  this.focusableElems.push( ...this.pageDots.dots );
  this.pageDots.holder.addEventListener( 'click', this.handlePageDotsClick );
  this.element.append( this.pageDots.holder );
};

proto.onPageDotsClick = function( event ) {
  let index = this.pageDots.dots.indexOf( event.target );
  if ( index === -1 ) return; // only dot clicks

  this.uiChange();
  this.select( index );
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected( this.selectedIndex );
};

proto.updatePageDots = function() {
  this.pageDots.dots.forEach( ( dot ) => {
    utils.removeFrom( this.focusableElems, dot );
  } );
  this.pageDots.setDots( this.slides.length );
  this.focusableElems.push( ...this.pageDots.dots );
};

proto.deactivatePageDots = function() {
  this.pageDots.holder.remove();
  this.pageDots.holder.removeEventListener( 'click', this.handlePageDotsClick );
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );


/***/ }),

/***/ 58476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( __webpack_require__(28071) );
  } else {
    // browser global
    factory( window.Flickity );
  }

}( typeof window != 'undefined' ? window : this, function factory( Flickity ) {

// -------------------------- Player -------------------------- //

function Player( autoPlay, onTick ) {
  this.autoPlay = autoPlay;
  this.onTick = onTick;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

// start play
Player.prototype.play = function() {
  if ( this.state === 'playing' ) return;

  // do not play if page is hidden, start playing when page is visible
  let isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state !== 'playing' ) return;

  // default to 3 seconds
  let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( () => {
    this.onTick();
    this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state === 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state === 'paused' ) this.play();
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  let isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

Object.assign( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.create.player = function() {
  this.player = new Player( this.options.autoPlay, () => {
    this.next( true );
  } );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

let proto = Flickity.prototype;

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) return;

  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) return;

  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );


/***/ }),

/***/ 28066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( __webpack_require__(28071) );
  } else {
    // browser global
    factory( window.Flickity );
  }

}( typeof window != 'undefined' ? window : this, function factory( Flickity ) {

const svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( increment, direction, arrowShape ) {
  this.increment = increment;
  this.direction = direction;
  this.isPrevious = increment === 'previous';
  this.isLeft = direction === 'left';
  this._create( arrowShape );
}

PrevNextButton.prototype._create = function( arrowShape ) {
  // properties
  let element = this.element = document.createElement('button');
  element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
  let label = this.isPrevious ? 'Previous' : 'Next';
  // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  element.setAttribute( 'aria-label', label );
  // init as disabled
  this.disable();
  // create arrow
  let svg = this.createSVG( label, arrowShape );
  element.append( svg );
};

PrevNextButton.prototype.createSVG = function( label, arrowShape ) {
  let svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  // add title #1189
  let title = document.createElementNS( svgURI, 'title' );
  title.append( label );
  // add path
  let path = document.createElementNS( svgURI, 'path' );
  let pathMovements = getArrowMovements( arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180)' );
  }
  svg.append( title, path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) return shape;

  let { x0, x1, x2, x3, y1, y2 } = shape;

  // create movement string
  return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
}

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  this.element.removeAttribute('disabled');
};

PrevNextButton.prototype.disable = function() {
  this.element.setAttribute( 'disabled', true );
};

// -------------------------- Flickity prototype -------------------------- //

Object.assign( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.create.prevNextButtons = function() {
  if ( !this.options.prevNextButtons ) return;

  let { rightToLeft, arrowShape } = this.options;
  let prevDirection = rightToLeft ? 'right' : 'left';
  let nextDirection = rightToLeft ? 'left' : 'right';
  this.prevButton = new PrevNextButton( 'previous', prevDirection, arrowShape );
  this.nextButton = new PrevNextButton( 'next', nextDirection, arrowShape );
  this.focusableElems.push( this.prevButton.element );
  this.focusableElems.push( this.nextButton.element );

  this.handlePrevButtonClick = () => {
    this.uiChange();
    this.previous();
  };

  this.handleNextButtonClick = () => {
    this.uiChange();
    this.next();
  };

  this.on( 'activate', this.activatePrevNextButtons );
  this.on( 'select', this.updatePrevNextButtons );
};

let proto = Flickity.prototype;

proto.updatePrevNextButtons = function() {
  let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
  this.updatePrevNextButton( this.prevButton, 0 );
  this.updatePrevNextButton( this.nextButton, lastIndex );
};

proto.updatePrevNextButton = function( button, disabledIndex ) {
  // enable is wrapAround and at least 2 slides
  if ( this.isWrapping && this.slides.length > 1 ) {
    button.enable();
    return;
  }

  let isEnabled = this.selectedIndex !== disabledIndex;
  button[ isEnabled ? 'enable' : 'disable' ]();
  // if disabling button that is focused,
  // shift focus to element to maintain keyboard accessibility
  let isDisabledFocused = !isEnabled && document.activeElement === button.element;
  if ( isDisabledFocused ) this.focus();
};

proto.activatePrevNextButtons = function() {
  this.prevButton.element.addEventListener( 'click', this.handlePrevButtonClick );
  this.nextButton.element.addEventListener( 'click', this.handleNextButtonClick );
  this.element.append( this.prevButton.element, this.nextButton.element );
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.element.remove();
  this.nextButton.element.remove();
  this.prevButton.element.removeEventListener( 'click', this.handlePrevButtonClick );
  this.nextButton.element.removeEventListener( 'click', this.handleNextButtonClick );
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );


/***/ }),

/***/ 53303:
/***/ (function(module) {

// slide
( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( typeof window != 'undefined' ? window : this, function factory() {

function Slide( beginMargin, endMargin, cellAlign ) {
  this.beginMargin = beginMargin;
  this.endMargin = endMargin;
  this.cellAlign = cellAlign;
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

let proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length === 1 ) {
    this.x = cell.x; // x comes from first cell
    this.firstMargin = cell.size[ this.beginMargin ];
  }
};

proto.updateTarget = function() {
  let lastCell = this.getLastCell();
  let lastMargin = lastCell ? lastCell.size[ this.endMargin ] : 0;
  let slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( ( cell ) => cell.select() );
};

proto.unselect = function() {
  this.cells.forEach( ( cell ) => cell.unselect() );
};

proto.getCellElements = function() {
  return this.cells.map( ( cell ) => cell.element );
};

return Slide;

} ) );


/***/ }),

/***/ 25669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory( window, __webpack_require__(62584) );
  } else {
    // browser global
    window.imagesLoaded = factory( window, window.EvEmitter );
  }

} )( typeof window !== 'undefined' ? window : this,
    function factory( window, EvEmitter ) {

let $ = window.jQuery;
let console = window.console;

// -------------------------- helpers -------------------------- //

// turn element or nodeList into an array
function makeArray( obj ) {
  // use object if already an array
  if ( Array.isArray( obj ) ) return obj;

  let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  // convert nodeList to array
  if ( isArrayLike ) return [ ...obj ];

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  let queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = {};
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    Object.assign( this.options, options );
  }

  if ( onAlways ) this.on( 'always', onAlways );

  this.getImages();
  // add jQuery Deferred object
  if ( $ ) this.jqDeferred = new $.Deferred();

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

const elementNodeTypes = [ 1, 9, 11 ];

/**
 * @param {Node} elem
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName === 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  let { nodeType } = elem;
  if ( !nodeType || !elementNodeTypes.includes( nodeType ) ) return;

  let childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( let img of childImgs ) {
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    let children = elem.querySelectorAll( this.options.background );
    for ( let child of children ) {
      this.addElementBackgroundImages( child );
    }
  }
};

const reURL = /url\((['"])?(.*?)\1\)/gi;

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  let style = getComputedStyle( elem );
  // Firefox returns null if in a hidden iframe https://bugzil.la/548397
  if ( !style ) return;

  // get url inside url("...")
  let matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    let url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  let loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  let background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  /* eslint-disable-next-line func-style */
  let onProgress = ( image, elem, message ) => {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( () => {
      this.progress( image, elem, message );
    } );
  };

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  } );
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount === this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( `progress: ${message}`, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  let eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  let isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  // add crossOrigin attribute. #204
  if ( this.img.crossOrigin ) {
    this.proxyImage.crossOrigin = this.img.crossOrigin;
  }
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.currentSrc || this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  let { parentNode } = this.img;
  // emit progress with parent <picture> or self <img>
  let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
  this.emitEvent( 'progress', [ this, elem, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  let method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  let isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) return;

  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, onAlways ) {
    let instance = new ImagesLoaded( this, options, onAlways );
    return instance.jqDeferred.promise( $( this ) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

} );


/***/ }),

/***/ 53316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(93542);


Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(2784);
var heyListen = __webpack_require__(9340);
var dom = __webpack_require__(14343);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * @public
 */
const MotionConfigContext = React.createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

const MotionContext = React.createContext({});
function useVisualElementContext() {
    return React.useContext(MotionContext).visualElement;
}

/**
 * @public
 */
const PresenceContext = React.createContext(null);

const isBrowser = typeof document !== "undefined";

const useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

const LazyContext = React.createContext({ strict: false });

function useVisualElement(Component, visualState, props, createVisualElement) {
    const parent = useVisualElementContext();
    const lazyContext = React.useContext(LazyContext);
    const presenceContext = React.useContext(PresenceContext);
    const reducedMotionConfig = React.useContext(MotionConfigContext).reducedMotion;
    const visualElementRef = React.useRef();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceId: presenceContext ? presenceContext.id : undefined,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(() => {
        visualElement && visualElement.render();
    });
    /**
     * If we have optimised appear animations to handoff from, trigger animateChanges
     * from a synchronous useLayoutEffect to ensure there's no flash of incorrectly
     * styled component in the event of a hydration error.
     */
    useIsomorphicLayoutEffect(() => {
        if (visualElement && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    useIsomorphicLayoutEffect(() => () => visualElement && visualElement.notify("Unmount"), []);
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return React.useCallback((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

const variantProps$1 = [
    "initial",
    "animate",
    "exit",
    "whileHover",
    "whileDrag",
    "whileTap",
    "whileFocus",
    "whileInView",
];
function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps$1.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, React.useContext(MotionContext));
    return React.useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

const createDefinition = (propNames) => ({
    isEnabled: (props) => propNames.some((name) => !!props[name]),
});
const featureDefinitions = {
    measureLayout: createDefinition(["layout", "layoutId", "drag"]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave",
    ]),
};

function loadFeatures(features) {
    for (const key in features) {
        if (key === "projectionNodeConstructor") {
            featureDefinitions.projectionNodeConstructor = features[key];
        }
        else {
            featureDefinitions[key].Component = features[key];
        }
    }
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};

let id$2 = 1;
function useProjectionId() {
    return useConstant(() => {
        if (globalProjectionState.hasEverUpdated) {
            return id$2++;
        }
    });
}

const LayoutGroupContext = React.createContext({});

class VisualElementHandler extends React__default["default"].Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */
    getSnapshotBeforeUpdate() {
        const { visualElement, props } = this.props;
        if (visualElement)
            visualElement.setProps(props);
        return null;
    }
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = React.createContext({});

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createMotionComponent({ preloadedFeatures, createVisualElement, projectionNodeConstructor, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const configAndProps = {
            ...React.useContext(MotionConfigContext),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        let features = null;
        const context = useCreateMotionContext(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */
        const projectionId = isStatic ? undefined : useProjectionId();
        /**
         *
         */
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */
            const lazyStrictMode = React.useContext(LazyContext).strict;
            const initialLayoutGroupConfig = React.useContext(SwitchLayoutGroupContext);
            if (context.visualElement) {
                features = context.visualElement.loadFeatures(
                // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                configAndProps, lazyStrictMode, preloadedFeatures, projectionId, projectionNodeConstructor ||
                    featureDefinitions.projectionNodeConstructor, initialLayoutGroupConfig);
            }
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (React__namespace.createElement(VisualElementHandler, { visualElement: context.visualElement, props: configAndProps },
            features,
            React__namespace.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement))));
    }
    const ForwardRefComponent = React.forwardRef(MotionComponent);
    ForwardRefComponent[motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = React.useContext(LayoutGroupContext).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);

function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

const isMotionValue = (value) => !!(value === null || value === void 0 ? void 0 : value.getVelocity);

const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
const sortTransformProps = (a, b) => transformPropOrder.indexOf(a) - transformPropOrder.indexOf(b);
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform({ transform, transformKeys, }, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Loop over each transform and build them into transformString
    for (const key of transformKeys) {
        transformString += `${translateAlias[key] || key}(${transform[key]}) `;
    }
    if (enableHardwareAcceleration && !transform.z) {
        transformString += "translateZ(0)";
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}

/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable$1(key) {
    return key.startsWith("--");
}

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => clamp(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}

const createUnitType = (unit) => ({
    test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};

const int = {
    ...number,
    transform: Math.round,
};

const numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformKeys, transformOrigin } = state;
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariable$1(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = numberValueTypes[key];
        const valueAsType = getValueAsType(value, valueType);
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0))
                transformIsNone = false;
        }
        else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
});

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return React.useMemo(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}

const animationProps = [
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView",
];
const tapProps = ["whileTap", "onTap", "onTapStart", "onTapCancel"];
const panProps = ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"];
const inViewProps = [
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
];
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onHoverStart",
    "onHoverEnd",
    "layoutScroll",
    ...inViewProps,
    ...tapProps,
    ...animationProps,
    ...panProps,
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}

let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp((__webpack_require__(79138)/* ["default"] */ .Z));
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    const pathLength = px.transform(length);
    const pathSpacing = px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = React.useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref,
        };
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return React.createElement(Component, elementProps);
    };
    return useRender;
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props) {
    const newValues = scrapeMotionValuesFromProps$1(props);
    for (const key in props) {
        if (isMotionValue(props[key])) {
            const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = React.useContext(MotionContext);
    const presenceContext = React.useContext(PresenceContext);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props);
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach((definition) => {
            const resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            const { transitionEnd, transition, ...target } = resolved;
            for (const key in target) {
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */
                    const index = isInitialAnimationBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (const key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement,
        projectionNodeConstructor,
        Component,
    };
}

exports.AnimationType = void 0;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(exports.AnimationType || (exports.AnimationType = {}));

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    React.useEffect(() => {
        const element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}

/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture({ whileFocus, visualElement, }) {
    const { animationState } = visualElement;
    const onFocus = () => {
        animationState && animationState.setActive(exports.AnimationType.Focus, true);
    };
    const onBlur = () => {
        animationState && animationState.setActive(exports.AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}

function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}

/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return (event) => {
        const isMouseEvent = event instanceof MouseEvent;
        const isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
const defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
    const primaryTouch = e.touches[0] || e.changedTouches[0];
    const point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType = "page") {
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType = "page") {
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
const wrapHandler = (handler, shouldFilterPrimaryPointer = false) => {
    const listener = (event) => handler(event, extractEventInfo(event));
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};

// We check for event support via functions in case they've been mocked by a testing suite.
const supportsPointerEvents = () => isBrowser && window.onpointerdown === null;
const supportsTouchEvents = () => isBrowser && window.ontouchstart === null;
const supportsMouseEvents = () => isBrowser && window.onmousedown === null;

const mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
const touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

function createHoverEvent(visualElement, isActive, callback) {
    return (event, info) => {
        if (!isMouseEvent(event) || isDragActive())
            return;
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (visualElement.animationState) {
            visualElement.animationState.setActive(exports.AnimationType.Hover, isActive);
        }
        callback && callback(event, info);
    };
}
function useHoverGesture({ onHoverStart, onHoverEnd, whileHover, visualElement, }) {
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined, { passive: !onHoverStart });
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined, { passive: !onHoverEnd });
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function useUnmountEffect(callback) {
    return React.useEffect(() => () => callback(), []);
}

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

/**
 * @param handlers -
 * @internal
 */
function useTapGesture({ onTap, onTapStart, onTapCancel, whileTap, visualElement, }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = React.useRef(false);
    const cancelPointerEndListeners = React.useRef(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */
    const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown),
    };
    function removePointerEndListener() {
        cancelPointerEndListeners.current && cancelPointerEndListeners.current();
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        removePointerEndListener();
        isPressing.current = false;
        visualElement.animationState &&
            visualElement.animationState.setActive(exports.AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */
        !isNodeOrChild(visualElement.current, event.target)
            ? onTapCancel && onTapCancel(event, info)
            : onTap && onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel && onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp, eventOptions), addPointerEvent(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */
        visualElement.animationState &&
            visualElement.animationState.setActive(exports.AnimationType.Tap, true);
        onTapStart && onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    useUnmountEffect(removePointerEndListener);
}

/**
 * Browser-safe usage of process
 */
const defaultEnvironment = "production";
const env = typeof process === "undefined" || process.env === undefined
    ? defaultEnvironment
    : "production" || 0;

const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

function useViewport({ visualElement, whileInView, onViewportEnter, onViewportLeave, viewport = {}, }) {
    const state = React.useRef({
        hasEnteredView: false,
        isInView: false,
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView)
        shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined"
        ? useMissingIntersectionObserver
        : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const thresholdNames = {
    some: 0,
    all: 1,
};
function useIntersectionObserver(shouldObserve, state, visualElement, { root, margin: rootMargin, amount = "some", once }) {
    React.useEffect(() => {
        if (!shouldObserve || !visualElement.current)
            return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const intersectionCallback = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (state.isInView === isIntersecting)
                return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && state.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                state.hasEnteredView = true;
            }
            if (visualElement.animationState) {
                visualElement.animationState.setActive(exports.AnimationType.InView, isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const props = visualElement.getProps();
            const callback = isIntersecting
                ? props.onViewportEnter
                : props.onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(visualElement.current, options, intersectionCallback);
    }, [shouldObserve, root, rootMargin, amount]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */
function useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback = true }) {
    React.useEffect(() => {
        if (!shouldObserve || !fallback)
            return;
        if (env !== "production") {
            warnOnce(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        }
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */
        requestAnimationFrame(() => {
            state.hasEnteredView = true;
            const { onViewportEnter } = visualElement.getProps();
            onViewportEnter && onViewportEnter(null);
            if (visualElement.animationState) {
                visualElement.animationState.setActive(exports.AnimationType.InView, true);
            }
        });
    }, [shouldObserve]);
}

const makeRenderlessComponent = (hook) => (props) => {
    hook(props);
    return null;
};

const gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = React.useContext(PresenceContext);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = React.useId();
    React.useEffect(() => register(id), []);
    const safeToRemove = () => onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
    return isPresent(React.useContext(PresenceContext));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);

const frameData = {
    delta: 0,
    timestamp: 0,
};

/*
  Detect and load appropriate clock setting for the execution environment
 */
const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(frameData);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frameData);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frameData.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - frameData.timestamp, maxElapsed), 1);
    frameData.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};

function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        addUniqueItem(this.subscriptions, handler);
        return () => removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "7.10.3";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = frameData;
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                sync.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update velocity subscribers
            if (this.events.velocityChange) {
                this.events.velocityChange.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => sync.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) {
                    this.events.velocityChange.notify(this.getVelocity());
                }
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(animation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.stopAnimation) {
            this.stopAnimation();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
    ...number,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
    test: isColorString("rgb", "red"),
    parse: splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        sanitize(alpha.transform(alpha$1)) +
        ")",
};

function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex = {
    test: isColorString("#"),
    parse: parseHex,
    transform: rgba.transform,
};

const hsla = {
    test: isColorString("hsl", "hue"),
    parse: splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            percent.transform(sanitize(saturation)) +
            ", " +
            percent.transform(sanitize(lightness)) +
            ", " +
            sanitize(alpha.transform(alpha$1)) +
            ")");
    },
};

const color = {
    test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
    parse: (v) => {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else {
            return hex.parse(v);
        }
    },
    transform: (v) => {
        return isString(v)
            ? v
            : v.hasOwnProperty("red")
                ? rgba.transform(v)
                : hsla.transform(v);
    },
};

const colorToken = "${c}";
const numberToken = "${n}";
function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        isString(v) &&
        (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
function analyseComplexValue(v) {
    if (typeof v === "number")
        v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace(colorRegex, colorToken);
        values.push(...colors.map(color.parse));
    }
    const numbers = v.match(floatRegex);
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace(floatRegex, numberToken);
        values.push(...numbers.map(number.parse));
    }
    return { values, numColors, numNumbers, tokenised: v };
}
function parse(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors
                ? color.transform(v[i])
                : sanitize(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parse(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 };

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...complex,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
    var _a;
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key) => (current[key] = value.get()));
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity$1(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    const reversedLabels = [...variantLabels].reverse();
    reversedLabels.forEach((key) => {
        var _a;
        const variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (let i = 0; i < numNewValues; i++) {
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value, { owner: visualElement }));
        if (origin[key] === undefined) {
            origin[key] = value;
        }
        if (value !== null)
            visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a;
    const origin = {};
    for (const key in target) {
        const transitionOrigin = getOriginFromTransition(key, transition);
        origin[key] =
            transitionOrigin !== undefined
                ? transitionOrigin
                : (_a = visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.get();
    }
    return origin;
}

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

const appearStoreId = (id, value) => `${id}: ${value}`;

function handoffOptimizedAppearAnimation(id, name) {
    const { MotionAppearAnimations } = window;
    const animationId = appearStoreId(id, transformProps.has(name) ? "transform" : name);
    const animation = MotionAppearAnimations && MotionAppearAnimations.get(animationId);
    if (animation) {
        /**
         * We allow the animation to persist until the next frame:
         *   1. So it continues to play until Framer Motion is ready to render
         *      (avoiding a potential flash of the element's original state)
         *   2. As all independent transforms share a single transform animation, stopping
         *      it synchronously would prevent subsequent transforms from handing off.
         */
        sync.render(() => {
            /**
             * Animation.cancel() throws so it needs to be wrapped in a try/catch
             */
            try {
                animation.cancel();
                MotionAppearAnimations.delete(animationId);
            }
            catch (e) { }
        });
        return animation.currentTime || 0;
    }
    else {
        return 0;
    }
}

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;

const instantAnimationState = {
    current: false,
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const easeIn = (p) => p * p;
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mix = (from, to, progress) => -progress * from + progress * to + from;

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    heyListen.invariant(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === hsla) {
        // TODO Remove this cast - needed since Framer Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba.transform(blended);
    };
};

function getMixer$1(origin, target) {
    if (typeof origin === "number") {
        return (v) => mix(origin, target, v);
    }
    else if (color.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer$1(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = { ...origin, ...target };
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer$1(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyseComplexValue(origin);
    const targetStats = analyseComplexValue(target);
    const canInterpolate = originStats.numColors === targetStats.numColors &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.values, targetStats.values), template);
    }
    else {
        heyListen.warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p) => `${p > 0 ? target : origin}`;
    }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") {
        return mixNumber;
    }
    else if (typeof v === "string") {
        if (color.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === "object") {
        return mixObject;
    }
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    heyListen.invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    heyListen.invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = progress(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
        : interpolator;
}

const noop = (any) => any;

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);

const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn);

const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

const easingLookup = {
    linear: noop,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn,
    backInOut,
    backOut,
    anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        heyListen.invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        heyListen.invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};
const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i) => i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}
function keyframes({ keyframes: keyframeValues, ease = easeInOut, times, duration = 300, }) {
    keyframeValues = [...keyframeValues];
    const origin = keyframes[0];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframes.length
        ? times
        : defaultOffset(keyframeValues), duration);
    function createInterpolator() {
        return interpolate(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions)
                ? easingFunctions
                : defaultEasing(keyframeValues, easingFunctions),
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t) => {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: () => {
            keyframeValues.reverse();
            interpolator = createInterpolator();
        },
    };
}

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    heyListen.warning(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */
function spring({ keyframes, restSpeed = 2, restDelta = 0.01, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    let resolveSpring = zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working within what looks like a 0-1 range, change the default restDelta
         * to 0.01
         */
        if (restDelta === undefined) {
            restDelta = Math.min(Math.abs(target - origin) / 100, 0.4);
        }
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (target -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq) *
                            Math.sin(angularFreq * t) +
                            initialDelta * Math.cos(angularFreq * t)));
            };
        }
        else if (dampingRatio === 1) {
            // Critically damped spring
            resolveSpring = (t) => target -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta +
                        (initialVelocity + undampedAngularFreq * initialDelta) *
                            t);
        }
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return (target -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq);
            };
        }
    }
    createSpring();
    return {
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */
                    if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - velocitySampleDuration);
                        currentVelocity = velocityPerSecond(current - resolveSpring(prevT), t - prevT);
                    }
                    else {
                        currentVelocity = 0;
                    }
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: () => {
            initialVelocity = -initialVelocity;
            [origin, target] = [target, origin];
            createSpring();
        },
    };
}
spring.needsInterpolation = (a, b) => typeof a === "string" || typeof b === "string";
const zero = (_t) => 0;

function decay({ 
/**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */
keyframes = [0], velocity = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget, }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    return {
        next: (t) => {
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: () => { },
    };
}

const types = {
    decay,
    keyframes: keyframes,
    tween: keyframes,
    spring,
};
function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update) => {
    const passTimestamp = ({ delta }) => update(delta);
    return {
        start: () => sync.update(passTimestamp, true),
        stop: () => cancelSync.update(passTimestamp),
    };
};
function animate$1({ duration, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, keyframes, autoplay = true, onPlay, onStop, onComplete, onRepeat, onUpdate, type = "keyframes", ...options }) {
    var _a, _b;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = types[keyframes.length > 2 ? "keyframes" : type];
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, origin, target)) {
        interpolateFromNumber = interpolate([0, 100], [origin, target], {
            clamp: false,
        });
        keyframes = [0, 100];
    }
    const animation = animator({
        ...options,
        duration,
        keyframes,
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) {
                computedDuration =
                    computedDuration !== undefined ? computedDuration : elapsed;
            }
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: () => {
            onStop && onStop();
            driverControls.stop();
        },
        sample: (t) => {
            return animation.next(Math.max(0, t));
        },
    };
}

function isWaapiSupportedEasing(easing) {
    return (!easing || // Default easing
        Array.isArray(easing) || // Bezier curve
        (typeof easing === "string" && supportedWaapiEasing[easing]));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing) {
    if (!easing)
        return undefined;
    return Array.isArray(easing)
        ? cubicBezierAsString(easing)
        : supportedWaapiEasing[easing];
}

function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
    return element.animate({ [valueName]: keyframes, offset: times }, {
        delay,
        duration,
        easing: mapEasingToNativeEasing(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    let { keyframes, duration = 0.3, elapsed = 0, ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (options.type === "spring" || !isWaapiSupportedEasing(options.ease)) {
        const sampleAnimation = animate$1(options);
        let state = { done: false, value: keyframes[0] };
        const pregeneratedKeyframes = [];
        let t = 0;
        while (!state.done) {
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = animateStyle(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */
        ease: ease,
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */
    animation.onfinish = () => {
        value.set(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */
    return () => {
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */
        const { currentTime } = animation;
        if (currentTime) {
            const sampleAnimation = animate$1(options);
            value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
        }
        sync.update(() => animation.cancel());
    };
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelSync.read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    sync.read(checkElapsed, true);
    return () => cancelSync.read(checkElapsed);
}

function createInstantAnimation({ keyframes, elapsed, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return () => { };
    };
    return elapsed ? delay(setValue, -elapsed) : setValue();
}

function inertia({ keyframes, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop, }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function findNearestBoundary(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate$1({
            keyframes: [0, 1],
            velocity: 0,
            ...options,
            driver,
            onUpdate: (v) => {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            },
            onComplete,
            onStop,
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta,
            ...options,
        });
    }
    if (isOutOfBounds(origin)) {
        // Start the animation with spring if outside the defined boundaries
        startSpring({
            velocity,
            keyframes: [origin, findNearestBoundary(origin)],
        });
    }
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */
        let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v) => {
            prev = current;
            current = v;
            velocity = velocityPerSecond(v - prev, frameData.delta);
            if ((heading === 1 && v > boundary) ||
                (heading === -1 && v < boundary)) {
                startSpring({ keyframes: [v, boundary], velocity });
            }
        };
        startAnimation({
            type: "decay",
            keyframes: [origin, 0],
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(),
    };
}

const underDampedSpring = () => ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
});
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const linearTween = () => ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
const defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else {
        const factory = defaultTransitions[valueKey] || defaultTransitions.default;
        return factory(keyframes[1]);
    }
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (key, value) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, ...transition }) {
    return !!Object.keys(transition).length;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}

function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = isAnimatable(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */
        origin = getAnimatableNone(valueName, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    /**
     * If the target has been defined as a series of keyframes
     */
    if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */
        if (target[0] === null) {
            target[0] = origin;
        }
        return target;
    }
    else {
        return [origin, target];
    }
}

const featureTests = {
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
};
const results = {};
const supports = {};
/**
 * Generate features tests that cache their results.
 */
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set(["opacity"]);
const createMotionValueAnimation = (valueName, value, target, transition = {}) => {
    return (onComplete) => {
        const valueTransition = getValueTransition(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */
        const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const keyframes = getKeyframes(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */
        const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
        const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
        heyListen.warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed,
            onUpdate: (v) => {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: () => {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
        };
        if (!isOriginAnimatable ||
            !isTargetAnimatable ||
            instantAnimationState.current ||
            valueTransition.type === false) {
            /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */
            return createInstantAnimation(options);
        }
        else if (valueTransition.type === "inertia") {
            /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */
            const animation = inertia(options);
            return () => animation.stop();
        }
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */
        if (!isTransitionDefined(valueTransition)) {
            options = {
                ...options,
                ...getDefaultTransition(valueName, options),
            };
        }
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */
        if (options.duration) {
            options.duration = secondsToMilliseconds(options.duration);
        }
        if (options.repeatDelay) {
            options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
        }
        const visualElement = value.owner;
        const element = visualElement && visualElement.current;
        const canAccelerateAnimation = supports.waapi() &&
            acceleratedValues.has(valueName) &&
            !options.repeatDelay &&
            options.repeatType !== "mirror" &&
            options.damping !== 0 &&
            visualElement &&
            element instanceof HTMLElement &&
            !visualElement.getProps().onUpdate;
        if (canAccelerateAnimation) {
            /**
             * If this animation is capable of being run via WAAPI, then do so.
             */
            return createAcceleratedAnimation(value, valueName, options);
        }
        else {
            /**
             * Otherwise, fall back to the main thread.
             */
            const animation = animate$1(options);
            return () => animation.stop();
        }
    };
};

function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(() => visualElement.notify("AnimationComplete", definition));
}
function animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = resolveVariant(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => animateTarget(visualElement, resolved, options)
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
/**
 * @internal
 */
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    var _a;
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for (const key in target) {
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        let valueTransition = { delay, elapsed: 0, ...transition };
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */
        if (visualElement.shouldReduceMotion && transformProps.has(key)) {
            valueTransition = {
                ...valueTransition,
                type: false,
                delay: 0,
            };
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        if (!value.hasAnimated) {
            const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
            if (appearId) {
                valueTransition.elapsed = handoffOptimizedAppearAnimation(appearId, key);
            }
        }
        let animation = value.start(createMotionValueAnimation(key, value, valueTarget, valueTransition));
        if (isWillChangeMotionValue(willChange)) {
            willChange.add(key);
            animation = animation.then(() => willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.values.forEach((value) => value.stop());
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

const variantPriorityOrder = [
    exports.AnimationType.Animate,
    exports.AnimationType.InView,
    exports.AnimationType.Focus,
    exports.AnimationType.Hover,
    exports.AnimationType.Tap,
    exports.AnimationType.Drag,
    exports.AnimationType.Exit,
];
const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (acc, definition) => {
        const resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type, ...options },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        [exports.AnimationType.Animate]: createTypeState(true),
        [exports.AnimationType.InView]: createTypeState(),
        [exports.AnimationType.Hover]: createTypeState(),
        [exports.AnimationType.Tap]: createTypeState(),
        [exports.AnimationType.Drag]: createTypeState(),
        [exports.AnimationType.Focus]: createTypeState(),
        [exports.AnimationType.Exit]: createTypeState(),
    };
}

const animations = {
    animation: makeRenderlessComponent(({ visualElement, animate }) => {
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */
        if (isAnimationControls(animate)) {
            React.useEffect(() => animate.subscribe(visualElement), [animate]);
        }
    }),
    exit: makeRenderlessComponent((props) => {
        const { custom, visualElement } = props;
        const [isPresent, safeToRemove] = usePresence();
        const presenceContext = React.useContext(PresenceContext);
        React.useEffect(() => {
            visualElement.isPresent = isPresent;
            const animation = visualElement.animationState &&
                visualElement.animationState.setActive(exports.AnimationType.Exit, !isPresent, {
                    custom: (presenceContext && presenceContext.custom) ||
                        custom,
                });
            if (animation && !isPresent) {
                animation.then(safeToRemove);
            }
        }, [isPresent]);
    }),
};

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = frameData;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            sync.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            const { onEnd, onSessionEnd } = this.handlers;
            const panInfo = getPanInfo(transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = frameData;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}

const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
            continue;
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale))
        return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys$1 = ["x", "scaleX", "originX"];
const yKeys$1 = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: AnyPointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        if (this.visualElement.isPresent === false)
            return;
        const onSessionStart = (event) => {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (percent.test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
                    if (measuredAxis) {
                        const length = calcLength(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(exports.AnimationType.Drag, true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) {
            this.visualElement.projection.isAnimationBlocked = false;
        }
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(exports.AnimationType.Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const { layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        heyListen.invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints === null || constraints === void 0 ? void 0 : constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start(createMotionValueAnimation(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        var _a;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, ((_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        var _a;
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints)) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props) {
    const { dragControls: groupDragControls, visualElement } = props;
    const dragControls = useConstant(() => new VisualElementDragControls(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    React.useEffect(() => groupDragControls && groupDragControls.subscribe(dragControls), [dragControls, groupDragControls]);
    // Apply the event listeners to the element
    React.useEffect(() => dragControls.addListeners(), [dragControls]);
}

/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture({ onPan, onPanStart, onPanEnd, onPanSessionStart, visualElement, }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = React.useRef(null);
    const { transformPagePoint } = React.useContext(MotionConfigContext);
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info) => {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    React.useEffect(() => {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(() => panSession.current && panSession.current.end());
}

const drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};

function isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token, fallback] = match;
    return [token, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    heyListen.invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariable(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element))
        return { target, transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = { ...transitionEnd };
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value) => {
        const current = value.get();
        if (!isCSSVariable(current))
            return;
        const resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (const key in target) {
        const current = target[key];
        if (!isCSSVariable(current))
            continue;
        const resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) {
            transitionEnd[key] = current;
        }
    }
    return { target, transitionEnd };
}

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
const isPositionalKey = (key) => positionalKeys.has(key);
const hasPositionalKey = (target) => {
    return Object.keys(target).some(isPositionalKey);
};
const setAndResetVelocity = (value, to) => {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
const isNumOrPxType = (v) => v === number || v === px;
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    /**
     * Record origins before we render and update styles
     */
    changedKeys.forEach((key) => {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key) => {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
    target = { ...target };
    transitionEnd = { ...transitionEnd };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        let from = origin[key];
        let fromType = findDimensionValueType(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (let i = fromIndex; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    heyListen.invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    heyListen.invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0
            ? window.pageYOffset
            : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(([key, value]) => {
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if (isBrowser && scrollY !== null) {
            window.scrollTo({ top: scrollY });
        }
        return { target: convertedTarget, transitionEnd };
    }
    else {
        return { target, transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target, transitionEnd };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
    const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!isBrowser)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}

function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            if (isWillChangeMotionValue(willChange)) {
                willChange.add(key);
            }
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (false) {}
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, motionValue(nextValue, { owner: element }));
            if (isWillChangeMotionValue(willChange)) {
                willChange.remove(key);
            }
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

const featureNames = Object.keys(featureDefinitions);
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "Unmount",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    constructor({ parent, props, reducedMotionConfig, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        /**
         * Tracks whether this VisualElement's React component is currently present
         * within the defined React tree.
         */
        this.isPresent = true;
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = () => sync.render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props);
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
                if (isWillChangeMotionValue(willChange)) {
                    willChange.add(key);
                }
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props) {
        return {};
    }
    mount(instance) {
        var _a;
        this.current = instance;
        if (this.projection) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (this.parent)
            this.parent.children.add(this);
        this.setProps(this.props);
    }
    unmount() {
        var _a, _b, _c;
        (_a = this.projection) === null || _a === void 0 ? void 0 : _a.unmount();
        cancelSync.update(this.notifyUpdate);
        cancelSync.render(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        (_b = this.removeFromVariantTree) === null || _b === void 0 ? void 0 : _b.call(this);
        (_c = this.parent) === null || _c === void 0 ? void 0 : _c.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate &&
                sync.update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type)
            return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(renderedProps, isStrict, preloadedFeatures, projectionId, ProjectionNodeConstructor, initialLayoutGroupConfig) {
        const features = [];
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */
        if (env !== "production" && preloadedFeatures && isStrict) {
            heyListen.invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
        }
        for (let i = 0; i < numFeatures; i++) {
            const name = featureNames[i];
            const { isEnabled, Component } = featureDefinitions[name];
            /**
             * It might be possible in the future to use this moment to
             * dynamically request functionality. In initial tests this
             * was producing a lot of duplication amongst bundles.
             */
            if (isEnabled(renderedProps) && Component) {
                features.push(React.createElement(Component, {
                    key: name,
                    ...renderedProps,
                    visualElement: this,
                }));
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) ||
                    (dragConstraints && isRefObject(dragConstraints)),
                visualElement: this,
                scheduleRender: () => this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */
                animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
            });
        }
        return features;
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
    makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    setProps(props) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.props = props;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props), this.prevMotionValues);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        var _a;
        return (_a = this.props.variants) === null || _a === void 0 ? void 0 : _a[name];
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        var _a;
        return this.isVariantNode ? this : (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getClosestVariantNode();
    }
    getVariantContext(startAtParent = false) {
        var _a, _b;
        if (startAtParent)
            return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getVariantContext();
        if (!this.isControllingVariants) {
            const context = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getVariantContext()) || {};
            if (this.props.initial !== undefined) {
                context.initial = this.props.initial;
            }
            return context;
        }
        const context = {};
        for (let i = 0; i < numVariantProps; i++) {
            const name = variantProps[i];
            const prop = this.props[name];
            if (isVariantLabel(prop) || prop === false) {
                context[name] = prop;
            }
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        var _a;
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        if (this.hasValue(key))
            this.removeValue(key);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
        this.bindToMotionValue(key, value);
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        var _a;
        this.values.delete(key);
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
        this.valueSubscriptions.delete(key);
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    /**
     * Get a motion value for this key. If called with a default
     * value, we'll create one if none exists.
     */
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = motionValue(defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key) {
        return this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object"
            ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
            : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !isMotionValue(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 ? void 0 : _a.notify(...args);
    }
}
const variantProps = ["initial", ...variantPriorityOrder];
const numVariantProps = variantProps.length;

class DOMVisualElement extends VisualElement {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(this, target, origin);
            const parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target,
        };
    }
}

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = getComputedStyle$1(instance);
            const value = (isCSSVariable$1(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props) {
        return scrapeMotionValuesFromProps$1(props);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderHTML(instance, renderState, styleProp, projection);
    }
}

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        var _a;
        if (transformProps.has(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return createBox();
    }
    scrapeMotionValuesFromProps(props) {
        return scrapeMotionValuesFromProps(props);
    }
    build(renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

const createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
        : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};

const varToken = "_$css";
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */
        const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) {
            latest = latest.replace(cssVariableRegex, (match) => {
                cssVariables.push(match);
                return varToken;
            });
        }
        const shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = mix(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace(varToken, () => {
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    },
};

class MeasureLayoutWithContext extends React__default["default"].Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                sync.postRender(() => {
                    var _a;
                    if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) {
                this.safeToRemove();
            }
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = React.useContext(LayoutGroupContext);
    return (React__default["default"].createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: React.useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

const layoutFeatures = {
    measureLayout: MeasureLayout,
};

/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */
function animate(from, to, transition = {}) {
    const value = isMotionValue(from) ? from : motionValue(from);
    value.start(createMotionValueAnimation("", value, to, transition));
    return {
        stop: () => value.stop(),
        isAnimating: () => value.isAnimating(),
    };
}

const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, circOut);
const easeCrossfadeOut = compress(0.5, 0.95, noop);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}

class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}

function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}

const compareByDepth = (a, b) => a.depth - b.depth;

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

const transformAxes = ["", "X", "Y", "Z"];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id$1 = 0;
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = id$1++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            this.isTransformDirty = false;
            /**
             * Flag to true if we think the projection calculations for this or any
             * child might need recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance)
                return;
            this.isSVG =
                instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    var _a, _b, _c, _d, _e;
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEquals(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged &&
                            this.animationProgress === 0) {
                            finishAnimation(this);
                        }
                        this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d));
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.remove(this);
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
            this.instance = undefined;
            cancelSync.preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return (this.isAnimationBlocked ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.forEach(resetRotation);
            this.animationId++;
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating)
                return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */
            if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            flushSync.update();
            flushSync.preRender();
            flushSync.render();
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            sync.preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            sync.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            var _a;
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.notify("LayoutMeasure", this.layout.layoutBox, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.layoutBox);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot: checkIsScrollRoot(this.instance),
                    offset: measureScroll(this.instance),
                };
            }
        }
        resetTransform() {
            var _a;
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                translateAxis(box.x, scroll.offset.x);
                translateAxis(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.isRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */
                        if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layoutBox, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        /**
         *
         */
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.isProjectionDirty = true;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */
        resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            if (!this.isProjectionDirty && !this.attemptToResolveRelativeTarget)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) {
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues))
                return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) &&
                this.parent.layout) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        calcProjection() {
            var _a;
            const { isProjectionDirty, isTransformDirty } = this;
            this.isProjectionDirty = this.isTransformDirty = false;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            if (isProjectionDirty)
                canSkip = false;
            if (isShared && isTransformDirty)
                canSkip = false;
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target } = lead;
            if (!target)
                return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a, _b;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const isSharedLayoutAnimation = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.source) !== ((_a = this.layout) === null || _a === void 0 ? void 0 : _a.source);
            const isOnlyMember = (((_b = this.getStack()) === null || _b === void 0 ? void 0 : _b.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest) => {
                var _a;
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            if (this.resumingFrom) {
                (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
            }
            if (this.pendingAnimation) {
                cancelSync.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = sync.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animate(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, latest);
                    },
                    onComplete: () => {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 ? void 0 : _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node),
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ) {
                hasRotate = true;
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate)
                return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 ? void 0 : visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_c = (_b = valuesToRender.opacity) !== null && _b !== void 0 ? _b : this.latestValues.opacity) !== null && _c !== void 0 ? _c : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        (_c = (_b = node.options).onExitComplete) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Propagate isProjectionDirty. Nodes are ordered by depth, so if the parent here
     * is dirty we can simply pass this forward.
     */
    node.isProjectionDirty || (node.isProjectionDirty = Boolean(node.parent && node.parent.isProjectionDirty));
    /**
     * Propagate isTransformDirty.
     */
    node.isTransformDirty || (node.isTransformDirty = Boolean(node.parent && node.parent.isTransformDirty));
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */
    let searchNode = node.root;
    for (let i = node.path.length - 1; i >= 0; i--) {
        if (Boolean(node.path[i].instance)) {
            searchNode = node.path[i];
            break;
        }
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element)
        node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}

const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode = createProjectionNode({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});

const featureBundle = {
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layoutFeatures,
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
const motion = /*@__PURE__*/ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, featureBundle, createDomVisualElement, HTMLProjectionNode));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement, HTMLProjectionNode));
}

/**
 * @public
 */
const m = createMotionProxy(createDomMotionConfig);

function useIsMounted() {
    const isMounted = React.useRef(false);
    useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

function useForceUpdate() {
    const isMounted = useIsMounted();
    const [forcedRenderCount, setForcedRenderCount] = React.useState(0);
    const forceRender = React.useCallback(() => {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    const deferredForceRender = React.useCallback(() => sync.postRender(forceRender), [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends React__namespace.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent }) {
    const id = React.useId();
    const ref = React.useRef(null);
    const size = React.useRef({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    React.useInsertionEffect(() => {
        const { width, height, top, left } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        }
        return () => {
            document.head.removeChild(style);
        };
    }, [isPresent]);
    return (React__namespace.createElement(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size }, React__namespace.cloneElement(children, { ref })));
}

const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
    const presenceChildren = useConstant(newChildrenMap);
    const id = React.useId();
    const context = React.useMemo(() => ({
        id,
        initial,
        isPresent,
        custom,
        onExitComplete: (childId) => {
            presenceChildren.set(childId, true);
            for (const isComplete of presenceChildren.values()) {
                if (!isComplete)
                    return; // can stop searching when any is incomplete
            }
            onExitComplete && onExitComplete();
        },
        register: (childId) => {
            presenceChildren.set(childId, false);
            return () => presenceChildren.delete(childId);
        },
    }), 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    React.useMemo(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    React__namespace.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = React__namespace.createElement(PopChild, { isPresent: isPresent }, children);
    }
    return (React__namespace.createElement(PresenceContext.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}

const getChildKey = (child) => child.key || "";
function updateChildLookup(children, allChildren) {
    children.forEach((child) => {
        const key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, custom, initial = true, onExitComplete, exitBeforeEnter, presenceAffectsLayout = true, mode = "sync", }) => {
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) {
        mode = "wait";
        warnOnce(false, "Replace exitBeforeEnter with mode='wait'");
    }
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = useForceUpdate();
    const forceRenderLayoutGroup = React.useContext(LayoutGroupContext).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    const isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = React.useRef(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = React.useRef(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = React.useRef(true);
    useIsomorphicLayoutEffect(() => {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    useUnmountEffect(() => {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) {
        return (React__namespace.createElement(React__namespace.Fragment, null, childrenToRender.map((child) => (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child)))));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [...childrenToRender];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map(getChildKey);
    const targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for (let i = 0; i < numPresent; i++) {
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key) => {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        const child = allChildren.get(key);
        if (!child)
            return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = () => {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild) => presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false)
                    return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child) => {
        const key = child.key;
        return exiting.has(key) ? (child) : (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    if (env !== "production" &&
        mode === "wait" &&
        childrenToRender.length > 1) {
        console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    }
    return (React__namespace.createElement(React__namespace.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map((child) => React.cloneElement(child))));
};

/**
 * @deprecated
 */
const DeprecatedLayoutGroupContext = React.createContext(null);

const notify = (node) => !node.isLayoutDirty && node.willUpdate(false);
function nodeGroup() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = () => nodes.forEach(notify);
    return {
        add: (node) => {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node) => {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}

const shouldInheritGroup = (inherit) => inherit === true;
const shouldInheritId = (inherit) => shouldInheritGroup(inherit === true) || inherit === "id";
const LayoutGroup = ({ children, id, inheritId, inherit = true }) => {
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    const layoutGroupContext = React.useContext(LayoutGroupContext);
    const deprecatedLayoutGroupContext = React.useContext(DeprecatedLayoutGroupContext);
    const [forceRender, key] = useForceUpdate();
    const context = React.useRef(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id,
            group: shouldInheritGroup(inherit)
                ? layoutGroupContext.group || nodeGroup()
                : nodeGroup(),
        };
    }
    const memoizedContext = React.useMemo(() => ({ ...context.current, forceRender }), [key]);
    return (React__namespace.createElement(LayoutGroupContext.Provider, { value: memoizedContext }, children));
};

let id = 0;
const AnimateSharedLayout = ({ children, }) => {
    React__namespace.useEffect(() => {
        heyListen.warning(false, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
    }, []);
    return (React__namespace.createElement(LayoutGroup, { id: useConstant(() => `asl-${id++}`) }, children));
};

/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */
function MotionConfig({ children, isValidProp, ...config }) {
    isValidProp && loadExternalIsValidProp(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */
    config = { ...React.useContext(MotionConfigContext), ...config };
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */
    config.isStatic = useConstant(() => config.isStatic);
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */
    const context = React.useMemo(() => config, [JSON.stringify(config.transition), config.transformPagePoint, config.reducedMotion]);
    return (React__namespace.createElement(MotionConfigContext.Provider, { value: context }, children));
}

/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimations } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimations}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimations')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */
function LazyMotion({ children, features, strict = false }) {
    const [, setIsLoaded] = React.useState(!isLazyBundle(features));
    const loadedRenderer = React.useRef(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */
    if (!isLazyBundle(features)) {
        const { renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        loadFeatures(loadedFeatures);
    }
    React.useEffect(() => {
        if (isLazyBundle(features)) {
            features().then(({ renderer, ...loadedFeatures }) => {
                loadFeatures(loadedFeatures);
                loadedRenderer.current = renderer;
                setIsLoaded(true);
            });
        }
    }, []);
    return (React__namespace.createElement(LazyContext.Provider, { value: { renderer: loadedRenderer.current, strict } }, children));
}
function isLazyBundle(features) {
    return typeof features === "function";
}

const ReorderContext = React.createContext(null);

function checkReorder(order, value, offset, velocity) {
    if (!velocity)
        return order;
    const index = order.findIndex((item) => item.value === value);
    if (index === -1)
        return order;
    const nextOffset = velocity > 0 ? 1 : -1;
    const nextItem = order[index + nextOffset];
    if (!nextItem)
        return order;
    const item = order[index];
    const nextLayout = nextItem.layout;
    const nextItemCenter = mix(nextLayout.min, nextLayout.max, 0.5);
    if ((nextOffset === 1 && item.layout.max + offset > nextItemCenter) ||
        (nextOffset === -1 && item.layout.min + offset < nextItemCenter)) {
        return moveItem(order, index, index + nextOffset);
    }
    return order;
}

function ReorderGroup({ children, as = "ul", axis = "y", onReorder, values, ...props }, externalRef) {
    const Component = useConstant(() => motion(as));
    const order = [];
    const isReordering = React.useRef(false);
    heyListen.invariant(Boolean(values), "Reorder.Group must be provided a values prop");
    const context = {
        axis,
        registerItem: (value, layout) => {
            /**
             * Ensure entries can't add themselves more than once
             */
            if (layout &&
                order.findIndex((entry) => value === entry.value) === -1) {
                order.push({ value, layout: layout[axis] });
                order.sort(compareMin);
            }
        },
        updateOrder: (id, offset, velocity) => {
            if (isReordering.current)
                return;
            const newOrder = checkReorder(order, id, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder
                    .map(getValue)
                    .filter((value) => values.indexOf(value) !== -1));
            }
        },
    };
    React.useEffect(() => {
        isReordering.current = false;
    });
    return (React__namespace.createElement(Component, { ...props, ref: externalRef },
        React__namespace.createElement(ReorderContext.Provider, { value: context }, children)));
}
const Group = React.forwardRef(ReorderGroup);
function getValue(item) {
    return item.value;
}
function compareMin(a, b) {
    return a.layout.min - b.layout.min;
}

/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = useConstant(() => motionValue(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = React.useContext(MotionConfigContext);
    if (isStatic) {
        const [, setLatest] = React.useState(initial);
        React.useEffect(() => value.on("change", setLatest), []);
    }
    return value;
}

const isCustomValueType = (v) => {
    return typeof v === "object" && v.mix;
};
const getMixer = (v) => (isCustomValueType(v) ? v.mix : undefined);
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = interpolate(inputRange, outputRange, {
        mixer: getMixer(outputRange[0]),
        ...options,
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}

function useOnChange(value, callback) {
    useIsomorphicLayoutEffect(() => {
        if (isMotionValue(value)) {
            callback(value.get());
            return value.on("change", callback);
        }
    }, [value, callback]);
}
function useMultiOnChange(values, handler, cleanup) {
    useIsomorphicLayoutEffect(() => {
        const subscriptions = values.map((value) => value.on("change", handler));
        return () => {
            subscriptions.forEach((unsubscribe) => unsubscribe());
            cleanup();
        };
    });
}

function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    const value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    const updateValue = () => value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    useMultiOnChange(values, () => sync.update(updateValue, false, true), () => cancelSync.update(updateValue));
    return value;
}

function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], ([latest]) => transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = useConstant(() => []);
    return useCombineMotionValues(values, () => {
        latest.length = 0;
        const numValues = values.length;
        for (let i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}

function useDefaultMotionValue(value, defaultValue = 0) {
    return isMotionValue(value) ? value : useMotionValue(defaultValue);
}
function ReorderItem({ children, style = {}, value, as = "li", onDrag, layout = true, ...props }, externalRef) {
    const Component = useConstant(() => motion(as));
    const context = React.useContext(ReorderContext);
    const point = {
        x: useDefaultMotionValue(style.x),
        y: useDefaultMotionValue(style.y),
    };
    const zIndex = useTransform([point.x, point.y], ([latestX, latestY]) => latestX || latestY ? 1 : "unset");
    const measuredLayout = React.useRef(null);
    heyListen.invariant(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    const { axis, registerItem, updateOrder } = context;
    React.useEffect(() => {
        registerItem(value, measuredLayout.current);
    }, [context]);
    return (React__namespace.createElement(Component, { drag: axis, ...props, dragSnapToOrigin: true, style: { ...style, x: point.x, y: point.y, zIndex }, layout: layout, onDrag: (event, gesturePoint) => {
            const { velocity } = gesturePoint;
            velocity[axis] &&
                updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag && onDrag(event, gesturePoint);
        }, onLayoutMeasure: (measured) => {
            measuredLayout.current = measured;
        }, ref: externalRef }, children));
}
const Item = React.forwardRef(ReorderItem);

const Reorder = {
    Group,
    Item,
};

/**
 * @public
 */
const domAnimation = {
    renderer: createDomVisualElement,
    ...animations,
    ...gestureAnimations,
};

/**
 * @public
 */
const domMax = {
    ...domAnimation,
    ...drag,
    ...layoutFeatures,
    projectionNodeConstructor: HTMLProjectionNode,
};

/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments, ...values) {
    /**
     * Create a function that will build a string from the latest motion values.
     */
    const numFragments = fragments.length;
    function buildValue() {
        let output = ``;
        for (let i = 0; i < numFragments; i++) {
            output += fragments[i];
            const value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return useCombineMotionValues(values, buildValue);
}

/**
 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
 *
 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
 * to another `MotionValue`.
 *
 * @remarks
 *
 * ```jsx
 * const x = useSpring(0, { stiffness: 300 })
 * const y = useSpring(x, { damping: 10 })
 * ```
 *
 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
 * @param springConfig - Configuration options for the spring.
 * @returns `MotionValue`
 *
 * @public
 */
function useSpring(source, config = {}) {
    const { isStatic } = React.useContext(MotionConfigContext);
    const activeSpringAnimation = React.useRef(null);
    const value = useMotionValue(isMotionValue(source) ? source.get() : source);
    React.useMemo(() => {
        return value.attach((v, set) => {
            /**
             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
             * at that level, but this will work for now
             */
            if (isStatic)
                return set(v);
            if (activeSpringAnimation.current) {
                activeSpringAnimation.current.stop();
            }
            activeSpringAnimation.current = animate$1({
                keyframes: [value.get(), v],
                velocity: value.getVelocity(),
                type: "spring",
                ...config,
                onUpdate: set,
            });
            return value.get();
        });
    }, [JSON.stringify(config)]);
    useOnChange(source, (v) => value.set(parseFloat(v)));
    return value;
}

/**
 * Creates a `MotionValue` that updates when the velocity of the provided `MotionValue` changes.
 *
 * ```javascript
 * const x = useMotionValue(0)
 * const xVelocity = useVelocity(x)
 * const xAcceleration = useVelocity(xVelocity)
 * ```
 *
 * @public
 */
function useVelocity(value) {
    const velocity = useMotionValue(value.getVelocity());
    React.useEffect(() => {
        return value.on("velocityChange", (newVelocity) => {
            velocity.set(newVelocity);
        });
    }, [value]);
    return velocity;
}

const createScrollMotionValues = () => ({
    scrollX: motionValue(0),
    scrollY: motionValue(0),
    scrollXProgress: motionValue(0),
    scrollYProgress: motionValue(0),
});
function useScroll({ container, target, layoutEffect = true, ...options } = {}) {
    const values = useConstant(createScrollMotionValues);
    const useLifecycleEffect = layoutEffect
        ? useIsomorphicLayoutEffect
        : React.useEffect;
    useLifecycleEffect(() => {
        return dom.scroll(({ x, y }) => {
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, {
            ...options,
            container: (container === null || container === void 0 ? void 0 : container.current) || undefined,
            target: (target === null || target === void 0 ? void 0 : target.current) || undefined,
        });
    }, []);
    return values;
}

/**
 * @deprecated useElementScroll is deprecated. Convert to useScroll({ container: ref })
 */
function useElementScroll(ref) {
    warnOnce(false, "useElementScroll is deprecated. Convert to useScroll({ container: ref }).");
    return useScroll({ container: ref });
}

/**
 * @deprecated useViewportScroll is deprecated. Convert to useScroll()
 */
function useViewportScroll() {
    warnOnce(false, "useViewportScroll is deprecated. Convert to useScroll().");
    return useScroll();
}

function useAnimationFrame(callback) {
    const initialTimestamp = React.useRef(0);
    const { isStatic } = React.useContext(MotionConfigContext);
    React.useEffect(() => {
        if (isStatic)
            return;
        const provideTimeSinceStart = ({ timestamp, delta }) => {
            if (!initialTimestamp.current)
                initialTimestamp.current = timestamp;
            callback(timestamp - initialTimestamp.current, delta);
        };
        sync.update(provideTimeSinceStart, true);
        return () => cancelSync.update(provideTimeSinceStart);
    }, [callback]);
}

function useTime() {
    const time = useMotionValue(0);
    useAnimationFrame((t) => time.set(t));
    return time;
}

class WillChangeMotionValue extends MotionValue {
    constructor() {
        super(...arguments);
        this.members = [];
        this.transforms = new Set();
    }
    add(name) {
        let memberName;
        if (transformProps.has(name)) {
            this.transforms.add(name);
            memberName = "transform";
        }
        else if (!name.startsWith("origin") &&
            !isCSSVariable$1(name) &&
            name !== "willChange") {
            memberName = camelToDash(name);
        }
        if (memberName) {
            addUniqueItem(this.members, memberName);
            this.update();
        }
    }
    remove(name) {
        if (transformProps.has(name)) {
            this.transforms.delete(name);
            if (!this.transforms.size) {
                removeItem(this.members, "transform");
            }
        }
        else {
            removeItem(this.members, camelToDash(name));
        }
        this.update();
    }
    update() {
        this.set(this.members.length ? this.members.join(", ") : "auto");
    }
}
function useWillChange() {
    return useConstant(() => new WillChangeMotionValue("auto"));
}

function useMotionValueEvent(value, event, callback) {
    useIsomorphicLayoutEffect(() => value.on(event, callback), [value, event, callback]);
}

/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */
function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */
    !hasReducedMotionListener.current && initPrefersReducedMotion();
    const [shouldReduceMotion] = React.useState(prefersReducedMotion.current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */
    return shouldReduceMotion;
}

function useReducedMotionConfig() {
    const reducedMotionPreference = useReducedMotion();
    const { reducedMotion } = React.useContext(MotionConfigContext);
    if (reducedMotion === "never") {
        return false;
    }
    else if (reducedMotion === "always") {
        return true;
    }
    else {
        return reducedMotionPreference;
    }
}

/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    let hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    const pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    const subscribers = new Set();
    const controls = {
        subscribe(visualElement) {
            subscribers.add(visualElement);
            return () => void subscribers.delete(visualElement);
        },
        start(definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                const animations = [];
                subscribers.forEach((visualElement) => {
                    animations.push(animateVisualElement(visualElement, definition, {
                        transitionOverride,
                    }));
                });
                return Promise.all(animations);
            }
            else {
                return new Promise((resolve) => {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve,
                    });
                });
            }
        },
        set(definition) {
            heyListen.invariant(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement) => {
                setValues(visualElement, definition);
            });
        },
        stop() {
            subscribers.forEach((visualElement) => {
                stopAnimation(visualElement);
            });
        },
        mount() {
            hasMounted = true;
            pendingAnimations.forEach(({ animation, resolve }) => {
                controls.start(...animation).then(resolve);
            });
            return () => {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}

/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    const controls = useConstant(animationControls);
    React.useEffect(controls.mount, []);
    return controls;
}
const useAnimation = useAnimationControls;

const wrap = (min, max, v) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

/**
 * Cycles through a series of visual properties. Can be used to toggle between or cycle through animations. It works similar to `useState` in React. It is provided an initial array of possible states, and returns an array of two arguments.
 *
 * An index value can be passed to the returned `cycle` function to cycle to a specific index.
 *
 * ```jsx
 * import * as React from "react"
 * import { motion, useCycle } from "framer-motion"
 *
 * export const MyComponent = () => {
 *   const [x, cycleX] = useCycle(0, 50, 100)
 *
 *   return (
 *     <motion.div
 *       animate={{ x: x }}
 *       onTap={() => cycleX()}
 *      />
 *    )
 * }
 * ```
 *
 * @param items - items to cycle through
 * @returns [currentState, cycleState]
 *
 * @public
 */
function useCycle(...items) {
    const index = React.useRef(0);
    const [item, setItem] = React.useState(items[index.current]);
    const runCycle = React.useCallback((next) => {
        index.current =
            typeof next !== "number"
                ? wrap(0, items.length, index.current + 1)
                : next;
        setItem(items[index.current]);
    }, 
    // The array will change on each call, but by putting items.length at
    // the front of this array, we guarantee the dependency comparison will match up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items.length, ...items]);
    return [item, runCycle];
}

function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = React.useState(false);
    React.useEffect(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return dom.inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}

/**
 * Can manually trigger a drag gesture on one or more `drag`-enabled `motion` components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
class DragControls {
    constructor() {
        this.componentControls = new Set();
    }
    /**
     * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
     *
     * @internal
     */
    subscribe(controls) {
        this.componentControls.add(controls);
        return () => this.componentControls.delete(controls);
    }
    /**
     * Start a drag gesture on every `motion` component that has this set of drag controls
     * passed into it via the `dragControls` prop.
     *
     * ```jsx
     * dragControls.start(e, {
     *   snapToCursor: true
     * })
     * ```
     *
     * @param event - PointerEvent
     * @param options - Options
     *
     * @public
     */
    start(event, options) {
        this.componentControls.forEach((controls) => {
            controls.start(event.nativeEvent || event, options);
        });
    }
}
const createDragControls = () => new DragControls();
/**
 * Usually, dragging is initiated by pressing down on a `motion` component with a `drag` prop
 * and moving it. For some use-cases, for instance clicking at an arbitrary point on a video scrubber, we
 * might want to initiate that dragging from a different component than the draggable one.
 *
 * By creating a `dragControls` using the `useDragControls` hook, we can pass this into
 * the draggable component's `dragControls` prop. It exposes a `start` method
 * that can start dragging from pointer events on other components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
function useDragControls() {
    return useConstant(createDragControls);
}

/**
 * Checks if a component is a `motion` component.
 */
function isMotionComponent(component) {
    return (component !== null &&
        typeof component === "object" &&
        motionComponentSymbol in component);
}

/**
 * Unwraps a `motion` component and returns either a string for `motion.div` or
 * the React component for `motion(Component)`.
 *
 * If the component is not a `motion` component it returns undefined.
 */
function unwrapMotionComponent(component) {
    if (isMotionComponent(component)) {
        return component[motionComponentSymbol];
    }
    return undefined;
}

function useInstantLayoutTransition() {
    return startTransition;
}
function startTransition(callback) {
    if (!rootProjectionNode.current)
        return;
    rootProjectionNode.current.isUpdating = false;
    rootProjectionNode.current.blockUpdate();
    callback && callback();
}

function useInstantTransition() {
    const [forceUpdate, forcedRenderCount] = useForceUpdate();
    const startInstantLayoutTransition = useInstantLayoutTransition();
    React.useEffect(() => {
        /**
         * Unblock after two animation frames, otherwise this will unblock too soon.
         */
        sync.postRender(() => sync.postRender(() => (instantAnimationState.current = false)));
    }, [forcedRenderCount]);
    return (callback) => {
        startInstantLayoutTransition(() => {
            instantAnimationState.current = true;
            forceUpdate();
            callback();
        });
    };
}

function useResetProjection() {
    const reset = React__namespace.useCallback(() => {
        const root = rootProjectionNode.current;
        if (!root)
            return;
        root.resetTree();
    }, []);
    return reset;
}

function startOptimizedAppearAnimation(element, name, keyframes, options) {
    window.MotionAppearAnimations || (window.MotionAppearAnimations = new Map());
    const id = element.dataset[optimizedAppearDataId];
    const animation = animateStyle(element, name, keyframes, options);
    if (id && animation) {
        window.MotionAppearAnimations.set(appearStoreId(id, name), animation);
    }
    return animation;
}

const createObject = () => ({});
class StateVisualElement extends VisualElement {
    build() { }
    measureInstanceViewportBox() {
        return createBox();
    }
    resetTransform() { }
    restoreTransform() { }
    removeValueFromRenderState() { }
    renderInstance() { }
    scrapeMotionValuesFromProps() {
        return createObject();
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    readValueFromInstance(_state, key, options) {
        return options.initialState[key] || 0;
    }
    sortInstanceNodePosition() {
        return 0;
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }) {
        const origin = getOrigin(target, transition || {}, this);
        checkTargetForNewValues(this, target, origin);
        return { transition, transitionEnd, ...target };
    }
}
const useVisualState = makeUseVisualState({
    scrapeMotionValuesFromProps: createObject,
    createRenderState: createObject,
});
/**
 * This is not an officially supported API and may be removed
 * on any version.
 */
function useAnimatedState(initialState) {
    const [animationState, setAnimationState] = React.useState(initialState);
    const visualState = useVisualState({}, false);
    const element = useConstant(() => {
        return new StateVisualElement({ props: {}, visualState }, { initialState });
    });
    React.useEffect(() => {
        element.mount({});
        return () => element.unmount();
    }, [element]);
    React.useEffect(() => {
        element.setProps({
            onUpdate: (v) => {
                setAnimationState({ ...v });
            },
        });
    }, [setAnimationState, element]);
    const startAnimation = useConstant(() => (animationDefinition) => {
        return animateVisualElement(element, animationDefinition);
    });
    return [animationState, startAnimation];
}

// Keep things reasonable and avoid scale: Infinity. In practise we might need
// to add another value, opacity, that could interpolate scaleX/Y [0,0.01] => [0,1]
// to simply hide content at unreasonable scales.
const maxScale = 100000;
const invertScale = (scale) => scale > 0.001 ? 1 / scale : maxScale;
let hasWarned = false;
/**
 * Returns a `MotionValue` each for `scaleX` and `scaleY` that update with the inverse
 * of their respective parent scales.
 *
 * This is useful for undoing the distortion of content when scaling a parent component.
 *
 * By default, `useInvertedScale` will automatically fetch `scaleX` and `scaleY` from the nearest parent.
 * By passing other `MotionValue`s in as `useInvertedScale({ scaleX, scaleY })`, it will invert the output
 * of those instead.
 *
 * ```jsx
 * const MyComponent = () => {
 *   const { scaleX, scaleY } = useInvertedScale()
 *   return <motion.div style={{ scaleX, scaleY }} />
 * }
 * ```
 *
 * @deprecated
 */
function useInvertedScale(scale) {
    let parentScaleX = useMotionValue(1);
    let parentScaleY = useMotionValue(1);
    const visualElement = useVisualElementContext();
    heyListen.invariant(!!(scale || visualElement), "If no scale values are provided, useInvertedScale must be used within a child of another motion component.");
    heyListen.warning(hasWarned, "useInvertedScale is deprecated and will be removed in 3.0. Use the layout prop instead.");
    hasWarned = true;
    if (scale) {
        parentScaleX = scale.scaleX || parentScaleX;
        parentScaleY = scale.scaleY || parentScaleY;
    }
    else if (visualElement) {
        parentScaleX = visualElement.getValue("scaleX", 1);
        parentScaleY = visualElement.getValue("scaleY", 1);
    }
    const scaleX = useTransform(parentScaleX, invertScale);
    const scaleY = useTransform(parentScaleY, invertScale);
    return { scaleX, scaleY };
}

exports.AnimatePresence = AnimatePresence;
exports.AnimateSharedLayout = AnimateSharedLayout;
exports.DeprecatedLayoutGroupContext = DeprecatedLayoutGroupContext;
exports.DragControls = DragControls;
exports.FlatTree = FlatTree;
exports.LayoutGroup = LayoutGroup;
exports.LayoutGroupContext = LayoutGroupContext;
exports.LazyMotion = LazyMotion;
exports.MotionConfig = MotionConfig;
exports.MotionConfigContext = MotionConfigContext;
exports.MotionContext = MotionContext;
exports.MotionValue = MotionValue;
exports.PresenceContext = PresenceContext;
exports.Reorder = Reorder;
exports.SwitchLayoutGroupContext = SwitchLayoutGroupContext;
exports.VisualElement = VisualElement;
exports.addPointerEvent = addPointerEvent;
exports.addScaleCorrector = addScaleCorrector;
exports.animate = animate;
exports.animateVisualElement = animateVisualElement;
exports.animationControls = animationControls;
exports.animations = animations;
exports.buildTransform = buildTransform;
exports.calcLength = calcLength;
exports.checkTargetForNewValues = checkTargetForNewValues;
exports.clamp = clamp;
exports.createBox = createBox;
exports.createDomMotionComponent = createDomMotionComponent;
exports.createMotionComponent = createMotionComponent;
exports.delay = delay;
exports.distance = distance;
exports.distance2D = distance2D;
exports.domAnimation = domAnimation;
exports.domMax = domMax;
exports.filterProps = filterProps;
exports.isBrowser = isBrowser;
exports.isDragActive = isDragActive;
exports.isMotionComponent = isMotionComponent;
exports.isMotionValue = isMotionValue;
exports.isValidMotionProp = isValidMotionProp;
exports.m = m;
exports.makeUseVisualState = makeUseVisualState;
exports.mix = mix;
exports.motion = motion;
exports.motionValue = motionValue;
exports.optimizedAppearDataAttribute = optimizedAppearDataAttribute;
exports.pipe = pipe;
exports.resolveMotionValue = resolveMotionValue;
exports.spring = spring;
exports.startOptimizedAppearAnimation = startOptimizedAppearAnimation;
exports.transform = transform;
exports.unwrapMotionComponent = unwrapMotionComponent;
exports.useAnimation = useAnimation;
exports.useAnimationControls = useAnimationControls;
exports.useAnimationFrame = useAnimationFrame;
exports.useCycle = useCycle;
exports.useDeprecatedAnimatedState = useAnimatedState;
exports.useDeprecatedInvertedScale = useInvertedScale;
exports.useDomEvent = useDomEvent;
exports.useDragControls = useDragControls;
exports.useElementScroll = useElementScroll;
exports.useForceUpdate = useForceUpdate;
exports.useInView = useInView;
exports.useInstantLayoutTransition = useInstantLayoutTransition;
exports.useInstantTransition = useInstantTransition;
exports.useIsPresent = useIsPresent;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
exports.useMotionTemplate = useMotionTemplate;
exports.useMotionValue = useMotionValue;
exports.useMotionValueEvent = useMotionValueEvent;
exports.usePresence = usePresence;
exports.useReducedMotion = useReducedMotion;
exports.useReducedMotionConfig = useReducedMotionConfig;
exports.useResetProjection = useResetProjection;
exports.useScroll = useScroll;
exports.useSpring = useSpring;
exports.useTime = useTime;
exports.useTransform = useTransform;
exports.useUnmountEffect = useUnmountEffect;
exports.useVelocity = useVelocity;
exports.useViewportScroll = useViewportScroll;
exports.useVisualElementContext = useVisualElementContext;
exports.useWillChange = useWillChange;
exports.wrap = wrap;
exports.wrapHandler = wrapHandler;


/***/ }),

/***/ 40172:
/***/ (function(module) {

/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */

( function( window, factory ) {
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

} )( window, function factory() {

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  let num = parseFloat( value );
  // not a percent like '100%', and a number
  let isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

// -------------------------- measurements -------------------------- //

let measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth',
];

let measurementsLength = measurements.length;

function getZeroSize() {
  let size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
  };
  measurements.forEach( ( measurement ) => {
    size[ measurement ] = 0;
  } );
  return size;
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) elem = document.querySelector( elem );

  // do not proceed on non-objects
  let isElement = elem && typeof elem == 'object' && elem.nodeType;
  if ( !isElement ) return;

  let style = getComputedStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) return getZeroSize();

  let size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  measurements.forEach( ( measurement ) => {
    let value = style[ measurement ];
    let num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  } );

  let paddingWidth = size.paddingLeft + size.paddingRight;
  let paddingHeight = size.paddingTop + size.paddingBottom;
  let marginWidth = size.marginLeft + size.marginRight;
  let marginHeight = size.marginTop + size.marginBottom;
  let borderWidth = size.borderLeftWidth + size.borderRightWidth;
  let borderHeight = size.borderTopWidth + size.borderBottomWidth;

  // overwrite width and height if we can get it from style
  let styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBox ? 0 : paddingWidth + borderWidth );
  }

  let styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBox ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

} );


/***/ }),

/***/ 89130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J9": function() { return /* binding */ disableExperimentalFragmentVariables; },
  "_t": function() { return /* binding */ disableFragmentWarnings; },
  "wO": function() { return /* binding */ enableExperimentalFragmentVariables; },
  "Ps": function() { return /* binding */ gql; },
  "HW": function() { return /* binding */ resetCaches; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(90781);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
// EXTERNAL MODULE: ../../node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(51591);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../../node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(88660);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(92277);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === 'production'
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,inspect/* inspect */.X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../../node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ../../node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = ((/* unused pure expression or super */ null && (gql)));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "invariant": function() { return /* binding */ invariant; },
/* harmony export */   "warning": function() { return /* binding */ warning; }
/* harmony export */ });
var warning = function () { };
var invariant = function () { };
if (false) {}




/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(48570);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 56204:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(35910)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
      return factory( window, EvEmitter );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  var queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = extend( {}, this.options );
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});


/***/ }),

/***/ 35910:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),

/***/ 52034:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 9599:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 17089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = memoize;


/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 36088:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.I = function (renderer) {
    // CSSOM support only browser environment.
    if (!renderer.client) return;

    if (false) {}

    // Style sheet for media queries.
    document.head.appendChild(renderer.msh = document.createElement('style'));

    renderer.createRule = function (selector, prelude) {
        var rawCss = selector + '{}';
        if (prelude) rawCss = prelude + '{' + rawCss + '}';
        var sheet = prelude ? renderer.msh.sheet : renderer.sh.sheet;
        var index = sheet.insertRule(rawCss, sheet.cssRules.length);
        var rule = (sheet.cssRules || sheet.rules)[index];

        // Keep track of `index` where rule was inserted in the sheet. This is
        // needed for rule deletion.
        rule.index = index;

        if (prelude) {
            // If rule has media query (it has prelude), move style (CSSStyleDeclaration)
            // object to the "top" to normalize it with a rule without the media
            // query, so that both rules have `.style` property available.
            var selectorRule = (rule.cssRules || rule.rules)[0];
            rule.style = selectorRule.style;
            rule.styleMap = selectorRule.styleMap;
        }

        return rule;
    };
};


/***/ }),

/***/ 96047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var removeRule = (__webpack_require__(36396)/* .removeRule */ .D);

exports.I = function (renderer) {
    // VCSSOM support only browser environment.
    if (!renderer.client) return;

    if (false) {}

    var kebab = renderer.kebab;

    function VRule (selector, prelude) {
        this.rule = renderer.createRule(selector, prelude);
        this.decl = {};
    }
    VRule.prototype.diff = function (newDecl) {
        var oldDecl = this.decl;
        var style = this.rule.style;
        var property;
        for (property in oldDecl)
            if (newDecl[property] === undefined)
                style.removeProperty(property);
        for (property in newDecl)
            if (newDecl[property] !== oldDecl[property])
                style.setProperty(kebab(property), newDecl[property]);
        this.decl = newDecl;
    };
    VRule.prototype.del = function () {
        removeRule(this.rule);
    };

    function VSheet () {
        /**
         * {
         *   '<at-rule-prelude>': {
         *     '<selector>': {
         *       color: 'red
         *     }
         *   }
         * }
         */
        this.tree = {};
    }
    VSheet.prototype.diff = function (newTree) {
        var oldTree = this.tree;

        // Remove media queries not present in new tree.
        for (var prelude in oldTree) {
            if (newTree[prelude] === undefined) {
                var rules = oldTree[prelude];
                for (var selector in rules)
                    rules[selector].del();
            }
        }

        for (var prelude in newTree) {
            if (oldTree[prelude] === undefined) {
                // Whole media query is new.
                for (var selector in newTree[prelude]) {
                    var rule = new VRule(selector, prelude);
                    rule.diff(newTree[prelude][selector]);
                    newTree[prelude][selector] = rule;
                }
            } else {
                // Old tree already has rules with this media query.
                var oldRules = oldTree[prelude];
                var newRules = newTree[prelude];

                // Remove rules not present in new tree.
                for (var selector in oldRules)
                    if (!newRules[selector])
                        oldRules[selector].del();

                // Apply new rules.
                for (var selector in newRules) {
                    var rule = oldRules[selector];
                    if (rule) {
                        rule.diff(newRules[selector]);
                        newRules[selector] = rule;
                    } else {
                        rule = new VRule(selector, prelude);
                        rule.diff(newRules[selector]);
                        newRules[selector] = rule;
                    }
                }
            }
        }

        this.tree = newTree;
    };

    renderer.VRule = VRule;
    renderer.VSheet = VSheet;
};


/***/ }),

/***/ 10972:
/***/ (function(__unused_webpack_module, exports) {

function cssToTree (tree, css, selector, prelude) {
    var declarations = {};
    var hasDeclarations = false;
    var key, value;

    for (key in css) {
        value = css[key];
        if (typeof value !== 'object') {
            hasDeclarations = true;
            declarations[key] = value;
        }
    }

    if (hasDeclarations) {
        if (!tree[prelude]) tree[prelude] = {};
        tree[prelude][selector] = declarations;
    }

    for (key in css) {
        value = css[key];
        if (typeof value === 'object') {
            if (key[0] === '@') {
                cssToTree(tree, value, selector, key);
            } else {
                var hasCurrentSymbol = key.indexOf('&') > -1;
                var selectorParts = selector.split(',');
                if (hasCurrentSymbol) {
                    for (var i = 0; i < selectorParts.length; i++) {
                        selectorParts[i] = key.replace(/&/g, selectorParts[i]);
                    }
                } else {
                    for (var i = 0; i < selectorParts.length; i++) {
                        selectorParts[i] = selectorParts[i] + ' ' + key;
                    }
                }
                cssToTree(tree, value, selectorParts.join(','), prelude);
            }
        }
    }
};

exports.z = cssToTree;


/***/ }),

/***/ 36396:
/***/ (function(__unused_webpack_module, exports) {

function removeRule (rule) {
    var maxIndex = rule.index;
    var sh = rule.parentStyleSheet;
    var rules = sh.cssRules || sh.rules;
    maxIndex = Math.max(maxIndex, rules.length - 1);
    while (maxIndex >= 0) {
        if (rules[maxIndex] === rule) {
            sh.deleteRule(maxIndex);
            break;
        }
        maxIndex--;
    }
}

exports.D = removeRule;


/***/ }),

/***/ 44699:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


var KEBAB_REGEX = /[A-Z]/g;

var hash = function (str) {
    var h = 5381, i = str.length;

    while (i) h = (h * 33) ^ str.charCodeAt(--i);

    return '_' + (h >>> 0).toString(36);
};

exports.U = function (config) {
    config = config || {};
    var assign = config.assign || Object.assign;
    var client = typeof window === 'object';

    // Check if we are really in browser environment.
    if (false) {}

    var renderer = assign({
        raw: '',
        pfx: '_',
        client: client,
        assign: assign,
        stringify: JSON.stringify,
        kebab: function (prop) {
            return prop.replace(KEBAB_REGEX, '-$&').toLowerCase();
        },
        decl: function (key, value) {
            key = renderer.kebab(key);
            return key + ':' + value + ';';
        },
        hash: function (obj) {
            return hash(renderer.stringify(obj));
        },
        selector: function (parent, selector) {
            return parent + (selector[0] === ':' ? ''  : ' ') + selector;
        },
        putRaw: function (rawCssRule) {
            renderer.raw += rawCssRule;
        }
    }, config);

    if (renderer.client) {
        if (!renderer.sh)
            document.head.appendChild(renderer.sh = document.createElement('style'));

        if (false) {}

        renderer.putRaw = function (rawCssRule) {
            // .insertRule() is faster than .appendChild(), that's why we use it in PROD.
            // But CSS injected using .insertRule() is not displayed in Chrome Devtools,
            // that's why we use .appendChild in DEV.
            if (true) {
                var sheet = renderer.sh.sheet;

                // Unknown pseudo-selectors will throw, this try/catch swallows all errors.
                try {
                    sheet.insertRule(rawCssRule, sheet.cssRules.length);
                // eslint-disable-next-line no-empty
                } catch (error) {}
            } else {}
        };
    }

    renderer.put = function (selector, decls, atrule) {
        var str = '';
        var prop, value;
        var postponed = [];

        for (prop in decls) {
            value = decls[prop];

            if ((value instanceof Object) && !(value instanceof Array)) {
                postponed.push(prop);
            } else {
                if (false) {} else {
                    str += renderer.decl(prop, value, selector, atrule);
                }
            }
        }

        if (str) {
            if (false) {} else {
                str = selector + '{' + str + '}';
            }
            renderer.putRaw(atrule ? atrule + '{' + str + '}' : str);
        }

        for (var i = 0; i < postponed.length; i++) {
            prop = postponed[i];

            if (prop[0] === '@' && prop !== '@font-face') {
                renderer.putAt(selector, decls[prop], prop);
            } else {
                renderer.put(renderer.selector(selector, prop), decls[prop], atrule);
            }
        }
    };

    renderer.putAt = renderer.put;

    return renderer;
};


/***/ }),

/***/ 93542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(42351);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(57977);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(36872).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(36497).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 33718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(30195)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(9788)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(30199)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(2784));
var _head = _interop_require_default(__webpack_require__(75913));
var _imageConfig = __webpack_require__(18113);
var _useIntersection = __webpack_require__(22030);
var _imageConfigContext = __webpack_require__(20001);
var _utils = __webpack_require__(34750);
var _normalizeTrailingSlash = __webpack_require__(60583);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[768,1440,2048],"imageSizes":[1440],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 90162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(19178)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(29918);
var _addLocale = __webpack_require__(94400);
var _routerContext = __webpack_require__(33220);
var _appRouterContext = __webpack_require__(64069);
var _useIntersection = __webpack_require__(22030);
var _getDomainLocale = __webpack_require__(65253);
var _addBasePath = __webpack_require__(73952);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 36872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(78458).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 22030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(49071);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( true ? __webpack_require__(2784) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 37953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* reexport */ CUSTOMER_ACTIVATE_ACCOUNT; },
  "XN": function() { return /* reexport */ CUSTOMER_ADD_TO_CART; },
  "fX": function() { return /* reexport */ CUSTOMER_BULK_ADD_TO_CART; },
  "PO": function() { return /* reexport */ CUSTOMER_DELETE_FROM_CART; },
  "MV": function() { return /* reexport */ CUSTOMER_EMAIL_FORGOT_PASSWORD; },
  "i_": function() { return /* reexport */ CUSTOMER_EMAIL_INVITE; },
  "Ki": function() { return /* reexport */ CUSTOMER_RESET_PASSWORD; },
  "Iu": function() { return /* reexport */ CUSTOMER_UPDATE_CART_ITEM; },
  "bG": function() { return /* reexport */ GET_CART; },
  "Fk": function() { return /* reexport */ GET_CATEGORIES; },
  "UB": function() { return /* reexport */ GET_CUSTOMER; },
  "j3": function() { return /* reexport */ GET_CUSTOMERS_BY_VAT_NUMBER; },
  "yi": function() { return /* reexport */ GET_CUSTOMER_GRID_MY_PRODUCTS; },
  "fI": function() { return /* reexport */ GET_POSTAL_CODES_VALID; },
  "Hd": function() { return /* reexport */ GET_PRODUCT_CMS; },
  "jc": function() { return /* reexport */ GET_SEARCH_PRODUCTS; },
  "zO": function() { return /* reexport */ MUTATION_CART_DELIVERY_DATE; },
  "qD": function() { return /* reexport */ MUTATION_CART_SYNC; },
  "Rw": function() { return /* reexport */ SIGNUP_MUTATION; },
  "Uk": function() { return /* reexport */ useApollo; }
});

// UNUSED EXPORTS: CART_REDIRECT_URLS, CUSTOMER_GENERATE_TOKEN, CUSTOMER_LOGOUT, CUSTOMER_UPDATE_ADDRESSES_MUTATION, CUSTOMER_UPDATE_MUTATION, FRAGMENT_DIGITAL_PRODUCT_REQUIRED, FRAGMENT_PRICE, FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED, GET_BRAND, GET_BRANDS, GET_BRAND_CATEGORIES, GET_BRAND_CATEGORY, GET_CART_RELATEDS, GET_CATEGORY, GET_CUSTOMER_ADDRESSES, GET_CUSTOMER_HOME_SLIDER_MY_PRODUCTS, GET_CUSTOMER_ID, GET_CUSTOMER_ORDERS, GET_FAQS, GET_HOMEPAGE, GET_INVOICES, GET_LAYOUT, GET_ORDER_BY_BC_ID, GET_PAGE, GET_PAGES, GET_PAGE_CATEGORY, GET_PRODUCTS_STATIC_PATHS, GET_SITEMAP, LOGIN_MUTATION, fetchGraph, initializeApollo

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72558);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js + 7 modules
var ApolloClient = __webpack_require__(77494);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/concat.js
var concat = __webpack_require__(60380);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(89552);
;// CONCATENATED MODULE: ./api/graphql/useApollo.ts



var apolloClient;
var httpLinkCMS = new HttpLink/* HttpLink */.u({
    uri: "https://".concat("cms.mammafiore.eu", "/graphql")
});
var httpLinkBigCommerce = new HttpLink/* HttpLink */.u({
    uri: "https://".concat("", "/graphql"),
    credentials: "include"
});
function createApolloClient(initialState) {
    var authCMS = new ApolloLink/* ApolloLink */.i(function(operation, forward) {
        var operationContext = operation.getContext();
        var isPrivatePath = operationContext.isPrivatePath;
        // const customerId = operationContext.customerId
        var DYCustomerToken = operationContext.DYCustomerToken;
        var DYResetPasswordToken = operationContext.DYResetPasswordToken;
        var DYInviteToken = operationContext.DYInviteToken;
        var token = isPrivatePath ? "eyJhbGciOiJIUzI1NiJ9.eyJ3ZWJzaXRlX2lkIjo5LCJzdG9yZV9pZCI6NCwiY2hhbm5lbF9pZCI6OCwiZXhwIjozMTcyODQ1MTY4MTN9.TnwrT3POxF1UFp6ETped3DSQlXNLngm2b2oKQc6CoT8" : "eyJhbGciOiJIUzI1NiJ9.eyJ3ZWJzaXRlX2lkIjo4LCJzdG9yZV9pZCI6NCwiY2hhbm5lbF9pZCI6NywiZXhwIjozMTcyODQ1MTY3OTV9.ZR7Etr9_QehWaUKWzWqEhXY5-t5-UFS1qulsxySWNyQ";
        // console.log(`🔑 DY CMS graphQL token (private:${isPrivatePath}):`, token)
        operation.setContext({
            headers: (0,_object_spread/* default */.Z)({
                "Accept": "application/json",
                "Content-Type": "application/json",
                "DY-Access-Token": "".concat(token)
            }, DYCustomerToken && {
                "DY-Customer-Token": DYCustomerToken
            }, DYResetPasswordToken && {
                "DY-Reset-Password-Token": DYResetPasswordToken
            }, DYInviteToken && {
                "DY-Invite-Token": DYInviteToken
            }),
            fetch: fetch
        });
        return forward(operation);
    });
    var authBigCommerce = new ApolloLink/* ApolloLink */.i(function(operation, forward) {
        var operationContext = operation.getContext();
        var isPrivatePath = operationContext.isPrivatePath;
        var customerId = operationContext.customerId;
        var token = isPrivatePath ? "" : "";
        // console.log(`🔑 BigCommerce DEVELOPMENT graphQL token (private:${isPrivatePath}):`, BCCustomerAccessToken)
        operation.setContext({
            headers: (0,_object_spread/* default */.Z)({
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer ".concat(token)
            }, customerId && {
                "x-bc-customer-id": customerId
            }),
            fetch: fetch
        });
        return forward(operation).map(function(response) {
            return response;
        });
    });
    return new ApolloClient/* ApolloClient */.f({
        ssrMode: "object" === "undefined",
        link: ApolloLink/* ApolloLink.split */.i.split(function(operation) {
            return operation.getContext().endpoint === "BC";
        }, (0,concat/* concat */.z)(authBigCommerce, httpLinkBigCommerce), (0,concat/* concat */.z)(authCMS, httpLinkCMS) // <= otherwise will send to our CMS
        ),
        cache: new inMemoryCache/* InMemoryCache */.h().restore(initialState),
        credentials: "include"
    });
}
function initializeApollo() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var _apolloClient = apolloClient !== null && apolloClient !== void 0 ? apolloClient : createApolloClient(initialState);
    // If the page has data fetching methods that use Apollo Client, the initial state gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        var existingCache = _apolloClient.extract();
        // Restore the cache using the data passed from getStaticProps/getServerSideProps combined with the existing cached data
        _apolloClient.cache.restore((0,_object_spread/* default */.Z)({}, existingCache, initialState));
    }
    // For SSG and SSR always create a new Apollo Client
    if (false) {}
    // Create the Apollo Client once in the client
    if (!apolloClient) apolloClient = _apolloClient;
    return _apolloClient;
}
function useApollo(initialState) {
    var clientStore = (0,react.useMemo)(function() {
        return initializeApollo(initialState);
    }, [
        initialState
    ]);
    // Clear the client's store on unmount to prevent memory leaks
    (0,react.useEffect)(function() {
        return function() {
            clientStore.clearStore();
        };
    }, [
        clientStore
    ]);
    return clientStore;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(89130);
;// CONCATENATED MODULE: ./api/graphql/queries/product.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_PRODUCTS_STATIC_PATHS {\n    products{\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentPrice on Variant {\n    price {\n      discount\n      salePrice:discountedPrice\n      retailPrice:fullPrice\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  fragment FragmentVariantRequired on Variant {\n    id\n    bigcommerceId\n    ean\n    gtin\n    deliveryDate\n    deliveryType\n    onDemandDay\n    media {\n      mediaType\n      medium(variant: "pdp")\n    }\n    minSaleUnits\n    qtyPerBox\n    name\n    ...FragmentPrice\n    sku\n    stock\n    stockWarning\n  }\n  ',
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentProductRequired on Product {\n    bigcommerceId\n    brand {\n      name\n    }\n    ean\n    gtin\n    inventoryTracking\n    name\n    productType\n    slug\n    sku\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentDigitalProduct on DigitalProduct {\n    name\n    price\n    sku\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentRelatedVariants on Product {\n    related {\n      ...FragmentVariantRequired\n      product {\n        ...FragmentProductRequired\n        labels {\n          name\n        }\n        brand {\n          name\n          slug\n        }\n        description\n        ingredients\n        nutrition {\n          name\n          value\n          nutritionType\n        }\n        infoSpecifications {\n          name\n          value\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_PRODUCT_CMS($slug: String!) {\n    product(slug: $slug) {\n      ...FragmentProductRequired\n      seo\n      description\n      infoSpecifications {\n        name\n        value\n      }\n      categories {\n        name\n      }\n      ingredients\n      ...FragmentRelatedVariants\n      nutrition {\n        name\n        value\n        nutritionType\n      }\n      labels {\n        name\n      }\n      brand {\n        name\n        slug\n      }\n      variants {\n        ...FragmentVariantRequired\n        product {\n          ...FragmentProductRequired\n          labels {\n            name\n          }\n          brand {\n            name\n            slug\n          }\n        }\n      }\n      filters {\n        name\n        param\n        type: filterType\n        values {\n          value\n          description\n          visible\n          image\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_SEARCH_PRODUCTS($search: String!) {\n    productSearch(search: $search) {\n      count\n      categories {\n        name\n        slug\n        bigcommerceId\n        subcategories {\n          name\n          slug\n        }\n      }\n      brands {\n        name\n        logo\n        slug\n      }\n      variants {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            product {\n              ...FragmentProductRequired\n              description\n              ingredients\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_BRANDS {\n    brands {\n      slug\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_BRAND($slug: String!) {\n    brand(slug: $slug) {\n      description\n      logo\n      name\n      slug\n      categories {\n        name\n        slug\n        subcategories {\n          name\n          slug\n        }\n      }\n      variants {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n             packItems {\n              name\n              sku\n            }\n            product {\n              description\n              ean\n              gtin\n              inventoryTracking\n              ingredients\n              name\n              productType\n              seo\n              sku\n              slug\n              brand {\n                name\n                slug\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_BRAND_CATEGORIES($slug: String!) {\n    brand(slug: $slug) {\n      categories {\n        slug\n        subcategories {\n          slug\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_BRAND_CATEGORY($slug: String!, $categorySlug: String! ) {\n    brand(slug: $slug) {\n      description\n      logo\n      name\n      slug\n      categories {\n        name\n        slug\n        subcategories {\n          name\n          slug\n        }\n      }\n      category(slug: $categorySlug) {\n        name\n        slug\n        subcategories {\n          name\n          slug\n        }\n      }\n      variants(categorySlug:  $categorySlug) {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            product {\n              description\n              ean\n              gtin\n              ingredients\n              name\n              productType\n              seo\n              sku\n              slug\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var GET_PRODUCTS_STATIC_PATHS = (0,lib/* gql */.Ps)(_templateObject());
var FRAGMENT_PRICE = (0,lib/* gql */.Ps)(_templateObject1());
var FRAGMENT_VARIANT_REQUIRED = (0,lib/* gql */.Ps)(_templateObject2(), FRAGMENT_PRICE);
var FRAGMENT_PRODUCT_REQUIRED = (0,lib/* gql */.Ps)(_templateObject3());
var FRAGMENT_DIGITAL_PRODUCT_REQUIRED = (0,lib/* gql */.Ps)(_templateObject4());
var FRAGMENT_RELATED_VARIANTS = (0,lib/* gql */.Ps)(_templateObject5(), FRAGMENT_VARIANT_REQUIRED, FRAGMENT_PRODUCT_REQUIRED);
var GET_PRODUCT_CMS = (0,lib/* gql */.Ps)(_templateObject6(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED, FRAGMENT_RELATED_VARIANTS);
var GET_SEARCH_PRODUCTS = (0,lib/* gql */.Ps)(_templateObject7(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED);
var GET_BRANDS = (0,lib/* gql */.Ps)(_templateObject8());
var GET_BRAND = (0,lib/* gql */.Ps)(_templateObject9(), FRAGMENT_VARIANT_REQUIRED);
var GET_BRAND_CATEGORIES = (0,lib/* gql */.Ps)(_templateObject10());
var GET_BRAND_CATEGORY = (0,lib/* gql */.Ps)(_templateObject11(), FRAGMENT_VARIANT_REQUIRED);

;// CONCATENATED MODULE: ./api/graphql/queries/cart.ts

function cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentServices on CartLine {\n    services {\n      id\n      quantity\n      cartLineType\n      listPrice\n      extendedSalePrice\n      product {\n        ...FragmentProductRequired\n        brand {\n          name\n          logo\n        }\n        labels {\n          name\n        }\n      }\n      variant {\n        ...FragmentVariantRequired\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentCartLines on Cart {\n    cartLines {\n      id\n      quantity\n      cartLineType\n      listPrice\n      extendedSalePrice\n      product {\n        ...FragmentProductRequired\n        brand {\n          name\n          logo\n        }\n        labels {\n          name\n        }\n      }\n      variant {\n        ...FragmentVariantRequired\n      }\n      ...FragmentServices\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    cart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentNotifications on Cart {\n    notifications {\n      ... on CartLineInvalidQuantity {\n        code\n        model\n        cartLine {\n          id\n          variant {\n            id\n            stock\n            name\n          }\n          product {\n            name\n          }\n        }\n        oldQuantity\n        newQuantity\n        deleted\n      }\n    }\n  }\n"
    ]);
    cart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cart_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentCart on Cart {\n    id\n    bigcommerceId\n    customer {\n      bigcommerceId\n    }\n    promotions {\n      id\n      name\n      rules {\n        ruleableType\n        ruleable\n      }\n    }\n    discountAmount\n    subtotalExTax\n    totalExTax\n    multipleDeliveryDates\n    deliveryDate\n    deliveryDateOptions\n    deliveryType\n    deliverySchedules {\n      name\n      agency\n      minimumPurchase\n      minimumPurchaseFrozen\n      agencyText\n    }\n    ...FragmentCartLines\n    ...FragmentNotifications\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    cart_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cart_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentboughtTogether on Cart {\n    boughtTogether {\n      ...FragmentVariantRequired\n      product {\n        ...FragmentProductRequired\n        description\n        ingredients\n        seo\n        labels {\n          name\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    cart_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cart_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CART {\n    cart {\n      ...FragmentCart\n    }\n    \n  }\n  ",
        "\n"
    ]);
    cart_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cart_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation MUTATION_CART_SYNC {\n    cartSync(input: {}) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n      checkoutUrl\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function cart_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation MUTATION_CART_DELIVERY_DATE($deliveryDate: String!) {\n    cartDeliveryDate(input: {\n      deliveryDate: $deliveryDate\n    }) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function cart_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CART_RELATEDS {\n    customer {\n      id\n      cart {\n        ...FragmentboughtTogether\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function cart_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_ADD_TO_CART($variantId: Int!, $quantity: Int!, $cartLineType: CartLineTypeEnum!) {\n    cartLinesAdd(\n      input: {\n        cartLines: {\n          variantId: $variantId,\n          quantity: $quantity,\n          cartLineType: $cartLineType\n        }\n      }\n    ) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function cart_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_UPDATE_CART_ITEM($variantId: Int!, $quantity: Int!, $cartLineType: CartLineTypeEnum!) {\n    cartLinesUpdate(\n      input: {\n        cartLines: {\n          variantId: $variantId,\n          quantity: $quantity,\n          cartLineType: $cartLineType\n        }\n      }\n    ) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function cart_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_DELETE_FROM_CART($variantId: Int!) {\n    cartLinesDelete(\n      input: {\n        cartLines: {\n          variantId: $variantId\n        }\n      }\n    ) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    cart_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_BULK_ADD_TO_CART($cartLines: [CartLineFieldsInput!]!) {\n    cartLinesAdd(\n      input: {\n        cartLines: $cartLines\n      }\n    ) {\n      ok\n      cart {\n        ...FragmentCart\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateCartRedirectUrls($cartEntityId: String!) {\n    cart {\n      createCartRedirectUrls(input: { cartEntityId: $cartEntityId }) {\n        redirectUrls {\n          embeddedCheckoutUrl\n          redirectedCheckoutUrl\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var FRAGMENT_SERVICES = (0,lib/* gql */.Ps)(cart_templateObject(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED);
var FRAGMENT_CART_LINES = (0,lib/* gql */.Ps)(cart_templateObject1(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED, FRAGMENT_SERVICES);
var FRAGMENT_NOTIFICATIONS = (0,lib/* gql */.Ps)(cart_templateObject2());
var FRAGMENT_CART = (0,lib/* gql */.Ps)(cart_templateObject3(), FRAGMENT_NOTIFICATIONS, FRAGMENT_CART_LINES);
var FRAGMENT_BOUGHT_TOGETHER_VARIANTS = (0,lib/* gql */.Ps)(cart_templateObject4(), FRAGMENT_VARIANT_REQUIRED, FRAGMENT_PRODUCT_REQUIRED);
var GET_CART = (0,lib/* gql */.Ps)(cart_templateObject5(), FRAGMENT_CART);
var MUTATION_CART_SYNC = (0,lib/* gql */.Ps)(cart_templateObject6(), FRAGMENT_CART);
var MUTATION_CART_DELIVERY_DATE = (0,lib/* gql */.Ps)(cart_templateObject7(), FRAGMENT_CART);
var GET_CART_RELATEDS = (0,lib/* gql */.Ps)(cart_templateObject8(), FRAGMENT_BOUGHT_TOGETHER_VARIANTS);
var CUSTOMER_ADD_TO_CART = (0,lib/* gql */.Ps)(cart_templateObject9(), FRAGMENT_CART);
var CUSTOMER_UPDATE_CART_ITEM = (0,lib/* gql */.Ps)(cart_templateObject10(), FRAGMENT_CART);
var CUSTOMER_DELETE_FROM_CART = (0,lib/* gql */.Ps)(cart_templateObject11(), FRAGMENT_CART);
var CUSTOMER_BULK_ADD_TO_CART = (0,lib/* gql */.Ps)(_templateObject12(), FRAGMENT_CART);
// export const CART_REDIRECT_URL = gql`
//   mutation($cartEntityId: String!) {
//     cart {
//       createCartRedirectUrls(input:{ cartEntityId: $cartEntityId }) {
//         redirectUrls {
//           embeddedCheckoutUrl
//           redirectedCheckoutUrl
//         }
//       }
//     }
//   }
// `
var CART_REDIRECT_URLS = (0,lib/* gql */.Ps)(_templateObject13());

;// CONCATENATED MODULE: ./api/graphql/queries/customer.ts

function customer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SIGNUP_MUTATION($firstName: String!, $lastName: String!, $companyName: String!, $email: String!, $password: String!, $formFields: CustomerRegisterFormFieldsInput!, $addresses: [CustomerAddressesInput!]!) {\n    customerRegister(\n      input: {\n        customer: {\n          firstName: $firstName\n          lastName: $lastName\n          companyName: $companyName\n          credentials: {\n            email: $email\n            password: $password\n          }\n          formFields: $formFields\n          addresses: $addresses\n        }\n      }\n    ) {\n      ok\n      errors\n      token\n      customer {\n        bigcommerceId\n      }\n    }\n  }\n"
    ]);
    customer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function customer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMERS_BY_VAT_NUMBER($vatNumber: String!) {\n    customers(vatNumber: $vatNumber) {\n      edges {\n        node {\n          emailObfuscated\n          vatNumber\n          onboardingStatus\n        }\n      }\n    }\n  }\n"
    ]);
    customer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function customer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMER {\n    customer {\n      id\n      bigcommerceId\n      firstName\n      lastName\n      email\n      paymentMethod\n      vatNumber\n    }\n  }\n"
    ]);
    customer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function customer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMER_ID {\n    customer {\n      id\n    }\n  }\n"
    ]);
    customer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function customer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FragmentAddress on Address {\n      bigcommerceId\n      addressType\n      city\n      countryCode\n      firstName\n      lastName\n      postalCode\n      region\n      street1\n      street2\n  }\n"
    ]);
    customer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function customer_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMER_ADDRESSES {\n    customer {\n      id\n      bigcommerceId\n      vatNumber\n      shippingAddress {\n      ...FragmentAddress\n      }\n      billingAddress {\n      ...FragmentAddress\n      }\n    }\n  }\n  ",
        "\n\n"
    ]);
    customer_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function customer_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  fragment FragmentOrders on Customer {\n    orders {\n      edges {\n        cursor\n        node {\n          bigcommerceId\n          dateCreated\n          orderStatus\n          storeCreditAmount\n          totalExTax\n          orderLines {\n            orderId\n            productName\n            quantity\n            priceExTax\n            brandName\n            # variantName\n            variantSku\n            product {\n              inventoryTracking\n            }\n            variant {\n              id\n              name\n              importStatus\n              media {\n                medium(variant: "grid")\n                mediaType\n              }\n              minSaleUnits\n              stock\n              stockWarning\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    customer_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function customer_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMER_ORDERS {\n    customer {\n      bigcommerceId\n      firstName\n      ...FragmentOrders\n    }\n  }\n  ",
        "\n"
    ]);
    customer_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function customer_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query GET_ORDER_BY_BC_ID($bigcommerceId: Int!) {\n    customer {\n      bigcommerceId\n    }\n    order(bigcommerceId: $bigcommerceId) {\n      bigcommerceId\n      dateCreated\n      deliveryDate\n      paymentMethod\n      subtotalExTax\n			discountAmount\n      couponDiscount\n      shippingCostExTax\n      totalIncTax\n      totalTax\n      orderLines {\n        orderId\n        basePrice\n        quantity\n        bigcommerceId\n        priceExTax\n        brandName\n        productName\n        # variantName\n        variant {\n          id\n          name\n          importStatus\n          bigcommerceId\n          media {\n            medium(variant: "grid")\n            mediaType\n          }\n          minSaleUnits\n          stock\n          stockWarning\n        }\n      }\n      comments\n      billingAddress\n      shippingAddress\n    }\n  }\n'
    ]);
    customer_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function customer_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_INVOICES {\n    customer {\n      bigcommerceId\n    }\n    invoices {\n      id\n      number\n      invoiceDate\n      totalExTax\n      invoiceLines {\n        bigcommerceId\n        dateCreated\n        totalExTax\n      }\n    }\n  }\n"
    ]);
    customer_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function customer_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LOGIN_MUTATION($email: String!, $password:String!) {\n    loginMutation(input: {\n    email: $email,\n    password: $password\n  }) {\n      ok\n      customer {\n        bigcommerceId\n      }\n      dyApiCustomerToken\n      dyApiCustomerTokenExpiry\n    }\n  }\n"
    ]);
    customer_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function customer_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_ACTIVATE_ACCOUNT($password: String!) {\n    customerActivate(\n      input: {\n        password: $password\n      }\n    ) {\n      ok\n      customer {\n        bigcommerceId\n      }\n      errors\n    }\n  }\n"
    ]);
    customer_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function customer_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_RESET_PASSWORD($password: String!) {\n    customerResetPassword(\n      input: {\n        password: $password\n      }\n    ) {\n      ok\n      customer {\n        bigcommerceId\n      }\n      errors\n    }\n  }\n"
    ]);
    customer_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function customer_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_UPDATE_MUTATION($password: String!) {\n    customerUpdate(\n      input: {\n        customer: {\n          password: $password\n        }\n      }\n    )\n    {\n      ok\n      customer {\n        bigcommerceId\n        email\n      }\n      errors\n    }\n  }\n"
    ]);
    customer_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_UPDATE_ADDRESSES_MUTATION($addresses: [CustomerAddressesUpdateInput!]) {\n    customerUpdate(\n      input: {\n        customer: {\n          addresses: $addresses\n        }\n      }\n    )\n    {\n      ok\n      errors\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_EMAIL_FORGOT_PASSWORD($email: String!) {\n    customerEmailResetPassword(\n      input: {\n        email: $email\n      }\n    ) {\n      ok\n      customer {\n        bigcommerceId\n        emailObfuscated\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_EMAIL_INVITE($vatNumber: String!) {\n    customerEmailInvite(\n      input: {\n        vatNumber: $vatNumber\n      }\n    ) {\n      ok\n      customer {\n        bigcommerceId\n        firstName\n        lastName\n        vatNumber\n        emailObfuscated\n        onboardingStatus\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CUSTOMER_GRID_MY_PRODUCTS($first: Int!) {\n    customer {\n      bigcommerceId\n      email\n      myUsual(first: $first) {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            product {\n              ...FragmentProductRequired\n            }\n          }\n        }\n      }\n      categories {\n        name\n        slug\n        subcategories {\n          name\n          slug\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query GET_CUSTOMER_HOME_SLIDER_MY_PRODUCTS($first: Int!) {\n    customer {\n      id\n      orders(first: $first) {\n        edges {\n          cursor\n          node {\n            id\n            deliveryDate\n            orderLines {\n              bigcommerceId\n              quantity\n              orderId\n              productName\n              priceExTax\n              brandName\n              # variantName\n              product {\n                inventoryTracking\n              }\n              variant {\n                id\n                name\n                importStatus\n                media {\n                  medium(variant: "grid")\n                  mediaType\n                }\n                minSaleUnits\n                stock\n                stockWarning\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  '
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CUSTOMER_GENERATE_TOKEN($email: String!, $password: String!) {\n    generateToken(input: {\n      email: $email\n      password: $password\n    }) {\n      ok\n      token\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LOGOUT_CUSTOMER {\n    logout {\n      result\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var SIGNUP_MUTATION = (0,lib/* gql */.Ps)(customer_templateObject());
var GET_CUSTOMERS_BY_VAT_NUMBER = (0,lib/* gql */.Ps)(customer_templateObject1());
var GET_CUSTOMER = (0,lib/* gql */.Ps)(customer_templateObject2());
var GET_CUSTOMER_ID = (0,lib/* gql */.Ps)(customer_templateObject3());
var FRAGMENT_ADDRESS = (0,lib/* gql */.Ps)(customer_templateObject4());
var GET_CUSTOMER_ADDRESSES = (0,lib/* gql */.Ps)(customer_templateObject5(), FRAGMENT_ADDRESS);
var FRAGMENT_ORDERS = (0,lib/* gql */.Ps)(customer_templateObject6());
var GET_CUSTOMER_ORDERS = (0,lib/* gql */.Ps)(customer_templateObject7(), FRAGMENT_ORDERS);
var GET_ORDER_BY_BC_ID = (0,lib/* gql */.Ps)(customer_templateObject8());
var GET_INVOICES = (0,lib/* gql */.Ps)(customer_templateObject9());
var LOGIN_MUTATION = (0,lib/* gql */.Ps)(customer_templateObject10());
var CUSTOMER_ACTIVATE_ACCOUNT = (0,lib/* gql */.Ps)(customer_templateObject11());
var CUSTOMER_RESET_PASSWORD = (0,lib/* gql */.Ps)(customer_templateObject12());
var CUSTOMER_UPDATE_MUTATION = (0,lib/* gql */.Ps)(customer_templateObject13());
var CUSTOMER_UPDATE_ADDRESSES_MUTATION = (0,lib/* gql */.Ps)(_templateObject14());
var CUSTOMER_EMAIL_FORGOT_PASSWORD = (0,lib/* gql */.Ps)(_templateObject15());
var CUSTOMER_EMAIL_INVITE = (0,lib/* gql */.Ps)(_templateObject16());
var GET_CUSTOMER_GRID_MY_PRODUCTS = (0,lib/* gql */.Ps)(_templateObject17(), FRAGMENT_VARIANT_REQUIRED, FRAGMENT_PRODUCT_REQUIRED);
var GET_CUSTOMER_HOME_SLIDER_MY_PRODUCTS = (0,lib/* gql */.Ps)(_templateObject18());
var CUSTOMER_GENERATE_TOKEN = (0,lib/* gql */.Ps)(_templateObject19());
var CUSTOMER_LOGOUT = (0,lib/* gql */.Ps)(_templateObject20());

;// CONCATENATED MODULE: ./api/graphql/queries/other.ts

function other_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CATEGORIES($type:CategoryTypeEnum) {\n    categories(type: $type) {\n      id\n      name\n      slug\n      categoryType\n      subcategories {\n        id\n        name\n        slug\n        categoryType\n      }\n    }\n  }\n"
    ]);
    other_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function other_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_CATEGORY($slug: String!) {\n    category(slug: $slug) {\n      name\n      seo\n      slug\n      categoryType\n      subcategories {\n        id\n        name\n        slug\n        categoryType\n      }\n      variants {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            packItems {\n              name\n              sku\n            }\n            product {\n              ...FragmentProductRequired\n              brand {\n                name\n                slug\n              }\n              labels {\n                name\n              }\n              filters {\n                name\n                param\n                type: filterType\n                values {\n                  name: value\n                  description\n                  media: image\n                  value:parameterizedValue\n                }\n              }\n              categories {\n                id\n                name\n                slug\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    other_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function other_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_LAYOUT($bannerType: BannerTypeEnum, $type:CategoryTypeEnum ) {\n    banners(bannerType: $bannerType) {\n      title\n      titleSize\n      bannerType\n    }\n    categories(type: $type) {\n      id\n      name\n      slug\n      categoryType\n      subcategories {\n        id\n        name\n        slug\n        categoryType\n      }\n    }\n    modals {\n      edges {\n        cursor\n        node {\n          linkPath\n          linkTitle\n          modalType\n          text\n          title\n          visibleFrom\n          visibleUntil\n        }\n      }\n    }\n    footers {\n      id\n      itemType\n      title\n      url\n    }\n  }\n"
    ]);
    other_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function other_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_FAQS($type: CategoryTypeEnum) {\n    categories(type: $type) {\n        id\n        name\n        seo\n        slug\n        faqs {\n          answer\n          parameterize\n          question\n        }\n    }\n  }\n"
    ]);
    other_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function other_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_PAGE_CATEGORY($slug: String!, $categorySlug: String!) {\n    page(slug: $slug) {\n      pageType\n      slug\n      title\n      subtitle\n      seo\n      contents {\n        rows\n        columns {\n          columnType\n          download\n          horizontalAlignment\n          imageCaption\n          longVideo\n          mediaSize\n          mediaType\n          medium\n          shortVideo\n          text\n          verticalAlignment\n          videoType\n        }\n      }\n      variants(categorySlug: $categorySlug) {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            packItems {\n              name\n              sku\n            }\n            product {\n              ...FragmentProductRequired\n              brand {\n                name\n                slug\n              }\n              labels {\n                name\n              }\n              filters {\n                name\n                param\n                type: filterType\n                values {\n                  name: value\n                  description\n                  media: image\n                  value:parameterizedValue\n                }\n              }\n              categories {\n                id\n                name\n                slug\n              }\n            }\n          }\n        }\n      }\n      category(slug: $categorySlug) {\n        name\n        slug\n        subcategories {\n          name\n          slug\n          parentId\n        }\n      }\n      categories {\n        name\n        parentId\n        slug\n        subcategories {\n          name\n          slug\n          parentId\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    other_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function other_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_PAGE($slug: String!) {\n    page(slug: $slug) {\n      pageType\n      slug\n      title\n      subtitle\n      seo\n      contents {\n        rows\n        columns {\n          columnType\n          download\n          horizontalAlignment\n          imageCaption\n          longVideo\n          mediaSize\n          mediaType\n          medium\n          shortVideo\n          text\n          verticalAlignment\n          videoType\n        }\n      }\n      variants {\n        edges {\n          cursor\n          node {\n            ...FragmentVariantRequired\n            packItems {\n              name\n              sku\n            }\n            product {\n              ...FragmentProductRequired\n              brand {\n                name\n                slug\n              }\n              labels {\n                name\n              }\n              filters {\n                name\n                param\n                type: filterType\n                values {\n                  name: value\n                  description\n                  media: image\n                  value:parameterizedValue\n                }\n              }\n              categories {\n                id\n                name\n                slug\n              }\n            }\n          }\n        }\n      }\n      categories {\n        name\n        parentId\n        slug\n        subcategories {\n          name\n          slug\n          parentId\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    other_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function other_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_HOMEPAGE {\n    homepage {\n      title\n      subtitle\n      slug\n      seo\n      visible\n      pageType\n      videos {\n        title\n      }\n      banners {\n        bannerType\n        mainType\n        productId\n        variant {\n          sku\n        }\n        textAlign\n        textValign\n        textPosition\n        mediaType\n        videoType\n        shortVideo\n        title\n        subtitle\n        link\n        titleSize\n        subtitleSize\n        ingredients\n        leftImage\n        centerImage\n        rightImage\n        media\n        backImage\n      }\n      highlighted {\n        ...FragmentVariantRequired\n        packItems {\n          name\n          sku\n        }\n        product {\n          ...FragmentProductRequired\n          labels {\n            name\n          }\n          brand {\n            name\n            slug\n          }\n          filters {\n            name\n            param\n            type: filterType\n            values {\n              name: value\n              description\n              media: image\n            }\n          }\n          categories {\n            id\n            name\n            slug\n          }\n        }\n      }\n      topSellers {\n        ...FragmentVariantRequired\n        packItems {\n          name\n          sku\n        }\n        product {\n          ...FragmentProductRequired\n          labels {\n            name\n          }\n          brand {\n            name\n            slug\n          }\n          filters {\n            name\n            param\n            type: filterType\n            values {\n              name: value\n              description\n              media: image\n            }\n          }\n          categories {\n            id\n            name\n            slug\n          }\n        }\n      }\n      services {\n        title\n        titleSize\n      }\n      brands {\n        name\n        slug\n        logo\n      }\n      contents {\n        rows\n        columns {\n          columnType\n          text\n          imageCaption\n          medium\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    other_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function other_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_PAGES($type: PageTypeEnum) {\n    pages(type: $type) {\n      slug\n    }\n  }\n"
    ]);
    other_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function other_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_POSTAL_CODES_VALID {\n    validPostalCodes {\n      from\n      to\n      value\n      valueType\n    }\n  }\n"
    ]);
    other_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function other_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GET_SITEMAP {\n    categories(type: PRODUCT) {\n      slug\n      updatedAt\n      subcategories {\n        slug\n        updatedAt\n      }\n    }\n    products{\n      slug\n      updatedAt\n    }\n    brands {\n      slug\n      updatedAt\n    }\n    contents:pages(type: REGULAR) {\n      slug\n      updatedAt\n    }\n    faqsCategories:categories(type: FAQ) {\n      slug\n      updatedAt\n      subcategories {\n        slug\n        updatedAt\n      }\n    }\n  }\n"
    ]);
    other_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var GET_CATEGORIES = (0,lib/* gql */.Ps)(other_templateObject());
var GET_CATEGORY = (0,lib/* gql */.Ps)(other_templateObject1(), FRAGMENT_VARIANT_REQUIRED, FRAGMENT_PRODUCT_REQUIRED);
var GET_LAYOUT = (0,lib/* gql */.Ps)(other_templateObject2());
var GET_FAQS = (0,lib/* gql */.Ps)(other_templateObject3());
var GET_PAGE_CATEGORY = (0,lib/* gql */.Ps)(other_templateObject4(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED);
var GET_PAGE = (0,lib/* gql */.Ps)(other_templateObject5(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED);
var GET_HOMEPAGE = (0,lib/* gql */.Ps)(other_templateObject6(), FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED);
var GET_PAGES = (0,lib/* gql */.Ps)(other_templateObject7());
var GET_POSTAL_CODES_VALID = (0,lib/* gql */.Ps)(other_templateObject8());
var GET_SITEMAP = (0,lib/* gql */.Ps)(other_templateObject9());

;// CONCATENATED MODULE: ./api/graphql/queries/index.ts





;// CONCATENATED MODULE: ./api/graphql/index.ts





/***/ }),

/***/ 95163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xb": function() { return /* reexport */ graphql/* CUSTOMER_ACTIVATE_ACCOUNT */.Xb; },
  "XN": function() { return /* reexport */ graphql/* CUSTOMER_ADD_TO_CART */.XN; },
  "fX": function() { return /* reexport */ graphql/* CUSTOMER_BULK_ADD_TO_CART */.fX; },
  "PO": function() { return /* reexport */ graphql/* CUSTOMER_DELETE_FROM_CART */.PO; },
  "MV": function() { return /* reexport */ graphql/* CUSTOMER_EMAIL_FORGOT_PASSWORD */.MV; },
  "i_": function() { return /* reexport */ graphql/* CUSTOMER_EMAIL_INVITE */.i_; },
  "Ki": function() { return /* reexport */ graphql/* CUSTOMER_RESET_PASSWORD */.Ki; },
  "Iu": function() { return /* reexport */ graphql/* CUSTOMER_UPDATE_CART_ITEM */.Iu; },
  "bG": function() { return /* reexport */ graphql/* GET_CART */.bG; },
  "Fk": function() { return /* reexport */ graphql/* GET_CATEGORIES */.Fk; },
  "UB": function() { return /* reexport */ graphql/* GET_CUSTOMER */.UB; },
  "j3": function() { return /* reexport */ graphql/* GET_CUSTOMERS_BY_VAT_NUMBER */.j3; },
  "yi": function() { return /* reexport */ graphql/* GET_CUSTOMER_GRID_MY_PRODUCTS */.yi; },
  "fI": function() { return /* reexport */ graphql/* GET_POSTAL_CODES_VALID */.fI; },
  "Hd": function() { return /* reexport */ graphql/* GET_PRODUCT_CMS */.Hd; },
  "jc": function() { return /* reexport */ graphql/* GET_SEARCH_PRODUCTS */.jc; },
  "Rw": function() { return /* reexport */ graphql/* SIGNUP_MUTATION */.Rw; },
  "Io": function() { return /* reexport */ fetchAPI; }
});

// UNUSED EXPORTS: CART_REDIRECT_URLS, CUSTOMER_GENERATE_TOKEN, CUSTOMER_LOGOUT, CUSTOMER_UPDATE_ADDRESSES_MUTATION, CUSTOMER_UPDATE_MUTATION, FRAGMENT_DIGITAL_PRODUCT_REQUIRED, FRAGMENT_PRICE, FRAGMENT_PRODUCT_REQUIRED, FRAGMENT_VARIANT_REQUIRED, GET_BRAND, GET_BRANDS, GET_BRAND_CATEGORIES, GET_BRAND_CATEGORY, GET_CART_RELATEDS, GET_CATEGORY, GET_CUSTOMER_ADDRESSES, GET_CUSTOMER_HOME_SLIDER_MY_PRODUCTS, GET_CUSTOMER_ID, GET_CUSTOMER_ORDERS, GET_FAQS, GET_HOMEPAGE, GET_INVOICES, GET_LAYOUT, GET_ORDER_BY_BC_ID, GET_PAGE, GET_PAGES, GET_PAGE_CATEGORY, GET_PRODUCTS_STATIC_PATHS, GET_SITEMAP, LOGIN_MUTATION, MUTATION_CART_DELIVERY_DATE, MUTATION_CART_SYNC, fetchGraph, initializeApollo, useApollo

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ./api/rest/endpoints.ts
// import { getLocaleCountry } from '@dy/commons/utils'
// const NEXT_PUBLIC_LOCALE = process.env.NEXT_PUBLIC_LOCALE
// const localeCountry = getLocaleCountry(NEXT_PUBLIC_LOCALE)
// const LOCALE = localeCountry.split('-')[0]
// const REGION = localeCountry.split('-')[1]
// const DY_API_URL = `${process.env.DY_API}/${REGION}/${LOCALE}`
var DY_API_URL = "https://".concat("cms.mammafiore.eu", "/api/v1");
var STORE_HASH = "";
var endpoints = {
    "layout": function() {
        return "".concat(DY_API_URL, "/layout.json");
    },
    "search": function(query) {
        return "".concat(DY_API_URL, "/search?q=").concat(query.q);
    },
    "search-products": function(query) {
        return "".concat(DY_API_URL, "/products/search?q=").concat(query.q);
    },
    "home": function() {
        return "".concat(DY_API_URL, "/pages/home.json");
    },
    "categories": function() {
        return "".concat(DY_API_URL, "/categories/product.json");
    },
    "category": function(query) {
        return "".concat(DY_API_URL, "/categories/product/").concat(query.slug, ".json");
    },
    "products": function() {
        return "".concat(DY_API_URL, "/products.json");
    },
    "product": function(query) {
        return "".concat(DY_API_URL, "/products/").concat(query.slug, ".json");
    },
    "relateds": function(query) {
        return "".concat(DY_API_URL, "/products/").concat(query.slug, "/related.json");
    },
    "faqs": function() {
        return "".concat(DY_API_URL, "/faqs.json");
    },
    "pages": function() {
        return "".concat(DY_API_URL, "/pages.json");
    },
    "page": function(query) {
        return "".concat(DY_API_URL, "/pages/").concat(query.slug, ".json");
    },
    "user-usual-purchases": function(query) {
        return "".concat(DY_API_URL, "/customers/").concat(query.customerId, "/products");
    },
    "brand": function(query) {
        return "".concat(DY_API_URL, "/brands/").concat(query.slug);
    },
    "brands": function() {
        return "".concat(DY_API_URL, "/brands/");
    },
    "brand-categories": function(query) {
        return "".concat(DY_API_URL, "/brands/").concat(query.slug, "/categories/");
    },
    "brand-category": function(query) {
        return "".concat(DY_API_URL, "/brands/").concat(query.slug, "/categories/").concat(query.categorySlug);
    },
    "download-customer-invoice-pdf": function(query) {
        return "".concat(DY_API_URL, "/invoices/pdf/").concat(query.slug);
    },
    "checkout-url": function(query) {
        return "https://api.bigcommerce.com/stores/".concat(STORE_HASH, "/v3/carts/").concat(query.cartId, "/redirect_urls");
    }
};

;// CONCATENATED MODULE: ./api/rest/fetchMethod.ts





// Any body that you want to add to your request: this can be a Blob, an ArrayBuffer, a TypedArray, a DataView, a FormData, a URLSearchParams, string object or literal
var defaultOptions = {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: null
};
var fetchAPI = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(endpointNamespace) {
        var query, fetchOptions, url, options, _body, body, res, _, file, data;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, fetchOptions = _arguments.length > 2 ? _arguments[2] : void 0;
                    if (!endpointNamespace || !endpoints[endpointNamespace]) {
                        throw new Error("No endpoint with namespace: '".concat(endpointNamespace, "'"));
                    }
                    url = endpoints[endpointNamespace](query);
                    options = !fetchOptions ? defaultOptions : (0,_object_spread/* default */.Z)({}, defaultOptions, fetchOptions);
                    body = (_body = options.body) !== null && _body !== void 0 ? _body : null;
                    return [
                        4,
                        fetch(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            body: body
                        }))
                    ];
                case 1:
                    res = _state.sent();
                    _ = res.status;
                    switch(_){
                        case 204:
                            return [
                                3,
                                2
                            ];
                        case 201:
                            return [
                                3,
                                3
                            ];
                        case 200:
                            return [
                                3,
                                3
                            ];
                        case 401:
                            return [
                                3,
                                7
                            ];
                        case 404:
                            return [
                                3,
                                8
                            ];
                        case 422:
                            return [
                                3,
                                9
                            ];
                        case 500:
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        11
                    ];
                case 2:
                    return [
                        2,
                        res
                    ];
                case 3:
                    if (false) {}
                    if (!(endpointNamespace.indexOf("download") !== -1)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        res.blob()
                    ];
                case 4:
                    file = _state.sent();
                    return [
                        2,
                        file
                    ];
                case 5:
                    return [
                        4,
                        res.json()
                    ];
                case 6:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
                case 7:
                    console.info("\uD83D\uDC6E\uD83C\uDFFB‍♂️⛔️ Unauthorized");
                    return [
                        2,
                        res
                    ];
                case 8:
                    throw new Error("DY API | 404 (Not found) for endpoint: ".concat(endpointNamespace));
                case 9:
                    console.log("DY API | 422 (Unprocessable Entity) for endpoint: ".concat(endpointNamespace));
                    return [
                        2,
                        res
                    ];
                case 10:
                    throw new Error("DY API | 500 - Some server error to check");
                case 11:
                    throw new Error("DY API | ".concat(res.status, " - Something went wrong with the fetch"));
                case 12:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchAPI(endpointNamespace) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./api/graphql/index.ts + 6 modules
var graphql = __webpack_require__(37953);
;// CONCATENATED MODULE: ./api/index.ts




/***/ }),

/***/ 95482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ ProductListItem; },
/* harmony export */   "vk": function() { return /* binding */ SectionAccount; },
/* harmony export */   "xI": function() { return /* binding */ CardListItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column: 1 / span 6;\n  margin: ",
        " 0;\n  padding: 0;\n\n  ",
        " {\n    grid-column: 4 / span 8;\n    margin: 0;\n  }\n\n  h2 {\n    color: ",
        ";\n  }\n\n  p {\n    ",
        "\n    color: ",
        ";\n    margin-bottom:",
        ";\n\n    ",
        " {\n      margin-bottom:",
        ";\n    }\n\n    ",
        " {\n      margin-bottom:",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    border-radius: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    margin-bottom: 30px;\n  }\n\n  > ul {\n    display: flex;\n  }\n\n  .mobile {\n    display: block;\n\n    ",
        " {\n      display: none;\n    }\n\n    .products_mobile {\n      display:flex;\n      flex-direction: column;\n      padding: ",
        " ",
        ";\n\n      ",
        " {\n        padding: ",
        " ",
        ";\n      }\n\n      ",
        " {\n        display:none;\n      }\n    }\n\n  }\n\n  .desktop {\n    display: none;\n\n    ",
        " {\n      display: block;\n    }\n  }\n\n  .headline_mobile {\n    ",
        "\n    color: ",
        ";\n    padding: ",
        "  ",
        "  ",
        ";\n    &:first-child {\n      margin-bottom:0;\n    }\n  }\n\n  .icon__mobile {\n    /* display:inline;\n    position: relative;\n    top: ",
        ";\n    left: calc(100% - ",
        "); */\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    gap: 30px;\n\n    > a {\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      min-height: 100px;\n      min-width: 100px;\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n      }\n    }\n\n\n  }\n\n  .overview {\n    border-bottom: none;\n    padding: ",
        " ",
        ";\n    width:100%;\n\n    ",
        " {\n      padding: ",
        " ",
        ";\n    }\n\n    ",
        " {\n      border-bottom: 1px solid ",
        ";\n      display: flex;\n      justify-content:space-between;\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 12px 40px 15px;\n    }\n\n    &.mobile {\n      display: block;\n\n      > button {\n        margin: 20px 0 0;\n        position: relative;\n        z-index:40;\n\n      }\n      ",
        " {\n        display: none;\n      }\n    }\n\n    &.desktop {\n      display: none;\n\n      ",
        " {\n        display: flex;\n      }\n    }\n\n    &.order {\n      display:none;\n\n      ",
        " {\n        display: block;\n        padding: ",
        " 0 ",
        ";\n      }\n\n      ",
        " {\n        padding: 12px 0 15px;\n      }\n    }\n\n    tr, td {\n      ",
        "\n      color: ",
        ";\n      margin-bottom: ",
        ";\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        ",
        "\n        margin-bottom: 0;\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 200px;\n      }\n\n      &.headline.mobile {\n        padding: ",
        " 0;\n\n        ",
        " {\n          padding: ",
        " 0;\n        }\n\n        ",
        " {\n          padding: 0;\n        }\n      }\n    }\n\n    td:last-child {\n      width: unset;\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 53px;\n      }\n    }\n\n    > span {\n      ",
        "\n      display: block;\n      padding-left:0;\n\n      &:first-of-type {\n        ",
        " {\n          padding-left: 0;\n        }\n      }\n\n       > span:last-of-type {\n        display: inline;\n        padding-left: ",
        ";\n\n        ",
        " {\n          padding-left: ",
        ";\n        }\n\n        ",
        " {\n          display: block;\n          padding-left: 0;\n        }\n      }\n    }\n  }\n\n  .main-info {\n    display: grid;\n    grid-template-columns: 1fr;\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      grid-template-columns: ",
        " 1fr;\n      grid-column-gap: ",
        ";\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      grid-template-columns: 500px 1fr;\n      grid-column-gap: 115px;\n      padding: 30px 40px 40px;\n    }\n    > button {\n      margin-top: ",
        ";\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 60px;\n      }\n    }\n    .products_desktop {\n      display:none;\n      ",
        " {\n        display:grid;\n        grid-area: 1 / 1 / span 1 / span 1;\n      }\n    }\n\n  \n    .headline {\n      ",
        "\n      color: ",
        ";\n      display:none;\n\n      ",
        " {\n        display:block;\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 34px;\n      }\n    }\n\n    .cta {\n      display:none;\n\n      ",
        " {\n        display:block;\n        a:not(button > div > a ) {\n          ",
        "\n          color: ",
        ";\n          display:block;\n          text-align: center;\n        }\n\n        > button {\n          width: 100%;\n          margin: 0 0 ",
        " 0;\n        }\n      }\n\n      ",
        " {\n        > button {\n          margin: 0 0 30px 0;\n        }\n      }\n    }\n\n    .invoice {\n      display:block;\n      padding: ",
        " ",
        ";\n\n      ",
        " {\n        padding: ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 0;\n      }\n\n      > button {\n        margin: auto 0;\n      }\n    }\n  }\n\n  .detail {\n    color: ",
        ";\n    padding: ",
        ";\n\n    ",
        " {\n      padding: ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 12px 20px 15px;\n    }\n\n    h1 {\n      ",
        ";\n      text-align:left;\n      margin: ",
        " 0;\n\n      ",
        " {\n        margin: ",
        " 0;\n      }\n\n      ",
        " {\n        margin: ",
        " 0;\n      }\n\n      ",
        " {\n        margin: 20px 0;\n      }\n    }\n\n  }\n  .mobile {\n    display: block;\n\n    ",
        " {\n      display: none;\n    }\n  }\n  .order_title {\n    border-bottom: 1px solid ",
        ";\n    padding: ",
        ";\n\n    ",
        " {\n      padding: ",
        ";\n    }\n\n    ",
        " {\n      padding:",
        ";\n    }\n\n    ",
        " {\n      padding: 20px;\n    }\n\n    h1 {\n      ",
        ";\n      text-align:left;\n    }\n  }\n\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-start;\n  display: grid;\n  column-gap: ",
        ";\n  grid-template-columns: min-content ",
        " auto;\n  margin-bottom: ",
        ";\n  padding-bottom: ",
        ";\n\n  ",
        " {\n    column-gap: ",
        ";\n    grid-template-columns: min-content ",
        " auto;\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n\n  }\n\n  ",
        " {\n    align-items: flex-start;\n    display: grid;\n    column-gap: ",
        ";\n    grid-template-columns: min-content ",
        " auto;\n    margin-bottom: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  ",
        " {\n    column-gap: 20px;\n    grid-template-columns: min-content 221px auto;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n  }\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  figure {\n    position: relative;\n    height: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 55px;\n      width: 55px;\n    }\n\n    &.placeholder {\n      background-color: rgba(0, 0, 0, .15);\n    }\n  }\n\n  span {\n    ",
        "\n    color: ",
        ";\n    display: block;\n  }\n\n  button {\n    ",
        "\n    color: ",
        ";\n    \n    &:disabled {\n      opacity: .5;\n      pointer-events: none;\n      user-select: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var SectionAccount = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].section.withConfig({
    displayName: "sharedAccountStyles__SectionAccount",
    componentId: "sc-a0ac14aa-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(60, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP26_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"));
var CardListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].li.withConfig({
    displayName: "sharedAccountStyles__CardListItem",
    componentId: "sc-a0ac14aa-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP26_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(0, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(45, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(13, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(8, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.hex2Rgba)(theme.colors.darkred, .1);
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(12, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(15, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(12, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(15, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP15_1B)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(5, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(5, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP12_1)(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(200, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(53, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP12_1)(), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(3, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(3, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(445, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(115, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(40, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(60, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP26_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(34, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP15_1B)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(10, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(12, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(15, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP26_1)(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.hex2Rgba)(theme.colors.darkred, .1);
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(30, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP26_1)());
var ProductListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].li.withConfig({
    displayName: "sharedAccountStyles__ProductListItem",
    componentId: "sc-a0ac14aa-2"
})(_templateObject2(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(100, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(100, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(221, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.hex2Rgba)(theme.colors.darkred, .1);
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.vw)(55, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP12_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_1__.getP15_1B)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});


/***/ }),

/***/ 31112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ NewCartItemsContext; },
/* harmony export */   "o": function() { return /* binding */ AddToCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33379);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90260);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88241);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92757);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _dy_commons_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7693);
/* harmony import */ var _dy_commons_context__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_context__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95163);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2722);

















var NewCartItemsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var getBoxCount = function(param) {
    var isBox = param.isBox, unitCount = param.unitCount, qtyPerBox = param.qtyPerBox;
    return isBox && typeof qtyPerBox === "number" ? Math.floor(unitCount / qtyPerBox) : unitCount;
};
var ButtonDelete = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var unitCount = param.unitCount, minSaleUnits = param.minSaleUnits, isPDP = param.isPDP, onClick = param.onClick, onClickBin = param.onClickBin, _frozen = param.frozen, frozen = _frozen === void 0 ? false : _frozen, isBox = param.isBox, cartLinesQuantity = param.cartLinesQuantity, qtyPerBox = param.qtyPerBox;
    var ref = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useDeviceType)(), isMobile = ref.isMobile, size = ref.size;
    var animate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isPDP ? "expandedPDP" : size.width >= 603 && size.width < 768 ? "expandedNexus" : isMobile ? "expandedMobile" : size.width >= 1650 ? "expandedWide" : "expandedDesktop";
    }, [
        isMobile,
        isPDP,
        size.width
    ]);
    var boxCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return getBoxCount({
            isBox: isBox,
            unitCount: unitCount,
            qtyPerBox: qtyPerBox
        });
    }, [
        unitCount,
        qtyPerBox,
        isBox
    ]);
    var initialAndExit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isPDP ? "collapsedPDP" : "collapsed";
    }, [
        isPDP
    ]);
    var showBin = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (isBox ? boxCount : unitCount) === (isBox ? 1 : minSaleUnits);
    }, [
        isBox,
        boxCount,
        unitCount,
        minSaleUnits
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div, {
        className: "btn-bin",
        initial: initialAndExit,
        variants: _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.deleteVariants,
        exit: initialAndExit,
        animate: animate,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
            circle: true,
            noHoverEffect: true,
            bgType: frozen ? "frozen" : "red",
            onClick: function() {
                isBox ? cartLinesQuantity === qtyPerBox ? onClickBin() : onClick(false) : unitCount === minSaleUnits ? onClickBin() : onClick(false);
            },
            name: "Remove unit",
            initial: "collapsed",
            variants: _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.deleteButtonVariants,
            animate: "expanded",
            exit: "collapsed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.figure */ .E.figure, {
                    initial: "binCollapsed",
                    variants: _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.figureVariants,
                    animate: showBin ? "fadeIn" : (isBox ? boxCount : unitCount) === (isBox ? qtyPerBox : minSaleUnits) ? "binExpanded" : "fadeOut",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/svg/btn-bin.svg",
                        alt: "Icon bin",
                        width: "16",
                        height: "19"
                    })
                }, "one-".concat(unitCount === minSaleUnits)),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.figure */ .E.figure, {
                    initial: {
                        opacity: 0,
                        scale: 0,
                        rotate: 0
                    },
                    animate: (isBox ? boxCount : unitCount) > (isBox ? 1 : minSaleUnits) ? {
                        opacity: 1,
                        scale: 1,
                        rotate: 0
                    } : {
                        opacity: 0,
                        scale: 0,
                        rotate: 90
                    },
                    transition: {
                        duration: .3
                    },
                    exit: {
                        opacity: 0,
                        rotate: 90
                    },
                    className: "figure-minus",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/svg/btn-minus.svg",
                        alt: "Icon minus sign",
                        width: "20",
                        height: "3",
                        className: "img-minus"
                    })
                }, "two-".concat((isBox ? boxCount : unitCount) > (isBox ? 1 : minSaleUnits)))
            ]
        })
    });
});
var AddButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className, frozen = param.frozen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div, {
        className: className,
        initial: "collapsed",
        variants: _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.defaultVariants,
        exit: "collapsed",
        animate: "expanded",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
            circle: true,
            bgType: frozen ? "frozen" : "red",
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/svg/btn-sign-icon.svg",
                    alt: "Icon add to cart",
                    width: "16",
                    height: "16"
                })
            })
        })
    });
});
function checkIfEnoughStock(param) {
    var stock = param.stock, minSaleUnits = param.minSaleUnits, qtyPerBox = param.qtyPerBox, unitCount = param.unitCount, isBox = param.isBox;
    var soldByBox = minSaleUnits === 1 && qtyPerBox > 1;
    // const soldByMinSaleUnits = minSaleUnits > 1 && qtyPerBox >= 1
    // const soldByUnit = minSaleUnits === 1 && qtyPerBox === 1
    if (isBox && soldByBox) return stock >= unitCount + qtyPerBox;
    return stock >= unitCount + minSaleUnits;
}
function getUpdatedStock(param) {
    var variant = param.variant, cartLine = param.cartLine;
    var ref;
    if (typeof (cartLine === null || cartLine === void 0 ? void 0 : (ref = cartLine.variant) === null || ref === void 0 ? void 0 : ref.stock) === "number") return cartLine.variant.stock;
    return typeof (variant === null || variant === void 0 ? void 0 : variant.stock) === "number" ? variant.stock : 0;
}
var AddToCart = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var data = param.data, _setHasUnitsInCart = param.setHasUnitsInCart, setHasUnitsInCart = _setHasUnitsInCart === void 0 ? null : _setHasUnitsInCart, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, _isCart = param.isCart, isCart = _isCart === void 0 ? false : _isCart, _displayStockWarning = param.displayStockWarning, displayStockWarning = _displayStockWarning === void 0 ? false : _displayStockWarning, _notAvailable = param.notAvailable, notAvailable = _notAvailable === void 0 ? false : _notAvailable, _inventoryTracking = param.inventoryTracking, inventoryTracking = _inventoryTracking === void 0 ? null : _inventoryTracking, _frozen = param.frozen, frozen = _frozen === void 0 ? false : _frozen, _shouldTriggerHowToBuyModal = param.shouldTriggerHowToBuyModal, shouldTriggerHowToBuyModal = _shouldTriggerHowToBuyModal === void 0 ? true : _shouldTriggerHowToBuyModal, _isBox = param.isBox, isBox = _isBox === void 0 ? false : _isBox;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var variant = data.variant;
    // Our react cart Context
    var ref = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useCart)(), cartLines = ref.cartLines, addToCart = ref.addToCart, removeFromCart = ref.removeFromCart, bulkUpdateCart = ref.bulkUpdateCart, isFrozenCart = ref.isFrozenCart;
    var existingLineItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return cartLines.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.id) === variant.id;
        });
    }, [
        cartLines,
        variant
    ]);
    var stock = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return getUpdatedStock({
            variant: variant,
            cartLine: existingLineItem
        });
    }, [
        variant,
        existingLineItem
    ]);
    // const stock2 = useMemo(() => !existingLineItem ? stock : existingLineItem.stock, [stock])
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), locale = ref1.locale, pathname = ref1.pathname, push = ref1.push;
    var t = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useTranslator */ .I4)().t;
    var ref2 = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useDeviceType)(), isMobile = ref2.isMobile, size = ref2.size;
    // const { toggle:openModalPublicInterested } = useModal(MODALS.PUBLIC_INTERESTED)
    var ref3 = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useModal)(_dy_commons_context__WEBPACK_IMPORTED_MODULE_5__.MODALS.AUTH), openModalAuth = ref3.toggle;
    var ref4 = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useModal)(_dy_commons_context__WEBPACK_IMPORTED_MODULE_5__.MODALS.COMERCIAL), openModalComercial = ref4.toggle;
    var ref5 = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useModal)(_dy_commons_context__WEBPACK_IMPORTED_MODULE_5__.MODALS.CART_TYPE), openModalCartType = ref5.toggle;
    var ref6 = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useActiveVariant */ .wT)(), cardSelected = ref6.cardSelected, removeActiveVariant = ref6.removeActiveVariant;
    var customer = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCustomer */ .ON)().customer;
    var addToast = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_4__.useToast)().addToast;
    var minSaleUnits = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return typeof (variant === null || variant === void 0 ? void 0 : variant.minSaleUnits) !== "number" ? 1 : variant.minSaleUnits;
    }, [
        variant
    ]);
    var qtyPerBox = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return typeof (variant === null || variant === void 0 ? void 0 : variant.qtyPerBox) !== "number" ? 1 : variant.qtyPerBox;
    }, [
        variant
    ]);
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), inputUnitsValue = ref7[0], setInputUnitsValue = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), unitCount = ref8[0], setUnitCount = ref8[1];
    var boxCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return getBoxCount({
            isBox: isBox,
            unitCount: unitCount,
            qtyPerBox: qtyPerBox
        });
    }, [
        isBox,
        unitCount,
        qtyPerBox
    ]);
    var productCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isBox ? boxCount : unitCount;
    }, [
        isBox,
        boxCount,
        unitCount
    ]);
    var enoughStock = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return checkIfEnoughStock({
            qtyPerBox: qtyPerBox,
            minSaleUnits: minSaleUnits,
            stock: stock,
            unitCount: unitCount,
            isBox: isBox
        });
    }, [
        qtyPerBox,
        minSaleUnits,
        stock,
        isBox,
        unitCount
    ]);
    // Grouping clicks to trigger less CMS API request
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), clickTimestamp = ref9[0], setClickTimestamp = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), timeoutId = ref10[0], setTimeoutId = ref10[1];
    var isPrivate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.getPathnameType)(pathname) === "private";
    }, [
        pathname
    ]);
    var animate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isPDP ? "expandedPDP" : size.width >= 603 && size.width < 768 ? "expandedNexus" : isMobile ? "expandedMobile" : size.width >= 1650 ? "expandedWide" : "expandedDesktop";
    }, [
        isMobile,
        isPDP,
        size.width
    ]);
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), backToSingleUnit = ref11[0], setBackToSingleUnit = ref11[1];
    var setCartItems = ((0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NewCartItemsContext) || {}).setCartItems;
    // graphQL mutations
    var ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)(_api__WEBPACK_IMPORTED_MODULE_6__/* .CUSTOMER_ADD_TO_CART */ .XN, {
        fetchPolicy: "no-cache"
    }), 2), cartLinesAdd = ref12[0], ref13 = ref12[1], dataAfterAdd = ref13.data;
    var ref14 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)(_api__WEBPACK_IMPORTED_MODULE_6__/* .CUSTOMER_UPDATE_CART_ITEM */ .Iu, {
        fetchPolicy: "no-cache",
        update: function(cache) {
            // Read the data from the cache for the relevant query
            // const cachedData: { customer: TypeCart['customer'] } | null = cache.readQuery({ query: GET_CART })
            var cachedData = null;
            if (cache) cachedData = cache.readQuery({
                query: _api__WEBPACK_IMPORTED_MODULE_6__/* .GET_CART */ .bG
            });
            // console.log('⭕️ cache', cache)
            console.log("⭕️⭕️ cD", cachedData);
        // console.log('⭕️ cartLinesUpdate', cartLinesUpdate)
        // // Check if cachedData and customer are not null before accessing properties
        // if (cachedData && cachedData.customer && cachedData.customer.cart) {
        //   // Update cart properties with the mutation response
        //   cachedData.customer.cart = { ...cachedData.customer.cart, ...cartLinesUpdate.cart }
        //   // Write the updated data back to the cache
        //   cache.writeQuery({
        //     query: GET_CART,
        //     data: { customer: { ...cachedData.customer } },
        //   })
        // } else if (!cachedData) {
        //   cache.writeQuery({
        //     query: GET_CART,
        //     data: { customer: { cart: { ...cartLinesUpdate.cart, boughtTogether: [] }}}
        //   })
        // }
        }
    }), 2), cartLinesUpdate = ref14[0], ref15 = ref14[1], dataAfterUpdate = ref15.data;
    var ref16 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)(_api__WEBPACK_IMPORTED_MODULE_6__/* .CUSTOMER_DELETE_FROM_CART */ .PO), 2), cartLinesDelete = ref16[0], ref17 = ref16[1], dataAfterDelete = ref17.data;
    var onInputUnitsChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        setInputUnitsValue(e.target.value);
    }, [
        setInputUnitsValue
    ]);
    // ⚠️ NEW INPUT UNITS
    var getValidValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(unitCountValue, stock) {
        var notification = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var minUnits = isBox ? qtyPerBox : minSaleUnits;
        var numb = Number(unitCountValue) ? isBox ? Number(unitCountValue) * qtyPerBox : Number(unitCountValue) : minUnits;
        if (numb > stock) {
            numb = stock;
            if (notification) {
                addToast({
                    message: (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.getDynamicText)(t("product_page.adjusted_stock"), {
                        units: numb
                    }),
                    type: "info"
                });
            }
        }
        if (numb % minUnits === 0) return numb;
        else {
            // Find the nearest lower multiple of minUnits
            var lowerMultiple = Math.floor(numb / minUnits) * minUnits;
            // Find the nearest higher multiple of minUnits
            var higherMultiple = lowerMultiple + minUnits;
            var validMultiple = null;
            // Determine which multiple is closer to units
            if (numb - lowerMultiple < higherMultiple - numb) {
                validMultiple = lowerMultiple;
            } else {
                validMultiple = higherMultiple;
            }
            if (validMultiple === 0 && higherMultiple <= stock) validMultiple = higherMultiple;
            if (notification) {
                addToast({
                    message: (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.getDynamicText)(t("product_page.adjusted_units"), {
                        units: validMultiple
                    }),
                    type: "info"
                });
            }
            return validMultiple;
        }
    }, [
        addToast,
        t,
        isBox,
        qtyPerBox,
        minSaleUnits
    ]);
    var updateUnit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var increase, customValue, initialInputValue, variantId, incomingValue, remainder, remainder1, incomingLineItem, now, newTimeoutId;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            increase = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : true, customValue = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
            // First check if it's a valid cart type
            if (cartLines.length > 0 && (isFrozenCart && !frozen || !isFrozenCart && frozen)) {
                openModalCartType();
                return [
                    2
                ];
            }
            initialInputValue = inputUnitsValue;
            variantId = variant.id;
            incomingValue = customValue ? Number(inputUnitsValue) + (isBox ? unitCount : 0) : 0;
            if (!customValue) {
                if (!increase) {
                    if (isBox) {
                        incomingValue = inputUnitsValue - qtyPerBox;
                    } else {
                        // if trying to delete the last allowed unit/box
                        if (inputUnitsValue <= 1 || minSaleUnits > 1 && inputUnitsValue <= minSaleUnits) incomingValue = 0;
                        else {
                            incomingValue = inputUnitsValue - minSaleUnits;
                        }
                    }
                } else {
                    if (isBox) {
                        remainder = inputUnitsValue % qtyPerBox;
                        incomingValue = (boxCount + 1) * qtyPerBox + remainder;
                    } else {
                        if (inputUnitsValue === 0) incomingValue = minSaleUnits;
                        else {
                            incomingValue = inputUnitsValue + minSaleUnits;
                        }
                    }
                }
            }
            if (inventoryTracking && incomingValue > stock) {
                remainder1 = stock % (isBox ? qtyPerBox : minSaleUnits);
                incomingValue = stock - remainder1;
            }
            setBackToSingleUnit(incomingValue === (isBox ? qtyPerBox : minSaleUnits));
            setHasUnitsInCart && setHasUnitsInCart(incomingValue > 0);
            setUnitCount(incomingValue);
            setInputUnitsValue(incomingValue);
            incomingLineItem = null;
            if (typeof existingLineItem === "object") {
                incomingLineItem = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, existingLineItem);
                incomingLineItem.quantity = incomingValue;
            }
            now = Date.now();
            if (timeoutId && now - clickTimestamp < 900) clearTimeout(timeoutId);
            newTimeoutId = setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
                var DYCustomerToken, mutationData;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            DYCustomerToken = _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.cookie.get("DY_CUSTOMER_TOKEN");
                            mutationData = {
                                variables: {
                                    variantId: variantId,
                                    quantity: incomingValue,
                                    cartLineType: _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.CART_LINE_TYPE.PHYSICAL
                                },
                                context: {
                                    isPrivatePath: true,
                                    DYCustomerToken: DYCustomerToken
                                }
                            };
                            if (!(increase && (!existingLineItem || (existingLineItem === null || existingLineItem === void 0 ? void 0 : existingLineItem.quantity) === 0) && incomingValue / minSaleUnits === 1)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                cartLinesAdd(mutationData).catch(function(error) {
                                    console.warn("Error with mutation: cartLinesAdd:", error);
                                    setUnitCount(initialInputValue);
                                    setInputUnitsValue(initialInputValue);
                                })
                            ];
                        case 1:
                            _state.sent();
                            (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.pushAnalyticsEvent)("add_to_cart", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, data), {
                                variant: variant,
                                units: incomingValue
                            }));
                            return [
                                3,
                                6
                            ];
                        case 2:
                            if (!(!increase && incomingValue === 0)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                cartLinesDelete(mutationData).catch(function(error) {
                                    console.warn("Error with mutation: cartLinesDelete:", error);
                                    setUnitCount(initialInputValue);
                                    setInputUnitsValue(initialInputValue);
                                })
                            ];
                        case 3:
                            _state.sent();
                            (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.pushAnalyticsEvent)("remove_from_cart", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, data), {
                                variant: variant,
                                units: incomingValue
                            }));
                            return [
                                3,
                                6
                            ];
                        case 4:
                            return [
                                4,
                                cartLinesUpdate(mutationData).catch(function(error) {
                                    console.warn("Error with mutation: cartLinesUpdate:", error);
                                    setUnitCount(initialInputValue);
                                    setInputUnitsValue(initialInputValue);
                                })
                            ];
                        case 5:
                            _state.sent();
                            (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.pushAnalyticsEvent)("add_to_cart", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, data), {
                                variant: variant,
                                units: incomingValue
                            }));
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            // End update CMS
            }), 900);
            setTimeoutId(newTimeoutId);
            setClickTimestamp(now);
            // End clicker
            // Update context
            if (incomingLineItem) {
                if (increase) addToCart(incomingLineItem);
                else removeFromCart(incomingLineItem);
            }
            return [
                2
            ];
        });
    }), [
        data,
        minSaleUnits,
        cartLines,
        addToCart,
        cartLinesAdd,
        cartLinesUpdate,
        cartLinesDelete,
        unitCount,
        removeFromCart,
        setHasUnitsInCart,
        variant,
        clickTimestamp,
        timeoutId,
        inputUnitsValue,
        stock,
        isBox,
        existingLineItem,
        frozen,
        isFrozenCart,
        openModalCartType,
        qtyPerBox,
        inventoryTracking,
        boxCount
    ]);
    var onInputUnitsKeyUp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (e.code === "Enter" || e.key === "Enter" || e.keyCode === 13) {
            console.log("Enter pressed ⤴️ !!!", inputUnitsValue);
            var val = getValidValue(inputUnitsValue, stock);
            e.target.value = val;
            updateUnit(true, true);
        }
    }, [
        updateUnit,
        inputUnitsValue,
        getValidValue,
        stock
    ]);
    var onBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        // Check if the new focused element is outside the wrapperRef
        if (!wrapperRef.current.contains(e.relatedTarget)) {
            setInputUnitsValue(productCount);
            e.target.value = productCount;
        }
    }, [
        productCount
    ]);
    var deleteCartLine = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            var variantId, DYCustomerToken;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                variantId = variant.id;
                setUnitCount(0);
                setInputUnitsValue(0);
                DYCustomerToken = _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.cookie.get("DY_CUSTOMER_TOKEN");
                try {
                    cartLinesDelete({
                        variables: {
                            variantId: variantId
                        },
                        context: {
                            isPrivatePath: true,
                            DYCustomerToken: DYCustomerToken
                        }
                    });
                // deleteFromCart(variantId)
                } catch (e) {
                    console.warn("cartLinesDelete catch: ", e);
                }
                return [
                    2
                ];
            });
        });
        return function deleteCartLine() {
            return _ref.apply(this, arguments);
        };
    }();
    // Check if variant product exist in the cart and update it's quantity
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var item = Array.isArray(cartLines) ? cartLines.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.id) === variant.id;
        }) : false;
        if (item) {
            setUnitCount(item.quantity);
            setInputUnitsValue(item.quantity);
            setBackToSingleUnit(variant.minSaleUnits === item.quantity);
            setHasUnitsInCart && setHasUnitsInCart(item.quantity > 0);
        // PENDING setHasUnitsInCartForBoxes
        } else {
            setUnitCount(0);
            setInputUnitsValue(0);
            setBackToSingleUnit(false);
            setHasUnitsInCart && setHasUnitsInCart(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartLines,
        variant.id,
        variant.minSaleUnits
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!dataAfterAdd) return;
        var cartRes = dataAfterAdd === null || dataAfterAdd === void 0 ? void 0 : (ref = dataAfterAdd.cartLinesAdd) === null || ref === void 0 ? void 0 : ref.cart;
        if (Array.isArray(cartRes === null || cartRes === void 0 ? void 0 : cartRes.cartLines)) {
            var newItemCart = cartRes.cartLines.find(function(item) {
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.id) === (variant === null || variant === void 0 ? void 0 : variant.id);
            });
            if (typeof newItemCart === "object") {
                setCartItems && setCartItems(function(prevValue) {
                    var prevArray = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(prevValue);
                    var matchedCartItem = prevArray.indexOf(function(item) {
                        var ref, ref1;
                        return ((ref = item.variant) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = newItemCart.variant) === null || ref1 === void 0 ? void 0 : ref1.id);
                    });
                    if (matchedCartItem === -1) return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(prevValue).concat([
                        newItemCart
                    ]);
                    else {
                        prevArray[matchedCartItem] = newItemCart;
                        return prevArray;
                    }
                });
            }
        }
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterAdd", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterAdd
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!dataAfterUpdate) return;
        var cartRes = dataAfterUpdate === null || dataAfterUpdate === void 0 ? void 0 : (ref = dataAfterUpdate.cartLinesUpdate) === null || ref === void 0 ? void 0 : ref.cart;
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterUpdate", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterUpdate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!dataAfterDelete) return;
        var cartRes = dataAfterDelete === null || dataAfterDelete === void 0 ? void 0 : (ref = dataAfterDelete.cartLinesDelete) === null || ref === void 0 ? void 0 : ref.cart;
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterDelete", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterDelete
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Clean up the timeout when the component unmounts
        return function() {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        timeoutId
    ]);
    var redirectToPage = function() {
        var isPanettone = data.product.name.toLowerCase().includes("panettone");
        if (isPanettone) return;
        if (cardSelected) removeActiveVariant();
        if (locale === "de-DE") {
            push("/page/kontaktieren-sie-uns");
        } else if (locale === "pt-PT") {
            push("/page/contacte-nos");
        }
    };
    var ref18;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.ButtonWrapper, {
            ref: wrapperRef,
            className: "".concat(isPDP ? "is-pdp" : isCart ? "is-cart" : ""),
            children: [
                isPDP ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
                    className: "gtm_add-to-cart btn-add--pdp".concat(productCount > 0 ? " hide-initial-add" : "").concat(isPrivate && inventoryTracking && !enoughStock ? " no-stock" : notAvailable ? " not-available" : ""),
                    bgType: frozen ? "frozen" : "red",
                    onClick: isPrivate ? updateUnit : locale === "de-DE" || locale === "pt-PT" ? redirectToPage : shouldTriggerHowToBuyModal ? openModalComercial : null,
                    children: isPrivate ? t(!inventoryTracking || stock >= minSaleUnits ? "commons.actions.add_to_cart" : "product_page.product.no_stock") : t("commons.actions.how_to_buy")
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: isPrivate && inventoryTracking && productCount === 0 && (!enoughStock || notAvailable) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
                        className: "btn-add insufficient-stock ".concat(cardSelected ? "selected-card" : ""),
                        circle: cardSelected ? true : false,
                        bgType: "red",
                        disabled: true,
                        name: t("product_page.product.no_stock"),
                        children: cardSelected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/svg/btn-sign-icon.svg",
                                alt: "Icon add to cart",
                                width: "16",
                                height: "16"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: notAvailable ? t("product_page.product_main.not_available") : t("product_page.product.no_stock")
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: isPrivate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
                            className: "gtm_add-to-cart btn-add ".concat(!enoughStock && inventoryTracking ? " insufficient-stock" : ""),
                            circle: true,
                            bgType: frozen ? "frozen" : "red",
                            onClick: isPrivate ? updateUnit : _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.hasPrivateStore[locale] ? openModalAuth : openModalComercial,
                            name: t("commons.actions.add_to_cart"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/svg/btn-sign-icon.svg",
                                    alt: "Icon add to cart",
                                    width: "16",
                                    height: "16"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .AnimatePresence */ .M, {
                    mode: "wait",
                    children: productCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Counter, {
                                className: "counter ".concat(isPDP ? " is-pdp" : ""),
                                isPDP: isPDP,
                                initial: isPDP ? "collapsedPDP" : size.width >= 603 && size.width <= 768 ? "collapsedNexus" : isMobile ? "collapsedMobile" : size.width >= 1650 ? "collapsedWide" : "collapsedDesktop",
                                variants: _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.counterVariants,
                                exit: isPDP ? "collapsedPDP" : size.width >= 603 && size.width <= 768 ? "collapsedNexus" : isMobile ? "collapsedMobile" : size.width >= 1650 ? "collapsedWide" : "collapsedDesktop",
                                animate: animate,
                                $frozen: frozen,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Units, {
                                    className: "units",
                                    initial: {
                                        y: -15,
                                        opacity: 0
                                    },
                                    animate: {
                                        y: 0,
                                        opacity: 1
                                    },
                                    transition: {
                                        duration: .3
                                    },
                                    defaultValue: productCount,
                                    type: "text",
                                    pattern: "^([1-9][\\d]{0,5}|0)$",
                                    onChange: onInputUnitsChange,
                                    onKeyUp: onInputUnitsKeyUp,
                                    onBlur: onBlur
                                }, unitCount)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonDelete, {
                                unitCount: unitCount,
                                isPDP: isPDP,
                                backToSingleUnit: backToSingleUnit,
                                minSaleUnits: minSaleUnits,
                                onClick: updateUnit,
                                onClickBin: deleteCartLine,
                                frozen: frozen,
                                isBox: isBox,
                                cartLinesQuantity: (ref18 = existingLineItem === null || existingLineItem === void 0 ? void 0 : existingLineItem.quantity) !== null && ref18 !== void 0 ? ref18 : 0,
                                qtyPerBox: qtyPerBox
                            }),
                            isPDP && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddButton, {
                                className: "gtm_add-to-cart mini btn-add".concat(!enoughStock && inventoryTracking ? " insufficient-stock" : ""),
                                onClick: updateUnit,
                                frozen: frozen
                            })
                        ]
                    })
                }),
                displayStockWarning && customer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "last_units",
                    children: t("product_page.product.last_units")
                })
            ]
        })
    });
});


/***/ }),

/***/ 61969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o4": function() { return /* reexport */ AddToCart/* AddToCart */.o; },
  "d1": function() { return /* reexport */ CartItemsAll; },
  "GR": function() { return /* reexport */ CartItemsNew; },
  "AQ": function() { return /* reexport */ CartList; },
  "VD": function() { return /* reexport */ CartSummary; },
  "G9": function() { return /* reexport */ ModalSummary; },
  "K3": function() { return /* reexport */ AddToCart/* NewCartItemsContext */.K; },
  "W4": function() { return /* reexport */ RepeatOrder; },
  "Xz": function() { return /* reexport */ _Price; },
  "Di": function() { return /* reexport */ itemVariants; },
  "hg": function() { return /* reexport */ listVariants; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(88241);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ./components/account/sharedAccountStyles.ts
var sharedAccountStyles = __webpack_require__(95482);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ./api/graphql/index.ts + 6 modules
var graphql = __webpack_require__(37953);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/merge-class-names/dist/esm/index.js
function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
    return classList.concat(arg);
  }, []).filter(function (arg) {
    return typeof arg === 'string';
  }).join(' ');
}
// EXTERNAL MODULE: ../../node_modules/lodash.memoize/index.js
var lodash_memoize = __webpack_require__(17089);
var lodash_memoize_default = /*#__PURE__*/__webpack_require__.n(lodash_memoize);
;// CONCATENATED MODULE: ../../node_modules/get-user-locale/dist/esm/index.js


function resolver(options) {
  return JSON.stringify(options);
}

function uniqDefined(arr) {
  return arr.filter(function (el, index) {
    return el && arr.indexOf(el) === index;
  });
}

function normalizeLocales(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return splitEl[0] + "-" + splitEl[1].toUpperCase();
  });
}

function getUserLocalesInternal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$useFallbackLocal = _ref.useFallbackLocale,
      useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal,
      _ref$fallbackLocale = _ref.fallbackLocale,
      fallbackLocale = _ref$fallbackLocale === void 0 ? 'en-US' : _ref$fallbackLocale;

  var languageList = [];

  if (typeof window !== 'undefined') {
    var _window = window,
        navigator = _window.navigator;
    languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
  }

  if (useFallbackLocale) {
    languageList.push(fallbackLocale);
  }

  return normalizeLocales(uniqDefined(languageList));
}

var getUserLocales = lodash_memoize_default()(getUserLocalesInternal, resolver);

function getUserLocaleInternal(options) {
  return getUserLocales(options)[0] || null;
}

var getUserLocale = lodash_memoize_default()(getUserLocaleInternal, resolver);
/* harmony default export */ var esm = (getUserLocale);
;// CONCATENATED MODULE: ../../node_modules/@wojtekmaj/date-utils/dist/esm/index.js
/**
 * Utils
 */
function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) { offset = defaultOffset; }
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [getStart(date), getEnd(date)];
    };
}
/**
 * Simple getters - getting a property of a given point in time
 */
/**
 * Gets year from a given date.
 *
 * @param {DateLike} date Date to get year from
 * @returns {number} Year
 */
function getYear(date) {
    if (date instanceof Date) {
        return date.getFullYear();
    }
    if (typeof date === 'number') {
        return date;
    }
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) {
        return year;
    }
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
/**
 * Gets month from a given date.
 *
 * @param {Date} date Date to get month from
 * @returns {number} Month
 */
function getMonth(date) {
    if (date instanceof Date) {
        return date.getMonth();
    }
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
/**
 * Gets human-readable month from a given date.
 *
 * @param {Date} date Date to get human-readable month from
 * @returns {number} Human-readable month
 */
function getMonthHuman(date) {
    if (date instanceof Date) {
        return date.getMonth() + 1;
    }
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
/**
 * Gets day of the month from a given date.
 *
 * @param {Date} date Date to get day of the month from
 * @returns {number} Day of the month
 */
function getDate(date) {
    if (date instanceof Date) {
        return date.getDate();
    }
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
/**
 * Gets hours from a given date.
 *
 * @param {Date | string} date Date to get hours from
 * @returns {number} Hours
 */
function getHours(date) {
    if (date instanceof Date) {
        return date.getHours();
    }
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) {
                    return hours;
                }
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
/**
 * Gets minutes from a given date.
 *
 * @param {Date | string} date Date to get minutes from
 * @returns {number} Minutes
 */
function getMinutes(date) {
    if (date instanceof Date) {
        return date.getMinutes();
    }
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || '0';
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) {
                return minutes;
            }
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
/**
 * Gets seconds from a given date.
 *
 * @param {Date | string} date Date to get seconds from
 * @returns {number} Seconds
 */
function getSeconds(date) {
    if (date instanceof Date) {
        return date.getSeconds();
    }
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) {
                return seconds;
            }
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
/**
 * Gets milliseconds from a given date.
 *
 * @param {Date | string} date Date to get milliseconds from
 * @returns {number} Milliseconds
 */
function getMilliseconds(date) {
    if (date instanceof Date) {
        return date.getMilliseconds();
    }
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var millisecondsString = secondsWithMillisecondsString.split('.')[1] || '0';
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) {
                return milliseconds;
            }
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
/**
 * Century
 */
/**
 * Gets century start date from a given date.
 *
 * @param {DateLike} date Date to get century start from
 * @returns {Date} Century start date
 */
function getCenturyStart(date) {
    var year = getYear(date);
    var centuryStartYear = year + ((-year + 1) % 100);
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
/**
 * Gets previous century start date from a given date.
 *
 * @param {DateLike} date Date to get previous century start from
 * @returns {Date} Previous century start date
 */
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
/**
 * Gets next century start date from a given date.
 *
 * @param {DateLike} date Date to get next century start from
 * @returns {Date} Next century start date
 */
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
/**
 * Gets century end date from a given date.
 *
 * @param {DateLike} date Date to get century end from
 * @returns {Date} Century end date
 */
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
/**
 * Gets previous century end date from a given date.
 *
 * @param {DateLike} date Date to get previous century end from
 * @returns {Date} Previous century end date
 */
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
/**
 * Gets next century end date from a given date.
 *
 * @param {DateLike} date Date to get next century end from
 * @returns {Date} Next century end date
 */
var getNextCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, 100);
/**
 * Gets century start and end dates from a given date.
 *
 * @param {DateLike} date Date to get century start and end from
 * @returns {[Date, Date]} Century start and end dates
 */
var getCenturyRange = makeGetRange(getCenturyStart, getCenturyEnd);
/**
 * Decade
 */
/**
 * Gets decade start date from a given date.
 *
 * @param {DateLike} date Date to get decade start from
 * @returns {Date} Decade start date
 */
function getDecadeStart(date) {
    var year = getYear(date);
    var decadeStartYear = year + ((-year + 1) % 10);
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
/**
 * Gets previous decade start date from a given date.
 *
 * @param {DateLike} date Date to get previous decade start from
 * @returns {Date} Previous decade start date
 */
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
/**
 * Gets next decade start date from a given date.
 *
 * @param {DateLike} date Date to get next decade start from
 * @returns {Date} Next decade start date
 */
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
/**
 * Gets decade end date from a given date.
 *
 * @param {DateLike} date Date to get decade end from
 * @returns {Date} Decade end date
 */
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
/**
 * Gets previous decade end date from a given date.
 *
 * @param {DateLike} date Date to get previous decade end from
 * @returns {Date} Previous decade end date
 */
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
/**
 * Gets next decade end date from a given date.
 *
 * @param {DateLike} date Date to get next decade end from
 * @returns {Date} Next decade end date
 */
var getNextDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, 10);
/**
 * Gets decade start and end dates from a given date.
 *
 * @param {DateLike} date Date to get decade start and end from
 * @returns {[Date, Date]} Decade start and end dates
 */
var getDecadeRange = makeGetRange(getDecadeStart, getDecadeEnd);
/**
 * Year
 */
/**
 * Gets year start date from a given date.
 *
 * @param {DateLike} date Date to get year start from
 * @returns {Date} Year start date
 */
function getYearStart(date) {
    var year = getYear(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
/**
 * Gets previous year start date from a given date.
 *
 * @param {DateLike} date Date to get previous year start from
 * @returns {Date} Previous year start date
 */
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
/**
 * Gets next year start date from a given date.
 *
 * @param {DateLike} date Date to get next year start from
 * @returns {Date} Next year start date
 */
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
/**
 * Gets year end date from a given date.
 *
 * @param {DateLike} date Date to get year end from
 * @returns {Date} Year end date
 */
var getYearEnd = makeGetEnd(getNextYearStart);
/**
 * Gets previous year end date from a given date.
 *
 * @param {DateLike} date Date to get previous year end from
 * @returns {Date} Previous year end date
 */
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
/**
 * Gets next year end date from a given date.
 *
 * @param {DateLike} date Date to get next year end from
 * @returns {Date} Next year end date
 */
var getNextYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, 1);
/**
 * Gets year start and end dates from a given date.
 *
 * @param {DateLike} date Date to get year start and end from
 * @returns {[Date, Date]} Year start and end dates
 */
var getYearRange = makeGetRange(getYearStart, getYearEnd);
/**
 * Month
 */
function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) { offset = defaultOffset; }
        var year = getYear(date);
        var month = getMonth(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
/**
 * Gets month start date from a given date.
 *
 * @param {DateLike} date Date to get month start from
 * @returns {Date} Month start date
 */
function getMonthStart(date) {
    var year = getYear(date);
    var month = getMonth(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
/**
 * Gets previous month start date from a given date.
 *
 * @param {DateLike} date Date to get previous month start from
 * @returns {Date} Previous month start date
 */
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
/**
 * Gets next month start date from a given date.
 *
 * @param {DateLike} date Date to get next month start from
 * @returns {Date} Next month start date
 */
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
/**
 * Gets month end date from a given date.
 *
 * @param {DateLike} date Date to get month end from
 * @returns {Date} Month end date
 */
var getMonthEnd = makeGetEnd(getNextMonthStart);
/**
 * Gets previous month end date from a given date.
 *
 * @param {DateLike} date Date to get previous month end from
 * @returns {Date} Previous month end date
 */
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
/**
 * Gets next month end date from a given date.
 *
 * @param {DateLike} date Date to get next month end from
 * @returns {Date} Next month end date
 */
var getNextMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, 1);
/**
 * Gets month start and end dates from a given date.
 *
 * @param {DateLike} date Date to get month start and end from
 * @returns {[Date, Date]} Month start and end dates
 */
var getMonthRange = makeGetRange(getMonthStart, getMonthEnd);
/**
 * Day
 */
function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) { offset = defaultOffset; }
        var year = getYear(date);
        var month = getMonth(date);
        var day = getDate(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
/**
 * Gets day start date from a given date.
 *
 * @param {DateLike} date Date to get day start from
 * @returns {Date} Day start date
 */
function getDayStart(date) {
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
/**
 * Gets previous day start date from a given date.
 *
 * @param {DateLike} date Date to get previous day start from
 * @returns {Date} Previous day start date
 */
var getPreviousDayStart = makeGetEdgeOfNeighborDay(getDayStart, -1);
/**
 * Gets next day start date from a given date.
 *
 * @param {DateLike} date Date to get next day start from
 * @returns {Date} Next day start date
 */
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
/**
 * Gets day end date from a given date.
 *
 * @param {DateLike} date Date to get day end from
 * @returns {Date} Day end date
 */
var getDayEnd = makeGetEnd(getNextDayStart);
/**
 * Gets previous day end date from a given date.
 *
 * @param {DateLike} date Date to get previous day end from
 * @returns {Date} Previous day end date
 */
var getPreviousDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, -1);
/**
 * Gets next day end date from a given date.
 *
 * @param {DateLike} date Date to get next day end from
 * @returns {Date} Next day end date
 */
var getNextDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, 1);
/**
 * Gets day start and end dates from a given date.
 *
 * @param {DateLike} date Date to get day start and end from
 * @returns {[Date, Date]} Day start and end dates
 */
var getDayRange = makeGetRange(getDayStart, getDayEnd);
/**
 * Other
 */
/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date
 * @returns {number} Number of days in a month
 */
function getDaysInMonth(date) {
    return getDate(getMonthEnd(date));
}
function padStart(num, val) {
    if (val === void 0) { val = 2; }
    var numStr = "".concat(num);
    if (numStr.length >= val) {
        return num;
    }
    return "0000".concat(numStr).slice(-val);
}
/**
 * Returns local hours and minutes (hh:mm).
 *
 * @param {Date | string} date Date to get hours and minutes from
 * @returns {string} Local hours and minutes
 */
function getHoursMinutes(date) {
    var hours = padStart(getHours(date));
    var minutes = padStart(getMinutes(date));
    return "".concat(hours, ":").concat(minutes);
}
/**
 * Returns local hours, minutes and seconds (hh:mm:ss).
 *
 * @param {Date | string} date Date to get hours, minutes and seconds from
 * @returns {string} Local hours, minutes and seconds
 */
function getHoursMinutesSeconds(date) {
    var hours = padStart(getHours(date));
    var minutes = padStart(getMinutes(date));
    var seconds = padStart(getSeconds(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 *
 * @param {Date} date Date to get month in ISO-like format from
 * @returns {string} Local month in ISO-like format
 */
function getISOLocalMonth(date) {
    var year = padStart(getYear(date), 4);
    var month = padStart(getMonthHuman(date));
    return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 *
 * @param {Date} date Date to get date in ISO-like format from
 * @returns {string} Local date in ISO-like format
 */
function getISOLocalDate(date) {
    var year = padStart(getYear(date), 4);
    var month = padStart(getMonthHuman(date));
    var day = padStart(getDate(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
/**
 * Returns local date & time in ISO-like format (YYYY-MM-DDThh:mm:ss).
 *
 * @param {Date} date Date to get date & time in ISO-like format from
 * @returns {string} Local date & time in ISO-like format
 */
function getISOLocalDateTime(date) {
    return "".concat(getISOLocalDate(date), "T").concat(getHoursMinutesSeconds(date));
}

;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/shared/const.js
var _CALENDAR_TYPE_LOCALE;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CALENDAR_TYPES = {
  ARABIC: 'Arabic',
  HEBREW: 'Hebrew',
  ISO_8601: 'ISO 8601',
  US: 'US'
};
var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ['en-CA', 'en-US', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO', 'es-EC', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-SV', 'es-VE', 'pt-BR']), _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [// ar-LB, ar-MA intentionally missing
'ar', 'ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LY', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SY', 'ar-YE', 'dv', 'dv-MV', 'ps', 'ps-AR']), _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ['he', 'he-IL']), _CALENDAR_TYPE_LOCALE);
var WEEKDAYS = _toConsumableArray(Array(7)).map(function (el, index) {
  return index;
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/shared/dateFormatter.js

var formatterCache = new Map();

function getFormatter(options) {
  return function (locale, date) {
    var localeWithDefault = locale || esm();

    if (!formatterCache.has(localeWithDefault)) {
      formatterCache.set(localeWithDefault, new Map());
    }

    var formatterCacheLocale = formatterCache.get(localeWithDefault);

    if (!formatterCacheLocale.has(options)) {
      formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
    }

    return formatterCacheLocale.get(options)(date);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatDateOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var formatDayOptions = {
  day: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatYearOptions = {
  year: 'numeric'
};
var formatDate = getSafeFormatter(formatDateOptions);
var dateFormatter_formatDay = getSafeFormatter(formatDayOptions);
var dateFormatter_formatLongDate = getSafeFormatter(formatLongDateOptions);
var dateFormatter_formatMonth = getSafeFormatter(formatMonthOptions);
var dateFormatter_formatMonthYear = getSafeFormatter(formatMonthYearOptions);
var dateFormatter_formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
var dateFormatter_formatWeekday = getSafeFormatter(formatWeekdayOptions);
var dateFormatter_formatYear = getSafeFormatter(formatYearOptions);
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/shared/dates.js



var SUNDAY = WEEKDAYS[0];
var FRIDAY = WEEKDAYS[5];
var SATURDAY = WEEKDAYS[6];
/* Simple getters - getting a property of a given point in time */

function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();

  switch (calendarType) {
    case CALENDAR_TYPES.ISO_8601:
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;

    case CALENDAR_TYPES.ARABIC:
      return (weekday + 1) % 7;

    case CALENDAR_TYPES.HEBREW:
    case CALENDAR_TYPES.US:
      return weekday;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/**
 * Century
 */

function getBeginOfCenturyYear(date) {
  var beginOfCentury = getCenturyStart(date);
  return getYear(beginOfCentury);
}
/**
 * Decade
 */

function getBeginOfDecadeYear(date) {
  var beginOfDecade = getDecadeStart(date);
  return getYear(beginOfDecade);
}
/**
 * Week
 */

/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {string} calendarType Calendar type. Can be ISO 8601 or US.
 */

function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var year = getYear(date);
  var monthIndex = getMonth(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {string} calendarType Calendar type. Can be ISO 8601 or US.
 */

function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var calendarTypeForWeekNumber = calendarType === CALENDAR_TYPES.US ? CALENDAR_TYPES.US : CALENDAR_TYPES.ISO_8601;
  var beginOfWeek = getBeginOfWeek(date, calendarType);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek; // Look for the first week one that does not come after a given date

  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === CALENDAR_TYPES.ISO_8601 ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarType);
    year -= 1;
  } while (date < beginOfFirstWeek);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Others
 */

/**
 * Returns the beginning of a given range.
 *
 * @param {string} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyStart(date);

    case 'decade':
      return getDecadeStart(date);

    case 'year':
      return getYearStart(date);

    case 'month':
      return getMonthStart(date);

    case 'day':
      return getDayStart(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyStart(date);

    case 'decade':
      return getPreviousDecadeStart(date);

    case 'year':
      return getPreviousYearStart(date);

    case 'month':
      return getPreviousMonthStart(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getNextCenturyStart(date);

    case 'decade':
      return getNextDecadeStart(date);

    case 'year':
      return getNextYearStart(date);

    case 'month':
      return getNextMonthStart(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeStart(date, -100);

    case 'year':
      return getPreviousYearStart(date, -10);

    case 'month':
      return getPreviousMonthStart(date, -12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getNextDecadeStart(date, 100);

    case 'year':
      return getNextYearStart(date, 10);

    case 'month':
      return getNextMonthStart(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns the end of a given range.
 *
 * @param {string} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyEnd(date);

    case 'decade':
      return getDecadeEnd(date);

    case 'year':
      return getYearEnd(date);

    case 'month':
      return getMonthEnd(date);

    case 'day':
      return getDayEnd(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyEnd(date);

    case 'decade':
      return getPreviousDecadeEnd(date);

    case 'year':
      return getPreviousYearEnd(date);

    case 'month':
      return getPreviousMonthEnd(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeEnd(date, -100);

    case 'year':
      return getPreviousYearEnd(date, -10);

    case 'month':
      return getPreviousMonthEnd(date, -12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {string} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);

    case 'decade':
      return getDecadeRange(date);

    case 'year':
      return getYearRange(date);

    case 'month':
      return getMonthRange(date);

    case 'day':
      return getDayRange(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {string} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */

function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}

function toYearLabel(locale) {
  var formatYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dateFormatter_formatYear;
  var dates = arguments.length > 2 ? arguments[2] : undefined;
  return dates.map(function (date) {
    return formatYear(locale, date);
  }).join(' – ');
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getCenturyLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getCenturyRange(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */

function getDecadeLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getDecadeRange(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */

function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();

  switch (calendarType) {
    case CALENDAR_TYPES.ARABIC:
    case CALENDAR_TYPES.HEBREW:
      return weekday === FRIDAY || weekday === SATURDAY;

    case CALENDAR_TYPES.ISO_8601:
    case CALENDAR_TYPES.US:
      return weekday === SATURDAY || weekday === SUNDAY;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/shared/propTypes.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }



var calendarTypes = Object.values(CALENDAR_TYPES);
var allViews = ['century', 'decade', 'year', 'month'];
var isCalendarType = prop_types_default().oneOf(calendarTypes);
var isClassName = prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]);
var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (!minDate) {
    return null;
  }

  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var maxDate = props.maxDate;

  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }

  return null;
};
var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (!maxDate) {
    return null;
  }

  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var minDate = props.minDate;

  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }

  return null;
};
var isRef = prop_types_default().oneOfType([(prop_types_default()).func, prop_types_default().shape({
  current: (prop_types_default()).any
})]);
var isValue = prop_types_default().oneOfType([prop_types_default().instanceOf(Date), prop_types_default().arrayOf(prop_types_default().instanceOf(Date))]);
var isViews = prop_types_default().arrayOf(prop_types_default().oneOf(allViews));
var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews;

  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  } // Everything is fine


  return null;
};

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];

  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = {
  activeStartDate: prop_types_default().instanceOf(Date).isRequired,
  hover: prop_types_default().instanceOf(Date),
  locale: (prop_types_default()).string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: (prop_types_default()).func,
  onMouseOver: (prop_types_default()).func,
  tileClassName: prop_types_default().oneOfType([(prop_types_default()).func, isClassName]),
  tileContent: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).node]),
  value: isValue,
  valueType: (prop_types_default()).string
};
var tileProps = {
  activeStartDate: prop_types_default().instanceOf(Date).isRequired,
  classes: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
  date: prop_types_default().instanceOf(Date).isRequired,
  locale: (prop_types_default()).string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: (prop_types_default()).func,
  onMouseOver: (prop_types_default()).func,
  style: prop_types_default().objectOf(prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])),
  tileClassName: prop_types_default().oneOfType([(prop_types_default()).func, isClassName]),
  tileContent: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).node]),
  tileDisabled: (prop_types_default()).func
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/Calendar/Navigation.js






var className = 'react-calendar__navigation';
function Navigation(_ref) {
  var activeStartDate = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear = _ref$formatMonthYear === void 0 ? dateFormatter_formatMonthYear : _ref$formatMonthYear,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? dateFormatter_formatYear : _ref$formatYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$navigationAriaLa = _ref.navigationAriaLabel,
      navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa,
      navigationAriaLive = _ref.navigationAriaLive,
      navigationLabel = _ref.navigationLabel,
      _ref$next2AriaLabel = _ref.next2AriaLabel,
      next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel,
      _ref$next2Label = _ref.next2Label,
      next2Label = _ref$next2Label === void 0 ? '»' : _ref$next2Label,
      _ref$nextAriaLabel = _ref.nextAriaLabel,
      nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel,
      _ref$nextLabel = _ref.nextLabel,
      nextLabel = _ref$nextLabel === void 0 ? '›' : _ref$nextLabel,
      _ref$prev2AriaLabel = _ref.prev2AriaLabel,
      prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel,
      _ref$prev2Label = _ref.prev2Label,
      prev2Label = _ref$prev2Label === void 0 ? '«' : _ref$prev2Label,
      _ref$prevAriaLabel = _ref.prevAriaLabel,
      prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel,
      _ref$prevLabel = _ref.prevLabel,
      prevLabel = _ref$prevLabel === void 0 ? '‹' : _ref$prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      showDoubleView = _ref.showDoubleView,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = getBeginPrevious(view, activeStartDate);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginPrevious2(view, activeStartDate);
  var nextActiveStartDate = getBeginNext(view, activeStartDate);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginNext2(view, activeStartDate);

  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 0) {
      return true;
    }

    var previousActiveEndDate = getEndPrevious(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 0) {
      return true;
    }

    var previousActiveEndDate = getEndPrevious2(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;

  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate, 'prev');
  }

  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2, 'prev2');
  }

  function onClickNext() {
    setActiveStartDate(nextActiveStartDate, 'next');
  }

  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2, 'next2');
  }

  function renderLabel(date) {
    var label = function () {
      switch (view) {
        case 'century':
          return getCenturyLabel(locale, formatYear, date);

        case 'decade':
          return getDecadeLabel(locale, formatYear, date);

        case 'year':
          return formatYear(locale, date);

        case 'month':
          return formatMonthYear(locale, date);

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }();

    return navigationLabel ? navigationLabel({
      date: date,
      label: label,
      locale: locale || getUserLocale(),
      view: view
    }) : label;
  }

  function renderButton() {
    var labelClassName = "".concat(className, "__label");
    return /*#__PURE__*/react.createElement("button", {
      "aria-label": navigationAriaLabel,
      "aria-live": navigationAriaLive,
      className: labelClassName,
      disabled: !drillUpAvailable,
      onClick: drillUp,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, /*#__PURE__*/react.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
    }, renderLabel(activeStartDate)), showDoubleView && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
      className: "".concat(labelClassName, "__divider")
    }, " \u2013 "), /*#__PURE__*/react.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
    }, renderLabel(nextActiveStartDate))));
  }

  return /*#__PURE__*/react.createElement("div", {
    className: className
  }, prev2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/react.createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), prevLabel !== null && /*#__PURE__*/react.createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), renderButton(), nextLabel !== null && /*#__PURE__*/react.createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/react.createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}
Navigation.propTypes = {
  activeStartDate: prop_types_default().instanceOf(Date).isRequired,
  drillUp: (prop_types_default()).func.isRequired,
  formatMonthYear: (prop_types_default()).func,
  formatYear: (prop_types_default()).func,
  locale: (prop_types_default()).string,
  maxDate: prop_types_default().instanceOf(Date),
  minDate: prop_types_default().instanceOf(Date),
  navigationAriaLabel: (prop_types_default()).string,
  navigationAriaLive: (prop_types_default()).string,
  navigationLabel: (prop_types_default()).func,
  next2AriaLabel: (prop_types_default()).string,
  next2Label: (prop_types_default()).node,
  nextAriaLabel: (prop_types_default()).string,
  nextLabel: (prop_types_default()).node,
  prev2AriaLabel: (prop_types_default()).string,
  prev2Label: (prop_types_default()).node,
  prevAriaLabel: (prop_types_default()).string,
  prevLabel: (prop_types_default()).node,
  setActiveStartDate: (prop_types_default()).func.isRequired,
  showDoubleView: (prop_types_default()).bool,
  view: isView.isRequired,
  views: isViews.isRequired
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/Flex.js
var _excluded = ["children", "className", "direction", "count", "offset", "style", "wrap"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { Flex_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Flex_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function toPercent(num) {
  return "".concat(num, "%");
}

function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react.createElement("div", _extends({
    className: className,
    style: _objectSpread({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), react.Children.map(children, function (child, index) {
    return /*#__PURE__*/react.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      style: {
        flexBasis: toPercent(100 / count),
        flexShrink: 0,
        flexGrow: 0,
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}
Flex.propTypes = {
  children: (prop_types_default()).node,
  className: (prop_types_default()).string,
  count: (prop_types_default()).number.isRequired,
  direction: (prop_types_default()).string,
  offset: (prop_types_default()).number,
  style: prop_types_default().objectOf(prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])),
  wrap: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/shared/utils.js
function utils_toConsumableArray(arr) { return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || utils_nonIterableSpread(); }

function utils_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function utils_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return utils_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen); }

function utils_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function utils_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return utils_arrayLikeToArray(arr); }

function utils_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */

function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
}
function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
}
function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
}

function getRangeClassNames(valueRange, dateRange, baseClassName) {
  var isRange = doRangesOverlap(dateRange, valueRange);
  var classes = [];

  if (isRange) {
    classes.push(baseClassName);
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

    if (isRangeStart) {
      classes.push("".concat(baseClassName, "Start"));
    }

    if (isRangeEnd) {
      classes.push("".concat(baseClassName, "End"));
    }

    if (isRangeStart && isRangeEnd) {
      classes.push("".concat(baseClassName, "BothEnds"));
    }
  }

  return classes;
}

function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!Array.isArray(date) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = Array.isArray(date) ? date : getRange(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }

  if (!value) {
    return classes;
  }

  if (!Array.isArray(value) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = Array.isArray(value) ? value : getRange(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  }

  var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
  classes.push.apply(classes, utils_toConsumableArray(valueRangeClassNames));
  var valueArray = [].concat(value);

  if (hover && valueArray.length === 1) {
    var hoverRange = hover > valueRange[0] ? [valueRange[0], hover] : [hover, valueRange[0]];
    var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
    classes.push.apply(classes, utils_toConsumableArray(hoverRangeClassNames));
  }

  return classes;
}
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/TileGroup.js
var TileGroup_excluded = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];

function TileGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TileGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TileGroup_ownKeys(Object(source), !0).forEach(function (key) { TileGroup_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TileGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function TileGroup_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TileGroup_extends() { TileGroup_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TileGroup_extends.apply(this, arguments); }

function TileGroup_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = TileGroup_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function TileGroup_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function TileGroup(_ref) {
  var className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 3 : _ref$count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = TileGroup_objectWithoutProperties(_ref, TileGroup_excluded);

  var tiles = [];

  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push( /*#__PURE__*/react.createElement(Tile, TileGroup_extends({
      key: date.getTime(),
      classes: getTileClasses({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }

  return /*#__PURE__*/react.createElement(Flex, {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = TileGroup_objectSpread(TileGroup_objectSpread({}, tileGroupProps), {}, {
  activeStartDate: prop_types_default().instanceOf(Date),
  count: (prop_types_default()).number,
  dateTransform: (prop_types_default()).func.isRequired,
  dateType: (prop_types_default()).string,
  offset: (prop_types_default()).number,
  step: (prop_types_default()).number,
  tile: (prop_types_default()).func.isRequired
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/Tile.js
function Tile_typeof(obj) { "@babel/helpers - typeof"; return Tile_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Tile_typeof(obj); }

function Tile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Tile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tile_ownKeys(Object(source), !0).forEach(function (key) { Tile_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (Tile_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function Tile_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}

function getValue(nextProps, prop) {
  var activeStartDate = nextProps.activeStartDate,
      date = nextProps.date,
      view = nextProps.view;
  return typeof prop === 'function' ? prop({
    activeStartDate: activeStartDate,
    date: date,
    view: view
  }) : prop;
}

var Tile = /*#__PURE__*/function (_Component) {
  _inherits(Tile, _Component);

  var _super = _createSuper(Tile);

  function Tile() {
    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Tile_defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return /*#__PURE__*/react.createElement("button", {
        className: mergeClassNames(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function (event) {
          return onClick(date, event);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? /*#__PURE__*/react.createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var activeStartDate = nextProps.activeStartDate,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent;
      var nextState = {};

      if (tileClassName !== prevState.tileClassNameProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileClassName = getValue(nextProps, tileClassName);
        nextState.tileClassNameProps = tileClassName;
      }

      if (tileContent !== prevState.tileContentProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileContent = getValue(nextProps, tileContent);
        nextState.tileContentProps = tileContent;
      }

      nextState.activeStartDateProps = activeStartDate;
      return nextState;
    }
  }]);

  return Tile;
}(react.Component);


Tile.propTypes = Tile_objectSpread(Tile_objectSpread({}, tileProps), {}, {
  children: (prop_types_default()).node.isRequired,
  formatAbbr: (prop_types_default()).func,
  maxDateTransform: (prop_types_default()).func.isRequired,
  minDateTransform: (prop_types_default()).func.isRequired
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/CenturyView/Decade.js
var Decade_excluded = ["classes", "formatYear"];

function Decade_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Decade_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Decade_ownKeys(Object(source), !0).forEach(function (key) { Decade_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Decade_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Decade_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Decade_extends() { Decade_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Decade_extends.apply(this, arguments); }

function Decade_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Decade_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Decade_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var Decade_className = 'react-calendar__century-view__decades__decade';
function Decade(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? dateFormatter_formatYear : _ref$formatYear,
      otherProps = Decade_objectWithoutProperties(_ref, Decade_excluded);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/react.createElement(Tile, Decade_extends({}, otherProps, {
    classes: [].concat(classes, Decade_className),
    maxDateTransform: getDecadeEnd,
    minDateTransform: getDecadeStart,
    view: "century"
  }), getDecadeLabel(locale, formatYear, date));
}
Decade.propTypes = Decade_objectSpread(Decade_objectSpread({}, tileProps), {}, {
  formatYear: (prop_types_default()).func
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/CenturyView/Decades.js
function Decades_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Decades_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Decades_ownKeys(Object(source), !0).forEach(function (key) { Decades_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Decades_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Decades_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Decades_extends() { Decades_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Decades_extends.apply(this, arguments); }







function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfCenturyYear(activeStartDate);
  var end = start + 99;
  return /*#__PURE__*/react.createElement(TileGroup, Decades_extends({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: getDecadeStart,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: Decade
  }));
}
Decades.propTypes = Decades_objectSpread({}, tileGroupProps);
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/CenturyView.js


function CenturyView(props) {
  function renderDecades() {
    return /*#__PURE__*/react.createElement(Decades, props);
  }

  return /*#__PURE__*/react.createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/DecadeView/Year.js
var Year_excluded = ["classes", "formatYear"];

function Year_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Year_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Year_ownKeys(Object(source), !0).forEach(function (key) { Year_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Year_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Year_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Year_extends() { Year_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Year_extends.apply(this, arguments); }

function Year_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Year_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Year_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Year_className = 'react-calendar__decade-view__years__year';
function Year(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? dateFormatter_formatYear : _ref$formatYear,
      otherProps = Year_objectWithoutProperties(_ref, Year_excluded);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/react.createElement(Tile, Year_extends({}, otherProps, {
    classes: [].concat(classes, Year_className),
    maxDateTransform: getYearEnd,
    minDateTransform: getYearStart,
    view: "decade"
  }), formatYear(locale, date));
}
Year.propTypes = Year_objectSpread(Year_objectSpread({}, tileProps), {}, {
  formatYear: (prop_types_default()).func
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/DecadeView/Years.js
function Years_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Years_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Years_ownKeys(Object(source), !0).forEach(function (key) { Years_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Years_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Years_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Years_extends() { Years_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Years_extends.apply(this, arguments); }






function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfDecadeYear(activeStartDate);
  var end = start + 9;
  return /*#__PURE__*/react.createElement(TileGroup, Years_extends({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      var date = new Date();
      date.setFullYear(year, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "year",
    end: end,
    start: start,
    tile: Year
  }));
}
Years.propTypes = Years_objectSpread({}, tileGroupProps);
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/DecadeView.js


function DecadeView(props) {
  function renderYears() {
    return /*#__PURE__*/react.createElement(Years, props);
  }

  return /*#__PURE__*/react.createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/YearView/Month.js
var Month_excluded = ["classes", "formatMonth", "formatMonthYear"];

function Month_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Month_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Month_ownKeys(Object(source), !0).forEach(function (key) { Month_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Month_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Month_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Month_extends() { Month_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Month_extends.apply(this, arguments); }

function Month_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Month_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Month_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Month_className = 'react-calendar__year-view__months__month';
function Month(_ref) {
  var classes = _ref.classes,
      _ref$formatMonth = _ref.formatMonth,
      formatMonth = _ref$formatMonth === void 0 ? dateFormatter_formatMonth : _ref$formatMonth,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear = _ref$formatMonthYear === void 0 ? dateFormatter_formatMonthYear : _ref$formatMonthYear,
      otherProps = Month_objectWithoutProperties(_ref, Month_excluded);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/react.createElement(Tile, Month_extends({}, otherProps, {
    classes: [].concat(classes, Month_className),
    formatAbbr: formatMonthYear,
    maxDateTransform: getMonthEnd,
    minDateTransform: getMonthStart,
    view: "year"
  }), formatMonth(locale, date));
}
Month.propTypes = Month_objectSpread(Month_objectSpread({}, tileProps), {}, {
  formatMonth: (prop_types_default()).func,
  formatMonthYear: (prop_types_default()).func
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/YearView/Months.js
function Months_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Months_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Months_ownKeys(Object(source), !0).forEach(function (key) { Months_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Months_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Months_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Months_extends() { Months_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Months_extends.apply(this, arguments); }







function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = getYear(activeStartDate);
  return /*#__PURE__*/react.createElement(TileGroup, Months_extends({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = new Date();
      date.setFullYear(year, monthIndex, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "month",
    end: end,
    start: start,
    tile: Month
  }));
}
Months.propTypes = Months_objectSpread(Months_objectSpread({}, tileGroupProps), {}, {
  locale: (prop_types_default()).string
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/YearView.js


function YearView(props) {
  function renderMonths() {
    return /*#__PURE__*/react.createElement(Months, props);
  }

  return /*#__PURE__*/react.createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView/Day.js
var Day_excluded = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];

function Day_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Day_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Day_ownKeys(Object(source), !0).forEach(function (key) { Day_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Day_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Day_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Day_extends() { Day_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Day_extends.apply(this, arguments); }

function Day_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Day_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Day_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var Day_className = 'react-calendar__month-view__days__day';
function Day(_ref) {
  var _ref$formatDay = _ref.formatDay,
      formatDay = _ref$formatDay === void 0 ? dateFormatter_formatDay : _ref$formatDay,
      _ref$formatLongDate = _ref.formatLongDate,
      formatLongDate = _ref$formatLongDate === void 0 ? dateFormatter_formatLongDate : _ref$formatLongDate,
      calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      otherProps = Day_objectWithoutProperties(_ref, Day_excluded);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/react.createElement(Tile, Day_extends({}, otherProps, {
    classes: [].concat(classes, Day_className, isWeekend(date, calendarType) ? "".concat(Day_className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(Day_className, "--neighboringMonth") : null),
    formatAbbr: formatLongDate,
    maxDateTransform: getDayEnd,
    minDateTransform: getDayStart,
    view: "month"
  }), formatDay(locale, date));
}
Day.propTypes = Day_objectSpread(Day_objectSpread({}, tileProps), {}, {
  currentMonthIndex: (prop_types_default()).number.isRequired,
  formatDay: (prop_types_default()).func,
  formatLongDate: (prop_types_default()).func
});
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView/Days.js
var Days_excluded = ["showFixedNumberOfWeeks", "showNeighboringMonth"];

function Days_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Days_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Days_ownKeys(Object(source), !0).forEach(function (key) { Days_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Days_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Days_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Days_extends() { Days_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Days_extends.apply(this, arguments); }

function Days_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Days_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Days_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = Days_objectWithoutProperties(props, Days_excluded);

  var year = getYear(activeStartDate);
  var monthIndex = getMonth(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = getDayOfWeek(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */

  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */

  var end = function () {
    if (showFixedNumberOfWeeks) {
      // Always show 6 weeks
      return start + 6 * 7 - 1;
    }

    var daysInMonth = getDaysInMonth(activeStartDate);

    if (showNeighboringMonth) {
      var activeEndDate = new Date();
      activeEndDate.setFullYear(year, monthIndex, daysInMonth);
      activeEndDate.setHours(0, 0, 0, 0);
      var daysUntilEndOfTheWeek = 7 - getDayOfWeek(activeEndDate, calendarType) - 1;
      return daysInMonth + daysUntilEndOfTheWeek;
    }

    return daysInMonth;
  }();

  return /*#__PURE__*/react.createElement(TileGroup, Days_extends({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      var date = new Date();
      date.setFullYear(year, monthIndex, day);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: Day
  }));
}
Days.propTypes = Days_objectSpread({
  calendarType: isCalendarType.isRequired,
  showFixedNumberOfWeeks: (prop_types_default()).bool,
  showNeighboringMonth: (prop_types_default()).bool
}, tileGroupProps);
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView/Weekdays.js








var Weekdays_className = 'react-calendar__month-view__weekdays';
var weekdayClassName = "".concat(Weekdays_className, "__weekday");
function Weekdays(props) {
  var calendarType = props.calendarType,
      _props$formatShortWee = props.formatShortWeekday,
      formatShortWeekday = _props$formatShortWee === void 0 ? dateFormatter_formatShortWeekday : _props$formatShortWee,
      _props$formatWeekday = props.formatWeekday,
      formatWeekday = _props$formatWeekday === void 0 ? dateFormatter_formatWeekday : _props$formatWeekday,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = getMonthStart(anyDate);
  var year = getYear(beginOfMonth);
  var monthIndex = getMonth(beginOfMonth);
  var weekdays = [];

  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, calendarType));
    var abbr = formatWeekday(locale, weekdayDate);
    weekdays.push( /*#__PURE__*/react.createElement("div", {
      key: weekday,
      className: mergeClassNames(weekdayClassName, isWeekend(weekdayDate, calendarType) && "".concat(weekdayClassName, "--weekend"))
    }, /*#__PURE__*/react.createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
  }

  return /*#__PURE__*/react.createElement(Flex, {
    className: Weekdays_className,
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}
Weekdays.propTypes = {
  calendarType: isCalendarType.isRequired,
  formatShortWeekday: (prop_types_default()).func,
  formatWeekday: (prop_types_default()).func,
  locale: (prop_types_default()).string,
  onMouseLeave: (prop_types_default()).func
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView/WeekNumber.js
var WeekNumber_excluded = ["date", "onClickWeekNumber", "weekNumber"];

function WeekNumber_extends() { WeekNumber_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return WeekNumber_extends.apply(this, arguments); }

function WeekNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WeekNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WeekNumber_ownKeys(Object(source), !0).forEach(function (key) { WeekNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WeekNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function WeekNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function WeekNumber_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = WeekNumber_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function WeekNumber_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var WeekNumber_className = 'react-calendar__tile';
function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber,
      otherProps = WeekNumber_objectWithoutProperties(_ref, WeekNumber_excluded);

  var props = WeekNumber_objectSpread({
    className: WeekNumber_className
  }, otherProps);

  var children = /*#__PURE__*/react.createElement("span", null, weekNumber);
  return onClickWeekNumber ? /*#__PURE__*/react.createElement("button", WeekNumber_extends({}, props, {
    onClick: function onClick(event) {
      return onClickWeekNumber(weekNumber, date, event);
    },
    type: "button"
  }), children) : /*#__PURE__*/react.createElement("div", props, children);
}
WeekNumber.propTypes = {
  date: prop_types_default().instanceOf(Date).isRequired,
  onClickWeekNumber: (prop_types_default()).func,
  weekNumber: (prop_types_default()).node.isRequired
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView/WeekNumbers.js







function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }

    var numberOfDays = getDaysInMonth(activeStartDate);
    var startWeekday = getDayOfWeek(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();

  var dates = function () {
    var year = getYear(activeStartDate);
    var monthIndex = getMonth(activeStartDate);
    var day = getDate(activeStartDate);
    var result = [];

    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push(getBeginOfWeek(new Date(year, monthIndex, day + index * 7), calendarType));
    }

    return result;
  }();

  var weekNumbers = dates.map(function (date) {
    return getWeekNumber(date, calendarType);
  });
  return /*#__PURE__*/react.createElement(Flex, {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return /*#__PURE__*/react.createElement(WeekNumber, {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}
WeekNumbers.propTypes = {
  activeStartDate: prop_types_default().instanceOf(Date).isRequired,
  calendarType: isCalendarType.isRequired,
  onClickWeekNumber: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  showFixedNumberOfWeeks: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/MonthView.js
var MonthView_excluded = ["calendarType", "formatShortWeekday", "formatWeekday", "onClickWeekNumber", "showWeekNumbers"];

function MonthView_extends() { MonthView_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return MonthView_extends.apply(this, arguments); }

function MonthView_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = MonthView_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function MonthView_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










function getCalendarTypeFromLocale(locale) {
  return Object.keys(CALENDAR_TYPE_LOCALES).find(function (calendarType) {
    return CALENDAR_TYPE_LOCALES[calendarType].includes(locale);
  }) || CALENDAR_TYPES.ISO_8601;
}

function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var _props$calendarType = props.calendarType,
      calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale) : _props$calendarType,
      formatShortWeekday = props.formatShortWeekday,
      formatWeekday = props.formatWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = MonthView_objectWithoutProperties(props, MonthView_excluded);

  function renderWeekdays() {
    return /*#__PURE__*/react.createElement(Weekdays, {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      formatWeekday: formatWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return /*#__PURE__*/react.createElement(WeekNumbers, {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }

  function renderDays() {
    return /*#__PURE__*/react.createElement(Days, MonthView_extends({
      calendarType: calendarType
    }, childProps));
  }

  var className = 'react-calendar__month-view';
  return /*#__PURE__*/react.createElement("div", {
    className: mergeClassNames(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), /*#__PURE__*/react.createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
  activeStartDate: prop_types_default().instanceOf(Date).isRequired,
  calendarType: isCalendarType,
  formatShortWeekday: (prop_types_default()).func,
  formatWeekday: (prop_types_default()).func,
  locale: (prop_types_default()).string,
  onClickWeekNumber: (prop_types_default()).func,
  onMouseLeave: (prop_types_default()).func,
  showFixedNumberOfWeeks: (prop_types_default()).bool,
  showWeekNumbers: (prop_types_default()).bool
};
;// CONCATENATED MODULE: ../../node_modules/react-calendar/dist/esm/Calendar.js
var Calendar_excluded = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];

function Calendar_extends() { Calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Calendar_extends.apply(this, arguments); }

function Calendar_typeof(obj) { "@babel/helpers - typeof"; return Calendar_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, Calendar_typeof(obj); }

function Calendar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Calendar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Calendar_createClass(Constructor, protoProps, staticProps) { if (protoProps) Calendar_defineProperties(Constructor.prototype, protoProps); if (staticProps) Calendar_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Calendar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) Calendar_setPrototypeOf(subClass, superClass); }

function Calendar_setPrototypeOf(o, p) { Calendar_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Calendar_setPrototypeOf(o, p); }

function Calendar_createSuper(Derived) { var hasNativeReflectConstruct = Calendar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Calendar_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Calendar_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Calendar_possibleConstructorReturn(this, result); }; }

function Calendar_possibleConstructorReturn(self, call) { if (call && (Calendar_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return Calendar_assertThisInitialized(self); }

function Calendar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Calendar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Calendar_getPrototypeOf(o) { Calendar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Calendar_getPrototypeOf(o); }

function Calendar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Calendar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Calendar_ownKeys(Object(source), !0).forEach(function (key) { Calendar_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Calendar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Calendar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Calendar_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Calendar_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Calendar_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Calendar_toConsumableArray(arr) { return Calendar_arrayWithoutHoles(arr) || Calendar_iterableToArray(arr) || Calendar_unsupportedIterableToArray(arr) || Calendar_nonIterableSpread(); }

function Calendar_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function Calendar_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Calendar_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Calendar_arrayLikeToArray(o, minLen); }

function Calendar_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function Calendar_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return Calendar_arrayLikeToArray(arr); }

function Calendar_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












var defaultMinDate = new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = new Date(8.64e15);
var baseClassName = 'react-calendar';
var Calendar_allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(Calendar_toConsumableArray(Calendar_allViews.slice(1)), ['day']);

function toDate(value) {
  if (value instanceof Date) {
    return value;
  }

  return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */


function getLimitedViews(minDetail, maxDetail) {
  return Calendar_allViews.slice(Calendar_allViews.indexOf(minDetail), Calendar_allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */


function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */


function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }

  return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */


function getValueType(maxDetail) {
  return allValueTypes[Calendar_allViews.indexOf(maxDetail)];
}

function Calendar_getValue(value, index) {
  if (!value) {
    return null;
  }

  var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;

  if (!rawValue) {
    return null;
  }

  var valueDate = toDate(rawValue);

  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueDate;
}

function getDetailValue(_ref, index) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
  var valuePiece = Calendar_getValue(value, index);

  if (!valuePiece) {
    return null;
  }

  var valueType = getValueType(maxDetail);
  var detailValueFrom = [getBegin, getEnd][index](valueType, valuePiece);
  return between(detailValueFrom, minDate, maxDate);
}

var getDetailValueFrom = function getDetailValueFrom(args) {
  return getDetailValue(args, 0);
};

var getDetailValueTo = function getDetailValueTo(args) {
  return getDetailValue(args, 1);
};

var getDetailValueArray = function getDetailValueArray(args) {
  var value = args.value;

  if (Array.isArray(value)) {
    return value;
  }

  return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
    return fn(args);
  });
};

function getActiveStartDate(props) {
  var maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom({
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail
  }) || new Date();
  return getBegin(rangeType, valueFrom);
}

function getInitialActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      defaultActiveStartDate = props.defaultActiveStartDate,
      defaultValue = props.defaultValue,
      defaultView = props.defaultView,
      maxDetail = props.maxDetail,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view,
      otherProps = Calendar_objectWithoutProperties(props, Calendar_excluded);

  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = activeStartDate || defaultActiveStartDate;

  if (valueFrom) {
    return getBegin(rangeType, valueFrom);
  }

  return getActiveStartDate(Calendar_objectSpread({
    maxDetail: maxDetail,
    minDetail: minDetail,
    value: value || defaultValue,
    view: view || defaultView
  }, otherProps));
}

var getIsSingleValue = function getIsSingleValue(value) {
  return value && [].concat(value).length === 1;
};

var Calendar = /*#__PURE__*/function (_Component) {
  Calendar_inherits(Calendar, _Component);

  var _super = Calendar_createSuper(Calendar);

  function Calendar() {
    var _this;

    Calendar_classCallCheck(this, Calendar);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "state", {
      activeStartDate: _this.props.defaultActiveStartDate,
      value: _this.props.defaultValue,
      view: _this.props.defaultView
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "setStateAndCallCallbacks", function (nextState, event, callback) {
      var _assertThisInitialize = Calendar_assertThisInitialized(_this),
          previousActiveStartDate = _assertThisInitialize.activeStartDate,
          previousView = _assertThisInitialize.view;

      var _this$props = _this.props,
          allowPartialRange = _this$props.allowPartialRange,
          onActiveStartDateChange = _this$props.onActiveStartDateChange,
          onChange = _this$props.onChange,
          onViewChange = _this$props.onViewChange,
          selectRange = _this$props.selectRange;
      var prevArgs = {
        activeStartDate: previousActiveStartDate,
        view: previousView
      };

      _this.setState(nextState, function () {
        var args = {
          action: nextState.action,
          activeStartDate: nextState.activeStartDate || _this.activeStartDate,
          value: nextState.value || _this.value,
          view: nextState.view || _this.view
        };

        function shouldUpdate(key) {
          return (// Key must exist, and…
            key in nextState && ( // …key changed from undefined to defined or the other way around, or…
            Calendar_typeof(nextState[key]) !== Calendar_typeof(prevArgs[key]) || ( // …value changed.
            nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]))
          );
        }

        if (shouldUpdate('activeStartDate')) {
          if (onActiveStartDateChange) onActiveStartDateChange(args);
        }

        if (shouldUpdate('view')) {
          if (onViewChange) onViewChange(args);
        }

        if (shouldUpdate('value')) {
          if (onChange) {
            if (selectRange) {
              var isSingleValue = getIsSingleValue(nextState.value);

              if (!isSingleValue) {
                onChange(nextState.value, event);
              } else if (allowPartialRange) {
                onChange([nextState.value], event);
              }
            } else {
              onChange(nextState.value, event);
            }
          }
        }

        if (callback) callback(args);
      });
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "setActiveStartDate", function (nextActiveStartDate, action) {
      _this.setStateAndCallCallbacks({
        action: action,
        activeStartDate: nextActiveStartDate
      });
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "drillDown", function (nextActiveStartDate, event) {
      if (!_this.drillDownAvailable) {
        return;
      }

      _this.onClickTile(nextActiveStartDate, event);

      var _assertThisInitialize2 = Calendar_assertThisInitialized(_this),
          view = _assertThisInitialize2.view,
          views = _assertThisInitialize2.views;

      var onDrillDown = _this.props.onDrillDown;
      var nextView = views[views.indexOf(view) + 1];

      _this.setStateAndCallCallbacks({
        action: 'drillDown',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillDown);
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _assertThisInitialize3 = Calendar_assertThisInitialized(_this),
          activeStartDate = _assertThisInitialize3.activeStartDate,
          view = _assertThisInitialize3.view,
          views = _assertThisInitialize3.views;

      var onDrillUp = _this.props.onDrillUp;
      var nextView = views[views.indexOf(view) - 1];
      var nextActiveStartDate = getBegin(nextView, activeStartDate);

      _this.setStateAndCallCallbacks({
        action: 'drillUp',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillUp);
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "onChange", function (value, event) {
      var _assertThisInitialize4 = Calendar_assertThisInitialized(_this),
          previousValue = _assertThisInitialize4.value;

      var _this$props2 = _this.props,
          goToRangeStartOnSelect = _this$props2.goToRangeStartOnSelect,
          selectRange = _this$props2.selectRange;

      _this.onClickTile(value, event);

      var isFirstValueInRange = selectRange && !getIsSingleValue(previousValue);
      var nextValue;

      if (selectRange) {
        // Range selection turned on
        var _assertThisInitialize5 = Calendar_assertThisInitialized(_this),
            valueType = _assertThisInitialize5.valueType;

        if (isFirstValueInRange) {
          // Value has 0 or 2 elements - either way we're starting a new array
          // First value
          nextValue = getBegin(valueType, value);
        } else {
          // Second value
          nextValue = getValueRange(valueType, previousValue, value);
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);
      }

      var nextActiveStartDate = // Range selection turned off
      !selectRange || // Range selection turned on, first value
      isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
      goToRangeStartOnSelect ? getActiveStartDate(Calendar_objectSpread(Calendar_objectSpread({}, _this.props), {}, {
        value: nextValue
      })) : null;
      event.persist();

      _this.setStateAndCallCallbacks({
        action: 'onChange',
        activeStartDate: nextActiveStartDate,
        value: nextValue
      }, event);
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "onClickTile", function (value, event) {
      var _assertThisInitialize6 = Calendar_assertThisInitialized(_this),
          view = _assertThisInitialize6.view;

      var _this$props3 = _this.props,
          onClickDay = _this$props3.onClickDay,
          onClickDecade = _this$props3.onClickDecade,
          onClickMonth = _this$props3.onClickMonth,
          onClickYear = _this$props3.onClickYear;

      var callback = function () {
        switch (view) {
          case 'century':
            return onClickDecade;

          case 'decade':
            return onClickYear;

          case 'year':
            return onClickMonth;

          case 'month':
            return onClickDay;

          default:
            throw new Error("Invalid view: ".concat(view, "."));
        }
      }();

      if (callback) callback(value, event);
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }

        return {
          hover: value
        };
      });
    });

    Calendar_defineProperty(Calendar_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });

    return _this;
  }

  Calendar_createClass(Calendar, [{
    key: "activeStartDate",
    get: function get() {
      var activeStartDateProps = this.props.activeStartDate;
      var activeStartDateState = this.state.activeStartDate;
      return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props4 = this.props,
          selectRange = _this$props4.selectRange,
          valueProps = _this$props4.value;
      var valueState = this.state.value; // In the middle of range selection, use value from state

      if (selectRange && getIsSingleValue(valueState)) {
        return valueState;
      }

      return valueProps !== undefined ? valueProps : valueState;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }, {
    key: "view",
    get: function get() {
      var _this$props5 = this.props,
          minDetail = _this$props5.minDetail,
          maxDetail = _this$props5.maxDetail,
          viewProps = _this$props5.view;
      var viewState = this.state.view;
      return getView(viewProps || viewState, minDetail, maxDetail);
    }
  }, {
    key: "views",
    get: function get() {
      var _this$props6 = this.props,
          minDetail = _this$props6.minDetail,
          maxDetail = _this$props6.maxDetail;
      return getLimitedViews(minDetail, maxDetail);
    }
  }, {
    key: "hover",
    get: function get() {
      var selectRange = this.props.selectRange;
      var hover = this.state.hover;
      return selectRange ? hover : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) > 0;
    }
    /**
     * Gets current value in a desired format.
     */

  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(value) {
      var _this$props7 = this.props,
          minDate = _this$props7.minDate,
          maxDate = _this$props7.maxDate,
          maxDetail = _this$props7.maxDetail,
          returnValue = _this$props7.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(next) {
      var currentActiveStartDate = this.activeStartDate,
          onMouseOver = this.onMouseOver,
          valueType = this.valueType,
          value = this.value,
          view = this.view;
      var _this$props8 = this.props,
          calendarType = _this$props8.calendarType,
          locale = _this$props8.locale,
          maxDate = _this$props8.maxDate,
          minDate = _this$props8.minDate,
          selectRange = _this$props8.selectRange,
          tileClassName = _this$props8.tileClassName,
          tileContent = _this$props8.tileContent,
          tileDisabled = _this$props8.tileDisabled;
      var hover = this.hover;
      var activeStartDate = next ? getBeginNext(view, currentActiveStartDate) : getBegin(view, currentActiveStartDate);
      var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onClick: onClick,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent,
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };

      switch (view) {
        case 'century':
          {
            var formatYear = this.props.formatYear;
            return /*#__PURE__*/react.createElement(CenturyView, Calendar_extends({
              formatYear: formatYear
            }, commonProps));
          }

        case 'decade':
          {
            var _formatYear = this.props.formatYear;
            return /*#__PURE__*/react.createElement(DecadeView, Calendar_extends({
              formatYear: _formatYear
            }, commonProps));
          }

        case 'year':
          {
            var _this$props9 = this.props,
                formatMonth = _this$props9.formatMonth,
                formatMonthYear = _this$props9.formatMonthYear;
            return /*#__PURE__*/react.createElement(YearView, Calendar_extends({
              formatMonth: formatMonth,
              formatMonthYear: formatMonthYear
            }, commonProps));
          }

        case 'month':
          {
            var _this$props10 = this.props,
                formatDay = _this$props10.formatDay,
                formatLongDate = _this$props10.formatLongDate,
                formatShortWeekday = _this$props10.formatShortWeekday,
                formatWeekday = _this$props10.formatWeekday,
                onClickWeekNumber = _this$props10.onClickWeekNumber,
                showDoubleView = _this$props10.showDoubleView,
                showFixedNumberOfWeeks = _this$props10.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props10.showNeighboringMonth,
                showWeekNumbers = _this$props10.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return /*#__PURE__*/react.createElement(MonthView, Calendar_extends({
              calendarType: calendarType,
              formatDay: formatDay,
              formatLongDate: formatLongDate,
              formatShortWeekday: formatShortWeekday,
              formatWeekday: formatWeekday,
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: selectRange ? onMouseLeave : null,
              showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;

      if (!showNavigation) {
        return null;
      }

      var activeStartDate = this.activeStartDate,
          view = this.view,
          views = this.views;
      var _this$props11 = this.props,
          formatMonthYear = _this$props11.formatMonthYear,
          formatYear = _this$props11.formatYear,
          locale = _this$props11.locale,
          maxDate = _this$props11.maxDate,
          minDate = _this$props11.minDate,
          navigationAriaLabel = _this$props11.navigationAriaLabel,
          navigationAriaLive = _this$props11.navigationAriaLive,
          navigationLabel = _this$props11.navigationLabel,
          next2AriaLabel = _this$props11.next2AriaLabel,
          next2Label = _this$props11.next2Label,
          nextAriaLabel = _this$props11.nextAriaLabel,
          nextLabel = _this$props11.nextLabel,
          prev2AriaLabel = _this$props11.prev2AriaLabel,
          prev2Label = _this$props11.prev2Label,
          prevAriaLabel = _this$props11.prevAriaLabel,
          prevLabel = _this$props11.prevLabel,
          showDoubleView = _this$props11.showDoubleView;
      return /*#__PURE__*/react.createElement(Navigation, {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        formatYear: formatYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationAriaLive: navigationAriaLive,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView: showDoubleView,
        view: view,
        views: views
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          className = _this$props12.className,
          inputRef = _this$props12.inputRef,
          selectRange = _this$props12.selectRange,
          showDoubleView = _this$props12.showDoubleView;
      var onMouseLeave = this.onMouseLeave,
          value = this.value;
      var valueArray = [].concat(value);
      return /*#__PURE__*/react.createElement("div", {
        className: mergeClassNames(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className),
        ref: inputRef
      }, this.renderNavigation(), /*#__PURE__*/react.createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent(), showDoubleView && this.renderContent(true)));
    }
  }]);

  return Calendar;
}(react.Component);


Calendar.defaultProps = {
  goToRangeStartOnSelect: true,
  maxDate: defaultMaxDate,
  maxDetail: 'month',
  minDate: defaultMinDate,
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true
};
var isActiveStartDate = prop_types_default().instanceOf(Date);
var isLooseValue = prop_types_default().oneOfType([(prop_types_default()).string, isValue]);
Calendar.propTypes = {
  activeStartDate: isActiveStartDate,
  allowPartialRange: (prop_types_default()).bool,
  calendarType: isCalendarType,
  className: isClassName,
  defaultActiveStartDate: isActiveStartDate,
  defaultValue: isLooseValue,
  defaultView: isView,
  formatDay: (prop_types_default()).func,
  formatLongDate: (prop_types_default()).func,
  formatMonth: (prop_types_default()).func,
  formatMonthYear: (prop_types_default()).func,
  formatShortWeekday: (prop_types_default()).func,
  formatWeekday: (prop_types_default()).func,
  formatYear: (prop_types_default()).func,
  goToRangeStartOnSelect: (prop_types_default()).bool,
  inputRef: isRef,
  locale: (prop_types_default()).string,
  maxDate: isMaxDate,
  maxDetail: prop_types_default().oneOf(Calendar_allViews),
  minDate: isMinDate,
  minDetail: prop_types_default().oneOf(Calendar_allViews),
  navigationAriaLabel: (prop_types_default()).string,
  navigationAriaLive: prop_types_default().oneOf(['off', 'polite', 'assertive']),
  navigationLabel: (prop_types_default()).func,
  next2AriaLabel: (prop_types_default()).string,
  next2Label: (prop_types_default()).node,
  nextAriaLabel: (prop_types_default()).string,
  nextLabel: (prop_types_default()).node,
  onActiveStartDateChange: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onClickDay: (prop_types_default()).func,
  onClickDecade: (prop_types_default()).func,
  onClickMonth: (prop_types_default()).func,
  onClickWeekNumber: (prop_types_default()).func,
  onClickYear: (prop_types_default()).func,
  onDrillDown: (prop_types_default()).func,
  onDrillUp: (prop_types_default()).func,
  onViewChange: (prop_types_default()).func,
  prev2AriaLabel: (prop_types_default()).string,
  prev2Label: (prop_types_default()).node,
  prevAriaLabel: (prop_types_default()).string,
  prevLabel: (prop_types_default()).node,
  returnValue: prop_types_default().oneOf(['start', 'end', 'range']),
  selectRange: (prop_types_default()).bool,
  showDoubleView: (prop_types_default()).bool,
  showFixedNumberOfWeeks: (prop_types_default()).bool,
  showNavigation: (prop_types_default()).bool,
  showNeighboringMonth: (prop_types_default()).bool,
  showWeekNumbers: (prop_types_default()).bool,
  tileClassName: prop_types_default().oneOfType([(prop_types_default()).func, isClassName]),
  tileContent: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).node]),
  tileDisabled: (prop_types_default()).func,
  value: isLooseValue,
  view: isView
};
// EXTERNAL MODULE: ../../node_modules/react-calendar/dist/Calendar.css
var dist_Calendar = __webpack_require__(78318);
;// CONCATENATED MODULE: ./components/cart/DeliveryCalendar.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &.rigth {\n    transform: rotate(180deg);\n  }\n  figure {\n    width: 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: #fff;\n  border-radius: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: ",
        ";\n  min-height: 350px;\n\n  ",
        " {\n    border-radius: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: ",
        ";\n    height: 100%;\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    margin-bottom: 30px;\n  }\n\n  .react-calendar {\n    background: #fff;\n    border: unset;\n    color : ",
        " !important;\n    font-family: ",
        ";\n    font-size: 10px !important;\n    font-size: 10px;\n    font-weight: 300;\n    letter-spacing: -.33px;\n    line-height: 13px !important;\n    max-width: 95%;\n    min-height: 270px;\n    width: 100%;\n\n    ",
        " {\n      font-size: 12px !important;\n      line-height: 15px !important;\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 350px;\n    }\n  }\n\n  .react-calendar__navigation__label,\n  .react-calendar__tile {\n    font-size: 13px;\n    font-weight: 300;\n    letter-spacing: -.33px;\n\n    ",
        " {\n      font-size: 11px !important;\n    }\n\n    ",
        " {\n      font-size: 12px !important;\n      line-height: 15px !important;\n    }\n  }\n\n  .react-calendar__month-view__weekdays {\n    font-size: 10px !important;\n    font-weight: 300;\n    letter-spacing: -.33px;\n\n    ",
        " {\n      font-size: 8px !important;\n    }\n\n    ",
        " {\n      font-size: 10px !important;\n    }\n  }\n  .react-calendar__tile {\n    flex: 0 0 13.9% !important;\n  }\n\n\n  .react-calendar__navigation__label__labelText,\n  .react-calendar__tile:not(.highlight, .default_selected),\n  .react-calendar__month-view__days__day--weekend {\n    color : ",
        " !important;\n  }\n\n  .react-calendar__navigation__label {\n    cursor: none;\n    pointer-events: none;\n  }\n  .react-calendar__navigation__next-button,\n  .react-calendar__navigation__prev-button {\n    background: transparent;\n    border: unset;\n    cursor: pointer;\n\n    &:hover,\n    &:enabled,\n    &:disabled {\n      background-color: white !important;\n    }\n  }\n\n  abbr[title]{\n    border-bottom-color: inherit !important;\n    border-bottom-style: solid !important;\n    border-bottom-width: 1px !important;\n    cursor: auto;\n  }\n\n  .react-calendar__navigation__next2-button,\n  .react-calendar__navigation__prev2-button {\n    display:none;\n  }\n\n  .default_selected {\n    background: ",
        " !important;\n  }\n\n  .highlight, .default_selected {\n    background: ",
        ";\n    border: .5px solid ",
        " !important;\n    color: ",
        " !important;\n    cursor: pointer;\n    padding: 1px;\n    pointer-events: auto;\n    user-select: auto;\n\n    &:hover {\n      background: ",
        ";\n      color: ",
        " !important;\n    }\n  }\n\n\n  .react-calendar__tile--now {\n    background: #dedede !important;\n    &:hover,\n    &:enabled {\n      background: #dedede !important\n    }\n  }\n\n  .react-calendar__tile {\n    max-width: 100%;\n    padding: 0.75em 0.5em;\n    text-align: center;\n}\n  .react-calendar__month-view__days {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    row-gap: 4px !important;\n  }\n\n  .react-calendar__tile:not(.highlight, .default_selected ) {\n    background: #dedede !important;\n    border: 1px solid white !important;\n    opacity: .5;\n    pointer-events: none;\n    user-select: none;\n    width: 10px !important;\n\n    &:hover,\n    &:enabled {\n      background: #dedede !important;\n    }\n  }\n\n  .react-calendar__tile--active {\n    &:enabled,\n    &:hover,\n    &:focus,\n    &:active {\n      background: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function getMadridDate(dateString) {
    var timeZone = "Europe/Madrid";
    var date;
    if (dateString) {
        // Convert the input date string to a valid Date object
        date = new Date(dateString);
        if (isNaN(date.getTime())) {
            console.warn("\uD83D\uDDD3️ Invalid date string: ".concat(dateString, ". Returning current Madrid date."));
            date = new Date();
        }
    } else {
        date = new Date() // Default to now
        ;
    }
    // Convert the date to Madrid timezone
    var madridTimeString = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23"
    }).format(date);
    // Extract the Madrid date components from the formatted string
    var ref = (0,_sliced_to_array/* default */.Z)(madridTimeString.match(/\d+/g).map(Number), 6), month = ref[0], day = ref[1], year = ref[2], hour = ref[3], minute = ref[4], second = ref[5];
    // Create a new Date object in Madrid timezone
    return new Date(year, month - 1, day, hour, minute, second);
}
function getFurthestDate(dates) {
    if (!dates || dates.length === 0) {
        console.warn("\uD83D\uDDD3️ Furthest date -> No valid dates provided.");
        return null;
    }
    return dates.reduce(function(furthest, current) {
        return new Date(current) > new Date(furthest) ? current : furthest;
    });
}
var getReadableDates = function(dates) {
    return dates.map(function(item) {
        return (0,utils.parseDateString)({
            dateString: item
        });
    });
};
var backIconLight = {
    type: "svg",
    src: "/images/svg/chevron--left.svg",
    alt: "Go back icon",
    size: {
        width: 12,
        height: 12
    }
};
var reactIconCalendarComponent = function(next) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
        className: next ? "rigth" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
            media: backIconLight,
            fill: false
        })
    });
};
var DeliveryCalendar = /*#__PURE__*/ (0,react.memo)(function(param) {
    var deliveryDateOptions = param.deliveryDateOptions, onSelectedDay = param.onSelectedDay, defaultDeliveryDate = param.defaultDeliveryDate;
    // console.log('calendar deliveryDateOptions', deliveryDateOptions)
    var ref = (0,react.useState)(getMadridDate(defaultDeliveryDate !== null && defaultDeliveryDate !== void 0 ? defaultDeliveryDate : null)), date = ref[0], setDate = ref[1];
    var transFormingDates = (0,react.useMemo)(function() {
        return deliveryDateOptions && getReadableDates(deliveryDateOptions);
    }, [
        deliveryDateOptions
    ]);
    var furthestDate = (0,react.useMemo)(function() {
        return getMadridDate(getFurthestDate(deliveryDateOptions));
    }, [
        deliveryDateOptions
    ]);
    // console.log('======================')
    // useEffect(() => {
    //   console.log('🟡 date', date)
    // }, [date])
    // useEffect(() => {
    //   console.log('calendarDates', transFormingDates)
    // }, [transFormingDates])
    // useEffect(() => {
    //   console.log('furthestDate', furthestDate)
    // }, [furthestDate])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Div, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {
            onChange: setDate,
            value: date,
            formatMonthYear: function(_locale, date) {
                return date.toLocaleString("es-ES", {
                    month: "long",
                    year: "numeric"
                });
            },
            selectRange: false,
            onClickDay: onSelectedDay,
            locale: "es-ES",
            defaultView: "month",
            minDate: getMadridDate(deliveryDateOptions === null || deliveryDateOptions === void 0 ? void 0 : deliveryDateOptions[0]),
            maxDate: furthestDate,
            nextLabel: reactIconCalendarComponent(true),
            prevLabel: reactIconCalendarComponent(false),
            tileClassName: function(param) {
                var date = param.date;
                if (transFormingDates && transFormingDates.includes((0,utils.parseDateString)({
                    dateString: date
                }))) {
                    return "highlight";
                }
            }
        })
    });
});
var Icon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DeliveryCalendar__Icon",
    componentId: "sc-eb459b5b-0"
})(_templateObject());
var Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DeliveryCalendar__Div",
    componentId: "sc-eb459b5b-1"
})(_templateObject1(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(350, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.colors.creme;
});

// EXTERNAL MODULE: ../commons/dist/context/index.js
var context = __webpack_require__(7693);
;// CONCATENATED MODULE: ./components/cart/CartSummary.tsx




function CartSummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width:  ",
        ";\n  height: 100%;\n  padding: ",
        " ",
        ";\n  position: relative;\n  left: 0;\n  top: 0;\n  margin: ",
        " auto;\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n    margin: ",
        " auto;\n  }\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n    height: 100%;\n    margin: ",
        " auto;\n  }\n\n  ",
        ' {\n    margin: 15px auto;\n    padding: 21px 10px;\n  }\n\n   &:after {\n    content: "";\n    border: ',
        " solid transparent;\n    border-bottom-color: ",
        ";\n    display: block;\n    left: 46%;\n    position: absolute;\n    top: ",
        ";\n\n    ",
        " {\n      top: ",
        ";\n    }\n\n    ",
        " {\n      border: ",
        " solid transparent;\n      border-bottom-color: ",
        ";\n      left: 45%;\n      top: ",
        ";\n    }\n\n    ",
        " {\n      border: 10px solid transparent;\n      border-bottom-color: ",
        ";\n      top: -18px;\n    }\n  }\n\n  p {\n    ",
        "\n    background-color: none;\n    color: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    CartSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartSummary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  height: fit-content;\n  margin: ",
        ";\n\n  ",
        " {\n    grid-column: 9 / 12;\n    margin: 0px;\n  }\n\n  .small {\n    h1, span, td {\n      color: ",
        ";\n    }\n    td {\n      >span {\n        opacity: .5;\n      }\n    }\n    span, td {\n      ",
        "\n    }\n\n    table {\n      width:100%;\n      padding: ",
        ";\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        " ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 12px 20px 15px;\n      }\n\n      tr {\n        display: flex;\n        justify-content: space-between;\n        margin: 0;\n        padding: ",
        " 0;\n\n        ",
        " {\n          padding: ",
        " 0;\n        }\n\n        ",
        " {\n          padding: ",
        " 0;\n        }\n\n        ",
        " {\n          padding: 10px 0;\n        }\n      }\n    }\n\n    .delivery-date,\n    .summary-total {\n      display: flex;\n      justify-content: space-between;\n      border-top: 1px solid ",
        ";\n      padding: ",
        ";\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        " ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 12px 20px 15px;\n      }\n    }\n\n    .summary-total, .opacity {\n      opacity: .4;\n    }\n\n    .opacity {\n      ",
        "\n      color: ",
        ";\n      margin-top: ",
        ";\n      ",
        " {\n        margin-top: ",
        ";\n      }\n      ",
        " {\n        margin-top: ",
        ";\n      }\n      ",
        " {\n        margin-top: 10px;\n      }\n    }\n    .delivery-date {\n      ",
        "\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      justify-content: space-between;\n\n      > span {\n        color: ",
        ";\n      }\n    }\n  }\n\n  button {\n    width: 100%;\n\n    &[disabled],\n    &.block {\n      pointer-events: none;\n      user-select: none;\n      opacity: .5;\n    }\n  }\n"
    ]);
    CartSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: block;\n  font-family: ",
        ";\n  /* width: 100%; */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var getMoneySaved = function(items) {
    var savedAmount = 0;
    items.map(function(item) {
        savedAmount = (item.originalPrice - item.listPrice) * item.quantity;
    });
    return savedAmount;
};
function getCartLineWithLatestDate(cartLines) {
    if (cartLines.length === 0) return null;
    var cartLineWithLatestDate = cartLines[0];
    // Initialize the latestDate with the first object's deliveryDate
    var latestDate = new Date(cartLines[0].variant.deliveryDate);
    // Iterate over the array of objects to find the latest date
    for(var i = 1; i < cartLines.length; i++){
        var deliveryDate = new Date(cartLines[i].variant.deliveryDate);
        if (deliveryDate > latestDate) {
            cartLineWithLatestDate = cartLines[i];
            latestDate = deliveryDate;
        }
    }
    return cartLineWithLatestDate;
}
function isACustomerNotFoundError(error) {
    var ref, ref1, ref2, ref3;
    return (error === null || error === void 0 ? void 0 : (ref = error.message) === null || ref === void 0 ? void 0 : ref.includes("Customer not found")) || (error === null || error === void 0 ? void 0 : (ref1 = error.graphQLErrors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.extensions) === null || ref3 === void 0 ? void 0 : ref3.code) === "CUSTOMER_NOT_FOUND";
}
var CartSummary = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var ref3 = (0,router.useRouter)(), locale = ref3.locale, push = ref3.push;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref4 = (0,hooks/* useCustomer */.ON)(), setLoaderActive = ref4.setLoaderActive, setCustomer = ref4.setCustomer;
    var updatePayload = (0,dist_hooks.useModal)(context.MODALS.STOCK_CART).updatePayload;
    var ref5 = (0,dist_hooks.useCart)(), subtotalExTax = ref5.subtotalExTax, cartLines = ref5.cartLines, multipleDeliveryDates = ref5.multipleDeliveryDates, deliveryDate = ref5.deliveryDate, deliveryDateOptions = ref5.deliveryDateOptions, totalExTax = ref5.totalExTax, bulkUpdateCart = ref5.bulkUpdateCart, isFrozenCart = ref5.isFrozenCart;
    var ref6 = data.deliverySchedules[0] || {}, agency = ref6.agency, agencyText = ref6.agencyText, minimumPurchase = ref6.minimumPurchase, minimumPurchaseFrozen = ref6.minimumPurchaseFrozen;
    var cartLinesFromQuery = data.cartLines, promotions = data.promotions;
    var orderedCartLines = getCartLineWithLatestDate(cartLinesFromQuery);
    var ref7 = (0,react.useState)(true), isDisabled = ref7[0], setIsDisabled = ref7[1];
    var promotionType = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = promotions[0]) === null || ref === void 0 ? void 0 : ref.rules[0]) === null || ref1 === void 0 ? void 0 : ref1.ruleable.discount_by;
    }, [
        promotions
    ]);
    var promotionAmount = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = promotions[0]) === null || ref === void 0 ? void 0 : ref.rules[0]) === null || ref1 === void 0 ? void 0 : ref1.ruleable.value;
    }, [
        promotions
    ]);
    var promotionSaved = (0,react.useMemo)(function() {
        return (subtotalExTax * Number(promotionAmount) / 100).toFixed(2);
    }, [
        promotionAmount,
        subtotalExTax
    ]);
    var blockedMinimumPurchase = (0,react.useMemo)(function() {
        return isFrozenCart && subtotalExTax < minimumPurchaseFrozen || !isFrozenCart && subtotalExTax < minimumPurchase;
    }, [
        isFrozenCart,
        minimumPurchaseFrozen,
        minimumPurchase,
        subtotalExTax
    ]);
    var numberMinimPurchase = (0,react.useMemo)(function() {
        return isFrozenCart ? minimumPurchaseFrozen : minimumPurchase;
    }, [
        isFrozenCart,
        minimumPurchaseFrozen,
        minimumPurchase
    ]);
    var ref8 = (0,react.useState)(null), dateSelectedByUser = ref8[0], setDateSelectedByUser = ref8[1];
    var addToast = (0,dist_hooks.useToast)().addToast;
    // Money saved in this purchase
    var moneySaved = (0,react.useMemo)(function() {
        return getMoneySaved(cartLines);
    }, [
        cartLines
    ]);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(graphql/* MUTATION_CART_SYNC */.qD), 2), cartSync = ref9[0], ref10 = ref9[1], cartSyncApolloError = ref10.error;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(graphql/* MUTATION_CART_DELIVERY_DATE */.zO), 2), cartDeliveryDate = ref11[0], ref12 = ref11[1], apolloError = ref12.error;
    // const [cartCreateRedirectUrls, { error:cartCreateRedirectUrlsApolloError }] = useMutation(CART_REDIRECT_URLS)
    (0,react.useEffect)(function() {
        console.log("\uD83D\uDFE2 deliveryDateOptions", deliveryDateOptions);
    // 2025-04-04T00:00:00+02:00
    // 2025-02-20T00:00:00.000Z
    }, [
        deliveryDateOptions
    ]);
    var closeSession = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetch("/api/auth/logout", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.error("❌ cartSummary closeSession failed:", e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    addToast({
                        message: "La sesi\xf3n ha caducado, redirigiendo a la p\xe1gina de inicio",
                        type: "error",
                        timeout: 6000
                    });
                    utils.cookie.removeCookie("BC_CUSTOMER_ID");
                    utils.cookie.removeCookie("DY_CUSTOMER_TOKEN");
                    setCustomer(null);
                    bulkUpdateCart([], null, 0, 0, null, null, false, 0, "fresh", null, []);
                    push("/?logout=true");
                    return [
                        2
                    ];
            }
        });
    }), [
        setCustomer,
        bulkUpdateCart,
        push,
        addToast
    ]);
    var onClickCheckout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var DYCustomerToken, mutationData, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, resCartSync, cartId, notifications, ref8, ref9, ref10, cartLines, cartId1, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications1, checkoutUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoaderActive(true);
                        setIsDisabled(true);
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        mutationData = {
                            context: {
                                isPrivatePath: true,
                                DYCustomerToken: DYCustomerToken
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            cartSync(mutationData)
                        ];
                    case 2:
                        resCartSync = _state.sent();
                        cartId = resCartSync === null || resCartSync === void 0 ? void 0 : (ref = resCartSync.data) === null || ref === void 0 ? void 0 : (ref1 = ref.cartSync) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cart) === null || ref2 === void 0 ? void 0 : ref2.bigcommerceId;
                        notifications = resCartSync === null || resCartSync === void 0 ? void 0 : (ref3 = resCartSync.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.cartSync) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cart) === null || ref5 === void 0 ? void 0 : ref5.notifications;
                        if (Array.isArray(notifications) && notifications.length > 0) {
                            ;
                            setLoaderActive(false);
                            ref10 = (ref8 = resCartSync.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.cartSync) === null || ref9 === void 0 ? void 0 : ref9.cart, cartLines = ref10.cartLines, cartId1 = ref10.bigcommerceId, subtotalExTax = ref10.subtotalExTax, totalExTax = ref10.totalExTax, deliveryDate = ref10.deliveryDate, deliveryDateOptions = ref10.deliveryDateOptions, multipleDeliveryDates = ref10.multipleDeliveryDates, discountAmount = ref10.discountAmount, deliveryType = ref10.deliveryType, deliverySchedules = ref10.deliverySchedules, notifications1 = ref10.notifications;
                            bulkUpdateCart(cartLines, cartId1, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications1);
                            updatePayload({
                                payload: notifications1,
                                open: true
                            });
                            return [
                                2
                            ];
                        }
                        if (!cartId) {
                            setLoaderActive(false);
                            addToast({
                                message: t("cart.cart_date_error"),
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        console.log("\uD83D\uDED2", cartId);
                        console.log("\uD83D\uDED2 resCartSync", resCartSync);
                        checkoutUrl = resCartSync === null || resCartSync === void 0 ? void 0 : (ref6 = resCartSync.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.cartSync) === null || ref7 === void 0 ? void 0 : ref7.checkoutUrl;
                        if (typeof checkoutUrl === "string" && checkoutUrl.includes("https")) {
                            window.location.href = checkoutUrl;
                        } else {
                            addToast({
                                message: t("cart.cart_error"),
                                type: "error"
                            });
                            setLoaderActive(false);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setLoaderActive(false);
                        console.log("Error trying to sync cart", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (blockedMinimumPurchase) setIsDisabled(true);
        else if ((cartLines === null || cartLines === void 0 ? void 0 : cartLines.length) > 0) setIsDisabled(false);
    }, [
        blockedMinimumPurchase,
        cartLines
    ]);
    (0,react.useEffect)(function() {
        if (deliveryDate) {
            var parsedDate = new Date(deliveryDate).toDateString();
            setDateSelectedByUser(parsedDate);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (!apolloError) return;
        console.log("\uD83D\uDFE1 apolloError", apolloError);
        setLoaderActive(false);
        if (isACustomerNotFoundError(apolloError)) {
            closeSession();
            return;
        } else {
            addToast({
                message: t("cart.cart_date_error"),
                type: "error"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        apolloError
    ]);
    (0,react.useEffect)(function() {
        if (!cartSyncApolloError) return;
        console.log("\uD83D\uDFE1 cartSyncApolloError", cartSyncApolloError);
        setLoaderActive(false);
        if (isACustomerNotFoundError(cartSyncApolloError)) {
            closeSession();
            return;
        } else {
            addToast({
                message: t("cart.cart_error"),
                type: "error"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartSyncApolloError
    ]);
    var onSelectedDay = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(date) {
            var parsedDate, DYCustomerToken, mutationData, ref, resCartDeliveryDate, ref1, cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        parsedDate = new Date(date).toDateString();
                        setDateSelectedByUser(parsedDate);
                        setLoaderActive(true);
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        mutationData = {
                            variables: {
                                deliveryDate: parsedDate
                            },
                            context: {
                                isPrivatePath: true,
                                DYCustomerToken: DYCustomerToken
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            cartDeliveryDate(mutationData)
                        ];
                    case 2:
                        resCartDeliveryDate = _state.sent();
                        ref1 = (ref = resCartDeliveryDate.data) === null || ref === void 0 ? void 0 : ref.cartDeliveryDate.cart, cartLines = ref1.cartLines, cartId = ref1.bigcommerceId, subtotalExTax = ref1.subtotalExTax, totalExTax = ref1.totalExTax, deliveryDate = ref1.deliveryDate, deliveryDateOptions = ref1.deliveryDateOptions, multipleDeliveryDates = ref1.multipleDeliveryDates, discountAmount = ref1.discountAmount, deliveryType = ref1.deliveryType, deliverySchedules = ref1.deliverySchedules, notifications = ref1.notifications;
                        bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
                        setLoaderActive(false);
                        if (!cartId) {
                            console.log("\uD83D\uDFE0 resCartDeliveryDate returned cart data without bigcommerceId");
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setLoaderActive(false);
                        console.log("Error trying to selectDay", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(date) {
            return _ref.apply(this, arguments);
        };
    }(), [
        bulkUpdateCart,
        cartDeliveryDate,
        setLoaderActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* CardListItem */.xI, {
                    className: "small",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order_title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    t("account.order.order_details.payment_summary"),
                                    " (",
                                    cartLines.length,
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: t("account.order.order_details.subtotal_products")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    typeof subtotalExTax === "number" && (0,utils.currencyFormatter)({
                                                        price: subtotalExTax,
                                                        localeRegion: locale,
                                                        round: false,
                                                        trailingZeros: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            " +",
                                                            t("account.order.taxes")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    promotions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: t("account.order.order_details.discount")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    promotionType === "percentage" ? "".concat(Number(promotionAmount), "%") : "".concat(Number(promotionAmount), "€"),
                                                    " ",
                                                    promotionType === "percentage" && " (-".concat(Number(promotionSaved), " €)")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: t("account.order.order_details.shipment")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: t("commons.cart.free")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: t("account.order.order_details.total_products")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    typeof totalExTax === "number" && (0,utils.currencyFormatter)({
                                                        price: totalExTax,
                                                        localeRegion: locale,
                                                        round: false,
                                                        trailingZeros: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            " +",
                                                            t("account.order.taxes")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        deliveryDate && !agency && Array.isArray(cartLines) && cartLines.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "delivery-date",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpanDeliveryDate, {
                                children: [
                                    (0,utils.getDynamicText)(t("cart.delivery_date"), {
                                        deliveryDate: (0,utils.getDateFormatted)(locale, dateSelectedByUser !== null && dateSelectedByUser !== void 0 ? dateSelectedByUser : deliveryDate)
                                    }),
                                    !multipleDeliveryDates ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanDeliveryDate, {
                                        className: "opacity",
                                        children: (0,utils.getDynamicText)(t("cart.delivery_date_".concat((ref = cartLines[0]) === null || ref === void 0 ? void 0 : ref.variant.deliveryType)), {
                                            deliveryDate: (0,utils.getDateFormatted)(locale, dateSelectedByUser !== null && dateSelectedByUser !== void 0 ? dateSelectedByUser : deliveryDate),
                                            onDemandDay: (0,utils.getDayOfWeekName)(locale, (ref1 = cartLines[0]) === null || ref1 === void 0 ? void 0 : ref1.variant.onDemandDay),
                                            deliveryHour: ((ref2 = cartLines[0]) === null || ref2 === void 0 ? void 0 : ref2.variant.deliveryType) === "on_demand" ? "14h" : "21h"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanDeliveryDate, {
                                        className: "opacity",
                                        children: (0,utils.getDynamicText)(t("cart.delivery_date_".concat(orderedCartLines.variant.deliveryType)), {
                                            deliveryDate: (0,utils.getDateFormatted)(locale, dateSelectedByUser !== null && dateSelectedByUser !== void 0 ? dateSelectedByUser : deliveryDate),
                                            onDemandDay: (0,utils.getDayOfWeekName)(locale, orderedCartLines.variant.onDemandDay),
                                            deliveryHour: orderedCartLines.variant.deliveryType === "on_demand" ? "14h" : "21h"
                                        })
                                    })
                                ]
                            })
                        }),
                        agency && Array.isArray(cartLines) && cartLines.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "delivery-date",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanDeliveryDate, {
                                children: agencyText
                            })
                        })
                    ]
                }),
                moneySaved > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTooltip, {
                    variants: listVariants,
                    $moneySaved: moneySaved,
                    initial: "inactive",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("cart.order_saved"),
                            " ",
                            (0,utils.currencyFormatter)({
                                price: moneySaved,
                                localeRegion: locale
                            })
                        ]
                    })
                }),
                !agency && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryCalendar, {
                    deliveryDateOptions: deliveryDateOptions,
                    onSelectedDay: onSelectedDay,
                    defaultDeliveryDate: deliveryDate
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                    disabled: isDisabled,
                    onClick: onClickCheckout,
                    bgType: "red",
                    children: t("commons.actions.next")
                }),
                blockedMinimumPurchase && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTooltip, {
                    variants: listVariants,
                    initial: "inactive",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("cart.minimum_order"),
                            " ",
                            (0,utils.currencyFormatter)({
                                price: numberMinimPurchase,
                                localeRegion: locale
                            })
                        ]
                    })
                })
            ]
        })
    });
});
var CartTooltip = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "CartSummary__CartTooltip",
    componentId: "sc-38f30a4b-0"
})(CartSummary_templateObject(), function(param) {
    var theme = param.theme, $moneySaved = param.$moneySaved;
    return $moneySaved ? theme.colors.creme : theme.colors.red;
}, function(param) {
    var $moneySaved = param.$moneySaved;
    return $moneySaved ? "100%" : "50%";
}, (0,styles.vw)(21, "mobile"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(21, "nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(21, "desktop"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), function(param) {
    var theme = param.theme, $moneySaved = param.$moneySaved;
    return $moneySaved ? theme.colors.creme : theme.colors.red;
}, (0,styles.vw)(-18, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(-18, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), function(param) {
    var theme = param.theme, $moneySaved = param.$moneySaved;
    return $moneySaved ? theme.colors.creme : theme.colors.red;
}, (0,styles.vw)(-18, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme, $moneySaved = param.$moneySaved;
    return $moneySaved ? theme.colors.creme : theme.colors.red;
}, (0,styles.getP12_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CartWrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "CartSummary__CartWrapper",
    componentId: "sc-38f30a4b-1"
})(CartSummary_templateObject1(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP15_1B)(), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .1);
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP10_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_2)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});
var SpanDeliveryDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CartSummary__SpanDeliveryDate",
    componentId: "sc-38f30a4b-2"
})(_templateObject2(), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(95163);
;// CONCATENATED MODULE: ./components/cart/CartList.tsx
/* eslint-disable indent */ 




function CartList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-column: 1 / span 6;\n  height: fit-content;\n  margin: ",
        ";\n\n  ",
        " {\n    margin: ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 2 / span 6;\n    margin: 0;\n    min-height: 200px;\n    overflow: hidden;\n  }\n\n  dt {\n    color: ",
        ";\n    margin: ",
        " 0 ",
        " ",
        ";\n\n    ",
        " {\n      margin: ",
        " 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      margin: ",
        " 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      margin: 40px 0 8px 20px;\n    }\n  }\n\n  dl {\n    > div {\n      &:first-child {\n        > dt {\n          margin-top: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    CartList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  background-color: ",
        ";\n  column-gap: ",
        ";\n  display: grid;\n  grid: auto-flow / repeat(6,1fr);\n  min-height: ",
        ";\n  padding: ",
        ";\n  position: relative;\n\n  ",
        " {\n    column-gap: ",
        ";\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    column-gap: ",
        ";\n    min-height: ",
        ";\n    padding:",
        ";\n  }\n\n  ",
        " {\n    column-gap: 10px;\n    min-height: 100px;\n    padding: 20px;\n  }\n\n  &:first-of-type {\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n\n    ",
        " {\n      border-top-left-radius: ",
        ";\n      border-top-right-radius: ",
        ";\n    }\n\n    ",
        " {\n      border-top-left-radius: ",
        ";\n      border-top-right-radius: ",
        ";\n    }\n\n    ",
        " {\n      border-top-left-radius: 20px;\n      border-top-right-radius: 20px;\n    }\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    ",
        " {\n      border-bottom-left-radius: ",
        ";\n      border-bottom-right-radius: ",
        ";\n    }\n\n    ",
        " {\n      border-bottom-left-radius: ",
        ";\n      border-bottom-right-radius: ",
        ";\n    }\n\n    ",
        " {\n      border-bottom-left-radius: 20px;\n      border-bottom-right-radius: 20px;\n    }\n  }\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .price_wrapper {\n    grid-area: 2 / 5 / span 1 / span 2;\n    justify-self: flex-end;\n    text-align: right;\n    width: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      grid-area: 1 / 6 / span 1 / span 1;\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 95px;\n    }\n\n    div:first-child {\n      padding-right: 0;\n      padding-bottom: 0;\n    }\n\n    button:last-child {\n      ",
        "\n      ",
        "\n      color: ",
        ";\n      margin-top: ",
        ";\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 10px;\n      }\n    }\n    .sale {\n      >span {\n        ",
        "\n        color: ",
        ";\n\n      }\n    }\n  }\n\n  .counter-wrapper {\n    grid-area: 2 / 3 / span 1 / span 3;\n    height: 100%;\n    position: relative;\n\n    ",
        " {\n      grid-area: 1 / 4 / span 1 / span 2;\n    }\n  }\n\n  .info {\n    display: flex;\n    flex-direction: column;\n    grid-area: 1 / 3 / span 1 / span 4;\n    min-height: ",
        ";\n\n    ",
        " {\n      grid-area: 1 / 2 / span 1 / span 3;\n      min-height: ",
        ";\n    }\n    ",
        " {\n      min-height:80px;\n    }\n\n   span {\n      ",
        "\n      color: ",
        ";\n      display: block;\n    }\n\n    span:first-child:not(.label){\n      ",
        "\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 100%;\n    }\n\n    > div {\n      margin-top: ",
        ";\n      position: unset;\n      top: unset;\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 10px;\n      }\n      > span:not(.on_demand) {\n        background-color: ",
        ";\n      }\n      .on_demand {\n        ",
        "\n        color: ",
        ";\n        display: block;\n      }\n\n\n\n\n    }\n\n    .on_demand_label {\n      ",
        "\n      color: ",
        ";\n      background-color: ",
        ";\n      text-transform: uppercase;\n      border-radius: ",
        ";\n      padding: ",
        " ",
        ";\n      max-height: ",
        ";\n      display: inline-block;\n      max-width: ",
        ";\n      margin-bottom:  ",
        ";\n      margin-right:  ",
        ";\n\n      ",
        " {\n        max-width: ",
        ";\n        margin-bottom:  ",
        ";\n        margin-right:  ",
        ";\n      }\n\n      ",
        " {\n        max-width: ",
        ";\n        margin-bottom:  ",
        " ;\n        margin-right:  ",
        " ;\n      }\n\n      ",
        " {\n        max-width: 110px;\n        margin-bottom:10px ;\n        margin-right:10px ;\n\n      }\n\n      ",
        " {\n        border-radius: ",
        ";\n        padding: ",
        " ",
        ";\n        max-height: ",
        ";\n      }\n\n      ",
        " {\n        border-radius: ",
        ";\n        padding: ",
        " ",
        ";\n        max-height: ",
        ";\n      }\n\n      ",
        " {\n        border-radius: 12px;\n        padding: 5px 9px;\n        max-height: 25px;\n      }\n    }\n\n  }\n\n  figure {\n    height: ",
        ";\n    grid-area: 1 / 1 / span 1/ span 2;\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      grid-area: 1/ 1 / span 1 / span 1;\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 100px;\n      width: 100px;\n    }\n\n    &.placeholder {\n      background-color: rgba(0, 0, 0, .15);\n    }\n  }\n\n"
    ]);
    CartList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  grid-area: 3 / 1 / span 1 / span 6;\n  margin-top: ",
        ";\n  opacity: .5;\n\n  ",
        " {\n    grid-area: 2 / 2 / span 1 / span 6;\n    margin-top: ",
        ";\n  }\n"
    ]);
    CartList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: baseline;\n  display: flex;\n  grid-column: 1 / span 6;\n  justify-content: flex-end;\n  margin-top: 10px;\n\n  p {\n    font-family: ",
        ";\n    font-size: 13px;\n    color: ",
        ";\n    opacity: .7;\n    margin-left: auto;\n\n    + div {\n      padding-bottom: 0;\n      padding-right: 0;\n\n      .sale {\n        /* font-weight: 400; */\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var mediaThumbnailProductSize = "(min-width: 768px) ".concat((0,styles.vw)(100, "desktop"), ", ").concat((0,styles.vw)(30, "mobile"));
var getLabels = function(labels) {
    return labels.map(function(label, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "on_demand_label",
            children: label.name
        }, idx);
    });
};
var formatLabels = function(labels, deliveryType, onDemandText, discount) {
    var allLabels = [];
    if (labels) allLabels = (0,_to_consumable_array/* default */.Z)(labels);
    if (deliveryType === "on_demand") allLabels.push({
        name: onDemandText
    });
    if (discount > 0) allLabels.push({
        name: "".concat(discount, "%")
    });
    return allLabels;
};
var getCartLines = function(data, deleteCartLine, locale, buttonText, onDemandText, t, multipleDeliveryDates, cartDeliveryDate) {
    var groupByDateData = (0,utils.groupByDate)(data);
    return groupByDateData.map(function(cartLines, idx) {
        var ref, ref1;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                    children: multipleDeliveryDates && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartList_SpanDeliveryDate, {
                        className: "opacity",
                        children: (0,utils.getDynamicText)(t("cart.delivery_available"), {
                            deliveryDate: (0,utils.getDateFormatted)((0,utils.getLang)(locale), (ref = cartLines[0]) === null || ref === void 0 ? void 0 : ref.variant.deliveryDate),
                            onDemandDay: (0,utils.getDayOfWeekName)((0,utils.getLang)(locale), (ref1 = cartLines[0]) === null || ref1 === void 0 ? void 0 : ref1.variant.onDemandDay),
                            cartDeliveryDate: (0,utils.getDateFormatted)((0,utils.getLang)(locale), cartDeliveryDate)
                        })
                    })
                }),
                cartLines.map(function(item, idx) {
                    var ref, ref1, ref2, ref3;
                    var product = item.product, variant = item.variant, quantity = item.quantity, services = item.services;
                    var name = product.name, brand = product.brand, labels = product.labels, inventoryTracking = product.inventoryTracking;
                    var media = variant.media, price = variant.price, stock = variant.stock, deliveryType = variant.deliveryType;
                    var discount = (price || {}).discount;
                    var isFrozen = deliveryType === "frozen";
                    var test = formatLabels(labels, deliveryType, onDemandText, discount);
                    var LabelItems = getLabels(test);
                    var priceQuantity = (price === null || price === void 0 ? void 0 : price.salePrice) ? {
                        salePrice: price.salePrice * quantity,
                        retailPrice: price.retailPrice * quantity
                    } : null;
                    var priceUnit = (price === null || price === void 0 ? void 0 : price.salePrice) ? {
                        salePrice: price.salePrice,
                        retailPrice: price.retailPrice
                    } : null;
                    var service = services[0];
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dd, {
                        $frozen: isFrozen,
                        children: [
                            (media === null || media === void 0 ? void 0 : (ref = media[0]) === null || ref === void 0 ? void 0 : ref.medium) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                media: media === null || media === void 0 ? void 0 : media[0].medium,
                                quality: 50,
                                sizes: mediaThumbnailProductSize
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "placeholder"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "info",
                                children: [
                                    LabelItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "labels",
                                        children: LabelItems
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: brand === null || brand === void 0 ? void 0 : brand.name
                                    }),
                                    priceUnit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (0,utils.currencyFormatter)({
                                                price: priceUnit.salePrice,
                                                localeRegion: locale,
                                                round: false,
                                                trailingZeros: true
                                            }),
                                            "/u"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "counter-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* AddToCart */.o, {
                                    data: item,
                                    isPDP: false,
                                    isCart: true,
                                    notAvailable: price === null && stock > 0,
                                    inventoryTracking: inventoryTracking,
                                    frozen: isFrozen
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price_wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Price, {
                                        type: "cart",
                                        price: priceQuantity,
                                        displayRetailPrice: false,
                                        round: false,
                                        pricePer: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            deleteCartLine(variant.id);
                                        },
                                        children: buttonText
                                    })
                                ]
                            }),
                            service && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivServices, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            service.quantity,
                                            "x ",
                                            service === null || service === void 0 ? void 0 : (ref1 = service.product) === null || ref1 === void 0 ? void 0 : ref1.name,
                                            " \xb7 ",
                                            service === null || service === void 0 ? void 0 : (ref2 = service.variant) === null || ref2 === void 0 ? void 0 : ref2.name
                                        ]
                                    }),
                                    (service === null || service === void 0 ? void 0 : (ref3 = service.variant) === null || ref3 === void 0 ? void 0 : ref3.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Price, {
                                        type: "cart",
                                        price: {
                                            salePrice: service === null || service === void 0 ? void 0 : service.extendedSalePrice
                                        },
                                        displayRetailPrice: false,
                                        round: false,
                                        pricePer: ""
                                    })
                                ]
                            })
                        ]
                    }, "".concat(idx, "-").concat(variant.id));
                })
            ]
        }, idx);
    });
};
var CartList = /*#__PURE__*/ (0,react.memo)(function() {
    var locale = (0,router.useRouter)().locale;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,dist_hooks.useCart)(), bulkUpdateCart = ref.bulkUpdateCart, multipleDeliveryDates = ref.multipleDeliveryDates, cartLines = ref.cartLines, cartDeliveryDate = ref.deliveryDate;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_DELETE_FROM_CART */.PO), 2), cartLinesDelete = ref1[0], ref2 = ref1[1], dataAfterDelete = ref2.data;
    var deleteCartLine = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variantId) {
            var DYCustomerToken;
            return (0,tslib_es6.__generator)(this, function(_state) {
                DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                try {
                    cartLinesDelete({
                        variables: {
                            variantId: variantId
                        },
                        context: {
                            isPrivatePath: true,
                            DYCustomerToken: DYCustomerToken
                        }
                    });
                // deleteFromCart(variantId)
                } catch (e) {
                    console.error(e);
                }
                return [
                    2
                ];
            });
        });
        return function(variantId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cartLinesDelete
    ]);
    var CartLinesGroupedByDate = (0,react.useMemo)(function() {
        return getCartLines(cartLines, deleteCartLine, locale, t("commons.actions.delete"), t("product_page.product.demand_product"), t, multipleDeliveryDates, cartDeliveryDate);
    }, [
        cartLines,
        deleteCartLine,
        locale,
        multipleDeliveryDates,
        t,
        cartDeliveryDate
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!dataAfterDelete) return;
        var cartRes = dataAfterDelete === null || dataAfterDelete === void 0 ? void 0 : (ref = dataAfterDelete.cartLinesDelete) === null || ref === void 0 ? void 0 : ref.cart;
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterDelete", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes", multipleDeliveryDates);
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterDelete
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
            children: CartLinesGroupedByDate
        })
    });
});
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "CartList__Section",
    componentId: "sc-3292c3b8-0"
})(CartList_templateObject(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(50, "mobile"), (0,styles.vw)(8, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "tablet"), (0,styles.vw)(8, "tablet"), (0,styles.vw)(20, "tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(8, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));
var Dd = styled_components_browser_esm["default"].dd.withConfig({
    displayName: "CartList__Dd",
    componentId: "sc-3292c3b8-1"
})(CartList_templateObject1(), function(param) {
    var $frozen = param.$frozen, theme = param.theme;
    return $frozen ? "#e1f2ff" : theme.colors.white;
}, (0,styles.vw)(10, "mobile"), (0,styles.vw)(90, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(156, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "tablet"), (0,styles.vw)(20, "tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "tablet"), (0,styles.vw)(20, "tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return (0,styles.hex2Rgba)($frozen ? theme.colors.dark_frozen : theme.colors.darkred, .1);
}, (0,styles.vw)(150, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(150, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(95, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_1)(), (0,styles.createUnderline)({
    color: "darkcreme"
}), function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_3)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1B)(), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? theme.colors.frozen : theme.colors.red;
}, (0,styles.getP18_1)(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.red, .2);
}, (0,styles.getP15_1B)(), function(param) {
    var theme = param.theme;
    return theme.colors.orange;
}, (0,styles.getP12_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
}, (0,styles.vw)(12, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(9, "mobile"), (0,styles.vw)(25, "mobile"), (0,styles.vw)(97, "mobile"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(97, "nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(110, "desktop"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(9, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(9, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(100, "mobile"), (0,styles.vw)(100, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(100, "nexus7"), (0,styles.vw)(100, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "desktop"), (0,styles.vw)(100, "desktop"), styles.mq.greaterThan("desktop"));
var CartList_SpanDeliveryDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CartList__SpanDeliveryDate",
    componentId: "sc-3292c3b8-2"
})(CartList_templateObject2(), (0,styles.getP10_1)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"));
var DivServices = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CartList__DivServices",
    componentId: "sc-3292c3b8-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});

;// CONCATENATED MODULE: ./components/cart/sharedCartStyles.ts

function sharedCartStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;"
    ]);
    sharedCartStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sharedCartStyles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  color: ",
        ";\n  display: flex;\n  ",
        "\n  font-weight: bold;\n  padding: ",
        " ",
        " ",
        ";\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: ",
        ";\n  grid-row-gap: ",
        ";\n\n  ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n    grid-column-gap: ",
        ";\n    grid-row-gap: ",
        ";\n  }\n\n  ",
        " {\n    padding: ",
        " ",
        " ",
        ";\n    grid-column-gap: ",
        ";\n    grid-row-gap: ",
        ";\n  }\n\n  ",
        " {\n    padding: 18px 18px 22px;\n    grid-column-gap: 10px;\n    grid-row-gap: 15px;\n  }\n\n  ",
        ";\n\n  > span:nth-child(2) {\n    justify-self: end;\n    color: ",
        ";\n  }\n\n  > button {\n    font-weight: 700;\n    width: 100%;\n\n    ",
        " {\n      padding: 0;\n      height: ",
        ";\n      max-width: ",
        ";\n    }\n\n    ",
        " {\n      height: 39px;\n      max-width: 130px;\n    }\n\n    > div:last-of-type {\n      ",
        "\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      width: 75%;\n      height: auto;\n      display: inline;\n    }\n  }\n"
    ]);
    sharedCartStyles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sharedCartStyles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    sharedCartStyles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ModalSummary = (0,styled_components_browser_esm["default"])(motion/* motion.dt */.E.dt).withConfig({
    displayName: "sharedCartStyles__ModalSummary",
    componentId: "sc-3b3ad548-0"
})(sharedCartStyles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.red, .1);
}, function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP18_2)(), (0,styles.vw)(18, "mobile"), (0,styles.vw)(18, "mobile"), (0,styles.vw)(22, "mobile"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(18, "nexus7"), (0,styles.vw)(18, "nexus7"), (0,styles.vw)(22, "nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(22, "desktop"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $type = param.$type;
    return $type === "new" && (0,styled_components_browser_esm.css)(sharedCartStyles_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(39, "desktop"), (0,styles.vw)(130, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_1)());
var _Price = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "sharedCartStyles___Price",
    componentId: "sc-3b3ad548-1"
})(sharedCartStyles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP12)());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/index.ts + 74 modules
var components_0 = __webpack_require__(83242);
;// CONCATENATED MODULE: ./components/cart/cartVariants.ts



var transition = (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5));
var listVariants = {
    inactive: {
        opacity: 0,
        transition: transition
    },
    enter: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
            staggerChildren: .01
        })
    },
    exit: {
        opacity: 0,
        transition: transition
    }
};
var itemVariants = {
    inactive: {
        y: -10,
        opacity: 0,
        transition: transition
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: transition
    },
    exit: {
        y: -10,
        opacity: 0,
        transition: transition
    }
};

;// CONCATENATED MODULE: ./components/cart/CartItem.tsx



function CartItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "border-top-left-radius: 20px; border-top-right-radius: 20px;"
    ]);
    CartItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-bottom: ",
        ";\n  min-height: ",
        ";\n  overflow-x: hidden;\n  transition: 300ms opacity ",
        ";\n  width: 100%;\n\n  ",
        " {\n    padding-bottom: ",
        ";\n    min-height: ",
        ";\n  }\n\n  ",
        " {\n    padding-bottom: ",
        ";\n    min-height: ",
        ";\n  }\n\n  ",
        " {\n    padding-bottom: 10px;\n    min-height: 55px;\n  }\n\n  &:first-of-type {\n    padding-top: ",
        ";\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: 20.5px;\n    }\n\n    ",
        ";\n  }\n\n  &:last-child {\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 30px;\n    }\n\n\n  }\n\n  article {\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0 ",
        ";\n\n    ",
        " {\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 20px;\n    }\n  }\n\n  .info {\n    align-items: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    padding-left: ",
        ";\n    width: 80%;\n\n    ",
        " {\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      padding-left: 20px;\n    }\n\n    > div {\n      display: flex;\n      flex-wrap: nowrap;\n      width: 100%;\n\n      h5, .total {\n        width: auto;\n        max-width: 100%;\n      }\n\n      h5 {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 100%;\n      }\n\n      .total {\n        font-weight: bold;\n        flex-shrink: 0;\n        margin-left: ",
        ";\n        width: auto;\n\n        ",
        " {\n          margin-left: ",
        ";\n        }\n\n        ",
        " {\n          margin-left: ",
        ";\n        }\n\n        ",
        " {\n          margin-left: 20px;\n        }\n      }\n    }\n\n    h5, .total, span {\n      ",
        "\n      font-family: ",
        ";\n      color: ",
        ";\n      text-align: left;\n    }\n\n    span {\n      font-weight: 500;\n      width: 100%;\n    }\n  }\n\n  .product__price {\n    p {\n      ",
        "\n\n      .value,\n      .decimals,\n      .unit {\n        ",
        "\n        font-family: ",
        ";\n        font-weight: 500;\n      }\n    }\n  }\n\n  .product_image {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    height: ",
        ";\n    overflow: hidden;\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 55px;\n      width: 55px;\n    }\n\n    &.placeholder {\n      background-color: rgba(0, 0, 0, .15);\n    }\n\n    img {\n      height: ",
        ";\n      object-fit: contain;\n      object-position: center;\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 55px;\n        width: 55px;\n      }\n    }\n  }\n\n  .total {\n    margin-bottom: 0;\n  }\n"
    ]);
    CartItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var cartItemSizes = "(min-width: 768px) ".concat((0,styles.vw)(55, "desktop"), ", ").concat((0,styles.vw)(55, "mobile"));
var CartItem = /*#__PURE__*/ (0,react.memo)(function(param) {
    var product = param.product, id = param.id, onClick = param.onClick, _type = param.type, type = _type === void 0 ? "all" : _type;
    var ref;
    var locale = (0,router.useRouter)().locale;
    var cartItemProduct = product.product, variant = product.variant, quantity = product.quantity;
    var name = cartItemProduct.name;
    var media = variant.media, price = variant.price;
    var priceQuantity = (price === null || price === void 0 ? void 0 : price.salePrice) ? {
        salePrice: price.salePrice * quantity,
        retailPrice: price.retailPrice * quantity
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalListItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variants: itemVariants,
        id: id
    }, onClick && (0,_object_spread/* default */.Z)({}, onClick)), {
        $type: type,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            children: [
                (media === null || media === void 0 ? void 0 : (ref = media[0]) === null || ref === void 0 ? void 0 : ref.medium) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    className: "product_image",
                    media: media === null || media === void 0 ? void 0 : media[0].medium,
                    lazy: false,
                    sizes: cartItemSizes,
                    quality: 50
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: "product_image placeholder"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                    children: [
                                        quantity,
                                        " x ",
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "total",
                                    children: priceQuantity && (0,utils.currencyFormatter)({
                                        price: priceQuantity.retailPrice,
                                        localeRegion: locale,
                                        round: false,
                                        trailingZeros: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_0._Price, {
                            children: [
                                (0,utils.currencyFormatter)({
                                    price: price === null || price === void 0 ? void 0 : price.retailPrice,
                                    localeRegion: locale,
                                    round: false,
                                    trailingZeros: true
                                }),
                                "/ud."
                            ]
                        })
                    ]
                })
            ]
        })
    }));
});
var ModalListItem = (0,styled_components_browser_esm["default"])(motion/* motion.dd */.E.dd).withConfig({
    displayName: "CartItem__ModalListItem",
    componentId: "sc-efc121bf-0"
})(CartItem_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
}, (0,styles.vw)(10, "mobile"), (0,styles.vw)(55, "mobile"), function(param) {
    var ease = param.ease;
    return ease;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(55, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(55, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20.5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20.5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20.5, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $type = param.$type;
    return $type === "new" && (0,styled_components_browser_esm.css)(CartItem_templateObject());
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12)(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP12)(), (0,styles.getP12)(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, (0,styles.vw)(55, "mobile"), (0,styles.vw)(55, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(55, "nexus7"), (0,styles.vw)(55, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(55, "desktop"), (0,styles.vw)(55, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(55, "mobile"), (0,styles.vw)(55, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(55, "nexus7"), (0,styles.vw)(55, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(55, "desktop"), (0,styles.vw)(55, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/cart/CartItemsAll.tsx

function CartItemsAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "pointer-events: initial; user-select: initial;"
    ]);
    CartItemsAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartItemsAll_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  height: 100dvh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  position: fixed;\n  user-select: none;\n  pointer-events: none;\n  transition: opacity 300ms ",
        ";\n  z-index: 400;\n\n  ",
        ";\n"
    ]);
    CartItemsAll_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartItemsAll_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: ",
        ";\n  top: 70px;\n  transition: 300ms top ease-out;\n  z-index: 5000;\n\n  ",
        " {\n    right: ",
        ";\n  }\n\n  ",
        " {\n    right: ",
        ";\n    top: ",
        ";\n  }\n\n  ",
        " {\n    right: 15px;\n    top: ",
        ";\n  }\n\n  ",
        " {\n    right: calc((100% - 1610px) / 2);\n  }\n\n\n  &:before {\n    border-bottom: ",
        " solid ",
        ";\n    border-left: ",
        " solid transparent;\n    border-right: ",
        " solid transparent;\n    top: -",
        ";\n    content: '';\n    height: 0;\n    position: absolute;\n    right: ",
        ";\n    width: 0;\n\n    ",
        " {\n      border-bottom: ",
        " solid ",
        ";\n      border-left: ",
        " solid transparent;\n      border-right: ",
        " solid transparent;\n      top: -",
        ";\n      right: ",
        ";\n    }\n\n    ",
        " {\n      border-bottom: ",
        " solid ",
        ";\n      border-left: ",
        " solid transparent;\n      border-right: ",
        " solid transparent;\n      top: -",
        ";\n      right: ",
        ";\n    }\n\n    ",
        " {\n      border-bottom: 10px solid ",
        ";\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      top: -8px;\n      right: 20px;\n    }\n  }\n"
    ]);
    CartItemsAll_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CartItemsAll_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  box-shadow: 0 10px 20px 0 ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  height: auto;\n  justify-content: flex-start;\n  width: ",
        ";\n  position: relative;\n  overflow: scroll;\n\n  ",
        "\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    display: flex;\n    max-height: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    max-height: 370px;\n    width: 308px;\n  }\n"
    ]);
    CartItemsAll_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var getProducts = function(products, push, urlHref) {
    return products.map(function(product, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem, {
            product: product,
            id: "cartitem-".concat(idx),
            onClick: function() {
                return push(urlHref);
            }
        }, "cartitem-".concat(idx));
    });
};
var cartUrl = {
    cart_url: "/cart",
    checkout_url: "https://localhost:3000/checkout"
};
var CartItemsAll = /*#__PURE__*/ (0,react.memo)(function(param) {
    var showCart = param.showCart, setShowCart = param.setShowCart, hasBanners = param.hasBanners;
    var scrollState = (0,dist_hooks.useScrollTracker)(1);
    var ref = (0,router.useRouter)(), localeRouter = ref.locale, push = ref.push, pathname = ref.pathname;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var locale = (0,utils.getLang)(localeRouter);
    var ref1 = (0,react.useState)([]), products = ref1[0], setProducts = ref1[1];
    var ref2 = (0,dist_hooks.useCart)(), cartLines = ref2.cartLines, subtotalExTax = ref2.subtotalExTax;
    (0,react.useEffect)(function() {
        if (cartLines) setProducts(cartLines);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartLines
    ]);
    var Products = (0,react.useMemo)(function() {
        return products && getProducts(products, push, cartUrl.cart_url);
    }, [
        push,
        products
    ]);
    if (!Products) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: showCart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAllOverlay, {
                    $active: showCart,
                    onMouseEnter: function() {
                        return setShowCart(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAllListWrapper, {
                    $scrollTop: scrollState === "TOP",
                    $hasBanners: hasBanners,
                    variants: listVariants,
                    initial: "inactive",
                    animate: "enter",
                    exit: "exit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAllList, {
                        variants: listVariants,
                        initial: "inactive",
                        animate: "enter",
                        exit: "exit",
                        children: [
                            Products,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalSummary, {
                                variants: itemVariants,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("commons.cart.total"),
                                            " (",
                                            Products.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,utils.currencyFormatter)({
                                            price: subtotalExTax,
                                            localeRegion: locale,
                                            round: false,
                                            trailingZeros: true
                                        })
                                    }),
                                    !pathname.includes("cart") && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                                        outline: true,
                                        onClick: function() {
                                            window.location.href = "https://".concat(utils.HOSTNAME, "/cart?d=").concat(Date.now());
                                        },
                                        bgType: "red",
                                        children: t("commons.cart.show_cart")
                                    })
                                ]
                            }, "summary")
                        ]
                    }, "itemsincart")
                })
            ]
        })
    });
});
var ModalAllOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CartItemsAll__ModalAllOverlay",
    componentId: "sc-45df40ed-0"
})(CartItemsAll_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var $active = param.$active;
    return $active && (0,styled_components_browser_esm.css)(CartItemsAll_templateObject());
});
var ModalAllListWrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "CartItemsAll__ModalAllListWrapper",
    componentId: "sc-45df40ed-1"
})(CartItemsAll_templateObject2(), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), function(param) {
    var $scrollTop = param.$scrollTop, $hasBanners = param.$hasBanners;
    return (0,styles.vw)($scrollTop ? $hasBanners ? 110 : 95 : 70, "desktop");
}, styles.mq.greaterThan("desktop"), function(param) {
    var $scrollTop = param.$scrollTop, $hasBanners = param.$hasBanners;
    return $scrollTop ? $hasBanners ? "110px" : "95px" : "70px";
}, styles.mq.greaterThan("desktop-wide"), (0,styles.vw)(10, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
}, (0,styles.vw)(9, "mobile"), (0,styles.vw)(9, "mobile"), (0,styles.vw)(8, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
}, (0,styles.vw)(9, "nexus7"), (0,styles.vw)(9, "nexus7"), (0,styles.vw)(8, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
}, (0,styles.vw)(9, "desktop"), (0,styles.vw)(9, "desktop"), (0,styles.vw)(8, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.greylight;
});
var ModalAllList = (0,styled_components_browser_esm["default"])(motion/* motion.dl */.E.dl).withConfig({
    displayName: "CartItemsAll__ModalAllList",
    componentId: "sc-45df40ed-2"
})(CartItemsAll_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .1);
}, (0,styles.vw)(308, "mobile"), (0,styles.hideScrollbar)(), styles.mq.greaterThan("nexus7"), (0,styles.vw)(308, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(370, "desktop"), (0,styles.vw)(308, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ./components/cart/AddToCart.tsx
var AddToCart = __webpack_require__(31112);
;// CONCATENATED MODULE: ./components/cart/CartItemsNew.tsx



function CartItemsNew_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  box-shadow: 0 10px 20px 0 ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  height: auto;\n  justify-content: flex-start;\n  pointer-events: none;\n  position: fixed;\n  right: ",
        ";\n  top: 70px;\n  transition: 300ms top ease-out;\n  user-select: none;\n  width: ",
        ";\n  z-index: 5000;\n\n\n  ",
        " {\n    right: ",
        ";\n    width: ",
        ";\n  }\n\n\n  ",
        " {\n    display: flex;\n    right: ",
        ";\n    top: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    right:15px;\n    top: ",
        ";\n    width:308px;\n\n  }\n\n  ",
        " {\n    right: calc((100% - 1575px) / 2);\n  }\n\n\n  > dt,\n  > dd {\n    background-color: ",
        ";\n    width: 100%;\n  }\n"
    ]);
    CartItemsNew_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CartItemsNew_getProducts = function(products) {
    return products.map(function(product, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem, {
            product: product,
            id: "cartitem-".concat(idx),
            type: "new"
        }, "cartitem-".concat(idx));
    });
};
var CartItemsNew = /*#__PURE__*/ (0,react.memo)(function(param) {
    var products = param.products, hasBanners = param.hasBanners;
    var scrollState = (0,dist_hooks.useScrollTracker)(1);
    var ref = (0,router.useRouter)(), localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var Products = (0,react.useMemo)(function() {
        return CartItemsNew_getProducts(products.slice(0, 5));
    }, [
        products
    ]);
    var setCartItems = ((0,react.useContext)(AddToCart/* NewCartItemsContext */.K) || {}).setCartItems;
    var ref1 = (0,react.useState)(0), clickTimestamp = ref1[0], setClickTimestamp = ref1[1];
    var ref2 = (0,react.useState)(null), timeoutId = ref2[0], setTimeoutId = ref2[1];
    var subtotalExTax = (0,dist_hooks.useCart)().subtotalExTax;
    (0,react.useEffect)(function() {
        if (products.length > 0) {
            var now = Date.now();
            if (timeoutId && now - clickTimestamp < 900) clearTimeout(timeoutId);
            var newTimeoutId = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setCartItems([]);
                    return [
                        2
                    ];
                });
            }), 2000);
            setTimeoutId(newTimeoutId);
            setClickTimestamp(now);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        products.length
    ]);
    (0,react.useEffect)(function() {
        // Clean up the timeout when the component unmounts
        return function() {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        timeoutId
    ]);
    if (!Products) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: products.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalNewList, {
            variants: listVariants,
            initial: "inactive",
            animate: "enter",
            exit: "exit",
            $hasBanners: hasBanners,
            $scrollTop: scrollState === "TOP",
            children: [
                Products,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalSummary, {
                    variants: itemVariants,
                    $type: "new",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("commons.cart.total"),
                                " (",
                                products.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: typeof subtotalExTax === "number" && (0,utils.currencyFormatter)({
                                price: subtotalExTax,
                                localeRegion: locale,
                                round: false,
                                trailingZeros: true
                            })
                        })
                    ]
                }, "itemincart-dt")
            ]
        }, "itemsincart")
    });
});
var ModalNewList = (0,styled_components_browser_esm["default"])(motion/* motion.dl */.E.dl).withConfig({
    displayName: "CartItemsNew__ModalNewList",
    componentId: "sc-b8dfc83b-0"
})(CartItemsNew_templateObject(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .1);
}, (0,styles.vw)(5, "mobile"), (0,styles.vw)(300, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(300, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), function(param) {
    var $scrollTop = param.$scrollTop, $hasBanners = param.$hasBanners;
    return (0,styles.vw)($scrollTop ? $hasBanners ? 110 : 95 : 70, "desktop");
}, (0,styles.vw)(308, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $scrollTop = param.$scrollTop, $hasBanners = param.$hasBanners;
    return $scrollTop ? $hasBanners ? "110px" : "95px" : "70px";
}, styles.mq.greaterThan("desktop-wide"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});

;// CONCATENATED MODULE: ./components/cart/RepeatOrder.tsx













var checkOrderLineAvailability = function(orderLines) {
    var disabled = false;
    orderLines.forEach(function(orderLine) {
        if (!orderLine.variant || orderLine.variant.importStatus === "archived" || orderLine.variant.importStatus === "to_delete") {
            disabled = true;
        }
    });
    return disabled;
};
var RepeatOrder = /*#__PURE__*/ (0,react.memo)(function(param) {
    var orderLines = param.orderLines;
    var setCartItems = ((0,react.useContext)(components_0.NewCartItemsContext) || {}).setCartItems;
    var addToast = (0,dist_hooks.useToast)().addToast;
    var bulkUpdateCart = (0,dist_hooks.useCart)().bulkUpdateCart;
    var t = (0,hooks/* useTranslator */.I4)().t;
    // graphQL mutations
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_BULK_ADD_TO_CART */.fX), 1), cartLinesAdd = ref[0];
    var roundUpMultiple = function(num, multipleNumber) {
        return num + (multipleNumber - num % multipleNumber) % multipleNumber;
    };
    var onClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(orderLines) {
            var DYCustomerToken, discardedOrderLines, mutationData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        discardedOrderLines = false;
                        mutationData = {
                            variables: {
                                cartLines: orderLines.map(function(item) {
                                    var quantity = item.quantity, variant = item.variant, product = item.product;
                                    if (!variant || !product) {
                                        discardedOrderLines = true;
                                        return false;
                                    }
                                    var stock = variant.stock, minSaleUnits = variant.minSaleUnits, importStatus = variant.importStatus;
                                    var inventoryTracking = product === null || product === void 0 ? void 0 : product.inventoryTracking;
                                    var quantityItem = quantity;
                                    if (!stock && inventoryTracking || importStatus === "archived" || importStatus === "to_delete") {
                                        discardedOrderLines = true;
                                        return false;
                                    } else if (stock < quantity && stock % minSaleUnits === 1) {
                                        //PENDING TO DO implement roundDownMultiple, para añadir el mínimo posible
                                        discardedOrderLines = true;
                                        return false;
                                    } else if (stock >= quantity && quantity % minSaleUnits === 1) {
                                    //do nothing here
                                    } else if (stock >= quantity && quantity < minSaleUnits) {
                                        quantityItem = roundUpMultiple(quantity, minSaleUnits);
                                    }
                                    return {
                                        variantId: item.variant.id,
                                        quantity: quantityItem,
                                        cartLineType: utils.CART_LINE_TYPE.PHYSICAL
                                    };
                                }).filter(Boolean)
                            },
                            context: {
                                isPrivatePath: true,
                                DYCustomerToken: DYCustomerToken
                            }
                        };
                        return [
                            4,
                            cartLinesAdd(mutationData).then(function(res) {
                                var _cart = res.data.cartLinesAdd.cart, cartLines = _cart.cartLines, cartId = _cart.bigcommerceId, subtotalExTax = _cart.subtotalExTax, totalExTax = _cart.totalExTax, deliveryDate = _cart.deliveryDate, deliveryDateOptions = _cart.deliveryDateOptions, multipleDeliveryDates = _cart.multipleDeliveryDates, discountAmount = _cart.discountAmount, deliveryType = _cart.deliveryType, deliverySchedules = _cart.deliverySchedules, notifications = _cart.notifications;
                                bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
                                setCartItems(cartLines);
                                addToast({
                                    message: t("account.order.repeat_order_feedback.success"),
                                    type: "success"
                                });
                                if (discardedOrderLines) console.info("Some order lines were discarded due to lack of stock or archived");
                            }).catch(function(error) {
                                console.warn("Error with mutation: cartLinesAdd:", error);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(orderLines) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToast,
        bulkUpdateCart,
        cartLinesAdd,
        setCartItems,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
        disabled: checkOrderLineAvailability(orderLines),
        onClick: function() {
            return onClick(orderLines);
        },
        bgType: "red",
        outline: true,
        children: t("account.repeat_order")
    });
});

;// CONCATENATED MODULE: ./components/cart/index.ts










/***/ }),

/***/ 17482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FormNewsletter; },
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63955);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2722);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92757);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  button {\n    &[type='submit'] {\n      margin-left: ",
        ";\n\n      ",
        " {\n        margin-left: ",
        ";\n      }\n\n      ",
        " {\n        margin-left: ",
        ";\n      }\n    }\n  }\n\n  > div {\n    align-items: flex-end;\n    display: flex;\n  }\n\n  legend > h2 {\n    margin-bottom: ",
        ";\n  }\n\n  .input--newsletter {\n    margin-bottom: 0;\n    padding: 0;\n\n    input {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Form = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].form.withConfig({
    displayName: "FormNewsletter__Form",
    componentId: "sc-d77f84f4-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.vw)(14, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.vw)(16, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.vw)(16, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_3__.vw)(30, "desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var FormNewsletter = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _hasLegend = param.hasLegend, hasLegend = _hasLegend === void 0 ? true : _hasLegend, _inputBgColor = param.inputBgColor, inputBgColor = _inputBgColor === void 0 ? "red" : _inputBgColor, _textColor = param.textColor, textColor = _textColor === void 0 ? "white" : _textColor, _buttonBgColor = param.buttonBgColor, buttonBgColor = _buttonBgColor === void 0 ? "creme" : _buttonBgColor;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)(), register = ref.register, _formState = ref.formState, formErrors = _formState.errors, handleSubmit = ref.handleSubmit;
    var t = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTranslator */ .I4)().t;
    var addToast = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__.useToast)().addToast;
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(formData, _e) {
            var success;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.subscribe)({
                                body: formData
                            })
                        ];
                    case 1:
                        success = _state.sent();
                        if (typeof success === "boolean" && success) {
                            console.info("✅ subscribed");
                            _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.cookie.set({
                                name: "DY_MODAL_NEWSLETTER",
                                value: "true",
                                days: 2
                            });
                            addToast({
                                message: t("commons.newsletter_feedback.success"),
                                type: "info"
                            });
                        } else {
                            addToast({
                                message: t("commons.newsletter_feedback.error"),
                                type: "error"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData, _e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Form, {
        onSubmit: handleSubmit(onSubmit),
        children: [
            hasLegend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("legend", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    children: t("layout.footer.newsletter.title")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.Input, {
                        type: "email",
                        name: "email",
                        className: "input--newsletter",
                        placeholder: t("layout.footer.newsletter.input_inactive"),
                        register: register,
                        required: {
                            required: t("form.errors.pattern_email"),
                            pattern: _dy_commons_utils__WEBPACK_IMPORTED_MODULE_7__.inputPattern.email
                        },
                        error: formErrors.email,
                        placeholderVisible: true,
                        textColor: textColor,
                        bgColor: inputBgColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.Button, {
                        type: "submit",
                        bgType: buttonBgColor,
                        className: "creme",
                        children: t("layout.footer.newsletter.button")
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 80874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionBestseller": function() { return /* binding */ SectionBestseller; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../node_modules/@motionone/dom/dist/gestures/scroll/index.es.js + 6 modules
var index_es = __webpack_require__(15734);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(40226);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(23617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-scroll.mjs






const createScrollMotionValues = () => ({
    scrollX: (0,es_value/* motionValue */.B)(0),
    scrollY: (0,es_value/* motionValue */.B)(0),
    scrollXProgress: (0,es_value/* motionValue */.B)(0),
    scrollYProgress: (0,es_value/* motionValue */.B)(0),
});
function useScroll({ container, target, layoutEffect = true, ...options } = {}) {
    const values = (0,use_constant/* useConstant */.h)(createScrollMotionValues);
    const useLifecycleEffect = layoutEffect
        ? use_isomorphic_effect/* useIsomorphicLayoutEffect */.L
        : react.useEffect;
    useLifecycleEffect(() => {
        return (0,index_es/* scroll */.A)(({ x, y }) => {
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, {
            ...options,
            container: (container === null || container === void 0 ? void 0 : container.current) || undefined,
            target: (target === null || target === void 0 ? void 0 : target.current) || undefined,
        });
    }, []);
    return values;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var is_motion_value = __webpack_require__(15815);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(60976);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-value.mjs





/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = (0,use_constant/* useConstant */.h)(() => (0,es_value/* motionValue */.B)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    if (isStatic) {
        const [, setLatest] = (0,react.useState)(initial);
        (0,react.useEffect)(() => value.on("change", setLatest), []);
    }
    return value;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-on-change.mjs



function useOnChange(value, callback) {
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        if ((0,is_motion_value/* isMotionValue */.i)(value)) {
            callback(value.get());
            return value.on("change", callback);
        }
    }, [value, callback]);
}
function useMultiOnChange(values, handler, cleanup) {
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        const subscriptions = values.map((value) => value.on("change", handler));
        return () => {
            subscriptions.forEach((unsubscribe) => unsubscribe());
            cleanup();
        };
    });
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/index.mjs + 9 modules
var legacy_popmotion = __webpack_require__(36781);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-spring.mjs







/**
 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
 *
 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
 * to another `MotionValue`.
 *
 * @remarks
 *
 * ```jsx
 * const x = useSpring(0, { stiffness: 300 })
 * const y = useSpring(x, { damping: 10 })
 * ```
 *
 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
 * @param springConfig - Configuration options for the spring.
 * @returns `MotionValue`
 *
 * @public
 */
function useSpring(source, config = {}) {
    const { isStatic } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    const activeSpringAnimation = (0,react.useRef)(null);
    const value = useMotionValue((0,is_motion_value/* isMotionValue */.i)(source) ? source.get() : source);
    (0,react.useMemo)(() => {
        return value.attach((v, set) => {
            /**
             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
             * at that level, but this will work for now
             */
            if (isStatic)
                return set(v);
            if (activeSpringAnimation.current) {
                activeSpringAnimation.current.stop();
            }
            activeSpringAnimation.current = (0,legacy_popmotion/* animate */.jt)({
                keyframes: [value.get(), v],
                velocity: value.getVelocity(),
                type: "spring",
                ...config,
                onUpdate: set,
            });
            return value.get();
        });
    }, [JSON.stringify(config)]);
    useOnChange(source, (v) => value.set(parseFloat(v)));
    return value;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(83972);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs


const isCustomValueType = (v) => {
    return typeof v === "object" && v.mix;
};
const getMixer = (v) => (isCustomValueType(v) ? v.mix : undefined);
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, {
        mixer: getMixer(outputRange[0]),
        ...options,
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/index.mjs + 2 modules
var frameloop = __webpack_require__(58387);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    const value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    const updateValue = () => value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    useMultiOnChange(values, () => frameloop/* sync.update */.Z_.update(updateValue, false, true), () => frameloop/* cancelSync.update */.qY.update(updateValue));
    return value;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs




function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], ([latest]) => transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = (0,use_constant/* useConstant */.h)(() => []);
    return useCombineMotionValues(values, () => {
        latest.length = 0;
        const numValues = values.length;
        for (let i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}



// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ./components/index.ts + 74 modules
var components_0 = __webpack_require__(83242);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
;// CONCATENATED MODULE: ./components/home/SectionBestseller.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  overflow: hidden;\n  transform: translateY(-17%);\n  user-select: none;\n  pointer-events: none;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  height: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    transform: translateY(-8%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  align-items: center;\n  position: relative;\n  padding: 0;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-right: 0;\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 200px;\n    margin-top: 150px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  user-select: none;\n  pointer-events: none;\n\n  &.bestseller-left {\n    left: ",
        ";\n    top: ",
        ";\n\n    figure {\n      height: ",
        ";\n      width: ",
        ";\n    }\n  }\n\n  &.bestseller-right {\n    right: ",
        ";\n    top: ",
        ";\n\n    figure {\n      height: ",
        ";\n      width: ",
        ";\n    }\n  }\n\n  ",
        " {\n    &.bestseller-left {\n      left: ",
        ";\n      top: ",
        ";\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n      }\n    }\n\n    &.bestseller-right {\n      right: ",
        ";\n      top: ",
        ";\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 0;\n\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        " {\n    ",
        "\n    max-width: 1649px;\n    margin: 0 auto;\n  }\n\n  &:nth-last-child(2) {\n    grid-area: 1 / 1 / span 1 / span 6;\n\n    ",
        " {\n      grid-area: 1 / 1 / span 1 / span 12;\n    }\n  }\n\n  &:last-of-type {\n    grid-area: 2 / 1 / span 1 / span 6;\n    margin-top: ",
        ";\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      grid-area: 2 / 1 / span 1 / span 12;\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 100px;\n    }\n  }\n\n  .headline-wrapper {\n    color: ",
        ";\n    align-items: center;\n    display: flex;\n    grid-area: 1 / 1 / span 1 / span 3;\n    margin: 0 ",
        ";\n\n    ",
        " {\n      margin: 0 ",
        ";\n    }\n\n    ",
        " {\n      grid-area: 1 / 2 / span 1 / span 3;\n      margin: 0;\n    }\n  }\n\n  h2 {\n    ",
        "\n    text-align: center;\n  }\n\n  .slider--flickity {\n    grid-area: 1 / 1 / span 1 / span 6;\n\n    ",
        " {\n      grid-area: 1 / 1 / span 1 / span 12;\n    }\n\n    .flickity-viewport {\n      overflow:visible;\n    }\n\n    .cart-wrapper:first-of-type article {\n      width: 50vw;\n      margin-right: 0;\n      background-color: transparent;\n      border: none;\n      opacity: 0;\n      pointer-events: none;\n\n      &:hover {\n        border-color: transparent;\n      }\n\n      ",
        " {\n        width: calc(100vw / 12 * 5);\n      }\n\n      ",
        " {\n        width: calc(100vw / 12 * 5);\n      }\n\n      ",
        " {\n        width: calc(100vw / 16 * 5);\n      }\n    }\n\n    .cart-wrapper:last-of-type article {\n      background-color: transparent;\n      opacity: 0;\n      width: 0;\n\n      &:hover {\n        border-color: transparent;\n      }\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 300px;\n      }\n    }\n\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var mediaPastaLeft = {
    type: "image",
    alt: "Icon pasta 1",
    default: {
        src: "/images/svg/pasta-left.svg",
        size: {
            width: 507,
            height: 844
        }
    }
};
var mediaPastaRight = {
    type: "image",
    alt: "Icon pasta 2",
    default: {
        src: "/images/svg/pasta-right.svg",
        size: {
            width: 608,
            height: 693
        }
    }
};
var ga_list_highlighted = {
    id: "list_highlighted",
    name: "List Highlighted (slider)"
};
// const ga_list = { id: 'list_bestsellers', name: 'List Bestsellers (slider)' }
var getSlides = function(products, onClick, t) {
    return products.map(function(product, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cart-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_0.ProductCard, {
                data: product,
                onClick: function(e) {
                    e.preventDefault();
                    onClick(product, idx);
                },
                pricePer: t("product_page.product.price_per.unit"),
                lastUnits: t("product_page.product.last_units")
            })
        }, idx);
    });
};
var SectionBestseller = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,router.useRouter)(), localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var highlighted = (data || {}).highlighted;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var setCardSelected = (0,hooks/* useActiveVariant */.wT)().setCardSelected;
    var containerRef = (0,react.useRef)(null);
    var ref1 = (0,dist_hooks.useInView)({
        rootMargin: "20px",
        threshold: 0,
        triggerOnce: true
    }), ref2 = ref1.ref, inView = ref1.inView;
    var scrollYProgress = useScroll({
        target: containerRef,
        offset: [
            "start end",
            "end end"
        ]
    }).scrollYProgress;
    var spring = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });
    var translateY = useTransform(spring, [
        0,
        1
    ], [
        -250,
        0
    ]);
    var translateX = useTransform(spring, [
        0,
        1
    ], [
        70,
        -180
    ]);
    var y = useTransform(spring, [
        0,
        1
    ], [
        -340,
        -120
    ]);
    var x = useTransform(spring, [
        0,
        1
    ], [
        -200,
        250
    ]);
    var onClick = function(variant, idx) {
        setCardSelected({
            variant_id: variant === null || variant === void 0 ? void 0 : variant.bigcommerceId,
            slug: variant.product.slug[locale],
            ga_list: ga_list_highlighted,
            idx: idx
        });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const SlidesBestSeller = useMemo(() => getSlides([{}, ...topSellers, {}], onClick, t), [topSellers])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var SlidesHightlighted = (0,react.useMemo)(function() {
        return getSlides([
            {}
        ].concat((0,_to_consumable_array/* default */.Z)(highlighted), [
            {}
        ]), onClick, t);
    }, [
        highlighted
    ]);
    (0,react.useEffect)(function() {
        if (inView) {
            // pushAnalyticsEvent('view_item_list', { products: topSellers, ga_list })
            (0,utils.pushAnalyticsEvent)("view_item_list", {
                products: highlighted,
                ga_list: ga_list_highlighted
            });
        }
    }, [
        inView,
        highlighted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BestsellerSection, {
        ref: ref2,
        className: "bestseller-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PastaWrapper, {
                ref: containerRef,
                className: "pasta-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOverlay, {
                        style: {
                            translateY: translateY,
                            translateX: translateX
                        },
                        className: "bestseller-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mediaPastaLeft
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOverlay, {
                        style: {
                            y: y,
                            x: x
                        },
                        className: "bestseller-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mediaPastaRight
                        })
                    })
                ]
            }),
            highlighted.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "headline-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("home.bestseller.offer")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.SliderFlickity, {
                        className: " slider--flickity slider--product-card",
                        options: {
                            pageDots: false,
                            groupCells: "90%"
                        },
                        children: SlidesHightlighted
                    })
                ]
            })
        ]
    });
});
var PastaWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionBestseller__PastaWrapper",
    componentId: "sc-7003de91-0"
})(_templateObject(), (0,styles.vw)(882, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(1356, "desktop"));
var BestsellerSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionBestseller__BestsellerSection",
    componentId: "sc-7003de91-1"
})(_templateObject1(), (0,styles.designGrid)({}), (0,styles.vw)(70, "mobile"), (0,styles.vw)(100, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(100, "nexus7"), (0,styles.vw)(70, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(200, "desktop"), (0,styles.vw)(150, "desktop"), styles.mq.greaterThan("desktop"));
var ImageOverlay = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "SectionBestseller__ImageOverlay",
    componentId: "sc-7003de91-2"
})(_templateObject2(), (0,styles.vw)(-130, "mobile"), (0,styles.vw)(650, "mobile"), (0,styles.vw)(418, "mobile"), (0,styles.vw)(240, "mobile"), (0,styles.vw)(-40, "mobile"), (0,styles.vw)(380, "mobile"), (0,styles.vw)(391, "mobile"), (0,styles.vw)(288, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(-120, "desktop"), (0,styles.vw)(685, "desktop"), (0,styles.vw)(844, "desktop"), (0,styles.vw)(507, "desktop"), (0,styles.vw)(-70, "desktop"), (0,styles.vw)(487, "desktop"), (0,styles.vw)(842, "desktop"), (0,styles.vw)(621, "desktop"));
var ProductWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionBestseller__ProductWrapper",
    componentId: "sc-7003de91-3"
})(_templateObject3(), (0,styles.designGrid)({}), styles.mq.greaterThan("nexus7"), (0,styles.designGrid)({
    withoutGutter: true
}), styles.mq.greaterThan("desktop"), (0,styles.designGrid)({
    withoutGutter: true
}), styles.mq.greaterThan("desktop-wide"), (0,styles.designGrid)({}), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(100, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.getP53)(), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("desktop-wide"), styles.mq.greaterThan("tablet"), (0,styles.vw)(300, "desktop"), styles.mq.greaterThan("desktop"));


/***/ }),

/***/ 21535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HighlightsSection": function() { return /* binding */ HighlightsSection; },
/* harmony export */   "SectionHighlights": function() { return /* binding */ SectionHighlights; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n  height: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    margin-bottom: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    height: 715px;\n    margin-bottom:200px;\n    margin-top: 150px;\n  }\n\n  ",
        " {\n    height: 715px;\n    margin: 150px auto 200px;\n    max-width: 1650px;\n  }\n\n  > div:first-of-type {\n    height: inherit;\n  }\n\n  .contentWrapper {\n    ",
        "\n    height: inherit;\n\n    figure {\n      user-select: none;\n      pointer-events: none;\n      filter: drop-shadow(8px 13px 1px rgb(78 57 14 / 7%));\n\n      img {\n        object-fit: cover;\n        height: 100%;\n        width: 100%;\n      }\n    }\n\n    &.media {\n      color: #FFF;\n    }\n\n    &[data-length='1'] {\n\n      figure {\n        grid-area: 1 / 2 / span 1 / span 4;\n        filter: none;\n\n        &.figure--video {\n          grid-area: 1 / 1 / span 2 / span 6;\n          filter: none;\n\n          iframe {\n            width: 200% !important;\n            transform: translateX(-50%);\n          }\n        }\n\n        &.product-highlight-image-center {\n          grid-area: 1 / 1 / span 2 / span 6;\n          filter: none;\n        }\n      }\n\n      .product-highlight-pos-center {\n        grid-area: 1 / 2 / span 2 / span 4;\n        align-self: center;\n        margin: 0;\n      }\n    }\n\n    &[data-length='2'] {\n      figure:nth-of-type(1) { grid-area: 1 / 1 / span 1 / span 4; }\n\n      figure:nth-of-type(2) { grid-area: 1 / 3 / span 1 / span 4; }\n    }\n\n    &[data-length='3'] {\n      figure:nth-of-type(1) { grid-area: 1 / 1 / span 1 / span 4; }\n\n      figure:nth-of-type(2) { grid-area: 1 / 2 / span 1 / span 4; }\n\n      figure:nth-of-type(3) { grid-area: 1 / 3 / span 1 / span 4; }\n    }\n  }\n\n\n  ",
        " {\n    .contentWrapper {\n      height: unset;\n\n      &[data-length] figure {\n        filter: drop-shadow(25px 40px 4px rgb(78 57 14 / 7%));\n        height: ",
        ";\n        width: ",
        ";\n\n        &.product-highlight-image-left {\n          grid-area: 1 / 1 / span 1 / span 6;\n        }\n        &.product-highlight-image-center {\n          grid-area: 1 / 4 / span 1 / span 6;\n        }\n        &.product-highlight-image-right {\n          grid-area: 1 / 7 / span 1 / span 6;\n        }\n      }\n\n      &[data-length='1'] {\n        figure {\n          &.product-highlight-image-center {\n            grid-area: 1 / 1 / span 1 / span 12;\n            margin: 0 ",
        ";\n            width: auto;\n            filter: none;\n          }\n\n          &.figure--video {\n            grid-area: 1 / 1 / span 1 / span 12;\n\n            iframe {\n              height: 200% !important;\n              width: calc(100% - ",
        ") !important;\n              transform: translate(",
        ", -25%);\n            }\n          }\n        }\n\n        .product-highlight-pos-center {\n          grid-area: 1 / 3 / span 1 / span 8;\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    .contentWrapper {\n      height: unset;\n\n      &[data-length] figure {\n        filter: drop-shadow(25px 40px 4px rgb(78 57 14 / 7%));\n        height: 700px;\n        width: 672px;\n\n        &.product-highlight-image-left {\n          grid-area: 1 / 1 / span 1 / span 6;\n        }\n        &.product-highlight-image-center {\n          grid-area: 1 / 4 / span 1 / span 6;\n        }\n        &.product-highlight-image-right {\n          grid-area: 1 / 7 / span 1 / span 6;\n        }\n      }\n\n      &[data-length='1'] {\n        figure {\n          &.product-highlight-image-center {\n            grid-area: 1 / 1 / span 1 / span 12;\n            margin: 0 50px;\n            width: auto;\n            filter: none;\n          }\n\n          &.figure--video {\n            grid-area: 1 / 1 / span 1 / span 12;\n\n            iframe {\n              height: 200% !important;\n              width: calc(100% - 100px) !important;\n              transform: translate(50px, -25%);\n            }\n          }\n        }\n\n        .product-highlight-pos-center {\n          grid-area: 1 / 3 / span 1 / span 8;\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    .contentWrapper {\n      height: unset;\n\n      &[data-length] figure {\n        filter: drop-shadow(25px 40px 4px rgb(78 57 14 / 7%));\n        height: 700px;\n        width: ",
        ";\n\n        &.product-highlight-image-left {\n          grid-area: 1 / 1 / span 1 / span 6;\n        }\n        &.product-highlight-image-center {\n          grid-area: 1 / 4 / span 1 / span 6;\n        }\n        &.product-highlight-image-right {\n          grid-area: 1 / 7 / span 1 / span 6;\n        }\n      }\n\n      &[data-length='1'] {\n        figure {\n          &.product-highlight-image-center {\n            filter: none;\n            grid-area: 1 / 1 / span 1 / span 12;\n            margin: 0 50px;\n            width: auto;\n          }\n\n          &.figure--video {\n            grid-area: 1 / 1 / span 1 / span 12;\n\n            iframe {\n              height: 200% !important;\n              transform: translate(50px, -25%);\n              width: calc(100% - ",
        ") !important;\n            }\n          }\n        }\n\n        .product-highlight-pos-center {\n          grid-area: 1 / 3 / span 1 / span 8;\n        }\n      }\n    }\n  }\n  .slider--product-highlight {\n    .flickity-viewport,\n    .flickity-slider,\n    .flickity-cell {\n      pointer-events: none;\n    }\n\n    .flickity-cell {\n      button, a {\n        pointer-events: auto;\n      }\n    }\n  }\n  .flickity-viewport {\n    display: flex ;\n  }\n\n  .flickity-slider,\n  .flickity-cell {\n    display: grid ;\n    transform: translateX(0) !important;\n  }\n\n  .flickity-cell {\n    opacity: 0;\n    grid-column: 1/ span 1;\n    grid-row: 1/ span 1;\n    transform: translate(0, 0) !important;\n    transition: 500ms opacity linear;\n\n    h2,\n    p,\n    button {\n      opacity: 0;\n      transition: 500ms opacity linear 50ms, 600ms transform linear 50ms;\n      transform: translateY(10px);\n    }\n\n    /* h2 {\n      transition-delay: 300ms;\n    }\n\n    p {\n      transition-delay: 400ms;\n    }\n\n    button {\n      transition-delay: 500ms;\n    } */\n\n    &.is-selected {\n      opacity: 1;\n\n      h2,\n      p,\n      button {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-top: ",
        "; align-self: start;"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-bottom: ",
        "; align-self: end;"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "align-self: center;"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-top: ",
        "; align-self: start;"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-bottom: ",
        "; align-self: end;"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "align-self: center;"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "letter-spacing: -1.5px;"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-top: 60px; align-self: start;"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "padding-bottom: 70px; align-self: end;"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "align-self: center;"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: 1 / 2 / span 2 / span 4;\n  text-align: center;\n  width: 100%;\n  ",
        ";\n  z-index: 1;\n\n  ",
        " {\n    grid-area: ",
        ";\n    ",
        ";\n  }\n\n  h2 {\n    ",
        ";\n    color: ",
        ";\n  }\n\n  p {\n    font-family: ",
        ";\n    ",
        ";\n    color: ",
        ";\n    margin: ",
        " 0 ",
        ";\n  }\n\n  h2,\n  p,\n  button {\n    text-align: center;\n  }\n\n  ",
        " {\n    &.product-highlight-pos-left {\n      p {\n        &.product-highlight-align-left {\n          margin: ",
        " calc(100vw / 12) ",
        " 0;\n        }\n        &.product-highlight-align-center {\n          margin: ",
        " calc(100vw / 24) ",
        ";\n        }\n        &.product-highlight-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12);\n        }\n      }\n    }\n\n    &.product-highlight-pos-center {\n      p {\n        &.product-highlight-align-left {\n          margin: ",
        " calc(100vw / 12 * 4) ",
        " 0;\n        }\n        &.product-highlight-align-center {\n          margin: ",
        " calc(100vw / 6) ",
        ";\n        }\n        &.product-highlight-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12 * 4);\n        }\n      }\n    }\n\n    &.product-highlight-pos-right {\n      p {\n        &.product-highlight-align-left {\n          margin: ",
        " calc(100vw / 12) ",
        " 0;\n        }\n        &.product-highlight-align-center {\n          margin: ",
        " calc(100vw / 24) ",
        ";\n        }\n        &.product-highlight-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12);\n        }\n      }\n    }\n\n    .product-highlight-align-left { text-align: left; }\n    .product-highlight-align-center { text-align: center; }\n    .product-highlight-align-right { text-align: right; }\n\n    button.product-highlight-align-left { margin: 0 auto 0 0; }\n    button.product-highlight-align-right { margin: 0 0 0 auto; }\n\n    p {\n      ",
        ";\n\n      &.home-header-text-subtitle {\n        ",
        ";\n      }\n    }\n  }\n\n  ",
        " {\n      ",
        ";\n\n    &.product-highlight-pos-left {\n\n      p {\n        &.product-highlight-align-left {\n          margin: 15px calc(100vw / 12) 30px 0;\n        }\n        &.product-highlight-align-center {\n          margin: 15px calc(100vw / 24) 30px;\n        }\n        &.product-highlight-align-right {\n          margin: 15px 0 30px calc(100vw / 12);\n        }\n      }\n    }\n    &.product-highlight-pos-center {\n\n      p {\n        &.product-highlight-align-left {\n          margin: 15px calc(100vw / 12 * 4) 30px 0;\n        }\n        &.product-highlight-align-center {\n          margin: 15px calc(100vw / 6) 30px;\n        }\n        &.product-highlight-align-right {\n          margin: 15px 0 30px calc(100vw / 12 * 4);\n        }\n      }\n    }\n    &.product-highlight-pos-right {\n\n      p {\n        &.product-highlight-align-left {\n          margin:15px calc(100vw / 12) 30px 0;\n        }\n        &.product-highlight-align-center {\n          margin:15px calc(100vw / 24) 30px;\n        }\n        &.product-highlight-align-right {\n          margin:15px 0 30px calc(100vw / 12);\n        }\n      }\n    }\n\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






// interface ITimeline {
//   currentIdx: number,
//   slides: any
// }
// const Bullet = ({ idx, slidesLength, currentIdx }) => {
//   return (
//     <DivBullet style={{ width: Math.round(100 / slidesLength) + '%' }} $isActive={currentIdx === idx }  $filled={currentIdx > idx}>
//       <div className={`progress-bar ` } />
//     </DivBullet>
//   )
// }
// const Timeline = memo<ITimeline>(({ currentIdx, slides }) => {
//   return (
//     <Div >
//       {slides.map((_, idx) => <Bullet key={`${currentIdx}-${idx}`} idx={idx} slidesLength={slides.length} currentIdx={currentIdx} />)}
//     </Div>
//   )
// })
var getSlide = function(slides, push) {
    return slides.map(function(slide, idx) {
        var title = slide.title, subtitle = slide.subtitle, link = slide.link, leftImage = slide.leftImage, centerImage = slide.centerImage, rightImage = slide.rightImage, position = slide.textPosition, alignment = slide.textAlign, media = slide.media, mainType = slide.mainType, textValign = slide.textValign, titleSize = slide.titleSize, subtitleSize = slide.subtitleSize;
        var images;
        if (mainType === "product") {
            images = [
                leftImage,
                centerImage,
                rightImage
            ];
        } else {
            images = [
                media
            ];
        }
        var onClick = function(e) {
            e.stopPropagation();
            push(link.path);
        };
        var filteredImages = images.filter(function(el) {
            return el != null;
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: mainType === "media" ? "media contentWrapper" : "contentWrapper",
            "data-length": filteredImages.length,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Figure, {
                    lazy: false,
                    className: "product-highlight-image-center",
                    media: media
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HighlightsTextWrapper, {
                    $position: position,
                    className: "product-highlight-pos-" + position,
                    title_size: titleSize,
                    subtitle_size: subtitleSize,
                    text_valign: textValign,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: "product-highlight-align-" + alignment + " product-highlight-text-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: "product-highlight-align-" + alignment + " product-highlight-text-subtitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
                            onClick: onClick,
                            className: "product-highlight-align-" + alignment + " product-highlight-text-button",
                            children: link.title
                        })
                    ]
                })
            ]
        }, idx);
    });
};
var SectionHighlights = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var data = param.data;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().push;
    var Slides = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return getSlide(data, push);
    }, [
        data,
        push
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HighlightsSection, {
        className: "product-highlight-wrapper",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.SliderFlickity, {
            className: "slider--product-highlight fade",
            options: {
                draggable: false,
                autoPlay: 4000,
                pauseAutoPlayOnHover: false,
                initialIndex: 0
            },
            children: Slides
        })
    });
});
var HighlightsSection = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].section.withConfig({
    displayName: "SectionHighlights__HighlightsSection",
    componentId: "sc-53dc9961-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(50, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(447, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(447, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(50, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(70, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(715, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(200, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(150, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop-wide"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.designGrid)({}), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(700, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(672, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(50, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(100, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(50, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop-wide"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(672, "desktop-wide"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(100, "desktop-wide"));
var HighlightsTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({
    displayName: "SectionHighlights__HighlightsTextWrapper",
    componentId: "sc-53dc9961-1"
})(_templateObject15(), function(param) {
    var text_valign = param.text_valign;
    return text_valign === "top" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject1(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(20, "mobile")) : text_valign === "bottom" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject2(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "mobile")) : (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject3());
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), function(param) {
    var $position = param.$position;
    return "1 / ".concat($position === "left" ? 2 : $position === "right" ? 7 : 3, " / span 1 / span ").concat($position === "center" ? 8 : 5);
}, function(param) {
    var text_valign = param.text_valign;
    return text_valign === "top" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject4(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(60, "desktop")) : text_valign === "bottom" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject5(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(70, "desktop")) : (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject6());
}, function(param) {
    var title_size = param.title_size;
    return title_size === "xl" ? (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP141)() : title_size === "l" ? (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP113)() : title_size === "m" ? (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP93_1)() : (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP53)();
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var subtitle_size = param.subtitle_size;
    return subtitle_size === "l" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject7(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP30_1)()) : subtitle_size === "m" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject8(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP30_1)()) : (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP15_1)();
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(15, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.vw)(30, "desktop"), function(param) {
    var subtitle_size = param.subtitle_size;
    return subtitle_size === "l" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject9(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP30_1)()) : subtitle_size === "m" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject10(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP26)()) : (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.getP20_2)();
}, function(param) {
    var subtitle_size = param.subtitle_size;
    return subtitle_size === "m" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject11()) : "";
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop"), function(param) {
    var text_valign = param.text_valign;
    return text_valign === "top" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject12()) : text_valign === "bottom" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject13()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject14());
})//
// const Div = styled.div<{ $filled?: boolean, $isSafari?:boolean }>`
//   display: flex;
//   flex-direction: row;
//   flex-wrap: nowrap;
//   height: 20px;
//   justify-content: space-between;
//   width: 100%;
//   z-index: 50;
// `
// const DivBullet = styled.div<{ $filled?: boolean, $isSafari?:boolean, $isActive: boolean }>`
//   background-color: rgba(247, 18, 18, .25);
//   height: 100%;
//   border-radius: 2px;
//   margin: 0 3px;
//   position: relative;
//   .progress-bar {
//     animation-delay: 400ms;
//     animation-duration: 4s;
//     animation-name: ${bulletWidth};
//     animation-fill-mode: forwards;
//     animation-iteration-count: unset;
//     animation-play-state:  ${({ $isActive }) => $isActive ? 'running' : 'paused'};
//     animation-timing-function: linear;
//     background-color: red;
//     position: absolute;
//     left: 0;
//     top: 0;
//     height: 100%;
//     will-change: width;
//     ${({ $isActive, $filled }) => (!$isActive && $filled) && css`
//       width: 100% !important;
//     `}
//   }
// `
;


/***/ }),

/***/ 3292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Subscribe": function() { return /* binding */ Subscribe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useTranslator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78026);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92757);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7693);
/* harmony import */ var _dy_commons_context__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_context__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  grid: auto-flow / repeat(8, ",
        ");\n  margin-bottom:unset;\n\n  ",
        " {\n    margin-bottom:",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 100px;\n  }\n\n  ",
        " {\n    margin: 0 auto 100px;\n    max-width: 1650px;\n  }\n\n  > div {\n    align-items: center;\n    background-color: ",
        ";\n    display: flex;\n    flex-direction: column;\n    height: ",
        ";\n    grid-area: 1 / 2 / span 1 / span 6;\n    margin: 0  0 ",
        ";\n    padding: ",
        "  ",
        " ;\n\n    ",
        " {\n      height: ",
        ";\n      margin: 0  0 ",
        ";\n      padding: ",
        "  ",
        " ;\n    }\n\n    ",
        " {\n      grid-column: 1 / span 12;\n      height:  ",
        ";\n      margin: 0 ",
        ";\n      padding: ",
        " ",
        ";\n    }\n\n    ",
        " {\n      height: 687px;\n      margin: 0 50px;\n      padding: 80px 50px;\n    }\n\n    >:first-child {\n      ",
        "\n      color: ",
        ";\n    }\n\n    >:nth-child(2) {\n      ",
        "\n      color: ",
        ";\n      font-weight: 400;\n    }\n\n    > :last-child {\n      margin: ",
        ";\n\n      ",
        " {\n        margin: ",
        ";\n      }\n\n      ",
        " {\n        margin: ",
        ";\n      }\n\n      ",
        " {\n        margin: 60px;\n      }\n    }\n  }\n\n  h1,h2 {\n    padding: 20px;\n  }\n\n  ul {\n    text-align: center;\n\n    ",
        " {\n      display: grid;\n      grid-template-columns: ",
        " auto;\n      text-align: start;\n    }\n\n    ",
        " {\n      grid-template-columns: 400px auto;\n    }\n\n    li {\n      ",
        "\n      color: ",
        ";\n      font-weight:500;\n      padding: ",
        ";\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: 14px;\n      }\n\n      &:before {\n        color: ",
        ';\n        content: "✓";\n        display: inline-block;\n        font-weight: 700;\n        margin-left: -1.3em;\n        width: 1.3em;\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Subscribe = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function() {
    var t = (0,hooks_useTranslator__WEBPACK_IMPORTED_MODULE_4__/* .useTranslator */ .I)().t;
    var toggle = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__.useModal)(_dy_commons_context__WEBPACK_IMPORTED_MODULE_6__.MODALS.AUTH).toggle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Div, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                    children: t("section_subscribe.welcome")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    children: t("section_subscribe.register")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.open")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.order")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.offer")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.save_products")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.check_invoices")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: t("section_subscribe.contact_commercial")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_3__.Button, {
                    onClick: toggle,
                    bgType: "red",
                    className: "red",
                    children: [
                        " ",
                        t("section_subscribe.register_button"),
                        " "
                    ]
                })
            ]
        })
    });
});
var Div = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Subscribe__Div",
    componentId: "sc-64e9ed39-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.designGrid)({
    withoutGutter: true
}), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(64, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(100, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop-wide"), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.hex2Rgba)(theme.colors.creme, .4);
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(629, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(687, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(60, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(687, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(80, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(30, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP53)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP30_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(315, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop-wide"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP15_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
});


/***/ }),

/***/ 42318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j7": function() { return /* reexport */ GridMyProducts; },
  "Qz": function() { return /* reexport */ HeaderHome; },
  "UQ": function() { return /* reexport */ SectionHighlights.HighlightsSection; },
  "UG": function() { return /* reexport */ SectionBestseller.SectionBestseller; },
  "gq": function() { return /* reexport */ SectionBrands; },
  "tL": function() { return /* reexport */ SectionHighlights.SectionHighlights; },
  "JD": function() { return /* reexport */ SectionMyProducts.SectionMyProducts; },
  "KU": function() { return /* reexport */ SectionStorePicker; },
  "xs": function() { return /* reexport */ Subscribe.Subscribe; },
  "s2": function() { return /* reexport */ imageVariants; },
  "$i": function() { return /* reexport */ img_variants_center; },
  "Sy": function() { return /* reexport */ img_variants_left; },
  "r6": function() { return /* reexport */ img_variants_right; },
  "fJ": function() { return /* reexport */ img_variants_single; },
  "OJ": function() { return /* reexport */ logoVariants; },
  "Px": function() { return /* reexport */ text_variants_button; },
  "sA": function() { return /* reexport */ text_variants_button_highlights; },
  "_r": function() { return /* reexport */ text_variants_subtitle; },
  "Z6": function() { return /* reexport */ text_variants_subtitle_highlights; },
  "ru": function() { return /* reexport */ text_variants_title; },
  "HG": function() { return /* reexport */ text_variants_title_highlights; },
  "vd": function() { return /* reexport */ wrapperVariants; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
;// CONCATENATED MODULE: ./components/home/homeVariants.ts




var transition = (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(1));
var logoVariants = {
    initial: {
        opacity: 0,
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
    },
    animate: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .3
        })
    },
    exit: {
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .3
        })
    }
};
var wrapperVariants = {
    inactive: {
        opacity: 0,
        transition: transition
    },
    active: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(1)), {
            delay: 1.5
        })
    }
};
var text_variants_title = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: function(singleImage) {
        return {
            opacity: 1,
            y: "0px",
            transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
                delay: singleImage ? 2 : .3
            })
        };
    }
};
var text_variants_subtitle = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: function(singleImage) {
        return {
            opacity: 1,
            y: "0px",
            transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
                delay: singleImage ? 2.1 : .5
            })
        };
    }
};
var text_variants_button = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: function(singleImage) {
        return {
            opacity: 1,
            y: "0px",
            transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
                delay: singleImage ? 2.2 : .3
            })
        };
    }
};
var img_variants_left = {
    inactive: {
        opacity: 0,
        rotate: "-10deg",
        y: (0,styles.vw)(260, "desktop")
    },
    active: function(mobile) {
        return {
            opacity: 1,
            rotate: "0deg",
            y: mobile ? 0 : (0,styles.vw)(65, "desktop"),
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(1))
        };
    }
};
var img_variants_right = {
    inactive: function(mobile) {
        return {
            opacity: 0,
            rotate: "-15deg",
            y: mobile ? (0,styles.vw)(350, "mobile") : (0,styles.vw)(170, "desktop")
        };
    },
    active: function(mobile) {
        return {
            opacity: 1,
            rotate: "0deg",
            y: mobile ? 0 : (0,styles.vw)(-100, "desktop"),
            transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(1)), {
                delay: .2
            })
        };
    }
};
var img_variants_center = {
    inactive: function(mobile) {
        return {
            opacity: 0,
            rotate: "17deg",
            y: mobile ? (0,styles.vw)(350, "mobile") : (0,styles.vw)(300, "desktop")
        };
    },
    active: function(mobile) {
        return {
            opacity: 1,
            rotate: "0deg",
            y: mobile ? 0 : (0,styles.vw)(130, "desktop"),
            transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(1)), {
                delay: .4
            })
        };
    }
};
var img_variants_single = {
    inactive: {
        opacity: 0
    },
    active: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
            delay: 1.5
        })
    }
};
var imageVariants = {
    initial: {
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            delay: 0
        })
    },
    animate: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: 1,
            delay: .3
        })
    },
    exit: {
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .2,
            delay: 0
        })
    }
};
var text_variants_title_highlights = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: {
        opacity: 1,
        y: "0px",
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
            delay: .3
        })
    }
};
var text_variants_subtitle_highlights = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: {
        opacity: 1,
        y: "0px",
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
            delay: .4
        })
    }
};
var text_variants_button_highlights = {
    inactive: {
        opacity: 0,
        y: "30px"
    },
    active: {
        opacity: 1,
        y: "0px",
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5)), {
            delay: .5
        })
    }
};

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
;// CONCATENATED MODULE: ./components/home/HeaderHome.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n ",
        "\n  place-items: center;\n  grid: auto-flow / repeat(8, ",
        ");\n  overflow-x: hidden;\n  margin-top: 60px;\n\n  div[class*='homeheaderimage'] > figure {\n    user-select: none;\n    pointer-events: none;\n    filter: drop-shadow(8px 13px 1px rgb(78 57 14 / 7%));\n    height: ",
        ";\n\n    ",
        " {\n      height: 100%;\n    }\n  }\n\n  &[data-length='1'] {\n    /* margin-bottom: ",
        "; */\n    margin-top: 60px;\n    color: #FFF;\n\n    div[class*='homeheaderimage'] {\n      grid-area: 1 / 2 / span 1 / span 4;\n      transform: none;\n      width: 100%;\n      z-index: -1;\n\n      &.figure--video {\n        grid-area: 1 / 2 / span 1 / span 6;\n        filter: none;\n        z-index: -1;\n        height: ",
        ";\n        overflow: hidden;\n\n        & + [class*='home-header-pos'] {\n          grid-area: 1 / 3 / span 2 / span 4;\n          margin-top: 0;\n        }\n      }\n\n      &.homeheaderimage-center {\n        grid-area: 1 / 2 / span 1 / span 6;\n        z-index: -1;\n        height: ",
        ";\n\n        > figure {\n          filter: none;\n        }\n\n        img {\n          object-fit: cover;\n          height: 100%;\n        }\n\n        & + [class*='home-header-pos'] {\n          grid-area: 1 / 3 / span 2 / span 4;\n          margin-top: 0;\n          padding-bottom: 0;\n        }\n      }\n    }\n  }\n\n  &[data-length='2'] {\n    div[class*='homeheaderimage']:nth-of-type(1) { grid-area: 1 / 1 / span 1 / span 4; }\n\n    div[class*='homeheaderimage']:nth-of-type(2) { grid-area: 1 / 5 / span 1 / span 4; }\n  }\n\n  &[data-length='3'] {\n    div[class*='homeheaderimage']:nth-of-type(1) { grid-area: 1 / 1 / span 1 / span 4; }\n\n    div[class*='homeheaderimage']:nth-of-type(2) { grid-area: 1 / 3 / span 1 / span 4; }\n\n    div[class*='homeheaderimage']:nth-of-type(3) { grid-area: 1 / 5 / span 1 / span 4; }\n  }\n\n  ",
        " {\n    height: ",
        ";\n    // margin-bottom: ",
        ";\n    margin-top: ",
        ";\n    overflow-x: unset;\n\n    div[class*='homeheaderimage'] {\n      width: ",
        ";\n      height: ",
        ";\n    }\n\n    &[data-length] div[class*='homeheaderimage'] {\n      > figure {\n        filter: drop-shadow(25px 40px 4px rgb(78 57 14 / 7%));\n      }\n\n      &.homeheaderimage-left {\n        grid-area: 1 / 1 / span 1 / span 6;\n        margin: 0;\n      }\n      &.homeheaderimage-center { grid-area: 1 / 4 / span 1 / span 6; }\n      &.homeheaderimage-right { grid-area: 1 / 7 / span 1 / span 6; }\n    }\n\n    &[data-length='1'] {\n      margin-top: ",
        ";\n      // margin-bottom: ",
        ";\n\n      div[class*='homeheaderimage'] {\n        grid-area: 1 / 1 / span 3 / span 12;\n\n        &.homeheaderimage-center {\n          grid-area: 1 / 1 / span 1 / span 12;\n          padding: 0 ",
        ";\n          transform: none;\n          width: 100%;\n          height: inherit;\n\n          & + [class*='home-header-pos'] {\n            &.home-header-pos-left { grid-area: 1 / 2 / span 1 / span 5; }\n            &.home-header-pos-center { grid-area: 1 / 3 / span 1 / span 8; }\n            &.home-header-pos-right { grid-area: 1 / 7 / span 1 / span 5; }\n          }\n        }\n      }\n\n      figure {\n        &.figure--video {\n          grid-area: 1 / 1 / span 3 / span 12;\n          height: ",
        ";\n\n          & + [class*='home-header-pos'] {\n            &.home-header-pos-left { grid-area: 1 / 2 / span 3 / span 5; }\n            &.home-header-pos-center { grid-area: 1 / 3 / span 3 / span 8; }\n            &.home-header-pos-right { grid-area: 1 / 7 / span 3 / span 5; }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    height: 750px;\n    margin-top: 120px;\n\n    div[class*='homeheaderimage'] {\n      width: 720px;\n      height: 750px;\n    }\n\n    &[data-length='1'] {\n      margin-top: 120px;\n      // margin-bottom: 50px;\n\n      div[class*='homeheaderimage'] {\n        &.homeheaderimage-center {\n          padding: 0 50px;\n        }\n      }\n\n      figure {\n        &.figure--video {\n          height: 715px;\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: 1650px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-top: ",
        "; align-self: start;"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-bottom: ",
        "; align-self: end;"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "align-self: center;"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-top: ",
        "; align-self: start;"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-bottom: ",
        "; align-self: end;"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "align-self: center;"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-top: ",
        "; align-self: start;"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-bottom: ",
        "; align-self: end;"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "align-self: center;"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-top: 60px ; align-self: start;"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "padding-bottom: 70px; align-self: end;"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "align-self: center;"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        " font-weight: 100;"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "letter-spacing: -1.5px;"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: 2 / 3 / span 1 / span 4;\n  margin-top: -",
        ";\n  padding-bottom: ",
        "; // fix for animations\n  width: 100%;\n\n  ",
        ";\n\n  ",
        " {\n    margin-top: -",
        ";\n    padding-bottom: ",
        "; // fix for animations\n    ",
        "\n  }\n\n  ",
        " {\n    grid-area: 1 / 5 / span 1 / span 4;\n    margin-top: 0;\n    padding-bottom: 0;\n    ",
        ";\n  }\n\n  ",
        " {\n    ",
        ";\n  }\n\n  h2 {\n    ",
        ";\n  }\n\n  p {\n    font-family: ",
        ";\n    ",
        ";\n    margin: ",
        " 0 ",
        ";\n\n    ",
        " {\n      ",
        ";\n\n      &.home-header-text-subtitle {\n        ",
        ";\n      }\n    }\n  }\n\n  .home-header-align-left,\n  .home-header-align-center,\n  .home-header-align-right {\n    text-align: center;\n  }\n\n  .home-header-align-left {\n    ",
        " {\n      text-align: left;\n    }\n  }\n\n  .home-header-align-right {\n    ",
        " {\n      text-align: right;\n    }\n  }\n\n  ",
        " {\n    &.home-header-pos-left {\n      grid-area: 1 / 2 / span 1 / span 5;\n\n      p {\n        &.home-header-align-left {\n          margin: ",
        " calc(100vw / 12) ",
        " 0;\n        }\n        &.home-header-align-center {\n          margin: ",
        " calc(100vw / 24) ",
        ";\n        }\n        &.home-header-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12);\n        }\n      }\n    }\n\n    &.home-header-pos-center {\n      grid-area: 1 / 3 / span 1 / span 8;\n\n      p {\n        &.home-header-align-left {\n          margin: ",
        " calc(100vw / 12 * 4) ",
        " 0;\n        }\n        &.home-header-align-center {\n          margin: ",
        " calc(100vw / 6) ",
        ";\n        }\n        &.home-header-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12 * 4);\n        }\n      }\n    }\n\n    &.home-header-pos-right {\n      grid-area: 1 / 7 / span 1 / span 5;\n\n      p {\n        &.home-header-align-left {\n          margin: ",
        " calc(100vw / 12) ",
        " 0;\n        }\n        &.home-header-align-center {\n          margin: ",
        " calc(100vw / 24) ",
        ";\n        }\n        &.home-header-align-right {\n          margin: ",
        " 0 ",
        " calc(100vw / 12);\n        }\n      }\n    }\n\n    button.home-header-align-left { margin: 0 auto 0 0; }\n    button.home-header-align-right { margin: 0 0 0 auto; }\n  }\n\n  ",
        " {\n    &.home-header-pos-left {\n      p {\n        &.home-header-align-left {\n          margin:15px calc(100vw / 12) 30px 0;\n        }\n        &.home-header-align-center {\n          margin:15px calc(100vw / 24) 30px;\n        }\n        &.home-header-align-right {\n          margin:15px 0 30px calc(100vw / 12);\n        }\n      }\n    }\n\n    &.home-header-pos-center {\n      p {\n        &.home-header-align-left {\n          margin: 15px calc(100vw / 12 * 4) 30px 0;\n        }\n        &.home-header-align-center {\n          margin: 15px calc(100vw / 6) 30px;\n        }\n        &.home-header-align-right {\n          margin: 15px 0 30px calc(100vw / 12 * 4);\n        }\n      }\n    }\n\n    &.home-header-pos-right {\n      grid-area: 1 / 7 / span 1 / span 5;\n\n      p {\n        &.home-header-align-left {\n          margin: 15px calc(100vw / 12) 30px 0;\n        }\n        &.home-header-align-center {\n          margin: 15px calc(100vw / 24) 30px;\n        }\n        &.home-header-align-right {\n          margin: 15px 0 30px calc(100vw / 12);\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}








var getImages = function(images, main_type, isMobile) {
    return images.map(function(img, idx) {
        var _variants = main_type === "media" ? img_variants_single : (img === null || img === void 0 ? void 0 : img.position) == "left" ? img_variants_left : (img === null || img === void 0 ? void 0 : img.position) == "right" ? img_variants_right : img_variants_center;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "homeheaderimage-" + (main_type === "media" ? "center" : img === null || img === void 0 ? void 0 : img.position),
            variants: _variants,
            animate: "active",
            initial: "inactive",
            custom: isMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                lazy: false,
                media: img
            })
        }, idx);
    });
};
var HeaderHome = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var title = data.title, subtitle = data.subtitle, link = data.link, leftImage = data.leftImage, centerImage = data.centerImage, rightImage = data.rightImage, position = data.textPosition, alignment = data.textAlign, media = data.media, mainType = data.mainType, textValign = data.textValign, titleSize = data.titleSize, subtitleSize = data.subtitleSize;
    var images = (0,react.useMemo)(function() {
        if (mainType === "product") {
            return [
                leftImage,
                centerImage,
                rightImage
            ];
        } else {
            return [
                media
            ];
        }
    }, [
        leftImage,
        centerImage,
        rightImage,
        media,
        mainType
    ]);
    var isMobile = (0,hooks.useDeviceType)().isMobile;
    var ImageList = (0,react.useMemo)(function() {
        return getImages(images, mainType, isMobile);
    }, [
        images,
        mainType,
        isMobile
    ]);
    var filteredImages = images.filter(function(el) {
        return el != null;
    });
    var singleImage = (filteredImages === null || filteredImages === void 0 ? void 0 : filteredImages.length) === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeHeader, {
        "data-length": filteredImages.length,
        children: [
            ImageList,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                className: "home-header-pos-" + position,
                $title_size: titleSize,
                $subtitle_size: subtitleSize,
                $text_valign: textValign,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.h2 */.E.h2, {
                        custom: singleImage,
                        variants: text_variants_title,
                        animate: "active",
                        initial: "inactive",
                        className: "home-header-align-" + alignment + " home-header-text-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
                        custom: singleImage,
                        variants: text_variants_subtitle,
                        animate: "active",
                        initial: "inactive",
                        className: "home-header-align-" + alignment + " home-header-text-subtitle",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: link === null || link === void 0 ? void 0 : link.path,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                            custom: singleImage,
                            variants: text_variants_button,
                            animate: "active",
                            initial: "inactive",
                            className: "home-header-align-" + alignment + " home-header-text-button",
                            children: link === null || link === void 0 ? void 0 : link.title
                        })
                    })
                ]
            })
        ]
    });
});
var HomeHeader = styled_components_browser_esm["default"].header.withConfig({
    displayName: "HeaderHome__HomeHeader",
    componentId: "sc-4a491563-0"
})(_templateObject(), (0,styles.designGrid)({
    withoutGutter: true
}), (0,styles.vw)(64, "mobile"), (0,styles.vw)(447, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(90, "mobile"), (0,styles.vw)(447, "mobile"), (0,styles.vw)(447, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(750, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(120, "desktop"), (0,styles.vw)(720, "desktop"), (0,styles.vw)(750, "desktop"), (0,styles.vw)(120, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(715, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("desktop-wide"));
var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderHome__TextWrapper",
    componentId: "sc-4a491563-1"
})(_templateObject18(), (0,styles.vw)(40, "mobile"), (0,styles.vw)(80, "mobile"), function(param) {
    var $text_valign = param.$text_valign;
    return $text_valign === "top" ? (0,styled_components_browser_esm.css)(_templateObject1(), (0,styles.vw)(20, "mobile")) : $text_valign === "bottom" ? (0,styled_components_browser_esm.css)(_templateObject2(), (0,styles.vw)(30, "mobile")) : (0,styled_components_browser_esm.css)(_templateObject3());
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(80, "nexus7"), function(param) {
    var $text_valign = param.$text_valign;
    return $text_valign === "top" ? (0,styled_components_browser_esm.css)(_templateObject4(), (0,styles.vw)(20, "nexus7")) : $text_valign === "bottom" ? (0,styled_components_browser_esm.css)(_templateObject5(), (0,styles.vw)(30, "nexus7")) : (0,styled_components_browser_esm.css)(_templateObject6());
}, styles.mq.greaterThan("tablet"), function(param) {
    var $text_valign = param.$text_valign;
    return $text_valign === "top" ? (0,styled_components_browser_esm.css)(_templateObject7(), (0,styles.vw)(60, "desktop")) : $text_valign === "bottom" ? (0,styled_components_browser_esm.css)(_templateObject8(), (0,styles.vw)(70, "desktop")) : (0,styled_components_browser_esm.css)(_templateObject9());
}, styles.mq.greaterThan("desktop"), function(param) {
    var $text_valign = param.$text_valign;
    return $text_valign === "top" ? (0,styled_components_browser_esm.css)(_templateObject10()) : $text_valign === "bottom" ? (0,styled_components_browser_esm.css)(_templateObject11()) : (0,styled_components_browser_esm.css)(_templateObject12());
}, function(param) {
    var $title_size = param.$title_size;
    return $title_size === "xl" ? (0,styles.getP141)() : $title_size === "l" ? (0,styles.getP113)() : $title_size === "m" ? (0,styles.getP93_1)() : (0,styles.getP53)();
}, function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, function(param) {
    var $subtitle_size = param.$subtitle_size;
    return $subtitle_size === "l" ? (0,styled_components_browser_esm.css)(_templateObject13(), (0,styles.getP30_1)()) : $subtitle_size === "m" ? (0,styled_components_browser_esm.css)(_templateObject14(), (0,styles.getP30_1)()) : (0,styles.getP15_1)();
}, (0,styles.vw)(15, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("tablet"), function(param) {
    var $subtitle_size = param.$subtitle_size;
    return $subtitle_size === "l" ? (0,styled_components_browser_esm.css)(_templateObject15(), (0,styles.getP30_1)()) : $subtitle_size === "m" ? (0,styled_components_browser_esm.css)(_templateObject16(), (0,styles.getP26)()) : (0,styles.getP20_2)();
}, function(param) {
    var $subtitle_size = param.$subtitle_size;
    return $subtitle_size === "m" ? (0,styled_components_browser_esm.css)(_templateObject17()) : "";
}, styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ./components/home/SectionHighlights.tsx
var SectionHighlights = __webpack_require__(21535);
// EXTERNAL MODULE: ./components/home/SectionBestseller.tsx + 7 modules
var SectionBestseller = __webpack_require__(80874);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/index.ts + 74 modules
var components_0 = __webpack_require__(83242);
// EXTERNAL MODULE: ./components/layout/index.ts + 2 modules
var layout = __webpack_require__(11242);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks_0 = __webpack_require__(2722);
;// CONCATENATED MODULE: ./components/home/SectionStorePicker.tsx

function SectionStorePicker_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  min-height: 100dvh;\n  min-height: 100vh;\n  width: 100vw;\n  overflow-x: clip;\n\n  .marquee {\n    background-color: unset !important;\n  }\n"
    ]);
    SectionStorePicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DynamicMarquee = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 17566, 23)).then(function(mod) {
        return mod.Marquee;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17566)
            ];
        }
    },
    ssr: false
});
var SectionStorePicker = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,hooks_0/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Logo */.TR, {
                fillColor: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMarquee, {
                data: t("section_subscribe.welcome")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_0.FormStore, {
                dropdownTextColor: "darkred",
                textColorInput: "white"
            })
        ]
    });
});
var Main = styled_components_browser_esm["default"].main.withConfig({
    displayName: "SectionStorePicker__Main",
    componentId: "sc-d0608324-0"
})(SectionStorePicker_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(88241);
;// CONCATENATED MODULE: ./components/home/SectionBrands.tsx


function SectionBrands_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  + .pack-highlighted-section {\n    margin-top: -",
        ";\n  }\n\n  h2 {\n    ",
        "\n    grid-area: 1 / 1 / span 1 / span 6;\n    text-align: center;\n    margin-bottom: ",
        ";\n    color: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n\n    + .pack-highlighted-section {\n      margin-top: -",
        ";\n    }\n\n    h2 {\n      grid-area: 1 / 1 / span 1 / span 6;\n      margin-bottom: ",
        ";\n    }\n  }\n\n  ",
        " {\n    ",
        "\n    margin-bottom: ",
        ";\n\n    + .pack-highlighted-section {\n      margin-top: -",
        ";\n    }\n\n    h2 {\n      grid-area: 1 / 1 / span 1 / span 12;\n      margin-bottom: ",
        ";\n    }\n  }\n\n  ",
        " {\n    margin-bottom: 84px;\n\n    + .pack-highlighted-section {\n      margin-top: -84px;\n    }\n\n    h2 {\n      margin-bottom: 40px;\n    }\n  }\n"
    ]);
    SectionBrands_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionBrands_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: 1 / 1 / span 1 / span 6;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  height: ",
        ";\n  margin: 0 ",
        ";\n\n  article { height: inherit; }\n  figure { height: 79px; }\n  article {\n    padding: ",
        " ",
        ";\n  }\n\n  img {\n    height: 100%;\n    object-fit: contain;\n    /* filter:invert(49%) sepia(37%) saturate(691%) hue-rotate(313deg) brightness(74%) contrast(127%); */\n  }\n\n  ",
        " {\n    height: ",
        ";\n    margin: 0 ",
        ";\n\n    article {\n      padding: ",
        " ",
        ";\n    }\n  }\n\n  ",
        " {\n    grid-area: 2 / 2 / span 1 / span 10;\n    grid-template-columns: repeat(5, 1fr);\n    grid-gap: 50px;\n    height: ",
        ";\n\n    article {\n      padding: 0;\n      margin: 0 ",
        ";\n    }\n  }\n\n  ",
        " {\n    height: 108px;\n\n    article {\n      margin: 0 30px;\n    }\n  }\n"
    ]);
    SectionBrands_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





// import { Figure, Link } from '@dy/commons/components'




var DEFAULT_LOCALE = "fr-FR".split("-")[0];
var getLogos = function(images) {
    return images.map(function(img, idx) {
        var ref, ref1, ref2;
        var ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            mode: "wait",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.article */.E.article, {
                className: "brand",
                variants: logoVariants,
                initial: "initial",
                exit: "exit",
                animate: "animate",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                    href: "/brand/".concat(img === null || img === void 0 ? void 0 : (ref = img.slug) === null || ref === void 0 ? void 0 : ref[DEFAULT_LOCALE]),
                    children: (img === null || img === void 0 ? void 0 : (ref1 = img.logo) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: img === null || img === void 0 ? void 0 : (ref2 = img.logo) === null || ref2 === void 0 ? void 0 : ref2.url,
                        alt: (ref3 = img === null || img === void 0 ? void 0 : img.alt) !== null && ref3 !== void 0 ? ref3 : "Brand logo"
                    })
                })
            }, img)
        }, idx);
    });
};
var getNewLogoArray = function(prevLogoArray, images) {
    var missingLogoArray = images.filter(function(img) {
        return !prevLogoArray.includes(img);
    });
    var newArrayLogo = Math.floor(Math.random() * missingLogoArray.length);
    var oldArrayLogo = Math.floor(Math.random() * prevLogoArray.length);
    var updatedArray = (0,_to_consumable_array/* default */.Z)(prevLogoArray);
    updatedArray[oldArrayLogo] = missingLogoArray[newArrayLogo];
    return updatedArray;
};
var SectionBrands = /*#__PURE__*/ (0,react.memo)(function(param) {
    var brands = param.brands;
    var isMobile = (0,hooks.useDeviceType)().isMobile;
    var initialArray = brands.slice(0, isMobile ? 3 : 5);
    var ref = (0,react.useState)(initialArray), logoArray = ref[0], changeLogoArray = ref[1];
    var isMounted = (0,hooks.useMount)();
    var t = (0,hooks_0/* useTranslator */.I4)().t;
    var ref1 = (0,hooks.useInView)({
        rootMargin: "0px",
        threshold: 1,
        triggerOnce: true
    }), ref2 = ref1.ref, inView = ref1.inView;
    var Logos = (0,react.useMemo)(function() {
        return getLogos(logoArray);
    }, [
        logoArray
    ]);
    (0,react.useEffect)(function() {
        if (brands.length > initialArray.length) {
            var interval = setInterval(function() {
                changeLogoArray(function(prevLogoArray) {
                    return getNewLogoArray(prevLogoArray, brands);
                });
            }, 3200);
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        isMounted,
        Logos,
        brands,
        initialArray
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("home.brands.brands_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Div, {
                variants: wrapperVariants,
                animate: inView ? "active" : "inactive",
                initial: "inactive",
                children: Logos
            })
        ]
    });
});
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionBrands__Section",
    componentId: "sc-67246f03-0"
})(SectionBrands_templateObject(), (0,styles.vw)(73, "mobile"), (0,styles.vw)(73, "mobile"), (0,styles.getP20_1)(), (0,styles.vw)(28, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(73, "nexus7"), (0,styles.vw)(73, "nexus7"), (0,styles.vw)(28, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.designGrid)({}), (0,styles.vw)(84, "desktop"), (0,styles.vw)(84, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));
var Div = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "SectionBrands__Div",
    componentId: "sc-67246f03-1"
})(SectionBrands_templateObject1(), (0,styles.vw)(57, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(57, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(108, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(95163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
;// CONCATENATED MODULE: ./components/home/myProducts/GridMyProducts.tsx





function GridMyProducts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  border-radius: 10%;\n  height:",
        ";\n  width: ",
        ";\n\n  ",
        " {\n    height:",
        ";\n    width: ",
        ";\n  }\n\n\n  ",
        " {\n    height:",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: 115px;\n    width: 130px;\n  }\n\n  figure {\n    align-items: center;\n    height: 100% !important;\n    margin: 0 auto;\n    width: 80% !important;\n\n    img {\n      width:100% !important\n    }\n  }\n"
    ]);
    GridMyProducts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GridMyProducts_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " 0 ",
        ";\n  pointer-events: none;\n  user-select: none;\n\n  ",
        " {\n    padding:",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    padding:",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    padding: 40px 0 50px;\n  }\n\n  ul {\n    display: grid;\n    column-gap: ",
        ";\n    row-gap: ",
        ";\n    grid-template-columns: repeat(4, 1fr);\n\n    ",
        " {\n      column-gap: ",
        ";\n      row-gap: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: ",
        ";\n      row-gap: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: 5px;\n      row-gap: 6px;\n    }\n  }\n"
    ]);
    GridMyProducts_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var getMyProducts = function(products) {
    return products.map(function(product, idx) {
        var ref;
        var media = product.media, bigcommerceId = product.bigcommerceId;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
            children: product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                className: "product-grid-image",
                media: media === null || media === void 0 ? void 0 : (ref = media[0]) === null || ref === void 0 ? void 0 : ref.medium,
                quality: 65
            }, "grid-img-".concat(bigcommerceId)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No image"
            })
        }, idx);
    });
};
var GridMyProducts = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(api/* GET_CUSTOMER_GRID_MY_PRODUCTS */.yi), 2), getDataForMyProducts = ref[0], ref1 = ref[1], ref1 = ref1 !== null ? ref1 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref2 = (0,react.useState)([]), currentProducts = ref2[0], setCurrentProducts = ref2[1];
    (0,react.useEffect)(function() {
        var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
        function getUsualPurchases() {
            return _getUsualPurchases.apply(this, arguments);
        }
        function _getUsualPurchases() {
            _getUsualPurchases = (0,_async_to_generator/* default */.Z)(function() {
                var data, myUsual, arrayOfVariantNodes;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDataForMyProducts({
                                    variables: {
                                        first: 8
                                    },
                                    context: {
                                        isPrivatePath: true,
                                        DYCustomerToken: DYCustomerToken
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (typeof (data === null || data === void 0 ? void 0 : data.customer) === "object") {
                                myUsual = data.customer.myUsual;
                                arrayOfVariantNodes = Array.isArray(myUsual.edges) ? myUsual.edges.map(function(item) {
                                    return item.node;
                                }) : [];
                                setCurrentProducts(arrayOfVariantNodes);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return _getUsualPurchases.apply(this, arguments);
        }
        if (DYCustomerToken && currentProducts.length < 1) getUsualPurchases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var ListItems = (0,react.useMemo)(function() {
        return getMyProducts(currentProducts);
    }, [
        currentProducts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridMyProducts_Div, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: ListItems
        })
    });
});
var Li = styled_components_browser_esm["default"].li.withConfig({
    displayName: "GridMyProducts__Li",
    componentId: "sc-af341640-0"
})(GridMyProducts_templateObject(), (0,styles.vw)(70, "mobile"), (0,styles.vw)(81, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(70, "nexus7"), (0,styles.vw)(81, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(115, "desktop"), (0,styles.vw)(130, "desktop"), styles.mq.greaterThan("desktop"));
var GridMyProducts_Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridMyProducts__Div",
    componentId: "sc-af341640-1"
})(GridMyProducts_templateObject1(), (0,styles.vw)(40, "mobile"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(6, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(6, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(6, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ./components/home/myProducts/SectionMyProducts.tsx
var SectionMyProducts = __webpack_require__(10361);
// EXTERNAL MODULE: ./components/home/Subscribe.tsx
var Subscribe = __webpack_require__(3292);
;// CONCATENATED MODULE: ./components/home/index.ts











/***/ }),

/***/ 10361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionMyProducts": function() { return /* binding */ SectionMyProducts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19453);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2722);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42318);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_cart__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61969);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    ",
        "\n    color: ",
        ";\n    display: inline-block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  display: block;\n  text-align: center;\n  justify-content: unset;\n  margin: ",
        ";\n  padding: ",
        " ",
        ";\n\n\n  ",
        " {\n    margin: ",
        ";\n    padding: ",
        " ",
        ";\n  }\n\n  ",
        " {\n    display: flex;\n    justify-content: space-between;\n    padding: ",
        " ",
        ";\n    margin: ",
        ";\n  }\n\n  ",
        " {\n    padding: 50px 70px;\n    margin: 50px;\n  }\n\n  ",
        " {\n    max-width: 1550px;\n    margin: 50px auto;\n  }\n\n  h1 {\n    ",
        "\n    text-align:left;\n  }\n\n  a {\n    ",
        "\n  }\n\n  .cta {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .left {\n    width:unset;\n\n    ul {\n      display:block;\n    }\n\n    ",
        " {\n      width: 48%;\n      ul {\n        display:inline;\n      }\n    }\n  }\n\n  .right {\n    width: unset;\n    padding: ",
        " 0;\n\n    ",
        " {\n      padding: ",
        " 0;\n    }\n\n    ",
        " {\n      width: 50%;\n      padding-top: 0;\n      padding-bottom: 0;\n      padding-left:",
        ";\n      padding-right:0;\n    }\n\n    ",
        " {\n      padding-left: 120px;\n    }\n\n    p {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display:flex;\n  flex-direction: row;\n  padding: ",
        " 0;\n  text-align: left;\n  justify-content: space-between;\n   align-items: center;\n\n  ",
        " {\n    padding: ",
        " 0 ;\n  }\n\n  ",
        " {\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    padding: 30px 0;\n  }\n\n\n  > button {\n    margin: 0;\n    width:",
        ";\n    height: ",
        ";\n\n    ",
        " {\n      width:",
        ";\n      height: ",
        ";\n    }\n    ",
        " {\n      width:",
        ";\n      height: ",
        ";\n    }\n\n    ",
        " {\n      width: 159px;\n      height: 40px;\n    }\n  }\n  > div {\n    flex-direction: column;\n  }\n\n  :first-child {\n    padding-top: ",
        ";\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: 40px;\n    }\n  }\n\n  :not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  h3 {\n    ",
        "\n    padding-bottom: ",
        ";\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var Div = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div.withConfig({
    displayName: "SectionMyProducts__Div",
    componentId: "sc-2bb30a87-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP12_2)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});
var getOrders = function(data, t) {
    return data.map(function(item, idx) {
        var _node = item.node, orderLines = _node.orderLines, id = _node.id, deliveryDate = _node.deliveryDate;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListOrders, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Div, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            children: deliveryDate ? (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__.getDynamicText)(t("cart.delivery_date"), {
                                deliveryDate: (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__.parseDateString)({
                                    dateString: deliveryDate,
                                    includeHour: false
                                })
                            }) : "Llegar\xe1 pronto"
                        }),
                        orderLines.map(function(item, idx) {
                            // We will display a maximum of 6 orderLines
                            // to avoid broken layout for extra large order
                            if (idx > 6) return false;
                            var productName = item.productName, quantity = item.quantity, id = item.id;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    quantity,
                                    " x ",
                                    productName,
                                    orderLines.length - 1 !== idx && ","
                                ]
                            }, "".concat(idx, "-").concat(id));
                        }).filter(Boolean),
                        orderLines.length > 6 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: "..."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_cart__WEBPACK_IMPORTED_MODULE_8__/* .RepeatOrder */ .W4, {
                    orderLines: orderLines
                })
            ]
        }, "".concat(idx, "-").concat(id));
    });
};
var SectionMyProducts = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var data = param.data;
    var t = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTranslator */ .I4)().t;
    var Orders = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return getOrders(data, t);
    }, [
        data,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "cta",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                children: t("account.home_my_products.last_orders")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.Link, {
                                href: "/account/orders",
                                children: t("account.home_my_products.see_all")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                        children: Orders
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "cta",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                children: t("account.home_my_products.my_usuals")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.Link, {
                                href: "/account/my-products",
                                children: t("account.home_my_products.see_all")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(___WEBPACK_IMPORTED_MODULE_4__/* .GridMyProducts */ .j7, {})
                ]
            })
        ]
    });
});
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].section.withConfig({
    displayName: "SectionMyProducts__SectionWrapper",
    componentId: "sc-2bb30a87-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.hex2Rgba)(theme.colors.creme, .4);
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(14, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(25, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(25, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(70, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop-wide"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP30)(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP15)(), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(50, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(120, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP15_1)());
var ListOrders = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].li.withConfig({
    displayName: "SectionMyProducts__ListOrders",
    componentId: "sc-2bb30a87-2"
})(_templateObject2(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(25, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(25, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(30, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(118, "mobile"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(42, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(118, "nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(42, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(159, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(30, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(30, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(40, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.hex2Rgba)(theme.colors.darkred, .1);
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.getP26_1)(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(8, "desktop"));


/***/ }),

/***/ 83242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddToCart": function() { return /* reexport */ cart/* AddToCart */.o4; },
  "ButtonHeader": function() { return /* reexport */ ButtonHeader; },
  "ButtonTriggerSearch": function() { return /* reexport */ ButtonTriggerSearch; },
  "CartItemsAll": function() { return /* reexport */ cart/* CartItemsAll */.d1; },
  "CartItemsNew": function() { return /* reexport */ cart/* CartItemsNew */.GR; },
  "CartList": function() { return /* reexport */ cart/* CartList */.AQ; },
  "CartSummary": function() { return /* reexport */ cart/* CartSummary */.VD; },
  "Content": function() { return /* reexport */ Content; },
  "ContentButtonDownload": function() { return /* reexport */ ContentButtonDownload; },
  "ContentImage": function() { return /* reexport */ ContentImage; },
  "ContentSectionBrand": function() { return /* reexport */ shop.ContentSectionBrand; },
  "ContentText": function() { return /* reexport */ ContentText; },
  "ContentVideo": function() { return /* reexport */ ContentVideo; },
  "DetailHeader": function() { return /* reexport */ DetailHeader; },
  "Dt": function() { return /* reexport */ Dt; },
  "DynamicContentSectionBrand": function() { return /* reexport */ shop.DynamicContentSectionBrand; },
  "DynamicSectionFiltersFeatured": function() { return /* reexport */ shop.DynamicSectionFiltersFeatured; },
  "FILTER_LABELS": function() { return /* reexport */ FILTER_LABELS; },
  "FeedbackAccountActivated": function() { return /* reexport */ FeedbackAccountActivated; },
  "FeedbackCIFAlreadyActive": function() { return /* reexport */ FeedbackCIFAlreadyActive; },
  "FeedbackCIFNotFound": function() { return /* reexport */ FeedbackCIFNotFound; },
  "FeedbackEmailInvite": function() { return /* reexport */ FeedbackEmailInvite; },
  "FeedbackEmailResetPassword": function() { return /* reexport */ FeedbackEmailResetPassword; },
  "FeedbackPasswordUpdated": function() { return /* reexport */ FeedbackPasswordUpdated; },
  "Form": function() { return /* reexport */ FormNewsletter/* Form */.l; },
  "FormCustomerUpdate": function() { return /* reexport */ FormCustomerUpdate; },
  "FormCustomerUpdateAddresses": function() { return /* reexport */ FormCustomerUpdateAddresses; },
  "FormNewsletter": function() { return /* reexport */ FormNewsletter/* FormNewsletter */.G; },
  "FormStore": function() { return /* reexport */ FormStore; },
  "FormUserActivateAccount": function() { return /* reexport */ FormUserActivateAccount; },
  "FormUserCheckCIF": function() { return /* reexport */ FormUserCheckCIF; },
  "FormUserForgotPassword": function() { return /* reexport */ FormUserForgotPassword; },
  "FormUserInitial": function() { return /* reexport */ FormUserInitial; },
  "FormUserLogIn": function() { return /* reexport */ FormUserLogIn; },
  "FormUserPreLogin": function() { return /* reexport */ FormUserPreLogin; },
  "FormUserResetPassword": function() { return /* reexport */ FormUserResetPassword; },
  "FormUserSignUp": function() { return /* reexport */ FormUserSignUp; },
  "FormUserSignUpCIF": function() { return /* reexport */ FormUserSignUpCIF; },
  "GridMyProducts": function() { return /* reexport */ home/* GridMyProducts */.j7; },
  "H2": function() { return /* reexport */ H2; },
  "HeaderContents": function() { return /* reexport */ HeaderContents; },
  "HeaderHome": function() { return /* reexport */ home/* HeaderHome */.Qz; },
  "HeaderShop": function() { return /* reexport */ shop.HeaderShop; },
  "HighlightsSection": function() { return /* reexport */ home/* HighlightsSection */.UQ; },
  "Layout": function() { return /* reexport */ layout/* Layout */.Ar; },
  "LayoutEmpty": function() { return /* reexport */ layout/* LayoutEmpty */.sN; },
  "LoadingScreen": function() { return /* reexport */ LoadingScreen; },
  "Logo": function() { return /* reexport */ layout/* Logo */.TR; },
  "LogoStyled": function() { return /* reexport */ layout/* LogoStyled */.AZ; },
  "Modal": function() { return /* reexport */ Modal; },
  "ModalAuth": function() { return /* reexport */ ModalAuth; },
  "ModalBuyBox": function() { return /* reexport */ ModalBuyBox; },
  "ModalCartType": function() { return /* reexport */ ModalCartType; },
  "ModalComercialRegion": function() { return /* reexport */ ModalComercialRegion; },
  "ModalFilters": function() { return /* reexport */ ModalFilters; },
  "ModalMenu": function() { return /* reexport */ ModalMenu; },
  "ModalMenuAccount": function() { return /* reexport */ ModalMenuAccount; },
  "ModalNewsletter": function() { return /* reexport */ ModalNewsletter; },
  "ModalPromo": function() { return /* reexport */ ModalPromo; },
  "ModalPublicInterested": function() { return /* reexport */ ModalPublicInterested; },
  "ModalRegion": function() { return /* reexport */ ModalRegion; },
  "ModalRegionRegister": function() { return /* reexport */ ModalRegionRegister; },
  "ModalSearch": function() { return /* reexport */ ModalSearch; },
  "ModalStockCart": function() { return /* reexport */ ModalStockCart; },
  "ModalSummary": function() { return /* reexport */ cart/* ModalSummary */.G9; },
  "ModalVideo": function() { return /* reexport */ ModalVideo; },
  "NavAccount": function() { return /* reexport */ NavAccount; },
  "NavShop": function() { return /* reexport */ shop.NavShop; },
  "NewCartItemsContext": function() { return /* reexport */ cart/* NewCartItemsContext */.K3; },
  "NoMessageP": function() { return /* reexport */ NoMessageP; },
  "OrderDetails": function() { return /* reexport */ OrderDetails; },
  "P": function() { return /* reexport */ P; },
  "ProductCard": function() { return /* reexport */ ProductCard; },
  "RepeatOrder": function() { return /* reexport */ cart/* RepeatOrder */.W4; },
  "SearchByCategory": function() { return /* reexport */ SearchByCategory; },
  "SearchResults": function() { return /* reexport */ SearchResults; },
  "SectionBestseller": function() { return /* reexport */ home/* SectionBestseller */.UG; },
  "SectionBrands": function() { return /* reexport */ home/* SectionBrands */.gq; },
  "SectionContents": function() { return /* reexport */ SectionContents; },
  "SectionFaqCategories": function() { return /* reexport */ SectionFaqCategories; },
  "SectionFilters": function() { return /* reexport */ shop.SectionFilters; },
  "SectionFiltersFeatured": function() { return /* reexport */ shop.SectionFiltersFeatured; },
  "SectionHighlights": function() { return /* reexport */ home/* SectionHighlights */.tL; },
  "SectionIngredients": function() { return /* reexport */ SectionIngredients; },
  "SectionInvoices": function() { return /* reexport */ SectionInvoices; },
  "SectionMoreInfo": function() { return /* reexport */ SectionMoreInfo; },
  "SectionMyProducts": function() { return /* reexport */ home/* SectionMyProducts */.JD; },
  "SectionNutrition": function() { return /* reexport */ SectionNutrition; },
  "SectionNutritionChart": function() { return /* reexport */ SectionNutritionChart; },
  "SectionOrders": function() { return /* reexport */ SectionOrders; },
  "SectionProductDetail": function() { return /* reexport */ shop.SectionProductDetail; },
  "SectionProductList": function() { return /* reexport */ shop.SectionProductList; },
  "SectionQuestionsList": function() { return /* reexport */ SectionQuestionsList; },
  "SectionRelated": function() { return /* reexport */ SectionRelated; },
  "SectionShop": function() { return /* reexport */ SectionShop; },
  "SectionStorePicker": function() { return /* reexport */ home/* SectionStorePicker */.KU; },
  "SectionUserAuth": function() { return /* reexport */ SectionUserAuth; },
  "Subscribe": function() { return /* reexport */ home/* Subscribe */.xs; },
  "Table": function() { return /* reexport */ Table; },
  "ViewMore": function() { return /* reexport */ shop.ViewMore; },
  "_Price": function() { return /* reexport */ cart/* _Price */.Xz; },
  "defaultAuthModalLevel": function() { return /* reexport */ defaultAuthModalLevel; },
  "defaultCommercial": function() { return /* reexport */ defaultCommercial; },
  "dialogStyles": function() { return /* reexport */ dialogStyles; },
  "dialogVariants": function() { return /* reexport */ dialogVariants; },
  "getAccountListItems": function() { return /* reexport */ getAccountListItems; },
  "getCommercials": function() { return /* reexport */ getCommercials; },
  "getCommercialsByCountry": function() { return /* reexport */ getCommercialsByCountry; },
  "getCountries": function() { return /* reexport */ getCountries; },
  "getFilterLabels": function() { return /* reexport */ getFilterLabels; },
  "getLegend": function() { return /* reexport */ getLegend; },
  "getOrderSummary": function() { return /* reexport */ getOrderSummary; },
  "getPricePerUnit": function() { return /* reexport */ getPricePerUnit; },
  "getSubdivisions": function() { return /* reexport */ getSubdivisions; },
  "imageVariants": function() { return /* reexport */ home/* imageVariants */.s2; },
  "img_variants_center": function() { return /* reexport */ home/* img_variants_center */.$i; },
  "img_variants_left": function() { return /* reexport */ home/* img_variants_left */.Sy; },
  "img_variants_right": function() { return /* reexport */ home/* img_variants_right */.r6; },
  "img_variants_single": function() { return /* reexport */ home/* img_variants_single */.fJ; },
  "itemVariants": function() { return /* reexport */ cart/* itemVariants */.Di; },
  "listVariants": function() { return /* reexport */ cart/* listVariants */.hg; },
  "logoVariants": function() { return /* reexport */ home/* logoVariants */.OJ; },
  "text_variants_button": function() { return /* reexport */ home/* text_variants_button */.Px; },
  "text_variants_button_highlights": function() { return /* reexport */ home/* text_variants_button_highlights */.sA; },
  "text_variants_subtitle": function() { return /* reexport */ home/* text_variants_subtitle */._r; },
  "text_variants_subtitle_highlights": function() { return /* reexport */ home/* text_variants_subtitle_highlights */.Z6; },
  "text_variants_title": function() { return /* reexport */ home/* text_variants_title */.ru; },
  "text_variants_title_highlights": function() { return /* reexport */ home/* text_variants_title_highlights */.HG; },
  "wrapperVariants": function() { return /* reexport */ home/* wrapperVariants */.vd; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
;// CONCATENATED MODULE: ./components/forms/FormCustomerUpdate.tsx
"use client";











var FormCustomerUpdate = /*#__PURE__*/ (0,react.memo)(function(param) {
    var animation = param.animation, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "background" : _bgColor, defaultEmail = param.defaultEmail;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors;
    var addToast = (0,dist_hooks.useToast)().addToast;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData, e) {
            var email, password, DYCustomerToken, res, data, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        email = formData.email, password = formData.password;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        return [
                            4,
                            fetch("/api/customer/update", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    email: email,
                                    password: password,
                                    DYCustomerToken: DYCustomerToken
                                })
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data = _state.sent().data;
                        addToast({
                            type: "success",
                            message: t("modals.auth.feedback_password_updated.text")
                        });
                        console.log("@@@ customerUpdate onSubmit res data", data);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e1 = _state.sent();
                        addToast({
                            type: "error",
                            message: t("commons.newsletter_feedback.error")
                        });
                        console.error("Customer update failed:", e1);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData, e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitError = function(errors, e) {
        return console.log(errors, e);
    };
    (0,react.useEffect)(function() {
        if (Object.keys(formErrors).length > 0) {
            console.log("CustomerUpdate formErrors:", formErrors);
            addToast({
                type: "warning",
                message: t("form.errors.pattern_password")
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formErrors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onSubmit: handleSubmit(onSubmit, onSubmitError)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: false,
                ariaBusy: false,
                legend: t("modals.auth.login.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "email",
                        name: "email",
                        register: register,
                        label: t("form.fields.email"),
                        defaultValue: defaultEmail,
                        placeholder: "email",
                        autoComplete: utils.autoComplete.email,
                        required: {
                            required: t("form.errors.pattern_email"),
                            pattern: utils.inputPattern.email
                        },
                        error: formErrors.email,
                        bgColor: bgColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "password",
                        name: "password",
                        register: register,
                        label: t("form.fields.new_password"),
                        placeholder: "password",
                        autoComplete: utils.autoComplete.password.current,
                        icon: "password",
                        bgColor: bgColor,
                        required: {
                            required: t("form.errors.pattern_password"),
                            pattern: utils.inputPattern.password
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "submit",
                bgType: "red",
                children: t("commons.actions.save")
            })
        ]
    }));
});

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(24432);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(95163);
;// CONCATENATED MODULE: ./components/forms/FormCustomerUpdateAddresses.tsx
"use client";













var FormCustomerUpdateAddresses = /*#__PURE__*/ (0,react.memo)(function(param) {
    var animation = param.animation, data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var locale = (0,router.useRouter)().locale;
    var countryCode = (0,react.useMemo)(function() {
        return (0,utils.getLocaleCountry)(locale).split("-")[1];
    }, [
        locale
    ]);
    var ref12 = (0,index_esm/* useForm */.cI)(), register = ref12.register, handleSubmit = ref12.handleSubmit, _formState = ref12.formState, formErrors = _formState.errors, setValue = ref12.setValue, watch = ref12.watch;
    // @ts-ignore
    var shippingPostalCode = watch("shipping[postalCode]");
    var ref13 = (0,react.useState)([]), countries = ref13[0], setCountries = ref13[1];
    var ref14 = (0,react.useState)([]), provinces = ref14[0], setProvinces = ref14[1];
    var ref15 = (0,react.useState)(false), validShippingPostalCode = ref15[0], setValidShippingPostalCode = ref15[1];
    console.log("validShippingPostalCode", validShippingPostalCode);
    var ref16 = (0,useQuery/* useQuery */.a)(api/* GET_POSTAL_CODES_VALID */.fI, {
        context: {
            isPrivatePath: true
        }
    }), resPostalCodes = ref16.data;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData) {
            var ref, ref1, billing, shipping, billingAddress, shippingAddress, addresses, DYCustomerToken, res, data1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        billing = formData.billing, shipping = formData.shipping;
                        billingAddress = {
                            bigcommerceId: data.billing.bigcommerceId,
                            firstName: billing.firstName,
                            lastName: billing.lastName,
                            street1: billing.streetLine,
                            street2: billing.streetLine2,
                            countryCode: billing.countryCode,
                            region: (ref = provinces.find(function(item) {
                                return item.value === billing.provinceCode;
                            })) === null || ref === void 0 ? void 0 : ref.name,
                            city: billing.city,
                            postalCode: billing.postalCode
                        };
                        shippingAddress = {
                            bigcommerceId: data.shipping.bigcommerceId,
                            firstName: shipping.firstName,
                            lastName: shipping.lastName,
                            street1: shipping.streetLine,
                            street2: shipping.streetLine2,
                            countryCode: shipping.countryCode,
                            region: (ref1 = provinces.find(function(item) {
                                return item.value === shipping.provinceCode;
                            })) === null || ref1 === void 0 ? void 0 : ref1.name,
                            city: shipping.city,
                            postalCode: shipping.postalCode
                        };
                        addresses = [
                            billingAddress,
                            shippingAddress
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        return [
                            4,
                            fetch("/api/customer/update-addresses", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    addresses: addresses,
                                    DYCustomerToken: DYCustomerToken
                                })
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        console.log("@@@ customerUpdateAddresses onSubmit res data", data1);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        console.error("Customer Addresses Update catch error:", e);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitError = function(errors, e) {
        return console.log(errors, e);
    };
    (0,react.useEffect)(function() {
        function getProvinces(countryCode) {
            return _getProvinces.apply(this, arguments);
        }
        function _getProvinces() {
            _getProvinces = (0,_async_to_generator/* default */.Z)(function(countryCode) {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__(94991)("./".concat(countryCode, "-provinces.json"))
                            ];
                        case 1:
                            data = _state.sent();
                            if (data) setProvinces(Array.from(data));
                            return [
                                2
                            ];
                    }
                });
            });
            return _getProvinces.apply(this, arguments);
        }
        function getCountries() {
            return _getCountries.apply(this, arguments);
        }
        function _getCountries() {
            _getCountries = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 1316).then(__webpack_require__.t.bind(__webpack_require__, 71316, 19))
                            ];
                        case 1:
                            data = _state.sent();
                            if (data) setCountries(Array.from(data));
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCountries.apply(this, arguments);
        }
        if (countries.length === 0 && typeof locale === "string") {
            getCountries();
        }
        if (provinces.length === 0 && typeof locale === "string") {
            if (typeof countryCode === "string" && countryCode !== "EU") getProvinces(countryCode);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        if (typeof shippingPostalCode !== "string") return;
        var regex = new RegExp(utils.inputPattern.postalCode[countryCode]);
        var patternValid = regex.test(shippingPostalCode);
        if (patternValid) {
            var ref;
            var arr = (ref = resPostalCodes === null || resPostalCodes === void 0 ? void 0 : resPostalCodes.validPostalCodes) !== null && ref !== void 0 ? ref : [];
            setValidShippingPostalCode((0,utils.shippingPostalCodeValid)(arr, shippingPostalCode));
        }
    }, [
        resPostalCodes,
        shippingPostalCode,
        countryCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onSubmit: handleSubmit(onSubmit, onSubmitError)
    }, animation && animation), {
        children: [
            data.billing && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: true,
                ariaBusy: false,
                legend: t("account.order.billing_address"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[firstName]",
                        defaultValue: data.billing.firstName,
                        col: 6,
                        register: register,
                        label: t("form.fields.first_name"),
                        required: true,
                        error: (ref = formErrors.billing) === null || ref === void 0 ? void 0 : ref.firstName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[lastName]",
                        defaultValue: data.billing.lastName,
                        col: 6,
                        register: register,
                        label: t("form.fields.last_name"),
                        required: true,
                        error: (ref1 = formErrors.billing) === null || ref1 === void 0 ? void 0 : ref1.lastName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        readOnly: true,
                        name: "billing[countryCode]",
                        defaultValue: data.billing.countryCode,
                        col: 6,
                        register: register,
                        label: t("form.fields.country"),
                        options: countries,
                        setFormValue: setValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        readOnly: true,
                        name: "billing[provinceCode]",
                        defaultValue: (ref2 = provinces.find(function(item) {
                            return item.name == data.billing.region;
                        })) === null || ref2 === void 0 ? void 0 : ref2.value,
                        col: 6,
                        register: register,
                        label: t("form.fields.province"),
                        options: provinces,
                        setFormValue: setValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[city]",
                        defaultValue: data.billing.city,
                        col: 12,
                        register: register,
                        label: t("form.fields.city"),
                        autoComplete: utils.autoComplete.address.cityOrTown
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[postalCode]",
                        defaultValue: data.billing.postalCode,
                        col: 12,
                        register: register,
                        label: t("form.fields.postal_code"),
                        required: {
                            required: t("form.errors.empty"),
                            pattern: utils.inputPattern.postalCode[countryCode]
                        },
                        error: (ref3 = formErrors.billing) === null || ref3 === void 0 ? void 0 : ref3.postalCode,
                        autoComplete: utils.autoComplete.address.postalCode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[streetLine]",
                        defaultValue: data.billing.street1,
                        register: register,
                        label: t("form.fields.street_line1"),
                        required: true,
                        error: (ref4 = formErrors.billing) === null || ref4 === void 0 ? void 0 : ref4.streetLine,
                        autoComplete: utils.autoComplete.address.street
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "billing[streetLine2]",
                        defaultValue: data.billing.street2,
                        col: 6,
                        register: register,
                        label: t("form.fields.street_line2"),
                        error: (ref5 = formErrors.billing) === null || ref5 === void 0 ? void 0 : ref5.streetLine2,
                        autoComplete: utils.autoComplete.address.street2
                    })
                ]
            }),
            data.shipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: true,
                ariaBusy: false,
                legend: t("account.order.shipping_address"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[firstName]",
                        defaultValue: data.shipping.firstName,
                        col: 6,
                        register: register,
                        label: t("form.fields.first_name"),
                        required: true,
                        error: (ref6 = formErrors.shipping) === null || ref6 === void 0 ? void 0 : ref6.firstName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[lastName]",
                        defaultValue: data.shipping.lastName,
                        col: 6,
                        register: register,
                        label: t("form.fields.last_name"),
                        required: true,
                        error: (ref7 = formErrors.shipping) === null || ref7 === void 0 ? void 0 : ref7.lastName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "shipping[countryCode]",
                        defaultValue: data.shipping.countryCode,
                        col: 6,
                        register: register,
                        label: t("form.fields.country"),
                        options: countries,
                        readOnly: true,
                        setFormValue: setValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        readOnly: true,
                        name: "shipping[provinceCode]",
                        defaultValue: (ref8 = provinces.find(function(item) {
                            return item.name == data.shipping.region;
                        })) === null || ref8 === void 0 ? void 0 : ref8.value,
                        col: 6,
                        register: register,
                        label: t("form.fields.province"),
                        options: provinces.filter(function(item) {
                            return item.in === "ES-CT";
                        }),
                        setFormValue: setValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[city]",
                        defaultValue: data.shipping.city,
                        col: 12,
                        register: register,
                        label: t("form.fields.city"),
                        autoComplete: utils.autoComplete.address.cityOrTown
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[postalCode]",
                        defaultValue: data.shipping.postalCode,
                        col: 12,
                        register: register,
                        label: t("form.fields.postal_code"),
                        required: {
                            required: true,
                            pattern: utils.inputPattern.postalCode[countryCode]
                        },
                        error: (ref9 = formErrors.shipping) === null || ref9 === void 0 ? void 0 : ref9.postalCode,
                        autoComplete: utils.autoComplete.address.postalCode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[streetLine]",
                        defaultValue: data.shipping.street1,
                        register: register,
                        label: t("form.fields.street_line1"),
                        required: true,
                        error: (ref10 = formErrors.shipping) === null || ref10 === void 0 ? void 0 : ref10.streetLine,
                        autoComplete: utils.autoComplete.address.street
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        readOnly: true,
                        name: "shipping[streetLine2]",
                        defaultValue: data.shipping.street2,
                        col: 6,
                        register: register,
                        label: t("form.fields.street_line2"),
                        error: (ref11 = formErrors.shipping) === null || ref11 === void 0 ? void 0 : ref11.streetLine2,
                        autoComplete: utils.autoComplete.address.street2
                    })
                ]
            })
        ]
    }));
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../commons/dist/context/index.js
var context = __webpack_require__(7693);
;// CONCATENATED MODULE: ./components/forms/FormUserCheckCIF.tsx
"use client";

















var FormUserCheckCIF = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation;
    var locale = (0,router.useRouter)().locale;
    var countryCode = (0,utils.getRegion)(locale);
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors, reset = ref.reset;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_EMAIL_INVITE */.i_, {
        errorPolicy: "all"
    }), 2), customerEmailInvite = ref1[0], ref2 = ref1[1], loading = ref2.loading, apolloError = ref2.error;
    var ref3 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleModalRegion = ref3.toggle;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, vatNumber, ref1, resData, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        vatNumber = data.vatNumber;
                        return [
                            4,
                            customerEmailInvite({
                                variables: {
                                    vatNumber: vatNumber
                                },
                                context: {
                                    isPrivatePath: true
                                }
                            })
                        ];
                    case 1:
                        ref1 = _state.sent(), resData = ref1.data;
                        res = resData === null || resData === void 0 ? void 0 : resData.customerEmailInvite;
                        if (!res) throw new Error("Unhandled customerEmailInvite error encountered, probably ApolloError");
                        if (res === null || res === void 0 ? void 0 : res.ok) {
                            updateLevel("feedback_email_invite", {
                                emailObfuscated: res.customer.emailObfuscated
                            });
                        } else if ((res === null || res === void 0 ? void 0 : (ref = res.customer) === null || ref === void 0 ? void 0 : ref.onboardingStatus) === "active") {
                            updateLevel("feedback_cif_already_active", {
                                emailObfuscated: res.customer.emailObfuscated
                            });
                        } else {
                            updateLevel("feedback_cif_not_found", {
                                vatNumber: vatNumber
                            });
                        }
                        reset();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (apolloError) console.warn("apolloError:", apolloError);
    }, [
        apolloError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        method: "post",
        onSubmit: handleSubmit(onSubmit)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("modals.auth.login_check_cif.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "light",
                        children: [
                            (0,utils.getDynamicText)(t("modals.auth.login_check_cif.text2"), {
                                storeName: utils.getStoreByLocale[locale]
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    toggleModalRegion();
                                },
                                children: t("modals.auth.login_check_cif.text2_action")
                            }),
                            "."
                        ]
                    }, "p-light"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "vatNumber",
                        register: register,
                        label: t("form.fields.cif"),
                        required: (0,_object_spread/* default */.Z)({
                            required: true
                        }, countryCode === "ES" && {
                            validate: function(value) {
                                return utils.validate.cif(value) || t("form.errors.validate_cif");
                            }
                        }),
                        error: formErrors.vatNumber,
                        bgColor: "white"
                    }, "vatNumber")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "submit",
                bgType: "red",
                outline: true,
                children: t("commons.actions.continue")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "subtext",
                children: [
                    t("modals.auth.prelogin.subtext"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            updateLevel("signup_cif");
                        },
                        children: t("modals.auth.prelogin.subtext_action")
                    }),
                    "."
                ]
            })
        ]
    }));
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
;// CONCATENATED MODULE: ./components/forms/FormUserInitial.tsx
"use client";



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  button:last-child {\n    margin-top: 0;\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 0;\n    }\n  }\n\n  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {\n    button:last-child {\n      margin-top: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







// temp loading until useMutation updated
var loading = false;
var FormStyled = (0,styled_components_browser_esm["default"])(components.Form).withConfig({
    displayName: "FormUserInitial__FormStyled",
    componentId: "sc-14efa273-0"
})(_templateObject(), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"));
var FormUserInitial = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("modals.auth.start.text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                onClick: function() {
                    updateLevel("prelogin");
                },
                bgType: "red",
                children: t("modals.auth.start.actions.primary")
            }),
            utils.DY_SIGNUP_ALLOWED && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                onClick: function() {
                    updateLevel("signup_cif");
                },
                bgType: "red",
                outline: true,
                children: t("modals.auth.start.actions.secondary")
            })
        ]
    }), "form-user-start");
});

// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
;// CONCATENATED MODULE: ./components/forms/FormUserSignUpCIF.tsx
"use client";
















var getLegend = function(locale, t, toggleModalRegion) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,utils.getDynamicText)(t("modals.auth.signup_cif.text"), {
                storeName: utils.getStoreByLocale[locale]
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: toggleModalRegion,
                children: t("modals.auth.signup_cif.text_action")
            }),
            "."
        ]
    });
};
var FormUserSignUpCIF = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors;
    var locale = (0,router.useRouter)().locale;
    var countryCode = (0,react.useMemo)(function() {
        return (0,utils.getLocaleCountry)(locale).split("-")[1];
    }, [
        locale
    ]);
    var ref1 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleModalRegion = ref1.toggle;
    var legend = (0,react.useMemo)(function() {
        return getLegend(locale, t, toggleModalRegion);
    }, [
        locale,
        t,
        toggleModalRegion
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(api/* GET_CUSTOMERS_BY_VAT_NUMBER */.j3), 2), customers = ref2[0], loading = ref2[1].loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_EMAIL_INVITE */.i_, {
        errorPolicy: "all"
    }), 1), customerEmailInvite = ref3[0];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData, e) {
            var ref, ref1, data, customer, onboardingStatus, ref2, resData, res, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            customers({
                                variables: {
                                    vatNumber: formData.vatNumber
                                },
                                context: {
                                    isPrivatePath: true
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        customer = data === null || data === void 0 ? void 0 : (ref = data.customers) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1[0];
                        if (!!customer) return [
                            3,
                            3
                        ];
                        updateLevel("signup", {
                            vatNumber: formData.vatNumber
                        });
                        return [
                            3,
                            6
                        ];
                    case 3:
                        onboardingStatus = customer.onboardingStatus === "invited" ? "inactive" : customer.onboardingStatus;
                        if (!(onboardingStatus === "inactive")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            customerEmailInvite({
                                variables: {
                                    vatNumber: formData.vatNumber
                                },
                                context: {
                                    isPrivatePath: true
                                }
                            })
                        ];
                    case 4:
                        ref2 = _state.sent(), resData = ref2.data;
                        res = resData === null || resData === void 0 ? void 0 : resData.customerEmailInvite;
                        if (res === null || res === void 0 ? void 0 : res.ok) {
                            updateLevel("feedback_email_invite", {
                                vatNumber: formData.vatNumber,
                                emailObfuscated: customer.emailObfuscated
                            });
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        updateLevel("feedback_cif_already_active", {
                            emailObfuscated: customer.emailObfuscated
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e1 = _state.sent();
                        console.error("customerByVatNumber failed:", e1);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData, e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitError = function(errors, e) {
        return console.log(errors, e);
    };
    (0,react.useEffect)(function() {
        if (Object.keys(formErrors).length > 0) console.log("customerByVatNumber formErrors:", formErrors);
    }, [
        formErrors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onSubmit: handleSubmit(onSubmit, onSubmitError)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: legend,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                    name: "vatNumber",
                    register: register,
                    label: t("form.fields.cif"),
                    required: (0,_object_spread/* default */.Z)({
                        required: true
                    }, countryCode === "ES" && {
                        validate: function(value) {
                            return utils.validate.cif(value) || t("form.errors.validate_cif");
                        }
                    }),
                    error: formErrors.vatNumber,
                    bgColor: "white"
                }, "vatNumber")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "submit",
                bgType: "red",
                children: t("commons.actions.continue")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "subtext",
                children: [
                    t("modals.auth.signup_cif.subtext"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            updateLevel("login");
                        },
                        children: t("modals.auth.signup_cif.subtext_action")
                    }),
                    "."
                ]
            })
        ]
    }));
});

;// CONCATENATED MODULE: ./components/forms/FormUserSignUp.tsx
"use client";

















var businessOptions = [
    {
        name: "Restaurante",
        value: "RESTAURANT"
    },
    {
        name: "Comercial",
        value: "COMMERCIAL"
    },
    {
        name: "Distribuidor",
        value: "DISTRIBUTOR"
    }
];
// const businessOptions = [
//   {
//     name: 'Restaurant',
//     value: 'RESTAURANT'
//   },
//   {
//     name: 'Commercial',
//     value: 'COMMERCIAL'
//   },
//   {
//     name: 'Distributor',
//     value: 'DISTRIBUTOR',
//   }
// ]
var FormUserSignUp = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation, payload = param.payload;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleModalRegion = ref11.toggle;
    var ref12 = (0,index_esm/* useForm */.cI)(), register = ref12.register, handleSubmit = ref12.handleSubmit, _formState = ref12.formState, formErrors = _formState.errors, setValue = ref12.setValue, watch = ref12.watch;
    var setLoaderActive = (0,hooks/* useCustomer */.ON)().setLoaderActive;
    // Input being watched
    var sameShippingBillingAddress = watch("sameShippingBillingAddress");
    var directDebit = watch("directDebit");
    // @ts-ignore
    var billingPostalCode = watch("billing[postalCode]");
    // @ts-ignore
    var shippingPostalCode = watch("shipping[postalCode]");
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref13 = (0,router.useRouter)(), locale = ref13.locale, push = ref13.push;
    var countryCode = (0,react.useMemo)(function() {
        return (0,utils.getLocaleCountry)(locale).split("-")[1];
    }, [
        locale
    ]);
    var legend = (0,react.useMemo)(function() {
        return getLegend(locale, t, toggleModalRegion);
    }, [
        locale,
        t,
        toggleModalRegion
    ]);
    var ref14 = (0,react.useState)([]), countries = ref14[0], setCountries = ref14[1];
    var ref15 = (0,react.useState)([]), provinces = ref15[0], setProvinces = ref15[1];
    var ref16 = (0,react.useState)(false), validBillingPostalCodeForShipping = ref16[0], setValidBillingPostalCodeForShipping = ref16[1];
    var ref17 = (0,react.useState)(false), validShippingPostalCode = ref17[0], setValidShippingPostalCode = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* SIGNUP_MUTATION */.Rw), 2), _customerRegister = ref18[0], ref19 = ref18[1], loading = ref19.loading, apolloError = ref19.error;
    var ref20 = (0,useQuery/* useQuery */.a)(api/* GET_POSTAL_CODES_VALID */.fI, {
        context: {
            isPrivatePath: true
        }
    }), resPostalCodes = ref20.data;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData) {
            var email, password, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoaderActive(true);
                        email = formData.email, password = formData.password;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        // const { data } = await customerRegister({
                        //   variables: {
                        //     email,
                        //     password,
                        //     firstName: billing.firstName,
                        //     lastName: billing.lastName,
                        //     companyName: billing.companyName,
                        //     formFields,
                        //     addresses
                        //   },
                        //   context: {
                        //     isPrivatePath: true
                        //   }
                        // })
                        // const res = data?.customerRegister
                        return [
                            4,
                            (0,utils.loginCustomer)({
                                email: email,
                                password: password,
                                push: push
                            })
                        ];
                    case 2:
                        _state.sent();
                        updateLevel(defaultAuthModalLevel, {}, true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setLoaderActive(false);
                        console.log("SignUp catch e:", e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onError = function(errors, e) {
        console.warn("\uD83D\uDFE1 Errors found before Submit");
        console.log(errors, e);
    };
    (0,react.useEffect)(function() {
        function getProvinces(countryCode) {
            return _getProvinces.apply(this, arguments);
        }
        function _getProvinces() {
            _getProvinces = (0,_async_to_generator/* default */.Z)(function(countryCode) {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__(94991)("./".concat(countryCode, "-provinces.json"))
                            ];
                        case 1:
                            data = _state.sent();
                            if (data) setProvinces(Array.from(data));
                            return [
                                2
                            ];
                    }
                });
            });
            return _getProvinces.apply(this, arguments);
        }
        function getCountries() {
            return _getCountries.apply(this, arguments);
        }
        function _getCountries() {
            _getCountries = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 1316).then(__webpack_require__.t.bind(__webpack_require__, 71316, 19))
                            ];
                        case 1:
                            data = _state.sent();
                            if (data) setCountries(Array.from(data));
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCountries.apply(this, arguments);
        }
        if (countries.length === 0 && typeof locale === "string") {
            getCountries();
        }
        if (provinces.length === 0 && typeof locale === "string") {
            if (typeof countryCode === "string" && countryCode !== "EU") getProvinces(countryCode);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        if (typeof billingPostalCode !== "string") return;
        var regex = new RegExp(utils.inputPattern.postalCode[countryCode]);
        var patternValid = regex.test(billingPostalCode);
        if (patternValid) {
            var ref;
            var arr = (ref = resPostalCodes === null || resPostalCodes === void 0 ? void 0 : resPostalCodes.validPostalCodes) !== null && ref !== void 0 ? ref : [];
            var billingCheck = (0,utils.shippingPostalCodeValid)(arr, billingPostalCode);
            setValidBillingPostalCodeForShipping(billingCheck);
            if (sameShippingBillingAddress) setValidShippingPostalCode(billingCheck);
        }
    }, [
        resPostalCodes,
        billingPostalCode,
        countryCode,
        sameShippingBillingAddress
    ]);
    (0,react.useEffect)(function() {
        if (typeof shippingPostalCode !== "string") return;
        var regex = new RegExp(utils.inputPattern.postalCode[countryCode]);
        var patternValid = regex.test(shippingPostalCode);
        if (patternValid) {
            var ref;
            var arr = (ref = resPostalCodes === null || resPostalCodes === void 0 ? void 0 : resPostalCodes.validPostalCodes) !== null && ref !== void 0 ? ref : [];
            setValidShippingPostalCode((0,utils.shippingPostalCodeValid)(arr, shippingPostalCode));
        }
    }, [
        resPostalCodes,
        shippingPostalCode,
        countryCode
    ]);
    var _vatNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        method: "post",
        onSubmit: handleSubmit(onSubmit, onError)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: legend,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "vatNumber",
                        register: register,
                        label: t("form.fields.cif"),
                        required: (0,_object_spread/* default */.Z)({
                            required: true
                        }, countryCode === "ES" && {
                            validate: function(value) {
                                return utils.validate.cif(value) || t("form.errors.validate_cif");
                            }
                        }),
                        defaultValue: (_vatNumber = payload.vatNumber) !== null && _vatNumber !== void 0 ? _vatNumber : "",
                        error: formErrors.vatNumber,
                        bgColor: "white",
                        readOnly: !!payload.vatNumber
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "email",
                        name: "email",
                        register: register,
                        label: t("form.fields.email"),
                        placeholder: "email",
                        autoComplete: utils.autoComplete.email,
                        bgColor: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "password",
                        name: "password",
                        register: register,
                        label: t("form.fields.password"),
                        autoComplete: utils.autoComplete.password["new"],
                        placeholder: "password",
                        bgColor: "white",
                        required: {
                            required: t("form.errors.pattern_password"),
                            pattern: utils.inputPattern.password
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("account.order.billing_address"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[firstName]",
                        col: 6,
                        register: register,
                        label: t("form.fields.first_name"),
                        required: true,
                        error: (ref = formErrors.billing) === null || ref === void 0 ? void 0 : ref.firstName,
                        bgColor: "white"
                    }, "billing[firstName]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[lastName]",
                        col: 6,
                        register: register,
                        label: t("form.fields.last_name"),
                        required: true,
                        error: (ref1 = formErrors.billing) === null || ref1 === void 0 ? void 0 : ref1.lastName,
                        bgColor: "white"
                    }, "billing[lastName]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[companyName]",
                        register: register,
                        label: t("form.fields.company_name"),
                        required: true,
                        error: (ref2 = formErrors.billing) === null || ref2 === void 0 ? void 0 : ref2.companyName,
                        bgColor: "white"
                    }, "billing[companyName]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "billing[countryCode]",
                        col: 6,
                        register: register,
                        label: t("form.fields.country"),
                        options: countries,
                        setFormValue: setValue,
                        bgColor: "white",
                        readOnly: true,
                        defaultValue: "ES"
                    }, "billing[countryCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "billing[provinceCode]",
                        col: 6,
                        register: register,
                        label: t("form.fields.province"),
                        options: provinces,
                        setFormValue: setValue,
                        bgColor: "white"
                    }, "billing[provinceCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[city]",
                        col: 12,
                        register: register,
                        label: t("form.fields.city"),
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.cityOrTown
                    }, "billing[city]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[postalCode]",
                        col: 12,
                        register: register,
                        label: t("form.fields.postal_code"),
                        required: {
                            required: t("form.errors.empty"),
                            pattern: utils.inputPattern.postalCode[countryCode]
                        },
                        error: (ref3 = formErrors.billing) === null || ref3 === void 0 ? void 0 : ref3.postalCode,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.postalCode
                    }, "billing[postalCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[streetLine]",
                        register: register,
                        label: t("form.fields.street_line1"),
                        required: true,
                        error: (ref4 = formErrors.billing) === null || ref4 === void 0 ? void 0 : ref4.streetLine,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.street
                    }, "billing[streetLine]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "billing[streetLine2]",
                        col: 6,
                        register: register,
                        label: t("form.fields.street_line2"),
                        error: (ref5 = formErrors.billing) === null || ref5 === void 0 ? void 0 : ref5.streetLine2,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.street2
                    }, "billing[streetLine2]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "businessType",
                        col: 6,
                        register: register,
                        label: "Business Type",
                        error: formErrors.businessType,
                        options: businessOptions,
                        setFormValue: setValue,
                        bgColor: "white"
                    }, "businessType"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Checkbox, {
                        name: "sameShippingBillingAddress",
                        col: 12,
                        register: register,
                        label: t("form.fields.shipping_as_billing"),
                        bgColor: "white",
                        defaultChecked: true
                    }, "check-same")
                ]
            }),
            !sameShippingBillingAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("account.order.shipping_address"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[firstName]",
                        col: 6,
                        register: register,
                        label: t("form.fields.first_name"),
                        required: true,
                        error: (ref6 = formErrors.shipping) === null || ref6 === void 0 ? void 0 : ref6.firstName,
                        bgColor: "white"
                    }, "shipping[firstName]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[lastName]",
                        col: 6,
                        register: register,
                        label: t("form.fields.last_name"),
                        required: true,
                        error: (ref7 = formErrors.shipping) === null || ref7 === void 0 ? void 0 : ref7.lastName,
                        bgColor: "white"
                    }, "shipping[lastName]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[countryCode]",
                        col: 6,
                        register: register,
                        label: t("form.fields.country"),
                        readOnly: true,
                        defaultValue: "ES",
                        required: true,
                        bgColor: "white"
                    }, "shipping[countryCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "shipping[provinceCode]",
                        col: 6,
                        register: register,
                        label: t("form.fields.province"),
                        options: provinces.filter(function(item) {
                            return item.in === "ES-CT";
                        }),
                        setFormValue: setValue,
                        bgColor: "white"
                    }, "shipping[provinceCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[city]",
                        col: 12,
                        register: register,
                        label: t("form.fields.city"),
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.cityOrTown
                    }, "shipping[city]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[postalCode]",
                        col: 12,
                        register: register,
                        label: t("form.fields.postal_code"),
                        required: {
                            required: true,
                            pattern: utils.inputPattern.postalCode[countryCode]
                        },
                        error: (ref8 = formErrors.shipping) === null || ref8 === void 0 ? void 0 : ref8.postalCode,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.postalCode
                    }, "shipping[postalCode]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[streetLine]",
                        register: register,
                        label: t("form.fields.street_line1"),
                        required: true,
                        error: (ref9 = formErrors.shipping) === null || ref9 === void 0 ? void 0 : ref9.streetLine,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.street
                    }, "shipping[streetLine]"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "shipping[streetLine2]",
                        col: 6,
                        register: register,
                        label: t("form.fields.street_line2"),
                        error: (ref10 = formErrors.shipping) === null || ref10 === void 0 ? void 0 : ref10.streetLine2,
                        bgColor: "white",
                        autoComplete: utils.autoComplete.address.street2
                    }, "shipping[streetLine2]")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Checkbox, {
                        name: "noCommercialContact",
                        col: 12,
                        register: register,
                        label: "No quiero ser contactado por un commercial",
                        bgColor: "white"
                    }, "check-nocommerical"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Checkbox, {
                        name: "directDebit",
                        col: 12,
                        register: register,
                        label: "Domiciliacion Bancaria (optional)",
                        bgColor: "white"
                    }, "directdebit"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "p-tiny",
                        children: t("modals.auth.signup.iban")
                    }),
                    !!directDebit && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        name: "iban",
                        col: 12,
                        register: register,
                        label: "Bank account",
                        error: formErrors.iban,
                        bgColor: "white",
                        required: {
                            required: t("form.errors.empty"),
                            validate: function(value) {
                                return ((value === null || value === void 0 ? void 0 : value.length) > 1 ? utils.validate.iban(value, countryCode) : true) || t("form.errors.validate_iban");
                            }
                        }
                    }, "iban")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                disabled: Object.keys(formErrors).length > 0 || !validBillingPostalCodeForShipping && billingPostalCode === shippingPostalCode || !validShippingPostalCode,
                type: "submit",
                children: t("commons.actions.signup")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.DisplayError, {
                error: apolloError
            }, "display-error")
        ]
    }));
});

;// CONCATENATED MODULE: ../../node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

;// CONCATENATED MODULE: ./components/forms/FormUserActivateAccount.tsx
"use client";
















var FormUserActivateAccount = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation, payload = param.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors, setValue = ref.setValue;
    var ref1 = (0,react.useState)(null), submitCustomError = ref1[0], setSubmitCustomError = ref1[1];
    var push = (0,router.useRouter)().push;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_ACTIVATE_ACCOUNT */.Xb), 2), customerActivate = ref2[0], loading = ref2[1].loading;
    var setLoaderActive = (0,hooks/* useCustomer */.ON)().setLoaderActive;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var email, password, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email, password = data.password;
                        setLoaderActive(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            customerActivate({
                                variables: {
                                    password: password
                                },
                                context: {
                                    isPrivatePath: true,
                                    DYInviteToken: payload.activationToken
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0,utils.loginCustomer)({
                                email: email,
                                password: password,
                                push: push
                            })
                        ];
                    case 3:
                        _state.sent();
                        updateLevel("feedback_account_active");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        setLoaderActive(false);
                        console.warn(e);
                        setSubmitCustomError(e);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var decodeToken = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(token) {
                var decoded, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                jwt_decode_esm(token)
                            ];
                        case 1:
                            decoded = _state.sent();
                            setValue("email", decoded.email);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log("decoding e", e);
                            updateLevel(defaultAuthModalLevel, {}, true);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function decodeToken(token) {
                return _ref.apply(this, arguments);
            };
        }();
        if (payload.activationToken) decodeToken(payload.activationToken);
    }, [
        payload,
        setValue,
        updateLevel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        method: "post",
        onSubmit: handleSubmit(onSubmit)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("modals.auth.activation.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "email",
                        name: "email",
                        register: register,
                        label: t("form.fields.email"),
                        bgColor: "white",
                        readOnly: true,
                        placeholderVisible: true
                    }, "email-read"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "password",
                        name: "password",
                        register: register,
                        label: t("form.fields.password"),
                        autoComplete: utils.autoComplete.password["new"],
                        icon: "password",
                        bgColor: "white",
                        required: {
                            required: t("form.errors.pattern_password"),
                            pattern: utils.inputPattern.password
                        },
                        error: formErrors.password
                    }, "password")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                disabled: loading,
                type: "submit",
                children: t("commons.actions.save")
            }),
            submitCustomError && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.DisplayError, {
                error: submitCustomError
            }, "display-error")
        ]
    }));
});

;// CONCATENATED MODULE: ./components/forms/FormUserPreLogin.tsx
"use client";






var FormUserPreLogin = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                legend: t("modals.auth.prelogin.text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                onClick: function() {
                    updateLevel("login");
                },
                bgType: "red",
                children: t("modals.auth.prelogin.actions.primary")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                onClick: function() {
                    updateLevel("login_check_cif");
                },
                bgType: "red",
                outline: true,
                children: t("modals.auth.prelogin.actions.secondary")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "subtext",
                children: [
                    t("modals.auth.prelogin.subtext"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            updateLevel("signup_cif");
                        },
                        children: t("modals.auth.prelogin.subtext_action")
                    }),
                    "."
                ]
            })
        ]
    }));
});

;// CONCATENATED MODULE: ./components/forms/FormUserLogIn.tsx
"use client";















var FormUserLogIn = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "white" : _bgColor;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var push = (0,router.useRouter)().push;
    var isActive = (0,dist_hooks.useModal)(context.MODALS.AUTH).isActive;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors;
    var ref1 = (0,react.useState)(null), customError = ref1[0], setCustomError = ref1[1];
    var setLoaderActive = (0,hooks/* useCustomer */.ON)().setLoaderActive;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData, e) {
            var email, password, res, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        email = formData.email, password = formData.password;
                        setLoaderActive(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,utils.loginCustomer)({
                                email: email,
                                password: password,
                                push: push
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (typeof (res === null || res === void 0 ? void 0 : res.error) === "object" && Object.keys(res.error).length > 1) {
                            setCustomError(res.error);
                        } else {
                            updateLevel(defaultAuthModalLevel, {}, true);
                        }
                        setLoaderActive(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.warn("login catch e:", e1);
                        if (e1 === null || e1 === void 0 ? void 0 : e1.error) setCustomError(e1.error);
                        setLoaderActive(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData, e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitError = function(errors, e) {
        return console.log(errors, e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onSubmit: handleSubmit(onSubmit, onSubmitError)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                disabled: false,
                ariaBusy: false,
                legend: t("modals.auth.login.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "email",
                        name: "email",
                        register: register,
                        label: t("form.fields.email"),
                        placeholder: "email",
                        autoComplete: utils.autoComplete.email,
                        required: {
                            required: t("form.errors.pattern_email"),
                            pattern: utils.inputPattern.email
                        },
                        error: formErrors.email,
                        bgColor: bgColor
                    }, "email"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "password",
                        name: "password",
                        register: register,
                        label: t("form.fields.password"),
                        placeholder: "password",
                        autoComplete: utils.autoComplete.password.current,
                        required: true,
                        icon: "password",
                        bgColor: bgColor,
                        readOnly: !isActive
                    }, "password"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "p-subinput",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function() {
                                updateLevel("forgot_password");
                            },
                            children: t("modals.auth.login.forgot_password")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                disabled: Object.keys(formErrors).length > 0,
                type: "submit",
                bgType: "red",
                children: t("commons.actions.login")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.DisplayError, {
                error: customError
            }, "display-error--login"),
            utils.DY_SIGNUP_ALLOWED && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "subtext",
                children: [
                    t("modals.auth.login.subtext"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            updateLevel("login_check_cif");
                        },
                        children: t("modals.auth.login.subtext_action")
                    }),
                    "."
                ]
            })
        ]
    }));
});

;// CONCATENATED MODULE: ./components/forms/FormUserResetPassword.tsx
"use client";











var FormUserResetPassword = /*#__PURE__*/ (0,react.memo)(function(param) {
    var payload = param.payload, updateLevel = param.updateLevel;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, formErrors = _formState.errors;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_RESET_PASSWORD */.Ki), 2), customerResetPassword = ref1[0], loading = ref1[1].loading;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var password, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        password = data.password;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            customerResetPassword({
                                variables: {
                                    password: password
                                },
                                context: {
                                    isPrivatePath: true,
                                    DYResetPasswordToken: payload === null || payload === void 0 ? void 0 : payload.resetToken
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        updateLevel("feedback_password_updated");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        method: "post",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("modals.auth.reset_password.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                    type: "password",
                    name: "password",
                    label: t("form.fields.new_password"),
                    register: register,
                    autoComplete: "new-password",
                    placeholder: "password",
                    icon: "password",
                    bgColor: "white",
                    required: {
                        required: t("form.errors.pattern_password"),
                        pattern: utils.inputPattern.password
                    },
                    error: formErrors.password
                }, "password")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                disabled: loading,
                type: "submit",
                children: t("commons.actions.save")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/FormUserForgotPassword.tsx
"use client";













var FormUserForgotPassword = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, animation = param.animation, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "white" : _bgColor;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, reset = ref.reset, _formState = ref.formState, formErrors = _formState.errors;
    var ref1 = (0,react.useState)(null), submitCustomError = ref1[0], setSubmitCustomError = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_EMAIL_FORGOT_PASSWORD */.MV), 2), customerEmailResetPassword = ref2[0], loading = ref2[1].loading;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData, e) {
            var email, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        email = formData.email;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            customerEmailResetPassword({
                                variables: {
                                    email: email
                                },
                                context: {
                                    isPrivatePath: true
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        updateLevel && updateLevel("feedback_email_reset_password");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        console.warn(e1);
                        setSubmitCustomError(e1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        reset();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData, e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitError = function(errors, e) {
        return console.log(errors, e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onSubmit: handleSubmit(onSubmit, onSubmitError)
    }, animation && animation), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                disabled: loading,
                ariaBusy: loading,
                legend: t("modals.auth.forgot_password.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                    type: "email",
                    name: "email",
                    register: register,
                    label: t("form.fields.email"),
                    placeholder: "email",
                    autoComplete: utils.autoComplete.email,
                    required: {
                        required: t("form.errors.pattern_email"),
                        pattern: utils.inputPattern.email
                    },
                    error: formErrors.email,
                    bgColor: bgColor
                }, "email")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                disabled: Object.keys(formErrors).length > 0 || loading,
                type: "submit",
                bgType: "red",
                children: t("commons.actions.send")
            }),
            submitCustomError && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.DisplayError, {
                error: submitCustomError
            }, "display-error")
        ]
    }));
});

// EXTERNAL MODULE: ./components/forms/FormNewsletter.tsx
var FormNewsletter = __webpack_require__(17482);
;// CONCATENATED MODULE: ./components/forms/FormStore.tsx





function FormStore_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin: 0 auto;\n  max-width: ",
        ";\n  padding:  0;\n  width: 100%;\n\n  ",
        " {\n    max-width: ",
        ";\n    padding:  0;\n  }\n\n  ",
        " {\n    max-width: ",
        ";\n    padding: 0;\n  }\n\n  form {\n    > div {\n      margin: 0 auto;\n\n      &:first-child {\n        z-index: 5;\n      }\n\n      &:last-of-type {\n        opacity: ",
        ";\n        pointer-events: ",
        ";\n        user-select: ",
        ";\n      }\n    }\n  }\n\n  .disabled {\n    opacity: 0.3;\n    pointer-events: none;\n    user-select: none;\n  }\n  button[type='submit'] {\n    width: ",
        ";\n    margin-top: ",
        ";\n  }\n"
    ]);
    FormStore_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: ",
        ";\n  padding: ",
        " ",
        ";\n  text-align: center;\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n  }\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n  }\n  ",
        " {\n    padding: 20px 12.5px;\n  }\n\n  dl {\n    margin: 0 0 ",
        ";\n\n    ",
        " {\n      margin: 0 0 ",
        ";\n    }\n  }\n\n  dt {\n    ",
        "\n    color: ",
        ";\n    padding-bottom: ",
        ";\n    text-align:  ",
        ";\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 10px;\n      margin-bottom: 20px;\n    }\n  }\n\n  dd {\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 30px;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  text-align:  ",
        ";\n\n  > span {\n    ",
        "\n    text-align:  ",
        ";\n    display: block;\n    margin-bottom: 2px;\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    &:first-child {\n      ",
        "\n    }\n  }\n\n  a {\n    ",
        "\n    color: ",
        ";\n    display: inline-block;\n    width: fit-content;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var getCommercials = function(data, textColorSubdividions, isModal, t) {
    return data.map(function(commercial, idx) {
        var client = commercial.client;
        var shouldDisplayClient = utils.NEXT_PUBLIC_LOCALE !== "en-GB" && utils.NEXT_PUBLIC_LOCALE !== "fr-FR" && utils.NEXT_PUBLIC_LOCALE !== "de-DE" && utils.NEXT_PUBLIC_LOCALE !== "pt-PT";
        var shouldDisplayLinkB2c = utils.NEXT_PUBLIC_LOCALE !== "de-DE" && utils.NEXT_PUBLIC_LOCALE !== "pt-PT";
        // const { client, area, address, contact: { name, tel, email }, operate_in } = commercial
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem, {
            $textColorSubdividions: textColorSubdividions,
            $isModal: isModal,
            children: [
                shouldDisplayClient && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: client
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t("modals.comercial_region.write_us"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: t("modals.comercial_region.mail_to_link"),
                            children: t("modals.comercial_region.mail_to")
                        }),
                        " ",
                        t("modals.comercial_region.more_info")
                    ]
                }),
                shouldDisplayLinkB2c && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t("modals.comercial_region.b2c"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: t("modals.comercial_region.link_to_b2c"),
                            target: "_blank",
                            children: t("modals.comercial_region.link_b2c")
                        })
                    ]
                })
            ]
        }, "commercial-".concat(idx));
    });
};
var defaultCommercial = [
    {
        client: "MAMMAFIORE DISTRIBUTION",
        contact: {
            email: "comercial@mammafiore.eu"
        }
    }
];
var displayComercial = false;
var buttonDisabled = true;
var getStore = function(regionCode, subdivisionCode, subdivisions) {
    if ((regionCode === null || regionCode === void 0 ? void 0 : regionCode.length) > 0) buttonDisabled = false;
    var store = null;
    if (regionCode === "ES") {
        buttonDisabled = true;
        if (!subdivisionCode) return store;
        var subdivisionData = subdivisions.filter(function(o) {
            return o.value === subdivisionCode;
        })[0];
        var val = subdivisionData.value;
        var locale = "".concat(val.split("-")[0].toLowerCase(), "-").concat(val.slice(-2));
        if (!(subdivisionData === null || subdivisionData === void 0 ? void 0 : subdivisionData.store)) displayComercial = true;
        store = {
            url: (0,utils.getStoreUrlByLocale)(locale, utils.PRO),
            locale: locale
        };
        buttonDisabled = false;
    } else if (regionCode === "GB") {
        store = {
            url: (0,utils.getStoreUrlByLocale)("en-GB", utils.PRO),
            locale: "en-GB",
            query: {
                zone: "GB"
            }
        };
    } else if (regionCode === "DE") {
        store = {
            url: (0,utils.getStoreUrlByLocale)("de-DE", utils.PRO),
            locale: "de-DE",
            query: {
                zone: "DE"
            }
        };
    } else if (regionCode === "FR") {
        store = {
            url: (0,utils.getStoreUrlByLocale)("fr-FR", utils.PRO),
            locale: "fr-FR",
            query: {
                zone: "FR"
            }
        };
    } else if (regionCode === "PT") {
        store = {
            url: (0,utils.getStoreUrlByLocale)("pt-PT", utils.PRO),
            locale: "pt-PT",
            query: {
                zone: "PT"
            }
        };
    }
    return store;
};
function getCountries() {
    return _getCountries.apply(this, arguments);
}
function _getCountries() {
    _getCountries = (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 1316).then(__webpack_require__.t.bind(__webpack_require__, 71316, 19))
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getCountries.apply(this, arguments);
}
function getCommercialsByCountry() {
    return _getCommercialsByCountry.apply(this, arguments);
}
function _getCommercialsByCountry() {
    _getCommercialsByCountry = (0,_async_to_generator/* default */.Z)(function() {
        var country, data;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    country = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "ES";
                    // @ts-ignore
                    if (country !== "ES") return [
                        2,
                        []
                    ];
                    return [
                        4,
                        __webpack_require__(76716)("./".concat(country, "-commercials.json"))
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getCommercialsByCountry.apply(this, arguments);
}
function getSubdivisions(countryCode) {
    return _getSubdivisions.apply(this, arguments);
}
function _getSubdivisions() {
    _getSubdivisions = (0,_async_to_generator/* default */.Z)(function(countryCode) {
        var data, dataArr, subdivisionWithData, dataStores, subdivisionsWithStores, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__(97820)("./".concat(countryCode, "-subdivisions.json"))
                    ];
                case 1:
                    data = _state.sent();
                    dataArr = Array.from(data);
                    subdivisionWithData = [];
                    if (!(countryCode === "ES")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        __webpack_require__(89049)("./".concat(countryCode, "-subdivisions-with-stores.json"))
                    ];
                case 2:
                    dataStores = _state.sent();
                    subdivisionsWithStores = Array.from(dataStores);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var item = _step.value;
                            // @ts-ignore
                            var idx = dataArr.find(function(o) {
                                return o.value === item.value;
                            });
                            if (idx) {
                                subdivisionWithData.push((0,_object_spread/* default */.Z)({}, dataArr[idx], item));
                                (0,utils.removeIndexFromArray)(dataArr, idx);
                            }
                        };
                        for(_iterator = subdivisionsWithStores[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        subdivisionWithData.concat(dataArr)
                    ];
            }
        });
    });
    return _getSubdivisions.apply(this, arguments);
}
var prevCountry = null;
var FormStore = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _bgInputColor = param.bgInputColor, bgInputColor = _bgInputColor === void 0 ? "red" : _bgInputColor, _textColorInput = param.textColorInput, textColorInput = _textColorInput === void 0 ? "darkred" : _textColorInput, colorWrapper = param.colorWrapper, _textColorSubdividions = param.textColorSubdividions, textColorSubdividions = _textColorSubdividions === void 0 ? "white" : _textColorSubdividions, _isModal = param.isModal, isModal = _isModal === void 0 ? false : _isModal, toggle = param.toggle, _dropdownTextColor = param.dropdownTextColor, dropdownTextColor = _dropdownTextColor === void 0 ? null : _dropdownTextColor;
    var ref, ref1, ref2;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var locale = (0,router.useRouter)().locale;
    // const { push } = useRouter()
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onChange"
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, setValue = ref3.setValue, watch = ref3.watch;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var selectedCountry = watch("country");
    var selectedSubdivision = watch("subdivision");
    var ref4 = (0,react.useState)([]), countries = ref4[0], setCountries = ref4[1];
    var ref5 = (0,react.useState)([]), subdivisions = ref5[0], setSubdivisions = ref5[1];
    var ref6 = (0,react.useState)([]), commercials = ref6[0], setCommercials = ref6[1];
    var Comercials = (0,react.useMemo)(function() {
        return getCommercials(commercials.length > 0 ? commercials : defaultCommercial, textColorSubdividions, isModal, t);
    }, [
        commercials,
        textColorSubdividions,
        isModal,
        t
    ]);
    var storeData = (0,react.useMemo)(function() {
        return getStore(selectedCountry, selectedSubdivision, subdivisions);
    }, [
        selectedCountry,
        selectedSubdivision,
        subdivisions
    ]);
    var cookieCatalogRegion = utils.cookie.get("DY_CATALOG_REGION");
    var onClickStore = function(storeData) {
        var ref;
        var value = (ref = storeData.locale) === null || ref === void 0 ? void 0 : ref.toUpperCase();
        utils.cookie.removeCookie("DY_CATALOG_REGION");
        utils.cookie.set({
            name: "DY_CATALOG_REGION",
            value: value,
            days: 365
        });
        if (storeData.locale !== locale) window.location.href = "https://".concat(storeData.url);
    };
    var onClickCatalogue = function(subdivisionValue, storeData) {
        var value = subdivisionValue === null || subdivisionValue === void 0 ? void 0 : subdivisionValue.toUpperCase();
        utils.cookie.removeCookie("DY_CATALOG_REGION");
        utils.cookie.set({
            name: "DY_CATALOG_REGION",
            value: value,
            days: 365
        });
        console.log("value", value);
        console.log("storeData", storeData);
        var ref;
        if (subdivisionValue !== locale) window.location.href = "https://".concat((ref = storeData === null || storeData === void 0 ? void 0 : storeData.url) !== null && ref !== void 0 ? ref : "mammafiore.es");
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData, _e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                console.log("FormStore submit data:", formData);
                toggle && toggle();
                return [
                    2
                ];
            });
        });
        return function onSubmit(formData, _e) {
            return _ref.apply(this, arguments);
        };
    }();
    var onError = function(errors, e) {
        console.log(errors, e);
    };
    (0,react.useEffect)(function() {
        if ((countries === null || countries === void 0 ? void 0 : countries.length) === 0) {
            getCountries().then(function(res) {
                setCountries(Array.from(res));
            });
        }
    }, [
        countries
    ]);
    (0,react.useEffect)(function() {
        if (prevCountry !== selectedCountry || !selectedSubdivision) {
            if (selectedCountry === "ES") {
                prevCountry = selectedCountry;
                getSubdivisions(selectedCountry).then(function(res) {
                    var data = Array.from(res).filter(function(item) {
                        return !item.hidden;
                    }).map(function(item) {
                        var value = [
                            "es-CT",
                            "es-MD",
                            "es-CN"
                        ].includes[locale] ? locale === null || locale === void 0 ? void 0 : locale.toUpperCase() : selectedSubdivision;
                        if (item.value === value) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            selected: true
                        });
                        return item;
                    });
                    var allSpainSelected = cookieCatalogRegion === "ES" && locale === "es-ES";
                    data.push({
                        name: "Resto de Espa\xf1a",
                        value: "ES",
                        selected: allSpainSelected
                    });
                    setSubdivisions(data);
                });
            } else {
                setSubdivisions([]);
            }
        }
    // if ((selectedCountry !== '' || !selectedCountry) && (selectedSubdivision !== '' || !selectedSubdivision)) {
    //   return () => subscription.unsubscribe()
    // }
    }, [
        selectedCountry,
        selectedSubdivision,
        locale,
        cookieCatalogRegion
    ]);
    (0,react.useEffect)(function() {
        if (selectedCountry === "ES") {
            getCommercialsByCountry(selectedCountry).then(function(res) {
                var arrOfCommercials = Array.from(res);
                if (selectedSubdivision) {
                    // @ts-ignore
                    var commercialsFiltered = arrOfCommercials.filter(function(item) {
                        return item.operate_in.find(function(area) {
                            return area === selectedSubdivision;
                        });
                    });
                    setCommercials(commercialsFiltered);
                }
            });
        }
    }, [
        selectedCountry,
        selectedSubdivision
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            $selectedCountry: selectedCountry,
            $colorWrapper: colorWrapper,
            className: "wrapper_store_picker",
            $isModal: isModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit, onError),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "country",
                        placeholder: t("form.fields.country"),
                        placeholderVisible: true,
                        options: countries,
                        register: register,
                        setFormValue: setValue,
                        textColor: textColorInput,
                        bgColor: bgInputColor,
                        dropdownTextColor: dropdownTextColor,
                        defaultValue: ((ref = utils.NEXT_PUBLIC_LOCALE.split("-")[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === "EN" ? "GB" : (ref1 = utils.NEXT_PUBLIC_LOCALE.split("-")[0]) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Select, {
                        name: "subdivision",
                        placeholder: "Regi\xf3n",
                        placeholderVisible: true,
                        options: subdivisions,
                        register: register,
                        setFormValue: setValue,
                        textColor: textColorInput,
                        bgColor: bgInputColor,
                        dropdownTextColor: dropdownTextColor,
                        defaultValue: utils.NEXT_PUBLIC_LOCALE === "es-ES" ? cookieCatalogRegion : utils.NEXT_PUBLIC_LOCALE.toUpperCase()
                    }),
                    displayComercial && subdivisions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Div, {
                        $active: selectedSubdivision,
                        $textColorSubdividions: textColorSubdividions,
                        $isModal: isModal,
                        className: "subdivisions",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                        children: [
                                            t("commons.region_picker.in"),
                                            " ",
                                            (ref2 = subdivisions.filter(function(o) {
                                                return o.value === selectedSubdivision;
                                            })[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
                                            " ",
                                            t("commons.region_picker.work_with")
                                        ]
                                    }),
                                    Comercials
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Button, {
                                type: "submit",
                                onClick: function() {
                                    var ref;
                                    return onClickCatalogue((ref = subdivisions.filter(function(o) {
                                        return o.value === selectedSubdivision;
                                    })[0]) === null || ref === void 0 ? void 0 : ref.value, storeData);
                                },
                                bgType: isModal ? "red" : "creme",
                                className: "creme",
                                children: [
                                    " ",
                                    t("commons.region_picker.go_catalogue"),
                                    " "
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Button, {
                        type: "submit",
                        onClick: function() {
                            onClickStore(storeData);
                        },
                        bgType: isModal ? "red" : "creme",
                        className: buttonDisabled && !isModal ? "disabled" : "",
                        children: [
                            t("commons.actions.enter"),
                            "!"
                        ]
                    })
                ]
            })
        })
    });
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FormStore__Wrapper",
    componentId: "sc-d8f6044-0"
})(FormStore_templateObject(), function(param) {
    var theme = param.theme, $colorWrapper = param.$colorWrapper;
    return $colorWrapper ? theme.colors[$colorWrapper] : theme.colors.white;
}, (0,styles.vw)(480, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(480, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(480, "desktop"), function(param) {
    var $selectedCountry = param.$selectedCountry;
    return $selectedCountry === "ES" ? 1 : 0;
}, function(param) {
    var $selectedCountry = param.$selectedCountry;
    return $selectedCountry === "ES" ? "auto" : "none";
}, function(param) {
    var $selectedCountry = param.$selectedCountry;
    return $selectedCountry === "ES" ? "auto" : "none";
}, function(param) {
    var $isModal = param.$isModal;
    return $isModal ? "100%" : "auto";
}, function(param) {
    var $isModal = param.$isModal;
    return $isModal ? (0,styles.vw)(50, "desktop") : "unset";
});
var Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FormStore__Div",
    componentId: "sc-d8f6044-1"
})(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 1 : 0;
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(4.25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(4.25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(12.5, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), (0,styles.getP18_1)(), function(param) {
    var theme = param.theme, $textColorSubdividions = param.$textColorSubdividions;
    return theme.colors[$textColorSubdividions !== null && $textColorSubdividions !== void 0 ? $textColorSubdividions : "white"];
}, (0,styles.vw)(10, "mobile"), function(param) {
    var $isModal = param.$isModal;
    return $isModal ? "left" : "center";
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));
var ListItem = styled_components_browser_esm["default"].dd.withConfig({
    displayName: "FormStore__ListItem",
    componentId: "sc-d8f6044-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, $textColorSubdividions = param.$textColorSubdividions;
    return theme.colors[$textColorSubdividions !== null && $textColorSubdividions !== void 0 ? $textColorSubdividions : "white"];
}, function(param) {
    var $isModal = param.$isModal;
    return $isModal ? "left" : "center";
}, (0,styles.getP15)(), function(param) {
    var $isModal = param.$isModal;
    return $isModal ? "left" : "center";
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.getP18_4)(), (0,styles.createUnderline)({
    height: 1,
    color: "darkred",
    reverse: true
}), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackAccountActivated.tsx
"use client";





var FeedbackAccountActivated = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClick = function() {
        updateLevel(defaultAuthModalLevel, {}, true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                legend: t("modals.auth.feedback_account_active.text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                bgType: "red",
                outline: true,
                onClick: onClick,
                children: t("commons.actions.close")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackCIFAlreadyActive.tsx
"use client";




var FeedbackCIFAlreadyActive = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, payload = param.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
                legend: "".concat(t("modals.auth.feedback_cif_already_active.text"), " ").concat(payload.emailObfuscated, "."),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "light",
                        children: [
                            t("modals.auth.feedback_cif_already_active.text2"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    updateLevel("login");
                                },
                                children: t("modals.auth.feedback_cif_already_active.text2_actions.login")
                            }),
                            t("modals.auth.feedback_cif_already_active.text2_2"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    updateLevel("forgot_password");
                                },
                                children: t("modals.auth.feedback_cif_already_active.text2_actions.restore_password")
                            }),
                            "."
                        ]
                    }, "p-light-active"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "light",
                        children: t("modals.auth.feedback_email_invite.text2")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                bgType: "red",
                outline: true,
                onClick: function() {
                    updateLevel("login", {}, true);
                },
                children: t("commons.actions.close")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackCIFNotFound.tsx
"use client";




var FeedbackCIFNotFound = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, payload = param.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Form, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Fieldset, {
            legend: "".concat(t("modals.auth.feedback_cif_not_found.text"), " ").concat(payload.vatNumber, " ").concat(t("modals.auth.feedback_cif_not_found.text_2")),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "light",
                    children: [
                        t("modals.auth.feedback_cif_not_found.text2"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:".concat(t("modals.auth.feedback_cif_not_found.text2_actions.email")),
                            children: t("modals.auth.feedback_cif_not_found.text2_actions.email")
                        }),
                        " / ",
                        t("modals.auth.feedback_cif_not_found.text2_actions.phone"),
                        "."
                    ]
                }, "p-light"),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "light",
                    children: [
                        t("modals.auth.feedback_cif_not_found.text3"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                updateLevel("signup", {
                                    vatNumber: payload.vatNumber
                                });
                            },
                            children: t("modals.auth.feedback_cif_not_found.text3_action")
                        }),
                        "."
                    ]
                }, "p-light-2")
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackEmailInvite.tsx
"use client";





var FeedbackEmailInvite = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel, payload = param.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClick = function() {
        updateLevel(defaultAuthModalLevel, {}, true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                legend: "".concat(t("modals.auth.feedback_email_invite.text"), " ").concat(payload.emailObfuscated).concat(t("modals.auth.feedback_email_invite.text_2")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "light",
                    children: [
                        t("modals.auth.feedback_email_invite.text2"),
                        "."
                    ]
                }, "p-light")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                bgType: "red",
                outline: true,
                onClick: onClick,
                children: t("commons.actions.close")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackEmailResetPassword.tsx
"use client";





var FeedbackEmailResetPassword = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClick = function() {
        updateLevel(defaultAuthModalLevel, {}, true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                legend: t("modals.auth.feedback_email_reset_password.text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                bgType: "red",
                outline: true,
                onClick: onClick,
                children: t("commons.actions.close")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/FeedbackPasswordUpdated.tsx
"use client";




var FeedbackPasswordUpdated = /*#__PURE__*/ (0,react.memo)(function(param) {
    var updateLevel = param.updateLevel;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClick = function() {
        updateLevel("login", {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Fieldset, {
                legend: t("modals.auth.feedback_password_updated.text")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                type: "button",
                bgType: "red",
                outline: true,
                onClick: onClick,
                children: t("commons.actions.login")
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/forms/feedbacks/index.ts







;// CONCATENATED MODULE: ./components/forms/index.ts
// Customer forms


// Authentication onBoarding flow forms









// Other forms


// Feedbacks after previously submitted forms (not real forms)


// EXTERNAL MODULE: ./components/layout/index.ts + 2 modules
var layout = __webpack_require__(11242);
// EXTERNAL MODULE: ./components/home/index.ts + 5 modules
var home = __webpack_require__(42318);
// EXTERNAL MODULE: ./components/cart/index.ts + 37 modules
var cart = __webpack_require__(61969);
// EXTERNAL MODULE: ../commons/dist/hooks/useCart.js
var useCart = __webpack_require__(61528);
// EXTERNAL MODULE: ../commons/dist/hooks/useModal.js
var useModal = __webpack_require__(21186);
// EXTERNAL MODULE: ../commons/dist/context/ModalsContext.js
var ModalsContext = __webpack_require__(90221);
;// CONCATENATED MODULE: ./components/account/NavAccount.tsx




function NavAccount_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display:none;\n\n  ",
        " {\n    display: inline;\n    grid-column: 1 / span 3;\n    min-height:  ",
        ";\n    padding: 0 ",
        " 0 ",
        ";\n  }\n"
    ]);
    NavAccount_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavAccount_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 20px;\n  }\n\n  button,\n  a {\n    ",
        "\n    color: ",
        ";\n    transition: 300ms color ease-out;\n    pointer-events: ",
        ";\n  }\n"
    ]);
    NavAccount_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











//
var getAccountListItems = function(data, query, pathname, toggle, closeSession) {
    return data.map(function(item, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
            $active: pathname === item.pathname && query.slug === item.slug,
            onClick: toggle,
            children: item.pathname ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                href: (0,_object_spread/* default */.Z)({
                    pathname: item.pathname
                }, item.slug && {
                    query: {
                        slug: item.slug
                    }
                }),
                children: item.name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: closeSession,
                children: item.name
            })
        }, "acc-nav-item-".concat(idx));
    });
};
var NavAccount = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,router.useRouter)(), query = ref.query, pathname = ref.pathname, push = ref.push;
    var setCustomer = (0,hooks/* useCustomer */.ON)().setCustomer;
    var bulkUpdateCart = (0,useCart.useCart)().bulkUpdateCart;
    var toggle = (0,useModal.useModal)(ModalsContext.MODALS.MENU_ACCOUNT).toggle;
    var closeSession = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetch("/api/auth/logout", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.ok) {
                        console.log("Logout successful");
                    } else {
                        console.log("Logout failed");
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.error("❌ Logout failed:", e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    utils.cookie.removeCookie("BC_CUSTOMER_ID");
                    utils.cookie.removeCookie("DY_CUSTOMER_TOKEN");
                    setCustomer(null);
                    bulkUpdateCart([], null, 0, 0, null, null, false, 0, "fresh", null, []);
                    push("/?logout=true");
                    return [
                        2
                    ];
            }
        });
    }), [
        setCustomer,
        bulkUpdateCart,
        push
    ]);
    var ListItems = (0,react.useMemo)(function() {
        return Array.isArray(data) ? getAccountListItems(data, query, pathname, toggle, closeSession) : [];
    }, [
        data,
        query,
        pathname,
        toggle,
        closeSession
    ]);
    if (!data) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: ListItems
        })
    });
});
var Nav = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "NavAccount__Nav",
    componentId: "sc-77022958-0"
})(NavAccount_templateObject(), styles.mq.greaterThan("tablet"), (0,styles.vw)(450, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(30, "desktop"));
var Li = styled_components_browser_esm["default"].li.withConfig({
    displayName: "NavAccount__Li",
    componentId: "sc-77022958-1"
})(NavAccount_templateObject1(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18InputLabel)(), function(param) {
    var theme = param.theme, $active = param.$active;
    return $active ? theme.colors.darkred : (0,styles.hex2Rgba)(theme.colors.darkred, .4);
}, function(param) {
    var $active = param.$active;
    return $active ? "none" : "auto";
});

// EXTERNAL MODULE: ./components/account/sharedAccountStyles.ts
var sharedAccountStyles = __webpack_require__(95482);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
// EXTERNAL MODULE: ./components/shop/shopVariants.ts
var shopVariants = __webpack_require__(42769);
;// CONCATENATED MODULE: ./components/account/SectionOrders.tsx




function SectionOrders_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  font-weight: 400;\n  opacity: .4;\n  padding: ",
        " ",
        ";\n  text-align: center;\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 4 / span 9;\n    margin: 0 auto;\n    padding: ",
        " 0;\n    max-width: 600px;\n  }\n\n  ",
        " {\n    padding: 40px 0;\n  }\n"
    ]);
    SectionOrders_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var mediaNarrowIcon = {
    type: "image",
    alt: "Icon pasta 1",
    default: {
        src: "/images/svg/i--account-narrow.svg",
        size: {
            width: 8,
            height: 13
        }
    }
};
var variantAvailable = function(importStatus) {
    return importStatus !== "archived" && importStatus !== "to_delete";
};
var getProducts = function(orderLines, locale, repeatOrderLine, t) {
    return orderLines.map(function(item, idx) {
        var ref, ref1;
        var priceExTax = item.priceExTax, quantity = item.quantity, productName = item.productName, brandName = item.brandName, variant = item.variant;
        var isVariantAvailable = typeof variant === "object" ? variantAvailable(variant === null || variant === void 0 ? void 0 : variant.importStatus) : false;
        var priceCurrency = (0,utils.currencyFormatter)({
            price: priceExTax,
            localeRegion: locale,
            decimals: 2,
            trailingZeros: false,
            round: false
        });
        // const pricePerWeightCurrency = currencyFormatter({price: pricePerWeight, localeRegion: locale})
        var thumbnail = variant === null || variant === void 0 ? void 0 : (ref = variant.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.medium;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* ProductListItem */.A5, {
            children: [
                thumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: thumbnail
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: "placeholder"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                quantity,
                                " x ",
                                productName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                brandName,
                                (variant === null || variant === void 0 ? void 0 : variant.name) ? " | ".concat(variant === null || variant === void 0 ? void 0 : variant.name) : "",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: priceCurrency
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: !isVariantAvailable,
                    onClick: function() {
                        repeatOrderLine(item);
                    },
                    children: isVariantAvailable ? t("account.buy_again") : t("account.order.no_stock")
                })
            ]
        }, "".concat(idx, "-").concat(variant === null || variant === void 0 ? void 0 : variant.id));
    });
};
var getOrders = function(items, t, locale, repeatOrderLine) {
    return items.map(function(item, idx) {
        var bigcommerceId = item.bigcommerceId, dateCreated = item.dateCreated, total = item.totalExTax, deliveryDate = item.deliveryDate, orderLines = item.orderLines;
        var ProductList = getProducts(orderLines, locale, repeatOrderLine, t);
        var priceCurrency = (0,utils.currencyFormatter)({
            price: total,
            localeRegion: locale,
            decimals: 2,
            trailingZeros: false,
            round: false
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* CardListItem */.xI, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "headline_mobile",
                            children: deliveryDate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "icon__mobile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "overview mobile",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("account.order.purchase"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "online"
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("account.order.date"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,utils.parseDateString)({
                                                        dateString: dateCreated
                                                    })
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("account.order.total"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: priceCurrency
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                t("account.order.number"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: bigcommerceId
                                                }),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                    href: "/account/order?id=".concat(bigcommerceId),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                        media: mediaNarrowIcon
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "products_mobile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "headline",
                                    children: deliveryDate
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: ProductList
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* RepeatOrder */.W4, {
                                    orderLines: orderLines
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "overview desktop",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("account.order.purchase"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "online"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("account.order.date"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,utils.parseDateString)({
                                        dateString: dateCreated
                                    })
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("account.order.total"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: priceCurrency
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("account.order.number"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: bigcommerceId
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "main-info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "products_desktop",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "headline",
                                    children: deliveryDate
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: ProductList
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cta",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* RepeatOrder */.W4, {
                                    orderLines: orderLines
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                    href: "/account/order?id=".concat(bigcommerceId),
                                    children: t("account.details")
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "".concat(idx, "-").concat(bigcommerceId));
    });
};
var SectionOrders = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,router.useRouter)(), localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_ADD_TO_CART */.XN), 2), cartLinesAdd = ref1[0], ref2 = ref1[1], dataAfterAdd = ref2.data;
    var bulkUpdateCart = (0,dist_hooks.useCart)().bulkUpdateCart;
    var setCartItems = ((0,react.useContext)(cart/* NewCartItemsContext */.K3) || {}).setCartItems;
    var repeatOrderLine = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(orderLine) {
            var DYCustomerToken, mutationData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        mutationData = {
                            variables: {
                                variantId: orderLine.variant.id,
                                quantity: orderLine.quantity,
                                cartLineType: utils.CART_LINE_TYPE.PHYSICAL
                            },
                            context: {
                                isPrivatePath: true,
                                DYCustomerToken: DYCustomerToken
                            }
                        };
                        return [
                            4,
                            cartLinesAdd(mutationData).then(function(res) {
                                var _cart = res.data.cartLinesAdd.cart, cartLines = _cart.cartLines, cartId = _cart.bigcommerceId, subtotalExTax = _cart.subtotalExTax, totalExTax = _cart.totalExTax, deliveryDate = _cart.deliveryDate, deliveryDateOptions = _cart.deliveryDateOptions, multipleDeliveryDates = _cart.multipleDeliveryDates, discountAmount = _cart.discountAmount, deliveryType = _cart.deliveryType, deliverySchedules = _cart.deliverySchedules, notifications = _cart.notifications;
                                bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
                                setCartItems(cartLines);
                            }).catch(function(error) {
                                console.warn("Error with mutation: cartLinesAdd:", error);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(orderLine) {
            return _ref.apply(this, arguments);
        };
    }(), [
        bulkUpdateCart,
        cartLinesAdd,
        setCartItems
    ]);
    var OrderItems = (0,react.useMemo)(function() {
        return getOrders(data, t, locale, repeatOrderLine);
    }, [
        data,
        t,
        locale,
        repeatOrderLine
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!dataAfterAdd) return;
        var cartRes = dataAfterAdd === null || dataAfterAdd === void 0 ? void 0 : (ref = dataAfterAdd.cartLinesAdd) === null || ref === void 0 ? void 0 : ref.cart;
        // if(Array.isArray(cartRes?.cartLines)) {
        //   const newItemCart = cartRes.cartLines.find(item => item?.variant?.id ===  variant?.id)
        //   if(typeof newItemCart === 'object') {
        //     setCartItems && setCartItems(prevValue => {
        //       const prevArray =  [...prevValue]
        //       const matchedCartItem = prevArray.indexOf(item => item.variant?.id === newItemCart.variant?.id)
        //       if(matchedCartItem === -1) return [...prevValue, newItemCart]
        //       else {
        //         prevArray[matchedCartItem] = newItemCart
        //         return prevArray
        //       }
        //     })
        //   }
        // }
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterAdd", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterAdd
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedAccountStyles/* SectionAccount */.vk, {
        children: OrderItems.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMessageP, {
            initial: "inactive",
            animate: "active",
            exit: "inactive",
            variants: shopVariants/* listVariants */.h,
            children: t("account.no_orders")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: OrderItems
        })
    });
});
var NoMessageP = (0,styled_components_browser_esm["default"])(motion/* motion.p */.E.p).withConfig({
    displayName: "SectionOrders__NoMessageP",
    componentId: "sc-83529730-0"
})(SectionOrders_templateObject(), (0,styles.getP30)(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/account/SectionInvoices.tsx












var SectionInvoices_getOrders = function(orders, locale) {
    return orders === null || orders === void 0 ? void 0 : orders.map(function(order, idx) {
        var dateCreated = order.dateCreated, totalExTax = order.totalExTax, code = order.bigcommerceId;
        var priceCurreny = (0,utils.currencyFormatter)({
            price: totalExTax,
            localeRegion: locale,
            decimals: 2,
            trailingZeros: false,
            round: false
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedAccountStyles/* CardListItem */.xI, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                className: "overview order",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: code
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: (0,utils.parseDateString)({
                                    dateString: dateCreated
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: priceCurreny
                            })
                        ]
                    })
                })
            })
        }, idx);
    });
};
var token = "eyJhbGciOiJIUzI1NiJ9.eyJ3ZWJzaXRlX2lkIjo5LCJzdG9yZV9pZCI6NCwiY2hhbm5lbF9pZCI6OCwiZXhwIjozMTcyODQ1MTY4MTN9.TnwrT3POxF1UFp6ETped3DSQlXNLngm2b2oKQc6CoT8";
var onClickDownloadPdf = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(invoiceNumber) {
        var DYCustomerToken, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                    if (!DYCustomerToken) throw new Error("no DYCustomerToken available to request pdf invoice");
                    return [
                        4,
                        (0,api/* fetchAPI */.Io)("download-customer-invoice-pdf", {
                            slug: invoiceNumber
                        }, {
                            method: "GET",
                            headers: {
                                "DY-Access-Token": "".concat(token),
                                "DY-Customer-Token": DYCustomerToken
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    (0,utils.downloadPDF)(response, "mammafiore_invoice_".concat(invoiceNumber));
                    return [
                        2
                    ];
            }
        });
    });
    return function onClickDownloadPdf(invoiceNumber) {
        return _ref.apply(this, arguments);
    };
}();
var getInvoices = function(items, t, locale) {
    return items.map(function(item, idx) {
        var id = item.id, invoiceDate = item.invoiceDate, totalExTax = item.totalExTax, invoiceLines = item.invoiceLines, number = item.number;
        var OrderList = SectionInvoices_getOrders(invoiceLines, locale);
        var priceCurreny = (0,utils.currencyFormatter)({
            price: totalExTax,
            localeRegion: locale,
            decimals: 2,
            trailingZeros: false,
            round: false
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* CardListItem */.xI, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    className: "overview",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    className: "headline mobile",
                                    children: [
                                        t("account.invoice"),
                                        " n\xba",
                                        id
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("account.invoice_issued")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: t("account.order.total")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: (0,utils.parseDateString)({
                                            dateString: invoiceDate,
                                            locale: locale
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: priceCurreny
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "main-info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "products",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "headline desktop",
                                    children: [
                                        t("account.invoice"),
                                        " n\xba",
                                        number
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: OrderList
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cta invoice",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                                bgType: "red",
                                outline: true,
                                onClick: function() {
                                    return onClickDownloadPdf(number);
                                },
                                children: t("account.invoice_download")
                            })
                        })
                    ]
                })
            ]
        }, idx);
    });
};
var SectionInvoices = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,router.useRouter)(), localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var InvoiceList = (0,react.useMemo)(function() {
        return getInvoices(data, t, locale);
    }, [
        data,
        t,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedAccountStyles/* SectionAccount */.vk, {
        children: data.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: InvoiceList
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMessageP, {
            initial: "inactive",
            animate: "active",
            exit: "inactive",
            variants: shopVariants/* listVariants */.h,
            children: t("account.no_invoice")
        })
    });
});

;// CONCATENATED MODULE: ./components/account/OrderDetails.tsx




function OrderDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  ",
        " {\n    display: flex;\n    place-content: space-between;\n  }\n\n  .big {\n    height: unset;\n    width: unset;\n\n    ",
        " {\n      height: 100%;\n      width: 63%;\n    }\n\n    h1, span {\n      color: ",
        ";\n    }\n\n    h1 {\n      margin-top: ",
        ";\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: ",
        ";\n      }\n\n      ",
        " {\n        margin-top:  53px;\n      }\n    }\n\n    span {\n      ",
        "\n      color: ",
        ";\n\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n\n    figure {\n      display: inline-block;\n      height: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 30px;\n        width: 30px;\n      }\n\n      + span {\n        display: inline;\n        padding-left: ",
        ";\n\n        ",
        " {\n          padding-left: ",
        ";\n        }\n\n        ",
        " {\n          padding-left: ",
        ";\n        }\n\n        ",
        " {\n          padding-left: 10px;\n        }\n      }\n    }\n\n    .detail {\n      div > span { display: block;}\n    }\n  }\n\n  .small {\n    height: unset;\n    width: unset;\n\n    ",
        " {\n      height: 90%;\n      width: 33%;\n    }\n\n    h1, td, span {\n      color: ",
        ";\n    }\n    td, span {\n      ",
        "\n    }\n\n    table {\n      width:100%;\n      padding: ",
        ";\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        " ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 12px 20px 15px;\n      }\n\n      tr {\n        display: flex;\n        justify-content: space-between;\n        margin: 0;\n        padding: ",
        " 0;\n\n        ",
        " {\n          padding: ",
        " 0;\n        }\n\n        ",
        " {\n          padding: ",
        " 0;\n        }\n\n        ",
        " {\n          padding: 10px 0;\n        }\n      }\n    }\n\n    .summary-total {\n      display: flex;\n      justify-content: space-between;\n      border-top: 1px solid ",
        ";\n      padding: ",
        ";\n\n      ",
        " {\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        " ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 12px 20px 15px;\n      }\n    }\n  }\n"
    ]);
    OrderDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














// const mediaPastaLeft = {
//   type: 'image' as const,
//   alt: 'Icon pasta 1',
//   default: {
//     src: '/images/pasta.jpeg',
//     size: { width: 30, height: 20 }
//   }
// }
var userDetails = function(item) {
    var city = item.city, country = item.country, first_name = item.first_name, last_name = item.last_name, phone = item.phone, zip = item.zip, state = item.state, street_1 = item.street_1, street_2 = item.street_2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    first_name,
                    " ",
                    last_name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    street_1,
                    " ",
                    street_2,
                    ", ",
                    city
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    state,
                    " ",
                    country
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: zip
            }),
            phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: phone
            })
        ]
    });
};
var getUserDetailOrder = function(item, t) {
    var Shipping = userDetails(item.shippingAddress);
    var Billing = userDetails(item.billingAddress);
    var DYcustomerPayment = utils.cookie.get("DY_CUSTOMER_PAYMENT_METHOD").toLocaleUpperCase();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedAccountStyles/* CardListItem */.xI, {
        className: "big",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "detail",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: t("account.order.order_details.shipment")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: Shipping
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    children: [
                        " ",
                        t("account.order.order_details.billing"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: Billing
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    children: [
                        " ",
                        t("account.order.order_details.payment"),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: DYcustomerPayment
                })
            ]
        })
    });
};
//comented until we know for sure how its the schema for orderStatus
// const getOrderStatus = (item) =>{
//   const { date, sended, delivering } = item
//   return(
//     <OrderLine>
//       <div className='progress_bar'>
//         <div className='completed'>
//           <span className='completed'></span>
//         </div>
//         <div className={sended ? 'completed': 'inactive' }>
//           <span className={sended ? 'completed': 'inactive'}></span>
//         </div>
//         <div className={delivering ? 'completed': 'inactive' }>
//           <span className={delivering ? 'completed': 'inactive'}></span>
//         </div>
//         <div className={item.delivering_date ? 'completed': 'inactive' }>
//           <span className={item.delivering_date ? 'completed': 'inactive' }></span>
//         </div>
//       </div>
//       <div className={'order_status'}>
//         <span>Ordered <span>{date}</span></span>
//         <span>Shipped <span>{sended}</span></span>
//         <span>En reparto <span>{''}</span></span>
//         <span>Llegada <span>{item.delivering_date? item.delivering_date : ''}</span></span>
//       </div>
//     </OrderLine>
//   )
// }
var OrderDetails_variantAvailable = function(importStatus) {
    return importStatus !== "to_delete";
};
var getOrderLines = function(products, locale, noStockText, buyAgainText, repeatOrderLine) {
    return products.map(function(item, idx) {
        var ref, ref1;
        var priceExTax = item.priceExTax, quantity = item.quantity, productName = item.productName, brandName = item.brandName, variantSku = item.variantSku, variant = item.variant;
        var isVariantAvailable = typeof variant === "object" ? OrderDetails_variantAvailable(variant === null || variant === void 0 ? void 0 : variant.importStatus) : false;
        var priceCurrency = (0,utils.currencyFormatter)({
            price: priceExTax,
            localeRegion: locale,
            decimals: 2,
            trailingZeros: false,
            round: false
        });
        // const pricePerWeightCurrency = currencyFormatter({price: pricePerWeight, localeRegion: locale})
        var thumbnail = variant === null || variant === void 0 ? void 0 : (ref = variant.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.medium;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* ProductListItem */.A5, {
            children: [
                thumbnail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: thumbnail
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: "placeholder"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                quantity,
                                " x ",
                                productName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                brandName,
                                (variant === null || variant === void 0 ? void 0 : variant.name) ? " | ".concat(variant === null || variant === void 0 ? void 0 : variant.name) : "",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: priceCurrency
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: !isVariantAvailable,
                    onClick: function() {
                        repeatOrderLine(item);
                    },
                    children: isVariantAvailable ? buyAgainText : noStockText
                })
            ]
        }, "".concat(idx, "-").concat(variantSku));
    });
};
var getOrderSummary = function(item, locale, t) {
    var subtotalExTax = item.subtotalExTax, discountAmount = item.discountAmount, couponDiscount = item.couponDiscount, shippingCostExTax = item.shippingCostExTax, totalIncTax = item.totalIncTax, orderLinesLength = item.orderLinesLength;
    // deliveryDate// totalTax,
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* CardListItem */.xI, {
        className: "small",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order_title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    children: [
                        t("account.order.order_details.payment_summary"),
                        " (",
                        orderLinesLength,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: t("account.order.order_details.total_products")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: (0,utils.currencyFormatter)({
                                        price: subtotalExTax,
                                        localeRegion: locale,
                                        round: false,
                                        trailingZeros: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        t("account.order.order_details.voucher"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        "-",
                                        (0,utils.currencyFormatter)({
                                            price: couponDiscount,
                                            localeRegion: locale,
                                            round: false,
                                            trailingZeros: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        " ",
                                        t("account.order.order_details.discount")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    children: [
                                        "-",
                                        (0,utils.currencyFormatter)({
                                            price: discountAmount,
                                            localeRegion: locale,
                                            round: false,
                                            trailingZeros: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: t("account.order.order_details.shipment")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: (0,utils.currencyFormatter)({
                                        price: shippingCostExTax,
                                        localeRegion: locale,
                                        round: false,
                                        trailingZeros: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-total",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("account.order.order_details.total_inc_tax")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,utils.currencyFormatter)({
                            price: totalIncTax,
                            localeRegion: locale,
                            round: false,
                            trailingZeros: true
                        })
                    })
                ]
            })
        ]
    });
};
var checkOnDemandItems = function(orderLines, deliveryDate) {
    var arrayOfDeliveryDates = [
        {
            "delivery": deliveryDate,
            "products": []
        }
    ];
    orderLines.forEach(function(line) {
        var _variant = line.variant, deliveryType = _variant.deliveryType, orderLineDeliveryDate = _variant.deliveryDate;
        if (deliveryType === "on_demand") {
            arrayOfDeliveryDates.push({
                delivery: orderLineDeliveryDate,
                products: [
                    line
                ]
            });
        } else {
            arrayOfDeliveryDates[0].products.push(line);
        }
    });
    return arrayOfDeliveryDates;
};
var getOrderLinesByDeliveryDate = function(arrayOfDeliveryDates, locale, deliveryText, noStockText, buyAgainText, repeatOrderLine) {
    return arrayOfDeliveryDates.map(function(el, idx) {
        var delivery = el.delivery, products = el.products;
        var OrderLinesItems = (0,react.useMemo)(function() {
            return getOrderLines(products, locale, noStockText, buyAgainText, repeatOrderLine);
        }, [
            products
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedAccountStyles/* CardListItem */.xI, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "products",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "headline",
                                children: [
                                    " ",
                                    deliveryText,
                                    ": ",
                                    (0,utils.parseDateString)({
                                        dateString: delivery
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: OrderLinesItems
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* RepeatOrder */.W4, {
                        orderLines: products
                    })
                ]
            })
        }, idx);
    });
};
var OrderDetails = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,router.useRouter)(), localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(api/* CUSTOMER_ADD_TO_CART */.XN), 2), cartLinesAdd = ref1[0], ref2 = ref1[1], dataAfterAdd = ref2.data;
    var bulkUpdateCart = (0,dist_hooks.useCart)().bulkUpdateCart;
    var setCartItems = ((0,react.useContext)(cart/* NewCartItemsContext */.K3) || {}).setCartItems;
    var bigcommerceId = data.bigcommerceId, orderLines = data.orderLines, billingAddress = data.billingAddress, shippingAddress = data.shippingAddress, paymentMethod = data.paymentMethod, deliveryDate = data.deliveryDate, subtotalExTax = data.subtotalExTax, discountAmount = data.discountAmount, couponDiscount = data.couponDiscount, shippingCostExTax = data.shippingCostExTax, totalIncTax = data.totalIncTax, totalTax // Summary
     = data.totalTax;
    // const OrderStatus = useMemo(() => getOrderStatus(data, t), [data, t])
    var UserDetailOrder = (0,react.useMemo)(function() {
        return getUserDetailOrder({
            billingAddress: billingAddress,
            shippingAddress: shippingAddress,
            paymentMethod: paymentMethod
        }, t);
    }, [
        billingAddress,
        shippingAddress,
        paymentMethod,
        t
    ]);
    var OrderSummary = (0,react.useMemo)(function() {
        return getOrderSummary({
            deliveryDate: deliveryDate,
            subtotalExTax: subtotalExTax,
            discountAmount: discountAmount,
            couponDiscount: couponDiscount,
            shippingCostExTax: shippingCostExTax,
            totalIncTax: totalIncTax,
            totalTax: totalTax,
            orderLinesLength: orderLines.length,
            orderLines: orderLines
        }, locale, t);
    }, [
        deliveryDate,
        subtotalExTax,
        discountAmount,
        couponDiscount,
        shippingCostExTax,
        totalIncTax,
        totalTax,
        locale,
        orderLines,
        t
    ]);
    var orderLinesByDeliveryDate = checkOnDemandItems(orderLines, deliveryDate);
    var repeatOrderLine = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(orderLine) {
            var DYCustomerToken, mutationData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        mutationData = {
                            variables: {
                                variantId: orderLine.variant.id,
                                quantity: orderLine.quantity,
                                cartLineType: utils.CART_LINE_TYPE.PHYSICAL
                            },
                            context: {
                                isPrivatePath: true,
                                DYCustomerToken: DYCustomerToken
                            }
                        };
                        return [
                            4,
                            cartLinesAdd(mutationData).then(function(res) {
                                var _cart = res.data.cartLinesAdd.cart, cartLines = _cart.cartLines, cartId = _cart.bigcommerceId, subtotalExTax = _cart.subtotalExTax, totalExTax = _cart.totalExTax, deliveryDate = _cart.deliveryDate, deliveryDateOptions = _cart.deliveryDateOptions, multipleDeliveryDates = _cart.multipleDeliveryDates, discountAmount = _cart.discountAmount, deliveryType = _cart.deliveryType, deliverySchedules = _cart.deliverySchedules, notifications = _cart.notifications;
                                bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
                                setCartItems(cartLines);
                            }).catch(function(error) {
                                console.warn("Error with mutation: cartLinesAdd:", error);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(orderLine) {
            return _ref.apply(this, arguments);
        };
    }(), [
        bulkUpdateCart,
        cartLinesAdd,
        setCartItems
    ]);
    var OrderLines = getOrderLinesByDeliveryDate(orderLinesByDeliveryDate, locale, t("product_page.product.on_demand"), t("account.order.no_stock"), t("account.buy_again"), repeatOrderLine);
    (0,react.useEffect)(function() {
        var ref;
        if (!dataAfterAdd) return;
        var cartRes = dataAfterAdd === null || dataAfterAdd === void 0 ? void 0 : (ref = dataAfterAdd.cartLinesAdd) === null || ref === void 0 ? void 0 : ref.cart;
        console.log("\uD83D\uDCC0\uD83D\uDCC0 CMS cartRes dataAfterAdd", cartRes);
        if (!!cartRes && typeof cartRes === "object") {
            var cartLines = cartRes.cartLines, cartId = cartRes.bigcommerceId, subtotalExTax = cartRes.subtotalExTax, totalExTax = cartRes.totalExTax, deliveryDate = cartRes.deliveryDate, deliveryDateOptions = cartRes.deliveryDateOptions, multipleDeliveryDates = cartRes.multipleDeliveryDates, discountAmount = cartRes.discountAmount, deliveryType = cartRes.deliveryType, deliverySchedules = cartRes.deliverySchedules, notifications = cartRes.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataAfterAdd
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sharedAccountStyles/* SectionAccount */.vk, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    t("account.order.number"),
                    " ",
                    bigcommerceId
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderDetails_Wrapper, {
                className: "detail",
                children: [
                    UserDetailOrder,
                    OrderSummary
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: OrderLines
            })
        ]
    });
});
var OrderDetails_Wrapper = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "OrderDetails__Wrapper",
    componentId: "sc-b17173af-0"
})(OrderDetails_templateObject(), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(53, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1B)(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .7);
}, styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP15_1B)(), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .1);
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"))// const OrderLine = styled.div`
//   display:grid;
//   grid-template-columns: ${vw(100, 'mobile')} auto;
//   height:${vw(300, 'mobile')};
//   margin: 0 0 ${vw(30, 'mobile')};
//   ${mq.greaterThan('nexus7')} {
//     grid-template-columns: ${vw(100, 'nexus7')} auto;
//     height:${vw(300, 'nexus7')};
//     margin: 0 0 ${vw(30, 'nexus7')};
//   }
//   ${mq.greaterThan('tablet')} {
//     display:block;
//     grid-template-columns: unset;
//     grid-template-rows: unset;
//     height:unset;
//   }
//   .progress_bar , .order_status {
//     display:grid;
//     ${mq.greaterThan('tablet')} {
//       grid-template-columns: repeat(4, 1fr);
//     }
//   }
//   .progress_bar {
//     grid-template-rows: repeat(4,25%);
//     justify-items: center;
//     ${mq.greaterThan('tablet')} {
//       grid-template-rows: unset;
//       justify-items: unset;
//     }
//     > div {
//       align-items: center;
//       background-color: ${({ theme }) => hex2Rgba(theme.colors.red, .2)};
//       display:grid;
//       height:100%;
//       justify-content: center;
//       text-align: center;
//       width: 10px;
//       z-index: -20;
//       ${mq.greaterThan('tablet')} {
//         display:block;
//         height: ${vw(5, 'desktop')};
//         width: 100%;
//       }
//       ${mq.greaterThan('desktop')} {
//         height: 5px;
//       }
//       &.completed {
//         background-color: ${({ theme }) => theme.colors.red};
//       }
//       &:first-child {
//         border-top-left-radius:  ${vw(10, 'mobile')};
//         border-top-right-radius:  ${vw(10, 'mobile')};
//         border-bottom-left-radius: 0;
//         ${mq.greaterThan('nexus7')} {
//           border-top-left-radius:  ${vw(10, 'nexus7')};
//           border-top-right-radius:  ${vw(10, 'nexus7')};
//         }
//         ${mq.greaterThan('tablet')} {
//           border-top-left-radius:  ${vw(10, 'desktop')};
//           border-top-right-radius: 0;
//           border-bottom-left-radius:  ${vw(10, 'desktop')};
//         }
//         ${mq.greaterThan('desktop')} {
//           border-top-left-radius:  10px;
//           border-bottom-left-radius:  10px;
//         }
//       }
//       &:last-child {
//         border-bottom-left-radius:  ${vw(10, 'mobile')};
//         border-bottom-right-radius:  ${vw(10, 'mobile')};
//         border-top-right-radius: 0;
//         ${mq.greaterThan('nexus7')} {
//           border-bottom-left-radius:  ${vw(10, 'nexus7')};
//           border-bottom-right-radius:  ${vw(10, 'nexus7')};
//         }
//         ${mq.greaterThan('tablet')} {
//           border-bottom-left-radius: 0;
//           border-top-right-radius:  ${vw(10, 'desktop')};
//           border-bottom-right-radius:  ${vw(10, 'desktop')};
//         }
//         ${mq.greaterThan('desktop')} {
//           border-top-right-radius:  10px;
//           border-bottom-right-radius:  10px;
//         }
//       }
//       span.completed:after {
//         ${getP26_1()}
//         color: white;
//         content:'✓';
//         left:${vw(3, 'mobile')};
//         position: relative;
//         top:${vw(-18, 'mobile')};
//         z-index: 1;
//         ${mq.greaterThan('nexus7')} {
//           left:${vw(3, 'nexus7')};
//           top:${vw(-18, 'nexus7')};
//         }
//         ${mq.greaterThan('tablet')} {
//           ${getP10()}
//           left:0;
//           top:${vw(-16, 'desktop')};
//         }
//         ${mq.greaterThan('desktop')} {
//           top:16px;
//         }
//       }
//       span.completed:before {
//         background: ${({ theme }) => theme.colors.red};
//         border-radius: 50%;
//         content:'';
//         display: block;
//         height: ${vw(20, 'mobile')};
//         margin: ${vw(20, 'mobile')} 0 0;
//         width: ${vw(20, 'mobile')};
//         ${mq.greaterThan('nexus7')} {
//            height: ${vw(20, 'nexus7')};
//            margin: ${vw(20, 'nexus7')} 0 0;
//            width: ${vw(20, 'nexus7')};
//         }
//         ${mq.greaterThan('tablet')} {
//           height: ${vw(15, 'desktop')};
//           margin: ${vw(-5, 'desktop')} auto;
//           width: ${vw(15, 'desktop')};
//         }
//         ${mq.greaterThan('desktop')} {
//           height: 15px;
//           margin: -5px auto;
//           width: 15px;
//         }
//       }
//     }
//   }
//   .order_status {
//     align-items: center;
//     grid-template-rows: repeat(4,25%);
//     justify-items:unset;
//     margin: 0;
//     ${mq.greaterThan('tablet')} {
//       align-items: unset;
//       grid-template-rows: unset;
//       justify-items: center;
//       margin-bottom: ${vw(55, 'desktop')};
//       margin-top: ${vw(30, 'desktop')};
//     }
//     ${mq.greaterThan('desktop')} {
//       margin-bottom: 55px;
//       margin-top: 30px;
//     }
//     > span {
//       ${getP12_1()}
//       color: ${({ theme }) => theme.colors.darkred};
//       display:block;
//       text-align:left;
//       ${mq.greaterThan('tablet')} {
//         display: inline-grid;
//         text-align: center;
//       }
//     }
//   }
// `
;

;// CONCATENATED MODULE: ./components/account/index.ts





// EXTERNAL MODULE: ./components/shop/index.ts + 10 modules
var shop = __webpack_require__(7074);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./components/detail/DetailHeader.tsx


function DetailHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1 {\n    ",
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    margin-bottom: ",
        ";\n    text-align: left;\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n  }\n\n  .description-clamp {\n    ",
        "\n    color: ",
        ";\n    height: ",
        ";\n    margin: ",
        " 0 ",
        ";\n    overflow: hidden;\n    font-family: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      margin: ",
        " 0 ",
        ";\n    }\n\n    ",
        " {\n      ",
        "\n      height: ",
        ";\n      margin: ",
        " 0 ",
        ";\n    }\n\n    ",
        " {\n      height: 210px;\n      margin: 40px 0 80px;\n    }\n\n    button {\n      ",
        "\n      font-family: ",
        ";\n      color: ",
        ";\n      transition: 200ms opacity ease-in-out;\n      ",
        "\n\n      &:hover {\n        opacity: 1;\n      }\n\n      ",
        " {\n        ",
        "\n      }\n    }\n  }\n\n  .last_units, .on_demand {\n    ",
        "\n    font-weight: 500;\n    font-family: ",
        ";\n    color: ",
        ";\n    display: block;\n    margin-top: ",
        ";\n    text-align: center;\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 15px;\n    }\n  }\n"
    ]);
    DetailHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        color: ",
        ";\n      "
    ]);
    DetailHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        "\n        color: ",
        ";\n    "
    ]);
    DetailHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-family: ",
        ";\n  justify-content: center;\n  margin-bottom: ",
        ";\n  flex-direction: column;\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 10px;\n  }\n\n  &.single-variant {\n    display: block;\n\n    label {\n      ",
        "\n      font-weight: 500;\n    }\n  }\n\n  label {\n    ",
        "\n    font-weight: 500;\n    display: block;\n\n  }\n\n  label, span {\n    font-family: ",
        ";\n    color: ",
        ";\n  }\n\n  div + span {\n    margin-top: ",
        ";\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 30px;\n    }\n  }\n\n  div {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    margin: 0 ",
        ";\n\n    ",
        " {\n      margin: 0 ",
        ";\n    }\n\n    ",
        " {\n      margin: 0 ",
        ";\n    }\n\n    ",
        " {\n      margin: 0 15px;\n    }\n\n    > div{\n      margin: 0 ",
        " ",
        ";\n\n      ",
        " {\n        margin: 0 ",
        " ",
        ";\n      }\n\n      ",
        " {\n        margin: 0 ",
        " ",
        ";\n      }\n\n      ",
        " {\n        margin: 0 15px 10px;\n      }\n    }\n  }\n\n  input {\n    position: absolute;\n    margin: 0;\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .per_box {\n    display: flex;\n    justify-content: center;\n    margin: ",
        " 0 ",
        " auto;\n    min-width: ",
        ";\n    text-align: left;\n\n    ",
        " {\n      margin: ",
        " 0 ",
        " auto;\n      min-width: ",
        ";\n    }\n\n    ",
        " {\n      margin: ",
        " 0 ",
        " auto;\n      min-width: ",
        ";\n    }\n\n    ",
        " {\n      margin: 20px 0 20px auto;\n      min-width: 180px;\n    }\n\n    > span {\n      ",
        "\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content:  ",
        ";\n  padding: 0 0 ",
        ";\n  row-gap: ",
        ";\n\n  ",
        " {\n    padding: 0 0 ",
        ";\n    row-gap: ",
        ";\n  }\n\n  ",
        " {\n    padding: 0 0 ",
        ";\n    row-gap: ",
        ";\n  }\n\n  ",
        " {\n    padding: 0 0 25px;\n    row-gap: 20px;\n  }\n\n  button {\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: absolute;\n  top: ",
        ";\n\n  ",
        " {\n    top: ",
        ";\n  }\n\n  ",
        " {\n    top: ",
        ";\n  }\n\n  ",
        " {\n    top: 15px;\n  }\n\n  span {\n    ",
        "\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    color: ",
        ";\n    margin-right: ",
        ";\n    padding: ",
        " ",
        ";\n    text-transform: uppercase;\n    z-index: 1;\n\n    ",
        " {\n      border-radius: ",
        ";\n      margin-right: ",
        ";\n      padding: ",
        " ",
        ";\n    }\n\n    ",
        " {\n      border-radius: ",
        ";\n      margin-right: ",
        ";\n      padding: ",
        " ",
        ";\n    }\n\n    ",
        " {\n      border-radius: 12px;\n      margin-right: 5px;\n      padding: 5px 8px ;\n    }\n  }\n\n  .fresh {\n    text-transform: none;\n  }\n\n  .discount {\n    background-color: ",
        ";\n  }\n\n  .filter-label {\n    background-color: unset;\n    height: ",
        ";\n    margin-right: ",
        ";\n    padding: 0;\n    width: ",
        ";\n    z-index: 1;\n\n    ",
        " {\n      height: ",
        ";\n      margin-right: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      margin-right: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 24px;\n      margin-right: 5px;\n      width: 24px;\n    }\n\n    > figure {\n      height: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 24px;\n        width: 24px;\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  ",
        "\n  font-family: ",
        ";\n  opacity: .4;\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}












var getAvailableVariants = function(variants, currentVariant, setCurrentVariant) {
    return variants.map(function(variant) {
        var name = variant.name;
        return {
            variant: variant,
            currentVariantId: currentVariant.bigcommerceId,
            setCurrentVariant: setCurrentVariant,
            text: "".concat(name)
        };
    });
};
var getUnifiedLabel = function(deliveryType, customer, labels, onDemandText) {
    var incomingLabels = [];
    if (Array.isArray(labels) && labels.length > 0) incomingLabels = (0,_to_consumable_array/* default */.Z)(labels);
    if (customer && deliveryType === "on_demand") incomingLabels.push({
        name: onDemandText
    });
    return incomingLabels;
};
var getLabels = function(labels) {
    return labels.map(function(label, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: label.name
        }, idx);
    });
};
var DetailHeader = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, _isPack = param.isPack, isPack = _isPack === void 0 ? false : _isPack, currentVariant = param.currentVariant, setCurrentVariant = param.setCurrentVariant, round = param.round, _isPrivate = param.isPrivate, isPrivate = _isPrivate === void 0 ? true : _isPrivate;
    var name = data.name, brand = data.brand, variants = data.variants, description = data.description, categories = data.categories, filters = data.filters;
    var variant_id = currentVariant.id, media = currentVariant.media, variant_name = currentVariant.name, price = currentVariant.price, reference_price = currentVariant.reference_price, reference_unit = currentVariant.reference_unit, stock = currentVariant.stock, stockWarning = currentVariant.stockWarning, minSaleUnits = currentVariant.minSaleUnits, deliveryType = currentVariant.deliveryType, deliveryDate = currentVariant.deliveryDate, onDemandDay = currentVariant.onDemandDay, product = currentVariant.product, qtyPerBox = currentVariant.qtyPerBox;
    var inventoryTracking = product.inventoryTracking;
    var isFrozen = (0,react.useMemo)(function() {
        return deliveryType === "frozen";
    }, [
        deliveryType
    ]);
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,router.useRouter)(), routerLocale = ref.locale, pathname = ref.pathname;
    var lang = (0,utils.getLang)(routerLocale);
    var updatePayload = (0,dist_hooks.useModal)(context.MODALS.BUY_BOX).updatePayload;
    var isPrivatePath = (0,react.useMemo)(function() {
        return (0,utils.getPathnameType)(pathname) === "private";
    }, [
        pathname
    ]);
    var isPanettone = name.toLowerCase().includes("panettone");
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    var availableVariants = (0,react.useMemo)(function() {
        return getAvailableVariants(variants, currentVariant, setCurrentVariant);
    }, [
        variants,
        currentVariant,
        setCurrentVariant
    ]);
    var discount = (price || {}).discount;
    var LabelDiscount = (0,react.useMemo)(function() {
        return discount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "discount",
            children: [
                "-",
                discount,
                "%"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        discount
    ]);
    var unifiedLabels = (0,react.useMemo)(function() {
        return getUnifiedLabel(deliveryType, customer, labels, t("product_page.product.demand_product"));
    }, [
        customer,
        labels,
        deliveryType,
        t
    ]);
    var LabelItems = (0,react.useMemo)(function() {
        return unifiedLabels ? getLabels(unifiedLabels) : [];
    }, [
        unifiedLabels
    ]);
    var preselectFilters = (0,react.useMemo)(function() {
        return filters === null || filters === void 0 ? void 0 : filters.filter(function(item) {
            var ref, ref1;
            return FILTER_LABELS[item.param] && (item === null || item === void 0 ? void 0 : (ref = item.values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.visible);
        });
    }, [
        filters
    ]);
    var LabelFilters = (0,react.useMemo)(function() {
        return (preselectFilters === null || preselectFilters === void 0 ? void 0 : preselectFilters.length) > 0 ? getFilterLabels(preselectFilters, pathname) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        preselectFilters,
        pathname
    ]);
    var displayStockWarning = inventoryTracking && stock >= 1 && stockWarning;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        isPack: isPack,
        $frozen: isFrozen,
        children: [
            !isPack && /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                $frozen: isFrozen,
                children: brand !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                    href: isPrivate ? "/shop/brand/".concat(brand.slug[lang]) : "/brand/".concat(brand.slug[lang]),
                    children: brand.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaWrapper, {
                children: [
                    (LabelItems.length > 0 || (LabelFilters === null || LabelFilters === void 0 ? void 0 : LabelFilters.length) > 0 || LabelDiscount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                        children: [
                            isFrozen && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "filter-label",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/svg/label-fresh.svg",
                                        alt: "frozen product"
                                    })
                                })
                            }),
                            LabelItems,
                            LabelFilters,
                            LabelDiscount
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.ImageSlider, {
                        data: media,
                        isPack: isPack
                    }, variant_id)
                ]
            }),
            !isPack && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfo, {
                className: (availableVariants === null || availableVariants === void 0 ? void 0 : availableVariants.length) === 1 ? "single-variant" : "",
                $frozen: isFrozen,
                children: [
                    (availableVariants === null || availableVariants === void 0 ? void 0 : availableVariants.length) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: minSaleUnits > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            children: variant_name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                variant_name,
                                getPricePerUnit(reference_price, reference_unit, false, routerLocale)
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components.RadioCheckBoxes, {
                        data: availableVariants
                    }),
                    minSaleUnits > 1 && isPrivate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,utils.getDynamicText)(t("product_page.product.description_min_sale_units"), {
                            minSaleUnits: minSaleUnits
                        })
                    }),
                    qtyPerBox > 1 && minSaleUnits === 1 && isPrivate && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            updatePayload({
                                payload: {
                                    data: {
                                        name: name,
                                        brand: brand,
                                        categories: categories,
                                        variant: currentVariant,
                                        product: currentVariant.product
                                    },
                                    stock: stock,
                                    inventoryTracking: inventoryTracking
                                },
                                open: true
                            });
                        },
                        className: "per_box",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (0,utils.getDynamicText)(t("product_page.product.buy_box"), {
                                units: qtyPerBox
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrap, {
                $isPrivate: isPrivate,
                children: [
                    (price !== null || reference_price !== null) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Price, {
                        type: "pdp",
                        price: price !== null && price !== void 0 ? price : getPricePerUnit(reference_price, reference_unit, false, routerLocale),
                        pricePer: t("product_page.product.price_per.unit"),
                        round: round
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* AddToCart */.o4, {
                        data: {
                            name: name,
                            brand: brand,
                            categories: categories,
                            variant: currentVariant,
                            product: currentVariant.product
                        },
                        isPDP: true,
                        displayStockWarning: displayStockWarning,
                        notAvailable: price === null && stock > 0,
                        inventoryTracking: inventoryTracking,
                        frozen: isFrozen,
                        shouldTriggerHowToBuyModal: !isPanettone
                    })
                ]
            }),
            utils.hasPrivateStore[routerLocale] && isPrivatePath && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanDeliveryDate, {
                children: (0,utils.getDynamicText)(t("product_page.product.delivery_date_".concat(deliveryType)), {
                    deliveryDate: (0,utils.getDateFormatted)(lang, deliveryDate),
                    onDemandDay: (0,utils.getDayOfWeekName)(lang, onDemandDay),
                    deliveryHour: deliveryType === "on_demand" ? "14h" : "21h"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.MaxHeightContainer, {
                force_link: true,
                className: "description-clamp",
                elipsis: t("product_page.product_main.see_more"),
                data: description
            })
        ]
    });
});
var Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "DetailHeader__Header",
    componentId: "sc-ac0ac979-0"
})(DetailHeader_templateObject(), (0,styles.getP30)(), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? theme.colors.frozen : theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var isPack = param.isPack;
    return (0,styles.vw)(isPack ? 42 : 19, "mobile");
}, styles.mq.greaterThan("nexus7"), function(param) {
    var isPack = param.isPack;
    return (0,styles.vw)(isPack ? 42 : 19, "nexus7");
}, styles.mq.greaterThan("tablet"), function(param) {
    var isPack = param.isPack;
    return isPack ? "".concat((0,styles.vw)(10, "desktop")) : "0";
}, styles.mq.greaterThan("desktop"), function(param) {
    var isPack = param.isPack;
    return isPack ? "10px" : "0";
}, (0,styles.getP18_3)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(174, "mobile"), (0,styles.vw)(40, "mobile"), (0,styles.vw)(60, "mobile"), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(154, "nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.getP20_2)(), (0,styles.vw)(210, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(80, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_3)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.createUnderline)({
    reverse: true,
    color: "red"
}), styles.mq.greaterThan("tablet"), (0,styles.getP20_2)(), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.orange;
}, (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"));
var Brand = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DetailHeader__Brand",
    componentId: "sc-ac0ac979-1"
})(_templateObject3(), (0,styles.getP18_1)(), function(param) {
    var $frozen = param.$frozen;
    return $frozen ? (0,styled_components_browser_esm.css)(DetailHeader_templateObject1(), (0,styles.createUnderline)({
        height: 0.5,
        color: "frozen"
    }), function(param) {
        var theme = param.theme;
        return theme.colors.frozen;
    }) : (0,styled_components_browser_esm.css)(DetailHeader_templateObject2(), (0,styles.createUnderline)({
        height: 0.5,
        color: "red"
    }), function(param) {
        var theme = param.theme;
        return theme.colors.red;
    });
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"));
var ProductInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DetailHeader__ProductInfo",
    componentId: "sc-ac0ac979-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondary;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1B)(), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? theme.colors.frozen : theme.colors.red;
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(15, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(125, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(125, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(180, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1B)(), (0,styles.createUnderline)({
    height: 1,
    color: "red",
    reverse: true
}));
var FlexWrap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DetailHeader__FlexWrap",
    componentId: "sc-ac0ac979-3"
})(_templateObject5(), function(param) {
    var $isPrivate = param.$isPrivate;
    return $isPrivate ? "space-between" : "flex-end";
}, (0,styles.vw)(35, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(35, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1B)());
var MediaWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DetailHeader__MediaWrapper",
    componentId: "sc-ac0ac979-4"
})(_templateObject6());
var LabelWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DetailHeader__LabelWrapper",
    componentId: "sc-ac0ac979-5"
})(_templateObject7(), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_1B)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
}, (0,styles.vw)(12, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,styles.vw)(5, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(8, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(8, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(8, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(24, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(24, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(24, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(24, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(24, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(24, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(24, "mobile"), (0,styles.vw)(24, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(24, "nexus7"), (0,styles.vw)(24, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(24, "desktop"), (0,styles.vw)(24, "desktop"), styles.mq.greaterThan("desktop"));
var SpanDeliveryDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DetailHeader__SpanDeliveryDate",
    componentId: "sc-ac0ac979-6"
})(_templateObject8(), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
});

;// CONCATENATED MODULE: ./components/detail/sharedDetailStyles.ts

function sharedDetailStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin: ",
        " 0 ",
        ";\n\n  ",
        " {\n    margin: ",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: 80px 0 20px;\n  }\n"
    ]);
    sharedDetailStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sharedDetailStyles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    sharedDetailStyles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sharedDetailStyles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-collapse: collapse;\n  width: 100%;\n\n  tr:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  td {\n    ",
        "\n    padding: ",
        " 0;\n    vertical-align: top;\n    width: 50%;\n\n    ",
        " {\n      padding: ",
        " 0;\n    }\n\n    ",
        " {\n      padding: ",
        " 0;\n    }\n\n    ",
        " {\n      padding: 16px 0;\n    }\n\n    &:nth-child(odd) {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    sharedDetailStyles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sharedDetailStyles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " 0 ",
        ";\n\n  ",
        " {\n    margin: ",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        " 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: 60px 0 10px;\n  }\n\n  h2 {\n    ",
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: left;\n  }\n"
    ]);
    sharedDetailStyles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sharedDetailStyles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  table td {\n    &:nth-child(even) {\n     text-align: right;\n     padding-right: ",
        ";\n\n      ",
        " {\n        padding-right: ",
        ";\n      }\n\n      ",
        " {\n        padding-right: ",
        ";\n      }\n\n      ",
        " {\n        padding-right: 25px;\n      }\n    }\n  }\n"
    ]);
    sharedDetailStyles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var H2 = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "sharedDetailStyles__H2",
    componentId: "sc-db2bf6e7-0"
})(sharedDetailStyles_templateObject(), (0,styles.getP53)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(60, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(80, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(80, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));
var P = styled_components_browser_esm["default"].p.withConfig({
    displayName: "sharedDetailStyles__P",
    componentId: "sc-db2bf6e7-1"
})(sharedDetailStyles_templateObject1(), (0,styles.getP18_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, styles.mq.greaterThan("tablet"), (0,styles.getP20_1)());
var Table = styled_components_browser_esm["default"].table.withConfig({
    displayName: "sharedDetailStyles__Table",
    componentId: "sc-db2bf6e7-2"
})(sharedDetailStyles_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.red, .2);
}, (0,styles.getP15_1)(), (0,styles.vw)(16.5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(16.5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(16.5, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});
var Dt = styled_components_browser_esm["default"].dt.withConfig({
    displayName: "sharedDetailStyles__Dt",
    componentId: "sc-db2bf6e7-3"
})(sharedDetailStyles_templateObject3(), (0,styles.vw)(60, "mobile"), (0,styles.vw)(24, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), (0,styles.vw)(24, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP30)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
});
var SectionNutrition = styled_components_browser_esm["default"].section.withConfig({
    displayName: "sharedDetailStyles__SectionNutrition",
    componentId: "sc-db2bf6e7-4"
})(sharedDetailStyles_templateObject4(), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/detail/SectionIngredients.tsx




var SectionIngredients = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: t("product_page.product_description.nutritional_value.ingredients")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P, {
                children: data
            })
        ]
    });
});

// EXTERNAL MODULE: ./hooks/useTranslator.tsx
var useTranslator = __webpack_require__(78026);
;// CONCATENATED MODULE: ./components/detail/SectionNutritionChart.tsx

function SectionNutritionChart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n\n  ",
        " {\n    height: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n  }\n\n  ",
        " {\n    height: 25px;\n  }\n\n  span {\n    align-items: center;\n    color: ",
        ";\n    display: flex;\n    ",
        "\n    font-family: ",
        ";\n    height: 100%;\n    justify-content: center;\n    padding: 0 ",
        ";\n\n    ",
        " {\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 25px;\n    }\n\n    &:nth-child(2) {\n      border-left: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    SectionNutritionChart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var localeString = {
    "en": "en-GB",
    "es": "es-ES"
};
var getNutritional = function(details, locale) {
    return details.map(function(detail, idx) {
        var value = detail.value < 1 ? "< 1" : detail.value.toLocaleString(localeString[locale]);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: detail.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: value
                })
            ]
        }, idx);
    });
};
var SectionNutritionChart = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useTranslator/* useTranslator */.I)().t;
    var energy = data.filter(function(item) {
        return item.nutritionType === "energy";
    })[0];
    var chartData = data.filter(function(item) {
        return item.nutritionType === "weight";
    });
    var dataWithPercentages = (0,react.useMemo)(function() {
        return getNutritional(chartData, locale);
    }, [
        chartData,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionNutrition, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: t("product_page.product_description.nutritional_value.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionNutritionChart_P, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            t("product_page.product_description.nutritional_value.average_value_per"),
                            " 100gr."
                        ]
                    }),
                    energy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            t("product_page.product_description.nutritional_value.energy"),
                            ": ",
                            energy.value,
                            " / ",
                            Math.round(typeof energy.value === "string" ? parseInt(energy.value) : Number(energy.value) * 4.184),
                            "kJ"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: dataWithPercentages
                })
            })
        ]
    });
});
var SectionNutritionChart_P = styled_components_browser_esm["default"].p.withConfig({
    displayName: "SectionNutritionChart__P",
    componentId: "sc-1f63bb6e-0"
})(SectionNutritionChart_templateObject(), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP12_1)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});

;// CONCATENATED MODULE: ./components/detail/SectionMoreInfo.tsx




var getInfo = function(details) {
    return details.map(function(detail, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: detail.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: detail.value
                })
            ]
        }, idx);
    });
};
var SectionMoreInfo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var t = (0,useTranslator/* useTranslator */.I)().t;
    var Information = (0,react.useMemo)(function() {
        return getInfo(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                children: t("product_page.product_description.more_info.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: Information
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/detail/SectionRelated.tsx



function SectionRelated_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: -",
        ";\n  margin-left: -",
        ";\n\n  ",
        " {\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n  }\n\n  ",
        " {\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n  }\n\n  ",
        " {\n    margin-right: -30px;\n    margin-left: -30px;\n  }\n\n  .flickity-slider dd:first-of-type, h2 {\n    padding-left: ",
        ";\n\n    ",
        " {\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      padding-left: 30px;\n    }\n  }\n\n  .slider--flickity .previous {\n    svg { display: none; }\n    ::after {\n      position: absolute;\n      top: 0;\n      left: 0;\n      content: url('/images/svg/i--arrow-left.svg');\n      z-index: 100;\n    }\n  }\n\n  .slider--flickity .next {\n    svg { display: none; }\n    ::after {\n      position: absolute;\n      top: 0;\n      left: 0;\n      content: url('/images/svg/i--arrow-right.svg');\n      z-index: 100;\n    }\n  }\n\n"
    ]);
    SectionRelated_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var getSlides = function(products) {
    return products.map(function(product, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                    idx: idx + 1
                }),
                narrow: true
            })
        }, idx);
    });
};
var SectionRelated = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, gaList = param.gaList;
    var Slides = (0,react.useMemo)(function() {
        return getSlides(data);
    }, [
        data
    ]);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,dist_hooks.useInView)({
        rootMargin: "20px",
        threshold: 0,
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    (0,react.useEffect)(function() {
        if (inView) {
            (0,utils.pushAnalyticsEvent)("view_item_list", {
                products: data,
                ga_list: gaList
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRel, {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dt, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: t("product_page.bottom-page.related")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.SliderFlickity, {
                    className: "slider--product-card",
                    options: {
                        pageDots: false,
                        groupCells: "90%",
                        cellAlign: "left",
                        draggable: true,
                        prevNextButtons: true
                    },
                    children: Slides
                })
            ]
        })
    });
});
var SectionRel = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionRelated__SectionRel",
    componentId: "sc-4e087191-0"
})(SectionRelated_templateObject(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/detail/index.ts







// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(88241);
;// CONCATENATED MODULE: ./components/user/SectionUserAuth.tsx


function SectionUserAuth_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    SectionUserAuth_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionUserAuth__Section",
    componentId: "sc-822be045-0"
})(SectionUserAuth_templateObject());
var formByLevel = {
    "start": FormUserInitial,
    "signup_cif": FormUserSignUpCIF,
    "signup": FormUserSignUp,
    "prelogin": FormUserPreLogin,
    "login_check_cif": FormUserCheckCIF,
    "login": FormUserLogIn,
    "forgot_password": FormUserForgotPassword,
    "reset_password": FormUserResetPassword,
    "activation": FormUserActivateAccount,
    "feedback_account_active": FeedbackAccountActivated,
    "feedback_cif_already_active": FeedbackCIFAlreadyActive,
    "feedback_cif_not_found": FeedbackCIFNotFound,
    "feedback_email_invite": FeedbackEmailInvite,
    "feedback_email_reset_password": FeedbackEmailResetPassword,
    "feedback_password_updated": FeedbackPasswordUpdated
};
var defaultAuthModalLevel = utils.DY_SIGNUP_ALLOWED ? "start" : "login";
var stepVariants = {
    initial: {
        opacity: 0,
        x: -250,
        transition: {
            duration: 0.3
        }
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.3
        }
    }
};
var animation = {
    initial: "initial",
    animate: "animate",
    exit: "initial",
    variants: stepVariants
};
var SectionUserAuth = /*#__PURE__*/ (0,react.memo)(function(param) {
    var payload = param.payload, updatePayload = param.updatePayload;
    var ref;
    var CurrentForm = (0,react.useMemo)(function() {
        return formByLevel[(ref = payload === null || payload === void 0 ? void 0 : payload.level) !== null && ref !== void 0 ? ref : defaultAuthModalLevel];
    }, [
        payload
    ]);
    var updateLevel = (0,react.useCallback)(function(newLevel) {
        var extraPayload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var payload = (0,_object_spread/* default */.Z)({
            level: newLevel
        }, extraPayload && extraPayload);
        updatePayload({
            payload: payload,
            close: close
        });
    }, [
        updatePayload
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentForm, {
                animation: animation,
                updateLevel: updateLevel,
                payload: payload
            }, "form--".concat(payload === null || payload === void 0 ? void 0 : payload.level))
        })
    });
});

;// CONCATENATED MODULE: ./components/user/index.ts


;// CONCATENATED MODULE: ./components/search/ButtonTriggerSearch.tsx

function ButtonTriggerSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: ",
        ";\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    background-color: white;\n    border-radius: ",
        ";\n    height: ",
        ";\n    max-width: ",
        ";\n    padding: 0 ",
        ";\n    width: 100%;\n  }\n\n  ",
        " {\n    border-radius: 24.5px;\n    height: 40px;\n    max-width: 406px;\n    padding: 0 20px;\n  }\n\n  figure {\n    width: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 16px;\n    }\n  }\n\n  >span {\n    ",
        "\n    display: none;\n    min-width: unset;\n\n    ",
        " {\n      display: inline-block;\n      margin-left: ",
        ";\n      min-width: ",
        ";\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    ",
        " {\n      margin-left: 13px;\n      min-width: 150px;\n    }\n  }\n"
    ]);
    ButtonTriggerSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var iconSearch = function() {
    var fillColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "darkred";
    return {
        type: "svg",
        src: "/images/svg/i--search".concat(fillColor === "white" ? "--white" : "", ".svg"),
        alt: "Logo",
        size: {
            width: 16,
            height: 16
        }
    };
};
var ButtonTriggerSearch = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "darkred" : _fillColor;
    var ref = (0,dist_hooks.useModal)(context.MODALS.SEARCH), toggleSearch = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
        onClick: toggleSearch,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                media: iconSearch(fillColor),
                fill: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: t("layout.search.what_are_you_looking_for")
            })
        ]
    });
});
var Button = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ButtonTriggerSearch__Button",
    componentId: "sc-951f82ca-0"
})(ButtonTriggerSearch_templateObject(), (0,styles.vw)(39, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(39, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(24.5, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(406, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(21, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(21, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(16, "desktop"), styles.mq.greaterThan("desktop"), styles.getP14Search, styles.mq.greaterThan("tablet"), (0,styles.vw)(13, "desktop"), (0,styles.vw)(150, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./components/search/SearchResults.tsx





function SearchResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  grid-row: 2 / span 1;\n  overflow: auto;\n  padding: ",
        " 0;\n  margin-bottom: 0;\n\n  ",
        " {\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    grid-column: 2 / span 5;\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    padding: 50px 0;\n  }\n\n  dt {\n    color: ",
        ";\n    font-weight: 400;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 20px;\n    }\n\n    button {\n      color: ",
        ";\n      text-decoration: underline;\n      transition: 300ms color ease-out;\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    SearchResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchResults_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 10px;\n  }\n\n  a {\n    ",
        "\n    align-items: center;\n    color: inherit;\n    display: flex;\n    text-decoration: none;\n    width: 100%;\n\n    &:hover {\n      span {\n        opacity: 1;\n      }\n    }\n\n    span {\n      opacity: .8;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      transition: 300ms opacity ease-out;\n      white-space: nowrap;\n    }\n  }\n\n  figure, img {\n    align-items: center;\n    display: flex;\n    height: ",
        ";\n    justify-content: center;\n    margin-right: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      margin-right: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      margin-right: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 40px;\n      margin-right: 15px;\n      width: 40px;\n    }\n\n    &.placeholder {\n      background-color: rgba(0, 0, 0, .15);\n    }\n  }\n"
    ]);
    SearchResults_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var LANG = utils.NEXT_PUBLIC_LOCALE.split("-")[0];
// This const resultIconByType keys set the order of the results by type
var resultIconByType = {
    search: function() {
        return {
            type: "svg",
            src: "/images/svg/i--search-result-lupa.svg",
            alt: "Search go page icon",
            size: {
                width: 40,
                height: 40
            }
        };
    },
    categories: function() {
        return {
            type: "svg",
            src: "/images/svg/i--search-result-category.svg",
            alt: "Search result - category",
            size: {
                width: 16,
                height: 16
            }
        };
    },
    brands: function(item) {
        return item === null || item === void 0 ? void 0 : item.logo;
    },
    articles: function() {
        return {
            type: "svg",
            src: "/images/svg/i--search-result-article.svg",
            alt: "Search result - blog article",
            size: {
                width: 16,
                height: 16
            }
        };
    },
    variants: function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.media) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.medium;
    }
};
var localStorageItem = "mammafiore_search_history";
var getHistory = function() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var historyVariants = JSON.parse(localStorage.getItem(localStorageItem)) || {};
    if (raw) return historyVariants;
    // Adapt to the results data schema, to be able to reuse the getListItems function
    var historyVariantsArray = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(historyVariants)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var slug = _step.value;
            historyVariantsArray.push(historyVariants[slug]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        variants: historyVariantsArray
    };
};
var updateSearchHistory = function(item) {
    var ref, ref1, ref2;
    var currentHistory = getHistory();
    var ref3;
    var slug = (ref3 = item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1[LANG]) !== null && ref3 !== void 0 ? ref3 : item === null || item === void 0 ? void 0 : (ref2 = item.slug) === null || ref2 === void 0 ? void 0 : ref2[LANG];
    if (!slug) return;
    if (!currentHistory) localStorage.setItem(localStorageItem, JSON.stringify((0,_define_property/* default */.Z)({}, slug, item)));
    if (!currentHistory[slug]) {
        var incomingHistory = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentHistory), (0,_define_property/* default */.Z)({}, slug, item));
        localStorage.setItem(localStorageItem, JSON.stringify(incomingHistory));
    }
};
var updateQueryParam = function(push, query) {
    push({
        pathname: "/",
        search: query
    });
};
var pathname = {
    categories: "/",
    brand: "/brand/",
    variants: "/product/"
};
var getListItems = function(customer, data, close, push) {
    var items = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var x = _step.value;
            var arr = data[x];
            if (!Array.isArray(arr)) return "continue";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _value = (0,_sliced_to_array/* default */.Z)(_step1.value, 2), idx = _value[0], item = _value[1];
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    var slug = (item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1[LANG]) ? item === null || item === void 0 ? void 0 : (ref2 = item.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.slug) === null || ref3 === void 0 ? void 0 : ref3[LANG] : item === null || item === void 0 ? void 0 : (ref4 = item.slug) === null || ref4 === void 0 ? void 0 : ref4[LANG];
                    var href = !slug ? item.href : (customer ? "/shop" : x === "brand" ? "" : "/catalog") + pathname[x] + slug + "?v=".concat(item.name);
                    var media = resultIconByType[x](item);
                    var ref10;
                    items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_ListItem, {
                        onClick: function() {
                            if (x === "variants") updateSearchHistory(item);
                            else if (x === "search") updateQueryParam(push, href);
                            if (x !== "search") close();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: href && x !== "brands" ? href : customer ? "/shop/brand/".concat(item === null || item === void 0 ? void 0 : (ref5 = item.slug) === null || ref5 === void 0 ? void 0 : ref5[LANG]) : "/brand/".concat(item === null || item === void 0 ? void 0 : (ref6 = item.slug) === null || ref6 === void 0 ? void 0 : ref6[LANG]),
                            children: [
                                x === "brands" && ((ref7 = item.logo) === null || ref7 === void 0 ? void 0 : ref7.url) ? // eslint-disable-next-line @next/next/no-img-element
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (ref8 = item.logo) === null || ref8 === void 0 ? void 0 : ref8.url,
                                    alt: item.name,
                                    className: x
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                    className: x,
                                    media: media
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        (ref10 = item === null || item === void 0 ? void 0 : (ref9 = item.product) === null || ref9 === void 0 ? void 0 : ref9.name) !== null && ref10 !== void 0 ? ref10 : item === null || item === void 0 ? void 0 : item.name,
                                        " ",
                                        "- ".concat(item === null || item === void 0 ? void 0 : item.name)
                                    ]
                                })
                            ]
                        })
                    }, "".concat(idx, "-result ").concat(item === null || item === void 0 ? void 0 : item.bigcommerceId)));
                };
                for(var _iterator = arr.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        for(var _iterator = Object.keys(resultIconByType)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return items;
};
var SearchResults = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data, close = param.close;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var push = (0,router.useRouter)().push;
    var ListItems = (0,react.useMemo)(function() {
        return getListItems(!!customer, data, close, push);
    }, [
        customer,
        data,
        close,
        push
    ]);
    var ref = (0,react.useState)(undefined), historyItemsLength = ref[0], setHistoryItemsLength = ref[1];
    var HistoryItems = (0,react.useMemo)(function() {
        return typeof historyItemsLength !== "number" || historyItemsLength > 0 ? getListItems(!!customer, getHistory(false), close, push) : [];
    }, [
        historyItemsLength,
        customer,
        close,
        push
    ]);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClickClearHistory = function() {
        localStorage.removeItem(localStorageItem);
        setHistoryItemsLength(0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
        children: (ListItems === null || ListItems === void 0 ? void 0 : ListItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                    children: t("layout.search.search_results")
                }),
                ListItems
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (HistoryItems === null || HistoryItems === void 0 ? void 0 : HistoryItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                        children: [
                            t("layout.search.history"),
                            ". ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: onClickClearHistory,
                                children: t("commons.actions.delete")
                            })
                        ]
                    }),
                    HistoryItems
                ]
            })
        })
    });
};
var List = styled_components_browser_esm["default"].dl.withConfig({
    displayName: "SearchResults__List",
    componentId: "sc-5d5bb654-0"
})(SearchResults_templateObject(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .5);
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .5);
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, 1);
});
var SearchResults_ListItem = (0,styled_components_browser_esm["default"])(motion/* motion.dd */.E.dd).withConfig({
    displayName: "SearchResults__ListItem",
    componentId: "sc-5d5bb654-1"
})(SearchResults_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, 1);
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), styles.getP15, (0,styles.vw)(40, "mobile"), (0,styles.vw)(15, "mobile"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(15, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/search/SearchByCategory.tsx

function SearchByCategory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  grid-column: 1 / span 6;\n  margin-bottom: 0;\n  max-height: 100%;\n  padding: ",
        " 0;\n\n  ",
        " {\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    align-items: flex-start;\n    align-self: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n    grid-column: 7 / span 5;\n    grid-row: 2 / span 1;\n    justify-content: center;\n    overflow: auto;\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    padding: 50px 0;\n  }\n\n  dt {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: 300;\n    margin-bottom: ",
        ";\n    text-align: center;\n    width: 100%;\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 60px;\n    }\n  }\n"
    ]);
    SearchByCategory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchByCategory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 20px;\n  }\n\n  a {\n    align-items: center;\n    color: ",
        ";\n    display: flex;\n    font-weight: bold;\n    height: ",
        ";\n    padding: 0 ",
        ";\n    text-decoration: none;\n    width: auto;\n\n    ",
        " {\n      height: ",
        ";\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      height: 40px;\n      padding: 0 25px;\n    }\n  }\n"
    ]);
    SearchByCategory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var SearchByCategory_LANG = utils.NEXT_PUBLIC_LOCALE.split("-")[0];
var SearchByCategory_getListItems = function(data, close) {
    return data.map(function(item, idx) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Dd, {
            onClick: close,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                href: "/catalog/".concat(item === null || item === void 0 ? void 0 : item.slug[SearchByCategory_LANG]),
                children: item.name
            })
        }, "".concat(idx, "-result"));
    });
};
var SearchByCategory = function(param) {
    var data = param.data, close = param.close;
    var ListItems = (0,react.useMemo)(function() {
        return SearchByCategory_getListItems(data, close);
    }, [
        data,
        close
    ]);
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dl, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                children: t("layout.search.search_by_category")
            }),
            ListItems
        ]
    });
};
var Dl = styled_components_browser_esm["default"].dl.withConfig({
    displayName: "SearchByCategory__Dl",
    componentId: "sc-f9ca7199-0"
})(SearchByCategory_templateObject(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(60, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"));
var Dd = styled_components_browser_esm["default"].dd.withConfig({
    displayName: "SearchByCategory__Dd",
    componentId: "sc-f9ca7199-1"
})(SearchByCategory_templateObject1(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/search/index.ts




// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ./components/modals/Modal.tsx



function Modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  align-items: flex-start;\n  background-color: rgba(0, 0, 0, .2);\n  /* background-color: rgba(255, 255, 255, .85); */\n  bottom: 0;\n  display: flex;\n  height: ",
        ";\n  height: ",
        ";\n  justify-content: ",
        ";\n  left: 0;\n  opacity: 0;\n	outline: 0;\n  overflow: auto;\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n  top: 0;\n  user-select: none;\n  width: 100%;\n  will-change: opacity;\n  z-index: ",
        ";\n\n  &[aria-hidden='false'] {\n    opacity: 1;\n    pointer-events: auto;\n    user-select: auto;\n  }\n\n  .modal__body {\n    position: relative;\n    width: 100%;\n    height: ",
        ";\n    height: ",
        ";\n\n  }\n  /* MOBILE LANDSCAPE */\n  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {\n    width: 100%;\n    .modal__body {\n      height: unset;\n    }\n  }\n\n  ",
        " {\n    height: ",
        ";\n  }\n"
    ]);
    Modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Modal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  height: 100%;\n  justify-content: center;\n  margin-left: auto;\n  max-width: 48px;\n  width: ",
        ";\n  z-index: 2;\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: 48px;\n    width: 48px;\n  }\n\n  figure {\n    max-height: 28px;\n    max-width: 28px;\n    width: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 10px;\n    }\n  }\n\n  &.btn--back {\n    left: 0;\n    position: absolute;\n  }\n"
    ]);
    Modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Modal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    user-select: none;\n    pointer-events: none;\n\n    > *,\n    li, dd,\n    button, a, form, input, fieldset,\n    figure, div {\n      user-select: none;\n      pointer-events: none;\n    }\n  "
    ]);
    Modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Modal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: 0 25px 50px rgba(0, 0, 0, .15);\n  font-family: ",
        ";\n  grid-column: 1 / span 6;\n  margin: ",
        ";\n  max-width: ",
        ";\n  position: relative;\n  width: calc(100% - ",
        "px);\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        " {\n    grid-column: 1 / span 12;\n    margin: ",
        ";\n    max-width: ",
        ";\n    width: calc(100% - ",
        "px);\n  }\n\n  ",
        " {\n    grid-column: 1 / span 12;\n    margin: ",
        ";\n    max-width: ",
        ";\n    width: calc(100% - ",
        "px);\n  }\n\n  ",
        " {\n    width: 100%;\n  }\n\n  > header {\n    align-items: center;\n    border-bottom: 1px solid ",
        ";\n    display: flex;\n    height: ",
        ";\n    justify-content: center;\n    padding-left: ",
        ";\n    position: relative;\n    width: 100%;\n\n    ",
        " {\n      height: ",
        ";\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      padding-left: ",
        ";\n    }\n\n    ",
        " {\n      height: 50px;\n      padding-left: 48px;\n    }\n\n    h2 {\n      ",
        "\n      color: ",
        ";\n      font-weight: 500;\n      margin-bottom: 0;\n      width: 100%;\n    }\n  }\n\n  .modal__body {\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 50px 27.5px 75px;\n    }\n  }\n\n  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {\n    margin: ",
        ";\n    height: max-content;\n\n    > header {\n      height: ",
        ";\n    }\n    .modal__body {\n      padding: ",
        " ",
        " ",
        ";\n      min-height: 100%;\n    }\n  }\n\n  ",
        "\n"
    ]);
    Modal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




// import type FlattenSimpleInterpolation from 'styled-components'





//triggerbuild
var closeIcon = {
    type: "svg",
    src: "/images/svg/close.svg",
    alt: "Close modal icon",
    size: {
        width: 12,
        height: 12
    }
};
var backIcon = {
    type: "svg",
    src: "/images/svg/chevron--left.svg",
    alt: "Go back icon",
    size: {
        width: 12,
        height: 12
    }
};
var defaultDialogVariants = function(isActive) {
    return {
        initial: {
            y: "10px"
        },
        animate: {
            y: isActive ? 0 : "10px"
        },
        exit: {
            y: "10px"
        },
        transition: {
            duration: .3,
            delay: .1
        }
    };
};
var Modal = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, children = param.children, isActive = param.isActive, close = param.close, _xAlign = param.xAlign, xAlign = _xAlign === void 0 ? "center" : _xAlign, _variants = param.variants, variants = _variants === void 0 ? defaultDialogVariants : _variants, _dialogStyles = param.dialogStyles, dialogStyles = _dialogStyles === void 0 ? null : _dialogStyles, _onClickBack = param.onClickBack, onClickBack = _onClickBack === void 0 ? null : _onClickBack, _size = param.size, size = _size === void 0 ? "auto" : _size, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 600 : _zIndex, _isModalFilters = param.isModalFilters, isModalFilters = _isModalFilters === void 0 ? false : _isModalFilters;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var t = (0,hooks/* useTranslator */.I4)().t;
    var titleAsSlug = (0,utils.slugify)(title);
    var onClick = function(e) {
        if (e.target.getAttribute("tabindex") === "-1") close();
    };
    (0,react.useEffect)(function() {
        setMounted(true);
        return function() {
            return setMounted(false);
        };
    }, []);
    return mounted ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalStyled, {
            tabIndex: -1,
            "aria-hidden": !isActive,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: isActive ? 1 : 0
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.3
            },
            onClick: onClick,
            $xAlign: xAlign,
            $zIndex: zIndex,
            $isModalFilters: isModalFilters,
            $isActive: isActive,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                $size: size,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": titleAsSlug
            }, variants(isActive), dialogStyles && {
                $dialogStyles: dialogStyles
            }), {
                $xAlign: xAlign,
                $isActive: isActive,
                children: [
                    hasHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        children: [
                            onClickBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonHeader, {
                                className: "btn--back",
                                type: "button",
                                onClick: onClickBack,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                    media: backIcon,
                                    fill: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                id: titleAsSlug,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonHeader, {
                                type: "button",
                                "data-dismiss": "modal",
                                "aria-label": t("commons.actions.close"),
                                onClick: close,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                    media: closeIcon,
                                    fill: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal__body",
                        children: children
                    })
                ]
            }))
        })
    }), document.body) : null;
};
// VER DE SACAR el Aside como un overlay externo para minimizar el componente del Modal pero tiene que funcionar un self-justify para reemplazar al xAlign que tenemos ahora
var ModalStyled = (0,styled_components_browser_esm["default"])(motion/* motion.aside */.E.aside).withConfig({
    displayName: "Modal__ModalStyled",
    componentId: "sc-fb7acb51-0"
})(Modal_templateObject(), (0,styles.designGrid)({}), function(param) {
    var $isModalFilters = param.$isModalFilters;
    return $isModalFilters ? "100%" : " 100vh";
}, function(param) {
    var $isModalFilters = param.$isModalFilters;
    return $isModalFilters ? "100%" : " 100dvh";
}, function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign;
}, function(param) {
    var $zIndex = param.$zIndex, $isActive = param.$isActive;
    return !$isActive ? 0 : $isActive && $zIndex ? $zIndex : 600;
}, function(param) {
    var $isModalFilters = param.$isModalFilters;
    return $isModalFilters ? "100vh" : "unset";
}, function(param) {
    var $isModalFilters = param.$isModalFilters;
    return $isModalFilters ? "100dvh" : "unset";
}, styles.mq.greaterThan("tablet"), function(param) {
    var $isModalFilters = param.$isModalFilters;
    return $isModalFilters ? "100%" : " 100vh";
});
var ButtonHeader = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Modal__ButtonHeader",
    componentId: "sc-fb7acb51-1"
})(Modal_templateObject1(), (0,styles.vw)(48, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(48, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"));
var DialogStyled = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "Modal__DialogStyled",
    componentId: "sc-fb7acb51-2"
})(Modal_templateObject3(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.white);
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" ? "0px 0px 0px auto" : "110px auto ".concat((0,styles.vw)(200, "mobile"));
}, function(param) {
    var $size = param.$size;
    return $size === "full" ? "unset" : $size === "s" ? "550px" : "740px";
}, styles.grid.mobile.columns.gutter.width, function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" && "height: 100vh;";
}, function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" && "height: 100dvh;";
}, function(param) {
    var $isActive = param.$isActive;
    return !$isActive && (0,styled_components_browser_esm.css)(Modal_templateObject2());
}, styles.mq.greaterThan("tablet"), function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" ? "0 0 0 auto" : "50px auto ".concat((0,styles.vw)(200, "desktop"));
}, function(param) {
    var $size = param.$size;
    return $size === "s" ? (0,styles.vw)(550, "desktop") : "unset";
}, styles.grid.tablet.columns.gutter.width, styles.mq.greaterThan("desktop"), function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" ? "0 0 0 auto" : "50px auto 200px";
}, function(param) {
    var $size = param.$size;
    return $size === "s" ? "550px" : "unset";
}, styles.grid.tablet.columns.gutter.width, styles.mq.greaterThan("desktop-xs"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .1);
}, (0,styles.vw)(50, "mobile"), (0,styles.vw)(48, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(48, "desktop"), styles.mq.greaterThan("desktop"), styles.getP20, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(50, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(75, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(75, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(75, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "right" ? "0 0 0 auto" : "40px auto";
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(75, "mobile"), function(param) {
    var $dialogStyles = param.$dialogStyles;
    return $dialogStyles && $dialogStyles;
});

;// CONCATENATED MODULE: ./components/modals/ModalMenuAccount.tsx



function ModalMenuAccount_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  margin: 0;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100vw;\n\n  ",
        " {\n    max-width: ",
        ";\n    width: auto;\n  }\n\n  ",
        " {\n    max-width: 400px;\n  }\n"
    ]);
    ModalMenuAccount_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var dialogVariants = function(isActive) {
    return {
        initial: {
            x: "-100%"
        },
        animate: {
            x: isActive ? 0 : "-100%"
        },
        exit: {
            x: "-100%"
        },
        transition: {
            duration: .3
        }
    };
};
var ModalMenuAccount = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,router.useRouter)(), query = ref.query, pathname = ref.pathname, push = ref.push;
    var setCustomer = (0,hooks/* useCustomer */.ON)().setCustomer;
    var ref1 = (0,dist_hooks.useModal)(context.MODALS.MENU_ACCOUNT), isActive = ref1.isActive, toggle = ref1.toggle;
    var isMobile = (0,dist_hooks.useDeviceType)().isMobile;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var bulkUpdateCart = (0,useCart.useCart)().bulkUpdateCart;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var closeSession = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetch("/api/auth/logout", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.ok) {
                        console.log("Logout successful");
                    } else {
                        console.log("Logout failed");
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.error("❌ Logout failed:", e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    utils.cookie.removeCookie("BC_CUSTOMER_ID");
                    utils.cookie.removeCookie("DY_CUSTOMER_TOKEN");
                    setCustomer(null);
                    bulkUpdateCart([], null, 0, 0, null, null, false, 0, "fresh", null, []);
                    push("/?logout=true");
                    return [
                        2
                    ];
            }
        });
    }), [
        setCustomer,
        bulkUpdateCart,
        push
    ]);
    var ListItems = (0,react.useMemo)(function() {
        return getAccountListItems(t("layout.nav_account"), query, pathname, toggle, closeSession);
    }, [
        t,
        query,
        pathname,
        toggle,
        closeSession
    ]);
    (0,react.useEffect)(function() {
        if (!isMobile && isActive || !customer && isActive) toggle();
    }, [
        isMobile,
        isActive,
        toggle,
        customer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("layout.nav.account.name"),
        xAlign: "flex-end",
        variants: dialogVariants,
        dialogStyles: dialogStyles,
        hasHeader: true,
        zIndex: 10000000,
        children: ListItems
    });
});
var dialogStyles = (0,styled_components_browser_esm.css)(ModalMenuAccount_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(400, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalMobileMenu/modalMobileMenuVariants.ts



var modalMobileMenuVariants_dialogVariants = function(isActive) {
    return {
        initial: {
            x: "-100%"
        },
        animate: {
            x: isActive ? 0 : "-100%"
        },
        exit: {
            x: "-100%"
        },
        transition: {
            duration: .3
        }
    };
};
var transition = (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)());
var listVariants = {
    inactive: {
        opacity: 0,
        transition: transition
    },
    active: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            staggerChildren: .01
        })
    },
    exit: {
        opacity: 0,
        transition: transition
    }
};
var listItemVariants = {
    inactive: {
        x: -10,
        opacity: 0,
        transition: transition
    },
    active: {
        x: 0,
        opacity: 1,
        transition: transition
    },
    exit: {
        opacity: 0
    }
};
var detailUlvariants = {
    inactive: {
        height: 0,
        opacity: 0,
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
    },
    active: {
        height: "auto",
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            delay: .1,
            staggerChildren: .01
        })
    },
    exit: {
        height: "0px",
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            staggerDirection: -1
        })
    }
};
var detailvariants = {
    inactive: {
        height: "25px",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
    },
    active: {
        height: "auto",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.1))
    }
};

;// CONCATENATED MODULE: ./components/modals/ModalMobileMenu/ModalMenu.tsx





function ModalMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  color: ",
        ";\n  font-family: ",
        ";\n  display: flex;\n  flex-direction: column;\n\n  a {\n    text-decoration: none;\n  }\n\n  a,\n  button,\n  summary {\n    ",
        "\n    align-items: center;\n    color: inherit;\n    display: flex;\n    max-height: ",
        ";\n    justify-content: flex-start\n\n    ",
        " {\n      max-height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 60px;\n    }\n  }\n\n  div {\n    > dl,\n    > ol,\n    > ul {\n\n      button,\n      summary {\n        font-weight: 500;\n      }\n      a {\n        ",
        "\n        text-decoration: none;\n        font-family: ",
        ";\n        color: ",
        ";\n      }\n\n    }\n    li:first-child{\n      margin-top: ",
        ";\n    }\n\n    li:last-child {\n      margin-bottom:",
        ";\n    }\n\n  }\n  li:nth-child(4), li:nth-child(3), li:nth-child(5) {\n    margin-bottom:",
        ";\n\n  }\n"
    ]);
    ModalMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  margin-bottom: ",
        ";\n"
    ]);
    ModalMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &[open] {\n    height: auto;\n\n    summary {\n      figure {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  summary {\n    justify-content: space-between;\n\n    figure {\n      max-height: 28px;\n      max-width: 28px;\n      transition: 200ms transform ease-out;\n      transform-origin: center;\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 10px;\n      }\n    }\n  }\n"
    ]);
    ModalMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalMenu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  height: ",
        ";\n  justify-content: center;\n  max-width: 48px;\n  transform: translateX(-30%);\n  width: ",
        ";\n  z-index: 2;\n  margin-bottom:",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    margin-bottom:",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: 48px;\n    width: 48px;\n  }\n\n  figure {\n    max-height: 28px;\n    max-width: 28px;\n    width: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 10px;\n    }\n  }\n"
    ]);
    ModalMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalMenu_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    display: block;\n    margin: 0;\n    min-height: 100%;\n    width: 100%;\n\n    ",
        " {\n      display:none;\n    }\n\n    .modal__body {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: ",
        ";\n      overflow-y: hidden;\n      transition: padding 300ms ease;\n\n      .store_localization {\n        ",
        "\n        align-items: baseline;\n        color: ",
        ";\n        display:flex;\n        flex-direction: row;\n\n        figure {\n          width: ",
        ";\n          height: ",
        ";\n          margin-right:",
        ";\n\n          ",
        " {\n            width: ",
        ";\n            height: ",
        ";\n            margin-right:",
        ";\n          }\n        }\n      }\n\n      > ul,  > button:not(.button-back) {\n        padding-left: ",
        ";\n      }\n    }\n\n    @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {\n      width: 100%;\n      height: unset;\n      .modal__body {\n        height: unset;\n        overflow-y: unset;\n      }\n    }\n  "
    ]);
    ModalMenu_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}















var backIconLight = {
    type: "svg",
    src: "/images/svg/chevron--left--light.svg",
    alt: "Go back icon",
    size: {
        width: 12,
        height: 12
    }
};
var locationIcon = {
    type: "svg",
    src: "/images/svg/i--location--white.svg",
    alt: "Location icon",
    size: {
        width: 14,
        height: 18
    }
};
var iconChevronAccordion = {
    type: "svg",
    src: "/images/svg/chevron--select--light.svg",
    alt: "Go back icon",
    size: {
        width: 12,
        height: 8
    }
};
// COMMENT  DETAIL IS A DIV FOR NOW SINCE ITS NOT POSSIBLE TO ANIMATE CLOSING ATTRIBUTTE
var ModalMenu_LANG = utils.NEXT_PUBLIC_LOCALE.split("-")[0];
var TRANSLATIONS = {
    "es": "Ver todo",
    "en": "See all",
    "de": "Alles sehen",
    "fr": "Voir tout",
    "pt": "Ver tudo"
};
var getSubcategories = function(subcategories) {
    return subcategories.map(function(subcategory) {
        var subcategoryData = {
            name: subcategory.name,
            href: "/catalog/".concat(subcategory === null || subcategory === void 0 ? void 0 : subcategory.slug[ModalMenu_LANG]),
            type: "link"
        };
        return subcategoryData;
    });
};
var cleanData = function(categories) {
    return categories.map(function(category) {
        if (category.subcategories.length === 0) {
            var cat = {
                name: category.name,
                href: "/catalog/".concat(category === null || category === void 0 ? void 0 : category.slug[ModalMenu_LANG]),
                type: "link"
            };
            return cat;
        } else {
            var categorySubcategory = {
                name: category.name,
                href: "/catalog/".concat(category === null || category === void 0 ? void 0 : category.slug[ModalMenu_LANG]),
                type: "link",
                childrenAs: "accordion",
                children: getSubcategories(category.subcategories)
            };
            return categorySubcategory;
        }
    });
};
var DetailDropdown = function(param) {
    var item = param.item, setLevel = param.setLevel, level = param.level, idx = param.idx;
    var ref = (0,_sliced_to_array/* default */.Z)((0,components.useDropdown)(), 4), triggerRef = ref[0], dropdownRef = ref[1], expanded = ref[2], toggleExpanded = ref[3];
    var onClick = function(e) {
        e.preventDefault();
        toggleExpanded();
    };
    var parsedChildrenIncludingAll = [
        {
            name: TRANSLATIONS[ModalMenu_LANG],
            href: "".concat(item.href),
            type: "link"
        }
    ].concat((0,_to_consumable_array/* default */.Z)(item.children));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, open && {
        open: open
    }), {
        animate: expanded ? "active" : "inactive",
        variants: detailvariants,
        idx: idx,
        ref: triggerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("summary", {
                onClick: function(e) {
                    onClick(e);
                },
                children: [
                    item.name,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                        media: iconChevronAccordion,
                        fill: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                mode: "wait",
                children: expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.ul */.E.ul, {
                    ref: dropdownRef,
                    initial: "inactive",
                    animate: expanded ? "active" : "exit",
                    exit: "exit",
                    variants: detailUlvariants,
                    children: getMenuItems(parsedChildrenIncludingAll, level, setLevel, true)
                })
            })
        ]
    }));
};
var itemByType = {
    "link": function(item, setLevel, idx, level) {
        if (!item.children) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
            href: item.href,
            children: item.name
        });
        if (item.childrenAs === "sublevel") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                        href: item.href,
                        children: item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            setLevel(function(prevLevel) {
                                return (0,_to_consumable_array/* default */.Z)(prevLevel).concat([
                                    idx
                                ]);
                            });
                        },
                        children: "CHEVRON"
                    })
                ]
            });
        } else if (item.childrenAs === "accordion") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailDropdown, {
                item: item,
                setLevel: setLevel,
                level: level,
                idx: idx
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
            href: item.href,
            children: item.name
        });
    },
    "button-level": function(item, setLevel, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function() {
                setLevel(function(prevLevel) {
                    return (0,_to_consumable_array/* default */.Z)(prevLevel).concat([
                        idx
                    ]);
                });
            },
            children: item.name
        });
    },
    "modal-trigger": function(item) {
        return "Modal trigger TODO ".concat(item);
    },
    "link-external": function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: item.href,
            rel: "noreferrer",
            target: "_blank",
            children: item.name
        });
    }
};
var getMenuItems = function(data, level, setLevel) {
    var accordionList = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var list = data;
    var reachLevel = 0;
    if (!accordionList) {
        while(reachLevel < level.length){
            var ref;
            list = (ref = list[level[reachLevel]]) === null || ref === void 0 ? void 0 : ref.children;
            reachLevel++;
        }
    }
    return list.map(function(item, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalMenu_Li, {
            variants: listItemVariants,
            children: itemByType[item.type](item, setLevel, idx, level)
        }, "".concat(level === null || level === void 0 ? void 0 : level.length, "-").concat(item.type, "-").concat(idx));
    });
};
var getMenuNavList = function(customer, t, categories) {
    if (customer) {
        return [
            {
                name: t("layout.nav.home.name"),
                href: t("layout.nav.home.pathname"),
                type: "link"
            },
            {
                name: t("layout.nav.shop.name"),
                href: t("layout.nav.shop.pathname"),
                type: "button-level",
                childrenAs: "sublevel",
                children: cleanData(categories)
            },
            {
                name: t("layout.nav.my_usuals.name"),
                href: t("layout.nav.my_usuals.pathname"),
                type: "link"
            }, 
        ];
    } else {
        return [
            {
                name: t("layout.nav.home.name"),
                href: t("layout.nav.home.pathname"),
                type: "link"
            },
            {
                name: t("layout.nav.products.name"),
                href: t("layout.nav.products.pathname"),
                type: "button-level",
                childrenAs: "sublevel",
                children: cleanData(categories)
            },
            {
                name: t("layout.nav.catalogue.name"),
                href: t("layout.nav.catalogue.pathname"),
                type: "link"
            },
            {
                name: t("layout.nav.about_us.name"),
                href: t("layout.nav.about_us.pathname"),
                type: "link"
            },
            {
                name: t("layout.nav.events.name"),
                href: t("layout.nav.events.pathname"),
                type: "link"
            },
            {
                name: t("layout.nav.contact_us.name"),
                href: t("layout.nav.contact_us.pathname"),
                type: "link"
            }
        ];
    }
};
var prevUrl = null;
var ModalMenu = /*#__PURE__*/ (0,react.memo)(function(param) {
    var hasBanners = param.hasBanners, data = param.data;
    var categories = data.categories;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,dist_hooks.useModal)(context.MODALS.MENU), isActive = ref.isActive, toggle = ref.toggle;
    var ref1 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleModalRegion = ref1.toggle;
    var ref2 = (0,react.useState)([]), level = ref2[0], setLevel = ref2[1];
    var ref3 = (0,react.useState)(""), storeLocation = ref3[0], setStoreLocation = ref3[1];
    var ref4 = (0,react.useState)([]), country = ref4[0], setCountry = ref4[1];
    var ref5 = (0,react.useState)([]), subdivisions = ref5[0], setSubdivisions = ref5[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var ref6 = (0,router.useRouter)(), locale = ref6.locale, asPath = ref6.asPath;
    var scrollPos = (0,dist_hooks.useScrollTracker)(1);
    var scrollTop = (0,react.useMemo)(function() {
        return scrollPos === "TOP";
    }, [
        scrollPos
    ]);
    var animate = (0,react.useMemo)(function() {
        return hasBanners && scrollTop ? true : false;
    }, [
        hasBanners,
        scrollTop
    ]);
    var fakeList = (0,react.useMemo)(function() {
        return getMenuNavList(customer, t, categories);
    }, [
        customer,
        t,
        categories
    ]);
    var Items = (0,react.useMemo)(function() {
        return getMenuItems(fakeList, level, setLevel);
    }, [
        fakeList,
        level,
        setLevel
    ]);
    var goOneLevelBack = (0,react.useCallback)(function() {
        setLevel(function(prevLevel) {
            var incomingLevel = (0,_to_consumable_array/* default */.Z)(prevLevel);
            incomingLevel.pop();
            return incomingLevel;
        });
    }, [
        setLevel
    ]);
    (0,react.useEffect)(function() {
        if (!prevUrl) prevUrl = asPath;
        else if (prevUrl !== asPath && isActive) {
            prevUrl = asPath;
            toggle();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        asPath
    ]);
    (0,react.useEffect)(function() {
        if ((country === null || country === void 0 ? void 0 : country.length) === 0) {
            getCountries().then(function(res) {
                setCountry(Array.from(res));
            });
        }
    }, [
        country
    ]);
    (0,react.useEffect)(function() {
        getSubdivisions("ES").then(function(res) {
            setSubdivisions(Array.from(res));
        });
    }, [
        country
    ]);
    (0,react.useEffect)(function() {
        if (locale.includes("es")) {
            var region = subdivisions.find(function(el) {
                return el.value === locale.toUpperCase();
            });
            var ref;
            setStoreLocation((ref = region === null || region === void 0 ? void 0 : region.name) !== null && ref !== void 0 ? ref : "Espa\xf1a");
        } else {
            var region1 = (0,utils.getRegion)(locale);
            var countryLocalization = country.find(function(el) {
                return el.value === region1;
            });
            setStoreLocation(countryLocalization === null || countryLocalization === void 0 ? void 0 : countryLocalization.name);
        }
    }, [
        locale,
        country,
        subdivisions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: "Menu",
        xAlign: "flex-start",
        variants: modalMobileMenuVariants_dialogVariants,
        dialogStyles: ModalMenu_dialogStyles(animate),
        hasHeader: false,
        zIndex: 150,
        isModalFilters: level.length === 0 ? true : false,
        children: [
            level.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuBack, {
                onClick: goOneLevelBack,
                className: "button-back",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: backIconLight,
                    fill: false
                })
            }, "menu-back-button"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ul, {
                $levelDepth: level === null || level === void 0 ? void 0 : level.length,
                initial: "inactive",
                animate: "active",
                exit: "exit",
                variants: listVariants,
                children: Items
            }, "list-menu-".concat(level === null || level === void 0 ? void 0 : level.length)),
            level.length === 0 && customer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: toggleModalRegion,
                title: "Region",
                className: "store_localization",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                        media: locationIcon,
                        fill: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: storeLocation
                    })
                ]
            })
        ]
    });
});
var Ul = (0,styled_components_browser_esm["default"])(motion/* motion.ul */.E.ul).withConfig({
    displayName: "ModalMenu__Ul",
    componentId: "sc-49b1cfd0-0"
})(ModalMenu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, function(param) {
    var $levelDepth = param.$levelDepth;
    return $levelDepth === 0 ? styles.getP113 : styles.getP27_P18;
}, (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_1)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(16, "mobile"), (0,styles.vw)(40, "mobile"));
var ModalMenu_Li = (0,styled_components_browser_esm["default"])(motion/* motion.li */.E.li).withConfig({
    displayName: "ModalMenu__Li",
    componentId: "sc-49b1cfd0-1"
})(ModalMenu_templateObject1(), (0,styles.vw)(26, "mobile"));
var Details = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "ModalMenu__Details",
    componentId: "sc-49b1cfd0-2"
})(ModalMenu_templateObject2(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"));
var ButtonMenuBack = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ModalMenu__ButtonMenuBack",
    componentId: "sc-49b1cfd0-3"
})(ModalMenu_templateObject3(), (0,styles.vw)(48, "mobile"), (0,styles.vw)(48, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(48, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(48, "desktop"), (0,styles.vw)(48, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));
var ModalMenu_dialogStyles = function(animate) {
    return (0,styled_components_browser_esm.css)(ModalMenu_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.red;
    }, styles.mq.greaterThan("tablet"), animate ? "".concat((0,styles.vw)(120, "mobile"), " ").concat((0,styles.vw)(40, "mobile"), " ").concat((0,styles.vw)(40, "mobile"), " ").concat((0,styles.vw)(10, "mobile")) : "".concat((0,styles.vw)(80, "mobile"), " ").concat((0,styles.vw)(40, "mobile"), " ").concat((0,styles.vw)(40, "mobile"), " ").concat((0,styles.vw)(10, "mobile")), (0,styles.getP26)(), function(param) {
        var theme = param.theme;
        return theme.colors.white;
    }, (0,styles.vw)(14, "mobile"), (0,styles.vw)(18, "mobile"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(14, "nexus7"), (0,styles.vw)(18, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(10, "mobile"));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
;// CONCATENATED MODULE: ./components/modals/ModalSearch.tsx







function ModalSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    height: 100vh;\n    height: 100dvh;\n    margin: ",
        ";\n    width: 100vw;\n    transition: margin 200ms ease;\n    z-index: ",
        ";\n\n\n    ",
        " {\n      margin: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      max-height: 95vh;\n      margin: ",
        ";\n      width: 100vw;\n    }\n\n    ",
        " {\n      height: 625px;\n      margin: ",
        ";\n    }\n\n    header {\n      border-bottom: 0;\n      position: absolute;\n      right: 0;\n\n      h2 {\n        display: none;\n      }\n\n      button {\n        &[data-dismiss='modal'] {\n          height: ",
        ";\n          width: ",
        ";\n          max-width: unset;\n\n          ",
        " {\n            height: ",
        ";\n            width: ",
        ";\n          }\n\n          ",
        " {\n            height: ",
        ";\n            padding-top: ",
        ";\n            width: ",
        ";\n          }\n\n          ",
        " {\n            height: 62px;\n            padding-top: 40px;\n            width: 62px;\n          }\n\n          figure {\n            width: ",
        ";\n\n            ",
        " {\n              width: ",
        ";\n            }\n\n            ",
        " {\n              width: ",
        ";\n            }\n\n            ",
        " {\n              width: 18px;\n            }\n          }\n        }\n      }\n    }\n\n    > .modal__body {\n      ",
        "\n      grid-template-rows: auto 1fr;\n      height: 100%;\n      padding: 0;\n      width: 100%;\n    }\n\n    form {\n      grid-column: 1 / span 6;\n      /* margin-top: ",
        "; */\n\n      ",
        " {\n        grid-column: 2 / span 10;\n        margin-top: ",
        ";\n        position: relative;\n      }\n\n      ",
        " {\n        margin-top: 20px;\n      }\n\n      input[type='search'] {\n        padding-bottom: ",
        ";\n        padding-top: ",
        ";\n\n        ",
        " {\n          padding-bottom: ",
        ";\n          padding-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-right: auto;\n          width: 80vw;\n        }\n\n        ",
        " {\n          padding-bottom: ",
        ";\n          padding-top: ",
        ";\n        }\n\n\n        ",
        " {\n          padding-bottom: 30px;\n          padding-top: 15px;\n        }\n      }\n\n      button {\n        align-items: center;\n        display: flex;\n        height: ",
        ";\n        justify-content: center;\n        opacity: 0;\n        position: absolute;\n        pointer-events: none;\n        right: ",
        ";\n        top: 0;\n        transition: 300ms opacity ease-out;\n        user-select: none;\n        width: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: ",
        ";\n          right: ",
        ";\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: 50px;\n          width: 50px;\n        }\n\n        &:hover {\n          figure {\n            opacity: .8;\n          }\n        }\n\n        figure {\n          opacity: .2;\n          transition: 300ms opacity ease-out;\n          width: ",
        ";\n\n          ",
        " {\n            width: ",
        ";\n          }\n\n          ",
        " {\n            width: ",
        ";\n          }\n\n          ",
        " {\n            width: 26px;\n          }\n        }\n      }\n\n      a {\n        opacity: 0;\n        display: none;\n        pointer-events: none;\n        transition: 300ms opacity ease-out;\n        user-select: none;\n\n        ",
        " {\n          align-items: center;\n          display: flex;\n          justify-content: center;\n          position: absolute;\n          right: 0;\n        }\n\n        figure {\n          ",
        " {\n            transition: 300ms transform ease-out;\n            width: ",
        ";\n          }\n\n          ",
        " {\n            width: 50px;\n          }\n        }\n\n        &:hover {\n          figure {\n            transform: scale(1.1);\n          }\n        }\n      }\n\n      &.dirty {\n        button,\n        a {\n          opacity: 1;\n          pointer-events: auto;\n          user-select: auto;\n        }\n      }\n    }\n\n    label {\n      padding: 0;\n      margin-bottom: 0;\n    }\n  "
    ]);
    ModalSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var emptySearchResult = {
    search: [],
    articles: [],
    brands: [],
    categories: [],
    variants: []
};
var searchClearIcon = {
    type: "svg",
    src: "/images/svg/i--search-clear.svg",
    alt: "Clear search icon",
    size: {
        width: 12,
        height: 12
    }
};
var searchGoPageIcon = {
    type: "svg",
    src: "/images/svg/i--search-go-page.svg",
    alt: "Search go page icon",
    size: {
        width: 12,
        height: 12
    }
};
var ModalSearch_dialogStyles = function(animate) {
    return (0,styled_components_browser_esm.css)(ModalSearch_templateObject(), function(param) {
        var theme = param.theme;
        return theme.colors.white;
    }, animate ? "".concat((0,styles.vw)(40, "mobile"), " 0 0") : "0 0 0", animate ? 660 : 0, styles.mq.greaterThan("nexus7"), animate ? "".concat((0,styles.vw)(40, "nexus7"), " 0 0") : "0 0 0", styles.mq.greaterThan("tablet"), (0,styles.vw)(625, "desktop"), animate ? "".concat((0,styles.vw)(30, "desktop"), " 0 200px") : "0 0 200px", styles.mq.greaterThan("desktop"), animate ? "30px 0 200px" : "0 0 200px", (0,styles.vw)(62, "mobile"), (0,styles.vw)(62, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(62, "nexus7"), (0,styles.vw)(62, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(62, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(62, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(18, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(18, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.designGrid)({}), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(16, "mobile"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(16, "nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.lessThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(50, "mobile"), (0,styles.vw)(styles.grid.mobile.columns.gutter.width + styles.grid.mobile.columns.gutter.width * .5 + styles.grid.mobile.columns.width, "mobile"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(styles.grid.desktop.columns.width, "desktop"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(26, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(26, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(26, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"));
};
var ModalSearch_dialogVariants = function(isActive) {
    return {
        initial: {
            y: "-100%",
            zIndex: 0
        },
        animate: {
            y: isActive ? 0 : "-100%",
            zIndex: isActive ? 660 : 0
        },
        exit: {
            y: "-100%",
            zIndex: 0
        },
        transition: {
            duration: .3
        }
    };
};
var ModalSearch = function(param) {
    var hasBanners = param.hasBanners, categories = param.categories;
    var ref = (0,dist_hooks.useModal)(context.MODALS.SEARCH), isActive = ref.isActive, toggle = ref.toggle;
    var ref1 = (0,index_esm/* useForm */.cI)(), register = ref1.register, handleSubmit = ref1.handleSubmit, reset = ref1.reset;
    var ref2 = (0,react.useState)(""), qValue = ref2[0], setQValue = ref2[1];
    var ref3 = (0,react.useState)(emptySearchResult), results = ref3[0], setResults = ref3[1];
    var scrollPos = (0,dist_hooks.useScrollTracker)(1);
    var scrollTop = (0,react.useMemo)(function() {
        return scrollPos === "TOP";
    }, [
        scrollPos
    ]);
    var animate = (0,react.useMemo)(function() {
        return hasBanners && scrollTop ? true : false;
    }, [
        hasBanners,
        scrollTop
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(api/* GET_SEARCH_PRODUCTS */.jc), 2), getDataForSearch = ref4[0], ref5 = ref4[1], ref5 = ref5 !== null ? ref5 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref6 = (0,router.useRouter)(), push = ref6.push, pathname = ref6.pathname;
    var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData) {
            var ref, ref1, searchValue, DYCustomerToken, data, arrayOfVariantNodes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        searchValue = formData.search;
                        if ((searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) < 2) return [
                            2,
                            {}
                        ];
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        return [
                            4,
                            getDataForSearch({
                                variables: {
                                    search: searchValue
                                },
                                context: DYCustomerToken ? {
                                    isPrivatePath: true,
                                    DYCustomerToken: DYCustomerToken
                                } : {
                                    isPrivatePath: false
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (!data) return [
                            2,
                            {}
                        ];
                        arrayOfVariantNodes = Array.isArray(data === null || data === void 0 ? void 0 : (ref = data.productSearch) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : ref1.edges) ? data.productSearch.variants.edges.map(function(item) {
                            return item.node;
                        }) : [];
                        setResults((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.productSearch), {
                            variants: arrayOfVariantNodes
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var onKeyUp = (0,react.useCallback)(function(e) {
        if (e.code === "Enter" || e.key === "Enter" || e.keyCode === 13) {
            var href = "".concat(DYCustomerToken ? "/shop" : "/catalog", "/search?q=").concat(e.target.value);
            if (pathname === "".concat(DYCustomerToken ? "/shop" : "/catalog", "/search")) {
                push(href, undefined, {
                    shallow: true
                });
            } else {
                push(href);
            }
            reset({
                search: ""
            });
            toggle();
        }
    }, [
        DYCustomerToken,
        pathname,
        push,
        reset,
        toggle
    ]);
    var onChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var target, ref, ref1, searchValue, DYCustomerToken, data, arrayOfVariantNodes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        target = param.target;
                        searchValue = target === null || target === void 0 ? void 0 : target.value;
                        if (typeof searchValue !== "string") return [
                            2
                        ];
                        if ((searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) < 3) return [
                            2,
                            {}
                        ];
                        setQValue(searchValue);
                        (0,utils.pushAnalyticsEvent)("search", searchValue);
                        DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
                        return [
                            4,
                            getDataForSearch({
                                variables: {
                                    search: searchValue
                                },
                                context: DYCustomerToken ? {
                                    isPrivatePath: true,
                                    DYCustomerToken: DYCustomerToken
                                } : {
                                    isPrivatePath: false
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (!data) return [
                            2,
                            {}
                        ];
                        arrayOfVariantNodes = Array.isArray(data === null || data === void 0 ? void 0 : (ref = data.productSearch) === null || ref === void 0 ? void 0 : (ref1 = ref.variants) === null || ref1 === void 0 ? void 0 : ref1.edges) ? data.productSearch.variants.edges.map(function(item) {
                            return item.node;
                        }) : [];
                        setResults((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.productSearch), {
                            variants: arrayOfVariantNodes
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickClearSearch = function() {
        console.info("Clearing");
        setQValue("");
        reset({
            search: ""
        }, {
            keepErrors: false,
            keepDirty: true
        });
    };
    var onClickResultClearAndClose = function() {
        toggle();
        onClickClearSearch();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: "Menu",
        xAlign: "flex-start",
        variants: ModalSearch_dialogVariants,
        dialogStyles: ModalSearch_dialogStyles(animate),
        size: "full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Form, {
                onSubmit: handleSubmit(onSubmit),
                className: "".concat((qValue === null || qValue === void 0 ? void 0 : qValue.length) > 2 ? "dirty" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Input, {
                        type: "search",
                        name: "search",
                        label: "",
                        col: 12,
                        register: register,
                        onChange: onChange,
                        bgColor: "white",
                        autoFocus: isActive,
                        onKeyUp: onKeyUp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: onClickClearSearch,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: searchClearIcon,
                            fill: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(DYCustomerToken ? "/shop" : "/catalog", "/search?q=").concat(qValue),
                        onClick: toggle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: searchGoPageIcon,
                            fill: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                        data: (0,_object_spread/* default */.Z)({
                            search: [
                                {
                                    name: "".concat(qValue),
                                    href: "".concat(DYCustomerToken ? "/shop" : "/catalog", "/search?q=").concat(qValue)
                                }
                            ]
                        }, results),
                        close: onClickResultClearAndClose
                    }, "results-list"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchByCategory, {
                        data: categories,
                        close: onClickResultClearAndClose
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/modals/ModalAuth.tsx
"use client";



function ModalAuth_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > .modal__body {\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 30px;\n    }\n  }\n"
    ]);
    ModalAuth_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var buttonBack = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils.DY_SIGNUP_ALLOWED && {
    "signup_cif": "start",
    "signup": "signup_cif",
    "signup_active_cif": "signup_cif"
}, utils.DY_LOGIN_ALLOWED && {
    "prelogin": "start",
    "login": "prelogin",
    "login_existing_cif": "prelogin",
    "feedback_cif_not_found": "prelogin",
    "login_check_cif": "prelogin"
}), {
    "forgot_password": "login",
    "reset_password": "login",
    "activation": "login"
});
var ModalAuth = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.AUTH), isActive = ref.isActive, payload = ref.payload, updatePayload = ref.updatePayload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var onClickBack = (0,react.useCallback)(function() {
        var ref;
        updatePayload({
            payload: {
                level: buttonBack[(ref = payload === null || payload === void 0 ? void 0 : payload.level) !== null && ref !== void 0 ? ref : defaultAuthModalLevel]
            }
        });
    }, [
        updatePayload,
        payload
    ]);
    var onClose = (0,react.useCallback)(function() {
        updatePayload({
            payload: {
                level: defaultAuthModalLevel
            },
            close: true
        });
    }, [
        updatePayload
    ]);
    (0,react.useEffect)(function() {
        if (!payload) updatePayload({
            payload: {
                level: defaultAuthModalLevel
            }
        });
    }, [
        payload,
        updatePayload
    ]);
    var ref1;
    return isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: onClose,
        title: t("modals.auth.".concat((ref1 = payload === null || payload === void 0 ? void 0 : payload.level) !== null && ref1 !== void 0 ? ref1 : defaultAuthModalLevel, ".title")),
        xAlign: "flex-start",
        onClickBack: buttonBack[payload === null || payload === void 0 ? void 0 : payload.level] ? onClickBack : null,
        size: "s",
        dialogStyles: ModalAuth_dialogStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionUserAuth, {
            payload: payload,
            updatePayload: updatePayload
        })
    });
});
var ModalAuth_dialogStyles = (0,styled_components_browser_esm.css)(ModalAuth_templateObject(), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalRegion.tsx

function ModalRegion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .modal__body {\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 30px 27.5px 25px;\n    }\n\n    span {\n      margin-bottom: 5px;\n    }\n  }\n\n  button[data-dismiss='modal'] {\n    display: none;\n  }\n\n"
    ]);
    ModalRegion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ModalRegion = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), isActive = ref.isActive, toggle = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.region_lang.title"),
        xAlign: "flex-end",
        size: "s",
        dialogStyles: ModalRegion_dialogStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormStore, {
            bgInputColor: "white",
            textColorInput: "darkred",
            textColorSubdividions: "darkred",
            isModal: true,
            toggle: toggle
        })
    });
});
var ModalRegion_dialogStyles = (0,styled_components_browser_esm.css)(ModalRegion_templateObject(), (0,styles.vw)(30, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalRegionRegister.tsx

function ModalRegionRegister_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  column-gap: ",
        ";\n  display: grid;\n  grid-template-columns: calc(50% - ",
        ") calc(50% - ",
        ");\n  margin-top: ",
        " ;\n  pointer-events: none;\n  width: 100%;\n\n  ",
        " {\n    column-gap: ",
        ";\n    grid-template-columns: calc(50% - ",
        ") calc(50% - ",
        ");\n    margin-top: ",
        " ;\n  }\n\n  ",
        " {\n    column-gap: ",
        ";\n    grid-template-columns: calc(50% - ",
        ") calc(50% - ",
        ");\n    margin-top: ",
        " ;\n  }\n\n  ",
        " {\n    column-gap: 20px;\n    grid-template-columns: calc(50% - 10px) calc(50% - 10px);\n    margin-top: 40px;\n  }\n\n  button {\n    height: ",
        ";\n    pointer-events: ",
        ";\n    white-space: nowrap;\n    width: 100%;\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 60px;\n    }\n  }\n\n  .button__bg {\n    border: none;\n  }\n"
    ]);
    ModalRegionRegister_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ModalRegionRegister = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.ADD_TO_CART), isActive = ref.isActive, toggle = ref.toggle;
    var ref1 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), openRegion = ref1.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var switchModals = function() {
        toggle();
        setTimeout(function() {
            openRegion();
        }, 200);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.region_register.title"),
        xAlign: "flex-end",
        size: "s",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: t("modals.region_register.description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                isActive: isActive,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                        onClick: switchModals,
                        bgType: "red",
                        outline: true,
                        children: t("modals.region_register.action_change")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                        onClick: toggle,
                        bgType: "red",
                        children: t("modals.region_register.action_stay")
                    })
                ]
            })
        ]
    });
});
var Actions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ModalRegionRegister__Actions",
    componentId: "sc-4d883e89-0"
})(ModalRegionRegister_templateObject(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(60, "mobile"), function(param) {
    var isActive = param.isActive;
    return isActive ? "auto" : "none";
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalComercialRegion.tsx

function ModalComercialRegion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  span {\n    ",
        "\n    color: ",
        ";\n    text-align: left;\n    margin-bottom: 2px;\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n  }\n\n  .actions {\n    margin-top:",
        ";\n\n    ",
        " {\n      margin-top:",
        ";\n    }\n\n    ",
        " {\n      margin-top:",
        ";\n    }\n\n    ",
        " {\n      margin-top: 50px;\n    }\n  }\n\n  p {\n    ",
        "\n    color: ",
        ";\n    margin-bottom:",
        ";\n\n    ",
        " {\n      margin-bottom:",
        ";\n    }\n\n    ",
        " {\n      margin-bottom:",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 20px;\n    }\n  }\n\n  ul {\n    margin-top: 6px;\n  }\n\n  span,\n  p {\n    a {\n      color: ",
        ";\n      ",
        "\n    }\n  }\n\n  .modal__body {\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 50px 27.5px 20px;\n    }\n  }\n"
    ]);
    ModalComercialRegion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var catalogRegionName = {
    "ES-IB": "Ibiza-Formentera",
    "ES-PM": "Palma de Mallorca",
    "ES-ME": "Menorca",
    "ES-NC": "Navarra",
    "ES-PC": "Ibiza-Formentera",
    "ES-AN": "Andaluc\xeda",
    "ES-VC": "Pa\xeds Vasco",
    "ES-CT": "Catalu\xf1a",
    "ES-CN": "Canarias",
    "ES-MD": "Madrid",
    "ES-ES": "Espa\xf1a",
    "FR-FR": "France",
    "EN-GB": "United Kingdom",
    "DE-DE": "Deutschland",
    "PT-PT": "Portugal"
};
var regionWithComercials = [
    "ES-IB",
    "ES-PM",
    "ES-ME",
    "ES-NC",
    "ES-PC",
    "ES-AN",
    "ES-VC"
];
var ModalComercialRegion = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.COMERCIAL), isActive = ref.isActive, toggle = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref1 = (0,react.useState)("Espa\xf1a"), catalogRegion = ref1[0], setCatalogRegion = ref1[1];
    var ref2 = (0,react.useState)([]), commercials = ref2[0], setCommercials = ref2[1];
    var ComercialsList = (0,react.useMemo)(function() {
        return getCommercials(commercials.length > 0 ? commercials : defaultCommercial, "white", true, t);
    }, [
        commercials,
        t
    ]);
    var shouldDisplay = (0,react.useMemo)(function() {
        return regionWithComercials.indexOf(catalogRegion) === 0 ? true : false;
    }, [
        catalogRegion
    ]);
    var shouldDisplayCatalogRegionName = utils.NEXT_PUBLIC_LOCALE !== "en-GB" && utils.NEXT_PUBLIC_LOCALE !== "fr-FR" && utils.NEXT_PUBLIC_LOCALE !== "de-DE" && utils.NEXT_PUBLIC_LOCALE !== "pt-PT";
    (0,react.useEffect)(function() {
        if (isActive) {
            var cookieCatalogRegion = utils.cookie.get("DY_CATALOG_REGION");
            if (cookieCatalogRegion) {
                setCatalogRegion(cookieCatalogRegion);
            }
            getCommercialsByCountry("ES").then(function(res) {
                var arrOfCommercials = Array.from(res);
                if (cookieCatalogRegion) {
                    // @ts-ignore
                    var commercialsFiltered = arrOfCommercials.filter(function(item) {
                        return item.operate_in.find(function(area) {
                            return area === cookieCatalogRegion;
                        });
                    });
                    setCommercials(commercialsFiltered);
                }
            });
        }
    }, [
        isActive,
        catalogRegion
    ]);
    var _catalogRegion;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.commercial.title"),
        xAlign: "flex-end",
        dialogStyles: ModalComercialRegion_dialogStyles,
        size: "s",
        children: [
            "ES-CT",
            "ES-MD",
            "ES-CN"
        ].includes(catalogRegion) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("modals.comercial_region.professional"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: t("modals.comercial_region.mail_to_link"),
                                children: t("modals.comercial_region.mail_to")
                            }),
                            " ",
                            t("modals.comercial_region.open_account")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("modals.comercial_region.b2c"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                href: t("modals.comercial_region.link_to_b2c"),
                                children: t("modals.comercial_region.link_b2c")
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                shouldDisplayCatalogRegionName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,utils.getDynamicText)(t("modals.commercial.in"), {
                        storeName: (_catalogRegion = catalogRegionName[catalogRegion]) !== null && _catalogRegion !== void 0 ? _catalogRegion : "Espa\xf1a"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: ComercialsList
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "actions",
                    children: shouldDisplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            t("modals.public_interested.contact"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:".concat(t("modals.public_interested.mail")),
                                children: t("modals.public_interested.mail")
                            })
                        ]
                    })
                })
            ]
        })
    });
});
var ModalComercialRegion_dialogStyles = (0,styled_components_browser_esm.css)(ModalComercialRegion_templateObject(), (0,styles.getP20_4)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.createUnderline)({
    color: "red",
    height: 1,
    reverse: true
}), (0,styles.vw)(50, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalFilters.tsx
"use client";

function ModalFilters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 100%;\n  min-height: 100%;\n\n  .modal__body {\n    height: calc(100% - ",
        ");\n    overflow: hidden scroll;\n    max-height: none;\n    padding-bottom: 0;\n\n    ",
        " {\n      height: calc(100% - ",
        ");\n    }\n\n    ",
        " {\n      height: calc(100% - ",
        ");\n    }\n\n    ",
        " {\n      height: calc(100% - 50px);\n    }\n  }\n\n  main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 10px;\n    }\n  }\n\n  section {\n    display: flex;\n    height: 100%;\n    justify-content: flex-start;\n    max-height: 100%;\n    overflow-x: clip;\n  }\n\n  ul {\n    height: auto;\n    overflow: auto;\n    width: 100%;\n    ",
        "\n\n    li {\n      margin-bottom: ",
        ";\n      width: 100%;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 40px;\n      }\n\n      > button,\n      [id*='btn-controls'] button {\n        padding: 0 ",
        ";\n\n        ",
        " {\n          padding: 0 ",
        ";\n        }\n\n        ",
        " {\n          padding: 0 ",
        ";\n        }\n\n        ",
        " {\n          padding: 0 10px;\n        }\n      }\n\n    }\n  }\n"
    ]);
    ModalFilters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalFilters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(0deg, ",
        " 60%, ",
        " 100%);\n  bottom: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  left: 0;\n  padding: ",
        " 0 0;\n  pointer-events: none;\n  position: sticky;\n  width: 100%;\n  max-height: 100%;\n\n  ",
        " {\n    bottom: ",
        ";\n    padding: ",
        " 0 0;\n  }\n\n  ",
        " {\n    bottom: ",
        ";\n    max-height: 100%;\n    padding: ",
        " 0 0;\n  }\n\n  button {\n    height: ",
        ";\n    pointer-events: ",
        ";\n    white-space: nowrap;\n    width: 100%;\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 60px;\n    }\n\n    > div:last-of-type {\n      ",
        "\n    }\n\n    &:first-child {\n      margin-right: ",
        ";\n\n      ",
        " {\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 20px;\n      }\n    }\n\n    &:nth-child(2) {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    ModalFilters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var ModalFilters = /*#__PURE__*/ (0,react.memo)(function(param) {
    var filters = param.filters, clearFilters = param.clearFilters, activeFiltersLength = param.activeFiltersLength, resultsLength = param.resultsLength;
    var ref = (0,dist_hooks.useModal)(context.MODALS.FILTER), isActive = ref.isActive, toggle = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.filter.title"),
        xAlign: "right",
        size: "s",
        dialogStyles: ModalFilters_dialogStyles,
        zIndex: 100000,
        isModalFilters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.ul */.E.ul, {
                        initial: "inactive",
                        children: filters
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFilters_Actions, {
                    isActive: isActive,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.Button, {
                            onClick: toggle,
                            bgType: "red",
                            children: [
                                t("commons.actions.show"),
                                activeFiltersLength > 0 && " (".concat(resultsLength, ")")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                            onClick: clearFilters,
                            bgType: "red",
                            outline: true,
                            children: t("commons.actions.delete_all")
                        })
                    ]
                })
            ]
        })
    });
});
var ModalFilters_dialogStyles = (0,styled_components_browser_esm.css)(ModalFilters_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.lightred;
}, (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.hideScrollbar)(), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"));
var ModalFilters_Actions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ModalFilters__Actions",
    componentId: "sc-f62dd05c-0"
})(ModalFilters_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.lightred, .85);
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.lightred, 0);
}, (0,styles.vw)(10, "mobile"), (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(80, "desktop"), (0,styles.vw)(60, "mobile"), function(param) {
    var isActive = param.isActive;
    return isActive ? "auto" : "none";
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_3B)(), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/contents/content-types/ContentVideo.tsx

function ContentVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  position: relative;\n  width: 100%;\n\n  ",
        " {\n    height: 600px;\n  }\n\n  img {\n    width: 100%;\n  }\n\n  figcaption {\n    ",
        "\n    border-bottom: ",
        ";\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 20px;\n    }\n  }\n\n  > div {\n    height:  ",
        " !important;\n    pointer-events: ",
        ";\n    width: 100% !important;\n\n    ",
        " {\n      height:  ",
        " !important;\n    }\n\n    ",
        " {\n      height:  ",
        " !important;\n      max-height: 100vh;\n    }\n\n    ",
        " {\n      height:  ",
        " !important;\n      max-height: 100vh;\n    }\n  }\n\n  iframe {\n    aspect-ratio: 16 / 9;\n    height: auto !important;\n    width: 100% !important;\n\n    @media (max-aspect-ratio: 16/9) {\n      height: 100% !important;\n    }\n\n    ",
        " {\n      height: 100% !important;\n      width: 100% !important;\n    }\n  }\n\n"
    ]);
    ContentVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-radius: 100%;\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: height 300ms ",
        ", width 300ms ",
        ";\n  width: ",
        ";\n  z-index: 2;\n\n  ",
        " {\n    height: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    width: ",
        ";\n\n    &:hover {\n      img {\n        &:first-child {\n          width: ",
        ";\n        }\n        &:nth-child(2) {\n          width: ",
        ";\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    height: 120px;\n    width: 110px;\n\n    &:hover {\n      img {\n        &:first-child {\n          width: 110px;\n        }\n        &:nth-child(2) {\n          width: 82px;\n        }\n      }\n    }\n  }\n\n  span {\n    ",
        "\n    color: #ffffff;\n    left: 50%;\n    position: absolute;\n    text-transform: uppercase;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 3;\n  }\n\n  img {\n    left: 50%;\n    opacity: .5;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    transition: 300ms width ",
        ";\n    user-select: none;\n    width: ",
        ";\n\n    &:first-child {\n      transition-delay: 150ms;\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 91px;\n    }\n\n    &.xs {\n      opacity: 1;\n      width: ",
        ";\n      z-index: 2;\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 63px;\n      }\n    }\n  }\n"
    ]);
    ContentVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








// import { Figure } from '@dy/commons/components'
var ReactPlayer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 84372, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84372)
            ];
        }
    },
    ssr: false
});
// const hexagonIcon = {
//   type: 'svg' as const,
//   src: '/images/svg/i--hexagon-rounded.svg',
//   alt: 'Hexagon icon',
//   size: { width: 63, height: 69 }
// }
var ContentVideo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, _longModal = param.longModal, longModal = _longModal === void 0 ? false : _longModal, _modalActive = param.modalActive, modalActive = _modalActive === void 0 ? false : _modalActive, _playsinline = param.playsinline, playsinline = _playsinline === void 0 ? false : _playsinline, _insideModal = param.insideModal, insideModal = _insideModal === void 0 ? false : _insideModal;
    var _medium = data.medium, platform = _medium.platform, long_video = _medium.long_video, short_video = _medium.short_video;
    var ref = (0,react.useState)(!longModal), playing = ref[0], setPlaying = ref[1];
    var ref1 = (0,dist_hooks.useInView)({
        rootMargin: "0px",
        threshold: 0
    }), ref2 = ref1.ref, inView = ref1.inView;
    var url = "https://www.".concat(platform, ".com/").concat(platform === "youtube" ? "watch?v=" : "").concat(longModal ? long_video : short_video);
    var toggle = (0,dist_hooks.useModal)(context.MODALS.VIDEO).toggle;
    (0,react.useEffect)(function() {
        if (longModal) return;
        setPlaying(inView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView
    ]);
    (0,react.useEffect)(function() {
        if (longModal) setPlaying(modalActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoContent, {
                ref: ref2,
                longModal: longModal,
                className: "figure--video",
                $insideModal: insideModal,
                $isModalActive: modalActive,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                        url: url,
                        playsinline: playsinline,
                        controls: longModal,
                        volume: longModal ? .5 : 0,
                        muted: !longModal,
                        loop: !longModal,
                        playing: playing
                    }),
                    long_video && !longModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlayIcon, {
                        onClick: toggle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/svg/i--hexagon-rounded.svg",
                                alt: "Icon Hexagon",
                                width: "63",
                                height: "69"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "xs",
                                src: "/images/svg/i--hexagon-rounded.svg",
                                alt: "Icon Hexagon small",
                                width: "63",
                                height: "69"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Play"
                            })
                        ]
                    })
                ]
            }),
            long_video && !longModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalVideo, {
                data: data
            })
        ]
    });
});
var VideoContent = styled_components_browser_esm["default"].figure.withConfig({
    displayName: "ContentVideo__VideoContent",
    componentId: "sc-aa95a5fb-0"
})(ContentVideo_templateObject(), styles.mq.greaterThan("desktop-wide"), (0,styles.getP12_1)(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.black, .1);
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var longModal = param.longModal;
    return longModal ? "56.25vw" : "".concat((0,styles.vw)(232, "mobile"));
}, function(param) {
    var $insideModal = param.$insideModal, $isModalActive = param.$isModalActive, longModal = param.longModal;
    return $insideModal ? $isModalActive ? "auto" : "none" : longModal ? "auto" : "none";
}, styles.mq.greaterThan("nexus7"), function(param) {
    var longModal = param.longModal;
    return longModal ? "56.25vw" : "".concat((0,styles.vw)(232, "nexus7"));
}, styles.mq.greaterThan("tablet"), function(param) {
    var longModal = param.longModal;
    return longModal ? "56.25vw" : "".concat((0,styles.vw)(540, "desktop"));
}, styles.mq.greaterThan("desktop-wide"), function(param) {
    var longModal = param.longModal;
    return longModal ? "56.25vw" : "540px";
}, styles.mq.greaterThan("desktop-wide"));
var PlayIcon = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ContentVideo__PlayIcon",
    componentId: "sc-aa95a5fb-1"
})(ContentVideo_templateObject1(), (0,styles.vw)(90, "mobile"), function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(90, "nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), (0,styles.vw)(110, "desktop"), (0,styles.vw)(110, "desktop"), (0,styles.vw)(82, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP10)(), function(param) {
    var ease = param.ease;
    return ease;
}, (0,styles.vw)(73, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(73, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(91, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalVideo.tsx

function ModalVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n\n  ",
        " {\n    margin: auto ",
        ";\n  }\n\n  ",
        " {\n    margin: auto 80px;\n  }\n\n  header {\n    display: none;\n  }\n\n  .modal__body {\n    padding: 0;\n  }\n\n  main {\n    max-height: none;\n    padding: 0;\n  }\n\n  .close figure {\n    width: ",
        ";\n    height: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n      height: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n      height: ",
        ";\n    }\n\n    ",
        " {\n      width: 16px;\n      height: 16px;\n    }\n  }\n"
    ]);
    ModalVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: auto;\n  justify-content: center;\n  padding: ",
        ";\n  right: ",
        ";\n  top: 0;\n  position: absolute;\n  width: auto;\n  z-index: 5;\n\n  ",
        " {\n    padding: ",
        ";\n    right: ",
        ";\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    right: ",
        ";\n    top: ",
        ";\n  }\n\n  ",
        " {\n    padding: 40px;\n    right: 40px;\n    top: 40px;\n  }\n\n  img {\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n  }\n"
    ]);
    ModalVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var mediaCrossIcon = {
    type: "image",
    alt: "Cross icon",
    default: {
        src: "/images/svg/i--close--white.svg",
        size: {
            width: 16,
            height: 16
        }
    }
};
var ModalVideo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,dist_hooks.useModal)(context.MODALS.VIDEO), toggle = ref.toggle, isActive = ref.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: "",
        dialogStyles: ModalVideo_dialogStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, {
                    className: "close",
                    onClick: toggle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                        media: mediaCrossIcon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentVideo, {
                    data: data,
                    longModal: true,
                    modalActive: isActive,
                    insideModal: true
                })
            ]
        })
    });
});
var ModalVideo_dialogStyles = (0,styled_components_browser_esm.css)(ModalVideo_templateObject(), styles.mq.greaterThan("tablet"), (0,styles.vw)(80, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(16, "mobile"), (0,styles.vw)(16, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(16, "nexus7"), (0,styles.vw)(16, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(16, "desktop"), (0,styles.vw)(16, "desktop"), styles.mq.greaterThan("desktop"));
var ButtonClose = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ModalVideo__ButtonClose",
    componentId: "sc-c7a31dfe-0"
})(ModalVideo_templateObject1(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalNewsletter.tsx

function ModalNewsletter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/images/svg/background-newsletter.svg') no-repeat center;\n  background-size: cover;\n\n  header {\n    border-bottom: none;\n    height: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 80px;\n    }\n\n    button {\n      background-color: ",
        ";\n      border-radius: 50%;\n      height: ",
        ";\n      margin: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        margin: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        margin: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 40px;\n        margin: 20px;\n        width: 40px;\n      }\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n          width: ",
        ";\n        }\n\n        ",
        " {\n           height: ",
        ";\n           width: ",
        ";\n        }\n\n        ",
        " {\n          height: 18px;\n          width: 18px;\n        }\n      }\n    }\n  }\n\n  .modal__body {\n    padding: 0 ",
        " ",
        ";\n\n    ",
        " {\n      padding: 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 27.5px 75px;\n    }\n\n     h2 {\n      ",
        "\n      text-align: center;\n    }\n\n    form {\n      padding: 0;\n\n      ",
        " {\n        padding: ",
        " ",
        " 0;\n      }\n\n      ",
        " {\n        padding: 20px 20px 0;\n      }\n    }\n\n    > p {\n      ",
        "\n      color: ",
        ";\n      margin: ",
        " 0 0;\n      text-align: left;\n\n      ",
        " {\n        margin: ",
        " 0 0;\n      }\n\n      ",
        " {\n        margin: ",
        ";\n        text-align: center;\n      }\n\n      ",
        " {\n        margin: 20px;\n      }\n    }\n  }\n\n"
    ]);
    ModalNewsletter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ModalNewsletter = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,dist_hooks.useModal)(context.MODALS.NEWSLETTER), isActive = ref.isActive, toggle = ref.toggle;
    var onClick = function() {
        utils.cookie.set({
            name: "DY_MODAL_NEWSLETTER",
            value: "true",
            days: 2
        });
        toggle();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: onClick,
        title: "",
        xAlign: "flex-end",
        dialogStyles: ModalNewsletter_dialogStyles,
        size: "s",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: data.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: data.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormNewsletter/* FormNewsletter */.G, {
                hasLegend: false,
                inputBgColor: "transparent",
                textColor: "red",
                buttonBgColor: "red"
            })
        ]
    });
});
var ModalNewsletter_dialogStyles = (0,styled_components_browser_esm.css)(ModalNewsletter_templateObject(), (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(80, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(18, "mobile"), (0,styles.vw)(18, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(18, "nexus7"), (0,styles.vw)(18, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(18, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(75, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(75, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(75, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP26)(), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP35)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalPromo.tsx

function ModalPromo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  header {\n    border-bottom: none;\n    height: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 80px;\n    }\n\n\n    button {\n      background-color: ",
        ";\n      border-radius: 50%;\n      height: ",
        ";\n      margin: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        margin: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        margin: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 40px;\n        margin: 20px;\n        width: 40px;\n      }\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n\n        ",
        " {\n           height: ",
        ";\n           width: ",
        ";\n        }\n\n        ",
        " {\n           height: ",
        ";\n           width: ",
        ";\n        }\n\n        ",
        " {\n          height: 18px;\n          width: 18px;\n        }\n      }\n    }\n  }\n\n\n  .modal__body {\n    padding: 0 ",
        " ",
        ";\n\n    ",
        " {\n      padding: 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 0 27.5px 75px;\n    }\n\n     h2 {\n      ",
        "\n      text-align: center;\n    }\n    form {\n      padding: 0;\n\n      ",
        " {\n        padding: ",
        " ",
        " 0;\n      }\n\n      ",
        " {\n        padding: 20px 20px 0;\n      }\n    }\n\n    > p {\n      ",
        "\n      color: ",
        ";\n      text-align: left;\n      margin: ",
        " 0 0;\n\n      ",
        " {\n        margin: ",
        " 0 0;\n      }\n\n      ",
        " {\n        text-align: center;\n        margin: ",
        ";\n      }\n\n      ",
        " {\n        margin: 20px;\n      }\n    }\n  }\n"
    ]);
    ModalPromo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ModalPromo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var ref = (0,dist_hooks.useModal)(context.MODALS.PROMO), isActive = ref.isActive, toggle = ref.toggle;
    var title = data.title, text = data.text, linkPath = data.linkPath, linkTitle = data.linkTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: "",
        xAlign: "flex-end",
        dialogStyles: ModalPromo_dialogStyles,
        size: "s",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linkPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                    children: linkTitle
                })
            })
        ]
    });
});
var ModalPromo_dialogStyles = (0,styled_components_browser_esm.css)(ModalPromo_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(80, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(18, "mobile"), (0,styles.vw)(18, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(18, "nexus7"), (0,styles.vw)(18, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(18, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(75, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(75, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(75, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP26)(), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP35)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/modals/ModalStockCart.tsx


function ModalStockCart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .modal__body  {\n    text-align: center;\n\n    button {\n      margin-top: 25px;\n    }\n  }\n  span {\n    display: block;\n    text-align: center;\n    margin-bottom: 15px;\n    \n    &:last-child{\n      margin-bottom: 25px;\n    }\n  }\n\n\n\n"
    ]);
    ModalStockCart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var createParagraphsFromNotifications = function(notifications, t) {
    if (!notifications) return null;
    return notifications.filter(function(n) {
        return n.code === "CART_LINE_QUANTITY_INVALID";
    }).map(function(n) {
        var productName = n.cartLine.product.name;
        var newQuantity = n.newQuantity, deleted = n.deleted;
        if (deleted) {
            return "".concat(productName, " ").concat(t("modals.stock_cart.deleted"), " ");
        }
        return "".concat(productName, " ").concat(t("modals.stock_cart.stock_change_1"), " ").concat(newQuantity, " ").concat(t("modals.stock_cart.stock_change_2"));
    });
};
var ModalStockCart = /*#__PURE__*/ (0,react.memo)(function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,dist_hooks.useModal)(context.MODALS.STOCK_CART), isActive = ref.isActive, toggle = ref.toggle, payload = ref.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var Notifications = (0,react.useMemo)(function() {
        return createParagraphsFromNotifications(payload, t);
    }, [
        payload,
        t
    ]);
    return isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.stock_cart.title"),
        xAlign: "flex-end",
        size: "s",
        dialogStyles: ModalStockCart_dialogStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("modals.stock_cart.description")
            }),
            Notifications,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                onClick: toggle,
                children: t("modals.stock_cart.ok")
            })
        ]
    });
});
var ModalStockCart_dialogStyles = (0,styled_components_browser_esm.css)(ModalStockCart_templateObject());

;// CONCATENATED MODULE: ./components/modals/ModalPublicInterested.tsx

function ModalPublicInterested_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > .modal__body {\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      padding-bottom: 30px;\n    }\n\n    p {\n      ",
        "\n      text-align: center;\n      color: ",
        ";\n      margin-bottom:",
        ";\n\n      ",
        " {\n        margin-bottom:",
        ";\n      }\n\n      ",
        " {\n        margin-bottom:",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 20px;\n      }\n    }\n    a {      \n      color: ",
        ";\n      ",
        "\n    }\n  }\n"
    ]);
    ModalPublicInterested_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ModalPublicInterested = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.PUBLIC_INTERESTED), isActive = ref.isActive, toggle = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.public_interested.title"),
        xAlign: "center",
        dialogStyles: ModalPublicInterested_dialogStyles,
        size: "s",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    t("modals.public_interested.contact"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:".concat(t("modals.public_interested.mail")),
                        children: t("modals.public_interested.mail")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    t("modals.public_interested.particular"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("modals.public_interested.cta_hm"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: "https://hellomamma.es",
                        children: t("modals.public_interested.online")
                    })
                ]
            })
        ]
    });
});
var ModalPublicInterested_dialogStyles = (0,styled_components_browser_esm.css)(ModalPublicInterested_templateObject(), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP20_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.createUnderline)({
    color: "red",
    height: 1
}));

;// CONCATENATED MODULE: ./components/modals/ModalCartType.tsx

function ModalCartType_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .modal__body {\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 30px 40px 25px;\n    }\n\n    p {\n      ",
        "\n      margin-bottom: 5px;\n      text-align: center;\n    }\n  }\n\n\n"
    ]);
    ModalCartType_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ModalCartType = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.CART_TYPE), isActive = ref.isActive, toggle = ref.toggle;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var isFrozenCart = (0,dist_hooks.useCart)().isFrozenCart;
    return isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        isActive: isActive,
        close: toggle,
        title: "",
        xAlign: "flex-end",
        dialogStyles: ModalCartType_dialogStyles,
        size: "s",
        hasHeader: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: isFrozenCart ? t("product_page.product.frozen_cart") : t("product_page.product.fresh_cart")
        })
    });
});
var ModalCartType_dialogStyles = (0,styled_components_browser_esm.css)(ModalCartType_templateObject(), (0,styles.vw)(30, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_2)());

;// CONCATENATED MODULE: ./components/modals/ModalBuyBox.tsx


function ModalBuyBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .modal__body {\n    padding: ",
        " ",
        " ",
        ";\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: 30px 27.5px 25px;\n    }\n\n    p {\n      ",
        "\n      color: ",
        ";\n      margin: 0 auto 5px;\n      text-align: center;\n      width: 80%\n    }\n\n\n    > div {\n      display: flex;\n      justify-content: center;\n      margin: 30px auto;\n      width: 60%;\n    }\n  }\n\n\n"
    ]);
    ModalBuyBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ModalBuyBox = /*#__PURE__*/ (0,react.memo)(function() {
    var ref = (0,dist_hooks.useModal)(context.MODALS.BUY_BOX), isActive = ref.isActive, toggle = ref.toggle, payload = ref.payload;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var data = (0,_object_spread/* default */.Z)({}, payload === null || payload === void 0 ? void 0 : payload.data);
    return isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        isActive: isActive,
        close: toggle,
        title: t("modals.buy_box.title"),
        xAlign: "flex-end",
        size: "s",
        dialogStyles: ModalBuyBox_dialogStyles,
        hasHeader: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: (0,utils.getDynamicText)(t("modals.buy_box.text"), {
                    units: data.variant.qtyPerBox
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* AddToCart */.o4, {
                    data: data,
                    inventoryTracking: payload.inventoryTracking,
                    isPDP: true,
                    isBox: true
                })
            })
        ]
    });
});
var ModalBuyBox_dialogStyles = (0,styled_components_browser_esm.css)(ModalBuyBox_templateObject(), (0,styles.vw)(30, "mobile"), (0,styles.vw)(40 - 4.25, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(40 - 4.25, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(40 - 12.5, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), styles.getP18_1, function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
});

;// CONCATENATED MODULE: ./components/modals/index.ts
















 // export * from './ModalWelcome'
 // export * from './ModalLanguages'

;// CONCATENATED MODULE: ./components/faqs/SectionFaqCategories.tsx

function SectionFaqCategories_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: inline-grid;\n    grid-column: 1 / span 3;\n    grid-auto-rows: max-content;\n    height: fit-content;\n    // min-height: calc(100vh - 80px);\n    overflow: auto;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n    position: sticky;\n    top: 80px;\n    z-index: 60;\n    ",
        "\n  }\n\n  ",
        " {\n    padding: 20px 50px 50px 30px;\n  }\n"
    ]);
    SectionFaqCategories_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SectionFaqCategories = function(param) {
    var categories = param.categories, activeIndex = param.activeIndex, activeCategory = param.activeCategory, activeQuestion = param.activeQuestion;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Accordion, {
            items: categories,
            activeIndex: activeIndex,
            activeCategory: activeCategory,
            activeQuestion: activeQuestion
        })
    });
};
var CategoriesSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionFaqCategories__CategoriesSection",
    componentId: "sc-9d4fee2e-0"
})(SectionFaqCategories_templateObject(), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.hideScrollbar)(), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/faqs/Question.tsx

function Question_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  position: relative;\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 10px;\n  }\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  h3 {\n    color: ",
        ";\n    ",
        "\n    font-family: ",
        ";\n    text-align: left;\n  }\n\n  .hash {\n    height: 1px;\n    opacity: 0;\n    position: absolute;\n    top: -110px;\n    user-select: none;\n    width: 100%;\n\n    ",
        " {\n      top: -140px;\n    }\n  }\n"
    ]);
    Question_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Question_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 60px;\n  }\n\n  p, ul, dl, ol {\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    padding-right: ",
        ";\n\n    ",
        " {\n      padding-right: ",
        ";\n    }\n\n    ",
        " {\n      padding-right: 0;\n    }\n  }\n\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    Question_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Question = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, setActiveQuestion = param.setActiveQuestion;
    var ref = (0,dist_hooks.useInView)({
        rootMargin: "100px 0px -50% 0px",
        threshold: 1,
        triggerOnce: false
    }), ref1 = ref.ref, inView = ref.inView;
    (0,react.useEffect)(function() {
        if (inView && (data === null || data === void 0 ? void 0 : data.parameterize)) setActiveQuestion(data.parameterize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionTitle, {
                ref: ref1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "".concat(data.parameterize),
                        className: "hash"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: data.question
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAnswer, {
                dangerouslySetInnerHTML: {
                    __html: data.answer
                }
            })
        ]
    });
});
var QuestionTitle = styled_components_browser_esm["default"].dt.withConfig({
    displayName: "Question__QuestionTitle",
    componentId: "sc-d8fdfebc-0"
})(Question_templateObject(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP26_2)(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, styles.mq.greaterThan("tablet"));
var QuestionAnswer = styled_components_browser_esm["default"].dd.withConfig({
    displayName: "Question__QuestionAnswer",
    componentId: "sc-d8fdfebc-1"
})(Question_templateObject1(), (0,styles.getP18_2)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(48, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(70, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(70, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});

;// CONCATENATED MODULE: ./components/faqs/faqVariants.ts



var faqListVariants = {
    initial: {
        height: 0,
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            delay: 0
        })
    },
    animate: {
        height: "auto",
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .3,
            delay: 0
        })
    },
    exit: {
        height: 0,
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .2,
            delay: 0
        })
    }
};

;// CONCATENATED MODULE: ./components/faqs/SectionQuestionsList.tsx



function SectionQuestionsList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  position: relative;\n  grid-auto-rows: max-content;\n  height: max-content;\n  ",
        " {\n    grid-column: 5 / span 6;\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 120px;\n  }\n\n  &:last-child {\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 120px;\n    }\n  }\n\n  .idslug {\n    height: 1px;\n    opacity: 0;\n    position: absolute;\n    top: -80px;\n    user-select: none;\n    width: 100%;\n\n    ",
        " {\n      top: -140px;\n    }\n  }\n\n  h2 {\n    height: ",
        ";\n    justify-content: flex-start;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      height: auto;\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 30px;\n    }\n\n    &,\n    button {\n      align-items: center;\n      color: ",
        ";\n      display: flex;\n      ",
        "\n      width: 100%;\n    }\n\n    button {\n      justify-content: space-between;\n      pointer-events: auto;\n      user-select: auto;\n\n      ",
        " {\n        pointer-events: none;\n      }\n    }\n  }\n  figure {\n    height: ",
        ";\n    width: ",
        ";\n  }\n"
    ]);
    SectionQuestionsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionQuestionsList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  &[aria-expanded='false'] {\n    pointer-events: none;\n    user-select: none;\n  }\n\n  &[aria-expanded='true'] {\n    pointer-events: auto;\n    user-select: auto;\n  }\n"
    ]);
    SectionQuestionsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionQuestionsList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 10px;\n  user-select: none;\n\n  ",
        " {\n    display: none;\n  }\n\n  img {\n    height: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n  }\n"
    ]);
    SectionQuestionsList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var mediaChevronIcon = {
    type: "image",
    alt: "Icon chevron",
    default: {
        src: "/images/svg/i--chevron--lightred.svg",
        size: {
            width: 6,
            height: 8
        }
    }
};
var getFaqs = function(faqs, setActiveQuestion) {
    return faqs.map(function(faq, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
            data: faq,
            setActiveQuestion: setActiveQuestion
        }, idx);
    });
};
var SectionQuestionsList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, idx = param.idx, setActiveIndex = param.setActiveIndex, setActiveCategory = param.setActiveCategory, setActiveQuestion = param.setActiveQuestion;
    var ref = (0,router.useRouter)(), locale = ref.locale, query = ref.query;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var Faqs = (0,react.useMemo)(function() {
        return getFaqs(data.faqs, setActiveQuestion);
    }, [
        data
    ]);
    var ref1 = (0,react.useState)(true), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var isMobile = (0,dist_hooks.useDeviceType)().isMobile;
    var ref2 = (0,dist_hooks.useInView)({
        rootMargin: "100px 0px -50% 0px",
        threshold: 1,
        triggerOnce: false
    }), ref3 = ref2.ref, inView = ref2.inView;
    (0,react.useEffect)(function() {
        if (inView && (data === null || data === void 0 ? void 0 : data.slug)) {
            setActiveIndex(idx);
            setActiveCategory(data.slug[locale.split("-")[0]]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView
    ]);
    (0,react.useEffect)(function() {
        if (isMobile) setIsExpanded(false);
    }, [
        isMobile
    ]);
    var handleOnClick = function() {
        setIsExpanded(!isExpanded);
    };
    var sectionRef = (0,react.useCallback)(function(node) {
        if (false) {}
        // @ts-ignore
        if (node !== null && (query === null || query === void 0 ? void 0 : query.slug) && query.slug[0] === data.slug[locale.split("-")[0]]) {
            setTimeout(function() {
                node.scrollIntoView({
                    behavior: "smooth"
                });
            }, 1200);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionQuestionsList_Section, {
        initial: {
            opacity: 0,
            y: -15
        },
        animate: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            y: 0
        },
        transition: {
            duration: 1.2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: sectionRef,
                className: "idslug"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                ref: ref3,
                children: [
                    data.name,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        "aria-hidden": true,
                        animate: {
                            rotate: isExpanded ? 90 : 0
                        },
                        transition: (0,styles.getTransition)(),
                        onClick: handleOnClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mediaChevronIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuestionsList_List, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, idx && {
                id: idx
            }), {
                "aria-expanded": isExpanded,
                tabIndex: -1,
                variants: faqListVariants,
                initial: "initial",
                exit: "exit",
                animate: isExpanded ? "animate" : "exit",
                children: Faqs
            }))
        ]
    });
});
var SectionQuestionsList_Section = (0,styled_components_browser_esm["default"])(motion/* motion.section */.E.section).withConfig({
    displayName: "SectionQuestionsList__Section",
    componentId: "sc-860b1f61-0"
})(SectionQuestionsList_templateObject(), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(70, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(70, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(35, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(35, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP53)(), styles.mq.greaterThan("tablet"), (0,styles.vw)(8, "mobile"), (0,styles.vw)(8, "mobile"));
var SectionQuestionsList_List = (0,styled_components_browser_esm["default"])(motion/* motion.dl */.E.dl).withConfig({
    displayName: "SectionQuestionsList__List",
    componentId: "sc-860b1f61-1"
})(SectionQuestionsList_templateObject1());
var Chevron = (0,styled_components_browser_esm["default"])(motion/* motion.span */.E.span).withConfig({
    displayName: "SectionQuestionsList__Chevron",
    componentId: "sc-860b1f61-2"
})(SectionQuestionsList_templateObject2(), styles.mq.greaterThan("tablet"), (0,styles.vw)(13, "mobile"), (0,styles.vw)(13, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(13, "nexus7"), (0,styles.vw)(13, "nexus7"));

;// CONCATENATED MODULE: ./components/faqs/index.ts



;// CONCATENATED MODULE: ./components/contents/content-types/ContentText.tsx

function ContentText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  word-break: break-word;\n  width: 100%;\n\n  a {\n    ",
        "\n  }\n\n  h2, h3, h4,\n  p, ul, ol, dl,\n  q, a {\n    color: inherit;\n    text-align: inherit;\n    word-break: inherit;\n  }\n\n  p, ul, ol, dl, q, a {\n    color: ",
        ";\n  }\n\n  h2, h3, h4, h5, h6 {\n    color: ",
        ";\n  }\n\n  h2, h3, h4 {\n    font-weight: 500;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 20px;\n    }\n\n    + p {\n      margin-top: -",
        ";\n\n      ",
        " {\n        margin-top: -",
        ";\n      }\n\n      ",
        " {\n        margin-top: -",
        ";\n      }\n\n      ",
        " {\n        margin-top: -10px;\n      }\n    }\n  }\n\n  h1, h2 {\n    ",
        "\n\n    br {\n      + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n        margin-top:  ",
        ";\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n\n  h3 {\n    ",
        "\n\n    br {\n      + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n        margin-top:  ",
        ";\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n\n  h4 {\n    ",
        "\n  }\n\n  h5 {\n    ",
        "\n  }\n\n  h4, h5 {\n    br {\n      + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n        margin-top:  ",
        ";\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  h6 {\n    ",
        "\n\n    br {\n      + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n        margin-top:  ",
        ";\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: 8px;\n        }\n      }\n    }\n  }\n\n  p {\n    ",
        "\n\n    br {\n      content: '';\n      display: block;\n      margin-bottom:  ",
        ";\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 15px;\n      }\n    }\n  }\n\n  ul, ol, dl {\n    ",
        "\n    font-weight: normal;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 60px;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    br {\n      + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n        margin-top:  ",
        ";\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: ",
        ";\n        }\n\n        ",
        " {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n\n\n\n\n  br {\n    + p, ul, ol, dl, h2, h3, h4, h5, h6, a {\n      ",
        "\n    }\n  }\n\n  ul, ol {\n    padding-left: 18px;\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n    }\n  }\n\n  ol {\n    li {\n      list-style-type: decimal;\n    }\n  }\n\n  q, blockquote {\n    border-left: 0;\n    color: ",
        ";\n    ",
        "\n    display: block;\n    font-weight: bold;\n    font-style: normal;\n    margin: auto;\n    padding: ",
        " ",
        " 0;\n    position: relative;\n    text-align: center;\n    width: 100%;\n\n    ",
        " {\n      padding: ",
        " ",
        " 0;\n    }\n\n    ",
        " {\n      padding: ",
        " 0 ",
        ";\n      transform: translateX(-",
        ");\n      width: calc(100% + ",
        ");\n    }\n\n    ",
        " {\n      padding: 20px 0 20px;\n      transform: translateX(-120px);\n      width: calc(100% + 240px);\n    }\n\n    &:before,\n    &:after {\n      content: '';\n      background-image: url('/images/svg/i--double-quotes.svg');\n      background-repeat: no-repeat;\n      display: inline-block;\n      height: ",
        ";\n      opacity: .2;\n      position: absolute;\n      user-select: none;\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        height: 66px;\n        width: 94px;\n      }\n    }\n\n    &:before {\n      left: ",
        ";\n      top: -",
        ";\n      transform: rotate(180deg);\n\n      ",
        " {\n        left: ",
        ";\n        top: -",
        ";\n      }\n\n      ",
        " {\n        left: ",
        ";\n        top: -",
        ";\n      }\n\n      ",
        " {\n        left: 30px;\n        top: -10px;\n      }\n    }\n\n    &:after {\n      bottom: -",
        ";\n      right: ",
        ";\n\n      ",
        " {\n        bottom: -",
        ";\n        right: ",
        ";\n      }\n\n      ",
        " {\n        bottom: 0;\n        right: ",
        ";\n      }\n\n      ",
        " {\n        right: 30px;\n      }\n    }\n\n    > p {\n      color: ",
        ";\n      display: inline;\n      ",
        "\n      font-family: ",
        ";\n      font-style: normal;\n      text-align: center;\n    }\n  }\n\n  table {\n    border-collapse: collapse;\n    width: 100%;\n\n    th,\n    td {\n      ",
        "\n      padding: ",
        " ",
        ";\n\n      ",
        " {\n        padding: ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: ",
        " ",
        ";\n      }\n\n      ",
        " {\n        padding: 30.5px 10px;\n      }\n\n      &:first-child {\n        padding-left: 0;\n      }\n\n      &:last-child {\n        padding-right: 0;\n      }\n    }\n\n    th {\n      color: ",
        ";\n      border-bottom: 1px solid ",
        ";\n    }\n\n    tbody, tfoot {\n      td {\n        border-bottom: 1px solid ",
        ";\n        color: ",
        ";\n\n        ",
        " {\n          max-width: ",
        ";\n          vertical-align: initial;\n        }\n\n        ",
        " {\n          max-width: 490px;\n        }\n      }\n\n      tr {\n        &:last-child {\n          td {\n            border-color: ",
        ";\n          }\n        }\n      }\n    }\n  }\n\n  &.contact {\n    ",
        "\n    align-items: baseline;\n    padding: 0;\n    margin-top: ",
        ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n    p:first-of-type {\n      display: none;\n    }\n\n    h3, b {\n      ",
        "\n    }\n    > section {\n      margin-bottom: 0;\n    }\n\n    h3 {\n      grid-area: 1 / 1 / span 1 / span 1;\n      text-align: center;\n      font-size: 1rem;\n      ",
        "{\n        text-align: left;\n      }\n    }\n    h4.spacer_contact {\n      grid-area:2 / 1 / span 1 / span 1 !important;\n    }\n    p {\n      display: inline-grid;\n      ",
        "{\n        display: inline-grid;\n        grid-column: 2 / span 5;\n        padding: 0 ",
        "vw 0 ",
        ";\n      }\n\n      &.nop {\n        display: none;\n      }\n    }\n\n    span {\n      font-size: ",
        ";\n      line-height: ",
        ";\n      letter-spacing: -.5px;\n      font-family: ",
        ";\n      font-weight: 400;\n\n      ",
        "{\n        font-size: ",
        ";\n        line-height: ",
        ";\n      }\n    }\n\n    p {\n      margin-bottom: ",
        ";\n\n      b, span {\n        display: block;\n        margin-bottom: ",
        ";\n\n        ",
        "{\n          margin-bottom: ",
        ";\n        }\n      }\n    }\n\n    ",
        "{\n      margin-top: ",
        ";\n\n      h3 {\n        font-size: unset;\n        grid-area: 1 / 2 / span 1 / span 2;\n      }\n      h4 {\n        grid-area:2 / 1 / span 1 / span 1 !important;\n      }\n      p {\n        display: inline-grid;\n        grid-column-end: span 3;\n        margin-bottom: ",
        ";\n        align-items: end;\n\n        &.nop {\n          display: block;\n          opacity: 0;\n          grid-column-end: span 2;\n        }\n      }\n    }\n  }\n\n  .panettone_container {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n\n    .panettone_card {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n      justify-content: flex-start;\n\n      ",
        " {\n        flex-direction: row;\n      }\n\n      > img {\n        width: 50%;\n\n        ",
        " {\n          width: 170px;\n        }\n\n      }\n\n      > p {\n        ",
        "\n        width: 100%;\n\n        ",
        " {\n            width: 55%;\n        }\n\n      }\n\n      > button {\n        ",
        "\n        align-items: center;\n        background-color: ",
        ";\n        color: ",
        ";\n        display: flex;\n        font-family: ",
        ";\n        height:",
        ";\n        justify-content: center;\n        letter-spacing: 0;\n        margin: 0 auto;\n        padding:",
        " ",
        ";\n        position: relative;\n        width:unset;\n\n        ",
        " {\n          height: ",
        ";\n          padding:",
        " ",
        ";\n        }\n\n        ",
        " {\n          height:",
        ";\n          padding: ",
        " ",
        ";\n        }\n\n        ",
        " {\n          height:60px;\n          padding: 19px 43px;\n        }\n\n        &,\n        &:before {\n          transition: 300ms background-color ",
        ", 300ms border ",
        ", 300ms color ",
        ", 300ms filter ",
        ", 300ms opacity ",
        ";\n          border-radius:",
        ";\n\n          ",
        " {\n            border-radius:",
        ";\n          }\n\n          ",
        " {\n            border-radius:",
        ";\n          }\n          \n          ",
        " {\n            border-radius: 30px;\n          }\n        }\n\n        > div:last-of-type {\n          ",
        "\n          align-items: center;\n          color: inherit;\n          display: flex;\n          height: 100%;\n          justify-content: center;\n          font-family: ",
        ";\n          width: 100%;\n          z-index: 2;\n          transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);\n          white-space: nowrap;\n\n          img {\n            padding: ",
        ";\n\n            ",
        " {\n              padding: ",
        ";\n            }\n\n            ",
        " {\n              padding: ",
        ";\n            }\n\n            ",
        " {\n              padding: 10px;\n            }\n          }\n        }\n\n        .button__bg {\n          background: ",
        ";\n          border-radius:",
        ";\n          border: none;\n          height: 100%;\n          left: 0;\n          overflow: hidden;\n          position: absolute;\n          top: 0;\n          transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);\n          width: 100%;\n\n          ",
        " {\n            border-radius:",
        ";\n          }\n\n          ",
        " {\n            border-radius:",
        ";\n          }\n          \n          ",
        " {\n            border-radius: 30px;\n          }\n\n          &:before,\n          &:after {\n            content: '';\n            position: absolute;\n            z-index: -1;\n            background-color: ",
        ";\n          }\n\n          &:before {\n            width: 110%;\n            height: 0;\n            padding-bottom: 110%;\n            top: 50%;\n            left: 50%;\n            border-radius: 50%;\n            transform: translate3d(-50%,-50%,0) scale3d(0,0,1);\n          }\n\n          &:after {\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            opacity: 0;\n            transition: opacity 0.3s;\n          }\n        }\n\n        &:hover {\n          color: ",
        ";\n\n          .button__bg {\n            transform: 'none';\n\n            ",
        " {\n              transform: scale3d(1.1,1.2,1);\n            }\n\n            &:before {\n              transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);\n              transform: translate3d(-50%,-50%,0) scale3d(1,1,1);\n            }\n\n            &:after {\n              opacity: 1;\n              transition-duration: 0.01s;\n              transition-delay: 0.3s;\n            }\n          }\n        }\n\n      }\n    }\n  }\n"
    ]);
    ContentText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var contactString = [
    "/page/find-us-here",
    "/page/contactanos",
    "/page/trouvez-nous",
    "/page/finden-sie-uns-hier",
    "/page/donde-estamos",
    "/page/encontre-nos-aqui"
];
var ContentText = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var text = data.text, color = data.color, align = data.align;
    var asPath = (0,router.useRouter)().asPath;
    var ref = (0,react.useRef)();
    // This chunk allows inner embed scripts to run
    (0,react.useLayoutEffect)(function() {
        var range = document.createRange();
        range.selectNode(ref.current);
        var documentFragment = range.createContextualFragment(text);
        ref.current.innerHTML = "";
        ref.current.append(documentFragment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent, {
        ref: ref,
        className: "text-wrapper ".concat(contactString.indexOf(asPath) !== -1 ? "contact" : ""),
        color: color,
        align: align,
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
});
var TextContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentText__TextContent",
    componentId: "sc-c621df34-0"
})(ContentText_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, function(param) {
    var color = param.color, theme = param.theme;
    return color ? color : theme.colors.darkred;
}, function(param) {
    var align = param.align;
    return align && align.h ? align.h : "left";
}, (0,styles.createUnderline)({
    height: 1,
    reverse: true
}), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(16, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(16, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP30)(), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP26_1)(), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_1)(), (0,styles.getP15)(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_1)(), (0,styles.vw)(8, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(8, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(8, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_1)(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP20)(), (0,styles.vw)(48, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP20_4)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP53)(), (0,styles.vw)(12, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(120, "desktop"), (0,styles.vw)(120 * 2, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(33, "mobile"), (0,styles.vw)(47, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(33, "nexus7"), (0,styles.vw)(47, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(66, "desktop"), (0,styles.vw)(94, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP53)(), function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, (0,styles.getP20)(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30.5, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .6);
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .1);
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, .6);
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(490, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.text, 0);
}, (0,styles.designGrid)({}), (0,styles.vw)(60, "mobile"), (0,styles.getP26_1)(), styles.mq.greaterThan("tablet"), styles.mq.lessThan("tablet"), (0,styles.vw)(20, 414), (0,styles.vw)(13, "mobile"), (0,styles.vw)(15, "mobile"), (0,styles.vw)(20, "mobile"), function(param) {
    var theme = param.theme;
    return theme.fonts.basier;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(25, "desktop"), (0,styles.vw)(37, "mobile"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.getP18_1)(), styles.mq.greaterThan("tablet"), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(50, "mobile"), (0,styles.vw)(17, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(17, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), (0,styles.vw)(19, "desktop"), (0,styles.vw)(43, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15)(), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, styles.mq.greaterThan("tablet"));

;// CONCATENATED MODULE: ./components/contents/content-types/ContentImage.tsx

function ContentImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  width: ",
        ";\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  > span {\n    position: relative !important;\n    height: auto;\n    width: 100%;\n  }\n\n  img {\n    position: relative !important;\n    height: 100% !important;\n    width: 100% !important;\n  }\n\n  figcaption {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-style: normal;\n    ",
        "\n    margin-top: ",
        ";\n    opacity: .5;\n    text-align: center;\n    text-transform: uppercase;\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 10px;\n    }\n  }\n"
    ]);
    ContentImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Fig = (0,styled_components_browser_esm["default"])(components.Figure).withConfig({
    displayName: "ContentImage__Fig",
    componentId: "sc-885ebec4-0"
})(ContentImage_templateObject(), function(param) {
    var $size = param.$size;
    return $size === "small" ? "".concat((0,styles.vw)(69 * 4, "mobile")) : $size === "medium" ? "".concat((0,styles.vw)(69 * 5, "mobile")) : "100%";
}, styles.mq.greaterThan("tablet"), function(param) {
    var $size = param.$size;
    return $size === "small" ? "".concat((0,styles.vw)(120 * 4, "desktop")) : $size === "medium" ? "".concat((0,styles.vw)(120 * 6, "desktop")) : "100%";
}, styles.mq.greaterThan("desktop"), function(param) {
    var $size = param.$size;
    return $size === "small" ? "480px" : $size === "medium" ? "650px" : "100%";
}, function(param) {
    var theme = param.theme;
    return theme.colors.greendark;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.platform;
}, (0,styles.getP10)(), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"));
var ContentImage = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var medium = data.medium, mediaSize = data.mediaSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fig, {
        media: medium,
        $size: mediaSize
    });
});

;// CONCATENATED MODULE: ./components/contents/content-types/ContentButtonDownload.tsx

function ContentButtonDownload_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-left: 0;"
    ]);
    ContentButtonDownload_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContentButtonDownload_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-right: 0;"
    ]);
    ContentButtonDownload_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContentButtonDownload_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin: 0 auto;"
    ]);
    ContentButtonDownload_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContentButtonDownload_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ContentButtonDownload_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ContentButtonDownload = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    var text = data.text, download = data.download, horizontalAlignment = data.horizontalAlignment;
    var onClick = function() {
        window.open(download);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDownload, {
        onClick: onClick,
        $xAlign: horizontalAlignment,
        bgType: "darkred",
        children: text
    });
});
var ButtonDownload = (0,styled_components_browser_esm["default"])(components.Button).withConfig({
    displayName: "ContentButtonDownload__ButtonDownload",
    componentId: "sc-799d4417-0"
})(ContentButtonDownload_templateObject3(), function(param) {
    var $xAlign = param.$xAlign;
    return $xAlign === "left" ? (0,styled_components_browser_esm.css)(ContentButtonDownload_templateObject()) : $xAlign === "right" ? (0,styled_components_browser_esm.css)(ContentButtonDownload_templateObject1()) : (0,styled_components_browser_esm.css)(ContentButtonDownload_templateObject2());
});

;// CONCATENATED MODULE: ./components/contents/content-types/index.ts





;// CONCATENATED MODULE: ./components/contents/Content.tsx

function Content_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  &.media {\n    margin: 0 auto;\n  }\n"
    ]);
    Content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MediaTypes = {
    "medium_image": function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentImage, {
            data: data
        });
    },
    "medium_video": function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentVideo, {
            data: data
        });
    }
};
var ContentsTypes = {
    "text": function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
            data: data
        });
    },
    "media": function(data) {
        return MediaTypes[data.mediaType](data);
    },
    "empty": function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "empty"
        });
    },
    "spacer": function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "spacer"
        });
    },
    "button_download": function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentButtonDownload, {
            data: data
        });
    }
};
var getContentByType = function(content) {
    var columnType = (content || {}).columnType;
    if (!content || !columnType || !ContentsTypes[columnType]) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return ContentsTypes[columnType](content);
};
var Content = function(param) {
    var content = param.content;
    var ContentByType = (0,react.useMemo)(function() {
        return getContentByType(content);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentArticle, {
        className: content.columnType,
        children: ContentByType
    });
};
var ContentArticle = styled_components_browser_esm["default"].article.withConfig({
    displayName: "Content__ContentArticle",
    componentId: "sc-c4b79506-0"
})(Content_templateObject());

;// CONCATENATED MODULE: ./components/contents/SectionContents.tsx

function SectionContents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  grid-column: 1 / span 6;\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 3 / span 8;\n    margin-bottom: ",
        ";\n    padding: 0;\n  }\n\n  ",
        " {\n    margin-bottom: 60px;\n  }\n\n  &:has(.contact) {\n    margin-bottom: 0;\n    padding: 0;\n    ",
        " {\n      grid-column: 2/ span 12;\n    }\n\n \n  }\n  > article {\n    &.media {\n      width: 100%;\n    }\n\n    &.text {\n      min-width: 100%;\n      ",
        " {\n        padding: 0 ",
        ";\n      }\n\n      ",
        " {\n        padding: 0 auto;\n      }\n\n      ",
        " {\n        padding: 0;\n      }\n\n      &:has(.contact) {\n          padding: 0;\n        \n      }\n    }\n  }\n\n  .spacer {\n    height: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 50px;\n    }\n  }\n"
    ]);
    SectionContents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getContentsByColumns = function(columns) {
    return columns.map(function(content, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            content: content
        }, idx + "column");
    });
};
var SectionContents = /*#__PURE__*/ (0,react.memo)(function(param) {
    var section = param.section;
    var columns = section.columns;
    var ContentsByColumns = (0,react.useMemo)(function() {
        return getContentsByColumns(columns);
    }, [
        columns
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSection, {
        children: ContentsByColumns
    });
});
var ContentSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionContents__ContentSection",
    componentId: "sc-a608794f-0"
})(SectionContents_templateObject(), (0,styles.vw)(5, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(53, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("desktop-wide"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/contents/HeaderContents.tsx

function HeaderContents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  align-content: flex-end;\n  align-items: center;\n  padding-top: ",
        ";\n  margin-bottom:",
        " ;\n\n  ",
        " {\n    padding-top: ",
        ";\n    margin-bottom:",
        " ;\n  }\n\n  ",
        " {\n    padding-top: 120px;\n    margin-bottom: 30px;\n  }\n\n  h1, p {\n    grid-column: 1 / span 6;\n    text-align: center;\n    width: 100%;\n  }\n\n  h1 {\n    ",
        "\n    color: ",
        ";\n    font-weight: 400;\n    margin-bottom: ",
        ";\n    padding-top: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      grid-column: 3 / span 8;\n      margin-bottom: ",
        ";\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 30px;\n      padding-top: 60px;\n    }\n  }\n\n  p {\n    ",
        "\n    color: ",
        ";\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      grid-column: 2 / span 10;\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 60px;\n    }\n  }\n"
    ]);
    HeaderContents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var HeaderContents_Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "HeaderContents__Header",
    componentId: "sc-e721f64e-0"
})(HeaderContents_templateObject(), (0,styles.designGrid)({
    withoutGutter: true
}), (0,styles.vw)(60, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP26_4)(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP93)(50, 100), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"));
var HeaderContents = /*#__PURE__*/ (0,react.memo)(function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContents_Header, {
        children: children
    });
});

;// CONCATENATED MODULE: ./components/contents/SectionShop.tsx

function SectionShop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  grid-column: 1 / span 6;\n  padding: 0;\n  position: relative;\n  z-index:1;\n\n  #main-top {\n    display: block;\n    height: 2px;\n    opacity: .01;\n    position: absolute;\n    top: 0;\n    transform: translateY(-80px);\n    user-select: none;\n    width: 100%;\n  }\n\n  ",
        " {\n    grid-column: 1 / span 12;\n  }\n"
    ]);
    SectionShop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var DynamicMarquee = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 17566, 23)).then(function(mod) {
        return mod.Marquee;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17566)
            ];
        }
    },
    ssr: false
});
var firstLoad = true;
var updateQueryParams = function(param) {
    var query = param.query, activeFilters = param.activeFilters, push = param.push;
    var ref;
    var slug = typeof query.slug === "string" ? query.slug : (ref = query.slug) === null || ref === void 0 ? void 0 : ref.join("/");
    var stringParams = (0,utils.generateQueryParams)(activeFilters).stringParams;
    if (query.category) {
        push("/page/[slug]/category/[...category]", "/page/".concat(slug, "/category/").concat(query === null || query === void 0 ? void 0 : query.category.join("/"), "?").concat(stringParams), {
            shallow: true
        });
    } else {
        push("/page/[...slug]", "/page/".concat(slug, "?").concat(stringParams), {
            shallow: true
        });
    }
};
var SectionShop = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, _pageCategory = param.pageCategory, pageCategory = _pageCategory === void 0 ? "" : _pageCategory;
    var ref;
    var categories = data.categories, variants = data.variants;
    var ref1 = (0,router.useRouter)(), localeRouter = ref1.locale, asPath = ref1.asPath, query = ref1.query, push = ref1.push, isFallback = ref1.isFallback;
    var localeRegion = (0,utils.getLocaleCountry)(localeRouter);
    var isMounted = (0,dist_hooks.useMount)();
    var ref2 = (0,react.useState)({
        sort: {
            recommended: true
        }
    }), activeFilters = ref2[0], setActiveFilters = ref2[1];
    var ref3 = (0,react.useState)([]), featuredFilters = ref3[0], setFeaturedFilters = ref3[1];
    var ref4 = (0,react.useState)({
        all: Array.from(variants),
        current: Array.from(variants)
    }), currentProducts = ref4[0], setCurrentProducts = ref4[1];
    var scrollState = (0,dist_hooks.useScrollTracker)(160);
    var isScrolling = (0,react.useMemo)(function() {
        return scrollState !== "TOP";
    }, [
        scrollState
    ]);
    var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
    var isPrivate = (0,react.useMemo)(function() {
        return DYCustomerToken ? true : false;
    }, [
        DYCustomerToken
    ]);
    var filters = (0,react.useMemo)(function() {
        return (0,utils.getFilters)(variants, localeRegion, isPrivate);
    }, [
        variants,
        localeRegion,
        isPrivate
    ]);
    (0,react.useEffect)(function() {
        if (window.history.scrollRestoration !== "manual") {
            window.history.scrollRestoration = "manual";
        }
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isMounted) {
            if (firstLoad) {
                firstLoad = false;
            } else {
                updateQueryParams({
                    query: query,
                    activeFilters: activeFilters,
                    push: push
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMounted,
        activeFilters
    ]);
    (0,react.useEffect)(function() {
        // @ts-ignore
        if (!firstLoad) {
            setCurrentProducts({
                all: variants,
                current: (0,utils.getFilteredProducts)(variants, activeFilters)
            });
            setFeaturedFilters((0,utils.getFeaturedFilters)(activeFilters, filters === null || filters === void 0 ? void 0 : filters[0]));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMounted,
        activeFilters
    ]);
    // Get param filters from URL
    (0,react.useEffect)(function() {
        if (filters) {
            var incomingActiveFiltersFromUrl = (0,utils.getFiltersFromQuery)(asPath, filters[1]);
            //@ts-ignore
            setActiveFilters(incomingActiveFiltersFromUrl);
        }
    }, [
        filters,
        asPath
    ]);
    if (isFallback) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMarquee, {
                data: "Productos destacados"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "main-top"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shop.NavShop, {
                        categories: categories,
                        pageCategory: pageCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shop.SectionFilters, {
                        isScrolling: isScrolling,
                        filters: filters === null || filters === void 0 ? void 0 : filters[0],
                        activeFilters: activeFilters,
                        setActiveFilters: setActiveFilters,
                        resultsLength: currentProducts === null || currentProducts === void 0 ? void 0 : (ref = currentProducts.current) === null || ref === void 0 ? void 0 : ref.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shop.DynamicSectionFiltersFeatured, {
                        filters: featuredFilters
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shop.SectionProductList, {
                        products: currentProducts.current,
                        usualPurchases: true,
                        ga_list: {
                            id: "list_grid_user_usual_purchases",
                            name: "List user Usual Purchases (grid)"
                        },
                        categories: categories
                    }, "list-products-".concat(asPath))
                ]
            })
        ]
    });
});
var ShopSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionShop__ShopSection",
    componentId: "sc-28d80ada-0"
})(SectionShop_templateObject(), (0,styles.designGrid)({
    withoutGutter: true
}), styles.mq.greaterThan("tablet"));

;// CONCATENATED MODULE: ./components/contents/index.ts






;// CONCATENATED MODULE: ./components/ProductCard.tsx



function ProductCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  display:flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-start;\n  width: 100%;\n"
    ]);
    ProductCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 0;\n      width: 100%;\n    "
    ]);
    ProductCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        "px;\n      }\n    "
    ]);
    ProductCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 20px;\n  border: 2px solid ",
        ";\n  font-family: ",
        ";\n  height: ",
        ";\n  margin-right: ",
        ";\n  overflow: hidden;\n  position: relative;\n  transition: 200ms border-color linear;\n  width: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    margin-right: ",
        ";\n    width: ",
        ";\n\n    &.selected {\n      border-color: ",
        ";\n    }\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    height: ",
        ";\n    margin-right: ",
        ";\n    width: ",
        ";\n\n  }\n\n  ",
        " {\n    height: 360px;\n    margin-right: 5px;\n    width: ",
        ";\n  }\n\n  &.active,\n  &:hover {\n    button:first-of-type:not(button[disabled]) {\n      opacity: 1;\n    }\n  }\n\n  &.active {\n    .btn-add {\n      ",
        " {\n        opacity: 1;\n      }\n\n      &.insufficient-stock {\n        opacity: .4;\n\n        ",
        " {\n          opacity: .4 !important;\n        }\n      }\n    }\n  }\n\n  &.no-stock,\n  &.not-available {\n    &:hover {\n      .btn-add {\n        opacity: .4 !important;\n        pointer-events: none;\n        user-select: none;\n\n        ",
        " {\n          opacity: .4 !important;\n        }\n      }\n    }\n\n    .insufficient-stock:not(.selected-card) {\n      &[disabled] {\n        height: ",
        ";\n        margin-right: 0;\n        pointer-events: none;\n        width: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n          pointer-events: none;\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: ",
        ";\n          pointer-events: none;\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: 25px;\n          width: 80px;\n        }\n\n        > div:last-of-type {\n          ",
        "\n        }\n      }\n    }\n  }\n\n  > div {\n    height: 100%;\n  }\n\n  .frozen_product {\n    span {\n      background-color: #e1f2ff !important;\n    }\n\n    img {\n      mix-blend-mode: multiply;\n    }\n  }\n\n  .product-card-image {\n    height: ",
        ";\n    margin: 0 auto;\n    overflow: hidden;\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n    }\n\n    ",
        " {\n      height: 200px;\n    }\n\n    ",
        "\n\n    img {\n      height: 100%;\n      object-fit: ",
        ";\n      border-radius: 20px;\n\n      ",
        " {\n        object-fit: contain;\n      }\n\n      ",
        " {\n        object-fit: ",
        ";\n      }\n    }\n\n    .no-img {\n      background-color: #F7F7F7;\n      border: ",
        " solid ",
        ";\n      height: 100%;\n      margin: 0 auto;\n      width: 100%;\n\n      ",
        " {\n        border-width: ",
        ";\n      }\n\n      ",
        " {\n        border-width: ",
        ";\n      }\n\n      ",
        " {\n        border-width: 15px;\n      }\n    }\n  }\n"
    ]);
    ProductCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        " ",
        " 0;\n  width: inherit;\n\n  ",
        " {\n    padding: ",
        " ",
        " 0;\n  }\n\n  ",
        " {\n    padding: ",
        " ",
        " 0;\n  }\n\n  ",
        " {\n    padding: 9px 15px 0;\n  }\n\n  span {\n    ",
        "\n    color: ",
        ";\n    display: inline-block;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &:first-of-type {\n      ",
        "\n      color: ",
        ";\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 2px;\n      }\n    }\n  }\n\n\n  + div {\n    width: 100%;\n    margin-top:auto;\n\n  }\n"
    ]);
    ProductCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  overflow: hidden;\n  z-index: 10;\n  top: ",
        ";\n  right: ",
        ";\n  left: ",
        ";\n  min-height: ",
        ";\n\n  ",
        " {\n    top: ",
        ";\n    right: ",
        ";\n    left: ",
        ";\n    min-height: ",
        ";\n  }\n\n  ",
        " {\n    top: ",
        ";\n    right: ",
        ";\n    left: ",
        ";\n    min-height: ",
        ";\n  }\n\n  ",
        " {\n    top: 20px;\n    right: 15px;\n    left: 15px;\n    min-height: 25px;\n  }\n\n  .right {\n    display: flex;\n    float: right;\n    column-gap: ",
        ";\n    row-gap: ",
        ";\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      column-gap: ",
        ";\n      row-gap: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: ",
        ";\n      row-gap: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: 5px;\n      row-gap: 5px;\n      margin-bottom: 5px;\n    }\n\n    > * {\n      display: flex;\n      column-gap: ",
        ";\n\n      ",
        " {\n        column-gap: ",
        ";\n      }\n\n      ",
        " {\n        column-gap: ",
        ";\n      }\n\n      ",
        " {\n        column-gap: 5px;\n      }\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: ",
        ";\n          width: ",
        ";\n        }\n\n\n        ",
        " {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n  }\n\n  .cms {\n    display: inline-block;\n    max-width: ",
        ";\n\n    ",
        " {\n      max-width: ",
        ";\n    }\n\n    ",
        " {\n      max-width: ",
        ";\n    }\n\n    ",
        " {\n      max-width: 60px;\n    }\n  }\n\n  .cms > span,\n  .discount {\n    ",
        "\n    color: ",
        ";\n    text-transform: uppercase;\n    border-radius: ",
        ";\n    padding: ",
        " ",
        ";\n    max-height: ",
        ";\n\n    ",
        " {\n      border-radius: ",
        ";\n      padding: ",
        " ",
        ";\n      max-height: ",
        ";\n    }\n\n    ",
        " {\n      border-radius: ",
        ";\n      padding: ",
        " ",
        ";\n      max-height: ",
        ";\n    }\n\n    ",
        " {\n      border-radius: 12px;\n      padding: 5px 9px;\n      max-height: 25px;\n    }\n  }\n\n  .cms > span {\n    background-color: ",
        ";\n    float: left;\n    margin-right: ",
        ";\n\n    ",
        " {\n      margin-right: ",
        ";\n    }\n\n    ",
        " {\n      margin-right: ",
        ";\n    }\n\n    ",
        " {\n      margin-right: 5px;\n    }\n  }\n\n  .cms:first-of-type > span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &.narrow-card .cms:first-of-type > span {\n    ",
        " {\n      max-width: ",
        ";\n      margin-right: ",
        ";\n    }\n\n    ",
        " {\n      max-width: ",
        ";\n      margin-right: 5px;\n    }\n\n    ",
        " {\n      max-width: ",
        ";\n      margin-right: 5px;\n    }\n  }\n\n  &.wide-card .cms:first-of-type > span {\n    transition: 300ms max-width ",
        ";\n    max-width: ",
        ";\n\n    ",
        " {\n      max-width: ",
        ";\n    }\n\n    ",
        " {\n      max-width: ",
        ";\n    }\n\n    ",
        " {\n      max-width: ",
        ";\n    }\n  }\n  .discount {\n    background-color: ",
        ";\n  }\n\n  .filter-label {\n    display: flex;\n    column-gap: ",
        ";\n\n    ",
        " {\n      column-gap: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: ",
        ";\n    }\n\n    ",
        " {\n      column-gap: 5px;\n    }\n\n    img {\n      width: ",
        ";\n      height: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      ",
        " {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  &.narrow-card ~ .product__price:has(.discount)  {\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 5px;\n    }\n  }\n"
    ]);
    ProductCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












var getPricePerUnit = function(reference_price, reference_unit, round, locale) {
    return reference_price && reference_unit ? " • ".concat((0,utils.currencyFormatter)({
        price: reference_price,
        localeRegion: locale,
        round: round
    }), "/").concat(reference_unit) : null;
};
var FILTER_LABELS = {
    "sin-gluten": "/images/svg/label-sin-gluten.svg",
    "bio": "/images/svg/label-bio.svg",
    "fresh": "/images/svg/label-fresh.svg",
    "integral": "/images/svg/label-integral.svg",
    "vegano": "/images/svg/label-vegan.svg"
};
var getFilterLabels = function(filters, pathname, showTooltip, setShowTooltip) {
    return filters.map(function(filter, idx) {
        var isPDP = pathname === "/catalog/product/[slug]" || pathname === "/shop/product/[slug]";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter.param === "fresh" && {
            onMouseEnter: function() {
                setShowTooltip(true);
            },
            onMouseLeave: function() {
                setShowTooltip(false);
            }
        }), {
            className: "filter-label ".concat(filter.param === "fresh" ? "fresh" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: FILTER_LABELS[filter.param],
                    alt: "Filter label image"
                }),
                filter.param === "fresh" && isPDP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.ToolTip, {
                    showTooltip: showTooltip
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            ]
        }), idx);
    });
};
var productCardSizes = "(min-width: 768px) 30vw, 50vw";
var transformLabels = function(labels) {
    return labels.map(function(label) {
        return label.name;
    });
};
var getCMSLabels = function(labels) {
    return labels.map(function(label, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "cms",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            })
        }, idx);
    });
};
var ProductCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, _narrow = param.narrow, narrow = _narrow === void 0 ? false : _narrow, _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, _isLazy = param.isLazy, isLazy = _isLazy === void 0 ? true : _isLazy, pricePer = param.pricePer, _round = param.round, round = _round === void 0 ? false : _round, lastUnits = param.lastUnits;
    var ref, ref1;
    var product = data.product;
    var ref2 = (0,router.useRouter)(), localeRouter = ref2.locale, pathname = ref2.pathname;
    var locale = (0,utils.getLang)(localeRouter);
    var ref3 = (0,hooks/* useActiveVariant */.wT)(), activeVariant = ref3.activeVariant, cardSelected = ref3.cardSelected;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var linkPathname = pathname.includes("account") || pathname.includes("page") || pathname.includes("welcome") || pathname.includes("cart") ? "shop" : pathname === "/" ? "catalog" : pathname.split("/")[1];
    //dev HARDCODED
    var ref4 = (0,react.useState)(false), showTooltip = ref4[0], setShowTooltip = ref4[1];
    var ref5 = data || {}, variant_bigcommerce_id = ref5.bigcommerceId, media = ref5.media, variantName = ref5.name, price = ref5.price, _stock = ref5.stock, stock = _stock === void 0 ? 0 : _stock, stockWarning = ref5.stockWarning, minSaleUnits = ref5.minSaleUnits, _variantType = ref5.variantType, variantType = _variantType === void 0 ? "regular" : _variantType, deliveryType = ref5.deliveryType;
    var ref6 = product || {}, name = ref6.name, brand = ref6.brand, slug = ref6.slug, categories = ref6.categories, ingredients = ref6.ingredients, labels = ref6.labels, filters = ref6.filters, inventoryTracking = ref6.inventoryTracking;
    var ref7 = (0,react.useState)(false), hasUnitsInCart = ref7[0], setHasUnitsInCart = ref7[1];
    var isFrozenProduct = (0,react.useMemo)(function() {
        return deliveryType === "frozen";
    }, [
        deliveryType
    ]);
    // @ts-ignore
    var discount = (price || {}).discount;
    var FormattedLabels = (0,react.useMemo)(function() {
        return labels ? transformLabels(labels) : [];
    }, [
        labels
    ]);
    var labelsAsTags = (labels === null || labels === void 0 ? void 0 : labels.length) > 1 || (FormattedLabels === null || FormattedLabels === void 0 ? void 0 : (ref = FormattedLabels[0]) === null || ref === void 0 ? void 0 : ref.length) > 2;
    var LabelCMS = (0,react.useMemo)(function() {
        return labelsAsTags ? getCMSLabels(FormattedLabels) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        labelsAsTags,
        FormattedLabels
    ]);
    var LabelDiscount = (0,react.useMemo)(function() {
        return discount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "discount",
            children: [
                "-",
                discount,
                "%"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        discount
    ]);
    var PreselectFilters = (0,react.useMemo)(function() {
        return filters === null || filters === void 0 ? void 0 : filters.filter(function(item) {
            return FILTER_LABELS[item.param];
        });
    }, [
        filters
    ]);
    var LabelFilters = (0,react.useMemo)(function() {
        return (PreselectFilters === null || PreselectFilters === void 0 ? void 0 : PreselectFilters.length) > 0 ? getFilterLabels(PreselectFilters, pathname, showTooltip, setShowTooltip) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }, [
        PreselectFilters,
        pathname,
        showTooltip,
        setShowTooltip
    ]);
    var emptyCard = Object.keys(data).length === 0;
    var ref8 = (0,dist_hooks.useInView)({
        rootMargin: "0px",
        threshold: 0,
        triggerOnce: true
    }).ref;
    var ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
        "data-sku": data.sku,
        ref: ref8,
        className: "product-card".concat(variantType === "pack" ? " pack" : "").concat((cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id) === variant_bigcommerce_id ? " selected" : "").concat(hasUnitsInCart ? " active" : "").concat(customer && inventoryTracking && stock < minSaleUnits ? " no-stock" : price === null && stock > 0 ? " not-available" : "").concat( false ? 0 : ""),
        $pack: variantType === "pack",
        $narrow: narrow,
        $frozen: isFrozenProduct,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                variants: variants,
                initial: "on_exit",
                animate: "on_load",
                exit: "on_exit",
                children: !emptyCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                            href: "/".concat(linkPathname, "/product/").concat((ref9 = slug === null || slug === void 0 ? void 0 : slug[locale]) !== null && ref9 !== void 0 ? ref9 : ""),
                            onClick: onClick,
                            "aria-label": "show product",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard_LabelWrapper, {
                                    filterLabelCount: PreselectFilters === null || PreselectFilters === void 0 ? void 0 : PreselectFilters.length,
                                    hasDiscount: discount > 0,
                                    className: "".concat(!!activeVariant ? "narrow-card" : "wide-card"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "right",
                                            children: [
                                                isFrozenProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "filter-label",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/svg/label-fresh.svg",
                                                            alt: "frozen product"
                                                        })
                                                    })
                                                }),
                                                LabelDiscount,
                                                LabelFilters
                                            ]
                                        }),
                                        LabelCMS
                                    ]
                                }),
                                (media === null || media === void 0 ? void 0 : (ref1 = media[0]) === null || ref1 === void 0 ? void 0 : ref1.medium) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                    lazy: isLazy,
                                    className: "product-card-image ".concat(isFrozenProduct ? "frozen_product" : ""),
                                    media: media === null || media === void 0 ? void 0 : media[0].medium,
                                    sizes: productCardSizes,
                                    quality: 99
                                }, "card-img-".concat(variant_bigcommerce_id)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                    className: "product-card-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "no-img"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard_ProductInfo, {
                                    className: "product-card_info",
                                    $frozen: isFrozenProduct,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: name
                                        }),
                                        typeof brand === "object" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                brand === null || brand === void 0 ? void 0 : brand.name,
                                                " "
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: ingredients && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: ingredients
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: minSaleUnits > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    variantName ? variantName + " " + "x" : " ",
                                                    " ",
                                                    minSaleUnits,
                                                    " ",
                                                    t("product_page.product.units_abbr")
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: variantName
                                            })
                                        })
                                    ]
                                }),
                                price !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Price, {
                                    type: "card",
                                    price: price,
                                    className: "product__price",
                                    pricePer: pricePer,
                                    round: round,
                                    stockWarning: stockWarning,
                                    stock: stock,
                                    lastUnits: lastUnits,
                                    minSaleUnits: minSaleUnits
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* AddToCart */.o4, {
                            data: {
                                name: name,
                                brand: brand,
                                categories: categories,
                                variant: data
                            },
                            isPDP: false,
                            setHasUnitsInCart: setHasUnitsInCart,
                            notAvailable: price === null && stock > 0,
                            inventoryTracking: inventoryTracking,
                            frozen: isFrozenProduct
                        })
                    ]
                })
            })
        })
    });
});
var StyledLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductCard__StyledLink",
    componentId: "sc-4af95c58-0"
})(ProductCard_templateObject());
var Article = styled_components_browser_esm["default"].article.withConfig({
    displayName: "ProductCard__Article",
    componentId: "sc-4af95c58-1"
})(ProductCard_templateObject3(), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "#e1f2ff" : theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(277, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(175, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(277, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(175, "nexus7"), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "rgb(122, 134, 238)" : (0,styles.hex2Rgba)(theme.colors.red, .6);
}, function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "rgb(146, 156, 254)" : (0,styles.hex2Rgba)(theme.colors.darkcreme, .6);
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(360, "desktop"), (0,styles.vw)(5, "desktop"), function(param) {
    var $narrow = param.$narrow;
    return $narrow ? "".concat((0,styles.vw)(204, "desktop")) : "".concat((0,styles.vw)(261, "desktop"));
}, styles.mq.greaterThan("desktop"), function(param) {
    var $narrow = param.$narrow;
    return $narrow ? "204px" : "261px";
}, styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "mobile"), (0,styles.vw)(80, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), (0,styles.vw)(80, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), (0,styles.vw)(80, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP10_1)(), (0,styles.vw)(152, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(144, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(200, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $pack = param.$pack, $narrow = param.$narrow;
    return $pack ? (0,styled_components_browser_esm.css)(ProductCard_templateObject1()) : (0,styled_components_browser_esm.css)(ProductCard_templateObject2(), (0,styles.vw)(147, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(154, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)($narrow ? 175 : 220, "desktop"), styles.mq.greaterThan("desktop"), $narrow ? 175 : 220);
}, function(param) {
    var $pack = param.$pack;
    return $pack ? "cover" : "contain";
}, styles.mq.greaterThan("nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var $pack = param.$pack;
    return $pack ? "cover" : "contain";
}, (0,styles.vw)(10, "mobile"), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "#e1f2ff" : theme.colors.white;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"));
var ProductCard_ProductInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCard__ProductInfo",
    componentId: "sc-4af95c58-2"
})(ProductCard_templateObject4(), (0,styles.vw)(7, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(7, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(9, "desktop"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1)(), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "#616fc4" : theme.colors.red;
}, (0,styles.getP15)(), function(param) {
    var theme = param.theme, $frozen = param.$frozen;
    return $frozen ? "#11294e" : theme.colors.darkred;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(2, "desktop"), styles.mq.greaterThan("desktop"));
var ProductCard_LabelWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCard__LabelWrapper",
    componentId: "sc-4af95c58-3"
})(ProductCard_templateObject5(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(15, "mobile"), (0,styles.vw)(15, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(15, "nexus7"), (0,styles.vw)(15, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(15, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(24, "mobile"), (0,styles.vw)(24, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(24, "nexus7"), (0,styles.vw)(24, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(24, "desktop"), (0,styles.vw)(24, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(60, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP12_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,styles.vw)(12, "mobile"), (0,styles.vw)(5, "mobile"), (0,styles.vw)(9, "mobile"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), (0,styles.vw)(5, "nexus7"), (0,styles.vw)(9, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(5, "desktop"), (0,styles.vw)(9, "desktop"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
}, (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? (0,styles.vw)(75, "desktop") : (0,styles.vw)(120, "desktop") : filterLabelCount === 2 ? hasDiscount ? (0,styles.vw)(47, "desktop") : (0,styles.vw)(90, "desktop") : filterLabelCount === 3 && !hasDiscount ? (0,styles.vw)(65, "desktop") : filterLabelCount === 4 && !hasDiscount ? (0,styles.vw)(35, "desktop") : (0,styles.vw)(120, "desktop");
}, (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? "75px" : "120px" : filterLabelCount === 2 ? hasDiscount ? "47px" : "90px" : filterLabelCount === 3 && !hasDiscount ? "65px" : filterLabelCount === 4 && !hasDiscount ? "35px" : "120px";
}, styles.mq.greaterThan("desktop-wide"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? "65px" : "120px" : filterLabelCount === 2 ? hasDiscount ? "47px" : "90px" : filterLabelCount === 3 && !hasDiscount ? "65px" : filterLabelCount === 4 && !hasDiscount ? "35px" : "120px";
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? (0,styles.vw)(75, "mobile") : (0,styles.vw)(115, "mobile") : filterLabelCount === 2 ? hasDiscount ? (0,styles.vw)(47, "mobile") : (0,styles.vw)(87, "mobile") : (0,styles.vw)(140, "mobile");
}, styles.mq.greaterThan("nexus7"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? (0,styles.vw)(75, "nexus7") : (0,styles.vw)(115, "nexus7") : filterLabelCount === 2 ? hasDiscount ? (0,styles.vw)(47, "nexus7") : (0,styles.vw)(87, "nexus7") : (0,styles.vw)(140, "nexus7");
}, styles.mq.greaterThan("tablet"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? (0,styles.vw)(125, "desktop") : (0,styles.vw)(175, "desktop") : filterLabelCount === 2 ? hasDiscount ? (0,styles.vw)(100, "desktop") : (0,styles.vw)(150, "desktop") : filterLabelCount === 3 ? hasDiscount ? (0,styles.vw)(72, "desktop") : (0,styles.vw)(115, "desktop") : filterLabelCount === 4 ? hasDiscount ? (0,styles.vw)(45, "desktop") : (0,styles.vw)(90, "desktop") : (0,styles.vw)(200, "desktop");
}, styles.mq.greaterThan("desktop"), function(param) {
    var filterLabelCount = param.filterLabelCount, hasDiscount = param.hasDiscount;
    return filterLabelCount === 1 ? hasDiscount ? "125px" : "175px" : filterLabelCount === 2 ? hasDiscount ? "100px" : "150px" : filterLabelCount === 3 ? hasDiscount ? "72px" : "115px" : filterLabelCount === 4 ? hasDiscount ? "45px" : "90px" : "200px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(24, "mobile"), (0,styles.vw)(24, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(24, "nexus7"), (0,styles.vw)(24, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(24, "desktop"), (0,styles.vw)(24, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"));
// const Offer = styled.span`
//   background-color: ${({ theme }) => theme.colors.darkcreme};
//   color: white;
//   border-top-left-radius: 20px;
//   clip-path: polygon(0 0, 0% 100%, 100% 0);
//   width: ${vw(45, 'mobile')};
//   height: ${vw(45, 'mobile')};
//   position: absolute;
//   top: -2px;
//   left: -2px;
//   z-index: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   ${mq.greaterThan('nexus7')} {
//     height: ${vw(60, 'nexus7')};
//     width: ${vw(60, 'nexus7')};
//   }
//   ${mq.greaterThan('tablet')} {
//     height: ${vw(60, 'desktop')};
//     width: ${vw(60, 'desktop')};
//   }
//   ${mq.greaterThan('desktop')} {
//     height: 60px;
//     width: 60px;
//   }
//   span {
//     display: block;
//     ${getP12_1()}
//     text-transform: uppercase;
//     transform: rotate(-45deg) translateY(-80%);
//     ${mq.greaterThan('tablet')} {
//       transform: rotate(-45deg) translateY(-90%);
//     }
//   }
// `
var variants = {
    on_load: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .5
        })
    },
    on_exit: {
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .5
        })
    }
};

;// CONCATENATED MODULE: ./components/LoadingScreen.tsx

function LoadingScreen_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  bottom: 0;\n  color: white;\n  display: flex;\n  height: 100vh;\n  height: 100dvh;\n  justify-content: center;\n  left: 0;\n  opacity: ",
        ";\n  pointer-events: ",
        ";\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: 150ms all ease-out;\n  user-select: ",
        ";\n  visibility: ",
        ";\n  width: 100vw;\n  width: 100dvw;\n  z-index: ",
        ";\n\n  .loader,\n  .loader:before,\n  .loader:after {\n    background: ",
        ";\n    animation: load1 1s infinite ease-in-out;\n    width: .3em;\n    height: 20em;\n  }\n\n  .loader {\n    animation-delay: -.16s;\n    color: ",
        ";\n    position: relative;\n    text-indent: -9999em;\n    transform: translateZ(0);\n    pointer-events: none;\n\n    &:before,\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n    }\n\n    &:before {\n      animation-delay: -.32s;\n      left: -1.5em;\n    }\n\n    &:after {\n      left: 1.5em;\n    }\n  }\n\n  @keyframes load1 {\n    0%,\n    80%,\n    100% {\n      box-shadow: 0 0;\n      height: 20em;\n    }\n    40% {\n      box-shadow: 0 -2em;\n      height: 17em;\n    }\n  }\n"
    ]);
    LoadingScreen_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var LoadingScreen = /*#__PURE__*/ (0,react.memo)(function(param) {
    var isActive = param.isActive;
    var someModalIsActive = (0,dist_hooks.useModal)(context.MODALS.MENU).someModalIsActive;
    (0,react.useEffect)(function() {
        document.body.style.overflow = isActive || someModalIsActive ? "hidden" : "initial";
    }, [
        isActive,
        someModalIsActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen_Div, {
        $isActive: isActive,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "loader"
        })
    });
});
var LoadingScreen_Div = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "LoadingScreen__Div",
    componentId: "sc-17d3ba44-0"
})(LoadingScreen_templateObject(), function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, .95);
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? 1 : 0;
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "auto" : "none";
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "auto" : "none";
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "visible" : "hidden";
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? 9999 : -1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.colors.creme;
});

;// CONCATENATED MODULE: ./components/index.ts

















/***/ }),

/***/ 99361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ../commons/dist/context/index.js
var context = __webpack_require__(7693);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ./components/index.ts + 74 modules
var components_0 = __webpack_require__(83242);
;// CONCATENATED MODULE: ./components/layout/nav/Burger.tsx
"use client";

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: ",
        ";\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    display: none;\n  }\n\n  figure {\n    width: ",
        ";\n\n    ",
        " {\n     width: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var closeMenuIcon = {
    type: "svg",
    src: "/images/svg/i--burger-close.svg",
    alt: "Close modal icon",
    size: {
        width: 12,
        height: 12
    }
};
var burgerIcon = {
    type: "svg",
    src: "/images/svg/i--burger.svg",
    alt: "Burger menu icon",
    size: {
        width: 12,
        height: 12
    }
};
var Burger = function(param) {
    var _menuOpen = param.menuOpen, menuOpen = _menuOpen === void 0 ? false : _menuOpen, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        type: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
            media: menuOpen ? closeMenuIcon : burgerIcon,
            fill: false
        })
    });
};
var Button = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Burger__Button",
    componentId: "sc-25dd726b-0"
})(_templateObject(), (0,styles.vw)(39, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(39, "tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(17, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "tablet"));

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(88241);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./components/layout/layoutVariants.ts



var menuUlVariants = {
    inactive: (0,_object_spread/* default */.Z)({
        opacity: 0
    }, (0,styles.getTransition)()),
    active: {
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            staggerChildren: .01
        })
    },
    exit: (0,_object_spread/* default */.Z)({
        opacity: 0
    }, (0,styles.getTransition)())
};
var menuListVariants = {
    inactive: (0,_object_spread/* default */.Z)({
        x: -10,
        opacity: 0
    }, (0,styles.getTransition)()),
    active: (0,_object_spread/* default */.Z)({
        x: 0,
        opacity: 1
    }, (0,styles.getTransition)()),
    exit: {
        opacity: 0
    }
};
var userLoggedInVariants = {
    enter: {
        x: "100%",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5))
    },
    animate: {
        x: "0%",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5))
    },
    exit: {
        x: "100%",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.5))
    }
};
var firstNameVariants = {
    initial: {
        width: 0,
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.3))
    },
    animate: {
        width: "100%",
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.3))
    },
    exit: {
        width: 0,
        transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)(.3))
    }
};

// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
;// CONCATENATED MODULE: ./components/layout/nav/Navbar.tsx
"use client";




function Navbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &.loading {\n    pointer-events: none;\n    user-select: none;\n  }\n"
    ]);
    Navbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  height: ",
        ";\n  position: fixed;\n  transition: 300ms background-color ease-out, 300ms box-shadow ease-out;\n  width: 100vw;\n  z-index: 600;\n  font-family: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n  }\n\n  ",
        " {\n    background-color: ",
        ";\n    color: ",
        ";\n    height: ",
        ";\n  }\n\n  ",
        " {\n    height: 120px;\n  }\n\n  ul {\n    margin: 0;\n  }\n\n  > ul {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: flex-start;\n    margin: 0;\n    position: relative;\n    width: 100%;\n\n    ",
        " {\n      margin: 0 auto;\n      max-width: 1650px;\n    }\n\n    &:before {\n      background-color: ",
        ";\n      content: '';\n      height: 100%;\n      pointer-events: none;\n      position: absolute;\n      user-select: none;\n      width: ",
        ";\n      transition: 300ms width ease-out;\n      z-index: -1;\n\n      ",
        " {\n        background-color: ",
        ";\n      }\n    }\n\n    li:not(.li--links li) {\n      &:first-child {\n        ",
        " {\n          display: none;\n        }\n      }\n    }\n  }\n\n  li {\n    align-items: center;\n    display: flex;\n    height: 100%;\n  }\n\n  .li--logo {\n    margin: ",
        " auto 0;\n    user-select: none;\n\n    ",
        " {\n      margin: ",
        " auto 0;\n    }\n\n    ",
        " {\n      margin: ",
        " ",
        " 0 ",
        ";\n    }\n\n    ",
        " {\n      margin: 12px 30px 0 50px;\n    }\n\n    &.no-cart {\n      transform: translateX(-",
        ");\n\n      ",
        " {\n        transform: translateX(-",
        ");\n      }\n\n      ",
        " {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  .li--links {\n    display: none;\n\n    ",
        " {\n      align-items: center;\n      display: flex;\n      justify-content: flex-start;\n    }\n\n    ul, li {\n      align-items: center;\n      display: flex;\n      justify-content: flex-start;\n    }\n\n    li {\n      ",
        " {\n        margin: 0 ",
        ";\n      }\n\n      ",
        " {\n        margin: 0 15px;\n      }\n    }\n\n    a, button {\n      ",
        "\n      ",
        "\n    }\n  }\n\n  .li--location {\n    display: flex;\n\n    ",
        " {\n      margin: 0 ",
        ";\n    }\n\n    ",
        " {\n      margin: 0 16px;\n    }\n\n    button {\n      font-weight: 500;\n    }\n\n    figure {\n      margin-right: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        margin-right: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 10px;\n        width: 14px;\n      }\n    }\n\n    span {\n      display: none;\n\n      ",
        " {\n        max-width: ",
        ";\n      }\n\n      ",
        " {\n        display: inline-block;\n        line-height: normal !important;\n        max-width: ",
        ";\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      ",
        " {\n        max-width: 136px;\n      }\n    }\n  }\n\n  .li--account,\n  .li--cart {\n    a,\n    button {\n      align-items: center;\n      display: flex;\n      height: 100%;\n      justify-content: center;\n      position: relative;\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        min-width: ",
        ";\n        width: unset;\n      }\n\n      ",
        " {\n        min-width: 50px;\n      }\n    }\n  }\n\n  .li--location,\n  .li--account,\n  .li--cart {\n    ",
        " {\n    order: 2;\n    }\n\n    span:not(.quantity) {\n      ",
        "\n    }\n\n    figure {\n      flex-shrink: 0;\n    }\n  }\n\n  .li--cart,\n  .li--account {\n    &.slot {\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: auto;\n      }\n    }\n\n    &:last-of-type {\n      ",
        " {\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 40px;\n      }\n    }\n  }\n\n  .li--account {\n    button {\n      margin-right:  unset;\n\n      ",
        " {\n        margin-right:  ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 20px;\n      }\n    }\n\n    .firstname {\n      display: none;\n\n      ",
        " {\n        ",
        "\n        display: inline-block;\n        max-width: 9vw;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    figure {\n      margin-right: ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        margin-right: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        width: 18px;\n        margin-right: 10px;\n      }\n    }\n\n    .account_s {\n      display: none;\n\n      ",
        " {\n        display: block;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .li--cart {\n    figure {\n      width: ",
        ";\n      margin-right: ",
        ";\n\n      ",
        " {\n        margin-right: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 0;\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 20.7px;\n        margin-right: 0;\n      }\n    }\n  }\n\n  .li--logo {\n    figure {\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 184px;\n      }\n    }\n  }\n\n  .li--search {\n    ",
        " {\n      margin: 0 ",
        " 0 auto;\n      order: 1;\n    }\n\n    ",
        " {\n      margin: 0 15px 0 auto;\n    }\n\n    figure {\n      width: ",
        ";\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: ",
        ";\n      }\n\n      ",
        " {\n        width: 20.7px;\n      }\n    }\n  }\n\n  p {\n    margin: 0;\n  }\n\n  button,\n  a {\n    align-items: center;\n    color: inherit;\n    display: flex;\n    text-decoration-color: transparent;\n    transition: 300ms color ease-out, 300ms text-decoration-color ease-out;\n\n    &:hover {\n      text-decoration-color: white;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  bottom: 20%;\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n  opacity: 0;\n  opacity: ",
        ";\n  position: absolute;\n  pointer-events: none;\n  right: 5%;\n  transition: 250ms opacity ",
        ", 250ms border-color ",
        ";\n  user-select: none;\n  width: ",
        ";\n\n  ",
        " {\n    bottom: 38%;\n    height: ",
        ";\n    right: 18%;\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: 8px;\n    width: 8px;\n  }\n\n  .quantity {\n    ",
        "\n    margin-left: 0;\n    color: white;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: nowrap;\n\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var accountIcon = function(fillColor, onHover) {
    return {
        type: "svg",
        src: "/images/svg/i--account".concat(onHover ? "--creme" : fillColor === "white" ? "--white" : "", ".svg"),
        alt: "User account icon",
        size: {
            width: 18,
            height: 18
        }
    };
};
var cartIcon = function(fillColor) {
    return {
        type: "svg",
        src: "/images/svg/i--cart".concat(fillColor === "white" ? "--white" : "", ".svg"),
        alt: "Cart icon",
        size: {
            width: 21,
            height: 18
        }
    };
};
var logo = function() {
    var fillColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "darkred";
    return {
        type: "svg",
        src: "/images/svg/logo".concat(fillColor === "white" ? "--white" : "", ".svg"),
        alt: "Logo",
        size: {
            width: 261,
            height: 66
        }
    };
};
var locationIcon = {
    type: "svg",
    src: "/images/svg/i--location.svg",
    alt: "Location icon",
    size: {
        width: 14,
        height: 18
    }
};
var NavLinkAccount = function(param) {
    var fillColor = param.fillColor;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,dist_hooks.useModal)(context.MODALS.AUTH), toggleModalAuth = ref.toggle;
    var ref1 = (0,dist_hooks.useModal)(context.MODALS.MENU_ACCOUNT), toggleModalMenuAccount = ref1.toggle;
    var isMobile = (0,dist_hooks.useDeviceType)().isMobile;
    var ref2 = (0,react.useState)(false), onHover = ref2[0], setOnHover = ref2[1];
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var clickAction = (0,react.useMemo)(function() {
        return !!customer && isMobile ? toggleModalMenuAccount : toggleModalAuth;
    }, [
        isMobile,
        customer,
        toggleModalMenuAccount,
        toggleModalAuth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: !isMobile && customer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.a */.E.a, {
            href: "/account/orders",
            title: t("layout.nav.account.name"),
            className: "account",
            variants: userLoggedInVariants,
            initial: "initial",
            exit: "exit",
            animate: "animate",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: accountIcon(fillColor, onHover),
                    fill: false
                }),
                customer.firstName && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                    className: "firstname",
                    initial: "initial",
                    animate: "animate",
                    exit: "exit",
                    variants: firstNameVariants,
                    children: customer.firstName
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.button */.E.button, {
            onClick: clickAction,
            title: "Account",
            className: "account",
            variants: userLoggedInVariants,
            initial: "initial",
            exit: "exit",
            animate: "animate",
            onMouseEnter: function() {
                return setOnHover(!!customer);
            },
            onMouseLeave: function() {
                return setOnHover(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: accountIcon(fillColor, onHover),
                    fill: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "account_s",
                    children: t("layout.nav.account.name")
                })
            ]
        })
    });
};
var NavLinkCart = function(param) {
    var _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "red" : _fillColor;
    var cartLines = (0,dist_hooks.useCart)().cartLines;
    var ref = (0,dist_hooks.useModal)(context.MODALS.AUTH), toggleAuth = ref.toggle;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!customer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartLink, {
            href: "https://".concat(utils.HOSTNAME, "/cart?d=").concat(Date.now()),
            title: "Cart icon",
            className: "cart",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: cartIcon(fillColor),
                    fill: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsInCartCircle, {
                    visible: cartLines.length > 0 ? true : false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "quantity",
                        children: cartLines === null || cartLines === void 0 ? void 0 : cartLines.length
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: toggleAuth,
            title: "Cart icon",
            className: "cart",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                media: cartIcon(fillColor),
                fill: false
            })
        })
    });
};
var Navbar = /*#__PURE__*/ (0,react.memo)(function(param) {
    var firstCategory = param.firstCategory, setShowCart = param.setShowCart, hasBanners = param.hasBanners;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, locale = ref.locale;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var scrollPos = (0,dist_hooks.useScrollTracker)(1);
    var ref1 = (0,react.useState)(""), storeLocation = ref1[0], setStoreLocation = ref1[1];
    var navbarRef = (0,react.useRef)(null);
    var ref2 = (0,dist_hooks.useDeviceType)(), deviceSize = ref2.size;
    var scrollTop = (0,react.useMemo)(function() {
        return scrollPos === "TOP";
    }, [
        scrollPos
    ]);
    var animate = (0,react.useMemo)(function() {
        return deviceSize.width < 603 ? scrollTop ? "mobile" : "mobileCompact" : deviceSize.width >= 603 && deviceSize.width < 768 ? scrollTop ? "nexus7" : "nexus7Compact" : scrollTop ? "initial" : "desktopCompact";
    }, [
        scrollTop,
        deviceSize.width
    ]);
    var ref3 = (0,dist_hooks.useModal)(context.MODALS.MENU), isActiveModalMenu = ref3.isActive, toggleModalMenu = ref3.toggle;
    var ref4 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleRegion = ref4.toggle;
    var fillColor = (0,react.useMemo)(function() {
        return !isActiveModalMenu || deviceSize.width >= 768 ? "darkred" : "white";
    }, [
        isActiveModalMenu,
        deviceSize
    ]);
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    (0,react.useEffect)(function() {
        var cookieCatalogRegion = utils.cookie.get("DY_CATALOG_REGION");
        var countryCode = "ES";
        function getCurrentLocation() {
            return _getCurrentLocation.apply(this, arguments);
        }
        function _getCurrentLocation() {
            _getCurrentLocation = (0,_async_to_generator/* default */.Z)(function() {
                var ref, data, dataArr, incomingLocation;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__(97820)("./".concat(countryCode, "-subdivisions.json"))
                            ];
                        case 1:
                            data = _state.sent();
                            dataArr = Array.from(data);
                            incomingLocation = (ref = dataArr.filter(function(item) {
                                return item.value === cookieCatalogRegion.toUpperCase();
                            })) === null || ref === void 0 ? void 0 : ref[0];
                            // @ts-ignore
                            setStoreLocation(incomingLocation ? incomingLocation.name : "Espa\xf1a");
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCurrentLocation.apply(this, arguments);
        }
        if (storeLocation) return;
        else if (utils.getStoreByLocale[locale]) {
            var store = utils.getStoreByLocale[locale];
            setStoreLocation(store);
        } else if (!cookieCatalogRegion) {
            var store1 = utils.getStoreByLocale[locale];
            setStoreLocation(store1 !== null && store1 !== void 0 ? store1 : "Espa\xf1a");
            return;
        } else getCurrentLocation();
    }, [
        locale,
        setStoreLocation,
        storeLocation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavStyled, {
        role: "navigation",
        ref: navbarRef,
        $isMenuActive: isActiveModalMenu,
        $scrollTop: scrollPos === "TOP",
        variants: navVariants({
            mq: deviceSize === null || deviceSize === void 0 ? void 0 : deviceSize.width,
            hasBanners: hasBanners
        }),
        initial: "initial",
        animate: animate,
        $boxShadow: pathname !== "/shop/[...slug]" && pathname !== "/catalog/[...slug]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                        onClick: toggleModalMenu,
                        menuOpen: isActiveModalMenu
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--search",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_0.ButtonTriggerSearch, {
                        fillColor: fillColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--logo".concat(!customer ? " no-cart" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                        href: "/",
                        title: t("layout.nav.home.name"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: logo(fillColor),
                            fill: false
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--links",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                    href: "/catalog/".concat(firstCategory),
                                    children: customer ? t("layout.nav.shop.name") : t("layout.nav.products.name")
                                })
                            }),
                            !customer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                            href: t("layout.nav.about_us.pathname"),
                                            children: t("layout.nav.about_us.name")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                            href: t("layout.nav.events.pathname"),
                                            children: t("layout.nav.events.name")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                            href: t("layout.nav.catalogue.pathname"),
                                            children: t("layout.nav.catalogue.name")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                            href: t("layout.nav.contact_us.pathname"),
                                            children: t("layout.nav.contact_us.name")
                                        })
                                    })
                                ]
                            }),
                            customer && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                                    href: t("layout.nav.my_usuals.pathname"),
                                    children: t("layout.nav.my_usuals.name")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--location",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: toggleRegion,
                        title: "Region",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                                media: locationIcon,
                                fill: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: storeLocation
                            })
                        ]
                    })
                }),
                utils.DY_LOGIN_ALLOWED && (locale === "es-CT" || locale === "es-MD") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--account",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinkAccount, {
                        fillColor: fillColor
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--account slot"
                }),
                customer && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "li--cart",
                    onMouseEnter: function() {
                        if (pathname !== "/cart") setShowCart(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLinkCart, {
                        fillColor: fillColor
                    })
                })
            ]
        })
    });
});
var CartLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "Navbar__CartLink",
    componentId: "sc-28aea5b-0"
})(Navbar_templateObject());
var NavStyled = (0,styled_components_browser_esm["default"])(motion/* motion.nav */.E.nav).withConfig({
    displayName: "Navbar__NavStyled",
    componentId: "sc-28aea5b-1"
})(_templateObject1(), function(param) {
    var $isMenuActive = param.$isMenuActive, theme = param.theme;
    return $isMenuActive ? theme.colors.red : theme.colors.background;
}, function(param) {
    var $isMenuActive = param.$isMenuActive, $scrollTop = param.$scrollTop, $boxShadow = param.$boxShadow, colors = param.theme.colors;
    return $boxShadow && !$scrollTop && !$isMenuActive ? "0 4px 40px 0 ".concat((0,styles.hex2Rgba)(colors.black, .1)) : "none";
}, function(param) {
    var $isMenuActive = param.$isMenuActive, theme = param.theme;
    return theme.colors[$isMenuActive ? "white" : "red"];
}, (0,styles.vw)(60, "mobile"), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(120, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("desktop-wide"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var $scrollTop = param.$scrollTop, $isMenuActive = param.$isMenuActive;
    return !$isMenuActive || !$scrollTop && $isMenuActive ? 0 : "100vw";
}, styles.mq.greaterThan("tablet"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(14, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(14, "nexus7"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.createUnderline)({
    color: "red",
    height: 2
}), styles.getP17NavLinks, styles.mq.greaterThan("tablet"), (0,styles.vw)(16, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(14, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(14, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(136, "desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(136, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(39, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(39, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.getP18_2)(), (0,styles.vw)(39, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(39, "nexus7"), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.getP18_3)(), (0,styles.vw)(10, "mobile"), (0,styles.vw)(21, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(21, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(18, "desktop"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(21.7, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(123, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(123, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(184, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(21.7, "desktop"), styles.mq.greaterThan("desktop"));
var ItemsInCartCircle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Navbar__ItemsInCartCircle",
    componentId: "sc-28aea5b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.orange;
}, function(param) {
    var theme = param.theme;
    return theme.colors.orange;
}, (0,styles.vw)(15, "mobile"), function(param) {
    var visible = param.visible;
    return visible ? 1 : 0;
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(8, "desktop"), (0,styles.vw)(8, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP9)(), styles.mq.greaterThan("tablet"));
var navVariants = function(param) {
    var _$mq = param.mq, hasBanners = param.hasBanners;
    return {
        mobile: {
            height: (0,styles.vw)(hasBanners ? 100 : 80, "mobile"),
            paddingTop: hasBanners ? "40px" : 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        },
        mobileCompact: {
            height: (0,styles.vw)(60, "mobile"),
            paddingTop: 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        },
        nexus7: {
            height: (0,styles.vw)(hasBanners ? 100 : 80, "nexus7"),
            paddingTop: hasBanners ? "40px" : 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        },
        nexus7Compact: {
            height: (0,styles.vw)(60, "nexus7"),
            paddingTop: 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        },
        initial: {
            height: _$mq > 1440 ? "120px" : (0,styles.vw)(120, "desktop"),
            paddingTop: hasBanners ? _$mq > 1440 ? "30px" : (0,styles.vw)(30, "desktop") : 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        },
        desktopCompact: {
            height: _$mq > 1440 ? "80px" : (0,styles.vw)(80, "desktop"),
            paddingTop: 0,
            transition: (0,_object_spread/* default */.Z)({}, (0,styles.getTransition)())
        }
    };
};

// EXTERNAL MODULE: ./components/forms/FormNewsletter.tsx
var FormNewsletter = __webpack_require__(17482);
;// CONCATENATED MODULE: ./components/layout/footer/SectionNewsletter.tsx

function SectionNewsletter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 9 / span 4;\n    margin-bottom: 0;\n  }\n\n  h2 {\n    ",
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: left;\n    margin-bottom: 0;\n\n  }\n\n  .input--newsletter {\n    width: ",
        ";\n\n    ",
        " {\n      width:100%;\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 240px;\n    }\n\n    > input {\n      ",
        "\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n\n  button {\n    ",
        "\n    cursor: pointer;\n\n    height: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 43px;\n      width: 95px;\n    }\n  }\n"
    ]);
    SectionNewsletter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SectionNewsletter = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormNewsletter/* FormNewsletter */.G, {})
    });
});
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionNewsletter__Section",
    componentId: "sc-f359aacc-0"
})(SectionNewsletter_templateObject(), (0,styles.vw)(60, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.getP26)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, (0,styles.vw)(286, "mobile"), styles.mq.greaterThan("nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(240, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, (0,styles.getP15_1B)(), (0,styles.vw)(50, "mobile"), (0,styles.vw)(74, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(74, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(43, "desktop"), (0,styles.vw)(95, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/layout/footer/SectionPages.tsx

function SectionPages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 4 / span 3;\n  padding: 0;\n\n  ",
        " {\n    align-items: flex-end;\n    grid-column: 6 / span 2;\n    grid-row: 1 / span 2;\n  }\n\n  .list--pages {\n    align-self: flex-end;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    list-style-type: none;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 0;\n    }\n\n    li {\n      align-items: center;\n      display: flex;\n      margin-bottom: ",
        ";\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 15px;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      color: ",
        ";\n      display: inline-block;\n      font-family: ",
        ";\n      ",
        "\n      font-size: ",
        ";\n      opacity: 1;\n      text-decoration: none;\n      transition: 300ms opacity ease-out;\n\n      ",
        " {\n        font-size: ",
        ";\n      }\n\n      ",
        " {\n        font-size: ",
        ";\n      }\n\n      ",
        " {\n        font-size: 15px;\n      }\n\n      &:hover {\n        opacity: .4;\n      }\n    }\n  }\n"
    ]);
    SectionPages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var pathGenerator = {
    "content": function(slug) {
        return "/page/".concat(slug);
    },
    "simple": function(slug) {
        return "/page/".concat(slug);
    },
    "faqs": function(slug) {
        return slug ? "/faqs/".concat(slug) : "/faqs";
    },
    "product": function(slug) {
        return "/product/".concat(slug);
    },
    "shop": function(slug) {
        return "/shop/".concat(slug);
    },
    "category": function(slug) {
        return "/shop/".concat(slug);
    }
};
var getPagesLink = function(pages, lang) {
    return pages.map(function(page, idx) {
        var type = page.type, title = page.title, _url = page.url, pageType = _url.page, slug = _url.slug;
        if (!title || title.indexOf("translation missing") !== -1) return null;
        var path = pathGenerator[pageType] ? pathGenerator[pageType](slug === null || slug === void 0 ? void 0 : slug[lang]) : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: type === "external" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: slug[lang],
                rel: "noreferrer",
                target: "_blank",
                title: title,
                children: title
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: path.includes("cookies") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: path,
                    title: title,
                    children: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                    href: path || "/",
                    title: title,
                    children: title
                })
            })
        }, "footer-pages-".concat(idx));
    });
};
var SectionPages = /*#__PURE__*/ (0,react.memo)(function(param) {
    var pages = param.pages;
    var ref = (0,router.useRouter)(), routerLocale = ref.locale;
    var lang = (0,utils.getLang)(routerLocale);
    var Pages = (0,react.useMemo)(function() {
        return getPagesLink(pages, lang);
    }, [
        pages,
        lang
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionPages_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "list--pages",
            children: Pages
        })
    });
});
var SectionPages_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionPages__Section",
    componentId: "sc-32f0209d-0"
})(SectionPages_templateObject(), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, (0,styles.getP15_1)(), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/layout/footer/CallUs.tsx

function CallUs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  ",
        "\n  grid-column: 1 / span 4;\n  letter-spacing: -.23px;\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    grid-column: 1 / span 6;\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    ",
        "\n    grid-column: 9 / span 4;\n    letter-spacing: -.3px;\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: 60px;\n  }\n\n  a {\n    ",
        "\n\n    &.phone {\n      ",
        "\n    }\n  }\n\n  .phone {\n    ",
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    display: inline-block;\n    margin-top: ",
        ";\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 15px;\n    }\n  }\n"
    ]);
    CallUs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CallUs = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,hooks/* useTranslator */.I4)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Div, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t("layout.footer.questions"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: utils.NEXT_PUBLIC_LOCALE === "fr-FR" ? "".concat(t("layout.footer.email")) : "mailto:".concat(t("layout.footer.email")),
                        children: t("layout.footer.write_us")
                    }),
                    " ",
                    t("layout.footer.call_us"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "tel:+".concat(t("layout.footer.phone_link")),
                className: "phone",
                children: t("layout.footer.phone_number")
            })
        ]
    });
});
var Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CallUs__Div",
    componentId: "sc-57417730-0"
})(CallUs_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, (0,styles.getP20_Mobile)(), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.getP26_1)(), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.createUnderline)({
    color: "white",
    reverse: true
}), (0,styles.createUnderline)({
    color: "creme",
    height: 3
}), (0,styles.getP53)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/layout/footer/List.tsx

function List_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    grid-column: 1 /span 3;\n    grid-row: 3;\n  }\n\n  ",
        " {\n    grid-column: 2 / span 4;\n    grid-row: 1 / span 2;\n  }\n\n  li {\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 15px;\n    }\n  }\n\n  a {\n    ",
        "\n    color: ",
        ";\n    display: inline-block;\n    font-family: ",
        ";\n    padding-bottom: 4px;\n\n    ",
        " {\n      font-weight: bold;\n      padding: 0 ",
        ";\n      position: relative;\n    }\n\n    ",
        " {\n      padding: 0 15px;\n    }\n\n    &.active {\n      border-bottom: 0;\n      color: ",
        ";\n      text-decoration: none;\n    }\n\n    > span {\n      right: ",
        ";\n      max-width: calc(100% - ",
        ");\n    }\n  }\n"
    ]);
    List_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var NavItemList = (0,styled_components_browser_esm["default"])(motion/* motion.ul */.E.ul).withConfig({
    displayName: "List__NavItemList",
    componentId: "sc-225b31da-0"
})(List_templateObject(), styles.mq.greaterThan("nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP53)(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,styles.vw)(30, "desktop"), (0,styles.vw)(30, "desktop"));
var getListItems = function(links, pathname, locale, firstCategory) {
    var Links = [];
    for(var idx = 0; idx < links.length; idx++){
        var ref;
        var linkData = links[idx];
        var name = linkData.name, slug = linkData.slug, type = linkData.type;
        var isShopLink = slug === "/shop" || slug === "/catalog";
        if (isShopLink && firstCategory && "object" !== "undefined") {
            var ref1;
            //@ts-ignore
            window.NO_URL_KLK = "/catalog/".concat((ref1 = firstCategory.slug) === null || ref1 === void 0 ? void 0 : ref1[locale]);
        }
        Links.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.li */.E.li, {
            variants: menuListVariants,
            children: type === "external" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: slug,
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: isShopLink && firstCategory ? "/catalog/".concat((ref = firstCategory.slug) === null || ref === void 0 ? void 0 : ref[locale]) : slug,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: pathname.includes(slug) ? "active" : "",
                    children: name
                })
            })
        }, idx));
    }
    return Links;
};
var List = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _firstCategory = param.firstCategory, firstCategory = _firstCategory === void 0 ? null : _firstCategory;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref = (0,router.useRouter)(), routerLocale = ref.locale, pathname = ref.pathname;
    var locale = routerLocale.split("-")[0];
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var fakeList = (0,react.useMemo)(function() {
        if (customer) {
            return [
                {
                    name: t("layout.nav.shop.name"),
                    slug: t("layout.nav.shop.pathname")
                },
                {
                    name: t("layout.nav.my_usuals.name"),
                    slug: t("layout.nav.my_usuals.pathname")
                }
            ];
        } else {
            return [
                {
                    name: t("layout.nav.products.name"),
                    slug: t("layout.nav.products.pathname")
                },
                {
                    name: t("layout.nav.catalogue.name"),
                    slug: t("layout.nav.catalogue.pathname")
                },
                {
                    name: t("layout.nav.contact_us.name"),
                    slug: t("layout.nav.contact_us.pathname")
                }
            ];
        }
    }, [
        t,
        customer
    ]);
    var ListItems = (0,react.useMemo)(function() {
        return getListItems(fakeList, pathname, locale, firstCategory);
    }, [
        pathname,
        firstCategory,
        locale,
        fakeList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItemList, {
        className: "nav-list",
        initial: "inactive",
        animate: "active",
        exit: "exit",
        variants: menuUlVariants,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.li */.E.li, {
                variants: menuListVariants,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: pathname === "/" ? "active" : "",
                        children: t("layout.nav.home.name")
                    })
                })
            }),
            ListItems
        ]
    });
});

;// CONCATENATED MODULE: ./components/layout/footer/PreFooter.tsx

function PreFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: hidden;\n"
    ]);
    PreFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DynamicMarquee = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 17566, 23)).then(function(mod) {
        return mod.Marquee;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17566)
            ];
        }
    },
    ssr: false
});
var PreFooter = /*#__PURE__*/ (0,react.memo)(function(param) {
    var services = param.services;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMarquee, {
            data: services.replace(/&nbsp;/g, " ")
        })
    });
});
var Aside = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "PreFooter__Aside",
    componentId: "sc-498b998f-0"
})(PreFooter_templateObject());

;// CONCATENATED MODULE: ./components/layout/footer/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  > div {\n    ",
        "\n    background-color: ",
        ";\n    padding: ",
        " ",
        " ",
        ";\n    position: relative;\n    z-index: 2;\n    ",
        " {\n      padding: ",
        " ",
        " ",
        ";\n    }\n\n    ",
        " {\n      padding: ",
        " 0 ",
        ";\n    }\n\n    ",
        " {\n      padding: 100px 0 60px;\n    }\n\n    ",
        " {\n      margin: 0 auto;\n      max-width: 1650px;\n    }\n  }\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var DynamicSectionRrss = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7847).then(__webpack_require__.bind(__webpack_require__, 77847));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77847)
            ];
        }
    }
});
var Footer = function(param) {
    var _pages = param.pages, pages = _pages === void 0 ? [] : _pages, _firstCategory = param.firstCategory, firstCategory = _firstCategory === void 0 ? null : _firstCategory, _services = param.services, services = _services === void 0 ? "" : _services;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            services && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreFooter, {
                services: services
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStyled, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUs, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionNewsletter, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            firstCategory: firstCategory
                        }),
                        (pages === null || pages === void 0 ? void 0 : pages.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionPages, {
                            pages: pages
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionRrss, {})
                    ]
                })
            })
        ]
    });
};
var FooterStyled = styled_components_browser_esm["default"].footer.withConfig({
    displayName: "Footer__FooterStyled",
    componentId: "sc-5f013a56-0"
})(Footer_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.designGrid)({}), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.vw)(70, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(70, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "desktop"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("desktop-wide"));

;// CONCATENATED MODULE: ./components/layout/footer/index.ts


// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(95163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(24432);
// EXTERNAL MODULE: ./components/cart/index.ts + 37 modules
var cart = __webpack_require__(61969);
;// CONCATENATED MODULE: ./components/layout/SlimBanners.tsx


function SlimBanners_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  background-color: ",
        ";\n  position: relative;\n  top: 0;\n  width: 100%;\n  z-index: 9998;\n\n  ",
        " {\n    height: ",
        ";\n  }\n\n  ",
        " {\n    height: 30px;\n  }\n\n  div {\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n\n  /* Don't use flex in the paragraph, it removes the spaces between links when comes from CMS */\n  p {\n    width: 100%;\n  }\n\n  a {\n    text-decoration: underline;\n  }\n\n  p, a {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-family: ",
        ";\n    text-align: center;\n    color: ",
        ";\n  }\n\n  ~ .pdp-back-btn {\n    ",
        " {\n      top: ",
        ";\n    }\n  }\n"
    ]);
    SlimBanners_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var SlimBanners = /*#__PURE__*/ (0,react.memo)(function(param) {
    var banners = param.banners;
    var currentSlide = (0,dist_hooks.useSlider)(banners.length, true).currentSlide;
    var SlideData = (0,react.useMemo)(function() {
        return banners[currentSlide];
    }, [
        currentSlide,
        banners
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlimBanners_Aside, {
        $bannerFontSize: SlideData === null || SlideData === void 0 ? void 0 : SlideData.titleSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            mode: "wait",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                variants: bannerVariants,
                initial: "inactive",
                animate: "active",
                exit: "exit",
                dangerouslySetInnerHTML: {
                    __html: SlideData === null || SlideData === void 0 ? void 0 : SlideData.title
                }
            }, currentSlide)
        })
    }, "slims");
});
var SlimBanners_Aside = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "SlimBanners__Aside",
    componentId: "sc-2a511985-0"
})(SlimBanners_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $bannerFontSize = param.$bannerFontSize;
    return $bannerFontSize === "xl" ? "14px" : "10px";
}, function(param) {
    var $bannerFontSize = param.$bannerFontSize;
    return $bannerFontSize === "xl" ? "18px" : "14px";
}, function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(200, "desktop"));
var bannerVariants = {
    inactive: (0,_object_spread/* default */.Z)({
        y: "-10px",
        opacity: 0
    }, (0,styles.getTransition)()),
    active: (0,_object_spread/* default */.Z)({
        y: "0",
        opacity: 1
    }, (0,styles.getTransition)()),
    exit: (0,_object_spread/* default */.Z)({
        y: "10px",
        opacity: 0
    }, (0,styles.getTransition)())
};

// EXTERNAL MODULE: ./components/cart/AddToCart.tsx
var AddToCart = __webpack_require__(31112);
;// CONCATENATED MODULE: ./components/layout/Layout.tsx

function Layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-start;\n  min-height: 100vh;\n  min-height: 100dvh;\n\n  ",
        " {\n    min-width: 100vw;\n    min-width: 100dvw;\n    width: 100%;\n    overflow-x: clip;\n  }\n"
    ]);
    Layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









// getRegion









// DEV ONLY

var DynamicModalAuth = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalAuth;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalMenu = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalSearch = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalSearch;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalRegion = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalRegion;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalRegionRegister = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalRegionRegister;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalComercialRegion = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalComercialRegion;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalNewsletter = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalNewsletter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalPromo = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalPromo;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalPublicInterested = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalPublicInterested;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicModalMenuAccount = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalMenuAccount;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var DynamicSectionProductDetail = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.SectionProductDetail;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    },
    ssr: false
});
var DynamicCartType = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalCartType;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    },
    ssr: false
});
var DynamicModalBuyBox = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalBuyBox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    },
    ssr: false
});
var customerId = null;
var getValidModal = function(modals, type) {
    var cleanModal = [];
    modals.map(function(modal) {
        var visibleFrom = modal.visibleFrom, visibleUntil = modal.visibleUntil, modalType = modal.modalType;
        var from = new Date(visibleFrom);
        var today = new Date();
        var to = new Date(visibleUntil);
        if (from <= today && to >= today && modalType === type) {
            cleanModal.push(modal);
        }
    });
    return cleanModal;
};
var queryChecked = false;
var Layout = /*#__PURE__*/ (0,react.memo)(function(param) {
    var children = param.children, data = param.data;
    var ref, ref1;
    var ref2 = (0,router.useRouter)(), localeRouter = ref2.locale, query = ref2.query;
    var lang = (0,utils.getLang)(localeRouter);
    // const region = getRegion(localeRouter)
    var isMounted = (0,dist_hooks.useMount)();
    var categories = data.categories, modals = data.modals, footers = data.footers, services = data.services;
    var modalNewsletter = (0,react.useMemo)(function() {
        return getValidModal(modals, "newsletter");
    }, [
        modals
    ]);
    var modalRegular = (0,react.useMemo)(function() {
        return getValidModal(modals, "regular");
    }, [
        modals
    ]);
    var slimBanners = (0,react.useMemo)(function() {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data.banners) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el.bannerType === "slim";
        });
    }, [
        data === null || data === void 0 ? void 0 : data.banners
    ]);
    var hasBanners = (0,react.useMemo)(function() {
        return (slimBanners === null || slimBanners === void 0 ? void 0 : slimBanners.length) > 0;
    }, [
        slimBanners
    ]);
    var ref3 = (0,react.useState)(false), showCart = ref3[0], setShowCart = ref3[1];
    var ref4 = (0,react.useState)([]), cartItems = ref4[0], setCartItems = ref4[1];
    var ref5 = (0,dist_hooks.useModal)(context.MODALS.NEWSLETTER), toggleModalNewsletter = ref5.toggle;
    var ref6 = (0,dist_hooks.useModal)(context.MODALS.PROMO), toggleModalPromo = ref6.toggle;
    var ref7 = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG), toggleModalRegion = ref7.toggle;
    var ref8 = (0,dist_hooks.useModal)(context.MODALS.AUTH), toggleModalAuth = ref8.toggle, updateAuthPayload = ref8.updatePayload;
    var ref9 = (0,hooks/* useCustomer */.ON)(), loaderActive = ref9.loaderActive, customer = ref9.customer;
    var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
    var ref10 = (0,useQuery/* useQuery */.a)(api/* GET_CART */.bG, {
        context: {
            isPrivatePath: true,
            DYCustomerToken: DYCustomerToken
        },
        skip: !DYCustomerToken,
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache"
    }), cartData = ref10.data, loading = ref10.loading, error = ref10.error;
    var bulkUpdateCart = (0,dist_hooks.useCart)().bulkUpdateCart;
    (0,react.useEffect)(function() {
        var cookieModalPromo = utils.cookie.get("DY_MODAL_PROMO");
        var cookieCatalogRegion = utils.cookie.get("DY_CATALOG_REGION");
        var cookieModalNewsletter = utils.cookie.get("DY_MODAL_NEWSLETTER");
        if (localeRouter !== "en-EU") {
            // Cookie of other store
            // const currentStore = getStoreByLocale[localeRouter]
            // const cookieLocale = `${cookieCatalogRegion?.split('-')[0]?.toLowerCase()}-${cookieCatalogRegion?.split('-')[1]}`
            // const regionStore = getStoreByLocale[cookieLocale]
            // No cookie, first visit
            if (!cookieCatalogRegion) {
                if (localeRouter === "es-ES") {
                    setTimeout(function() {
                        toggleModalRegion();
                    }, 2500);
                } else {
                    utils.cookie.set({
                        name: "DY_CATALOG_REGION",
                        value: localeRouter.toUpperCase(),
                        days: 365
                    });
                }
            } else if (localeRouter !== "es-ES") {
                utils.cookie.set({
                    name: "DY_CATALOG_REGION",
                    value: localeRouter.toUpperCase(),
                    days: 365
                });
            } else if (localeRouter === "es-ES" && (!cookieCatalogRegion.includes("ES-") || cookieCatalogRegion === "ES-CT" || cookieCatalogRegion === "ES-MD" || cookieCatalogRegion === "ES-CN")) {
                // if we are in Spain and cookie is not any related Spain region
                console.info("\uD83D\uDFE1 Spain area, and cookie not Spain region related");
                // Display modal
                setTimeout(function() {
                    toggleModalRegion();
                }, 2500);
            }
            // MODAL NEWSLETTER
            if (cookieCatalogRegion) {
                if (!DYCustomerToken && !cookieModalNewsletter && modalNewsletter.length > 0) {
                    setTimeout(function() {
                        toggleModalNewsletter();
                    }, 3000);
                }
                if (!cookieModalPromo && modalRegular.length > 0) {
                    setTimeout(function() {
                        utils.cookie.set({
                            name: "DY_MODAL_PROMO",
                            value: "true",
                            days: 1
                        });
                        toggleModalPromo();
                    }, 2000);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
        if (DYCustomerToken && typeof (customer === null || customer === void 0 ? void 0 : customer.id) === "number" && (!customerId || customerId !== customer.id) && !loading && !error && (cartData === null || cartData === void 0 ? void 0 : cartData.cart)) {
            var _cart = cartData.cart, cartLines = _cart.cartLines, cartId = _cart.bigcommerceId, subtotalExTax = _cart.subtotalExTax, totalExTax = _cart.totalExTax, discountAmount = _cart.discountAmount, deliveryDate = _cart.deliveryDate, deliveryDateOptions = _cart.deliveryDateOptions, multipleDeliveryDates = _cart.multipleDeliveryDates, deliveryType = _cart.deliveryType, deliverySchedules = _cart.deliverySchedules, notifications = _cart.notifications;
            bulkUpdateCart(cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications);
            customerId = customer.id;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartData,
        loading,
        error,
        customerId,
        customer
    ]);
    (0,react.useEffect)(function() {
        if (typeof query === "object" && Object.keys(query).length > 0 && !queryChecked) {
            var reset = query.reset, activate = query.activate;
            if (reset) {
                updateAuthPayload({
                    payload: {
                        level: "reset_password",
                        resetToken: reset
                    },
                    open: true
                });
            } else if (activate) {
                updateAuthPayload({
                    payload: {
                        level: "activation",
                        activationToken: activate
                    },
                    open: true
                });
            }
            queryChecked = true;
        }
    }, [
        query,
        updateAuthPayload,
        toggleModalAuth
    ]);
    var ref11;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutStyled, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddToCart/* NewCartItemsContext.Provider */.K.Provider, {
                value: {
                    cartItems: cartItems,
                    setCartItems: setCartItems
                },
                children: [
                    localeRouter !== "en-EU" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            hasBanners && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlimBanners, {
                                banners: slimBanners
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                                firstCategory: (ref11 = categories === null || categories === void 0 ? void 0 : (ref = categories[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1[lang]) !== null && ref11 !== void 0 ? ref11 : {},
                                setShowCart: setShowCart,
                                hasBanners: hasBanners
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* CartItemsNew */.GR, {
                                products: cartItems,
                                hasBanners: hasBanners
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart/* CartItemsAll */.d1, {
                                showCart: showCart,
                                setShowCart: setShowCart,
                                hasBanners: hasBanners
                            })
                        ]
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionProductDetail, {})
                ]
            }),
            modalRegular.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalPromo, {
                data: modalRegular[0]
            }),
            modalNewsletter.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalNewsletter, {
                data: modalNewsletter[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalMenu, {
                hasBanners: hasBanners,
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalPublicInterested, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalRegion, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalComercialRegion, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalRegionRegister, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCartType, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalBuyBox, {}),
            (localeRouter === "es-CT" || localeRouter === "es-MD") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalMenuAccount, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalAuth, {})
                ]
            }),
            localeRouter !== "en-EU" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalSearch, {
                        hasBanners: hasBanners,
                        categories: categories
                    }),
                    footers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        services: services,
                        pages: footers,
                        firstCategory: categories === null || categories === void 0 ? void 0 : categories[1]
                    })
                ]
            }),
            !utils.STAGING && !utils.PRO && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles.Susy, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_0.LoadingScreen, {
                isActive: loaderActive
            })
        ]
    });
});
var LayoutStyled = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Layout__LayoutStyled",
    componentId: "sc-794e9d1c-0"
})(Layout_templateObject(), styles.mq.greaterThan("tablet"));


/***/ }),

/***/ 11242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ar": function() { return /* reexport */ Layout/* Layout */.A; },
  "sN": function() { return /* reexport */ LayoutEmpty; },
  "TR": function() { return /* reexport */ Logo; },
  "AZ": function() { return /* reexport */ LogoStyled; }
});

// EXTERNAL MODULE: ./components/layout/Layout.tsx + 11 modules
var Layout = __webpack_require__(99361);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
;// CONCATENATED MODULE: ./components/layout/LayoutEmpty.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-start;\n  min-height: 100vh;\n  min-height: 100dvh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// DEV ONLY

var LayoutEmpty = /*#__PURE__*/ (0,react.memo)(function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Div, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles.Susy, {})
        ]
    });
});
var Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LayoutEmpty__Div",
    componentId: "sc-f0e6ab0b-0"
})(_templateObject());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
;// CONCATENATED MODULE: ./components/layout/Logo.tsx



function Logo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " auto;\n  order: 2;\n  padding: 0 ",
        ";\n\n  ",
        " {\n    margin: ",
        " auto;\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        " auto;\n    grid-column: 1 / span 3;\n    order: 0;\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    margin: 40px auto;\n    padding: 0 50px;\n  }\n\n\n  figure {\n    margin: 0 auto;\n    height: ",
        ";\n    position: relative;\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 44px;\n      width: 184px;\n    }\n  }\n"
    ]);
    Logo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var mediaLogo = {
    type: "image",
    alt: "Mammafiore logo",
    default: {
        src: "",
        size: {
            width: 261,
            height: 66
        }
    }
};
var Logo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var fillColor = param.fillColor;
    var mediaLogoWithSrc = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mediaLogo), {
        default: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mediaLogo.default), {
            src: fillColor === "white" ? "/images/svg/logo--white.svg" : "/images/svg/logo.svg"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
        href: "/",
        className: "logo",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoStyled, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: mediaLogoWithSrc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "srt-only",
                    children: "Go to Homepage"
                })
            ]
        })
    });
});
var LogoStyled = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Logo__LogoStyled",
    componentId: "sc-e61b7203-0"
})(Logo_templateObject(), (0,styles.vw)(20, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(50, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(23, "mobile"), (0,styles.vw)(123, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(23, "nexus7"), (0,styles.vw)(123, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(44, "desktop"), (0,styles.vw)(184, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/layout/index.ts





/***/ }),

/***/ 7074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ContentSectionBrand": function() { return /* reexport */ ContentSectionBrand; },
  "DynamicContentSectionBrand": function() { return /* reexport */ DynamicContentSectionBrand; },
  "DynamicSectionFiltersFeatured": function() { return /* reexport */ DynamicSectionFiltersFeatured; },
  "HeaderShop": function() { return /* reexport */ HeaderShop; },
  "NavShop": function() { return /* reexport */ NavShop; },
  "SectionFilters": function() { return /* reexport */ SectionFilters; },
  "SectionFiltersFeatured": function() { return /* reexport */ SectionFiltersFeatured; },
  "SectionProductDetail": function() { return /* reexport */ SectionProductDetail; },
  "SectionProductList": function() { return /* reexport */ SectionProductList; },
  "ViewMore": function() { return /* reexport */ ViewMore; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
;// CONCATENATED MODULE: ./components/shop/HeaderShop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top:  ",
        ";\n  overflow-x: hidden;\n\n  ",
        " {\n    margin-top:  ",
        ";\n  }\n\n  ",
        " {\n    margin-top:  ",
        ";\n  }\n\n  ",
        " {\n    margin-top: 80px;\n  }\n\n  .marquee {\n    ",
        " {\n      margin-bottom:  ",
        ";\n      padding: ",
        " 0 0;\n    }\n\n    ",
        " {\n      margin-bottom: 40px;\n      padding: 30px 0 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DynamicMarquee = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 17566, 23)).then(function(mod) {
        return mod.Marquee;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17566)
            ];
        }
    },
    ssr: false
});
var getCategoriesAndSubcategories = function(categories, isBrandPage, isFallback) {
    var parsedCategories = [];
    if (!isBrandPage && !isFallback) {
        categories.map(function(category) {
            var ref;
            parsedCategories.push(category);
            category === null || category === void 0 ? void 0 : (ref = category.subcategories) === null || ref === void 0 ? void 0 : ref.map(function(subcategory) {
                parsedCategories.push(subcategory);
            });
        });
    } else {
        parsedCategories = categories;
    }
    return parsedCategories;
};
var replaceHyphensWithSpaces = function(inputString, textBrand) {
    if (typeof inputString !== "string") {
        throw new Error("Input must be a string");
    }
    return textBrand.toUpperCase() + " " + inputString.replace(/-/g, " ").toUpperCase();
};
var HeaderShop = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, _isBrandPage = param.isBrandPage, isBrandPage = _isBrandPage === void 0 ? false : _isBrandPage, _isFallback = param.isFallback, isFallback = _isFallback === void 0 ? false : _isFallback;
    var ref, ref1, ref2;
    var ref3 = (0,router.useRouter)(), localeRouter = ref3.locale, query = ref3.query;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var allCategoriesAndSubcategories = getCategoriesAndSubcategories(data, isBrandPage, isFallback);
    var queryParsed = (query === null || query === void 0 ? void 0 : (ref = query.slug) === null || ref === void 0 ? void 0 : ref.length) > 1 && Array.isArray(query === null || query === void 0 ? void 0 : query.slug) && !isFallback ? query === null || query === void 0 ? void 0 : (ref1 = query.slug) === null || ref1 === void 0 ? void 0 : ref1.join("/") : ((ref2 = query.slug) === null || ref2 === void 0 ? void 0 : ref2[0]) && !isFallback ? query.slug[0] : "";
    var currentPage = (0,react.useMemo)(function() {
        return !isFallback && !isBrandPage ? allCategoriesAndSubcategories.find(function(category) {
            return queryParsed === category.slug[locale];
        }) : isBrandPage ? replaceHyphensWithSpaces(data[0].slug[locale], t("layout.search.brand")) : data.name;
    }, [
        isFallback,
        isBrandPage,
        allCategoriesAndSubcategories,
        data,
        locale,
        t,
        queryParsed
    ]);
    return currentPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
        $isBrandPage: isBrandPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMarquee, {
            data: (currentPage === null || currentPage === void 0 ? void 0 : currentPage.name) ? currentPage === null || currentPage === void 0 ? void 0 : currentPage.name : currentPage
        })
    });
});
var Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "HeaderShop__Header",
    componentId: "sc-b1582ada-0"
})(_templateObject(), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? 0 : "80px";
}, styles.mq.greaterThan("nexus7"), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "".concat((0,styles.vw)(20, "nexus7")) : "".concat((0,styles.vw)(60, "nexus7"));
}, styles.mq.greaterThan("tablet"), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "".concat((0,styles.vw)(80, "desktop")) : "".concat((0,styles.vw)(80, "desktop"));
}, styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
;// CONCATENATED MODULE: ./components/shop/NavShop.tsx

function NavShop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        "\n  ",
        "\n\n  ",
        " {\n    height: calc(100vh - 80px);\n    display: flex;\n    grid-column: 1 / span 3;\n    grid-row: 1 / span 4;\n    margin-bottom: ",
        ";\n    overflow-y: auto;\n    padding: 0 ",
        ";\n    position: sticky;\n    top: ",
        ";\n    transform: translateX(",
        ");\n    transition: 200ms transform ",
        ";\n    z-index: 50;\n  }\n\n  ",
        " {\n    margin-bottom: 100px;\n    padding: 0 30px;\n    top: 140px;\n    transform: translateX(",
        ");\n    max-width: 360px;\n  }\n\n  ",
        " {\n    transform: translateX(",
        ");\n  }\n"
    ]);
    NavShop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var NavShop = /*#__PURE__*/ (0,react.memo)(function(param) {
    var categories = param.categories, _brandCategory = param.brandCategory, brandCategory = _brandCategory === void 0 ? "" : _brandCategory, _pageCategory = param.pageCategory, pageCategory = _pageCategory === void 0 ? "" : _pageCategory;
    var cardSelected = (0,hooks/* useActiveVariant */.wT)().cardSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.CategoriesAccordion, {
            categories: categories,
            brandCategory: brandCategory,
            pageCategory: pageCategory
        })
    });
});
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "NavShop__Section",
    componentId: "sc-ca535b6d-0"
})(NavShop_templateObject(), (0,styles.hideScrollbar)(), (0,styles.getP18_1)(), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(150, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat((0,styles.vw)(120 * 3, "desktop")) : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat(120 * 3, "px") : 0;
}, styles.mq.greaterThan("desktop-wide"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat((0,styles.vw)(140 * 4, "desktop-wide")) : 0;
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ../commons/dist/context/index.js
var context = __webpack_require__(7693);
;// CONCATENATED MODULE: ./components/shop/ButtonFilterCheckbox.tsx

function ButtonFilterCheckbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 100px;\n  height: ",
        ";\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%) scale(",
        ");\n  transition: transform 200ms ",
        ";\n  user-select: none;\n  width: ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: 9px;\n    width: 9px;\n  }\n"
    ]);
    ButtonFilterCheckbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border: 0;\n  color: ",
        ";\n  display: flex;\n  ",
        "\n  height: ",
        ";\n  font-family: ",
        ";\n  font-weight: 700;\n  justify-content: space-between;\n  opacity: ",
        ";\n  padding: 0 ",
        ";\n  width: 100%;\n  white-space: normal;\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: 50px;\n    padding: 0 40px;\n  }\n\n  > div {\n    position: relative;\n  }\n\n  svg {\n    display: block;\n    opacity: ",
        ";\n    transition: opacity 200ms ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 25px;\n    }\n\n    path {\n      transition: fill 200ms ",
        ";\n    }\n  }\n\n  figure {\n    display: flex;\n    height: ",
        ";\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%) scale(",
        ");\n    transition: transform 200ms ",
        ";\n    user-select: none;\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 12px;\n      width: 12px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Svg = /*#__PURE__*/ (0,react.memo)(function(param) {
    var isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "27",
        height: "29",
        viewBox: "0 0 27 29",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23.75 6.13l-8-4.54c-1.39-.79-3.11-.79-4.5 0l-8 4.54A4.4 4.4 0 0 0 1 9.96v9.08a4.4 4.4 0 0 0 2.25 3.83l8 4.54c1.39.79 3.11.79 4.5 0l8-4.54A4.4 4.4 0 0 0 26 19.04V9.96a4.4 4.4 0 0 0-2.25-3.83",
            fill: isActive ? "#4E1114" : "#D8C7C7",
            stroke: "#4E1114"
        })
    });
});
var mediaTick = {
    type: "image",
    alt: "Icon tick",
    default: {
        src: "/images/svg/i--tick.svg",
        size: {
            width: 9,
            height: 9
        }
    }
};
var ButtonFilterCheckbox = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data, onClick = param.onClick, isActive = param.isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckboxButton, {
        onClick: onClick,
        isActive: isActive,
        isMultiple: data.type === "multiple",
        children: [
            data.name,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                        isActive: isActive
                    }),
                    data.type === "multiple" && data.param !== "sort" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                        media: mediaTick,
                        lazy: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCircle, {
                        isActive: isActive
                    })
                ]
            })
        ]
    });
});
var CheckboxCircle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonFilterCheckbox__CheckboxCircle",
    componentId: "sc-52209ee7-0"
})(ButtonFilterCheckbox_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.lightred;
}, (0,styles.vw)(9, "mobile"), function(param) {
    var isActive = param.isActive;
    return isActive ? 1 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.vw)(9, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(9, "nexus7"), (0,styles.vw)(9, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(9, "desktop"), (0,styles.vw)(9, "desktop"), styles.mq.greaterThan("desktop"));
var CheckboxButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ButtonFilterCheckbox__CheckboxButton",
    componentId: "sc-52209ee7-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP20)(), (0,styles.vw)(50, "mobile"), function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, function(param) {
    var isActive = param.isActive, isMultiple = param.isMultiple;
    return isMultiple && !isActive ? .5 : 1;
}, (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var isActive = param.isActive;
    return isActive ? 1 : .4;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.vw)(12, "mobile"), function(param) {
    var isActive = param.isActive;
    return isActive ? 1 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.vw)(12, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(12, "nexus7"), (0,styles.vw)(12, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(12, "desktop"), (0,styles.vw)(12, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 145 modules
var motion = __webpack_require__(90260);
;// CONCATENATED MODULE: ./components/shop/ButtonFilterAccordion.tsx



function ButtonFilterAccordion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  width: ",
        ";\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  figure {\n    height: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 8px;\n      width: 8px;\n    }\n  }\n"
    ]);
    ButtonFilterAccordion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonFilterAccordion_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n\n  &[aria-expanded=false] {\n    button {\n      pointer-events: none;\n      user-select: none;\n    }\n  }\n\n  button {\n    ",
        "\n    margin-top: ",
        ";\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 2px;\n    }\n  }\n"
    ]);
    ButtonFilterAccordion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border: 0;\n  color: ",
        ";\n  display: flex;\n  ",
        "\n  height: ",
        ";\n  justify-content: space-between;\n  padding: 0 ",
        ";\n  position: relative;\n  width: 100%;\n  white-space: normal;\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: 50px;\n    padding: 0 40px;\n  }\n\n  > div {\n    position: relative;\n\n    &.txt-wrapper {\n      ",
        "\n      display: flex;\n      flex-direction: column;\n      flex-shrink: 1;\n      font-family: ",
        ";\n      font-weight: 700;\n      justify-content: space-between;\n      text-align: left;\n      width: calc(100% - 40px);\n\n    }\n\n    &:last-child {\n      flex-shrink: 0;\n\n      span {\n        width: 27px;\n      }\n    }\n  }\n\n  .values {\n    bottom: -",
        ";\n    color: ",
        ";\n    ",
        "\n    font-family: ",
        ";\n    font-weight: 500;\n    letter-spacing: 0;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    text-overflow: ellipsis;\n    transition: 200ms opacity ",
        ";\n    user-select: none;\n    width: 100%;\n    white-space: nowrap;\n\n    ",
        " {\n      bottom: -",
        ";\n    }\n\n    ",
        " {\n      bottom: -",
        ";\n      letter-spacing: 0;\n    }\n\n    ",
        " {\n      bottom: -21px;\n    }\n\n    &.visible {\n      opacity: .5;\n      user-select: auto;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var getActiveNames = function(values, activeValues) {
    if (typeof activeValues !== "object") return "";
    return Object.keys(activeValues).map(function(activeVal, idx) {
        var ref;
        var name = (ref = values === null || values === void 0 ? void 0 : values.filter(function(val) {
            return val.value.includes(activeVal);
        })[0]) === null || ref === void 0 ? void 0 : ref.name;
        return idx < 1 ? name : ", ".concat(name);
    });
};
var mediaChevron = {
    type: "image",
    alt: "Icon chevron",
    default: {
        src: "/images/svg/i--chevron.svg",
        size: {
            width: 6,
            height: 8
        }
    }
};
var ButtonFilterAccordion = /*#__PURE__*/ (0,react.memo)(function(param) {
    var activeValues = param.activeValues, children = param.children, data = param.data, _clickedParam = param.clickedParam, clickedParam = _clickedParam === void 0 ? null : _clickedParam;
    var ActiveNames = getActiveNames(data.values, activeValues);
    var id = "btn-controls-".concat(data.param);
    var ref;
    var ref1 = (0,react.useState)((ref = clickedParam === data.param) !== null && ref !== void 0 ? ref : false), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var onClick = function() {
        setIsExpanded(!isExpanded);
    };
    (0,react.useEffect)(function() {
        if (clickedParam === data.param) {
            setIsExpanded(true);
        } else {
            setIsExpanded(false);
        }
    }, [
        clickedParam,
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionButton, {
                onClick: onClick,
                "aria-controls": id,
                $isExpanded: isExpanded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "txt-wrapper",
                        children: [
                            data.name,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "values".concat(!isExpanded ? " visible" : ""),
                                children: ActiveNames
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        "aria-hidden": true,
                        animate: {
                            rotate: isExpanded ? 90 : 0
                        },
                        transition: (0,styles.getTransition)(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mediaChevron
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionWrapper, {
                id: id,
                "aria-expanded": isExpanded,
                tabIndex: -1,
                variants: accordionVariants,
                initial: "initial",
                exit: "exit",
                animate: isExpanded ? "animate" : "exit",
                children: children
            })
        ]
    });
});
var Chevron = (0,styled_components_browser_esm["default"])(motion/* motion.span */.E.span).withConfig({
    displayName: "ButtonFilterAccordion__Chevron",
    componentId: "sc-3b00981b-0"
})(ButtonFilterAccordion_templateObject(), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(25, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), (0,styles.vw)(8, "mobile"), (0,styles.vw)(6, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(8, "desktop"), (0,styles.vw)(6, "desktop"), styles.mq.greaterThan("desktop"));
var AccordionWrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "ButtonFilterAccordion__AccordionWrapper",
    componentId: "sc-3b00981b-1"
})(ButtonFilterAccordion_templateObject1(), (0,styles.getP18_1)(), (0,styles.vw)(2, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(2, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(2, "desktop"), styles.mq.greaterThan("desktop"));
var AccordionButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ButtonFilterAccordion__AccordionButton",
    componentId: "sc-3b00981b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP20)(), (0,styles.vw)(50, "mobile"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP20)(), function(param) {
    var theme = param.theme;
    return theme.fonts.primaryFont;
}, (0,styles.vw)(20, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP15_5)(), function(param) {
    var theme = param.theme;
    return theme.fonts.tertiaryFont;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(21, "desktop"), styles.mq.greaterThan("desktop"));
var accordionVariants = {
    initial: {
        height: "0px",
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            delay: 0
        })
    },
    animate: {
        height: "auto",
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .3,
            delay: .25
        })
    },
    exit: {
        height: "0px",
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .2,
            delay: 0
        })
    }
};

;// CONCATENATED MODULE: ./components/shop/SectionFilters.tsx



function SectionFilters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  grid-row: 1 / span 1;\n  height: ",
        ";\n  position: sticky;\n  top: ",
        ";\n  transition: 300ms width ",
        ", 300ms top ",
        ";\n  z-index: 20;\n  will-change: top;\n\n  ",
        " {\n    height: ",
        ";\n    top: ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 4 / span 9;\n    height: auto;\n    margin-top: -",
        ";\n    top: ",
        ";\n    z-index: 105;\n    width: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: -10px;\n    top: 80px;\n  }\n\n  ul {\n    align-items: center;\n    background-color: ",
        ";\n    box-shadow: ",
        ";\n    display: flex;\n    height: ",
        ";\n    justify-content: center;\n    padding: 0 ",
        ";\n    transition: 300ms width ease-in-out, 200ms transform ",
        ";\n    z-index: 2;\n    width: 100vw;\n\n    ",
        " {\n      height: ",
        ";\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      box-shadow: none;\n      height: ",
        ";\n      justify-content: flex-start;\n      padding: 0 ",
        ";\n      transform: translate(",
        ", 0);\n      width: 100%;\n    }\n\n    ",
        " {\n      height: 60px;\n      padding: 0 20px;\n      transform: translate(",
        ", 0);\n    }\n\n    li {\n      display: none;\n\n      ",
        " {\n        display: inline-block;\n      }\n\n      &:not(:nth-child(2)) {\n        ",
        " {\n          margin-left: ",
        ";\n        }\n\n        ",
        " {\n          margin-left: 10px;\n        }\n      }\n\n      &:first-child {\n        display: inline-block;\n        height: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n        }\n\n        ",
        " {\n          display: none;\n        }\n\n        button {\n          height: 100%;\n          justify-content: center;\n          min-width: ",
        ";\n\n          ",
        " {\n            min-width: ",
        ";\n          }\n        }\n      }\n\n      &.slider-bar-wrapper {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    SectionFilters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionFilters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 90px;\n  color: ",
        ";\n  display: flex;\n  ",
        "\n  font-weight: 500;\n  height: ",
        ";\n  transition: 200ms background-color ",
        ", 200ms border-color ",
        ", 200ms color ",
        ";\n  padding: 0 ",
        ";\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    height: 40px;\n    padding: 0 20px;\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    SectionFilters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var DynamicModalFilters = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.ModalFilters;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    },
    ssr: false
});
var LANG = (0,utils.getLang)(utils.NEXT_PUBLIC_LOCALE);
//hardcoded!! need to check all idioms
var TRANSLATIONS = {
    "en": {
        "brand": "brand"
    },
    "es": {
        "brand": "marca"
    },
    "fr": {
        "brand": "marque"
    }
};
var getFilterButtons = function(param) {
    var filters = param.filters, target = param.target, onClickParam = param.onClickParam, clickedParam = param.clickedParam, onClick = param.onClick, activeFilters = param.activeFilters, isBrandPage = param.isBrandPage;
    var params = Object.keys(filters);
    if (isBrandPage) {
        var mutatedArray = params.filter(function(item) {
            var ref;
            return item !== ((ref = TRANSLATIONS[LANG]) === null || ref === void 0 ? void 0 : ref.brand);
        });
        params = mutatedArray;
    }
    var item = {
        "filters-bar": function(param, filter, idx) {
            var paramMultipleActive = (filter.type === "multiple" || filter.type === "brand") && typeof activeFilters[param] === "object" && Object.keys(activeFilters[param]).length > 0;
            var isActive = filter.type === "multiple" || filter.type === "brand" ? paramMultipleActive : activeFilters[param];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersButton, {
                    onClick: filter.type === "multiple" || filter.type === "brand" ? function() {
                        onClickParam(param);
                    } : function() {
                        onClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                            param: param
                        }), activeFilters);
                    },
                    isActive: param !== "sort" && isActive,
                    children: [
                        (filter === null || filter === void 0 ? void 0 : filter.name) ? filter.name : "Ordenar",
                        paramMultipleActive && param !== "sort" && " (".concat(Object.keys(activeFilters[param]).length, ")")
                    ]
                })
            }, "target-".concat(idx));
        },
        "filters-modal": function(param, filter, idx) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: filter.type === "simple" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFilterCheckbox, {
                    data: filter,
                    onClick: function() {
                        onClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                            param: param
                        }), activeFilters);
                    },
                    isActive: activeFilters[param]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFilterAccordion, {
                    data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                        param: param
                    }),
                    activeValues: activeFilters[param],
                    clickedParam: clickedParam,
                    children: filter === null || filter === void 0 ? void 0 : (ref = filter.values) === null || ref === void 0 ? void 0 : ref.map(function(value, idx) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonFilterCheckbox, {
                            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                param: param,
                                value: value,
                                type: "multiple"
                            }),
                            onClick: function() {
                                onClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                    param: param
                                }), activeFilters);
                            },
                            isActive: (ref = activeFilters[param]) === null || ref === void 0 ? void 0 : ref[value.value]
                        }, "filter-val-".concat(idx));
                    })
                })
            }, "target-".concat(idx));
        }
    };
    return params.map(function(param, idx) {
        return item[target](param, filters[param], idx);
    });
};
var scrollToTopGrid = function() {
    if (true) {
        var main = document.getElementById("main-top");
        if (main) setTimeout(function() {
            main.scrollIntoView({
                behavior: "smooth"
            });
        }, 300);
    }
};
var SectionFilters = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _filters = param.filters, filters = _filters === void 0 ? {} : _filters, activeFilters = param.activeFilters, _resultsLength = param.resultsLength, resultsLength = _resultsLength === void 0 ? 0 : _resultsLength, setActiveFilters = param.setActiveFilters, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? null : _isScrolling, _isBrandPage = param.isBrandPage, isBrandPage = _isBrandPage === void 0 ? false : _isBrandPage;
    var toggle = (0,dist_hooks.useModal)(context.MODALS.FILTER).toggle;
    var ref = (0,react.useState)(null), clickedParam = ref[0], setClickedParam = ref[1];
    var cardSelected = (0,hooks/* useActiveVariant */.wT)().cardSelected;
    var onClick = (0,react.useCallback)(function(filter, actives) {
        var incomingActives = (0,utils.updateActiveFilters)(actives, filter);
        setActiveFilters(incomingActives);
        scrollToTopGrid();
    }, [
        setActiveFilters
    ]);
    var onClickParam = (0,react.useCallback)(function(param) {
        setClickedParam(param);
        toggle();
    }, [
        toggle,
        setClickedParam
    ]);
    var clearFilters = (0,react.useCallback)(function() {
        setActiveFilters({
            sort: {
                recommended: true
            }
        });
        scrollToTopGrid();
    }, [
        setActiveFilters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var FilterButtons = (0,react.useMemo)(function() {
        return getFilterButtons({
            filters: filters,
            target: "filters-bar",
            onClickParam: onClickParam,
            activeFilters: activeFilters,
            onClick: onClick,
            isBrandPage: isBrandPage
        });
    }, [
        filters,
        onClickParam,
        activeFilters,
        onClick,
        isBrandPage
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var FilterButtonsModal = (0,react.useMemo)(function() {
        return getFilterButtons({
            filters: filters,
            target: "filters-modal",
            activeFilters: activeFilters,
            onClick: onClick,
            clickedParam: clickedParam,
            isBrandPage: isBrandPage
        });
    }, [
        filters,
        activeFilters,
        onClick,
        clickedParam,
        isBrandPage
    ]);
    var length = (0,react.useMemo)(function() {
        return Object.keys(activeFilters).length;
    }, [
        activeFilters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersSection, {
                $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
                isScrolling: isScrolling,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersButton, {
                                onClick: toggle,
                                isActive: length > 0,
                                children: [
                                    "Order and filter",
                                    length > 0 && " (".concat(length, ")")
                                ]
                            })
                        }),
                        FilterButtons.length < 8 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: FilterButtons
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "slider-bar-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.SliderFlickity, {
                                className: "slider--filters-bar",
                                options: {
                                    pageDots: false,
                                    prevNextButtons: false,
                                    freeScroll: true,
                                    cellAlign: "left"
                                },
                                children: FilterButtons
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModalFilters, {
                filters: FilterButtonsModal,
                activeFiltersLength: length,
                resultsLength: resultsLength,
                clearFilters: clearFilters
            })
        ]
    });
});
var FiltersSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionFilters__FiltersSection",
    componentId: "sc-4c079068-0"
})(SectionFilters_templateObject(), (0,styles.vw)(60, "mobile"), (0,styles.vw)(60, "mobile"), function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), (0,styles.vw)(80, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "calc(100% + 25vw)" : "100%";
}, styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var isScrolling = param.isScrolling, colors = param.theme.colors;
    return isScrolling ? "0 4px 40px 0 ".concat((0,styles.hex2Rgba)(colors.black, .1)) : "none";
}, (0,styles.vw)(60, "mobile"), (0,styles.vw)(10, "mobile"), function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), (0,styles.vw)(20, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat((0,styles.vw)(120 * 3, "desktop")) : 0;
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat(120 * 3, "px") : 0;
}, styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(250, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(250, "nexus7"));
var FiltersButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SectionFilters__FiltersButton",
    componentId: "sc-4c079068-1"
})(SectionFilters_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return (0,styles.hex2Rgba)(theme.colors.darkred, isActive ? 1 : 0);
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return (0,styles.hex2Rgba)(theme.colors.grey, isActive ? 1 : .3);
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.background : (0,styles.hex2Rgba)(theme.colors.darkred, .5);
}, (0,styles.getP15_5)(), (0,styles.vw)(40, "mobile"), function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, function(param) {
    var ease = param.ease;
    return ease;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return (0,styles.hex2Rgba)(theme.colors.darkred, isActive ? 1 : 0);
}, function(param) {
    var theme = param.theme;
    return (0,styles.hex2Rgba)(theme.colors.darkred, 1);
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.background : (0,styles.hex2Rgba)(theme.colors.darkred, .5);
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(88241);
// EXTERNAL MODULE: ./components/index.ts + 74 modules
var components_0 = __webpack_require__(83242);
// EXTERNAL MODULE: ./components/shop/shopVariants.ts
var shopVariants = __webpack_require__(42769);
;// CONCATENATED MODULE: ./components/shop/SectionProductList.tsx



function SectionProductList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  grid-row: 3 / span 1;\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  opacity: ",
        ";\n  transition: 300ms all ease-in-out;\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    padding-top: ",
        ";\n  }\n\n  ",
        " {\n    grid-column: ",
        ";\n    grid-row: 2 / span 4;\n    margin-bottom: ",
        ";\n    padding-top: ",
        ";\n    opacity: 1;\n  }\n\n  ",
        " {\n    margin-bottom: 100px;\n    padding-top: ",
        ";\n    grid-column: ",
        ";\n  }\n"
    ]);
    SectionProductList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionProductList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding-left: ",
        ";\n          padding-right: ",
        ";\n        "
    ]);
    SectionProductList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionProductList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding-left: 15px;\n          padding-right: 15px;\n        "
    ]);
    SectionProductList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "width: auto;"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: dense;\n  grid-gap: ",
        ";\n  grid-template-columns: repeat(2, 1fr);\n  padding: 0 ",
        ";\n\n  ",
        " {\n    grid-gap: ",
        ";\n    grid-template-columns: repeat(",
        ", 1fr);\n    padding: 0 ",
        ";\n  }\n\n  ",
        " {\n    grid-gap: ",
        ";\n    grid-template-columns: repeat(",
        ", 1fr);\n    /* padding-right: ",
        "; */\n    transform: translateX(",
        ");\n    transition: 200ms width ",
        ", 200ms transform ",
        ";\n    width: ",
        "%;\n  }\n\n  ",
        " {\n    grid-gap: ",
        ";\n    /* padding-right: ",
        "; */\n    transform: translateX(",
        ");\n  }\n\n  ",
        " {\n    grid-template-columns: repeat(",
        ", 1fr);\n    grid-gap: ",
        ";\n    /* padding-right: ",
        "; */\n    transform: translateX(",
        ");\n  }\n\n  li.giftcardleft, li.giftcardright {\n    height:100%;\n    grid-column: auto / span 2;\n  }\n\n  article {\n    .product-card-image {\n      + div {\n        max-width: ",
        ";\n\n        ",
        " {\n          max-width: ",
        ";\n        }\n\n        ",
        " {\n          display: grid;\n          max-width: ",
        ";\n        }\n\n        ",
        " {\n          max-width: ",
        ";\n        }\n      }\n    }\n\n    .stacked,\n    .product-card_info {\n      ",
        " {\n        ",
        "\n      }\n\n      ",
        " {\n        ",
        "\n      }\n    }\n\n    &.pack {\n      ",
        "\n    }\n  }\n\n  li {\n    display: inline-grid;\n    grid-column: auto / span 1;\n\n    ",
        " {\n      height: ",
        ";\n      width: auto;\n    }\n\n    ",
        " {\n      height: 360px;\n    }\n\n    article {\n      margin: 0;\n      width: auto;\n    }\n\n    article:not(.pack, .giftcardleft, .giftcardright) {\n      width: auto;\n\n      .product-card-image {\n        ",
        " {\n          max-width: ",
        ";\n          min-width: ",
        ";\n          width: 100%;\n        }\n\n        ",
        " {\n          max-width: 260px;\n          min-width: 180px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-weight: 400;\n  opacity: .4;\n  padding: ",
        " ",
        ";\n  text-align: center;\n\n  ",
        " {\n    padding: ",
        " ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 4 / span 9;\n    margin: 0 auto;\n    max-width: ",
        ";\n    padding: ",
        " 0;\n  }\n\n  ",
        " {\n    max-width: 720px;\n    padding: 40px 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








// import { GiftCard } from '@dy/commons/components'





var getProducts = function(products, onClick, ga_list, categories, t) {
    return products.map(function(product, idx) {
        if (product === null || product === void 0 ? void 0 : product.category_card) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.CategoryCard, {
                    data: categories
                })
            ]
        }, idx);
        else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_0.ProductCard, {
                    isLazy: idx > 5,
                    data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                        ga_list: ga_list,
                        idx: idx + 1
                    }),
                    onClick: function(e) {
                        e.preventDefault();
                        onClick(product, idx);
                    },
                    lastUnits: t("product_page.product.last_units")
                })
            }, idx);
        }
    });
};
var SectionProductList_scrollToTopGrid = function() {
    if (true) {
        var main = document.getElementById("main-top");
        if (main) setTimeout(function() {
            main.scrollIntoView({
                behavior: "smooth"
            });
        }, 300);
    }
};
var SectionProductList = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _products = param.products, products = _products === void 0 ? [] : _products, _usualPurchases = param.usualPurchases, usualPurchases = _usualPurchases === void 0 ? false : _usualPurchases, _packsGrid = param.packsGrid, packsGrid = _packsGrid === void 0 ? false : _packsGrid, _ga_list = param.ga_list, ga_list = _ga_list === void 0 ? {
        id: "list_grid_shop",
        name: "List Shop (grid)"
    } : _ga_list, _categories = param.categories, categories = _categories === void 0 ? [] : _categories;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, localeRouter = ref.locale;
    var locale = (0,utils.getLang)(localeRouter);
    var t = (0,hooks/* useTranslator */.I4)().t;
    var ref1 = (0,hooks/* useActiveVariant */.wT)(), cardSelected = ref1.cardSelected, setCardSelected = ref1.setCardSelected;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var isMobile = (0,dist_hooks.useDeviceType)().isMobile;
    var ref2 = (0,dist_hooks.useInView)({
        rootMargin: "-60px 0px 0px",
        threshold: 1,
        initialInView: true
    }).ref;
    var onClick = (0,react.useCallback)(function(variant, idx) {
        (0,utils.pushAnalyticsEvent)("select_item", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
            idx: idx + 1,
            ga_list: ga_list,
            locale: locale
        }));
        if ((cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id) !== variant.bigcommerceId) {
            setCardSelected({
                variant_id: variant.bigcommerceId,
                slug: variant.product.slug[locale],
                ga_list: ga_list,
                idx: idx + 1
            });
            if (!isMobile && idx < 4) SectionProductList_scrollToTopGrid();
        }
        var url = "".concat(customer ? "/shop" : "/catalog", "/product/").concat(variant.product.slug[locale]);
        window.history.pushState("", "", url);
    }, [
        cardSelected,
        setCardSelected,
        isMobile,
        ga_list,
        locale,
        customer
    ]);
    var Products = (0,react.useMemo)(function() {
        return getProducts(products, onClick, ga_list, categories, t);
    }, [
        products,
        onClick,
        ga_list,
        categories,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListSection, {
        ref: ref2,
        className: className,
        $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
        $packsGrid: packsGrid,
        $usualPurchases: usualPurchases,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            mode: "wait",
            children: products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList, {
                initial: "inactive",
                animate: "active",
                exit: "inactive",
                variants: shopVariants/* listVariants */.h,
                $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
                $packsGrid: packsGrid,
                children: Products
            }, asPath) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoProductsMessage, {
                initial: "inactive",
                animate: "active",
                exit: "inactive",
                variants: shopVariants/* listVariants */.h,
                children: !usualPurchases ? t("shop.no_filter") : t("shop.no_products")
            }, asPath)
        })
    });
});
var ProductListSection = (0,styled_components_browser_esm["default"])(motion/* motion.section */.E.section).withConfig({
    displayName: "SectionProductList__ProductListSection",
    componentId: "sc-575d0212-0"
})(SectionProductList_templateObject(), (0,styles.vw)(100, "mobile"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 0 : "".concat((0,styles.vw)(20, "mobile"));
}, function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : 1;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(100, "nexus7"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 0 : "".concat((0,styles.vw)(20, "nexus7"));
}, styles.mq.greaterThan("tablet"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? "2 / span 10" : "4 / span 9";
}, (0,styles.vw)(100, "desktop"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 0 : "".concat((0,styles.vw)(45, "desktop"));
}, styles.mq.greaterThan("desktop"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 0 : "45px";
}, function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? "2 / span 10" : "4 / span 9";
});
var ProductList = (0,styled_components_browser_esm["default"])(motion/* motion.ul */.E.ul).withConfig({
    displayName: "SectionProductList__ProductList",
    componentId: "sc-575d0212-1"
})(_templateObject4(), (0,styles.vw)(10, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "desktop"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 2 : 3;
}, (0,styles.vw)(10, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var $packsGrid = param.$packsGrid, $activeVariant = param.$activeVariant;
    return $packsGrid && !$activeVariant ? "".concat((0,styles.vw)(60, "desktop")) : "".concat((0,styles.vw)(10, "desktop"));
}, function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 3 : 4;
}, function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "".concat((0,styles.vw)(10, "desktop"));
}, function(param) {
    var $activeVariant = param.$activeVariant, $packsGrid = param.$packsGrid;
    return $activeVariant ? "-".concat((0,styles.vw)(120 * ($packsGrid ? 1 : 3), "desktop")) : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var $activeVariant = param.$activeVariant, $packsGrid = param.$packsGrid;
    return 100 - ($activeVariant ? $packsGrid ? 29.166666666666668 : 22.22222222222222 : 0);
}, styles.mq.greaterThan("desktop"), function(param) {
    var $packsGrid = param.$packsGrid, $activeVariant = param.$activeVariant;
    return $packsGrid && !$activeVariant ? "60px" : "10px";
}, function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "10px";
}, function(param) {
    var $activeVariant = param.$activeVariant, $packsGrid = param.$packsGrid;
    return $activeVariant ? "-".concat(120 * ($packsGrid ? 1 : 3), "px") : 0;
}, styles.mq.greaterThan("desktop-wide"), function(param) {
    var $packsGrid = param.$packsGrid;
    return $packsGrid ? 4 : 5;
}, function(param) {
    var $packsGrid = param.$packsGrid, $activeVariant = param.$activeVariant;
    return $packsGrid && !$activeVariant ? "60px" : "10px";
}, function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "10px";
}, function(param) {
    var $activeVariant = param.$activeVariant, $packsGrid = param.$packsGrid;
    return $activeVariant ? "-".concat(120 * ($packsGrid ? 1 : 3), "px") : 0;
}, (0,styles.vw)(188, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(188, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var $packsGrid = param.$packsGrid, $activeVariant = param.$activeVariant;
    return (0,styles.vw)($activeVariant ? $packsGrid ? 260 : 195 : $packsGrid ? 360 : 260, "desktop");
}, styles.mq.greaterThan("desktop"), function(param) {
    var $packsGrid = param.$packsGrid, $activeVariant = param.$activeVariant;
    return $activeVariant ? $packsGrid ? "260px" : "195px" : $packsGrid ? "360px" : "260px";
}, styles.mq.greaterThan("tablet"), function(param) {
    var $activeVariant = param.$activeVariant;
    if ($activeVariant) return (0,styled_components_browser_esm.css)(SectionProductList_templateObject1(), (0,styles.vw)(15, "desktop"), (0,styles.vw)(15, "desktop"));
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    if ($activeVariant) return (0,styled_components_browser_esm.css)(SectionProductList_templateObject2());
}, function(param) {
    var $activeVariant = param.$activeVariant;
    if (!$activeVariant) return (0,styled_components_browser_esm.css)(_templateObject3());
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(360, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(260, "desktop"), (0,styles.vw)(180, "desktop"), styles.mq.greaterThan("desktop"));
var NoProductsMessage = (0,styled_components_browser_esm["default"])(motion/* motion.p */.E.p).withConfig({
    displayName: "SectionProductList__NoProductsMessage",
    componentId: "sc-575d0212-2"
})(_templateObject5(), (0,styles.getP30)(), (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(120 * 6, "desktop"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));

// EXTERNAL MODULE: ./pages/catalog/product/[slug].tsx
var _slug_ = __webpack_require__(61962);
// EXTERNAL MODULE: ./pages/shop/product/[slug].tsx
var product_slug_ = __webpack_require__(39647);
;// CONCATENATED MODULE: ./components/shop/SectionProductDetail.tsx

function SectionProductDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  height: calc(98vh - 60px);\n  height: calc(98dvh - 60px);\n  grid-column: 1 / span 6;\n  left: 0;\n  margin: auto;\n  overflow-y: auto;\n  position: fixed;\n  top: 60px;\n  transform: translateX(",
        ");\n  transition: 400ms transform ",
        ", 400ms margin ",
        ", 300ms top ",
        ", 300ms height ",
        ";\n  right: -10px;\n  ",
        "\n  width: 90vw;\n  z-index: 110;\n  will-change: translate, top, height;\n\n  ",
        " {\n    height: calc(95vh - ",
        ");\n    height: calc(95dvh - ",
        ");\n    top: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    grid-column: 8 / span 5;\n    grid-row: 2 / auto;\n    height: calc(95vh - ",
        ");\n    height: calc(95dvh - ",
        ");\n    left: auto;\n    margin-bottom: 15px;\n    margin-top: ",
        ";\n    padding-bottom: ",
        ";\n    top: ",
        ";\n    transform: translateX(",
        ");\n    width: ",
        ";\n    z-index: 110;\n  }\n\n  ",
        " {\n    height: calc(95vh - 160px);\n    margin-top: 40px;\n    padding-bottom: 60px;\n    top: 120px;\n    transform: translateX(",
        ");\n    width: 580px;\n  }\n\n  ",
        " {\n    margin-right: 22vw;\n  }\n\n  &.plp-page {\n    height: calc(100vh - ",
        ");\n    height: calc(100dvh - ",
        ");\n    top: ",
        ";\n\n    ",
        " {\n      height: calc(100vh - ",
        ");\n      height: calc(100dvh - ",
        ");\n      top: ",
        ";\n    }\n\n    ",
        " {\n      height: calc(100vh - ",
        ");\n      top: ",
        ";\n      z-index: 150;\n    }\n\n    ",
        " {\n      height: calc(100vh - ",
        ");\n      top: 100px;\n    }\n\n  }\n\n  > div {\n    margin-top: -",
        ";\n    margin-bottom: 0;\n    pointer-events: auto;\n    background-color: transparent;\n\n    ",
        " {\n      margin-top: -",
        ";\n      padding-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: -",
        ";\n    }\n\n    ",
        " {\n      margin-top: -40px;\n    }\n  }\n"
    ]);
    SectionProductDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionProductDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  width: 100dvw;\n  z-index: 150;\n\n  ",
        " {\n    ",
        "\n  }\n  > section {\n    pointer-events: auto;\n\n    ",
        " {\n      grid-column: 8 / span auto;\n      position: relative;\n      margin-left: 50px;\n    }\n    @media (min-width: 1800px) {\n      margin-left: 30px;\n    }\n    ",
        " {\n      margin-left: 20px;\n    }\n    @media (min-width: 2000px) {\n      margin-left: 10px;\n    }\n  }\n\n"
    ]);
    SectionProductDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionProductDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 50%;\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n  pointer-events: auto;\n  position: sticky;\n  right: ",
        ";\n  top: ",
        ";\n  width: ",
        ";\n  z-index: 200;\n  transform: translateX(",
        ");\n  transition: 200ms transform ",
        ", 200ms margin ",
        ";\n  margin-right: 0;\n  margin-left: auto;\n\n  ",
        " {\n    height: ",
        ";\n    right: ",
        ";\n    top: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    height: ",
        ";\n    right: ",
        ";\n    top: ",
        ";\n    width: ",
        ";\n    transform: translateX(",
        ");\n  }\n\n  ",
        " {\n    height: 40px;\n    right: 30px;\n    top: 40px;\n    width: 40px;\n    transform: translateX(",
        ");\n  }\n\n  figure {\n    height: ",
        ";\n    width: ",
        ";\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      height: 16px;\n      width: 16px;\n    }\n  }\n"
    ]);
    SectionProductDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var mediaCloseIcon = {
    type: "image",
    alt: "Icon close",
    default: {
        src: "/images/svg/i--close.svg",
        size: {
            width: 40,
            height: 40
        }
    }
};
var SectionProductDetail = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _filters = param.filters, filters = _filters === void 0 ? {} : _filters;
    var ref;
    var scrollState = (0,dist_hooks.useScrollTracker)(0);
    var scrollTop = (0,react.useMemo)(function() {
        return scrollState === "TOP";
    }, [
        scrollState
    ]);
    var filtersInSlider = typeof filters === "object" ? ((ref = Object.keys(filters)) === null || ref === void 0 ? void 0 : ref.length) >= 8 : false;
    // const { isMobile } = useDeviceType()
    var ref1 = (0,hooks/* useActiveVariant */.wT)(), cardSelected = ref1.cardSelected, removeActiveVariant = ref1.removeActiveVariant;
    var customer = (0,hooks/* useCustomer */.ON)().customer;
    var pathname = (0,router.useRouter)().pathname;
    var ref2 = (0,react.useState)(false), showLargeProductDetail = ref2[0], setShowLargeProductDetail = ref2[1];
    // const onMouseDown = useCallback(({ target }) => {
    //   if (!isMobile) {
    //     const section = document.getElementById('detail-page-wrapper')
    //     if (!section) return 
    //     const clickedInSection = section.contains(target)
    //     console.log(clickedInSection, 'clickedInSection', target, 'target')
    //     if (clickedInSection) return
    //     if (target instanceof HTMLAnchorElement || target instanceof HTMLButtonElement) {
    //       if (!target.classList.contains('product-card') && !target.classList.contains('btn-add') && !target.classList.contains('btn-bin')) removeActiveVariant()
    //     } else if (target instanceof HTMLImageElement) {
    //       console.log('.')
    //     } else {
    //       removeActiveVariant()
    //     }
    //   }
    // }, [isMobile, removeActiveVariant])
    var onKeyUp = (0,react.useCallback)(function(e) {
        if (e.code === "Escape" || e.key === "Escape" || e.keyCode === 27) {
            removeActiveVariant();
        }
    }, [
        removeActiveVariant
    ]);
    (0,react.useEffect)(function() {
        if (!cardSelected) return;
        window.addEventListener("keyup", onKeyUp);
        // window.addEventListener('mousedown', onMouseDown)
        return function() {
            window.removeEventListener("keyup", onKeyUp);
        // window.removeEventListener('mousedown', onMouseDown)
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cardSelected
    ]);
    (0,react.useEffect)(function() {
        if (cardSelected) setShowLargeProductDetail(true);
    }, [
        cardSelected
    ]);
    (0,react.useEffect)(function() {
        if (pathname === "/" || pathname === "/welcome") {
            if (cardSelected) removeActiveVariant();
            setShowLargeProductDetail(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    if (!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Div, {
        $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetailSection, {
            id: "detail-page-wrapper",
            className: "plp-page",
            $showLargeProductDetail: showLargeProductDetail,
            $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
            $filtersInSlider: filtersInSlider,
            $scrollTop: scrollTop,
            $scrollUp: scrollState === "SCROLLING_UP",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseDetailsButton, {
                    onClick: removeActiveVariant,
                    name: "Close details",
                    $filtersInSlider: filtersInSlider,
                    $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                        media: mediaCloseIcon
                    })
                }),
                !!customer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(product_slug_["default"], {
                    variant: cardSelected
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_slug_["default"], {
                    variant: cardSelected
                })
            ]
        })
    }, cardSelected.variant_id);
});
var ProductDetailSection = (0,styled_components_browser_esm["default"])(motion/* motion.section */.E.section).withConfig({
    displayName: "SectionProductDetail__ProductDetailSection",
    componentId: "sc-23d32570-0"
})(SectionProductDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var $activeVariant = param.$activeVariant, colors = param.theme.colors;
    return $activeVariant ? "0 40px 40px 0 ".concat((0,styles.hex2Rgba)(colors.black, .1)) : "none";
}, function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "100vw";
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.hideScrollbar)(), styles.mq.greaterThan("nexus7"), (0,styles.vw)(65, "nexus7"), (0,styles.vw)(65, "nexus7"), (0,styles.vw)(65, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(160, "desktop"), (0,styles.vw)(160, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(60, "desktop"), (0,styles.vw)(120, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-10px" : "100vw";
}, (0,styles.vw)(580, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-20px" : "100vw";
}, styles.mq.greaterThan("large-screen"), (0,styles.vw)(120, "mobile"), (0,styles.vw)(120, "mobile"), (0,styles.vw)(120, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(120, "nexus7"), (0,styles.vw)(120, "nexus7"), (0,styles.vw)(120, "nexus7"), styles.mq.greaterThan("tablet"), function(param) {
    var $showLargeProductDetail = param.$showLargeProductDetail, $scrollUp = param.$scrollUp;
    return $showLargeProductDetail ? $scrollUp ? (0,styles.vw)(140, "desktop") : (0,styles.vw)(60, "desktop") : (0,styles.vw)(160, "desktop");
}, (0,styles.vw)(100, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var $showLargeProductDetail = param.$showLargeProductDetail, $scrollUp = param.$scrollUp;
    return $showLargeProductDetail ? $scrollUp ? "140px" : "60px" : "160px";
}, (0,styles.vw)(40, "mobile"), styles.mq.lessThan("tablet"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), styles.mq.greaterThan("desktop"));
var Div = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionProductDetail__Div",
    componentId: "sc-23d32570-1"
})(SectionProductDetail_templateObject1(), styles.mq.greaterThan("desktop-wide"), (0,styles.designGrid)({}), styles.mq.greaterThan("desktop-wide"), styles.mq.greaterThan("large-screen"));
var CloseDetailsButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SectionProductDetail__CloseDetailsButton",
    componentId: "sc-23d32570-2"
})(SectionProductDetail_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(40, "mobile"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "100vw";
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(40, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : (0,styles.vw)(600, "desktop");
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? 0 : "600px";
}, (0,styles.vw)(16, "mobile"), (0,styles.vw)(16, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(16, "nexus7"), (0,styles.vw)(16, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(16, "desktop"), (0,styles.vw)(16, "desktop"), styles.mq.greaterThan("desktop"));

;// CONCATENATED MODULE: ./components/shop/SectionFeaturedFilters.tsx



function SectionFeaturedFilters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 6;\n  grid-row: 2 / span 1;\n  margin-top: ",
        ";\n\n  ",
        " {\n    grid-column: 4 / span 9;\n    grid-row: 1;\n    margin-top: ",
        ";\n  }\n\n  > div {\n    ",
        " {\n      padding: ",
        " 0 0 ",
        ";\n      transform: translateX(",
        ");\n      transition: 300ms width ease-in-out, 200ms transform ",
        ";\n      width: 100%;\n    }\n\n    ",
        " {\n      padding: 80px 0 0 60px;\n      transform: translateX(",
        ");\n    }\n\n    li {\n      padding: ",
        " ",
        ";\n      width: ",
        ";\n\n      ",
        " {\n        padding: ",
        " ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        padding: 0 ",
        " 0 0;\n        padding: ",
        ";\n        width: ",
        ";\n      }\n\n      ",
        " {\n        padding: 0 158px 0 0;\n      }\n    }\n  }\n"
    ]);
    SectionFeaturedFilters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionFeaturedFilters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n    margin: 0;\n  }\n\n  img {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n    user-select: none;\n    width: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 0;\n      margin-right: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      margin-right: 38px;\n      width: 165px;\n    }\n  }\n\n  &.param-marca,\n  &.param-brand,\n  &.param-marque {\n    figure {\n      align-items: center;\n      background: ",
        ";\n      border-radius: 50%;\n      display: flex;\n      height: ",
        ";\n      justify-content: center;\n      padding: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        height: ",
        ";\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        height: 165px;\n        padding: 20px;\n      }\n\n      img {\n        filter: invert(.95);\n        height: 100%;\n      }\n    }\n  }\n\n  .text-wrapper {\n    padding-top: ",
        ";\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: 20px;\n    }\n  }\n\n  h2 {\n    color: ",
        ";\n    ",
        "\n    font-weight: bold;\n    letter-spacing: -.5;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 5px;\n    }\n  }\n\n  p {\n    color: ",
        ";\n    ",
        "\n    text-align: center;\n  }\n\n  h2, p {\n    ",
        " {\n      text-align: left;\n    }\n  }\n"
    ]);
    SectionFeaturedFilters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var getSlides = function(filters, isBrandPage) {
    return filters.map(function(filter, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article, {
                className: "param-".concat(filter.param),
                $isBrandPage: isBrandPage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: filter.media.url,
                        alt: filter.media.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: filter.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: filter.description
                                }
                            })
                        ]
                    })
                ]
            })
        }, "slide-".concat(idx));
    });
};
var SectionFiltersFeatured = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _filters = param.filters, filters = _filters === void 0 ? [] : _filters, isBrandPage = param.isBrandPage;
    var activeVariant = (0,hooks/* useActiveVariant */.wT)().activeVariant;
    var Slides = (0,react.useMemo)(function() {
        return getSlides(filters, isBrandPage);
    }, [
        filters,
        isBrandPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFeaturedFilters_Section, {
        variants: variants,
        initial: "initial",
        exit: "exit",
        animate: (filters === null || filters === void 0 ? void 0 : filters.length) < 1 ? "exit" : "animate",
        $activeVariant: !!activeVariant,
        $isBrandPage: isBrandPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.SliderFlickity, {
            className: "slider--product-card",
            options: {
                freeScroll: false,
                pageDots: false,
                groupCells: "80%",
                cellAlign: "left"
            },
            children: Slides
        })
    });
});
var DynamicSectionFiltersFeatured = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7074)).then(function(mod) {
        return mod.SectionFiltersFeatured;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7074)
            ];
        }
    },
    ssr: false
});
var SectionFeaturedFilters_Section = (0,styled_components_browser_esm["default"])(motion/* motion.section */.E.section).withConfig({
    displayName: "SectionFeaturedFilters__Section",
    componentId: "sc-a1fd74e9-0"
})(SectionFeaturedFilters_templateObject(), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "".concat((0,styles.vw)(48, "mobile")) : 0;
}, styles.mq.greaterThan("tablet"), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "".concat((0,styles.vw)(48, "desktop")) : 0;
}, styles.mq.greaterThan("tablet"), (0,styles.vw)(80, "desktop"), (0,styles.vw)(10, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat((0,styles.vw)(350, "desktop")) : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-350px" : 0;
}, (0,styles.vw)(40, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(414, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(40, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(603, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(158, "desktop"), function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "0" : "0 ".concat((0,styles.vw)(158, "desktop"), " 0 0");
}, function(param) {
    var $isBrandPage = param.$isBrandPage;
    return $isBrandPage ? "unset" : "80%";
}, styles.mq.greaterThan("desktop"));
var Article = styled_components_browser_esm["default"].article.withConfig({
    displayName: "SectionFeaturedFilters__Article",
    componentId: "sc-a1fd74e9-1"
})(SectionFeaturedFilters_templateObject1(), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(125, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(125, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(38, "desktop"), (0,styles.vw)(165, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(125, "mobile"), (0,styles.vw)(12, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(125, "nexus7"), (0,styles.vw)(12, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(165, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP20_1)(), (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(5, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.getP15_2)(), styles.mq.greaterThan("tablet"));
var variants = {
    initial: {
        height: "0px",
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            delay: 0
        })
    },
    animate: {
        height: "auto",
        opacity: 1,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .5,
            delay: .4
        })
    },
    exit: {
        height: "0px",
        opacity: 0,
        transition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,styles.getTransition)()), {
            duration: .2,
            delay: 0
        })
    }
};

;// CONCATENATED MODULE: ./components/shop/ContentSectionBrand.tsx

function ContentSectionBrand_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: ",
        " 0 ",
        ";\n\n  ",
        " {\n    margin: ",
        " 0 ",
        ";\n  }\n  ",
        " {\n    margin: ",
        " 0 0;\n  }\n\n  ",
        " {\n    margin: 180px 0 0;\n  }\n\n  img {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n    user-select: none;\n    width: ",
        ";\n    /* filter:invert(49%) sepia(37%) saturate(691%) hue-rotate(313deg) brightness(74%) contrast(127%); */\n\n    ",
        " {\n      margin-bottom: ",
        ";\n      width: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 0;\n      width: ",
        ";\n    }\n\n    ",
        " {\n      width: 165px;\n    }\n  }\n\n  .text-wrapper {\n    ",
        "\n    color: ",
        ";\n    padding-top: ",
        ";\n    width: 95%;\n    ",
        " {\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      width: 50%;\n      padding-top: ",
        ";\n    }\n\n    ",
        " {\n      padding-top: 60px;\n    }\n  }\n\n  h2 {\n    color: ",
        ";\n    ",
        "\n    letter-spacing: -.5;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n\n    ",
        " {\n      margin-bottom: 60px;\n    }\n  }\n\n  h2, p, a {\n    ",
        " {\n      text-align: left;\n    }\n  }\n"
    ]);
    ContentSectionBrand_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ContentSectionBrand = /*#__PURE__*/ (0,react.memo)(function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSectionBrand_Article, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: data.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: data.logo.url,
                alt: data.logo.alt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: data.description
                    }
                })
            })
        ]
    });
});
var DynamicContentSectionBrand = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7074)).then(function(mod) {
        return mod.ContentSectionBrand;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7074)
            ];
        }
    },
    ssr: false
});
var ContentSectionBrand_Article = styled_components_browser_esm["default"].article.withConfig({
    displayName: "ContentSectionBrand__Article",
    componentId: "sc-40e918f3-0"
})(ContentSectionBrand_templateObject(), (0,styles.vw)(138, "nexus7"), (0,styles.vw)(40, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(138, "nexus7"), (0,styles.vw)(40, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(180, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(125, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(125, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(165, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP18_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(48, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(48, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, (0,styles.getP20_5)(), (0,styles.vw)(46, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(46, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.greaterThan("tablet"));

;// CONCATENATED MODULE: ./components/shop/ViewMore.tsx

function ViewMore_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 auto ",
        ";\n  grid-column: 1 / span 6;\n\n  ",
        " {\n    margin: 0 auto ",
        ";\n  }\n\n  ",
        " {\n    grid-column: 8 / span 1;\n    grid-row:6/ auto;\n    margin: 0 auto ",
        ";\n    transform: translateX(",
        ");\n    transition: 400ms transform ",
        ", 400ms margin ",
        ", 300ms top ",
        ", 300ms height ",
        ";\n    left: auto;\n  }\n\n  ",
        " {\n    margin: 0 auto 100px;\n    transform: translateX(",
        ");\n  }\n\n  > figure {\n      height:",
        ";\n      margin-bottom:",
        ";\n      width:",
        ";\n\n    ",
        " {\n      height:",
        ";\n      margin-bottom:",
        ";\n      width:",
        ";\n    }\n\n    ",
        " {\n      height:",
        ";\n      margin-bottom:",
        ";\n      width:",
        ";\n    }\n\n    ",
        " {\n      height: 99px;\n      margin-bottom: 20px;\n      width: 91px;\n    }\n  }\n\n  &:last-child {\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    ViewMore_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var mediaViewMore = {
    type: "image",
    alt: "View more",
    default: {
        src: "/images/svg/btn-hexagon.svg",
        size: {
            width: 91,
            height: 99
        }
    }
};
var ViewMore = /*#__PURE__*/ (0,react.memo)(function(param) {
    var pagination = param.pagination;
    var productsDisplayed = pagination.productsDisplayed, totalProducts = pagination.totalProducts;
    var t = (0,hooks/* useTranslator */.I4)().t;
    var cardSelected = (0,hooks/* useActiveVariant */.wT)().cardSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        $activeVariant: !!(cardSelected === null || cardSelected === void 0 ? void 0 : cardSelected.variant_id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                media: mediaViewMore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: (0,utils.getDynamicText)(t("shop.displayed_products"), {
                    productsDisplayed: productsDisplayed,
                    totalProducts: totalProducts
                })
            })
        ]
    });
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ViewMore__Wrapper",
    componentId: "sc-9911db0b-0"
})(ViewMore_templateObject(), (0,styles.vw)(100, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(100, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(100, "desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat((0,styles.vw)(120 * 4, "desktop")) : 0;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, function(param) {
    var theme = param.theme;
    return theme.ease;
}, styles.mq.greaterThan("desktop"), function(param) {
    var $activeVariant = param.$activeVariant;
    return $activeVariant ? "-".concat(120 * 4, "px") : 0;
}, (0,styles.vw)(99, "mobile"), (0,styles.vw)(20, "mobile"), (0,styles.vw)(91, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(99, "nexus7"), (0,styles.vw)(20, "nexus7"), (0,styles.vw)(91, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(99, "desktop"), (0,styles.vw)(20, "desktop"), (0,styles.vw)(91, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_5)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkcreme;
});

;// CONCATENATED MODULE: ./components/shop/index.ts










/***/ }),

/***/ 42769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ listVariants; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_0__);


var listVariants = {
    active: {
        opacity: 1,
        transition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_0__.getTransition)())
    },
    inactive: {
        opacity: 0,
        transition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_0__.getTransition)())
    }
};


/***/ }),

/***/ 28449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* reexport */ ActiveVariantContext; },
  "z$": function() { return /* reexport */ ActiveVariantProvider; },
  "Am": function() { return /* reexport */ CustomerContext; },
  "f3": function() { return /* reexport */ CustomerProvider; },
  "yJ": function() { return /* reexport */ TranslationsContext; },
  "tY": function() { return /* reexport */ TranslationsProvider; }
});

// UNUSED EXPORTS: GridVariantsContext, GridVariantsProvider, getTranslations

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
;// CONCATENATED MODULE: ./public/locales/en.json
var en_namespaceObject = JSON.parse('{"layout":{"nav":{"account":{"name":"Account","pathname":"/account"},"cart":{"name":"Cart","pathname":"/cart"},"home":{"name":"Home","pathname":"/"},"shop":{"name":"Shop","pathname":"/catalog"},"my_usuals":{"name":"My Usuals","pathname":"/account/my-products"},"products":{"name":"Products","pathname":"/catalog"},"about_us":{"name":"About Us","pathname":"/page/about-us"},"contact_us":{"name":"Contact Us","pathname":"/page/contact-us"},"catalogue":{"name":"Catalogue PDF","pathname":"/page/catalogue"},"events":{"name":"In giro con Mammafiore","pathname":"/page/in-giro-con-noi"}},"footer":{"questions":"Got Questions?","write_us":"Write to Us","email":"london@mammafiore.eu","call_us":"or call","phone_link":"4402037576120","phone_number":"+44 (0) 2037576120","newsletter":{"title":"Join Our Famiglia","input_inactive":"Leave Us Your Email","button":"Join"},"partners":"Our Partners","legal_warning":"Legal Notice","change_country_lang":"Change Area"},"search":{"search_results":"Search Results","history":"Search History","delete":"Delete","empty_01":"We haven\'t found any results. Would you like to make a ","empty_02":"new search?","product":"product","products":"products","brand":"brand","search_by_category":"Search by Category:","what_are_you_looking_for":"What are you looking for?"},"nav_account":[{"name":"Orders","pathname":"/account/[slug]","slug":"orders"},{"name":"Invoices","pathname":"/account/[slug]","slug":"invoices"},{"name":"Addresses","pathname":"/account/[slug]","slug":"addresses"},{"name":"Access Data","pathname":"/account"},{"name":"Log Out","action":"logout"}]},"form":{"fields":{"email":"Email","first_name":"First Name","last_name":"Last Name","phone":"Phone","mobile_phone":"Mobile Phone","password":"Password","new_password":"New Password","street_line1":"Address","street_line2":"Apartment/Suite/Building","country":"Country","province":"Region","city":"City","postal_code":"Postal Code","comments":"Comments","shipping_as_billing":"Use shipping address as billing address","im_a_company":"I am a company","cif":"CIF","company_name":"Company Name"},"errors":{"incomplete":"The form must be fully completed to send","required":"This field is required","empty":"This field cannot be empty","minLength":"The field length is not sufficient","maxLength":"The field length has been exceeded","pattern_username":"The username can only contain alphanumeric characters","pattern_password":"The password must be at least 8 characters and contain at least one of each; uppercase and lowercase, numbers and symbols","pattern_email":"The entered email is not valid","validate_cif":"The entered CIF number is not valid","validate_phone":"The entered phone number is not valid","validate_iban":"The entered IBAN number is not valid"}},"commons":{"actions":{"accept":"Accept","add":"Add","cancel":"Cancel","close":"Close","continue":"Continue","delete":"Delete","delete_all":"Delete All","download":"Download","edit":"Edit","enter":"Enter","go_back":"Go Back","load":"Load","login":"Log In","logout":"Log Out","next":"Next","prev":"Previous","remove":"Remove","save":"Save","search":"Search","send":"Send","signup":"Sign Up","submit":"Submit","add_to_cart":"Add to Cart","how_to_buy":"How to Buy","increase_cart_units":"Increase Cart Units","remove_units_from_cart":"Remove Units from Cart","delete_from_cart":"Delete from Cart","show":"Show"},"status":{"deleting":"Deleting","downloading":"Downloading","loading":"Loading","saving":"Saving","updating":"Updating","uploading":"Uploading"},"newsletter_feedback":{"success":"Thank you! We will keep you informed about the latest news","error":"There was a problem sending the form. Please try again later","duplicated":"Email is already registered"},"faqs":{"title":"Frequently Asked Questions"},"page_not_found":{"404":"Page not found.","title":"The page you are looking for does not exist","description":"Try navigating through the website to find it. Or maybe you’ll discover something much better, who knows?","goback_homepage":"Go back to Home"},"page_error":{"500":"An unexpected error occurred","title":"The page you are looking for encountered an error","description":"Try navigating to another area of the website.","goback_homepage":"Go back to Home"},"region_picker":{"in":"In","work_with":"we operate through:","go_catalogue":"Go to catalogue"},"cart":{"total":"total","show_cart":"View cart","go_checkout":"Proceed to checkout","free":"Free"}},"modals":{"auth":{"start":{"title":"Access","text":"Are you a Mammafiore customer? Even if you have never purchased through our website.","actions":{"primary":"I am already a customer","secondary":"I want to register"}},"prelogin":{"title":"Access","subtitle":"Have you already activated your account on our website?","text":"If you are already a Mammafiore customer but have never purchased through the website, click on Activate account.","actions":{"primary":"Log in","secondary":"Activate account"},"subtext":"Not yet a Mammafiore customer?","subtext_action":"Register"},"login":{"title":"Log in","text":"Welcome back to Mammafiore.","forgot_password":"Forgot your password?","subtext":"Are you a customer but have not yet activated your account?","subtext_action":"activate it here"},"login_check_cif":{"title":"Activate Account","text":"First enter your CIF.","text2":"You are in the store of {{storeName}}. If you are from another country/zone, you can change","text2_action":" here"},"signup":{"title":"Registration","text":"You are signing up in the store of If you are from another country/zone, you can change here.","iban":"Simplify your payments. Buy what you need and we\'ll charge it to your bank account at the end of the month. Fill in your IBAN and we\'ll notify you when it\'s enabled as a payment method. Meanwhile, you can place your orders by paying with a card"},"signup_cif":{"title":"Registration","text":"You are signing up for the store of {{storeName}}. If you are from another country/zone, you can change","text_action":" here","subtext":"If you are already a customer (even if you have never purchased through our website) access","subtext_action":" here"},"activation":{"title":"Account Activation","text":"Add a password to complete the activation of your account."},"forgot_password":{"title":"Reset Password","text":"Enter your email to request a new password. We will send you an email with a verification link."},"reset_password":{"title":"Reset Password","text":"Add your new password"},"feedback_account_active":{"title":"Account Activated","text":"Your account has been successfully activated."},"feedback_password_updated":{"title":"New Password","text":"Your password has been successfully updated."},"feedback_email_invite":{"title":"You have an inactive account","text":"We have sent you an email to ","text_2":". Open it and follow the instructions.","text2":"If you do not have access to this email, contact us at info@mammafiore.eu or +34 93 303 76 15"},"feedback_email_reset_password":{"title":"Recover Password","text":"We have sent you a link to create a new password."},"feedback_cif_already_active":{"title":"You Already Have an Account","text":"This CIF already has an active account on our website with the email","text2":"You can ","text2_2":" or ","text2_actions":{"login":"log in","restore_password":"reset your password."}},"feedback_cif_not_found":{"title":"CIF Not Found","text":"We do not have the CIF","text_2":" in our database.","text2":"If it is misspelled, you can go back. If you think it is an error or need help, contact us at ","test2_2":" / ","text2_actions":{"email":"email@mammafiore.es","phone":"743 673 554"},"text3":"Or if you are not yet a Mammafiore customer, you can","text3_action":"register here"}},"filter":{"title":"Filter"},"region_register":{"title":"New Account","description":"Registration is only available for countries or regions with an online store. Would you like to stay here or change the country?","action_change":"Change Country/Region","action_stay":"Stay Here"},"region_lang":{"title":"Select Region"},"commercial":{"title":"How to Buy","in":"In {{storeName}} we operate through:","ok":"OK","action_change":"Change Country/Region"},"stock_cart":{"title":"Cart updated","description":"We\'ve updated your cart with the available stock for:","deleted":"(removed, no stock available now)","stock_change_1":"(updated to","stock_change_2":"unit(s), currently the maximum available)","ok":"OK"},"public_interested":{"title":"How to Buy","contact":"For professional purchases, contact ","mail":"sales@mammafiore.es","particular":"To buy as an individual","cta_hm":"visit our","online":"online store"},"comercial_region":{"write_us":"Write to us at","mail_to_link":"mailto:london@mammafiore.eu","mail_to":"london@mammafiore.eu","more_info":"for more info.","open_account":"and we will open an account for you","professional":"Are you a professional? Write to us at ","b2c":"Are you an individual? Shop in our online store","link_to_b2c":"https://hellomamma.co.uk","link_b2c":"hellomamma.co.uk","you_are_in":"You are in "},"buy_box":{"title":"Buy by box","text":"This product can be added by boxes, the boxes contain {{units}} units. How many boxes would you like?"}},"payment_status":{"succeeded":"Payment succeeded","processing":"Processing your payment.","requires_payment_method":"Your payment was not successful, please try again.","something_went_wrong":"Something went wrong.","unexpected_error":"An unexpected error occurred."},"dates":{"months":{"january":"January","february":"February","march":"March","april":"April","may":"May","june":"June","july":"July","august":"August","september":"September","october":"October","november":"November","december":"December"},"weekdays":{"monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday"},"seasons":{"spring":"Spring","Summer":"Summer","autumn":"Autumn","winter":"Winter"}},"home":{"bestseller":{"new":"Discover all our new products","offer":"Essentials for your pantry"},"brands":{"brands_title":"Behind every product is a great brand"}},"section_subscribe":{"welcome":"Welcome to the family","register":"Register and enjoy the benefits of being part of Mammafiore:","open":"Open 24/7 all year round","order":"Place your order with your mobile, tablet or PC","offer":"Personalised offers","save_products":"We save your products so you don\'t lose time","check_invoices":"Easily check orders or invoices","contact_commercial":"Direct contact with your sales representative","register_button":"Register at Mammafiore"},"account":{"buy_again":"Buy Again","repeat_order":"Repeat Order","details":"Order Details","invoice":"Invoice","invoice_issued":"Invoice issued on","invoice_download":"Download Invoice","no_invoice":"Vuoto come una pentola a fine festa! You don\'t have any invoices in the system yet. We\'ll put them here as they are generated","no_orders":"Che tristezza! Your order list looks like the desert. Here you\'ll see them (when you make them)","my_products":{"my_usual":"My Usuals","title":"We make it very easy for you","description":"Register and you will be able to see the products you bought in previous orders and have them at hand to facilitate your next purchases.","identify":"Register or log in"},"home_my_products":{"see_all":"See all","last_orders":"Last orders","my_usuals":"My usuals","my_comercial":"My commercial"},"order":{"shipping_address":"Shipping address","billing_address":"Billing address","summary":"Summary","coupon":"Discount coupon","shipping_cost":"Shipping costs","subtotal":"Subtotal","discount":"Discount","total":"Total","taxes":"VAT","purchase":"Purchase","date":"Date","number":"Order No","purchase_order":"Place order","several_dates":"You have products with different delivery dates. We will serve you the entire order on the date of the last product. You can modify the order if you want to receive the rest sooner.","order_details":{"shipment":"Shipping","billing":"Billing","payment":"Payment","payment_summary":"Order summary","total_products":"Total products","subtotal_products":"Subtotal","discount":"Applied discounts","voucher":"Voucher","total_inc_tax":"Total (incl. VAT)","estimated_date":"Estimated date"},"no_stock":"There is no stock for this product","repeat_order_feedback":{"success":"All available products have been added to the cart"}}},"product_page":{"product_main":{"size_dropdown":"Choose format:","button_add":"Add to cart","no_stock":"Out of stock","not_available":"Not Available","see_more":"See more","choose_size":"Choose format:"},"product_description":{"nutritional_value":{"title":"Nutritional Info","per_ration":"Per serving","per_100gr":"Per 100g","ingredients":"Ingredients","average_value_per":"Average value per","energy":"Energy"},"more_info":{"title":"More info"}},"bottom-page":{"related":"Inseparable"},"product":{"units":"Units","units_abbr":"units","color":"colour","colors":"colours","pack":"Pack","bundle":"Bundle","no_stock":"Out of stock","last_units":"Last units!","on_demand":"Delivery","demand_product":"ON DEMAND","tax":"VAT","price_per":{"unit":"/unit","box":"/box","kg":"/Kg"},"buy_box":"Order by boxes of {{units}} units","description_min_sale_units":"Boxes of {{minSaleUnits}} (adding in units of {{minSaleUnits}})","delivery_date_stocked":"Estimated delivery: {{deliveryDate}} (orders before {{deliveryHour}})","delivery_date_on_demand":"Estimated delivery: {{deliveryDate}} (orders before {{onDemandDay}} at {{deliveryHour}})","delivery_date_frozen":"Estimated delivery: {{deliveryDate}} (orders before {{deliveryHour}})","frozen_cart":"Frozen orders are managed separately. To add non-frozen products, finish the order or empty the cart.","fresh_cart":"Non-frozen orders are managed separately. To add frozen products, finish"}},"shop":{"filters":"Filter","no_filter":"No products match the selected filters","no_products":"Mamma mia, la tavola è vuota! As soon as you have orders, we\'ll show your favorite regular products here so you can find them quickly","displayed_products":"You have seen {{productsDisplayed}} of {{totalProducts}}"},"cart":{"500":{"title":"There has been a problem trying to connect to your shopping cart.","try_again_later":"Please wait a few moments and try again later.","sorry":"Sorry for the inconvenience."},"cart":"Your cart","articles":"items","article":"item","add_relateds":"Add these inseparables","minimum_order":"Minimum order","cart_date_error":"There was a problem choosing the delivery date, please try again later","cart_error":"There has been an error with the cart, please try again later","order_saved":"You have saved on this order","delivery_available":"Delivery available {{deliveryDate}} (but will be grouped into a single delivery {{cartDeliveryDate}})","delivery_date":"Delivery {{deliveryDate}}","delivery_date_stocked":"(orders before {{deliveryHour}})","delivery_date_on_demand":"(orders before {{onDemandDay}} at {{deliveryHour}})","delivery_date_frozen":"(orders before {{deliveryHour}})"}}');
;// CONCATENATED MODULE: ./public/locales/es.json
var es_namespaceObject = JSON.parse('{"layout":{"nav":{"account":{"name":"Cuenta","pathname":"/account"},"cart":{"name":"Carrito","pathname":"/cart"},"home":{"name":"Inicio","pathname":"/"},"shop":{"name":"Productos","pathname":"/catalog"},"my_usuals":{"name":"Mis habituales","pathname":"/account/my-products"},"products":{"name":"Productos","pathname":"/catalog"},"about_us":{"name":"Nosotros","pathname":"/page/sobre-nosotros"},"contact_us":{"name":"Contacta","pathname":"/page/contacta"},"catalogue":{"name":"Catálogo PDF","pathname":"/page/catalogo"},"events":{"name":"In giro con noi","pathname":"/page/in-giro-con-noi"}},"footer":{"questions":"¿Tienes preguntas?","write_us":"Escríbenos","email":"info@mammafiore.eu","call_us":"o llama al","phone_link":"34933037615","phone_number":"+34 93 303 76 15","newsletter":{"title":"Únete a nuestra famiglia","input_inactive":"Déjanos tu email","button":"Unirme"},"partners":"Nuestros partners","legal_warning":"Aviso legal","change_country_lang":"Cambiar zona"},"search":{"search_results":"Resultados de búsqueda","history":"Historial de búsqueda","delete":"Borrar","empty_01":"No hemos encontrado resultados. ¿Quieres realizar una ","empty_02":"nueva búsqueda?","product":"producto","products":"productos","brand":"marca","search_by_category":"Buscar por categoría:","what_are_you_looking_for":"¿Qué estás buscando?"},"nav_account":[{"name":"Pedidos","pathname":"/account/[slug]","slug":"orders"},{"name":"Facturas","pathname":"/account/[slug]","slug":"invoices"},{"name":"Direcciones","pathname":"/account/[slug]","slug":"addresses"},{"name":"Datos de acceso","pathname":"/account"},{"name":"Cerrar sesión","action":"logout"}]},"form":{"fields":{"email":"Email","first_name":"Nombre","last_name":"Apellidos","phone":"Teléfono","mobile_phone":"Teléfono móvil","password":"Contraseña","new_password":"Nueva contraseña","street_line1":"Dirección","street_line2":"Apartamento/Suite/Edificio","country":"País","province":"Región","city":"Ciudad","postal_code":"Código postal","comments":"Comentarios","shipping_as_billing":"Usar dirección de envío como dirección de facturación","im_a_company":"Soy una empresa","cif":"CIF","company_name":"Nombre de empresa"},"errors":{"incomplete":"Hay que rellenar completamente el formulario para poder enviarlo","required":"Este campo es requerido","empty":"Este campo no puede estar vacío","minLength":"La longitud del campo no es suficiente","maxLength":"Se ha excedido la longitud del campo","pattern_username":"El nombre de usuario solo puede contener carácteres alfanuméricos","pattern_password":"La contraseña debe ser al menos de 8 carácteres y contener al menos 1 de cada; mayúsculas y minúsculas, números y símbolos","pattern_email":"El email introducido no es válido","validate_cif":"El número CIF introducido no es válido","validate_phone":"El número de Teléfono introducido no es válido","validate_iban":"El número IBAN introducido no es válido"}},"commons":{"actions":{"accept":"Aceptar","add":"Añadir","cancel":"Cancelar","close":"Cerrar","continue":"Continuar","delete":"Eliminar","delete_all":"Eliminar todo","download":"Descargar","edit":"Editar","enter":"Entrar","go_back":"Ir atrás","load":"Cargar","login":"Iniciar sesión","logout":"Cerrar sesión","next":"Siguiente","prev":"Anterior","remove":"Quitar","save":"Guardar","search":"Buscar","send":"Enviar","signup":"Crear cuenta","submit":"Entregar","add_to_cart":"Añadir al carrito","how_to_buy":"Cómo comprar","increase_cart_units":"Aumentar unidades del carrito","remove_units_from_cart":"Quitar unidades del carrito","delete_from_cart":"Eliminar del carrito","show":"Mostrar"},"status":{"deleting":"Eliminando","downloading":"Descargando","loading":"Cargando","saving":"Guardando","updating":"Actualizando","uploading":"Subiendo"},"newsletter_feedback":{"success":"Gracias! Te mantendremos informado sobre las últimas novedades","error":"Hubo un problema enviando el formulario. Por favor inténtelo de nuevo más tarde","duplicated":"Email ya esta dado de alta"},"faqs":{"title":"Preguntas frecuentes"},"page_not_found":{"404":"Página no encontrada.","title":"La página que estás buscando no existe","description":"Prueba de navegar por la web a ver si lo encuentras. O quizás descubres algo mucho mejor, quién sabe.","goback_homepage":"Volver a la Home"},"page_error":{"500":"Sucedió un error inesperado","title":"La página que estás buscando sufrió un error","description":"Prueba de navegar por otra zona de la web.","goback_homepage":"Volver a la Home"},"region_picker":{"in":"En","work_with":"operamos a través de:","go_catalogue":"Ir al catálogo"},"cart":{"total":"total","show_cart":"Ver cesta","go_checkout":"Tramitar pedido","free":"Gratis"}},"modals":{"auth":{"start":{"title":"Acceso","text":"¿Eres cliente de Mammafiore?  Aunque no hayas comprado nunca a través de nuestra web.","actions":{"primary":"Ya soy cliente","secondary":"Quiero registrarme"}},"prelogin":{"title":"Acceso","subtitle":"¿Has activado ya tu cuenta en nuestra web?","text":"Si ya eres cliente de Mammafiore pero nunca has comprado a través de la web, toca Activar cuenta.","actions":{"primary":"Inciar sesión","secondary":"Activar cuenta"},"subtext":"¿Todavía no eres cliente de Mammafiore?","subtext_action":"Registrarme"},"login":{"title":"Iniciar sesión","text":"Bienvenido de nuevo a Mammafiore.","forgot_password":"¿Has olvidado tu contraseña?","subtext":"¿Eres cliente pero todavía no has activado tu cuenta?","subtext_action":"actívala aquí"},"login_check_cif":{"title":"Activar cuenta","text":"Escribe primero tu CIF.","text2":"Estás en la tienda de {{storeName}}. Si eres de otro país/zona puedes cambiarte","text2_2":"Si eres de otro país/zona puedes cambiarte","text2_action":" desde aquí"},"signup":{"title":"Registro","text":"Te estás dando de alta en la tienda de Si eres de otro país/zona puedes cambiarte desde aquí.","iban":"Simplifica tus pagos. Compra lo que necesites y te lo cargamos a tu cuenta bancaria a final de mes. Rellena tu IBAN y te avisaremos cuando esté habilitado como método de pago. Mientras puedes realizar tus pedidos pagando con tarjeta"},"signup_cif":{"title":"Registro","text":"Te estás dando de alta para la tienda de {{storeName}}. Si eres de otro país/zona puedes cambiarte","text_action":"desde aquí","subtext":"Si ya eres cliente (aunque no hayas comprado a través de nuestra web) accede","subtext_action":"desde aquí"},"activation":{"title":"Activación de cuenta","text":"Añade una contraseña para completar la activación de tu cuenta."},"forgot_password":{"title":"Restablecer constraseña","text":"Introduce tu email para solicitar un nueva contraseña. Te enviaremos un correo con un enlace de verificación."},"reset_password":{"title":"Restablecer contraseña","text":"Añade tu nueva contraseña"},"feedback_account_active":{"title":"Cuenta activada","text":"Tu cuenta se ha activado correctamente."},"feedback_password_updated":{"title":"Nueva contraseña","text":"Tu contraseña se ha modificado con éxito."},"feedback_email_invite":{"title":"Tienes una cuenta inactiva","text":"Te hemos enviado un email a ","text_2":". Ábrelo y sigue las instrucciones.","text2":"Si no tienes acceso a este email contacta con nosotros a través de info@mammafiore.eu o +34 93 303 76 15"},"feedback_email_reset_password":{"title":"Recuperar contraseña","text":"Te hemos enviado un enlace para crear una nueva contraseña."},"feedback_cif_already_active":{"title":"Ya tienes una cuenta","text":"Este CIF ya tiene una cuenta activa en nuestra web con el email","text2":"Puedes ","text2_2":" o ","text2_actions":{"login":"iniciar sesión","restore_password":"restablecer tu contraseña."}},"feedback_cif_not_found":{"title":"CIF no encontrado","text":"No tenemos el CIF","text_2":"en nuestra base de datos.","text2":"Si está mal escrito puedes volver atrás. Si crees que es un error o necesitas ayuda contáctanos a ","test2_2":" / ","text2_actions":{"email":"email@mammafiore.es","phone":"743 673 554"},"text3":"O si aun no eres cliente de Mammafiore puedes","text3_action":"registrarte aquí"}},"filter":{"title":"Filter"},"region_register":{"title":"Nueva cuenta","description":"Solo hay opción de registro para los países o regiones con tienda online. ¿Quieres seguir aquí o prefieres cambiar de país?","action_change":"Cambiar país/región","action_stay":"Seguir aquí"},"region_lang":{"title":"Seleccionar región"},"commercial":{"title":"Cómo comprar","in":"En {{storeName}} operamos a través de:","ok":"OK","action_change":"Cambiar país/región"},"stock_cart":{"title":"Carrito actualizado","description":"Hemos actualizado tu carrito con el stock disponible para:","deleted":"(eliminado, no hay stock ahora)","stock_change_1":"(actualizado a","stock_change_2":"uni., el máximo disponible ahora)","ok":"OK"},"public_interested":{"title":"Como comprar","contact":"Para compras como profesional, contacta con ","mail":"ventas@mammafiore.es","particular":"Para comprar como particular","cta_hm":"entra en nuestra","online":"tienda online"},"comercial_region":{"write_us":"Escríbenos a","mail_to_link":"mailto:comercial@mammafiore.eu","mail_to":"comercial@mammafiore.eu","more_info":"para más info.","open_account":"y te abriremos una cuenta","professional":"¿Eres profesional? Escríbenos a ","b2c":"¿Eres particular? Compra en nuestra tienda online","link_to_b2c":"https://hellomamma.es","link_b2c":"hellomamma.es","you_are_in":"Estás en "},"buy_box":{"title":"Comprar por cajas","text":"Este producto lo puedes añadir por cajas, las cajas son de {{units}} unidades ¿cuántas cajas querrías?"}},"payment_status":{"succeeded":"Pago realizado con éxito","processing":"Se está procesando tu pago.","requires_payment_method":"Tu pago no se ha efectuado correctamente. Por favor, inténtalo de nuevo.","something_went_wrong":"Algo fue mal.","unexpected_error":"Ha ocurrido un error inesperado."},"dates":{"months":{"january":"Enero","february":"Febrero","march":"Marzo","april":"Abril","may":"Mayo","june":"Junio","july":"Julio","august":"Agosto","september":"Septiembre","october":"Octubre","november":"Noviembre","december":"Diciembre"},"weekdays":{"monday":"Lunes","tuesday":"Martes","wednesday":"Miércoles","thursday":"Jueves","friday":"Viernes","saturday":"Sábado","sunday":"Domingo"},"seasons":{"spring":"Primavera","summer":"Verano","autumn":"Otoño","winter":"Invierno"}},"home":{"bestseller":{"new":"Descubre todas nuestras novedades","offer":"No pueden faltar en tu dispensa"},"brands":{"brands_title":"Detrás de cada producto hay una gran marca"}},"section_subscribe":{"welcome":"Benvenuto a la famiglia","register":"Regístrate y disfruta de las ventajas de formar parte de Mammafiore:","open":"Abierto 24/7 todo el año","order":"Haz tu pedido con tu móvil, tablet o PC","offer":"Ofertas personalizadas","save_products":"Guardamos tus productos para que no pierdas tiempo","check_invoices":"Consulta pedidos o facturas fácilmente","contact_commercial":"Contacto directo con tu comercial","register_button":"Regístrate en Mammafiore"},"account":{"buy_again":"Comprar de nuevo","repeat_order":"Repetir pedido","details":"Detalle del pedido","invoice":"Factura","invoice_issued":"Factura emitida el","invoice_download":"Descargar factura","no_invoice":"Vuoto come una pentola a fine festa! Aun no tienes ninguna factura en el sistema. Las iremos poniendo aquí a medida que se generen","no_orders":"Che tristezza! Tu lista de pedidos parece el desierto. Aquí los verás (cuando los hagas)","my_products":{"my_usual":"Mis habituales","title":"Te lo ponemos muy fácil","description":"Regístrate y podrás ver los productos que compraste en anteriores pedidos y así tenerlos a mano para facilitar tus próximas compras.","identify":"Regístrate o identifícate"},"home_my_products":{"see_all":"Ver todos","last_orders":"Últimos pedidos","my_usuals":"Mis habituales","my_comercial":"Mi comercial"},"order":{"shipping_address":"Dirección de envío","billing_address":"Dirección de facturación","summary":"Resumen","coupon":"Cupón de descuento","shipping_cost":"Gastos de envío","subtotal":"Subtotal","discount":"Descuento","total":"Total","taxes":"IVA","purchase":"Compra","date":"Fecha","number":"Nº pedido","purchase_order":"Tramitar pedido","several_dates":"Tienes productos con distintas fechas de entrega. Te serviremos el pedido entero en la fecha del último producto. Puedes modificar el pedido si quieres recibir el resto antes.","order_details":{"shipment":"Envío","billing":"Facturación","payment":"Pago","payment_summary":"Resumen pedido","total_products":"Total productos","subtotal_products":"Subtotal","discount":"Descuentos aplicados","voucher":"Cupón","total_inc_tax":"Total (iva incl.)","estimated_date":"Fecha estimada"},"no_stock":"No hay stock para este producto","repeat_order_feedback":{"success":"Se han añadido al carrito todos los productos disponibles"}}},"product_page":{"adjusted_stock":"Hemos ajustado a {{units}} unidades, para cuadrar con el stock","adjusted_units":"Hemos ajustado a {{units}} unidades, para cuadrar el tamaño de la caja","product_main":{"size_dropdown":"Escoger formato:","button_add":"Añadir al carrito","no_stock":"Agotado","not_available":"No disponible","see_more":"Ver más","choose_size":"Escoge formato:"},"product_description":{"nutritional_value":{"title":"Info nutricional","per_ration":"Por ración","per_100gr":"Por 100g","ingredients":"Ingredientes","average_value_per":"Valor medio por","energy":"Energía"},"more_info":{"title":"Más info"}},"bottom-page":{"related":"Inseparables"},"product":{"units":"Unidades","units_abbr":"uds","color":"color","colors":"colores","pack":"Pack","bundle":"Bundle","no_stock":"Agotado","last_units":"¡Últimas unidades!","on_demand":"Entrega","demand_product":"BAJO DEMANDA","tax":"iva","price_per":{"unit":"/ud","box":"/caja","kg":"/Kg"},"buy_box":"Pedir por cajas de {{units}} unidades","description_min_sale_units":"Cajas de {{minSaleUnits}} (se añade de {{minSaleUnits}} en {{minSaleUnits}} unidades)","delivery_date_stocked":"Entrega estimada: {{deliveryDate}} (pedidos antes de las {{deliveryHour}})","delivery_date_on_demand":"Entrega estimada: {{deliveryDate}} (pedidos antes del {{onDemandDay}} a las {{deliveryHour}})","delivery_date_frozen":"Entrega estimada: {{deliveryDate}} (pedidos antes de las {{deliveryHour}})","frozen_cart":"Los pedidos de congelado se gestionan por separado. Para añadir productos no congelados, acaba el pedido o vacía el carrito","fresh_cart":"Los pedidos de productos no congelados se gestionan por separado. Para añadir productos congelados, acaba el pedido o vacía el carrito"}},"shop":{"filters":"Filtrar","no_filter":"No hay ningún producto que coincida con los filtros seleccionados","no_products":"Mamma mia, la tavola è vuota! En cuanto tengas pedidos, mostraremos aquí tus productos habituales favoritos para los encuentres rápidamente","displayed_products":"Has visto {{productsDisplayed}} de {{totalProducts}}"},"cart":{"500":{"title":"Ha habido un problema intentando conectar con tu carrito.","try_again_later":"Por favor espere unos instantes e inténtelo de nuevo más tarde.","sorry":"Disculpe las molestias."},"cart":"Tu cesta","articles":"artículos","article":"artículo","add_relateds":"Añade estos inseparables","minimum_order":"Pedido mínimo","cart_error":"Ha habido un error en el carrito, inténtalo de nuevo más tarde","cart_date_error":"Ha habido un problema escogiendo la fecha de entrega, inténtalo de nuevo más tarde","order_saved":"En este pedido has ahorrado","delivery_available":"Disponible para {{deliveryDate}} (pero te serviremos el pedido agrupado)","delivery_date":"Entrega estimada: {{deliveryDate}}","delivery_date_stocked":"Pedidos antes de las {{deliveryHour}}. Se ajusta si hay festivos. Recibirás confirmación de fecha reparto. Agrupamos pedidos pequeños para optimizar envíos o llegar al importe mínimo","delivery_date_on_demand":"Pedidos antes del {{onDemandDay}} a las {{deliveryHour}}. Se ajusta si hay festivos. Recibirás confirmación de fecha reparto. Solemos agrupar pedidos pequeños para optimizar envíos o llegar al importe mínimo","delivery_date_frozen":"Pedidos antes de las {{deliveryHour}}. Se ajusta si hay festivos. Recibirás confirmación de fecha reparto. Agrupamos pedidos pequeños para optimizar envíos o llegar al importe mínimo"}}');
;// CONCATENATED MODULE: ./public/locales/fr.json
var fr_namespaceObject = JSON.parse('{"layout":{"nav":{"account":{"name":"Compte","pathname":"/account"},"cart":{"name":"Panier","pathname":"/cart"},"home":{"name":"Page d\'accueil","pathname":"/"},"shop":{"name":"Boutique","pathname":"/catalog"},"my_usuals":{"name":"Mes produits habituels","pathname":"/account/my-products"},"products":{"name":"Produits","pathname":"/catalog"},"about_us":{"name":"À propos de nous","pathname":"/page/a-propos-de-nous"},"contact_us":{"name":"Contactez-nous","pathname":"/page/contactez-nous"},"catalogue":{"name":"Catalogue PDF","pathname":"/page/catalogue"},"events":{"name":"In giro avec Mammafiore","pathname":"/page/in-giro-avec-mammafiore"}},"footer":{"questions":"Vous avez des questions ?","write_us":"Écrivez-nous","email":"https://mammafiorehelp.zendesk.com/hc/fr","call_us":"ou appelez au","phone_link":"330148904750","phone_number":"+33 (0) 148 904 750","newsletter":{"title":"Rejoignez notre famille","input_inactive":"Laissez-nous votre e-mail","button":"Rejoindre"},"partners":"Nos partenaires","legal_warning":"Mentions légales","change_country_lang":"Changer de région"},"search":{"search_results":"Résultats de la recherche","history":"Historique de recherche","delete":"Supprimer","empty_01":"Nous n\'avons trouvé aucun résultat. Voulez-vous faire une ","empty_02":"nouvelle recherche ?","product":"produit","products":"produits","brand":"marque","search_by_category":"Rechercher par catégorie :","what_are_you_looking_for":"Que recherchez-vous ?"},"nav_account":[{"name":"Commandes","pathname":"/account/[slug]","slug":"orders"},{"name":"Factures","pathname":"/account/[slug]","slug":"invoices"},{"name":"Adresses","pathname":"/account/[slug]","slug":"addresses"},{"name":"Données d\'accès","pathname":"/account"},{"name":"Se déconnecter","action":"logout"}]},"form":{"fields":{"email":"E-mail","first_name":"Prénom","last_name":"Nom","phone":"Téléphone","mobile_phone":"Téléphone portable","password":"Mot de passe","new_password":"Nouveau mot de passe","street_line1":"Adresse","street_line2":"Appartement/Suite/Immeuble","country":"Pays","province":"Région","city":"Ville","postal_code":"Code postal","comments":"Commentaires","shipping_as_billing":"Utiliser l\'adresse de livraison comme adresse de facturation","im_a_company":"Je suis une entreprise","cif":"SIRET","company_name":"Nom de l\'entreprise"},"errors":{"incomplete":"Le formulaire doit être entièrement rempli pour l\'envoyer","required":"Ce champ est requis","empty":"Ce champ ne peut pas être vide","minLength":"La longueur du champ n\'est pas suffisante","maxLength":"La longueur maximale du champ a été dépassée","pattern_username":"Le nom d\'utilisateur ne peut contenir que des caractères alphanumériques","pattern_password":"Le mot de passe doit être composé d\'au moins 8 caractères et contenir au moins 1 caractère de chaque : majuscules et minuscules, chiffres et symbole","pattern_email":"L\'e-mail saisi n\'est pas valide","validate_cif":"Le numéro SIRET saisi n\'est pas valide","validate_phone":"Le numéro de téléphone saisi n\'est pas valide","validate_iban":"Le numéro IBAN saisi n\'est pas valide"}},"commons":{"actions":{"accept":"Accepter","add":"Ajouter","cancel":"Annuler","close":"Fermer","continue":"Continuer","delete":"Supprimer","delete_all":"Tout supprimer","download":"Télécharger","edit":"Modifier","enter":"Entrer","go_back":"Retour","load":"Charger","login":"Se connecter","logout":"Se déconnecter","next":"Suivant","prev":"Précédent","remove":"Supprimer","save":"Enregistrer","search":"Rechercher","send":"Envoyer","signup":"S\'inscrire","submit":"Soumettre","add_to_cart":"Ajouter au panier","how_to_buy":"Comment acheter","increase_cart_units":"Augmenter les unités du panier","remove_units_from_cart":"Supprimer des unités du panier","delete_from_cart":"Supprimer du panier","show":"Afficher"},"status":{"deleting":"Suppression en cours","downloading":"Téléchargement en cours","loading":"Chargement en cours","saving":"Enregistrement en cours","updating":"Mise à jour en cours","uploading":"Mise en ligne en cours"},"newsletter_feedback":{"success":"Merci ! Nous vous tiendrons informé(e) des dernières nouveautés","error":"Il y a eu un problème lors de l\'envoi du formulaire. Veuillez réessayer plus tard","duplicated":"L\'e-mail est déjà enregistré"},"faqs":{"title":"Questions fréquentes"},"page_not_found":{"404":"Page non trouvée.","title":"La page que vous recherchez n\'existe pas","description":"Essayez de naviguer sur le site pour la trouver. Ou peut-être découvrirez-vous quelque chose de bien meilleur, qui sait.","goback_homepage":"Retour à la page d\'accueil"},"page_error":{"500":"Une erreur inattendue s\'est produite","title":"Il se peut que le site rencontre des difficultés","description":"Essayez de naviguer dans une autre zone du site.","goback_homepage":"Retour à la page d\'accueil"},"region_picker":{"in":"En","work_with":"nous opérons à travers :","go_catalogue":"Aller au catalogue"},"cart":{"total":"total","show_cart":"Voir le panier","go_checkout":"Procéder au paiement","free":"Gratuit"}},"modals":{"auth":{"start":{"title":"Accès","text":"Êtes-vous client de Mammafiore? Même si vous n\'avez jamais acheté via notre site web.","actions":{"primary":"Je suis déjà client(e)","secondary":"Je veux m\'inscrire"}},"prelogin":{"title":"Accès","subtitle":"Avez-vous déjà activé votre compte sur notre site web?","text":"Si vous êtes déjà client(e) de Mammafiore mais que vous n\'avez jamais acheté via le site web, cliquez sur Activer le compte.","actions":{"primary":"Se connecter","secondary":"Activer le compte"},"subtext":"Vous n\'êtes pas encore client(e) de Mammafiore?","subtext_action":"M\'inscrire"},"login":{"title":"Se connecter","text":"Bienvenue à nouveau chez Mammafiore.","forgot_password":"Avez-vous oublié votre mot de passe?","subtext":"Vous êtes client(e) mais n\'avez pas encore activé votre compte?","subtext_action":"activez-le ici"},"login_check_cif":{"title":"Activer le compte","text":"Saisissez d\'abord votre SIRET.","text2":"Vous êtes dans la boutique de {{storeName}}. Si vous êtes originaire d\'un autre pays/zone, vous pouvez le/la modifier","text2_action":" ici"},"signup":{"title":"Inscription","text":"Vous vous inscrivez dans la boutique de Si vous êtes originaire d\'un autre pays/zone, vous pouvez le/la modifier ici.","iban":"Simplifiez vos paiements. Achetez ce dont vous avez besoin et nous débiterons votre compte bancaire à la fin du mois. Complétez votre IBAN et nous vous informerons lorsqu\'il sera activé en tant que mode de paiement. En attendant, vous pouvez passer vos commandes par carte de crédit"},"signup_cif":{"title":"Inscription","text":"Vous vous inscrivez pour la boutique de {{storeName}}. Si vous êtes originaire d\'un autre pays/zone, vous pouvez le/la modifier","text_action":" ici","subtext":"Si vous êtes déjà client(e) (même si vous n\'avez jamais acheté via notre site web), accédez","subtext_action":" ici"},"activation":{"title":"Activation du compte","text":"Ajoutez un mot de passe pour compléter l\'activation de votre compte."},"forgot_password":{"title":"Réinitialiser le mot de passe","text":"Saisissez votre e-mail pour demander un nouveau mot de passe. Nous vous enverrons un e-mail avec un lien de vérification."},"reset_password":{"title":"Réinitialiser le mot de passe","text":"Ajoutez votre nouveau mot de passe"},"feedback_account_active":{"title":"Compte activé","text":"Votre compte a bien été activé."},"feedback_password_updated":{"title":"Nouveau mot de passe","text":"Votre mot de passe a bien été modifié."},"feedback_email_invite":{"title":"Vous avez un compte inactif","text":"Nous vous avons envoyé un e-mail à ","text_2":". Ouvrez-le et suivez les instructions.","text2":"Si vous n\'avez pas accès à cet e-mail, contactez-nous à info@mammafiore.eu ou au +34 93 303 76 15"},"feedback_email_reset_password":{"title":"Récupérer le mot de passe","text":"Nous vous avons envoyé un lien pour créer un nouveau mot de passe."},"feedback_cif_already_active":{"title":"Vous avez déjà un compte","text":"Ce SIRET a déjà un compte actif sur notre site web avec l\'e-mail","text2":"Vous pouvez ","text2_2":" ou ","text2_actions":{"login":"vous connecter","restore_password":"réinitialiser votre mot de passe."}},"feedback_cif_not_found":{"title":"SIRET non trouvé","text":"Nous n\'avons pas ce SIRET","text_2":" dans notre base de données.","text2":"S\'il est mal écrit, vous pouvez revenir en arrière. Si vous pensez que c\'est une erreur ou si vous avez besoin d\'aide, contactez-nous à ","test2_2":" / ","text2_actions":{"email":"email@mammafiore.es","phone":"743 673 554"},"text3":"Ou si vous n\'êtes pas encore client de Mammafiore, vous pouvez","text3_action":"vous inscrire ici"}},"filter":{"title":"Filtre"},"region_register":{"title":"Nouveau compte","description":"L\'inscription n\'est possible que pour les pays ou régions disposant d\'une boutique en ligne. Voulez-vous rester ici ou préférez-vous changer de pays ?","action_change":"Changer de pays/région","action_stay":"Rester ici"},"region_lang":{"title":"Sélectionner la région"},"commercial":{"title":"Comment acheter","in":"En {{storeName}} nous opérons à travers :","ok":"OK","action_change":"Changer de pays/région"},"stock_cart":{"title":"Panier mis à jour","description":"Nous avons mis à jour votre panier avec le stock disponible pour :","deleted":"(supprimé, plus de stock disponible)","stock_change_1":"(mis à jour à","stock_change_2":"unités, maximum disponible actuellement)","ok":"OK"},"public_interested":{"title":"Comment acheter","contact":"Pour les achats professionnels, contactez ","mail":"ventes@mammafiore.es","particular":"Pour acheter en tant que particulier","cta_hm":"visitez notre","online":"boutique en ligne"},"comercial_region":{"write_us":"Écrivez-nous à","mail_to_link":"mailto:paris@mammafiore.eu ","mail_to":"paris@mammafiore.eu ","more_info":"pour plus d\'infos.","open_account":"et nous ouvrirons un compte pour vous","professional":"Vous êtes un(e) professionnel(le) ? Écrivez-nous à ","b2c":"Vous êtes un particulier ? Achetez dans notre boutique en ligne","link_to_b2c":"https://hellomamma.fr","link_b2c":"hellomamma.fr","you_are_in":"Vous êtes sur "},"buy_box":{"title":"Acheter par cartons","text":"Ce produit peut être ajouté par boîtes, les boîtes contiennent {{units}} unités. Combien de boîtes voudriez-vous ?"}},"payment_status":{"succeeded":"Paiement effectué avec succès","processing":"Votre paiement est en cours de traitement.","requires_payment_method":"Votre paiement n\'a pas été effectué correctement. Veuillez réessayer.","something_went_wrong":"Quelque chose s\'est mal passé.","unexpected_error":"Une erreur inattendue s\'est produite."},"dates":{"months":{"january":"Janvier","february":"Février","march":"Mars","april":"Avril","may":"Mai","june":"Juin","july":"Juillet","august":"Août","september":"Septembre","october":"Octobre","november":"Novembre","december":"Décembre"},"weekdays":{"monday":"Lundi","tuesday":"Mardi","wednesday":"Mercredi","thursday":"Jeudi","friday":"Vendredi","saturday":"Samedi","sunday":"Dimanche"},"seasons":{"spring":"Printemps","summer":"Été","autumn":"Automne","winter":"Hiver"}},"home":{"bestseller":{"new":"Découvrez toutes nos nouveautés","offer":"Les incontournables du garde-manger"},"brands":{"brands_title":"Derrière chaque produit se trouve une grande marque"}},"section_subscribe":{"welcome":"Bienvenue dans la famille","register":"Inscrivez-vous et profitez des avantages de faire partie de Mammafiore :","open":"Ouvert 24/7 toute l\'année","order":"Passez votre commande avec votre téléphone portable, tablette ou PC","offer":"Offres personnalisées","save_products":"Nous sauvegardons vos produits pour vous faire gagner du temps","check_invoices":"Consultez facilement commandes ou factures","contact_commercial":"Contact direct avec votre commercial","register_button":"Inscrivez-vous chez Mammafiore"},"account":{"buy_again":"Acheter à nouveau","repeat_order":"Répéter la commande","details":"Détails de la commande","invoice":"Facture","invoice_issued":"Facture émise le","invoice_download":"Télécharger la facture","no_invoice":"Vuoto come una pentola a fine festa! Vous n\'avez pas encore de factures dans le système. Nous les mettrons ici au fur et à mesure qu\'elles seront générées","no_orders":"Che tristezza! Votre liste de commandes ressemble au désert. Vous les verrez ici (quand vous les ferez)","my_products":{"my_usual":"Mes produits habituels","title":"Nous vous facilitons les choses","description":"Inscrivez-vous et vous pourrez voir les produits que vous avez achetés lors de commandes précédentes et ainsi les avoir à portée de main pour faciliter vos prochains achats.","identify":"Inscrivez-vous ou identifiez-vous"},"home_my_products":{"see_all":"Voir tous","last_orders":"Dernières commandes","my_usuals":"Mes produits habituels","my_comercial":"Mon commercial"},"order":{"shipping_address":"Adresse de livraison","billing_address":"Adresse de facturation","summary":"Résumé","coupon":"Bon de réduction","shipping_cost":"Frais de livraison","subtotal":"Sous-total","discount":"Remise","total":"Total","taxes":"TVA","purchase":"Achat","date":"Date","number":"N° de commande","purchase_order":"Passer commande","several_dates":"Vous avez des produits avec des dates de livraison différentes. Nous vous servirons la totalité de la commande à la date du dernier produit. Vous pouvez modifier la commande si vous souhaitez recevoir le reste plus tôt.","order_details":{"shipment":"Livraison","billing":"Facturation","payment":"Paiement","payment_summary":"Résumé de la commande","total_products":"Total produits","subtotal_products":"Sous-total","discount":"Remises appliquées","voucher":"Bon","total_inc_tax":"Total (TVA incl.)","estimated_date":"Date estimée"},"no_stock":"Il n\'y a pas de stock pour ce produit","repeat_order_feedback":{"success":"Tous les produits disponibles ont été ajoutés au panier"}}},"product_page":{"product_main":{"size_dropdown":"Choisir le format :","button_add":"Ajouter au panier","no_stock":"Pas de stock","not_available":"Pas disponible","see_more":"Voir plus","choose_size":"Choisissez le format :"},"product_description":{"nutritional_value":{"title":"Info nutritionnelle","per_ration":"Par portion","per_100gr":"Pour 100g","ingredients":"Ingrédients","average_value_per":"Valeur moyenne par","energy":"Énergie"},"more_info":{"title":"Plus d\'infos"}},"bottom-page":{"related":"Inséparables"},"product":{"units":"Unités","units_abbr":"U.","color":"couleur","colors":"couleurs","pack":"Pack","bundle":"Bundle","no_stock":"Pas de stock","last_units":"Dernières unités !","on_demand":"Livraison","demand_product":"SUR COMMANDE","tax":"TVA","price_per":{"unit":"/unité","box":"/boîte","kg":"/Kg"},"buy_box":"Commander par boîtes de {{units}} unités","description_min_sale_units":"Boîtes de {{minSaleUnits}} (ajoutées par unités de {{minSaleUnits}} )","delivery_date_stocked":"Livraison estimée : {{deliveryDate}} (commandes avant {{deliveryHour}})","delivery_date_on_demand":"Livraison estimée : {{deliveryDate}} (commandes avant le {{onDemandDay}} à {{deliveryHour}})","delivery_date_frozen":"Livraison estimée : {{deliveryDate}} (commandes avant {{deliveryHour}})","frozen_cart":"Les commandes de produits surgelés sont gérées séparément. Pour ajouter des produits non surgelés, terminez la commande ou videz le panier.","fresh_cart":"Les commandes de produits non surgelés sont gérées séparément. Pour ajouter des produits surgelés, terminez la commande ou videz le panier."}},"shop":{"filters":"Filtrer","no_filter":"Aucun produit ne correspond aux filtres sélectionnés","no_products":"Mamma mia, la tavola è vuota! Dès que vous avez des commandes, nous afficherons ici vos produits habituels préférés afin que vous puissiez les trouver rapidement","displayed_products":"Vous avez vu {{productsDisplayed}} de {{totalProducts}}"},"cart":{"500":{"title":"Un problème est survenu lors de la tentative de connexion à votre panier.","try_again_later":"Veuillez patienter quelques instants et réessayer plus tard.","sorry":"Désolé pour le dérangement."},"cart":"Votre panier","articles":"articles","article":"article","add_relateds":"Ajoutez ces inséparables","minimum_order":"Commande minimale","cart_error":"Une erreur s\'est produite dans le panier, veuillez réessayer plus tard","cart_date_error":"Un problème est survenu lors du choix de la date de livraison, veuillez réessayer plus tard","order_saved":"Vous avez économisé sur cette commande","delivery_available":"Livraison disponible {{deliveryDate}} (mais sera regroupée en une seule livraison {{cartDeliveryDate}})","delivery_date":"Livraison {{deliveryDate}}","delivery_date_stocked":"(commandes avant {{deliveryHour}})","delivery_date_on_demand":"(commandes avant le {{onDemandDay}} à {{deliveryHour}})","delivery_date_frozen":"(commandes avant {{deliveryHour}})"}}');
;// CONCATENATED MODULE: ./public/locales/de.json
var de_namespaceObject = JSON.parse('{"layout":{"nav":{"account":{"name":"Konto","pathname":"/account"},"cart":{"name":"Warenkorb","pathname":"/cart"},"home":{"name":"Startseite","pathname":"/"},"shop":{"name":"Shop","pathname":"/catalog"},"my_usuals":{"name":"Meine Üblichen","pathname":"/account/my-products"},"products":{"name":"Produkte","pathname":"/catalog"},"about_us":{"name":"Über Uns","pathname":"/page/uber-uns"},"catalogue":{"name":"Katalog PDF","pathname":"/page/katalog"},"contact_us":{"name":"Kontaktieren Sie Uns","pathname":"/page/kontaktieren-sie-uns"},"events":{"name":"In giro con Mammafiore","pathname":"/page/in-giro-con-noi"}},"footer":{"questions":"Haben Sie Fragen?","write_us":"Schreiben Sie Uns","email":"berlin@mammafiore.eu","call_us":"oder rufen Sie an","phone_link":"+493027980249","phone_number":"+49 3027980249","newsletter":{"title":"Werden Sie Familienmitglied","input_inactive":"Geben Sie uns Ihre E-Mail-Adresse","button":"Verbinden"},"partners":"Unsere Partner","legal_warning":"Rechtlicher Hinweis","change_country_lang":"Region Ändern"},"search":{"search_results":"Suchergebnisse","history":"Suchverlauf","delete":"Löschen","empty_01":"Wir haben keine Ergebnisse gefunden. Möchten Sie eine ","empty_02":"neue Suche starten?","product":"Produkt","products":"Produkte","brand":"Marke","search_by_category":"Suche nach Kategorien:","what_are_you_looking_for":"Wonach suchen Sie?"},"nav_account":[{"name":"Bestellungen","pathname":"/account/[slug]","slug":"Bestellungen"},{"name":"Rechnungen","pathname":"/account/[slug]","slug":"Rechnungen"},{"name":"Adressen","pathname":"/account/[slug]","slug":"Adressen"},{"name":"Zugangsdaten","pathname":"/account"},{"name":"Ausloggen","action":"logout"}]},"form":{"fields":{"email":"E-Mail","first_name":"Vorname","last_name":"Nachname","phone":"Telefon","mobile_phone":"Mobiltelefon","password":"Passwort","new_password":"Neues Passwort","street_line1":"Adresse","street_line2":"Wohnung/Suite/Gebäude","country":"Land","province":"Region","city":"Ortschaft","postal_code":"Postleitzahl","comments":"Kommentare","shipping_as_billing":"Versandadresse als Rechnungsadresse verwenden","im_a_company":"Ich bin ein Unternehmen","cif":"CIF","company_name":"Firmenname"},"errors":{"incomplete":"Das Formular muss zum Senden vollständig ausgefüllt sein.","required":"Dieses Feld ist Pflicht","empty":"Dieses Feld darf nicht leer sein.","minLength":"Die Feldlänge ist nicht ausreichend.","maxLength":"Die maximale Feldlänge wurde überschritten.","pattern_username":"Der Benutzername darf nur alphanumerische Zeichen enthalten.","pattern_password":"Das Passwort muss mind. 8 Zeichen lang sein und zumindest enthalten: 1 Groß- und 1 Kleinbuchstaben, 1 Zahl und 1 Symbol","pattern_email":"Die eingegebene E-Mail ist nicht gültig.","validate_cif":"Die eingegebene CIF-Nummer ist nicht gültig.","validate_phone":"Die eingegebene Telefonnummer ist nicht gültig.","validate_iban":"Die eingegebene IBAN-Nummer ist nicht gültig."}},"commons":{"actions":{"accept":"OK","add":"Hinzufügen","cancel":"Abbrechen","close":"Schließen","continue":"Fortsetzen","delete":"Löschen","delete_all":"Alles löschen","download":"Herunterladen","edit":"Bearbeiten","enter":"Eintreten","go_back":"Zurück","load":"Laden","login":"Einloggen","logout":"Ausloggen","next":"Weiter","prev":"Vorherige","remove":"Entfernen","save":"Speichern","search":"Suchen","send":"Senden","signup":"Konto erstellen","submit":"Absenden","add_to_cart":"In den Warenkorb","how_to_buy":"Wie man kauft","increase_cart_units":"Warenkorbeinheiten erhöhen","remove_units_from_cart":"Warenkorbeinheiten entfernen","delete_from_cart":"Aus dem Warenkorb löschen","show":"Anzeigen"},"status":{"deleting":"Wird gelöscht","downloading":"Wird heruntergeladen","loading":"Wird geladen","saving":"Wird gespeichert","updating":"Wird aktualisiert","uploading":"Wird hochgeladen"},"newsletter_feedback":{"success":"Danke! Wir werden Sie über die letzten Neuigkeiten informieren.","error":"Problem beim Senden des Formulars. Bitte versuchen Sie es später noch einmal.","duplicated":"E-Mail ist bereits registriert."},"faqs":{"title":"Häufig gestellte Fragen"},"page_not_found":{"404":"Seite nicht gefunden.","title":"Die gesuchte Seite existiert nicht.","description":"Versuchen Sie, sie durch Surfen auf der Website zu finden. Vielleicht entdecken Sie etwas viel Besseres. Wer weiß?","goback_homepage":"Zurück zur Startseite"},"page_error":{"500":"Ein unerwarteter Fehler ist aufgetreten","title":"Die gesuchte Seite hat einen Fehler erlitten.","description":"Versuchen Sie, durch anderen Bereiche der Website zu surfen.","goback_homepage":"Zurück zur Startseite"},"region_picker":{"in":"In","work_with":"arbeiten wir über:","go_catalogue":"Zum Katalog"},"cart":{"total":"Gesamt","show_cart":"Warenkorb anzeigen","go_checkout":"Bestellung aufgeben","free":"Frei"}},"modals":{"auth":{"start":{"title":"Zugang","text":"Sind Sie Kunde bei Mammafiore?  Auch wenn Sie noch nie über unsere Website gekauft haben.","actions":{"primary":"Ich bin bereits Kunde.","secondary":"Ich möchte mich registrieren."}},"prelogin":{"title":"Zugang","subtitle":"Haben Sie Ihr Konto auf unserer Website aktiviert?","text":"Wenn Sie schon Kunde bei Mammafiore sind, aber noch nie über die Website gekauft haben, klicken Sie auf „Konto aktivieren“.","actions":{"primary":"Einloggen","secondary":"Konto aktivieren"},"subtext":"Noch kein Kunde bei Mammafiore?","subtext_action":"Registrieren"},"login":{"title":"Einloggen","text":"Willkommen zurück bei Mammafiore.","forgot_password":"Haben Sie Ihr Passwort vergessen?","subtext":"Sind Sie Kunde, haben aber Ihr Konto noch nicht aktiviert?","subtext_action":"Aktivieren Sie es hier."},"login_check_cif":{"title":"Konto aktivieren","text":"Geben Sie zuerst Ihre CIF ein.","text2":"Sie sind im Shop von {{storeName}}. Wenn Sie aus einem anderen Land/Gebiet sind, können Sie wechseln","text2_action":" von hier aus"},"signup":{"title":"Registrierung","text":"Sie registrieren sich im Shop von   Wenn Sie aus einem anderen Land/Gebiet kommen, können Sie hier wechseln.","iban":"Vereinfachen Sie Ihre Zahlungen. Kaufen Sie, was Sie benötigen, und wir belasten Ihr Bankkonto am Ende des Monats. Geben Sie Ihre IBAN ein und wir informieren Sie, sobald sie als Zahlungsmethode aktiviert ist. In der Zwischenzeit können Sie Ihre Bestellungen mit Karte bezahlen."},"signup_cif":{"title":"Registrierung","text":"Sie registrieren sich für den Shop von {{storeName}}. Wenn Sie aus einem anderen Land/Gebiet kommen, können Sie hier wechseln.","text_action":"von hier aus","subtext":"Wenn Sie schon Kunde sind (auch wenn Sie noch nie bei uns gekauft haben): Zugang","subtext_action":"von hier aus"},"activation":{"title":"Kontoaktivierung","text":"Geben Sie ein Passwort ein, um die Aktivierung Ihres Kontos abzuschließen."},"forgot_password":{"title":"Passwort zurücksetzen","text":"Ihre E-Mail-Adresse eingeben, um ein neues Passwort anzufordern. Wir senden Ihnen eine E-Mail mit einem Verifizierungslink."},"reset_password":{"title":"Passwort zurücksetzen","text":"Geben Sie Ihr neues Passwort ein"},"feedback_account_active":{"title":"Konto aktiviert","text":"Ihr Konto wurde erfolgreich aktiviert."},"feedback_password_updated":{"title":"Neues Passwort","text":"Ihr Passwort wurde erfolgreich aktualisiert."},"feedback_email_invite":{"title":"Sie haben ein inaktives Konto","text":"Wir haben Ihnen eine E-Mail geschickt an ","text_2":". Öffnen Sie sie und folgen Sie den Anweisungen.","text2":"Wenn Sie keinen Zugriff auf diese E-Mail haben, kontaktieren Sie uns unter berlin@mammafiore.eu oder +49 0173 7265074"},"feedback_email_reset_password":{"title":"Passwort zurücksetzen","text":"Wir haben Ihnen einen Link gesendet, um ein neues Passwort zu erstellen."},"feedback_cif_already_active":{"title":"Sie haben bereits ein Konto.","text":"Diese CIF hat bereits ein aktives Konto auf unserer Website mit der E-Mail","text2":"Sie können ","text2_2":" oder ","text2_actions":{"login":"sich einloggen","restore_password":"Ihr Passwort zurücksetzen."}},"feedback_cif_not_found":{"title":"CIF nicht gefunden","text":"Wir haben die CIF","text_2":"nicht in unserer Datenbank.","text2":"Wenn sie falsch geschrieben ist, können Sie zurückgehen. Sie glauben, das ist ein Fehler oder Sie benötigen Hilfe: Kontaktieren Sie uns ","test2_2":" / ","text2_actions":{"email":"berlin@mammafiore.eu","phone":"+49 0173 7265074"},"text3":"Oder wenn Sie noch kein Kunde von Mammafiore sind, können Sie","text3_action":"sich hier registrieren"}},"filter":{"title":"Filter"},"region_register":{"title":"Neues Konto","description":"Eine Registrierung ist nur für Länder oder Regionen mit einem Online-Shop möglich. Möchten Sie hier bleiben oder das Land wechseln?","action_change":"Land/Region ändern","action_stay":"Hier bleiben"},"region_lang":{"title":"Region auswählen"},"commercial":{"title":"Wie man kauft","in":"In {{storeName}} arbeiten wir über:","ok":"OK","action_change":"Land/Region ändern"},"stock_cart":{"title":"Warenkorb aktualisiert","description":"Wir haben deinen Warenkorb mit dem verfügbaren Bestand aktualisiert für:","deleted":"(entfernt, momentan nicht auf Lager)","stock_change_1":"(aktualisiert auf","stock_change_2":"Stk., derzeit maximal verfügbar)","ok":"OK"},"public_interested":{"title":"Wie man kauft","contact":"Für Einkäufe als Unternehmer kontaktieren Sie ","mail":"ventas@mammafiore.eu","particular":"Um als Privatperson zu kaufen","cta_hm":"besuchen Sie unseren","online":"Online-Shop"},"comercial_region":{"write_us":"Schreiben Sie uns an","mail_to_link":"mailto:berlin@mammafiore.eu","mail_to":"berlin@mammafiore.eu","more_info":"für weitere Informationen.","open_account":"und wir eröffnen ein Konto für Sie.","professional":"Sind Sie ein Unternehmen? Schreiben Sie uns an ","b2c":"Sind Sie ein Privatperson? Kaufen Sie in unserem Online-Shop","link_to_b2c":"https://hellomamma.es","link_b2c":"hellomamma.es","you_are_in":"Sie sind in "},"buy_box":{"title":"Kaufen pro Kartons","text":"Dieses Produkt kann kistenweise hinzugefügt werden, die Kisten enthalten {{units}} Einheiten. Wie viele Kisten möchten Sie?"}},"payment_status":{"succeeded":"Zahlung erfolgreich abgeschlossen","processing":"Ihre Zahlung wird bearbeitet.","requires_payment_method":"Ihre Zahlung war nicht erfolgreich. Bitte versuchen Sie es erneut.","something_went_wrong":"Etwas ist schief gelaufen.","unexpected_error":"Ein unerwarteter Fehler ist aufgetreten."},"dates":{"months":{"january":"Januar","february":"Februar","march":"März","april":"April","may":"Mai","june":"Juni","july":"Juli","august":"August","september":"September","october":"Oktober","november":"November","december":"Dezember"},"weekdays":{"monday":"Montag","tuesday":"Dienstag","wednesday":"Mittwoch","thursday":"Donnerstag","friday":"Freitag","saturday":"Samstag","sunday":"Sonntag"},"seasons":{"spring":"Frühling","summer":"Sommer","autumn":"Herbst","winter":"Winter"}},"home":{"bestseller":{"new":"Entdecken Sie alle unsere Neuheiten.","offer":"Unverzichtbar in Ihrer Vorratskammer."},"brands":{"brands_title":"Hinter jedem Produkt steht eine große Marke"}},"section_subscribe":{"welcome":"Willkommen in der Familie!","register":"Registrieren Sie sich und genießen Sie die Vorteile, Mitglied bei Mammafiore zu sein:","open":"Das ganze Jahr über 24/7 geöffnet","order":"Bestellen Sie mit Ihrem Handy, Tablet oder PC","offer":"Personalisierte Angebote","save_products":"Wir speichern Ihre Produkte, damit Sie keine Zeit verlieren.","check_invoices":"Einfache Prüfung von Bestellungen und Rechnungen","contact_commercial":"Direkter Kontakt mit Ihrem Vertriebsmitarbeiter","register_button":"Registrieren Sie sich bei Mammafiore."},"account":{"buy_again":"Erneut kaufen","repeat_order":"Bestellung wiederholen","details":"Einzelheiten der Bestellung","invoice":"Rechnung","invoice_issued":"Rechnung ausgestellt am","invoice_download":"Rechnung herunterladen","no_invoice":"Vuoto come una pentola a fine festa! Du hast noch keine Rechnungen im System. Wir werden sie hier einstellen, sobald sie generiert werden","no_orders":"Che tristezza! Deine Bestellliste sieht aus wie die Wüste. Hier wirst du sie sehen (wenn du sie machst)","my_products":{"my_usual":"Meine üblichen","title":"Wir machen es Ihnen sehr leicht.","description":"Registrieren Sie sich, und Sie können die Produkte sehen, die Sie in früheren Bestellungen gekauft haben, um Ihre nächsten Einkäufe zu erleichtern.","identify":"Registrieren oder anmelden"},"home_my_products":{"see_all":"Alle anzeigen","last_orders":"Letzte Bestellungen","my_usuals":"Meine üblichen","my_comercial":"Mein Vertriebsmitarbeiter"},"order":{"shipping_address":"Lieferadresse","billing_address":"Rechnungsadresse","summary":"Zusammenfassung","coupon":"Rabattgutschein","shipping_cost":"Versandkosten","subtotal":"Zwischensumme","discount":"Rabatt","total":"Gesamt","taxes":"MWSt.","purchase":"Kauf","date":"Datum","number":"Bestell-Nr.","purchase_order":"Bestellung aufgeben","several_dates":"Sie haben Produkte mit unterschiedlichen Lieferterminen. Wir liefern Ihnen die gesamte Bestellung am Datum des letzten Produkts. Sie können die Bestellung ändern, wenn Sie den Rest früher erhalten möchten.","order_details":{"shipment":"Versand","billing":"Abrechnung","payment":"Zahlung","payment_summary":"Zusammenfassung Bestellung","total_products":"Gesamt Produkte","subtotal_products":"Zwischensumme","discount":"Angewandte Rabatte","voucher":"Gutschein","total_inc_tax":"Gesamt (inkl. MwSt.)","estimated_date":"Geschätztes Datum"},"no_stock":"Für dieses Produkt ist kein Bestand verfügbar.","repeat_order_feedback":{"success":"Alle verfügbaren Produkte wurden in den Warenkorb gelegt."}}},"product_page":{"product_main":{"size_dropdown":"Format wählen:","button_add":"In den Warenkorb","no_stock":"Ausverkauft","not_available":"Nicht verfügbar","see_more":"Mehr sehen","choose_size":"Format wählen:"},"product_description":{"nutritional_value":{"title":"Nährwertangaben","per_ration":"Pro Portion","per_100gr":"Pro 100 g","ingredients":"Zutaten","average_value_per":"Durchschnittswert pro","energy":"Energie"},"more_info":{"title":"Mehr Info"}},"bottom-page":{"related":"Unzertrennlich"},"product":{"units":"Stück","units_abbr":"Stck.","color":"Farbe","colors":"Farben","pack":"Pack","bundle":"Bündel","no_stock":"Ausverkauft","last_units":"Letzte Einheiten!","on_demand":"Lieferung","demand_product":"AUF ANFRAGE","tax":"MwSt.","price_per":{"unit":"/Stck","box":"/Kiste","kg":"/Kg"},"buy_box":"In Kisten zu {{units}} Einheiten bestellen","description_min_sale_units":"Kartons zu {{minSaleUnits}} Stück (in Einheiten von {{minSaleUnits}} Stück hinzufügen)","delivery_date_stocked":"Voraussichtliche Lieferung: {{deliveryDate}} (Bestellungen vor {{deliveryHour}} Uhr)","delivery_date_on_demand":"Voraussichtliche Lieferung: {{deliveryDate}} (Bestellungen vor dem {{onDemandDay}} um {{deliveryHour}} Uhr)","delivery_date_frozen":"Voraussichtliche Lieferung: {{deliveryDate}} (Bestellungen vor {{deliveryHour}} Uhr)","frozen_cart":"Bestellungen von Tiefkühlprodukten werden separat bearbeitet. Um nicht tiefgekühlte Produkte hinzuzufügen, schließen Sie die Bestellung ab oder leeren Sie den Warenkorb.","fresh_cart":"Bestellungen von nicht tiefgekühlten Produkten werden separat bearbeitet. Um Tiefkühlprodukte hinzuzufügen, schließen Sie die Bestellung ab oder leeren Sie den Warenkorb."}},"shop":{"filters":"Filtern","no_filter":"Keine Produkte entsprechen den ausgewählten Filtern.","no_products":"Mamma mia, la tavola è vuota! Sobald Sie Bestellungen haben, zeigen wir hier Ihre Lieblingsprodukte an, damit Sie sie schnell finden können","displayed_products":"Sie haben gesehen {{productsDisplayed}} von {{totalProducts}}"},"cart":{"500":{"title":"Beim Versuch, eine Verbindung zu Ihrem Warenkorb herzustellen, ist ein Problem aufgetreten.","try_again_later":"Bitte warten Sie einen Moment und versuchen Sie es später erneut.","sorry":"Sorry for the inconvenience."},"cart":"Ihr Warenkorb","articles":"Artikel","article":"Artikel","add_relateds":"Fügen Sie diese Unzertrennlichen hinzu","minimum_order":"Mindestbestellung","cart_error":"Es ist ein Fehler im Warenkorb aufgetreten, bitte versuche es später erneut","cart_date_error":"Beim Auswählen des Lieferdatums ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut","order_saved":"Sie haben bei dieser Bestellung gespart","delivery_available":"Lieferung verfügbar {{deliveryDate}} (wird jedoch in eine einzige Lieferung gruppiert {{cartDeliveryDate}})","delivery_date_stocked":"(Bestellungen vor {{deliveryHour}} Uhr)","delivery_date_on_demand":"(Bestellungen vor dem {{onDemandDay}} um {{deliveryHour}} Uhr)","delivery_date_frozen":"(Bestellungen vor {{deliveryHour}} Uhr)"}}');
;// CONCATENATED MODULE: ./public/locales/pt.json
var pt_namespaceObject = JSON.parse('{"layout":{"nav":{"account":{"name":"Conta","pathname":"/account"},"cart":{"name":"Carrinho","pathname":"/cart"},"home":{"name":"Início","pathname":"/"},"shop":{"name":"Loja","pathname":"/catalog"},"my_usuals":{"name":"Os Meus Habituais","pathname":"/account/my-products"},"products":{"name":"Produtos","pathname":"/catalog"},"about_us":{"name":"Sobre nós","pathname":"/page/sobre-nos"},"catalogue":{"name":"Catálogo PDF","pathname":"/page/catalogo"},"contact_us":{"name":"Contacte-nos","pathname":"/page/contacte-nos"},"events":{"name":"In giro con Mammafiore","pathname":"/page/in-giro-con-noi"}},"footer":{"questions":"Tem perguntas?","write_us":"Escreva-nos","email":"geral@mammafiore.eu","call_us":"ou ligue para","phone_link":"+351932816161","phone_number":"+351 93 281 61 61","newsletter":{"title":"Junte-se à nossa famiglia","input_inactive":"Deixe o seu e-mail","button":"Juntar"},"partners":"Os Nossos Parceiros","legal_warning":"Aviso Legal","change_country_lang":"Mudar de Zona"},"search":{"search_results":"Resultados da Pesquisa","history":"Histórico de Pesquisa","delete":"Apagar","empty_01":"Não encontrámos resultados. Quer fazer uma ","empty_02":"nova pesquisa?","product":"producto","products":"produtos","brand":"marca","search_by_category":"Pesquisar por Categoria:","what_are_you_looking_for":"O que está à procura?"},"nav_account":[{"name":"Encomendas","pathname":"/account/[slug]","slug":"orders"},{"name":"Faturas","pathname":"/account/[slug]","slug":"invoices"},{"name":"Moradas","pathname":"/account/[slug]","slug":"addresses"},{"name":"Dados de Acesso","pathname":"/account"},{"name":"Terminar Sessão","action":"logout"}]},"form":{"fields":{"email":"E-mail","first_name":"Nome","last_name":"Apelido","phone":"Telefone","mobile_phone":"Telemóvel","password":"Palavra-passe","new_password":"Nova palavra-passe","street_line1":"Morada","street_line2":"Apartamento/Suite/Edifício","country":"País","province":"Região","city":"Cidade","postal_code":"Código Postal","comments":"Comentários","shipping_as_billing":"Usar morada de envio como morada de faturação","im_a_company":"Sou uma empresa","cif":"NIPC","company_name":"Nome da empresa"},"errors":{"incomplete":"O formulário deve ser completamente preenchido antes de poder ser enviado","required":"Este campo é obrigatório","empty":"Este campo não pode estar vazio","minLength":"O comprimento do campo não é suficiente","maxLength":"O comprimento máximo do campo foi excedido","pattern_username":"O nome de utilizador só pode conter caracteres alfanuméricos","pattern_password":"A palavra-passe deve ter, pelo menos, 8 caracteres e conter, pelo menos, 1 de cada: maiúsculas e minúsculas, números e símbolos","pattern_email":"O e-mail inserido não é válido","validate_cif":"O número NIPC inserido não é válido","validate_phone":"O número de telefone inserido não é válido","validate_iban":"O número IBAN inserido não é válido"}},"commons":{"actions":{"accept":"Aceitar","add":"Adicionar","cancel":"Cancelar","close":"Fechar","continue":"Continuar","delete":"Eliminar","delete_all":"Eliminar Tudo","download":"Transferir","edit":"Editar","enter":"Entrar","go_back":"Voltar","load":"Carregar","login":"Iniciar Sessão","logout":"Terminar Sessão","next":"Seguinte","prev":"Anterior","remove":"Remover","save":"Guardar","search":"Pesquisar","send":"Enviar","signup":"Criar Conta","submit":"Submeter","add_to_cart":"Adicionar ao Carrinho","how_to_buy":"Como Comprar","increase_cart_units":"Aumentar Unidades do Carrinho","remove_units_from_cart":"Remover Unidades do Carrinho","delete_from_cart":"Eliminar do Carrinho","show":"Mostrar"},"status":{"deleting":"A Eliminar","downloading":"A Transferir","loading":"A Carregar","saving":"A Guardar","updating":"A Atualizar","uploading":"A Carregar"},"newsletter_feedback":{"success":"Obrigado! Mantê-lo-emos informado sobre as últimas novidades","error":"Ocorreu um problema ao enviar o formulário. Por favor, tente novamente mais tarde","duplicated":"O e-mail já está registado"},"faqs":{"title":"Perguntas Frequentes"},"page_not_found":{"404":"Página não encontrada.","title":"A página que está à procura não existe","description":"Tente navegar pelo site para encontrá-la. Ou talvez descubra algo muito melhor, quem sabe.","goback_homepage":"Voltar para a Home"},"page_error":{"500":"Ocorreu um erro inesperado","title":"A página que está à procura apresenta um erro","description":"Tente navegar por outra área do sítio.","goback_homepage":"Voltar para a Home"},"region_picker":{"in":"Em","work_with":"operamos através de:","go_catalogue":"Ir para o catálogo"},"cart":{"total":"total","show_cart":"Ver carrinho","go_checkout":"Finalizar compra","free":"Livre"}},"modals":{"auth":{"start":{"title":"Acesso","text":"É cliente da Mammafiore? Mesmo que nunca tenha comprado através do nosso sítio.","actions":{"primary":"Já sou cliente","secondary":"Quero registar-me"}},"prelogin":{"title":"Acesso","subtitle":"Já ativou a sua conta no nosso sítio?","text":"Se já é cliente da Mammafiore mas nunca comprou através do sítio, clique em Ativar conta.","actions":{"primary":"Iniciar sessão","secondary":"Ativar conta"},"subtext":"Ainda não é cliente da Mammafiore?","subtext_action":"Registar-me"},"login":{"title":"Iniciar sessão","text":"Bem-vindo de volta à Mammafiore.","forgot_password":"Esqueceu a sua palavra-passe?","subtext":"É cliente mas ainda não ativou a sua conta?","subtext_action":"ative-a aqui"},"login_check_cif":{"title":"Ativar Conta","text":"Primeiro insira o seu NIPC.","text2":"Você está na loja de {{storeName}}. Se é de outro país/zona, pode alterar","text2_action":" aqui"},"signup":{"title":"Registo","text":"Está a registar-se na loja de Se é de outro país/zona, pode alterar aqui.","iban":"Simplifique os seus pagamentos. Compre o que precisa e nós debitaremos na sua conta bancária no final do mês. Preencha o seu IBAN e informaremos quando estiver habilitado como método de pagamento. Enquanto isso, pode fazer as suas encomendas e pagar com cartão"},"signup_cif":{"title":"Registo","text":"Está a registar-se para a loja de {{storeName}}. Se você é de outro país/zona, pode alterar","text_action":" aqui","subtext":"Se já é cliente (mesmo que nunca tenha comprado através do nosso sítio) aceda","subtext_action":" aqui"},"activation":{"title":"Ativação da Conta","text":"Adicione uma palavra-passe para concluir a ativação da sua conta."},"forgot_password":{"title":"Redefinir Palavra-passe","text":"Insira o seu e-mail para solicitar uma nova palavra-passe. Enviaremos um e-mail com um link de verificação."},"reset_password":{"title":"Redefinir Palavra-passe","text":"Adicione a sua nova palavra-passe"},"feedback_account_active":{"title":"Conta Ativada","text":"A sua conta foi ativada com sucesso."},"feedback_password_updated":{"title":"Nova Palavra-passe","text":"A sua palavra-passe foi atualizada com sucesso."},"feedback_email_invite":{"title":"Você tem uma conta inativa","text":"Enviámos um e-mail para ","text_2":". Abra-o e siga as instruções.","text2":"Se não tem acesso a este e-mail, contacte-nos através de info@mammafiore.eu ou +34 93 303 76 15"},"feedback_email_reset_password":{"title":"Recuperar Palavra-passe","text":"Enviámos-lhe um link para criar uma nova palavra-passe."},"feedback_cif_already_active":{"title":"Você Já Tem Uma Conta","text":"Este NIPC já tem uma conta ativa no nosso sítio com o e-mail","text2":"Você pode ","text2_2":" ou ","text2_actions":{"login":"iniciar sessão","restore_password":"restaurar a sua palavra-passe."}},"feedback_cif_not_found":{"title":"NIPC Não Encontrado","text":"Não temos o NIPC","text_2":" na nossa base de dados.","text2":"Se está mal escrito, pode voltar atrás. Se acha que é um erro ou precisa de ajuda, contacte-nos em ","test2_2":" / ","text2_actions":{"email":"email@mammafiore.es","phone":"743 673 554"},"text3":"Ou se ainda não é cliente da Mammafiore, pode","text3_action":"registar-se aqui"}},"filter":{"title":"Filtro"},"region_register":{"title":"Nova conta","description":"O registo só está disponível para países ou regiões com loja online. Quer ficar aqui ou prefere mudar de país?","action_change":"Mudar de país/região","action_stay":"Ficar aqui"},"region_lang":{"title":"Selecionar região"},"commercial":{"title":"Como comprar","in":"Em {{storeName}} operamos através de:","ok":"OK","action_change":"Mudar de país/região"},"stock_cart":{"title":"Carrinho atualizado","description":"Atualizamos seu carrinho com o estoque disponível para:","deleted":"(removido, sem estoque no momento)","stock_change_1":"(atualizado para","stock_change_2":"unid., máximo disponível agora)","ok":"OK"},"public_interested":{"title":"Como Comprar","contact":"Para compras profissionais, contacte ","mail":"vendas@mammafiore.es","particular":"Para comprar como particular","cta_hm":"visite a nossa","online":"loja online"},"comercial_region":{"write_us":"Escreva-nos para","mail_to_link":"mailto:geral@mammafiore.eu","mail_to":"geral@mammafiore.eu","more_info":"para mais informações.","open_account":"e abriremos uma conta para si","professional":"É profissional? Escreva-nos para ","b2c":"É particular? Compre na nossa loja online","link_to_b2c":"https://hellomamma.es","link_b2c":"hellomamma.es","you_are_in":"Você está em "},"buy_box":{"title":"Comprar por caixas","text":"Este produto pode ser adicionado por caixas, as caixas contêm {{units}} unidades. Quantas caixas você gostaria?"}},"payment_status":{"succeeded":"Pagamento efetuado com sucesso","processing":"O seu pagamento está a ser processado.","requires_payment_method":"O seu pagamento não foi efetuado corretamente. Por favor, tente novamente.","something_went_wrong":"Algo correu mal.","unexpected_error":"Ocorreu um erro inesperado."},"dates":{"months":{"january":"Janeiro","february":"Fevereiro","march":"Março","april":"Abril","may":"Maio","june":"Junho","july":"Julho","august":"Agosto","september":"Setembro","october":"Outubro","november":"Novembro","december":"Dezembro"},"weekdays":{"monday":"Segunda-feira","tuesday":"Terça-feira","wednesday":"Quarta-feira","thursday":"Quinta-feira","friday":"Sexta-feira","saturday":"Sábado","sunday":"Domingo"},"seasons":{"spring":"Primavera","summer":"Verão","autumn":"Outono","winter":"Inverno"}},"home":{"bestseller":{"new":"Descubra todas as nossas novidades","offer":"Não podem faltar na sua despensa"},"brands":{"brands_title":"Por detrás de cada produto há uma grande marca"}},"section_subscribe":{"welcome":"Bem-vindo à família","register":"Registe-se e desfrute das vantagens de fazer parte da Mammafiore:","open":"Aberto 24/7 durante todo o ano","order":"Faça a sua encomenda com o seu telemóvel, tablet ou PC","offer":"Ofertas personalizadas","save_products":"Guardamos os seus produtos para que não perca tempo","check_invoices":"Consulte facilmente encomendas ou faturas","contact_commercial":"Contacto direto com o seu comercial","register_button":"Registe-se na Mammafiore"},"account":{"buy_again":"Comprar de novo","repeat_order":"Repetir encomenda","details":"Detalhes da encomenda","invoice":"Fatura","invoice_issued":"Fatura emitida em","invoice_download":"Transferir fatura","no_invoice":"Vuoto come una pentola a fine festa! Você ainda não tem nenhuma fatura no sistema. Vamos colocá-las aqui conforme forem geradas","no_orders":"Che tristezza! Sua lista de pedidos parece o deserto. Aqui você os verá (quando os fizer)","my_products":{"my_usual":"Os Meus Habituais","title":"Tornamos tudo muito fácil para si","description":"Registe-se e poderá ver os produtos que comprou em encomendas anteriores e tê-los à mão para facilitar as suas próximas compras.","identify":"Registe-se ou identifique-se"},"home_my_products":{"see_all":"Ver todos","last_orders":"Últimas encomendas","my_usuals":"Os Meus Habituais","my_comercial":"O Meu Comercial"},"order":{"shipping_address":"Morada de envio","billing_address":"Morada de faturação","summary":"Resumo","coupon":"Cupão de desconto","shipping_cost":"Custos de envio","subtotal":"Subtotal","discount":"Desconto","total":"Total","taxes":"IVA","purchase":"Compra","date":"Data","number":"N.º de encomenda","purchase_order":"Processar encomenda","several_dates":"Você tem produtos com datas de entrega diferentes. Serviremos todo o pedido na data do último produto. Você pode modificar o pedido se quiser receber o restante antes.","order_details":{"shipment":"Envio","billing":"Faturação","payment":"Pagamento","payment_summary":"Resumo da encomenda","total_products":"Total de produtos","subtotal_products":"Subtotal","discount":"Descontos aplicados","voucher":"Vale","total_inc_tax":"Total (IVA incl.)","estimated_date":"Data estimada"},"no_stock":"Não há stock para este produto","repeat_order_feedback":{"success":"Todos os produtos disponíveis foram adicionados ao carrinho"}}},"product_page":{"product_main":{"size_dropdown":"Escolher formato:","button_add":"Adicionar ao carrinho","no_stock":"Esgotado","not_available":"Não disponível","see_more":"Ver mais","choose_size":"Escolha o formato:"},"product_description":{"nutritional_value":{"title":"Info nutricional","per_ration":"Por porção","per_100gr":"Por 100 g","ingredients":"Ingredientes","average_value_per":"Valor médio por","energy":"Energia"},"more_info":{"title":"Mais informações"}},"bottom-page":{"related":"Indissociáveis"},"product":{"units":"Unidades","units_abbr":"un","color":"cor","colors":"cores","pack":"Pacote","bundle":"Conjunto","no_stock":"Esgotado","last_units":"Últimas unidades!","on_demand":"Entrega","demand_product":"POR ENCOMENDA","tax":"iva","price_per":{"unit":"/un","box":"/caixa","kg":"/Kg"},"buy_box":"Pedir por caixas de {{units}} unidades","description_min_sale_units":"Caixas de {{minSaleUnits}} (adicionando em unidades de {{minSaleUnits}})","delivery_date_stocked":"\'Entrega estimada: {{deliveryDate}} (encomendas antes das {{deliveryHour}})","delivery_date_on_demand":"\'Entrega estimada: {{deliveryDate}} (encomendas antes de {{onDemandDay}} às {{deliveryHour}})","delivery_date_frozen":"\'Entrega estimada: {{deliveryDate}} (encomendas antes das {{deliveryHour}})","frozen_cart":"Os pedidos de produtos congelados são geridos separadamente. Para adicionar produtos não congelados, finalize o pedido ou esvazie o carrinho.","fresh_cart":"Os pedidos de produtos não congelados são geridos separadamente. Para adicionar produtos congelados, finalize o pedido ou esvaz"}},"shop":{"filters":"Filtrar","no_filter":"Não há nenhum produto que corresponda aos filtros selecionados","no_products":"Mamma mia, la tavola è vuota! Assim que você tiver pedidos, mostraremos aqui seus produtos regulares favoritos para que você os encontre rapidamente","displayed_products":"Viu {{productsDisplayed}} de {{totalProducts}}"},"cart":{"500":{"title":"Ocorreu um problema ao tentar conectar-se ao seu carrinho de compras.","try_again_later":"Aguarde alguns instantes e tente novamente mais tarde.","sorry":"Desculpe pela inconveniência."},"cart":"O seu carrinho","articles":"artigos","article":"artigo","add_relateds":"Adicione estes inseparáveis","minimum_order":"Encomenda mínima","cart_error":"Ocorreu um erro no carrinho, por favor, tente novamente mais tarde","cart_date_error":"Houve um problema ao escolher a data de entrega, por favor, tente novamente mais tarde.","order_saved":"Poupou nesta encomenda","delivery_available":"Entrega disponível {{deliveryDate}} (mas será agrupada numa única entrega {{cartDeliveryDate}})","delivery_date_stocked":"(encomendas antes das {{deliveryHour}})","delivery_date_on_demand":"(encomendas antes de {{onDemandDay}} às {{deliveryHour}})","delivery_date_frozen":"(encomendas antes das {{deliveryHour}})"}}');
;// CONCATENATED MODULE: ./context/TranslationContext.tsx









var DEFAULT_LANG = utils.NEXT_PUBLIC_LOCALE.split("-")[0];
var dictionary = {
    // @ts-ignore
    en: en_namespaceObject,
    // @ts-ignore
    es: es_namespaceObject,
    // @ts-ignore
    fr: fr_namespaceObject,
    // @ts-ignore
    de: de_namespaceObject,
    // @ts-ignore
    pt: pt_namespaceObject
};
// to get translations data, used in getStaticProps of each page
var getTranslations = function(locale) {
    var namespace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var lang = typeof locale === "string" ? locale.split("-")[0] : DEFAULT_LANG;
    // const dict = await import(`../public/locales/${lang}.json`)
    var translations = {
        layout: dictionary[lang].layout,
        form: dictionary[lang].form,
        commons: dictionary[lang].commons,
        modals: dictionary[lang].modals
    };
    if (typeof namespace === "string") {
        translations[namespace] = dictionary[lang][namespace];
    } else if (Array.isArray(namespace)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = namespace[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var name = _step.value;
                if (typeof name === "string") translations[name] = dictionary[lang][name];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return {
        locale: lang,
        translations: translations,
        namespace: namespace
    };
};
var initialLocalization = {
    locale: DEFAULT_LANG,
    translations: dictionary[DEFAULT_LANG],
    namespace: null
};
var TranslationsContext = /*#__PURE__*/ (0,react.createContext)({
    localization: initialLocalization,
    setTranslation: function() {
        return null;
    }
});
var TranslationsProvider = function(param) {
    var localization = param.localization, children = param.children;
    var ref = (0,react.useState)(initialLocalization), localizationState = ref[0], setLocalizationState = ref[1];
    var ref1 = (0,router.useRouter)(), routerLocale = ref1.locale;
    (0,react.useEffect)(function() {
        var locale = routerLocale.split("-")[0];
        if ((localization === null || localization === void 0 ? void 0 : localization.locale) && (locale !== (localization === null || localization === void 0 ? void 0 : localization.locale) || localizationState.namespace !== localization.namespace)) {
            setLocalizationState({
                locale: localization === null || localization === void 0 ? void 0 : localization.locale,
                translations: localization === null || localization === void 0 ? void 0 : localization.translations,
                namespace: localization === null || localization === void 0 ? void 0 : localization.namespace
            });
        }
    }, [
        routerLocale,
        localization,
        localizationState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslationsContext.Provider, {
        value: {
            localization: localizationState,
            setTranslation: setLocalizationState
        },
        children: children
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(24432);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(95163);
;// CONCATENATED MODULE: ./context/CustomerContext.tsx








var CustomerContext = /*#__PURE__*/ (0,react.createContext)(null);
var CustomerProvider = function(param) {
    var _data = param.data, data = _data === void 0 ? null : _data, children = param.children;
    var ref = (0,react.useState)(data), customer = ref[0], setCustomer = ref[1];
    var ref1 = (0,react.useState)(false), loaderActive = ref1[0], setLoaderActive = ref1[1];
    var ref2 = (0,router.useRouter)(), asPath = ref2.asPath, pathname = ref2.pathname;
    var DYCustomerToken = utils.cookie.get("DY_CUSTOMER_TOKEN");
    var ref3 = (0,useQuery/* useQuery */.a)(api/* GET_CUSTOMER */.UB, {
        context: {
            isPrivatePath: true,
            DYCustomerToken: DYCustomerToken
        },
        skip: !DYCustomerToken
    }), customerData = ref3.data;
    var allowedPaymentMethods = [
        "giro",
        "check",
        "delivery",
        "transferencia"
    ];
    (0,react.useEffect)(function() {
        var customer = customerData === null || customerData === void 0 ? void 0 : customerData.customer;
        if (customer) {
            setCustomer(customer);
            utils.cookie.set({
                name: "DY_CUSTOMER_PAYMENT_METHOD",
                value: customer.paymentMethod && allowedPaymentMethods.indexOf(customer.paymentMethod) !== -1 ? customer.paymentMethod : "fallback"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerData
    ]);
    (0,react.useEffect)(function() {
        if (asPath.includes("logout=true")) return;
        var pathnameType = (0,utils.getPathnameType)(pathname);
        // Checking validity of token for the current store
        var checkValidToken = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, token, resCheckToken, data, _tmp, valid;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            token = "eyJhbGciOiJIUzI1NiJ9.eyJ3ZWJzaXRlX2lkIjo5LCJzdG9yZV9pZCI6NCwiY2hhbm5lbF9pZCI6OCwiZXhwIjozMTcyODQ1MTY4MTN9.TnwrT3POxF1UFp6ETped3DSQlXNLngm2b2oKQc6CoT8";
                            return [
                                4,
                                fetch("https://".concat("cms.mammafiore.eu", "/graphql"), {
                                    method: "POST",
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json",
                                        "DY-Access-Token": "".concat(token),
                                        "DY-Customer-Token": DYCustomerToken
                                    },
                                    body: JSON.stringify({
                                        query: "\n            mutation CustomerTokenValidator {\n              customerTokenValidator(input: {}) {\n                ok\n              }\n            }\n          "
                                    })
                                })
                            ];
                        case 1:
                            resCheckToken = _state.sent();
                            if (!resCheckToken.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                resCheckToken.json()
                            ];
                        case 2:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _tmp = null;
                            _state.label = 4;
                        case 4:
                            data = _tmp;
                            valid = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.customerTokenValidator) === null || ref1 === void 0 ? void 0 : ref1.ok;
                            console.log("CustomerProvider - valid token:", valid, asPath);
                            if (!valid && DYCustomerToken) {
                                console.warn("\uD83D\uDC6E\uD83C\uDFFB‍♂️⛔️ ".concat(asPath, " Invalid TOKEN, trying to clear cookies"));
                                if (pathnameType === "private") window.location.href = "/?logout=true";
                                // window.location.href =
                                utils.cookie.removeCookie("BC_CUSTOMER_ID");
                                utils.cookie.removeCookie("DY_CUSTOMER_TOKEN");
                                setCustomer(null);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkValidToken() {
                return _ref.apply(this, arguments);
            };
        }();
        checkValidToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerContext.Provider, {
        value: {
            customer: customer,
            setCustomer: setCustomer,
            loaderActive: loaderActive,
            setLoaderActive: setLoaderActive
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./context/GridVariantsContext.tsx


var GridVariantsContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
// type ProductsAction = { type: 'SET_PRODUCTS', payload: TypeVariant[] }
// type FiltersAction = { type: 'SET_FILTERS', payload: Record<string, string[]> }
// const filteredProductsReducer = (state: TypeVariant[], action: ProductsAction) => {
//   switch (action.type) {
//     case 'SET_PRODUCTS':
//       return action.payload
//     default:
//       return state
//   }
// }
// const activeFiltersReducer = (state: Record<string, string[]>, action: FiltersAction) => {
//   switch (action.type) {
//     case 'SET_FILTERS':
//       return action.payload
//     default:
//       return state
//   }
// }
var GridVariantsProvider = function(param) {
    var children = param.children;
    var ref = useState([]), allProducts = ref[0], setAllProducts = ref[1];
    // const [rawProducts, setRawProducts] = useState<TypeVariant[]>([])
    // const [filters, setFilters] = useState<Record<string, string[]>>({})
    // const [activeFilters, filtersDispatch] = useReducer(activeFiltersReducer, {})
    // const [filteredProducts, filteredProductsDispatch] = useReducer(filteredProductsReducer, [])
    // rawProducts,
    // filters,
    // activeFilters,
    // filteredProducts,
    // setFilters: (newFilters) => {
    //   // Logic to set filters and update activeFilters and filteredProducts
    // }
    return /*#__PURE__*/ _jsx(GridVariantsContext.Provider, {
        value: {
            allProducts: allProducts,
            setAllProducts: setAllProducts
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./context/ActiveVariantContext.tsx




var ActiveVariantContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var ActiveVariantProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(undefined), activeVariant = ref[0], setActiveVariant = ref[1];
    var ref1 = (0,react.useState)(undefined), cardSelected = ref1[0], setCardSelected = ref1[1];
    var pathname = (0,router.useRouter)().pathname;
    var removeActiveVariant = function() {
        setActiveVariant(null);
        setCardSelected(null);
        if ( true && pathname !== "/" && pathname !== "/welcome") window.history.back();
    };
    (0,react.useEffect)(function() {
        if (cardSelected) {
            console.log("cardHasBeenClickedFrom", cardSelected);
        // APOLLO ASK FOR VARIANT DATA
        }
    }, [
        cardSelected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveVariantContext.Provider, {
        value: {
            activeVariant: activeVariant,
            cardSelected: cardSelected,
            setActiveVariant: setActiveVariant,
            setCardSelected: setCardSelected,
            removeActiveVariant: removeActiveVariant
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./context/index.ts






/***/ }),

/***/ 2722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wT": function() { return /* reexport */ useActiveVariant; },
  "ON": function() { return /* reexport */ useCustomer; },
  "I4": function() { return /* reexport */ useTranslator/* useTranslator */.I; }
});

// UNUSED EXPORTS: useGridVariants

// EXTERNAL MODULE: ./hooks/useTranslator.tsx
var useTranslator = __webpack_require__(78026);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./context/index.ts + 9 modules
var context = __webpack_require__(28449);
;// CONCATENATED MODULE: ./hooks/useCustomer.tsx


function useCustomer() {
    var ctx = (0,react.useContext)(context/* CustomerContext */.Am);
    if (ctx === undefined) throw new Error("useCustomer must be used within a CustomerProvider");
    return ctx;
}

;// CONCATENATED MODULE: ./hooks/useGridVariants.tsx


var useGridVariants = function() {
    var ctx = useContext(GridVariantsContext);
    if (!ctx) throw new Error("useGridVariants must be used within a GridVariantsProvider");
    return ctx;
};

;// CONCATENATED MODULE: ./hooks/useActiveVariant.tsx


var useActiveVariant = function() {
    var ctx = (0,react.useContext)(context/* ActiveVariantContext */.o5);
    if (!ctx) throw new Error("useActiveVariant must be used within a ActiveVariantsProvider");
    return ctx;
};

;// CONCATENATED MODULE: ./hooks/index.ts






/***/ }),

/***/ 78026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useTranslator; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28449);


function useTranslator() {
    var t = function t(keyValue) {
        var translation = "".concat(keyValue).split(".").reduce(function(p, c) {
            return p && p[c] || null;
        }, localization.translations);
        if (!translation) {
            console.warn("Translation key: '".concat(keyValue, "' for locale: '").concat(localization === null || localization === void 0 ? void 0 : localization.locale, "' not found."));
            return "";
        }
        if (typeof translation === "string" || typeof translation === "number" || Array.isArray(translation)) {
            return translation;
        } else {
            console.warn("Translation for key: '".concat(keyValue, "' has a NestedObj, please specify an inner key"));
            return "";
        }
    };
    var localization = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .TranslationsContext */ .yJ).localization;
    return {
        t: t,
        locale: localization === null || localization === void 0 ? void 0 : localization.locale
    };
}


/***/ }),

/***/ 57977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ./context/index.ts + 9 modules
var context = __webpack_require__(28449);
// EXTERNAL MODULE: ../commons/dist/context/index.js
var dist_context = __webpack_require__(7693);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 11 modules
var Layout = __webpack_require__(99361);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/layout/head/GoogleTagManager.tsx


var GoogleTagManager = function(param) {
    var id = param.id, _noscript = param.noscript, noscript = _noscript === void 0 ? false : _noscript;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !noscript ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "script-gtm",
            children: "\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','".concat(id, "');\n          ")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://www.googletagmanager.com/ns.html?id='".concat(id, "'"),
                height: "0",
                width: "0",
                style: {
                    display: "none",
                    visibility: "hidden"
                }
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/flickity/css/flickity.css
var flickity = __webpack_require__(8411);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(55671);
// EXTERNAL MODULE: ./api/graphql/index.ts + 6 modules
var graphql = __webpack_require__(37953);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
;// CONCATENATED MODULE: ./pages/_app.tsx












function reportWebVitals(metric) {
    if (!metric.label) return;
    var label = metric.label, name = metric.name, startTime = metric.startTime, value = metric.value;
    if (label === "web-vital" && name === "LCP") {
        // The metric object ({ id, name, startTime, value, label }) is logged to the console
        console.info("".concat(label, " ").concat(name, " | startTime: ").concat(startTime, " - value: ").concat(value));
    }
}
var MyApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var translations = pageProps.translations, layout = pageProps.layout, initialApolloState = pageProps.initialApolloState;
    var apolloClient = (0,graphql/* useApollo */.Uk)(initialApolloState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider/* ApolloProvider */.e, {
            client: apolloClient,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* CustomerProvider */.f3, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_context.ModalsProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_context.CartProvider, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm.ThemeProvider, {
                            theme: styles.theme,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles.Reset, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* TranslationsProvider */.tY, {
                                    localization: translations,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_context.ToastProvider, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ActiveVariantProvider */.z$, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                                                data: layout,
                                                children: [
                                                    utils.PRO && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTagManager, {
                                                        id: "GTM-K6MTWJM"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
//@ts-ignore
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 61962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "getVariantByQueryParam": function() { return /* binding */ getVariantByQueryParam; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95163);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3842);







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  grid-column: unset;\n  grid-row: unset;\n  margin: ",
        ";\n  padding: ",
        ";\n  width: 90vw;\n\n  ",
        " {\n    grid-column: 1 /span 6;\n    padding: ",
        ";\n    margin: ",
        ";\n\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    grid-column: 5 / span 9;\n    grid-row: 1 / span 4;\n    margin: ",
        ";\n    padding: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        ";\n    padding: 30px;\n    width: 580px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  flex-grow: 2;\n  padding: 0;\n  position: relative;\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: 1650px;\n  }\n\n  #main-top {\n    background-color: ",
        ";\n    display: block;\n    height: 2px;\n    opacity: .01;\n    position: absolute;\n    top: 120px;\n    user-select: none;\n    width: 100%;\n\n    ",
        " {\n      transform: translateY(-",
        ");\n    }\n\n    ",
        " {\n      transform: translateY(-20px);\n    }\n  }\n\n  section:not( div > section) {\n    margin: unset;\n    ",
        " {\n      margin: ",
        " 0;\n    }\n\n    ",
        " {\n      margin: 120px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var DynamicSectionRelated = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.SectionRelated;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var __N_SSG = true;
var getVariantByQueryParam = function(data, variantName) {
    var ref, ref1;
    var variant = data === null || data === void 0 ? void 0 : (ref = data.variants) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.name === variantName;
    });
    var ref2;
    return variant ? variant : (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.variants) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref2 !== void 0 ? ref2 : null;
};
var CatalogProductPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var data = param.data, _variant = param.variant, variant = _variant === void 0 ? null : _variant;
    var ref;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), localeQuery = ref1.locale, pathname = ref1.pathname, isFallback = ref1.isFallback, query = ref1.query;
    var locale = (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.getLang)(localeQuery);
    var isPDP = pathname === "/catalog/product/[slug]";
    var round = false;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(data), productData = ref2[0], setProductData = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useLazyQuery */ .t)(_api__WEBPACK_IMPORTED_MODULE_9__/* .GET_PRODUCT_CMS */ .Hd), 2), getDataForProducts = ref3[0], ref4 = ref3[1], ref4 = ref4 !== null ? ref4 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useLazyQuery */ .t)(_api__WEBPACK_IMPORTED_MODULE_9__/* .GET_CATEGORIES */ .Fk), 2), getDataForCategories = ref5[0], ref6 = ref5[1], ref6 = ref6 !== null ? ref6 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__/* .useLazyQuery */ .t)(_api__WEBPACK_IMPORTED_MODULE_9__/* .GET_PRODUCT_CMS */ .Hd), 2), getDataForRelateds = ref7[0], ref8 = ref7[1], ref8 = ref8 !== null ? ref8 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isPDP ? (query === null || query === void 0 ? void 0 : query.v) ? getVariantByQueryParam(data, query.v) : data === null || data === void 0 ? void 0 : (ref = data.variants) === null || ref === void 0 ? void 0 : ref[0] : null), currentVariant = ref9[0], setCurrentVariant = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), relateds = ref10[0], setRelateds = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), categoriesMenu = ref11[0], setCategoriesMenu = ref11[1];
    var ref12 = productData || {}, id = ref12.id, bigcommerceId = ref12.bigcommerceId, name = ref12.name, brand = ref12.brand, slug = ref12.slug, filters = ref12.filters, description = ref12.description, nutrition = ref12.nutrition, ingredients = ref12.ingredients, infoSpecifications = ref12.infoSpecifications, variants = ref12.variants, labels = ref12.labels, seo = ref12.seo, sku = ref12.sku, categories = ref12.categories;
    //eslint-disable-next-line react-hooks/exhaustive-deps
    var header = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            id: id,
            bigcommerceId: bigcommerceId,
            name: name,
            brand: brand,
            filters: filters,
            description: description,
            variants: variants,
            sku: sku,
            slug: slug,
            categories: categories
        };
    }, [
        productData
    ]);
    // useEffect for PDP nested in the grid page
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function getProductData() {
            return _getProductData.apply(this, arguments);
        }
        function _getProductData() {
            _getProductData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
                var data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDataForProducts({
                                    variables: {
                                        slug: variant === null || variant === void 0 ? void 0 : variant.slug
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data === null || data === void 0 ? void 0 : data.product) {
                                setProductData(data.product);
                                (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.pushAnalyticsEvent)("view_item", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, data.product), {
                                    variant: variant,
                                    isPDP: true
                                }));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return _getProductData.apply(this, arguments);
        }
        if (variant) getProductData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variant
    ]);
    // updating currentVariant
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (productData) {
            setCurrentVariant(variant ? variants.filter(function(variantItem) {
                return variantItem.bigcommerceId === variant.variant_id;
            })[0] : (query === null || query === void 0 ? void 0 : query.v) ? getVariantByQueryParam(data, query.v) : variants[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productData,
        query.v
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function getCategoriesMenu() {
            return _getCategoriesMenu.apply(this, arguments);
        }
        function _getCategoriesMenu() {
            _getCategoriesMenu = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
                var data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDataForCategories({
                                    variables: {
                                        type: _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.CATEGORIES.PRODUCT
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) setCategoriesMenu(data === null || data === void 0 ? void 0 : data.categories);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCategoriesMenu.apply(this, arguments);
        }
        getCategoriesMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function getRelateds() {
            return _getRelateds.apply(this, arguments);
        }
        function _getRelateds() {
            _getRelateds = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
                var ref, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDataForRelateds({
                                    variables: {
                                        slug: productData === null || productData === void 0 ? void 0 : productData.slug[locale]
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) setRelateds(data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.related);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getRelateds.apply(this, arguments);
        }
        if (productData) getRelateds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productData
    ]);
    if (isFallback) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    if (!data && isPDP || !data && !variant && !isPDP) return null;
    if (!productData || !currentVariant) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_7__.HeadTag, {
                seo: seo,
                jsonld: {
                    data: data,
                    pageType: "product"
                },
                slug: slug["es"],
                pageType: "product"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConditionalWrapper, {
                condition: isPDP,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                id: "main-top"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.NavShop, {
                                categories: categoriesMenu
                            }),
                            children
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, slug && {
                    id: typeof slug === "string" ? slug : slug["es"]
                }), {
                    isPack: false,
                    isPDP: isPDP,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.DetailHeader, {
                            data: header,
                            labels: labels,
                            currentVariant: currentVariant,
                            setCurrentVariant: setCurrentVariant,
                            isPack: false,
                            round: round,
                            isPrivate: false
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ConditionalWrapper, {
                            condition: !isPDP,
                            wrapper: function(children) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                                    children: children
                                });
                            },
                            children: [
                                (nutrition === null || nutrition === void 0 ? void 0 : nutrition.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionNutritionChart, {
                                    data: nutrition
                                }),
                                (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionIngredients, {
                                    data: ingredients
                                }),
                                (infoSpecifications === null || infoSpecifications === void 0 ? void 0 : infoSpecifications.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionMoreInfo, {
                                    data: infoSpecifications
                                }),
                                (relateds === null || relateds === void 0 ? void 0 : relateds.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicSectionRelated, {
                                    data: relateds,
                                    gaList: {
                                        id: "list_relateds",
                                        name: "List relateds (slider) [public]"
                                    }
                                })
                            ]
                        })
                    ]
                }))
            })
        ]
    });
});
CatalogProductPage.Layout = _components__WEBPACK_IMPORTED_MODULE_6__.Layout;
/* harmony default export */ __webpack_exports__["default"] = (CatalogProductPage);
var ProductWrapper = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].div.withConfig({
    displayName: "[slug]__ProductWrapper",
    componentId: "sc-1b042e7c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "60px 20px 200px" : "60px auto 200px";
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("nexus7"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "nexus7"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(70, "nexus7"), " auto 200px") : "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(70, "nexus7"), " auto 200px");
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), " 0 200px") : "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), " auto 200px");
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(580, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "120px 80px 200px" : "120px auto 200px";
});
var Main = styled_components__WEBPACK_IMPORTED_MODULE_17__["default"].main.withConfig({
    displayName: "[slug]__Main",
    componentId: "sc-1b042e7c-1"
})(_templateObject1(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.designGrid)({
    withoutGutter: true
}), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop-wide"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"));


/***/ }),

/***/ 39647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95163);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3842);
/* harmony import */ var _catalog_product_slug___WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61962);







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  grid-column: unset;\n  grid-row: unset;\n  margin: ",
        ";\n  padding: ",
        ";\n  width: 90vw;\n\n  ",
        " {\n    grid-column: 1 /span 6;\n    margin: ",
        ";\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    grid-column: 5 / span 9;\n    grid-row: 1 / span 4;\n    margin: ",
        ";\n    padding: ",
        ";\n    width: ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        ";\n    padding: 30px;\n    width: 580px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  flex-grow: 2;\n  padding: 0;\n  position: relative;\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: 1650px;\n  }\n\n  #main-top {\n    background-color: ",
        ";\n    display: block;\n    height: 2px;\n    opacity: .01;\n    position: absolute;\n    top: 120px;\n    user-select: none;\n    width: 100%;\n\n    ",
        " {\n      transform: translateY(-",
        ");\n    }\n\n    ",
        " {\n      transform: translateY(-20px);\n    }\n  }\n\n  section:not( div > section) {\n    margin: unset;\n    ",
        " {\n      margin: ",
        " 0;\n    }\n\n    ",
        " {\n      margin: 120px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var DynamicSectionRelated = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83242)).then(function(mod) {
        return mod.SectionRelated;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83242)
            ];
        }
    }
});
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var ShopProductPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _data = param.data, data = _data === void 0 ? null : _data, _variant = param.variant, variant = _variant === void 0 ? null : _variant;
    var ref;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), localeQuery = ref1.locale, pathname = ref1.pathname, isFallback = ref1.isFallback, query = ref1.query;
    var locale = (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.getLang)(localeQuery);
    var isPDP = pathname === "/shop/product/[slug]" || pathname === "/catalog/product/[slug]";
    var round = false;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(data), productData = ref2[0], setProductData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isPDP ? (query === null || query === void 0 ? void 0 : query.v) ? (0,_catalog_product_slug___WEBPACK_IMPORTED_MODULE_10__.getVariantByQueryParam)(data, query.v) : data === null || data === void 0 ? void 0 : (ref = data.variants) === null || ref === void 0 ? void 0 : ref[0] : null), currentVariant = ref3[0], setCurrentVariant = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isPDP ? data === null || data === void 0 ? void 0 : data.related : []), relateds = ref4[0], setRelateds = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), categoriesMenu = ref5[0], setCategoriesMenu = ref5[1];
    var ref6 = productData || {}, id = ref6.id, bigcommerceId = ref6.bigcommerceId, name = ref6.name, brand = ref6.brand, slug = ref6.slug, filters = ref6.filters, description = ref6.description, nutrition = ref6.nutrition, ingredients = ref6.ingredients, infoSpecifications = ref6.infoSpecifications, variants = ref6.variants, labels = ref6.labels, seo = ref6.seo, sku = ref6.sku, categories = ref6.categories;
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_12__/* .useLazyQuery */ .t)(_api__WEBPACK_IMPORTED_MODULE_9__/* .GET_PRODUCT_CMS */ .Hd), 2), getDataForProducts = ref7[0], ref8 = ref7[1], ref8 = ref8 !== null ? ref8 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_12__/* .useLazyQuery */ .t)(_api__WEBPACK_IMPORTED_MODULE_9__/* .GET_CATEGORIES */ .Fk), 2), getDataForCategories = ref9[0], ref10 = ref9[1], ref10 = ref10 !== null ? ref10 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    // const [getDataForRelateds, {}] = useLazyQuery(GET_PRODUCT_CMS)
    //eslint-disable-next-line react-hooks/exhaustive-deps
    var header = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            id: id,
            bigcommerceId: bigcommerceId,
            name: name,
            brand: brand,
            filters: filters,
            description: description,
            variants: variants,
            sku: sku,
            slug: slug,
            categories: categories
        };
    }, [
        productData
    ]);
    var isPack = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return currentVariant ? (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.variantType) === "pack" : false;
    }, [
        currentVariant
    ]);
    // useEffect for PDP nested in the grid page
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function getProductData(slug) {
            return _getProductData.apply(this, arguments);
        }
        function _getProductData() {
            _getProductData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(slug) {
                var DYCustomerToken, data, ref;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            DYCustomerToken = _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.cookie.get("DY_CUSTOMER_TOKEN");
                            return [
                                4,
                                getDataForProducts({
                                    variables: {
                                        slug: slug
                                    },
                                    context: {
                                        isPrivatePath: true,
                                        DYCustomerToken: DYCustomerToken
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data === null || data === void 0 ? void 0 : data.product) {
                                ;
                                setProductData(data.product);
                                setRelateds((ref = data.product) === null || ref === void 0 ? void 0 : ref.related);
                                (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.pushAnalyticsEvent)("view_item", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, data.product), {
                                    variant: variant,
                                    isPDP: true
                                }));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return _getProductData.apply(this, arguments);
        }
        var slug = variant === null || variant === void 0 ? void 0 : variant.slug;
        if (slug && !productData) getProductData(slug);
    }, [
        variant,
        productData,
        getDataForProducts,
        locale
    ]);
    // updating currentVariant
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (productData) {
            setCurrentVariant(variant ? variants.filter(function(variantItem) {
                return variantItem.bigcommerceId === variant.variant_id;
            })[0] : (query === null || query === void 0 ? void 0 : query.v) ? (0,_catalog_product_slug___WEBPACK_IMPORTED_MODULE_10__.getVariantByQueryParam)(data, query.v) : variants[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productData,
        query.v
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function getCategoriesMenu() {
            return _getCategoriesMenu.apply(this, arguments);
        }
        function _getCategoriesMenu() {
            _getCategoriesMenu = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                var DYCustomerToken, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            DYCustomerToken = _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.cookie.get.DY_CUSTOMER_TOKEN;
                            return [
                                4,
                                getDataForCategories({
                                    variables: {
                                        type: _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.CATEGORIES.PRODUCT
                                    },
                                    context: {
                                        isPrivatePath: true,
                                        DYCustomerToken: DYCustomerToken
                                    }
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) setCategoriesMenu(data === null || data === void 0 ? void 0 : data.categories);
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCategoriesMenu.apply(this, arguments);
        }
        getCategoriesMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (isFallback) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    if (!data && isPDP || !data && !variant && !isPDP) return null;
    if (!productData || !currentVariant) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_7__.HeadTag, {
                seo: seo,
                jsonld: {
                    data: data,
                    pageType: "product"
                },
                slug: slug["es"],
                pageType: "product"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConditionalWrapper, {
                condition: isPDP,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                id: "main-top"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.NavShop, {
                                categories: categoriesMenu
                            }),
                            children
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, slug && {
                    id: typeof slug === "string" ? slug : slug["es"]
                }), {
                    isPack: isPack,
                    isPDP: isPDP,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.DetailHeader, {
                            data: header,
                            labels: labels,
                            currentVariant: currentVariant,
                            setCurrentVariant: setCurrentVariant,
                            isPack: isPack,
                            round: round,
                            isPrivate: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ConditionalWrapper, {
                            condition: !isPDP,
                            wrapper: function(children) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                                    children: children
                                });
                            },
                            children: [
                                !isPack && (nutrition === null || nutrition === void 0 ? void 0 : nutrition.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionNutritionChart, {
                                    data: nutrition
                                }),
                                !isPack && (ingredients === null || ingredients === void 0 ? void 0 : ingredients.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionIngredients, {
                                    data: ingredients
                                }),
                                (infoSpecifications === null || infoSpecifications === void 0 ? void 0 : infoSpecifications.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__.SectionMoreInfo, {
                                    data: infoSpecifications
                                }),
                                (relateds === null || relateds === void 0 ? void 0 : relateds.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicSectionRelated, {
                                    data: relateds,
                                    gaList: {
                                        id: "list_relateds",
                                        name: "List relateds (slider) [private]"
                                    }
                                })
                            ]
                        })
                    ]
                }))
            })
        ]
    });
});
ShopProductPage.Layout = _components__WEBPACK_IMPORTED_MODULE_6__.Layout;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopProductPage);
var ProductWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].div.withConfig({
    displayName: "[slug]__ProductWrapper",
    componentId: "sc-51758f21-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "60px 20px 200px" : "60px auto 200px";
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "mobile"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("nexus7"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(70, "nexus7"), " auto 200px") : "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(70, "nexus7"), " auto 200px");
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "nexus7"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), " 0 200px") : "".concat((0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), " auto 200px");
}, (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(30, "desktop"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(580, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"), function(param) {
    var isPDP = param.isPDP;
    return isPDP ? "120px 80px 200px" : "120px auto 200px";
});
var Main = styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].main.withConfig({
    displayName: "[slug]__Main",
    componentId: "sc-51758f21-1"
})(_templateObject1(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.designGrid)({
    withoutGutter: true
}), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop-wide"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.vw)(120, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_5__.mq.greaterThan("desktop"));


/***/ }),

/***/ 8411:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 78318:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42351:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 96577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(33718)


/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90162)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 78435:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 2421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _reactDom = __webpack_require__(28316);

var _imagesloaded = _interopRequireDefault(__webpack_require__(56204));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var FlickityComponent = /*#__PURE__*/function (_Component) {
  _inherits(FlickityComponent, _Component);

  var _super = _createSuper(FlickityComponent);

  function FlickityComponent(props) {
    var _this;

    _classCallCheck(this, FlickityComponent);

    _this = _super.call(this, props);
    _this.state = {
      flickityReady: false,
      flickityCreated: false,
      cellCount: 0
    };
    _this.carousel = null;
    _this.flkty = null;
    return _this;
  }

  _createClass(FlickityComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$options = _this$props.options,
          draggable = _this$props$options.draggable,
          initialIndex = _this$props$options.initialIndex,
          reloadOnUpdate = _this$props.reloadOnUpdate,
          disableImagesLoaded = _this$props.disableImagesLoaded;
      var flickityReady = this.state.flickityReady;

      if (reloadOnUpdate || !prevState.flickityReady && flickityReady) {
        var isActive = this.flkty.isActive;
        this.flkty.deactivate();
        this.flkty.selectedIndex = initialIndex || 0;
        this.flkty.options.draggable = draggable === undefined ? children ? children.length > 1 : false : draggable;
        if (isActive) this.flkty.activate();

        if (!disableImagesLoaded && this.carousel) {
          (0, _imagesloaded["default"])(this.carousel, function () {
            _this2.flkty.reloadCells();
          });
        }
      } else {
        this.flkty.reloadCells();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!canUseDOM) return null;

      var Flickity = __webpack_require__(89735);

      var _this$props2 = this.props,
          flickityRef = _this$props2.flickityRef,
          options = _this$props2.options;
      this.flkty = new Flickity(this.carousel, options);
      if (flickityRef) flickityRef(this.flkty);

      if (this.props["static"]) {
        this.setReady();
      } else {
        this.setState({
          flickityCreated: true
        });
      }
    }
  }, {
    key: "setReady",
    value: function setReady() {
      var _this3 = this;

      if (this.state.flickityReady) return;

      var setFlickityToReady = function setFlickityToReady() {
        return _this3.setState({
          flickityReady: true
        });
      };

      if (this.props.disableImagesLoaded) setFlickityToReady();else (0, _imagesloaded["default"])(this.carousel, setFlickityToReady);
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      var _this4 = this;

      if (!this.carousel) return null;
      var mountNode = this.carousel.querySelector('.flickity-slider');

      if (mountNode) {
        var element = /*#__PURE__*/(0, _reactDom.createPortal)(this.props.children, mountNode);
        setTimeout(function () {
          return _this4.setReady();
        }, 0);
        return element;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/_react["default"].createElement(this.props.elementType, {
        className: this.props.className,
        ref: function ref(c) {
          _this5.carousel = c;
        }
      }, this.props["static"] ? this.props.children : this.renderPortal());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var cellCount = _react["default"].Children.count(props.children);

      if (cellCount !== state.cellCount) return {
        flickityReady: false,
        cellCount: cellCount
      };
      return null;
    }
  }]);

  return FlickityComponent;
}(_react.Component);

FlickityComponent.propTypes = {
  children: _propTypes["default"].array,
  className: _propTypes["default"].string,
  disableImagesLoaded: _propTypes["default"].bool,
  elementType: _propTypes["default"].string,
  flickityRef: _propTypes["default"].func,
  options: _propTypes["default"].object,
  reloadOnUpdate: _propTypes["default"].bool,
  "static": _propTypes["default"].bool
};
FlickityComponent.defaultProps = {
  className: '',
  disableImagesLoaded: false,
  elementType: 'div',
  options: {},
  reloadOnUpdate: false,
  "static": false
};
var _default = FlickityComponent;
exports["default"] = _default;
module.exports = exports.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 16403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var Player_exports = {};
__export(Player_exports, {
  default: () => Player
});
module.exports = __toCommonJS(Player_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_react_fast_compare = __toESM(__webpack_require__(78435));
var import_props = __webpack_require__(29090);
var import_utils = __webpack_require__(77838);
const SEEK_ON_PLAY_EXPIRY = 5e3;
class Player extends import_react.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "mounted", false);
    __publicField(this, "isReady", false);
    __publicField(this, "isPlaying", false);
    // Track playing state internally to prevent bugs
    __publicField(this, "isLoading", true);
    // Use isLoading to prevent onPause when switching URL
    __publicField(this, "loadOnReady", null);
    __publicField(this, "startOnPlay", true);
    __publicField(this, "seekOnPlay", null);
    __publicField(this, "onDurationCalled", false);
    __publicField(this, "handlePlayerMount", (player) => {
      if (this.player) {
        this.progress();
        return;
      }
      this.player = player;
      this.player.load(this.props.url);
      this.progress();
    });
    __publicField(this, "getInternalPlayer", (key) => {
      if (!this.player)
        return null;
      return this.player[key];
    });
    __publicField(this, "progress", () => {
      if (this.props.url && this.player && this.isReady) {
        const playedSeconds = this.getCurrentTime() || 0;
        const loadedSeconds = this.getSecondsLoaded();
        const duration = this.getDuration();
        if (duration) {
          const progress = {
            playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          if (progress.playedSeconds !== this.prevPlayed || progress.loadedSeconds !== this.prevLoaded) {
            this.props.onProgress(progress);
          }
          this.prevPlayed = progress.playedSeconds;
          this.prevLoaded = progress.loadedSeconds;
        }
      }
      this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
    });
    __publicField(this, "handleReady", () => {
      if (!this.mounted)
        return;
      this.isReady = true;
      this.isLoading = false;
      const { onReady, playing, volume, muted } = this.props;
      onReady();
      if (!muted && volume !== null) {
        this.player.setVolume(volume);
      }
      if (this.loadOnReady) {
        this.player.load(this.loadOnReady, true);
        this.loadOnReady = null;
      } else if (playing) {
        this.player.play();
      }
      this.handleDurationCheck();
    });
    __publicField(this, "handlePlay", () => {
      this.isPlaying = true;
      this.isLoading = false;
      const { onStart, onPlay, playbackRate } = this.props;
      if (this.startOnPlay) {
        if (this.player.setPlaybackRate && playbackRate !== 1) {
          this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        this.startOnPlay = false;
      }
      onPlay();
      if (this.seekOnPlay) {
        this.seekTo(this.seekOnPlay);
        this.seekOnPlay = null;
      }
      this.handleDurationCheck();
    });
    __publicField(this, "handlePause", (e) => {
      this.isPlaying = false;
      if (!this.isLoading) {
        this.props.onPause(e);
      }
    });
    __publicField(this, "handleEnded", () => {
      const { activePlayer, loop, onEnded } = this.props;
      if (activePlayer.loopOnEnded && loop) {
        this.seekTo(0);
      }
      if (!loop) {
        this.isPlaying = false;
        onEnded();
      }
    });
    __publicField(this, "handleError", (...args) => {
      this.isLoading = false;
      this.props.onError(...args);
    });
    __publicField(this, "handleDurationCheck", () => {
      clearTimeout(this.durationCheckTimeout);
      const duration = this.getDuration();
      if (duration) {
        if (!this.onDurationCalled) {
          this.props.onDuration(duration);
          this.onDurationCalled = true;
        }
      } else {
        this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }
    });
    __publicField(this, "handleLoaded", () => {
      this.isLoading = false;
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    clearTimeout(this.progressTimeout);
    clearTimeout(this.durationCheckTimeout);
    if (this.isReady && this.props.stopOnUnmount) {
      this.player.stop();
      if (this.player.disablePIP) {
        this.player.disablePIP();
      }
    }
    this.mounted = false;
  }
  componentDidUpdate(prevProps) {
    if (!this.player) {
      return;
    }
    const { url, playing, volume, muted, playbackRate, pip, loop, activePlayer, disableDeferredLoading } = this.props;
    if (!(0, import_react_fast_compare.default)(prevProps.url, url)) {
      if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, import_utils.isMediaStream)(url)) {
        console.warn(`ReactPlayer: the attempt to load ${url} is being deferred until the player has loaded`);
        this.loadOnReady = url;
        return;
      }
      this.isLoading = true;
      this.startOnPlay = true;
      this.onDurationCalled = false;
      this.player.load(url, this.isReady);
    }
    if (!prevProps.playing && playing && !this.isPlaying) {
      this.player.play();
    }
    if (prevProps.playing && !playing && this.isPlaying) {
      this.player.pause();
    }
    if (!prevProps.pip && pip && this.player.enablePIP) {
      this.player.enablePIP();
    }
    if (prevProps.pip && !pip && this.player.disablePIP) {
      this.player.disablePIP();
    }
    if (prevProps.volume !== volume && volume !== null) {
      this.player.setVolume(volume);
    }
    if (prevProps.muted !== muted) {
      if (muted) {
        this.player.mute();
      } else {
        this.player.unmute();
        if (volume !== null) {
          setTimeout(() => this.player.setVolume(volume));
        }
      }
    }
    if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
      this.player.setPlaybackRate(playbackRate);
    }
    if (prevProps.loop !== loop && this.player.setLoop) {
      this.player.setLoop(loop);
    }
  }
  getDuration() {
    if (!this.isReady)
      return null;
    return this.player.getDuration();
  }
  getCurrentTime() {
    if (!this.isReady)
      return null;
    return this.player.getCurrentTime();
  }
  getSecondsLoaded() {
    if (!this.isReady)
      return null;
    return this.player.getSecondsLoaded();
  }
  seekTo(amount, type, keepPlaying) {
    if (!this.isReady) {
      if (amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(() => {
          this.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
      }
      return;
    }
    const isFraction = !type ? amount > 0 && amount < 1 : type === "fraction";
    if (isFraction) {
      const duration = this.player.getDuration();
      if (!duration) {
        console.warn("ReactPlayer: could not seek using fraction \u2013\xA0duration not yet available");
        return;
      }
      this.player.seekTo(duration * amount, keepPlaying);
      return;
    }
    this.player.seekTo(amount, keepPlaying);
  }
  render() {
    const Player2 = this.props.activePlayer;
    if (!Player2) {
      return null;
    }
    return /* @__PURE__ */ import_react.default.createElement(
      Player2,
      {
        ...this.props,
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }
    );
  }
}
__publicField(Player, "displayName", "Player");
__publicField(Player, "propTypes", import_props.propTypes);
__publicField(Player, "defaultProps", import_props.defaultProps);


/***/ }),

/***/ 52055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var ReactPlayer_exports = {};
__export(ReactPlayer_exports, {
  createReactPlayer: () => createReactPlayer
});
module.exports = __toCommonJS(ReactPlayer_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_deepmerge = __toESM(__webpack_require__(39714));
var import_memoize_one = __toESM(__webpack_require__(36631));
var import_react_fast_compare = __toESM(__webpack_require__(78435));
var import_props = __webpack_require__(29090);
var import_utils = __webpack_require__(77838);
var import_Player = __toESM(__webpack_require__(16403));
const Preview = (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerPreview */ 7664).then(__webpack_require__.t.bind(__webpack_require__, 27296, 23)));
const IS_BROWSER = typeof window !== "undefined" && window.document;
const IS_GLOBAL = typeof __webpack_require__.g !== "undefined" && __webpack_require__.g.window && __webpack_require__.g.window.document;
const SUPPORTED_PROPS = Object.keys(import_props.propTypes);
const UniversalSuspense = IS_BROWSER || IS_GLOBAL ? import_react.Suspense : () => null;
const customPlayers = [];
const createReactPlayer = (players, fallback) => {
  var _a;
  return _a = class extends import_react.Component {
    constructor() {
      super(...arguments);
      __publicField(this, "state", {
        showPreview: !!this.props.light
      });
      // Use references, as refs is used by React
      __publicField(this, "references", {
        wrapper: (wrapper) => {
          this.wrapper = wrapper;
        },
        player: (player) => {
          this.player = player;
        }
      });
      __publicField(this, "handleClickPreview", (e) => {
        this.setState({ showPreview: false });
        this.props.onClickPreview(e);
      });
      __publicField(this, "showPreview", () => {
        this.setState({ showPreview: true });
      });
      __publicField(this, "getDuration", () => {
        if (!this.player)
          return null;
        return this.player.getDuration();
      });
      __publicField(this, "getCurrentTime", () => {
        if (!this.player)
          return null;
        return this.player.getCurrentTime();
      });
      __publicField(this, "getSecondsLoaded", () => {
        if (!this.player)
          return null;
        return this.player.getSecondsLoaded();
      });
      __publicField(this, "getInternalPlayer", (key = "player") => {
        if (!this.player)
          return null;
        return this.player.getInternalPlayer(key);
      });
      __publicField(this, "seekTo", (fraction, type, keepPlaying) => {
        if (!this.player)
          return null;
        this.player.seekTo(fraction, type, keepPlaying);
      });
      __publicField(this, "handleReady", () => {
        this.props.onReady(this);
      });
      __publicField(this, "getActivePlayer", (0, import_memoize_one.default)((url) => {
        for (const player of [...customPlayers, ...players]) {
          if (player.canPlay(url)) {
            return player;
          }
        }
        if (fallback) {
          return fallback;
        }
        return null;
      }));
      __publicField(this, "getConfig", (0, import_memoize_one.default)((url, key) => {
        const { config } = this.props;
        return import_deepmerge.default.all([
          import_props.defaultProps.config,
          import_props.defaultProps.config[key] || {},
          config,
          config[key] || {}
        ]);
      }));
      __publicField(this, "getAttributes", (0, import_memoize_one.default)((url) => {
        return (0, import_utils.omit)(this.props, SUPPORTED_PROPS);
      }));
      __publicField(this, "renderActivePlayer", (url) => {
        if (!url)
          return null;
        const player = this.getActivePlayer(url);
        if (!player)
          return null;
        const config = this.getConfig(url, player.key);
        return /* @__PURE__ */ import_react.default.createElement(
          import_Player.default,
          {
            ...this.props,
            key: player.key,
            ref: this.references.player,
            config,
            activePlayer: player.lazyPlayer || player,
            onReady: this.handleReady
          }
        );
      });
    }
    shouldComponentUpdate(nextProps, nextState) {
      return !(0, import_react_fast_compare.default)(this.props, nextProps) || !(0, import_react_fast_compare.default)(this.state, nextState);
    }
    componentDidUpdate(prevProps) {
      const { light } = this.props;
      if (!prevProps.light && light) {
        this.setState({ showPreview: true });
      }
      if (prevProps.light && !light) {
        this.setState({ showPreview: false });
      }
    }
    renderPreview(url) {
      if (!url)
        return null;
      const { light, playIcon, previewTabIndex, oEmbedUrl } = this.props;
      return /* @__PURE__ */ import_react.default.createElement(
        Preview,
        {
          url,
          light,
          playIcon,
          previewTabIndex,
          oEmbedUrl,
          onClick: this.handleClickPreview
        }
      );
    }
    render() {
      const { url, style, width, height, fallback: fallback2, wrapper: Wrapper } = this.props;
      const { showPreview } = this.state;
      const attributes = this.getAttributes(url);
      const wrapperRef = typeof Wrapper === "string" ? this.references.wrapper : void 0;
      return /* @__PURE__ */ import_react.default.createElement(Wrapper, { ref: wrapperRef, style: { ...style, width, height }, ...attributes }, /* @__PURE__ */ import_react.default.createElement(UniversalSuspense, { fallback: fallback2 }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
    }
  }, __publicField(_a, "displayName", "ReactPlayer"), __publicField(_a, "propTypes", import_props.propTypes), __publicField(_a, "defaultProps", import_props.defaultProps), __publicField(_a, "addCustomPlayer", (player) => {
    customPlayers.push(player);
  }), __publicField(_a, "removeCustomPlayers", () => {
    customPlayers.length = 0;
  }), __publicField(_a, "canPlay", (url) => {
    for (const Player2 of [...customPlayers, ...players]) {
      if (Player2.canPlay(url)) {
        return true;
      }
    }
    return false;
  }), __publicField(_a, "canEnablePIP", (url) => {
    for (const Player2 of [...customPlayers, ...players]) {
      if (Player2.canEnablePIP && Player2.canEnablePIP(url)) {
        return true;
      }
    }
    return false;
  }), _a;
};


/***/ }),

/***/ 84372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);
var import_players = __toESM(__webpack_require__(18350));
var import_ReactPlayer = __webpack_require__(52055);
const fallback = import_players.default[import_players.default.length - 1];
var src_default = (0, import_ReactPlayer.createReactPlayer)(import_players.default, fallback);


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var patterns_exports = {};
__export(patterns_exports, {
  AUDIO_EXTENSIONS: () => AUDIO_EXTENSIONS,
  DASH_EXTENSIONS: () => DASH_EXTENSIONS,
  FLV_EXTENSIONS: () => FLV_EXTENSIONS,
  HLS_EXTENSIONS: () => HLS_EXTENSIONS,
  MATCH_URL_DAILYMOTION: () => MATCH_URL_DAILYMOTION,
  MATCH_URL_FACEBOOK: () => MATCH_URL_FACEBOOK,
  MATCH_URL_FACEBOOK_WATCH: () => MATCH_URL_FACEBOOK_WATCH,
  MATCH_URL_KALTURA: () => MATCH_URL_KALTURA,
  MATCH_URL_MIXCLOUD: () => MATCH_URL_MIXCLOUD,
  MATCH_URL_SOUNDCLOUD: () => MATCH_URL_SOUNDCLOUD,
  MATCH_URL_STREAMABLE: () => MATCH_URL_STREAMABLE,
  MATCH_URL_TWITCH_CHANNEL: () => MATCH_URL_TWITCH_CHANNEL,
  MATCH_URL_TWITCH_VIDEO: () => MATCH_URL_TWITCH_VIDEO,
  MATCH_URL_VIDYARD: () => MATCH_URL_VIDYARD,
  MATCH_URL_VIMEO: () => MATCH_URL_VIMEO,
  MATCH_URL_WISTIA: () => MATCH_URL_WISTIA,
  MATCH_URL_YOUTUBE: () => MATCH_URL_YOUTUBE,
  VIDEO_EXTENSIONS: () => VIDEO_EXTENSIONS,
  canPlay: () => canPlay
});
module.exports = __toCommonJS(patterns_exports);
var import_utils = __webpack_require__(77838);
const MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
const MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
const MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
const MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
const MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
const MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
const MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
const MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
const MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
const MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
const MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
const MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
const MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
const AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
const FLV_EXTENSIONS = /\.(flv)($|\?)/i;
const canPlayFile = (url) => {
  if (url instanceof Array) {
    for (const item of url) {
      if (typeof item === "string" && canPlayFile(item)) {
        return true;
      }
      if (canPlayFile(item.src)) {
        return true;
      }
    }
    return false;
  }
  if ((0, import_utils.isMediaStream)(url) || (0, import_utils.isBlobUrl)(url)) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
};
const canPlay = {
  youtube: (url) => {
    if (url instanceof Array) {
      return url.every((item) => MATCH_URL_YOUTUBE.test(item));
    }
    return MATCH_URL_YOUTUBE.test(url);
  },
  soundcloud: (url) => MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url),
  vimeo: (url) => MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url),
  facebook: (url) => MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url),
  streamable: (url) => MATCH_URL_STREAMABLE.test(url),
  wistia: (url) => MATCH_URL_WISTIA.test(url),
  twitch: (url) => MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url),
  dailymotion: (url) => MATCH_URL_DAILYMOTION.test(url),
  mixcloud: (url) => MATCH_URL_MIXCLOUD.test(url),
  vidyard: (url) => MATCH_URL_VIDYARD.test(url),
  kaltura: (url) => MATCH_URL_KALTURA.test(url),
  file: canPlayFile
};


/***/ }),

/***/ 18350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var players_exports = {};
__export(players_exports, {
  default: () => players_default
});
module.exports = __toCommonJS(players_exports);
var import_utils = __webpack_require__(77838);
var import_patterns = __webpack_require__(842);
var players_default = [
  {
    key: "youtube",
    name: "YouTube",
    canPlay: import_patterns.canPlay.youtube,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerYouTube */ 4439).then(__webpack_require__.t.bind(__webpack_require__, 56250, 23)))
  },
  {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: import_patterns.canPlay.soundcloud,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerSoundCloud */ 6125).then(__webpack_require__.t.bind(__webpack_require__, 71323, 23)))
  },
  {
    key: "vimeo",
    name: "Vimeo",
    canPlay: import_patterns.canPlay.vimeo,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerVimeo */ 3743).then(__webpack_require__.t.bind(__webpack_require__, 22127, 23)))
  },
  {
    key: "facebook",
    name: "Facebook",
    canPlay: import_patterns.canPlay.facebook,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerFacebook */ 2121).then(__webpack_require__.t.bind(__webpack_require__, 1027, 23)))
  },
  {
    key: "streamable",
    name: "Streamable",
    canPlay: import_patterns.canPlay.streamable,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerStreamable */ 2546).then(__webpack_require__.t.bind(__webpack_require__, 69788, 23)))
  },
  {
    key: "wistia",
    name: "Wistia",
    canPlay: import_patterns.canPlay.wistia,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerWistia */ 8055).then(__webpack_require__.t.bind(__webpack_require__, 5337, 23)))
  },
  {
    key: "twitch",
    name: "Twitch",
    canPlay: import_patterns.canPlay.twitch,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerTwitch */ 6216).then(__webpack_require__.t.bind(__webpack_require__, 13691, 23)))
  },
  {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: import_patterns.canPlay.dailymotion,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerDailyMotion */ 7596).then(__webpack_require__.t.bind(__webpack_require__, 82353, 23)))
  },
  {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: import_patterns.canPlay.mixcloud,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerMixcloud */ 4667).then(__webpack_require__.t.bind(__webpack_require__, 96123, 23)))
  },
  {
    key: "vidyard",
    name: "Vidyard",
    canPlay: import_patterns.canPlay.vidyard,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerVidyard */ 8888).then(__webpack_require__.t.bind(__webpack_require__, 85987, 23)))
  },
  {
    key: "kaltura",
    name: "Kaltura",
    canPlay: import_patterns.canPlay.kaltura,
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerKaltura */ 261).then(__webpack_require__.t.bind(__webpack_require__, 2630, 23)))
  },
  {
    key: "file",
    name: "FilePlayer",
    canPlay: import_patterns.canPlay.file,
    canEnablePIP: (url) => {
      return import_patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, import_utils.supportsWebKitPresentationMode)()) && !import_patterns.AUDIO_EXTENSIONS.test(url);
    },
    lazyPlayer: (0, import_utils.lazy)(() => __webpack_require__.e(/* import() | reactPlayerFilePlayer */ 6011).then(__webpack_require__.t.bind(__webpack_require__, 53377, 23)))
  }
];


/***/ }),

/***/ 29090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var props_exports = {};
__export(props_exports, {
  defaultProps: () => defaultProps,
  propTypes: () => propTypes
});
module.exports = __toCommonJS(props_exports);
var import_prop_types = __toESM(__webpack_require__(13980));
const { string, bool, number, array, oneOfType, shape, object, func, node } = import_prop_types.default;
const propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  stopOnUnmount: bool,
  light: oneOfType([bool, string, object]),
  playIcon: node,
  previewTabIndex: number,
  fallback: node,
  oEmbedUrl: string,
  wrapper: oneOfType([
    string,
    func,
    shape({ render: func.isRequired })
  ]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      onUnstarted: func
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string,
      attributes: object
    }),
    dailymotion: shape({
      params: object
    }),
    vimeo: shape({
      playerOptions: object,
      title: string
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceSafariHLS: bool,
      forceDisableHls: bool,
      forceDASH: bool,
      forceFLV: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string,
      flvVersion: string
    }),
    wistia: shape({
      options: object,
      playerId: string,
      customControls: array
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    }),
    vidyard: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onPlaybackRateChange: func,
  onPlaybackQualityChange: func,
  onProgress: func,
  onClickPreview: func,
  onEnablePIP: func,
  onDisablePIP: func
};
const noop = () => {
};
const defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: false,
  pip: false,
  stopOnUnmount: true,
  light: false,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: noop
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": false
      }
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      forceFLV: false,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: false
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: noop,
  onStart: noop,
  onPlay: noop,
  onPause: noop,
  onBuffer: noop,
  onBufferEnd: noop,
  onEnded: noop,
  onError: noop,
  onDuration: noop,
  onSeek: noop,
  onPlaybackRateChange: noop,
  onPlaybackQualityChange: noop,
  onProgress: noop,
  onClickPreview: noop,
  onEnablePIP: noop,
  onDisablePIP: noop
};


/***/ }),

/***/ 77838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  callPlayer: () => callPlayer,
  getConfig: () => getConfig,
  getSDK: () => getSDK,
  isBlobUrl: () => isBlobUrl,
  isMediaStream: () => isMediaStream,
  lazy: () => lazy,
  omit: () => omit,
  parseEndTime: () => parseEndTime,
  parseStartTime: () => parseStartTime,
  queryString: () => queryString,
  randomString: () => randomString,
  supportsWebKitPresentationMode: () => supportsWebKitPresentationMode
});
module.exports = __toCommonJS(utils_exports);
var import_react = __toESM(__webpack_require__(2784));
var import_load_script = __toESM(__webpack_require__(9599));
var import_deepmerge = __toESM(__webpack_require__(39714));
const lazy = (componentImportFn) => import_react.default.lazy(async () => {
  const obj = await componentImportFn();
  return typeof obj.default === "function" ? obj : obj.default;
});
const MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
const MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
const MATCH_START_STAMP = /(\d+)(h|m|s)/g;
const MATCH_NUMERIC = /^\d+$/;
function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return void 0;
  }
  const match = url.match(pattern);
  if (match) {
    const stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }
  return void 0;
}
function parseTimeString(stamp) {
  let seconds = 0;
  let array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    const [, count, period] = array;
    if (period === "h")
      seconds += parseInt(count, 10) * 60 * 60;
    if (period === "m")
      seconds += parseInt(count, 10) * 60;
    if (period === "s")
      seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}
function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}
function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
}
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}
function queryString(object) {
  return Object.keys(object).map((key) => `${key}=${object[key]}`).join("&");
}
function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }
  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }
  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }
  return null;
}
const requests = {};
const getSDK = enableStubOn(function getSDK2(url, sdkGlobal, sdkReady = null, isLoaded = () => true, fetchScript = import_load_script.default) {
  const existingGlobal = getGlobal(sdkGlobal);
  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }
  return new Promise((resolve, reject) => {
    if (requests[url]) {
      requests[url].push({ resolve, reject });
      return;
    }
    requests[url] = [{ resolve, reject }];
    const onLoaded = (sdk) => {
      requests[url].forEach((request) => request.resolve(sdk));
    };
    if (sdkReady) {
      const previousOnReady = window[sdkReady];
      window[sdkReady] = function() {
        if (previousOnReady)
          previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }
    fetchScript(url, (err) => {
      if (err) {
        requests[url].forEach((request) => request.reject(err));
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
});
function getConfig(props, defaultProps) {
  return (0, import_deepmerge.default)(defaultProps.config, props.config);
}
function omit(object, ...arrays) {
  const omitKeys = [].concat(...arrays);
  const output = {};
  const keys = Object.keys(object);
  for (const key of keys) {
    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }
  return output;
}
function callPlayer(method, ...args) {
  if (!this.player || !this.player[method]) {
    let message = `ReactPlayer: ${this.constructor.displayName} player could not call %c${method}%c \u2013 `;
    if (!this.player) {
      message += "The player was not available";
    } else if (!this.player[method]) {
      message += "The method was not available";
    }
    console.warn(message, "font-weight: bold", "");
    return null;
  }
  return this.player[method](...args);
}
function isMediaStream(url) {
  return typeof window !== "undefined" && typeof window.MediaStream !== "undefined" && url instanceof window.MediaStream;
}
function isBlobUrl(url) {
  return /^blob:/.test(url);
}
function supportsWebKitPresentationMode(video = document.createElement("video")) {
  const notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === "function" && notMobile;
}
function enableStubOn(fn) {
  if (false) {}
  return fn;
}


/***/ }),

/***/ 51115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(22970);
var wrapInStatefulComponent_1 = tslib_1.__importDefault(__webpack_require__(88274));
var addClassDecoratorSupport = function (Comp) {
    var isSFC = !Comp.prototype;
    return !isSFC ? Comp : wrapInStatefulComponent_1.default(Comp);
};
exports["default"] = addClassDecoratorSupport;
//# sourceMappingURL=addClassDecoratorSupport.js.map

/***/ }),

/***/ 98478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.divWrapper = void 0;
var tslib_1 = __webpack_require__(22970);
var React = tslib_1.__importStar(__webpack_require__(2784));
var addClassDecoratorSupport_1 = tslib_1.__importDefault(__webpack_require__(51115));
var h = React.createElement;
var noWrap = function (Comp, propName, props, state) {
    var _a;
    return h(Comp, propName ? tslib_1.__assign((_a = {}, _a[propName] = state, _a), props) : tslib_1.__assign(tslib_1.__assign({}, state), props));
};
exports.divWrapper = function (Comp, propName, props, state) {
    return h('div', null, noWrap(Comp, propName, props, state));
};
var createEnhancer = function (Facc, prop, wrapper) {
    if (wrapper === void 0) { wrapper = noWrap; }
    var enhancer = function (Comp, propName, faccProps) {
        if (propName === void 0) { propName = prop; }
        if (faccProps === void 0) { faccProps = null; }
        var isClassDecoratorMethodCall = typeof Comp === 'string';
        if (isClassDecoratorMethodCall) {
            return function (Klass) { return enhancer(Klass, Comp || prop, propName); };
        }
        var Enhanced = function (props) {
            return h(Facc, faccProps, function (state) { return wrapper(Comp, propName, props, state); });
        };
        if (false) {}
        return isClassDecoratorMethodCall ? addClassDecoratorSupport_1.default(Enhanced) : Enhanced;
    };
    return enhancer;
};
exports["default"] = createEnhancer;
//# sourceMappingURL=createEnhancer.js.map

/***/ }),

/***/ 64289:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(22970);
var render_1 = tslib_1.__importDefault(__webpack_require__(8416));
var defaultMapPropsToArgs = function (props) { return [props]; };
var hookToRenderProp = function (hook, mapPropsToArgs) {
    if (mapPropsToArgs === void 0) { mapPropsToArgs = defaultMapPropsToArgs; }
    return function (props) { return render_1.default(props, hook.apply(void 0, mapPropsToArgs(props))); };
};
exports["default"] = hookToRenderProp;
//# sourceMappingURL=hookToRenderProp.js.map

/***/ }),

/***/ 61746:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var tslib_1 = __webpack_require__(22970);
var render_1 = tslib_1.__importDefault(__webpack_require__(8416));
__webpack_unused_export__ = render_1.default;
var createEnhancer_1 = tslib_1.__importDefault(__webpack_require__(98478));
__webpack_unused_export__ = createEnhancer_1.default;
var hookToRenderProp_1 = tslib_1.__importDefault(__webpack_require__(64289));
__webpack_unused_export__ = hookToRenderProp_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8416:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(22970);
var react_1 = __webpack_require__(2784);
var isReact16Plus = parseInt(react_1.version.substr(0, react_1.version.indexOf('.'))) > 15;
var isFn = function (fn) { return typeof fn === 'function'; };
var render = function (props, data) {
    var more = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        more[_i - 2] = arguments[_i];
    }
    if (false) { var children_1, render_1; }
    var render = props.render, _a = props.children, children = _a === void 0 ? render : _a, component = props.component, _b = props.comp, comp = _b === void 0 ? component : _b;
    if (isFn(children))
        return children.apply(void 0, tslib_1.__spreadArrays([data], more));
    if (comp) {
        return react_1.createElement(comp, data);
    }
    if (children instanceof Array)
        return isReact16Plus ? children : react_1.createElement.apply(void 0, tslib_1.__spreadArrays(['div', null], children));
    if (children && (children instanceof Object)) {
        if (false) {}
        else {
            if (typeof children.type === 'string')
                return children;
            return react_1.cloneElement(children, Object.assign({}, children.props, data));
        }
    }
    return children || null;
};
exports["default"] = render;
//# sourceMappingURL=render.js.map

/***/ }),

/***/ 88274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(22970);
var React = tslib_1.__importStar(__webpack_require__(2784));
var wrapInStatefulComponent = function (Comp) {
    var Decorated = (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return Comp(this.props, this.context);
        };
        return class_1;
    }(React.Component));
    if (false) {}
    return Decorated;
};
exports["default"] = wrapInStatefulComponent;
//# sourceMappingURL=wrapInStatefulComponent.js.map

/***/ }),

/***/ 88180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "createBreakpoint": function() { return /* reexport */ factory_createBreakpoint; },
  "createGlobalState": function() { return /* reexport */ createGlobalState; },
  "createMemo": function() { return /* reexport */ factory_createMemo; },
  "createReducer": function() { return /* reexport */ factory_createReducer; },
  "createReducerContext": function() { return /* reexport */ factory_createReducerContext; },
  "createStateContext": function() { return /* reexport */ factory_createStateContext; },
  "ensuredForwardRef": function() { return /* reexport */ ensuredForwardRef; },
  "useAsync": function() { return /* reexport */ useAsync; },
  "useAsyncFn": function() { return /* reexport */ useAsyncFn; },
  "useAsyncRetry": function() { return /* reexport */ esm_useAsyncRetry; },
  "useAudio": function() { return /* reexport */ esm_useAudio; },
  "useBattery": function() { return /* reexport */ esm_useBattery; },
  "useBeforeUnload": function() { return /* reexport */ esm_useBeforeUnload; },
  "useBoolean": function() { return /* reexport */ useBoolean; },
  "useClickAway": function() { return /* reexport */ esm_useClickAway; },
  "useCookie": function() { return /* reexport */ esm_useCookie; },
  "useCopyToClipboard": function() { return /* reexport */ esm_useCopyToClipboard; },
  "useCounter": function() { return /* reexport */ useCounter; },
  "useCss": function() { return /* reexport */ esm_useCss; },
  "useCustomCompareEffect": function() { return /* reexport */ esm_useCustomCompareEffect; },
  "useDebounce": function() { return /* reexport */ useDebounce; },
  "useDeepCompareEffect": function() { return /* reexport */ esm_useDeepCompareEffect; },
  "useDefault": function() { return /* reexport */ esm_useDefault; },
  "useDrop": function() { return /* reexport */ esm_useDrop; },
  "useDropArea": function() { return /* reexport */ esm_useDropArea; },
  "useEffectOnce": function() { return /* reexport */ esm_useEffectOnce; },
  "useEnsuredForwardedRef": function() { return /* reexport */ useEnsuredForwardedRef; },
  "useError": function() { return /* reexport */ esm_useError; },
  "useEvent": function() { return /* reexport */ esm_useEvent; },
  "useFavicon": function() { return /* reexport */ esm_useFavicon; },
  "useFirstMountState": function() { return /* reexport */ useFirstMountState; },
  "useFullscreen": function() { return /* reexport */ esm_useFullscreen; },
  "useGeolocation": function() { return /* reexport */ esm_useGeolocation; },
  "useGetSet": function() { return /* reexport */ useGetSet; },
  "useGetSetState": function() { return /* reexport */ esm_useGetSetState; },
  "useHarmonicIntervalFn": function() { return /* reexport */ esm_useHarmonicIntervalFn; },
  "useHash": function() { return /* reexport */ useHash; },
  "useHover": function() { return /* reexport */ esm_useHover; },
  "useHoverDirty": function() { return /* reexport */ esm_useHoverDirty; },
  "useIdle": function() { return /* reexport */ esm_useIdle; },
  "useIntersection": function() { return /* reexport */ esm_useIntersection; },
  "useInterval": function() { return /* reexport */ esm_useInterval; },
  "useIsomorphicLayoutEffect": function() { return /* reexport */ esm_useIsomorphicLayoutEffect; },
  "useKey": function() { return /* reexport */ esm_useKey; },
  "useKeyPress": function() { return /* reexport */ esm_useKeyPress; },
  "useKeyPressEvent": function() { return /* reexport */ esm_useKeyPressEvent; },
  "useLatest": function() { return /* reexport */ esm_useLatest; },
  "useLifecycles": function() { return /* reexport */ esm_useLifecycles; },
  "useList": function() { return /* reexport */ esm_useList; },
  "useLocalStorage": function() { return /* reexport */ esm_useLocalStorage; },
  "useLocation": function() { return /* reexport */ useLocation; },
  "useLockBodyScroll": function() { return /* reexport */ useLockBodyScroll; },
  "useLogger": function() { return /* reexport */ esm_useLogger; },
  "useLongPress": function() { return /* reexport */ esm_useLongPress; },
  "useMap": function() { return /* reexport */ esm_useMap; },
  "useMeasure": function() { return /* reexport */ esm_useMeasure; },
  "useMedia": function() { return /* reexport */ esm_useMedia; },
  "useMediaDevices": function() { return /* reexport */ esm_useMediaDevices; },
  "useMediatedState": function() { return /* reexport */ useMediatedState; },
  "useMethods": function() { return /* reexport */ esm_useMethods; },
  "useMotion": function() { return /* reexport */ esm_useMotion; },
  "useMount": function() { return /* reexport */ esm_useMount; },
  "useMountedState": function() { return /* reexport */ useMountedState; },
  "useMouse": function() { return /* reexport */ esm_useMouse; },
  "useMouseHovered": function() { return /* reexport */ esm_useMouseHovered; },
  "useMouseWheel": function() { return /* reexport */ useMouseWheel; },
  "useMultiStateValidator": function() { return /* reexport */ useMultiStateValidator; },
  "useNetworkState": function() { return /* reexport */ useNetworkState; },
  "useNumber": function() { return /* reexport */ useNumber; },
  "useObservable": function() { return /* reexport */ esm_useObservable; },
  "useOrientation": function() { return /* reexport */ esm_useOrientation; },
  "usePageLeave": function() { return /* reexport */ esm_usePageLeave; },
  "usePermission": function() { return /* reexport */ esm_usePermission; },
  "usePinchZoom": function() { return /* reexport */ esm_usePinchZoom; },
  "usePrevious": function() { return /* reexport */ usePrevious; },
  "usePreviousDistinct": function() { return /* reexport */ usePreviousDistinct; },
  "usePromise": function() { return /* reexport */ esm_usePromise; },
  "useQueue": function() { return /* reexport */ esm_useQueue; },
  "useRaf": function() { return /* reexport */ esm_useRaf; },
  "useRafLoop": function() { return /* reexport */ useRafLoop; },
  "useRafState": function() { return /* reexport */ esm_useRafState; },
  "useRendersCount": function() { return /* reexport */ useRendersCount; },
  "useScratch": function() { return /* reexport */ esm_useScratch; },
  "useScroll": function() { return /* reexport */ esm_useScroll; },
  "useScrollbarWidth": function() { return /* reexport */ useScrollbarWidth; },
  "useScrolling": function() { return /* reexport */ esm_useScrolling; },
  "useSearchParam": function() { return /* reexport */ esm_useSearchParam; },
  "useSessionStorage": function() { return /* reexport */ esm_useSessionStorage; },
  "useSet": function() { return /* reexport */ esm_useSet; },
  "useSetState": function() { return /* reexport */ esm_useSetState; },
  "useShallowCompareEffect": function() { return /* reexport */ esm_useShallowCompareEffect; },
  "useSize": function() { return /* reexport */ esm_useSize; },
  "useSlider": function() { return /* reexport */ esm_useSlider; },
  "useSpeech": function() { return /* reexport */ esm_useSpeech; },
  "useStartTyping": function() { return /* reexport */ esm_useStartTyping; },
  "useStateList": function() { return /* reexport */ useStateList; },
  "useStateValidator": function() { return /* reexport */ useStateValidator; },
  "useStateWithHistory": function() { return /* reexport */ useStateWithHistory; },
  "useThrottle": function() { return /* reexport */ esm_useThrottle; },
  "useThrottleFn": function() { return /* reexport */ esm_useThrottleFn; },
  "useTimeout": function() { return /* reexport */ useTimeout; },
  "useTimeoutFn": function() { return /* reexport */ useTimeoutFn; },
  "useTitle": function() { return /* reexport */ esm_useTitle; },
  "useToggle": function() { return /* reexport */ esm_useToggle; },
  "useTween": function() { return /* reexport */ esm_useTween; },
  "useUnmount": function() { return /* reexport */ esm_useUnmount; },
  "useUnmountPromise": function() { return /* reexport */ esm_useUnmountPromise; },
  "useUpdate": function() { return /* reexport */ useUpdate; },
  "useUpdateEffect": function() { return /* reexport */ esm_useUpdateEffect; },
  "useUpsert": function() { return /* reexport */ useUpsert; },
  "useVibrate": function() { return /* reexport */ esm_useVibrate; },
  "useVideo": function() { return /* reexport */ esm_useVideo; },
  "useWindowScroll": function() { return /* reexport */ esm_useWindowScroll; },
  "useWindowSize": function() { return /* reexport */ esm_useWindowSize; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createMemo.js

var createMemo = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,react.useMemo)(function () { return fn.apply(void 0, args); }, args);
    };
};
/* harmony default export */ var factory_createMemo = (createMemo);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createReducerContext.js

var createReducerContext = function (reducer, defaultInitialState) {
    var context = (0,react.createContext)(undefined);
    var providerFactory = function (props, children) { return (0,react.createElement)(context.Provider, props, children); };
    var ReducerProvider = function (_a) {
        var children = _a.children, initialState = _a.initialState;
        var state = (0,react.useReducer)(reducer, initialState !== undefined ? initialState : defaultInitialState);
        return providerFactory({ value: state }, children);
    };
    var useReducerContext = function () {
        var state = (0,react.useContext)(context);
        if (state == null) {
            throw new Error("useReducerContext must be used inside a ReducerProvider.");
        }
        return state;
    };
    return [useReducerContext, ReducerProvider, context];
};
/* harmony default export */ var factory_createReducerContext = (createReducerContext);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useFirstMountState.js

function useFirstMountState() {
    var isFirst = (0,react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUpdateEffect.js


var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    (0,react.useEffect)(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
/* harmony default export */ var esm_useUpdateEffect = (useUpdateEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createReducer.js


function composeMiddleware(chain) {
    return function (context, dispatch) {
        return chain.reduceRight(function (res, middleware) {
            return middleware(context)(res);
        }, dispatch);
    };
}
var createReducer = function () {
    var middlewares = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middlewares[_i] = arguments[_i];
    }
    var composedMiddleware = composeMiddleware(middlewares);
    return function (reducer, initialState, initializer) {
        if (initializer === void 0) { initializer = function (value) { return value; }; }
        var ref = (0,react.useRef)(initializer(initialState));
        var _a = (0,react.useState)(ref.current), setState = _a[1];
        var dispatch = (0,react.useCallback)(function (action) {
            ref.current = reducer(ref.current, action);
            setState(ref.current);
            return action;
        }, [reducer]);
        var dispatchRef = (0,react.useRef)(composedMiddleware({
            getState: function () { return ref.current; },
            dispatch: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return dispatchRef.current.apply(dispatchRef, args);
            },
        }, dispatch));
        esm_useUpdateEffect(function () {
            dispatchRef.current = composedMiddleware({
                getState: function () { return ref.current; },
                dispatch: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return dispatchRef.current.apply(dispatchRef, args);
                },
            }, dispatch);
        }, [dispatch]);
        return [ref.current, dispatchRef.current];
    };
};
/* harmony default export */ var factory_createReducer = (createReducer);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createStateContext.js

var createStateContext = function (defaultInitialValue) {
    var context = (0,react.createContext)(undefined);
    var providerFactory = function (props, children) { return (0,react.createElement)(context.Provider, props, children); };
    var StateProvider = function (_a) {
        var children = _a.children, initialValue = _a.initialValue;
        var state = (0,react.useState)(initialValue !== undefined ? initialValue : defaultInitialValue);
        return providerFactory({ value: state }, children);
    };
    var useStateContext = function () {
        var state = (0,react.useContext)(context);
        if (state == null) {
            throw new Error("useStateContext must be used inside a StateProvider.");
        }
        return state;
    };
    return [useStateContext, StateProvider, context];
};
/* harmony default export */ var factory_createStateContext = (createStateContext);

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMountedState.js

function useMountedState() {
    var mountedRef = (0,react.useRef)(false);
    var get = (0,react.useCallback)(function () { return mountedRef.current; }, []);
    (0,react.useEffect)(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return get;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useAsyncFn.js



function useAsyncFn(fn, deps, initialState) {
    if (deps === void 0) { deps = []; }
    if (initialState === void 0) { initialState = { loading: false }; }
    var lastCallId = (0,react.useRef)(0);
    var isMounted = useMountedState();
    var _a = (0,react.useState)(initialState), state = _a[0], set = _a[1];
    var callback = (0,react.useCallback)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callId = ++lastCallId.current;
        if (!state.loading) {
            set(function (prevState) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, prevState), { loading: true })); });
        }
        return fn.apply(void 0, args).then(function (value) {
            isMounted() && callId === lastCallId.current && set({ value: value, loading: false });
            return value;
        }, function (error) {
            isMounted() && callId === lastCallId.current && set({ error: error, loading: false });
            return error;
        });
    }, deps);
    return [state, callback];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useAsync.js


function useAsync(fn, deps) {
    if (deps === void 0) { deps = []; }
    var _a = useAsyncFn(fn, deps, {
        loading: true,
    }), state = _a[0], callback = _a[1];
    (0,react.useEffect)(function () {
        callback();
    }, [callback]);
    return state;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useAsyncRetry.js



var useAsyncRetry = function (fn, deps) {
    if (deps === void 0) { deps = []; }
    var _a = (0,react.useState)(0), attempt = _a[0], setAttempt = _a[1];
    var state = useAsync(fn, (0,tslib_es6.__spreadArrays)(deps, [attempt]));
    var stateLoading = state.loading;
    var retry = (0,react.useCallback)(function () {
        if (stateLoading) {
            if (false) {}
            return;
        }
        setAttempt(function (currentAttempt) { return currentAttempt + 1; });
    }, (0,tslib_es6.__spreadArrays)(deps, [stateLoading]));
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, state), { retry: retry });
};
/* harmony default export */ var esm_useAsyncRetry = (useAsyncRetry);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSetState.js

var useSetState = function (initialState) {
    if (initialState === void 0) { initialState = {}; }
    var _a = (0,react.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0,react.useCallback)(function (patch) {
        set(function (prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [state, setState];
};
/* harmony default export */ var esm_useSetState = (useSetState);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/misc/parseTimeRanges.js
function parseTimeRanges(ranges) {
    var result = [];
    for (var i = 0; i < ranges.length; i++) {
        result.push({
            start: ranges.start(i),
            end: ranges.end(i),
        });
    }
    return result;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createHTMLMediaHook.js





function createHTMLMediaHook(tag) {
    return function (elOrProps) {
        var element;
        var props;
        if (react.isValidElement(elOrProps)) {
            element = elOrProps;
            props = element.props;
        }
        else {
            props = elOrProps;
        }
        var _a = esm_useSetState({
            buffered: [],
            time: 0,
            duration: 0,
            paused: true,
            muted: false,
            volume: 1,
            playing: false,
        }), state = _a[0], setState = _a[1];
        var ref = (0,react.useRef)(null);
        var wrapEvent = function (userEvent, proxyEvent) {
            return function (event) {
                try {
                    proxyEvent && proxyEvent(event);
                }
                finally {
                    userEvent && userEvent(event);
                }
            };
        };
        var onPlay = function () { return setState({ paused: false }); };
        var onPlaying = function () { return setState({ playing: true }); };
        var onWaiting = function () { return setState({ playing: false }); };
        var onPause = function () { return setState({ paused: true, playing: false }); };
        var onVolumeChange = function () {
            var el = ref.current;
            if (!el) {
                return;
            }
            setState({
                muted: el.muted,
                volume: el.volume,
            });
        };
        var onDurationChange = function () {
            var el = ref.current;
            if (!el) {
                return;
            }
            var duration = el.duration, buffered = el.buffered;
            setState({
                duration: duration,
                buffered: parseTimeRanges(buffered),
            });
        };
        var onTimeUpdate = function () {
            var el = ref.current;
            if (!el) {
                return;
            }
            setState({ time: el.currentTime });
        };
        var onProgress = function () {
            var el = ref.current;
            if (!el) {
                return;
            }
            setState({ buffered: parseTimeRanges(el.buffered) });
        };
        if (element) {
            element = react.cloneElement(element, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ controls: false }, props), { ref: ref, onPlay: wrapEvent(props.onPlay, onPlay), onPlaying: wrapEvent(props.onPlaying, onPlaying), onWaiting: wrapEvent(props.onWaiting, onWaiting), onPause: wrapEvent(props.onPause, onPause), onVolumeChange: wrapEvent(props.onVolumeChange, onVolumeChange), onDurationChange: wrapEvent(props.onDurationChange, onDurationChange), onTimeUpdate: wrapEvent(props.onTimeUpdate, onTimeUpdate), onProgress: wrapEvent(props.onProgress, onProgress) }));
        }
        else {
            element = react.createElement(tag, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ controls: false }, props), { ref: ref, onPlay: wrapEvent(props.onPlay, onPlay), onPlaying: wrapEvent(props.onPlaying, onPlaying), onWaiting: wrapEvent(props.onWaiting, onWaiting), onPause: wrapEvent(props.onPause, onPause), onVolumeChange: wrapEvent(props.onVolumeChange, onVolumeChange), onDurationChange: wrapEvent(props.onDurationChange, onDurationChange), onTimeUpdate: wrapEvent(props.onTimeUpdate, onTimeUpdate), onProgress: wrapEvent(props.onProgress, onProgress) })); // TODO: fix this typing.
        }
        // Some browsers return `Promise` on `.play()` and may throw errors
        // if one tries to execute another `.play()` or `.pause()` while that
        // promise is resolving. So we prevent that with this lock.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=593273
        var lockPlay = false;
        var controls = {
            play: function () {
                var el = ref.current;
                if (!el) {
                    return undefined;
                }
                if (!lockPlay) {
                    var promise = el.play();
                    var isPromise = typeof promise === 'object';
                    if (isPromise) {
                        lockPlay = true;
                        var resetLock = function () {
                            lockPlay = false;
                        };
                        promise.then(resetLock, resetLock);
                    }
                    return promise;
                }
                return undefined;
            },
            pause: function () {
                var el = ref.current;
                if (el && !lockPlay) {
                    return el.pause();
                }
            },
            seek: function (time) {
                var el = ref.current;
                if (!el || state.duration === undefined) {
                    return;
                }
                time = Math.min(state.duration, Math.max(0, time));
                el.currentTime = time;
            },
            volume: function (volume) {
                var el = ref.current;
                if (!el) {
                    return;
                }
                volume = Math.min(1, Math.max(0, volume));
                el.volume = volume;
                setState({ volume: volume });
            },
            mute: function () {
                var el = ref.current;
                if (!el) {
                    return;
                }
                el.muted = true;
            },
            unmute: function () {
                var el = ref.current;
                if (!el) {
                    return;
                }
                el.muted = false;
            },
        };
        (0,react.useEffect)(function () {
            var el = ref.current;
            if (!el) {
                if (false) {}
                return;
            }
            setState({
                volume: el.volume,
                muted: el.muted,
                paused: el.paused,
            });
            // Start media, if autoPlay requested.
            if (props.autoPlay && el.paused) {
                controls.play();
            }
        }, [props.src]);
        return [element, state, controls, ref];
    };
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useAudio.js

var useAudio = createHTMLMediaHook('audio');
/* harmony default export */ var esm_useAudio = (useAudio);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/react.js
var fast_deep_equal_react = __webpack_require__(44082);
var fast_deep_equal_react_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal_react);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/misc/isDeepEqual.js

/* harmony default export */ var isDeepEqual = ((fast_deep_equal_react_default()));

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useBattery.js



var nav = isNavigator ? navigator : undefined;
var isBatteryApiSupported = nav && typeof nav.getBattery === 'function';
function useBatteryMock() {
    return { isSupported: false };
}
function useBattery() {
    var _a = (0,react.useState)({ isSupported: true, fetched: false }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var isMounted = true;
        var battery = null;
        var handleChange = function () {
            if (!isMounted || !battery) {
                return;
            }
            var newState = {
                isSupported: true,
                fetched: true,
                level: battery.level,
                charging: battery.charging,
                dischargingTime: battery.dischargingTime,
                chargingTime: battery.chargingTime,
            };
            !isDeepEqual(state, newState) && setState(newState);
        };
        nav.getBattery().then(function (bat) {
            if (!isMounted) {
                return;
            }
            battery = bat;
            on(battery, 'chargingchange', handleChange);
            on(battery, 'chargingtimechange', handleChange);
            on(battery, 'dischargingtimechange', handleChange);
            on(battery, 'levelchange', handleChange);
            handleChange();
        });
        return function () {
            isMounted = false;
            if (battery) {
                off(battery, 'chargingchange', handleChange);
                off(battery, 'chargingtimechange', handleChange);
                off(battery, 'dischargingtimechange', handleChange);
                off(battery, 'levelchange', handleChange);
            }
        };
    }, []);
    return state;
}
/* harmony default export */ var esm_useBattery = (isBatteryApiSupported ? useBattery : useBatteryMock);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useBeforeUnload.js


var useBeforeUnload = function (enabled, message) {
    if (enabled === void 0) { enabled = true; }
    var handler = (0,react.useCallback)(function (event) {
        var finalEnabled = typeof enabled === 'function' ? enabled() : true;
        if (!finalEnabled) {
            return;
        }
        event.preventDefault();
        if (message) {
            event.returnValue = message;
        }
        return message;
    }, [enabled, message]);
    (0,react.useEffect)(function () {
        if (!enabled) {
            return;
        }
        on(window, 'beforeunload', handler);
        return function () { return off(window, 'beforeunload', handler); };
    }, [enabled, handler]);
};
/* harmony default export */ var esm_useBeforeUnload = (useBeforeUnload);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useToggle.js

var toggleReducer = function (state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var useToggle = function (initialValue) {
    return (0,react.useReducer)(toggleReducer, initialValue);
};
/* harmony default export */ var esm_useToggle = (useToggle);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useBoolean.js

/* harmony default export */ var useBoolean = (esm_useToggle);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useClickAway.js


var defaultEvents = ['mousedown', 'touchstart'];
var useClickAway = function (ref, onClickAway, events) {
    if (events === void 0) { events = defaultEvents; }
    var savedCallback = (0,react.useRef)(onClickAway);
    (0,react.useEffect)(function () {
        savedCallback.current = onClickAway;
    }, [onClickAway]);
    (0,react.useEffect)(function () {
        var handler = function (event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var eventName = events_1[_i];
            on(document, eventName, handler);
        }
        return function () {
            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                var eventName = events_2[_i];
                off(document, eventName, handler);
            }
        };
    }, [events, ref]);
};
/* harmony default export */ var esm_useClickAway = (useClickAway);

// EXTERNAL MODULE: ../../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(52034);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useCookie.js


var useCookie = function (cookieName) {
    var _a = (0,react.useState)(function () { return js_cookie_default().get(cookieName) || null; }), value = _a[0], setValue = _a[1];
    var updateCookie = (0,react.useCallback)(function (newValue, options) {
        js_cookie_default().set(cookieName, newValue, options);
        setValue(newValue);
    }, [cookieName]);
    var deleteCookie = (0,react.useCallback)(function () {
        js_cookie_default().remove(cookieName);
        setValue(null);
    }, [cookieName]);
    return [value, updateCookie, deleteCookie];
};
/* harmony default export */ var esm_useCookie = (useCookie);

// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useCopyToClipboard.js




var useCopyToClipboard = function () {
    var isMounted = useMountedState();
    var _a = esm_useSetState({
        value: undefined,
        error: undefined,
        noUserInteraction: true,
    }), state = _a[0], setState = _a[1];
    var copyToClipboard = (0,react.useCallback)(function (value) {
        if (!isMounted()) {
            return;
        }
        var noUserInteraction;
        var normalizedValue;
        try {
            // only strings and numbers casted to strings can be copied to clipboard
            if (typeof value !== 'string' && typeof value !== 'number') {
                var error = new Error("Cannot copy typeof " + typeof value + " to clipboard, must be a string");
                if (false)
                    {}
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true,
                });
                return;
            }
            // empty strings are also considered invalid
            else if (value === '') {
                var error = new Error("Cannot copy empty string to clipboard.");
                if (false)
                    {}
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true,
                });
                return;
            }
            normalizedValue = value.toString();
            noUserInteraction = copy_to_clipboard_default()(normalizedValue);
            setState({
                value: normalizedValue,
                error: undefined,
                noUserInteraction: noUserInteraction,
            });
        }
        catch (error) {
            setState({
                value: normalizedValue,
                error: error,
                noUserInteraction: noUserInteraction,
            });
        }
    }, []);
    return [state, copyToClipboard];
};
/* harmony default export */ var esm_useCopyToClipboard = (useCopyToClipboard);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUpdate.js

var updateReducer = function (num) { return (num + 1) % 1000000; };
function useUpdate() {
    var _a = (0,react.useReducer)(updateReducer, 0), update = _a[1];
    return update;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/misc/hookState.js
function resolveHookState(nextState, currentState) {
    if (typeof nextState === 'function') {
        return nextState.length ? nextState(currentState) : nextState();
    }
    return nextState;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useGetSet.js



function useGetSet(initialState) {
    var state = (0,react.useRef)(resolveHookState(initialState));
    var update = useUpdate();
    return (0,react.useMemo)(function () { return [
        function () { return state.current; },
        function (newState) {
            state.current = resolveHookState(newState, state.current);
            update();
        },
    ]; }, []);
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useCounter.js



function useCounter(initialValue, max, min) {
    if (initialValue === void 0) { initialValue = 0; }
    if (max === void 0) { max = null; }
    if (min === void 0) { min = null; }
    var init = resolveHookState(initialValue);
    typeof init !== 'number' &&
        console.error('initialValue has to be a number, got ' + typeof initialValue);
    if (typeof min === 'number') {
        init = Math.max(init, min);
    }
    else if (min !== null) {
        console.error('min has to be a number, got ' + typeof min);
    }
    if (typeof max === 'number') {
        init = Math.min(init, max);
    }
    else if (max !== null) {
        console.error('max has to be a number, got ' + typeof max);
    }
    var _a = useGetSet(init), get = _a[0], setInternal = _a[1];
    return [
        get(),
        (0,react.useMemo)(function () {
            var set = function (newState) {
                var prevState = get();
                var rState = resolveHookState(newState, prevState);
                if (prevState !== rState) {
                    if (typeof min === 'number') {
                        rState = Math.max(rState, min);
                    }
                    if (typeof max === 'number') {
                        rState = Math.min(rState, max);
                    }
                    prevState !== rState && setInternal(rState);
                }
            };
            return {
                get: get,
                set: set,
                inc: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num + rDelta; });
                },
                dec: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num - rDelta; });
                },
                reset: function (value) {
                    if (value === void 0) { value = init; }
                    var rValue = resolveHookState(value, get());
                    if (typeof rValue !== 'number') {
                        console.error('value has to be a number or function returning a number, got ' + typeof rValue);
                    }
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    init = rValue;
                    set(rValue);
                },
            };
        }, [init, min, max]),
    ];
}

// EXTERNAL MODULE: ../../node_modules/nano-css/index.js
var nano_css = __webpack_require__(44699);
// EXTERNAL MODULE: ../../node_modules/nano-css/addon/cssom.js
var cssom = __webpack_require__(36088);
// EXTERNAL MODULE: ../../node_modules/nano-css/addon/vcssom.js
var vcssom = __webpack_require__(96047);
// EXTERNAL MODULE: ../../node_modules/nano-css/addon/vcssom/cssToTree.js
var cssToTree = __webpack_require__(10972);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useIsomorphicLayoutEffect.js


var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var esm_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useCss.js






var nano = (0,nano_css/* create */.U)();
(0,cssom/* addon */.I)(nano);
(0,vcssom/* addon */.I)(nano);
var counter = 0;
var useCss = function (css) {
    var className = (0,react.useMemo)(function () { return 'react-use-css-' + (counter++).toString(36); }, []);
    var sheet = (0,react.useMemo)(function () { return new nano.VSheet(); }, []);
    esm_useIsomorphicLayoutEffect(function () {
        var tree = {};
        (0,cssToTree/* cssToTree */.z)(tree, css, '.' + className, '');
        sheet.diff(tree);
        return function () {
            sheet.diff({});
        };
    });
    return className;
};
/* harmony default export */ var esm_useCss = (useCss);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useCustomCompareEffect.js

var isPrimitive = function (val) { return val !== Object(val); };
var useCustomCompareEffect = function (effect, deps, depsEqual) {
    if (false) {}
    var ref = (0,react.useRef)(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) {
        ref.current = deps;
    }
    (0,react.useEffect)(effect, ref.current);
};
/* harmony default export */ var esm_useCustomCompareEffect = (useCustomCompareEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useTimeoutFn.js

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react.useRef)(false);
    var timeout = (0,react.useRef)();
    var callback = (0,react.useRef)(fn);
    var isReady = (0,react.useCallback)(function () { return ready.current; }, []);
    var set = (0,react.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useDebounce.js


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = useTimeoutFn(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react.useEffect)(reset, deps);
    return [isReady, cancel];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useDeepCompareEffect.js


var useDeepCompareEffect_isPrimitive = function (val) { return val !== Object(val); };
var useDeepCompareEffect = function (effect, deps) {
    if (false) {}
    esm_useCustomCompareEffect(effect, deps, isDeepEqual);
};
/* harmony default export */ var esm_useDeepCompareEffect = (useDeepCompareEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useDefault.js

var useDefault = function (defaultValue, initialValue) {
    var _a = (0,react.useState)(initialValue), value = _a[0], setValue = _a[1];
    if (value === undefined || value === null) {
        return [defaultValue, setValue];
    }
    return [value, setValue];
};
/* harmony default export */ var esm_useDefault = (useDefault);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useDrop.js



var createProcess = function (options) { return function (dataTransfer, event) {
    var uri = dataTransfer.getData('text/uri-list');
    if (uri) {
        (options.onUri || noop)(uri, event);
        return;
    }
    if (dataTransfer.files && dataTransfer.files.length) {
        (options.onFiles || noop)(Array.from(dataTransfer.files), event);
        return;
    }
    if (event.clipboardData) {
        var text = event.clipboardData.getData('text');
        (options.onText || noop)(text, event);
        return;
    }
}; };
var useDrop = function (options, args) {
    if (options === void 0) { options = {}; }
    if (args === void 0) { args = []; }
    var onFiles = options.onFiles, onText = options.onText, onUri = options.onUri;
    var _a = (0,react.useState)(false), over = _a[0], setOverRaw = _a[1];
    var setOver = (0,react.useCallback)(setOverRaw, []);
    var process = (0,react.useMemo)(function () { return createProcess(options); }, [onFiles, onText, onUri]);
    (0,react.useEffect)(function () {
        var onDragOver = function (event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragEnter = function (event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragLeave = function () {
            setOver(false);
        };
        var onDragExit = function () {
            setOver(false);
        };
        var onDrop = function (event) {
            event.preventDefault();
            setOver(false);
            process(event.dataTransfer, event);
        };
        var onPaste = function (event) {
            process(event.clipboardData, event);
        };
        on(document, 'dragover', onDragOver);
        on(document, 'dragenter', onDragEnter);
        on(document, 'dragleave', onDragLeave);
        on(document, 'dragexit', onDragExit);
        on(document, 'drop', onDrop);
        if (onText) {
            on(document, 'paste', onPaste);
        }
        return function () {
            off(document, 'dragover', onDragOver);
            off(document, 'dragenter', onDragEnter);
            off(document, 'dragleave', onDragLeave);
            off(document, 'dragexit', onDragExit);
            off(document, 'drop', onDrop);
            off(document, 'paste', onPaste);
        };
    }, (0,tslib_es6.__spreadArrays)([process], args));
    return { over: over };
};
/* harmony default export */ var esm_useDrop = (useDrop);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useDropArea.js



/*
const defaultState: DropAreaState = {
  over: false,
};
*/
var useDropArea_createProcess = function (options, mounted) { return function (dataTransfer, event) {
    var uri = dataTransfer.getData('text/uri-list');
    if (uri) {
        (options.onUri || noop)(uri, event);
        return;
    }
    if (dataTransfer.files && dataTransfer.files.length) {
        (options.onFiles || noop)(Array.from(dataTransfer.files), event);
        return;
    }
    if (dataTransfer.items && dataTransfer.items.length) {
        dataTransfer.items[0].getAsString(function (text) {
            if (mounted) {
                (options.onText || noop)(text, event);
            }
        });
    }
}; };
var createBond = function (process, setOver) { return ({
    onDragOver: function (event) {
        event.preventDefault();
    },
    onDragEnter: function (event) {
        event.preventDefault();
        setOver(true);
    },
    onDragLeave: function () {
        setOver(false);
    },
    onDrop: function (event) {
        event.preventDefault();
        event.persist();
        setOver(false);
        process(event.dataTransfer, event);
    },
    onPaste: function (event) {
        event.persist();
        process(event.clipboardData, event);
    },
}); };
var useDropArea = function (options) {
    if (options === void 0) { options = {}; }
    var onFiles = options.onFiles, onText = options.onText, onUri = options.onUri;
    var isMounted = useMountedState();
    var _a = (0,react.useState)(false), over = _a[0], setOver = _a[1];
    var process = (0,react.useMemo)(function () { return useDropArea_createProcess(options, isMounted()); }, [onFiles, onText, onUri]);
    var bond = (0,react.useMemo)(function () { return createBond(process, setOver); }, [process, setOver]);
    return [bond, { over: over }];
};
/* harmony default export */ var esm_useDropArea = (useDropArea);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useEffectOnce.js

var useEffectOnce = function (effect) {
    (0,react.useEffect)(effect, []);
};
/* harmony default export */ var esm_useEffectOnce = (useEffectOnce);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useEnsuredForwardedRef.js

function useEnsuredForwardedRef(forwardedRef) {
    var ensuredRef = (0,react.useRef)(forwardedRef && forwardedRef.current);
    (0,react.useEffect)(function () {
        if (!forwardedRef) {
            return;
        }
        forwardedRef.current = ensuredRef.current;
    }, [forwardedRef]);
    return ensuredRef;
}
function ensuredForwardRef(Component) {
    return (0,react.forwardRef)(function (props, ref) {
        var ensuredRef = useEnsuredForwardedRef(ref);
        return Component(props, ensuredRef);
    });
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useEvent.js


var defaultTarget = isBrowser ? window : null;
var isListenerType1 = function (target) {
    return !!target.addEventListener;
};
var isListenerType2 = function (target) {
    return !!target.on;
};
var useEvent = function (name, handler, target, options) {
    if (target === void 0) { target = defaultTarget; }
    (0,react.useEffect)(function () {
        if (!handler) {
            return;
        }
        if (!target) {
            return;
        }
        if (isListenerType1(target)) {
            on(target, name, handler, options);
        }
        else if (isListenerType2(target)) {
            target.on(name, handler, options);
        }
        return function () {
            if (isListenerType1(target)) {
                off(target, name, handler, options);
            }
            else if (isListenerType2(target)) {
                target.off(name, handler, options);
            }
        };
    }, [name, handler, target, JSON.stringify(options)]);
};
/* harmony default export */ var esm_useEvent = (useEvent);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useError.js

var useError = function () {
    var _a = (0,react.useState)(null), error = _a[0], setError = _a[1];
    (0,react.useEffect)(function () {
        if (error) {
            throw error;
        }
    }, [error]);
    var dispatchError = (0,react.useCallback)(function (err) {
        setError(err);
    }, []);
    return dispatchError;
};
/* harmony default export */ var esm_useError = (useError);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useFavicon.js

var useFavicon = function (href) {
    (0,react.useEffect)(function () {
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = href;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, [href]);
};
/* harmony default export */ var esm_useFavicon = (useFavicon);

// EXTERNAL MODULE: ../../node_modules/screenfull/dist/screenfull.js
var screenfull = __webpack_require__(71301);
var screenfull_default = /*#__PURE__*/__webpack_require__.n(screenfull);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useFullscreen.js




var useFullscreen = function (ref, enabled, options) {
    if (options === void 0) { options = {}; }
    var video = options.video, _a = options.onClose, onClose = _a === void 0 ? noop : _a;
    var _b = (0,react.useState)(enabled), isFullscreen = _b[0], setIsFullscreen = _b[1];
    esm_useIsomorphicLayoutEffect(function () {
        if (!enabled) {
            return;
        }
        if (!ref.current) {
            return;
        }
        var onWebkitEndFullscreen = function () {
            if (video === null || video === void 0 ? void 0 : video.current) {
                off(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
            }
            onClose();
        };
        var onChange = function () {
            if ((screenfull_default()).isEnabled) {
                var isScreenfullFullscreen = (screenfull_default()).isFullscreen;
                setIsFullscreen(isScreenfullFullscreen);
                if (!isScreenfullFullscreen) {
                    onClose();
                }
            }
        };
        if ((screenfull_default()).isEnabled) {
            try {
                screenfull_default().request(ref.current);
                setIsFullscreen(true);
            }
            catch (error) {
                onClose(error);
                setIsFullscreen(false);
            }
            screenfull_default().on('change', onChange);
        }
        else if (video && video.current && video.current.webkitEnterFullscreen) {
            video.current.webkitEnterFullscreen();
            on(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
            setIsFullscreen(true);
        }
        else {
            onClose();
            setIsFullscreen(false);
        }
        return function () {
            setIsFullscreen(false);
            if ((screenfull_default()).isEnabled) {
                try {
                    screenfull_default().off('change', onChange);
                    screenfull_default().exit();
                }
                catch (_a) { }
            }
            else if (video && video.current && video.current.webkitExitFullscreen) {
                off(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
                video.current.webkitExitFullscreen();
            }
        };
    }, [enabled, video, ref]);
    return isFullscreen;
};
/* harmony default export */ var esm_useFullscreen = (useFullscreen);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useGeolocation.js


var useGeolocation = function (options) {
    var _a = (0,react.useState)({
        loading: true,
        accuracy: null,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        latitude: null,
        longitude: null,
        speed: null,
        timestamp: Date.now(),
    }), state = _a[0], setState = _a[1];
    var mounted = true;
    var watchId;
    var onEvent = function (event) {
        if (mounted) {
            setState({
                loading: false,
                accuracy: event.coords.accuracy,
                altitude: event.coords.altitude,
                altitudeAccuracy: event.coords.altitudeAccuracy,
                heading: event.coords.heading,
                latitude: event.coords.latitude,
                longitude: event.coords.longitude,
                speed: event.coords.speed,
                timestamp: event.timestamp,
            });
        }
    };
    var onEventError = function (error) {
        return mounted && setState(function (oldState) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, oldState), { loading: false, error: error })); });
    };
    (0,react.useEffect)(function () {
        navigator.geolocation.getCurrentPosition(onEvent, onEventError, options);
        watchId = navigator.geolocation.watchPosition(onEvent, onEventError, options);
        return function () {
            mounted = false;
            navigator.geolocation.clearWatch(watchId);
        };
    }, []);
    return state;
};
/* harmony default export */ var esm_useGeolocation = (useGeolocation);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useGetSetState.js



var useGetSetState = function (initialState) {
    if (initialState === void 0) { initialState = {}; }
    if (false) {}
    var update = useUpdate();
    var state = (0,react.useRef)((0,tslib_es6.__assign)({}, initialState));
    var get = (0,react.useCallback)(function () { return state.current; }, []);
    var set = (0,react.useCallback)(function (patch) {
        if (!patch) {
            return;
        }
        if (false) {}
        Object.assign(state.current, patch);
        update();
    }, []);
    return [get, set];
};
/* harmony default export */ var esm_useGetSetState = (useGetSetState);

;// CONCATENATED MODULE: ../../node_modules/set-harmonic-interval/lib/index.esm.js
var index_esm_counter = 0;
var buckets = {};
var setHarmonicInterval = function (fn, ms) {
    var _a;
    var id = index_esm_counter++;
    if (buckets[ms]) {
        buckets[ms].listeners[id] = fn;
    }
    else {
        var timer = setInterval(function () {
            var listeners = buckets[ms].listeners;
            var didThrow = false;
            var lastError;
            for (var _i = 0, _a = Object.values(listeners); _i < _a.length; _i++) {
                var listener = _a[_i];
                try {
                    listener();
                }
                catch (error) {
                    didThrow = true;
                    lastError = error;
                }
            }
            if (didThrow)
                throw lastError;
        }, ms);
        buckets[ms] = {
            ms: ms,
            timer: timer,
            listeners: (_a = {},
                _a[id] = fn,
                _a),
        };
    }
    return {
        bucket: buckets[ms],
        id: id,
    };
};
var clearHarmonicInterval = function (_a) {
    var bucket = _a.bucket, id = _a.id;
    delete bucket.listeners[id];
    var hasListeners = false;
    for (var listener in bucket.listeners) {
        hasListeners = true;
        break;
    }
    if (!hasListeners) {
        clearInterval(bucket.timer);
        delete buckets[bucket.ms];
    }
};



;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useHarmonicIntervalFn.js


var useHarmonicIntervalFn = function (fn, delay) {
    if (delay === void 0) { delay = 0; }
    var latestCallback = (0,react.useRef)(function () { });
    (0,react.useEffect)(function () {
        latestCallback.current = fn;
    });
    (0,react.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setHarmonicInterval(function () { return latestCallback.current(); }, delay);
            return function () { return clearHarmonicInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ var esm_useHarmonicIntervalFn = (useHarmonicIntervalFn);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useHover.js


var useState = react.useState;
var useHover = function (element) {
    var _a = useState(false), state = _a[0], setState = _a[1];
    var onMouseEnter = function (originalOnMouseEnter) { return function (event) {
        (originalOnMouseEnter || noop)(event);
        setState(true);
    }; };
    var onMouseLeave = function (originalOnMouseLeave) { return function (event) {
        (originalOnMouseLeave || noop)(event);
        setState(false);
    }; };
    if (typeof element === 'function') {
        element = element(state);
    }
    var el = react.cloneElement(element, {
        onMouseEnter: onMouseEnter(element.props.onMouseEnter),
        onMouseLeave: onMouseLeave(element.props.onMouseLeave),
    });
    return [el, state];
};
/* harmony default export */ var esm_useHover = (useHover);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useHoverDirty.js


// kudos: https://usehooks.com/
var useHoverDirty = function (ref, enabled) {
    if (enabled === void 0) { enabled = true; }
    if (false) {}
    var _a = (0,react.useState)(false), value = _a[0], setValue = _a[1];
    (0,react.useEffect)(function () {
        var onMouseOver = function () { return setValue(true); };
        var onMouseOut = function () { return setValue(false); };
        if (enabled && ref && ref.current) {
            on(ref.current, 'mouseover', onMouseOver);
            on(ref.current, 'mouseout', onMouseOut);
        }
        // fixes react-hooks/exhaustive-deps warning about stale ref elements
        var current = ref.current;
        return function () {
            if (enabled && current) {
                off(current, 'mouseover', onMouseOver);
                off(current, 'mouseout', onMouseOut);
            }
        };
    }, [enabled, ref]);
    return value;
};
/* harmony default export */ var esm_useHoverDirty = (useHoverDirty);

;// CONCATENATED MODULE: ../../node_modules/throttle-debounce/esm/index.js
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useIdle.js



var useIdle_defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];
var oneMinute = 60e3;
var useIdle = function (ms, initialState, events) {
    if (ms === void 0) { ms = oneMinute; }
    if (initialState === void 0) { initialState = false; }
    if (events === void 0) { events = useIdle_defaultEvents; }
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var timeout;
        var localState = state;
        var set = function (newState) {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        var onEvent = throttle(50, function () {
            if (localState) {
                set(false);
            }
            clearTimeout(timeout);
            timeout = setTimeout(function () { return set(true); }, ms);
        });
        var onVisibility = function () {
            if (!document.hidden) {
                onEvent();
            }
        };
        for (var i = 0; i < events.length; i++) {
            on(window, events[i], onEvent);
        }
        on(document, 'visibilitychange', onVisibility);
        timeout = setTimeout(function () { return set(true); }, ms);
        return function () {
            mounted = false;
            for (var i = 0; i < events.length; i++) {
                off(window, events[i], onEvent);
            }
            off(document, 'visibilitychange', onVisibility);
        };
    }, [ms, events]);
    return state;
};
/* harmony default export */ var esm_useIdle = (useIdle);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useIntersection.js

var useIntersection = function (ref, options) {
    var _a = (0,react.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ var esm_useIntersection = (useIntersection);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useInterval.js

var useInterval = function (callback, delay) {
    var savedCallback = (0,react.useRef)(function () { });
    (0,react.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ var esm_useInterval = (useInterval);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKey.js



var createKeyPredicate = function (keyFilter) {
    return typeof keyFilter === 'function'
        ? keyFilter
        : typeof keyFilter === 'string'
            ? function (event) { return event.key === keyFilter; }
            : keyFilter
                ? function () { return true; }
                : function () { return false; };
};
var useKey = function (key, fn, opts, deps) {
    if (fn === void 0) { fn = noop; }
    if (opts === void 0) { opts = {}; }
    if (deps === void 0) { deps = [key]; }
    var _a = opts.event, event = _a === void 0 ? 'keydown' : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0,react.useMemo)(function () {
        var predicate = createKeyPredicate(key);
        var handler = function (handlerEvent) {
            if (predicate(handlerEvent)) {
                return fn(handlerEvent);
            }
        };
        return handler;
    }, deps);
    esm_useEvent(event, useMemoHandler, target, options);
};
/* harmony default export */ var esm_useKey = (useKey);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createBreakpoint.js


var createBreakpoint = function (breakpoints) {
    if (breakpoints === void 0) { breakpoints = { laptopL: 1440, laptop: 1024, tablet: 768 }; }
    return function () {
        var _a = (0,react.useState)(isBrowser ? window.innerWidth : 0), screen = _a[0], setScreen = _a[1];
        (0,react.useEffect)(function () {
            var setSideScreen = function () {
                setScreen(window.innerWidth);
            };
            setSideScreen();
            on(window, 'resize', setSideScreen);
            return function () {
                off(window, 'resize', setSideScreen);
            };
        });
        var sortedBreakpoints = (0,react.useMemo)(function () { return Object.entries(breakpoints).sort(function (a, b) { return (a[1] >= b[1] ? 1 : -1); }); }, [breakpoints]);
        var result = sortedBreakpoints.reduce(function (acc, _a) {
            var name = _a[0], width = _a[1];
            if (screen >= width) {
                return name;
            }
            else {
                return acc;
            }
        }, sortedBreakpoints[0][0]);
        return result;
    };
};
/* harmony default export */ var factory_createBreakpoint = (createBreakpoint);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKeyPress.js


var useKeyPress = function (keyFilter) {
    var _a = (0,react.useState)([false, null]), state = _a[0], set = _a[1];
    esm_useKey(keyFilter, function (event) { return set([true, event]); }, { event: 'keydown' }, [state]);
    esm_useKey(keyFilter, function (event) { return set([false, event]); }, { event: 'keyup' }, [state]);
    return state;
};
/* harmony default export */ var esm_useKeyPress = (useKeyPress);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useKeyPressEvent.js


var useKeyPressEvent = function (key, keydown, keyup, useKeyPress) {
    if (useKeyPress === void 0) { useKeyPress = esm_useKeyPress; }
    var _a = useKeyPress(key), pressed = _a[0], event = _a[1];
    esm_useUpdateEffect(function () {
        if (!pressed && keyup) {
            keyup(event);
        }
        else if (pressed && keydown) {
            keydown(event);
        }
    }, [pressed]);
};
/* harmony default export */ var esm_useKeyPressEvent = (useKeyPressEvent);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLatest.js

var useLatest = function (value) {
    var ref = (0,react.useRef)(value);
    ref.current = value;
    return ref;
};
/* harmony default export */ var esm_useLatest = (useLatest);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLifecycles.js

var useLifecycles = function (mount, unmount) {
    (0,react.useEffect)(function () {
        if (mount) {
            mount();
        }
        return function () {
            if (unmount) {
                unmount();
            }
        };
    }, []);
};
/* harmony default export */ var esm_useLifecycles = (useLifecycles);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useList.js



function useList(initialList) {
    if (initialList === void 0) { initialList = []; }
    var list = (0,react.useRef)(resolveHookState(initialList));
    var update = useUpdate();
    var actions = (0,react.useMemo)(function () {
        var a = {
            set: function (newList) {
                list.current = resolveHookState(newList, list.current);
                update();
            },
            push: function () {
                var items = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    items[_i] = arguments[_i];
                }
                items.length && actions.set(function (curr) { return curr.concat(items); });
            },
            updateAt: function (index, item) {
                actions.set(function (curr) {
                    var arr = curr.slice();
                    arr[index] = item;
                    return arr;
                });
            },
            insertAt: function (index, item) {
                actions.set(function (curr) {
                    var arr = curr.slice();
                    index > arr.length ? (arr[index] = item) : arr.splice(index, 0, item);
                    return arr;
                });
            },
            update: function (predicate, newItem) {
                actions.set(function (curr) { return curr.map(function (item) { return (predicate(item, newItem) ? newItem : item); }); });
            },
            updateFirst: function (predicate, newItem) {
                var index = list.current.findIndex(function (item) { return predicate(item, newItem); });
                index >= 0 && actions.updateAt(index, newItem);
            },
            upsert: function (predicate, newItem) {
                var index = list.current.findIndex(function (item) { return predicate(item, newItem); });
                index >= 0 ? actions.updateAt(index, newItem) : actions.push(newItem);
            },
            sort: function (compareFn) {
                actions.set(function (curr) { return curr.slice().sort(compareFn); });
            },
            filter: function (callbackFn, thisArg) {
                actions.set(function (curr) { return curr.slice().filter(callbackFn, thisArg); });
            },
            removeAt: function (index) {
                actions.set(function (curr) {
                    var arr = curr.slice();
                    arr.splice(index, 1);
                    return arr;
                });
            },
            clear: function () {
                actions.set([]);
            },
            reset: function () {
                actions.set(resolveHookState(initialList).slice());
            },
        };
        /**
         * @deprecated Use removeAt method instead
         */
        a.remove = a.removeAt;
        return a;
    }, []);
    return [list.current, actions];
}
/* harmony default export */ var esm_useList = (useList);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLocalStorage.js


var useLocalStorage = function (key, initialValue, options) {
    if (!isBrowser) {
        return [initialValue, noop, noop];
    }
    if (!key) {
        throw new Error('useLocalStorage key may not be falsy');
    }
    var deserializer = options
        ? options.raw
            ? function (value) { return value; }
            : options.deserializer
        : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0,react.useRef)(function (key) {
        try {
            var serializer = options ? (options.raw ? String : options.serializer) : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) {
                return deserializer(localStorageValue);
            }
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react.useState)(function () { return initializer.current(key); }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useLayoutEffect)(function () { return setState(initializer.current(key)); }, [key]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0,react.useCallback)(function (valOrFunc) {
        try {
            var newState = typeof valOrFunc === 'function' ? valOrFunc(state) : valOrFunc;
            if (typeof newState === 'undefined')
                return;
            var value = void 0;
            if (options)
                if (options.raw)
                    if (typeof newState === 'string')
                        value = newState;
                    else
                        value = JSON.stringify(newState);
                else if (options.serializer)
                    value = options.serializer(newState);
                else
                    value = JSON.stringify(newState);
            else
                value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [key, setState]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0,react.useCallback)(function () {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw.
        }
    }, [key, setState]);
    return [state, set, remove];
};
/* harmony default export */ var esm_useLocalStorage = (useLocalStorage);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLocation.js


var patchHistoryMethod = function (method) {
    var history = window.history;
    var original = history[method];
    history[method] = function (state) {
        var result = original.apply(this, arguments);
        var event = new Event(method.toLowerCase());
        event.state = state;
        window.dispatchEvent(event);
        return result;
    };
};
if (isBrowser) {
    patchHistoryMethod('pushState');
    patchHistoryMethod('replaceState');
}
var useLocationServer = function () { return ({
    trigger: 'load',
    length: 1,
}); };
var buildState = function (trigger) {
    var _a = window.history, state = _a.state, length = _a.length;
    var _b = window.location, hash = _b.hash, host = _b.host, hostname = _b.hostname, href = _b.href, origin = _b.origin, pathname = _b.pathname, port = _b.port, protocol = _b.protocol, search = _b.search;
    return {
        trigger: trigger,
        state: state,
        length: length,
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: protocol,
        search: search,
    };
};
var useLocationBrowser = function () {
    var _a = (0,react.useState)(buildState('load')), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var onPopstate = function () { return setState(buildState('popstate')); };
        var onPushstate = function () { return setState(buildState('pushstate')); };
        var onReplacestate = function () { return setState(buildState('replacestate')); };
        on(window, 'popstate', onPopstate);
        on(window, 'pushstate', onPushstate);
        on(window, 'replacestate', onReplacestate);
        return function () {
            off(window, 'popstate', onPopstate);
            off(window, 'pushstate', onPushstate);
            off(window, 'replacestate', onReplacestate);
        };
    }, []);
    return state;
};
var hasEventConstructor = typeof Event === 'function';
/* harmony default export */ var useLocation = (isBrowser && hasEventConstructor ? useLocationBrowser : useLocationServer);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLockBodyScroll.js


function getClosestBody(el) {
    if (!el) {
        return null;
    }
    else if (el.tagName === 'BODY') {
        return el;
    }
    else if (el.tagName === 'IFRAME') {
        var document_1 = el.contentDocument;
        return document_1 ? document_1.body : null;
    }
    else if (!el.offsetParent) {
        return null;
    }
    return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
}
var isIosDevice = isBrowser &&
    window.navigator &&
    window.navigator.platform &&
    /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
var documentListenerAdded = false;
/* harmony default export */ var useLockBodyScroll = (!doc
    ? function useLockBodyMock(_locked, _elementRef) {
        if (_locked === void 0) { _locked = true; }
    }
    : function useLockBody(locked, elementRef) {
        if (locked === void 0) { locked = true; }
        var bodyRef = (0,react.useRef)(doc.body);
        elementRef = elementRef || bodyRef;
        var lock = function (body) {
            var bodyInfo = bodies.get(body);
            if (!bodyInfo) {
                bodies.set(body, { counter: 1, initialOverflow: body.style.overflow });
                if (isIosDevice) {
                    if (!documentListenerAdded) {
                        on(document, 'touchmove', preventDefault, { passive: false });
                        documentListenerAdded = true;
                    }
                }
                else {
                    body.style.overflow = 'hidden';
                }
            }
            else {
                bodies.set(body, {
                    counter: bodyInfo.counter + 1,
                    initialOverflow: bodyInfo.initialOverflow,
                });
            }
        };
        var unlock = function (body) {
            var bodyInfo = bodies.get(body);
            if (bodyInfo) {
                if (bodyInfo.counter === 1) {
                    bodies.delete(body);
                    if (isIosDevice) {
                        body.ontouchmove = null;
                        if (documentListenerAdded) {
                            off(document, 'touchmove', preventDefault);
                            documentListenerAdded = false;
                        }
                    }
                    else {
                        body.style.overflow = bodyInfo.initialOverflow;
                    }
                }
                else {
                    bodies.set(body, {
                        counter: bodyInfo.counter - 1,
                        initialOverflow: bodyInfo.initialOverflow,
                    });
                }
            }
        };
        (0,react.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            if (locked) {
                lock(body);
            }
            else {
                unlock(body);
            }
        }, [locked, elementRef.current]);
        // clean up, on un-mount
        (0,react.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            return function () {
                unlock(body);
            };
        }, []);
    });

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLogger.js



var useLogger = function (componentName) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    esm_useEffectOnce(function () {
        console.log.apply(console, (0,tslib_es6.__spreadArrays)([componentName + " mounted"], rest));
        return function () { return console.log(componentName + " unmounted"); };
    });
    esm_useUpdateEffect(function () {
        console.log.apply(console, (0,tslib_es6.__spreadArrays)([componentName + " updated"], rest));
    });
};
/* harmony default export */ var esm_useLogger = (useLogger);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useLongPress.js


var isTouchEvent = function (ev) {
    return 'touches' in ev;
};
var useLongPress_preventDefault = function (ev) {
    if (!isTouchEvent(ev))
        return;
    if (ev.touches.length < 2 && ev.preventDefault) {
        ev.preventDefault();
    }
};
var useLongPress = function (callback, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isPreventDefault, isPreventDefault = _c === void 0 ? true : _c, _d = _b.delay, delay = _d === void 0 ? 300 : _d;
    var timeout = (0,react.useRef)();
    var target = (0,react.useRef)();
    var start = (0,react.useCallback)(function (event) {
        // prevent ghost click on mobile devices
        if (isPreventDefault && event.target) {
            on(event.target, 'touchend', useLongPress_preventDefault, { passive: false });
            target.current = event.target;
        }
        timeout.current = setTimeout(function () { return callback(event); }, delay);
    }, [callback, delay, isPreventDefault]);
    var clear = (0,react.useCallback)(function () {
        // clearTimeout and removeEventListener
        timeout.current && clearTimeout(timeout.current);
        if (isPreventDefault && target.current) {
            off(target.current, 'touchend', useLongPress_preventDefault);
        }
    }, [isPreventDefault]);
    return {
        onMouseDown: function (e) { return start(e); },
        onTouchStart: function (e) { return start(e); },
        onMouseUp: clear,
        onMouseLeave: clear,
        onTouchEnd: clear,
    };
};
/* harmony default export */ var esm_useLongPress = (useLongPress);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMap.js


var useMap = function (initialMap) {
    if (initialMap === void 0) { initialMap = {}; }
    var _a = (0,react.useState)(initialMap), map = _a[0], set = _a[1];
    var stableActions = (0,react.useMemo)(function () { return ({
        set: function (key, entry) {
            set(function (prevMap) {
                var _a;
                return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, prevMap), (_a = {}, _a[key] = entry, _a)));
            });
        },
        setAll: function (newMap) {
            set(newMap);
        },
        remove: function (key) {
            set(function (prevMap) {
                var _a = prevMap, _b = key, omit = _a[_b], rest = (0,tslib_es6.__rest)(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return rest;
            });
        },
        reset: function () { return set(initialMap); },
    }); }, [set]);
    var utils = (0,tslib_es6.__assign)({ get: (0,react.useCallback)(function (key) { return map[key]; }, [map]) }, stableActions);
    return [map, utils];
};
/* harmony default export */ var esm_useMap = (useMap);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMedia.js


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (isBrowser) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia = function (query, defaultState) {
    var _a = (0,react.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addEventListener('change', onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ var esm_useMedia = (useMedia);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMediaDevices.js


var useMediaDevices = function () {
    var _a = (0,react.useState)({}), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var onChange = function () {
            navigator.mediaDevices
                .enumerateDevices()
                .then(function (devices) {
                if (mounted) {
                    setState({
                        devices: devices.map(function (_a) {
                            var deviceId = _a.deviceId, groupId = _a.groupId, kind = _a.kind, label = _a.label;
                            return ({
                                deviceId: deviceId,
                                groupId: groupId,
                                kind: kind,
                                label: label,
                            });
                        }),
                    });
                }
            })
                .catch(noop);
        };
        on(navigator.mediaDevices, 'devicechange', onChange);
        onChange();
        return function () {
            mounted = false;
            off(navigator.mediaDevices, 'devicechange', onChange);
        };
    }, []);
    return state;
};
var useMediaDevicesMock = function () { return ({}); };
/* harmony default export */ var esm_useMediaDevices = (isNavigator && !!navigator.mediaDevices ? useMediaDevices : useMediaDevicesMock);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMediatedState.js

function useMediatedState(mediator, initialState) {
    var mediatorFn = (0,react.useRef)(mediator);
    var _a = (0,react.useState)(initialState), state = _a[0], setMediatedState = _a[1];
    var setState = (0,react.useCallback)(function (newState) {
        if (mediatorFn.current.length === 2) {
            mediatorFn.current(newState, setMediatedState);
        }
        else {
            setMediatedState(mediatorFn.current(newState));
        }
    }, [state]);
    return [state, setState];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMethods.js

var useMethods = function (createMethods, initialState) {
    var reducer = (0,react.useMemo)(function () { return function (reducerState, action) {
        var _a;
        return (_a = createMethods(reducerState))[action.type].apply(_a, action.payload);
    }; }, [createMethods]);
    var _a = (0,react.useReducer)(reducer, initialState), state = _a[0], dispatch = _a[1];
    var wrappedMethods = (0,react.useMemo)(function () {
        var actionTypes = Object.keys(createMethods(initialState));
        return actionTypes.reduce(function (acc, type) {
            acc[type] = function () {
                var payload = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    payload[_i] = arguments[_i];
                }
                return dispatch({ type: type, payload: payload });
            };
            return acc;
        }, {});
    }, [createMethods, initialState]);
    return [state, wrappedMethods];
};
/* harmony default export */ var esm_useMethods = (useMethods);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMotion.js


var defaultState = {
    acceleration: {
        x: null,
        y: null,
        z: null,
    },
    accelerationIncludingGravity: {
        x: null,
        y: null,
        z: null,
    },
    rotationRate: {
        alpha: null,
        beta: null,
        gamma: null,
    },
    interval: 16,
};
var useMotion = function (initialState) {
    if (initialState === void 0) { initialState = defaultState; }
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var handler = function (event) {
            var acceleration = event.acceleration, accelerationIncludingGravity = event.accelerationIncludingGravity, rotationRate = event.rotationRate, interval = event.interval;
            setState({
                acceleration: {
                    x: acceleration.x,
                    y: acceleration.y,
                    z: acceleration.z,
                },
                accelerationIncludingGravity: {
                    x: accelerationIncludingGravity.x,
                    y: accelerationIncludingGravity.y,
                    z: accelerationIncludingGravity.z,
                },
                rotationRate: {
                    alpha: rotationRate.alpha,
                    beta: rotationRate.beta,
                    gamma: rotationRate.gamma,
                },
                interval: interval,
            });
        };
        on(window, 'devicemotion', handler);
        return function () {
            off(window, 'devicemotion', handler);
        };
    }, []);
    return state;
};
/* harmony default export */ var esm_useMotion = (useMotion);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMount.js

var useMount = function (fn) {
    esm_useEffectOnce(function () {
        fn();
    });
};
/* harmony default export */ var esm_useMount = (useMount);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUnmount.js


var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    esm_useEffectOnce(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ var esm_useUnmount = (useUnmount);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useRafState.js


var useRafState = function (initialState) {
    var frame = (0,react.useRef)(0);
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0,react.useCallback)(function (value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
            setState(value);
        });
    }, []);
    esm_useUnmount(function () {
        cancelAnimationFrame(frame.current);
    });
    return [state, setRafState];
};
/* harmony default export */ var esm_useRafState = (useRafState);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMouse.js



var useMouse = function (ref) {
    if (false) {}
    var _a = esm_useRafState({
        docX: 0,
        docY: 0,
        posX: 0,
        posY: 0,
        elX: 0,
        elY: 0,
        elH: 0,
        elW: 0,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var moveHandler = function (event) {
            if (ref && ref.current) {
                var _a = ref.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, elW = _a.width, elH = _a.height;
                var posX = left + window.pageXOffset;
                var posY = top_1 + window.pageYOffset;
                var elX = event.pageX - posX;
                var elY = event.pageY - posY;
                setState({
                    docX: event.pageX,
                    docY: event.pageY,
                    posX: posX,
                    posY: posY,
                    elX: elX,
                    elY: elY,
                    elH: elH,
                    elW: elW,
                });
            }
        };
        on(document, 'mousemove', moveHandler);
        return function () {
            off(document, 'mousemove', moveHandler);
        };
    }, [ref]);
    return state;
};
/* harmony default export */ var esm_useMouse = (useMouse);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMouseHovered.js


var nullRef = { current: null };
var useMouseHovered = function (ref, options) {
    if (options === void 0) { options = {}; }
    var whenHovered = !!options.whenHovered;
    var bound = !!options.bound;
    var isHovered = esm_useHoverDirty(ref, whenHovered);
    var state = esm_useMouse(whenHovered && !isHovered ? nullRef : ref);
    if (bound) {
        state.elX = Math.max(0, Math.min(state.elX, state.elW));
        state.elY = Math.max(0, Math.min(state.elY, state.elH));
    }
    return state;
};
/* harmony default export */ var esm_useMouseHovered = (useMouseHovered);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMouseWheel.js


/* harmony default export */ var useMouseWheel = (function () {
    var _a = (0,react.useState)(0), mouseWheelScrolled = _a[0], setMouseWheelScrolled = _a[1];
    (0,react.useEffect)(function () {
        var updateScroll = function (e) {
            setMouseWheelScrolled(e.deltaY + mouseWheelScrolled);
        };
        on(window, 'wheel', updateScroll, false);
        return function () { return off(window, 'wheel', updateScroll); };
    });
    return mouseWheelScrolled;
});

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useNetworkState.js


var useNetworkState_nav = isNavigator ? navigator : undefined;
var conn = useNetworkState_nav && (useNetworkState_nav.connection || useNetworkState_nav.mozConnection || useNetworkState_nav.webkitConnection);
function getConnectionState(previousState) {
    var online = useNetworkState_nav === null || useNetworkState_nav === void 0 ? void 0 : useNetworkState_nav.onLine;
    var previousOnline = previousState === null || previousState === void 0 ? void 0 : previousState.online;
    return {
        online: online,
        previous: previousOnline,
        since: online !== previousOnline ? new Date() : previousState === null || previousState === void 0 ? void 0 : previousState.since,
        downlink: conn === null || conn === void 0 ? void 0 : conn.downlink,
        downlinkMax: conn === null || conn === void 0 ? void 0 : conn.downlinkMax,
        effectiveType: conn === null || conn === void 0 ? void 0 : conn.effectiveType,
        rtt: conn === null || conn === void 0 ? void 0 : conn.rtt,
        saveData: conn === null || conn === void 0 ? void 0 : conn.saveData,
        type: conn === null || conn === void 0 ? void 0 : conn.type,
    };
}
function useNetworkState(initialState) {
    var _a = (0,react.useState)(initialState !== null && initialState !== void 0 ? initialState : getConnectionState), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var handleStateChange = function () {
            setState(getConnectionState);
        };
        on(window, 'online', handleStateChange, { passive: true });
        on(window, 'offline', handleStateChange, { passive: true });
        if (conn) {
            on(conn, 'change', handleStateChange, { passive: true });
        }
        return function () {
            off(window, 'online', handleStateChange);
            off(window, 'offline', handleStateChange);
            if (conn) {
                off(conn, 'change', handleStateChange);
            }
        };
    }, []);
    return state;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useNumber.js

/* harmony default export */ var useNumber = (useCounter);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useObservable.js


function useObservable(observable$, initialValue) {
    var _a = (0,react.useState)(initialValue), value = _a[0], update = _a[1];
    esm_useIsomorphicLayoutEffect(function () {
        var s = observable$.subscribe(update);
        return function () { return s.unsubscribe(); };
    }, [observable$]);
    return value;
}
/* harmony default export */ var esm_useObservable = (useObservable);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useOrientation.js


var useOrientation_defaultState = {
    angle: 0,
    type: 'landscape-primary',
};
var useOrientation = function (initialState) {
    if (initialState === void 0) { initialState = useOrientation_defaultState; }
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var screen = window.screen;
        var mounted = true;
        var onChange = function () {
            if (mounted) {
                var orientation_1 = screen.orientation;
                if (orientation_1) {
                    var angle = orientation_1.angle, type = orientation_1.type;
                    setState({ angle: angle, type: type });
                }
                else if (window.orientation !== undefined) {
                    setState({
                        angle: typeof window.orientation === 'number' ? window.orientation : 0,
                        type: '',
                    });
                }
                else {
                    setState(initialState);
                }
            }
        };
        on(window, 'orientationchange', onChange);
        onChange();
        return function () {
            mounted = false;
            off(window, 'orientationchange', onChange);
        };
    }, []);
    return state;
};
/* harmony default export */ var esm_useOrientation = (useOrientation);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePageLeave.js


var usePageLeave = function (onPageLeave, args) {
    if (args === void 0) { args = []; }
    (0,react.useEffect)(function () {
        if (!onPageLeave) {
            return;
        }
        var handler = function (event) {
            event = event ? event : window.event;
            var from = event.relatedTarget || event.toElement;
            if (!from || from.nodeName === 'HTML') {
                onPageLeave();
            }
        };
        on(document, 'mouseout', handler);
        return function () {
            off(document, 'mouseout', handler);
        };
    }, args);
};
/* harmony default export */ var esm_usePageLeave = (usePageLeave);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePermission.js


// const usePermission = <T extends PermissionDescriptor>(permissionDesc: T): IState => {
var usePermission = function (permissionDesc) {
    var _a = (0,react.useState)(''), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var permissionStatus = null;
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(function () { var _a; return (_a = permissionStatus === null || permissionStatus === void 0 ? void 0 : permissionStatus.state) !== null && _a !== void 0 ? _a : ''; });
        };
        navigator.permissions
            .query(permissionDesc)
            .then(function (status) {
            permissionStatus = status;
            on(permissionStatus, 'change', onChange);
            onChange();
        })
            .catch(noop);
        return function () {
            permissionStatus && off(permissionStatus, 'change', onChange);
            mounted = false;
            permissionStatus = null;
        };
    }, [permissionDesc]);
    return state;
};
/* harmony default export */ var esm_usePermission = (usePermission);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePrevious.js

function usePrevious(state) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function () {
        ref.current = state;
    });
    return ref.current;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePreviousDistinct.js


var strictEquals = function (prev, next) { return prev === next; };
function usePreviousDistinct(value, compare) {
    if (compare === void 0) { compare = strictEquals; }
    var prevRef = (0,react.useRef)();
    var curRef = (0,react.useRef)(value);
    var isFirstMount = useFirstMountState();
    if (!isFirstMount && !compare(curRef.current, value)) {
        prevRef.current = curRef.current;
        curRef.current = value;
    }
    return prevRef.current;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePromise.js


var usePromise = function () {
    var isMounted = useMountedState();
    return (0,react.useCallback)(function (promise) {
        return new Promise(function (resolve, reject) {
            var onValue = function (value) {
                isMounted() && resolve(value);
            };
            var onError = function (error) {
                isMounted() && reject(error);
            };
            promise.then(onValue, onError);
        });
    }, []);
};
/* harmony default export */ var esm_usePromise = (usePromise);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useQueue.js


var useQueue = function (initialValue) {
    if (initialValue === void 0) { initialValue = []; }
    var _a = (0,react.useState)(initialValue), state = _a[0], set = _a[1];
    return {
        add: function (value) {
            set(function (queue) { return (0,tslib_es6.__spreadArrays)(queue, [value]); });
        },
        remove: function () {
            var result;
            set(function (_a) {
                var first = _a[0], rest = _a.slice(1);
                result = first;
                return rest;
            });
            return result;
        },
        get first() {
            return state[0];
        },
        get last() {
            return state[state.length - 1];
        },
        get size() {
            return state.length;
        },
    };
};
/* harmony default export */ var esm_useQueue = (useQueue);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useRaf.js


var useRaf = function (ms, delay) {
    if (ms === void 0) { ms = 1e12; }
    if (delay === void 0) { delay = 0; }
    var _a = (0,react.useState)(0), elapsed = _a[0], set = _a[1];
    esm_useIsomorphicLayoutEffect(function () {
        var raf;
        var timerStop;
        var start;
        var onFrame = function () {
            var time = Math.min(1, (Date.now() - start) / ms);
            set(time);
            loop();
        };
        var loop = function () {
            raf = requestAnimationFrame(onFrame);
        };
        var onStart = function () {
            timerStop = setTimeout(function () {
                cancelAnimationFrame(raf);
                set(1);
            }, ms);
            start = Date.now();
            loop();
        };
        var timerDelay = setTimeout(onStart, delay);
        return function () {
            clearTimeout(timerStop);
            clearTimeout(timerDelay);
            cancelAnimationFrame(raf);
        };
    }, [ms, delay]);
    return elapsed;
};
/* harmony default export */ var esm_useRaf = (useRaf);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useRafLoop.js

function useRafLoop(callback, initiallyActive) {
    if (initiallyActive === void 0) { initiallyActive = true; }
    var raf = (0,react.useRef)(null);
    var rafActivity = (0,react.useRef)(false);
    var rafCallback = (0,react.useRef)(callback);
    rafCallback.current = callback;
    var step = (0,react.useCallback)(function (time) {
        if (rafActivity.current) {
            rafCallback.current(time);
            raf.current = requestAnimationFrame(step);
        }
    }, []);
    var result = (0,react.useMemo)(function () {
        return [
            function () {
                // stop
                if (rafActivity.current) {
                    rafActivity.current = false;
                    raf.current && cancelAnimationFrame(raf.current);
                }
            },
            function () {
                // start
                if (!rafActivity.current) {
                    rafActivity.current = true;
                    raf.current = requestAnimationFrame(step);
                }
            },
            function () { return rafActivity.current; },
        ];
    }, []);
    (0,react.useEffect)(function () {
        if (initiallyActive) {
            result[1]();
        }
        return result[0];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return result;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSearchParam.js


var getValue = function (search, param) { return new URLSearchParams(search).get(param); };
var useSearchParam = function (param) {
    var location = window.location;
    var _a = (0,react.useState)(function () { return getValue(location.search, param); }), value = _a[0], setValue = _a[1];
    (0,react.useEffect)(function () {
        var onChange = function () {
            setValue(getValue(location.search, param));
        };
        on(window, 'popstate', onChange);
        on(window, 'pushstate', onChange);
        on(window, 'replacestate', onChange);
        return function () {
            off(window, 'popstate', onChange);
            off(window, 'pushstate', onChange);
            off(window, 'replacestate', onChange);
        };
    }, []);
    return value;
};
var useSearchParamServer = function () { return null; };
/* harmony default export */ var esm_useSearchParam = (isBrowser ? useSearchParam : useSearchParamServer);

// EXTERNAL MODULE: ../../node_modules/react-universal-interface/lib/index.js
var lib = __webpack_require__(61746);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useScratch.js





var useScratch = function (params) {
    if (params === void 0) { params = {}; }
    var disabled = params.disabled;
    var paramsRef = esm_useLatest(params);
    var _a = (0,react.useState)({ isScratching: false }), state = _a[0], setState = _a[1];
    var refState = (0,react.useRef)(state);
    var refScratching = (0,react.useRef)(false);
    var refAnimationFrame = (0,react.useRef)(null);
    var _b = (0,react.useState)(null), el = _b[0], setEl = _b[1];
    (0,react.useEffect)(function () {
        if (disabled)
            return;
        if (!el)
            return;
        var onMoveEvent = function (docX, docY) {
            cancelAnimationFrame(refAnimationFrame.current);
            refAnimationFrame.current = requestAnimationFrame(function () {
                var _a = el.getBoundingClientRect(), left = _a.left, top = _a.top;
                var elX = left + window.scrollX;
                var elY = top + window.scrollY;
                var x = docX - elX;
                var y = docY - elY;
                setState(function (oldState) {
                    var newState = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, oldState), { dx: x - (oldState.x || 0), dy: y - (oldState.y || 0), end: Date.now(), isScratching: true });
                    refState.current = newState;
                    (paramsRef.current.onScratch || noop)(newState);
                    return newState;
                });
            });
        };
        var onMouseMove = function (event) {
            onMoveEvent(event.pageX, event.pageY);
        };
        var onTouchMove = function (event) {
            onMoveEvent(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
        };
        var onMouseUp;
        var onTouchEnd;
        var stopScratching = function () {
            if (!refScratching.current)
                return;
            refScratching.current = false;
            refState.current = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, refState.current), { isScratching: false });
            (paramsRef.current.onScratchEnd || noop)(refState.current);
            setState({ isScratching: false });
            off(window, 'mousemove', onMouseMove);
            off(window, 'touchmove', onTouchMove);
            off(window, 'mouseup', onMouseUp);
            off(window, 'touchend', onTouchEnd);
        };
        onMouseUp = stopScratching;
        onTouchEnd = stopScratching;
        var startScratching = function (docX, docY) {
            if (!refScratching.current)
                return;
            var _a = el.getBoundingClientRect(), left = _a.left, top = _a.top;
            var elX = left + window.scrollX;
            var elY = top + window.scrollY;
            var x = docX - elX;
            var y = docY - elY;
            var time = Date.now();
            var newState = {
                isScratching: true,
                start: time,
                end: time,
                docX: docX,
                docY: docY,
                x: x,
                y: y,
                dx: 0,
                dy: 0,
                elH: el.offsetHeight,
                elW: el.offsetWidth,
                elX: elX,
                elY: elY,
            };
            refState.current = newState;
            (paramsRef.current.onScratchStart || noop)(newState);
            setState(newState);
            on(window, 'mousemove', onMouseMove);
            on(window, 'touchmove', onTouchMove);
            on(window, 'mouseup', onMouseUp);
            on(window, 'touchend', onTouchEnd);
        };
        var onMouseDown = function (event) {
            refScratching.current = true;
            startScratching(event.pageX, event.pageY);
        };
        var onTouchStart = function (event) {
            refScratching.current = true;
            startScratching(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
        };
        on(el, 'mousedown', onMouseDown);
        on(el, 'touchstart', onTouchStart);
        return function () {
            off(el, 'mousedown', onMouseDown);
            off(el, 'touchstart', onTouchStart);
            off(window, 'mousemove', onMouseMove);
            off(window, 'touchmove', onTouchMove);
            off(window, 'mouseup', onMouseUp);
            off(window, 'touchend', onTouchEnd);
            if (refAnimationFrame.current)
                cancelAnimationFrame(refAnimationFrame.current);
            refAnimationFrame.current = null;
            refScratching.current = false;
            refState.current = { isScratching: false };
            setState(refState.current);
        };
    }, [el, disabled, paramsRef]);
    return [setEl, state];
};
var ScratchSensor = function (props) {
    var children = props.children, params = __rest(props, ["children"]);
    var _a = useScratch(params), ref = _a[0], state = _a[1];
    var element = render(props, state);
    return cloneElement(element, __assign(__assign({}, element.props), { ref: function (el) {
            if (element.props.ref) {
                if (typeof element.props.ref === 'object')
                    element.props.ref.current = el;
                if (typeof element.props.ref === 'function')
                    element.props.ref(el);
            }
            ref(el);
        } }));
};
/* harmony default export */ var esm_useScratch = (useScratch);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useScroll.js



var useScroll = function (ref) {
    if (false) {}
    var _a = esm_useRafState({
        x: 0,
        y: 0,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var handler = function () {
            if (ref.current) {
                setState({
                    x: ref.current.scrollLeft,
                    y: ref.current.scrollTop,
                });
            }
        };
        if (ref.current) {
            on(ref.current, 'scroll', handler, {
                capture: false,
                passive: true,
            });
        }
        return function () {
            if (ref.current) {
                off(ref.current, 'scroll', handler);
            }
        };
    }, [ref]);
    return state;
};
/* harmony default export */ var esm_useScroll = (useScroll);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useScrolling.js


var useScrolling = function (ref) {
    var _a = (0,react.useState)(false), scrolling = _a[0], setScrolling = _a[1];
    (0,react.useEffect)(function () {
        if (ref.current) {
            var scrollingTimeout_1;
            var handleScrollEnd_1 = function () {
                setScrolling(false);
            };
            var handleScroll_1 = function () {
                setScrolling(true);
                clearTimeout(scrollingTimeout_1);
                scrollingTimeout_1 = setTimeout(function () { return handleScrollEnd_1(); }, 150);
            };
            on(ref.current, 'scroll', handleScroll_1, false);
            return function () {
                if (ref.current) {
                    off(ref.current, 'scroll', handleScroll_1, false);
                }
            };
        }
        return function () { };
    }, [ref]);
    return scrolling;
};
/* harmony default export */ var esm_useScrolling = (useScrolling);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSessionStorage.js


var useSessionStorage = function (key, initialValue, raw) {
    if (!isBrowser) {
        return [initialValue, function () { }];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react.useState)(function () {
        try {
            var sessionStorageValue = sessionStorage.getItem(key);
            if (typeof sessionStorageValue !== 'string') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            }
            else {
                return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function () {
        try {
            var serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. Also JSON.stringify can throw.
        }
    });
    return [state, setState];
};
/* harmony default export */ var esm_useSessionStorage = (useSessionStorage);

// EXTERNAL MODULE: ../../node_modules/fast-shallow-equal/index.js
var fast_shallow_equal = __webpack_require__(34235);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useShallowCompareEffect.js


var useShallowCompareEffect_isPrimitive = function (val) { return val !== Object(val); };
var shallowEqualDepsList = function (prevDeps, nextDeps) {
    return prevDeps.every(function (dep, index) { return (0,fast_shallow_equal/* equal */.D)(dep, nextDeps[index]); });
};
var useShallowCompareEffect = function (effect, deps) {
    if (false) {}
    esm_useCustomCompareEffect(effect, deps, shallowEqualDepsList);
};
/* harmony default export */ var esm_useShallowCompareEffect = (useShallowCompareEffect);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSize.js



var useSize_useState = react.useState, useEffect = react.useEffect, useRef = react.useRef;
var DRAF = function (callback) { return setTimeout(callback, 35); };
var useSize = function (element, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.width, width = _c === void 0 ? Infinity : _c, _d = _b.height, height = _d === void 0 ? Infinity : _d;
    if (!isBrowser) {
        return [
            typeof element === 'function' ? element({ width: width, height: height }) : element,
            { width: width, height: height },
        ];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _e = useSize_useState({ width: width, height: height }), state = _e[0], setState = _e[1];
    if (typeof element === 'function') {
        element = element(state);
    }
    var style = element.props.style || {};
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var ref = useRef(null);
    var window = null;
    var setSize = function () {
        var iframe = ref.current;
        var size = iframe
            ? {
                width: iframe.offsetWidth,
                height: iframe.offsetHeight,
            }
            : { width: width, height: height };
        setState(size);
    };
    var onWindow = function (windowToListenOn) {
        on(windowToListenOn, 'resize', setSize);
        DRAF(setSize);
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
        var iframe = ref.current;
        if (!iframe) {
            // iframe will be undefined if component is already unmounted
            return;
        }
        if (iframe.contentWindow) {
            window = iframe.contentWindow;
            onWindow(window);
        }
        else {
            var onLoad_1 = function () {
                on(iframe, 'load', onLoad_1);
                window = iframe.contentWindow;
                onWindow(window);
            };
            off(iframe, 'load', onLoad_1);
        }
        return function () {
            if (window && window.removeEventListener) {
                off(window, 'resize', setSize);
            }
        };
    }, []);
    style.position = 'relative';
    var sized = react.cloneElement.apply(react_namespaceObject, (0,tslib_es6.__spreadArrays)([element, { style: style }], (0,tslib_es6.__spreadArrays)([
        react.createElement('iframe', {
            ref: ref,
            style: {
                background: 'transparent',
                border: 'none',
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                zIndex: -1,
            },
        })
    ], react.Children.toArray(element.props.children))));
    return [sized, state];
};
/* harmony default export */ var esm_useSize = (useSize);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSlider.js




var useSlider = function (ref, options) {
    if (options === void 0) { options = {}; }
    var isMounted = useMountedState();
    var isSliding = (0,react.useRef)(false);
    var valueRef = (0,react.useRef)(0);
    var frame = (0,react.useRef)(0);
    var _a = esm_useSetState({
        isSliding: false,
        value: 0,
    }), state = _a[0], setState = _a[1];
    valueRef.current = state.value;
    (0,react.useEffect)(function () {
        if (isBrowser) {
            var styles = options.styles === undefined ? true : options.styles;
            var reverse_1 = options.reverse === undefined ? false : options.reverse;
            if (ref.current && styles) {
                ref.current.style.userSelect = 'none';
            }
            var startScrubbing_1 = function () {
                if (!isSliding.current && isMounted()) {
                    (options.onScrubStart || noop)();
                    isSliding.current = true;
                    setState({ isSliding: true });
                    bindEvents_1();
                }
            };
            var stopScrubbing_1 = function () {
                if (isSliding.current && isMounted()) {
                    (options.onScrubStop || noop)(valueRef.current);
                    isSliding.current = false;
                    setState({ isSliding: false });
                    unbindEvents_1();
                }
            };
            var onMouseDown_1 = function (event) {
                startScrubbing_1();
                onMouseMove_1(event);
            };
            var onMouseMove_1 = options.vertical
                ? function (event) { return onScrub_1(event.clientY); }
                : function (event) { return onScrub_1(event.clientX); };
            var onTouchStart_1 = function (event) {
                startScrubbing_1();
                onTouchMove_1(event);
            };
            var onTouchMove_1 = options.vertical
                ? function (event) { return onScrub_1(event.changedTouches[0].clientY); }
                : function (event) { return onScrub_1(event.changedTouches[0].clientX); };
            var bindEvents_1 = function () {
                on(document, 'mousemove', onMouseMove_1);
                on(document, 'mouseup', stopScrubbing_1);
                on(document, 'touchmove', onTouchMove_1);
                on(document, 'touchend', stopScrubbing_1);
            };
            var unbindEvents_1 = function () {
                off(document, 'mousemove', onMouseMove_1);
                off(document, 'mouseup', stopScrubbing_1);
                off(document, 'touchmove', onTouchMove_1);
                off(document, 'touchend', stopScrubbing_1);
            };
            var onScrub_1 = function (clientXY) {
                cancelAnimationFrame(frame.current);
                frame.current = requestAnimationFrame(function () {
                    if (isMounted() && ref.current) {
                        var rect = ref.current.getBoundingClientRect();
                        var pos = options.vertical ? rect.top : rect.left;
                        var length_1 = options.vertical ? rect.height : rect.width;
                        // Prevent returning 0 when element is hidden by CSS
                        if (!length_1) {
                            return;
                        }
                        var value = (clientXY - pos) / length_1;
                        if (value > 1) {
                            value = 1;
                        }
                        else if (value < 0) {
                            value = 0;
                        }
                        if (reverse_1) {
                            value = 1 - value;
                        }
                        setState({
                            value: value,
                        });
                        (options.onScrub || noop)(value);
                    }
                });
            };
            on(ref.current, 'mousedown', onMouseDown_1);
            on(ref.current, 'touchstart', onTouchStart_1);
            return function () {
                off(ref.current, 'mousedown', onMouseDown_1);
                off(ref.current, 'touchstart', onTouchStart_1);
            };
        }
        else {
            return undefined;
        }
    }, [ref, options.vertical]);
    return state;
};
/* harmony default export */ var esm_useSlider = (useSlider);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSpeech.js


var Status;
(function (Status) {
    Status[Status["init"] = 0] = "init";
    Status[Status["play"] = 1] = "play";
    Status[Status["pause"] = 2] = "pause";
    Status[Status["end"] = 3] = "end";
})(Status || (Status = {}));
var useSpeech = function (text, options) {
    var mounted = (0,react.useRef)(false);
    var _a = (0,react.useState)(function () {
        var _a = options.voice || {}, _b = _a.lang, lang = _b === void 0 ? 'default' : _b, _c = _a.name, name = _c === void 0 ? '' : _c;
        return {
            isPlaying: false,
            status: Status[Status.init],
            lang: options.lang || 'default',
            voiceInfo: { lang: lang, name: name },
            rate: options.rate || 1,
            pitch: options.pitch || 1,
            volume: options.volume || 1,
        };
    }), state = _a[0], setState = _a[1];
    var handlePlay = (0,react.useCallback)(function () {
        if (!mounted.current) {
            return;
        }
        setState(function (preState) {
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, preState), { isPlaying: true, status: Status[Status.play] });
        });
    }, []);
    var handlePause = (0,react.useCallback)(function () {
        if (!mounted.current) {
            return;
        }
        setState(function (preState) {
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, preState), { isPlaying: false, status: Status[Status.pause] });
        });
    }, []);
    var handleEnd = (0,react.useCallback)(function () {
        if (!mounted.current) {
            return;
        }
        setState(function (preState) {
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, preState), { isPlaying: false, status: Status[Status.end] });
        });
    }, []);
    (0,react.useEffect)(function () {
        mounted.current = true;
        var utterance = new SpeechSynthesisUtterance(text);
        options.lang && (utterance.lang = options.lang);
        options.voice && (utterance.voice = options.voice);
        utterance.rate = options.rate || 1;
        utterance.pitch = options.pitch || 1;
        utterance.volume = options.volume || 1;
        utterance.onstart = handlePlay;
        utterance.onpause = handlePause;
        utterance.onresume = handlePlay;
        utterance.onend = handleEnd;
        window.speechSynthesis.speak(utterance);
        return function () {
            mounted.current = false;
        };
    }, []);
    return state;
};
/* harmony default export */ var esm_useSpeech = (useSpeech);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useStartTyping.js


var isFocusedElementEditable = function () {
    var activeElement = document.activeElement, body = document.body;
    if (!activeElement) {
        return false;
    }
    // If not element has focus, we assume it is not editable, too.
    if (activeElement === body) {
        return false;
    }
    // Assume <input> and <textarea> elements are editable.
    switch (activeElement.tagName) {
        case 'INPUT':
        case 'TEXTAREA':
            return true;
    }
    // Check if any other focused element id editable.
    return activeElement.hasAttribute('contenteditable');
};
var isTypedCharGood = function (_a) {
    var keyCode = _a.keyCode, metaKey = _a.metaKey, ctrlKey = _a.ctrlKey, altKey = _a.altKey;
    if (metaKey || ctrlKey || altKey) {
        return false;
    }
    // 0...9
    if (keyCode >= 48 && keyCode <= 57) {
        return true;
    }
    // a...z
    if (keyCode >= 65 && keyCode <= 90) {
        return true;
    }
    // All other keys.
    return false;
};
var useStartTyping = function (onStartTyping) {
    esm_useIsomorphicLayoutEffect(function () {
        var keydown = function (event) {
            !isFocusedElementEditable() && isTypedCharGood(event) && onStartTyping(event);
        };
        on(document, 'keydown', keydown);
        return function () {
            off(document, 'keydown', keydown);
        };
    }, []);
};
/* harmony default export */ var esm_useStartTyping = (useStartTyping);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useStateWithHistory.js



function useStateWithHistory(initialState, capacity, initialHistory) {
    if (capacity === void 0) { capacity = 10; }
    if (capacity < 1) {
        throw new Error("Capacity has to be greater than 1, got '" + capacity + "'");
    }
    var isFirstMount = useFirstMountState();
    var _a = (0,react.useState)(initialState), state = _a[0], innerSetState = _a[1];
    var history = (0,react.useRef)((initialHistory !== null && initialHistory !== void 0 ? initialHistory : []));
    var historyPosition = (0,react.useRef)(0);
    // do the states manipulation only on first mount, no sense to load re-renders with useless calculations
    if (isFirstMount) {
        if (history.current.length) {
            // if last element of history !== initial - push initial to history
            if (history.current[history.current.length - 1] !== initialState) {
                history.current.push(initialState);
            }
            // if initial history bigger that capacity - crop the first elements out
            if (history.current.length > capacity) {
                history.current = history.current.slice(history.current.length - capacity);
            }
        }
        else {
            // initiate the history with initial state
            history.current.push(initialState);
        }
        historyPosition.current = history.current.length && history.current.length - 1;
    }
    var setState = (0,react.useCallback)(function (newState) {
        innerSetState(function (currentState) {
            newState = resolveHookState(newState, currentState);
            // is state has changed
            if (newState !== currentState) {
                // if current position is not the last - pop element to the right
                if (historyPosition.current < history.current.length - 1) {
                    history.current = history.current.slice(0, historyPosition.current + 1);
                }
                historyPosition.current = history.current.push(newState) - 1;
                // if capacity is reached - shift first elements
                if (history.current.length > capacity) {
                    history.current = history.current.slice(history.current.length - capacity);
                }
            }
            return newState;
        });
    }, [state, capacity]);
    var historyState = (0,react.useMemo)(function () { return ({
        history: history.current,
        position: historyPosition.current,
        capacity: capacity,
        back: function (amount) {
            if (amount === void 0) { amount = 1; }
            // don't do anything if we already at the left border
            if (!historyPosition.current) {
                return;
            }
            innerSetState(function () {
                historyPosition.current -= Math.min(amount, historyPosition.current);
                return history.current[historyPosition.current];
            });
        },
        forward: function (amount) {
            if (amount === void 0) { amount = 1; }
            // don't do anything if we already at the right border
            if (historyPosition.current === history.current.length - 1) {
                return;
            }
            innerSetState(function () {
                historyPosition.current = Math.min(historyPosition.current + amount, history.current.length - 1);
                return history.current[historyPosition.current];
            });
        },
        go: function (position) {
            if (position === historyPosition.current) {
                return;
            }
            innerSetState(function () {
                historyPosition.current =
                    position < 0
                        ? Math.max(history.current.length + position, 0)
                        : Math.min(history.current.length - 1, position);
                return history.current[historyPosition.current];
            });
        },
    }); }, [state]);
    return [state, setState, historyState];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useStateList.js





function useStateList(stateSet) {
    if (stateSet === void 0) { stateSet = []; }
    var isMounted = useMountedState();
    var update = useUpdate();
    var index = (0,react.useRef)(0);
    // If new state list is shorter that before - switch to the last element
    esm_useUpdateEffect(function () {
        if (stateSet.length <= index.current) {
            index.current = stateSet.length - 1;
            update();
        }
    }, [stateSet.length]);
    var actions = (0,react.useMemo)(function () { return ({
        next: function () { return actions.setStateAt(index.current + 1); },
        prev: function () { return actions.setStateAt(index.current - 1); },
        setStateAt: function (newIndex) {
            // do nothing on unmounted component
            if (!isMounted())
                return;
            // do nothing on empty states list
            if (!stateSet.length)
                return;
            // in case new index is equal current - do nothing
            if (newIndex === index.current)
                return;
            // it gives the ability to travel through the left and right borders.
            // 4ex: if list contains 5 elements, attempt to set index 9 will bring use to 5th element
            // in case of negative index it will start counting from the right, so -17 will bring us to 4th element
            index.current =
                newIndex >= 0
                    ? newIndex % stateSet.length
                    : stateSet.length + (newIndex % stateSet.length);
            update();
        },
        setState: function (state) {
            // do nothing on unmounted component
            if (!isMounted())
                return;
            var newIndex = stateSet.length ? stateSet.indexOf(state) : -1;
            if (newIndex === -1) {
                throw new Error("State '" + state + "' is not a valid state (does not exist in state list)");
            }
            index.current = newIndex;
            update();
        },
    }); }, [stateSet]);
    return (0,tslib_es6.__assign)({ state: stateSet[index.current], currentIndex: index.current, isFirst: index.current === 0, isLast: index.current === stateSet.length - 1 }, actions);
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useThrottle.js


var useThrottle = function (value, ms) {
    if (ms === void 0) { ms = 200; }
    var _a = (0,react.useState)(value), state = _a[0], setState = _a[1];
    var timeout = (0,react.useRef)();
    var nextValue = (0,react.useRef)(null);
    var hasNextValue = (0,react.useRef)(0);
    (0,react.useEffect)(function () {
        if (!timeout.current) {
            setState(value);
            var timeoutCallback_1 = function () {
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setState(nextValue.current);
                    timeout.current = setTimeout(timeoutCallback_1, ms);
                }
                else {
                    timeout.current = undefined;
                }
            };
            timeout.current = setTimeout(timeoutCallback_1, ms);
        }
        else {
            nextValue.current = value;
            hasNextValue.current = true;
        }
    }, [value]);
    esm_useUnmount(function () {
        timeout.current && clearTimeout(timeout.current);
    });
    return state;
};
/* harmony default export */ var esm_useThrottle = (useThrottle);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useThrottleFn.js


var useThrottleFn = function (fn, ms, args) {
    if (ms === void 0) { ms = 200; }
    var _a = (0,react.useState)(null), state = _a[0], setState = _a[1];
    var timeout = (0,react.useRef)();
    var nextArgs = (0,react.useRef)();
    (0,react.useEffect)(function () {
        if (!timeout.current) {
            setState(fn.apply(void 0, args));
            var timeoutCallback_1 = function () {
                if (nextArgs.current) {
                    setState(fn.apply(void 0, nextArgs.current));
                    nextArgs.current = undefined;
                    timeout.current = setTimeout(timeoutCallback_1, ms);
                }
                else {
                    timeout.current = undefined;
                }
            };
            timeout.current = setTimeout(timeoutCallback_1, ms);
        }
        else {
            nextArgs.current = args;
        }
    }, args);
    esm_useUnmount(function () {
        timeout.current && clearTimeout(timeout.current);
    });
    return state;
};
/* harmony default export */ var esm_useThrottleFn = (useThrottleFn);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useTimeout.js


function useTimeout(ms) {
    if (ms === void 0) { ms = 0; }
    var update = useUpdate();
    return useTimeoutFn(update, ms);
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useTitle.js

var DEFAULT_USE_TITLE_OPTIONS = {
    restoreOnUnmount: false,
};
function useTitle(title, options) {
    if (options === void 0) { options = DEFAULT_USE_TITLE_OPTIONS; }
    var prevTitleRef = (0,react.useRef)(document.title);
    if (document.title !== title)
        document.title = title;
    (0,react.useEffect)(function () {
        if (options && options.restoreOnUnmount) {
            return function () {
                document.title = prevTitleRef.current;
            };
        }
        else {
            return;
        }
    }, []);
}
/* harmony default export */ var esm_useTitle = (typeof document !== 'undefined' ? useTitle : function (_title) { });

// EXTERNAL MODULE: ../../node_modules/ts-easing/lib/index.js
var ts_easing_lib = __webpack_require__(64507);
;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useTween.js


var useTween = function (easingName, ms, delay) {
    if (easingName === void 0) { easingName = 'inCirc'; }
    if (ms === void 0) { ms = 200; }
    if (delay === void 0) { delay = 0; }
    var fn = ts_easing_lib/* easing */.U[easingName];
    var t = esm_useRaf(ms, delay);
    if (false) {}
    return fn(t);
};
/* harmony default export */ var esm_useTween = (useTween);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUnmountPromise.js


var useUnmountPromise = function () {
    var refUnmounted = (0,react.useRef)(false);
    esm_useEffectOnce(function () { return function () {
        refUnmounted.current = true;
    }; });
    var wrapper = (0,react.useMemo)(function () {
        var race = function (promise, onError) {
            var newPromise = new Promise(function (resolve, reject) {
                promise.then(function (result) {
                    if (!refUnmounted.current)
                        resolve(result);
                }, function (error) {
                    if (!refUnmounted.current)
                        reject(error);
                    else if (onError)
                        onError(error);
                    else
                        console.error('useUnmountPromise', error);
                });
            });
            return newPromise;
        };
        return race;
    }, []);
    return wrapper;
};
/* harmony default export */ var esm_useUnmountPromise = (useUnmountPromise);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useUpsert.js


/**
 * @deprecated Use `useList` hook's upsert action instead
 */
function useUpsert(predicate, initialList) {
    if (initialList === void 0) { initialList = []; }
    var _a = esm_useList(initialList), list = _a[0], listActions = _a[1];
    return [
        list,
        (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, listActions), { upsert: function (newItem) {
                listActions.upsert(predicate, newItem);
            } }),
    ];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useVibrate.js


var isVibrationApiSupported = isNavigator && 'vibrate' in navigator;
function useVibrate(enabled, pattern, loop) {
    if (enabled === void 0) { enabled = true; }
    if (pattern === void 0) { pattern = [1000, 1000]; }
    if (loop === void 0) { loop = true; }
    (0,react.useEffect)(function () {
        var interval;
        if (enabled) {
            navigator.vibrate(pattern);
            if (loop) {
                var duration = pattern instanceof Array ? pattern.reduce(function (a, b) { return a + b; }) : pattern;
                interval = setInterval(function () {
                    navigator.vibrate(pattern);
                }, duration);
            }
        }
        return function () {
            if (enabled) {
                navigator.vibrate(0);
                if (loop) {
                    clearInterval(interval);
                }
            }
        };
    }, [enabled]);
}
/* harmony default export */ var esm_useVibrate = (isVibrationApiSupported ? useVibrate : noop);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useVideo.js

var useVideo = createHTMLMediaHook('video');
/* harmony default export */ var esm_useVideo = (useVideo);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useStateValidator.js

function useStateValidator(state, validator, initialState) {
    if (initialState === void 0) { initialState = [undefined]; }
    var validatorInner = (0,react.useRef)(validator);
    var stateInner = (0,react.useRef)(state);
    validatorInner.current = validator;
    stateInner.current = state;
    var _a = (0,react.useState)(initialState), validity = _a[0], setValidity = _a[1];
    var validate = (0,react.useCallback)(function () {
        if (validatorInner.current.length >= 2) {
            validatorInner.current(stateInner.current, setValidity);
        }
        else {
            setValidity(validatorInner.current(stateInner.current));
        }
    }, [setValidity]);
    (0,react.useEffect)(function () {
        validate();
    }, [state]);
    return [validity, validate];
}

;// CONCATENATED MODULE: ../../node_modules/@xobotyi/scrollbar-width/dist/index.esm.js
var e=function(t){if("undefined"==typeof document)return 0;if(document.body&&(!document.readyState||"loading"!==document.readyState)){if(!0!==t&&"number"==typeof e.__cache)return e.__cache;var o=document.createElement("div"),d=o.style;d.display="block",d.position="absolute",d.width="100px",d.height="100px",d.left="-999px",d.top="-999px",d.overflow="scroll",document.body.insertBefore(o,null);var n=o.clientWidth;if(0!==n)return e.__cache=100-n,document.body.removeChild(o),e.__cache;document.body.removeChild(o)}};

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useScrollbarWidth.js


function useScrollbarWidth() {
    var _a = (0,react.useState)(e()), sbw = _a[0], setSbw = _a[1];
    // this needed to ensure the scrollbar width in case hook called before the DOM is ready
    (0,react.useEffect)(function () {
        if (typeof sbw !== 'undefined') {
            return;
        }
        var raf = requestAnimationFrame(function () {
            setSbw(e());
        });
        return function () { return cancelAnimationFrame(raf); };
    }, []);
    return sbw;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMultiStateValidator.js

function useMultiStateValidator(states, validator, initialValidity) {
    if (initialValidity === void 0) { initialValidity = [undefined]; }
    if (typeof states !== 'object') {
        throw new Error('states expected to be an object or array, got ' + typeof states);
    }
    var validatorInner = (0,react.useRef)(validator);
    var statesInner = (0,react.useRef)(states);
    validatorInner.current = validator;
    statesInner.current = states;
    var _a = (0,react.useState)(initialValidity), validity = _a[0], setValidity = _a[1];
    var validate = (0,react.useCallback)(function () {
        if (validatorInner.current.length >= 2) {
            validatorInner.current(statesInner.current, setValidity);
        }
        else {
            setValidity(validatorInner.current(statesInner.current));
        }
    }, [setValidity]);
    (0,react.useEffect)(function () {
        validate();
    }, Object.values(states));
    return [validity, validate];
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useWindowScroll.js



var useWindowScroll = function () {
    var _a = esm_useRafState(function () { return ({
        x: isBrowser ? window.pageXOffset : 0,
        y: isBrowser ? window.pageYOffset : 0,
    }); }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var handler = function () {
            setState(function (state) {
                var pageXOffset = window.pageXOffset, pageYOffset = window.pageYOffset;
                //Check state for change, return same state if no change happened to prevent rerender
                //(see useState/setState documentation). useState/setState is used internally in useRafState/setState.
                return state.x !== pageXOffset || state.y !== pageYOffset
                    ? {
                        x: pageXOffset,
                        y: pageYOffset,
                    }
                    : state;
            });
        };
        //We have to update window scroll at mount, before subscription.
        //Window scroll may be changed between render and effect handler.
        handler();
        on(window, 'scroll', handler, {
            capture: false,
            passive: true,
        });
        return function () {
            off(window, 'scroll', handler);
        };
    }, []);
    return state;
};
/* harmony default export */ var esm_useWindowScroll = (useWindowScroll);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useWindowSize.js



var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var _a = esm_useRafState({
        width: isBrowser ? window.innerWidth : initialWidth,
        height: isBrowser ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        if (isBrowser) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            on(window, 'resize', handler_1);
            return function () {
                off(window, 'resize', handler_1);
            };
        }
    }, []);
    return state;
};
/* harmony default export */ var esm_useWindowSize = (useWindowSize);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useMeasure.js



var useMeasure_defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
function useMeasure() {
    var _a = (0,react.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0,react.useState)(useMeasure_defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0,react.useMemo)(function () {
        return new window.ResizeObserver(function (entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({ x: x, y: y, width: width, height: height, top: top_1, left: left, bottom: bottom, right: right });
            }
        });
    }, []);
    esm_useIsomorphicLayoutEffect(function () {
        if (!element)
            return;
        observer.observe(element);
        return function () {
            observer.disconnect();
        };
    }, [element]);
    return [ref, rect];
}
/* harmony default export */ var esm_useMeasure = (isBrowser && typeof window.ResizeObserver !== 'undefined'
    ? useMeasure
    : (function () { return [noop, useMeasure_defaultState]; }));

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/usePinchZoom.js

var ZoomState;
(function (ZoomState) {
    ZoomState["ZOOMING_IN"] = "ZOOMING_IN";
    ZoomState["ZOOMING_OUT"] = "ZOOMING_OUT";
})(ZoomState || (ZoomState = {}));
var usePinchZoom = function (ref) {
    var cacheRef = (0,react.useMemo)(function () { return ({
        evCache: [],
        prevDiff: -1,
    }); }, [ref.current]);
    var _a = (0,react.useState)(), zoomingState = _a[0], setZoomingState = _a[1];
    var pointermove_handler = function (ev) {
        // This function implements a 2-pointer horizontal pinch/zoom gesture.
        //
        // If the distance between the two pointers has increased (zoom in),
        // the target element's background is changed to 'pink' and if the
        // distance is decreasing (zoom out), the color is changed to 'lightblue'.
        //
        // This function sets the target element's border to 'dashed' to visually
        // indicate the pointer's target received a move event.
        // Find this event in the cache and update its record with this event
        for (var i = 0; i < cacheRef.evCache.length; i++) {
            if (ev.pointerId == cacheRef.evCache[i].pointerId) {
                cacheRef.evCache[i] = ev;
                break;
            }
        }
        // If two pointers are down, check for pinch gestures
        if (cacheRef.evCache.length == 2) {
            // console.log(prevDiff)
            // Calculate the distance between the two pointers
            var curDiff = Math.abs(cacheRef.evCache[0].clientX - cacheRef.evCache[1].clientX);
            if (cacheRef.prevDiff > 0) {
                if (curDiff > cacheRef.prevDiff) {
                    // The distance between the two pointers has increased
                    setZoomingState([ZoomState.ZOOMING_IN, curDiff]);
                }
                if (curDiff < cacheRef.prevDiff) {
                    // The distance between the two pointers has decreased
                    setZoomingState([ZoomState.ZOOMING_OUT, curDiff]);
                }
            }
            // Cache the distance for the next move event
            cacheRef.prevDiff = curDiff;
        }
    };
    var pointerdown_handler = function (ev) {
        // The pointerdown event signals the start of a touch interaction.
        // This event is cached to support 2-finger gestures
        cacheRef.evCache.push(ev);
        // console.log('pointerDown', ev);
    };
    var pointerup_handler = function (ev) {
        // Remove this pointer from the cache and reset the target's
        // background and border
        remove_event(ev);
        // If the number of pointers down is less than two then reset diff tracker
        if (cacheRef.evCache.length < 2) {
            cacheRef.prevDiff = -1;
        }
    };
    var remove_event = function (ev) {
        // Remove this event from the target's cache
        for (var i = 0; i < cacheRef.evCache.length; i++) {
            if (cacheRef.evCache[i].pointerId == ev.pointerId) {
                cacheRef.evCache.splice(i, 1);
                break;
            }
        }
    };
    (0,react.useEffect)(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            ref.current.onpointerdown = pointerdown_handler;
            ref.current.onpointermove = pointermove_handler;
            ref.current.onpointerup = pointerup_handler;
            ref.current.onpointercancel = pointerup_handler;
            ref.current.onpointerout = pointerup_handler;
            ref.current.onpointerleave = pointerup_handler;
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    return zoomingState
        ? { zoomingState: zoomingState[0], pinchState: zoomingState[1] }
        : { zoomingState: null, pinchState: 0 };
};
/* harmony default export */ var esm_usePinchZoom = (usePinchZoom);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useRendersCount.js

function useRendersCount() {
    return ++(0,react.useRef)(0).current;
}

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useSet.js


var useSet = function (initialSet) {
    if (initialSet === void 0) { initialSet = new Set(); }
    var _a = (0,react.useState)(initialSet), set = _a[0], setSet = _a[1];
    var stableActions = (0,react.useMemo)(function () {
        var add = function (item) { return setSet(function (prevSet) { return new Set((0,tslib_es6.__spreadArrays)(Array.from(prevSet), [item])); }); };
        var remove = function (item) {
            return setSet(function (prevSet) { return new Set(Array.from(prevSet).filter(function (i) { return i !== item; })); });
        };
        var toggle = function (item) {
            return setSet(function (prevSet) {
                return prevSet.has(item)
                    ? new Set(Array.from(prevSet).filter(function (i) { return i !== item; }))
                    : new Set((0,tslib_es6.__spreadArrays)(Array.from(prevSet), [item]));
            });
        };
        return { add: add, remove: remove, toggle: toggle, reset: function () { return setSet(initialSet); }, clear: function () { return setSet(new Set()); } };
    }, [setSet]);
    var utils = (0,tslib_es6.__assign)({ has: (0,react.useCallback)(function (item) { return set.has(item); }, [set]) }, stableActions);
    return [set, utils];
};
/* harmony default export */ var esm_useSet = (useSet);

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/factory/createGlobalState.js




function createGlobalState(initialState) {
    var store = {
        state: initialState instanceof Function ? initialState() : initialState,
        setState: function (nextState) {
            store.state = resolveHookState(nextState, store.state);
            store.setters.forEach(function (setter) { return setter(store.state); });
        },
        setters: [],
    };
    return function () {
        var _a = (0,react.useState)(store.state), globalState = _a[0], stateSetter = _a[1];
        esm_useEffectOnce(function () { return function () {
            store.setters = store.setters.filter(function (setter) { return setter !== stateSetter; });
        }; });
        esm_useIsomorphicLayoutEffect(function () {
            if (!store.setters.includes(stateSetter)) {
                store.setters.push(stateSetter);
            }
        });
        return [globalState, store.setState];
    };
}
/* harmony default export */ var factory_createGlobalState = ((/* unused pure expression or super */ null && (createGlobalState)));

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/useHash.js



/**
 * read and write url hash, response to url hash change
 */
var useHash = function () {
    var _a = (0,react.useState)(function () { return window.location.hash; }), hash = _a[0], setHash = _a[1];
    var onHashChange = (0,react.useCallback)(function () {
        setHash(window.location.hash);
    }, []);
    esm_useLifecycles(function () {
        on(window, 'hashchange', onHashChange);
    }, function () {
        off(window, 'hashchange', onHashChange);
    });
    var _setHash = (0,react.useCallback)(function (newHash) {
        if (newHash !== hash) {
            window.location.hash = newHash;
        }
    }, [hash]);
    return [hash, _setHash];
};

;// CONCATENATED MODULE: ../../node_modules/react-use/esm/index.js








































// not exported because of peer dependency
// export { default as useKeyboardJs } from './useKeyboardJs';












































// not exported because of peer dependency
// export { default as useSpring } from './useSpring';































/***/ }),

/***/ 38421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(2784);


/***/ }),

/***/ 71301:
/***/ (function(module) {

/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
	var isCommonjs =  true && module.exports;

	var fn = (function () {
		var val;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var eventNameMap = {
		change: fn.fullscreenchange,
		error: fn.fullscreenerror
	};

	var screenfull = {
		request: function (element, options) {
			return new Promise(function (resolve, reject) {
				var onFullScreenEntered = function () {
					this.off('change', onFullScreenEntered);
					resolve();
				}.bind(this);

				this.on('change', onFullScreenEntered);

				element = element || document.documentElement;

				var returnPromise = element[fn.requestFullscreen](options);

				if (returnPromise instanceof Promise) {
					returnPromise.then(onFullScreenEntered).catch(reject);
				}
			}.bind(this));
		},
		exit: function () {
			return new Promise(function (resolve, reject) {
				if (!this.isFullscreen) {
					resolve();
					return;
				}

				var onFullScreenExit = function () {
					this.off('change', onFullScreenExit);
					resolve();
				}.bind(this);

				this.on('change', onFullScreenExit);

				var returnPromise = document[fn.exitFullscreen]();

				if (returnPromise instanceof Promise) {
					returnPromise.then(onFullScreenExit).catch(reject);
				}
			}.bind(this));
		},
		toggle: function (element, options) {
			return this.isFullscreen ? this.exit() : this.request(element, options);
		},
		onchange: function (callback) {
			this.on('change', callback);
		},
		onerror: function (callback) {
			this.on('error', callback);
		},
		on: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.addEventListener(eventName, callback, false);
			}
		},
		off: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.removeEventListener(eventName, callback, false);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = {isEnabled: false};
		} else {
			window.screenfull = {isEnabled: false};
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		isEnabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 19453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerStyleSheet": function() { return /* binding */ Ue; },
  "StyleSheetConsumer": function() { return /* binding */ ue; },
  "StyleSheetContext": function() { return /* binding */ ce; },
  "StyleSheetManager": function() { return /* binding */ me; },
  "ThemeConsumer": function() { return /* binding */ Ge; },
  "ThemeContext": function() { return /* binding */ Me; },
  "ThemeProvider": function() { return /* binding */ Le; },
  "__PRIVATE__": function() { return /* binding */ Ze; },
  "createGlobalStyle": function() { return /* binding */ $e; },
  "css": function() { return /* binding */ Ae; },
  "default": function() { return /* binding */ styled_components_browser_esm; },
  "isStyledComponent": function() { return /* binding */ _; },
  "keyframes": function() { return /* binding */ We; },
  "useTheme": function() { return /* binding */ Xe; },
  "version": function() { return /* binding */ A; },
  "withTheme": function() { return /* binding */ Je; }
});

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/styled-components/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ../../node_modules/styled-components/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(93542);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=react.forwardRef((function(t,n){var o=(0,react.useContext)(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,react.createElement(e,y({},t,{theme:a,ref:n}))}));return hoist_non_react_statics_cjs_default()(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return (0,react.useContext)(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 91706:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 64507:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.U = {
    // No easing, no acceleration
    linear: function (t) { return t; },
    // Accelerates fast, then slows quickly towards end.
    quadratic: function (t) { return t * (-(t * t) * t + 4 * t * t - 6 * t + 4); },
    // Overshoots over 1 and then returns to 1 towards end.
    cubic: function (t) { return t * (4 * t * t - 9 * t + 6); },
    // Overshoots over 1 multiple times - wiggles around 1.
    elastic: function (t) { return t * (33 * t * t * t * t - 106 * t * t * t + 126 * t * t - 67 * t + 15); },
    // Accelerating from zero velocity
    inQuad: function (t) { return t * t; },
    // Decelerating to zero velocity
    outQuad: function (t) { return t * (2 - t); },
    // Acceleration until halfway, then deceleration
    inOutQuad: function (t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
    // Accelerating from zero velocity
    inCubic: function (t) { return t * t * t; },
    // Decelerating to zero velocity
    outCubic: function (t) { return (--t) * t * t + 1; },
    // Acceleration until halfway, then deceleration
    inOutCubic: function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
    // Accelerating from zero velocity
    inQuart: function (t) { return t * t * t * t; },
    // Decelerating to zero velocity
    outQuart: function (t) { return 1 - (--t) * t * t * t; },
    // Acceleration until halfway, then deceleration
    inOutQuart: function (t) { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
    // Accelerating from zero velocity
    inQuint: function (t) { return t * t * t * t * t; },
    // Decelerating to zero velocity
    outQuint: function (t) { return 1 + (--t) * t * t * t * t; },
    // Acceleration until halfway, then deceleration
    inOutQuint: function (t) { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; },
    // Accelerating from zero velocity
    inSine: function (t) { return -Math.cos(t * (Math.PI / 2)) + 1; },
    // Decelerating to zero velocity
    outSine: function (t) { return Math.sin(t * (Math.PI / 2)); },
    // Accelerating until halfway, then decelerating
    inOutSine: function (t) { return -(Math.cos(Math.PI * t) - 1) / 2; },
    // Exponential accelerating from zero velocity
    inExpo: function (t) { return Math.pow(2, 10 * (t - 1)); },
    // Exponential decelerating to zero velocity
    outExpo: function (t) { return -Math.pow(2, -10 * t) + 1; },
    // Exponential accelerating until halfway, then decelerating
    inOutExpo: function (t) {
        t /= .5;
        if (t < 1)
            return Math.pow(2, 10 * (t - 1)) / 2;
        t--;
        return (-Math.pow(2, -10 * t) + 2) / 2;
    },
    // Circular accelerating from zero velocity
    inCirc: function (t) { return -Math.sqrt(1 - t * t) + 1; },
    // Circular decelerating to zero velocity Moves VERY fast at the beginning and
    // then quickly slows down in the middle. This tween can actually be used
    // in continuous transitions where target value changes all the time,
    // because of the very quick start, it hides the jitter between target value changes.
    outCirc: function (t) { return Math.sqrt(1 - (t = t - 1) * t); },
    // Circular acceleration until halfway, then deceleration
    inOutCirc: function (t) {
        t /= .5;
        if (t < 1)
            return -(Math.sqrt(1 - t * t) - 1) / 2;
        t -= 2;
        return (Math.sqrt(1 - t * t) + 1) / 2;
    }
};


/***/ }),

/***/ 17083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */

( function( window, factory ) {
  // universal module definition
  if (  true && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        __webpack_require__(62584),
    );
  } else {
    // browser global
    window.Unidragger = factory(
        window,
        window.EvEmitter,
    );
  }

}( typeof window != 'undefined' ? window : this, function factory( window, EvEmitter ) {

function Unidragger() {}

// inherit EvEmitter
let proto = Unidragger.prototype = Object.create( EvEmitter.prototype );

// ----- bind start ----- //

// trigger handler methods for events
proto.handleEvent = function( event ) {
  let method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

let startEvent, activeEvents;
if ( 'ontouchstart' in window ) {
  // HACK prefer Touch Events as you can preventDefault on touchstart to
  // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
  startEvent = 'touchstart';
  activeEvents = [ 'touchmove', 'touchend', 'touchcancel' ];
} else if ( window.PointerEvent ) {
  // Pointer Events
  startEvent = 'pointerdown';
  activeEvents = [ 'pointermove', 'pointerup', 'pointercancel' ];
} else {
  // mouse events
  startEvent = 'mousedown';
  activeEvents = [ 'mousemove', 'mouseup' ];
}

// prototype so it can be overwriteable by Flickity
proto.touchActionValue = 'none';

proto.bindHandles = function() {
  this._bindHandles( 'addEventListener', this.touchActionValue );
};

proto.unbindHandles = function() {
  this._bindHandles( 'removeEventListener', '' );
};

/**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */
proto._bindHandles = function( bindMethod, touchAction ) {
  this.handles.forEach( ( handle ) => {
    handle[ bindMethod ]( startEvent, this );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) handle.style.touchAction = touchAction;
  } );
};

proto.bindActivePointerEvents = function() {
  activeEvents.forEach( ( eventName ) => {
    window.addEventListener( eventName, this );
  } );
};

proto.unbindActivePointerEvents = function() {
  activeEvents.forEach( ( eventName ) => {
    window.removeEventListener( eventName, this );
  } );
};

// ----- event handler helpers ----- //

// trigger method with matching pointer
proto.withPointer = function( methodName, event ) {
  if ( event.pointerId === this.pointerIdentifier ) {
    this[ methodName ]( event, event );
  }
};

// trigger method with matching touch
proto.withTouch = function( methodName, event ) {
  let touch;
  for ( let changedTouch of event.changedTouches ) {
    if ( changedTouch.identifier === this.pointerIdentifier ) {
      touch = changedTouch;
    }
  }
  if ( touch ) this[ methodName ]( event, touch );
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  this.pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this.pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this.pointerDown( event, event );
};

// nodes that have text fields
const cursorNodes = [ 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION' ];
// input types that do not have text fields
const clickTypes = [ 'radio', 'checkbox', 'button', 'submit', 'image', 'file' ];

/**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  // dismiss multi-touch taps, right clicks, and clicks on text fields
  let isCursorNode = cursorNodes.includes( event.target.nodeName );
  let isClickType = clickTypes.includes( event.target.type );
  let isOkayElement = !isCursorNode || isClickType;
  let isOkay = !this.isPointerDown && !event.button && isOkayElement;
  if ( !isOkay ) return;

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;
  // track position for move
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  this.bindActivePointerEvents();
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// ----- move ----- //

proto.onmousemove = function( event ) {
  this.pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  this.withPointer( 'pointerMove', event );
};

proto.ontouchmove = function( event ) {
  this.withTouch( 'pointerMove', event );
};

proto.pointerMove = function( event, pointer ) {
  let moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY,
  };
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  // start drag if pointer has moved far enough to start drag
  let isDragStarting = !this.isDragging && this.hasDragStarted( moveVector );
  if ( isDragStarting ) this.dragStart( event, pointer );
  if ( this.isDragging ) this.dragMove( event, pointer, moveVector );
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- drag ----- //

proto.dragStart = function( event, pointer ) {
  this.isDragging = true;
  this.isPreventingClicks = true; // set flag to prevent clicks
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

proto.dragMove = function( event, pointer, moveVector ) {
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// ----- end ----- //

proto.onmouseup = function( event ) {
  this.pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  this.withPointer( 'pointerUp', event );
};

proto.ontouchend = function( event ) {
  this.withTouch( 'pointerUp', event );
};

proto.pointerUp = function( event, pointer ) {
  this.pointerDone();
  this.emitEvent( 'pointerUp', [ event, pointer ] );

  if ( this.isDragging ) {
    this.dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this.staticClick( event, pointer );
  }
};

proto.dragEnd = function( event, pointer ) {
  this.isDragging = false; // reset flag
  // re-enable clicking async
  setTimeout( () => delete this.isPreventingClicks );

  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// triggered on pointer up & pointer cancel
proto.pointerDone = function() {
  this.isPointerDown = false;
  delete this.pointerIdentifier;
  this.unbindActivePointerEvents();
  this.emitEvent('pointerDone');
};

// ----- cancel ----- //

proto.onpointercancel = function( event ) {
  this.withPointer( 'pointerCancel', event );
};

proto.ontouchcancel = function( event ) {
  this.withTouch( 'pointerCancel', event );
};

proto.pointerCancel = function( event, pointer ) {
  this.pointerDone();
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// ----- click ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) event.preventDefault();
};

// triggered after pointer down & up with no/tiny movement
proto.staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  let isMouseup = event.type === 'mouseup';
  if ( isMouseup && this.isIgnoringMouseUp ) return;

  this.emitEvent( 'staticClick', [ event, pointer ] );

  // set flag for emulated clicks 300ms after touchend
  if ( isMouseup ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 400ms
    setTimeout( () => {
      delete this.isIgnoringMouseUp;
    }, 400 );
  }
};

// -----  ----- //

return Unidragger;

} ) );


/***/ }),

/***/ 76716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./ES-commercials.json": [
		53632,
		3632
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 76716;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 94991:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./DE-provinces.json": [
		21492,
		1492
	],
	"./ES-provinces.json": [
		64586,
		4586
	],
	"./FR-provinces.json": [
		86864,
		6864
	],
	"./GB-provinces.json": [
		17792,
		7792
	],
	"./IT-provinces.json": [
		99538,
		9538
	],
	"./PT-provinces.json": [
		68264,
		8264
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94991;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 89049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./ES-subdivisions-with-stores.json": [
		80034,
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 89049;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 97820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./DE-subdivisions.json": [
		23282,
		3282
	],
	"./ES-subdivisions.json": [
		79386,
		9386
	],
	"./FR-subdivisions.json": [
		13767,
		3767
	],
	"./GB-subdivisions.json": [
		84039,
		4039
	],
	"./IT-subdivisions.json": [
		19003,
		9003
	],
	"./PT-subdivisions.json": [
		52401,
		2401
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97820;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 94551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.figureVariants = exports.deleteButtonVariants = exports.deleteVariants = exports.counterVariants = exports.defaultVariants = exports.transitionAddToCart = exports.bounceTransition = exports.Units = exports.Counter = exports.ButtonWrapper = void 0;
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const framer_motion_1 = __webpack_require__(53316);
exports.ButtonWrapper = styled_components_1.default.div `
  bottom: ${(0, styles_1.vw)(15, 'mobile')};
  position: absolute;
  right: ${(0, styles_1.vw)(10, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    bottom: ${(0, styles_1.vw)(15, 'nexus7')};
    right: ${(0, styles_1.vw)(10, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    bottom: ${(0, styles_1.vw)(17, 'desktop')};
    right: ${(0, styles_1.vw)(15, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    bottom: 17px;
    right: 15px;
  }

  &.is-pdp {
    bottom: auto;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-direction: column;
    height: ${(0, styles_1.vw)(40, 'mobile')};
    margin: 0;
    min-width: ${(0, styles_1.vw)(125, 'mobile')};
    position: relative;
    right: auto;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(40, 'nexus7')};
      min-width: ${(0, styles_1.vw)(125, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(50, 'desktop')};
      min-width: ${(0, styles_1.vw)(180, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 50px;
      min-width: 180px;
    }

    > button {
      height: ${(0, styles_1.vw)(50, 'mobile')};
      opacity: 1;
      width: 100%;

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(50, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 50px;
      }
      &[disabled] {
        opacity: .4;
      }
    }

    .btn-add--pdp {
      height: ${(0, styles_1.vw)(50, 'mobile')};
      /* position: absolute; */
      right: 0;
      white-space: nowrap;
      width: 120px;

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(50, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: 100%;
        height: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 50px;
      }

      &.no-stock {
        opacity: .4;
        pointer-events: none;

        + .counter {
          pointer-events: none !important;

          .units {
            pointer-events: none !important;
          }
        }
      }

      &.hide-initial-add {
        display: none !important;
        pointer-events: none;
        user-select: none;
      }

      img {
        height: 100%;
      }
    }
    /* PDP */
    .btn-add,
    .btn-bin {
      width: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(40, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 50px;
      }

      button {
        height: ${(0, styles_1.vw)(40, 'mobile')};
        width: ${(0, styles_1.vw)(40, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          height: ${(0, styles_1.vw)(40, 'nexus7')};
          width: ${(0, styles_1.vw)(40, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          height: ${(0, styles_1.vw)(50, 'desktop')};
          width: ${(0, styles_1.vw)(50, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          height: 50px;
          width: 50px;
        }

        img {
          height: 100%;
          padding: 0;
          object-fit: contain;
        }
      }
    }

    .btn-add {
      position: absolute;
      right: 0;

      &.insufficient-stock {
        opacity: .5;

        ${styles_1.mq.greaterThan('tablet')} {
          opacity: .5 !important;
        }
      }

      figure {
        max-height: 100%;
      }
    }

    .btn-bin {
      bottom: auto;
      position: relative;
      right: auto;

      > button {
        position: relative;
      }
    }
  }

  > button {
    opacity: 0;
    transition: opacity 300ms ${({ theme }) => theme.ease};
  }


  .btn-add,
  .btn-minus,
  .btn-bin {
    > button > div:last-of-type img,
    > div:last-of-type img {
      padding: 0;
    }

    figure {
      align-items: center;
      display: flex;
      justify-content: center;
      user-select: none;

      img {
        display: inline-block;
        object-fit: contain;
        user-select: none;
      }
    }
  }

  .btn-add {
    opacity: 1;
    z-index: 10;

    &.insufficient-stock {
      opacity: .5;
      pointer-events: none;
    }
    &[disabled] {
      opacity: .4;
      pointer-events: none;
    }

    img {
      width: ${(0, styles_1.vw)(19, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(19, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(19, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 19px;
      }
    }
  }


  .btn-bin {
    bottom: 0;
    height: ${(0, styles_1.vw)(38, 'mobile')};
    position: absolute;
    right: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(38, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      bottom: 0;
      height: ${(0, styles_1.vw)(40, 'desktop')};
      right: 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
    }

    button {
      right: 0;
      position: absolute;
      border-radius: 200px;

      > div:last-child {
        position: relative;

        figure {
          height: ${(0, styles_1.vw)(38, 'mobile')};
          position: relative;
          width: ${(0, styles_1.vw)(38, 'mobile')};

          ${styles_1.mq.greaterThan('nexus7')} {
            height: ${(0, styles_1.vw)(38, 'nexus7')};
            width: ${(0, styles_1.vw)(38, 'nexus7')};
          }

          ${styles_1.mq.greaterThan('tablet')} {
            height: ${(0, styles_1.vw)(40, 'desktop')};
            width: ${(0, styles_1.vw)(40, 'desktop')};
          }

          ${styles_1.mq.greaterThan('desktop')} {
            height: 40px;
            width: 40px;
          }

          &.figure-minus {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
          }

        }
      }
    }


    img {
      width: ${(0, styles_1.vw)(16, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(16, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(16, 'desktop')};
      }

      &.img-minus {
        height: ${(0, styles_1.vw)(3, 'mobile')};
        width: ${(0, styles_1.vw)(20, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          height: ${(0, styles_1.vw)(3, 'nexus7')};
          width: ${(0, styles_1.vw)(20, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          height: ${(0, styles_1.vw)(3, 'desktop')};
          width: ${(0, styles_1.vw)(20, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          height: 3px;
          width: 20px;
        }
      }
    }
  }

  &.is-pdp:has(.on_demand) {
    display: flex;
    flex-direction: column;
    height: ${(0, styles_1.vw)(50, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 50px;
    }
  }
`;
exports.Counter = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  background-color: ${({ theme, $frozen }) => $frozen ? 'rgba(50, 35, 169, .45)' : (0, styles_1.hex2Rgba)(theme.colors.red, 0.7)};
  border-radius: 150px;
  bottom: ${({ isPDP }) => isPDP ? 'auto' : 0};
  height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(70, 'mobile')}`};
  position: absolute;
  text-align: center;
  right: ${({ isPDP }) => isPDP ? 0 : 'auto'};
  width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(80, 'mobile')}` : '100%'};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(70, 'nexus7')}`};
    width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(80, 'nexus7')}` : '100%'};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    border-radius: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(25, 'desktop')}` : `${(0, styles_1.vw)(20, 'desktop')}`};
    height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(85, 'desktop')}`};
    width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(110, 'desktop')}` : '100%'};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    border-radius: ${({ isPDP }) => isPDP ? '25px' : '20px'};
    height: ${({ isPDP }) => isPDP ? '100%' : '85px'};
    width: ${({ isPDP }) => isPDP ? '110px' : '100%'};
  }

  .units {
    color: ${({ theme }) => theme.colors.white};
    ${(0, styles_1.getP20_2)()}
    font-family: ${({ theme }) => theme.fonts.platform};
    margin-top: ${(0, styles_1.vw)(12, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(15, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 15px;
    }
  }

  &.is-pdp {
    > .units {
      ${(0, styles_1.getP25)()}
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      margin-top: 0;
      width: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(40, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(67, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 67px;
      }
    }
  }
`;
exports.Units = (0, styled_components_1.default)(framer_motion_1.motion.input) `
  text-align: center;
  width: 100%;
`;
exports.bounceTransition = {
    type: 'spring',
    duration: .3,
    bounce: .4,
    velocity: 1.2
};
exports.transitionAddToCart = Object.assign({}, (0, styles_1.getTransition)());
exports.defaultVariants = {
    collapsed: {
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transitionAddToCart: exports.transitionAddToCart
    },
    expanded: {
        opacity: 1,
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.counterVariants = {
    collapsedMobile: {
        height: `${(0, styles_1.vw)(38, 'mobile')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedNexus: {
        height: `${(0, styles_1.vw)(38, 'nexus7')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedDesktop: {
        height: `${(0, styles_1.vw)(40, 'desktop')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedWide: {
        height: '40px',
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    expandedMobile: {
        height: `${(0, styles_1.vw)(70, 'mobile')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedNexus: {
        height: `${(0, styles_1.vw)(85, 'nexus7')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedDesktop: {
        height: `${(0, styles_1.vw)(85, 'desktop')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedWide: {
        height: '85px',
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    collapsedPDP: {
        opacity: 0,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedPDP: {
        opacity: 1,
        pointerEvents: 'auto',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.deleteVariants = {
    collapsed: {
        x: 0,
        pointerEvents: 'none',
        transitionEnd: { display: 'none' },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedMobile: {
        x: `-${(0, styles_1.vw)(44, 'mobile')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedNexus: {
        x: `-${(0, styles_1.vw)(44, 'nexus7')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedDesktop: {
        x: `-${(0, styles_1.vw)(45, 'desktop')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedWide: {
        x: '-45px',
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    collapsedPDP: {
        opacity: 0,
        pointerEvents: 'none',
        transitionEnd: { display: 'none' },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedPDP: {
        opacity: 1,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.deleteButtonVariants = {
    collapsedMobile: {
        width: [`${(0, styles_1.vw)(38, 'mobile')}`, `${(0, styles_1.vw)(55, 'mobile')}`, `${(0, styles_1.vw)(38, 'mobile')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedNexus7: {
        width: [`${(0, styles_1.vw)(38, 'nexus7')}`, `${(0, styles_1.vw)(55, 'nexus7')}`, `${(0, styles_1.vw)(38, 'nexus7')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedDesktop: {
        width: [`${(0, styles_1.vw)(40, 'desktop')}`, `${(0, styles_1.vw)(60, 'desktop')}`, `${(0, styles_1.vw)(40, 'desktop')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedPDP: {
        opacity: 0,
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedMobile: {
        width: [`${(0, styles_1.vw)(38, 'mobile')}`, `${(0, styles_1.vw)(55, 'mobile')}`, `${(0, styles_1.vw)(38, 'mobile')}`],
        transition: {
            duration: .3,
            type: 'spring',
            times: [0, 0.2, 1],
            ease: 'easeOut'
        }
    },
    expandedDesktop: {
        width: [`${(0, styles_1.vw)(40, 'desktop')}`, `${(0, styles_1.vw)(60, 'desktop')}`, `${(0, styles_1.vw)(40, 'desktop')}`],
        transition: {
            duration: .3,
            type: 'spring',
            times: [0, 0.2, 1],
            ease: 'easeOut'
        }
    },
    expandedPDP: {
        opacity: 1,
        transitionAddToCart: exports.transitionAddToCart
    },
};
exports.figureVariants = {
    binCollapsed: {
        opacity: [1, 0, 0],
        rotate: [0, 0, 0],
        scale: [0, 0.5, 0],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1] })
    },
    binExpanded: {
        opacity: [0, .5, 1],
        rotate: [0, 0, 0],
        scale: [0, 1.15, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], delay: .18 })
    },
    fadeIn: {
        opacity: [0, .5, 1],
        rotate: [-90, -45, 0],
        scale: [1, 1, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], duration: .2 })
    },
    fadeOut: {
        opacity: [1, .5, 0],
        rotate: [0, -45, -90],
        scale: [1, 1, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], duration: .2 })
    }
};


/***/ }),

/***/ 94656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoriesAccordion = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const styles_1 = __webpack_require__(73267);
const getSubcategories = (subcategories, locale, menuMobile, closeMenuMobile, querySubCat, isExpanded, brandCategory, pageCategory) => {
    if (subcategories.length < 1)
        return null;
    return subcategories.map((subcategory, idx) => {
        var _a, _b;
        const slug = (_a = subcategory === null || subcategory === void 0 ? void 0 : subcategory.slug) === null || _a === void 0 ? void 0 : _a[locale];
        if (typeof slug !== 'string')
            return false;
        const url = brandCategory.length > 0 ? `/brand/${brandCategory}/${slug}` : pageCategory.length > 0 ? `/page/${pageCategory}/${slug}` : `/catalog/${slug}`;
        const isActive = (slug && querySubCat) ? querySubCat === ((_b = slug === null || slug === void 0 ? void 0 : slug.split('/')) === null || _b === void 0 ? void 0 : _b[1]) : false;
        return ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.dd, Object.assign({ variants: itemVariants }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: url }, (menuMobile && { onClick: closeMenuMobile }), { className: `${isActive ? 'is-active' : ''}` }, { children: subcategory.name })) }), `subcategory-item-${idx}-${isExpanded}`));
    });
};
const CategoryAccordionItem = (0, react_1.memo)(({ category, menuMobile, closeMenuMobile, brandCategory, pageCategory }) => {
    var _a, _b;
    const { locale: routerLocale, query } = (0, router_1.useRouter)();
    const lang = (0, react_1.useMemo)(() => routerLocale.split('-')[0], [routerLocale]);
    const slug = category.slug[lang] ? category.slug[lang] : category.slug;
    const url = brandCategory.length > 0 ? category.isInformativeText ? null : category.isFirstCategory ? `/brand/${slug}` : `/brand/${brandCategory}/${slug}` : pageCategory.length > 0 ? pageCategory.split('/')[0].includes(slug) ? `/page/${slug}` : `/page/${pageCategory}/${slug}` : `/catalog/${slug}`;
    const isActive = (0, react_1.useMemo)(() => { var _a; return ((_a = query === null || query === void 0 ? void 0 : query.slug) === null || _a === void 0 ? void 0 : _a[0]) === slug; }, [query, slug]);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(isActive);
    const Subcategories = (0, react_1.useMemo)(() => { var _a; return getSubcategories(category.subcategories, lang, menuMobile, closeMenuMobile, (_a = query === null || query === void 0 ? void 0 : query.slug) === null || _a === void 0 ? void 0 : _a[1], isExpanded, brandCategory, pageCategory); }, [category.subcategories, lang, menuMobile, closeMenuMobile, query, isExpanded, brandCategory, pageCategory]);
    const onClick = () => {
        setIsExpanded(!isExpanded);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(framer_motion_1.motion.dt, Object.assign({ variants: itemVariants }, { children: [url ?
                        (0, jsx_runtime_1.jsx)("a", Object.assign({ href: url }, (menuMobile && { onClick: closeMenuMobile }), { className: `${isActive ? 'is-active' : ''}` }, { children: category.name }))
                        :
                            (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'informative' }, { children: category.name })), ((_a = category.subcategories) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        (0, jsx_runtime_1.jsx)(Chevron, Object.assign({ menuMobile: menuMobile, onClick: onClick, "aria-hidden": true, animate: { rotate: isExpanded ? 90 : 0 }, transition: ChevronTransition }, { children: (0, jsx_runtime_1.jsx)("img", { src: `/images/svg/i--chevron${menuMobile ? '--white' : ''}.svg`, alt: 'Icon chevron', width: '6', height: '8' }) }))] })), ((_b = category.subcategories) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                (0, jsx_runtime_1.jsx)(Div, Object.assign({ "aria-expanded": isExpanded, tabIndex: -1, variants: variants, initial: 'inactive', exit: 'exit', animate: isExpanded ? 'active' : 'exit' }, { children: Subcategories }))] }));
});
const getCategories = (categories, menuMobile, closeMenuMobile, path, brandCategory, pageCategory) => {
    return categories.map((category, idx) => {
        return ((0, jsx_runtime_1.jsx)(CategoryAccordionItem, { category: category, menuMobile: menuMobile, closeMenuMobile: closeMenuMobile, brandCategory: brandCategory, pageCategory: pageCategory }, `cat-item-${idx}-${path}`));
    });
};
exports.CategoriesAccordion = (0, react_1.memo)(({ categories = [], menuMobile = false, closeMenuMobile = null, decreaseLevel = null, brandCategory = '', pageCategory = '' }) => {
    const { asPath } = (0, router_1.useRouter)();
    const Categories = (0, react_1.useMemo)(() => getCategories(categories, menuMobile, closeMenuMobile, asPath, brandCategory, pageCategory), [categories, menuMobile, closeMenuMobile, asPath, brandCategory, pageCategory]);
    return ((0, jsx_runtime_1.jsxs)(Dl, Object.assign({ menuMobile: menuMobile, initial: 'inactive', animate: 'active', exit: 'exit', variants: listVariants }, { children: [menuMobile &&
                (0, jsx_runtime_1.jsx)(framer_motion_1.motion.dt, Object.assign({ variants: itemVariants }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: 'go-back', onClick: decreaseLevel }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--go-back--white.svg', alt: 'Icon back', width: '7', height: '12' }) })) })), Categories] })));
});
const Dl = (0, styled_components_1.default)(framer_motion_1.motion.dl) `
  display: flex;
  flex-direction: column;
  padding:  ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(100, 'mobile')}` : 0};
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding:  ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(100, 'nexus7')}` : 0};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${({ menuMobile }) => menuMobile ? `0 ${(0, styles_1.vw)(20, 'desktop')}` : 0};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: ${({ menuMobile }) => menuMobile ? '0 20px' : 0};
  }

  dt {
    align-items: center;
    display: flex;
    height: ${(0, styles_1.vw)(65, 'mobile')};
    justify-content: space-between;
    flex-shrink: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(65, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(45, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 45px;
    }

    &:active,
    &:focus {
      outline: 0;
    }

    a,
    button {
      &:active,
      &:focus {
        outline: 0;
      }
    }

    a {
      font-family: ${({ theme }) => theme.fonts.primaryFont};
      font-weight: bold;
      width: 100%;

      ${styles_1.mq.greaterThan('tablet')} {
        font-family: ${({ theme }) => theme.fonts.secondaryFont};
        font-weight: 500;
      }
    }

    button {
      flex-shrink: 0;
      justify-content: center;

      ${styles_1.mq.greaterThan('tablet')} {
        margin-left: ${(0, styles_1.vw)(30, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-left: 30px;
      }

      &.go-back {
        margin-left: 0;

        ${styles_1.mq.greaterThan('tablet')} {
          display: none;
        }

        img {
          height: ${(0, styles_1.vw)(20, 'mobile')};
          width: ${(0, styles_1.vw)(12, 'mobile')};
        }
      }
    }
  }

  dd {
    align-items: center;
    display: flex;
    height: ${(0, styles_1.vw)(50, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(40, 'desktop')};
      padding: 0 ${(0, styles_1.vw)(20, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
      padding: 0 20px;
    }

    &:active,
    &:focus {
      outline: 0;
    }

    &:last-child {
      margin-bottom: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        margin-bottom: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        margin-bottom: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-bottom: 10px;
      }
    }

    a {
      font-family: ${({ theme }) => theme.fonts.secondaryFont};
      opacity: ${({ menuMobile }) => menuMobile ? 1 : .5};
      transition: 300ms opacity ${({ ease }) => ease};
      font-weight: 500;

      &.is-active {
        opacity: 1;
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  dt, dd {
    a {
      align-items: center;
      color: ${({ theme, menuMobile }) => theme.colors[menuMobile ? 'white' : 'darkred']};
      display: flex;
      height: 100%;
      justify-content: flex-start;
    }
  }

  dt {
    a {
      ${(0, styles_1.getP18)()}
      &.is-active {
        color: ${({ theme }) => theme.colors.creme};
      }
    }
  }
  dd {
    a {
      ${(0, styles_1.getP15_2B)()}
    }
  }
  .informative {
    ${(0, styles_1.getP15)()}
    font-family: ${({ theme }) => theme.fonts.secondaryFont};
    opacity: .5;
  }
`;
const Chevron = (0, styled_components_1.default)(framer_motion_1.motion.button) `
  align-items: center;
  display: flex;
  height: ${(0, styles_1.vw)(45, 'mobile')};
  padding: ${(0, styles_1.vw)(10, 'mobile')};
  width: ${(0, styles_1.vw)(45, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(45, 'nexus7')};
    padding: ${(0, styles_1.vw)(10, 'nexus7')};
    width: ${(0, styles_1.vw)(45, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(45, 'desktop')};
    padding: ${(0, styles_1.vw)(10, 'desktop')};
    width: ${(0, styles_1.vw)(45, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 45px;
    padding: 10px;
    width: 45px;
  }

  img {
    height: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'mobile')};
    width: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'nexus7')};
      width: ${({ menuMobile }) => (0, styles_1.vw)(menuMobile ? 13 : 9, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(9, 'desktop')};
      width: ${(0, styles_1.vw)(9, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 9px;
      width: 9px;
    }
  }
`;
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  dd, a, button {
    transition: opacity 300ms ease-out;
  }

  &[aria-expanded=false] {
    /* overflow: hidden; */

    dd, a, button {
      opacity: 0;
      pointer-events: none;
      user-select: none;
    }
  }
`;
const transition = Object.assign({}, (0, styles_1.getTransition)());
const listVariants = {
    inactive: {
        opacity: 0,
        transition
    },
    active: {
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { staggerChildren: .01 })
    },
    exit: {
        opacity: 0,
        transition
    }
};
const itemVariants = {
    inactive: {
        x: -10,
        opacity: 0,
        transition
    },
    active: {
        x: 0,
        opacity: 1,
        transition
    },
    exit: {
        opacity: 0
    }
};
const variants = {
    inactive: {
        height: 0,
        opacity: 0,
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
    active: {
        height: 'auto',
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { staggerChildren: .01 })
    },
    exit: {
        height: 0,
        opacity: 0,
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
};
const ChevronTransition = {
    ease: [.25, .1, .25, 1],
    duration: .3,
    type: 'tween'
};


/***/ }),

/***/ 32392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryCard = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const _1 = __webpack_require__(17566);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const utils_1 = __webpack_require__(76079);
const TRANSLATIONS = {
    'es': 'Ver toda nuestra selección de',
    'en': 'View all our selection of',
    'ca': 'Veure tota la nostra selecció de',
    'de': 'Sehen Sie sich unsere gesamte Auswahl an',
    'fr': 'Voir toute notre sélection de ',
    'pt': 'Ver toda a nossa seleção de',
    'it': 'Vedi tutta la nostra selezione di'
};
const mediaArrowIcon = {
    type: 'image',
    alt: 'Icon arrow',
    default: {
        src: '/images/svg/i--arrow.svg',
        size: { width: 45, height: 39 }
    }
};
exports.CategoryCard = (0, react_1.memo)(({ data }) => {
    const { locale: localeRouter } = (0, router_1.useRouter)();
    const locale = (0, utils_1.getLang)(localeRouter);
    const { name, slug } = data;
    return ((0, jsx_runtime_1.jsx)(Article, { children: (0, jsx_runtime_1.jsx)(StyledLink, Object.assign({ href: `/product/${slug ? slug[locale] : ''}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'container' }, { children: [(0, jsx_runtime_1.jsx)(_1.Figure, { media: mediaArrowIcon }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", TRANSLATIONS[locale], " ", name, " "] })] })) })) }));
});
const Article = styled_components_1.default.article `
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 20px;
  border: 2px solid ${({ theme }) => theme.colors.creme};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  height: ${(0, styles_1.vw)(277, 'mobile')};
  margin-right: ${(0, styles_1.vw)(5, 'mobile')};
  overflow: hidden;
  position: relative;
  transition: 200ms border-color ${({ ease }) => ease};
  width: ${(0, styles_1.vw)(175, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(277, 'nexus7')};
    margin-right: ${(0, styles_1.vw)(5, 'nexus7')};
    width: ${(0, styles_1.vw)(175, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(360, 'desktop')};
    margin-right: ${(0, styles_1.vw)(5, 'desktop')};
    width: ${({ $narrow }) => $narrow ? `${(0, styles_1.vw)(204, 'desktop')}` : `${(0, styles_1.vw)(261, 'desktop')}`};

    &.selected,
    &:hover {
      border-color: ${({ theme }) => theme.colors.red};
    }
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 360px;
    margin-right: 5px;
    width: ${({ $narrow }) => $narrow ? '204px' : '261px'};
  }

  .container {
    display: grid;
    align-content: center;
    height: 100%;

    span {
      display:block;
      &:last-child {
        color: ${({ theme }) => theme.colors.darkcreme};
        text-align: center;
        margin:20px auto;
        width: 80%;
      }
    }
    figure {
      height: ${(0, styles_1.vw)(23, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(23, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(45, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 45px;
      }
    }
  }

`;
const StyledLink = styled_components_1.default.a `
  align-items: flex-start;
  display:flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  width: 100%;
`;


/***/ }),

/***/ 22468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DisplayError = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const client_1 = __webpack_require__(40591);
const styles_1 = __webpack_require__(73267);
const DisplayError = ({ error }) => {
    if (!error || !error.message)
        return null;
    if (error instanceof client_1.ApolloError) {
        // Handle GraphQL errors
        const graphqlErrors = error.graphQLErrors;
        const networkError = error.networkError;
        console.log('GraphQL errors::', graphqlErrors);
        if (graphqlErrors) {
            return ((0, jsx_runtime_1.jsx)(ErrorStyled, { children: graphqlErrors.map((item, idx) => ((0, jsx_runtime_1.jsx)("p", { children: item.message }, `gql-error-${idx}`))) }));
        }
        if (networkError) {
            // Handle network errors
            console.log('Network error:', networkError);
        }
    }
    else {
        // Handle other non-GraphQL errors here
        console.log('non-GraphQL error or Apollo response error', error);
        return ((0, jsx_runtime_1.jsx)(ErrorStyled, { children: (0, jsx_runtime_1.jsx)("p", { children: typeof error === 'string' ? error : error.message }) }));
    }
};
exports.DisplayError = DisplayError;
const ErrorStyled = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.input_error};
  background: #ff000022;
  margin: 1rem 0;
  padding: .75rem 1rem;
  width: 100%;

  p {
    ${styles_1.getP14Search}
    color: ${({ theme }) => theme.colors.input_error};
    margin: 0;
    font-weight: 100;
  }

  strong {
    margin-right: 1rem;
  }
`;


/***/ }),

/***/ 69451:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fieldset = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const styles_1 = __webpack_require__(73267);
const Fieldset = ({ col = 12, children, disabled = false, ariaBusy = false, legend }) => {
    return ((0, jsx_runtime_1.jsxs)(FieldsetStyled, Object.assign({ col: col, disabled: disabled, "aria-busy": ariaBusy, variants: variants, initial: 'initial', animate: 'active', exit: 'exit' }, { children: [legend && (0, jsx_runtime_1.jsx)("legend", { children: legend }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'fieldset-content-wrapper' }, { children: children }))] })));
};
exports.Fieldset = Fieldset;
const FieldsetStyled = (0, styled_components_1.default)(framer_motion_1.motion.fieldset) `
  width: 100%;

  ${styles_1.mq.greaterThan('tablet')} {
    width: ${({ col }) => 100 * col / 12}%;
  }

  &[disabled] {
    opacity: .5;
  }

  &[aria-busy='true'] {
    opacity: .6;
  }

  legend,
  .light {
    ${styles_1.getP20v2}
    font-family: ${({ theme }) => theme.fonts.tertiaryFont};
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
      padding: 0 ${(0, styles_1.vw)(4.5, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
      padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 20px;
      padding: 0 12.5px;
    }

    a,
    button {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      text-decoration: underline;
      transition: 300ms opacity ease-out;

      &:hover {
        opacity: .8;
      }
    }
  }

  .p-subinput,
  .p-tiny {
    ${(0, styles_1.getP12_1)()}
    color: ${({ theme }) => theme.colors.darkred};
    font-weight: normal;
    padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 0 12.5px;
    }

    > a,
    > button {
      color: inherit
    }
  }

  .p-subinput {
    transform: translateY(-${(0, styles_1.vw)(20, 'mobile')});

    ${styles_1.mq.greaterThan('nexus7')} {
      transform: translateY(-${(0, styles_1.vw)(30, 'nexus7')});
    }

    ${styles_1.mq.greaterThan('tablet')} {
      transform: translateY(-${(0, styles_1.vw)(25, 'desktop')});
    }

    ${styles_1.mq.greaterThan('desktop')} {
      transform: translateY(-25px);
    }
  }

  legend {
    font-weight: 500;
  }

  .light {
    font-weight: 300;
  }

  .fieldset-content-wrapper {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 0 ${(0, styles_1.vw)(50, 'desktop')};
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: 0 0 ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: 0 0 ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 0 0 50px;
    }
  }
`;
const variants = {
    'initial': {
        opacity: 0,
        height: 0,
        transition: {
            duration: .1,
        }
    },
    'active': {
        opacity: 1,
        height: 'auto',
        transition: {
            duration: .2,
        }
    },
    'exit': {
        opacity: 0,
        height: 0,
        transition: {
            duration: .1,
        }
    }
};


/***/ }),

/***/ 99155:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Form = void 0;
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
exports.Form = styled_components_1.default.form `
  align-items: flex-start;
  display: flex;
  color: ${({ theme }) => theme.colors.darkred};
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;

  > fieldset {
    color: ${({ theme }) => theme.colors.red};
  }

  > button {
    flex-grow: 2;
    margin: 0 ${(0, styles_1.vw)(4.25, 'mobile')} ${(0, styles_1.vw)(4.25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin: 0 ${(0, styles_1.vw)(4.5, 'nexus7')} ${(0, styles_1.vw)(4.5, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin: 0 ${(0, styles_1.vw)(12.5, 'desktop')} ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin: 0 12.5px 12.5px;
    }
  }

  > .subtext {
    ${(0, styles_1.getP15_2)()}
    color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, .5)};
    margin-top: ${(0, styles_1.vw)(30, 'mobile')};
    text-align: center;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(30, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 50px;
    }

    a,
    button {
      ${(0, styles_1.getP15_2)()}
      color: inherit;
      transition: 300ms color ease-out;
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, 1)};
      }
    }
  }
`;


/***/ }),

/***/ 96794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GiftCard = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const link_1 = __importDefault(__webpack_require__(39097));
const hooks_1 = __webpack_require__(92757);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const TRANSLATIONS_GIFT_CARD = {
    'es-ES': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'en-EU': {
        name: 'Gift Card',
        title: 'The best gift for Christmas',
        cta: 'Get your gift card'
    },
    'fr-FR': {
        name: 'Carte cadeau',
        title: 'Le meilleur cadeau pour Noël',
        cta: 'Recevez votre carte cadeau'
    },
    'en-GB': {
        name: 'Gift Card',
        title: 'The best gift for Christmas',
        cta: 'Get your gift card'
    },
    'de-DE': {
        'brand': 'brand'
    },
    'es-MD': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'es-CN': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'es-CT': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'pt-PT': {
        name: 'Cartão Presente',
        title: 'O melhor presente para este Natal',
        cta: 'Obtenha o seu cartão presente'
    }
};
exports.GiftCard = (0, react_1.memo)(({ data, onClick, narrow = false }) => {
    const { locale } = (0, router_1.useRouter)();
    // const { cardClicked } = useActiveVariant()
    const { ref } = (0, hooks_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
        triggerOnce: true,
    });
    console.log('data', data);
    return ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: '/' }, { children: (0, jsx_runtime_1.jsx)(Article, Object.assign({ ref: ref, className: `gift-card ${ true ? ' selected' : 0}`, narrow: narrow, onClick: () => { onClick; } }, { children: (0, jsx_runtime_1.jsxs)(TextWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [" ", TRANSLATIONS_GIFT_CARD[locale].name] }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'gift' }, { children: TRANSLATIONS_GIFT_CARD[locale].title }))] }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'cta' }, { children: [TRANSLATIONS_GIFT_CARD[locale].cta, (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/arrow-right.svg', alt: 'Arrow right', width: '15', height: '13' })] }))] }) })) })));
});
const Article = styled_components_1.default.article `
  background: url('/images/svg/gift-card-mobile.svg');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  box-shadow: 2px 2px 4px ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.black, .4)};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.basier};
  height: ${(0, styles_1.vw)(270, 'mobile')};
  margin-right: ${(0, styles_1.vw)(5, 'mobile')};
  overflow: hidden;
  position: relative;
  transition: 200ms all ${({ ease }) => ease};
  transform: rotate(-0.5deg);
  scale: 0.9;
  width: ${(0, styles_1.vw)(350, 'mobile')};
  z-index: 20;

  &.selected,
  &:hover {
    border-color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, .6)};
    box-shadow: 2px 2px 8px ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.black, .4)};
    transform: rotate(1deg) scale(1.02);
  }

  &:not(.selected) {
    &:hover {
      .cta {
        transform: translateX(${(0, styles_1.vw)(10, 'mobile')});

        ${styles_1.mq.greaterThan('nexus7')} {
          transform: translateX(${(0, styles_1.vw)(10, 'nexus7')});
        }

        ${styles_1.mq.greaterThan('tablet')} {
          transform: translateX(${(0, styles_1.vw)(10, 'desktop')});
        }

        ${styles_1.mq.greaterThan('desktop')} {
          transform: translateX(10px);
        }
      }
    }
  }

  &.selected {
    ${styles_1.mq.greaterThan('tablet')} {
      background-position: top;
      width: ${(0, styles_1.vw)(386, 'desktop')}
    }
  }

  ${styles_1.mq.greaterThan('nexus7')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: ${(0, styles_1.vw)(277, 'nexus7')};
    width: ${(0, styles_1.vw)(350, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: ${(0, styles_1.vw)(360, 'desktop')};
    margin-right: ${(0, styles_1.vw)(5, 'desktop')};
    width: ${({ narrow }) => narrow ? `${(0, styles_1.vw)(386, 'desktop')}` : `${(0, styles_1.vw)(440, 'desktop')}`};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: 360px;
    margin-right: 5px;
    width: ${({ narrow }) => narrow ? '385px' : '440px'};
  }
`;
const TextWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(40, 'mobile')} ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(20, 'mobile')};
  text-align: left;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(40, 'nexus7')} ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${(0, styles_1.vw)(40, 'desktop')} ${(0, styles_1.vw)(80, 'desktop')} ${(0, styles_1.vw)(40, 'desktop')} ${(0, styles_1.vw)(40, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding:40px 80px 40px 40px;
  }

  span {
    display: block;
  }

  .gift {
    ${(0, styles_1.getP45)()}
    text-align: left;
    margin: ${(0, styles_1.vw)(15, 'mobile')} 0 ${(0, styles_1.vw)(60, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin: ${(0, styles_1.vw)(15, 'nexus7')} 0 ${(0, styles_1.vw)(60, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin: ${(0, styles_1.vw)(15, 'desktop')} 0 ${(0, styles_1.vw)(80, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin: 15px 35px 80px 0;
    }
  }

  .cta {
    ${(0, styles_1.getP15_1B)()}
    color: ${({ theme }) => theme.colors.creamlight};
    transition: 300ms transform ease-out;

    img {
      margin-left: 5px;
      width: unset;
    }
  }
`;


/***/ }),

/***/ 44308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeaderMarquee = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const dynamic_1 = __importDefault(__webpack_require__(25237));
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const DynamicMarquee = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(__webpack_require__(17566))).then((mod) => mod.Marquee), { ssr: false });
exports.HeaderMarquee = (0, react_1.memo)(({ data }) => {
    return ((0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(DynamicMarquee, { data: data }) }));
});
const Header = styled_components_1.default.header `
  margin: 85px 0 ${(0, styles_1.vw)(35, 'mobile')};
  overflow: hidden;
  width: 100vw;

  ${styles_1.mq.greaterThan('tablet')} {
    margin: 80px 0 ${(0, styles_1.vw)(60, 'desktop')};
  }

  .marquee {
    background-color: unset;
    margin-top: ${(0, styles_1.vw)(25, 'mobile')};
    padding: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(30, 'desktop')};
      padding: 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 30px;
    }
  }
`;


/***/ }),

/***/ 362:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Link = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const link_1 = __importDefault(__webpack_require__(39097));
const Link = ({ href, children, ariaDisabled, rel, locale, title, className, onClick = undefined }) => {
    return ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: href, passHref: true }, locale && { locale }, onClick && { onClick }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({}, rel && { rel }, ariaDisabled && { 'aria-disabled': ariaDisabled }, title && { title }, className && { className }, { children: children })) })));
};
exports.Link = Link;


/***/ }),

/***/ 80977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MediaContextProvider = exports.Media = exports.mediaStyles = void 0;
const fresnel_1 = __webpack_require__(3517);
const MediaQueries = (0, fresnel_1.createMedia)({
    breakpoints: {
        mobile: 0,
        tablet: 768,
        laptop: 996,
        desktop: 1200,
        screen: 1440,
    }
});
// Make styles for injection into the header of the page
exports.mediaStyles = MediaQueries.createMediaStyle();
exports.Media = MediaQueries.Media, exports.MediaContextProvider = MediaQueries.MediaContextProvider;


/***/ }),

/***/ 82564:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Price = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const styled_components_1 = __importStar(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const utils_1 = __webpack_require__(76079);
const TRANSLATIONS = {
    'en': 'VAT',
    'es': 'IVA',
    'fr': 'TVA',
    'de': 'MwSt.',
    'pt': 'IVA'
};
const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;
exports.Price = (0, react_1.memo)(({ type = 'card', price, className = '', withTax = false, displayRetailPrice = true, pricePer, round = true, stockWarning, stock, lastUnits, minSaleUnits }) => {
    const { locale: localeRouter } = (0, router_1.useRouter)();
    const localeRegion = (0, utils_1.getLocaleCountry)(localeRouter);
    const LANG = (0, utils_1.getLang)(localeRouter);
    if (!price)
        return;
    const retailPrice = typeof price.retailPrice === 'object' ? price === null || price === void 0 ? void 0 : price.retailPrice : { exTax: price === null || price === void 0 ? void 0 : price.retailPrice, incTax: null };
    const salePrice = typeof price.salePrice === 'object' ? price.salePrice : { exTax: price.salePrice, incTax: null };
    const hasDiscount = retailPrice.exTax > salePrice.exTax || retailPrice.incTax > salePrice.incTax;
    const displayStockWarning = stock >= minSaleUnits && stockWarning;
    const retailPriceCurrency = (0, utils_1.currencyFormatter)({ price: retailPrice[withTax ? 'incTax' : 'exTax'], localeRegion, round });
    const salePriceCurrency = (0, utils_1.currencyFormatter)({ price: salePrice[withTax ? 'incTax' : 'exTax'], localeRegion, round });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Div, Object.assign({ "$type": type, "$hasDiscount": hasDiscount, className: className }, { children: (0, jsx_runtime_1.jsxs)(ConditionalWrapper, Object.assign({ condition: (displayStockWarning && !hasDiscount), wrapper: children => (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: 'last_units' }, { children: lastUnits })), children] }) }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'sale' }, { children: [salePriceCurrency, pricePer && (0, jsx_runtime_1.jsx)("span", { children: pricePer })] })), (displayRetailPrice && hasDiscount) &&
                        (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'flex' }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'retail' }, { children: [retailPriceCurrency, pricePer && (0, jsx_runtime_1.jsx)("span", { children: pricePer })] })), type === 'pdp' && (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'plus-iva' }, { children: ["+", TRANSLATIONS[LANG]] })), displayStockWarning && lastUnits && (0, jsx_runtime_1.jsx)("p", Object.assign({ className: 'last_units discount' }, { children: lastUnits }))] }))] })) })) }));
});
const Div = styled_components_1.default.div `
  align-items: baseline;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: fit-content;
  justify-content: flex-start;
  padding: 0 ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(10, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: 0 ${(0, styles_1.vw)(10, 'nexus7')} ${(0, styles_1.vw)(14, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: 0 ${(0, styles_1.vw)(15, 'desktop')} ${(0, styles_1.vw)(20, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 0 15px 20px;
  }

  p {
    ${(0, styles_1.getP12_3)()}
    color: ${({ theme }) => theme.colors.red};

    &.discount {
      margin-left: 3px;
    }
  }
  .flex {
    display: flex;
    flex-direction: row;
  }

  /* SHARED FOR ALL THE TYPES using card as default */
  span {
    color: ${({ theme }) => theme.colors.darkred};
  }

  /* BOTH PRICES STYLED HERE */
  /* Sale Price */
  /* &:first-child {} */

  /* Retail Price */
  .retail {
    display: inline-block;
    height: fit-content;
    opacity: .3;
    font-size: 11px;
    position: relative;
    width: fit-content;

    ${styles_1.mq.greaterThan('tablet')} {
      ${(0, styles_1.getP12_3)()}
    }

    ::after {
      content: '';
      background-color: ${({ theme }) => theme.colors.darkred};
      display: block;
      height: ${(0, styles_1.vw)(1, 'desktop')};
      min-height: 1px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(1, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(1, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 1px;
      }
    }
  }

  /* SPECIFIC FOR TYPES */
  ${({ $type }) => $type === 'card' && (0, styled_components_1.css) `
    align-items: flex-start;
    color: ${({ theme }) => theme.colors.darkred};
    flex-direction: column;

    span:first-of-type:not(.flex > span) {
      ${(0, styles_1.getP26_3)()}
      margin-top: ${(0, styles_1.vw)(4, 'desktop')};
      order: 1;

      ${styles_1.mq.greaterThan('nexus7')} {
        margin-top: ${(0, styles_1.vw)(4, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        margin-top: ${(0, styles_1.vw)(6, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-top: 6px;
      }

      span {
        ${(0, styles_1.getP15_3)()}
      }
    }

    .flex span:first-of-type {
      ${(0, styles_1.getP15_3)()}

      span {
        ${(0, styles_1.getP12)()}
      }
    }

  `}

  ${({ $type }) => $type === 'pdp' && (0, styled_components_1.css) `
    color: ${({ theme }) => theme.colors.darkred};
    flex-direction: row;
    padding: 0 0 ${(0, styles_1.vw)(14, 'mobile')} 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: 0 0 ${(0, styles_1.vw)(14, 'nexus7')} 0;
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: 0 0 ${(0, styles_1.vw)(20, 'desktop')} 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 0 0 20px 0;
    }

    > span {
      &:first-child {
        ${(0, styles_1.getP53_2)()}
        margin-right: ${(0, styles_1.vw)(4, 'desktop')};

        ${styles_1.mq.greaterThan('nexus7')} {
          margin-right: ${(0, styles_1.vw)(4, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          margin-right: ${(0, styles_1.vw)(6, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          margin-right: 6px;
        }

        span {
          ${(0, styles_1.getP30_2)()}
        }
      }

      &:nth-child(2) {
        ${(0, styles_1.getP26_3)()}

        span {
          ${(0, styles_1.getP15_3)()}
        }
      }
    }

    .plus-iva {
      ${(0, styles_1.getP13_3)()}
      font-family: ${({ theme }) => theme.fonts.platform};
      font-weight: 400;
      margin-left: ${(0, styles_1.vw)(6, 'desktop')};
      opacity: .4;

      ${styles_1.mq.greaterThan('nexus7')} {
        margin-left: ${(0, styles_1.vw)(6, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        margin-left: ${(0, styles_1.vw)(7, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        margin-left: 7px;
      }
    }
  `}

  ${({ $type }) => $type === 'cart' && (0, styled_components_1.css) `
    align-items: flex-end;
    flex-direction: column;

    > span {
      &:first-child {
        ${(0, styles_1.getP26_3)()}
        color: ${({ theme }) => theme.colors.darkcreme};
        margin-bottom: ${(0, styles_1.vw)(4, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          margin-bottom: ${(0, styles_1.vw)(4, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          margin-bottom: ${(0, styles_1.vw)(6, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          margin-bottom: 6px;
        }
      }
    }

    div:last-child {
      color: ${({ theme }) => theme.colors.darkred};
      span {
        ${(0, styles_1.getP15_3)()}
      }
    }
  `}
`;


/***/ }),

/***/ 91840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ToastWrapper = exports.Toast = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const _1 = __webpack_require__(17566);
const utils_1 = __webpack_require__(76079);
const styles_1 = __webpack_require__(73267);
const getColorByType = (type) => {
    switch (type) {
        case 'info':
            return '#EFC881';
        case 'success':
            return '#5F895E';
        case 'warning':
            return '#A92329';
        case 'error':
            return '#A92329';
        default:
            return '#EFC881';
    }
};
exports.Toast = (0, react_1.memo)(({ message, type, icon, timeout = 5000, closeNeeded = false, onClose }) => {
    const [visible, setVisible] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        let timer;
        if (!closeNeeded) {
            timer = setTimeout(() => {
                setVisible(false);
            }, timeout);
        }
        return () => { clearTimeout(timer); };
    }, [timeout, closeNeeded]);
    const handleClose = (e) => {
        e.stopPropagation(); // Prevent the event from reaching the ToastContainer
        setVisible(false);
        if (onClose)
            onClose();
    };
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: 'wait' }, { children: visible &&
            (0, jsx_runtime_1.jsxs)(Div, Object.assign({ "$type": type, role: 'alert', "aria-relevant": 'additions', variants: variants, initial: 'initial', animate: 'animate', exit: 'exit' }, { children: [icon && (0, jsx_runtime_1.jsx)(_1.Figure, { media: (0, utils_1.iconByName)(icon) }), (0, jsx_runtime_1.jsx)("p", { children: message }), closeNeeded && (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleClose, name: 'Cerrar', "aria-label": 'Cerrar' }, { children: (0, jsx_runtime_1.jsx)(_1.Figure, { media: (0, utils_1.iconByName)('close') }) }))] })) })));
});
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  ${(0, styles_1.font12_15)(true, 400)}
  align-items: center;
  background-color: ${({ $type }) => getColorByType($type)};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  color: ${({ $type }) => ($type === 'warning' || $type === 'error' || $type === 'success') ? '#F3EFE6' : '#4E1114'};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  justify-content: space-between;
  margin: ${(0, styles_1.vw)(4, 'mobile')} 0;
  padding: ${(0, styles_1.vw)(4, 'mobile')} ${(0, styles_1.vw)(16, 'mobile')};
  pointer-events: auto;
  z-index: 999;
  width: 100vw;
  width: 100dvw;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin: ${(0, styles_1.vw)(4, 'tablet')} 0;
    padding: ${(0, styles_1.vw)(4, 'tablet')} ${(0, styles_1.vw)(16, 'tablet')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    ${(0, styles_1.font12_15)(false, 400)}
    margin: ${(0, styles_1.vw)(4, 'desktop')} 0;
    padding: ${(0, styles_1.vw)(4, 'desktop')} ${(0, styles_1.vw)(16, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin: 4px 0;
    padding: 4px 16px;
  }

  p {
    flex-grow: 2;
    flex-shrink: 0;
    text-align: center;
    width: 100%;
  }
`;
const variants = {
    initial: {
        opacity: 0,
        x: '100%',
        transition: { duration: .4 }
    },
    animate: {
        opacity: 1,
        x: '0%',
        transition: { duration: .4 }
    },
    exit: {
        opacity: 0,
        x: '100%',
        transition: { duration: .3 }
    }
};
exports.ToastWrapper = styled_components_1.default.aside `
  bottom: 0;
  left: 0;
  max-width: 100vw;
  pointer-events: none;
  position: fixed;
  right: 0;
  transition: 300ms all linear;
  user-select: none;
  width: 100%;
  z-index: 500;

  > div {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;


/***/ }),

/***/ 27929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ToolTip = exports.listToolTipVariants = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const framer_motion_1 = __webpack_require__(53316);
const transition = Object.assign({}, (0, styles_1.getTransition)(.5));
exports.listToolTipVariants = {
    inactive: {
        opacity: 0,
        transition
    },
    enter: {
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)(.5)), { staggerChildren: .01 })
    },
    exit: {
        opacity: 0,
        transition
    }
};
const TRANSLATIONS = {
    'es-ES': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'en-EU': {
        'title': 'SUPERFRESH PRODUCT',
        'description': ' There\'s limited stock of this product to warranty it\'s super fresh. We recommend ordering with 3 days in advance to ensure availability. To urgent orders with less time: we\'ll do our best to seve it at the requested date or as soon as possible'
    },
    'es-MD': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'es-CN': {
        'title': 'PRODUCTO SUPERFRESCO',
        'description': 'Hay existencias limitadas de este producto para garantizar que es súper fresco. Recomendamos ordenar con 3 días de anticipación para asegurar disponibilidad. A pedidos urgentes con menos tiempo: haremos todo lo posible para atenderlo en la fecha solicitada o lo antes posible'
    },
    'es-CT': {
        'title': 'PRODUCTE SUPERFRESC',
        'description': 'Hi ha estoc limitat d\'aquest producte per garantir que és molt fresc. Recomanem fer la comanda amb 3 dies d\'antelació per garantir la disponibilitat. Per a comandes urgents amb menys temps: farem tot el possible per atendre-les en la data sol·licitada o el més aviat possible'
    },
    'de-DE': {
        'title': 'SUPERFRISCHES PRODUKT',
        'description': 'Dieses Produkt ist nur begrenzt vorrätig, um sicherzustellen, dass es superfrisch ist. Wir empfehlen, 3 Tage im Voraus zu bestellen, um die Verfügbarkeit zu gewährleisten. Für dringende Bestellungen mit weniger Zeit: Wir werden unser Bestes tun, um sie zum gewünschten Datum oder so schnell wie möglich zu liefern'
    },
    'fr-FR': {
        'title': 'PRODUIT SUPER FRAIS',
        'description': ' There\'s limited stock of this product to warranty it\'s super fresh. We recommend ordering with 3 days in advance to ensure availability. To urgent orders with less time: we\'ll do our best to seve it at the requested date or as soon as possible'
    },
    'en-GB': {
        'title': 'SUPERFRESH PRODUCT',
        'description': 'Il y a un stock limité de ce produit pour garantir qu\'il est super frais. Nous vous recommandons de commander avec 3 jours à l\'avance pour garantir la disponibilité. Pour les commandes urgentes avec moins de temps: nous ferons de notre mieux pour le régler à la date demandée ou dès que possible'
    },
    'pt-PT': {
        'title': 'PRODUTO SUPER FRESCO',
        'description': 'Há estoques limitados deste produto para garantir que ele seja super fresco. Recomendamos fazer o pedido com 3 dias de antecedência para assegurar a disponibilidade. Para pedidos urgentes com menos tempo: faremos o possível para atendê-lo na data solicitada ou o mais breve possível'
    }
};
exports.ToolTip = (0, react_1.memo)(({ showTooltip }) => {
    const { locale } = (0, router_1.useRouter)();
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: 'wait' }, { children: showTooltip && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Wrapper, Object.assign({ className: 'tooltip', "$active": showTooltip, variants: exports.listToolTipVariants, initial: 'inactive', animate: 'enter', exit: 'exit' }, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: 'title' }, { children: TRANSLATIONS[locale].title })), (0, jsx_runtime_1.jsxs)("p", Object.assign({ className: 'description' }, { children: [TRANSLATIONS[locale].description, " "] }))] })) })) })));
});
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.darkred};
  height: ${(0, styles_1.vw)(170, 'mobile')};
  left: ${(0, styles_1.vw)(-75, 'mobile')};
  padding: ${(0, styles_1.vw)(21, 'mobile')} ${(0, styles_1.vw)(10, 'mobile')};
  position: relative;
  top: ${(0, styles_1.vw)(10, 'mobile')};
  width: ${(0, styles_1.vw)(170, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(170, 'nexus7')};
    left: ${(0, styles_1.vw)(-75, 'nexus7')};
    padding: ${(0, styles_1.vw)(21, 'nexus7')} ${(0, styles_1.vw)(10, 'nexus7')};
    top: ${(0, styles_1.vw)(10, 'nexus7')};
    width: ${(0, styles_1.vw)(170, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${(0, styles_1.vw)(21, 'desktop')} ${(0, styles_1.vw)(10, 'desktop')};
    width: ${(0, styles_1.vw)(270, 'desktop')};
    height: ${(0, styles_1.vw)(150, 'desktop')};
    left: ${(0, styles_1.vw)(-120, 'desktop')};
    top: ${(0, styles_1.vw)(10, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 21px 10px;
    width: 270px;
    height: 150px;
    left: -120px;
    top: 10px;
  }

   &:after{
    content: "";
    display: block;
    border: ${(0, styles_1.vw)(10, 'mobile')} solid transparent;
    border-bottom-color: ${({ theme }) => theme.colors.darkred};
    position: absolute;
    top: ${(0, styles_1.vw)(-20, 'mobile')};
    left: 46%;

    ${styles_1.mq.greaterThan('tablet')} {
      top: ${(0, styles_1.vw)(-20, 'desktop')};
      left: 45%;
      border: ${(0, styles_1.vw)(10, 'desktop')} solid transparent;
      border-bottom-color: ${({ theme }) => theme.colors.darkred};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      top: 20px;
      border: 10px solid transparent;
    }
  }

  p {
    ${(0, styles_1.getP12_1)()}
    background-color: none;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
  }

  .title {
    padding-bottom: ${(0, styles_1.vw)(10, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      padding-bottom: ${(0, styles_1.vw)(10, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding-bottom: ${(0, styles_1.vw)(10, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding-bottom: 10px;
    }
  }
`;


/***/ }),

/***/ 67796:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Accordion = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const AccordionItem_1 = __webpack_require__(44447);
const useAccordion_1 = __webpack_require__(44438);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const getAccordionItems = (items, activeIndex, activeCategory, activeQuestion) => {
    const parsedItems = [];
    for (let item of items) {
        if (Array.isArray(item.content)) {
            const parsedCategory = {
                header: item.header,
                content: (0, jsx_runtime_1.jsx)(exports.Accordion, { items: item.content, activeIndex: activeIndex, activeCategory: activeCategory, activeQuestion: activeQuestion })
            };
            parsedItems.push(parsedCategory);
        }
        else {
            parsedItems.push(item);
        }
    }
    return parsedItems.map((parsedItem, idx) => {
        return ((0, jsx_runtime_1.jsx)(AccordionItem_1.AccordionItem, { data: parsedItem, index: idx, activeCategory: activeCategory, activeQuestion: activeQuestion }, idx));
    });
};
const Accordion = ({ items = [], activeIndex, activeCategory, activeQuestion }) => {
    const [activeItem, setActiveItem, collapseAll] = (0, useAccordion_1.useAccordion)();
    const AccordionItems = (0, react_1.useMemo)(() => getAccordionItems(items, activeIndex, activeCategory, activeQuestion), [items, activeCategory, activeQuestion]);
    const context = (0, react_1.useMemo)(() => ({ activeItem, setActiveItem, collapseAll }), [activeItem]);
    (0, react_1.useEffect)(() => {
        setActiveItem({
            index: activeIndex,
            slug: activeCategory,
            parameterize: activeQuestion,
        });
    }, [activeIndex, activeCategory, activeQuestion]);
    return ((0, jsx_runtime_1.jsx)(useAccordion_1.AccordionContext.Provider, Object.assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(AccordionWrapper, { children: AccordionItems }) })));
};
exports.Accordion = Accordion;
const AccordionWrapper = styled_components_1.default.dl `
  display: flex;
  flex-direction: column;
  width: 100%;

  a > span {
      margin: 10px 0;
  }
`;


/***/ }),

/***/ 44447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AccordionItem = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const useAccordionItem_1 = __webpack_require__(30556);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const framer_motion_1 = __webpack_require__(53316);
const __1 = __webpack_require__(17566);
const utils_1 = __webpack_require__(76079);
const transition = {
    ease: [.25, .1, .25, 1],
    duration: .3,
    type: 'tween'
};
const expandVariants = {
    expanded: {
        height: 'auto',
        display: 'block',
        opacity: 1,
        transition
    },
    collapsed: {
        height: 0,
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition
    },
};
const getFaqs = (faqs = [], slug, locale, asPath, activeQuestion) => faqs.map((faq, idx) => {
    return ((0, jsx_runtime_1.jsx)(__1.Link, Object.assign({ href: `/faqs/${slug[locale]}#${faq.parameterize}` }, { children: (0, jsx_runtime_1.jsx)(LinkAsTitle, Object.assign({ active: faq.parameterize === asPath.split('#')[1] || faq.parameterize === activeQuestion }, { children: faq.question })) }), idx));
});
const AccordionItem = ({ data: { id, name, faqs, slug }, index, activeCategory, activeQuestion }) => {
    var _a;
    const { locale: localeRouter, query, asPath } = (0, router_1.useRouter)();
    const locale = (0, utils_1.getLang)(localeRouter);
    const [trigger, accordion, expanded, toggleExpanded, onKeyDown] = (0, useAccordionItem_1.useAccordionItem)(index, slug, locale);
    const triggerId = `${id}__trigger`;
    const regionId = `${id}__region`;
    const href = `/faqs/${slug[locale]}`;
    // @ts-ignore
    const active = (0, react_1.useMemo)(() => (slug[locale] === (query === null || query === void 0 ? void 0 : query.slug) || slug[locale] === activeCategory), [query, activeCategory]);
    const onClick = () => {
        toggleExpanded();
    };
    (0, react_1.useEffect)(() => {
        if (active && !expanded)
            toggleExpanded();
    }, [active]);
    const Faqs = (0, react_1.useMemo)(() => getFaqs(faqs, slug, locale, asPath, activeQuestion), [faqs, slug, locale, asPath, activeQuestion]);
    const firstQuestionHash = (_a = faqs === null || faqs === void 0 ? void 0 : faqs[0]) === null || _a === void 0 ? void 0 : _a.parameterize;
    if (Faqs.length === 0)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(AccordionTitle, Object.assign({ ref: trigger, id: triggerId, role: 'button', onClick: onClick, tabIndex: 0, "aria-expanded": expanded, "aria-controls": regionId, onKeyDown: onKeyDown }, { children: [(0, jsx_runtime_1.jsx)(__1.Link, Object.assign({ href: `${href}#${firstQuestionHash}` }, { children: (0, jsx_runtime_1.jsx)(LinkAsTitle, Object.assign({ active: active }, { children: name })) })), (0, jsx_runtime_1.jsx)(Chevron, Object.assign({ "aria-hidden": true, animate: { rotate: expanded ? 90 : 0 }, transition: transition }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--chevron.svg', alt: 'Icon chevron', width: '6', height: '8' }) }))] })), (0, jsx_runtime_1.jsx)(AccordionContent, Object.assign({ ref: accordion, role: 'region', id: regionId, "aria-labelledby": triggerId, tabIndex: -1, animate: expanded ? 'expanded' : 'collapsed', initial: 'collapsed', variants: expandVariants }, { children: Faqs }))] }));
};
exports.AccordionItem = AccordionItem;
const AccordionTitle = styled_components_1.default.dt `
  color: ${({ theme }) => theme.colors.darkred};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  transition: 200ms margin-bottom ease-out, 200ms color ease-in-out;
  width: 100%;

  a {
    ${(0, styles_1.getP18_2)()}
    margin-bottom: 0;
    opacity: 1;

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: 0;
    }
  }

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 10px;
  }

  &:focus {
    outline: 0;
  }

  &:hover {
  color: ${({ theme }) => theme.colors.darkred};
  }

  &[aria-expanded='true'] {
    color: ${({ theme }) => theme.colors.darkred};
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 20px;
    }

    span {
      opacity: 1;
    }
  }
`;
const LinkAsTitle = styled_components_1.default.span `
  ${(0, styles_1.getP15_2)()}
  color: inherit;
  display: block;
  font-weight: 500;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  opacity: ${({ active }) => active ? 1 : .4};
  text-decoration: none;
  transition: 200ms opacity ease-in-out;
  width: 100%;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 20px;
  }

  &:hover {
    opacity: 1;
  }
`;
const AccordionContent = (0, styled_components_1.default)(framer_motion_1.motion.dd) `
  ${(0, styles_1.getP15_2)()}
  color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, 1)};
  margin-bottom: ${(0, styles_1.vw)(30, 'mobile')};
  overflow: hidden;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    padding-left: ${(0, styles_1.vw)(20, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
  }

  &:focus {
    outline: 0;
  }
`;
const Chevron = (0, styled_components_1.default)(framer_motion_1.motion.span) `
  display: inline-block;
  margin-left: 10px;
  opacity: .3;
  user-select: none;
`;


/***/ }),

/***/ 55675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(67796), exports);


/***/ }),

/***/ 44438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAccordion = exports.AccordionContext = void 0;
const react_1 = __webpack_require__(2784);
const initialState = {
    index: null,
    slug: null,
    parameterize: null,
};
exports.AccordionContext = (0, react_1.createContext)(null);
const useAccordion = () => {
    const [activeItem, setActiveItem] = (0, react_1.useState)(initialState);
    const collapseAll = () => {
        setActiveItem(initialState);
    };
    return [activeItem, setActiveItem, collapseAll];
};
exports.useAccordion = useAccordion;


/***/ }),

/***/ 30556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAccordionItem = void 0;
const react_1 = __webpack_require__(2784);
const useAccordion_1 = __webpack_require__(44438);
const useAccordionItem = (index, slug, locale) => {
    const triggerRef = (0, react_1.useRef)(null);
    const accordionRef = (0, react_1.useRef)(null);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const { activeItem, setActiveItem } = (0, react_1.useContext)(useAccordion_1.AccordionContext);
    const onToggle = (0, react_1.useCallback)(() => {
        setActiveItem({ index: index === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.index) ? null : index, slug: index === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.index) ? null : slug[locale], parameterize: null });
        setExpanded(!expanded);
    }, [activeItem, expanded]);
    (0, react_1.useEffect)(() => {
        setExpanded(index === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.index));
    }, [activeItem]);
    const onKeyDown = e => {
        switch (e.key) {
            case ' ':
            case 'Enter':
                e.preventDefault();
                onToggle();
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (triggerRef.current && triggerRef.current.nextElementSibling && triggerRef.current.nextElementSibling.nextElementSibling) {
                    triggerRef.current.nextElementSibling.nextElementSibling.focus();
                }
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (triggerRef.current && triggerRef.current.previousElementSibling && triggerRef.current.previousElementSibling.previousElementSibling) {
                    triggerRef.current.previousElementSibling.previousElementSibling.focus();
                }
                break;
            case 'Home':
            case 'End':
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    return [triggerRef, accordionRef, expanded, onToggle, onKeyDown, activeItem];
};
exports.useAccordionItem = useAccordionItem;


/***/ }),

/***/ 71198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Button = exports.handleBgTypeHover = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const styles_1 = __webpack_require__(73267);
const styled_components_2 = __webpack_require__(19453);
const handleBgTypeHover = (bgType, theme) => {
    var _a, _b, _c, _d;
    switch (bgType) {
        case 'frozen':
            return (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.dark_frozen;
        case 'red':
            return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.creme;
        case 'white':
            return (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.creme;
        default:
            return (_d = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _d === void 0 ? void 0 : _d.red;
    }
};
exports.handleBgTypeHover = handleBgTypeHover;
exports.Button = (0, react_1.memo)(({ bgType = 'darkcreme', children, circle = false, disabled = false, className = '', id, name = 'Button', onClick = null, outline = false, type = 'button', uppercase = false, noHoverEffect = false, initial, variants, exit, animate, custom }) => {
    return ((0, jsx_runtime_1.jsxs)(ButtonStyled, Object.assign({}, (id && { id }), { className: className, onClick: onClick, type: type, "$bgType": bgType, "$circle": circle, disabled: disabled, "$uppercase": uppercase, name: name, "$outline": outline, "$noHoverEffect": noHoverEffect }, (initial && { initial }), (variants && { variants }), (exit && { exit }), (animate && { animate }), (custom && { custom }), { children: [(0, jsx_runtime_1.jsx)("div", { className: 'button__bg' }), (0, jsx_runtime_1.jsx)("div", { children: children })] })));
});
const ButtonStyled = (0, styled_components_1.default)(framer_motion_1.motion.button) `
  ${(0, styles_1.getP15)()}
  align-items: center;
  background-color: ${({ $bgType, theme, $outline }) => $outline ? 'transparent' : theme.colors[$bgType]};
  color: ${({ theme, $bgType, $outline }) => { var _a; return $outline ? theme.colors[$bgType] : (_a = theme.colors) === null || _a === void 0 ? void 0 : _a[$bgType === 'background' ? 'darkred' : $bgType === 'creme' || $bgType === 'white' ? 'red' : 'white']; }};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  justify-content: center;
  letter-spacing: 0;
  margin: 0 auto;
  position: relative;
  text-transform: ${({ $uppercase }) => $uppercase ? 'uppercase' : 'initial'};

  ${styles_1.mq.greaterThan('tablet')} {
    ${(0, styles_1.getP18_1B)()}
  }

  ${({ $circle }) => $circle ? (0, styled_components_2.css) `
    height: ${(0, styles_1.vw)(38, 'mobile')};
    padding: 0 ;
    width: ${(0, styles_1.vw)(38, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(38, 'nexus7')} ;
      width: ${(0, styles_1.vw)(38, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height:${(0, styles_1.vw)(40, 'desktop')};
      width:${(0, styles_1.vw)(40, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
      width: 40px;
    }
    ` : (0, styled_components_2.css) `
    height:${(0, styles_1.vw)(50, 'mobile')};
    padding:${(0, styles_1.vw)(17, 'mobile')} ${(0, styles_1.vw)(30, 'mobile')};
    width:unset;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
      padding:${(0, styles_1.vw)(17, 'nexus7')} ${(0, styles_1.vw)(30, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height:${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(19, 'desktop')} ${(0, styles_1.vw)(43, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height:60px;
      padding: 19px 43px;
    }
  `}



  &[type='submit'] {
    ${(0, styles_1.getP15)()}
  }

  &,
  &:before {
    transition: 300ms background-color ${({ ease }) => ease}, 300ms border ${({ ease }) => ease}, 300ms color ${({ ease }) => ease}, 300ms filter ${({ ease }) => ease}, 300ms opacity ${({ ease }) => ease};

    ${({ $circle }) => $circle ? (0, styled_components_2.css) `
      border-radius: 50%;
    
      ` : (0, styled_components_2.css) `
      border-radius:${(0, styles_1.vw)(30, 'mobile')};


      ${styles_1.mq.greaterThan('nexus7')} {
        border-radius:${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        border-radius:${(0, styles_1.vw)(30, 'desktop')};
      }
      
      ${styles_1.mq.greaterThan('desktop')} {
        border-radius: 30px;
      }
    `}
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: .4;
    pointer-events: none;

    &:before {
      content: none;
      display: none;
    }
  }


  > div:last-of-type {
    ${(0, styles_1.getP15)()}
    align-items: center;
    color: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.secondaryFont};
    width: 100%;
    z-index: 2;
    transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
    white-space: nowrap;

    img {
      padding: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        padding: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        padding: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        padding: 10px;
      }
    }
  }

  .button__bg {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
    background: ${({ $bgType, theme, $outline }) => $outline ? 'transparent' : theme.colors[$bgType]};
    border: ${({ $bgType, theme, $outline }) => $outline ? `1px solid ${theme.colors[$bgType]}` : 'none'};
   
    ${({ $circle }) => $circle ? (0, styled_components_2.css) `
      border-radius: 50%;
    ` : (0, styled_components_2.css) `
      border-radius:${(0, styles_1.vw)(30, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        border-radius:${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        border-radius:${(0, styles_1.vw)(30, 'desktop')};
      }
      
      ${styles_1.mq.greaterThan('desktop')} {
        border-radius: 30px;
      }
    `}

    &:before,
    &:after {
      content: '';
      position: absolute;
      z-index: -1;
      background-color: ${({ $bgType, theme, $circle, $outline }) => $circle || $outline ? 'transparent' : (0, exports.handleBgTypeHover)($bgType, theme)};
    }

    &:before {
      width: 110%;
      height: 0;
      padding-bottom: 110%;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      transform: translate3d(-50%,-50%,0) scale3d(0,0,1);
    }

    &:after {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s;
    }
  }

  &:hover {
    color: ${({ theme, $outline, $bgType }) => $outline ? theme.colors[$bgType] : theme.colors.white};

    .button__bg {
      transform: 'none';

      ${styles_1.mq.greaterThan('tablet')} {
        transform: ${({ $circle, $noHoverEffect }) => $noHoverEffect ? 'none' : $circle ? 'scale3d(1.2,1.2,1)' : 'scale3d(1.1,1.2,1)'};
      }

      &:before {
        transition: transform 0.4s cubic-bezier(0.1, 0, 0.3, 1);
        transform: translate3d(-50%,-50%,0) scale3d(1,1,1);
      }

      &:after {
        opacity: 1;
        transition-duration: 0.01s;
        transition-delay: 0.3s;
      }
    }
  }
`;


/***/ }),

/***/ 26267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonBack = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const hooks_1 = __webpack_require__(92757);
exports.ButtonBack = (0, react_1.memo)(({ sticky = false }) => {
    const scrollState = (0, hooks_1.useScrollTracker)(80);
    const scrollTop = (0, react_1.useMemo)(() => scrollState === 'TOP', [scrollState]);
    const router = (0, router_1.useRouter)() || { back: () => { } };
    const onClick = () => {
        router.back();
    };
    return ((0, jsx_runtime_1.jsx)(Button, Object.assign({ sticky: sticky, scrollTop: scrollTop, onClick: onClick, title: 'Ir atr\u00E1s' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--chevron--white.svg', alt: 'Icon arrow back', width: '16', height: '16' }) })));
});
const Button = styled_components_1.default.button `
  align-items: center;
  background-color: #262626;
  border-radius: ${({ sticky }) => sticky ? 0 : '50%'};
  display: flex;
  height: ${(0, styles_1.vw)(50, 'mobile')};
  justify-content: center;
  left: ${(0, styles_1.vw)(20, 'mobile')};
  position: fixed;
  top: 82px;
  transition: 200ms all ${({ theme }) => theme.ease};
  width: ${(0, styles_1.vw)(50, 'mobile')};
  z-index: 20;

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${(0, styles_1.vw)(50, 'nexus7')};
    left: ${(0, styles_1.vw)(20, 'nexus7')};
    width: ${(0, styles_1.vw)(50, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${(0, styles_1.vw)(80, 'desktop')};
    left: ${({ sticky }) => sticky ? 0 : `${(0, styles_1.vw)(20, 'desktop')}`};
    top: ${({ sticky, scrollTop }) => sticky ? '80px' : `${scrollTop ? '120px' : '92px'}`};
    width: ${({ sticky }) => (0, styles_1.vw)(sticky ? 120 : 80, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: 80px;
    left: ${({ sticky }) => sticky ? 0 : '20px'};
    top: ${({ sticky, scrollTop }) => sticky ? '80px' : `${scrollTop ? '120px' : '92px'}`};
    width: ${({ sticky }) => sticky ? '120px' : '80px'};
  }

  img {
    transform: rotate(90deg);
    width: ${(0, styles_1.vw)(8, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      width: ${(0, styles_1.vw)(8, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      width: ${(0, styles_1.vw)(18, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      width: 18px;
    }
  }
`;


/***/ }),

/***/ 70827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(71198), exports);
__exportStar(__webpack_require__(26267), exports);


/***/ }),

/***/ 8556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dropdown = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const useDropdown_1 = __webpack_require__(52979);
const styles_1 = __webpack_require__(73267);
const getOptions = (options, onClickOption, currentSelection) => {
    return options.map((option, idx) => ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: option.text === currentSelection ? 'active' : '' }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => { onClickOption(option); } }, { children: option.text })) }), idx)));
};
const getInitialSelection = (options) => {
    var _a, _b;
    if ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.currentVariantId) {
        const selected = options.filter((option) => option.variant.bigcommerce_id === option.currentVariantId)[0];
        return (_b = selected === null || selected === void 0 ? void 0 : selected.text) !== null && _b !== void 0 ? _b : options[0];
    }
    else {
        return options[0];
    }
};
exports.Dropdown = (0, react_1.memo)(({ className = '', trigger, options }) => {
    const [triggerRef, dropdownRef, expanded, toggleExpanded] = (0, useDropdown_1.useDropdown)();
    const [currentSelection, setSelection] = (0, react_1.useState)(getInitialSelection(options));
    const onClickOption = (option) => {
        var _a;
        toggleExpanded();
        setSelection((_a = option.text) !== null && _a !== void 0 ? _a : option);
        // Exception for variants
        option.setCurrentVariant && option.setCurrentVariant(option.variant);
    };
    const Options = (0, react_1.useMemo)(() => getOptions(options, onClickOption, currentSelection), [options]);
    return ((0, jsx_runtime_1.jsxs)(DropdownWrapper, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)("button", Object.assign({ className: 'triggerButton', ref: triggerRef, type: 'button', onClick: toggleExpanded }, { children: [trigger, (0, jsx_runtime_1.jsx)("span", Object.assign({ "data-expanded": expanded }, { children: currentSelection }))] })), (0, jsx_runtime_1.jsx)(OptionsList, Object.assign({ ref: dropdownRef, initial: 'collapsed', variants: optionsListVariants, animate: expanded ? 'expanded' : 'collapsed' }, { children: Options }))] })));
});
const DropdownWrapper = styled_components_1.default.div `
  .triggerButton {
    ${(0, styles_1.getP18_1)()}
    color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.black, 0.5)};

    span {
      color: ${({ theme }) => theme.colors.black};
      position: relative;
      margin-left: ${(0, styles_1.vw)(10, 'mobile')};

      &::after {
        content: url('/images/svg/arrow-down.svg');
        display: inline-block;
        transition: transform 300ms ${({ theme }) => theme.ease};
        margin-left: ${(0, styles_1.vw)(10, 'mobile')};
      }

      &[data-expanded='true']::after {
        transform: rotate(-180deg);
      }
    }
  }

  ${styles_1.mq.greaterThan('nexus7')} {
    .triggerButton span {
      margin-left: ${(0, styles_1.vw)(10, 'nexus7')};

      &::after { margin-left: ${(0, styles_1.vw)(10, 'nexus7')}; }
    }
  }

  ${styles_1.mq.greaterThan('tablet')} {
    .triggerButton span {
      margin-left: ${(0, styles_1.vw)(10, 'desktop')};

      &::after { margin-left: ${(0, styles_1.vw)(10, 'desktop')}; }
    }
  }

  ${styles_1.mq.greaterThan('desktop')} {
    .triggerButton span {
      margin-left: 10px;

      &::after { margin-left: 10px; }
    }
  }
`;
const OptionsList = (0, styled_components_1.default)(framer_motion_1.motion.ul) `
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 4px 0 rgba(0,0,0, .2);
  right: 0;
  top: 100%;
  height: 0;
  opacity: 0;
  overflow-y: auto;
  padding: ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(30, 'mobile')} ${(0, styles_1.vw)(30, 'mobile')};
  position: absolute;
  width: auto;
  z-index: 10;
  ${(0, styles_1.hideScrollbar)()}

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(30, 'nexus7')} ${(0, styles_1.vw)(30, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${(0, styles_1.vw)(20, 'desktop')} ${(0, styles_1.vw)(30, 'desktop')} ${(0, styles_1.vw)(30, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 20px 30px 30px;
  }

  li {
    cursor: pointer;
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
    opacity: .4;
    color: ${({ theme }) => theme.colors.black};
    width: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    transition: opacity 300ms ${({ theme }) => theme.ease}, background-color 300ms ${({ theme }) => theme.ease};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 20px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &:active,
    &:hover,
    &.active {
      opacity: 1;
    }

    button {
      ${(0, styles_1.getP18_1)()}
    }
  }
`;
const optionsListVariants = {
    collapsed: {
        height: '0',
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
    expanded: {
        height: 'auto',
        opacity: 1,
        display: 'block',
        transition: Object.assign({}, (0, styles_1.getTransition)())
    }
};


/***/ }),

/***/ 74494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(8556), exports);
__exportStar(__webpack_require__(52979), exports);


/***/ }),

/***/ 52979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDropdown = void 0;
const react_1 = __webpack_require__(2784);
const useDropdown = ({ onChange } = { onChange: null }) => {
    const triggerRef = (0, react_1.useRef)(null);
    const dropdownRef = (0, react_1.useRef)(null);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const toggleExpanded = (0, react_1.useCallback)(() => {
        setExpanded((state) => !state);
    }, []);
    const onTriggerFocus = (0, react_1.useCallback)(() => {
        if (!expanded)
            setExpanded(true);
    }, [expanded]);
    const onMouseClick = (0, react_1.useCallback)(({ target }) => {
        const triggerClicked = triggerRef.current ? triggerRef.current.contains(target) : null;
        const dropdownClicked = dropdownRef.current ? dropdownRef.current.contains(target) : null;
        if (!triggerClicked && !dropdownClicked) { // outside click
            setExpanded(false);
        }
        else if (dropdownClicked) { // dropdown list click
            if (target instanceof HTMLAnchorElement || (target instanceof HTMLButtonElement && target.dataset.dismiss) || target.dataset.value) {
                const value = target.dataset.value;
                const text = target.textContent;
                onChange && onChange(value, text);
                // NOTE setExpanded shouldBeManaged in the onClick option event, to avoid this mouseCLick to run before and close dropdown before all events have been run.
                // setTimeout(() => {
                //   setExpanded(false)
                // }, 90)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onEsc = (0, react_1.useCallback)(e => {
        if (e.keyCode === 27 && expanded === true)
            setExpanded(false);
    }, [expanded]);
    (0, react_1.useEffect)(() => {
        document[`${expanded ? 'add' : 'remove'}EventListener`]('mousedown', onMouseClick);
        window[`${expanded ? 'add' : 'remove'}EventListener`]('keyup', onEsc);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expanded]);
    return [triggerRef, dropdownRef, expanded, onTriggerFocus, toggleExpanded];
};
exports.useDropdown = useDropdown;


/***/ }),

/***/ 69799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Favicon = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const styles_1 = __webpack_require__(73267);
const Favicon = () => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("link", { rel: 'icon', type: 'image/x-icon', sizes: '16x16', href: '/favicon/favico.ico' }), (0, jsx_runtime_1.jsx)("link", { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon/favicon-16x16.png' }), (0, jsx_runtime_1.jsx)("link", { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon/favicon-32x32.png' }), (0, jsx_runtime_1.jsx)("link", { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicon/apple-touch-icon.png' }), (0, jsx_runtime_1.jsx)("link", { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/favicon/android-chrome-192x192.png' }), (0, jsx_runtime_1.jsx)("link", { rel: 'icon', type: 'image/png', sizes: '512x512', href: '/favicon/android-chrome-512x512.png' }), (0, jsx_runtime_1.jsx)("link", { rel: 'manifest', href: '/favicon/site.webmanifest' }), (0, jsx_runtime_1.jsx)("link", { rel: 'mask-icon', href: '/favicon/safari-pinned-tab.svg', color: styles_1.themeProject.colors.creme }), (0, jsx_runtime_1.jsx)("meta", { name: 'apple-mobile-web-app-capable', content: 'yes' }), (0, jsx_runtime_1.jsx)("meta", { name: 'apple-mobile-web-app-status-bar-style', content: 'black' }), (0, jsx_runtime_1.jsx)("meta", { name: 'apple-mobile-web-app-title', content: 'Mammafiore' }), (0, jsx_runtime_1.jsx)("meta", { name: 'application-name', content: 'Mammafiore' }), (0, jsx_runtime_1.jsx)("meta", { name: 'theme-color', content: styles_1.themeProject.colors.creme }), (0, jsx_runtime_1.jsx)("meta", { name: 'msapplication-navbutton-color', content: styles_1.themeProject.colors.creme }), (0, jsx_runtime_1.jsx)("meta", { name: 'msapplication-TileColor', content: styles_1.themeProject.colors.creme })] }));
};
exports.Favicon = Favicon;


/***/ }),

/***/ 17043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeadTag = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const head_1 = __importDefault(__webpack_require__(97729));
const router_1 = __webpack_require__(5632);
const jsonld_1 = __webpack_require__(23805);
const utils_1 = __webpack_require__(76079);
// NOTE: <title> and <meta> elements need to be contained as direct children of the <Head> element,
// or wrapped into maximum one level of <React.Fragment>, otherwise
// the metatags won't be correctly picked up on clientside navigation.
// NOTE:- Segun parece tampoco acepta `Fragments` que son hermanos. Solo pilla el primero.
const generateJson = {
    'contents': (data) => (0, jsonld_1.article)(data),
    'faqs': (data) => (0, jsonld_1.faqs)(data),
    'home': (data) => (0, jsonld_1.home)(data),
    'product': (data, region, locale) => (0, jsonld_1.product)({ data, region, locale }),
    'products': (data, region, locale) => (0, jsonld_1.products)({ data, region, locale }),
    'search': (_data, _region, locale) => (0, jsonld_1.search)({ locale }),
    'article': (data, region, locale) => (0, jsonld_1.article)({ data, region, locale, hostname: utils_1.HOSTNAME }),
    'journal': (data, region, locale) => (0, jsonld_1.articles)({ data, region, locale, hostname: utils_1.HOSTNAME })
};
const defaultOgImage = {
    default: `https://${utils_1.HOSTNAME}/images/og_cover.jpg`,
    content_type: 'image/jpg',
    alt: 'Mammafiore',
    size: {
        height: 627,
        width: 1200
    }
};
const pathnameByPageType = {
    'home': '/',
    'contents': '/page',
    'products': '/catalog',
    'product': '/catalog/product',
};
const generateCanonicalAndAlternates = ({ locale, pageType, slug }) => {
    var _a;
    const localeSlug = (slug !== 'search') ? (typeof slug === 'string') ? slug : slug[locale] : '';
    const href = `https://${utils_1.HOSTNAME}${(_a = pathnameByPageType[pageType]) !== null && _a !== void 0 ? _a : `/${pageType}`}${localeSlug ? `/${localeSlug}` : ''}`;
    const hrefLang = locale;
    return (0, jsx_runtime_1.jsx)("link", { rel: 'canonical', href: href, hrefLang: hrefLang }, 'canonical');
};
const robots = utils_1.PRO && (utils_1.NEXT_PUBLIC_LOCALE === 'es-ES' || utils_1.NEXT_PUBLIC_LOCALE === 'fr-FR' || utils_1.NEXT_PUBLIC_LOCALE === 'en-GB' || utils_1.NEXT_PUBLIC_LOCALE === 'de-DE' || utils_1.NEXT_PUBLIC_LOCALE === 'pt-PT') ? 'all' : 'noindex, follow';
const HeadTag = ({ seo, jsonld = null, slug = null, pageType = null }) => {
    var _a;
    const { locale: localeRouter, query } = (0, router_1.useRouter)();
    const locale = (0, utils_1.getLang)(localeRouter);
    const image = defaultOgImage;
    const OgImages = [
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image', content: image.default }, 'og:image'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image:alt', content: image.alt }, 'og:image:alt'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image:type', content: image.content_type }, 'og:image:type'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image:secure_url', content: image.default }, 'og:image:secure_url'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image:height', content: `${image.size.height}` }, 'og:image:height'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:image:width', content: `${image.size.width}` }, 'og:image:width'),
    ];
    const OgBase = [
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:description', content: seo.description }, 'og:description'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:locale', content: `${locale}` }, 'og:locale'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:site_name', content: 'Mammafiore' }, 'og:site_name'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:title', content: seo.title }, 'og:title'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:type', content: 'website' }, 'og:type'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:url', content: utils_1.HOSTNAME }, 'og:url'),
    ];
    const OgVideo = seo.video ? [
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:video:type', content: seo.video.content_type }, 'og:video:type'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:video:secure_url', content: seo.video.default }, 'og:video:secure_url'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:video:height', content: `${seo.video.size.height}` }, 'og:video:height'),
        (0, jsx_runtime_1.jsx)("meta", { property: 'og:video:width', content: `${seo.video.size.width}` }, 'og:video:width'),
    ] : [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const CanonicalAndAlternates = (0, react_1.useMemo)(() => slug || slug === '' ? generateCanonicalAndAlternates({ locale, pageType, slug }) : [], [locale, pageType, slug]);
    return ((0, jsx_runtime_1.jsxs)(head_1.default, { children: [(0, jsx_runtime_1.jsx)("title", { children: seo.title }), (0, jsx_runtime_1.jsx)("meta", { name: 'description', content: seo.description }), (0, jsx_runtime_1.jsx)("meta", { name: 'robots', content: robots }), OgBase, OgImages, OgVideo, jsonld && (0, jsx_runtime_1.jsx)("script", { type: 'application/ld+json', dangerouslySetInnerHTML: { __html: generateJson[(_a = jsonld.type) !== null && _a !== void 0 ? _a : pageType](jsonld.data, query.region, locale) } }), CanonicalAndAlternates] }));
};
exports.HeadTag = HeadTag;


/***/ }),

/***/ 88823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(69799), exports);
__exportStar(__webpack_require__(17043), exports);


/***/ }),

/***/ 20982:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.article = void 0;
/* eslint-disable quotes */
const article = ({ data, region, locale, hostname, articlePage = true }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!data)
        return null;
    const image = articlePage ? (_f = (_e = (_d = (_c = (_b = (_a = data.header) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.medium) === null || _d === void 0 ? void 0 : _d.default) === null || _e === void 0 ? void 0 : _e['2x']) === null || _f === void 0 ? void 0 : _f.regular : (_k = (_j = (_h = (_g = data.image) === null || _g === void 0 ? void 0 : _g.media) === null || _h === void 0 ? void 0 : _h.default) === null || _j === void 0 ? void 0 : _j['2x']) === null || _k === void 0 ? void 0 : _k.regular;
    const url = `${hostname}/${locale}/${region}/stories/${data.slug[locale]}`;
    const articleSchema = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ "@context": "https://schema.org", "@type": "NewsArticle", "mainEntityOfPage": url, "url": url, "headline": `${data.name}` }, (data.shortDescription && { "description": `${data.shortDescription}` })), (data.shortDescription && { "articleBody": `${data.shortDescription}` })), (image && { "image": [image] })), (data.publishedAt && { "datePublished": data.publishedAt.split('.').reverse().join('-') })), { 
        // "dateModified": "2021-02-05T09:20:00+08:00",
        "publisher": {
            "@type": "Organization",
            "name": "Mammafiore",
            "logo": {
                "@type": "ImageObject",
                "url": `${hostname}/images/logo--mammafiore.png`
            }
        } });
    return articlePage ? JSON.stringify(articleSchema) : articleSchema;
};
exports.article = article;


/***/ }),

/***/ 47698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articles = void 0;
/* eslint-disable quotes */
const _1 = __webpack_require__(23805);
const articles = ({ data, region = 'ESP', locale = 'en', hostname }) => {
    const items = data;
    const productsPage = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": [
            items.map((item, idx) => ({
                "@type": "ListItem",
                "position": `${idx + 1}`,
                "item": (0, _1.article)({ data: item, region, locale, articlePage: false, hostname })
            }))
        ]
    };
    return JSON.stringify(productsPage);
};
exports.articles = articles;


/***/ }),

/***/ 38459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.faqs = void 0;
/* eslint-disable quotes */
const faqs = (data) => {
    if (!data)
        return null;
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": data.faqs.map((faq) => ({
            "@type": "Question",
            "name": `${faq.question}`,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `${faq.answer}`
            }
        }))
    });
};
exports.faqs = faqs;


/***/ }),

/***/ 8169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.home = void 0;
/* eslint-disable quotes */
const utils_1 = __webpack_require__(76079);
const hostnameUrl = 'https://' + utils_1.HOSTNAME;
const home = (data) => {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "",
        "name": "Mammafiore",
        "url": hostnameUrl,
        "isPartOf": {
            "@type": "WebSite"
        },
        "publisher": Object.assign(Object.assign(Object.assign({ "@type": "Store" }, (data.seo && { "name": `${data.seo.title}` })), (data.seo && { "description": `${data.seo.description}` })), { "brand": "Mammafiore", "email": "support@mammafiore.eu", "url": hostnameUrl, "sameAs": [
                'https://www.instagram.com/mammafiore_official/',
                'https://www.facebook.com/mammafiore/',
                'https://es.linkedin.com/company/mammafiore',
                'https://www.youtube.com/channel/UCuDpwGtXsWSSvaWn_ZBIavA'
            ], "image": `${hostnameUrl}/images/og_cover.jpg`, "priceRange": "45 - 300", "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "email": "supporto@mammafiore.eu",
                    "contactType": "customer service",
                    "availableLanguage": ["English", "Spanish", "Catalan", "French", "Italian", "Deutsch"]
                }
            ], "logo": "https://mammafiore.eu/images/logo--mammafiore.png", "openingHours": "Mo-Fr 09:00-18:30", "currenciesAccepted": "EUR", "paymentAccepted": "Credit Card, Visa" })
    });
};
exports.home = home;


/***/ }),

/***/ 23805:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(20982), exports);
__exportStar(__webpack_require__(47698), exports);
__exportStar(__webpack_require__(38459), exports);
__exportStar(__webpack_require__(8169), exports);
__exportStar(__webpack_require__(96828), exports);
__exportStar(__webpack_require__(49008), exports);
__exportStar(__webpack_require__(95219), exports);


/***/ }),

/***/ 96828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productGrid = exports.product = void 0;
/* eslint-disable quotes */
const utils_1 = __webpack_require__(76079);
const getColorVariants = (options) => {
    let colorVariants = [];
    if (!Array.isArray(options))
        return colorVariants;
    for (let option of options) {
        if (option.optionType === 'color') {
            colorVariants = Array.isArray(option.optionValues) ? option.optionValues : [];
            break;
        }
    }
    return colorVariants;
};
const TRANSLATIONS = {
    'de': {
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "name": "Keine Rückgaberegelung",
            "description": "Dieser Artikel wird wie besehen verkauft und kann nicht zurückgegeben werden."
        }
    },
    'en': {
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "name": "No Return Policy",
            "description": "This item is sold as-is and cannot be returned."
        }
    },
    'es': {
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "name": "Política de Devolución No Disponible",
            "description": "Este artículo se vende tal cual y no se puede devolver."
        }
    },
    'fr': {
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "name": "Politique de Retour Non Disponible",
            "description": "Cet article est vendu tel quel et ne peut pas être retourné."
        }
    },
    'pt': {
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "name": "Política de Devolução Não Disponível",
            "description": "Este artigo é vendido como está e não pode ser devolvido."
        }
    }
};
const product = ({ data, region = 'ES', locale = 'es', productPage = true, gridUrl = null }) => {
    var _a, _b, _c, _d, _e;
    const { brand, name, description, variant, variants, sku, pack, slug, labels, filters } = data;
    const currentVariant = variants ? variants[0] : null;
    const image = (_d = (_c = (_b = (_a = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.media) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.medium) === null || _c === void 0 ? void 0 : _c.default) === null || _d === void 0 ? void 0 : _d.src;
    const url = `https://${utils_1.HOSTNAME}/${productPage ? `product/${slug[locale]}` : `catalog/${gridUrl}#${slug[locale]}`}`;
    const filter = filters === null || filters === void 0 ? void 0 : filters.map((item) => item.name);
    const keywords = labels.map((item) => item.name);
    const offers = (item) => {
        var _a, _b, _c, _d, _e;
        return (Object.assign(Object.assign({ "@type": "Offer" }, (slug && { "url": url })), { "priceCurrency": `${(_b = (_a = utils_1.currencyBasedOnRegion[region]) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : 'EUR'}`, "price": `${((_c = item.prices) === null || _c === void 0 ? void 0 : _c.price_inc_tax) ? item.prices.price_inc_tax : '0.00'}`, 
            // ...(item.price.validUntil && { "priceValidUntil": `${item.price.validUntil}` }),
            "itemCondition": "https://schema.org/NewCondition", "availability": `https://schema.org/${(currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.stock) > 1 ? 'InStock' : 'OutOfStock'}`, "inventoryLevel": `${(_d = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.stock) !== null && _d !== void 0 ? _d : '0'}`, "sku": `${Array.isArray(item.sku) ? (_e = item.sku) === null || _e === void 0 ? void 0 : _e[0] : item.sku}`, "seller": {
                "@type": "Organization",
                "name": "Mammafiore",
            } }));
    };
    const productSchema = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (productPage && { "@context": "https://schema.org/" })), { "@type": `${pack ? 'ProductGroup' : 'Product'}`, "name": `${name}` }), (image && { "image": `${image}` })), (description && { "description": `${description}` })), (data.mpn && { "mpn": `${data.mpn}` })), (brand && { "brand": { "@type": "Brand", "name": `${brand.name}` } })), { "sku": `${sku}` }), ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 && { "category": `${filter.toString()}` })), (labels.length > 0 && { "keywords": `${keywords.toString()}` })), (currentVariant && { "weight": `${currentVariant.name}` })), ((variants === null || variants === void 0 ? void 0 : variants.length) > 0 && { "hasVariant": variants.map((item) => `${item.sku}`) })), ((variants === null || variants === void 0 ? void 0 : variants.length) > 0 && { "offers": variants.map((item) => offers(item)) })), (variant && { "offers": offers(variant) })), { "hasMerchantReturnPolicy": Object.assign({}, (_e = TRANSLATIONS[locale]) === null || _e === void 0 ? void 0 : _e.hasMerchantReturnPolicy) });
    return productPage ? JSON.stringify(productSchema) : productSchema;
};
exports.product = product;
const productGrid = ({ data, region, locale }) => {
    var _a, _b, _c;
    const { media, product, sku, price, ean } = data;
    const { description, name, slug, brand, filters, labels, stock } = product;
    const image = (_a = media === null || media === void 0 ? void 0 : media[0]) === null || _a === void 0 ? void 0 : _a.medium;
    const filter = filters === null || filters === void 0 ? void 0 : filters.map((item) => item.name);
    const keywords = labels === null || labels === void 0 ? void 0 : labels.map((item) => item.name);
    const url = `https://${utils_1.HOSTNAME}/catalog/product/${slug[locale]}`;
    const productSchema = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ "@type": "Product", "name": `${name}`, "sku": `${sku}`, "gtin13": `${ean}` }, (image && { "image": `${image.default.src}` })), (description && { "description": `${description}` })), (brand && { "brand": { "@type": "Brand", "name": `${brand.name}` } })), ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 && { "category": `${filter.toString()}` })), ((labels === null || labels === void 0 ? void 0 : labels.length) > 0 && { "keywords": `${keywords.toString()}` })), (data.mpn && { "mpn": `${data.mpn}` })), { "offers": Object.assign(Object.assign({ "@type": "Offer" }, (slug && { "url": url })), { "priceCurrency": `${(_c = (_b = utils_1.currencyBasedOnRegion[region]) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 'EUR'}`, "price": `${price !== null && price !== void 0 ? price : '0.00'}`, 
            // ...(item.price.validUntil && { "priceValidUntil": `${item.price.validUntil}` }),
            "itemCondition": "https://schema.org/NewCondition", "availability": `https://schema.org/${stock > 1 ? 'InStock' : 'OutOfStock'}`, "inventoryLevel": `${stock !== null && stock !== void 0 ? stock : '0'}`, "sku": `${sku}`, "gtin13": `${ean}`, "seller": {
                "@type": "Organization",
                "name": "Mammafiore",
            } }) });
    return productSchema;
};
exports.productGrid = productGrid;


/***/ }),

/***/ 49008:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.products = void 0;
/* eslint-disable quotes */
const _1 = __webpack_require__(23805);
const products = ({ data, region, locale }) => {
    const items = data.variants;
    const productsPage = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": [
            items.map((productItem, idx) => ({
                "@type": "ListItem",
                "position": `${idx}`,
                "item": (0, _1.productGrid)({ data: productItem, region, locale })
            }))
        ]
    };
    return JSON.stringify(productsPage);
};
exports.products = products;


/***/ }),

/***/ 95219:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.search = void 0;
/* eslint-disable quotes */
const search = ({ locale }) => {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "url": `https://www.mammafiore.${locale.toLowerCase()}`,
        "potentialAction": {
            "@type": "SearchAction",
            "target": `https://mammafiore.${locale.toLowerCase()}`,
            "query-input": "required name=search_term_string"
        }
    });
};
exports.search = search;


/***/ }),

/***/ 17566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(94656), exports);
__exportStar(__webpack_require__(88823), exports);
__exportStar(__webpack_require__(80977), exports);
__exportStar(__webpack_require__(362), exports);
__exportStar(__webpack_require__(74494), exports);
__exportStar(__webpack_require__(70827), exports);
__exportStar(__webpack_require__(22468), exports);
__exportStar(__webpack_require__(69451), exports);
__exportStar(__webpack_require__(99155), exports);
__exportStar(__webpack_require__(33239), exports);
__exportStar(__webpack_require__(88252), exports);
__exportStar(__webpack_require__(24638), exports);
__exportStar(__webpack_require__(82564), exports);
__exportStar(__webpack_require__(45391), exports);
__exportStar(__webpack_require__(55675), exports);
__exportStar(__webpack_require__(44308), exports);
__exportStar(__webpack_require__(96794), exports);
__exportStar(__webpack_require__(32392), exports);
__exportStar(__webpack_require__(27929), exports);
__exportStar(__webpack_require__(94551), exports);


/***/ }),

/***/ 92638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Checkbox = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const Input_1 = __webpack_require__(82385);
const styles_1 = __webpack_require__(73267);
const Checkbox = ({ name, label, defaultChecked = false, required = false, disabled = false, readOnly = null, onChange = null, col = 12, register = Input_1.noRegister, textColor = 'darkred', bgColor = 'background', error }) => {
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, onBlur: registerOnBlur, name: registerName, ref: registerRef } = register(name, Object.assign({}, requireProps));
    const [checked, setChecked] = (0, react_1.useState)(defaultChecked);
    const handleChange = e => {
        col;
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
        setChecked(e.target.checked);
    };
    return ((0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$col": col, "$bgColor": bgColor, "$textColor": textColor, "$checked": checked }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({}, registerRef && { ref: registerRef }, { type: 'checkbox', name: registerName !== null && registerName !== void 0 ? registerName : name, required: required, readOnly: readOnly, disabled: disabled, onChange: handleChange, "aria-invalid": !!error }, defaultChecked && { defaultChecked: checked })), (0, jsx_runtime_1.jsx)(TickBox, {}), (0, jsx_runtime_1.jsx)("span", { children: label })] })));
};
exports.Checkbox = Checkbox;
const Label = styled_components_1.default.label `
  align-items: flex-start;
  color: ${({ theme, $textColor }) => theme.colors[$textColor]};
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
    padding: 0 12px;
  }

  > div {
    border-color: ${({ theme }) => theme.colors['red']};
  }

  input {
    opacity: 0;
    position: absolute;
    user-select: none;
    visibility: hidden;

    + div {
      background-color: ${({ theme, $checked }) => $checked ? theme.colors['red'] : 'transparent'};
    }
  }

  &:hover {
    input + div {
      opacity: .7;
    }
  }

  span {
    ${(0, styles_1.getP15_5)()}
    display: inline-block;
    margin-top: 3px;
    user-select: none;
  }
`;
const TickBox = styled_components_1.default.div `
  border: 1px solid;
  border-radius: 2px;
  height: 16px;
  margin-right: ${(0, styles_1.vw)(10, 'mobile')};
  position: relative;
  transition: 250ms background-color linear, 250ms opacity linear;
  user-select: none;
  width: 16px;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-right: ${(0, styles_1.vw)(10, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-right: ${(0, styles_1.vw)(10, 'desktop')};
  }

  ${styles_1.mq.greaterThan('large-screen')} {
    margin-right: 10px;
  }
`;


/***/ }),

/***/ 82385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Input = exports.noRegister = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importStar(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const media_1 = __webpack_require__(24638);
const hasContentState = () => (0, styled_components_1.css) `
  ${(0, styles_1.getP18InputHasContentLabel)()}
  opacity: 1;
  transform: translateY(-${(0, styles_1.vw)(25, 'mobile')});

  ${styles_1.mq.greaterThan('tablet')} {
    transform: translateY(-${(0, styles_1.vw)(30, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    transform: translateY(-30px);
  }
`;
const mediaPasswordIcon = {
    type: 'image',
    alt: 'Password eye icon',
    default: {
        src: '/images/svg/i--password-eye.svg',
        size: { width: 18, height: 18 }
    }
};
// aria-invalid https://react-hook-form.com/advanced-usage
const getIcon = (icon, type, setInputType) => {
    if (!icon)
        return false;
    if (typeof icon === 'boolean' || typeof icon === 'string') {
        if (type === 'password') {
            const Icon = (0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', className: 'btn--toggle-password', onClick: (e) => {
                    e.preventDefault();
                    setInputType(prevType => prevType === 'password' ? 'text' : 'password');
                } }, { children: (0, jsx_runtime_1.jsx)(media_1.Figure, { media: mediaPasswordIcon }) }), 'icon');
            return [Icon, true];
        }
        else if (type === 'search') {
            // Search and clear action
        }
    }
    else if ((0, react_1.isValidElement)(icon)) {
    }
};
const noRegister = () => ({ onChange: null, onBlur: null, ref: null, name: null });
exports.noRegister = noRegister;
// Attributes https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
const Input = ({ type = 'text', name = '', defaultValue = '', label, autoComplete, placeholder, placeholderVisible = false, required = false, disabled = false, readOnly = null, onChange = null, col, register = exports.noRegister, icon, className, textColor = 'darkred', bgColor = 'background', error, autoFocus = false, onKeyUp = null }) => {
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, onBlur: registerOnBlur, name: registerName, ref: registerRef } = register(name, requireProps);
    const ref = (0, react_1.useRef)(null);
    const [inputType, setInputType] = (0, react_1.useState)(type);
    const [inputValue, setInputValue] = (0, react_1.useState)(defaultValue);
    const handleChange = e => {
        var _a;
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
        setInputValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    const handleBlur = e => {
        var _a;
        registerOnBlur && registerOnBlur(e);
        setInputValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    const ButtonIcon = (0, react_1.useMemo)(() => getIcon(icon, type, setInputType), [icon, type]);
    (0, react_1.useEffect)(() => {
        if (error)
            console.log(`input ${name} error`, error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    (0, react_1.useEffect)(() => {
        if (autoFocus && ref.current)
            ref.current.focus();
    }, [autoFocus]);
    return ((0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$hasContent": !!defaultValue || !!inputValue, "$hidden": inputType === 'hidden', "$col": col, "$buttonIcon": !!ButtonIcon, "$placeholderVisible": placeholderVisible, "$textColor": textColor, "$bgColor": bgColor, "$hasError": !!error }, className && { className }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ type: inputType, name: registerName !== null && registerName !== void 0 ? registerName : name, disabled: disabled, readOnly: readOnly, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label, onChange: handleChange, onBlur: handleBlur, "aria-invalid": !!error, onKeyUp: onKeyUp }, typeof required === 'boolean' && { required }, { ref: (e) => {
                    ref.current = e;
                    registerRef && registerRef(e);
                } }, autoComplete && { autoComplete }, defaultValue && { defaultValue }, (!defaultValue && !registerRef && inputValue && { value: inputValue }))), label && (0, jsx_runtime_1.jsx)("span", { children: label }), ButtonIcon && ButtonIcon, (error === null || error === void 0 ? void 0 : error.message) && (0, jsx_runtime_1.jsx)("span", Object.assign({ role: 'alert' }, { children: error.message }))] })));
};
exports.Input = Input;
const Label = styled_components_1.default.label `
  display: flex;
  flex-direction: column;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
    padding: 0 12.5px;
  }

  ${({ $hidden }) => $hidden && (0, styled_components_1.css) `
    opacity: 0;
    pointer-events: none;
    position: absolute;
    user-select: none;
    visibility: hidden;
  `}

  > input {
    ${(0, styles_1.getP18_3)()}
    background-color: ${({ theme, $bgColor }) => theme.colors[$bgColor]};
    border-bottom: 1px solid;
    border-color: ${({ theme, $textColor, $hasError }) => (0, styles_1.hex2Rgba)(theme.colors[$hasError ? 'input_error' : $textColor], $hasError ? 1 : .4)};
    color: inherit;
    height: ${(0, styles_1.vw)(60, 'mobile')};
    padding: ${(0, styles_1.vw)(25, 'mobile')} 0 ${(0, styles_1.vw)(12, 'mobile')};
    transition: 300ms border-color ease-out;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(60, 'nexus7')};
      padding: ${(0, styles_1.vw)(25, 'nexus7')} 0 ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(25, 'desktop')} 0 ${(0, styles_1.vw)(12, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 60px;
      padding: 25px 0 12px;
    }

    &[readonly],
    &[disabled] {
      cursor: auto;
      pointer-events: none;
    }

    &[readonly] {
      opacity: .3;

      + span {
        opacity: .3;
      }
    }

    &[disabled] {
      opacity: .2;

      + span {
        opacity: .2;
      }
    }

    ${({ $buttonIcon }) => $buttonIcon && (0, styled_components_1.css) `
      padding-right: ${(0, styles_1.vw)(40, 'iphone6')};

      ${styles_1.mq.greaterThan('tablet')} {
        padding-right: ${(0, styles_1.vw)(40, 'desktop')};
      }

      > button {
        align-items: center;
        background: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        bottom: ${(0, styles_1.vw)(5, 'mobile')};
        display: flex;
        height: ${(0, styles_1.vw)(21, 'mobile')};
        position: absolute;
        right: ${(0, styles_1.vw)(4.25, 'mobile')};
        user-select: none;

        ${styles_1.mq.greaterThan('nexus7')} {
          bottom: ${(0, styles_1.vw)(5, 'nexus7')};
          height: ${(0, styles_1.vw)(21, 'nexus7')};
          right: ${(0, styles_1.vw)(4.25, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          bottom: ${(0, styles_1.vw)(5, 'desktop')};
          height: ${(0, styles_1.vw)(21, 'desktop')};
          right: ${(0, styles_1.vw)(12.5, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          bottom: 5px;
          height: 21px;
          right: 12.5px;
        }
      }
    `}

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      -webkit-box-shadow: 0 0 0 500px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      box-shadow: 0 0 0 100px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      color: inherit;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      opacity: ${$placeholderVisible ? .4 : 0};
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
    `)}

    &:focus {
      border-color: ${({ theme, $textColor, $hasError }) => $hasError ? theme.colors['input_error'] : (0, styles_1.hex2Rgba)(theme.colors[$textColor], 1)};

      + span {
        ${hasContentState()}
      }
    }
  }

  > span {
    /* FLOATING LABEL */
    &:first-of-type {
      ${({ $placeholderVisible }) => $placeholderVisible ? hasContentState() : (0, styles_1.getP18InputLabel)()}
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      bottom: ${(0, styles_1.vw)(12, 'mobile')};
      color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      opacity: .4;
      position: absolute;
      transition: 300ms font-size ease, 300ms transform ease, 300ms opacity ease;
      white-space: nowrap;

      ${styles_1.mq.greaterThan('nexus7')} {
        bottom: ${(0, styles_1.vw)(12, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        bottom: ${(0, styles_1.vw)(12, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        bottom: 12px;
      }

      ${({ $hasContent }) => $hasContent ? (0, styled_components_1.css) `${hasContentState()}` : ''}
    }

    /* ERROR MESSAGE */
    &[role='alert'] {
      ${(0, styles_1.getP12_2)()}
      color: ${({ theme }) => theme.colors['input_error']};
      pointer-events: none;
      position: absolute;
      top: ${(0, styles_1.vw)(62, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        top: ${(0, styles_1.vw)(62, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        top: ${(0, styles_1.vw)(65, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        top: 65px;
      }
    }
  }

  figure {
    height: ${(0, styles_1.vw)(15, 'mobile')};
    position: absolute;
    right: ${(0, styles_1.vw)(17, 'mobile')};
    top: 40%;
    width: ${(0, styles_1.vw)(23, 'mobile')};

    img {
      height: 100%;
      width: 100%;
    }

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(15, 'nexus7')};
      right: ${(0, styles_1.vw)(17, 'nexus7')};
      width: ${(0, styles_1.vw)(23, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(15, 'desktop')};
      right: ${(0, styles_1.vw)(17, 'desktop')};
      width: ${(0, styles_1.vw)(23, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 15px;
      right: 17px;
      width: 23px;
    }
  }
`;


/***/ }),

/***/ 56154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InputPhone = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importStar(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const media_1 = __webpack_require__(24638);
const dropdown_1 = __webpack_require__(74494);
const framer_motion_1 = __webpack_require__(53316);
const _1 = __webpack_require__(33239);
const countries = [
    { value: '+44', longCode: '0044', name: 'United Kingdom', flag: '🇬🇧', locale: 'UK' },
    { value: '+34', longCode: '0034', name: 'España', flag: '🇪🇸', locale: 'ES' },
    { value: '+33', longCode: '0033', name: 'France', flag: '🇫🇷', locale: 'FR' },
    // Add more countries as needed
];
const hasContentState = () => (0, styled_components_1.css) `
  ${(0, styles_1.getP18InputHasContentLabel)()}
  opacity: 1;
  transform: translateY(-${(0, styles_1.vw)(25, 'mobile')});

  ${styles_1.mq.greaterThan('tablet')} {
    transform: translateY(-${(0, styles_1.vw)(30, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    transform: translateY(-30px);
  }
`;
const mediaPasswordIcon = {
    type: 'image',
    alt: 'Password eye icon',
    default: {
        src: '/images/svg/i--password-eye.svg',
        size: { width: 18, height: 18 }
    }
};
// aria-invalid https://react-hook-form.com/advanced-usage
const getIcon = (icon, type, setInputType) => {
    if (!icon)
        return false;
    if (typeof icon === 'boolean' || typeof icon === 'string') {
        if (type === 'password') {
            const Icon = (0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', className: 'btn--toggle-password', onClick: (e) => {
                    e.preventDefault();
                    setInputType(prevType => prevType === 'password' ? 'text' : 'password');
                } }, { children: (0, jsx_runtime_1.jsx)(media_1.Figure, { media: mediaPasswordIcon }) }), 'icon');
            return [Icon, true];
        }
        else if (type === 'search') {
            // Search and clear action
        }
    }
    else if ((0, react_1.isValidElement)(icon)) {
    }
};
const getOptionsList = (data, onClickOption, currentValue, prefixType) => data.map((option, idx) => {
    var _a;
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: `${currentValue === option[prefixType] ? 'current' : ''}${option.store ? ` online-store${((_a = data[idx + 1]) === null || _a === void 0 ? void 0 : _a.store) ? '' : ' last-store'}` : ''}` }, { children: (0, jsx_runtime_1.jsxs)("button", Object.assign({ type: 'button', onClick: () => { onClickOption(option); }, "data-dismiss": true }, { children: [option[prefixType], " ", option.value] })) }), `${option.value}-${idx}`));
});
const noRegister = () => ({ onChange: null, onBlur: null, ref: null, name: null });
// Attributes https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
let TIMEOUT_ID = null;
const InputPhone = ({ type = 'tel', name = '', nameCode = 'countryCode', defaultValue = '', label, autoComplete, placeholder, placeholderVisible = false, required = false, disabled = false, readOnly = null, onChange = null, col, colSelect, register = noRegister, icon, className, textColor = 'darkred', bgColor = 'background', error, autoFocus = false, onKeyUp = null, includePrefixValue = false, displayPrefixOption = true, prefixType = 'flag', setFormValue, unregister, dialogStyles = null }) => {
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, onBlur: registerOnBlur, name: registerName, ref: registerRef } = register(name, requireProps);
    const { name: registerNameCode, ref: registerRefCode } = register('countryCode', { required: includePrefixValue ? includePrefixValue : false });
    const ref = (0, react_1.useRef)(null);
    const [triggerRef, dropdownRef, expanded, onTriggerFocus, toggleExpanded] = (0, dropdown_1.useDropdown)();
    const [fancyValue, setFancyValue] = (0, react_1.useState)(countries[1][prefixType] + ' ' + countries[1].value);
    const [currentOptions, setCurrentOptions] = (0, react_1.useState)(countries);
    const [currentValue, setCurrentValue] = (0, react_1.useState)(countries[1][prefixType]);
    const [inputType, setInputType] = (0, react_1.useState)(type);
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const handleChange = e => {
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
        const trimedInputValue = e.target.value.toString().trim().replace(/ /g, '');
        const country = countries.find(el => trimedInputValue.includes(el.longCode) || trimedInputValue.includes(el.value));
        const startSlice = trimedInputValue.includes(country === null || country === void 0 ? void 0 : country.value) ? country === null || country === void 0 ? void 0 : country.value : country === null || country === void 0 ? void 0 : country.longCode;
        const strippedPhoneNumber = trimedInputValue.slice(startSlice === null || startSlice === void 0 ? void 0 : startSlice.length);
        setInputValue(strippedPhoneNumber);
        if (country) {
            setFancyValue(country[prefixType] + ' ' + country.value);
            setCurrentValue(country[prefixType]);
            setFormValue(name, strippedPhoneNumber.replace(/ /g, ''));
            setFormValue(nameCode, country.value);
        }
    };
    const onClickOption = (0, react_1.useCallback)((option) => {
        !includePrefixValue && unregister && unregister(nameCode);
        setFormValue(nameCode, option === null || option === void 0 ? void 0 : option.value);
        setCurrentValue(option === null || option === void 0 ? void 0 : option.value);
        setFancyValue((option === null || option === void 0 ? void 0 : option[prefixType]) + ' ' + (option === null || option === void 0 ? void 0 : option.value));
        toggleExpanded();
    }, [includePrefixValue, nameCode, prefixType, setFormValue, toggleExpanded, unregister]);
    const handleBlur = e => {
        var _a;
        registerOnBlur && registerOnBlur(e);
        setInputValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    const ButtonIcon = (0, react_1.useMemo)(() => getIcon(icon, type, setInputType), [icon, type]);
    (0, react_1.useEffect)(() => {
        if (error)
            console.log(`input ${name} error`, error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    (0, react_1.useEffect)(() => {
        if (autoFocus && ref.current)
            ref.current.focus();
    }, [autoFocus]);
    const Options = (0, react_1.useMemo)(() => getOptionsList(currentOptions, onClickOption, currentValue, prefixType), [currentOptions, currentValue, onClickOption, prefixType]);
    const filterBySearch = (0, react_1.useCallback)(({ value, valid }) => __awaiter(void 0, void 0, void 0, function* () {
        if (valid) {
            //filter by name of country, by code +44 or long code 0044
            const data = countries.filter(option => option.name.toLowerCase().includes(value.toLowerCase()) || option.value.toLowerCase().includes(value.toLowerCase()) || option.longCode.toLowerCase().includes(value.toLowerCase()));
            setCurrentOptions(data);
        }
        else {
            setCurrentOptions(countries);
        }
    }), []);
    const handleSearch = e => {
        var _a;
        const value = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        setFancyValue(value);
        if (typeof value === 'string') {
            const valid = value.length > 1;
            TIMEOUT_ID && clearTimeout(TIMEOUT_ID);
            TIMEOUT_ID = setTimeout(() => filterBySearch({ value, valid }), 300);
        }
    };
    const onBlurSearch = () => {
        var _a;
        const value = fancyValue;
        let matchOption = null;
        if (typeof value === 'string' && value.length > 2) {
            matchOption = (_a = countries.filter(option => option.name.toLowerCase().includes(value.toLowerCase()))) === null || _a === void 0 ? void 0 : _a[0];
        }
        setFormValue(nameCode, matchOption ? matchOption.value : '');
        setCurrentValue(matchOption ? matchOption.value : '');
        setFancyValue(matchOption ? matchOption[prefixType] + ' ' + matchOption.value : '');
        setCurrentOptions(countries);
    };
    (0, react_1.useEffect)(() => {
        setCurrentOptions(countries);
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        let matchOption = null;
        if (defaultValue) {
            matchOption = (_a = countries.filter(option => option.value === defaultValue)) === null || _a === void 0 ? void 0 : _a[0];
            setFormValue(name, matchOption ? matchOption.value : '');
            setFormValue(nameCode, matchOption ? matchOption.value : '');
            setCurrentValue(matchOption ? matchOption.value : '');
            setFancyValue(matchOption ? matchOption.name : '');
        }
    }, [defaultValue, name, nameCode, setFormValue]);
    return ((0, jsx_runtime_1.jsxs)(DialogStyled, Object.assign({}, (dialogStyles && { $dialogStyles: dialogStyles }), { children: [displayPrefixOption &&
                (0, jsx_runtime_1.jsxs)(Div, Object.assign({ ref: triggerRef, "$col": colSelect, "$readOnly": readOnly }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ type: 'hidden', name: nameCode !== null && nameCode !== void 0 ? nameCode : registerNameCode, "aria-invalid": !!error, ref: (e) => {
                                ref.current = e;
                                includePrefixValue && registerRefCode && registerRefCode(e);
                            } }, defaultValue && { defaultValue }, (currentValue && { value: currentValue }))), (0, jsx_runtime_1.jsxs)(LabelSelect, Object.assign({ "$hasContent": !!fancyValue, "$placeholderVisible": placeholderVisible, "$textColor": textColor, "$bgColor": bgColor }, className && { className }, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'text', name: `${nameCode}_searcher`, disabled: disabled, readOnly: readOnly, onChange: handleSearch, onFocus: onTriggerFocus, onBlur: onBlurSearch, value: fancyValue, autoComplete: autoComplete }), icon ? icon : (0, jsx_runtime_1.jsx)(media_1.Figure, { media: textColor === 'white' ? _1.arrowIconWhite : _1.arrowIcon, fill: false, lazy: true, className: 'chevron' })] })), !readOnly && (0, jsx_runtime_1.jsx)(Ul, Object.assign({ ref: dropdownRef, initial: 'collapsed', variants: _1.optionsListVariants, animate: expanded ? 'expanded' : 'collapsed', "$textColor": textColor, "$dropdownTextColor": textColor }, { children: Options }))] })), (0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$hasContent": !!defaultValue || !!inputValue, "$hidden": inputType === 'hidden', "$type": type, "$col": col, "$buttonIcon": !!ButtonIcon, "$placeholderVisible": placeholderVisible, "$textColor": textColor, "$bgColor": bgColor, "$hasError": !!error }, className && { className }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ type: inputType, name: registerName !== null && registerName !== void 0 ? registerName : name, disabled: disabled, readOnly: readOnly, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label, onChange: handleChange, onBlur: handleBlur, "aria-invalid": !!error, onKeyUp: onKeyUp }, typeof required === 'boolean' && { required }, { ref: (e) => {
                            ref.current = e;
                            registerRef && registerRef(e);
                        } }, autoComplete && { autoComplete }, defaultValue && { defaultValue }, (!defaultValue && !registerRef && inputValue && { value: inputValue }))), label && (0, jsx_runtime_1.jsx)("span", { children: label }), ButtonIcon && ButtonIcon, (error === null || error === void 0 ? void 0 : error.message) && (0, jsx_runtime_1.jsx)("span", Object.assign({ role: 'alert' }, { children: error.message }))] }))] })));
};
exports.InputPhone = InputPhone;
const Label = styled_components_1.default.label `
  display: flex;
  flex-direction: ${({ $type }) => $type === 'tel' ? 'row' : 'column'};
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
    padding: 0 12.5px;
  }

  ${({ $hidden }) => $hidden && (0, styled_components_1.css) `
    opacity: 0;
    pointer-events: none;
    position: absolute;
    user-select: none;
    visibility: hidden;
  `}

  > input {
    ${(0, styles_1.getP18_3)()}
    background-color: ${({ theme, $bgColor }) => theme.colors[$bgColor]};
    border-bottom: 1px solid;
    border-color: ${({ theme, $textColor, $hasError }) => (0, styles_1.hex2Rgba)(theme.colors[$hasError ? 'input_error' : $textColor], $hasError ? 1 : .4)};
    color: inherit;
    height: ${(0, styles_1.vw)(60, 'mobile')};
    padding: ${(0, styles_1.vw)(25, 'mobile')} 0 ${(0, styles_1.vw)(12, 'mobile')};
    transition: 300ms border-color ease-out;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(60, 'nexus7')};
      padding: ${(0, styles_1.vw)(25, 'nexus7')} 0 ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(25, 'desktop')} 0 ${(0, styles_1.vw)(12, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 60px;
      padding: 25px 0 12px;
    }

    &[readonly],
    &[disabled] {
      cursor: auto;
      pointer-events: none;
    }

    &[readonly] {
      opacity: .3;

      + span {
        opacity: .3;
      }
    }

    &[disabled] {
      opacity: .2;

      + span {
        opacity: .2;
      }
    }

    ${({ $buttonIcon }) => $buttonIcon && (0, styled_components_1.css) `
      padding-right: ${(0, styles_1.vw)(40, 'iphone6')};

      ${styles_1.mq.greaterThan('tablet')} {
        padding-right: ${(0, styles_1.vw)(40, 'desktop')};
      }

      > button {
        align-items: center;
        background: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        bottom: ${(0, styles_1.vw)(5, 'mobile')};
        display: flex;
        height: ${(0, styles_1.vw)(21, 'mobile')};
        position: absolute;
        right: ${(0, styles_1.vw)(4.25, 'mobile')};
        user-select: none;

        ${styles_1.mq.greaterThan('nexus7')} {
          bottom: ${(0, styles_1.vw)(5, 'nexus7')};
          height: ${(0, styles_1.vw)(21, 'nexus7')};
          right: ${(0, styles_1.vw)(4.25, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          bottom: ${(0, styles_1.vw)(5, 'desktop')};
          height: ${(0, styles_1.vw)(21, 'desktop')};
          right: ${(0, styles_1.vw)(12.5, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          bottom: 5px;
          height: 21px;
          right: 12.5px;
        }
      }
    `}

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      -webkit-box-shadow: 0 0 0 500px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      box-shadow: 0 0 0 100px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      color: inherit;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      opacity: ${$placeholderVisible ? .4 : 0};
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
    `)}

    &:focus {
      border-color: ${({ theme, $textColor, $hasError }) => $hasError ? theme.colors['input_error'] : (0, styles_1.hex2Rgba)(theme.colors[$textColor], 1)};

      + span {
        ${hasContentState()}
      }
    }
  }

  > span {
    /* FLOATING LABEL */
    &:first-of-type {
      ${({ $placeholderVisible }) => $placeholderVisible ? hasContentState() : (0, styles_1.getP18InputLabel)()}
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      bottom: ${(0, styles_1.vw)(12, 'mobile')};
      color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      opacity: .4;
      position: absolute;
      transition: 300ms font-size ease, 300ms transform ease, 300ms opacity ease;
      white-space: nowrap;

      ${styles_1.mq.greaterThan('nexus7')} {
        bottom: ${(0, styles_1.vw)(12, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        bottom: ${(0, styles_1.vw)(12, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        bottom: 12px;
      }

      ${({ $hasContent }) => $hasContent ? (0, styled_components_1.css) `${hasContentState()}` : ''}
    }

    /* ERROR MESSAGE */
    &[role='alert'] {
      ${(0, styles_1.getP12_2)()}
      color: ${({ theme }) => theme.colors['input_error']};
      pointer-events: none;
      position: absolute;
      top: ${(0, styles_1.vw)(62, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        top: ${(0, styles_1.vw)(62, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        top: ${(0, styles_1.vw)(65, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        top: 65px;
      }
    }
  }

  figure {
    height: ${(0, styles_1.vw)(15, 'mobile')};
    position: absolute;
    right: ${(0, styles_1.vw)(17, 'mobile')};
    top: 40%;
    width: ${(0, styles_1.vw)(23, 'mobile')};

    img {
      height: 100%;
      width: 100%;
    }

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(15, 'nexus7')};
      right: ${(0, styles_1.vw)(17, 'nexus7')};
      width: ${(0, styles_1.vw)(23, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(15, 'desktop')};
      right: ${(0, styles_1.vw)(17, 'desktop')};
      width: ${(0, styles_1.vw)(23, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 15px;
      right: 17px;
      width: 23px;
    }
  }

`;
const Div = styled_components_1.default.div `
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  pointer-events: ${({ $readOnly }) => $readOnly ? 'none' : 'auto'};
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: 0 ${(0, styles_1.vw)(4.5, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 0 12.5px;
  }

  ${({ $readOnly }) => {
    if ($readOnly)
        return (0, styled_components_1.css) `
    .chevron {
      opacity: 0;
    }
  `;
}}
`;
const Ul = (0, styled_components_1.default)(framer_motion_1.motion.ul) `
  background: white;
  margin-top: 1px;
  max-height: ${(0, styles_1.vw)(20 * 5.5 + 4.25 * 6, 'mobile')};
  overflow-y: auto;
  padding: ${(0, styles_1.vw)(8.5, 'mobile')} 0 ${(0, styles_1.vw)(12.5, 'mobile')};
  position: absolute;
  top: ${(0, styles_1.vw)(60, 'mobile')};
  width: calc(100% - ${(0, styles_1.vw)(8.5, 'mobile')});
  z-index: 5;

  ${styles_1.mq.greaterThan('nexus7')} {
    max-height: ${(0, styles_1.vw)(20 * 5.5 + 4.25 * 6, 'nexus7')};
    padding: ${(0, styles_1.vw)(8.5, 'nexus7')} 0 ${(0, styles_1.vw)(12.5, 'nexus7')};
    top: ${(0, styles_1.vw)(60, 'nexus7')};
    width: calc(100% - ${(0, styles_1.vw)(8.5, 'nexus7')});
  }

  ${styles_1.mq.greaterThan('tablet')} {
    max-height: ${(0, styles_1.vw)(32 * 5.5 + 4.25 * 6, 'desktop')};
    padding: ${(0, styles_1.vw)(8.5, 'desktop')} 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    top: ${(0, styles_1.vw)(60, 'desktop')};
    width: calc(100% - ${(0, styles_1.vw)(25, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    max-height: 208.5px;
    padding: 8.5px 0 12.5px;
    top: 60px;
    width: calc(100% - 25px);
  }

  li {
    margin-bottom: ${(0, styles_1.vw)(4.25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(4.25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(4.25, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 4.25px;
    }


  }

  button {
    ${(0, styles_1.getP18_3)()}
    align-items: center;
    color: ${({ theme, $textColor, $dropdownTextColor }) => $dropdownTextColor ? theme.colors[$dropdownTextColor] : theme.colors[$textColor]};
    display: flex;
    justify-content: space-between;
    opacity: .4;
    overflow-x: hidden;
    padding: ${(0, styles_1.vw)(2, 'mobile')} ${(0, styles_1.vw)(4.25, 'mobile')};
    text-overflow: ellipsis;
    transition: 300ms opacity ease-out;
    white-space: nowrap;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: ${(0, styles_1.vw)(2, 'nexus7')} ${(0, styles_1.vw)(4.25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: ${(0, styles_1.vw)(8, 'desktop')} ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 8px 12.5px;
    }

    &:hover {
      opacity: 1;
    }

  }
`;
const LabelSelect = styled_components_1.default.label `
  display: flex;
  flex-direction: column;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
  }

  > input {
    ${(0, styles_1.getP18_3)()}
    background-color: ${({ theme, $bgColor }) => theme.colors[$bgColor]};
    border-bottom: 1px solid;
    border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], .4)};
    color: ${({ theme, $textColor }) => $textColor ? theme.colors[$textColor] : theme.colors.darkred};
    height: ${(0, styles_1.vw)(60, 'mobile')};
    padding: ${(0, styles_1.vw)(25, 'mobile')} 0 ${(0, styles_1.vw)(12, 'mobile')};
    transition: 300ms border-color ease-out;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(60, 'nexus7')};
      padding: ${(0, styles_1.vw)(25, 'nexus7')} 0 ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(25, 'desktop')} 0 ${(0, styles_1.vw)(12, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 60px;
      padding: 25px 0 12px;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
      opacity: ${$placeholderVisible ? .4 : 0};
    `)}

    ${({ $buttonIcon }) => $buttonIcon && (0, styled_components_1.css) `
      padding-right: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('tablet')} {
        padding-right: ${(0, styles_1.vw)(40, 'desktop')};
      }

      > button {
        align-items: center;
        background: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        bottom: ${(0, styles_1.vw)(5, 'mobile')};
        display: flex;
        height: ${(0, styles_1.vw)(21, 'mobile')};
        position: absolute;
        right: ${(0, styles_1.vw)(4.25, 'mobile')};
        user-select: none;

        ${styles_1.mq.greaterThan('nexus7')} {
          bottom: ${(0, styles_1.vw)(5, 'nexus7')};
          height: ${(0, styles_1.vw)(21, 'nexus7')};
          right: ${(0, styles_1.vw)(12.5, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          bottom: ${(0, styles_1.vw)(5, 'desktop')};
          height: ${(0, styles_1.vw)(21, 'desktop')};
          right: ${(0, styles_1.vw)(12.5, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          bottom: 5px;
          height: 21px;
          right: 12.5px;
        }
      }
    `}

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      -webkit-box-shadow: 0 0 0 500px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      box-shadow: 0 0 0 100px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      color: inherit;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      opacity: ${$placeholderVisible ? .4 : 0};
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
    `)}

    &:focus {
      border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], 1)};

      + span {
        ${hasContentState()}
      }
    }

    &[readonly] {
      opacity: .3;

      + span {
        opacity: .3;
      }
    }
  }

  figure {
    &.chevron {
      bottom: ${(0, styles_1.vw)(21, 'mobile')};
      height: ${(0, styles_1.vw)(8, 'mobile')};
      pointer-events: none;
      position: absolute;
      right: ${(0, styles_1.vw)(20, 'mobile')};

      ${styles_1.mq.lessThan('tablet')} {
        width: ${(0, styles_1.vw)(12, 'mobile')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        bottom: ${(0, styles_1.vw)(21, 'desktop')};
        height: ${(0, styles_1.vw)(8, 'desktop')};
        right: ${(0, styles_1.vw)(20, 'desktop')};
        width: ${(0, styles_1.vw)(12, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        bottom: 21px;
        height: 8px;
        right: 20px;
        width: 12px;
      }

      svg {
        height: 100%;
        object-fit: contain;
        transition: 300ms transform ease-out;
        width: 100%;
      }
    }
  }
`;
const DialogStyled = styled_components_1.default.div `
  display: flex;
  flex-direction: row;

  ${({ $dialogStyles }) => $dialogStyles && $dialogStyles}

`;


/***/ }),

/***/ 65026:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RadioCheckBoxes = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const getRadioCheckBoxes = (variants) => variants.map((variant, idx) => {
    if (!variant)
        return;
    const { variant: { bigcommerceId: variant_id }, currentVariantId, setCurrentVariant, text } = variant;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { id: idx, onChange: () => { setCurrentVariant(variant.variant); }, type: 'radio', checked: variant_id === currentVariantId }), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: idx }, { children: text }))] }, idx));
});
exports.RadioCheckBoxes = (0, react_1.memo)(({ data }) => {
    const InputRadios = (0, react_1.useMemo)(() => getRadioCheckBoxes(data), [data]);
    return ((0, jsx_runtime_1.jsx)(RadioButtonWrapper, { children: InputRadios }));
});
const RadioButtonWrapper = styled_components_1.default.div `
  span {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.red};
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
    display: flex;
    height: ${(0, styles_1.vw)(27, 'mobile')};
    justify-content: center;
    margin-right: ${(0, styles_1.vw)(10, 'mobile')};
    pointer-events: none;
    position: relative;
    user-select: none;
    width: ${(0, styles_1.vw)(25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(27, 'nexus7')};
      margin-right: ${(0, styles_1.vw)(10, 'nexus7')};
      width: ${(0, styles_1.vw)(25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(27, 'desktop')};
      margin-right: ${(0, styles_1.vw)(10, 'desktop')};
      width: ${(0, styles_1.vw)(25, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 27px;
      margin-right: 10px;
      width: 25px;
    }

    &:before {
      background-color: ${({ theme }) => theme.colors.white};
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
      content: ' ';
      display: none;
      height: ${(0, styles_1.vw)(24, 'mobile')};
      width: ${(0, styles_1.vw)(22, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(24, 'nexus7')};
        width: ${(0, styles_1.vw)(22, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(24, 'desktop')};
        width: ${(0, styles_1.vw)(22, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 24px;
        width: 22px;
      }
    }

    &:after {
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 50%;
      content: ' ';
      height: ${(0, styles_1.vw)(10, 'mobile')};
      position: absolute;
      width: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(10, 'nexus7')};
        width: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(10, 'desktop')};
        width: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 10px;
        width: 10px;
      }
    }
  }

  label {
    white-space: nowrap;
    cursor: pointer;

  }

  input:not(:checked) + span::before {
    display: block;
  }
`;


/***/ }),

/***/ 13259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Select = exports.arrowIconWhite = exports.arrowIcon = exports.optionsListVariants = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const framer_motion_1 = __webpack_require__(53316);
const styled_components_1 = __importStar(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const Input_1 = __webpack_require__(82385);
const dropdown_1 = __webpack_require__(74494);
const media_1 = __webpack_require__(24638);
const hasContentState = () => (0, styled_components_1.css) `
  ${(0, styles_1.getP18InputHasContentLabel)()}
  opacity: 1;
  transform: translateY(-${(0, styles_1.vw)(35, 'mobile')});

  ${styles_1.mq.greaterThan('tablet')} {
    transform: translateY(-${(0, styles_1.vw)(35, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    transform: translateY(-35px);
  }
`;
exports.optionsListVariants = {
    collapsed: {
        height: '0',
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)())
    },
    expanded: {
        height: 'auto',
        opacity: 1,
        display: 'block',
        transition: Object.assign({}, (0, styles_1.getTransition)())
    }
};
const getOptionsList = (data, onClickOption, currentValue) => data.map((option, idx) => {
    var _a;
    return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: `${currentValue === option.value ? 'current' : ''}${option.store ? ` online-store${((_a = data[idx + 1]) === null || _a === void 0 ? void 0 : _a.store) ? '' : ' last-store'}` : ''}` }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button', onClick: () => { onClickOption(option); }, "data-dismiss": true }, { children: option.name })) }), `${option.value}-${idx}`));
});
exports.arrowIcon = {
    type: 'image',
    alt: 'Arrow icon',
    default: {
        src: '/images/svg/i--arrow-select.svg',
        size: { width: 12, height: 8 }
    }
};
exports.arrowIconWhite = {
    type: 'image',
    alt: 'Arrow icon',
    default: {
        src: '/images/svg/i--arrow-select--white.svg',
        size: { width: 12, height: 8 }
    }
};
let TIMEOUT_ID = null;
exports.Select = (0, react_1.memo)(({ options, name = 'country_code', defaultValue, label, autoComplete = 'off', placeholder, placeholderVisible = false, required = false, disabled = false, readOnly = null, onChange = null, col, register = Input_1.noRegister, icon = null, className, textColor = 'darkred', bgColor = 'background', error, setFormValue, dropdownTextColor = null }) => {
    var _a, _b;
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, onBlur: registerOnBlur, name: registerName, ref: registerRef } = register(name, Object.assign({}, requireProps));
    const [fancyValue, setFancyValue] = (0, react_1.useState)((_b = (_a = options.filter(option => option.value === defaultValue)[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
    const [currentOptions, setCurrentOptions] = (0, react_1.useState)(options);
    const [currentValue, setCurrentValue] = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : '');
    const [triggerRef, dropdownRef, expanded, onTriggerFocus, toggleExpanded] = (0, dropdown_1.useDropdown)();
    const handleChange = e => {
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
    };
    const handleBlur = e => {
        registerOnBlur && registerOnBlur(e);
        // setInputValue(e?.target?.value)
        // setFormValue(e?.target?.value)
    };
    const onClickOption = (option) => {
        setFormValue && setFormValue(name, option.value);
        setCurrentValue(option.value);
        setFancyValue(option.name);
        toggleExpanded();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const Options = (0, react_1.useMemo)(() => getOptionsList(currentOptions, onClickOption, currentValue), [currentOptions, currentValue]);
    const filterBySearch = (0, react_1.useCallback)(({ value, valid }) => __awaiter(void 0, void 0, void 0, function* () {
        if (valid) {
            const data = options.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
            setCurrentOptions(data);
        }
        else {
            setCurrentOptions(options);
        }
    }), [options]);
    const handleSearch = e => {
        var _a;
        const value = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        setFancyValue(value);
        if (typeof value === 'string') {
            const valid = value.length > 1;
            TIMEOUT_ID && clearTimeout(TIMEOUT_ID);
            TIMEOUT_ID = setTimeout(() => filterBySearch({ value, valid }), 300);
        }
    };
    const onBlurSearch = () => {
        var _a;
        const value = fancyValue;
        let matchOption = null;
        if (typeof value === 'string' && value.length > 2) {
            matchOption = (_a = options.filter(option => option.name.toLowerCase().includes(value.toLowerCase()))) === null || _a === void 0 ? void 0 : _a[0];
        }
        setFormValue(name, matchOption ? matchOption.value : '');
        setCurrentValue(matchOption ? matchOption.value : '');
        setFancyValue(matchOption ? matchOption.name : '');
        setCurrentOptions(options);
    };
    (0, react_1.useEffect)(() => {
        setCurrentOptions(options);
    }, [options]);
    (0, react_1.useEffect)(() => {
        var _a;
        let matchOption = null;
        if (defaultValue) {
            matchOption = (_a = options.filter(option => option.value === defaultValue)) === null || _a === void 0 ? void 0 : _a[0];
            setFormValue(name, matchOption ? matchOption.value : '');
            setCurrentValue(matchOption ? matchOption.value : '');
            setFancyValue(matchOption ? matchOption.name : '');
        }
    }, [defaultValue, options, name, setFormValue]);
    return ((0, jsx_runtime_1.jsxs)(Div, Object.assign({ ref: triggerRef, "$col": col, "$readOnly": readOnly }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ type: 'hidden', name: name, required: required, "aria-invalid": !!error }, registerRef && { ref: registerRef }, defaultValue && { defaultValue })), (0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$hasContent": !!fancyValue, "$placeholderVisible": placeholderVisible, "$textColor": textColor, "$bgColor": bgColor }, className && { className }, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'text', name: `${name}_searcher`, disabled: disabled, readOnly: readOnly, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label, onChange: handleSearch, onFocus: onTriggerFocus, onBlur: onBlurSearch, value: fancyValue, autoComplete: autoComplete }), label && (0, jsx_runtime_1.jsx)("span", { children: label }), icon ? icon : (0, jsx_runtime_1.jsx)(media_1.Figure, { media: textColor === 'white' ? exports.arrowIconWhite : exports.arrowIcon, fill: false, lazy: true, className: 'chevron' })] })), !readOnly && (0, jsx_runtime_1.jsx)(Ul, Object.assign({ ref: dropdownRef, initial: 'collapsed', variants: exports.optionsListVariants, animate: expanded ? 'expanded' : 'collapsed', "$textColor": textColor, "$dropdownTextColor": dropdownTextColor }, { children: Options }))] })));
});
const Div = styled_components_1.default.div `
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  pointer-events: ${({ $readOnly }) => $readOnly ? 'none' : 'auto'};
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: 0 ${(0, styles_1.vw)(4.5, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding: 0 12.5px;
  }

  ${({ $readOnly }) => {
    if ($readOnly)
        return (0, styled_components_1.css) `
    .chevron {
      opacity: 0;
    }
  `;
}}
`;
const Ul = (0, styled_components_1.default)(framer_motion_1.motion.ul) `
  background: white;
  margin-top: 1px;
  max-height: ${(0, styles_1.vw)(28 * 5.5 + 4.25 * 6, 'mobile')};
  overflow-y: auto;
  padding: ${(0, styles_1.vw)(8.5, 'mobile')} 0 ${(0, styles_1.vw)(12.5, 'mobile')};
  position: absolute;
  top: ${(0, styles_1.vw)(60, 'mobile')};
  width: calc(100% - ${(0, styles_1.vw)(8.5, 'mobile')});
  z-index: 5;

  ${styles_1.mq.greaterThan('nexus7')} {
    max-height: ${(0, styles_1.vw)(20 * 5.5 + 4.25 * 6, 'nexus7')};
    padding: ${(0, styles_1.vw)(8.5, 'nexus7')} 0 ${(0, styles_1.vw)(12.5, 'nexus7')};
    top: ${(0, styles_1.vw)(60, 'nexus7')};
    width: calc(100% - ${(0, styles_1.vw)(8.5, 'nexus7')});
  }

  ${styles_1.mq.greaterThan('tablet')} {
    max-height: ${(0, styles_1.vw)(32 * 5.5 + 4.25 * 6, 'desktop')};
    padding: ${(0, styles_1.vw)(8.5, 'desktop')} 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    top: ${(0, styles_1.vw)(60, 'desktop')};
    width: calc(100% - ${(0, styles_1.vw)(25, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    max-height: 208.5px;
    padding: 8.5px 0 12.5px;
    top: 60px;
    width: calc(100% - 25px);
  }

  li {
    margin-bottom: ${(0, styles_1.vw)(4.25, 'mobile')};
    margin-left: ${(0, styles_1.vw)(10, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(4.25, 'nexus7')};
      margin-left: ${(0, styles_1.vw)(10, 'mobile')};

    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(4.25, 'desktop')};
      margin-left: 0;

    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 4.25px;
    }

    &.online-store {
      &.last-store {
        margin-bottom: ${(0, styles_1.vw)(8.25, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          margin-bottom: ${(0, styles_1.vw)(8.25, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          margin-bottom: ${(0, styles_1.vw)(8.25, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          margin-bottom: 8.25px;
        }

        + li {
          border-top: 1px solid ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], .4)};
          margin-top: ${(0, styles_1.vw)(8.25, 'mobile')};
          padding-top: ${(0, styles_1.vw)(8.25, 'mobile')};

          ${styles_1.mq.greaterThan('nexus7')} {
            margin-top: ${(0, styles_1.vw)(8.25, 'nexus7')};
            padding-top: ${(0, styles_1.vw)(8.25, 'nexus7')};
          }

          ${styles_1.mq.greaterThan('tablet')} {
            margin-top: ${(0, styles_1.vw)(8.25, 'desktop')};
            padding-top: ${(0, styles_1.vw)(8.25, 'desktop')};
          }

          ${styles_1.mq.greaterThan('desktop')} {
            margin-top: 8.25px;
            padding-top: 8.25px;
          }
        }
      }
    }

  }

  button {
    ${(0, styles_1.getP18_3)()}
    align-items: center;
    color: ${({ theme, $textColor, $dropdownTextColor }) => $dropdownTextColor ? theme.colors[$dropdownTextColor] : theme.colors[$textColor]};
    display: flex;
    justify-content: space-between;
    opacity: .4;
    overflow-x: hidden;
    padding: ${(0, styles_1.vw)(2, 'mobile')} ${(0, styles_1.vw)(4.25, 'mobile')};
    text-overflow: ellipsis;
    transition: 300ms opacity ease-out;
    white-space: nowrap;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: ${(0, styles_1.vw)(2, 'nexus7')} ${(0, styles_1.vw)(4.25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: ${(0, styles_1.vw)(8, 'desktop')} ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 8px 12.5px;
    }

    &:hover {
      opacity: 1;
    }

    .online-store {
      opacity: .7;
    }
  }
`;
const Label = styled_components_1.default.label `
  display: flex;
  flex-direction: column;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
  }

  > input {
    ${(0, styles_1.getP18_3)()}
    background-color: ${({ theme, $bgColor }) => theme.colors[$bgColor]};
    border-bottom: 1px solid;
    border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], .4)};
    color: ${({ theme, $textColor }) => $textColor ? theme.colors[$textColor] : theme.colors.darkred};
    height: ${(0, styles_1.vw)(60, 'mobile')};
    padding: ${(0, styles_1.vw)(25, 'mobile')} 0 ${(0, styles_1.vw)(12, 'mobile')};
    transition: 300ms border-color ease-out;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(60, 'nexus7')};
      padding: ${(0, styles_1.vw)(25, 'nexus7')} 0 ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(60, 'desktop')};
      padding: ${(0, styles_1.vw)(25, 'desktop')} 0 ${(0, styles_1.vw)(12, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 60px;
      padding: 25px 0 12px;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
      opacity: ${$placeholderVisible ? .4 : 0};
    `)}

    ${({ $buttonIcon }) => $buttonIcon && (0, styled_components_1.css) `
      padding-right: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('tablet')} {
        padding-right: ${(0, styles_1.vw)(40, 'desktop')};
      }

      > button {
        align-items: center;
        background: transparent;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        bottom: ${(0, styles_1.vw)(5, 'mobile')};
        display: flex;
        height: ${(0, styles_1.vw)(21, 'mobile')};
        position: absolute;
        right: ${(0, styles_1.vw)(4.25, 'mobile')};
        user-select: none;

        ${styles_1.mq.greaterThan('nexus7')} {
          bottom: ${(0, styles_1.vw)(5, 'nexus7')};
          height: ${(0, styles_1.vw)(21, 'nexus7')};
          right: ${(0, styles_1.vw)(12.5, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          bottom: ${(0, styles_1.vw)(5, 'desktop')};
          height: ${(0, styles_1.vw)(21, 'desktop')};
          right: ${(0, styles_1.vw)(12.5, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          bottom: 5px;
          height: 21px;
          right: 12.5px;
        }
      }
    `}

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: ${({ theme, $textColor }) => theme.colors[$textColor]};
      -webkit-box-shadow: 0 0 0 500px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      box-shadow: 0 0 0 100px ${({ theme, $bgColor }) => theme.colors[$bgColor]} inset;
      color: inherit;
    }

    ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
      opacity: ${$placeholderVisible ? .4 : 0};
      color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
    `)}

    &:focus {
      border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], 1)};

      + span {
        ${hasContentState()}
      }
    }

    &[readonly] {
      opacity: .3;

      + span {
        opacity: .3;
      }
    }
  }

  > span {
    ${({ $placeholderVisible }) => $placeholderVisible ? hasContentState() : (0, styles_1.getP18InputLabel)()}
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    bottom: ${(0, styles_1.vw)(12, 'mobile')};
    color: ${({ theme, $textColor }) => theme.colors[$textColor]};
    opacity: 1;
    position: absolute;
    transform: translateY(-${(0, styles_1.vw)(35, 'mobile')});
    transition: 300ms font-size ease, 300ms transform ease, 300ms opacity ease;
    white-space: nowrap;

    ${styles_1.mq.greaterThan('nexus7')} {
      bottom: ${(0, styles_1.vw)(12, 'nexus7')};
      transform: translateY(-${(0, styles_1.vw)(35, 'nexus7')});
    }

    ${styles_1.mq.greaterThan('tablet')} {
      bottom: ${(0, styles_1.vw)(12, 'desktop')};
      transform: translateY(-${(0, styles_1.vw)(35, 'desktop')});
    }

    ${styles_1.mq.greaterThan('desktop')} {
      bottom: 12px;
      transform: translateY(-35px);
    }
  }

  figure {
    &.chevron {
      bottom: ${(0, styles_1.vw)(21, 'mobile')};
      height: ${(0, styles_1.vw)(8, 'mobile')};
      pointer-events: none;
      position: absolute;
      right: ${(0, styles_1.vw)(20, 'mobile')};

      ${styles_1.mq.lessThan('tablet')} {
        width: ${(0, styles_1.vw)(12, 'mobile')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        bottom: ${(0, styles_1.vw)(21, 'desktop')};
        height: ${(0, styles_1.vw)(8, 'desktop')};
        right: ${(0, styles_1.vw)(20, 'desktop')};
        width: ${(0, styles_1.vw)(12, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        bottom: 21px;
        height: 8px;
        right: 20px;
        width: 12px;
      }

      svg {
        height: 100%;
        object-fit: contain;
        transition: 300ms transform ease-out;
        width: 100%;
      }
    }
  }
`;


/***/ }),

/***/ 18607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextArea = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importStar(__webpack_require__(19453));
const styles_1 = __webpack_require__(73267);
const __1 = __webpack_require__(17566);
const hasContentState = () => (0, styled_components_1.css) `
  ${(0, styles_1.getP18InputHasContentLabel)()}
  opacity: 1;
  transform: translateY(-${(0, styles_1.vw)(35, 'mobile')});

  ${styles_1.mq.greaterThan('nexus7')} {
    transform: translateY(-${(0, styles_1.vw)(35, 'nexus7')});
  }

  ${styles_1.mq.greaterThan('tablet')} {
    transform: translateY(-${(0, styles_1.vw)(35, 'desktop')});
  }

  ${styles_1.mq.greaterThan('desktop')} {
    transform: translateY(-35px);
  }
`;
//Requested by design, text area componet should occupy  a whole column due to his dynamic height behaviour
exports.TextArea = (0, react_1.memo)(({ name, label, required = false, onChange = null, col, register = __1.noRegister, className, textColor = 'darkred', bgColor = 'background', error, disabled, readOnly, placeholder, placeholderVisible = false }) => {
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, name: registerName, ref: registerRef } = register(name, Object.assign({}, requireProps));
    const [heightTextArea, setHeightTextArea] = (0, react_1.useState)(60);
    const handleChange = e => {
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
        if (e.target.value.trim().length === 0) {
            setHeightTextArea(60);
        }
    };
    const onKeyUp = (e) => {
        const maxheigth = 148;
        if (e.key === 'Enter') {
            if (heightTextArea <= maxheigth)
                setHeightTextArea(heightTextArea + 22);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$col": col, "$textColor": textColor, "$bgColor": bgColor }, className && { className }, { "$placeholderVisible": placeholderVisible, "$height": heightTextArea }, { children: [(0, jsx_runtime_1.jsx)("textarea", { name: registerName !== null && registerName !== void 0 ? registerName : name, required: required, "aria-invalid": !!error, onChange: handleChange, ref: registerRef, disabled: disabled, readOnly: readOnly, placeholder: placeholderVisible ? placeholder : '', onKeyDown: onKeyUp }), label && (0, jsx_runtime_1.jsx)("span", { children: label })] })));
});
const Label = styled_components_1.default.label `
  display: block;
  flex-direction: column;
  height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'mobile')}` : `${(0, styles_1.vw)(60, 'mobile')}`};
  justify-content: flex-end;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  min-height: ${(0, styles_1.vw)(69, 'mobile')};
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'nexus7')}` : `${(0, styles_1.vw)(60, 'nexus7')}`};
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    min-height: ${(0, styles_1.vw)(69, 'nexus7')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'desktop')}` : `${(0, styles_1.vw)(60, 'desktop')}`};
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    min-height: ${(0, styles_1.vw)(47, 'desktop')};
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    height: ${({ $height }) => $height ? `${$height}px` : '60px'};
    margin-bottom: 30px;
    min-height: 47px;
    padding: 0 12px;
  }

  ${({ theme, $placeholderVisible, $textColor }) => (0, styles_1.parsePlaceHolder)(`
    color: ${$placeholderVisible ? theme.colors[$textColor] : 'rgba(0, 0, 0 ,0)'};
    opacity: ${$placeholderVisible ? .4 : 0};
  `)}

  > span {
    ${(0, styles_1.getP18InputLabel)()}
    bottom: ${(0, styles_1.vw)(2, 'mobile')};
    position: relative;
    transform: translateY(-${(0, styles_1.vw)(35, 'mobile')});
    transition: 300ms font-size ease, 300ms transform ease, 300ms opacity ease;

    ${styles_1.mq.greaterThan('nexus7')} {
      bottom: ${(0, styles_1.vw)(2, 'nexus7')};
      transform: translateY(-${(0, styles_1.vw)(35, 'nexus7')});
    }

    ${styles_1.mq.greaterThan('tablet')} {
      bottom: ${(0, styles_1.vw)(12, 'desktop')};
      transform: translateY(-${(0, styles_1.vw)(35, 'desktop')});
    }

    ${styles_1.mq.greaterThan('desktop')} {
      bottom: 12px ;
      transform: translateY(-35px);
    }

  }

  textarea {
    ${(0, styles_1.getP18_3)()}
    background-color: ${({ theme, $bgColor }) => theme.colors[$bgColor]};
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 1px solid;
    border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], .4)};
    display: block;
    height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'mobile')}` : `${(0, styles_1.vw)(60, 'mobile')}`};
    outline: none;
    min-height: ${(0, styles_1.vw)(47, 'mobile')};
    max-height:${(0, styles_1.vw)(148, 'mobile')};
    padding:  ${(0, styles_1.vw)(25, 'mobile')} 0  ${(0, styles_1.vw)(12, 'mobile')};
    position: absolute;
    resize: none;
    top: 0;
    width:98%;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'nexus7')}` : `${(0, styles_1.vw)(60, 'nexus7')}`};
      min-height: ${(0, styles_1.vw)(47, 'nexus7')};
      max-height:${(0, styles_1.vw)(148, 'nexus7')};
      padding:  ${(0, styles_1.vw)(25, 'nexus7')} 0  ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${({ $height }) => $height ? `${(0, styles_1.vw)($height, 'desktop')}` : `${(0, styles_1.vw)(60, 'desktop')}`};
      min-height: ${(0, styles_1.vw)(47, 'desktop')};
      max-height:${(0, styles_1.vw)(148, 'desktop')};
      padding:  ${(0, styles_1.vw)(25, 'desktop')} 0 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: ${({ $height }) => $height ? `${$height}px` : '60px'};
      min-height: 47px;
      max-height: 148px;
      padding: 25px 0 0;
    }

    &:focus {
      border-color: ${({ theme, $textColor }) => (0, styles_1.hex2Rgba)(theme.colors[$textColor], 1)};
      + span {
        ${hasContentState()}
      }
    }
  }
`;


/***/ }),

/***/ 33239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(82385), exports);
__exportStar(__webpack_require__(56154), exports);
__exportStar(__webpack_require__(13259), exports);
__exportStar(__webpack_require__(92638), exports);
__exportStar(__webpack_require__(65026), exports);
__exportStar(__webpack_require__(18607), exports);


/***/ }),

/***/ 41200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MaxHeightContainer = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const framer_motion_1 = __webpack_require__(53316);
const clamp_1 = __webpack_require__(35851);
const variants = {
    active: {
        height: 'auto',
        transition: {
            type: 'tween',
            ease: [.25, .1, .25, 1],
            duration: .3,
        }
    },
    init: {
        height: '0px',
        transition: {
            type: 'tween',
            ease: [.25, .1, .25, 1],
            duration: .3,
        }
    }
};
exports.MaxHeightContainer = (0, react_1.memo)(({ className = '', data, elipsis, force_link = false }) => {
    const elementRef = (0, react_1.useRef)(null);
    const buttonRef = (0, react_1.useRef)(null);
    const [isRendered, setRender] = (0, react_1.useState)(false);
    const [currentData, setData] = (0, react_1.useState)(data);
    const [isExpanded, setExpanded] = (0, react_1.useState)(false);
    // const mediaType = useDeviceType()
    const handleHover = (isHover) => () => {
        if (buttonRef.current && !force_link) {
            isHover ? buttonRef.current.classList.add('active') : buttonRef.current.classList.remove('active');
        }
    };
    (0, react_1.useEffect)(() => {
        if (!elementRef.current)
            return;
        const isClamped = (0, clamp_1.clamp)(elementRef.current, elementRef.current.offsetHeight, { ellipsis: elipsis });
        buttonRef.current = elementRef.current.getElementsByClassName('dy-max-button')[0];
        if (force_link && buttonRef.current) {
            buttonRef.current.addEventListener('click', handleExpanded);
        }
        setExpanded(!isClamped);
    }, [currentData]);
    (0, react_1.useEffect)(() => {
        buttonRef.current = elementRef.current.getElementsByClassName('dy-max-button')[0];
    }, []);
    const handleExpanded = () => {
        if (!buttonRef.current)
            return;
        buttonRef.current.remove();
        setExpanded(true);
    };
    const handleClick = (0, react_1.useRef)(handleExpanded);
    (0, react_1.useEffect)(() => {
        if (!isRendered)
            return;
        setData(data);
    }, [data]);
    (0, react_1.useEffect)(() => {
        setRender(true);
    }, []);
    return isExpanded ? (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { animate: 'active', variants: variants, onClick: null, className: `dy-max expanded ${className}`, dangerouslySetInnerHTML: { __html: currentData } }) :
        (0, jsx_runtime_1.jsx)("div", { onClick: !force_link ? handleClick.current : null, onMouseEnter: handleHover(true), onMouseLeave: handleHover(false), ref: elementRef, className: `dy-max ${className}`, dangerouslySetInnerHTML: { __html: currentData } });
});


/***/ }),

/***/ 35851:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// SRC: https://github.com/yuanqing/line-clamp/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clamp = void 0;
function truncateTextNode(textNode, rootElement, maximumHeight, ellipsisCharacter, element) {
    var lastIndexOfWhitespace;
    var textContent = textNode.textContent;
    while (textContent.length > 1) {
        lastIndexOfWhitespace = textContent.lastIndexOf(' ');
        if (lastIndexOfWhitespace === -1) {
            break;
        }
        textNode.textContent = textContent.substring(0, lastIndexOfWhitespace);
        if (rootElement.scrollHeight <= maximumHeight) {
            textNode.textContent = textContent;
            break;
        }
        textContent = textNode.textContent;
    }
    return truncateTextNodeByCharacter(textNode, rootElement, maximumHeight, ellipsisCharacter, element);
}
var TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/;
function truncateTextNodeByCharacter(textNode, rootElement, maximumHeight, ellipsisCharacter, element) {
    var textContent = textNode.textContent;
    var length = textContent.length;
    while (length > 1) {
        // Trim off one trailing character and any trailing punctuation and whitespace.
        textContent = textContent
            .substring(0, length - 10)
            .replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, '');
        length = textContent.length;
        textNode.textContent = textContent + '... ' + ellipsisCharacter;
        if (rootElement.scrollHeight <= maximumHeight) {
            textNode.textContent = textContent + '... ';
            const button = document.createElement('button');
            const span = document.createElement('span');
            button.textContent = ellipsisCharacter;
            button.appendChild(span);
            button.classList.add('dy-max-button');
            element.appendChild(button);
            return true;
        }
    }
    return false;
}
function truncateElementNode(element, rootElement, maximumHeight, ellipsisCharacter) {
    var childNodes = element.childNodes;
    var i = childNodes.length - 1;
    while (i > -1) {
        var childNode = childNodes[i--];
        var nodeType = childNode.nodeType;
        if ((nodeType === 1 &&
            truncateElementNode(childNode, rootElement, maximumHeight, ellipsisCharacter)) ||
            (nodeType === 3 &&
                truncateTextNode(childNode, rootElement, maximumHeight, ellipsisCharacter, element))) {
            return true;
        }
        element.removeChild(childNode);
    }
    return false;
}
var ELLIPSIS_CHARACTER = '\u2026';
const clamp = function (rootElement, maximumHeight, options = {}) {
    rootElement.style.cssText +=
        'overflow:hidden;overflow-wrap:break-word;word-wrap:break-word';
    // Exit if text does not overflow `rootElement`.
    if (rootElement.scrollHeight <= maximumHeight) {
        return false;
    }
    return truncateElementNode(rootElement, rootElement, maximumHeight, (options && options.ellipsis) || ELLIPSIS_CHARACTER);
};
exports.clamp = clamp;


/***/ }),

/***/ 45391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(41200), exports);


/***/ }),

/***/ 29854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Figure = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const image_1 = __importDefault(__webpack_require__(96577));
const styled_components_1 = __importDefault(__webpack_require__(19453));
const Video_1 = __webpack_require__(43858);
const FigureStyled = styled_components_1.default.figure `
  display: block;
  position: relative;
`;
exports.Figure = (0, react_1.memo)(({ media, lazy = true, fill = true, onClick = null, className = '', outRef = null, sizes = '70vw', quality = 75 }) => {
    var _a;
    const isMobile = false;
    if (!media)
        return (0, jsx_runtime_1.jsx)("figure", { className: 'placeholder' });
    if (media.type === 'video') {
        return (0, jsx_runtime_1.jsx)(Video_1.Video, { data: media });
    }
    else if (media.type === 'svg')
        return ((0, jsx_runtime_1.jsx)(FigureStyled, Object.assign({ className: className }, onClick && { onClick }, outRef && { ref: outRef }, { children: (0, jsx_runtime_1.jsx)(image_1.default, Object.assign({ src: media.src, alt: media.alt, layout: fill ? 'fill' : 'responsive' }, !lazy && { priority: true }, !fill && { height: media.size.height }, !fill && { width: media.size.width })) })));
    return ((0, jsx_runtime_1.jsx)(FigureStyled, Object.assign({ className: className }, onClick && { onClick }, outRef && { ref: outRef }, { children: (0, jsx_runtime_1.jsx)(image_1.default, Object.assign({ src: (_a = media === null || media === void 0 ? void 0 : media[(isMobile && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default']) === null || _a === void 0 ? void 0 : _a.src, alt: media === null || media === void 0 ? void 0 : media.alt, layout: fill ? 'fill' : 'responsive' }, !lazy && { priority: true }, !fill && { height: media === null || media === void 0 ? void 0 : media[(isMobile && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].size.height }, !fill && { width: media === null || media === void 0 ? void 0 : media[(isMobile && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].size.width }, { sizes: sizes }, quality !== 75 && { quality })) })));
});


/***/ }),

/***/ 43858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Video = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const lazy_1 = __importDefault(__webpack_require__(84372));
const hooks_1 = __webpack_require__(92757);
const styles_1 = __webpack_require__(73267);
const styles_2 = __webpack_require__(73267);
const hooks_2 = __webpack_require__(92757);
exports.Video = (0, react_1.memo)(({ data }) => {
    const { platform, long_video: longVideo, short_video: shortVideo } = data;
    const [playing, setPlaying] = (0, react_1.useState)(true);
    const { ref, inView } = (0, hooks_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
        triggerOnce: true
    });
    const { isMobile } = (0, hooks_2.useDeviceType)();
    const url = `https://www.${platform}.com/${platform === 'youtube' ? 'watch?v=' : ''}${longVideo !== null && longVideo !== void 0 ? longVideo : shortVideo}`;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Figure, Object.assign({ ref: ref, className: 'figure--video' }, { children: (0, jsx_runtime_1.jsx)(lazy_1.default, { url: url, playsinline: true, controls: false, volume: 0, muted: true, loop: true, title: '', playing: isMobile ? true : playing }) })) }));
});
const Figure = styled_components_1.default.figure `
  height: auto;
  position: relative;
  width: 100%;

  img {
    width: 100%;
  }

  figcaption {
    ${(0, styles_2.getP12)()}
    border-bottom: ${({ theme }) => (0, styles_2.hex2Rgba)(theme.colors.black, .1)};
    padding-bottom: ${(0, styles_1.vw)(20, 'mobile')};
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};

    ${styles_1.mq.greaterThan('tablet')} {
      padding-bottom: ${(0, styles_1.vw)(20, 'desktop')};
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
    }
  }

  > div {
    height: 100%!important;
    width: 100%!important;
  }

  iframe {
    aspect-ratio: 16 / 9;
    height: 100% !important;
    width: auto !important;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);

    ${styles_1.mq.greaterThan('tablet')} {
      left: unset;
      position: unset;
      transform: none;
      height: auto !important;
      width: 100% !important;
    }
    ${styles_1.mq.greaterThan('desktop')} {
      position: absolute;
      top: 50%;
      transform: translateY(-55%);
    }

  }
`;


/***/ }),

/***/ 24638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(29854), exports);


/***/ }),

/***/ 46340:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ImageSlider = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importStar(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const __1 = __webpack_require__(17566);
const styles_1 = __webpack_require__(73267);
const hooks_1 = __webpack_require__(92757);
const Timeline = (0, react_1.memo)(({ currentIdx, nSlides }) => {
    const controls = (0, framer_motion_1.useAnimation)();
    const [spanVariants] = (0, react_1.useMemo)(() => {
        const variants = {};
        const percentage = 100 / nSlides;
        for (let idx = 0; idx < nSlides; idx++) {
            variants[idx] = {
                width: (idx + 1) * percentage + '%',
                transition: {
                    ease: 'linear',
                    duration: hooks_1.SLIDE_TIME / 1000,
                },
            };
            variants[idx + 'prev'] = {
                width: (idx) * percentage + '%',
                transition: {
                    ease: 'linear',
                    duration: 0.1,
                },
            };
        }
        return [variants];
    }, [nSlides]);
    const changeSpan = (0, react_1.useCallback)((idx) => __awaiter(void 0, void 0, void 0, function* () {
        yield controls.start(idx + 'prev');
        controls.start(idx + '');
    }), []);
    (0, react_1.useEffect)(() => {
        changeSpan(currentIdx);
        return () => {
            controls.stop();
        };
    }, [currentIdx]);
    return ((0, jsx_runtime_1.jsx)(TimelineContainer, Object.assign({ className: 'second' }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'span-container' }, { children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { variants: spanVariants, animate: controls }) })) })));
});
const imageVariants = {
    initial: {
        opacity: 0,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { delay: 0 })
    },
    animate: {
        opacity: 1,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { duration: 1, delay: .3 })
    },
    exit: {
        opacity: 0,
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { duration: .2, delay: 0 })
    }
};
const slideSizes = `(min-width: 768px) ${(0, styles_1.vw)(520, 'desktop')}, ${(0, styles_1.vw)(374, 'mobile')}`;
const getSlide = (image, idx) => {
    var _a;
    if (!image[idx])
        return null;
    return ((0, jsx_runtime_1.jsx)(__1.Figure, { media: (_a = image[idx]) === null || _a === void 0 ? void 0 : _a.medium, lazy: idx > 5, sizes: slideSizes, quality: 99 }));
};
exports.ImageSlider = (0, react_1.memo)(({ data, isPack = false }) => {
    if (!data)
        return (0, jsx_runtime_1.jsx)(SliderStyled, {});
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { currentSlide, triggerRef, nextSlide, prevSlide, setSlide, startAnimation } = (0, hooks_1.useSlider)(data.length);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const Image = (0, react_1.useMemo)(() => getSlide(data, currentSlide), [data, currentSlide]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const nSlides = (0, react_1.useMemo)(() => data.length, [data.length]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, react_1.useEffect)(() => {
        startAnimation();
        setSlide(0);
    }, [data]);
    return ((0, jsx_runtime_1.jsxs)(SliderStyled, Object.assign({ layout: true, ref: triggerRef, isPack: isPack }, { children: [(0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: 'wait' }, { children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, Object.assign({ variants: imageVariants, initial: 'initial', exit: 'exit', animate: 'animate' }, { children: Image }), currentSlide) })), data.length > 1 &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => prevSlide(), className: 'control-btn prev' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--prevslide.svg', width: '40', height: '40' }) })), (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: () => nextSlide(), className: 'control-btn next' }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--nextslide.svg', width: '40', height: '40' }) })), (0, jsx_runtime_1.jsx)(Timeline, { nSlides: nSlides, currentIdx: currentSlide })] })] })));
});
const SliderStyled = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  min-height: ${(0, styles_1.vw)(325, 'mobile')};
  position: relative;

  ${styles_1.mq.greaterThan('nexus7')} {
    min-height: ${(0, styles_1.vw)(325, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    min-height: ${(0, styles_1.vw)(430, 'desktop')};

    &:hover .control-btn {
      display: block;
    }
  }

  ${styles_1.mq.greaterThan('desktop')} {
    min-height: 430px;
  }

  figure {
    height: ${({ isPack }) => isPack ? `${(0, styles_1.vw)(245, 'mobile')}` : `${(0, styles_1.vw)(324, 'mobile')}`};
    margin: ${(0, styles_1.vw)(15, 'mobile')} auto;
    max-width: 100%;
    width: ${(0, styles_1.vw)(374, 'mobile')};

    ${({ isPack }) => { if (isPack) {
    return (0, styled_components_1.css) `width: 100%;`;
} }}

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${({ isPack }) => isPack ? `${(0, styles_1.vw)(245, 'nexus7')}` : `${(0, styles_1.vw)(324, 'nexus7')}`};
      margin: ${(0, styles_1.vw)(15, 'nexus7')} auto;
      width: ${(0, styles_1.vw)(374, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      width: ${(0, styles_1.vw)(520, 'desktop')};
      height: ${({ isPack }) => isPack ? `${(0, styles_1.vw)(407, 'desktop')}` : `${(0, styles_1.vw)(428, 'desktop')}`};
      margin: ${(0, styles_1.vw)(10, 'desktop')} auto;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      width: 520px;
      height: ${({ isPack }) => isPack ? '407px' : '428px'};
      margin: 10px auto;
    }
  }

  img {
    object-fit: ${({ isPack }) => isPack ? 'cover' : 'contain'};
    height: 100%;
  }

  .control-btn {
    display: none;
    position: absolute;
    top: 50%;
    left: ${(0, styles_1.vw)(20, 'mobile')};

    &.next {
      right: ${(0, styles_1.vw)(20, 'mobile')};
      left: auto;
    }

    ${styles_1.mq.greaterThan('nexus7')} {
      left: ${(0, styles_1.vw)(20, 'nexus7')};

      &.next {
        right: ${(0, styles_1.vw)(20, 'nexus7')};
      }
    }

    ${styles_1.mq.greaterThan('tablet')} {
      left: ${(0, styles_1.vw)(20, 'desktop')};
      top: calc(50% - ${(0, styles_1.vw)(10, 'desktop')});

      &.next {
        right: ${(0, styles_1.vw)(20, 'desktop')};
      }
    }

    ${styles_1.mq.greaterThan('desktop')} {
      left: 20px;
      top: calc(50% - 10px);

      &.next {
        right: 20px;
      }
    }
  }
`;
const TimelineContainer = styled_components_1.default.div `
  .span-container {
    background-color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.red, 0.3)};
    position: relative;
    display: block;
    height: ${(0, styles_1.vw)(2, 'mobile')};
    border-radius: 3px;

    span {
      background-color: ${({ theme }) => theme.colors.red};
      position: absolute;
      display: block;
      height: ${(0, styles_1.vw)(2, 'mobile')};
      border-radius: 3px;
    }
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-top: ${(0, styles_1.vw)(10, 'desktop')};
    margin-bottom: ${(0, styles_1.vw)(10, 'desktop')};

    .span-container {
      height: ${(0, styles_1.vw)(3, 'desktop')};

      span { height: ${(0, styles_1.vw)(3, 'desktop')}; }
    }
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-top: 10px;
    margin-bottom: 10px;

    .span-container {
      height: 3px;

      span { height: 3px; }
    }
  }
`;


/***/ }),

/***/ 97699:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

'use client';
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Marquee = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const react_use_1 = __webpack_require__(88180);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const framer_motion_1 = __webpack_require__(53316);
const hooks_1 = __webpack_require__(92757);
const styles_1 = __webpack_require__(73267);
const marqueeOptions = {
    speed: .45,
    threshold: 0.014,
    wheelFactor: 1.8,
    dragFactor: 1.2
};
const MarqueeItem = ({ content, speed }) => {
    const item = (0, react_1.useRef)(null);
    const rect = (0, react_1.useRef)(null);
    const x = (0, react_1.useRef)(0);
    const { size: { width, height } } = (0, hooks_1.useDeviceType)();
    const setX = () => {
        if (!item.current || !rect.current)
            return;
        const xPercentage = (x.current / rect.current.width) * 100;
        if (xPercentage < -100)
            x.current = 0;
        if (xPercentage > 0)
            x.current = -rect.current.width;
        item.current.style.transform = `translate3d(${xPercentage}%, 0, 0)`;
    };
    (0, react_1.useEffect)(() => {
        rect.current = item.current.getBoundingClientRect();
    }, [width, height]);
    const loop = (_e) => {
        x.current -= speed.get();
        setX();
    };
    (0, react_use_1.useRafLoop)(loop, true);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'item', ref: item }, { children: content }));
};
const springOptions = {
    damping: 40,
    stiffness: 90,
    mass: 5
};
const Marquee = ({ data, options = null }) => {
    var _a;
    const marquee = (0, react_1.useRef)(null);
    const slowDown = (0, react_1.useRef)(false);
    const x = (0, react_1.useRef)(0);
    const w = (0, react_1.useRef)(typeof window !== 'undefined' ? window.innerWidth : 0).current;
    const speed = (0, framer_motion_1.useSpring)((_a = options === null || options === void 0 ? void 0 : options.speed) !== null && _a !== void 0 ? _a : marqueeOptions.speed, springOptions);
    const skewX = (0, framer_motion_1.useTransform)(speed, [-w * 0.25, 0, w * 0.25], [-25, 0, 25]);
    const loop = () => {
        var _a;
        if (slowDown.current || Math.abs(x.current) < marqueeOptions.threshold)
            return;
        x.current *= 0.66;
        x.current = x.current < 0 ? Math.min(x.current, 0) : Math.max(x.current, 0);
        speed.set(((_a = options === null || options === void 0 ? void 0 : options.speed) !== null && _a !== void 0 ? _a : marqueeOptions.speed) + x.current);
    };
    (0, react_use_1.useRafLoop)(loop, true);
    return ((0, jsx_runtime_1.jsxs)(Div, Object.assign({ className: 'marquee', ref: marquee, style: { skewX } }, { children: [(0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed })] })));
};
exports.Marquee = Marquee;
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  align-items: center;
  display: flex;

  .item {
    ${(0, styles_1.getP93)()}
    align-items: center;
    color: ${({ theme }) => theme.colors.creme};
    display: flex;
    height: 100px;
    padding: ${(0, styles_1.vw)(20, 'mobile')} 0;
    padding-right: 0 !important;
    width: auto;
    white-space: nowrap;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: ${(0, styles_1.vw)(20, 'nexus7')} 0;
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: ${(0, styles_1.vw)(40, 'desktop')} 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 40px 10px;
    }

    &:after {
      content: '·';
      display: inline-block;
      padding: 0 ${(0, styles_1.vw)(30, 'mobile')};
      width: fit-content;

      ${styles_1.mq.greaterThan('nexus7')} {
        padding: 0 ${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        padding: 0 ${(0, styles_1.vw)(30, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        padding: 30px;
      }
    }
  }

  ul {
    display: flex;
  }
`;


/***/ }),

/***/ 45980:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SliderFlickity = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_flickity_component_1 = __importDefault(__webpack_require__(2421));
const react_1 = __webpack_require__(2784);
const defaultOptions = {
    accessibility: false,
    autoPlay: false,
    cellAlign: 'left',
    contain: true,
    draggable: true,
    dragThreshold: 5,
    freeScroll: true,
    freeScrollFriction: 0.075,
    friction: 0.15,
    groupCells: false,
    initialIndex: 0,
    lazyLoad: 2,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    pageDots: false,
    resize: true,
    selectedAttraction: 0.01,
    wrapAround: false
};
//   // just in case the dragEnd event doesn't fire:
//   document.body.addEventListener('touchstart', (ev) => {
//     document.ontouchmove = () => true;
//   });
// }
const sliderBeingDragged = 'slider-being-dragged';
function dragEnd() {
    document.ontouchmove = () => true;
    setTimeout(() => {
        document.body.classList.remove(sliderBeingDragged);
    }, 50);
}
function dragMove() {
    document.ontouchmove = () => false;
    document.body.classList.add(sliderBeingDragged);
}
function dragStart() {
    document.ontouchmove = () => false;
}
exports.SliderFlickity = (0, react_1.memo)(({ children, className = '', elementType = 'div', options = {}, onChange = null, reloadOnUpdate = false, dynamicSlider = false }) => {
    const [flickityRef, setFlickityRef] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!flickityRef)
            return;
        flickityRef.on('dragStart', dragStart);
        flickityRef.on('dragMove', dragMove);
        flickityRef.on('dragEnd', dragEnd);
        if (onChange)
            flickityRef.on('change', onChange);
        return () => {
            flickityRef.off('dragStart', dragStart);
            flickityRef.off('dragMove', dragMove);
            flickityRef.off('dragEnd', dragEnd);
            if (onChange)
                flickityRef.off('change', onChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flickityRef]);
    return ((0, jsx_runtime_1.jsx)(react_flickity_component_1.default, Object.assign({ flickityRef: (ref) => setFlickityRef(ref), className: `slider ${className}`, elementType: elementType, options: Object.assign(Object.assign({}, defaultOptions), options), disableImagesLoaded: false, reloadOnUpdate: reloadOnUpdate, static: !dynamicSlider }, { children: children })));
});


/***/ }),

/***/ 88252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(45980), exports);
__exportStar(__webpack_require__(46340), exports);
__exportStar(__webpack_require__(97699), exports);


/***/ }),

/***/ 72938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartProvider = exports.CartContext = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const initialCartState = { id: null, cartLines: [], subtotalExTax: 0, totalExTax: 0, deliveryDate: null, deliveryDateOptions: null, multipleDeliveryDates: false, discountAmount: 0, deliveryType: 'fresh', isFrozenCart: false, deliverySchedules: [], notifications: [] };
exports.CartContext = (0, react_1.createContext)(initialCartState);
const cartReducer = (state = initialCartState, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'ADD':
        case 'REMOVE':
        case 'DELETE':
        case 'BULKUPDATE':
            return Object.assign(Object.assign({}, state), { id: payload.cartId, cartLines: payload.cartLines, subtotalExTax: payload.subtotalExTax, totalExTax: payload.totalExTax, discountAmount: payload.discountAmount, deliveryDate: payload.deliveryDate, deliveryDateOptions: payload.deliveryDateOptions, multipleDeliveryDates: payload.multipleDeliveryDates, notifications: payload.notifications });
        default:
            throw new Error(`cartReducer: No case for type: ${type}`);
    }
};
const CartProvider = ({ children }) => {
    const [state, dispatch] = (0, react_1.useReducer)(cartReducer, initialCartState);
    const [isFrozenCart, setIsFrozenCart] = (0, react_1.useState)(false);
    const addToCart = (productVariant) => {
        const index = state.cartLines.findIndex(item => item.variant.id === productVariant.variant.id);
        let updatedCart = [...state.cartLines];
        if (index !== -1) {
            updatedCart[index] = productVariant;
        }
        else {
            updatedCart.push(productVariant);
        }
        dispatch({ type: 'ADD',
            payload: {
                cartLines: updatedCart
            }
        });
    };
    const removeFromCart = (productVariant) => {
        const index = state.cartLines.findIndex(item => item.variant.id === productVariant.variant.id);
        let updatedCart = [];
        if (index !== -1 && productVariant.quantity > 0) {
            updatedCart = [...state.cartLines];
            updatedCart[index] = productVariant;
        }
        else {
            updatedCart = state.cartLines.filter(item => item.variant.id !== productVariant.variant.id);
        }
        dispatch({ type: 'REMOVE',
            payload: {
                cartLines: updatedCart
            }
        });
    };
    const deleteFromCart = (variantId) => {
        const updatedCart = state.cartLines.filter(item => item.variant.id !== variantId);
        dispatch({ type: 'DELETE',
            payload: {
                cartLines: updatedCart
            }
        });
    };
    const bulkUpdateCart = (cartLines, cartId, subtotalExTax, totalExTax, deliveryDate, deliveryDateOptions, multipleDeliveryDates, discountAmount, deliveryType, deliverySchedules, notifications) => {
        dispatch({ type: 'BULKUPDATE',
            payload: {
                cartLines,
                cartId,
                subtotalExTax,
                totalExTax,
                deliveryDate,
                deliveryDateOptions,
                multipleDeliveryDates,
                discountAmount,
                deliveryType,
                deliverySchedules,
                notifications
            }
        });
    };
    (0, react_1.useEffect)(() => {
        function checkFrozenCart() {
            const isFrozen = state.cartLines.some(item => { var _a; return ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.deliveryType) === 'frozen'; });
            setIsFrozenCart(isFrozen);
        }
        checkFrozenCart();
        console.log('🛒 Cart type:', isFrozenCart ? 'frozen' : 'fresh');
    }, [isFrozenCart, state.cartLines]);
    return ((0, jsx_runtime_1.jsx)(exports.CartContext.Provider, Object.assign({ value: {
            id: state.id,
            cartLines: state.cartLines,
            subtotalExTax: state.subtotalExTax,
            totalExTax: state.totalExTax,
            deliveryDate: state.deliveryDate,
            deliveryDateOptions: state.deliveryDateOptions,
            multipleDeliveryDates: state.multipleDeliveryDates,
            discountAmount: state.discountAmount,
            deliveryType: state.deliveryType,
            deliverySchedules: state.deliverySchedules,
            notifications: state.notifications,
            isFrozenCart,
            addToCart,
            removeFromCart,
            deleteFromCart,
            bulkUpdateCart
        } }, { children: children })));
};
exports.CartProvider = CartProvider;


/***/ }),

/***/ 90221:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModalsProvider = exports.ModalsContext = exports.MODALS = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
var MODALS;
(function (MODALS) {
    MODALS["ADD_TO_CART"] = "modal_add_to_cart";
    MODALS["AUTH"] = "modal_auth";
    MODALS["CART_TYPE"] = "modal_cart_type";
    MODALS["MENU_ACCOUNT"] = "modal_account";
    MODALS["MENU"] = "modal_menu";
    MODALS["PROMO"] = "modal_promo";
    MODALS["REGION_LANG"] = "modal_region_lang";
    MODALS["SEARCH"] = "modal_search";
    MODALS["COMERCIAL"] = "modal_comercial_region";
    MODALS["NEWSLETTER"] = "modal_newsletter";
    MODALS["FILTER"] = "modal_filters";
    MODALS["VIDEO"] = "modal_video";
    MODALS["STOCK_CART"] = "modal_stock_cart";
    MODALS["PUBLIC_INTERESTED"] = "modal_public_interested";
    MODALS["BUY_BOX"] = "modal_buy_box";
})(MODALS = exports.MODALS || (exports.MODALS = {}));
const initialState = {
    modals: {},
    setModal: () => { },
    someModalIsActive: false
};
exports.ModalsContext = (0, react_1.createContext)(initialState);
const ModalsProvider = ({ children }) => {
    const [modals, setModals] = (0, react_1.useState)({});
    const [someModalIsActive, setSomeModalIsActive] = (0, react_1.useState)(false);
    const setModal = (modal) => {
        setModals(prevModals => (Object.assign(Object.assign({}, prevModals), modal)));
        let someActive = false;
        const [modalKeyname, modalData] = Object.entries(modal)[0];
        if (modalData === null || modalData === void 0 ? void 0 : modalData.isActive)
            someActive = true;
        else {
            for (const [mKeyname, m] of Object.entries(modals)) {
                // Object.entries(modals) still have the old state for the current modal
                // so we only check if any other modal isActive
                if (m.isActive && modalKeyname !== mKeyname) {
                    someActive = true;
                    break;
                }
            }
        }
        setSomeModalIsActive(someActive);
    };
    (0, react_1.useEffect)(() => {
        document.body.style.overflow = someModalIsActive ? 'hidden' : 'initial';
        document.body.style.height = someModalIsActive ? '100vh' : 'unset';
    }, [someModalIsActive]);
    return ((0, jsx_runtime_1.jsx)(exports.ModalsContext.Provider, Object.assign({ value: { modals, setModal, someModalIsActive } }, { children: children })));
};
exports.ModalsProvider = ModalsProvider;


/***/ }),

/***/ 38399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ToastProvider = exports.ToastContext = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const Toast_1 = __webpack_require__(91840);
exports.ToastContext = (0, react_1.createContext)(undefined);
const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = (0, react_1.useState)([]);
    const toastIdRef = (0, react_1.useRef)(0);
    const addToast = (0, react_1.useCallback)((toastData) => {
        setToasts((prevToasts) => [
            ...prevToasts,
            Object.assign(Object.assign({}, toastData), { id: toastIdRef.current++ }),
        ]);
    }, [setToasts]);
    return ((0, jsx_runtime_1.jsxs)(exports.ToastContext.Provider, Object.assign({ value: { addToast } }, { children: [children, (0, jsx_runtime_1.jsx)(Toast_1.ToastWrapper, Object.assign({ "aria-live": 'assertive', "aria-atomic": 'true' }, { children: toasts.map((toast) => ((0, jsx_runtime_1.jsx)(Toast_1.Toast, Object.assign({}, toast, { onClose: () => setToasts((prev) => prev.filter((t) => t.id !== toast.id)) }), toast.id))) }))] })));
};
exports.ToastProvider = ToastProvider;


/***/ }),

/***/ 7693:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(72938), exports);
__exportStar(__webpack_require__(90221), exports);
__exportStar(__webpack_require__(38399), exports);


/***/ }),

/***/ 92757:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(95334), exports);
__exportStar(__webpack_require__(61528), exports);
__exportStar(__webpack_require__(60393), exports);
__exportStar(__webpack_require__(71122), exports);
__exportStar(__webpack_require__(21186), exports);
__exportStar(__webpack_require__(74117), exports);
__exportStar(__webpack_require__(31127), exports);
__exportStar(__webpack_require__(65853), exports);


/***/ }),

/***/ 61528:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCart = void 0;
const react_1 = __webpack_require__(2784);
const context_1 = __webpack_require__(7693);
function useCart() {
    const ctx = (0, react_1.useContext)(context_1.CartContext);
    if (ctx === undefined)
        throw new Error('useCart must be used within a CartProvider');
    return ctx;
}
exports.useCart = useCart;


/***/ }),

/***/ 95334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useDeviceType = exports.iOS = exports.isSafari = void 0;
const react_1 = __webpack_require__(2784);
const BREAKPOINTS = {
    mobile: 375,
    tablet: 768,
    desktopXs: 992,
    desktop: 1440,
    getDeviceType(width) {
        return width < this.tablet ? 'mobile' :
            width < this.desktopXs ? 'tablet' :
                'desktop';
    }
};
const checkUserAgent = () => {
    const UA = navigator.userAgent;
    return UA ? Boolean(UA.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)) : false;
};
const isSafari = () => {
    const UA = navigator.userAgent;
    return UA ? Boolean(UA.match(/^((?!chrome|android).)*safari/i)) : false;
};
exports.isSafari = isSafari;
const iOS = () => {
    const UA = navigator.userAgent;
    return UA ? Boolean(UA.match(/iPhone|iPad|iPod/i)) : false;
};
exports.iOS = iOS;
const initialInfo = {
    size: { width: undefined, height: undefined },
    deviceType: 'desktop',
    isMobile: false,
    mobileDevice: false,
    mobileLandscape: false,
    isTouchDevice: false
};
const getInfo = (isClient) => {
    var _a;
    return isClient ? {
        size: { width: window.innerWidth, height: window.innerHeight },
        deviceType: BREAKPOINTS.getDeviceType(window.innerWidth),
        isMobile: BREAKPOINTS.getDeviceType(window.innerWidth) === 'mobile',
        mobileDevice: checkUserAgent(),
        mobileLandscape: ((_a = screen === null || screen === void 0 ? void 0 : screen.orientation) === null || _a === void 0 ? void 0 : _a.angle) === 90,
        isTouchDevice: (('ontouchstart' in window) || (navigator.maxTouchPoints > 0))
    } : initialInfo;
};
function debounce(func, miliseconds) {
    let timer;
    return function (event) {
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(func, miliseconds, event);
    };
}
const useDeviceType = (miliseconds = 500) => {
    const [info, setInfo] = (0, react_1.useState)(getInfo(typeof window !== 'undefined'));
    const handleResize = (0, react_1.useCallback)(() => {
        const newInfo = getInfo(typeof window !== 'undefined');
        setInfo(newInfo);
    }, [setInfo]);
    const debouncedHandler = debounce(handleResize, miliseconds);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', debouncedHandler, { passive: true });
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', debouncedHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return info;
};
exports.useDeviceType = useDeviceType;


/***/ }),

/***/ 60393:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useInView = void 0;
const react_1 = __webpack_require__(2784);
const useInView = (options = {}) => {
    const ref = (0, react_1.useRef)(null);
    const [inView, setInView] = (0, react_1.useState)((options === null || options === void 0 ? void 0 : options.initialInView) || false);
    const [entry, setEntry] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        if (options.skip || !ref)
            return;
        const observerOptions = {
            threshold: options.threshold || 0,
            rootMargin: options.rootMargin || '0px',
        };
        let observer;
        const handleIntersection = (entries) => {
            const [firstEntry] = entries;
            setInView(firstEntry.isIntersecting);
            setEntry(firstEntry);
            if (options.triggerOnce && firstEntry.isIntersecting)
                observer.disconnect();
        };
        if (typeof IntersectionObserver !== 'undefined') {
            observer = new IntersectionObserver(handleIntersection, observerOptions);
            const currentRef = ref.current;
            if (currentRef)
                observer.observe(currentRef);
        }
        else {
            // Fallback behavior when IntersectionObserver is not available
            console.warn('IntersectionObserver is not supported in this browser. Please consider using a polyfill.');
        }
        return () => { if (observer)
            observer.disconnect(); };
    }, [options]);
    return { ref, inView, entry };
};
exports.useInView = useInView;


/***/ }),

/***/ 21186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useModal = void 0;
const react_1 = __webpack_require__(2784);
const context_1 = __webpack_require__(7693);
const useModal = (id, openOnLoad = false) => {
    const { modals, setModal, someModalIsActive } = (0, react_1.useContext)(context_1.ModalsContext);
    const { isActive, payload } = (0, react_1.useMemo)(() => { var _a; return (_a = modals[id]) !== null && _a !== void 0 ? _a : { isActive: openOnLoad, payload: null }; }, [modals, id, openOnLoad]);
    const toggle = (0, react_1.useCallback)(() => {
        setModal({ [id]: { isActive: !isActive, payload } });
    }, [id, setModal, isActive, payload]);
    const updatePayload = (0, react_1.useCallback)(({ payload = null, close = false, open = false }) => {
        setModal({ [id]: { isActive: open ? open : close ? false : isActive, payload } });
    }, [id, setModal, isActive]);
    const handleEsc = (0, react_1.useCallback)((e) => {
        if (e.key === 'Escape')
            toggle();
    }, [toggle]);
    (0, react_1.useEffect)(() => {
        if (!modals[id])
            setModal({ [id]: { isActive: openOnLoad, payload: null } });
    }, [id, modals, setModal, openOnLoad]);
    (0, react_1.useEffect)(() => {
        if (isActive)
            window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [isActive, handleEsc]);
    return { isActive, toggle, payload, updatePayload, someModalIsActive };
};
exports.useModal = useModal;


/***/ }),

/***/ 74117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMount = void 0;
const react_1 = __webpack_require__(2784);
const useMount = () => {
    const [isMount, setMount] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setMount(true);
        return () => setMount(false);
    }, []);
    return isMount;
};
exports.useMount = useMount;


/***/ }),

/***/ 71122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useScrollTracker = void 0;
const react_1 = __webpack_require__(2784);
const SCROLL = {
    currentState: 'TOP',
    lastScroll: 0,
    getCurrentState(currentScroll, maxHeight) {
        if (currentScroll < maxHeight)
            this.currentState = 'TOP';
        else {
            if (this.lastScroll < currentScroll)
                this.currentState = 'SCROLLING_DOWN';
            else if (this.lastScroll > currentScroll)
                this.currentState = 'SCROLLING_UP';
        }
        this.lastScroll = currentScroll;
        return this.currentState;
    }
};
const useScrollTracker = (maxHeight = 60) => {
    const [scrollState, setScrollState] = (0, react_1.useState)('TOP');
    const trackScroll = () => {
        const newState = SCROLL.getCurrentState(window.scrollY, maxHeight);
        setScrollState((currentState) => {
            return (currentState !== newState) ? newState : currentState;
        });
    };
    const debounceTrackScroll = () => requestAnimationFrame(trackScroll);
    (0, react_1.useEffect)(() => {
        window.addEventListener('scroll', debounceTrackScroll, { passive: true });
        return () => window.removeEventListener('scroll', debounceTrackScroll);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxHeight]);
    return scrollState;
};
exports.useScrollTracker = useScrollTracker;


/***/ }),

/***/ 31127:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSlider = exports.SLIDE_TIME = void 0;
const react_1 = __webpack_require__(2784);
const hooks_1 = __webpack_require__(92757);
exports.SLIDE_TIME = 5000;
const useSlider = (maxSize, always = false) => {
    const [currentSlide, setSlide] = (0, react_1.useState)(0);
    const TIMEOUT_ID = (0, react_1.useRef)(null);
    const { ref, inView } = (0, hooks_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
    });
    const nSlides = (0, react_1.useMemo)(() => maxSize, [maxSize]);
    const tick = (0, react_1.useCallback)((current) => {
        TIMEOUT_ID.current && clearTimeout(TIMEOUT_ID.current);
        const newSlideIndex = current + 1;
        const nextSlide = newSlideIndex < 0 ? nSlides - 1 : newSlideIndex % nSlides;
        TIMEOUT_ID.current = setTimeout(() => tick(nextSlide), exports.SLIDE_TIME);
        setSlide(nextSlide);
    }, [nSlides]);
    const startAnimation = (0, react_1.useCallback)(() => {
        tick(currentSlide);
    }, [currentSlide, tick]);
    const nextSlide = (0, react_1.useCallback)(() => {
        tick(currentSlide);
    }, [currentSlide, tick]);
    const prevSlide = (0, react_1.useCallback)(() => {
        tick(currentSlide - 2);
    }, [currentSlide, tick]);
    (0, react_1.useEffect)(() => {
        if (inView || always) {
            TIMEOUT_ID.current && clearTimeout(TIMEOUT_ID.current);
            TIMEOUT_ID.current = setTimeout(() => startAnimation(), exports.SLIDE_TIME);
        }
        else {
            TIMEOUT_ID.current && clearTimeout(TIMEOUT_ID.current);
            TIMEOUT_ID.current = null;
        }
        return () => {
            TIMEOUT_ID.current && clearTimeout(TIMEOUT_ID.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView, startAnimation]);
    return { currentSlide, triggerRef: ref, nextSlide, prevSlide, setSlide, startAnimation };
};
exports.useSlider = useSlider;


/***/ }),

/***/ 65853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useToast = void 0;
const react_1 = __webpack_require__(2784);
const context_1 = __webpack_require__(7693);
const useToast = () => {
    const ctx = (0, react_1.useContext)(context_1.ToastContext);
    if (!ctx)
        throw new Error('useToast must be used within a ToastProvider');
    return ctx;
};
exports.useToast = useToast;


/***/ }),

/***/ 49070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getP12_3 = exports.getP12_2 = exports.getP12_1B = exports.getP12_1 = exports.getP12 = exports.getP13_3 = exports.getP15_6 = exports.getP15_5 = exports.getP15_4 = exports.getP15_3B = exports.getP15_3 = exports.getP15_2 = exports.getP15_2B = exports.getP15_1B = exports.getP15 = exports.getP15_1 = exports.getP16 = exports.getP18_1B = exports.getP18InputHasContentLabel = exports.getP18 = exports.getP18InputLabel = exports.getP18_4 = exports.getP18_3 = exports.getP18_2 = exports.getP18_1 = exports.getP20_Mobile = exports.getP20_4 = exports.getP20_3 = exports.getP20_2 = exports.getP20_5 = exports.getP20_1 = exports.getP20 = exports.getP25 = exports.getP26_4 = exports.getP26_3 = exports.getP26_2 = exports.getP26_1 = exports.getP26 = exports.getP30_2 = exports.getP30_1 = exports.getP30 = exports.getP35 = exports.getP45 = exports.getP53_2 = exports.getP50_1 = exports.getP53 = exports.getP93_1 = exports.getP93 = exports.getP113 = exports.getP141 = void 0;
exports.font12_15 = exports.getP17NavLinks = exports.getP20v2 = exports.getP27_P18 = exports.getP15Search = exports.getP14Search = exports.getP9 = exports.getP10 = exports.getP10_1 = void 0;
const styled_components_1 = __webpack_require__(19453);
const _1 = __webpack_require__(73267);
const _2 = __webpack_require__(73267);
// 1rem mobile -> 15px, 1rem desktop -> 18px
const rem = {
    baseMobile: 15,
    base: 18,
    get: (value, factor = null) => `${value / (factor !== null && factor !== void 0 ? factor : rem.baseMobile)}rem`
};
const getP141 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(75)};
    font-weight: 700;
    line-height: ${rem.get(64)};
    letter-spacing: 1.56px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(141, rem.base)};
      line-height: ${rem.get(122, rem.base)};
      letter-spacing: 2.94px;
    }
  `;
};
exports.getP141 = getP141;
const getP113 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(55)};
    font-weight: 700;
    line-height: ${rem.get(50)};
    letter-spacing: 0.53px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(113, rem.base)};
      line-height: ${rem.get(97, rem.base)};
      letter-spacing: 1px;
    }
  `;
};
exports.getP113 = getP113;
const getP93 = (lineHeightMobile = 54, lineHeightDesktop = 112) => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(45)};
    font-weight: bold;
    line-height: ${rem.get(lineHeightMobile)};
    letter-spacing: 1.45px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(93, rem.base)};
      line-height: ${rem.get(lineHeightDesktop, rem.base)};
      letter-spacing: 3px;
    }
  `;
};
exports.getP93 = getP93;
const getP93_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(45)};
    font-weight: 700;
    line-height: ${rem.get(40)};
    letter-spacing: 1.45px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(93, rem.base)};
      line-height: ${rem.get(83, rem.base)};
      letter-spacing: 1px;
    }
  `;
};
exports.getP93_1 = getP93_1;
const getP53 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(27)};
    font-weight: bold;
    line-height: ${rem.get(29)};
    letter-spacing: 0.56px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(53, rem.base)};
      line-height: ${rem.get(57, rem.base)};
      letter-spacing: 1px;
    }
  `;
};
exports.getP53 = getP53;
const getP50_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(50)};
    font-weight: regular;
    line-height: ${rem.get(54)};
    letter-spacing: -3.81px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(50, rem.base)};
      line-height: ${rem.get(54, rem.base)};
      letter-spacing: -3.81px;
    }
  `;
};
exports.getP50_1 = getP50_1;
// salePrice PDP
const getP53_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(27)};
    font-weight: 700;
    line-height: ${rem.get(29)};
    letter-spacing: 0.56px;
    font-family: ${_2.themeProject.fonts.primaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(53, rem.base)};
      line-height: ${rem.get(45, rem.base)};
      letter-spacing: .59px;
    }
  `;
};
exports.getP53_2 = getP53_2;
const getP45 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(36)};
    font-weight: 700;
    line-height: ${rem.get(40)};
    letter-spacing: 0.37px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(45, rem.base)};
      line-height: ${rem.get(40, rem.base)};
      letter-spacing: 0.56px;
    }
  `;
};
exports.getP45 = getP45;
const getP35 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(28)};
    font-weight: 400;
    line-height: ${rem.get(32)};
    letter-spacing: -1.13px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(35, rem.base)};
      line-height: ${rem.get(38.8, rem.base)};
      letter-spacing: -1.67px;
    }
  `;
};
exports.getP35 = getP35;
const getP30 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 700;
    line-height: ${rem.get(24)};
    letter-spacing: -0.2px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(30, rem.base)};
      line-height: ${rem.get(42, rem.base)};
      letter-spacing: -0.3px;
    }
  `;
};
exports.getP30 = getP30;
const getP30_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: 300;
    line-height: ${rem.get(19)};
    letter-spacing: -0.8px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(30, rem.base)};
      line-height: ${rem.get(37, rem.base)};
      letter-spacing: -1.5px;
    }
  `;
};
exports.getP30_1 = getP30_1;
// salePrice PDP pricePer (/.ud, /caja.)
const getP30_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(24)};
    font-weight: 700;
    line-height: ${rem.get(35)};
    letter-spacing: 0.27px;
    font-family: ${_2.themeProject.fonts.primaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(30, rem.base)};
      line-height: ${rem.get(42, rem.base)};
      letter-spacing: 0.33px;
    }
  `;
};
exports.getP30_2 = getP30_2;
const getP26 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 700;
    line-height: ${rem.get(24)};
    letter-spacing: -0.22px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(26, rem.base)};
      line-height: ${rem.get(29, rem.base)};
      letter-spacing: -.26px;
    }
  `;
};
exports.getP26 = getP26;
const getP26_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: regular;
    line-height: ${rem.get(19)};
    letter-spacing: -0.8px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(26, rem.base)};
      font-weight: 300;
      line-height: ${rem.get(29, rem.base)};
      letter-spacing: -0.3px;
    }
  `;
};
exports.getP26_1 = getP26_1;
const getP26_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 700;
    line-height: ${rem.get(24)};
    letter-spacing: 0.22px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(26, rem.base)};
      line-height: ${rem.get(30, rem.base)};
      letter-spacing: -0.26px;
    }
  `;
};
exports.getP26_2 = getP26_2;
// ProductCard -> salePrice
const getP26_3 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 700;
    line-height: ${rem.get(21)};
    letter-spacing: .22px;
    font-family: ${_2.themeProject.fonts.primaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(26, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: .29px;
    }
  `;
};
exports.getP26_3 = getP26_3;
// contents
const getP26_4 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: 300;
    line-height: ${rem.get(20)};
    letter-spacing: -0.8px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(26, rem.base)};
      line-height: ${rem.get(34, rem.base)};
      letter-spacing: -1.41px;
    }
  `;
};
exports.getP26_4 = getP26_4;
const getP25 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(19)};
    font-weight: 700;
    line-height: ${rem.get(24)};
    letter-spacing: -0.22px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(25, rem.base)};
      line-height: ${rem.get(29, rem.base)};
      letter-spacing: -.26px;
    }
  `;
};
exports.getP25 = getP25;
const getP20 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 700;
    line-height: ${rem.get(24)};
    letter-spacing: 0.5px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(24, rem.base)};
      letter-spacing: 0.5px;
    }
  `;
};
exports.getP20 = getP20;
const getP20_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(18)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: -0.36px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -0.5px;
    }
  `;
};
exports.getP20_1 = getP20_1;
const getP20_5 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(18)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: -0.36px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -0.5px;
    }
  `;
};
exports.getP20_5 = getP20_5;
const getP20_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: 500;
    line-height: ${rem.get(19)};
    letter-spacing: -.8px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -.5px;
    }
  `;
};
exports.getP20_2 = getP20_2;
const getP20_3 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: bold;
    line-height: ${rem.get(19)};
    letter-spacing: -.8px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(16, rem.base)};
      letter-spacing: -.5px;
    }
  `;
};
exports.getP20_3 = getP20_3;
const getP20_4 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: 300;
    line-height: ${rem.get(19)};
    letter-spacing: -.8px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -.5px;
    }
  `;
};
exports.getP20_4 = getP20_4;
const getP20_Mobile = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(20)};
    font-weight: 600;
    line-height: ${rem.get(25)};
    letter-spacing: -0.23px;
  `;
};
exports.getP20_Mobile = getP20_Mobile;
const getP18_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 300;
    line-height: ${rem.get(19)};
    letter-spacing: -0.3px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(22, rem.base)};
      letter-spacing: -0.36px;
    }
  `;
};
exports.getP18_1 = getP18_1;
const getP18_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(19)};
    letter-spacing: -0.3px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(25, rem.base)};
      letter-spacing: -0.36px;
    }
  `;
};
exports.getP18_2 = getP18_2;
const getP18_3 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(18)};
    font-weight: 500;
    line-height: ${rem.get(22)};
    letter-spacing: -0.36px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(22, rem.base)};
    }
  `;
};
exports.getP18_3 = getP18_3;
const getP18_4 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 700;
    line-height: ${rem.get(19)};
    letter-spacing: -0.3px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(22, rem.base)};
      letter-spacing: -0.36px;
    }
  `;
};
exports.getP18_4 = getP18_4;
const getP18InputLabel = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: -.3px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(15, rem.base)};
      letter-spacing: -.36px;
    }
  `;
};
exports.getP18InputLabel = getP18InputLabel;
const getP18 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: -.3px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(15, rem.base)};
      letter-spacing: -.36px;
    }
  `;
};
exports.getP18 = getP18;
const getP18InputHasContentLabel = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(12)};
    font-weight: 500;
    line-height: ${rem.get(10)};
    font-family: ${_2.themeProject.fonts.secondaryFont};
    letter-spacing: -.3px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(10, rem.base)};
      letter-spacing: -.36px;
    }
  `;
};
exports.getP18InputHasContentLabel = getP18InputHasContentLabel;
const getP18_1B = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(19)};
    letter-spacing: -0.3px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      font-weight: 700;
      line-height: ${rem.get(22, rem.base)};
      letter-spacing: 0px;
    }
  `;
};
exports.getP18_1B = getP18_1B;
const getP16 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(16)};
    font-weight: 500;
    line-height: ${rem.get(19)};
    letter-spacing: -0.8px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(16, rem.base)};
      line-height: ${rem.get(19, rem.base)};
      letter-spacing: 0;
    }
  `;
};
exports.getP16 = getP16;
const getP15_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(12)};
    font-weight: 300;
    line-height: ${rem.get(15)};
    letter-spacing: -0.4px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(20, rem.base)};
      letter-spacing: -0.5px;
    }
  `;
};
exports.getP15_1 = getP15_1;
const getP15 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(12)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: 0.13px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.17px;
    }
  `;
};
exports.getP15 = getP15;
const getP15_1B = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(13)};
    font-weight: 300;
    line-height: ${rem.get(15)};
    letter-spacing: -0.4px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(20, rem.base)};
      letter-spacing: -0.5px;
    }
  `;
};
exports.getP15_1B = getP15_1B;
const getP15_2B = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(15)};
    letter-spacing: -.3px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(15, rem.base)};
      letter-spacing: -.36px;
    }
  `;
};
exports.getP15_2B = getP15_2B;
const getP15_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(19)};
    letter-spacing: -.38px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(19, rem.base)};
    }
  `;
};
exports.getP15_2 = getP15_2;
const getP15_3 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 700;
    line-height: ${rem.get(25)};
    letter-spacing: -.38px;
    font-family: ${_2.themeProject.fonts.primaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.17px;
    }
  `;
};
exports.getP15_3 = getP15_3;
const getP15_3B = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 700;
    line-height: ${rem.get(20)};
    letter-spacing: 0px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(20, rem.base)};
      letter-spacing: 0px;
    }
  `;
};
exports.getP15_3B = getP15_3B;
const getP15_4 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(18)};
    letter-spacing: -.38px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(18, rem.base)};
    }
  `;
};
exports.getP15_4 = getP15_4;
const getP15_5 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 300;
    line-height: ${rem.get(14)};
    letter-spacing: -.38px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(14, rem.base)};
    }
  `;
};
exports.getP15_5 = getP15_5;
const getP15_6 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(15)};
    font-weight: 500;
    line-height: ${rem.get(14)};
    letter-spacing: -.38px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(15, rem.base)};
      line-height: ${rem.get(14, rem.base)};
    }
  `;
};
exports.getP15_6 = getP15_6;
const getP13_3 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(9)};
    font-weight: 700;
    line-height: ${rem.get(15)};
    letter-spacing: -.38px;
    font-family: ${_2.themeProject.fonts.primaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(13, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.17px;
    }
  `;
};
exports.getP13_3 = getP13_3;
const getP12 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(9)};
    font-weight: 700;
    line-height: ${rem.get(15)};
    letter-spacing: 0.1px;

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(21, rem.base)};
      letter-spacing: 0.13px;
    }
  `;
};
exports.getP12 = getP12;
const getP12_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(10)};
    font-weight: 300;
    line-height: ${rem.get(13)};
    letter-spacing: -.33px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(14, rem.base)};
      letter-spacing: -0.3px;
    }
  `;
};
exports.getP12_1 = getP12_1;
const getP12_1B = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(10)};
    font-weight: 300;
    line-height: ${rem.get(13)};
    letter-spacing: -.33px;
    font-family: ${_2.themeProject.fonts.tertiaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(14, rem.base)};
      letter-spacing: -0.3px;
    }
  `;
};
exports.getP12_1B = getP12_1B;
const getP12_2 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(10)};
    font-weight: 300;
    line-height: ${rem.get(13)};
    letter-spacing: -.33px;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(14, rem.base)};
      letter-spacing: -.3px;
    }
  `;
};
exports.getP12_2 = getP12_2;
const getP12_3 = () => {
    return (0, styled_components_1.css) `
  font-size: ${rem.get(10)};
  font-weight: regular;
  line-height: ${rem.get(25)};
  letter-spacing: -.5px;
  font-family: ${_2.themeProject.fonts.secondaryFont};
  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(12, rem.base)};
    line-height: ${rem.get(20, rem.base)};
    letter-spacing: -.5px;
  }
`;
};
exports.getP12_3 = getP12_3;
const getP10_1 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(8.5)};
    font-weight: 300;
    line-height: ${rem.get(15)};
    letter-spacing: 0;
    font-family: ${_2.themeProject.fonts.secondaryFont};

    ${_1.mq.greaterThan('tablet')} {
      font-size:  ${rem.get(10)};
      line-height: ${rem.get(15)};
    }
  `;
};
exports.getP10_1 = getP10_1;
const getP10 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(10)};
    font-weight: 700;
    line-height: ${rem.get(15)};
    letter-spacing: .25px;

    ${_1.mq.greaterThan('tablet')} {
      font-size:  ${rem.get(10, rem.base)};
      line-height: ${rem.get(15, rem.base)};
      letter-spacing: .25px;
    }
  `;
};
exports.getP10 = getP10;
const getP9 = () => {
    return (0, styled_components_1.css) `
    font-size: ${rem.get(10)};
    font-weight: 300;
    line-height: ${rem.get(12)};
    letter-spacing: .25px;

    ${_1.mq.greaterThan('tablet')} {
      font-size:  ${rem.get(10, rem.base)};
      line-height: ${rem.get(12, rem.base)};
      letter-spacing: .25px;
    }
  `;
};
exports.getP9 = getP9;
exports.getP14Search = (0, styled_components_1.css) `
  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(14, rem.base)};
    line-height: ${rem.get(17, rem.base)};
  }
`;
exports.getP15Search = (0, styled_components_1.css) `
  font-size: ${rem.get(15, rem.base)};
  font-weight: 500;
  letter-spacing: -.38px;
  line-height: ${rem.get(18, rem.base)};

  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(15, rem.base)};
    line-height: ${rem.get(18, rem.base)};
  }
`;
exports.getP27_P18 = (0, styled_components_1.css) `
  font-size: ${rem.get(27, rem.base)};
  font-weight: 700;
  line-height: ${rem.get(29, rem.base)};
  letter-spacing: .56px;

  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(18, rem.base)};
    line-height: ${rem.get(22, rem.base)};
    letter-spacing: -.36px;
  }
`;
exports.getP20v2 = (0, styled_components_1.css) `
  font-size: ${rem.get(20, rem.base)};
  line-height: ${rem.get(24, rem.base)};
  letter-spacing: .5px;

  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(20, rem.base)};
    line-height: ${rem.get(24, rem.base)};
    letter-spacing: .5px;
  }
`;
exports.getP17NavLinks = (0, styled_components_1.css) `
  font-weight: bold;
  letter-spacing: 0;
  font-family: ${_2.themeProject.fonts.primaryFont};

  ${_1.mq.greaterThan('tablet')} {
    font-size: ${rem.get(17, rem.base)};
    line-height: ${rem.get(18, rem.base)};
  }
`;
const font12_15 = (mobile = true, weight = 400) => (0, styled_components_1.css) `
  font-size: ${rem.get(12, rem[mobile ? 'baseMobile' : 'base'])};
  font-weight: ${weight};
  line-height: ${rem.get(15, rem[mobile ? 'baseMobile' : 'base'])};
`;
exports.font12_15 = font12_15;


/***/ }),

/***/ 56667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

'use client';
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Susy = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
const styled_components_1 = __importDefault(__webpack_require__(19453));
const hooks_1 = __webpack_require__(92757);
const _1 = __webpack_require__(73267);
const SusyGrid = styled_components_1.default.div `
  ${(0, _1.designGrid)({})}
  bottom: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  user-select: none;
  z-index: 9999;
`;
const Column = styled_components_1.default.span `
  background-color: rgba(76, 0, 255, 0.01);
  border: 1px solid rgba(85, 0, 255, 0.08);
  grid-area: ${({ $columnIndex }) => `${1}/${$columnIndex + 1}/${2}/${$columnIndex + 1}`};
`;
const getColumns = (isMobile = undefined) => {
    const columns = isMobile ? 6 : 12;
    const array = [];
    for (let idx = 0; idx < columns; idx++) {
        array.push((0, jsx_runtime_1.jsx)(Column, { "$columnIndex": idx }, idx));
    }
    return array;
};
const Susy = () => {
    const { isMobile } = (0, hooks_1.useDeviceType)();
    const isMount = (0, hooks_1.useMount)();
    const Columns = (0, react_1.useMemo)(() => getColumns(isMobile), [isMobile]);
    return ((0, jsx_runtime_1.jsx)(SusyGrid, Object.assign({ className: 'susy' }, { children: isMount && Columns })));
};
exports.Susy = Susy;


/***/ }),

/***/ 99575:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.designGrid = exports.grid = exports.getTransition = exports.getEasing = exports.rem = exports.vh = exports.vw = exports.mq = void 0;
const styled_components_1 = __webpack_require__(19453);
const themeConfig_1 = __webpack_require__(8015);
const breakpoints = {
    'iphone6': '375px',
    'mobile': '414px',
    'phablet': '480px',
    'nexus7': '603px',
    'tablet': '768px',
    'desktop-xs': '992px',
    'container': '1170px',
    'desktop-md': '1200px',
    'desktop': '1440px',
    'desktop-wide': '1650px',
    'large-screen': '1900px'
};
function pxToEm(breakpoint, baseRemPx = 16) {
    const breakpointValue = breakpoints[breakpoint];
    if (!breakpointValue)
        throw new Error(`Breakpoint "${breakpoint}" not found.`);
    const parsedValue = parseInt(breakpointValue, 10);
    const emValue = parsedValue / baseRemPx; // Assuming 1rem = 16px
    return `${emValue}em`;
}
exports.mq = {
    greaterThan: (device) => `@media (min-width: ${pxToEm(device)})`,
    lessThan: (device) => `@media (max-width: ${pxToEm(device)})`,
    between: (fromDevice, untilDevice) => `@media (min-width: ${pxToEm(fromDevice)}) and (max-width: ${pxToEm(untilDevice)})`
};
const vw = (size, breakpoint, unit = 'vw') => {
    var _a;
    const screenWidth = (_a = breakpoints[breakpoint]) !== null && _a !== void 0 ? _a : (breakpoint + '');
    return `${(100 * size / parseInt(screenWidth))}${unit}`;
};
exports.vw = vw;
const vh = (size, breakpoint) => {
    var _a;
    const screenWidth = (_a = breakpoints[breakpoint]) !== null && _a !== void 0 ? _a : (breakpoint + '');
    return `${(100 * size / parseInt(screenWidth))}vh`;
};
exports.vh = vh;
const rem = (value) => {
    const unitlessValue = parseInt(value);
    if (unitlessValue == 0)
        return unitlessValue;
    return `${unitlessValue / themeConfig_1.themeProject.fonts.size}rem`;
};
exports.rem = rem;
const getEasing = (duration = 300) => ({
    duration,
    ease: [.25, .1, .25, 1]
});
exports.getEasing = getEasing;
const getTransition = (duration = .3) => ({
    duration,
    type: 'tween',
    ease: [.25, .1, .25, 1]
});
exports.getTransition = getTransition;
exports.grid = {
    mobile: {
        maxWidth: 414,
        columns: {
            gutter: { outside: true, width: 17 },
            number: 6,
            width: 52
        }
    },
    tablet: {
        maxWidth: 768,
        columns: {
            gutter: { outside: true, width: 12 },
            number: 12,
            width: 52
        }
    },
    desktop: {
        maxWidth: 1440,
        columns: {
            gutter: { outside: true, width: 50 },
            number: 12,
            width: 70
        }
    },
    withoutGutter: false
};
const designGrid = ({ mobile = exports.grid.mobile, tablet = exports.grid.tablet, desktop = exports.grid.desktop, withoutGutter = exports.grid.withoutGutter }) => (0, styled_components_1.css) `
  display: grid;
  grid-template-columns: ${`repeat(${mobile.columns.number}, ${(0, exports.vw)(withoutGutter ? mobile.columns.width + mobile.columns.gutter.width : mobile.columns.width, mobile.maxWidth, '%')})`};
  grid-column-gap: ${withoutGutter ? 'unset' : `${(0, exports.vw)(mobile.columns.gutter.width, mobile.maxWidth, '%')}`};
  grid-row-gap: 0;
  justify-content: center;
  width: 100%;

  ${exports.mq.greaterThan('tablet')} {
    grid-column-gap: ${withoutGutter ? 'unset' : `${(0, exports.vw)(tablet.columns.gutter.width, tablet.maxWidth, '%')}`};
    grid-template-columns: ${`repeat(${tablet.columns.number}, ${(0, exports.vw)(withoutGutter ? tablet.columns.width + tablet.columns.gutter.width : tablet.columns.width, tablet.maxWidth, '%')})`};
    padding: 0;
  }

  ${exports.mq.greaterThan('desktop')} {
    grid-column-gap: ${withoutGutter ? 'unset' : `${(0, exports.vw)(desktop.columns.gutter.width, desktop.maxWidth, '%')}`};
    grid-template-columns: ${`repeat(${desktop.columns.number}, ${(0, exports.vw)(withoutGutter ? desktop.columns.width + desktop.columns.gutter.width : desktop.columns.width, desktop.maxWidth, '%')})`};
  }
`;
exports.designGrid = designGrid;


/***/ }),

/***/ 10457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withGlobalStyle = exports.overwriteDefaultTheme = exports.defaultTheme = void 0;
const styled_components_1 = __webpack_require__(19453);
exports.defaultTheme = {
    colors: {
        'background': 'rgb(30, 30, 30)',
        'text': 'rgb(255, 255, 255)',
    },
    fonts: {
        // eslint-disable-next-line quotes
        'family': `'Montserrat', sans-serif`,
        // eslint-disable-next-line quotes
        'familyCode': `'Courier New', monospace`,
        'size': 16,
        'lineHeight': 24 / 16,
        'headersize': 20,
        'headerLineHeight': 24 / 20
    }
};
const overwriteDefaultTheme = (theme) => {
    return Object.assign(Object.assign(Object.assign({}, exports.defaultTheme), theme), { colors: Object.assign(Object.assign({}, exports.defaultTheme.colors), theme.colors), fonts: Object.assign(Object.assign({}, exports.defaultTheme.fonts), theme.fonts) });
};
exports.overwriteDefaultTheme = overwriteDefaultTheme;
const withGlobalStyle = (theme = exports.defaultTheme, extraCss = null) => (0, styled_components_1.createGlobalStyle) `
  html {
    -moz-osx-font-smoothing     : grayscale;
    -webkit-font-smoothing      : antialiased;
    -webkit-overflow-scrolling  : touch;
    -webkit-tap-highlight-color : transparent;
    box-sizing: border-box;
    font-family: sans-serif;
    font-size: 100%;
    text-rendering: optimizeLegibility;
    text-size-adjust: 100%;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html,
  body {
    min-height: 100%;
  }

  html, body,
  nav, header, main, footer,
  section, aside, article, div,
  img, caption, figure, figcaption, video, audio, progress,
  h1, h2, h3, h4, h5, h6,
  p, span, small, strong,
  ol, ul, li,
  dl, dt, dd,
  blockquote,
  form, fieldset, legend, label,
  table, tbody, tfoot, thead, tr, th, td,
  pre, abbr, address, cite, summary, code,
  del, dfn, em, ins, kbd, q, samp, sub, sup, var, time, mark {
    background: transparent;
    border: 0;
    direction: ltr;
    margin: 0;
    padding: 0;
  }

  .flickity-slider { -webkit-overflow-scrolling: touch; }

  body {
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    position: relative;
    scroll-behavior: smooth;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  .srt-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  button {
    appearance: none;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    outline: 0;
    padding: 0;

    &,
    &:focus,
    &:active {
      outline: 0;
    }
  }

  p,
  span,
  small,
  strong {
    text-align: left;
  }

  h1, h2, h3, h4, h5, h6 {
    text-align: center;
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }

  audio {
    &:not([controls]) {
      display: none;
      height: 0;
    }
  }

  [hidden] {
    display: none;
  }

  a {
    background-color: transparent;
    cursor: pointer;

    &:active,
    &:hover {
      outline: 0;
    }
  }

  li {
    list-style-type: none;
  }

  img {
    -ms-interpolation-mode: bicubic;
    transform: translate3d(0, 0, 0);
    vertical-align : middle;
  }

  figure {
    margin: 0;

    img {
      margin: 0;
    }

  	figcaption {
  		color: lighten(${theme.colors.text}, 30%);
  		display: block;
  		font-style: italic;
  		font-weight: normal;
      font-size: 14px;
  	}
  }

  input,
  textarea {
    &,
    &:active,
    &:focus,
    &:hover {
      outline: 0;
    }
  }

  input {
    border: 0;
    border-radius: 0;
    cursor: pointer;

    &::-webkit-caps-lock-indicator,
    &::-webkit-contacts-auto-fill-button,
    &::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      position: absolute;
      right: 0;
    }


    &::-ms-clear,
    &::-ms-reveal {
      display: none;
    }

    &:-webkit-autofill {
      content: '\feff';
    }
  }

  h1, h2, h3, h4, h5, h6 {
    text-rendering : optimizelegibility;
    font-weight    : 400;
  }

  p {
    color: inherit;
    font-size : ${theme.fonts.size}px;
    font-weight : 300;
    line-height : ${theme.fonts.lineHeight};
    margin-bottom: 0;
  }

  small {
  	font-size: 12px;
  }

  ol,
  ul,
  dl,
  dd,
  address {
    margin-bottom : 0;
  }

  dl {
    outline: 0;
  }

  dt {
    font-weight : bold;
  }

  blockquote  {
    border-left: 10px solid ${theme.colors.text};
    font-style: normal;
    margin: 0;
    padding: 0 15px;

    p {
      font-size  : 18px;
      color      : lighten(${theme.colors.text}, 15%);
      font-style : italic;
    }

    .quote-info {
      text-align: right;
    }
  }


  q {
    font-style : italic;
    quotes     : none;
  }


  blockquote p::before,
  blockquote p::after,
  q:before,
  q:after {
    content : '';
  }

  cite {
    font-style : normal;
  }

  hr {
    border: 0;
    border-top: 1px solid ${theme.colors.text};
    clear: both;
    display: block;
    height: 1px;
    margin: ${theme.fonts.lineHeight} * 2 0;
    padding: 0;
  }

  abbr[title] {
    cursor: help;
    border-bottom: 1px dotted lighten(${theme.colors.text}, 15%);
  }

  b,
  strong {
    font-weight : bold;
  }

  dfn {
    font-style : italic;
  }

  ins {
    background-color: lighten(${theme.colors.text}, 75%);
    color: darken(${theme.colors.text}, 20%);
    text-decoration: none;
  }

  mark {
    background-color: ${theme.colors.text};
    color: darken(${theme.colors.text}, 20%);
  }

  pre,
  code,
  kbd,
  samp {
    font-size: 14px;
    font-family: ${theme.fonts.familyCode};
    line-height: ${theme.fonts.lineHeight};
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  sub,
  sup {
    font-size: 12px;
    line-height: 0;
    position: relative;
    vertical-align: ${theme.fonts.lineHeight};
  }

  sup {
    right: .2em;
    top: .2em;
  }

  sub {
    bottom: -.25em;
  }

  ${extraCss && (0, styled_components_1.css) `${extraCss}`}
`;
exports.withGlobalStyle = withGlobalStyle;


/***/ }),

/***/ 73267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(99575), exports);
__exportStar(__webpack_require__(8015), exports);
__exportStar(__webpack_require__(49070), exports);
__exportStar(__webpack_require__(10457), exports);
__exportStar(__webpack_require__(25417), exports);
__exportStar(__webpack_require__(56667), exports);
__exportStar(__webpack_require__(38284), exports);


/***/ }),

/***/ 38284:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Reset = exports.theme = void 0;
const _1 = __webpack_require__(73267);
exports.theme = (0, _1.overwriteDefaultTheme)(_1.themeProject);
const extraGlobalCss = `
  html {
    overflow-x: hidden;
  }

  body {
    color: ${_1.themeProject.colors.text};
    font-family: ${_1.themeProject.fonts.primaryFont};

    &.slider-being-dragged {
      .slider--flickity {
        button,
        a {
          pointer-events: none !important;
        }
      }
    }
  }

  button {
    outline: 0;
    padding: 0;
    background-color: transparent;

    &:active,
    &:focus {
      outline: 0;
    }
  }

  nav {
    + main {
      flex-grow: 2;
    }
  }

  a {
    color: unset;
    text-decoration: none;
  }

  input {
    background: transparent;
    margin-bottom: 0;
  }

  input::-webkit-search-cancel-button {
    display: none;
  }

  html, body {
    font-size: ${(0, _1.vw)(15, 'mobile')};

    @media (min-width: 603px) {
      font-size:  ${(0, _1.vw)(15, 'nexus7')};
    }

    @media (min-width: 768px) {
      font-size: ${(0, _1.vw)(18, 'desktop')};
    }

    @media (min-width: 1440px) {
      font-size: 18px;
    }
  }

  figure {
    margin-bottom: 0;
  }

  img {
    width: 100%;
  }

  .modal-as-tooltip {
    justify-content: flex-end;

    .overlay {
      opacity: .2;
    }
  }

  .slider--flickify {
    outline: none;
  }

  .flickify-viewport {
    overflow: hidden;
    position: relative;
  }


  #at-cv-lightbox-message > span {
    color: ${_1.themeProject.colors.text};
    font-family: ${_1.themeProject.fonts.platform};
    text-align: center;
  }

  .at-branding-logo {
    display: none !important;
  }

  .cookiefirst-root > div {
    margin-left: auto !important;
    max-width: 890px !important;
  }

  .fade .flickity-viewport,
  .fade .flickity-slider {
    transform: none !important;
  }

  .fade .flickity-cell {
    opacity: 0 !important;
    transform: none !important;
    transition: 200ms opacity ease-in-out !important;
    z-index: auto;
  }

  .fade .flickity-cell.is-selected {
    opacity: 1 !important;
    transform: none !important;
    transition: 200ms opacity ease-in-out !important;
    z-index: 2;
  }

  .flickity-prev-next-button {
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
    display: flex;
    justify-content: center;
    transition: 250ms border-color linear;
  }

  .flickity-prev-next-button:hover {
    border-color: ${_1.themeProject.colors.darkred};
  }

  .flickity-prev-next-button > svg.flickity-button-icon {
    height: 50%;
    min-height: 20px;
    min-width: 20px;
    left: auto;
    position: relative;
    top: auto;
    width: 50%;
  }
`;
exports.Reset = (0, _1.withGlobalStyle)(exports.theme, extraGlobalCss);


/***/ }),

/***/ 25417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parsePlaceHolder = exports.hideScrollbar = exports.hex2Rgba = exports.createTooltip = exports.createUnderline = void 0;
const styled_components_1 = __webpack_require__(19453);
const _1 = __webpack_require__(73267);
const createUnderline = ({ height = 1, reverse = false, color = 'black' } = {}) => (0, styled_components_1.css) `
  background-image: linear-gradient(${({ theme }) => theme.colors[color]}, ${({ theme }) => theme.colors[color]});
  background-position: ${reverse ? '100% 100%' : '0 100%'};
  background-repeat: no-repeat;
  background-size: ${reverse ? `100% ${height}px` : '0% 2px'};
  position: relative;
  transition: background-size 300ms ease;

  &:hover,
  &.active {
    background-size: ${reverse ? '0% 2px' : `100% ${height}px`};
  }
`;
exports.createUnderline = createUnderline;
const createTooltip = ({ color = '#F6A300' }) => (0, styled_components_1.css) `
  &:before {
    border: ${(0, _1.vw)(9, 'mobile')} solid transparent;
    border-bottom-color: ${color};
    bottom: 100%;
    content: '';
    display: block;
    height: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 0;

    ${_1.mq.greaterThan('tablet')} {
      border: ${(0, _1.vw)(9, 'desktop')} solid transparent;
      border-bottom-color: ${color};
    }
  }

  &:after {
    border: ${(0, _1.vw)(4, 'mobile')} solid transparent;
    border-bottom-color: ${color};
    bottom: 100%;
    content: '';
    display: block;
    height: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 0;

    ${_1.mq.greaterThan('tablet')} {
      border: ${(0, _1.vw)(4, 'desktop')} solid transparent;
      border-bottom-color: ${color};
    }
  }
`;
exports.createTooltip = createTooltip;
function hex2Rgba(hex, alpha) {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
exports.hex2Rgba = hex2Rgba;
const hideScrollbar = () => (0, styled_components_1.css) `
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */

  &::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0);
    display: none;
  }
`;
exports.hideScrollbar = hideScrollbar;
const defaultPlaceHolderStyles = (color) => (0, styled_components_1.css) `
  transition: opacity 300ms ${({ ease }) => ease};
  color: ${color !== null && color !== void 0 ? color : 'rgba(0, 0, 0, 0)'};
`;
const parsePlaceHolder = (styles, color = null) => ((0, styled_components_1.css) `
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    ${defaultPlaceHolderStyles(color)}
    ${styles}
  }
  ::-moz-placeholder { /* Firefox 19+ */
    ${defaultPlaceHolderStyles(color)}
    ${styles}
  }
  :-ms-input-placeholder { /* IE 10+ */
    ${defaultPlaceHolderStyles(color)}
    ${styles}
  }
  :-moz-placeholder { /* Firefox 18- */
    ${defaultPlaceHolderStyles(color)}
    ${styles}
  }
`);
exports.parsePlaceHolder = parsePlaceHolder;


/***/ }),

/***/ 8015:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.themeProject = void 0;
exports.themeProject = {
    colors: {
        'background': '#F3EFE6',
        'text': '#1E1E1E',
        'red': '#A92329',
        'darkred': '#4E1114',
        'lightred': '#D8C7C7',
        'creme': '#EFC881',
        'toast_success': '#E8A836',
        'toast_warning': '#A92329',
        'toast_error': '#FF0048',
        'darkcreme': '#E8A836',
        'white': '#FFFFFF',
        'black': '#000000',
        'input_error': '#FF4E15',
        'grey': '#979797',
        'greylight': '#F7F7F7',
        'transparent': 'transparent',
        'orange': '#F6A300',
        'frozen': '#616FC4',
        'dark_frozen': '#11294E'
    },
    fonts: {
        // eslint-disable-next-line quotes
        'primaryFont': `'Platform', sans-serif`,
        // eslint-disable-next-line quotes
        'secondaryFont': `'Graphik', sans-serif`,
        // eslint-disable-next-line quotes
        'tertiaryFont': `'Basier Circle', sans-serif`,
        // eslint-disable-next-line quotes
        'familyCode': `'monospace', monospace`,
        'size': 16,
        'lineHeight': 24 / 16,
        'headersize': 20,
        'headerLineHeight': 24 / 20
    },
    ease: 'cubic-bezier(.25, .1, .25, 1)'
};


/***/ }),

/***/ 70536:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pushAnalyticsEvent = void 0;
const getSelectItemObject = (data) => {
    var _a, _b, _c, _d, _e;
    const { name, price, product, idx, ga_list, locale, variant } = data;
    return {
        'event': 'select_item',
        'ecommerce': {
            'items': [Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ 'item_name': product === null || product === void 0 ? void 0 : product.name, 'item_variant': name, 'item_id': (_a = data.sku) !== null && _a !== void 0 ? _a : product === null || product === void 0 ? void 0 : product.sku }, ((price === null || price === void 0 ? void 0 : price.retailPrice) && { 'discount': (price === null || price === void 0 ? void 0 : price.retailPrice) - (price === null || price === void 0 ? void 0 : price.salePrice) })), { 'price': price === null || price === void 0 ? void 0 : price.salePrice, 'index': idx, 'item_list_name': ga_list.name, 'item_list_id': ga_list.id, 'affiliation': `Mammafiore ${locale} Store`, 'item_brand': (_c = (_b = product === null || product === void 0 ? void 0 : product.brand) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'Packs' }), ((product === null || product === void 0 ? void 0 : product.categories) && { 'item_category': product === null || product === void 0 ? void 0 : product.categories[0].name })), (((_d = product === null || product === void 0 ? void 0 : product.categories) === null || _d === void 0 ? void 0 : _d.length) === 2 && { 'item_category2': product === null || product === void 0 ? void 0 : product.categories[1].name })), (((_e = product === null || product === void 0 ? void 0 : product.categories) === null || _e === void 0 ? void 0 : _e.length) === 3 && { 'item_category3': product === null || product === void 0 ? void 0 : product.categories[2].name })), { 'currency': 'EUR', 'quantity': 1 })],
            'item_list_name': ga_list.name,
            'item_list_id': ga_list.id
        }
    };
};
const getViewItemObject = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!data)
        return;
    const { name, brand, categories, sku, variant, variants, idx } = data;
    const variantData = variant ? variants.find(item => item.bigcommerceId === variant.variant_id) : variants === null || variants === void 0 ? void 0 : variants[0];
    return {
        'event': 'view_item',
        'ecommerce': {
            'items': [Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ 'item_name': name, 'item_variant': variantData === null || variantData === void 0 ? void 0 : variantData.name, 'item_id': (variantData === null || variantData === void 0 ? void 0 : variantData.sku) ? variantData === null || variantData === void 0 ? void 0 : variantData.sku : sku }, (((_a = variantData === null || variantData === void 0 ? void 0 : variantData.price) === null || _a === void 0 ? void 0 : _a.retailPrice) && { 'discount': ((_b = variantData === null || variantData === void 0 ? void 0 : variantData.price) === null || _b === void 0 ? void 0 : _b.retailPrice) - ((_c = variantData === null || variantData === void 0 ? void 0 : variantData.price) === null || _c === void 0 ? void 0 : _c.salePrice) })), { 'price': (_d = variantData === null || variantData === void 0 ? void 0 : variantData.price) === null || _d === void 0 ? void 0 : _d.salePrice, 'item_brand': (_e = brand === null || brand === void 0 ? void 0 : brand.name) !== null && _e !== void 0 ? _e : 'Packs' }), (categories && { 'item_category': (_f = categories[0]) === null || _f === void 0 ? void 0 : _f.name })), ((categories === null || categories === void 0 ? void 0 : categories.length) === 2 && { 'item_category2': (_g = categories[1]) === null || _g === void 0 ? void 0 : _g.name })), ((categories === null || categories === void 0 ? void 0 : categories.length) === 3 && { 'item_category3': (_h = categories[2]) === null || _h === void 0 ? void 0 : _h.name })), ((variant === null || variant === void 0 ? void 0 : variant.ga_list) && {
                    'item_list_name': (_j = variant.ga_list) === null || _j === void 0 ? void 0 : _j.name,
                    'item_list_id': (_k = variant.ga_list) === null || _k === void 0 ? void 0 : _k.id
                })), (idx && { 'index': idx })), { 'quantity': 1 })]
        }
    };
};
const getViewItemListObject = (data) => {
    const { products, ga_list } = data;
    const items = products.map((productEl, idx) => {
        var _a, _b, _c, _d;
        const { name, product, price } = productEl;
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ 'item_name': product === null || product === void 0 ? void 0 : product.name, 'item_variant': name, 'item_id': product.sku }, ((price === null || price === void 0 ? void 0 : price.retailPrice) && { 'discount': (price === null || price === void 0 ? void 0 : price.retailPrice) - (price === null || price === void 0 ? void 0 : price.salePrice) })), { 'price': price === null || price === void 0 ? void 0 : price.salePrice, 'item_brand': (_b = (_a = product === null || product === void 0 ? void 0 : product.brand) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'Packs' }), ((product === null || product === void 0 ? void 0 : product.categories) && { 'item_category': product === null || product === void 0 ? void 0 : product.categories[0].name })), (((_c = product === null || product === void 0 ? void 0 : product.categories) === null || _c === void 0 ? void 0 : _c.length) === 2 && { 'item_category2': product === null || product === void 0 ? void 0 : product.categories[1].name })), (((_d = product === null || product === void 0 ? void 0 : product.categories) === null || _d === void 0 ? void 0 : _d.length) === 3 && { 'item_category3': product === null || product === void 0 ? void 0 : product.categories[2].name })), { 'item_list_name': ga_list === null || ga_list === void 0 ? void 0 : ga_list.name, 'item_list_id': ga_list === null || ga_list === void 0 ? void 0 : ga_list.id, 'index': idx + 1, 'quantity': 1 });
    });
    return {
        'event': 'view_item_list',
        'ecommerce': {
            'items': items
        }
    };
};
const getCartItemObject = (data, add = true) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { name, brand, categories, variant, units } = data;
    const quantity = units !== null && units !== void 0 ? units : 1;
    const salePrice = (_b = (_a = variant === null || variant === void 0 ? void 0 : variant.price) === null || _a === void 0 ? void 0 : _a.salePrice) !== null && _b !== void 0 ? _b : 0;
    const discount = ((_c = variant === null || variant === void 0 ? void 0 : variant.price) === null || _c === void 0 ? void 0 : _c.discount) ? (_d = variant === null || variant === void 0 ? void 0 : variant.price) === null || _d === void 0 ? void 0 : _d.discount : (((_e = variant === null || variant === void 0 ? void 0 : variant.price) === null || _e === void 0 ? void 0 : _e.retailPrice) && typeof ((_f = variant === null || variant === void 0 ? void 0 : variant.price) === null || _f === void 0 ? void 0 : _f.retailPrice) === 'number') ? Math.round((((_g = variant === null || variant === void 0 ? void 0 : variant.price) === null || _g === void 0 ? void 0 : _g.retailPrice) - salePrice + Number.EPSILON) * 100) / 100 : 0;
    return {
        'event': add ? 'add_to_cart' : 'remove_from_cart',
        'ecommerce': {
            'currency': 'EUR',
            'value': Math.round(((salePrice * quantity) + Number.EPSILON) * 100) / 100,
            'items': [Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ 'item_id': variant.sku, 'item_name': name }, (discount && { 'discount': discount })), (variant.idx && { 'index': variant.idx })), { 'item_brand': (_h = brand === null || brand === void 0 ? void 0 : brand.name) !== null && _h !== void 0 ? _h : 'Packs' }), ((categories === null || categories === void 0 ? void 0 : categories[0]) && { 'item_category': categories[0].name })), ((categories === null || categories === void 0 ? void 0 : categories[1]) && { 'item_category2': categories[1].name })), ((categories === null || categories === void 0 ? void 0 : categories[2]) && { 'item_category3': categories[2].name })), ((categories === null || categories === void 0 ? void 0 : categories[3]) && { 'item_category4': categories[3].name })), ((categories === null || categories === void 0 ? void 0 : categories[4]) && { 'item_category5': categories[4].name })), (variant.ga_list && {
                    'item_list_id': variant.ga_list.id,
                    'item_list_name': variant.ga_list.name
                })), { 'item_variant': variant.name, 'price': salePrice, 'quantity': quantity })]
        }
    };
};
// Data from BC
const getCheckoutObj = (data) => {
    const items = data.line_items.physical_items.map((item) => {
        const { name, extended_sale_price, sku, variant_id, quantity } = item;
        return {
            'item_name': name,
            'item_id': sku,
            'price': extended_sale_price,
            'item_variant': variant_id,
            'quantity': quantity
        };
    });
    return {
        'event': 'begin_checkout',
        'ecommerce': {
            'items': items
        }
    };
};
// Data from BC
const getPurchaseObj = (data) => {
    var _a;
    const { id, cart_amount, locale, line_items, currency } = data;
    const items = line_items.physical_items.map((item) => {
        const { name, extended_sale_price, sku, variant_id, quantity } = item;
        return {
            'item_name': name,
            'item_id': sku,
            'price': extended_sale_price,
            'item_variant': variant_id,
            'quantity': quantity
        };
    });
    return {
        'event': 'purchase',
        'ecommerce': {
            'transaction_id': id,
            'affiliation': `Mammafiore ${locale} Store`,
            'value': cart_amount,
            // 'tax': '4.90',
            // 'shipping': '5.99',
            'currency': (_a = currency === null || currency === void 0 ? void 0 : currency.code) !== null && _a !== void 0 ? _a : 'EUR',
            'items': items
        }
    };
};
const events = {
    'view_item_list': (data) => getViewItemListObject(data),
    'select_item': (data) => getSelectItemObject(data),
    'view_item': (data) => getViewItemObject(data),
    'add_to_cart': (data) => getCartItemObject(data, true),
    'remove_from_cart': (data) => getCartItemObject(data, false),
    'begin_checkout': (data) => getCheckoutObj(data),
    'purchase': (data) => getPurchaseObj(data),
    'search': (q) => ({ 'search_term': q })
};
const pushAnalyticsEvent = (event_type, data) => {
    if (typeof window !== 'undefined') {
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({ ecommerce: null });
        window['dataLayer'].push(events[event_type](data));
    }
};
exports.pushAnalyticsEvent = pushAnalyticsEvent;


/***/ }),

/***/ 96345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cookie = void 0;
const cookie_1 = __webpack_require__(13421);
const _1 = __webpack_require__(76079);
// interface CookieSerializeOptions {
// 	domain?: string | undefined;
// 	encode?(value: string): string;
// 	expires?: Date | undefined;
// 	httpOnly?: boolean | undefined;
// 	maxAge?: number | undefined;
// 	path?: string | undefined;
// 	sameSite?: true | false | 'lax' | 'strict' | 'none' | undefined;
// 	secure?: boolean | undefined;
// }
const HOST = _1.HOSTNAME.split('.mammafiore.');
// To manage subdomains URLs: staging.cat.mammafiore.es, .cat.mammafiore.es and also
// to manage root domain URLs: mammafiore.es, mammafiore.it, ...etc.
const DOMAIN = HOST.length > 1 ? '.mammafiore.' + HOST[HOST.length - 1] : '.' + HOST[0];
exports.cookie = {
    set: ({ name, value, expire = null, seconds = null, days = 365, path = '/', sameSite = null }) => {
        var _a;
        if (typeof window === 'undefined')
            return;
        const date = new Date();
        if (seconds) {
            date.setTime(date.getTime() + (seconds * 1000));
        }
        else if (days) {
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        }
        let expires = `; expires=${expire ? (_a = new Date(expire)) === null || _a === void 0 ? void 0 : _a.toUTCString() : date.toUTCString()}`;
        const incomingCookie = `${name}=${(value || '')}${expires}; path=${path}; domain=${_1.DEV ? 'localhost' : `${DOMAIN}`};${sameSite ? ` sameSite=${sameSite};` : ''}${_1.PRO ? ' secure;' : ''}`;
        document.cookie = incomingCookie;
    },
    setHeader: (res, name, value, options = {}) => {
        res.setHeader('Set-Cookie', (0, cookie_1.serialize)(name, value, Object.assign(Object.assign({}, options), { domain: !_1.DEV ? `${DOMAIN}` : 'localhost' })));
    },
    get: (name) => {
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return null;
        const nameEQ = `${name}=`;
        const arrayOfCookies = document === null || document === void 0 ? void 0 : document.cookie.split(';');
        for (let rawCookie of arrayOfCookies) {
            let cookie = rawCookie;
            while (cookie.charAt(0) == ' ')
                cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) == 0)
                return cookie.substring(nameEQ.length, cookie.length);
        }
        return null;
    },
    removeCookie: (name) => {
        if (typeof window !== 'undefined') {
            if (_1.DEV) {
                document.cookie = name + '=; Max-Age=-99999999;';
                return;
            }
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Path=/; domain=${_1.DEV ? 'localhost' : `${DOMAIN}`}`;
        }
    },
    extract: (cookieString, name) => {
        const cookiePairs = cookieString.split(', ');
        for (const pair of cookiePairs) {
            const [cookie] = pair.split('; ');
            const [cookieName, value] = cookie.split('=');
            if (cookieName.trim() === name) {
                const cookieObj = { name: cookieName.trim(), value: value.trim() };
                return cookieObj;
            }
        }
        return undefined;
    }
};


/***/ }),

/***/ 6511:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.copyTextToClipboard = void 0;
function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.opacity = '0';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.info('Fallback: Copying text command was ' + msg);
    }
    catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
}
function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}
exports.copyTextToClipboard = copyTextToClipboard;


/***/ }),

/***/ 61919:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAllPricesCurrency = exports.calcPriceWithTax = exports.currencyFormatter = exports.currencyBasedOnRegion = void 0;
const locales_1 = __webpack_require__(95669);
exports.currencyBasedOnRegion = {
    'AD': { code: 'EUR' },
    'AL': { code: 'EUR' },
    'AS': { code: 'USD' },
    'AT': { code: 'EUR' },
    'AU': { code: 'AUD' },
    'BQ': { code: 'USD' },
    'CH': { code: 'EUR' },
    'DE': { code: 'EUR' },
    'DEU': { code: 'EUR' },
    'EC': { code: 'USD' },
    'ES': { code: 'EUR' },
    'ESP': { code: 'EUR' },
    'FM': { code: 'USD' },
    'FR': { code: 'EUR' },
    'FRA': { code: 'EUR' },
    'GB': { code: 'GBP' },
    'GBR': { code: 'GBP' },
    'GR': { code: 'EUR' },
    'GU': { code: 'USD' },
    'HT': { code: 'USD' },
    'IE': { code: 'EUR' },
    'IM': { code: 'GBP' },
    'IO': { code: 'USD' },
    'IT': { code: 'EUR' },
    'ITA': { code: 'EUR' },
    'JE': { code: 'GBP' },
    'MC': { code: 'EUR' },
    'MH': { code: 'USD' },
    'MP': { code: 'USD' },
    'PA': { code: 'USD' },
    'PR': { code: 'USD' },
    'PT': { code: 'EUR' },
    'PW': { code: 'USD' },
    'SE': { code: 'EUR' },
    'SV': { code: 'EUR' },
    'UM': { code: 'USD' },
    'US': { code: 'USD' },
};
const currencyFormatter = ({ price, localeRegion, decimals = 2, round = true, trailingZeros = false }) => {
    var _a, _b;
    const region = (0, locales_1.getLocaleCountry)(localeRegion).split('-')[1];
    const digits = (!round && price % 1 !== 0) ? decimals : trailingZeros ? decimals : 0;
    return new Intl.NumberFormat(localeRegion, {
        style: 'currency',
        currency: (_b = (_a = exports.currencyBasedOnRegion === null || exports.currencyBasedOnRegion === void 0 ? void 0 : exports.currencyBasedOnRegion[region]) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : 'EUR',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    }).format(round ? Math.round(price) : price);
};
exports.currencyFormatter = currencyFormatter;
const calcPriceWithTax = ({ price, tax }) => {
    if (!price || typeof price !== 'number')
        return null;
    const vat = typeof tax === 'number' ? tax : 0;
    const taxAsValue = price * vat / 100;
    return Math.round(price + taxAsValue);
};
exports.calcPriceWithTax = calcPriceWithTax;
const getAllPricesCurrency = (priceObject, locale, decimals, round) => {
    const newObj = {};
    Object.entries(priceObject).forEach(([key, value]) => {
        newObj[key + 'Currency'] = (0, exports.currencyFormatter)({ price: value, localeRegion: locale, decimals, round });
    });
    return newObj;
};
exports.getAllPricesCurrency = getAllPricesCurrency;


/***/ }),

/***/ 12027:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.groupByDate = exports.getDateFormatted = exports.getDayOfWeekName = exports.parseDateString = exports.isValidDate = void 0;
const isValidDate = (dateString) => !isNaN(Date.parse(dateString));
exports.isValidDate = isValidDate;
function parseDateString({ dateString, locale = 'es-ES', includeHour = false, includeSeconds = false, includeTimezone = false, }) {
    if (!dateString) {
        console.warn('🗓️ Invalid dateString format or missing value. Cannot be parsed.');
        return '';
    }
    let date;
    if (dateString instanceof Date) {
        // If already a Date object, use it directly
        date = new Date(Date.UTC(dateString.getUTCFullYear(), dateString.getUTCMonth(), dateString.getUTCDate(), dateString.getUTCHours(), dateString.getUTCMinutes(), dateString.getUTCSeconds()));
    }
    else if (typeof dateString === 'string') {
        // Extract the raw YYYY-MM-DD date components from the string
        const dateParts = dateString.split('T')[0].split('-').map(Number);
        if (dateParts.length !== 3) {
            console.warn(`🗓️ Error parsing dateString: ${dateString}. Ensure it's a valid ISO 8601 format.`);
            return '';
        }
        const [year, month, day] = dateParts;
        // Create a date in **pure UTC** to prevent any timezone shifting
        date = new Date(Date.UTC(year, month - 1, day));
    }
    else {
        console.warn(`🗓️ Invalid dateString type: ${typeof dateString}. Expected Date | string.`);
        return '';
    }
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    if (includeHour) {
        options.hour = '2-digit';
        options.minute = '2-digit';
        if (includeSeconds)
            options.second = '2-digit';
    }
    if (includeTimezone)
        options.timeZoneName = 'short';
    return date.toLocaleString(locale, options);
}
exports.parseDateString = parseDateString;
function getDayOfWeekName(lang, dayOfWeek) {
    const options = { weekday: 'long', locale: lang };
    const formatter = new Intl.DateTimeFormat(lang, options);
    // Get the name of the week day based on the day of the week integer
    const dayName = formatter.format(new Date(Date.UTC(new Date().getFullYear(), 0, dayOfWeek)));
    return dayName;
}
exports.getDayOfWeekName = getDayOfWeekName;
function getDateFormatted(locale, dateString) {
    const date = new Date(dateString);
    const options = {
        weekday: 'long',
        day: 'numeric',
        month: 'numeric'
    };
    const formatter = new Intl.DateTimeFormat(locale, options);
    const parts = formatter.formatToParts(date);
    const formattedDate = `${parts[0].value} ${parts[2].value}/${parts[4].value}`;
    return formattedDate;
}
exports.getDateFormatted = getDateFormatted;
function groupByDate(data = []) {
    if (!data.length)
        return [];
    const cartLines = [...data];
    // Sort the cartLines array by deliveryDate in ascending order
    cartLines.sort((a, b) => {
        const dateA = new Date(a.variant.deliveryDate);
        const dateB = new Date(b.variant.deliveryDate);
        return dateA.getTime() - dateB.getTime();
    });
    // Create a Map to store cartLines grouped by date
    const groupedByDate = new Map();
    // Iterate over the sorted array of cartLines
    cartLines.forEach(item => {
        const deliveryDate = new Date(item.variant.deliveryDate);
        // Create a key based on year, month, and day (ignoring hours and minutes)
        const key = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate()).toString();
        // Add the object to the corresponding group in the Map
        if (groupedByDate.has(key)) {
            groupedByDate.get(key).push(item);
        }
        else {
            groupedByDate.set(key, [item]);
        }
    });
    // Convert the Map values to an array of arrays
    const result = Array.from(groupedByDate.values());
    return result;
}
exports.groupByDate = groupByDate;


/***/ }),

/***/ 88852:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.POSTAL_CODE_TYPE = exports.CART_LINE_TYPE = exports.ADDRESS_TYPE = exports.PAGES = exports.BANNER = exports.CATEGORIES = void 0;
var CATEGORIES;
(function (CATEGORIES) {
    CATEGORIES["PRODUCT"] = "PRODUCT";
    CATEGORIES["FAQ"] = "FAQ";
})(CATEGORIES = exports.CATEGORIES || (exports.CATEGORIES = {}));
var BANNER;
(function (BANNER) {
    BANNER["SLIM"] = "SLIM";
})(BANNER = exports.BANNER || (exports.BANNER = {}));
var PAGES;
(function (PAGES) {
    PAGES["REGULAR"] = "REGULAR";
})(PAGES = exports.PAGES || (exports.PAGES = {}));
var ADDRESS_TYPE;
(function (ADDRESS_TYPE) {
    ADDRESS_TYPE["BILLING"] = "BILLING";
    ADDRESS_TYPE["SHIPPING"] = "SHIPPING";
})(ADDRESS_TYPE = exports.ADDRESS_TYPE || (exports.ADDRESS_TYPE = {}));
var CART_LINE_TYPE;
(function (CART_LINE_TYPE) {
    CART_LINE_TYPE["PHYSICAL"] = "PHYSICAL";
    CART_LINE_TYPE["GIFT_CERTIFICATE"] = "GIFT_CERTIFICATE";
})(CART_LINE_TYPE = exports.CART_LINE_TYPE || (exports.CART_LINE_TYPE = {}));
var POSTAL_CODE_TYPE;
(function (POSTAL_CODE_TYPE) {
    POSTAL_CODE_TYPE["SINGLE"] = "SINGLE";
    POSTAL_CODE_TYPE["RANGE"] = "RANGE";
})(POSTAL_CODE_TYPE = exports.POSTAL_CODE_TYPE || (exports.POSTAL_CODE_TYPE = {}));


/***/ }),

/***/ 4296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.appendGiftCard = exports.getFeaturedFilters = exports.slugMatch = exports.getFiltersFromQuery = exports.generateQueryParams = exports.updateActiveFilters = exports.getFilters = exports.getFilteredProducts = exports.hasQueryParams = void 0;
const hasQueryParams = (asPath, param = null) => {
    return !!asPath.split(`?${param ? `${param}=` : ''}`)[1];
};
exports.hasQueryParams = hasQueryParams;
const sortProducts = (variants, sortBy = null) => {
    const _products = Array.from(variants);
    if (!sortBy || Object.keys(sortBy)[0] === 'recommended') {
        return _products;
    }
    const ascending = Object.keys(sortBy)[0] === 'low-price';
    _products.sort((a, b) => {
        var _a, _b;
        const a_price_per_unit = (_a = a.price) === null || _a === void 0 ? void 0 : _a.salePrice;
        const b_price_per_unit = (_b = b.price) === null || _b === void 0 ? void 0 : _b.salePrice;
        return ascending ? a_price_per_unit - b_price_per_unit : b_price_per_unit - a_price_per_unit;
    });
    return _products;
};
const getFilteredProducts = (variants, appliedFilters) => {
    var _a, _b;
    if ((variants === null || variants === void 0 ? void 0 : variants.length) < 1)
        return [];
    if (Object.keys(appliedFilters).length < 1)
        return sortProducts(variants);
    // Parse appliedFilters into keyparams as array of true values
    // sample: { size: ['s', 'm'], color: ['white', 'blue', 'yellow']}
    const parsedFilters = {};
    for (const filterParam in appliedFilters) {
        if (typeof appliedFilters[filterParam] === 'boolean') {
            parsedFilters[filterParam] = true;
        }
        else {
            if (filterParam !== 'sort') {
                const values = appliedFilters[filterParam];
                if (typeof values === 'object' && Object.keys(values).length > 0 && !(JSON.stringify(Object.keys(values)) === '[""]'))
                    parsedFilters[filterParam] = values;
            }
        }
    }
    if (Object.keys(parsedFilters).length < 1)
        return sortProducts(variants, appliedFilters.sort);
    // If something to filter
    const filteredProducts = [];
    for (const variant of variants) {
        let matchAllFilters = false;
        // Product must match all filterParam
        for (const filterParam in parsedFilters) {
            if ((_b = (_a = variant === null || variant === void 0 ? void 0 : variant.product) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.some(filter => filter.param === filterParam)) {
                // product has this filter param, now lets check if match at least one param value
                for (const filter of variant.product.filters) {
                    if (filter.param === filterParam) {
                        if (filter.type === 'simple') {
                            matchAllFilters = true;
                        }
                        else {
                            const values = filter.values.map((value) => {
                                return value.value;
                            });
                            //@ts-ignore
                            const matchedValues = [...new Set(Object.keys(parsedFilters[filterParam]).filter(val => values.includes(val)))];
                            matchAllFilters = matchedValues.length > 0;
                        }
                        break;
                    }
                }
            }
            else {
                matchAllFilters = false;
                break;
            }
            if (!matchAllFilters)
                break;
        }
        if (matchAllFilters)
            filteredProducts.push(variant);
    }
    return sortProducts(filteredProducts, appliedFilters.sort);
};
exports.getFilteredProducts = getFilteredProducts;
const TRANSLATIONS_SORT_BY_PRIVATE = {
    'es': {
        name: 'Ordenar',
        values: [
            { name: 'Recomendados', value: 'recommended' },
            { name: 'Precio más bajo', value: 'low-price' },
            { name: 'Precio más alto', value: 'high-price' },
        ]
    },
    'ca': {
        name: 'Ordenar',
        values: [
            { name: 'Recomanats', value: 'recommended' },
            { name: 'Preu més baix', value: 'low-price' },
            { name: 'Preu més alt', value: 'high-price' },
        ]
    },
    'en': {
        name: 'Sort',
        values: [
            { name: 'Recommended', value: 'recommended' },
            { name: 'Lowest Price', value: 'low-price' },
            { name: 'Highest Price', value: 'high-price' },
        ]
    },
    'fr': {
        name: 'Trier',
        values: [
            { name: 'Recommandés', value: 'recommended' },
            { name: 'Prix le plus bas', value: 'low-price' },
            { name: 'Prix le plus élevé', value: 'high-price' },
        ]
    },
    'pt': {
        name: 'Ordenar',
        values: [
            { name: 'Recomendados', value: 'recommended' },
            { name: 'Preço mais baixo', value: 'low-price' },
            { name: 'Preço mais alto', value: 'high-price' },
        ]
    },
    'de': {
        name: 'Sortieren',
        values: [
            { name: 'Empfohlen', value: 'recommended' },
            { name: 'Niedrigster Preis', value: 'low-price' },
            { name: 'Höchster Preis', value: 'high-price' },
        ]
    },
    'it': {
        name: 'Ordina',
        values: [
            { name: 'Consigliati', value: 'recommended' },
            { name: 'Prezzo più basso', value: 'low-price' },
            { name: 'Prezzo più alto', value: 'high-price' },
        ]
    }
};
const TRANSLATIONS_SORT_BY_PUBLIC = {
    'es': {
        name: 'Ordenar',
        values: [
            { name: 'Recomendados', value: 'recommended' }
        ]
    },
    'ca': {
        name: 'Ordenar',
        values: [
            { name: 'Recomanats', value: 'recommended' }
        ]
    },
    'en': {
        name: 'Sort',
        values: [
            { name: 'Recommended', value: 'recommended' }
        ]
    },
    'fr': {
        name: 'Trier',
        values: [
            { name: 'Recommandés', value: 'recommended' }
        ]
    },
    'pt': {
        name: 'Ordenar',
        values: [
            { name: 'Recomendados', value: 'recommended' }
        ]
    },
    'de': {
        name: 'Sortieren',
        values: [
            { name: 'Empfohlen', value: 'recommended' }
        ]
    },
    'it': {
        name: 'Ordina',
        values: [
            { name: 'Consigliati', value: 'recommended' }
        ]
    }
};
const getFilters = (variants = [], lang, isPrivate = false) => {
    if ((variants === null || variants === void 0 ? void 0 : variants.length) === 0)
        return null;
    const finalFilters = {};
    if (lang) {
        isPrivate ? finalFilters['sort'] = Object.assign(Object.assign({}, TRANSLATIONS_SORT_BY_PRIVATE[lang]), { type: 'multiple' }) : finalFilters['sort'] = Object.assign(Object.assign({}, TRANSLATIONS_SORT_BY_PUBLIC[lang]), { type: 'multiple' });
    }
    const mergeFilters = (filters) => {
        for (let filter of filters) {
            const { param, name, type, values } = filter;
            if (!(param in finalFilters)) {
                finalFilters[param] = (type === 'multiple' || type === 'brand') ? { name, type, values } : { name, type };
            }
            else {
                if (type === 'multiple' || type === 'brand') {
                    const mergedValues = [...finalFilters[param].values, ...values];
                    // @ts-ignore
                    const uniqValues = [...new Map(mergedValues.map(item => [item.value, item])).values()];
                    finalFilters[param].values = Array.from(uniqValues);
                }
            }
        }
    };
    variants.map((variant) => {
        var _a;
        const { product } = variant;
        if (((_a = product.filters) === null || _a === void 0 ? void 0 : _a.length) > 0)
            mergeFilters(product.filters);
    });
    return [finalFilters, Object.keys(finalFilters)];
};
exports.getFilters = getFilters;
const updateActiveFilters = (currentFilters, filter) => {
    let incomingFilters = Object.assign({}, currentFilters);
    const param = incomingFilters[filter.param];
    if (filter.param === 'sort') {
        if (param && param[filter.value]) {
            delete incomingFilters[filter.param];
        }
        else {
            incomingFilters = Object.assign(Object.assign({}, incomingFilters), { [filter.param]: { [filter.value]: true } });
        }
    }
    else if (param) {
        if (filter.type === 'simple') {
            delete incomingFilters[filter.param];
        }
        else {
            param[filter.value] ? delete param[filter.value] : param[filter.value] = true;
        }
    }
    else {
        if (filter.type === 'simple') {
            incomingFilters[filter.param] = true;
        }
        else {
            incomingFilters[filter.param] = { [filter.value]: true };
        }
    }
    return incomingFilters;
};
exports.updateActiveFilters = updateActiveFilters;
const generateQueryParams = (filters) => {
    if (Object.keys(filters).length < 1)
        return {};
    const queryParams = {};
    let stringParams = '';
    for (const key in filters) {
        if (typeof filters[key] === 'boolean') {
            queryParams[key] = 'true';
            stringParams += `${stringParams.length > 1 ? '&' : ''}${key}=true`;
        }
        else {
            let values = [];
            for (let value in filters[key]) {
                values.push(`${value}`);
            }
            queryParams[key] = values;
            stringParams += `${stringParams.length > 1 ? '&' : ''}${key}=${values.join(',')}`;
        }
    }
    return { queryParams, stringParams };
};
exports.generateQueryParams = generateQueryParams;
const getFiltersFromQuery = (url, params) => {
    var _a, _b;
    const queryFilters = {};
    const urlParams = new URL(`https://frontend.rules${url}`).searchParams;
    queryFilters['sort'] = { [(_a = urlParams.get('sort')) !== null && _a !== void 0 ? _a : 'recommended']: true };
    for (const param of params) {
        const values = (_b = urlParams.get(param)) === null || _b === void 0 ? void 0 : _b.split(',');
        if (values) {
            if ((values === null || values === void 0 ? void 0 : values.length) === 1) {
                queryFilters[param] = values[0] === 'true' ? true : { [values[0]]: true };
            }
            else {
                for (const value of values) {
                    if (queryFilters[param]) {
                        queryFilters[param][value] = true;
                    }
                    else {
                        queryFilters[param] = { [value]: true };
                    }
                }
            }
        }
    }
    return queryFilters;
};
exports.getFiltersFromQuery = getFiltersFromQuery;
const slugMatch = (arr1, arr2) => {
    let arr = arr1;
    if (typeof arr1 === 'string')
        arr = [arr1];
    if (arr.length !== arr2.length)
        return false;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== arr2[i])
            return false;
    }
    return true;
};
exports.slugMatch = slugMatch;
const getFeaturedFilters = (activeFilters, filters) => {
    var _a;
    const incomingfeaturedFilters = [];
    for (const keyparam in activeFilters) {
        const filter = filters === null || filters === void 0 ? void 0 : filters[keyparam];
        if (filter) {
            for (const keyvalue in activeFilters[keyparam]) {
                const matchFilter = (_a = filter === null || filter === void 0 ? void 0 : filter.values) === null || _a === void 0 ? void 0 : _a.filter(value => value.value === keyvalue)[0];
                if (matchFilter && matchFilter.media)
                    incomingfeaturedFilters.push(Object.assign(Object.assign({}, matchFilter), { param: keyparam }));
            }
        }
    }
    return incomingfeaturedFilters;
};
exports.getFeaturedFilters = getFeaturedFilters;
const appendGiftCard = (products, width) => {
    //hardCoded GifcardOBJECT!
    const giftCardObj = {
        'giftCard': true,
        'bigcommerce_id': null,
        'bigcommerce_slug': null,
        'name': null,
        'slug': null,
        'sku': null,
        'variant': null,
        'pack': false,
        'labels': null,
        'filters': [
            {
                'name': 'Marca',
                'param': 'marca',
                'type': 'multiple',
                'values': [
                    {
                        'name': 'Mammafiore!',
                        'value': 'mamma-value',
                        'description': '',
                        'media': null
                    }
                ]
            }
        ],
        'brand': null,
        'categories': null
    };
    let clonedArray = [...products];
    let columns = width >= 1650 ? 5 : (width < 603 || (width >= 768 && width <= 1649)) ? 4 : 3;
    let variableCount = width >= 1650 ? 39 : 41;
    let productCount = variableCount + columns;
    for (let idx = 1; idx <= clonedArray.length; idx++) {
        if (idx === columns && !clonedArray[idx].giftCard) {
            clonedArray.splice(columns, 0, giftCardObj);
        }
        else if ((idx % productCount === 0)) {
            clonedArray.splice(idx, 0, giftCardObj);
        }
    }
    return clonedArray;
};
exports.appendGiftCard = appendGiftCard;


/***/ }),

/***/ 40918:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.scrollToTop = exports.removeIndexFromArray = void 0;
const removeIndexFromArray = (array, idx) => {
    const index = array.indexOf(idx);
    if (index > -1)
        array.splice(index, 1);
};
exports.removeIndexFromArray = removeIndexFromArray;
const scrollToTop = () => {
    window === null || window === void 0 ? void 0 : window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
};
exports.scrollToTop = scrollToTop;


/***/ }),

/***/ 29212:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.iconByName = void 0;
const altByIcon = {
    'close': 'Close icon',
};
const iconByName = (iconName) => ({
    type: 'svg',
    src: `/images/svg/i--${iconName}.svg`,
    alt: altByIcon[iconName],
    size: { width: 24, height: 24 }
});
exports.iconByName = iconByName;


/***/ }),

/***/ 76079:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAllCategories = exports.hasPrivateStore = exports.getPathnameType = exports.privatePaths = exports.DY_LOGIN_ALLOWED = exports.DY_SIGNUP_ALLOWED = exports.PRO = exports.STAGING = exports.DEV = exports.HOSTNAME = exports.NEXT_PUBLIC_LOCALE = void 0;
exports.NEXT_PUBLIC_LOCALE = "fr-FR";
exports.HOSTNAME = "mammafiore.fr";
exports.DEV = "production" === 'development';
exports.STAGING = "production" === 'preview';
exports.PRO = "production" === 'production';
exports.DY_SIGNUP_ALLOWED = "false" === 'true';
exports.DY_LOGIN_ALLOWED = "false" === 'true';
exports.privatePaths = [
    '/welcome',
    '/shop',
    '/account',
    '/checkout',
    '/cart',
    '/shop/search'
];
const getPathnameType = (pathname) => {
    for (let path of exports.privatePaths) {
        if (pathname.startsWith(path))
            return 'private';
    }
    return 'public';
};
exports.getPathnameType = getPathnameType;
exports.hasPrivateStore = {
    'en-EU': false,
    'es-ES': false,
    'es-CT': true,
    'es-MD': false,
    'es-CN': false,
    'fr-FR': false,
    'en-GB': false,
    'pt-PT': false,
    'de-DE': false,
};
const TRANSLATIONS = {
    'es': 'Todos los productos de esta marca',
    'ca': 'Tots els productes d´aquesta marca',
    'en': 'All products of this brand',
    'fr': 'Tous les produits de cette marque',
    'pt': 'Todos os produtos desta marca',
    'de': 'Alle Produkte dieser Marke',
    'it': 'Tutti i prodotti di questo marchio' // Italian
};
const translations_info = {
    'es': 'Categorías de la marca:',
    'ca': 'Categories de la marca:',
    'en': 'Categories of the brand:',
    'fr': 'Catégories de la marque:',
    'pt': 'Categorias da marca:',
    'de': 'Kategorien der Marke:',
    'it': 'Categorie del marchio:'
};
const getAllCategories = (parentSlug, locale, categories) => {
    if (categories.length === 0)
        return;
    const firstCategory = {
        '__typename': 'Category',
        'name': `${TRANSLATIONS[locale]}`,
        'parentId': null,
        'slug': parentSlug,
        'isFirstCategory': true,
        'subcategories': []
    };
    const informativeText = {
        '__typename': 'Category',
        'name': `${translations_info[locale]}`,
        'parentId': null,
        'slug': parentSlug,
        'isInformativeText': true,
        'subcategories': []
    };
    if (categories[0].name !== TRANSLATIONS[locale])
        return [firstCategory, informativeText, ...categories];
    else
        return categories;
};
exports.getAllCategories = getAllCategories;
__exportStar(__webpack_require__(88171), exports);
__exportStar(__webpack_require__(88852), exports);
__exportStar(__webpack_require__(12027), exports);
__exportStar(__webpack_require__(40918), exports);
__exportStar(__webpack_require__(6511), exports);
__exportStar(__webpack_require__(60148), exports);
__exportStar(__webpack_require__(61919), exports);
__exportStar(__webpack_require__(96345), exports);
__exportStar(__webpack_require__(70536), exports);
__exportStar(__webpack_require__(80454), exports);
__exportStar(__webpack_require__(4296), exports);
__exportStar(__webpack_require__(95669), exports);
__exportStar(__webpack_require__(86692), exports);
__exportStar(__webpack_require__(51035), exports);
__exportStar(__webpack_require__(51634), exports);
__exportStar(__webpack_require__(83215), exports);
__exportStar(__webpack_require__(64485), exports);
__exportStar(__webpack_require__(29212), exports);


/***/ }),

/***/ 86692:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.autoComplete = void 0;
// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#attr-fe-autocomplete
exports.autoComplete = {
    name: {
        prefix: 'honorific-prefix',
        fullname: 'name',
        firstName: 'given-name',
        secondName: 'additional-name',
        lastName: 'family-name',
        suffix: 'honorific-suffix',
        nickname: 'nickname',
        username: 'username'
    },
    password: {
        new: 'new-password',
        current: 'current-password'
    },
    address: {
        street: 'street-address',
        street1: 'address-line1',
        street2: 'address-line2',
        postalCode: 'postal-code',
        countryCode: 'country',
        countryName: 'country-name',
        provinceOrstate: 'address-level1',
        cityOrTown: 'address-level2',
        district: 'address-level3',
    },
    card: {
        fullName: 'cc-name',
        firstName: 'cc-given-name',
        secondName: 'cc-additional-name',
        lastName: 'cc-family-name',
        number: 'cc-number',
        expirationDate: 'cc-exp',
        expirationMonth: 'cc-exp-month',
        expirationYear: 'cc-exp-year',
        cvv: 'cc-csc',
        type: 'cc-type'
    },
    transaction: {
        currency: 'transaction-currency',
        amount: 'transaction-amount'
    },
    language: 'language',
    gender: 'sex',
    tel: {
        internationalNumber: 'tel',
        countryCodeNumber: 'tel-country-code',
        nationalNumber: 'tel-national',
        extension: 'tel-extension'
    },
    birthday: {
        date: 'bday',
        day: 'bday-day',
        month: 'bday-month',
        year: 'bday-year'
    },
    email: 'email',
    company: {
        name: 'organization',
        jobPosition: 'organization-title'
    }
};


/***/ }),

/***/ 51634:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.inputPattern = void 0;
// https://rgxdb.com/r/3EZMSVWM
exports.inputPattern = {
    email: /^[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+$/i,
    postalCode: {
        'BE': /^(?:(?:[1-9])(?:\d{3}))$/,
        'CH': /^[1-9]\d{3}$/,
        'DE': /^\d{5}$/,
        'DK': /^(?:[1-24-9]\d{3}|3[0-8]\d{2})$/,
        'ES': /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,
        'FR': /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/,
        'GB': /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/,
        'IT': /^\d{5}$/,
        'PT': /^\d{4}-\d{3}?$/,
        'US': /^\d{5}(?:-\d{4})?$/
    },
    password: /(?=.*[a-zA-Z])((?=.*[0-9])|(?=.*([[:print:]][^[[:alnum:]]]))).{8,}/,
};


/***/ }),

/***/ 83215:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shippingPostalCodeValid = void 0;
const shippingPostalCodeValid = (data, inputValue) => {
    if (typeof inputValue !== 'string')
        return false;
    if (Array.isArray(data) && data.length === 0)
        return true;
    let valid = false;
    for (let postalCode of data) {
        const { valueType, to, from, value } = postalCode;
        if (valueType === 'range') {
            const fromInt = parseInt(from);
            const toInt = parseInt(to);
            const valueInt = parseInt(inputValue);
            valid = fromInt < valueInt && valueInt < toInt;
        }
        else {
            valid = inputValue === value;
        }
        if (valid)
            break;
    }
    return valid;
};
exports.shippingPostalCodeValid = shippingPostalCodeValid;


/***/ }),

/***/ 51035:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validate = void 0;
const phoneValidator = phoneNumber => {
    const trimedPhoneNumber = phoneNumber.replace(/ /g, '');
    const ES_REGEX = /(([+]?34) ?)?(6(([0-9]{8})|([0-9]{2} [0-9]{6})|([0-9]{2} [0-9]{3} [0-9]{3}))|9(([0-9]{8})|([0-9]{2} [0-9]{6})|([1-9] [0-9]{7})|([0-9]{2} [0-9]{3} [0-9]{3})|([0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2})))/;
    const FR_REGEX = /^(\+33 |0)[1-9]( \d\d){4}$/;
    const UK_REGEX = /^((\+44\s?\d{4}|\(?\d{5}\)?)\s?\d{6})|((\+44\s?|0)7\d{3}\s?\d{6})$/;
    const PT_REGEX = /(\+351 ?)?((2\d{8})|(9[1236]\d{7})|(7[012]\d{7}))/;
    const DE_REGEX = /(\+49 ?)?([1-9][0-9]{1,4})([0-9]{6,10})/;
    const validate = trimedPhoneNumber => {
        const valid = getNumberMatch(trimedPhoneNumber);
        return valid;
    };
    const getNumberMatch = phoneNumber => {
        if (ES_REGEX.test(phoneNumber))
            return true;
        if (UK_REGEX.test(phoneNumber))
            return true;
        if (FR_REGEX.test(phoneNumber))
            return true;
        if (PT_REGEX.test(phoneNumber))
            return true;
        if (DE_REGEX.test(phoneNumber))
            return true;
    };
    return validate(trimedPhoneNumber);
};
const nifValidator = id => {
    const DNI_REGEX = /^(\d{8})([A-Z])$/;
    const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
    const validate = id => {
        // Ensure upcase and remove whitespace
        id = id.toUpperCase().replace(/\s/, '');
        const type = getIdType(id);
        const valid = type === 'dni' ? validDNI(id) : validNIE(id);
        // return { type, valid }
        return valid;
    };
    const getIdType = id => {
        if (id.match(DNI_REGEX))
            return 'dni';
        if (id.match(NIE_REGEX))
            return 'nie';
    };
    const validDNI = dni => {
        const dni_letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        const letter = dni_letters.charAt(parseInt(dni, 10) % 23);
        return letter == dni.charAt(8);
    };
    const validNIE = nie => {
        // Change the initial letter for the corresponding number and validate as DNI
        const prefixDigit = { 'X': 0, 'Y': 1, 'Z': 2 };
        let prefix = nie.charAt(0);
        prefix = prefixDigit[prefix];
        return validDNI(prefix + nie.substr(1));
    };
    return validate(id);
};
const ibanValidator = rawIban => {
    const iban = trim(rawIban.toUpperCase().replace(/\s/g, ''));
    if (iban.length !== 24 || iban.substring(0, 2) !== 'ES')
        return false;
    const regex = new RegExp('\\d{22}');
    if (regex.test(iban.substring(2, 24))) {
        const char1 = iban.substring(0, 1);
        const char2 = iban.substring(1, 2);
        const char1Code = getCharCode(char1);
        const char2Code = getCharCode(char2);
        let isbanaux = String(char1Code) + String(char2Code) + iban.substring(2);
        isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);
        const remainer = module97(isbanaux);
        return remainer === 1;
    }
    function trim(str) {
        return str.replace(/^\s+/g, '').replace(/\s+$/g, '');
    }
    function getCharCode(char) {
        const abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return abc.search(char) + 10;
    }
    function module97(banaux) {
        let parts = Math.ceil(banaux.length / 7);
        let remainer = '';
        for (let i = 1; i <= parts; i++) {
            remainer = String(parseFloat(remainer + banaux.substr((i - 1) * 7, 7)) % 97);
        }
        return parseInt(remainer);
    }
};
const cifValidator = (cif) => {
    if (!cif || cif.length !== 9)
        return false;
    const letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    let digits = cif.substr(1, cif.length - 2);
    const letter = cif.substr(0, 1);
    let control = cif.substr(cif.length - 1);
    let sum = 0;
    let digit;
    if (!letter.match(/[A-Z]/))
        return false;
    let i;
    for (i = 0; i < digits.length; ++i) {
        digit = parseInt(digits[i]);
        if (isNaN(digit))
            return false;
        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9)
                digit = parseInt(`${digit / 10}`) + (digit % 10);
        }
        sum += digit;
    }
    sum %= 10;
    digit = sum !== 0 ? 10 - sum : sum;
    if (letter.match(/[ABEH]/))
        return String(digit) === control;
    if (letter.match(/[NPQRSW]/))
        return letters[digit] === control;
    return String(digit) === control || letters[digit] === control;
};
const cifAndNifValidator = (id) => {
    return cifValidator(id) || nifValidator(id);
};
const validateIBAN = (iban, countryCode) => {
    // Remove whitespace and convert to uppercase
    iban = iban.replace(/\s+/g, '').toUpperCase();
    // Check if the IBAN length is valid
    if (iban.length < 2 || iban.length > 34)
        return false;
    // Check specific rules based on the country code
    switch (countryCode) {
        case 'ES': // Spain
            if (!/^ES\d{22}$/.test(iban))
                return false;
            break;
        case 'FR': // France
            if (!/^FR\d{12}[A-Z0-9]{11}\d{2}$/.test(iban))
                return false;
            break;
        case 'GB': // United Kingdom
            if (!/^GB\d{2}[A-Z]{4}\d{14}$/.test(iban))
                return false;
            break;
        case 'PT': // Portugal
            if (!/^PT\d{23}$/.test(iban))
                return false;
            break;
        case 'IT': // Italy
            if (!/^IT\d{2}[A-Z]\d{22}$/.test(iban))
                return false;
            break;
        case 'DE': // Germany
            if (!/^DE\d{20}$/.test(iban))
                return false;
            break;
        default:
            return false;
    }
    // Move the first four characters to the end
    const rearrangedIBAN = iban.slice(4) + iban.slice(0, 4);
    // Convert letters to numbers (A = 10, B = 11, ..., Z = 35)
    const convertedIBAN = rearrangedIBAN.replace(/[A-Z]/g, char => (char.charCodeAt(0) - 55).toString());
    // Perform modulo 97 operation on the converted IBAN
    let remainder = 0;
    let block = '';
    for (let i = 0; i < convertedIBAN.length; i += 6) {
        block = remainder.toString() + convertedIBAN.substr(i, 6);
        remainder = parseInt(block, 10) % 97;
    }
    return remainder === 1;
};
exports.validate = {
    cif: cifValidator,
    cifandnif: cifAndNifValidator,
    ibanES: ibanValidator,
    iban: validateIBAN,
    nif: nifValidator,
    phone: phoneValidator
};


/***/ }),

/***/ 95669:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// PENDING TODO improve locale on base file instead of here since its a general type
// type TypeLocale = 'en-EU' | 'es-ES' | 'es-CT' | 'es-CN' | 'es-MD' | 'en-GB' | 'fr-FR' | 'de-DE'
// type TypeLocaleCountry = 'es-ES' | 'en-GB' | 'fr-FR' | 'de-DE'
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRegion = exports.getLang = exports.getStoreUrlByLocale = exports.getStoreByLocale = exports.getLocaleCountry = void 0;
// export function getLocaleCountry(locale: TypeLocale): TypeLocaleCountry {
function getLocaleCountry(locale) {
    switch (locale) {
        case 'es-CN':
        case 'es-CT':
        case 'es-MD':
            return 'es-ES';
        case 'en-EU':
            return 'en-GB';
        default:
            return locale;
    }
}
exports.getLocaleCountry = getLocaleCountry;
exports.getStoreByLocale = {
    'en-EU': 'Europe',
    'es-CN': 'Canarias',
    'es-CT': 'Cataluña',
    'es-MD': 'Madrid',
    'fr-FR': 'France',
    'en-GB': 'United Kingdom',
    'de-DE': 'Deutschland',
    'pt-PT': 'Portugal',
};
const getStoreUrlByLocale = (locale, PRO) => {
    const url = {
        'en-EU': 'mammafiore.eu',
        'es-ES': 'mammafiore.es?zone=es-ES',
        'es-CN': 'canarias.mammafiore.es?zone=es-CN',
        'es-CT': 'cat.mammafiore.es?zone=es-CT',
        'es-MD': 'madrid.mammafiore.es?zone=es-MD',
        'fr-FR': 'mammafiore.fr?zone=fr-FR',
        'en-GB': 'mammafiore.co.uk?zone=en-GB',
        'de-DE': 'mammafiore.de?zone=de-DE',
        'pt-PT': 'mammafiore.pt?zone=pt-PT',
    };
    if (!url[locale])
        return undefined;
    return (!PRO ? 'staging.' : '') + url[locale];
};
exports.getStoreUrlByLocale = getStoreUrlByLocale;
function getLang(str) {
    if (typeof str !== 'string')
        throw new Error('getLang parameter must be typeof "string"');
    return str.substring(2, 0);
}
exports.getLang = getLang;
function getRegion(str) {
    if (typeof str !== 'string')
        throw new Error('getRegion parameter must be typeof "string"');
    return str.split('-')[1];
}
exports.getRegion = getRegion;


/***/ }),

/***/ 64485:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.loginCustomer = void 0;
const cookies_1 = __webpack_require__(96345);
const error = {
    message: 'Credentials error or inactive account',
    extensions: {
        code: 'CREDENTIALS_ERROR',
        attribute: 'customer'
    }
};
const loginCustomer = ({ email, password, push }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const res = yield fetch('/api/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });
        if (res.ok && (res.status === 201 || res.status === 200)) {
            const { data } = yield res.json();
            // let cookieToken = token
            // // LOGIN & ACTIVATION only (when signup we already got the token in the response)
            // if(!token) {
            //   const resToken = await fetch('/api/auth/token', {
            //     method: 'POST',
            //     headers: {
            //       'Accept': 'application/json',
            //       'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({ email, password }),
            //   })
            //   const { data: dataToken } = await resToken.json()
            //   if (dataToken?.generateToken?.ok) cookieToken = dataToken.generateToken?.token
            // }
            cookies_1.cookie.removeCookie('DY_CUSTOMER_TOKEN');
            cookies_1.cookie.removeCookie('BC_CUSTOMER_ID');
            if (!data.loginMutation.dyApiCustomerToken) {
                console.log('NO COOKIE TOKEN');
                return { error };
            }
            const expiry = data.loginMutation.dyApiCustomerTokenExpiry;
            cookies_1.cookie.set({ name: 'DY_CUSTOMER_TOKEN', value: data.loginMutation.dyApiCustomerToken, expire: expiry });
            cookies_1.cookie.set({ name: 'BC_CUSTOMER_ID', value: (_b = (_a = data.loginMutation) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.bigcommerceId, expire: expiry });
            push(`/welcome?d=${Date.now()}`);
            // window.location.href = `https://${HOSTNAME}/welcome?d=${Date.now()}`
        }
        else {
            console.log('error en el ELSE');
            return { error };
        }
    }
    catch (e) {
        console.error('❌ Login failed:', e);
        return { error };
    }
});
exports.loginCustomer = loginCustomer;


/***/ }),

/***/ 80454:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.subscribe = void 0;
const subscribe = ({ body = {} }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch('/api/active-campaign/newsletter', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            contact: body,
        })
    });
    const data = yield response.json();
    return !!data.data.contactList;
});
exports.subscribe = subscribe;


/***/ }),

/***/ 60148:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// src:- https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.downloadPDF = void 0;
const downloadPDF = (blob, name = 'mammafiore_file') => __awaiter(void 0, void 0, void 0, function* () {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], { type: 'application/pdf' });
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    //@ts-ignore
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //@ts-ignore
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
    }
    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = `${name}.pdf`;
    link.click();
    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
});
exports.downloadPDF = downloadPDF;


/***/ }),

/***/ 88171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSeo = exports.getDynamicText = exports.slugify = void 0;
const slugify = (text) => text
    .toString() // Cast to string (optional)
    .normalize('NFKD') // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string (optional)
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
exports.slugify = slugify;
function getDynamicText(text, variables) {
    // Use a regular expression to find all placeholders between double curly braces
    const placeholderRegex = /\{\{([^}]+)\}\}/g;
    // Replace each placeholder with the corresponding value from the variables object
    const dynamicText = text.replace(placeholderRegex, (match, placeholder) => {
        // Trim the placeholder to remove any leading or trailing spaces
        const keyName = placeholder.trim();
        // Check if the keyName exists in the variables object
        if (variables.hasOwnProperty(keyName)) {
            // If the keyName exists, return its value
            return variables[keyName].toString();
        }
        else {
            // If the keyName does not exist, return the original placeholder
            console.warn(`keyName: ${keyName} doesn't exist for the text: ${text}`);
            return match;
        }
    });
    return dynamicText;
}
exports.getDynamicText = getDynamicText;
const getSeo = (name, locale) => {
    const seo = {
        'es': {
            title: `Mammafiore | Marca ${name}`,
            description: `Pagina de marca ${name}`
        },
        'en': {
            title: `Mammafiore | Brand ${name}`,
            description: `Brand Page ${name}`
        },
        'de': {
            title: `Mammafiore | Marke ${name}`,
            description: `Markenseite ${name}`
        },
        'ca': {
            title: `Mammafiore | Marca ${name}`,
            description: `Pàgina de marca ${name}`
        },
        'fr': {
            title: `Mammafiore | Marque ${name}`,
            description: `Page de marque ${name}`
        },
        'pt': {
            title: `Mammafiore | Marca ${name}`,
            description: `Página da marca ${name}`
        }
    };
    return seo[locale];
};
exports.getSeo = getSeo;


/***/ }),

/***/ 69117:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ApolloCache; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38223);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18001);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44245);
/* harmony import */ var _wry_caches__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61114);
/* harmony import */ var _utilities_caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80892);





var ApolloCache = /** @class */ (function () {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .wrap */ .re)(_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getFragmentQueryDocument */ .Yk, {
            max: _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .cacheSizes["cache.fragmentQueryDocuments"] */ .Q["cache.fragmentQueryDocuments"] ||
                1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
            cache: _wry_caches__WEBPACK_IMPORTED_MODULE_3__/* .WeakCache */ .k,
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic
            : options.optimistic === false ? null
                : void 0;
        var updateResult;
        this.performTransaction(function () { return (updateResult = options.update(_this)); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { rootId: options.id || "ROOT_QUERY", optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__rest)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__rest)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

if (globalThis.__DEV__ !== false) {
    ApolloCache.prototype.getMemoryInternals = _utilities_caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_5__/* .getApolloCacheMemoryInternals */ .Kb;
}
//# sourceMappingURL=cache.js.map

/***/ }),

/***/ 19814:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MissingFieldError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22970);

var MissingFieldError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map

/***/ }),

/***/ 15397:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ TypeOrFieldNameRegExp; },
/* harmony export */   "E_": function() { return /* binding */ fieldNameFromStoreName; },
/* harmony export */   "Is": function() { return /* binding */ extractFragmentContext; },
/* harmony export */   "RC": function() { return /* binding */ selectionSetMatchesResult; },
/* harmony export */   "RI": function() { return /* binding */ hasOwn; },
/* harmony export */   "ig": function() { return /* binding */ makeProcessedFieldsMerger; },
/* harmony export */   "j": function() { return /* binding */ storeValueIsStoreObject; },
/* harmony export */   "jS": function() { return /* binding */ normalizeConfig; },
/* harmony export */   "jp": function() { return /* binding */ getTypenameFromStoreObject; },
/* harmony export */   "lg": function() { return /* binding */ shouldCanonizeResults; },
/* harmony export */   "uG": function() { return /* binding */ defaultDataIdFromObject; }
/* harmony export */ });
/* unused harmony export isNullish */
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9428);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45931);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43056);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9572);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34529);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18001);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86607);

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}

function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id }
                    : !isNullish(_id) ? { _id: _id }
                        : void 0;
        }
        // If there is no object.id, fall back to object._id.
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ?
                id
                : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(objectOrReference) ?
        store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(result)) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(result) ?
            result.every(function (item) {
                return selectionSetMatchesResult(selectionSet, item, variables);
            })
            : selectionSet.selections.every(function (field) {
                if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isField */ .My)(field) && (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .shouldInclude */ .LZ)(field, variables)) {
                    var key = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .resultKeyNameFromField */ .u2)(field);
                    return (hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables)));
                }
                // If the selection has been skipped with @skip(true) or
                // @include(false), it should not count against the matching. If
                // the selection is not a field, it must be a fragment (inline or
                // named). We will determine if selectionSetMatchesResult for that
                // fragment when we get to it, so for now we return true.
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) && !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(value) && !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(value);
}
function makeProcessedFieldsMerger() {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .DeepMerger */ .w0();
}
function extractFragmentContext(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .createFragmentMap */ .F)((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getFragmentDefinitions */ .kU)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 89552:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ InMemoryCache; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/optimism/lib/index.js + 7 modules
var lib = __webpack_require__(38223);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/index.js
var equality_lib = __webpack_require__(78807);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(69117);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(19814);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/DocumentTransform.js
var DocumentTransform = __webpack_require__(46945);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(11209);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/sizes.js
var sizes = __webpack_require__(44245);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canonicalStringify.js
var canonicalStringify = __webpack_require__(18099);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/print.js + 2 modules
var print = __webpack_require__(40122);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(34529);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(18001);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(23180);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(45931);
// EXTERNAL MODULE: ../../node_modules/@wry/trie/lib/index.js
var trie_lib = __webpack_require__(49452);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(15397);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = /** @class */ (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function (objectOrReference, storeFieldName) {
            return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                _this.get(objectOrReference.__ref, storeFieldName)
                : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function (objOrRef) {
            return (0,storeUtils/* isReference */.Yk)(objOrRef) ?
                _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,storeUtils/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,storeUtils/* isReference */.Yk)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,storeUtils/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && helpers/* hasOwn.call */.RI.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            helpers/* hasOwn.call */.RI.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0,storeUtils/* isReference */.Yk)(older))
            older = older.__ref;
        if ((0,storeUtils/* isReference */.Yk)(newer))
            newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup((dataId = older)) : older;
        var incoming = typeof newer === "string" ? this.lookup((dataId = newer)) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming)
            return;
        (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new mergeDeep/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing ||
                        existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    // Since we return default root __typename strings
                    // automatically from store.get, we don't need to dirty the
                    // ROOT_QUERY.__typename field if merged.__typename is equal
                    // to the default string (usually "Query").
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: storeUtils/* isReference */.Yk,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ?
                        {
                            fieldName: fieldNameOrOptions,
                            from: from || (0,storeUtils/* makeReference */.kQ)(dataId),
                        }
                        : fieldNameOrOptions, { store: _this });
                },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function" ? fields : (fields[storeFieldName] || fields[fieldName]);
                if (modify) {
                    var newValue = modify === delModifier ? DELETE : (modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) })));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function (ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0,storeUtils/* isReference */.Yk)(newValue)) {
                                    checkReference(newValue);
                                }
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for (var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++) {
                                        var value = newValue_1[_i];
                                        if ((0,storeUtils/* isReference */.Yk)(value)) {
                                            seenReference = true;
                                            if (checkReference(value))
                                                break;
                                        }
                                        else {
                                            // Do not warn on primitive values, since those could never be represented
                                            // by a reference. This is a valid (albeit uncommon) use case.
                                            if (typeof value === "object" && !!value) {
                                                var id = _this.policies.identify(value)[0];
                                                // check if object could even be referenced, otherwise we are not interested in it for this warning
                                                if (id) {
                                                    someNonReference = value;
                                                }
                                            }
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ?
                this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (helpers/* hasOwn.call */.RI.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!helpers/* hasOwn.call */.RI.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && helpers/* hasOwn.call */.RI.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6.__rest)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return (this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1);
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
            // always considered roots for garbage collection, regardless of
            // their retainment counts in this.rootIds.
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (helpers/* hasOwn.call */.RI.call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!helpers/* hasOwn.call */.RI.call(this.refs, dataId)) {
            var found_1 = (this.refs[dataId] = Object.create(null));
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function (obj) {
                if ((0,storeUtils/* isReference */.Yk)(obj)) {
                    found_1[obj.__ref] = true;
                    // In rare cases, a { __ref } Reference object may have other fields.
                    // This often indicates a mismerging of References with StoreObjects,
                    // but garbage collection should not be fooled by a stray __ref
                    // property in a StoreObject (ignoring all the other fields just
                    // because the StoreObject looks like a Reference). To avoid this
                    // premature termination of findChildRefIds recursion, we fall through
                    // to the code below, which will handle any other properties of obj.
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        // No need to add primitive values to the workSet, since they cannot
                        // contain reference objects.
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var CacheGroup = /** @class */ (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? (0,lib/* dep */.dP)() : null;
        this.keyMaker = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
            if (fieldName !== storeFieldName) {
                // Fields with arguments that contribute extra identifying
                // information to the fieldName (thus forming the storeFieldName)
                // depend not only on the full storeFieldName but also on the
                // short fieldName, so the field can be invalidated using either
                // level of specificity.
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), 
            // When storeFieldName === "__exists", that means the entity identified
            // by dataId has either disappeared from the cache or was newly added,
            // so the result caching system would do well to "forget everything it
            // knows" about that object. To achieve that kind of invalidation, we
            // not only dirty the associated result cache entry, but also remove it
            // completely from the dependency graph. For the optimism implementation
            // details, see https://github.com/benjamn/optimism/pull/195.
            storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        // We use this pseudo-field __exists elsewhere in the EntityStore code to
        // represent changes in the existence of the entity object identified by
        // entityId. This dependency gets reliably dirtied whenever an object with
        // this ID is deleted (or newly created) within this group, so any result
        // cache entries (for example, StoreReader#executeSelectionSet results) that
        // depend on __exists for this entityId will get dirtied as well, leading to
        // the eventual recomputation (instead of reuse) of those result objects the
        // next time someone reads them from the cache.
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ (function (_super) {
        (0,tslib_es6.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var Layer = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                // Dirty every ID we're removing. Technically we might be able to avoid
                // dirtying fields that have values in higher layers, but we don't have
                // easy access to higher layers here, and we're about to recreate those
                // layers anyway (see parent.addLayer below).
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        // The StoreObject identified by dataId was defined in this layer
                        // but will be undefined in the parent layer, so we can delete the
                        // whole entity using this.delete(dataId). Since we're about to
                        // throw this layer away, the only goal of this deletion is to dirty
                        // the removed fields.
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        // This layer had an entry for dataId but it was undefined, which
                        // means the entity was deleted in this layer, and it's about to
                        // become undeleted when we remove this layer, so we need to dirty
                        // all fields that are about to be reexposed.
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        // If ownStoreObject is not exactly the same as parentStoreObject,
                        // dirty any fields whose values will change as a result of this
                        // removal.
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_lib/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent)
            return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return helpers/* hasOwn.call */.RI.call(this.data, dataId) ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, 
        // @ts-expect-error
        arguments);
    };
    return Layer;
}(EntityStore));
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var Stump = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function (older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0,equality_lib/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/object-canon.js




function shallowCopy(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        return (0,arrays/* isArray */.k)(value) ?
            value.slice(0)
            : (0,tslib_es6.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var ObjectCanon = /** @class */ (function () {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,objects/* isNonNullObject */.s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,objects/* isNonNullObject */.s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add((node.array = array));
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = (node.object = Object.create(proto_1));
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, (node.keys = { sorted: keys, json: json }));
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

//# sourceMappingURL=object-canon.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/readFromStore.js









function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults,
    ];
}
var StoreReader = /** @class */ (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(config),
        });
        this.canon = config.canon || new ObjectCanon();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0,lib/* wrap */.re)(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, other), { 
                        // If we previously read this result without canonizing it, we can
                        // reuse that result simply by canonizing it now.
                        result: _this.canon.admit(other.result) });
                }
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize ||
                sizes/* cacheSizes.inMemoryCache.executeSelectionSet */.Q["inMemoryCache.executeSelectionSet"] ||
                50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
            keyArgs: execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,storeUtils/* isReference */.Yk)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            },
        });
        this.executeSubSelectedArray = (0,lib/* wrap */.re)(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize ||
                sizes/* cacheSizes.inMemoryCache.executeSubSelectedArray */.Q["inMemoryCache.executeSubSelectedArray"] ||
                10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            },
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getQueryDefinition */.iW)(query))), variables);
        var rootRef = (0,storeUtils/* makeReference */.kQ)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,getFromAST/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6.__assign)({ store: store, query: query, policies: policies, variables: variables, varString: (0,canonicalStringify/* canonicalStringify */.B)(variables), canonizeResults: canonizeResults }, (0,helpers/* extractFragmentContext */.Is)(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new common/* MissingFieldError */.y(firstMissing(execResult.missing), execResult.missing, query, variables),
            ];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, 
            // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0,storeUtils/* isReference */.Yk)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            // Ensure we always include a default value for the __typename
            // field, if we have one, and this.config.addTypename is true. Note
            // that this field can be overridden by other merged objects.
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {},
                    _a[resultName] = result.missing,
                    _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0,directives/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,storeUtils/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
                if (fieldValue === void 0) {
                    if (!transform/* addTypenameToDocument.added */.Gw.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                                objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,arrays/* isArray */.k)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    // If the field does not have a selection set, then we handle it
                    // as a scalar value. To keep this.canon from canonicalizing
                    // this value, we use this.canon.pass to wrap fieldValue in a
                    // Pass object that this.canon.admit will later unwrap as-is.
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    // In this case, because we know the field has a selection set,
                    // it must be trying to query a GraphQLObjectType, which is why
                    // fieldValue must be != null.
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: (0,storeUtils/* isReference */.Yk)(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw (0,globals/* newInvariantError */._K)(9, selection.name.value);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = (0,mergeDeep/* mergeDeepArray */.bw)(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults ?
            this.canon.admit(finalResult)
            // Since this.canon is normally responsible for freezing results (only in
            // development), freeze them manually if canonization is disabled.
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            // null value in array
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse
            if ((0,arrays/* isArray */.k)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            // This is an object, run the selection set on it
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: (0,storeUtils/* isReference */.Yk)(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (globalThis.__DEV__ !== false) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                (0,globals/* invariant */.kG)(
                    !(0,storeUtils/* isReference */.Yk)(value),
                    10,
                    (0,helpers/* getTypenameFromStoreObject */.jp)(store, value),
                    field.name.value
                );
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(89732);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/stringifyForDisplay.js
var stringifyForDisplay = __webpack_require__(63118);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/key-extractor.js



// Mapping from JSON-encoded KeySpecifier strings to associated information.
var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return (specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null)));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
            var extract = function (from, key) {
                return context.readField(key, from);
            };
            var keyObject = (context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
                var extracted = extractKeyPath(context.storeObject, schemaKeyPath, 
                // Using context.readField to extract paths from context.storeObject
                // allows the extraction to see through Reference objects and respect
                // custom read functions.
                extract);
                if (extracted === void 0 &&
                    object !== context.storeObject &&
                    helpers/* hasOwn.call */.RI.call(object, schemaKeyPath[0])) {
                    // If context.storeObject fails to provide a value for the requested
                    // path, fall back to the raw result object, if it has a top-level key
                    // matching the first key in the path (schemaKeyPath[0]). This allows
                    // key fields included in the written data to be saved in the cache
                    // even if they are not selected explicitly in context.selectionSet.
                    // Not being mentioned by context.selectionSet is convenient here,
                    // since it means these extra fields cannot be affected by field
                    // aliasing, which is why we can use extractKey instead of
                    // context.readField for this extraction.
                    extracted = extractKeyPath(object, schemaKeyPath, extractKey);
                }
                (0,globals/* invariant */.kG)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
                return extracted;
            }));
            return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
        }));
}
// The keyArgs extraction process is roughly analogous to keyFields extraction,
// but there are no aliases involved, missing fields are tolerated (by merely
// omitting them from the key), and drawing from field.directives or variables
// is allowed (in addition to drawing from the field's arguments object).
// Concretely, these differences mean passing a different key path extractor
// function to collectSpecifierPaths, reusing the shared extractKeyPath helper
// wherever possible.
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyArgsFn ||
        (info.keyArgsFn = function (args, _a) {
            var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
            var collected = collectSpecifierPaths(specifier, function (keyPath) {
                var firstKey = keyPath[0];
                var firstChar = firstKey.charAt(0);
                if (firstChar === "@") {
                    if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                        var directiveName_1 = firstKey.slice(1);
                        // If the directive appears multiple times, only the first
                        // occurrence's arguments will be used. TODO Allow repetition?
                        // TODO Cache this work somehow, a la aliasMap?
                        var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                        // Fortunately argumentsObjectFromField works for DirectiveNode!
                        var directiveArgs = d && (0,storeUtils/* argumentsObjectFromField */.NC)(d, variables);
                        // For directives without arguments (d defined, but directiveArgs ===
                        // null), the presence or absence of the directive still counts as
                        // part of the field key, so we return null in those cases. If no
                        // directive with this name was found for this field (d undefined and
                        // thus directiveArgs undefined), we return undefined, which causes
                        // this value to be omitted from the key object returned by
                        // collectSpecifierPaths.
                        return (directiveArgs &&
                            extractKeyPath(directiveArgs, 
                            // If keyPath.length === 1, this code calls extractKeyPath with an
                            // empty path, which works because it uses directiveArgs as the
                            // extracted value.
                            keyPath.slice(1)));
                    }
                    // If the key started with @ but there was no corresponding directive,
                    // we want to omit this value from the key object, not fall through to
                    // treating @whatever as a normal argument name.
                    return;
                }
                if (firstChar === "$") {
                    var variableName = firstKey.slice(1);
                    if (variables && helpers/* hasOwn.call */.RI.call(variables, variableName)) {
                        var varKeyPath = keyPath.slice(0);
                        varKeyPath[0] = variableName;
                        return extractKeyPath(variables, varKeyPath);
                    }
                    // If the key started with $ but there was no corresponding variable, we
                    // want to omit this value from the key object, not fall through to
                    // treating $whatever as a normal argument name.
                    return;
                }
                if (args) {
                    return extractKeyPath(args, keyPath);
                }
            });
            var suffix = JSON.stringify(collected);
            // If no arguments were passed to this field, and it didn't have any other
            // field key contributions from directives or variables, hide the empty
            // :{} suffix from the field key. However, a field passed no arguments can
            // still end up with a non-empty :{...} suffix if its key configuration
            // refers to directives or variables.
            if (args || suffix !== "{}") {
                fieldName += ":" + suffix;
            }
            return fieldName;
        }));
}
function collectSpecifierPaths(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new mergeDeep/* DeepMerger */.w0();
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = (info.paths = []);
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,arrays/* isArray */.k)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,arrays/* isArray */.k)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,arrays/* isArray */.k)(obj) ?
            obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) {
            return extractKeyPath(value, path);
        });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/policies.js






function argsFromFieldSpecifier(spec) {
    return (spec.args !== void 0 ? spec.args
        : spec.field ? (0,storeUtils/* argumentsObjectFromField */.NC)(spec.field, spec.variables)
            : null);
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = /** @class */ (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6.__assign)({ dataIdFromObject: helpers/* defaultDataIdFromObject */.uG }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = (partialContext &&
            (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename))) ||
            object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = (partialContext && partialContext.storeObject) || object;
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, partialContext), { typename: typename, storeObject: storeObject, readField: (partialContext && partialContext.readField) ||
                function () {
                    var options = normalizeReadFieldOptions(arguments, storeObject);
                    return policies.readField(options, {
                        store: policies.cache["data"],
                        variables: options.variables,
                    });
                } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = (policy && policy.keyFn) || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, object), storeObject), context);
            if ((0,arrays/* isArray */.k)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6.__rest)(_a, ["queryType", "mutationType", "subscriptionType"]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (helpers/* hasOwn.call */.RI.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge
                    // Pass merge:true as a shorthand for a merge implementation
                    // that returns options.mergeObjects(existing, incoming).
                    : merge === true ? mergeTrueFn
                        // Pass merge:false to make incoming always replace existing
                        // without any warnings about data clobbering.
                        : merge === false ? mergeFalseFn
                            : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn =
            // Pass false to disable normalization for this typename.
            keyFields === false ? nullKeyFieldsFn
                // Pass an array of strings to use those fields to compute a
                // composite ID for objects of this typename.
                : (0,arrays/* isArray */.k)(keyFields) ? keyFieldsFnFromSpecifier(keyFields)
                    // Pass a function to take full control over identification.
                    : typeof keyFields === "function" ? keyFields
                        // Leave existing.keyFn unchanged if above cases fail.
                        : existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        // Pass false to disable argument-based differentiation of
                        // field identities.
                        keyArgs === false ? simpleKeyArgsFn
                            // Pass an array of strings to use named arguments to
                            // compute a composite identity for the field.
                            : (0,arrays/* isArray */.k)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs)
                                // Pass a function to take full control over field identity.
                                : typeof keyArgs === "function" ? keyArgs
                                    // Leave existing.keyFn unchanged if above cases fail.
                                    : existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    // If we have both a read and a merge function, assume
                    // keyArgs:false, because read and merge together can take
                    // responsibility for interpreting arguments in and out. This
                    // default assumption can always be overridden by specifying
                    // keyArgs explicitly in the FieldPolicy.
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0,globals/* invariant */.kG)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old)
                delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(helpers/* TypeOrFieldNameRegExp */.$O);
                if (!match || match[0] !== subtype) {
                    // TODO Don't interpret just any invalid typename as a RegExp.
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!helpers/* hasOwn.call */.RI.call(this.typePolicies, typename)) {
            var policy_1 = (this.typePolicies[typename] = Object.create(null));
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function (regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) {
                            fuzzySupertypes.forEach(function (supertype) {
                                return supertypes_1.add(supertype);
                            });
                        }
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) {
                supertypes_1.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6.__rest)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            // Merge the pending policies into this.typePolicies, in the order they
            // were originally passed to addTypePolicy.
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return (fieldPolicies[fieldName] ||
                (createIfMissing && (fieldPolicies[fieldName] = Object.create(null))));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, (supertypeSet = new Set()));
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(6, typename, supertype);
                        }
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    // Start checking fuzzy subtypes only after exhausting all
                    // non-fuzzy subtypes (after the final iteration of the loop).
                    i === workQueue_1.length - 1 &&
                    // We could wait to compare fragment.selectionSet to result
                    // after we verify the supertype, but this check is often less
                    // expensive than that search, and we will have to do the
                    // comparison anyway whenever we find a potential match.
                    (0,helpers/* selectionSetMatchesResult */.RC)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,arrays/* isArray */.k)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName =
                fieldSpec.field ?
                    (0,storeUtils/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                    : (0,storeUtils/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) {
            return fieldName;
        }
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName) ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                objectOrReference.__ref
                : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, read, [
                existing,
                readOptions,
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            // Instead of going to the trouble of creating a full
            // FieldFunctionOptions object and calling mergeTrueFn, we can
            // simply call mergeObjects, as mergeTrueFn would.
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            // Likewise for mergeFalseFn, whose implementation is even simpler.
            return incoming;
        }
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, 
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables,
        }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: storeUtils/* isReference */.Yk,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            // Default to objectOrReference only when no second argument was
            // passed for the from parameter, not when undefined is explicitly
            // passed as the second argument.
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!helpers/* hasOwn.call */.RI.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) {
        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(7, (0,stringifyForDisplay/* stringifyForDisplay */.v)(Array.from(readFieldArgs)));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,arrays/* isArray */.k)(existing) || (0,arrays/* isArray */.k)(incoming)) {
            throw (0,globals/* newInvariantError */._K)(8);
        }
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0,objects/* isNonNullObject */.s)(existing) && (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if ((0,storeUtils/* isReference */.Yk)(existing) && (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) && (0,storeUtils/* isReference */.Yk)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/writeToStore.js








// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, (flavored =
            context.clientOnly === clientOnly && context.deferred === deferred ?
                context
                : (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { clientOnly: clientOnly, deferred: deferred })));
    }
    return flavored;
}
var StoreWriter = /** @class */ (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0,getFromAST/* getOperationDefinition */.$H)(query);
        var merger = (0,helpers/* makeProcessedFieldsMerger */.ig)();
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)(operationDefinition)), variables);
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: (0,canonicalStringify/* canonicalStringify */.B)(variables) }, (0,helpers/* extractFragmentContext */.Is)(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map(), clientOnly: false, deferred: false, flavors: new Map() });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map() },
            context: context,
        });
        if (!(0,storeUtils/* isReference */.Yk)(ref)) {
            throw (0,globals/* newInvariantError */._K)(11, result);
        }
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0,storeUtils/* isReference */.Yk)(applied)) {
                    // Assume References returned by applyMerges have already been merged
                    // into the store. See makeMergeObjectsFunction in policies.ts for an
                    // example of how this can happen.
                    return;
                }
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[(0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)] ===
                        true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, 
        // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if ((0,storeUtils/* isReference */.Yk)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, 
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, 
                // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ?
                    getContextFlavor(context, false, false)
                    : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet &&
                    ((0,storeUtils/* isReference */.Yk)(incomingValue) || (0,helpers/* storeValueIsStoreObject */.j)(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        // TODO Check compatibility against any existing childTree.field?
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (globalThis.__DEV__ !== false &&
                !context.clientOnly &&
                !context.deferred &&
                !transform/* addTypenameToDocument.added */.Gw.added(field) &&
                // If the field has a read function, it may be a synthetic field or
                // provide a default value, so its absence from the written data should
                // not be cause for alarm.
                !policies.getReadFunction(typename, field.name.value)) {
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(12, (0,storeUtils/* resultKeyNameFromField */.u2)(field), result);
            }
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) {
                // TODO Reverse the order of the arguments?
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader &&
                this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    // Save a reference to mergeTree only if it is not empty, because
                    // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                    // reused for entirely different parts of the result tree.
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            // In development, we need to clone scalar values so that they can be
            // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
            // it's cheaper to store the scalar values directly in the cache.
            return globalThis.__DEV__ !== false ? (0,cloneDeep/* cloneDeep */.X)(value) : value;
        }
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new trie_lib/* Trie */.B(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, 
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = (0,storeUtils/* argumentsObjectFromField */.NC)(dir, context.variables);
                            // The @defer directive takes an optional args.if boolean
                            // argument, similar to @include(if: boolean). Note that
                            // @defer(if: false) does not make context.deferred false, but
                            // instead behaves as if there was no @defer directive.
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                            // TODO In the future, we may want to record args.label using
                            // context.deferred, if a label is specified.
                        }
                    });
                }
                if ((0,storeUtils/* isField */.My)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw (0,globals/* newInvariantError */._K)(13, selection.name.value);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,storeUtils/* isReference */.Yk)(incoming)) {
            var e_1 = 
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            (!(0,arrays/* isArray */.k)(incoming) &&
                // Likewise, existing must be either a Reference or a StoreObject
                // in order for its fields to be safe to merge with the fields of
                // the incoming object.
                ((0,storeUtils/* isReference */.Yk)(existing) || (0,helpers/* storeValueIsStoreObject */.j)(existing))) ?
                existing
                : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,storeUtils/* isReference */.Yk)(e_1) ? e_1.__ref : e_1];
            }
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return ((0,arrays/* isArray */.k)(from) ?
                    typeof name === "number" ?
                        from[name]
                        : void 0
                    : context.store.getFieldValue(from, String(name)));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = ((0,arrays/* isArray */.k)(i_1) ? i_1.slice(0) : (0,tslib_es6.__assign)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map() });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map()
        : left.map.size ? left.map
            : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0,storeUtils/* isReference */.Yk)(existing))
        return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0,equality_lib/* equal */.D)(existing, incoming))
        return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0,arrays/* isArray */.k)(existing) && !(0,arrays/* isArray */.k)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" && !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(14, fieldName, parentType, childTypenames.length ?
        "either ensure all objects of type " +
            childTypenames.join(" and ") +
            " have an ID or a custom merge function, or "
        : "", typeDotName, existing, incoming);
}
//# sourceMappingURL=writeToStore.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/getMemoryInternals.js
var getMemoryInternals = __webpack_require__(80892);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js


// Make builtins like Map and Set safe to use with non-extensible objects.













var InMemoryCache = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new DocumentTransform/* DocumentTransform */.A(transform/* addTypenameToDocument */.Gw);
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = reactiveVars/* makeVar */.QS;
        _this.txCount = 0;
        _this.config = (0,helpers/* normalizeConfig */.jS)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = (this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        }));
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new StoreWriter(this, (this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(this.config),
            canon: resetResultIdentities ? void 0 : (previousReader && previousReader.canon),
            fragments: fragments,
        })), fragments);
        this.maybeBroadcastWatch = (0,lib/* wrap */.re)(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize ||
                sizes/* cacheSizes.inMemoryCache.maybeBroadcastWatch */.Q["inMemoryCache.maybeBroadcastWatch"] ||
                5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
            makeCacheKey: function (c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, 
                    // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0,canonicalStringify/* canonicalStringify */.B)({ optimistic: optimistic, id: id, variables: variables }));
                }
            },
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([this.data.group, this.optimisticData.group]).forEach(function (group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return (this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null);
        }
        catch (e) {
            if (e instanceof common/* MissingFieldError */.y) {
                // Swallow MissingFieldError and return null, so callers do not need to
                // worry about catching "normal" exceptions resulting from incomplete
                // cache data. Unexpected errors will be re-thrown. If you need more
                // information about which fields were missing, use cache.diff instead,
                // and examine diffResult.missing.
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (helpers/* hasOwn.call */.RI.call(options, "id") && !options.id) {
            // To my knowledge, TypeScript does not currently provide a way to
            // enforce that an optional property?:type must *not* be undefined
            // when present. That ability would be useful here, because we want
            // options.id to default to ROOT_QUERY only when no options.id was
            // provided. If the caller attempts to pass options.id with a
            // falsy/undefined value (perhaps because cache.identify failed), we
            // should not assume the goal was to modify the ROOT_QUERY object.
            // We could throw, but it seems natural to return false to indicate
            // that nothing was modified.
            return false;
        }
        var store = ((options.optimistic) // Defaults to false.
        ) ?
            this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            // In case we previously called forgetCache(this) because
            // this.watches became empty (see below), reattach this cache to any
            // reactive variables on which it previously depended. It might seem
            // paradoxical that we're able to recall something we supposedly
            // forgot, but the point of calling forgetCache(this) is to silence
            // useless broadcasts while this.watches is empty, and to allow the
            // cache to be garbage collected. If, however, we manage to call
            // recallCache(this) here, this cache object must not have been
            // garbage collected yet, and should resume receiving updates from
            // reactive variables, now that it has a watcher to notify.
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(_this);
            }
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        var _a;
        canonicalStringify/* canonicalStringify.reset */.B.reset();
        print/* print.reset */.S.reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function (object) {
        if ((0,storeUtils/* isReference */.Yk)(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (helpers/* hasOwn.call */.RI.call(options, "id")) {
                // See comment in modify method about why we return false when
                // options.id exists but is falsy/undefined.
                return false;
            }
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify/* canonicalStringify.reset */.B.reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
            // this.broadcastWatches() triggers a broadcast to every current watcher
            // (letting them know their data is now missing). This default behavior is
            // convenient because it means the watches do not have to be manually
            // reestablished after resetting the cache. To prevent this broadcast and
            // cancel all watches, pass true for options.discardWatches.
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return (updateResult = update(_this));
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            // If an options.onWatchUpdated callback is provided, we want to call it
            // with only the Cache.WatchOptions objects affected by options.update,
            // but there might be dirty watchers already waiting to be broadcast that
            // have nothing to do with the update. To prevent including those watchers
            // in the post-update broadcast, we perform this initial broadcast to
            // collect the dirty watchers, so we can re-dirty them later, after the
            // post-update broadcast, allowing them to receive their pending
            // broadcasts the next time broadcastWatches is called, just as they would
            // if we never called cache.batch.
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === "string") {
            // Note that there can be multiple layers with the same optimistic ID.
            // When removeOptimistic(id) is called for that id, all matching layers
            // will be removed, and the remaining layers will be reapplied.
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            // Ensure both this.data and this.optimisticData refer to the root
            // (non-optimistic) layer of the cache during the update. Note that
            // this.data could be a Layer if we are currently executing an optimistic
            // update function, but otherwise will always be an EntityStore.Root
            // instance.
            perform(this.data);
        }
        else {
            // Otherwise, leave this.data and this.optimisticData unchanged and run
            // the update with broadcast batching.
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        // Since onWatchUpdated did not return false, this diff is
                        // about to be broadcast to watch.callback, so we don't need
                        // to re-dirty it with the other alreadyDirty watches below.
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            // If alreadyDirty is empty or we don't have an onWatchUpdated
            // function, we don't need to go to the trouble of wrapping
            // options.onWatchUpdated.
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null,
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.addFragmentsToDocument = function (document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function (document) {
        if (this.addTypename) {
            return this.addTypenameTransform.transformDocument(document);
        }
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                // Returning false from the onWatchUpdated callback will prevent
                // calling c.callback(diff) for this watcher.
                return;
            }
        }
        if (!lastDiff || !(0,equality_lib/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback((c.lastDiff = diff), lastDiff);
        }
    };
    return InMemoryCache;
}(cache/* ApolloCache */.R));

if (globalThis.__DEV__ !== false) {
    InMemoryCache.prototype.getMemoryInternals = getMemoryInternals/* getInMemoryCacheMemoryInternals */.q4;
}
//# sourceMappingURL=inMemoryCache.js.map

/***/ }),

/***/ 17600:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ makeVar; },
/* harmony export */   "_v": function() { return /* binding */ recallCache; },
/* harmony export */   "ab": function() { return /* binding */ cacheSlot; },
/* harmony export */   "li": function() { return /* binding */ forgetCache; }
/* harmony export */ });
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38223);

// Contextual Slot that acquires its value when custom read functions are
// called in Policies#readField.
var cacheSlot = new optimism__WEBPACK_IMPORTED_MODULE_0__/* .Slot */ .g7();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, (info = {
            vars: new Set(),
            dep: (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .dep */ .dP)(),
        }));
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
// Calling forgetCache(cache) serves to silence broadcasts and allows the
// cache to be garbage collected. However, the varsByCache WeakMap
// preserves the set of reactive variables that were previously associated
// with this cache, which makes it possible to "recall" the cache at a
// later time, by reattaching it to those variables. If the cache has been
// garbage collected in the meantime, because it is no longer reachable,
// you won't be able to call recallCache(cache), and the cache will
// automatically disappear from the varsByCache WeakMap.
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = (rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    });
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

/***/ }),

/***/ 77494:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; }
});

// UNUSED EXPORTS: mergeOptions

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(36602);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/version.js
var version = __webpack_require__(12674);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72558);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(78807);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(84776);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(11209);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canonicalStringify.js
var canonicalStringify = __webpack_require__(18099);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/DocumentTransform.js
var DocumentTransform = __webpack_require__(46945);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/asyncMap.js

// Like Observable.prototype.map, except that the mapping function can
// optionally return a Promise (or be async).
function asyncMap(observable, mapFn, catchFn) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, key) {
            return function (arg) {
                if (examiner) {
                    var both = function () {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ?
                            /* will be swallowed */ 0
                            : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) { return observer.next(result); }, function (error) { return observer.error(error); });
                }
                else {
                    observer[key](arg);
                }
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function () {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function () { return observer.complete(); });
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/errorHandling.js


function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0,arrays/* isNonEmptyArray */.O)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors) ? result.errors.slice(0) : [];
    if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(45931);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(99635);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/iteration.js
var iteration = __webpack_require__(13287);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/subclassing.js
var subclassing = __webpack_require__(21931);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var Concast = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0,iteration/* iterateObserversSafely */.p)(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return (_this.sub = obs.subscribe(_this.handlers)); }, _this.handlers.error);
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function (_) { });
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") {
            sources = [new zen_observable_ts_module/* Observable */.y(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) {
            // In case there are still any listeners in this.nextResultListeners, and
            // no error or completion has been broadcast yet, make sure those
            // observers have a chance to run and then remove themselves from
            // this.observers.
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(zen_observable_ts_module/* Observable */.y));

// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0,subclassing/* fixObservableSubclass */.D)(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js + 1 modules
var ObservableQuery = __webpack_require__(21409);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === Kind.OPERATION_DEFINITION ||
    node.kind === Kind.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === kinds/* Kind.FIELD */.h.FIELD ||
    node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD ||
    node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === Kind.VARIABLE ||
    node.kind === Kind.INT ||
    node.kind === Kind.FLOAT ||
    node.kind === Kind.STRING ||
    node.kind === Kind.BOOLEAN ||
    node.kind === Kind.NULL ||
    node.kind === Kind.ENUM ||
    node.kind === Kind.LIST ||
    node.kind === Kind.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === Kind.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === Kind.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== Kind.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === Kind.NAMED_TYPE ||
    node.kind === Kind.LIST_TYPE ||
    node.kind === Kind.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === Kind.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === Kind.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_DEFINITION ||
    node.kind === Kind.OBJECT_TYPE_DEFINITION ||
    node.kind === Kind.INTERFACE_TYPE_DEFINITION ||
    node.kind === Kind.UNION_TYPE_DEFINITION ||
    node.kind === Kind.ENUM_TYPE_DEFINITION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_EXTENSION ||
    node.kind === Kind.OBJECT_TYPE_EXTENSION ||
    node.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    node.kind === Kind.UNION_TYPE_EXTENSION ||
    node.kind === Kind.ENUM_TYPE_EXTENSION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION
  );
}

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(34529);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(18001);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/LocalState.js





var LocalState = /** @class */ (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_c) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2 /*return*/, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function (document) {
        if ((0,directives/* hasDirectives */.FS)(["client"], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function (document) {
        return (0,transform/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, 
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, variables), data.exportedVariables)); })];
                }
                return [2 /*return*/, (0,tslib_es6.__assign)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === "always" &&
                                arg.value.kind === "BooleanValue" &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,transform/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0,tslib_es6.__generator)(this, function (_b) {
                mainDefinition = (0,getFromAST/* getMainDefinition */.p$)(document);
                fragments = (0,getFromAST/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ?
                    definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2 /*return*/, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6.__generator)(this, function (_a) {
                        if (!isClientFieldDescendant &&
                            !execContext.selectionsToResolve.has(selection)) {
                            // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [2 /*return*/];
                        }
                        if (!(0,directives/* shouldInclude */.LZ)(selection, variables)) {
                            // Skip this entirely.
                            return [2 /*return*/];
                        }
                        if ((0,storeUtils/* isField */.My)(selection)) {
                            return [2 /*return*/, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,storeUtils/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,storeUtils/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            // This is a named fragment.
                            fragment = fragmentMap[selection.name.value];
                            (0,globals/* invariant */.kG)(fragment, 18, selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2 /*return*/, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2 /*return*/];
                    });
                }); };
                return [2 /*return*/, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,mergeDeep/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (!rootValue) {
                    return [2 /*return*/, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(
                            // In case the resolve function accesses reactive variables,
                            // set cacheSlot to the current cache instance.
                            reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, resolve, [
                                rootValue,
                                (0,storeUtils/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2 /*return*/, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === "export" && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === "as" && arg.value.kind === "StringValue") {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        // Handle all scalar types here.
                        if (!field.selectionSet) {
                            return result;
                        }
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) {
                            // Basically any field in a GraphQL response can be null, or missing
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === "client"; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse.
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            // This is an object, run the selection set on it.
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0,visitor/* visit */.Vn)(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === "client") {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0,globals/* invariant */.kG)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    },
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryInfo.js







var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        // @ts-expect-error this is just too generic to be typed correctly
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, 
            // The %1e15 allows the count to wrap around to 0 safely every
            // quadrillion evictions, so there's no risk of overflow. To be
            // clear, this is more of a pedantic principle than something
            // that matters in any conceivable practical scenario.
            (destructiveMethodCounts.get(cache) + 1) % 1e15);
            // @ts-expect-error this is just too generic to be typed correctly
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var QueryInfo = /** @class */ (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = (this.cache = queryManager.cache);
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.Ie.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.Ie.loading &&
            !(0,lib/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables;
        }
        if (!(0,lib/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function () {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function () {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0,lib/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff =
            diff ?
                {
                    diff: diff,
                    options: options || this.getDiffOptions(),
                }
                : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we do not tolerate partial results, skip this update to prevent it
        // from being reported. This prevents a situtuation where a query that
        // errors and another succeeds with overlapping data does not report the
        // partial data result to the errored query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff &&
            !diff.complete &&
            !((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.returnPartialData) &&
            // In the case of a cache eviction, the diff will become partial so we
            // schedule a notification to send a network request (this.oqListener) to
            // go and fetch the missing data.
            !(oldDiff && oldDiff.complete)) {
            return;
        }
        this.updateLastDiff(diff);
        if (!this.dirty && !(0,lib/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add((this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    // If this diff came from an optimistic transaction, deliver the
                    // current cache data to the ObservableQuery, but don't perform a
                    // reobservation, since oq.reobserveCacheFirst might make a network
                    // request, and we never want to trigger network requests in the
                    // middle of optimistic updates.
                    oq["observe"]();
                }
                else {
                    // Otherwise, make the ObservableQuery "reobserve" the latest data
                    // using a temporary fetch policy of "cache-first", so complete cache
                    // results have a chance to be delivered without triggering additional
                    // network requests, even when options.fetchPolicy is "network-only"
                    // or "cache-and-network". All other fetch policies are preserved by
                    // this method, and are handled by calling oq.reobserve(). If this
                    // reobservation is spurious, isDifferentFromLastResult still has a
                    // chance to catch it before delivery to ObservableQuery subscribers.
                    (0,ObservableQuery/* reobserveCacheFirst */.vj)(oq);
                }
            }));
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch || !(0,lib/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch((this.lastWatch = watchOptions));
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            // If cache.evict has been called since the last time we wrote this
            // data into the cache, there's a chance writing this result into
            // the cache will repair what was evicted.
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,lib/* equal */.D)(variables, lastWrite.variables) &&
            (0,lib/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new mergeDeep/* DeepMerger */.w0();
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(this.getDiff().result, result);
            result.data = mergedData;
            // Detect the first chunk of a deferred query and merge it with existing
            // cache data. This ensures a `cache-first` fetch policy that returns
            // partial cache data or a `cache-and-network` fetch policy that already
            // has full data in the cache does not complain when trying to merge the
            // initial deferred server data with existing cache data.
        }
        else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                // Using a transaction here so we have a chance to read the result
                // back from the cache before the watch callback fires as a result
                // of writeQuery, so we can store the new diff quietly and ignore
                // it when we receive it redundantly from the watch callback.
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        // If result is the same as the last result we received from
                        // the network (and the variables match too), avoid writing
                        // result into the cache again. The wisdom of skipping this
                        // cache write is far from obvious, since any cache write
                        // could be the one that puts the cache back into a desired
                        // state, fixing corruption or missing data. However, if we
                        // always write every network result into the cache, we enable
                        // feuds between queries competing to update the same data in
                        // incompatible ways, which can lead to an endless cycle of
                        // cache broadcasts and useless network requests. As with any
                        // feud, eventually one side must step back from the brink,
                        // letting the other side(s) have the last word(s). There may
                        // be other points where we could break this cycle, such as
                        // silencing the broadcast for cache.writeQuery (not a good
                        // idea, since it just delays the feud a bit) or somehow
                        // avoiding the network request that just happened (also bad,
                        // because the server could return useful new data). All
                        // options considered, skipping this cache write seems to be
                        // the least damaging place to break the cycle, because it
                        // reflects the intuition that we recently wrote this exact
                        // result into the cache, so the cache *should* already/still
                        // contain this data. If some other query has clobbered that
                        // data in the meantime, that's too bad, but there will be no
                        // winners if every query blindly reverts to its own version
                        // of the data. This approach also gives the network a chance
                        // to return new data, which will be written into the cache as
                        // usual, notifying only those queries that are directly
                        // affected by the cache updates, as usual. In the future, an
                        // even more sophisticated cache could perhaps prevent or
                        // mitigate the clobbering somehow, but that would make this
                        // particular cache write even less important, and thus
                        // skipping it would be even safer than it is today.
                        if (_this.lastDiff && _this.lastDiff.diff.complete) {
                            // Reuse data from the last good (complete) diff that we
                            // received, when possible.
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                        // If the previous this.diff was incomplete, fall through to
                        // re-reading the latest data with cache.diff, below.
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    // In case the QueryManager stops this QueryInfo before its
                    // results are delivered, it's important to avoid restarting the
                    // cache watch when markResult is called. We also avoid updating
                    // the watch if we are writing a result that doesn't match the current
                    // variables to avoid race conditions from broadcasting the wrong
                    // result.
                    if (!_this.stopped && (0,lib/* equal */.D)(_this.variables, options.variables)) {
                        // Any time we're about to update this.diff, we need to make
                        // sure we've started watching the cache.
                        _this.updateWatch(options.variables);
                    }
                    // If we're allowed to write to the cache, and we can read a
                    // complete result from the cache, update result.data to be the
                    // result from the cache, rather than the raw network result.
                    // Set without setDiff to avoid triggering a notify call, since
                    // we have other ways of notifying for this result.
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return (this.networkStatus = core_networkStatus/* NetworkStatus.ready */.Ie.ready);
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.Ie.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/print.js + 2 modules
var print = __webpack_require__(40122);
// EXTERNAL MODULE: ../../node_modules/@wry/trie/lib/index.js
var trie_lib = __webpack_require__(49452);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/caches.js
var caches = __webpack_require__(50734);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/sizes.js
var sizes = __webpack_require__(44245);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryManager.js















var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var IGNORE = Object.create(null);


var QueryManager = /** @class */ (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new caches/* AutoCleanedWeakCache */.s(sizes/* cacheSizes.queryManager.getDocumentInfo */.Q["queryManager.getDocumentInfo"] ||
            2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */);
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new trie_lib/* Trie */.B(false);
        var defaultDocumentTransform = new DocumentTransform/* DocumentTransform */.A(function (document) { return _this.cache.transformDocument(document); }, 
        // Allow the apollo cache to manage its own transform caches
        { cache: false });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform =
            documentTransform ?
                defaultDocumentTransform
                    .concat(documentTransform)
                    // The custom document transform may add new fragment spreads or new
                    // field selections, so we want to give the cache a chance to run
                    // again. For example, the InMemoryCache adds __typename to field
                    // selections and fragments from the fragment registry.
                    .concat(defaultDocumentTransform)
                : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0,globals/* newInvariantError */._K)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            return (0,tslib_es6.__generator)(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        (0,globals/* invariant */.kG)(mutation, 26);
                        (0,globals/* invariant */.kG)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_h.sent());
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        isOptimistic = optimisticResponse &&
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        this.broadcastQueries();
                        self = this;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { optimisticResponse: isOptimistic ? optimisticResponse : void 0 }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === "none") {
                                        throw new client_errors/* ApolloError */.cA({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6.__assign)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === "ignore" && graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof client_errors/* ApolloError */.cA ? err : (new client_errors/* ApolloError */.cA({
                                            networkError: err,
                                        })));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!(0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: "ROOT_MUTATION",
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) &&
                (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(diff.result, result);
                }
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    // Read the current query result from the store.
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        // Run our reducer using the current query result and the mutation result.
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: (document && (0,getFromAST/* getOperationName */.rY)(document)) || void 0,
                            queryVariables: variables,
                        });
                        // Write the modified result back into the store if we got a new result.
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: "ROOT_QUERY",
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            (mutation.refetchQueries || "").length > 0 ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0,incrementalResult/* isExecutionPatchResult */.M0)(result) ||
                        ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { data: diff.result });
                                if ("incremental" in result) {
                                    delete result.incremental;
                                }
                                if ("hasNext" in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: "ROOT_MUTATION",
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                // Returning a promise here makes the mutation await that promise, so we
                // include results in that promise's work if awaitRefetchQueries or an
                // onQueryUpdated function was specified.
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ?
            optimisticResponse(mutation.variables, { IGNORE: IGNORE })
            : optimisticResponse;
        if (data === IGNORE) {
            return false;
        }
        this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast
            .promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0,directives/* hasClientExports */.mj)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0,directives/* hasDirectives */.FS)(["nonreactive"], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0,transform/* removeDirectivesFromDocument */.bi)([
                    { name: "client", remove: true },
                    { name: "connection" },
                    { name: "nonreactive" },
                ], document),
                defaultVars: (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getOperationDefinition */.$H)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, document), { definitions: document.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, def), { operation: "query" });
                        }
                        return def;
                    }) }),
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { variables: this.getVariables(query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery/* ObservableQuery */.ue({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        (0,globals/* invariant */.kG)(options.query, 28);
        (0,globals/* invariant */.kG)(options.query.kind === "Document", 29);
        (0,globals/* invariant */.kG)(!options.returnPartialData, 30);
        (0,globals/* invariant */.kG)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { query: this.transform(options.query) })).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0,globals/* newInvariantError */._K)(32));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                // Set loading to true so listeners don't trigger unless they want
                // results with partial data.
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.Ie.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if ((0,storeUtils/* isDocumentNode */.JW)(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc), false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                // We will be issuing a fresh network request for this query, so we
                // pre-allocate a new query ID here, using a special prefix to enable
                // cleaning up these temporary queries later, after fetching.
                var queryId = (0,makeUniqueId/* makeUniqueId */.X)("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery/* ObservableQuery */.ue({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" && fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: "ROOT_SUBSCRIPTION",
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                var hasErrors = graphQLResultHasError(result);
                var hasProtocolErrors = (0,client_errors/* graphQLResultHasProtocolErrors */.ls)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) {
                        errors.graphQLErrors = result.errors;
                    }
                    if (hasProtocolErrors) {
                        errors.protocolErrors = result.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                    }
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) {
                        throw new client_errors/* ApolloError */.cA(errors);
                    }
                }
                if (errorPolicy === "ignore") {
                    delete result.errors;
                }
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState
                .addExportedVariables(query, variables, context)
                .then(makeObservable);
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return (sub = observable.subscribe(observer)); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, 
    // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,getFromAST/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0,print/* print */.S)(serverQuery);
                var varJson_1 = (0,canonicalStringify/* canonicalStringify */.B)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new Concast([
                        (0,execute/* execute */.h)(link, operation),
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function () {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            }
            else {
                observable = new Concast([
                    (0,execute/* execute */.h)(link, operation),
                ]);
            }
        }
        else {
            observable = new Concast([zen_observable_ts_module/* Observable.of */.y.of({ data: {} })]);
            context = this.prepareContext(context);
        }
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = (queryInfo.lastRequestId = this.generateRequestId());
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    // Throwing here effectively calls observer.error.
                    throw queryInfo.markError(new client_errors/* ApolloError */.cA({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.Ie.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.Ie.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,client_errors/* isApolloError */.MS)(networkError) ? networkError : (new client_errors/* ApolloError */.cA({ networkError: networkError }));
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function (queryId, options, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.Ie.loading; }
        if (query === void 0) { query = options.query; }
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? (defaults && defaults.fetchPolicy) || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? (defaults && defaults.errorPolicy) || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" &&
                // The "standby" policy currently returns [] from fetchQueryByPolicy, so
                // this is another way to detect when nothing was done/fetched.
                sourcesWithInfo.sources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new Concast(this.localState
                .addExportedVariables(normalized.query, normalized.variables, normalized.context)
                .then(fromVariables)
                .then(function (sourcesWithInfo) { return sourcesWithInfo.sources; }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        }
        else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new Concast(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink,
        };
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map();
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                // Since you can perform any combination of cache reads and/or writes in
                // the cache.batch update function, its optimistic option can be either
                // a boolean or a string, representing three distinct modes of
                // operation:
                //
                // * false: read/write only the root layer
                // * true: read/write the topmost layer
                // * string: read/write a fresh optimistic layer with that ID string
                //
                // When typeof optimistic === "string", a new optimistic layer will be
                // temporarily created within cache.batch with that string as its ID. If
                // we then pass that same string as the removeOptimistic option, we can
                // make cache.batch immediately remove the optimistic layer after
                // running the updateCache function, triggering only one broadcast.
                //
                // However, the refetchQueries method accepts only true or false for its
                // optimistic option (not string). We interpret true to mean a temporary
                // optimistic layer should be created, to allow efficiently rolling back
                // the effect of the updateCache function, which involves passing a
                // string instead of true as the optimistic option to cache.batch, when
                // refetchQueries receives optimistic: true.
                //
                // In other words, we are deliberately not supporting the use case of
                // writing to an *existing* optimistic layer (using the refetchQueries
                // updateCache function), since that would potentially interfere with
                // other optimistic updates in progress. Instead, you can read/write
                // only the root layer by passing optimistic: false to refetchQueries,
                // or you can read/write a brand new optimistic layer that will be
                // automatically removed by passing optimistic: true.
                optimistic: (optimistic && removeOptimistic) || false,
                // The removeOptimistic option can also be provided by itself, even if
                // optimistic === false, to remove some previously-added optimistic
                // layer safely and efficiently, like we do in markMutationResult.
                //
                // If an explicit removeOptimistic string is provided with optimistic:
                // true, the removeOptimistic string will determine the ID of the
                // temporary optimistic layer, in case that ever matters.
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo && watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            // Since we're about to handle this query now, remove it from
                            // includedQueriesById, in case it was added earlier because of
                            // options.include.
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                // The onQueryUpdated function requested the default refetching
                                // behavior by returning true.
                                result = oq.refetch();
                            }
                            // Record the result in the results Map, as long as onQueryUpdated
                            // did not return false to skip/ignore this result.
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            // Allow the default cache broadcast to happen, except when
                            // onQueryUpdated returns false.
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            // If we don't have an onQueryUpdated function, and onQueryUpdated
                            // was not disabled by passing null, make sure this query is
                            // "included" like any other options.include-specified query.
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                // If onQueryUpdated is provided, we want to use it for all included
                // queries, even the QueryOptions ones.
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset(); // Force info.getDiff() to read from cache.
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                // Otherwise, we fall back to refetching.
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            // In case no updateCache callback was provided (so cache.batch was not
            // called above, and thus did not already remove the optimistic layer),
            // remove it here. Since this is a no-op when the layer has already been
            // removed, we do it even if we called cache.batch above, since it's
            // possible this.cache is an instance of some ApolloCache subclass other
            // than InMemoryCache, and does not fully support the removeOptimistic
            // option for cache.batch.
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.Ie.loading; }
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0,lib/* equal */.D)(data, {})) {
                (0,ObservableQuery/* logMissingFieldErrors */.DC)(diff.missing);
            }
            var fromData = function (data) {
                return zen_observable_ts_module/* Observable.of */.y.of((0,tslib_es6.__assign)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true })));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) {
                return _this.localState
                    .runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                })
                    .then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" &&
                networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */
            // Watched queries must opt into overwriting existing data on refetch,
            // by passing refetchWritePolicy: "overwrite" in their WatchQueryOptions.
            : (networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch &&
                refetchWritePolicy !== "merge") ?
                1 /* CacheWriteBehavior.OVERWRITE */
                : 2 /* CacheWriteBehavior.MERGE */;
        var resultsFromLink = function () {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return {
                        fromLink: false,
                        sources: [resultsFromCache(diff, queryInfo.markReady())],
                    };
                }
                if (returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [resultsFromCache(readCache(), queryInfo.markReady())],
                };
            case "network-only":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(readCache()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "no-cache":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        // Note that queryInfo.getDiff() for no-cache queries does not call
                        // cache.diff, but instead returns a { complete: false } stub result
                        // when there is no queryInfo.diff already defined.
                        sources: [resultsFromCache(queryInfo.getDiff()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "standby":
                return { fromLink: false, sources: [] };
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.defaultContext), newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/getMemoryInternals.js
var getMemoryInternals = __webpack_require__(80892);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;
// Though mergeOptions now resides in @apollo/client/utilities, it was
// previously declared and exported from this module, and then reexported from
// @apollo/client/core. Since we need to preserve that API anyway, the easiest
// solution is to reexport mergeOptions where it was previously declared (here).



/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */
var ApolloClient = /** @class */ (function () {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) {
            throw (0,globals/* newInvariantError */._K)(15);
        }
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, 
        // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, 
        // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" &&
            !window.__APOLLO_CLIENT__ &&
            globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link =
                uri ? new HttpLink/* HttpLink */.u({ uri: uri, credentials: credentials, headers: headers }) : ApolloLink/* ApolloLink.empty */.i.empty();
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = version/* version */.i;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ?
                function () {
                    if (_this.devToolsHookCb) {
                        _this.devToolsHookCb({
                            action: {},
                            state: {
                                queries: _this.queryManager.getQueryStore(),
                                mutations: _this.queryManager.mutationStore || {},
                            },
                            dataWithOptimisticResults: _this.cache.extract(true),
                        });
                    }
                }
                : void 0,
        });
        if (connectToDevTools)
            this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function () {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] =
                windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            hasSuggestedDevtools = true;
            setTimeout(function () {
                if (typeof window !== "undefined" &&
                    window.document &&
                    window.top === window.self &&
                    !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) {
                            url =
                                "https://chrome.google.com/webstore/detail/" +
                                    "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        }
                        else if (ua.indexOf("Firefox/") > -1) {
                            url =
                                "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                        }
                    }
                    if (url) {
                        globalThis.__DEV__ !== false && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                            "experience: %s", url);
                    }
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */
        get: function () {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === "network-only" ||
                options.fetchPolicy === "cache-and-network")) {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        (0,globals/* invariant */.kG)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return (0,execute/* execute */.h)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: false,
            });
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: true,
            });
        })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function (error) {
            globalThis.__DEV__ !== false && globals/* invariant.debug */.kG.debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function () {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}());

if (globalThis.__DEV__ !== false) {
    ApolloClient.prototype.getMemoryInternals = getMemoryInternals/* getApolloClientMemoryInternals */.su;
}
//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 21409:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ue": function() { return /* binding */ ObservableQuery; },
  "DC": function() { return /* binding */ logMissingFieldErrors; },
  "vj": function() { return /* binding */ reobserveCacheFirst; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(78807);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(89732);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/iteration.js
var iteration = __webpack_require__(13287);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/subclassing.js
var subclassing = __webpack_require__(21931);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(18001);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/equalByQuery.js



// Returns true if aResult and bResult are deeply equal according to the fields
// selected by the given query, ignoring any fields marked as @nonreactive.
function equalByQuery(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0,tslib_es6.__rest)(_a, ["data"]);
    var bData = _b.data, bRest = (0,tslib_es6.__rest)(_b, ["data"]);
    return ((0,lib/* default */.Z)(aRest, bRest) &&
        equalBySelectionSet((0,getFromAST/* getMainDefinition */.p$)(query).selectionSet, aData, bData, {
            fragmentMap: (0,fragments/* createFragmentMap */.F)((0,getFromAST/* getFragmentDefinitions */.kU)(query)),
            variables: variables,
        }));
}
function equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) {
        return true;
    }
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function (selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection))
            return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
            return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if (selectionHasNonreactiveDirective(selection))
            return true;
        if ((0,storeUtils/* isField */.My)(selection)) {
            var resultKey = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) {
                // These are scalar values, so we can compare them with deep equal
                // without redoing the main recursive work.
                return (0,lib/* default */.Z)(aResultChild, bResultChild);
            }
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray)
                return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) {
                    return false;
                }
                for (var i = 0; i < length_1; ++i) {
                    if (!equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) {
                        return false;
                    }
                }
                return true;
            }
            return equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        }
        else {
            var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if (selectionHasNonreactiveDirective(fragment))
                    return true;
                return equalBySelectionSet(fragment.selectionSet, 
                // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function selectionHasNonreactiveDirective(selection) {
    return (!!selection.directives && selection.directives.some(directiveIsNonreactive));
}
function directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}
//# sourceMappingURL=equalByQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js






var ObservableQuery_assign = Object.assign, ObservableQuery_hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) {
                // Blindly catching here prevents unhandled promise rejections,
                // and is safe because the ObservableQuery handles this error with
                // this.observer.error, so we're not just swallowing the error by
                // ignoring it here.
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : (fetchPolicy) : _f;
        _this.options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { 
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy, 
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0,getFromAST/* getOperationDefinition */.$H)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function () {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function (result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */
    ObservableQuery.prototype.resetDiff = function () {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            core_networkStatus/* NetworkStatus.ready */.Ie.ready;
        var result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, lastResult), { loading: (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        skipCacheDataFor(fetchPolicy) ||
            // If this.options.query has @client(always: true) fields, we cannot
            // trust diff.result, since it was read from the cache without running
            // local resolvers (and it's too late to run resolvers now, since we must
            // return a result synchronously).
            this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) {
            // Fall through.
        }
        else if (this.waitForOwnResult) {
            // This would usually be a part of `QueryInfo.getDiff()`.
            // which we skip in the waitForOwnResult case since we are not
            // interested in the diff.
            this.queryInfo["updateWatch"]();
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,lib/* equal */.D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete &&
                    result.networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading &&
                    (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = core_networkStatus/* NetworkStatus.ready */.Ie.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (globalThis.__DEV__ !== false &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        if (!this.last) {
            return true;
        }
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ?
            !equalByQuery(this.query, this.last.result, newResult, this.variables)
            : !(0,lib/* equal */.D)(this.last.result, newResult);
        return (resultIsDifferent || (variables && !(0,lib/* equal */.D)(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,lib/* equal */.D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0,
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === "no-cache") {
            reobserveOptions.fetchPolicy = "no-cache";
        }
        else {
            reobserveOptions.fetchPolicy = "network-only";
        }
        if (globalThis.__DEV__ !== false && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0,getFromAST/* getQueryDefinition */.iW)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(
                    20,
                    variables,
                    ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef
                );
            }
        }
        if (variables && !(0,lib/* equal */.D)(this.options.variables, variables)) {
            // Update the existing options with new variables
            reobserveOptions.variables = this.options.variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.refetch */.Ie.refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (fetchMoreOptions.query ? fetchMoreOptions : ((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.options), { query: this.options.query }), fetchMoreOptions), { variables: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.options.variables), fetchMoreOptions.variables) })))), { 
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache" });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery =
            fetchMoreOptions.query ?
                this.transformDocument(this.options.query)
                : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore)
            .then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) {
                            return updateQuery(previous, {
                                fetchMoreResult: fetchMoreResult.data,
                                variables: combinedOptions.variables,
                            });
                        });
                    }
                    else {
                        // If we're using a field policy instead of updateQuery, the only
                        // thing we need to do is write the new data to the cache using
                        // combinedOptions.variables (instead of this.variables, which is
                        // what this.updateQuery uses, because it works by abusing the
                        // original field value, keyed by the original variables).
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        })
            .finally(function () {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(21, err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function (newOptions) {
        var mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        ObservableQuery_assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,lib/* equal */.D)(this.variables, variables)) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            return this.observers.size ? this.result() : Promise.resolve();
        }
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, 
    // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
                // Do nothing, leaving options.fetchPolicy unchanged.
            }
            else if (typeof options.nextFetchPolicy === "function") {
                // When someone chooses "cache-and-network" or "network-only" as their
                // initial FetchPolicy, they often do not want future cache updates to
                // trigger unconditional network requests, which is what repeatedly
                // applying the "cache-and-network" or "network-only" policies would
                // seem to imply. Instead, when the cache reports an update after the
                // initial network request, it may be desirable for subsequent network
                // requests to be triggered only if the cache result is incomplete. To
                // that end, the options.nextFetchPolicy option provides an easy way to
                // update options.fetchPolicy after the initial network request, without
                // having to call observableQuery.setOptions.
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) {
            return;
        }
        (0,globals/* invariant */.kG)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(_this.queryInfo.networkStatus) &&
                    !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) {
                    _this.reobserve({
                        // Most fetchPolicy options don't make sense to use in a polling context, as
                        // users wouldn't want to be polling the cache directly. However, network-only and
                        // no-cache are both useful for when the user wants to control whether or not the
                        // polled results are written to the cache.
                        fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ?
                            "no-cache"
                            : "network-only",
                    }, core_networkStatus/* NetworkStatus.poll */.Ie.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0,lib/* equal */.D)(variables, this.last.variables)) {
            error = void 0;
        }
        return (this.last = (0,tslib_es6.__assign)({ result: this.queryManager.assumeImmutableResults ?
                newResult
                : (0,cloneDeep/* cloneDeep */.X)(newResult), variables: variables }, (error ? { error: error } : null)));
    };
    ObservableQuery.prototype.reobserveAsConcast = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = 
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch ||
            // The fetchMore method does not actually call the reobserve method, but,
            // if it did, it would definitely use a disposable Concast.
            newNetworkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore ||
            // Polling uses a disposable Concast so the polling options (which force
            // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
            newNetworkStatus === core_networkStatus/* NetworkStatus.poll */.Ie.poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        var options = useDisposableConcast ?
            // Disposable Concast fetches receive a shallow copy of this.options
            // (merged with newOptions), leaving this.options unmodified.
            mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions &&
                newOptions.variables &&
                !(0,lib/* equal */.D)(newOptions.variables, oldVariables) &&
                // Don't mess with the fetchPolicy if it's currently "standby".
                options.fetchPolicy !== "standby" &&
                // If we're changing the fetchPolicy anyway, don't try to change it here
                // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables;
                }
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function () {
            if (_this.concast === concast) {
                _this.waitForOwnResult = false;
            }
        };
        var variables = options.variables && (0,tslib_es6.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function (result) {
                if ((0,lib/* equal */.D)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function (error) {
                if ((0,lib/* equal */.D)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            },
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus)
            .promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function () {
        this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) {
            this.updateLastResult(result, variables);
        }
        if (lastError || isDifferent) {
            (0,iteration/* iterateObserversSafely */.p)(this.observers, "next", result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: core_networkStatus/* NetworkStatus.error */.Ie.error, loading: false });
        this.updateLastResult(errorResult, variables);
        (0,iteration/* iterateObserversSafely */.p)(this.observers, "error", (this.last.error = error));
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function (document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}(zen_observable_ts_module/* Observable */.y));

// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0,subclassing/* fixObservableSubclass */.D)(ObservableQuery);
// Reobserve with fetchPolicy effectively set to "cache-first", triggering
// delivery of any new data from the cache, possibly falling back to the network
// if any cache data are missing. This allows _complete_ cache results to be
// delivered without also kicking off unnecessary network requests when
// this.options.fetchPolicy is "cache-and-network" or "network-only". When
// this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
// "standby", or "no-cache"), we call this.reobserve() as usual.
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function (currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") {
                    return this.nextFetchPolicy(currentFetchPolicy, context);
                }
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(23, error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (globalThis.__DEV__ !== false && missing) {
        globalThis.__DEV__ !== false && globals/* invariant.debug */.kG.debug(24, missing);
    }
}
function skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */) {
    return (fetchPolicy === "network-only" ||
        fetchPolicy === "no-cache" ||
        fetchPolicy === "standby");
}
//# sourceMappingURL=ObservableQuery.js.map

/***/ }),

/***/ 64368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "Jp": function() { return /* binding */ isNetworkRequestSettled; },
/* harmony export */   "Oj": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
/**
 * The current status of a query’s execution in our system.
 */
var NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
/**
 * Returns true if the network request is in ready or error state according to a given network
 * status.
 */
function isNetworkRequestSettled(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 45832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ isApolloError; },
/* harmony export */   "YG": function() { return /* binding */ PROTOCOL_ERRORS_SYMBOL; },
/* harmony export */   "cA": function() { return /* binding */ ApolloError; },
/* harmony export */   "ls": function() { return /* binding */ graphQLResultHasProtocolErrors; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45931);



// This Symbol allows us to pass transport-specific errors from the link chain
// into QueryManager/client internals without risking a naming collision within
// extensions (which implementers can use as they see fit).
var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) {
        return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function (err) {
    var errors = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError)
        errors.push(err.networkError);
    return (errors
        // The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
        .map(function (err) {
        return ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(err) && err.message) || "Error message not found.";
    })
        .join("\n"));
};
var ApolloError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 40591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApolloCache": function() { return /* reexport */ cache/* ApolloCache */.R; },
  "ApolloClient": function() { return /* reexport */ ApolloClient/* ApolloClient */.f; },
  "ApolloConsumer": function() { return /* reexport */ ApolloConsumer; },
  "ApolloError": function() { return /* reexport */ errors/* ApolloError */.cA; },
  "ApolloLink": function() { return /* reexport */ ApolloLink/* ApolloLink */.i; },
  "ApolloProvider": function() { return /* reexport */ ApolloProvider/* ApolloProvider */.e; },
  "Cache": function() { return /* reexport */ Cache; },
  "DocumentTransform": function() { return /* reexport */ DocumentTransform/* DocumentTransform */.A; },
  "DocumentType": function() { return /* reexport */ parser/* DocumentType */.n_; },
  "HttpLink": function() { return /* reexport */ HttpLink/* HttpLink */.u; },
  "InMemoryCache": function() { return /* reexport */ inMemoryCache/* InMemoryCache */.h; },
  "MissingFieldError": function() { return /* reexport */ common/* MissingFieldError */.y; },
  "NetworkStatus": function() { return /* reexport */ networkStatus/* NetworkStatus */.Ie; },
  "Observable": function() { return /* reexport */ zen_observable_ts_module/* Observable */.y; },
  "ObservableQuery": function() { return /* reexport */ ObservableQuery/* ObservableQuery */.ue; },
  "checkFetcher": function() { return /* reexport */ checkFetcher/* checkFetcher */.U; },
  "concat": function() { return /* reexport */ concat/* concat */.z; },
  "createHttpLink": function() { return /* reexport */ createHttpLink/* createHttpLink */.L; },
  "createQueryPreloader": function() { return /* reexport */ createQueryPreloader; },
  "createSignalIfSupported": function() { return /* reexport */ createSignalIfSupported; },
  "defaultDataIdFromObject": function() { return /* reexport */ helpers/* defaultDataIdFromObject */.uG; },
  "defaultPrinter": function() { return /* reexport */ selectHttpOptionsAndBody/* defaultPrinter */.sb; },
  "disableExperimentalFragmentVariables": function() { return /* reexport */ lib/* disableExperimentalFragmentVariables */.J9; },
  "disableFragmentWarnings": function() { return /* reexport */ lib/* disableFragmentWarnings */._t; },
  "empty": function() { return /* reexport */ empty; },
  "enableExperimentalFragmentVariables": function() { return /* reexport */ lib/* enableExperimentalFragmentVariables */.wO; },
  "execute": function() { return /* reexport */ execute/* execute */.h; },
  "fallbackHttpConfig": function() { return /* reexport */ selectHttpOptionsAndBody/* fallbackHttpConfig */.SC; },
  "from": function() { return /* reexport */ from; },
  "fromError": function() { return /* reexport */ fromError/* fromError */.Q; },
  "fromPromise": function() { return /* reexport */ fromPromise; },
  "getApolloContext": function() { return /* reexport */ context_ApolloContext/* getApolloContext */.K; },
  "gql": function() { return /* reexport */ lib/* gql */.Ps; },
  "isApolloError": function() { return /* reexport */ errors/* isApolloError */.MS; },
  "isNetworkRequestSettled": function() { return /* reexport */ networkStatus/* isNetworkRequestSettled */.Jp; },
  "isReference": function() { return /* reexport */ storeUtils/* isReference */.Yk; },
  "makeReference": function() { return /* reexport */ storeUtils/* makeReference */.kQ; },
  "makeVar": function() { return /* reexport */ reactiveVars/* makeVar */.QS; },
  "mergeOptions": function() { return /* reexport */ mergeOptions/* mergeOptions */.J; },
  "operationName": function() { return /* reexport */ parser/* operationName */.mw; },
  "parseAndCheckHttpResponse": function() { return /* reexport */ parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.dO; },
  "parser": function() { return /* reexport */ parser/* parser */.E2; },
  "resetApolloContext": function() { return /* reexport */ context_ApolloContext/* resetApolloContext */.Z; },
  "resetCaches": function() { return /* reexport */ lib/* resetCaches */.HW; },
  "rewriteURIForGET": function() { return /* reexport */ rewriteURIForGET/* rewriteURIForGET */.H; },
  "selectHttpOptionsAndBody": function() { return /* reexport */ selectHttpOptionsAndBody/* selectHttpOptionsAndBody */.E4; },
  "selectHttpOptionsAndBodyInternal": function() { return /* reexport */ selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve; },
  "selectURI": function() { return /* reexport */ selectURI/* selectURI */.r; },
  "serializeFetchParameter": function() { return /* reexport */ serializeFetchParameter/* serializeFetchParameter */.g; },
  "setLogVerbosity": function() { return /* reexport */ invariant/* setVerbosity */.U6; },
  "skipToken": function() { return /* reexport */ skipToken; },
  "split": function() { return /* reexport */ split; },
  "throwServerError": function() { return /* reexport */ throwServerError/* throwServerError */.P; },
  "toPromise": function() { return /* reexport */ toPromise; },
  "useApolloClient": function() { return /* reexport */ useApolloClient/* useApolloClient */.x; },
  "useBackgroundQuery": function() { return /* reexport */ useBackgroundQuery; },
  "useFragment": function() { return /* reexport */ useFragment; },
  "useLazyQuery": function() { return /* reexport */ useLazyQuery/* useLazyQuery */.t; },
  "useLoadableQuery": function() { return /* reexport */ useLoadableQuery; },
  "useMutation": function() { return /* reexport */ useMutation/* useMutation */.D; },
  "useQuery": function() { return /* reexport */ useQuery/* useQuery */.a; },
  "useQueryRefHandlers": function() { return /* reexport */ useQueryRefHandlers; },
  "useReactiveVar": function() { return /* reexport */ useReactiveVar; },
  "useReadQuery": function() { return /* reexport */ useReadQuery; },
  "useSubscription": function() { return /* reexport */ useSubscription; },
  "useSuspenseQuery": function() { return /* reexport */ useSuspenseQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js + 7 modules
var ApolloClient = __webpack_require__(77494);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js + 1 modules
var ObservableQuery = __webpack_require__(21409);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/core/types/Cache.js
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(69117);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(89552);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(19814);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(15397);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/empty.js

var empty = ApolloLink/* ApolloLink.empty */.i.empty;
//# sourceMappingURL=empty.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/from.js

var from = ApolloLink/* ApolloLink.from */.i.from;
//# sourceMappingURL=from.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/split.js

var split = ApolloLink/* ApolloLink.split */.i.split;
//# sourceMappingURL=split.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/concat.js
var concat = __webpack_require__(60380);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(36602);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/index.js








//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js + 5 modules
var parseAndCheckHttpResponse = __webpack_require__(70892);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/serializeFetchParameter.js
var serializeFetchParameter = __webpack_require__(17016);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js
var selectHttpOptionsAndBody = __webpack_require__(69069);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/checkFetcher.js
var checkFetcher = __webpack_require__(16173);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/createSignalIfSupported.js
/**
 * @deprecated
 * This is not used internally any more and will be removed in
 * the next major version of Apollo Client.
 */
var createSignalIfSupported = function () {
    if (typeof AbortController === "undefined")
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/selectURI.js
var selectURI = __webpack_require__(52550);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/createHttpLink.js + 1 modules
var createHttpLink = __webpack_require__(34578);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72558);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/rewriteURIForGET.js
var rewriteURIForGET = __webpack_require__(5729);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/index.js










//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(67163);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/toPromise.js

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(42);
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
//# sourceMappingURL=toPromise.js.map
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/fromPromise.js

function fromPromise(promise) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(46968);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/DocumentTransform.js
var DocumentTransform = __webpack_require__(46945);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(35948);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(89130);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/index.js
/* Core */







/* Link */




/* Supporting */
// The verbosity of invariant.{log,warn,error} can be controlled globally
// (for anyone using the same ts-invariant package) by passing "log",
// "warn", "error", or "silent" to setVerbosity ("log" is the default).
// Note that all invariant.* logging is hidden in production.


(0,invariant/* setVerbosity */.U6)(globalThis.__DEV__ !== false ? "log" : "silent");
// Note that importing `gql` by itself, then destructuring
// additional properties separately before exporting, is intentional.
// Due to the way the `graphql-tag` library is setup, certain bundlers
// can't find the properties added to the exported `gql` function without
// additional guidance (e.g. Rollup - see
// https://rollupjs.org/guide/en/#error-name-is-not-exported-by-module).
// Instead of having people that are using bundlers with `@apollo/client` add
// extra bundler config to help `graphql-tag` exports be found (which would be
// awkward since they aren't importing `graphql-tag` themselves), this
// workaround of pulling the extra properties off the `gql` function,
// then re-exporting them separately, helps keeps bundlers happy without any
// additional config changes.

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(55671);
// EXTERNAL MODULE: ../../node_modules/rehackt/index.js
var rehackt = __webpack_require__(38421);
var rehackt_namespaceObject = /*#__PURE__*/__webpack_require__.t(rehackt, 2);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(42370);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/context/ApolloConsumer.js



var ApolloConsumer = function (props) {
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (rehackt.createElement(ApolloContext.Consumer, null, function (context) {
        (0,globals/* invariant */.kG)(context && context.client, 44);
        return props.children(context.client);
    }));
};
//# sourceMappingURL=ApolloConsumer.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(56675);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(24432);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/index.js
var equality_lib = __webpack_require__(78807);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(87274);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useSubscription.js





/**
 * > Refer to the [Subscriptions](https://www.apollographql.com/docs/react/data/subscriptions/) section for a more in-depth overview of `useSubscription`.
 *
 * @example
 * ```jsx
 * const COMMENTS_SUBSCRIPTION = gql`
 *   subscription OnCommentAdded($repoFullName: String!) {
 *     commentAdded(repoFullName: $repoFullName) {
 *       id
 *       content
 *     }
 *   }
 * `;
 *
 * function DontReadTheComments({ repoFullName }) {
 *   const {
 *     data: { commentAdded },
 *     loading,
 *   } = useSubscription(COMMENTS_SUBSCRIPTION, { variables: { repoFullName } });
 *   return <h4>New comment: {!loading && commentAdded.content}</h4>;
 * }
 * ```
 * @remarks
 * #### Subscriptions and React 18 Automatic Batching
 *
 * With React 18's [automatic batching](https://react.dev/blog/2022/03/29/react-v18#new-feature-automatic-batching), multiple state updates may be grouped into a single re-render for better performance.
 *
 * If your subscription API sends multiple messages at the same time or in very fast succession (within fractions of a millisecond), it is likely that only the last message received in that narrow time frame will result in a re-render.
 *
 * Consider the following component:
 *
 * ```jsx
 * export function Subscriptions() {
 *   const { data, error, loading } = useSubscription(query);
 *   const [accumulatedData, setAccumulatedData] = useState([]);
 *
 *   useEffect(() => {
 *     setAccumulatedData((prev) => [...prev, data]);
 *   }, [data]);
 *
 *   return (
 *     <>
 *       {loading && <p>Loading...</p>}
 *       {JSON.stringify(accumulatedData, undefined, 2)}
 *     </>
 *   );
 * }
 * ```
 *
 * If your subscription back-end emits two messages with the same timestamp, only the last message received by Apollo Client will be rendered. This is because React 18 will batch these two state updates into a single re-render.
 *
 * Since the component above is using `useEffect` to push `data` into a piece of local state on each `Subscriptions` re-render, the first message will never be added to the `accumulatedData` array since its render was skipped.
 *
 * Instead of using `useEffect` here, we can re-write this component to use the `onData` callback function accepted in `useSubscription`'s `options` object:
 *
 * ```jsx
 * export function Subscriptions() {
 *   const [accumulatedData, setAccumulatedData] = useState([]);
 *   const { data, error, loading } = useSubscription(
 *     query,
 *     {
 *       onData({ data }) {
 *         setAccumulatedData((prev) => [...prev, data])
 *       }
 *     }
 *   );
 *
 *   return (
 *     <>
 *       {loading && <p>Loading...</p>}
 *       {JSON.stringify(accumulatedData, undefined, 2)}
 *     </>
 *   );
 * }
 * ```
 *
 * > ⚠️ **Note:** The `useSubscription` option `onData` is available in Apollo Client >= 3.7. In previous versions, the equivalent option is named `onSubscriptionData`.
 *
 * Now, the first message will be added to the `accumulatedData` array since `onData` is called _before_ the component re-renders. React 18 automatic batching is still in effect and results in a single re-render, but with `onData` we can guarantee each message received after the component mounts is added to `accumulatedData`.
 *
 * @since 3.0.0
 * @param subscription - A GraphQL subscription document parsed into an AST by `gql`.
 * @param options - Options to control how the subscription is executed.
 * @returns Query result object
 */
function useSubscription(subscription, options) {
    var hasIssuedDeprecationWarningRef = rehackt.useRef(false);
    var client = (0,useApolloClient/* useApolloClient */.x)(options === null || options === void 0 ? void 0 : options.client);
    (0,parser/* verifyDocumentType */.Vp)(subscription, parser/* DocumentType.Subscription */.n_.Subscription);
    var _a = rehackt.useState({
        loading: !(options === null || options === void 0 ? void 0 : options.skip),
        error: void 0,
        data: void 0,
        variables: options === null || options === void 0 ? void 0 : options.variables,
    }), result = _a[0], setResult = _a[1];
    if (!hasIssuedDeprecationWarningRef.current) {
        hasIssuedDeprecationWarningRef.current = true;
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionData) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(options.onData ? 52 : 53);
        }
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionComplete) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(options.onComplete ? 54 : 55);
        }
    }
    var _b = rehackt.useState(function () {
        if (options === null || options === void 0 ? void 0 : options.skip) {
            return null;
        }
        return client.subscribe({
            query: subscription,
            variables: options === null || options === void 0 ? void 0 : options.variables,
            fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
            context: options === null || options === void 0 ? void 0 : options.context,
        });
    }), observable = _b[0], setObservable = _b[1];
    var canResetObservableRef = rehackt.useRef(false);
    rehackt.useEffect(function () {
        return function () {
            canResetObservableRef.current = true;
        };
    }, []);
    var ref = rehackt.useRef({ client: client, subscription: subscription, options: options });
    rehackt.useEffect(function () {
        var _a, _b, _c, _d;
        var shouldResubscribe = options === null || options === void 0 ? void 0 : options.shouldResubscribe;
        if (typeof shouldResubscribe === "function") {
            shouldResubscribe = !!shouldResubscribe(options);
        }
        if (options === null || options === void 0 ? void 0 : options.skip) {
            if (!(options === null || options === void 0 ? void 0 : options.skip) !== !((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.skip) ||
                canResetObservableRef.current) {
                setResult({
                    loading: false,
                    data: void 0,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables,
                });
                setObservable(null);
                canResetObservableRef.current = false;
            }
        }
        else if ((shouldResubscribe !== false &&
            (client !== ref.current.client ||
                subscription !== ref.current.subscription ||
                (options === null || options === void 0 ? void 0 : options.fetchPolicy) !== ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
                !(options === null || options === void 0 ? void 0 : options.skip) !== !((_c = ref.current.options) === null || _c === void 0 ? void 0 : _c.skip) ||
                !(0,equality_lib/* equal */.D)(options === null || options === void 0 ? void 0 : options.variables, (_d = ref.current.options) === null || _d === void 0 ? void 0 : _d.variables))) ||
            canResetObservableRef.current) {
            setResult({
                loading: true,
                data: void 0,
                error: void 0,
                variables: options === null || options === void 0 ? void 0 : options.variables,
            });
            setObservable(client.subscribe({
                query: subscription,
                variables: options === null || options === void 0 ? void 0 : options.variables,
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                context: options === null || options === void 0 ? void 0 : options.context,
            }));
            canResetObservableRef.current = false;
        }
        Object.assign(ref.current, { client: client, subscription: subscription, options: options });
    }, [client, subscription, options, canResetObservableRef.current]);
    rehackt.useEffect(function () {
        if (!observable) {
            return;
        }
        var subscriptionStopped = false;
        var subscription = observable.subscribe({
            next: function (fetchResult) {
                var _a, _b;
                if (subscriptionStopped) {
                    return;
                }
                var result = {
                    loading: false,
                    // TODO: fetchResult.data can be null but SubscriptionResult.data
                    // expects TData | undefined only
                    data: fetchResult.data,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables,
                };
                setResult(result);
                if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onData) {
                    ref.current.options.onData({
                        client: client,
                        data: result,
                    });
                }
                else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionData) {
                    ref.current.options.onSubscriptionData({
                        client: client,
                        subscriptionData: result,
                    });
                }
            },
            error: function (error) {
                var _a, _b;
                if (!subscriptionStopped) {
                    setResult({
                        loading: false,
                        data: void 0,
                        error: error,
                        variables: options === null || options === void 0 ? void 0 : options.variables,
                    });
                    (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
                }
            },
            complete: function () {
                var _a, _b;
                if (!subscriptionStopped) {
                    if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onComplete) {
                        ref.current.options.onComplete();
                    }
                    else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionComplete) {
                        ref.current.options.onSubscriptionComplete();
                    }
                }
            },
        });
        return function () {
            // immediately stop receiving subscription values, but do not unsubscribe
            // until after a short delay in case another useSubscription hook is
            // reusing the same underlying observable and is about to subscribe
            subscriptionStopped = true;
            setTimeout(function () {
                subscription.unsubscribe();
            });
        };
    }, [observable]);
    return result;
}
//# sourceMappingURL=useSubscription.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useSyncExternalStore.js
var useSyncExternalStore = __webpack_require__(17520);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useReactiveVar.js


/**
 * Reads the value of a [reactive variable](https://www.apollographql.com/docs/react/local-state/reactive-variables/) and re-renders the containing component whenever that variable's value changes. This enables a reactive variable to trigger changes _without_ relying on the `useQuery` hook.
 *
 * @example
 * ```jsx
 * import { makeVar, useReactiveVar } from "@apollo/client";
 * export const cartItemsVar = makeVar([]);
 *
 * export function Cart() {
 *   const cartItems = useReactiveVar(cartItemsVar);
 *   // ...
 * }
 * ```
 * @since 3.2.0
 * @param rv - A reactive variable.
 * @returns The current value of the reactive variable.
 */
function useReactiveVar(rv) {
    return (0,useSyncExternalStore/* useSyncExternalStore */.$)(rehackt.useCallback(function (update) {
        // By reusing the same onNext function in the nested call to
        // rv.onNextChange(onNext), we can keep using the initial clean-up function
        // returned by rv.onNextChange(function onNext(v){...}), without having to
        // register the new clean-up function (returned by the nested
        // rv.onNextChange(onNext)) with yet another callback.
        return rv.onNextChange(function onNext() {
            update();
            rv.onNextChange(onNext);
        });
    }, [rv]), rv, rv);
}
//# sourceMappingURL=useReactiveVar.js.map
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(34529);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/internal/useDeepMemo.js


function useDeepMemo(memoFn, deps) {
    var ref = rehackt.useRef();
    if (!ref.current || !(0,equality_lib/* equal */.D)(ref.current.deps, deps)) {
        ref.current = { value: memoFn(), deps: deps };
    }
    return ref.current.value;
}
//# sourceMappingURL=useDeepMemo.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/internal/useLazyRef.js

var INIT = {};
function useLazyRef(getInitialValue) {
    var ref = rehackt.useRef(INIT);
    if (ref.current === INIT) {
        ref.current = getInitialValue();
    }
    return ref;
}
//# sourceMappingURL=useLazyRef.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useFragment.js







function useFragment(options) {
    var cache = (0,useApolloClient/* useApolloClient */.x)(options.client).cache;
    var diffOptions = useDeepMemo(function () {
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, rest = (0,tslib_es6.__rest)(options, ["fragment", "fragmentName", "from", "optimistic"]);
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), { returnPartialData: true, id: typeof from === "string" ? from : cache.identify(from), query: cache["getFragmentDoc"](fragment, fragmentName), optimistic: optimistic });
    }, [options]);
    var resultRef = useLazyRef(function () {
        return diffToResult(cache.diff(diffOptions));
    });
    // Used for both getSnapshot and getServerSnapshot
    var getSnapshot = rehackt.useCallback(function () { return resultRef.current; }, []);
    return (0,useSyncExternalStore/* useSyncExternalStore */.$)(rehackt.useCallback(function (forceUpdate) {
        var lastTimeout = 0;
        var unsubscribe = cache.watch((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, diffOptions), { immediate: true, callback: function (diff) {
                if (!(0,equality_lib/* equal */.D)(diff.result, resultRef.current.data)) {
                    resultRef.current = diffToResult(diff);
                    // If we get another update before we've re-rendered, bail out of
                    // the update and try again. This ensures that the relative timing
                    // between useQuery and useFragment stays roughly the same as
                    // fixed in https://github.com/apollographql/apollo-client/pull/11083
                    clearTimeout(lastTimeout);
                    lastTimeout = setTimeout(forceUpdate);
                }
            } }));
        return function () {
            unsubscribe();
            clearTimeout(lastTimeout);
        };
    }, [cache, diffOptions]), getSnapshot, getSnapshot);
}
function diffToResult(diff) {
    var result = {
        data: diff.result,
        complete: !!diff.complete,
    };
    if (diff.missing) {
        result.missing = (0,mergeDeep/* mergeDeepArray */.bw)(diff.missing.map(function (error) { return error.missing; }));
    }
    return result;
}
//# sourceMappingURL=useFragment.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/promises/decoration.js
function createFulfilledPromise(value) {
    var promise = Promise.resolve(value);
    promise.status = "fulfilled";
    promise.value = value;
    return promise;
}
function createRejectedPromise(reason) {
    var promise = Promise.reject(reason);
    // prevent potential edge cases leaking unhandled error rejections
    promise.catch(function () { });
    promise.status = "rejected";
    promise.reason = reason;
    return promise;
}
function isStatefulPromise(promise) {
    return "status" in promise;
}
function wrapPromiseWithState(promise) {
    if (isStatefulPromise(promise)) {
        return promise;
    }
    var pendingPromise = promise;
    pendingPromise.status = "pending";
    pendingPromise.then(function (value) {
        if (pendingPromise.status === "pending") {
            var fulfilledPromise = pendingPromise;
            fulfilledPromise.status = "fulfilled";
            fulfilledPromise.value = value;
        }
    }, function (reason) {
        if (pendingPromise.status === "pending") {
            var rejectedPromise = pendingPromise;
            rejectedPromise.status = "rejected";
            rejectedPromise.reason = reason;
        }
    });
    return promise;
}
//# sourceMappingURL=decoration.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/internal/__use.js


// Prevent webpack from complaining about our feature detection of the
// use property of the React namespace, which is expected not
// to exist when using current stable versions, and that's fine.
var useKey = "use";
var realHook = rehackt_namespaceObject[useKey];
// This is named with two underscores to allow this hook to evade typical rules of
// hooks (i.e. it can be used conditionally)
var __use = realHook ||
    function __use(promise) {
        var statefulPromise = wrapPromiseWithState(promise);
        switch (statefulPromise.status) {
            case "pending":
                throw statefulPromise;
            case "rejected":
                throw statefulPromise.reason;
            case "fulfilled":
                return statefulPromise.value;
        }
    };
//# sourceMappingURL=__use.js.map
// EXTERNAL MODULE: ../../node_modules/@wry/trie/lib/index.js
var trie_lib = __webpack_require__(49452);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/internal/cache/QueryReference.js




var QUERY_REFERENCE_SYMBOL = Symbol();
var PROMISE_SYMBOL = Symbol();
function wrapQueryRef(internalQueryRef) {
    var _a;
    var ref = (_a = {
            toPromise: function () {
                // We avoid resolving this promise with the query data because we want to
                // discourage using the server data directly from the queryRef. Instead,
                // the data should be accessed through `useReadQuery`. When the server
                // data is needed, its better to use `client.query()` directly.
                //
                // Here we resolve with the ref itself to make using this in React Router
                // or TanStack Router `loader` functions a bit more ergonomic e.g.
                //
                // function loader() {
                //   return { queryRef: await preloadQuery(query).toPromise() }
                // }
                return getWrappedPromise(ref).then(function () { return ref; });
            }
        },
        _a[QUERY_REFERENCE_SYMBOL] = internalQueryRef,
        _a[PROMISE_SYMBOL] = internalQueryRef.promise,
        _a);
    return ref;
}
function getWrappedPromise(queryRef) {
    var internalQueryRef = unwrapQueryRef(queryRef);
    return internalQueryRef.promise.status === "fulfilled" ?
        internalQueryRef.promise
        : queryRef[PROMISE_SYMBOL];
}
function unwrapQueryRef(queryRef) {
    return queryRef[QUERY_REFERENCE_SYMBOL];
}
function updateWrappedQueryRef(queryRef, promise) {
    queryRef[PROMISE_SYMBOL] = promise;
}
var OBSERVED_CHANGED_OPTIONS = [
    "canonizeResults",
    "context",
    "errorPolicy",
    "fetchPolicy",
    "refetchWritePolicy",
    "returnPartialData",
];
var InternalQueryReference = /** @class */ (function () {
    function InternalQueryReference(observable, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dispose = this.dispose.bind(this);
        this.observable = observable;
        if (options.onDispose) {
            this.onDispose = options.onDispose;
        }
        this.setResult();
        this.subscribeToQuery();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this queryRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function () {
            var _a;
            if (!_this.references) {
                _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
            }
        };
        // We wait until the request has settled to ensure we don't dispose of the
        // query ref before the request finishes, otherwise we would leave the
        // promise in a pending state rendering the suspense boundary indefinitely.
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    Object.defineProperty(InternalQueryReference.prototype, "disposed", {
        get: function () {
            return this.subscription.closed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalQueryReference.prototype, "watchQueryOptions", {
        get: function () {
            return this.observable.options;
        },
        enumerable: false,
        configurable: true
    });
    InternalQueryReference.prototype.reinitialize = function () {
        var observable = this.observable;
        var originalFetchPolicy = this.watchQueryOptions.fetchPolicy;
        try {
            if (originalFetchPolicy !== "no-cache") {
                observable.resetLastResults();
                observable.silentSetOptions({ fetchPolicy: "cache-first" });
            }
            else {
                observable.silentSetOptions({ fetchPolicy: "standby" });
            }
            this.subscribeToQuery();
            if (originalFetchPolicy === "no-cache") {
                return;
            }
            observable.resetDiff();
            this.setResult();
        }
        finally {
            observable.silentSetOptions({ fetchPolicy: originalFetchPolicy });
        }
    };
    InternalQueryReference.prototype.retain = function () {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function () {
            if (disposed) {
                return;
            }
            disposed = true;
            _this.references--;
            // Wait before fully disposing in case the app is running in strict mode.
            setTimeout(function () {
                if (!_this.references) {
                    _this.dispose();
                }
            });
        };
    };
    InternalQueryReference.prototype.didChangeOptions = function (watchQueryOptions) {
        var _this = this;
        return OBSERVED_CHANGED_OPTIONS.some(function (option) {
            return !(0,equality_lib/* equal */.D)(_this.watchQueryOptions[option], watchQueryOptions[option]);
        });
    };
    InternalQueryReference.prototype.applyOptions = function (watchQueryOptions) {
        var _a = this.watchQueryOptions, currentFetchPolicy = _a.fetchPolicy, currentCanonizeResults = _a.canonizeResults;
        // "standby" is used when `skip` is set to `true`. Detect when we've
        // enabled the query (i.e. `skip` is `false`) to execute a network request.
        if (currentFetchPolicy === "standby" &&
            currentFetchPolicy !== watchQueryOptions.fetchPolicy) {
            this.initiateFetch(this.observable.reobserve(watchQueryOptions));
        }
        else {
            this.observable.silentSetOptions(watchQueryOptions);
            if (currentCanonizeResults !== watchQueryOptions.canonizeResults) {
                this.result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.result), this.observable.getCurrentResult());
                this.promise = createFulfilledPromise(this.result);
            }
        }
        return this.promise;
    };
    InternalQueryReference.prototype.listen = function (listener) {
        var _this = this;
        this.listeners.add(listener);
        return function () {
            _this.listeners.delete(listener);
        };
    };
    InternalQueryReference.prototype.refetch = function (variables) {
        return this.initiateFetch(this.observable.refetch(variables));
    };
    InternalQueryReference.prototype.fetchMore = function (options) {
        return this.initiateFetch(this.observable.fetchMore(options));
    };
    InternalQueryReference.prototype.dispose = function () {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    InternalQueryReference.prototype.onDispose = function () {
        // noop. overridable by options
    };
    InternalQueryReference.prototype.handleNext = function (result) {
        var _a;
        switch (this.promise.status) {
            case "pending": {
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) {
                    result.data = this.result.data;
                }
                this.result = result;
                (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, result);
                break;
            }
            default: {
                // This occurs when switching to a result that is fully cached when this
                // class is instantiated. ObservableQuery will run reobserve when
                // subscribing, which delivers a result from the cache.
                if (result.data === this.result.data &&
                    result.networkStatus === this.result.networkStatus) {
                    return;
                }
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) {
                    result.data = this.result.data;
                }
                this.result = result;
                this.promise = createFulfilledPromise(result);
                this.deliver(this.promise);
                break;
            }
        }
    };
    InternalQueryReference.prototype.handleError = function (error) {
        var _a;
        this.subscription.unsubscribe();
        this.subscription = this.observable.resubscribeAfterError(this.handleNext, this.handleError);
        switch (this.promise.status) {
            case "pending": {
                (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, error);
                break;
            }
            default: {
                this.promise = createRejectedPromise(error);
                this.deliver(this.promise);
            }
        }
    };
    InternalQueryReference.prototype.deliver = function (promise) {
        this.listeners.forEach(function (listener) { return listener(promise); });
    };
    InternalQueryReference.prototype.initiateFetch = function (returnedPromise) {
        var _this = this;
        this.promise = this.createPendingPromise();
        this.promise.catch(function () { });
        // If the data returned from the fetch is deeply equal to the data already
        // in the cache, `handleNext` will not be triggered leaving the promise we
        // created in a pending state forever. To avoid this situtation, we attempt
        // to resolve the promise if `handleNext` hasn't been run to ensure the
        // promise is resolved correctly.
        returnedPromise
            .then(function (result) {
            var _a;
            if (_this.promise.status === "pending") {
                _this.result = result;
                (_a = _this.resolve) === null || _a === void 0 ? void 0 : _a.call(_this, result);
            }
        })
            .catch(function () { });
        return returnedPromise;
    };
    InternalQueryReference.prototype.subscribeToQuery = function () {
        var _this = this;
        this.subscription = this.observable
            .filter(function (result) { return !(0,equality_lib/* equal */.D)(result.data, {}) && !(0,equality_lib/* equal */.D)(result, _this.result); })
            .subscribe(this.handleNext, this.handleError);
    };
    InternalQueryReference.prototype.setResult = function () {
        // Don't save this result as last result to prevent delivery of last result
        // when first subscribing
        var result = this.observable.getCurrentResult(false);
        if ((0,equality_lib/* equal */.D)(result, this.result)) {
            return;
        }
        this.result = result;
        this.promise =
            (result.data &&
                (!result.partial || this.watchQueryOptions.returnPartialData)) ?
                createFulfilledPromise(result)
                : this.createPendingPromise();
    };
    InternalQueryReference.prototype.createPendingPromise = function () {
        var _this = this;
        return wrapPromiseWithState(new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    return InternalQueryReference;
}());

//# sourceMappingURL=QueryReference.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/internal/cache/SuspenseCache.js



var SuspenseCache = /** @class */ (function () {
    function SuspenseCache(options) {
        if (options === void 0) { options = Object.create(null); }
        this.queryRefs = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
        this.options = options;
    }
    SuspenseCache.prototype.getQueryRef = function (cacheKey, createObservable) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        if (!ref.current) {
            ref.current = new InternalQueryReference(createObservable(), {
                autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
                onDispose: function () {
                    delete ref.current;
                },
            });
        }
        return ref.current;
    };
    return SuspenseCache;
}());

//# sourceMappingURL=SuspenseCache.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/internal/cache/getSuspenseCache.js

var suspenseCacheSymbol = Symbol.for("apollo.suspenseCache");
function getSuspenseCache(client) {
    var _a;
    if (!client[suspenseCacheSymbol]) {
        client[suspenseCacheSymbol] = new SuspenseCache((_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense);
    }
    return client[suspenseCacheSymbol];
}
//# sourceMappingURL=getSuspenseCache.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canonicalStringify.js
var canonicalStringify = __webpack_require__(18099);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/constants.js
var skipToken = Symbol.for("apollo.skipToken");
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useSuspenseQuery.js











function useSuspenseQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    var client = (0,useApolloClient/* useApolloClient */.x)(options.client);
    var suspenseCache = getSuspenseCache(client);
    var watchQueryOptions = useWatchQueryOptions({
        client: client,
        query: query,
        options: options,
    });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var cacheKey = (0,tslib_es6.__spreadArray)([
        query,
        (0,canonicalStringify/* canonicalStringify */.B)(variables)
    ], [].concat(queryKey), true);
    var queryRef = suspenseCache.getQueryRef(cacheKey, function () {
        return client.watchQuery(watchQueryOptions);
    });
    var _b = rehackt.useState([queryRef.key, queryRef.promise]), current = _b[0], setPromise = _b[1];
    // This saves us a re-execution of the render function when a variable changed.
    if (current[0] !== queryRef.key) {
        current[0] = queryRef.key;
        current[1] = queryRef.promise;
    }
    var promise = current[1];
    if (queryRef.didChangeOptions(watchQueryOptions)) {
        current[1] = promise = queryRef.applyOptions(watchQueryOptions);
    }
    rehackt.useEffect(function () {
        var dispose = queryRef.retain();
        var removeListener = queryRef.listen(function (promise) {
            setPromise([queryRef.key, promise]);
        });
        return function () {
            removeListener();
            dispose();
        };
    }, [queryRef]);
    var skipResult = rehackt.useMemo(function () {
        var error = toApolloError(queryRef.result);
        return {
            loading: false,
            data: queryRef.result.data,
            networkStatus: error ? networkStatus/* NetworkStatus.error */.Ie.error : networkStatus/* NetworkStatus.ready */.Ie.ready,
            error: error,
        };
    }, [queryRef.result]);
    var result = fetchPolicy === "standby" ? skipResult : __use(promise);
    var fetchMore = rehackt.useCallback((function (options) {
        var promise = queryRef.fetchMore(options);
        setPromise([queryRef.key, queryRef.promise]);
        return promise;
    }), [queryRef]);
    var refetch = rehackt.useCallback(function (variables) {
        var promise = queryRef.refetch(variables);
        setPromise([queryRef.key, queryRef.promise]);
        return promise;
    }, [queryRef]);
    var subscribeToMore = rehackt.useCallback(function (options) { return queryRef.observable.subscribeToMore(options); }, [queryRef]);
    return rehackt.useMemo(function () {
        return {
            client: client,
            data: result.data,
            error: toApolloError(result),
            networkStatus: result.networkStatus,
            fetchMore: fetchMore,
            refetch: refetch,
            subscribeToMore: subscribeToMore,
        };
    }, [client, fetchMore, refetch, result, subscribeToMore]);
}
function validateOptions(options) {
    var query = options.query, fetchPolicy = options.fetchPolicy, returnPartialData = options.returnPartialData;
    (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
    validateFetchPolicy(fetchPolicy);
    validatePartialDataReturn(fetchPolicy, returnPartialData);
}
function validateFetchPolicy(fetchPolicy) {
    if (fetchPolicy === void 0) { fetchPolicy = "cache-first"; }
    var supportedFetchPolicies = [
        "cache-first",
        "network-only",
        "no-cache",
        "cache-and-network",
    ];
    (0,globals/* invariant */.kG)(supportedFetchPolicies.includes(fetchPolicy), 56, fetchPolicy);
}
function validatePartialDataReturn(fetchPolicy, returnPartialData) {
    if (fetchPolicy === "no-cache" && returnPartialData) {
        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(57);
    }
}
function toApolloError(result) {
    return (0,arrays/* isNonEmptyArray */.O)(result.errors) ?
        new errors/* ApolloError */.cA({ graphQLErrors: result.errors })
        : result.error;
}
function useWatchQueryOptions(_a) {
    var client = _a.client, query = _a.query, options = _a.options;
    return useDeepMemo(function () {
        var _a;
        if (options === skipToken) {
            return { query: query, fetchPolicy: "standby" };
        }
        var fetchPolicy = options.fetchPolicy ||
            ((_a = client.defaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            "cache-first";
        var watchQueryOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: fetchPolicy, query: query, notifyOnNetworkStatusChange: false, nextFetchPolicy: void 0 });
        if (globalThis.__DEV__ !== false) {
            validateOptions(watchQueryOptions);
        }
        // Assign the updated fetch policy after our validation since `standby` is
        // not a supported fetch policy on its own without the use of `skip`.
        if (options.skip) {
            watchQueryOptions.fetchPolicy = "standby";
        }
        return watchQueryOptions;
    }, [client, options, query]);
}
//# sourceMappingURL=useSuspenseQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useBackgroundQuery.js






function useBackgroundQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    var client = (0,useApolloClient/* useApolloClient */.x)(options.client);
    var suspenseCache = getSuspenseCache(client);
    var watchQueryOptions = useWatchQueryOptions({ client: client, query: query, options: options });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    // This ref tracks the first time query execution is enabled to determine
    // whether to return a query ref or `undefined`. When initialized
    // in a skipped state (either via `skip: true` or `skipToken`) we return
    // `undefined` for the `queryRef` until the query has been enabled. Once
    // enabled, a query ref is always returned regardless of whether the query is
    // skipped again later.
    var didFetchResult = rehackt.useRef(fetchPolicy !== "standby");
    didFetchResult.current || (didFetchResult.current = fetchPolicy !== "standby");
    var cacheKey = (0,tslib_es6.__spreadArray)([
        query,
        (0,canonicalStringify/* canonicalStringify */.B)(variables)
    ], [].concat(queryKey), true);
    var queryRef = suspenseCache.getQueryRef(cacheKey, function () {
        return client.watchQuery(watchQueryOptions);
    });
    var _b = rehackt.useState(wrapQueryRef(queryRef)), wrappedQueryRef = _b[0], setWrappedQueryRef = _b[1];
    if (unwrapQueryRef(wrappedQueryRef) !== queryRef) {
        setWrappedQueryRef(wrapQueryRef(queryRef));
    }
    if (queryRef.didChangeOptions(watchQueryOptions)) {
        var promise = queryRef.applyOptions(watchQueryOptions);
        updateWrappedQueryRef(wrappedQueryRef, promise);
    }
    var fetchMore = rehackt.useCallback(function (options) {
        var promise = queryRef.fetchMore(options);
        setWrappedQueryRef(wrapQueryRef(queryRef));
        return promise;
    }, [queryRef]);
    var refetch = rehackt.useCallback(function (variables) {
        var promise = queryRef.refetch(variables);
        setWrappedQueryRef(wrapQueryRef(queryRef));
        return promise;
    }, [queryRef]);
    return [
        didFetchResult.current ? wrappedQueryRef : void 0,
        { fetchMore: fetchMore, refetch: refetch },
    ];
}
//# sourceMappingURL=useBackgroundQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/internal/useRenderGuard.js

function getRenderDispatcher() {
    var _a, _b;
    return (_b = (_a = rehackt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _a === void 0 ? void 0 : _a.ReactCurrentDispatcher) === null || _b === void 0 ? void 0 : _b.current;
}
var RenderDispatcher = null;
/*
Relay does this too, so we hope this is safe.
https://github.com/facebook/relay/blob/8651fbca19adbfbb79af7a3bc40834d105fd7747/packages/react-relay/relay-hooks/loadQuery.js#L90-L98
*/
function useRenderGuard() {
    RenderDispatcher = getRenderDispatcher();
    return rehackt.useCallback(function () {
        return (RenderDispatcher !== null && RenderDispatcher === getRenderDispatcher());
    }, []);
}
//# sourceMappingURL=useRenderGuard.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useLoadableQuery.js








function useLoadableQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    var client = (0,useApolloClient/* useApolloClient */.x)(options.client);
    var suspenseCache = getSuspenseCache(client);
    var watchQueryOptions = useWatchQueryOptions({ client: client, query: query, options: options });
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var _b = rehackt.useState(null), queryRef = _b[0], setQueryRef = _b[1];
    var internalQueryRef = queryRef && unwrapQueryRef(queryRef);
    if (queryRef && (internalQueryRef === null || internalQueryRef === void 0 ? void 0 : internalQueryRef.didChangeOptions(watchQueryOptions))) {
        var promise = internalQueryRef.applyOptions(watchQueryOptions);
        updateWrappedQueryRef(queryRef, promise);
    }
    var calledDuringRender = useRenderGuard();
    var fetchMore = rehackt.useCallback(function (options) {
        if (!internalQueryRef) {
            throw new Error("The query has not been loaded. Please load the query.");
        }
        var promise = internalQueryRef.fetchMore(options);
        setQueryRef(wrapQueryRef(internalQueryRef));
        return promise;
    }, [internalQueryRef]);
    var refetch = rehackt.useCallback(function (options) {
        if (!internalQueryRef) {
            throw new Error("The query has not been loaded. Please load the query.");
        }
        var promise = internalQueryRef.refetch(options);
        setQueryRef(wrapQueryRef(internalQueryRef));
        return promise;
    }, [internalQueryRef]);
    var loadQuery = rehackt.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (0,globals/* invariant */.kG)(!calledDuringRender(), 50);
        var variables = args[0];
        var cacheKey = (0,tslib_es6.__spreadArray)([
            query,
            (0,canonicalStringify/* canonicalStringify */.B)(variables)
        ], [].concat(queryKey), true);
        var queryRef = suspenseCache.getQueryRef(cacheKey, function () {
            return client.watchQuery((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, watchQueryOptions), { variables: variables }));
        });
        setQueryRef(wrapQueryRef(queryRef));
    }, [query, queryKey, suspenseCache, watchQueryOptions, calledDuringRender]);
    var reset = rehackt.useCallback(function () {
        setQueryRef(null);
    }, [queryRef]);
    return [loadQuery, queryRef, { fetchMore: fetchMore, refetch: refetch, reset: reset }];
}
//# sourceMappingURL=useLoadableQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useQueryRefHandlers.js


/**
 * A React hook that returns a `refetch` and `fetchMore` function for a given
 * `queryRef`.
 *
 * This is useful to get access to handlers for a `queryRef` that was created by
 * `createQueryPreloader` or when the handlers for a `queryRef` produced in
 * a different component are inaccessible.
 *
 * @example
 * ```tsx
 * const MyComponent({ queryRef }) {
 *   const { refetch, fetchMore } = useQueryRefHandlers(queryRef);
 *
 *   // ...
 * }
 * ```
 * @since 3.9.0
 * @param queryRef - A `QueryReference` returned from `useBackgroundQuery`, `useLoadableQuery`, or `createQueryPreloader`.
 */
function useQueryRefHandlers(queryRef) {
    var _a = rehackt.useState(queryRef), previousQueryRef = _a[0], setPreviousQueryRef = _a[1];
    var _b = rehackt.useState(queryRef), wrappedQueryRef = _b[0], setWrappedQueryRef = _b[1];
    var internalQueryRef = unwrapQueryRef(queryRef);
    // To ensure we can support React transitions, this hook needs to manage the
    // queryRef state and apply React's state value immediately to the existing
    // queryRef since this hook doesn't return the queryRef directly
    if (previousQueryRef !== queryRef) {
        setPreviousQueryRef(queryRef);
        setWrappedQueryRef(queryRef);
    }
    else {
        updateWrappedQueryRef(queryRef, getWrappedPromise(wrappedQueryRef));
    }
    var refetch = rehackt.useCallback(function (variables) {
        var promise = internalQueryRef.refetch(variables);
        setWrappedQueryRef(wrapQueryRef(internalQueryRef));
        return promise;
    }, [internalQueryRef]);
    var fetchMore = rehackt.useCallback(function (options) {
        var promise = internalQueryRef.fetchMore(options);
        setWrappedQueryRef(wrapQueryRef(internalQueryRef));
        return promise;
    }, [internalQueryRef]);
    return { refetch: refetch, fetchMore: fetchMore };
}
//# sourceMappingURL=useQueryRefHandlers.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useReadQuery.js





function useReadQuery(queryRef) {
    var internalQueryRef = rehackt.useMemo(function () { return unwrapQueryRef(queryRef); }, [queryRef]);
    var getPromise = rehackt.useCallback(function () { return getWrappedPromise(queryRef); }, [queryRef]);
    if (internalQueryRef.disposed) {
        internalQueryRef.reinitialize();
        updateWrappedQueryRef(queryRef, internalQueryRef.promise);
    }
    rehackt.useEffect(function () { return internalQueryRef.retain(); }, [internalQueryRef]);
    var promise = (0,useSyncExternalStore/* useSyncExternalStore */.$)(rehackt.useCallback(function (forceUpdate) {
        return internalQueryRef.listen(function (promise) {
            updateWrappedQueryRef(queryRef, promise);
            forceUpdate();
        });
    }, [internalQueryRef]), getPromise, getPromise);
    var result = __use(promise);
    return rehackt.useMemo(function () {
        return {
            data: result.data,
            networkStatus: result.networkStatus,
            error: toApolloError(result),
        };
    }, [result]);
}
//# sourceMappingURL=useReadQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/index.js














//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/query-preloader/createQueryPreloader.js


/**
 * A higher order function that returns a `preloadQuery` function which
 * can be used to begin loading a query with the given `client`. This is useful
 * when you want to start loading a query as early as possible outside of a
 * React component.
 *
 * > Refer to the [Suspense - Initiating queries outside React](https://www.apollographql.com/docs/react/data/suspense#initiating-queries-outside-react) section for a more in-depth overview.
 *
 * @param client - The `ApolloClient` instance that will be used to load queries
 * from the returned `preloadQuery` function.
 * @returns The `preloadQuery` function.
 *
 * @example
 * ```js
 * const preloadQuery = createQueryPreloader(client);
 * ```
 * @since 3.9.0
 * @alpha
 */
function createQueryPreloader(client) {
    return function preloadQuery(query, options) {
        var _a, _b;
        if (options === void 0) { options = Object.create(null); }
        var queryRef = new InternalQueryReference(client.watchQuery((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { query: query })), {
            autoDisposeTimeoutMs: (_b = (_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense) === null || _b === void 0 ? void 0 : _b.autoDisposeTimeoutMs,
        });
        return wrapQueryRef(queryRef);
    };
}
//# sourceMappingURL=createQueryPreloader.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ApolloLink; }
});

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6.__assign)({}, starting);
    var setContext = function (next) {
        if (typeof next === "function") {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6.__assign)({}, context)); };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== "string" ?
                (0,getFromAST/* getOperationName */.rY)(transformedOperation.query) || undefined
                : "";
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context",
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw (0,globals/* newInvariantError */._K)(43, key);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js



function passthrough(op, forward) {
    return (forward ? forward(op) : zen_observable_ts_module/* Observable.of */.y.of());
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return zen_observable_ts_module/* Observable.of */.y.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        var ret;
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            ret = new ApolloLink(function (operation) {
                return test(operation) ?
                    leftLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            ret = new ApolloLink(function (operation, forward) {
                return test(operation) ?
                    leftLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        return Object.assign(ret, { left: leftLink, right: rightLink });
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts_module/* Observable.of */.y.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(35, firstLink);
            return firstLink;
        }
        var nextLink = toLink(second);
        var ret;
        if (isTerminating(nextLink)) {
            ret = new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_module/* Observable.of */.y.of(); }) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            ret = new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || zen_observable_ts_module/* Observable.of */.y.of();
                }) || zen_observable_ts_module/* Observable.of */.y.of());
            });
        }
        return Object.assign(ret, { left: firstLink, right: nextLink });
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw (0,globals/* newInvariantError */._K)(36);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 60380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ concat; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33957);

var concat = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.concat */ .i.concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ 36602:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ execute; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33957);

var execute = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.execute */ .i.execute;
//# sourceMappingURL=execute.js.map

/***/ }),

/***/ 72558:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22970);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33957);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34578);



var HttpLink = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, (0,_createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__/* .createHttpLink */ .L)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__/* .ApolloLink */ .i));

//# sourceMappingURL=HttpLink.js.map

/***/ }),

/***/ 16173:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkFetcher; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        throw (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(37);
    }
};
//# sourceMappingURL=checkFetcher.js.map

/***/ }),

/***/ 34578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ createHttpLink; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 3 modules
var globals = __webpack_require__(42140);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/serializeFetchParameter.js
var serializeFetchParameter = __webpack_require__(17016);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/selectURI.js
var selectURI = __webpack_require__(52550);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js + 5 modules
var parseAndCheckHttpResponse = __webpack_require__(70892);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/checkFetcher.js
var checkFetcher = __webpack_require__(16173);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js
var selectHttpOptionsAndBody = __webpack_require__(69069);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/rewriteURIForGET.js
var rewriteURIForGET = __webpack_require__(5729);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(67163);
// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/filterOperationVariables.js


function filterOperationVariables(variables, query) {
    var result = (0,tslib_es6.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0,visitor/* visit */.Vn)(query, {
        Variable: function (node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent &&
                parent.kind !== "VariableDefinition") {
                unusedNames.delete(node.name.value);
            }
        },
    });
    unusedNames.forEach(function (name) {
        delete result[name];
    });
    return result;
}
//# sourceMappingURL=filterOperationVariables.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(11209);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/createHttpLink.js












var backupFetch = (0,globals/* maybe */.wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, 
    // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? selectHttpOptionsAndBody/* defaultPrinter */.sb : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib_es6.__rest)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (globalThis.__DEV__ !== false) {
        // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
        // defined, so requests won't fail at runtime.
        (0,checkFetcher/* checkFetcher */.U)(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink/* ApolloLink */.i(function (operation) {
        var chosenURI = (0,selectURI/* selectURI */.r)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders["apollographql-client-name"] = name_1;
            }
            if (version) {
                clientAwarenessHeaders["apollographql-client-version"] = version;
            }
        }
        var contextHeaders = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        if ((0,directives/* hasDirectives */.FS)(["client"], operation.query)) {
            var transformedQuery = (0,transform/* removeClientSetsFromDocument */.ob)(operation.query);
            if (!transformedQuery) {
                return (0,fromError/* fromError */.Q)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            }
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0,selectHttpOptionsAndBody/* selectHttpOptionsAndBodyInternal */.ve)(operation, print, selectHttpOptionsAndBody/* fallbackHttpConfig */.SC, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            body.variables = filterOperationVariables(body.variables, operation.query);
        }
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0,getFromAST/* getMainDefinition */.p$)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0,directives/* hasDirectives */.FS)(["defer"], operation.query);
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = "GET";
        }
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) {
                globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(38);
            }
            if (isSubscription) {
                acceptHeader +=
                    "boundary=graphql;subscriptionSpec=1.0,application/json";
            }
            else if (hasDefer) {
                acceptHeader += "deferSpec=20220824,application/json";
            }
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0,rewriteURIForGET/* rewriteURIForGET */.H)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) {
                return (0,fromError/* fromError */.Q)(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = (0,serializeFetchParameter/* serializeFetchParameter */.g)(body, "Payload");
            }
            catch (parseError) {
                return (0,fromError/* fromError */.Q)(parseError);
            }
        }
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0,globals/* maybe */.wY)(function () { return fetch; }) || backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return (0,parseAndCheckHttpResponse/* readMultipartBody */.TF)(response, observerNext);
                }
                else {
                    return (0,parseAndCheckHttpResponse/* parseAndCheckHttpResponse */.dO)(operation)(response).then(observerNext);
                }
            })
                .then(function () {
                controller = undefined;
                observer.complete();
            })
                .catch(function (err) {
                controller = undefined;
                (0,parseAndCheckHttpResponse/* handleError */.S3)(err, observer);
            });
            return function () {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map

/***/ }),

/***/ 70892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S3": function() { return /* binding */ handleError; },
  "dO": function() { return /* binding */ parseAndCheckHttpResponse; },
  "TF": function() { return /* binding */ readMultipartBody; }
});

// UNUSED EXPORTS: parseHeaders, parseJsonBody

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/async.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/nodeStream.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/promise.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/reader.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/responseIterator.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */





function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(46968);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(84776);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js





var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, nextValue) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0,tslib_es6.__generator)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ?
                        contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [3 /*break*/, 3];
                    return [4 /*yield*/, iterator.next()];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while (bi > -1) {
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = parseHeaders(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 &&
                            contentType_1.toLowerCase().indexOf("application/json") === -1) {
                            throw new Error("Unsupported patch content type: application/json is required.");
                        }
                        body = message.slice(i);
                        if (body) {
                            result = parseJsonBody(response, body);
                            if (Object.keys(result).length > 1 ||
                                "data" in result ||
                                "incremental" in result ||
                                "errors" in result ||
                                "payload" in result) {
                                if ((0,incrementalResult/* isApolloPayloadResult */.yU)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        next = (0,tslib_es6.__assign)({}, result.payload);
                                    }
                                    if ("errors" in result) {
                                        next = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, next), { extensions: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ("extensions" in next ? next.extensions : null)), (_d = {}, _d[errors/* PROTOCOL_ERRORS_SYMBOL */.YG] = result.errors, _d)) });
                                    }
                                    nextValue(next);
                                }
                                else {
                                    // for the last chunk with only `hasNext: false`
                                    // we don't need to call observer.next as there is no data/errors
                                    nextValue(result);
                                }
                            }
                            else if (
                            // If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 &&
                                "hasNext" in result &&
                                !result.hasNext) {
                                return [2 /*return*/];
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        (0,throwServerError/* throwServerError */.P)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) {
        // if we don't call next, the UI can only show networkError
        // because AC didn't get any graphqlErrors this is graphql
        // execution result info (i.e errors and possibly data) this is
        // because there is no formal spec how errors should translate to
        // http status codes. So an auth error (401) could have both data
        // from a public field, errors from a private field, and a status
        // of 401
        // {
        //  user { // this will have errors
        //    firstName
        //  }
        //  products { // this is public so will have data
        //    cost
        //  }
        // }
        //
        // the result of above *could* look like this:
        // {
        //   data: { products: [{ cost: "$10" }] },
        //   errors: [{
        //      message: 'your session has timed out',
        //      path: []
        //   }]
        // }
        // status code of above would be a 401
        // in the UI you want to show data where you can, errors as data where you can
        // and use correct http status codes
        observer.next(err.result);
    }
    observer.error(err);
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                // Data error
                (0,throwServerError/* throwServerError */.P)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ?
                    operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map

/***/ }),

/***/ 5729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ rewriteURIForGET; }
/* harmony export */ });
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17016);

// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) {
        addQueryParam("query", body.query);
    }
    if (body.operationName) {
        addQueryParam("operationName", body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.variables, "Variables map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.extensions, "Extensions map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map

/***/ }),

/***/ 69069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ selectHttpOptionsAndBody; },
/* harmony export */   "SC": function() { return /* binding */ fallbackHttpConfig; },
/* harmony export */   "sb": function() { return /* binding */ defaultPrinter; },
/* harmony export */   "ve": function() { return /* binding */ selectHttpOptionsAndBodyInternal; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22970);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40122);


var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json",
};
var defaultOptions = {
    method: "POST",
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__spreadArray)([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, options), config.options), { headers: (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = printer(query, _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .print */ .S);
    return {
        options: options,
        body: body,
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name],
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map

/***/ }),

/***/ 52550:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ selectURI; }
/* harmony export */ });
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === "function") {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || "/graphql";
    }
};
//# sourceMappingURL=selectURI.js.map

/***/ }),

/***/ 17016:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ serializeFetchParameter; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map

/***/ }),

/***/ 67163:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ fromError; }
/* harmony export */ });
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12129);

function fromError(errorValue) {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map

/***/ }),

/***/ 46968:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throwServerError; }
/* harmony export */ });
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map

/***/ }),

/***/ 42370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; },
/* harmony export */   "Z": function() { return /* binding */ resetApolloContext; }
/* harmony export */ });
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38421);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43869);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42140);



// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseSymbol */ .aS ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function getApolloContext() {
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)( true, 45);
    var context = rehackt__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(rehackt__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: (context = rehackt__WEBPACK_IMPORTED_MODULE_0__.createContext({})),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
/**
 * @deprecated This function has no "resetting" effect since Apollo Client 3.4.12,
 * and will be removed in the next major version of Apollo Client.
 * If you want to get the Apollo Context, use `getApolloContext` instead.
 */
var resetApolloContext = getApolloContext;
//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 55671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ApolloProvider; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38421);
/* harmony import */ var _ApolloContext_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42370);




var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,_ApolloContext_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)();
    var parentContext = rehackt__WEBPACK_IMPORTED_MODULE_1__.useContext(ApolloContext);
    var context = rehackt__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_3__.__assign)({}, parentContext), { client: client || parentContext.client });
    }, [parentContext, client]);
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(context.client, 46);
    return (rehackt__WEBPACK_IMPORTED_MODULE_1__.createElement(ApolloContext.Provider, { value: context }, children));
};
//# sourceMappingURL=ApolloProvider.js.map

/***/ }),

/***/ 56675:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38421);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42370);



/**
 * @example
 * ```jsx
 * import { useApolloClient } from '@apollo/client';
 *
 * function SomeComponent() {
 *   const client = useApolloClient();
 *   // `client` is now set to the `ApolloClient` instance being used by the
 *   // application (that was configured using something like `ApolloProvider`)
 * }
 * ```
 *
 * @since 3.0.0
 * @returns The `ApolloClient` instance being used by the application.
 */
function useApolloClient(override) {
    var context = rehackt__WEBPACK_IMPORTED_MODULE_1__.useContext((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 49);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useLazyQuery; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38421);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58769);
/* harmony import */ var _useQuery_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24432);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56675);





// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "subscribeToMore",
];
/**
 * A hook for imperatively executing queries in an Apollo application, e.g. in response to user interaction.
 *
 * > Refer to the [Queries - Manual execution with useLazyQuery](https://www.apollographql.com/docs/react/data/queries#manual-execution-with-uselazyquery) section for a more in-depth overview of `useLazyQuery`.
 *
 * @example
 * ```jsx
 * import { gql, useLazyQuery } from "@apollo/client";
 *
 * const GET_GREETING = gql`
 *   query GetGreeting($language: String!) {
 *     greeting(language: $language) {
 *       message
 *     }
 *   }
 * `;
 *
 * function Hello() {
 *   const [loadGreeting, { called, loading, data }] = useLazyQuery(
 *     GET_GREETING,
 *     { variables: { language: "english" } }
 *   );
 *   if (called && loading) return <p>Loading ...</p>
 *   if (!called) {
 *     return <button onClick={() => loadGreeting()}>Load greeting</button>
 *   }
 *   return <h1>Hello {data.greeting.message}!</h1>;
 * }
 * ```
 * @since 3.0.0
 *
 * @param query - A GraphQL query document parsed into an AST by `gql`.
 * @param options - Default options to control how the query is executed.
 * @returns A tuple in the form of `[execute, result]`
 */
function useLazyQuery(query, options) {
    var _a;
    var execOptionsRef = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef();
    var optionsRef = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef();
    var queryRef = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef();
    var merged = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeOptions */ .J)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var internalState = (0,_useQuery_js__WEBPACK_IMPORTED_MODULE_2__/* .useInternalState */ .A)((0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__/* .useApolloClient */ .x)(options && options.client), document);
    var useQueryResult = internalState.useQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, merged), { skip: !execOptionsRef.current }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy ||
        internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = rehackt__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    internalState.forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (executeOptions) {
        execOptionsRef.current =
            executeOptions ? (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
                fetchPolicy: initialFetchPolicy,
            };
        var options = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeOptions */ .J)(optionsRef.current, (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ query: queryRef.current }, execOptionsRef.current));
        var promise = internalState
            .executeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { skip: false }))
            .then(function (queryResult) { return Object.assign(queryResult, eagerMethods); });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function () { });
        return promise;
    }, []);
    return [execute, result];
}
//# sourceMappingURL=useLazyQuery.js.map

/***/ }),

/***/ 33379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38421);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58769);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78807);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87274);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45832);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56675);







/**
 *
 *
 * > Refer to the [Mutations](https://www.apollographql.com/docs/react/data/mutations/) section for a more in-depth overview of `useMutation`.
 *
 * @example
 * ```jsx
 * import { gql, useMutation } from '@apollo/client';
 *
 * const ADD_TODO = gql`
 *   mutation AddTodo($type: String!) {
 *     addTodo(type: $type) {
 *       id
 *       type
 *     }
 *   }
 * `;
 *
 * function AddTodo() {
 *   let input;
 *   const [addTodo, { data }] = useMutation(ADD_TODO);
 *
 *   return (
 *     <div>
 *       <form
 *         onSubmit={e => {
 *           e.preventDefault();
 *           addTodo({ variables: { type: input.value } });
 *           input.value = '';
 *         }}
 *       >
 *         <input
 *           ref={node => {
 *             input = node;
 *           }}
 *         />
 *         <button type="submit">Add Todo</button>
 *       </form>
 *     </div>
 *   );
 * }
 * ```
 * @since 3.0.0
 * @param mutation - A GraphQL mutation document parsed into an AST by `gql`.
 * @param options - Options to control how the mutation is executed.
 * @returns A tuple in the form of `[mutate, result]`
 */
function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = rehackt__WEBPACK_IMPORTED_MODULE_0__.useState({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    // TODO: Trying to assign these in a useEffect or useLayoutEffect breaks
    // higher-order components.
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading &&
            !baseOptions.ignoreResults &&
            ref.current.isMounted) {
            setResult((ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            }));
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client
            .mutate(clientOptions)
            .then(function (response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ?
                new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .cA({ graphQLErrors: errors })
                : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) {
                onError(error, clientOptions);
            }
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult((ref.current.result = result_1));
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            }
            return response;
        })
            .catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult((ref.current.result = result_2));
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
        if (ref.current.isMounted) {
            var result_3 = { called: false, loading: false, client: client };
            Object.assign(ref.current, { mutationId: 0, result: result_3 });
            setResult(result_3);
        }
    }, []);
    rehackt__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 24432:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useInternalState; },
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22970);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38421);
/* harmony import */ var _useSyncExternalStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17520);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78807);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58769);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42370);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45832);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64368);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87274);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56675);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23180);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43869);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9428);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43056);












var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * A hook for executing queries in an Apollo application.
 *
 * To run a query within a React component, call `useQuery` and pass it a GraphQL query document.
 *
 * When your component renders, `useQuery` returns an object from Apollo Client that contains `loading`, `error`, and `data` properties you can use to render your UI.
 *
 * > Refer to the [Queries](https://www.apollographql.com/docs/react/data/queries) section for a more in-depth overview of `useQuery`.
 *
 * @example
 * ```jsx
 * import { gql, useQuery } from '@apollo/client';
 *
 * const GET_GREETING = gql`
 *   query GetGreeting($language: String!) {
 *     greeting(language: $language) {
 *       message
 *     }
 *   }
 * `;
 *
 * function Hello() {
 *   const { loading, error, data } = useQuery(GET_GREETING, {
 *     variables: { language: 'english' },
 *   });
 *   if (loading) return <p>Loading ...</p>;
 *   return <h1>Hello {data.greeting.message}!</h1>;
 * }
 * ```
 * @since 3.0.0
 * @param query - A GraphQL query document parsed into an AST by `gql`.
 * @param options - Options to control how the query is executed.
 * @returns Query result object
 */
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_3__/* .useApolloClient */ .x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = rehackt__WEBPACK_IMPORTED_MODULE_1__.useRef();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = rehackt__WEBPACK_IMPORTED_MODULE_1__.useReducer(function (tick) { return tick + 1; }, 0)[1];
    return state;
}
var InternalState = /** @class */ (function () {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */
        this.forceUpdate = function () { return _this.forceUpdateState(); };
        this.ssrDisabledResult = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .maybeDeepFreeze */ .J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: _core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .NetworkStatus.loading */ .Ie.loading,
        });
        this.skipStandbyResult = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .maybeDeepFreeze */ .J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: _core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .NetworkStatus.ready */ .Ie.ready,
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .canUseWeakMap */ .mr ? WeakMap : Map)();
        (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_7__/* .verifyDocumentType */ .Vp)(query, _parser_index_js__WEBPACK_IMPORTED_MODULE_7__/* .DocumentType.Query */ .n_.Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */
    InternalState.prototype.forceUpdateState = function () {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn(51);
    };
    InternalState.prototype.executeQuery = function (options) {
        var _this = this;
        var _a;
        if (options.query) {
            Object.assign(this, { query: options.query });
        }
        this.watchQueryOptions = this.createWatchQueryOptions((this.queryHookOptions = options));
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function (resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function (value) {
                    result = value;
                },
                error: function () {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function () {
                    resolve(_this.toQueryResult(result));
                },
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = rehackt__WEBPACK_IMPORTED_MODULE_1__.useContext((0,_context_index_js__WEBPACK_IMPORTED_MODULE_8__/* .getApolloContext */ .K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0,_useSyncExternalStore_js__WEBPACK_IMPORTED_MODULE_9__/* .useSyncExternalStore */ .$)(rehackt__WEBPACK_IMPORTED_MODULE_1__.useCallback(function (handleStoreChange) {
            if (_this.renderPromises) {
                return function () { };
            }
            _this.forceUpdate = handleStoreChange;
            var onNext = function () {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,_wry_equality__WEBPACK_IMPORTED_MODULE_2__/* .equal */ .D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!hasOwnProperty.call(error, "graphQLErrors")) {
                    // The error is not a GraphQL error
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_2__/* .equal */ .D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: _core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .NetworkStatus.error */ .Ie.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function () {
                setTimeout(function () { return subscription.unsubscribe(); });
                _this.forceUpdate = function () { return _this.forceUpdateState(); };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions((this.queryHookOptions = options));
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_2__/* .equal */ .D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted =
            options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            // If SSR has been explicitly disabled, and this function has been called
            // on the server side, return the default loading state.
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === "standby") {
            // When skipping a query (ie. we're not querying for data but still want to
            // render children), make sure the `data` is cleared out and `loading` is
            // set to `false` (since we aren't loading anything).
            //
            // NOTE: We no longer think this is the correct behavior. Skipping should
            // not automatically set `data` to `undefined`, but instead leave the
            // previous data in place. In other words, skipping should not mandate that
            // previously received data is all of a sudden removed. Unfortunately,
            // changing this is breaking, so we'll have to wait until Apollo Client 4.0
            // to address this.
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_10__/* .compact */ .o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(_utilities_index_js__WEBPACK_IMPORTED_MODULE_11__/* .mergeOptions */ .J);
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, 
        // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_12__.__rest)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === "network-only" ||
                watchQueryOptions.fetchPolicy === "cache-and-network")) {
            // this behavior was added to react-apollo without explanation in this PR
            // https://github.com/apollographql/react-apollo/pull/1579
            watchQueryOptions.fetchPolicy = "cache-first";
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby",
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = (this.observable =
            (this.renderPromises &&
                this.renderPromises.getSSRObservable(this.watchQueryOptions)) ||
                this.observable || // Reuse this.observable if possible (and not SSR)
                this.client.watchQuery(this.getObsQueryOptions()));
        this.obsQueryFields = rehackt__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                // TODO: This is a legacy API which could probably be cleaned up
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve()
                .then(function () {
                if (error_1) {
                    _this.onError(error_1);
                }
                else if (result.data &&
                    (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus &&
                    result.networkStatus === _core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .NetworkStatus.ready */ .Ie.ready) {
                    _this.onCompleted(result.data);
                }
            })
                .catch(function (error) {
                globalThis.__DEV__ !== false && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function (result) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_13__/* .isNonEmptyArray */ .O)(result.errors) ?
            new _errors_index_js__WEBPACK_IMPORTED_MODULE_14__/* .ApolloError */ .cA({ graphQLErrors: result.errors })
            : result.error;
    };
    InternalState.prototype.getCurrentResult = function () {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) {
            this.handleErrorOrCompleted((this.result = this.observable.getCurrentResult()));
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib__WEBPACK_IMPORTED_MODULE_12__.__rest)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, (queryResult = (0,tslib__WEBPACK_IMPORTED_MODULE_12__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_12__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_12__.__assign)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })));
        if (!queryResult.error && (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_13__/* .isNonEmptyArray */ .O)(result.errors)) {
            // Until a set naming convention for networkError and graphQLErrors is
            // decided upon, we map errors (graphQLErrors) to the error options.
            // TODO: Is it possible for both result.error and result.errors to be
            // defined here?
            queryResult.error = new _errors_index_js__WEBPACK_IMPORTED_MODULE_14__/* .ApolloError */ .cA({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: _core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .NetworkStatus.refetch */ .Ie.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 17520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
var rehackt__WEBPACK_IMPORTED_MODULE_1___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38421);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43869);



var didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var uSESKey = "useSyncExternalStore";
var realHook = /*#__PURE__*/ (rehackt__WEBPACK_IMPORTED_MODULE_1___namespace_cache || (rehackt__WEBPACK_IMPORTED_MODULE_1___namespace_cache = __webpack_require__.t(rehackt__WEBPACK_IMPORTED_MODULE_1__, 2)))[uSESKey];
// Adapted from https://www.npmjs.com/package/use-sync-external-store, with
// Apollo Client deviations called out by "// DEVIATION ..." comments.
// When/if React.useSyncExternalStore is defined, delegate fully to it.
var useSyncExternalStore = realHook ||
    (function (subscribe, getSnapshot, getServerSnapshot) {
        // Read the current snapshot from the store on every render. Again, this
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (
        // DEVIATION: Using __DEV__
        globalThis.__DEV__ !== false &&
            !didWarnUncachedGetSnapshot &&
            // DEVIATION: Not using Object.is because we know our snapshots will never
            // be exotic primitive values like NaN, which is !== itself.
            value !== getSnapshot()) {
            didWarnUncachedGetSnapshot = true;
            // DEVIATION: Using invariant.error instead of console.error directly.
            globalThis.__DEV__ !== false && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error(58);
        }
        // Because updates are synchronous, we don't queue them. Instead we force a
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _a = rehackt__WEBPACK_IMPORTED_MODULE_1__.useState({
            inst: { value: value, getSnapshot: getSnapshot },
        }), inst = _a[0].inst, forceUpdate = _a[1];
        // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        if (_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseLayoutEffect */ .JC) {
            // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
            // which may seem like a conditional hook, but this code ends up behaving
            // unconditionally (one way or the other) because canUseLayoutEffect is
            // constant.
            rehackt__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(function () {
                Object.assign(inst, { value: value, getSnapshot: getSnapshot });
                // Whenever getSnapshot or subscribe changes, we need to check in the
                // commit phase if there was an interleaved mutation. In concurrent mode
                // this can happen all the time, but even in synchronous mode, an earlier
                // effect may have mutated the store.
                if (checkIfSnapshotChanged(inst)) {
                    // Force a re-render.
                    forceUpdate({ inst: inst });
                }
            }, [subscribe, value, getSnapshot]);
        }
        else {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
        }
        rehackt__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) {
                // Force a re-render.
                forceUpdate({ inst: inst });
            }
            // Subscribe to the store and return a clean-up function.
            return subscribe(function handleStoreChange() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) {
                    // Force a re-render.
                    forceUpdate({ inst: inst });
                }
            });
        }, [subscribe]);
        return value;
    });
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map

/***/ }),

/***/ 87274:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ parser; },
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "mw": function() { return /* binding */ operationName; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50734);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44245);
/* harmony import */ var _utilities_caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80892);



var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache;
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = "Query";
            break;
        case DocumentType.Mutation:
            name = "Mutation";
            break;
        case DocumentType.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
// This parser is mostly used to safety check incoming documents.
function parser(document) {
    if (!cache) {
        cache = new _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .AutoCleanedWeakCache */ .s(_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .cacheSizes.parser */ .Q.parser || 1000 /* defaultCacheSizes.parser */);
    }
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") {
            switch (x.operation) {
                case "query":
                    queries.push(x);
                    break;
                case "mutation":
                    mutations.push(x);
                    break;
                case "subscription":
                    subscriptions.push(x);
                    break;
            }
        }
    }
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        queries.length ||
        mutations.length ||
        subscriptions.length, 60);
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(
        queries.length + mutations.length + subscriptions.length <= 1,
        61,
        document,
        queries.length,
        subscriptions.length,
        mutations.length
    );
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length ? queries
        : mutations.length ? mutations
            : subscriptions;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") {
        name = definition.name.value;
    }
    else {
        name = "data"; // fallback to using data if no name
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
parser.resetCache = function () {
    cache = undefined;
};
if (globalThis.__DEV__ !== false) {
    (0,_utilities_caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_3__/* .registerGlobalCache */ .zP)("parser", function () { return (cache ? cache.size : 0); });
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(
        operation.type === type,
        63,
        requiredOperationName,
        requiredOperationName,
        usedOperationName
    );
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 50734:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AutoCleanedStrongCache; },
/* harmony export */   "s": function() { return /* binding */ AutoCleanedWeakCache; }
/* harmony export */ });
/* harmony import */ var _wry_caches__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61114);
/* harmony import */ var _wry_caches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4820);

var scheduledCleanup = new WeakSet();
function schedule(cache) {
    if (!scheduledCleanup.has(cache)) {
        scheduledCleanup.add(cache);
        setTimeout(function () {
            cache.clean();
            scheduledCleanup.delete(cache);
        }, 100);
    }
}
/**
 * @internal
 * A version of WeakCache that will auto-schedule a cleanup of the cache when
 * a new item is added.
 * Throttled to once per 100ms.
 *
 * @privateRemarks
 * Should be used throughout the rest of the codebase instead of WeakCache,
 * with the notable exception of usage in `wrap` from `optimism` - that one
 * already handles cleanup and should remain a `WeakCache`.
 */
var AutoCleanedWeakCache = function (max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    var cache = new _wry_caches__WEBPACK_IMPORTED_MODULE_0__/* .WeakCache */ .k(max, dispose);
    cache.set = function (key, value) {
        schedule(this);
        return _wry_caches__WEBPACK_IMPORTED_MODULE_0__/* .WeakCache.prototype.set.call */ .k.prototype.set.call(this, key, value);
    };
    return cache;
};
/**
 * @internal
 * A version of StrongCache that will auto-schedule a cleanup of the cache when
 * a new item is added.
 * Throttled to once per 100ms.
 *
 * @privateRemarks
 * Should be used throughout the rest of the codebase instead of StrongCache,
 * with the notable exception of usage in `wrap` from `optimism` - that one
 * already handles cleanup and should remain a `StrongCache`.
 */
var AutoCleanedStrongCache = function (max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    var cache = new _wry_caches__WEBPACK_IMPORTED_MODULE_1__/* .StrongCache */ .e(max, dispose);
    cache.set = function (key, value) {
        schedule(this);
        return _wry_caches__WEBPACK_IMPORTED_MODULE_1__/* .StrongCache.prototype.set.call */ .e.prototype.set.call(this, key, value);
    };
    return cache;
};
//# sourceMappingURL=caches.js.map

/***/ }),

/***/ 80892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kb": function() { return /* binding */ getApolloCacheMemoryInternals; },
/* harmony export */   "q4": function() { return /* binding */ getInMemoryCacheMemoryInternals; },
/* harmony export */   "su": function() { return /* binding */ getApolloClientMemoryInternals; },
/* harmony export */   "zP": function() { return /* binding */ registerGlobalCache; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _sizes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44245);


var globalCaches = {};
function registerGlobalCache(name, getSize) {
    globalCaches[name] = getSize;
}
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getApolloClientMemoryInternals = globalThis.__DEV__ !== false ?
    _getApolloClientMemoryInternals
    : undefined;
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getInMemoryCacheMemoryInternals = globalThis.__DEV__ !== false ?
    _getInMemoryCacheMemoryInternals
    : undefined;
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getApolloCacheMemoryInternals = globalThis.__DEV__ !== false ?
    _getApolloCacheMemoryInternals
    : undefined;
function getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */,
        print: 2000 /* defaultCacheSizes["print"] */,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
    };
    return Object.fromEntries(Object.entries(defaults).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            _sizes_js__WEBPACK_IMPORTED_MODULE_0__/* .cacheSizes */ .Q[k] || v,
        ];
    }));
}
function _getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false))
        throw new Error("only supported in development mode");
    return {
        limits: getCurrentCacheSizes(),
        sizes: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ print: (_a = globalCaches.print) === null || _a === void 0 ? void 0 : _a.call(globalCaches), parser: (_b = globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call(globalCaches), canonicalStringify: (_c = globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call(globalCaches), links: linkInfo(this.link), queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: transformInfo(this["queryManager"].documentTransform),
            } }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d)),
    };
}
function _getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: getWrapperInformation(this["getFragmentDoc"]),
        },
    };
}
function _getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, _getApolloCacheMemoryInternals.apply(this)), { addTypenameDocumentTransform: transformInfo(this["addTypenameTransform"]), inMemoryCache: {
            executeSelectionSet: getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: getWrapperInformation(this["maybeBroadcastWatch"]),
        }, fragmentRegistry: {
            findFragmentSpreads: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform),
        } });
}
function isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function getWrapperInformation(f) {
    return isWrapper(f) ? f.size : undefined;
}
function isDefined(value) {
    return value != null;
}
function transformInfo(transform) {
    return recurseTransformInfo(transform).map(function (cache) { return ({ cache: cache }); });
}
function recurseTransformInfo(transform) {
    return transform ?
        (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([
            getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
        ], recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter(isDefined)
        : [];
}
function linkInfo(link) {
    var _a;
    return link ?
        (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([
            (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
        ], linkInfo(link === null || link === void 0 ? void 0 : link.left), true), linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter(isDefined)
        : [];
}
//# sourceMappingURL=getMemoryInternals.js.map

/***/ }),

/***/ 44245:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ cacheSizes; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);


var cacheSizeSymbol = Symbol.for("apollo.cacheSize");
/**
 *
 * The global cache size configuration for Apollo Client.
 *
 * @remarks
 *
 * You can directly modify this object, but any modification will
 * only have an effect on caches that are created after the modification.
 *
 * So for global caches, such as `parser`, `canonicalStringify` and `print`,
 * you might need to call `.reset` on them, which will essentially re-create them.
 *
 * Alternatively, you can set `globalThis[Symbol.for("apollo.cacheSize")]` before
 * you load the Apollo Client package:
 *
 * @example
 * ```ts
 * globalThis[Symbol.for("apollo.cacheSize")] = {
 *   parser: 100
 * } satisfies Partial<CacheSizes> // the `satisfies` is optional if using TypeScript
 * ```
 */
var cacheSizes = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .global */ .CO[cacheSizeSymbol]);
//# sourceMappingURL=sizes.js.map

/***/ }),

/***/ 43056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
// A version of Array.isArray that works better with readonly arrays.
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 43869:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);

var canUseWeakMap = typeof WeakMap === "function" &&
    !(0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product == "ReactNative" && !global.HermesInternal; });
var canUseWeakSet = typeof WeakSet === "function";
var canUseSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = 
// Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
// Our tests should all continue to pass if we remove this !usingJSDOM
// condition, thereby allowing useLayoutEffect when using jsdom. Unfortunately,
// if we allow useLayoutEffect, then useSyncExternalStore generates many
// warnings about useLayoutEffect doing nothing on the server. While these
// warnings are harmless, this !usingJSDOM condition seems to be the best way to
// prevent them (i.e. skipping useLayoutEffect when using jsdom).
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 18099:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ canonicalStringify; }
/* harmony export */ });
/* harmony import */ var _utilities_caching_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50734);
/* harmony import */ var _utilities_caching_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44245);
/* harmony import */ var _caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80892);


/**
 * Like JSON.stringify, but with object keys always sorted in the same order.
 *
 * To achieve performant sorting, this function uses a Map from JSON-serialized
 * arrays of keys (in any order) to sorted arrays of the same keys, with a
 * single sorted array reference shared by all permutations of the keys.
 *
 * As a drawback, this function will add a little bit more memory for every
 * object encountered that has different (more, less, a different order of) keys
 * than in the past.
 *
 * In a typical application, this extra memory usage should not play a
 * significant role, as `canonicalStringify` will be called for only a limited
 * number of object shapes, and the cache will not grow beyond a certain point.
 * But in some edge cases, this could be a problem, so we provide
 * canonicalStringify.reset() as a way of clearing the cache.
 * */
var canonicalStringify = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, stableObjectReplacer);
}, {
    reset: function () {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        sortingMap = new _utilities_caching_index_js__WEBPACK_IMPORTED_MODULE_0__/* .AutoCleanedStrongCache */ .L(_utilities_caching_index_js__WEBPACK_IMPORTED_MODULE_1__/* .cacheSizes.canonicalStringify */ .Q.canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */);
    },
});
if (globalThis.__DEV__ !== false) {
    (0,_caching_getMemoryInternals_js__WEBPACK_IMPORTED_MODULE_2__/* .registerGlobalCache */ .zP)("canonicalStringify", function () { return sortingMap.size; });
}
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var sortingMap;
canonicalStringify.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every(everyKeyInOrder))
                return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = sortingMap.get(sortedKey) || keys;
                sortingMap.set(unsortedKey, sortedKeys);
                sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function (key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
//# sourceMappingURL=canonicalStringify.js.map

/***/ }),

/***/ 89732:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ cloneDeep; }
/* harmony export */ });
var toString = Object.prototype.toString;
/**
 * Deeply clones a value to create a new instance.
 */
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 84776:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ isExecutionPatchIncrementalResult; },
/* harmony export */   "M0": function() { return /* binding */ isExecutionPatchResult; },
/* harmony export */   "mT": function() { return /* binding */ mergeIncrementalData; },
/* harmony export */   "yU": function() { return /* binding */ isApolloPayloadResult; }
/* harmony export */ });
/* unused harmony export isExecutionPatchInitialResult */
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45931);
/* harmony import */ var _arrays_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43056);
/* harmony import */ var _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34529);



function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
// This function detects an Apollo payload result before it is transformed
// into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
// once it leaves the link chain.
function isApolloPayloadResult(value) {
    return (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__/* .DeepMerger */ .w0();
    if (isExecutionPatchIncrementalResult(result) &&
        (0,_arrays_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonEmptyArray */ .O)(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}
//# sourceMappingURL=incrementalResult.js.map

/***/ }),

/***/ 99635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeUniqueId; }
/* harmony export */ });
var prefixCounts = new Map();
// These IDs won't be globally unique, but they will be unique within this
// process, thanks to the counter, and unguessable thanks to the random suffix.
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map

/***/ }),

/***/ 23180:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45931);

function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
            // they all throw a TypeError when you try, so we re-throw any exceptions
            // that are not TypeErrors, since that would be unexpected.
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (globalThis.__DEV__ !== false) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 34529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ mergeDeep; },
/* harmony export */   "bw": function() { return /* binding */ mergeDeepArray; },
/* harmony export */   "w0": function() { return /* binding */ DeepMerger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45931);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
// In almost any situation where you could succeed in getting the
// TypeScript compiler to infer a tuple type for the sources array, you
// could just use mergeDeep instead of mergeDeepArray, so instead of
// trying to convert T[] to an intersection type we just infer the array
// element type, which works perfectly when the sources array has a
// consistent element type.
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = /** @class */ (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = _objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(source) && (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([target,
                            source,
                            sourceKey], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map

/***/ }),

/***/ 58769:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9428);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, (defaults && defaults.variables)), options.variables)),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 45931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
/* unused harmony export isPlainObject */
function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
function isPlainObject(obj) {
    return (obj !== null &&
        typeof obj === "object" &&
        (Object.getPrototypeOf(obj) === Object.prototype ||
            Object.getPrototypeOf(obj) === null));
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 63118:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ stringifyForDisplay; }
/* harmony export */ });
/* harmony import */ var _makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99635);

function stringifyForDisplay(value, space) {
    if (space === void 0) { space = 0; }
    var undefId = (0,_makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__/* .makeUniqueId */ .X)("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }, space)
        .split(JSON.stringify(undefId))
        .join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map

/***/ }),

/***/ 42140:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CO": function() { return /* reexport */ globals_global; },
  "kG": function() { return /* reexport */ invariant; },
  "wY": function() { return /* reexport */ maybe; },
  "_K": function() { return /* reexport */ newInvariantError; }
});

// UNUSED EXPORTS: DEV, InvariantError, __DEV__

// EXTERNAL MODULE: ../../node_modules/ts-invariant/lib/invariant.js
var lib_invariant = __webpack_require__(35948);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/version.js
var version = __webpack_require__(12674);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
maybe(function () {
    return maybe.constructor("return this")();
}));
//# sourceMappingURL=global.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/stringifyForDisplay.js
var stringifyForDisplay = __webpack_require__(63118);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/invariantWrappers.js




function wrap(fn) {
    return function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof message === "number") {
            var arg0 = message;
            message = getHandledErrorMsg(arg0);
            if (!message) {
                message = getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [message].concat(args));
    };
}
var invariant = Object.assign(function invariant(condition, message) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (!condition) {
        (0,lib_invariant/* invariant */.kG)(condition, getHandledErrorMsg(message, args) || getFallbackErrorMsg(message, args));
    }
}, {
    debug: wrap(lib_invariant/* invariant.debug */.kG.debug),
    log: wrap(lib_invariant/* invariant.log */.kG.log),
    warn: wrap(lib_invariant/* invariant.warn */.kG.warn),
    error: wrap(lib_invariant/* invariant.error */.kG.error),
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */
function newInvariantError(message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    return new lib_invariant/* InvariantError */.ej(getHandledErrorMsg(message, optionalParams) ||
        getFallbackErrorMsg(message, optionalParams));
}
var ApolloErrorMessageHandler = Symbol.for("ApolloErrorMessageHandler_" + version/* version */.i);
function stringify(arg) {
    return typeof arg == "string" ? arg : ((0,stringifyForDisplay/* stringifyForDisplay */.v)(arg, 2).slice(0, 1000));
}
function getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return (globals_global[ApolloErrorMessageHandler] &&
        globals_global[ApolloErrorMessageHandler](message, messageArgs.map(stringify)));
}
function getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: version/* version */.i,
        message: message,
        args: messageArgs.map(stringify),
    })));
}

//# sourceMappingURL=invariantWrappers.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js




/**
 * @deprecated we do not use this internally anymore,
 * it is just exported for backwards compatibility
 */
// this file is extempt from automatic `__DEV__` replacement
// so we have to write it out here
// @ts-ignore
var DEV = globalThis.__DEV__ !== false;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ DocumentTransform; }
/* harmony export */ });
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49452);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43869);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86607);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42140);
/* harmony import */ var _wry_caches__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61114);
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38223);
/* harmony import */ var _caching_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44245);







function identity(document) {
    return document;
}
var DocumentTransform = /** @class */ (function () {
    function DocumentTransform(transform, options) {
        if (options === void 0) { options = Object.create(null); }
        this.resultCache = _common_canUse_js__WEBPACK_IMPORTED_MODULE_3__/* .canUseWeakSet */ .sy ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) {
            // Override default `getCacheKey` function, which returns [document].
            this.getCacheKey = options.getCacheKey;
        }
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function (document) {
        return [document];
    };
    DocumentTransform.identity = function () {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform(identity, { cache: false });
    };
    DocumentTransform.split = function (predicate, left, right) {
        if (right === void 0) { right = DocumentTransform.identity(); }
        return Object.assign(new DocumentTransform(function (document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, 
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: false }), { left: left, right: right });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */
    DocumentTransform.prototype.resetCache = function () {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new _wry_trie__WEBPACK_IMPORTED_MODULE_0__/* .Trie */ .B(_common_canUse_js__WEBPACK_IMPORTED_MODULE_3__/* .canUseWeakMap */ .mr);
            this.performWork = (0,optimism__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function (document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: _caching_index_js__WEBPACK_IMPORTED_MODULE_4__/* .cacheSizes["documentTransform.cache"] */ .Q["documentTransform.cache"],
                cache: (_wry_caches__WEBPACK_IMPORTED_MODULE_5__/* .WeakCache */ .k),
            });
        }
    };
    DocumentTransform.prototype.performWork = function (document) {
        (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_6__/* .checkDocument */ .A$)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function (document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) {
            return document;
        }
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function (otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function (document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, 
        // Reasonably assume both transforms handle their own caching
        { cache: false }), {
            left: this,
            right: otherTransform,
        });
    };
    return DocumentTransform;
}());

//# sourceMappingURL=DocumentTransform.js.map

/***/ }),

/***/ 9572:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ hasDirectives; },
/* harmony export */   "LZ": function() { return /* binding */ shouldInclude; },
/* harmony export */   "mj": function() { return /* binding */ hasClientExports; }
/* harmony export */ });
/* unused harmony exports getDirectiveNames, hasAnyDirectives, hasAllDirectives, getInclusionDirectives */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58867);


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue =
                variables && variables[ifArgument.value.name.value];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, 67, directive.name.value);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) {
    return hasDirectives(names, root, false);
};
var hasAllDirectives = function (names, root) {
    return hasDirectives(names, root, true);
};
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .visit */ .Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_1__/* .BREAK */ .$_;
            }
        },
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(["client", "export"], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
            var ifArgument = directiveArguments[0];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
            var ifValue = ifArgument.value;
            // means it has to be a variable value if this is a valid @skip or @include directive
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map

/***/ }),

/***/ 18001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createFragmentMap; },
/* harmony export */   "Yk": function() { return /* binding */ getFragmentQueryDocument; },
/* harmony export */   "hi": function() { return /* binding */ getFragmentFromSelection; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22970);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);


/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more than one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function (definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") {
            throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(
                71,
                definition.operation,
                definition.name ? " named '".concat(definition.name.value, "'") : ""
            );
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, document), { definitions: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case "InlineFragment":
            return selection;
        case "FragmentSpread": {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, 73, fragmentName);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 86607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getOperationDefinition; },
/* harmony export */   "A$": function() { return /* binding */ checkDocument; },
/* harmony export */   "O4": function() { return /* binding */ getDefaultValues; },
/* harmony export */   "iW": function() { return /* binding */ getQueryDefinition; },
/* harmony export */   "kU": function() { return /* binding */ getFragmentDefinitions; },
/* harmony export */   "p$": function() { return /* binding */ getMainDefinition; },
/* harmony export */   "pD": function() { return /* binding */ getFragmentDefinition; },
/* harmony export */   "rY": function() { return /* binding */ getOperationName; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);


// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== "FragmentDefinition"; })
        .map(function (definition) {
        if (definition.kind !== "OperationDefinition") {
            throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(75, definition.kind);
        }
        return definition;
    });
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, 76, operations.length);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function getFragmentDefinition(doc) {
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === "Document", 78);
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" ||
                operation === "mutation" ||
                operation === "subscription") {
                return definition;
            }
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(81);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                (0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .valueToObjectRepresentation */ .vb)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),

/***/ 40122:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ print_print; }
});

// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/caches.js
var caches = __webpack_require__(50734);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/sizes.js
var sizes = __webpack_require__(44245);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/caching/getMemoryInternals.js
var getMemoryInternals = __webpack_require__(80892);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/graphql/print.js



var printCache;
var print_print = Object.assign(function (ast) {
    var result = printCache.get(ast);
    if (!result) {
        result = print(ast);
        printCache.set(ast, result);
    }
    return result;
}, {
    reset: function () {
        printCache = new caches/* AutoCleanedWeakCache */.s(sizes/* cacheSizes.print */.Q.print || 2000 /* defaultCacheSizes.print */);
    },
});
print_print.reset();
if (globalThis.__DEV__ !== false) {
    (0,getMemoryInternals/* registerGlobalCache */.zP)("print", function () { return (printCache ? printCache.size : 0); });
}
//# sourceMappingURL=print.js.map

/***/ }),

/***/ 72:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ isInlineFragment; },
/* harmony export */   "JW": function() { return /* binding */ isDocumentNode; },
/* harmony export */   "My": function() { return /* binding */ isField; },
/* harmony export */   "NC": function() { return /* binding */ argumentsObjectFromField; },
/* harmony export */   "PT": function() { return /* binding */ getStoreKeyName; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "kQ": function() { return /* binding */ makeReference; },
/* harmony export */   "qw": function() { return /* binding */ getTypenameFromResult; },
/* harmony export */   "u2": function() { return /* binding */ resultKeyNameFromField; },
/* harmony export */   "vb": function() { return /* binding */ valueToObjectRepresentation; },
/* harmony export */   "vf": function() { return /* binding */ storeKeyNameFromField; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var _common_objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45931);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18001);
/* harmony import */ var _common_canonicalStringify_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18099);




function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function isDocumentNode(value) {
    return ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === "StringValue";
}
function isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function isIntValue(value) {
    return value.kind === "IntValue";
}
function isFloatValue(value) {
    return value.kind === "FloatValue";
}
function isVariable(value) {
    return value.kind === "Variable";
}
function isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function isListValue(value) {
    return value.kind === "ListValue";
}
function isEnumValue(value) {
    return value.kind === "EnumValue";
}
function isNullValue(value) {
    return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(82, name.value, value.kind);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive",
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var storeKeyNameStringify = _common_canonicalStringify_js__WEBPACK_IMPORTED_MODULE_2__/* .canonicalStringify */ .B;
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives["connection"] &&
        directives["connection"]["key"]) {
        if (directives["connection"]["filter"] &&
            directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ?
                directives["connection"]["filter"]
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat(storeKeyNameStringify(filteredArgs_1), ")");
        }
        else {
            return directives["connection"]["key"];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(storeKeyNameStringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = storeKeyNameStringify;
        storeKeyNameStringify = s;
        return previous;
    },
});
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    var fragments;
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === "__typename") {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else if (fragments) {
            fragments.push(selection);
        }
        else {
            fragments = [selection];
        }
    }
    if (typeof result.__typename === "string") {
        return result.__typename;
    }
    if (fragments) {
        for (var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++) {
            var selection = fragments_1[_b];
            var typename = getTypenameFromResult(result, (0,_fragments_js__WEBPACK_IMPORTED_MODULE_3__/* .getFragmentFromSelection */ .hi)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === "string") {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === "Field";
}
function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),

/***/ 11209:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gw": function() { return /* binding */ addTypenameToDocument; },
/* harmony export */   "aL": function() { return /* binding */ buildQueryFromSelectionSet; },
/* harmony export */   "bi": function() { return /* binding */ removeDirectivesFromDocument; },
/* harmony export */   "ob": function() { return /* binding */ removeClientSetsFromDocument; }
/* harmony export */ });
/* unused harmony exports removeConnectionDirectiveFromDocument, removeArgumentsFromDocument, removeFragmentSpreadFromDocument */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42140);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95115);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58867);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86607);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18001);
/* harmony import */ var _common_arrays_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43056);







var TYPENAME_FIELD = {
    kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD,
    name: {
        kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.NAME */ .h.NAME,
        value: "__typename",
    },
};
function isEmpty(op, fragmentMap) {
    return (!op ||
        op.selectionSet.selections.every(function (selection) {
            return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_SPREAD */ .h.FRAGMENT_SPREAD &&
                isEmpty(fragmentMap[selection.name.value], fragmentMap);
        }));
}
function nullIfDocIsEmpty(doc) {
    return (isEmpty((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getOperationDefinition */ .$H)(doc) || (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinition */ .pD)(doc), (0,_fragments_js__WEBPACK_IMPORTED_MODULE_3__/* .createFragmentMap */ .F)((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinitions */ .kU)(doc)))) ?
        null
        : doc;
}
function getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function (directive) {
        if (directive) {
            if (directive.name) {
                names.set(directive.name, directive);
            }
            else if (directive.test) {
                tests.set(directive.test, directive);
            }
        }
    });
    return function (directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) {
            tests.forEach(function (testConfig, test) {
                if (test(directive)) {
                    config = testConfig;
                }
            });
        }
        return config;
    };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, (inUse = {
                // Variable and fragment spread names used directly within this
                // operation or fragment definition, as identified by key. These sets
                // will be populated during the first traversal of the document in
                // removeDirectivesFromDocument below.
                variables: new Set(),
                fragmentSpreads: new Set(),
            }));
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if ((0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isArray */ .k)(ancestor))
                continue;
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                // If an operation is anonymous, we use the empty string as its key.
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        globalThis.__DEV__ !== false && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error(83);
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var shouldRemoveField = function (nodeDirectives) {
        return (0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isNonEmptyArray */ .O)(nodeDirectives) &&
            nodeDirectives
                .map(directiveMatcher)
                .some(function (config) { return config && config.remove; });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
                // We might like to remove this FragmentSpread by returning null here if
                // the corresponding FragmentDefinition node is also going to be removed
                // by the logic below, but we can't control the relative order of those
                // events, so we have to postpone the removal of dangling FragmentSpread
                // nodes until after the current visit of the document has finished.
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    // If the FragmentNode received by this leave function is identical to
                    // the one received by the corresponding enter function (above), then
                    // the visitor must not have made any changes within this
                    // FragmentDefinition node. This fragment definition may still be
                    // removed if there are no ...spread references to it, but it won't be
                    // removed just because it has only a __typename field.
                    return node;
                }
                if (
                // This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) {
                        return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD &&
                            selection.name.value === "__typename";
                    })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        // If our first pass did not change anything about the document, then there
        // is no cleanup we need to do, and we can return the original doc.
        return doc;
    }
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION &&
            // If there are no operations in the document, then all fragment
            // definitions count as usages of their own fragment names. This heuristic
            // prevents accidentally removing all fragment definitions from the
            // document just because it contains no operations that use the fragments.
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function (fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) {
        return !!(
        // A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) ||
            getInUseByFragmentName(fragmentName).removed));
    };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty((0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(
                    // If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                                return usedVariableNames_1.has(varDef.variable.name.value);
                            }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent &&
                    parent.kind ===
                        graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                    return;
                }
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function (selection) {
                    return ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(selection) &&
                        (selection.name.value === "__typename" ||
                            selection.name.value.lastIndexOf("__", 0) === 0));
                });
                if (skip) {
                    return;
                }
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === "export"; })) {
                    return;
                }
                // Create and return a new SelectionSet with a __typename Field.
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { selections: (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === "key"; })) {
                globalThis.__DEV__ !== false && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn(84);
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === Kind.VARIABLE &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign(__assign({}, node), { 
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ?
                        node.variableDefinitions.filter(function (varDef) {
                            return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                        })
                        : [] });
            },
        },
        Field: {
            enter: function (node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                // Remove all matching arguments.
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
// If the incoming document is a query, return it as is. Otherwise, build a
// new document containing a query operation based on the selection set
// of the previous main operation.
function buildQueryFromSelectionSet(document) {
    var definition = (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getMainDefinition */ .p$)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") {
        // Already a query, so return the existing document.
        return document;
    }
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { operation: "query" });
            },
        },
    });
    return modifiedDoc;
}
// Remove fields / selection sets that include an @client directive.
function removeClientSetsFromDocument(document) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === "client"; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ 13287:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ iterateObserversSafely; }
/* harmony export */ });
function iterateObserversSafely(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map

/***/ }),

/***/ 21931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ fixObservableSubclass; }
/* harmony export */ });
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12129);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43869);


// Generic implementations of Observable.prototype methods like map and
// filter need to know how to create a new Observable from an Observable
// subclass (like Concast or ObservableQuery). Those methods assume
// (perhaps unwisely?) that they can call the subtype's constructor with a
// Subscriber function, even though the subclass constructor might expect
// different parameters. Defining this static Symbol.species property on
// the subclass is a hint to generic Observable code to use the default
// constructor instead of trying to do `new Subclass(observer => ...)`.
function fixObservableSubclass(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, { value: _Observable_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y });
    }
    if (_common_canUse_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS && Symbol.species) {
        set(Symbol.species);
    }
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map

/***/ }),

/***/ 12674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ version; }
/* harmony export */ });
var version = "3.9.5";
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 18770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 93520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 68875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 4820:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ StrongCache; }
/* harmony export */ });
function defaultDispose() { }
class StrongCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=strong.js.map

/***/ }),

/***/ 61114:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ WeakCache; }
/* harmony export */ });
function noop() { }
const defaultDispose = noop;
const _WeakRef = typeof WeakRef !== "undefined"
    ? WeakRef
    : function (value) {
        return { deref: () => value };
    };
const _WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const _FinalizationRegistry = typeof FinalizationRegistry !== "undefined"
    ? FinalizationRegistry
    : function () {
        return {
            register: noop,
            unregister: noop,
        };
    };
const finalizationBatchSize = 10024;
class WeakCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new _WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = () => {
            const iterator = this.unfinalizedNodes.values();
            for (let i = 0; i < finalizationBatchSize; i++) {
                const node = iterator.next().value;
                if (!node)
                    break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new _WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) {
                queueMicrotask(this.finalize);
            }
            else {
                this.finalizationScheduled = false;
            }
        };
        this.registry = new _FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return (node.value = value);
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest,
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while (this.oldest && this.size > this.max) {
            this.deleteNode(this.oldest);
        }
    }
    deleteNode(node) {
        if (node === this.newest) {
            this.newest = node.older;
        }
        if (node === this.oldest) {
            this.oldest = node.newer;
        }
        if (node.newer) {
            node.newer.older = node.older;
        }
        if (node.older) {
            node.older.newer = node.newer;
        }
        this.size--;
        const key = node.key || (node.keyRef && node.keyRef.deref());
        this.dispose(node.value, key);
        if (!node.keyRef) {
            this.unfinalizedNodes.delete(node);
        }
        else {
            this.registry.unregister(node);
        }
        if (key)
            this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}
//# sourceMappingURL=weak.js.map

/***/ }),

/***/ 78807:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
const { toString, hasOwnProperty } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
// Allow default imports as well.
/* harmony default export */ __webpack_exports__["Z"] = (equal);
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = toString.call(a);
    const bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            const aKeys = definedKeys(a);
            const bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            const keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (let k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (let k = 0; k < keyCount; ++k) {
                const key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            const aIterator = a.entries();
            const isMap = aTag === '[object Map]';
            while (true) {
                const info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                const [aKey, aValue] = info.value;
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            let len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            const aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49452:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Trie; }
/* harmony export */ });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray(slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
                    map.delete(head);
                }
            }
        }
        else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && isObjRef(key)
            ? this.weak || (create ? this.weak = new WeakMap : void 0)
            : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 36781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jt": function() { return /* binding */ animate; }
});

// UNUSED EXPORTS: hasRepeatDelayElapsed, loopElapsed, reverseElapsed

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/easing/modifiers/mirror.mjs
var mirror = __webpack_require__(17070);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/easing/modifiers/reverse.mjs
var reverse = __webpack_require__(26574);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/easing/ease.mjs



const easeIn = (p) => p * p;
const easeOut = (0,reverse/* reverseEasing */.M)(easeIn);
const easeInOut = (0,mirror/* mirrorEasing */.o)(easeIn);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(83972);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/noop.mjs
var noop = __webpack_require__(50065);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/easing/cubic-bezier.mjs


/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop/* noop */.Z;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/easing/circ.mjs
var circ = __webpack_require__(41469);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/easing/back.mjs




const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = (0,reverse/* reverseEasing */.M)(backOut);
const backInOut = (0,mirror/* mirrorEasing */.o)(backIn);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/easing/anticipate.mjs


const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/easing.mjs








const easingLookup = {
    linear: noop/* noop */.Z,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circ/* circIn */.Z7,
    circInOut: circ/* circInOut */.X7,
    circOut: circ/* circOut */.Bn,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0,hey_listen_es.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        (0,hey_listen_es.invariant)(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};
const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/keyframes.mjs




function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i) => i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}
function keyframes({ keyframes: keyframeValues, ease = easeInOut, times, duration = 300, }) {
    keyframeValues = [...keyframeValues];
    const origin = keyframes[0];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframes.length
        ? times
        : defaultOffset(keyframeValues), duration);
    function createInterpolator() {
        return (0,interpolate/* interpolate */.s)(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions)
                ? easingFunctions
                : defaultEasing(keyframeValues, easingFunctions),
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t) => {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: () => {
            keyframeValues.reverse();
            interpolator = createInterpolator();
        },
    };
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = __webpack_require__(51366);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/find-spring.mjs



const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    (0,hey_listen_es.warning)(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = (0,clamp/* clamp */.u)(minDamping, maxDamping, dampingRatio);
    duration = (0,clamp/* clamp */.u)(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/velocity-per-second.mjs
var velocity_per_second = __webpack_require__(75394);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/spring.mjs



const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */
function spring({ keyframes, restSpeed = 2, restDelta = 0.01, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    let resolveSpring = zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working within what looks like a 0-1 range, change the default restDelta
         * to 0.01
         */
        if (restDelta === undefined) {
            restDelta = Math.min(Math.abs(target - origin) / 100, 0.4);
        }
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (target -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq) *
                            Math.sin(angularFreq * t) +
                            initialDelta * Math.cos(angularFreq * t)));
            };
        }
        else if (dampingRatio === 1) {
            // Critically damped spring
            resolveSpring = (t) => target -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta +
                        (initialVelocity + undampedAngularFreq * initialDelta) *
                            t);
        }
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return (target -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq);
            };
        }
    }
    createSpring();
    return {
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */
                    if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - velocitySampleDuration);
                        currentVelocity = (0,velocity_per_second/* velocityPerSecond */.R)(current - resolveSpring(prevT), t - prevT);
                    }
                    else {
                        currentVelocity = 0;
                    }
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: () => {
            initialVelocity = -initialVelocity;
            [origin, target] = [target, origin];
            createSpring();
        },
    };
}
spring.needsInterpolation = (a, b) => typeof a === "string" || typeof b === "string";
const zero = (_t) => 0;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/decay.mjs
function decay({ 
/**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */
keyframes = [0], velocity = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget, }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    return {
        next: (t) => {
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: () => { },
    };
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/index.mjs + 2 modules
var frameloop = __webpack_require__(58387);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/index.mjs






const types = {
    decay: decay,
    keyframes: keyframes,
    tween: keyframes,
    spring: spring,
};
function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update) => {
    const passTimestamp = ({ delta }) => update(delta);
    return {
        start: () => frameloop/* sync.update */.Z_.update(passTimestamp, true),
        stop: () => frameloop/* cancelSync.update */.qY.update(passTimestamp),
    };
};
function animate({ duration, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, keyframes, autoplay = true, onPlay, onStop, onComplete, onRepeat, onUpdate, type = "keyframes", ...options }) {
    var _a, _b;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = types[keyframes.length > 2 ? "keyframes" : type];
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, origin, target)) {
        interpolateFromNumber = (0,interpolate/* interpolate */.s)([0, 100], [origin, target], {
            clamp: false,
        });
        keyframes = [0, 100];
    }
    const animation = animator({
        ...options,
        duration,
        keyframes,
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) {
                computedDuration =
                    computedDuration !== undefined ? computedDuration : elapsed;
            }
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: () => {
            onStop && onStop();
            driverControls.stop();
        },
        sample: (t) => {
            return animation.next(Math.max(0, t));
        },
    };
}




/***/ }),

/***/ 88241:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/process.mjs
var process = __webpack_require__(28723);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/index.mjs + 2 modules
var frameloop = __webpack_require__(58387);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(23617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/use-is-mounted.mjs



function useIsMounted() {
    const isMounted = (0,react.useRef)(false);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/use-force-update.mjs




function useForceUpdate() {
    const isMounted = useIsMounted();
    const [forcedRenderCount, setForcedRenderCount] = (0,react.useState)(0);
    const forceRender = (0,react.useCallback)(() => {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    const deferredForceRender = (0,react.useCallback)(() => frameloop/* sync.postRender */.Z_.postRender(forceRender), [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var PresenceContext = __webpack_require__(97967);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/PopChild.mjs



/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends react.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent }) {
    const id = (0,react.useId)();
    const ref = (0,react.useRef)(null);
    const size = (0,react.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    (0,react.useInsertionEffect)(() => {
        const { width, height, top, left } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        }
        return () => {
            document.head.removeChild(style);
        };
    }, [isPresent]);
    return (react.createElement(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size }, react.cloneElement(children, { ref })));
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs






const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
    const presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    const id = (0,react.useId)();
    const context = (0,react.useMemo)(() => ({
        id,
        initial,
        isPresent,
        custom,
        onExitComplete: (childId) => {
            presenceChildren.set(childId, true);
            for (const isComplete of presenceChildren.values()) {
                if (!isComplete)
                    return; // can stop searching when any is incomplete
            }
            onExitComplete && onExitComplete();
        },
        register: (childId) => {
            presenceChildren.set(childId, false);
            return () => presenceChildren.delete(childId);
        },
    }), 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = react.createElement(PopChild, { isPresent: isPresent }, children);
    }
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs
var use_unmount_effect = __webpack_require__(96073);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warn_once = __webpack_require__(74963);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs











const getChildKey = (child) => child.key || "";
function updateChildLookup(children, allChildren) {
    children.forEach((child) => {
        const key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, (child) => {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, custom, initial = true, onExitComplete, exitBeforeEnter, presenceAffectsLayout = true, mode = "sync", }) => {
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) {
        mode = "wait";
        (0,warn_once/* warnOnce */.O)(false, "Replace exitBeforeEnter with mode='wait'");
    }
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = useForceUpdate();
    const forceRenderLayoutGroup = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    const isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0,react.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0,react.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0,react.useRef)(true);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0,use_unmount_effect/* useUnmountEffect */.z)(() => {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) {
        return (react.createElement(react.Fragment, null, childrenToRender.map((child) => (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child)))));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [...childrenToRender];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map(getChildKey);
    const targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for (let i = 0; i < numPresent; i++) {
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key) => {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        const child = allChildren.get(key);
        if (!child)
            return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = () => {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild) => presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false)
                    return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child) => {
        const key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    if (process/* env */.O !== "production" &&
        mode === "wait" &&
        childrenToRender.length > 1) {
        console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    }
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map((child) => (0,react.cloneElement)(child))));
};




/***/ }),

/***/ 3422:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ LayoutGroupContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


const LayoutGroupContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});




/***/ }),

/***/ 60976:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ MotionConfigContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * @public
 */
const MotionConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});




/***/ }),

/***/ 97967:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PresenceContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * @public
 */
const PresenceContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);




/***/ }),

/***/ 41469:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ circOut; },
/* harmony export */   "X7": function() { return /* binding */ circInOut; },
/* harmony export */   "Z7": function() { return /* binding */ circIn; }
/* harmony export */ });
/* harmony import */ var _modifiers_mirror_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17070);
/* harmony import */ var _modifiers_reverse_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26574);



const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = (0,_modifiers_reverse_mjs__WEBPACK_IMPORTED_MODULE_0__/* .reverseEasing */ .M)(circIn);
const circInOut = (0,_modifiers_mirror_mjs__WEBPACK_IMPORTED_MODULE_1__/* .mirrorEasing */ .o)(circOut);




/***/ }),

/***/ 17070:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ mirrorEasing; }
/* harmony export */ });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;




/***/ }),

/***/ 26574:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ reverseEasing; }
/* harmony export */ });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);




/***/ }),

/***/ 85403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ frameData; }
/* harmony export */ });
const frameData = {
    delta: 0,
    timestamp: 0,
};




/***/ }),

/***/ 58387:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qY": function() { return /* binding */ cancelSync; },
  "iW": function() { return /* binding */ flushSync; },
  "Z_": function() { return /* binding */ sync; }
});

;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/frameloop/on-next-frame.mjs
/*
  Detect and load appropriate clock setting for the execution environment
 */
const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/frameloop/create-render-step.mjs
function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/data.mjs
var data = __webpack_require__(85403);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/frameloop/index.mjs




const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(data/* frameData */.w);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(data/* frameData */.w);
const processFrame = (timestamp) => {
    runNextFrame = false;
    data/* frameData.delta */.w.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - data/* frameData.timestamp */.w.timestamp, maxElapsed), 1);
    data/* frameData.timestamp */.w.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};




/***/ }),

/***/ 90260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ motion; }
});

// UNUSED EXPORTS: createDomMotionComponent

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(60976);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/MotionContext/index.mjs


const MotionContext = (0,react.createContext)({});
function useVisualElementContext() {
    return (0,react.useContext)(MotionContext).visualElement;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var context_PresenceContext = __webpack_require__(97967);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(23617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/LazyContext.mjs


const LazyContext = (0,react.createContext)({ strict: false });



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs







function useVisualElement(Component, visualState, props, createVisualElement) {
    const parent = useVisualElementContext();
    const lazyContext = (0,react.useContext)(LazyContext);
    const presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    const reducedMotionConfig = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).reducedMotion;
    const visualElementRef = (0,react.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceId: presenceContext ? presenceContext.id : undefined,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        visualElement && visualElement.render();
    });
    /**
     * If we have optimised appear animations to handoff from, trigger animateChanges
     * from a synchronous useLayoutEffect to ensure there's no flash of incorrectly
     * styled component in the event of a hydration error.
     */
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        if (visualElement && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => () => visualElement && visualElement.notify("Unmount"), []);
    return visualElement;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs



/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return (0,react.useCallback)((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/is-variant-label.mjs
/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/is-controlling-variants.mjs



const variantProps = [
    "initial",
    "animate",
    "exit",
    "whileHover",
    "whileDrag",
    "whileTap",
    "whileFocus",
    "whileInView",
];
function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs



function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/MotionContext/create.mjs




function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, (0,react.useContext)(MotionContext));
    return (0,react.useMemo)(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/definitions.mjs
const createDefinition = (propNames) => ({
    isEnabled: (props) => propNames.some((name) => !!props[name]),
});
const featureDefinitions = {
    measureLayout: createDefinition(["layout", "layoutId", "drag"]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave",
    ]),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/load-features.mjs


function loadFeatures(features) {
    for (const key in features) {
        if (key === "projectionNodeConstructor") {
            featureDefinitions.projectionNodeConstructor = features[key];
        }
        else {
            featureDefinitions[key].Component = features[key];
        }
    }
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/is-browser.mjs
var is_browser = __webpack_require__(33791);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/state.mjs
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/id.mjs



let id = 1;
function useProjectionId() {
    return (0,use_constant/* useConstant */.h)(() => {
        if (globalProjectionState.hasEverUpdated) {
            return id++;
        }
    });
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/VisualElementHandler.mjs


class VisualElementHandler extends react.Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */
    getSnapshotBeforeUpdate() {
        const { visualElement, props } = this.props;
        if (visualElement)
            visualElement.setProps(props);
        return null;
    }
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs


/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = (0,react.createContext)({});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/symbol.mjs
const motionComponentSymbol = Symbol.for("motionComponentSymbol");



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/index.mjs

















/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function motion_createMotionComponent({ preloadedFeatures, createVisualElement, projectionNodeConstructor, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const configAndProps = {
            ...(0,react.useContext)(MotionConfigContext/* MotionConfigContext */._),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        let features = null;
        const context = useCreateMotionContext(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */
        const projectionId = isStatic ? undefined : useProjectionId();
        /**
         *
         */
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && is_browser/* isBrowser */.j) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */
            const lazyStrictMode = (0,react.useContext)(LazyContext).strict;
            const initialLayoutGroupConfig = (0,react.useContext)(SwitchLayoutGroupContext);
            if (context.visualElement) {
                features = context.visualElement.loadFeatures(
                // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                configAndProps, lazyStrictMode, preloadedFeatures, projectionId, projectionNodeConstructor ||
                    featureDefinitions.projectionNodeConstructor, initialLayoutGroupConfig);
            }
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (react.createElement(VisualElementHandler, { visualElement: context.visualElement, props: configAndProps },
            features,
            react.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement))));
    }
    const ForwardRefComponent = (0,react.forwardRef)(MotionComponent);
    ForwardRefComponent[motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs


/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return motion_createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs


function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/transform.mjs
/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.mjs



function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
var is_motion_value = __webpack_require__(15815);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/build-transform.mjs


const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
const sortTransformProps = (a, b) => transformPropOrder.indexOf(a) - transformPropOrder.indexOf(b);
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform({ transform, transformKeys, }, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Loop over each transform and build them into transformString
    for (const key of transformKeys) {
        transformString += `${translateAlias[key] || key}(${transform[key]}) `;
    }
    if (enableHardwareAcceleration && !transform.z) {
        transformString += "translateZ(0)";
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.mjs
/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
    return key.startsWith("--");
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.mjs
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/numbers/index.mjs
var numbers = __webpack_require__(30397);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/numbers/units.mjs
var units = __webpack_require__(88772);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-int.mjs


const type_int_int = {
    ...numbers/* number */.Rx,
    transform: Math.round,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/number.mjs




const numberValueTypes = {
    // Border props
    borderWidth: units.px,
    borderTopWidth: units.px,
    borderRightWidth: units.px,
    borderBottomWidth: units.px,
    borderLeftWidth: units.px,
    borderRadius: units.px,
    radius: units.px,
    borderTopLeftRadius: units.px,
    borderTopRightRadius: units.px,
    borderBottomRightRadius: units.px,
    borderBottomLeftRadius: units.px,
    // Positioning props
    width: units.px,
    maxWidth: units.px,
    height: units.px,
    maxHeight: units.px,
    size: units.px,
    top: units.px,
    right: units.px,
    bottom: units.px,
    left: units.px,
    // Spacing props
    padding: units.px,
    paddingTop: units.px,
    paddingRight: units.px,
    paddingBottom: units.px,
    paddingLeft: units.px,
    margin: units.px,
    marginTop: units.px,
    marginRight: units.px,
    marginBottom: units.px,
    marginLeft: units.px,
    // Transform props
    rotate: units/* degrees */.RW,
    rotateX: units/* degrees */.RW,
    rotateY: units/* degrees */.RW,
    rotateZ: units/* degrees */.RW,
    scale: numbers/* scale */.bA,
    scaleX: numbers/* scale */.bA,
    scaleY: numbers/* scale */.bA,
    scaleZ: numbers/* scale */.bA,
    skew: units/* degrees */.RW,
    skewX: units/* degrees */.RW,
    skewY: units/* degrees */.RW,
    distance: units.px,
    translateX: units.px,
    translateY: units.px,
    translateZ: units.px,
    x: units.px,
    y: units.px,
    z: units.px,
    perspective: units.px,
    transformPerspective: units.px,
    opacity: numbers/* alpha */.Fq,
    originX: units/* progressPercentage */.$C,
    originY: units/* progressPercentage */.$C,
    originZ: units.px,
    // Misc
    zIndex: type_int_int,
    // SVG
    fillOpacity: numbers/* alpha */.Fq,
    strokeOpacity: numbers/* alpha */.Fq,
    numOctaves: type_int_int,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/build-styles.mjs






function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformKeys, transformOrigin } = state;
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariable(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = numberValueTypes[key];
        const valueAsType = getValueAsType(value, valueType);
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0))
                transformIsNone = false;
        }
        else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/use-props.mjs






function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!(0,is_motion_value/* isMotionValue */.i)(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return (0,react.useMemo)(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
const animationProps = [
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView",
];
const tapProps = ["whileTap", "onTap", "onTapStart", "onTapCancel"];
const panProps = ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"];
const inViewProps = [
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
];
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onHoverStart",
    "onHoverEnd",
    "layoutScroll",
    ...inViewProps,
    ...tapProps,
    ...animationProps,
    ...panProps,
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/filter-props.mjs


let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.mjs


function calcOrigin(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : units.px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/path.mjs


const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = units.px.transform(-offset);
    // Build the dash array
    const pathLength = units.px.transform(length);
    const pathSpacing = units.px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.mjs




/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs


const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/is-svg-tag.mjs
const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/use-props.mjs






function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = (0,react.useMemo)(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/use-render.mjs






function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref,
        };
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return (0,react.createElement)(Component, elementProps);
    };
    return useRender;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.mjs
/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/render.mjs
function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.mjs
/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/render.mjs




function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.mjs



function scrapeMotionValuesFromProps(props) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if ((0,is_motion_value/* isMotionValue */.i)(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.mjs



function scrape_motion_values_scrapeMotionValuesFromProps(props) {
    const newValues = scrapeMotionValuesFromProps(props);
    for (const key in props) {
        if ((0,is_motion_value/* isMotionValue */.i)(props[key])) {
            const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/resolve-variants.mjs
function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.mjs
const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/resolve-value.mjs


const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = (0,is_motion_value/* isMotionValue */.i)(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs









function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = (0,react.useContext)(MotionContext);
    const presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : (0,use_constant/* useConstant */.h)(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props);
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach((definition) => {
            const resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            const { transitionEnd, transition, ...target } = resolved;
            for (const key in target) {
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */
                    const index = isInitialAnimationBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (const key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/config-motion.mjs







const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrape_motion_values_scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/config-motion.mjs




const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState,
    }),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs





function create_config_createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement,
        projectionNodeConstructor,
        Component,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/types.mjs
var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/events/use-dom-event.mjs


function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    (0,react.useEffect)(() => {
        const element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/use-focus-gesture.mjs



/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture({ whileFocus, visualElement, }) {
    const { animationState } = visualElement;
    const onFocus = () => {
        animationState && animationState.setActive(AnimationType.Focus, true);
    };
    const onBlur = () => {
        animationState && animationState.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/utils/event-type.mjs
function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/events/event-info.mjs


/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return (event) => {
        const isMouseEvent = event instanceof MouseEvent;
        const isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
const defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
    const primaryTouch = e.touches[0] || e.changedTouches[0];
    const point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType = "page") {
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType = "page") {
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
const wrapHandler = (handler, shouldFilterPrimaryPointer = false) => {
    const listener = (event) => handler(event, extractEventInfo(event));
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/events/utils.mjs


// We check for event support via functions in case they've been mocked by a testing suite.
const supportsPointerEvents = () => is_browser/* isBrowser */.j && window.onpointerdown === null;
const supportsTouchEvents = () => is_browser/* isBrowser */.j && window.ontouchstart === null;
const supportsMouseEvents = () => is_browser/* isBrowser */.j && window.onmousedown === null;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/events/use-pointer-event.mjs




const mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
const touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/drag/utils/lock.mjs
function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/use-hover-gesture.mjs





function createHoverEvent(visualElement, isActive, callback) {
    return (event, info) => {
        if (!isMouseEvent(event) || isDragActive())
            return;
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (visualElement.animationState) {
            visualElement.animationState.setActive(AnimationType.Hover, isActive);
        }
        callback && callback(event, info);
    };
}
function useHoverGesture({ onHoverStart, onHoverEnd, whileHover, visualElement, }) {
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined, { passive: !onHoverStart });
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined, { passive: !onHoverEnd });
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.mjs
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs
var use_unmount_effect = __webpack_require__(96073);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/pipe.mjs
var pipe = __webpack_require__(96953);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/use-tap-gesture.mjs








/**
 * @param handlers -
 * @internal
 */
function useTapGesture({ onTap, onTapStart, onTapCancel, whileTap, visualElement, }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = (0,react.useRef)(false);
    const cancelPointerEndListeners = (0,react.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */
    const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown),
    };
    function removePointerEndListener() {
        cancelPointerEndListeners.current && cancelPointerEndListeners.current();
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        removePointerEndListener();
        isPressing.current = false;
        visualElement.animationState &&
            visualElement.animationState.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */
        !isNodeOrChild(visualElement.current, event.target)
            ? onTapCancel && onTapCancel(event, info)
            : onTap && onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel && onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0,pipe/* pipe */.z)(addPointerEvent(window, "pointerup", onPointerUp, eventOptions), addPointerEvent(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */
        visualElement.animationState &&
            visualElement.animationState.setActive(AnimationType.Tap, true);
        onTapStart && onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0,use_unmount_effect/* useUnmountEffect */.z)(removePointerEndListener);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/process.mjs
var process = __webpack_require__(28723);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/warn-once.mjs
var warn_once = __webpack_require__(74963);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/viewport/observers.mjs
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/viewport/use-viewport.mjs






function useViewport({ visualElement, whileInView, onViewportEnter, onViewportLeave, viewport = {}, }) {
    const state = (0,react.useRef)({
        hasEnteredView: false,
        isInView: false,
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView)
        shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined"
        ? useMissingIntersectionObserver
        : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const thresholdNames = {
    some: 0,
    all: 1,
};
function useIntersectionObserver(shouldObserve, state, visualElement, { root, margin: rootMargin, amount = "some", once }) {
    (0,react.useEffect)(() => {
        if (!shouldObserve || !visualElement.current)
            return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const intersectionCallback = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (state.isInView === isIntersecting)
                return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && state.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                state.hasEnteredView = true;
            }
            if (visualElement.animationState) {
                visualElement.animationState.setActive(AnimationType.InView, isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const props = visualElement.getProps();
            const callback = isIntersecting
                ? props.onViewportEnter
                : props.onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(visualElement.current, options, intersectionCallback);
    }, [shouldObserve, root, rootMargin, amount]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */
function useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback = true }) {
    (0,react.useEffect)(() => {
        if (!shouldObserve || !fallback)
            return;
        if (process/* env */.O !== "production") {
            (0,warn_once/* warnOnce */.O)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        }
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */
        requestAnimationFrame(() => {
            state.hasEnteredView = true;
            const { onViewportEnter } = visualElement.getProps();
            onViewportEnter && onViewportEnter(null);
            if (visualElement.animationState) {
                visualElement.animationState.setActive(AnimationType.InView, true);
            }
        });
    }, [shouldObserve]);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/utils/make-renderless-component.mjs
const makeRenderlessComponent = (hook) => (props) => {
    hook(props);
    return null;
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/gestures.mjs






const gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs



/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = (0,react.useId)();
    (0,react.useEffect)(() => register(id), []);
    const safeToRemove = () => onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
    return isPresent(useContext(PresenceContext));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/is-numerical-string.mjs
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/is-zero-value-string.mjs
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(40226);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/complex/index.mjs
var complex = __webpack_require__(76865);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/utils.mjs
var utils = __webpack_require__(59747);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/types/complex/filter.mjs



/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(utils/* floatRegex */.KP) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...complex/* complex */.P,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/color/index.mjs
var color = __webpack_require__(45982);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/defaults.mjs




/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color: color/* color */.$,
    backgroundColor: color/* color */.$,
    outlineColor: color/* color */.$,
    fill: color/* color */.$,
    stroke: color/* color */.$,
    // Border props
    borderColor: color/* color */.$,
    borderTopColor: color/* color */.$,
    borderRightColor: color/* color */.$,
    borderBottomColor: color/* color */.$,
    borderLeftColor: color/* color */.$,
    filter: filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.mjs




function getAnimatableNone(key, value) {
    var _a;
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex/* complex */.P;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/test.mjs
/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.mjs
/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.mjs





/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [numbers/* number */.Rx, units.px, units/* percent */.aQ, units/* degrees */.RW, units.vw, units.vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/value-types/find.mjs





/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color/* color */.$, complex/* complex */.P];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/resolve-dynamic-variants.mjs


/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key) => (current[key] = value.get()));
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs









/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, (0,es_value/* motionValue */.B)(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    const reversedLabels = [...variantLabels].reverse();
    reversedLabels.forEach((key) => {
        var _a;
        const variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (let i = 0; i < numNewValues; i++) {
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex/* complex.test */.P.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, (0,es_value/* motionValue */.B)(value, { owner: visualElement }));
        if (origin[key] === undefined) {
            origin[key] = value;
        }
        if (value !== null)
            visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a;
    const origin = {};
    for (const key in target) {
        const transitionOrigin = getOriginFromTransition(key, transition);
        origin[key] =
            transitionOrigin !== undefined
                ? transitionOrigin
                : (_a = visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.get();
    }
    return origin;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-will-change/is.mjs


function isWillChangeMotionValue(value) {
    return Boolean((0,is_motion_value/* isMotionValue */.i)(value) && value.add);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/index.mjs + 2 modules
var frameloop = __webpack_require__(58387);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/optimized-appear/store-id.mjs
const appearStoreId = (id, value) => `${id}: ${value}`;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/optimized-appear/handoff.mjs




function handoffOptimizedAppearAnimation(id, name) {
    const { MotionAppearAnimations } = window;
    const animationId = appearStoreId(id, transformProps.has(name) ? "transform" : name);
    const animation = MotionAppearAnimations && MotionAppearAnimations.get(animationId);
    if (animation) {
        /**
         * We allow the animation to persist until the next frame:
         *   1. So it continues to play until Framer Motion is ready to render
         *      (avoiding a potential flash of the element's original state)
         *   2. As all independent transforms share a single transform animation, stopping
         *      it synchronously would prevent subsequent transforms from handing off.
         */
        frameloop/* sync.render */.Z_.render(() => {
            /**
             * Animation.cancel() throws so it needs to be wrapped in a try/catch
             */
            try {
                animation.cancel();
                MotionAppearAnimations.delete(animationId);
            }
            catch (e) { }
        });
        return animation.currentTime || 0;
    }
    else {
        return 0;
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/optimized-appear/data-id.mjs


const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);



// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/time-conversion.mjs
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
const instantAnimationState = {
    current: false,
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/index.mjs + 9 modules
var legacy_popmotion = __webpack_require__(36781);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/waapi/easing.mjs
function isWaapiSupportedEasing(easing) {
    return (!easing || // Default easing
        Array.isArray(easing) || // Bezier curve
        (typeof easing === "string" && supportedWaapiEasing[easing]));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing) {
    if (!easing)
        return undefined;
    return Array.isArray(easing)
        ? cubicBezierAsString(easing)
        : supportedWaapiEasing[easing];
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/waapi/index.mjs


function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
    return element.animate({ [valueName]: keyframes, offset: times }, {
        delay,
        duration,
        easing: mapEasingToNativeEasing(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/waapi/create-accelerated-animation.mjs





/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    let { keyframes, duration = 0.3, elapsed = 0, ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (options.type === "spring" || !isWaapiSupportedEasing(options.ease)) {
        const sampleAnimation = (0,legacy_popmotion/* animate */.jt)(options);
        let state = { done: false, value: keyframes[0] };
        const pregeneratedKeyframes = [];
        let t = 0;
        while (!state.done) {
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = animateStyle(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */
        ease: ease,
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */
    animation.onfinish = () => {
        value.set(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */
    return () => {
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */
        const { currentTime } = animation;
        if (currentTime) {
            const sampleAnimation = (0,legacy_popmotion/* animate */.jt)(options);
            value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
        }
        frameloop/* sync.update */.Z_.update(() => animation.cancel());
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/delay.mjs


/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            frameloop/* cancelSync.read */.qY.read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frameloop/* sync.read */.Z_.read(checkElapsed, true);
    return () => frameloop/* cancelSync.read */.qY.read(checkElapsed);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/create-instant-animation.mjs


function createInstantAnimation({ keyframes, elapsed, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return () => { };
    };
    return elapsed ? delay(setValue, -elapsed) : setValue();
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/velocity-per-second.mjs
var velocity_per_second = __webpack_require__(75394);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/frameloop/data.mjs
var data = __webpack_require__(85403);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/legacy-popmotion/inertia.mjs




function inertia({ keyframes, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop, }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function findNearestBoundary(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = (0,legacy_popmotion/* animate */.jt)({
            keyframes: [0, 1],
            velocity: 0,
            ...options,
            driver,
            onUpdate: (v) => {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            },
            onComplete,
            onStop,
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta,
            ...options,
        });
    }
    if (isOutOfBounds(origin)) {
        // Start the animation with spring if outside the defined boundaries
        startSpring({
            velocity,
            keyframes: [origin, findNearestBoundary(origin)],
        });
    }
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */
        let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v) => {
            prev = current;
            current = v;
            velocity = (0,velocity_per_second/* velocityPerSecond */.R)(v - prev, data/* frameData.delta */.w.delta);
            if ((heading === 1 && v > boundary) ||
                (heading === -1 && v < boundary)) {
                startSpring({ keyframes: [v, boundary], velocity });
            }
        };
        startAnimation({
            type: "decay",
            keyframes: [origin, 0],
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(),
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/default-transitions.mjs
const underDampedSpring = () => ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
});
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const linearTween = () => ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
const defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else {
        const factory = defaultTransitions[valueKey] || defaultTransitions.default;
        return factory(keyframes[1]);
    }
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/is-animatable.mjs


/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (key, value) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex/* complex.test */.P.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/transitions.mjs


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, ...transition }) {
    return !!Object.keys(transition).length;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/utils/keyframes.mjs




function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = isAnimatable(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */
        origin = getAnimatableNone(valueName, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    /**
     * If the target has been defined as a series of keyframes
     */
    if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */
        if (target[0] === null) {
            target[0] = origin;
        }
        return target;
    }
    else {
        return [origin, target];
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/waapi/supports.mjs
const featureTests = {
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
};
const results = {};
const supports = {};
/**
 * Generate features tests that cache their results.
 */
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/index.mjs













/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set(["opacity"]);
const createMotionValueAnimation = (valueName, value, target, transition = {}) => {
    return (onComplete) => {
        const valueTransition = getValueTransition(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */
        const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const keyframes = getKeyframes(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */
        const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
        const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
        (0,hey_listen_es.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed,
            onUpdate: (v) => {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: () => {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
        };
        if (!isOriginAnimatable ||
            !isTargetAnimatable ||
            instantAnimationState.current ||
            valueTransition.type === false) {
            /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */
            return createInstantAnimation(options);
        }
        else if (valueTransition.type === "inertia") {
            /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */
            const animation = inertia(options);
            return () => animation.stop();
        }
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */
        if (!isTransitionDefined(valueTransition)) {
            options = {
                ...options,
                ...getDefaultTransition(valueName, options),
            };
        }
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */
        if (options.duration) {
            options.duration = secondsToMilliseconds(options.duration);
        }
        if (options.repeatDelay) {
            options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
        }
        const visualElement = value.owner;
        const element = visualElement && visualElement.current;
        const canAccelerateAnimation = supports.waapi() &&
            acceleratedValues.has(valueName) &&
            !options.repeatDelay &&
            options.repeatType !== "mirror" &&
            options.damping !== 0 &&
            visualElement &&
            element instanceof HTMLElement &&
            !visualElement.getProps().onUpdate;
        if (canAccelerateAnimation) {
            /**
             * If this animation is capable of being run via WAAPI, then do so.
             */
            return createAcceleratedAnimation(value, valueName, options);
        }
        else {
            /**
             * Otherwise, fall back to the main thread.
             */
            const animation = (0,legacy_popmotion/* animate */.jt)(options);
            return () => animation.stop();
        }
    };
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs








function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(() => visualElement.notify("AnimationComplete", definition));
}
function animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = resolveVariant(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => animateTarget(visualElement, resolved, options)
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
/**
 * @internal
 */
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    var _a;
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for (const key in target) {
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        let valueTransition = { delay, elapsed: 0, ...transition };
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */
        if (visualElement.shouldReduceMotion && transformProps.has(key)) {
            valueTransition = {
                ...valueTransition,
                type: false,
                delay: 0,
            };
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        if (!value.hasAnimated) {
            const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
            if (appearId) {
                valueTransition.elapsed = handoffOptimizedAppearAnimation(appearId, key);
            }
        }
        let animation = value.start(createMotionValueAnimation(key, value, valueTarget, valueTransition));
        if (isWillChangeMotionValue(willChange)) {
            willChange.add(key);
            animation = animation.then(() => willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.values.forEach((value) => value.stop());
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation-state.mjs








const variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.InView,
    AnimationType.Focus,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Exit,
];
const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (acc, definition) => {
        const resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type, ...options },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        [AnimationType.Animate]: createTypeState(true),
        [AnimationType.InView]: createTypeState(),
        [AnimationType.Hover]: createTypeState(),
        [AnimationType.Tap]: createTypeState(),
        [AnimationType.Drag]: createTypeState(),
        [AnimationType.Focus]: createTypeState(),
        [AnimationType.Exit]: createTypeState(),
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/animations.mjs








const animations = {
    animation: makeRenderlessComponent(({ visualElement, animate }) => {
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */
        if (isAnimationControls(animate)) {
            (0,react.useEffect)(() => animate.subscribe(visualElement), [animate]);
        }
    }),
    exit: makeRenderlessComponent((props) => {
        const { custom, visualElement } = props;
        const [isPresent, safeToRemove] = usePresence();
        const presenceContext = (0,react.useContext)(context_PresenceContext/* PresenceContext */.O);
        (0,react.useEffect)(() => {
            visualElement.isPresent = isPresent;
            const animation = visualElement.animationState &&
                visualElement.animationState.setActive(AnimationType.Exit, !isPresent, {
                    custom: (presenceContext && presenceContext.custom) ||
                        custom,
                });
            if (animation && !isPresent) {
                animation.then(safeToRemove);
            }
        }, [isPresent]);
    }),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/distance.mjs
const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/PanSession.mjs









/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = data/* frameData */.w;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            frameloop/* sync.update */.Z_.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            const { onEnd, onSessionEnd } = this.handlers;
            const panInfo = getPanInfo(transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = data/* frameData */.w;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0,pipe/* pipe */.z)(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        frameloop/* cancelSync.update */.qY.update(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: PanSession_getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function PanSession_getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/progress.mjs
var progress = __webpack_require__(17475);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/mix.mjs
var mix = __webpack_require__(65339);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs


function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0,mix/* mix */.C)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        (0,mix/* mix */.C)(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = __webpack_require__(51366);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs





/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? (0,mix/* mix */.C)(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? (0,mix/* mix */.C)(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function constraints_calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = (0,progress/* progress */.Y)(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = (0,progress/* progress */.Y)(source.min, source.max - targetLength, target.min);
    }
    return (0,clamp/* clamp */.u)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/models.mjs
const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
function eachAxis(callback) {
    return [callback("x"), callback("y")];
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/conversion.mjs
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/utils/has-transform.mjs
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/delta-apply.mjs



/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
            continue;
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale))
        return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0,mix/* mix */.C)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys);
    transformAxis(box.y, transform, yKeys);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/utils/measure.mjs



function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs


















const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: AnyPointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        if (this.visualElement.isPresent === false)
            return;
        const onSessionStart = (event) => {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (units/* percent.test */.aQ.test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
                    if (measuredAxis) {
                        const length = calcLength(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Drag, true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) {
            this.visualElement.projection.isAnimationBlocked = false;
        }
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const { layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        (0,hey_listen_es.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints === null || constraints === void 0 ? void 0 : constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start(createMotionValueAnimation(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        var _a;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, ((_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0,mix/* mix */.C)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        var _a;
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = constraints_calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set((0,mix/* mix */.C)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints)) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/drag/use-drag.mjs




/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props) {
    const { dragControls: groupDragControls, visualElement } = props;
    const dragControls = (0,use_constant/* useConstant */.h)(() => new VisualElementDragControls(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0,react.useEffect)(() => groupDragControls && groupDragControls.subscribe(dragControls), [dragControls, groupDragControls]);
    // Apply the event listeners to the element
    (0,react.useEffect)(() => dragControls.addListeners(), [dragControls]);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/gestures/use-pan-gesture.mjs






/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture({ onPan, onPanStart, onPanEnd, onPanSessionStart, visualElement, }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = (0,react.useRef)(null);
    const { transformPagePoint } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info) => {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    (0,react.useEffect)(() => {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0,use_unmount_effect/* useUnmountEffect */.z)(() => panSession.current && panSession.current.end());
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/drag.mjs




const drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.mjs


function css_variables_conversion_isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token, fallback] = match;
    return [token, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    (0,hey_listen_es.invariant)(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (css_variables_conversion_isCSSVariable(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element))
        return { target, transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = { ...transitionEnd };
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value) => {
        const current = value.get();
        if (!css_variables_conversion_isCSSVariable(current))
            return;
        const resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (const key in target) {
        const current = target[key];
        if (!css_variables_conversion_isCSSVariable(current))
            continue;
        const resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) {
            transitionEnd[key] = current;
        }
    }
    return { target, transitionEnd };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.mjs








const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
const isPositionalKey = (key) => positionalKeys.has(key);
const hasPositionalKey = (target) => {
    return Object.keys(target).some(isPositionalKey);
};
const setAndResetVelocity = (value, to) => {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
const isNumOrPxType = (v) => v === numbers/* number */.Rx || v === units.px;
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    /**
     * Record origins before we render and update styles
     */
    changedKeys.forEach((key) => {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key) => {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
    target = { ...target };
    transitionEnd = { ...transitionEnd };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        let from = origin[key];
        let fromType = findDimensionValueType(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (let i = fromIndex; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    (0,hey_listen_es.invariant)(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    (0,hey_listen_es.invariant)(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === units.px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0
            ? window.pageYOffset
            : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(([key, value]) => {
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if (is_browser/* isBrowser */.j && scrollY !== null) {
            window.scrollTo({ top: scrollY });
        }
        return { target: convertedTarget, transitionEnd };
    }
    else {
        return { target, transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target, transitionEnd };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/utils/parse-dom-variant.mjs



/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
    const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/reduced-motion/state.mjs
// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/reduced-motion/index.mjs



function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!is_browser/* isBrowser */.j)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/subscription-manager.mjs
var subscription_manager = __webpack_require__(88069);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/motion-values.mjs





function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0,is_motion_value/* isMotionValue */.i)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            if (isWillChangeMotionValue(willChange)) {
                willChange.add(key);
            }
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (false) {}
        }
        else if ((0,is_motion_value/* isMotionValue */.i)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, (0,es_value/* motionValue */.B)(nextValue, { owner: element }));
            if (isWillChangeMotionValue(willChange)) {
                willChange.remove(key);
            }
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0,es_value/* motionValue */.B)(latestValue !== undefined ? latestValue : nextValue));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/VisualElement.mjs




















const featureNames = Object.keys(featureDefinitions);
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "Unmount",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    constructor({ parent, props, reducedMotionConfig, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        /**
         * Tracks whether this VisualElement's React component is currently present
         * within the defined React tree.
         */
        this.isPresent = true;
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = () => frameloop/* sync.render */.Z_.render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props);
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0,is_motion_value/* isMotionValue */.i)(value)) {
                value.set(latestValues[key], false);
                if (isWillChangeMotionValue(willChange)) {
                    willChange.add(key);
                }
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props) {
        return {};
    }
    mount(instance) {
        var _a;
        this.current = instance;
        if (this.projection) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (this.parent)
            this.parent.children.add(this);
        this.setProps(this.props);
    }
    unmount() {
        var _a, _b, _c;
        (_a = this.projection) === null || _a === void 0 ? void 0 : _a.unmount();
        frameloop/* cancelSync.update */.qY.update(this.notifyUpdate);
        frameloop/* cancelSync.render */.qY.render(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        (_b = this.removeFromVariantTree) === null || _b === void 0 ? void 0 : _b.call(this);
        (_c = this.parent) === null || _c === void 0 ? void 0 : _c.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate &&
                frameloop/* sync.update */.Z_.update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type)
            return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(renderedProps, isStrict, preloadedFeatures, projectionId, ProjectionNodeConstructor, initialLayoutGroupConfig) {
        const features = [];
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */
        if (process/* env */.O !== "production" && preloadedFeatures && isStrict) {
            (0,hey_listen_es.invariant)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
        }
        for (let i = 0; i < numFeatures; i++) {
            const name = featureNames[i];
            const { isEnabled, Component } = featureDefinitions[name];
            /**
             * It might be possible in the future to use this moment to
             * dynamically request functionality. In initial tests this
             * was producing a lot of duplication amongst bundles.
             */
            if (isEnabled(renderedProps) && Component) {
                features.push((0,react.createElement)(Component, {
                    key: name,
                    ...renderedProps,
                    visualElement: this,
                }));
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) ||
                    (dragConstraints && isRefObject(dragConstraints)),
                visualElement: this,
                scheduleRender: () => this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */
                animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
            });
        }
        return features;
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
    makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    setProps(props) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.props = props;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props), this.prevMotionValues);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        var _a;
        return (_a = this.props.variants) === null || _a === void 0 ? void 0 : _a[name];
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        var _a;
        return this.isVariantNode ? this : (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getClosestVariantNode();
    }
    getVariantContext(startAtParent = false) {
        var _a, _b;
        if (startAtParent)
            return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getVariantContext();
        if (!this.isControllingVariants) {
            const context = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getVariantContext()) || {};
            if (this.props.initial !== undefined) {
                context.initial = this.props.initial;
            }
            return context;
        }
        const context = {};
        for (let i = 0; i < numVariantProps; i++) {
            const name = VisualElement_variantProps[i];
            const prop = this.props[name];
            if (isVariantLabel(prop) || prop === false) {
                context[name] = prop;
            }
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        var _a;
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        if (this.hasValue(key))
            this.removeValue(key);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
        this.bindToMotionValue(key, value);
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        var _a;
        this.values.delete(key);
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
        this.valueSubscriptions.delete(key);
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    /**
     * Get a motion value for this key. If called with a default
     * value, we'll create one if none exists.
     */
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0,es_value/* motionValue */.B)(defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key) {
        return this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object"
            ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
            : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0,is_motion_value/* isMotionValue */.i)(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new subscription_manager/* SubscriptionManager */.L();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 ? void 0 : _a.notify(...args);
    }
}
const VisualElement_variantProps = ["initial", ...variantPriorityOrder];
const numVariantProps = VisualElement_variantProps.length;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/DOMVisualElement.mjs




class DOMVisualElement extends VisualElement {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(this, target, origin);
            const parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target,
        };
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/html/HTMLVisualElement.mjs









function HTMLVisualElement_getComputedStyle(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = HTMLVisualElement_getComputedStyle(instance);
            const value = (isCSSVariable(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props) {
        return scrapeMotionValuesFromProps(props);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderHTML(instance, renderState, styleProp, projection);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/svg/SVGVisualElement.mjs











class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        var _a;
        if (transformProps.has(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return createBox();
    }
    scrapeMotionValuesFromProps(props) {
        return scrape_motion_values_scrapeMotionValuesFromProps(props);
    }
    build(renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs




const create_visual_element_createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
        : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/styles/scale-border-radius.mjs


function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (units.px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/styles/scale-box-shadow.mjs




const varToken = "_$css";
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */
        const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) {
            latest = latest.replace(cssVariableRegex, (match) => {
                cssVariables.push(match);
                return varToken;
            });
        }
        const shadow = complex/* complex.parse */.P.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex/* complex.createTransformer */.P.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = (0,mix/* mix */.C)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace(varToken, () => {
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    },
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/layout/MeasureLayout.mjs










class MeasureLayoutWithContext extends react.Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                frameloop/* sync.postRender */.Z_.postRender(() => {
                    var _a;
                    if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) {
                this.safeToRemove();
            }
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    return (react.createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: (0,react.useContext)(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/motion/features/layout/index.mjs


const layoutFeatures = {
    measureLayout: MeasureLayout,
};



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animate.mjs




/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */
function animate(from, to, transition = {}) {
    const value = (0,is_motion_value/* isMotionValue */.i)(from) ? from : (0,es_value/* motionValue */.B)(from);
    value.start(createMotionValueAnimation("", value, to, transition));
    return {
        stop: () => value.stop(),
        isAnimating: () => value.isAnimating(),
    };
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/easing/circ.mjs
var circ = __webpack_require__(41469);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/noop.mjs
var noop = __webpack_require__(50065);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/animation/mix-values.mjs






const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || units.px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0,mix/* mix */.C)(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = (0,mix/* mix */.C)(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = (0,mix/* mix */.C)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0,mix/* mix */.C)(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (units/* percent.test */.aQ.test(leadRadius) || units/* percent.test */.aQ.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = (0,mix/* mix */.C)(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, circ/* circOut */.Bn);
const easeCrossfadeOut = compress(0.5, 0.95, noop/* noop */.Z);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing((0,progress/* progress */.Y)(min, max, p));
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/copy.mjs
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/delta-remove.mjs




/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (units/* percent.test */.aQ.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0,mix/* mix */.C)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = (0,mix/* mix */.C)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const delta_remove_xKeys = ["x", "scaleX", "originX"];
const delta_remove_yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, delta_remove_xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, delta_remove_yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/geometry/utils.mjs


function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/array.mjs
var array = __webpack_require__(44866);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/shared/stack.mjs


class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        (0,array/* addUniqueItem */.y4)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0,array/* removeItem */.cl)(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/styles/transform.mjs
function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
const compareByDepth = (a, b) => a.depth - b.depth;



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/utils/flat-tree.mjs



class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0,array/* addUniqueItem */.y4)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0,array/* removeItem */.cl)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/create-projection-node.mjs






















const transformAxes = ["", "X", "Y", "Z"];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let create_projection_node_id = 0;
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = create_projection_node_id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            this.isTransformDirty = false;
            /**
             * Flag to true if we think the projection calculations for this or any
             * child might need recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new subscription_manager/* SubscriptionManager */.L());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance)
                return;
            this.isSVG =
                instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    var _a, _b, _c, _d, _e;
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEquals(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged &&
                            this.animationProgress === 0) {
                            finishAnimation(this);
                        }
                        this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d));
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.remove(this);
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
            this.instance = undefined;
            frameloop/* cancelSync.preRender */.qY.preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return (this.isAnimationBlocked ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.forEach(resetRotation);
            this.animationId++;
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating)
                return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */
            if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            frameloop/* flushSync.update */.iW.update();
            frameloop/* flushSync.preRender */.iW.preRender();
            frameloop/* flushSync.render */.iW.render();
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            frameloop/* sync.preRender */.Z_.preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            frameloop/* sync.postRender */.Z_.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            var _a;
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.notify("LayoutMeasure", this.layout.layoutBox, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.layoutBox);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot: checkIsScrollRoot(this.instance),
                    offset: measureScroll(this.instance),
                };
            }
        }
        resetTransform() {
            var _a;
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                translateAxis(box.x, scroll.offset.x);
                translateAxis(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.isRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */
                        if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layoutBox, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        /**
         *
         */
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.isProjectionDirty = true;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */
        resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            if (!this.isProjectionDirty && !this.attemptToResolveRelativeTarget)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) {
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues))
                return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) &&
                this.parent.layout) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        calcProjection() {
            var _a;
            const { isProjectionDirty, isTransformDirty } = this;
            this.isProjectionDirty = this.isTransformDirty = false;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            if (isProjectionDirty)
                canSkip = false;
            if (isShared && isTransformDirty)
                canSkip = false;
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target } = lead;
            if (!target)
                return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a, _b;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const isSharedLayoutAnimation = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.source) !== ((_a = this.layout) === null || _a === void 0 ? void 0 : _a.source);
            const isOnlyMember = (((_b = this.getStack()) === null || _b === void 0 ? void 0 : _b.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest) => {
                var _a;
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            if (this.resumingFrom) {
                (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
            }
            if (this.pendingAnimation) {
                frameloop/* cancelSync.update */.qY.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = frameloop/* sync.update */.Z_.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animate(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, latest);
                    },
                    onComplete: () => {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 ? void 0 : _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node),
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ) {
                hasRotate = true;
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate)
                return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 ? void 0 : visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_c = (_b = valuesToRender.opacity) !== null && _b !== void 0 ? _b : this.latestValues.opacity) !== null && _c !== void 0 ? _c : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        (_c = (_b = node.options).onExitComplete) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Propagate isProjectionDirty. Nodes are ordered by depth, so if the parent here
     * is dirty we can simply pass this forward.
     */
    node.isProjectionDirty || (node.isProjectionDirty = Boolean(node.parent && node.parent.isProjectionDirty));
    /**
     * Propagate isTransformDirty.
     */
    node.isTransformDirty || (node.isTransformDirty = Boolean(node.parent && node.parent.isTransformDirty));
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = (0,mix/* mix */.C)(delta.translate, 0, p);
    output.scale = (0,mix/* mix */.C)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = (0,mix/* mix */.C)(from.min, to.min, p);
    output.max = (0,mix/* mix */.C)(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */
    let searchNode = node.root;
    for (let i = node.path.length - 1; i >= 0; i--) {
        if (Boolean(node.path[i].instance)) {
            searchNode = node.path[i];
            break;
        }
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element)
        node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/DocumentProjectionNode.mjs



const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs



const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode_HTMLProjectionNode = createProjectionNode({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs










const featureBundle = {
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layoutFeatures,
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
const motion = /*@__PURE__*/ createMotionProxy((Component, config) => create_config_createDomMotionConfig(Component, config, featureBundle, create_visual_element_createDomVisualElement, HTMLProjectionNode_HTMLProjectionNode));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement, HTMLProjectionNode));
}




/***/ }),

/***/ 44866:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "y4": function() { return /* binding */ addUniqueItem; }
/* harmony export */ });
/* unused harmony export moveItem */
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}




/***/ }),

/***/ 51366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ clamp; }
/* harmony export */ });
const clamp = (min, max, v) => Math.min(Math.max(v, min), max);




/***/ }),

/***/ 83972:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ interpolate; }
});

// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/color/index.mjs
var color = __webpack_require__(45982);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/clamp.mjs
var clamp = __webpack_require__(51366);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/mix.mjs
var mix = __webpack_require__(65339);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/hsla-to-rgba.mjs
// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/color/hex.mjs
var hex = __webpack_require__(92395);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/color/rgba.mjs
var rgba = __webpack_require__(56572);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/color/hsla.mjs
var hsla = __webpack_require__(86845);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/mix-color.mjs







// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [hex/* hex */.$, rgba/* rgba */.m, hsla/* hsla */.J];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    (0,hey_listen_es.invariant)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === hsla/* hsla */.J) {
        // TODO Remove this cast - needed since Framer Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0,mix/* mix */.C)(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba/* rgba.transform */.m.transform(blended);
    };
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/pipe.mjs
var pipe = __webpack_require__(96953);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/types/complex/index.mjs
var complex = __webpack_require__(76865);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/mix-complex.mjs







function getMixer(origin, target) {
    if (typeof origin === "number") {
        return (v) => (0,mix/* mix */.C)(origin, target, v);
    }
    else if (color/* color.test */.$.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = { ...origin, ...target };
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
const mixComplex = (origin, target) => {
    const template = complex/* complex.createTransformer */.P.createTransformer(target);
    const originStats = (0,complex/* analyseComplexValue */.V)(origin);
    const targetStats = (0,complex/* analyseComplexValue */.V)(target);
    const canInterpolate = originStats.numColors === targetStats.numColors &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return (0,pipe/* pipe */.z)(mixArray(originStats.values, targetStats.values), template);
    }
    else {
        (0,hey_listen_es.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p) => `${p > 0 ? target : origin}`;
    }
};



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/progress.mjs
var progress = __webpack_require__(17475);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/interpolate.mjs









const mixNumber = (from, to) => (p) => (0,mix/* mix */.C)(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") {
        return mixNumber;
    }
    else if (typeof v === "string") {
        if (color/* color.test */.$.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === "object") {
        return mixObject;
    }
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0,pipe/* pipe */.z)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    (0,hey_listen_es.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0,hey_listen_es.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = (0,progress/* progress */.Y)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator((0,clamp/* clamp */.u)(input[0], input[inputLength - 1], v))
        : interpolator;
}




/***/ }),

/***/ 33791:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; }
/* harmony export */ });
const isBrowser = typeof document !== "undefined";




/***/ }),

/***/ 65339:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ mix; }
/* harmony export */ });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mix = (from, to, progress) => -progress * from + progress * to + from;




/***/ }),

/***/ 50065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
const noop = (any) => any;




/***/ }),

/***/ 96953:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ pipe; }
/* harmony export */ });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);




/***/ }),

/***/ 28723:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ env; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(93542);
/**
 * Browser-safe usage of process
 */
const defaultEnvironment = "production";
const env = typeof process === "undefined" || process.env === undefined
    ? defaultEnvironment
    : "production" || 0;




/***/ }),

/***/ 17475:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ progress; }
/* harmony export */ });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};




/***/ }),

/***/ 88069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ SubscriptionManager; }
/* harmony export */ });
/* harmony import */ var _array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44866);


class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        (0,_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* .addUniqueItem */ .y4)(this.subscriptions, handler);
        return () => (0,_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* .removeItem */ .cl)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}




/***/ }),

/***/ 3105:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}




/***/ }),

/***/ 23617:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _is_browser_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33791);



const useIsomorphicLayoutEffect = _is_browser_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .j ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;




/***/ }),

/***/ 96073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useUnmountEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useUnmountEffect(callback) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => callback(), []);
}




/***/ }),

/***/ 75394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ velocityPerSecond; }
/* harmony export */ });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/***/ }),

/***/ 74963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ warnOnce; }
/* harmony export */ });
const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}




/***/ }),

/***/ 40226:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ motionValue; }
/* harmony export */ });
/* unused harmony export MotionValue */
/* harmony import */ var _frameloop_data_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85403);
/* harmony import */ var _frameloop_index_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58387);
/* harmony import */ var _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88069);
/* harmony import */ var _utils_velocity_per_second_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75394);





const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "7.10.3";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = _frameloop_data_mjs__WEBPACK_IMPORTED_MODULE_0__/* .frameData */ .w;
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                _frameloop_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .sync.postRender */ .Z_.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update velocity subscribers
            if (this.events.velocityChange) {
                this.events.velocityChange.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => _frameloop_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .sync.postRender */ .Z_.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) {
                    this.events.velocityChange.notify(this.getVelocity());
                }
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new _utils_subscription_manager_mjs__WEBPACK_IMPORTED_MODULE_2__/* .SubscriptionManager */ .L();
        }
        return this.events[eventName].add(callback);
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                (0,_utils_velocity_per_second_mjs__WEBPACK_IMPORTED_MODULE_3__/* .velocityPerSecond */ .R)(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(animation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.stopAnimation) {
            this.stopAnimation();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}




/***/ }),

/***/ 92395:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ hex; }
/* harmony export */ });
/* harmony import */ var _rgba_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56572);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24536);



function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex = {
    test: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isColorString */ .i)("#"),
    parse: parseHex,
    transform: _rgba_mjs__WEBPACK_IMPORTED_MODULE_1__/* .rgba.transform */ .m.transform,
};




/***/ }),

/***/ 86845:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ hsla; }
/* harmony export */ });
/* harmony import */ var _numbers_index_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30397);
/* harmony import */ var _numbers_units_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88772);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59747);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24536);





const hsla = {
    test: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isColorString */ .i)("hsl", "hue"),
    parse: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .splitColor */ .d)("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            _numbers_units_mjs__WEBPACK_IMPORTED_MODULE_1__/* .percent.transform */ .aQ.transform((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(saturation)) +
            ", " +
            _numbers_units_mjs__WEBPACK_IMPORTED_MODULE_1__/* .percent.transform */ .aQ.transform((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(lightness)) +
            ", " +
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sanitize */ .Nw)(_numbers_index_mjs__WEBPACK_IMPORTED_MODULE_3__/* .alpha.transform */ .Fq.transform(alpha$1)) +
            ")");
    },
};




/***/ }),

/***/ 45982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59747);
/* harmony import */ var _hex_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92395);
/* harmony import */ var _hsla_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86845);
/* harmony import */ var _rgba_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56572);





const color = {
    test: (v) => _rgba_mjs__WEBPACK_IMPORTED_MODULE_0__/* .rgba.test */ .m.test(v) || _hex_mjs__WEBPACK_IMPORTED_MODULE_1__/* .hex.test */ .$.test(v) || _hsla_mjs__WEBPACK_IMPORTED_MODULE_2__/* .hsla.test */ .J.test(v),
    parse: (v) => {
        if (_rgba_mjs__WEBPACK_IMPORTED_MODULE_0__/* .rgba.test */ .m.test(v)) {
            return _rgba_mjs__WEBPACK_IMPORTED_MODULE_0__/* .rgba.parse */ .m.parse(v);
        }
        else if (_hsla_mjs__WEBPACK_IMPORTED_MODULE_2__/* .hsla.test */ .J.test(v)) {
            return _hsla_mjs__WEBPACK_IMPORTED_MODULE_2__/* .hsla.parse */ .J.parse(v);
        }
        else {
            return _hex_mjs__WEBPACK_IMPORTED_MODULE_1__/* .hex.parse */ .$.parse(v);
        }
    },
    transform: (v) => {
        return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(v)
            ? v
            : v.hasOwnProperty("red")
                ? _rgba_mjs__WEBPACK_IMPORTED_MODULE_0__/* .rgba.transform */ .m.transform(v)
                : _hsla_mjs__WEBPACK_IMPORTED_MODULE_2__/* .hsla.transform */ .J.transform(v);
    },
};




/***/ }),

/***/ 56572:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ rgba; }
/* harmony export */ });
/* unused harmony export rgbUnit */
/* harmony import */ var _utils_clamp_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51366);
/* harmony import */ var _numbers_index_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30397);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59747);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24536);





const clampRgbUnit = (v) => (0,_utils_clamp_mjs__WEBPACK_IMPORTED_MODULE_0__/* .clamp */ .u)(0, 255, v);
const rgbUnit = {
    ..._numbers_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
    test: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .isColorString */ .i)("rgb", "red"),
    parse: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .splitColor */ .d)("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_3__/* .sanitize */ .Nw)(_numbers_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .alpha.transform */ .Fq.transform(alpha$1)) +
        ")",
};




/***/ }),

/***/ 24536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ splitColor; },
/* harmony export */   "i": function() { return /* binding */ isColorString; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59747);


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean(((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) && _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .singleColorRegex.test */ .mj.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v))
        return v;
    const [a, b, c, alpha] = v.match(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};




/***/ }),

/***/ 76865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ complex; },
/* harmony export */   "V": function() { return /* binding */ analyseComplexValue; }
/* harmony export */ });
/* harmony import */ var _color_index_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45982);
/* harmony import */ var _numbers_index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30397);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59747);




const colorToken = "${c}";
const numberToken = "${n}";
function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) &&
        (((_a = v.match(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
function analyseComplexValue(v) {
    if (typeof v === "number")
        v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA);
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .colorRegex */ .dA, colorToken);
        values.push(...colors.map(_color_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .color.parse */ .$.parse));
    }
    const numbers = v.match(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP);
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace(_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .floatRegex */ .KP, numberToken);
        values.push(...numbers.map(_numbers_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .number.parse */ .Rx.parse));
    }
    return { values, numColors, numNumbers, tokenised: v };
}
function parse(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors
                ? _color_index_mjs__WEBPACK_IMPORTED_MODULE_1__/* .color.transform */ .$.transform(v[i])
                : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .sanitize */ .Nw)(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
    const parsed = parse(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone };




/***/ }),

/***/ 30397:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "Rx": function() { return /* binding */ number; },
/* harmony export */   "bA": function() { return /* binding */ scale; }
/* harmony export */ });
/* harmony import */ var _utils_clamp_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51366);


const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => (0,_utils_clamp_mjs__WEBPACK_IMPORTED_MODULE_0__/* .clamp */ .u)(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};




/***/ }),

/***/ 88772:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ progressPercentage; },
/* harmony export */   "RW": function() { return /* binding */ degrees; },
/* harmony export */   "aQ": function() { return /* binding */ percent; },
/* harmony export */   "px": function() { return /* binding */ px; },
/* harmony export */   "vh": function() { return /* binding */ vh; },
/* harmony export */   "vw": function() { return /* binding */ vw; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59747);


const createUnitType = (unit) => ({
    test: (v) => (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(v) && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};




/***/ }),

/***/ 59747:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "KP": function() { return /* binding */ floatRegex; },
/* harmony export */   "Nw": function() { return /* binding */ sanitize; },
/* harmony export */   "dA": function() { return /* binding */ colorRegex; },
/* harmony export */   "mj": function() { return /* binding */ singleColorRegex; }
/* harmony export */ });
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}




/***/ }),

/***/ 15815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ isMotionValue; }
/* harmony export */ });
const isMotionValue = (value) => !!(value === null || value === void 0 ? void 0 : value.getVelocity);




/***/ }),

/***/ 88660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 92277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 90781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 85717:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51591);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 51591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 95115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 58867:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88660);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92277);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90781);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95115);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 38223:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g7": function() { return /* reexport */ Slot; },
  "dP": function() { return /* reexport */ dep; },
  "re": function() { return /* binding */ wrap; }
});

// UNUSED EXPORTS: KeyTrie, asyncFromGen, bindContext, defaultMakeCacheKey, noContext, nonReactive, setTimeout

;// CONCATENATED MODULE: ../../node_modules/optimism/node_modules/@wry/trie/lib/index.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty: lib_hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return lib_hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@wry/caches/lib/strong.js
var strong = __webpack_require__(4820);
;// CONCATENATED MODULE: ../../node_modules/@wry/context/lib/slot.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());
//# sourceMappingURL=slot.js.map
;// CONCATENATED MODULE: ../../node_modules/@wry/context/lib/index.js


const { bind, noContext } = Slot;
// Like global.setTimeout, except the callback runs with captured context.

function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject) => {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            const invokeNext = (value) => invoke(boundNext, value);
            const invokeThrow = (error) => invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method) => {
            const fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/context.js

const parentEntrySlot = new Slot();
function nonReactive(fn) {
    return parentEntrySlot.withValue(void 0, fn);
}


//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/helpers.js
const { hasOwnProperty: helpers_hasOwnProperty, } = Object.prototype;
const arrayFromSet = Array.from ||
    function (set) {
        const array = [];
        set.forEach(item => array.push(item));
        return array;
    };
function maybeUnsubscribe(entryOrDep) {
    const { unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/entry.js


const emptySetPool = [];
const POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    const len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
class Entry {
    constructor(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    peek() {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    }
    setDirty() {
        if (this.dirty)
            return;
        this.dirty = true;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, (parent, child) => {
            parent.setDirty();
            forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            arrayFromSet(this.deps).forEach(dep => dep.delete(this));
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
Entry.count = 0;
function rememberParent(child) {
    const parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) {
        oldValueCopy = valueCopy(entry.value);
    }
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !valueIs(oldValueCopy, entry.value)) {
            try {
                entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
            }
            catch (_a) {
                // If normalizeResult throws, just use the newer value, rather than
                // saving the exception as entry.value[1].
            }
        }
    }
    catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = arrayFromSet(child.parents);
        for (let i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    const parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach((_value, child) => {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
//# sourceMappingURL=entry.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/dep.js


const EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = parentEntrySlot.getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) {
                depsByKey.set(key, dep = new Set);
            }
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = (entryMethodName &&
                helpers_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            arrayFromSet(dep).forEach(entry => entry[m]());
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}
//# sourceMappingURL=dep.js.map
;// CONCATENATED MODULE: ../../node_modules/optimism/lib/index.js




// These helper functions are important for making optimism work with
// asynchronous code. In order to register parent-child dependencies,
// optimism needs to know about any currently active parent computations.
// In ordinary synchronous code, the parent context is implicit in the
// execution stack, but asynchronous code requires some extra guidance in
// order to propagate context from one async task segment to the next.

// A lighter-weight dependency, similar to OptimisticWrapperFunction, except
// with only one argument, no makeCacheKey, no wrapped function to recompute,
// and no result value. Useful for representing dependency leaves in the graph
// of computation. Subscriptions are supported.

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let defaultKeyTrie;
function defaultMakeCacheKey(...args) {
    const trie = defaultKeyTrie || (defaultKeyTrie = new Trie(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
// If you're paranoid about memory leaks, or you want to avoid using WeakMap
// under the hood, but you still need the behavior of defaultMakeCacheKey,
// import this constructor to create your own tries.

;
const caches = new Set();
function wrap(originalFunction, { max = Math.pow(2, 16), keyArgs, makeCacheKey = defaultMakeCacheKey, normalizeResult, subscribe, cache: cacheOption = strong/* StrongCache */.e, } = Object.create(null)) {
    const cache = typeof cacheOption === "function"
        ? new cacheOption(max, entry => entry.dispose())
        : cacheOption;
    const optimistic = function () {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = () => cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(cache => cache.clean());
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: () => cache.size,
        configurable: false,
        enumerable: false,
    });
    Object.freeze(optimistic.options = {
        max,
        keyArgs,
        makeCacheKey,
        normalizeResult,
        subscribe,
        cache,
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 63955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports Controller, Form, FormProvider, appendErrors, get, set, useController, useFieldArray, useFormContext, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (object, path, defaultValue) => {
    if (!path || !isObject(object)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = React.useState(control._getWatch(name, defaultValue));
    React.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
        ...(isBoolean(props.disabled) ? { disabled: props.disabled } : {}),
    }));
    React.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    React.useEffect(() => {
        if (get(control._fields, name)) {
            control._updateDisabledField({
                disabled,
                fields: control._fields,
                name,
                value: get(control._fields, name)._f.value,
            });
        }
    }, [disabled, name, control]);
    return {
        field: {
            name,
            value,
            ...(isBoolean(disabled) || formState.disabled
                ? { disabled: formState.disabled || disabled }
                : {}),
            onChange: React.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: React.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = React.useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event) => {
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data) => {
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            }
            catch (_a) { }
            for (const name of control._names.mount) {
                formData.append(name, get(data, name));
            }
            if (onSubmit) {
                await onSubmit({
                    data,
                    event,
                    method,
                    formData,
                    formDataJson,
                });
            }
            if (action) {
                try {
                    const shouldStringifySubmissionData = [
                        headers && headers['Content-Type'],
                        encType,
                    ].some((value) => value && value.includes('json'));
                    const response = await fetch(action, {
                        method,
                        headers: {
                            ...headers,
                            ...(encType ? { 'Content-Type': encType } : {}),
                        },
                        body: shouldStringifySubmissionData ? formDataJson : formData,
                    });
                    if (response &&
                        (validateStatus
                            ? !validateStatus(response.status)
                            : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({ response });
                        type = String(response.status);
                    }
                    else {
                        onSuccess && onSuccess({ response });
                    }
                }
                catch (error) {
                    hasError = true;
                    onError && onError({ error });
                }
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false,
            });
            props.control.setError('root.server', {
                type,
            });
        }
    };
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return render ? (React.createElement(React.Fragment, null, render({
        submit,
    }))) : (React.createElement("form", { noValidate: mounted, action: action, method: method, encType: encType, onSubmit: submit, ...rest }, children));
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    break;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    break;
                }
                else {
                    iterateFieldsByAction(currentField, action);
                }
            }
            else if (isObject(currentField)) {
                iterateFieldsByAction(currentField, action);
            }
        }
    }
};

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

var appendAt = (data, value) => [
    ...data,
    ...convertToArrayPayload(value),
];

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

var prependAt = (data, value) => [
    ...convertToArrayPayload(value),
    ...convertToArrayPayload(data),
];

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    [data[indexA], data[indexB]] = [data[indexB], data[indexA]];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError
                        ? (!error && existingError.type) ||
                            (error &&
                                (existingError.type !== error.type ||
                                    existingError.message !== error.message))
                        : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field &&
                    field._f &&
                    !(getValidationModes(control._options.reValidateMode).isOnSubmit &&
                        getValidationModes(control._options.mode).isOnSubmit)) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            iterateFieldsByAction(control._fields, (ref, key) => {
                if (control._names.focus &&
                    key.startsWith(control._names.focus) &&
                    ref.focus) {
                    ref.focus();
                    return 1;
                }
                return;
            });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend, [updateValues, name, control]),
        append: React.useCallback(append, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false,
    };
    let _fields = {};
    let _defaultValues = isObject(_options.values) || isObject(_options.defaultValues)
        ? cloneObject(_options.values || _options.defaultValues) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    fieldValue === get(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value, }) => {
        if (isBoolean(disabled)) {
            const inputValue = disabled
                ? undefined
                : isUndefined(value)
                    ? getFieldValue(field ? field._f : get(fields, name)._f)
                    : value;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: options.disabled,
                name,
                value: options.value,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                let requiredDisabledState = disabled;
                const currentField = get(_fields, name);
                if (currentField && isBoolean(currentField._f.disabled)) {
                    requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                }
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        let onValidError = undefined;
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            try {
                await onValid(fieldValues, e);
            }
            catch (error) {
                onValidError = error;
            }
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
        if (onValidError) {
            throw onValidError;
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, cloneObject(get(_defaultValues, name)));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, cloneObject(get(_defaultValues, name)))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount =
            !_proxyFormState.isValid ||
                !!keepStateOptions.keepIsValid ||
                !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? keepStateOptions.keepDefaultValues && _formValues
                    ? getDirtyFields(_defaultValues, _formValues)
                    : _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const _values = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
        }
    }, [props.errors, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        props.shouldUnregister &&
            control._subjects.values.next({
                values: control._getWatch(),
            });
    }, [props.shouldUnregister, control]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 35948:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U6": function() { return /* binding */ setVerbosity; },
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22970);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (invariant)));
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 12129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);